(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire388f"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire388f"] = parcelRequire;
}
parcelRequire.register("fQLEo", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $b8a0acba9234cdac$export$ffb0004e005737fa; }, function (v) { return $b8a0acba9234cdac$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $b8a0acba9234cdac$export$34b9dba7ce09269b; }, function (v) { return $b8a0acba9234cdac$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $b8a0acba9234cdac$export$25062201e9e25d76; }, function (v) { return $b8a0acba9234cdac$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b8a0acba9234cdac$export$ffb0004e005737fa;
var $b8a0acba9234cdac$export$34b9dba7ce09269b;
var $b8a0acba9234cdac$export$25062201e9e25d76;
"use strict";

var $35jnV = parcelRequire("35jnV");
var $b8a0acba9234cdac$var$k = Symbol.for("react.element"), $b8a0acba9234cdac$var$l = Symbol.for("react.fragment"), $b8a0acba9234cdac$var$m = Object.prototype.hasOwnProperty, $b8a0acba9234cdac$var$n = $35jnV.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $b8a0acba9234cdac$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b8a0acba9234cdac$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$b8a0acba9234cdac$var$m.call(a, b) && !$b8a0acba9234cdac$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $b8a0acba9234cdac$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $b8a0acba9234cdac$var$n.current
    };
}
$b8a0acba9234cdac$export$ffb0004e005737fa = $b8a0acba9234cdac$var$l;
$b8a0acba9234cdac$export$34b9dba7ce09269b = $b8a0acba9234cdac$var$q;
$b8a0acba9234cdac$export$25062201e9e25d76 = $b8a0acba9234cdac$var$q;

});
parcelRequire.register("35jnV", function(module, exports) {
"use strict";

module.exports = (parcelRequire("O7Ngz"));

});
parcelRequire.register("O7Ngz", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $096ab746cc52bc66$export$dca3b0875bd9a954; }, function (v) { return $096ab746cc52bc66$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $096ab746cc52bc66$export$16fa2f45be04daa8; }, function (v) { return $096ab746cc52bc66$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $096ab746cc52bc66$export$ffb0004e005737fa; }, function (v) { return $096ab746cc52bc66$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $096ab746cc52bc66$export$e2c29f18771995cb; }, function (v) { return $096ab746cc52bc66$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $096ab746cc52bc66$export$221d75b3f55bb0bd; }, function (v) { return $096ab746cc52bc66$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $096ab746cc52bc66$export$5f8d39834fd61797; }, function (v) { return $096ab746cc52bc66$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $096ab746cc52bc66$export$74bf444e3cd11ea5; }, function (v) { return $096ab746cc52bc66$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $096ab746cc52bc66$export$ae55be85d98224ed; }, function (v) { return $096ab746cc52bc66$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $096ab746cc52bc66$export$e530037191fcd5d7; }, function (v) { return $096ab746cc52bc66$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $096ab746cc52bc66$export$fd42f52fd3ae1109; }, function (v) { return $096ab746cc52bc66$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $096ab746cc52bc66$export$c8a8987d4410bf2d; }, function (v) { return $096ab746cc52bc66$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $096ab746cc52bc66$export$d38cd72104c1f0e9; }, function (v) { return $096ab746cc52bc66$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $096ab746cc52bc66$export$7d1e3a5e95ceca43; }, function (v) { return $096ab746cc52bc66$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $096ab746cc52bc66$export$257a8862b851cb5b; }, function (v) { return $096ab746cc52bc66$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $096ab746cc52bc66$export$a8257692ac88316c; }, function (v) { return $096ab746cc52bc66$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $096ab746cc52bc66$export$488013bae63b21da; }, function (v) { return $096ab746cc52bc66$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $096ab746cc52bc66$export$7c73462e0d25e514; }, function (v) { return $096ab746cc52bc66$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $096ab746cc52bc66$export$7568632d0d33d16d; }, function (v) { return $096ab746cc52bc66$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $096ab746cc52bc66$export$88948ce120ea2619; }, function (v) { return $096ab746cc52bc66$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $096ab746cc52bc66$export$35808ee640e87ca7; }, function (v) { return $096ab746cc52bc66$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $096ab746cc52bc66$export$fae74005e78b1a27; }, function (v) { return $096ab746cc52bc66$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $096ab746cc52bc66$export$dc8fbce3eb94dc1e; }, function (v) { return $096ab746cc52bc66$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $096ab746cc52bc66$export$6a7bc4e911dc01cf; }, function (v) { return $096ab746cc52bc66$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $096ab746cc52bc66$export$6d9c69b0de29b591; }, function (v) { return $096ab746cc52bc66$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $096ab746cc52bc66$export$f680877a34711e37; }, function (v) { return $096ab746cc52bc66$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $096ab746cc52bc66$export$d5a552a76deda3c2; }, function (v) { return $096ab746cc52bc66$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $096ab746cc52bc66$export$aaabe4eda9ed9969; }, function (v) { return $096ab746cc52bc66$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $096ab746cc52bc66$export$e5c5a5f917a5871c; }, function (v) { return $096ab746cc52bc66$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $096ab746cc52bc66$export$1538c33de8887b59; }, function (v) { return $096ab746cc52bc66$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $096ab746cc52bc66$export$13e3392192263954; }, function (v) { return $096ab746cc52bc66$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $096ab746cc52bc66$export$b8f5890fc79d6aca; }, function (v) { return $096ab746cc52bc66$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $096ab746cc52bc66$export$60241385465d0a34; }, function (v) { return $096ab746cc52bc66$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $096ab746cc52bc66$export$306c0aa65ff9ec16; }, function (v) { return $096ab746cc52bc66$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $096ab746cc52bc66$export$7b286972b8d8ccbf; }, function (v) { return $096ab746cc52bc66$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $096ab746cc52bc66$export$83d89fbfd8236492; }, function (v) { return $096ab746cc52bc66$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $096ab746cc52bc66$export$dca3b0875bd9a954;
var $096ab746cc52bc66$export$16fa2f45be04daa8;
var $096ab746cc52bc66$export$ffb0004e005737fa;
var $096ab746cc52bc66$export$e2c29f18771995cb;
var $096ab746cc52bc66$export$221d75b3f55bb0bd;
var $096ab746cc52bc66$export$5f8d39834fd61797;
var $096ab746cc52bc66$export$74bf444e3cd11ea5;
var $096ab746cc52bc66$export$ae55be85d98224ed;
var $096ab746cc52bc66$export$e530037191fcd5d7;
var $096ab746cc52bc66$export$fd42f52fd3ae1109;
var $096ab746cc52bc66$export$c8a8987d4410bf2d;
var $096ab746cc52bc66$export$d38cd72104c1f0e9;
var $096ab746cc52bc66$export$7d1e3a5e95ceca43;
var $096ab746cc52bc66$export$257a8862b851cb5b;
var $096ab746cc52bc66$export$a8257692ac88316c;
var $096ab746cc52bc66$export$488013bae63b21da;
var $096ab746cc52bc66$export$7c73462e0d25e514;
var $096ab746cc52bc66$export$7568632d0d33d16d;
var $096ab746cc52bc66$export$88948ce120ea2619;
var $096ab746cc52bc66$export$35808ee640e87ca7;
var $096ab746cc52bc66$export$fae74005e78b1a27;
var $096ab746cc52bc66$export$dc8fbce3eb94dc1e;
var $096ab746cc52bc66$export$6a7bc4e911dc01cf;
var $096ab746cc52bc66$export$6d9c69b0de29b591;
var $096ab746cc52bc66$export$f680877a34711e37;
var $096ab746cc52bc66$export$d5a552a76deda3c2;
var $096ab746cc52bc66$export$aaabe4eda9ed9969;
var $096ab746cc52bc66$export$e5c5a5f917a5871c;
var $096ab746cc52bc66$export$1538c33de8887b59;
var $096ab746cc52bc66$export$13e3392192263954;
var $096ab746cc52bc66$export$b8f5890fc79d6aca;
var $096ab746cc52bc66$export$60241385465d0a34;
var $096ab746cc52bc66$export$306c0aa65ff9ec16;
var $096ab746cc52bc66$export$7b286972b8d8ccbf;
var $096ab746cc52bc66$export$83d89fbfd8236492;
"use strict";
var $096ab746cc52bc66$var$l = Symbol.for("react.element"), $096ab746cc52bc66$var$n = Symbol.for("react.portal"), $096ab746cc52bc66$var$p = Symbol.for("react.fragment"), $096ab746cc52bc66$var$q = Symbol.for("react.strict_mode"), $096ab746cc52bc66$var$r = Symbol.for("react.profiler"), $096ab746cc52bc66$var$t = Symbol.for("react.provider"), $096ab746cc52bc66$var$u = Symbol.for("react.context"), $096ab746cc52bc66$var$v = Symbol.for("react.forward_ref"), $096ab746cc52bc66$var$w = Symbol.for("react.suspense"), $096ab746cc52bc66$var$x = Symbol.for("react.memo"), $096ab746cc52bc66$var$y = Symbol.for("react.lazy"), $096ab746cc52bc66$var$z = Symbol.iterator;
function $096ab746cc52bc66$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $096ab746cc52bc66$var$z && a[$096ab746cc52bc66$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $096ab746cc52bc66$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $096ab746cc52bc66$var$C = Object.assign, $096ab746cc52bc66$var$D = {};
function $096ab746cc52bc66$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $096ab746cc52bc66$var$D;
    this.updater = e || $096ab746cc52bc66$var$B;
}
$096ab746cc52bc66$var$E.prototype.isReactComponent = {};
$096ab746cc52bc66$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$096ab746cc52bc66$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $096ab746cc52bc66$var$F() {}
$096ab746cc52bc66$var$F.prototype = $096ab746cc52bc66$var$E.prototype;
function $096ab746cc52bc66$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $096ab746cc52bc66$var$D;
    this.updater = e || $096ab746cc52bc66$var$B;
}
var $096ab746cc52bc66$var$H = $096ab746cc52bc66$var$G.prototype = new $096ab746cc52bc66$var$F;
$096ab746cc52bc66$var$H.constructor = $096ab746cc52bc66$var$G;
$096ab746cc52bc66$var$C($096ab746cc52bc66$var$H, $096ab746cc52bc66$var$E.prototype);
$096ab746cc52bc66$var$H.isPureReactComponent = !0;
var $096ab746cc52bc66$var$I = Array.isArray, $096ab746cc52bc66$var$J = Object.prototype.hasOwnProperty, $096ab746cc52bc66$var$K = {
    current: null
}, $096ab746cc52bc66$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $096ab746cc52bc66$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$096ab746cc52bc66$var$J.call(b, d) && !$096ab746cc52bc66$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $096ab746cc52bc66$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $096ab746cc52bc66$var$K.current
    };
}
function $096ab746cc52bc66$var$N(a, b) {
    return {
        $$typeof: $096ab746cc52bc66$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $096ab746cc52bc66$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $096ab746cc52bc66$var$l;
}
function $096ab746cc52bc66$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $096ab746cc52bc66$var$P = /\/+/g;
function $096ab746cc52bc66$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $096ab746cc52bc66$var$escape("" + a.key) : b.toString(36);
}
function $096ab746cc52bc66$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $096ab746cc52bc66$var$l:
                case $096ab746cc52bc66$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $096ab746cc52bc66$var$Q(h, 0) : d, $096ab746cc52bc66$var$I(c) ? (e = "", null != a && (e = a.replace($096ab746cc52bc66$var$P, "$&/") + "/"), $096ab746cc52bc66$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($096ab746cc52bc66$var$O(c) && (c = $096ab746cc52bc66$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($096ab746cc52bc66$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($096ab746cc52bc66$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $096ab746cc52bc66$var$Q(k, g);
        h += $096ab746cc52bc66$var$R(k, b, e, f, c);
    }
    else if (f = $096ab746cc52bc66$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $096ab746cc52bc66$var$Q(k, g++), h += $096ab746cc52bc66$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $096ab746cc52bc66$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $096ab746cc52bc66$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $096ab746cc52bc66$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $096ab746cc52bc66$var$U = {
    current: null
}, $096ab746cc52bc66$var$V = {
    transition: null
}, $096ab746cc52bc66$var$W = {
    ReactCurrentDispatcher: $096ab746cc52bc66$var$U,
    ReactCurrentBatchConfig: $096ab746cc52bc66$var$V,
    ReactCurrentOwner: $096ab746cc52bc66$var$K
};
$096ab746cc52bc66$export$dca3b0875bd9a954 = {
    map: $096ab746cc52bc66$var$S,
    forEach: function(a, b, e) {
        $096ab746cc52bc66$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $096ab746cc52bc66$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $096ab746cc52bc66$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$096ab746cc52bc66$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$096ab746cc52bc66$export$16fa2f45be04daa8 = $096ab746cc52bc66$var$E;
$096ab746cc52bc66$export$ffb0004e005737fa = $096ab746cc52bc66$var$p;
$096ab746cc52bc66$export$e2c29f18771995cb = $096ab746cc52bc66$var$r;
$096ab746cc52bc66$export$221d75b3f55bb0bd = $096ab746cc52bc66$var$G;
$096ab746cc52bc66$export$5f8d39834fd61797 = $096ab746cc52bc66$var$q;
$096ab746cc52bc66$export$74bf444e3cd11ea5 = $096ab746cc52bc66$var$w;
$096ab746cc52bc66$export$ae55be85d98224ed = $096ab746cc52bc66$var$W;
$096ab746cc52bc66$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $096ab746cc52bc66$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $096ab746cc52bc66$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$096ab746cc52bc66$var$J.call(b, f) && !$096ab746cc52bc66$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $096ab746cc52bc66$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$096ab746cc52bc66$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $096ab746cc52bc66$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $096ab746cc52bc66$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$096ab746cc52bc66$export$c8a8987d4410bf2d = $096ab746cc52bc66$var$M;
$096ab746cc52bc66$export$d38cd72104c1f0e9 = function(a) {
    var b = $096ab746cc52bc66$var$M.bind(null, a);
    b.type = a;
    return b;
};
$096ab746cc52bc66$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$096ab746cc52bc66$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $096ab746cc52bc66$var$v,
        render: a
    };
};
$096ab746cc52bc66$export$a8257692ac88316c = $096ab746cc52bc66$var$O;
$096ab746cc52bc66$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $096ab746cc52bc66$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $096ab746cc52bc66$var$T
    };
};
$096ab746cc52bc66$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $096ab746cc52bc66$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$096ab746cc52bc66$export$7568632d0d33d16d = function(a) {
    var b = $096ab746cc52bc66$var$V.transition;
    $096ab746cc52bc66$var$V.transition = {};
    try {
        a();
    } finally{
        $096ab746cc52bc66$var$V.transition = b;
    }
};
$096ab746cc52bc66$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$096ab746cc52bc66$export$35808ee640e87ca7 = function(a, b) {
    return $096ab746cc52bc66$var$U.current.useCallback(a, b);
};
$096ab746cc52bc66$export$fae74005e78b1a27 = function(a) {
    return $096ab746cc52bc66$var$U.current.useContext(a);
};
$096ab746cc52bc66$export$dc8fbce3eb94dc1e = function() {};
$096ab746cc52bc66$export$6a7bc4e911dc01cf = function(a) {
    return $096ab746cc52bc66$var$U.current.useDeferredValue(a);
};
$096ab746cc52bc66$export$6d9c69b0de29b591 = function(a, b) {
    return $096ab746cc52bc66$var$U.current.useEffect(a, b);
};
$096ab746cc52bc66$export$f680877a34711e37 = function() {
    return $096ab746cc52bc66$var$U.current.useId();
};
$096ab746cc52bc66$export$d5a552a76deda3c2 = function(a, b, e) {
    return $096ab746cc52bc66$var$U.current.useImperativeHandle(a, b, e);
};
$096ab746cc52bc66$export$aaabe4eda9ed9969 = function(a, b) {
    return $096ab746cc52bc66$var$U.current.useInsertionEffect(a, b);
};
$096ab746cc52bc66$export$e5c5a5f917a5871c = function(a, b) {
    return $096ab746cc52bc66$var$U.current.useLayoutEffect(a, b);
};
$096ab746cc52bc66$export$1538c33de8887b59 = function(a, b) {
    return $096ab746cc52bc66$var$U.current.useMemo(a, b);
};
$096ab746cc52bc66$export$13e3392192263954 = function(a, b, e) {
    return $096ab746cc52bc66$var$U.current.useReducer(a, b, e);
};
$096ab746cc52bc66$export$b8f5890fc79d6aca = function(a) {
    return $096ab746cc52bc66$var$U.current.useRef(a);
};
$096ab746cc52bc66$export$60241385465d0a34 = function(a) {
    return $096ab746cc52bc66$var$U.current.useState(a);
};
$096ab746cc52bc66$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $096ab746cc52bc66$var$U.current.useSyncExternalStore(a, b, e);
};
$096ab746cc52bc66$export$7b286972b8d8ccbf = function() {
    return $096ab746cc52bc66$var$U.current.useTransition();
};
$096ab746cc52bc66$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("eeNZT", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $a5d927e783c48bfa$export$ae55be85d98224ed; }, function (v) { return $a5d927e783c48bfa$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $a5d927e783c48bfa$export$d39a5bbd09211389; }, function (v) { return $a5d927e783c48bfa$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $a5d927e783c48bfa$export$882461b6382ed46c; }, function (v) { return $a5d927e783c48bfa$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $a5d927e783c48bfa$export$466bfc07425424d5; }, function (v) { return $a5d927e783c48bfa$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $a5d927e783c48bfa$export$cd75ccfd720a3cd4; }, function (v) { return $a5d927e783c48bfa$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $a5d927e783c48bfa$export$fa8d919ba61d84db; }, function (v) { return $a5d927e783c48bfa$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $a5d927e783c48bfa$export$757ceba2d55c277e; }, function (v) { return $a5d927e783c48bfa$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $a5d927e783c48bfa$export$b3890eb0ae9dca99; }, function (v) { return $a5d927e783c48bfa$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $a5d927e783c48bfa$export$502457920280e6be; }, function (v) { return $a5d927e783c48bfa$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $a5d927e783c48bfa$export$c78a37762a8d58e1; }, function (v) { return $a5d927e783c48bfa$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $a5d927e783c48bfa$export$dc54d992c10e8a18; }, function (v) { return $a5d927e783c48bfa$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $a5d927e783c48bfa$export$83d89fbfd8236492; }, function (v) { return $a5d927e783c48bfa$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $a5d927e783c48bfa$export$ae55be85d98224ed;
var $a5d927e783c48bfa$export$d39a5bbd09211389;
var $a5d927e783c48bfa$export$882461b6382ed46c;
var $a5d927e783c48bfa$export$466bfc07425424d5;
var $a5d927e783c48bfa$export$cd75ccfd720a3cd4;
var $a5d927e783c48bfa$export$fa8d919ba61d84db;
var $a5d927e783c48bfa$export$757ceba2d55c277e;
var $a5d927e783c48bfa$export$b3890eb0ae9dca99;
var $a5d927e783c48bfa$export$502457920280e6be;
var $a5d927e783c48bfa$export$c78a37762a8d58e1;
var $a5d927e783c48bfa$export$dc54d992c10e8a18;
var $a5d927e783c48bfa$export$83d89fbfd8236492;
"use strict";

var $35jnV = parcelRequire("35jnV");

var $aUPxC = parcelRequire("aUPxC");
function $a5d927e783c48bfa$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $a5d927e783c48bfa$var$da = new Set, $a5d927e783c48bfa$var$ea = {};
function $a5d927e783c48bfa$var$fa(a, b) {
    $a5d927e783c48bfa$var$ha(a, b);
    $a5d927e783c48bfa$var$ha(a + "Capture", b);
}
function $a5d927e783c48bfa$var$ha(a, b) {
    $a5d927e783c48bfa$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$a5d927e783c48bfa$var$da.add(b[a]);
}
var $a5d927e783c48bfa$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $a5d927e783c48bfa$var$ja = Object.prototype.hasOwnProperty, $a5d927e783c48bfa$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $a5d927e783c48bfa$var$la = {}, $a5d927e783c48bfa$var$ma = {};
function $a5d927e783c48bfa$var$oa(a) {
    if ($a5d927e783c48bfa$var$ja.call($a5d927e783c48bfa$var$ma, a)) return !0;
    if ($a5d927e783c48bfa$var$ja.call($a5d927e783c48bfa$var$la, a)) return !1;
    if ($a5d927e783c48bfa$var$ka.test(a)) return $a5d927e783c48bfa$var$ma[a] = !0;
    $a5d927e783c48bfa$var$la[a] = !0;
    return !1;
}
function $a5d927e783c48bfa$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $a5d927e783c48bfa$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $a5d927e783c48bfa$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $a5d927e783c48bfa$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $a5d927e783c48bfa$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $a5d927e783c48bfa$var$z[a] = new $a5d927e783c48bfa$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $a5d927e783c48bfa$var$z[b] = new $a5d927e783c48bfa$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $a5d927e783c48bfa$var$z[a] = new $a5d927e783c48bfa$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $a5d927e783c48bfa$var$z[a] = new $a5d927e783c48bfa$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $a5d927e783c48bfa$var$z[a] = new $a5d927e783c48bfa$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $a5d927e783c48bfa$var$z[a] = new $a5d927e783c48bfa$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $a5d927e783c48bfa$var$z[a] = new $a5d927e783c48bfa$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $a5d927e783c48bfa$var$z[a] = new $a5d927e783c48bfa$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $a5d927e783c48bfa$var$z[a] = new $a5d927e783c48bfa$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $a5d927e783c48bfa$var$ra = /[\-:]([a-z])/g;
function $a5d927e783c48bfa$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($a5d927e783c48bfa$var$ra, $a5d927e783c48bfa$var$sa);
    $a5d927e783c48bfa$var$z[b] = new $a5d927e783c48bfa$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($a5d927e783c48bfa$var$ra, $a5d927e783c48bfa$var$sa);
    $a5d927e783c48bfa$var$z[b] = new $a5d927e783c48bfa$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($a5d927e783c48bfa$var$ra, $a5d927e783c48bfa$var$sa);
    $a5d927e783c48bfa$var$z[b] = new $a5d927e783c48bfa$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $a5d927e783c48bfa$var$z[a] = new $a5d927e783c48bfa$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$a5d927e783c48bfa$var$z.xlinkHref = new $a5d927e783c48bfa$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $a5d927e783c48bfa$var$z[a] = new $a5d927e783c48bfa$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $a5d927e783c48bfa$var$ta(a, b, c, d) {
    var e = $a5d927e783c48bfa$var$z.hasOwnProperty(b) ? $a5d927e783c48bfa$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $a5d927e783c48bfa$var$qa(b, c, e, d) && (c = null), d || null === e ? $a5d927e783c48bfa$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $a5d927e783c48bfa$var$ua = $35jnV.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $a5d927e783c48bfa$var$va = Symbol.for("react.element"), $a5d927e783c48bfa$var$wa = Symbol.for("react.portal"), $a5d927e783c48bfa$var$ya = Symbol.for("react.fragment"), $a5d927e783c48bfa$var$za = Symbol.for("react.strict_mode"), $a5d927e783c48bfa$var$Aa = Symbol.for("react.profiler"), $a5d927e783c48bfa$var$Ba = Symbol.for("react.provider"), $a5d927e783c48bfa$var$Ca = Symbol.for("react.context"), $a5d927e783c48bfa$var$Da = Symbol.for("react.forward_ref"), $a5d927e783c48bfa$var$Ea = Symbol.for("react.suspense"), $a5d927e783c48bfa$var$Fa = Symbol.for("react.suspense_list"), $a5d927e783c48bfa$var$Ga = Symbol.for("react.memo"), $a5d927e783c48bfa$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $a5d927e783c48bfa$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $a5d927e783c48bfa$var$Ja = Symbol.iterator;
function $a5d927e783c48bfa$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $a5d927e783c48bfa$var$Ja && a[$a5d927e783c48bfa$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $a5d927e783c48bfa$var$A = Object.assign, $a5d927e783c48bfa$var$La;
function $a5d927e783c48bfa$var$Ma(a) {
    if (void 0 === $a5d927e783c48bfa$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $a5d927e783c48bfa$var$La = b && b[1] || "";
    }
    return "\n" + $a5d927e783c48bfa$var$La + a;
}
var $a5d927e783c48bfa$var$Na = !1;
function $a5d927e783c48bfa$var$Oa(a, b) {
    if (!a || $a5d927e783c48bfa$var$Na) return "";
    $a5d927e783c48bfa$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $a5d927e783c48bfa$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $a5d927e783c48bfa$var$Ma(a) : "";
}
function $a5d927e783c48bfa$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $a5d927e783c48bfa$var$Ma(a.type);
        case 16:
            return $a5d927e783c48bfa$var$Ma("Lazy");
        case 13:
            return $a5d927e783c48bfa$var$Ma("Suspense");
        case 19:
            return $a5d927e783c48bfa$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $a5d927e783c48bfa$var$Oa(a.type, !1), a;
        case 11:
            return a = $a5d927e783c48bfa$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $a5d927e783c48bfa$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $a5d927e783c48bfa$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $a5d927e783c48bfa$var$ya:
            return "Fragment";
        case $a5d927e783c48bfa$var$wa:
            return "Portal";
        case $a5d927e783c48bfa$var$Aa:
            return "Profiler";
        case $a5d927e783c48bfa$var$za:
            return "StrictMode";
        case $a5d927e783c48bfa$var$Ea:
            return "Suspense";
        case $a5d927e783c48bfa$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $a5d927e783c48bfa$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $a5d927e783c48bfa$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $a5d927e783c48bfa$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $a5d927e783c48bfa$var$Ga:
            return b = a.displayName || null, null !== b ? b : $a5d927e783c48bfa$var$Qa(a.type) || "Memo";
        case $a5d927e783c48bfa$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $a5d927e783c48bfa$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $a5d927e783c48bfa$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $a5d927e783c48bfa$var$Qa(b);
        case 8:
            return b === $a5d927e783c48bfa$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $a5d927e783c48bfa$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $a5d927e783c48bfa$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $a5d927e783c48bfa$var$Ua(a) {
    var b = $a5d927e783c48bfa$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $a5d927e783c48bfa$var$Va(a) {
    a._valueTracker || (a._valueTracker = $a5d927e783c48bfa$var$Ua(a));
}
function $a5d927e783c48bfa$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $a5d927e783c48bfa$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $a5d927e783c48bfa$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $a5d927e783c48bfa$var$Ya(a, b) {
    var c = b.checked;
    return $a5d927e783c48bfa$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $a5d927e783c48bfa$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $a5d927e783c48bfa$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a5d927e783c48bfa$var$ab(a, b) {
    b = b.checked;
    null != b && $a5d927e783c48bfa$var$ta(a, "checked", b, !1);
}
function $a5d927e783c48bfa$var$bb(a, b) {
    $a5d927e783c48bfa$var$ab(a, b);
    var c = $a5d927e783c48bfa$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $a5d927e783c48bfa$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $a5d927e783c48bfa$var$cb(a, b.type, $a5d927e783c48bfa$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $a5d927e783c48bfa$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $a5d927e783c48bfa$var$cb(a, b, c) {
    if ("number" !== b || $a5d927e783c48bfa$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $a5d927e783c48bfa$var$eb = Array.isArray;
function $a5d927e783c48bfa$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $a5d927e783c48bfa$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $a5d927e783c48bfa$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($a5d927e783c48bfa$var$p(91));
    return $a5d927e783c48bfa$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $a5d927e783c48bfa$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($a5d927e783c48bfa$var$p(92));
            if ($a5d927e783c48bfa$var$eb(c)) {
                if (1 < c.length) throw Error($a5d927e783c48bfa$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $a5d927e783c48bfa$var$Sa(c)
    };
}
function $a5d927e783c48bfa$var$ib(a, b) {
    var c = $a5d927e783c48bfa$var$Sa(b.value), d = $a5d927e783c48bfa$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $a5d927e783c48bfa$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $a5d927e783c48bfa$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $a5d927e783c48bfa$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $a5d927e783c48bfa$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $a5d927e783c48bfa$var$mb, $a5d927e783c48bfa$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $a5d927e783c48bfa$var$mb = $a5d927e783c48bfa$var$mb || document.createElement("div");
        $a5d927e783c48bfa$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $a5d927e783c48bfa$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $a5d927e783c48bfa$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $a5d927e783c48bfa$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $a5d927e783c48bfa$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($a5d927e783c48bfa$var$pb).forEach(function(a) {
    $a5d927e783c48bfa$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $a5d927e783c48bfa$var$pb[b] = $a5d927e783c48bfa$var$pb[a];
    });
});
function $a5d927e783c48bfa$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $a5d927e783c48bfa$var$pb.hasOwnProperty(a) && $a5d927e783c48bfa$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $a5d927e783c48bfa$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $a5d927e783c48bfa$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $a5d927e783c48bfa$var$tb = $a5d927e783c48bfa$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $a5d927e783c48bfa$var$ub(a, b) {
    if (b) {
        if ($a5d927e783c48bfa$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($a5d927e783c48bfa$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($a5d927e783c48bfa$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($a5d927e783c48bfa$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($a5d927e783c48bfa$var$p(62));
    }
}
function $a5d927e783c48bfa$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $a5d927e783c48bfa$var$wb = null;
function $a5d927e783c48bfa$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $a5d927e783c48bfa$var$yb = null, $a5d927e783c48bfa$var$zb = null, $a5d927e783c48bfa$var$Ab = null;
function $a5d927e783c48bfa$var$Bb(a) {
    if (a = $a5d927e783c48bfa$var$Cb(a)) {
        if ("function" !== typeof $a5d927e783c48bfa$var$yb) throw Error($a5d927e783c48bfa$var$p(280));
        var b = a.stateNode;
        b && (b = $a5d927e783c48bfa$var$Db(b), $a5d927e783c48bfa$var$yb(a.stateNode, a.type, b));
    }
}
function $a5d927e783c48bfa$var$Eb(a) {
    $a5d927e783c48bfa$var$zb ? $a5d927e783c48bfa$var$Ab ? $a5d927e783c48bfa$var$Ab.push(a) : $a5d927e783c48bfa$var$Ab = [
        a
    ] : $a5d927e783c48bfa$var$zb = a;
}
function $a5d927e783c48bfa$var$Fb() {
    if ($a5d927e783c48bfa$var$zb) {
        var a = $a5d927e783c48bfa$var$zb, b = $a5d927e783c48bfa$var$Ab;
        $a5d927e783c48bfa$var$Ab = $a5d927e783c48bfa$var$zb = null;
        $a5d927e783c48bfa$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$a5d927e783c48bfa$var$Bb(b[a]);
    }
}
function $a5d927e783c48bfa$var$Gb(a, b) {
    return a(b);
}
function $a5d927e783c48bfa$var$Hb() {}
var $a5d927e783c48bfa$var$Ib = !1;
function $a5d927e783c48bfa$var$Jb(a, b, c) {
    if ($a5d927e783c48bfa$var$Ib) return a(b, c);
    $a5d927e783c48bfa$var$Ib = !0;
    try {
        return $a5d927e783c48bfa$var$Gb(a, b, c);
    } finally{
        if ($a5d927e783c48bfa$var$Ib = !1, null !== $a5d927e783c48bfa$var$zb || null !== $a5d927e783c48bfa$var$Ab) $a5d927e783c48bfa$var$Hb(), $a5d927e783c48bfa$var$Fb();
    }
}
function $a5d927e783c48bfa$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $a5d927e783c48bfa$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($a5d927e783c48bfa$var$p(231, b, typeof c));
    return c;
}
var $a5d927e783c48bfa$var$Lb = !1;
if ($a5d927e783c48bfa$var$ia) try {
    var $a5d927e783c48bfa$var$Mb = {};
    Object.defineProperty($a5d927e783c48bfa$var$Mb, "passive", {
        get: function() {
            $a5d927e783c48bfa$var$Lb = !0;
        }
    });
    window.addEventListener("test", $a5d927e783c48bfa$var$Mb, $a5d927e783c48bfa$var$Mb);
    window.removeEventListener("test", $a5d927e783c48bfa$var$Mb, $a5d927e783c48bfa$var$Mb);
} catch (a) {
    $a5d927e783c48bfa$var$Lb = !1;
}
function $a5d927e783c48bfa$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $a5d927e783c48bfa$var$Ob = !1, $a5d927e783c48bfa$var$Pb = null, $a5d927e783c48bfa$var$Qb = !1, $a5d927e783c48bfa$var$Rb = null, $a5d927e783c48bfa$var$Sb = {
    onError: function(a) {
        $a5d927e783c48bfa$var$Ob = !0;
        $a5d927e783c48bfa$var$Pb = a;
    }
};
function $a5d927e783c48bfa$var$Tb(a, b, c, d, e, f, g, h, k) {
    $a5d927e783c48bfa$var$Ob = !1;
    $a5d927e783c48bfa$var$Pb = null;
    $a5d927e783c48bfa$var$Nb.apply($a5d927e783c48bfa$var$Sb, arguments);
}
function $a5d927e783c48bfa$var$Ub(a, b, c, d, e, f, g, h, k) {
    $a5d927e783c48bfa$var$Tb.apply(this, arguments);
    if ($a5d927e783c48bfa$var$Ob) {
        if ($a5d927e783c48bfa$var$Ob) {
            var l = $a5d927e783c48bfa$var$Pb;
            $a5d927e783c48bfa$var$Ob = !1;
            $a5d927e783c48bfa$var$Pb = null;
        } else throw Error($a5d927e783c48bfa$var$p(198));
        $a5d927e783c48bfa$var$Qb || ($a5d927e783c48bfa$var$Qb = !0, $a5d927e783c48bfa$var$Rb = l);
    }
}
function $a5d927e783c48bfa$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $a5d927e783c48bfa$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $a5d927e783c48bfa$var$Xb(a) {
    if ($a5d927e783c48bfa$var$Vb(a) !== a) throw Error($a5d927e783c48bfa$var$p(188));
}
function $a5d927e783c48bfa$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $a5d927e783c48bfa$var$Vb(a);
        if (null === b) throw Error($a5d927e783c48bfa$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $a5d927e783c48bfa$var$Xb(e), a;
                if (f === d) return $a5d927e783c48bfa$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($a5d927e783c48bfa$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($a5d927e783c48bfa$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($a5d927e783c48bfa$var$p(190));
    }
    if (3 !== c.tag) throw Error($a5d927e783c48bfa$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $a5d927e783c48bfa$var$Zb(a) {
    a = $a5d927e783c48bfa$var$Yb(a);
    return null !== a ? $a5d927e783c48bfa$var$$b(a) : null;
}
function $a5d927e783c48bfa$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $a5d927e783c48bfa$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $a5d927e783c48bfa$var$ac = $aUPxC.unstable_scheduleCallback, $a5d927e783c48bfa$var$bc = $aUPxC.unstable_cancelCallback, $a5d927e783c48bfa$var$cc = $aUPxC.unstable_shouldYield, $a5d927e783c48bfa$var$dc = $aUPxC.unstable_requestPaint, $a5d927e783c48bfa$var$B = $aUPxC.unstable_now, $a5d927e783c48bfa$var$ec = $aUPxC.unstable_getCurrentPriorityLevel, $a5d927e783c48bfa$var$fc = $aUPxC.unstable_ImmediatePriority, $a5d927e783c48bfa$var$gc = $aUPxC.unstable_UserBlockingPriority, $a5d927e783c48bfa$var$hc = $aUPxC.unstable_NormalPriority, $a5d927e783c48bfa$var$ic = $aUPxC.unstable_LowPriority, $a5d927e783c48bfa$var$jc = $aUPxC.unstable_IdlePriority, $a5d927e783c48bfa$var$kc = null, $a5d927e783c48bfa$var$lc = null;
function $a5d927e783c48bfa$var$mc(a) {
    if ($a5d927e783c48bfa$var$lc && "function" === typeof $a5d927e783c48bfa$var$lc.onCommitFiberRoot) try {
        $a5d927e783c48bfa$var$lc.onCommitFiberRoot($a5d927e783c48bfa$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $a5d927e783c48bfa$var$oc = Math.clz32 ? Math.clz32 : $a5d927e783c48bfa$var$nc, $a5d927e783c48bfa$var$pc = Math.log, $a5d927e783c48bfa$var$qc = Math.LN2;
function $a5d927e783c48bfa$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($a5d927e783c48bfa$var$pc(a) / $a5d927e783c48bfa$var$qc | 0) | 0;
}
var $a5d927e783c48bfa$var$rc = 64, $a5d927e783c48bfa$var$sc = 4194304;
function $a5d927e783c48bfa$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $a5d927e783c48bfa$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $a5d927e783c48bfa$var$tc(h) : (f &= g, 0 !== f && (d = $a5d927e783c48bfa$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $a5d927e783c48bfa$var$tc(g) : 0 !== f && (d = $a5d927e783c48bfa$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $a5d927e783c48bfa$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $a5d927e783c48bfa$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $a5d927e783c48bfa$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $a5d927e783c48bfa$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $a5d927e783c48bfa$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $a5d927e783c48bfa$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $a5d927e783c48bfa$var$yc() {
    var a = $a5d927e783c48bfa$var$rc;
    $a5d927e783c48bfa$var$rc <<= 1;
    0 === ($a5d927e783c48bfa$var$rc & 4194240) && ($a5d927e783c48bfa$var$rc = 64);
    return a;
}
function $a5d927e783c48bfa$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $a5d927e783c48bfa$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $a5d927e783c48bfa$var$oc(b);
    a[b] = c;
}
function $a5d927e783c48bfa$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $a5d927e783c48bfa$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $a5d927e783c48bfa$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $a5d927e783c48bfa$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $a5d927e783c48bfa$var$C = 0;
function $a5d927e783c48bfa$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $a5d927e783c48bfa$var$Ec, $a5d927e783c48bfa$var$Fc, $a5d927e783c48bfa$var$Gc, $a5d927e783c48bfa$var$Hc, $a5d927e783c48bfa$var$Ic, $a5d927e783c48bfa$var$Jc = !1, $a5d927e783c48bfa$var$Kc = [], $a5d927e783c48bfa$var$Lc = null, $a5d927e783c48bfa$var$Mc = null, $a5d927e783c48bfa$var$Nc = null, $a5d927e783c48bfa$var$Oc = new Map, $a5d927e783c48bfa$var$Pc = new Map, $a5d927e783c48bfa$var$Qc = [], $a5d927e783c48bfa$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $a5d927e783c48bfa$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $a5d927e783c48bfa$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $a5d927e783c48bfa$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $a5d927e783c48bfa$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $a5d927e783c48bfa$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $a5d927e783c48bfa$var$Pc.delete(b.pointerId);
    }
}
function $a5d927e783c48bfa$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $a5d927e783c48bfa$var$Cb(b), null !== b && $a5d927e783c48bfa$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $a5d927e783c48bfa$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $a5d927e783c48bfa$var$Lc = $a5d927e783c48bfa$var$Tc($a5d927e783c48bfa$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $a5d927e783c48bfa$var$Mc = $a5d927e783c48bfa$var$Tc($a5d927e783c48bfa$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $a5d927e783c48bfa$var$Nc = $a5d927e783c48bfa$var$Tc($a5d927e783c48bfa$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $a5d927e783c48bfa$var$Oc.set(f, $a5d927e783c48bfa$var$Tc($a5d927e783c48bfa$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $a5d927e783c48bfa$var$Pc.set(f, $a5d927e783c48bfa$var$Tc($a5d927e783c48bfa$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $a5d927e783c48bfa$var$Vc(a) {
    var b = $a5d927e783c48bfa$var$Wc(a.target);
    if (null !== b) {
        var c = $a5d927e783c48bfa$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $a5d927e783c48bfa$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $a5d927e783c48bfa$var$Ic(a.priority, function() {
                        $a5d927e783c48bfa$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $a5d927e783c48bfa$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $a5d927e783c48bfa$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $a5d927e783c48bfa$var$wb = d;
            c.target.dispatchEvent(d);
            $a5d927e783c48bfa$var$wb = null;
        } else return b = $a5d927e783c48bfa$var$Cb(c), null !== b && $a5d927e783c48bfa$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $a5d927e783c48bfa$var$Zc(a, b, c) {
    $a5d927e783c48bfa$var$Xc(a) && c.delete(b);
}
function $a5d927e783c48bfa$var$$c() {
    $a5d927e783c48bfa$var$Jc = !1;
    null !== $a5d927e783c48bfa$var$Lc && $a5d927e783c48bfa$var$Xc($a5d927e783c48bfa$var$Lc) && ($a5d927e783c48bfa$var$Lc = null);
    null !== $a5d927e783c48bfa$var$Mc && $a5d927e783c48bfa$var$Xc($a5d927e783c48bfa$var$Mc) && ($a5d927e783c48bfa$var$Mc = null);
    null !== $a5d927e783c48bfa$var$Nc && $a5d927e783c48bfa$var$Xc($a5d927e783c48bfa$var$Nc) && ($a5d927e783c48bfa$var$Nc = null);
    $a5d927e783c48bfa$var$Oc.forEach($a5d927e783c48bfa$var$Zc);
    $a5d927e783c48bfa$var$Pc.forEach($a5d927e783c48bfa$var$Zc);
}
function $a5d927e783c48bfa$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $a5d927e783c48bfa$var$Jc || ($a5d927e783c48bfa$var$Jc = !0, $aUPxC.unstable_scheduleCallback($aUPxC.unstable_NormalPriority, $a5d927e783c48bfa$var$$c)));
}
function $a5d927e783c48bfa$var$bd(a) {
    function b(b) {
        return $a5d927e783c48bfa$var$ad(b, a);
    }
    if (0 < $a5d927e783c48bfa$var$Kc.length) {
        $a5d927e783c48bfa$var$ad($a5d927e783c48bfa$var$Kc[0], a);
        for(var c = 1; c < $a5d927e783c48bfa$var$Kc.length; c++){
            var d = $a5d927e783c48bfa$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $a5d927e783c48bfa$var$Lc && $a5d927e783c48bfa$var$ad($a5d927e783c48bfa$var$Lc, a);
    null !== $a5d927e783c48bfa$var$Mc && $a5d927e783c48bfa$var$ad($a5d927e783c48bfa$var$Mc, a);
    null !== $a5d927e783c48bfa$var$Nc && $a5d927e783c48bfa$var$ad($a5d927e783c48bfa$var$Nc, a);
    $a5d927e783c48bfa$var$Oc.forEach(b);
    $a5d927e783c48bfa$var$Pc.forEach(b);
    for(c = 0; c < $a5d927e783c48bfa$var$Qc.length; c++)d = $a5d927e783c48bfa$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $a5d927e783c48bfa$var$Qc.length && (c = $a5d927e783c48bfa$var$Qc[0], null === c.blockedOn);)$a5d927e783c48bfa$var$Vc(c), null === c.blockedOn && $a5d927e783c48bfa$var$Qc.shift();
}
var $a5d927e783c48bfa$var$cd = $a5d927e783c48bfa$var$ua.ReactCurrentBatchConfig, $a5d927e783c48bfa$var$dd = !0;
function $a5d927e783c48bfa$var$ed(a, b, c, d) {
    var e = $a5d927e783c48bfa$var$C, f = $a5d927e783c48bfa$var$cd.transition;
    $a5d927e783c48bfa$var$cd.transition = null;
    try {
        $a5d927e783c48bfa$var$C = 1, $a5d927e783c48bfa$var$fd(a, b, c, d);
    } finally{
        $a5d927e783c48bfa$var$C = e, $a5d927e783c48bfa$var$cd.transition = f;
    }
}
function $a5d927e783c48bfa$var$gd(a, b, c, d) {
    var e = $a5d927e783c48bfa$var$C, f = $a5d927e783c48bfa$var$cd.transition;
    $a5d927e783c48bfa$var$cd.transition = null;
    try {
        $a5d927e783c48bfa$var$C = 4, $a5d927e783c48bfa$var$fd(a, b, c, d);
    } finally{
        $a5d927e783c48bfa$var$C = e, $a5d927e783c48bfa$var$cd.transition = f;
    }
}
function $a5d927e783c48bfa$var$fd(a, b, c, d) {
    if ($a5d927e783c48bfa$var$dd) {
        var e = $a5d927e783c48bfa$var$Yc(a, b, c, d);
        if (null === e) $a5d927e783c48bfa$var$hd(a, b, d, $a5d927e783c48bfa$var$id, c), $a5d927e783c48bfa$var$Sc(a, d);
        else if ($a5d927e783c48bfa$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($a5d927e783c48bfa$var$Sc(a, d), b & 4 && -1 < $a5d927e783c48bfa$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $a5d927e783c48bfa$var$Cb(e);
                null !== f && $a5d927e783c48bfa$var$Ec(f);
                f = $a5d927e783c48bfa$var$Yc(a, b, c, d);
                null === f && $a5d927e783c48bfa$var$hd(a, b, d, $a5d927e783c48bfa$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $a5d927e783c48bfa$var$hd(a, b, d, null, c);
    }
}
var $a5d927e783c48bfa$var$id = null;
function $a5d927e783c48bfa$var$Yc(a, b, c, d) {
    $a5d927e783c48bfa$var$id = null;
    a = $a5d927e783c48bfa$var$xb(d);
    a = $a5d927e783c48bfa$var$Wc(a);
    if (null !== a) {
        if (b = $a5d927e783c48bfa$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $a5d927e783c48bfa$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $a5d927e783c48bfa$var$id = a;
    return null;
}
function $a5d927e783c48bfa$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($a5d927e783c48bfa$var$ec()){
                case $a5d927e783c48bfa$var$fc:
                    return 1;
                case $a5d927e783c48bfa$var$gc:
                    return 4;
                case $a5d927e783c48bfa$var$hc:
                case $a5d927e783c48bfa$var$ic:
                    return 16;
                case $a5d927e783c48bfa$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $a5d927e783c48bfa$var$kd = null, $a5d927e783c48bfa$var$ld = null, $a5d927e783c48bfa$var$md = null;
function $a5d927e783c48bfa$var$nd() {
    if ($a5d927e783c48bfa$var$md) return $a5d927e783c48bfa$var$md;
    var a, b = $a5d927e783c48bfa$var$ld, c = b.length, d, e = "value" in $a5d927e783c48bfa$var$kd ? $a5d927e783c48bfa$var$kd.value : $a5d927e783c48bfa$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $a5d927e783c48bfa$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $a5d927e783c48bfa$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $a5d927e783c48bfa$var$pd() {
    return !0;
}
function $a5d927e783c48bfa$var$qd() {
    return !1;
}
function $a5d927e783c48bfa$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $a5d927e783c48bfa$var$pd : $a5d927e783c48bfa$var$qd;
        this.isPropagationStopped = $a5d927e783c48bfa$var$qd;
        return this;
    }
    $a5d927e783c48bfa$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $a5d927e783c48bfa$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $a5d927e783c48bfa$var$pd);
        },
        persist: function() {},
        isPersistent: $a5d927e783c48bfa$var$pd
    });
    return b;
}
var $a5d927e783c48bfa$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $a5d927e783c48bfa$var$td = $a5d927e783c48bfa$var$rd($a5d927e783c48bfa$var$sd), $a5d927e783c48bfa$var$ud = $a5d927e783c48bfa$var$A({}, $a5d927e783c48bfa$var$sd, {
    view: 0,
    detail: 0
}), $a5d927e783c48bfa$var$vd = $a5d927e783c48bfa$var$rd($a5d927e783c48bfa$var$ud), $a5d927e783c48bfa$var$wd, $a5d927e783c48bfa$var$xd, $a5d927e783c48bfa$var$yd, $a5d927e783c48bfa$var$Ad = $a5d927e783c48bfa$var$A({}, $a5d927e783c48bfa$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $a5d927e783c48bfa$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $a5d927e783c48bfa$var$yd && ($a5d927e783c48bfa$var$yd && "mousemove" === a.type ? ($a5d927e783c48bfa$var$wd = a.screenX - $a5d927e783c48bfa$var$yd.screenX, $a5d927e783c48bfa$var$xd = a.screenY - $a5d927e783c48bfa$var$yd.screenY) : $a5d927e783c48bfa$var$xd = $a5d927e783c48bfa$var$wd = 0, $a5d927e783c48bfa$var$yd = a);
        return $a5d927e783c48bfa$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $a5d927e783c48bfa$var$xd;
    }
}), $a5d927e783c48bfa$var$Bd = $a5d927e783c48bfa$var$rd($a5d927e783c48bfa$var$Ad), $a5d927e783c48bfa$var$Cd = $a5d927e783c48bfa$var$A({}, $a5d927e783c48bfa$var$Ad, {
    dataTransfer: 0
}), $a5d927e783c48bfa$var$Dd = $a5d927e783c48bfa$var$rd($a5d927e783c48bfa$var$Cd), $a5d927e783c48bfa$var$Ed = $a5d927e783c48bfa$var$A({}, $a5d927e783c48bfa$var$ud, {
    relatedTarget: 0
}), $a5d927e783c48bfa$var$Fd = $a5d927e783c48bfa$var$rd($a5d927e783c48bfa$var$Ed), $a5d927e783c48bfa$var$Gd = $a5d927e783c48bfa$var$A({}, $a5d927e783c48bfa$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a5d927e783c48bfa$var$Hd = $a5d927e783c48bfa$var$rd($a5d927e783c48bfa$var$Gd), $a5d927e783c48bfa$var$Id = $a5d927e783c48bfa$var$A({}, $a5d927e783c48bfa$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $a5d927e783c48bfa$var$Jd = $a5d927e783c48bfa$var$rd($a5d927e783c48bfa$var$Id), $a5d927e783c48bfa$var$Kd = $a5d927e783c48bfa$var$A({}, $a5d927e783c48bfa$var$sd, {
    data: 0
}), $a5d927e783c48bfa$var$Ld = $a5d927e783c48bfa$var$rd($a5d927e783c48bfa$var$Kd), $a5d927e783c48bfa$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $a5d927e783c48bfa$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $a5d927e783c48bfa$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $a5d927e783c48bfa$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $a5d927e783c48bfa$var$Od[a]) ? !!b[a] : !1;
}
function $a5d927e783c48bfa$var$zd() {
    return $a5d927e783c48bfa$var$Pd;
}
var $a5d927e783c48bfa$var$Qd = $a5d927e783c48bfa$var$A({}, $a5d927e783c48bfa$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $a5d927e783c48bfa$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $a5d927e783c48bfa$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $a5d927e783c48bfa$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $a5d927e783c48bfa$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $a5d927e783c48bfa$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $a5d927e783c48bfa$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $a5d927e783c48bfa$var$Rd = $a5d927e783c48bfa$var$rd($a5d927e783c48bfa$var$Qd), $a5d927e783c48bfa$var$Sd = $a5d927e783c48bfa$var$A({}, $a5d927e783c48bfa$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $a5d927e783c48bfa$var$Td = $a5d927e783c48bfa$var$rd($a5d927e783c48bfa$var$Sd), $a5d927e783c48bfa$var$Ud = $a5d927e783c48bfa$var$A({}, $a5d927e783c48bfa$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $a5d927e783c48bfa$var$zd
}), $a5d927e783c48bfa$var$Vd = $a5d927e783c48bfa$var$rd($a5d927e783c48bfa$var$Ud), $a5d927e783c48bfa$var$Wd = $a5d927e783c48bfa$var$A({}, $a5d927e783c48bfa$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a5d927e783c48bfa$var$Xd = $a5d927e783c48bfa$var$rd($a5d927e783c48bfa$var$Wd), $a5d927e783c48bfa$var$Yd = $a5d927e783c48bfa$var$A({}, $a5d927e783c48bfa$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $a5d927e783c48bfa$var$Zd = $a5d927e783c48bfa$var$rd($a5d927e783c48bfa$var$Yd), $a5d927e783c48bfa$var$$d = [
    9,
    13,
    27,
    32
], $a5d927e783c48bfa$var$ae = $a5d927e783c48bfa$var$ia && "CompositionEvent" in window, $a5d927e783c48bfa$var$be = null;
$a5d927e783c48bfa$var$ia && "documentMode" in document && ($a5d927e783c48bfa$var$be = document.documentMode);
var $a5d927e783c48bfa$var$ce = $a5d927e783c48bfa$var$ia && "TextEvent" in window && !$a5d927e783c48bfa$var$be, $a5d927e783c48bfa$var$de = $a5d927e783c48bfa$var$ia && (!$a5d927e783c48bfa$var$ae || $a5d927e783c48bfa$var$be && 8 < $a5d927e783c48bfa$var$be && 11 >= $a5d927e783c48bfa$var$be), $a5d927e783c48bfa$var$ee = String.fromCharCode(32), $a5d927e783c48bfa$var$fe = !1;
function $a5d927e783c48bfa$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $a5d927e783c48bfa$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $a5d927e783c48bfa$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $a5d927e783c48bfa$var$ie = !1;
function $a5d927e783c48bfa$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $a5d927e783c48bfa$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $a5d927e783c48bfa$var$fe = !0;
            return $a5d927e783c48bfa$var$ee;
        case "textInput":
            return a = b.data, a === $a5d927e783c48bfa$var$ee && $a5d927e783c48bfa$var$fe ? null : a;
        default:
            return null;
    }
}
function $a5d927e783c48bfa$var$ke(a, b) {
    if ($a5d927e783c48bfa$var$ie) return "compositionend" === a || !$a5d927e783c48bfa$var$ae && $a5d927e783c48bfa$var$ge(a, b) ? (a = $a5d927e783c48bfa$var$nd(), $a5d927e783c48bfa$var$md = $a5d927e783c48bfa$var$ld = $a5d927e783c48bfa$var$kd = null, $a5d927e783c48bfa$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $a5d927e783c48bfa$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $a5d927e783c48bfa$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $a5d927e783c48bfa$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$a5d927e783c48bfa$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $a5d927e783c48bfa$var$ne(a, b, c, d) {
    $a5d927e783c48bfa$var$Eb(d);
    b = $a5d927e783c48bfa$var$oe(b, "onChange");
    0 < b.length && (c = new $a5d927e783c48bfa$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $a5d927e783c48bfa$var$pe = null, $a5d927e783c48bfa$var$qe = null;
function $a5d927e783c48bfa$var$re(a) {
    $a5d927e783c48bfa$var$se(a, 0);
}
function $a5d927e783c48bfa$var$te(a) {
    var b = $a5d927e783c48bfa$var$ue(a);
    if ($a5d927e783c48bfa$var$Wa(b)) return a;
}
function $a5d927e783c48bfa$var$ve(a, b) {
    if ("change" === a) return b;
}
var $a5d927e783c48bfa$var$we = !1;
if ($a5d927e783c48bfa$var$ia) {
    var $a5d927e783c48bfa$var$xe;
    if ($a5d927e783c48bfa$var$ia) {
        var $a5d927e783c48bfa$var$ye = "oninput" in document;
        if (!$a5d927e783c48bfa$var$ye) {
            var $a5d927e783c48bfa$var$ze = document.createElement("div");
            $a5d927e783c48bfa$var$ze.setAttribute("oninput", "return;");
            $a5d927e783c48bfa$var$ye = "function" === typeof $a5d927e783c48bfa$var$ze.oninput;
        }
        $a5d927e783c48bfa$var$xe = $a5d927e783c48bfa$var$ye;
    } else $a5d927e783c48bfa$var$xe = !1;
    $a5d927e783c48bfa$var$we = $a5d927e783c48bfa$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $a5d927e783c48bfa$var$Ae() {
    $a5d927e783c48bfa$var$pe && ($a5d927e783c48bfa$var$pe.detachEvent("onpropertychange", $a5d927e783c48bfa$var$Be), $a5d927e783c48bfa$var$qe = $a5d927e783c48bfa$var$pe = null);
}
function $a5d927e783c48bfa$var$Be(a) {
    if ("value" === a.propertyName && $a5d927e783c48bfa$var$te($a5d927e783c48bfa$var$qe)) {
        var b = [];
        $a5d927e783c48bfa$var$ne(b, $a5d927e783c48bfa$var$qe, a, $a5d927e783c48bfa$var$xb(a));
        $a5d927e783c48bfa$var$Jb($a5d927e783c48bfa$var$re, b);
    }
}
function $a5d927e783c48bfa$var$Ce(a, b, c) {
    "focusin" === a ? ($a5d927e783c48bfa$var$Ae(), $a5d927e783c48bfa$var$pe = b, $a5d927e783c48bfa$var$qe = c, $a5d927e783c48bfa$var$pe.attachEvent("onpropertychange", $a5d927e783c48bfa$var$Be)) : "focusout" === a && $a5d927e783c48bfa$var$Ae();
}
function $a5d927e783c48bfa$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $a5d927e783c48bfa$var$te($a5d927e783c48bfa$var$qe);
}
function $a5d927e783c48bfa$var$Ee(a, b) {
    if ("click" === a) return $a5d927e783c48bfa$var$te(b);
}
function $a5d927e783c48bfa$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $a5d927e783c48bfa$var$te(b);
}
function $a5d927e783c48bfa$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a5d927e783c48bfa$var$He = "function" === typeof Object.is ? Object.is : $a5d927e783c48bfa$var$Ge;
function $a5d927e783c48bfa$var$Ie(a, b) {
    if ($a5d927e783c48bfa$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$a5d927e783c48bfa$var$ja.call(b, e) || !$a5d927e783c48bfa$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $a5d927e783c48bfa$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $a5d927e783c48bfa$var$Ke(a, b) {
    var c = $a5d927e783c48bfa$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $a5d927e783c48bfa$var$Je(c);
    }
}
function $a5d927e783c48bfa$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $a5d927e783c48bfa$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $a5d927e783c48bfa$var$Me() {
    for(var a = window, b = $a5d927e783c48bfa$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $a5d927e783c48bfa$var$Xa(a.document);
    }
    return b;
}
function $a5d927e783c48bfa$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $a5d927e783c48bfa$var$Oe(a) {
    var b = $a5d927e783c48bfa$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $a5d927e783c48bfa$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $a5d927e783c48bfa$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $a5d927e783c48bfa$var$Ke(c, f);
                var g = $a5d927e783c48bfa$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $a5d927e783c48bfa$var$Pe = $a5d927e783c48bfa$var$ia && "documentMode" in document && 11 >= document.documentMode, $a5d927e783c48bfa$var$Qe = null, $a5d927e783c48bfa$var$Re = null, $a5d927e783c48bfa$var$Se = null, $a5d927e783c48bfa$var$Te = !1;
function $a5d927e783c48bfa$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $a5d927e783c48bfa$var$Te || null == $a5d927e783c48bfa$var$Qe || $a5d927e783c48bfa$var$Qe !== $a5d927e783c48bfa$var$Xa(d) || (d = $a5d927e783c48bfa$var$Qe, "selectionStart" in d && $a5d927e783c48bfa$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $a5d927e783c48bfa$var$Se && $a5d927e783c48bfa$var$Ie($a5d927e783c48bfa$var$Se, d) || ($a5d927e783c48bfa$var$Se = d, d = $a5d927e783c48bfa$var$oe($a5d927e783c48bfa$var$Re, "onSelect"), 0 < d.length && (b = new $a5d927e783c48bfa$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $a5d927e783c48bfa$var$Qe)));
}
function $a5d927e783c48bfa$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $a5d927e783c48bfa$var$We = {
    animationend: $a5d927e783c48bfa$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $a5d927e783c48bfa$var$Ve("Animation", "AnimationIteration"),
    animationstart: $a5d927e783c48bfa$var$Ve("Animation", "AnimationStart"),
    transitionend: $a5d927e783c48bfa$var$Ve("Transition", "TransitionEnd")
}, $a5d927e783c48bfa$var$Xe = {}, $a5d927e783c48bfa$var$Ye = {};
$a5d927e783c48bfa$var$ia && ($a5d927e783c48bfa$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $a5d927e783c48bfa$var$We.animationend.animation, delete $a5d927e783c48bfa$var$We.animationiteration.animation, delete $a5d927e783c48bfa$var$We.animationstart.animation), "TransitionEvent" in window || delete $a5d927e783c48bfa$var$We.transitionend.transition);
function $a5d927e783c48bfa$var$Ze(a) {
    if ($a5d927e783c48bfa$var$Xe[a]) return $a5d927e783c48bfa$var$Xe[a];
    if (!$a5d927e783c48bfa$var$We[a]) return a;
    var b = $a5d927e783c48bfa$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $a5d927e783c48bfa$var$Ye) return $a5d927e783c48bfa$var$Xe[a] = b[c];
    return a;
}
var $a5d927e783c48bfa$var$$e = $a5d927e783c48bfa$var$Ze("animationend"), $a5d927e783c48bfa$var$af = $a5d927e783c48bfa$var$Ze("animationiteration"), $a5d927e783c48bfa$var$bf = $a5d927e783c48bfa$var$Ze("animationstart"), $a5d927e783c48bfa$var$cf = $a5d927e783c48bfa$var$Ze("transitionend"), $a5d927e783c48bfa$var$df = new Map, $a5d927e783c48bfa$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $a5d927e783c48bfa$var$ff(a, b) {
    $a5d927e783c48bfa$var$df.set(a, b);
    $a5d927e783c48bfa$var$fa(b, [
        a
    ]);
}
for(var $a5d927e783c48bfa$var$gf = 0; $a5d927e783c48bfa$var$gf < $a5d927e783c48bfa$var$ef.length; $a5d927e783c48bfa$var$gf++){
    var $a5d927e783c48bfa$var$hf = $a5d927e783c48bfa$var$ef[$a5d927e783c48bfa$var$gf], $a5d927e783c48bfa$var$jf = $a5d927e783c48bfa$var$hf.toLowerCase(), $a5d927e783c48bfa$var$kf = $a5d927e783c48bfa$var$hf[0].toUpperCase() + $a5d927e783c48bfa$var$hf.slice(1);
    $a5d927e783c48bfa$var$ff($a5d927e783c48bfa$var$jf, "on" + $a5d927e783c48bfa$var$kf);
}
$a5d927e783c48bfa$var$ff($a5d927e783c48bfa$var$$e, "onAnimationEnd");
$a5d927e783c48bfa$var$ff($a5d927e783c48bfa$var$af, "onAnimationIteration");
$a5d927e783c48bfa$var$ff($a5d927e783c48bfa$var$bf, "onAnimationStart");
$a5d927e783c48bfa$var$ff("dblclick", "onDoubleClick");
$a5d927e783c48bfa$var$ff("focusin", "onFocus");
$a5d927e783c48bfa$var$ff("focusout", "onBlur");
$a5d927e783c48bfa$var$ff($a5d927e783c48bfa$var$cf, "onTransitionEnd");
$a5d927e783c48bfa$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$a5d927e783c48bfa$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$a5d927e783c48bfa$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$a5d927e783c48bfa$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$a5d927e783c48bfa$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$a5d927e783c48bfa$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$a5d927e783c48bfa$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$a5d927e783c48bfa$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$a5d927e783c48bfa$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$a5d927e783c48bfa$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $a5d927e783c48bfa$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $a5d927e783c48bfa$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($a5d927e783c48bfa$var$lf));
function $a5d927e783c48bfa$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $a5d927e783c48bfa$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $a5d927e783c48bfa$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a5d927e783c48bfa$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a5d927e783c48bfa$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($a5d927e783c48bfa$var$Qb) throw a = $a5d927e783c48bfa$var$Rb, $a5d927e783c48bfa$var$Qb = !1, $a5d927e783c48bfa$var$Rb = null, a;
}
function $a5d927e783c48bfa$var$D(a, b) {
    var c = b[$a5d927e783c48bfa$var$of];
    void 0 === c && (c = b[$a5d927e783c48bfa$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($a5d927e783c48bfa$var$pf(b, a, 2, !1), c.add(d));
}
function $a5d927e783c48bfa$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $a5d927e783c48bfa$var$pf(c, a, d, b);
}
var $a5d927e783c48bfa$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $a5d927e783c48bfa$var$sf(a) {
    if (!a[$a5d927e783c48bfa$var$rf]) {
        a[$a5d927e783c48bfa$var$rf] = !0;
        $a5d927e783c48bfa$var$da.forEach(function(b) {
            "selectionchange" !== b && ($a5d927e783c48bfa$var$mf.has(b) || $a5d927e783c48bfa$var$qf(b, !1, a), $a5d927e783c48bfa$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$a5d927e783c48bfa$var$rf] || (b[$a5d927e783c48bfa$var$rf] = !0, $a5d927e783c48bfa$var$qf("selectionchange", !1, b));
    }
}
function $a5d927e783c48bfa$var$pf(a, b, c, d) {
    switch($a5d927e783c48bfa$var$jd(b)){
        case 1:
            var e = $a5d927e783c48bfa$var$ed;
            break;
        case 4:
            e = $a5d927e783c48bfa$var$gd;
            break;
        default:
            e = $a5d927e783c48bfa$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$a5d927e783c48bfa$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $a5d927e783c48bfa$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $a5d927e783c48bfa$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $a5d927e783c48bfa$var$Jb(function() {
        var d = f, e = $a5d927e783c48bfa$var$xb(c), g = [];
        a: {
            var h = $a5d927e783c48bfa$var$df.get(a);
            if (void 0 !== h) {
                var k = $a5d927e783c48bfa$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $a5d927e783c48bfa$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $a5d927e783c48bfa$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $a5d927e783c48bfa$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $a5d927e783c48bfa$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $a5d927e783c48bfa$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $a5d927e783c48bfa$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $a5d927e783c48bfa$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $a5d927e783c48bfa$var$Vd;
                        break;
                    case $a5d927e783c48bfa$var$$e:
                    case $a5d927e783c48bfa$var$af:
                    case $a5d927e783c48bfa$var$bf:
                        k = $a5d927e783c48bfa$var$Hd;
                        break;
                    case $a5d927e783c48bfa$var$cf:
                        k = $a5d927e783c48bfa$var$Xd;
                        break;
                    case "scroll":
                        k = $a5d927e783c48bfa$var$vd;
                        break;
                    case "wheel":
                        k = $a5d927e783c48bfa$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $a5d927e783c48bfa$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $a5d927e783c48bfa$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $a5d927e783c48bfa$var$Kb(w, x), null != F && t.push($a5d927e783c48bfa$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $a5d927e783c48bfa$var$wb && (n = c.relatedTarget || c.fromElement) && ($a5d927e783c48bfa$var$Wc(n) || n[$a5d927e783c48bfa$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $a5d927e783c48bfa$var$Wc(n) : null, null !== n && (J = $a5d927e783c48bfa$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $a5d927e783c48bfa$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $a5d927e783c48bfa$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $a5d927e783c48bfa$var$ue(k);
                        u = null == n ? h : $a5d927e783c48bfa$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $a5d927e783c48bfa$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $a5d927e783c48bfa$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $a5d927e783c48bfa$var$vf(F))u++;
                            for(; 0 < w - u;)t = $a5d927e783c48bfa$var$vf(t), w--;
                            for(; 0 < u - w;)x = $a5d927e783c48bfa$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $a5d927e783c48bfa$var$vf(t);
                                x = $a5d927e783c48bfa$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $a5d927e783c48bfa$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $a5d927e783c48bfa$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $a5d927e783c48bfa$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $a5d927e783c48bfa$var$ve;
                else if ($a5d927e783c48bfa$var$me(h)) {
                    if ($a5d927e783c48bfa$var$we) na = $a5d927e783c48bfa$var$Fe;
                    else {
                        na = $a5d927e783c48bfa$var$De;
                        var xa = $a5d927e783c48bfa$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $a5d927e783c48bfa$var$Ee);
                if (na && (na = na(a, d))) {
                    $a5d927e783c48bfa$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $a5d927e783c48bfa$var$cb(h, "number", h.value);
            }
            xa = d ? $a5d927e783c48bfa$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($a5d927e783c48bfa$var$me(xa) || "true" === xa.contentEditable) $a5d927e783c48bfa$var$Qe = xa, $a5d927e783c48bfa$var$Re = d, $a5d927e783c48bfa$var$Se = null;
                    break;
                case "focusout":
                    $a5d927e783c48bfa$var$Se = $a5d927e783c48bfa$var$Re = $a5d927e783c48bfa$var$Qe = null;
                    break;
                case "mousedown":
                    $a5d927e783c48bfa$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $a5d927e783c48bfa$var$Te = !1;
                    $a5d927e783c48bfa$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($a5d927e783c48bfa$var$Pe) break;
                case "keydown":
                case "keyup":
                    $a5d927e783c48bfa$var$Ue(g, c, e);
            }
            var $a;
            if ($a5d927e783c48bfa$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $a5d927e783c48bfa$var$ie ? $a5d927e783c48bfa$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($a5d927e783c48bfa$var$de && "ko" !== c.locale && ($a5d927e783c48bfa$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $a5d927e783c48bfa$var$ie && ($a = $a5d927e783c48bfa$var$nd()) : ($a5d927e783c48bfa$var$kd = e, $a5d927e783c48bfa$var$ld = "value" in $a5d927e783c48bfa$var$kd ? $a5d927e783c48bfa$var$kd.value : $a5d927e783c48bfa$var$kd.textContent, $a5d927e783c48bfa$var$ie = !0)), xa = $a5d927e783c48bfa$var$oe(d, ba), 0 < xa.length && (ba = new $a5d927e783c48bfa$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $a5d927e783c48bfa$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $a5d927e783c48bfa$var$ce ? $a5d927e783c48bfa$var$je(a, c) : $a5d927e783c48bfa$var$ke(a, c)) d = $a5d927e783c48bfa$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $a5d927e783c48bfa$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $a5d927e783c48bfa$var$se(g, b);
    });
}
function $a5d927e783c48bfa$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $a5d927e783c48bfa$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $a5d927e783c48bfa$var$Kb(a, c), null != f && d.unshift($a5d927e783c48bfa$var$tf(a, f, e)), f = $a5d927e783c48bfa$var$Kb(a, b), null != f && d.push($a5d927e783c48bfa$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $a5d927e783c48bfa$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $a5d927e783c48bfa$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $a5d927e783c48bfa$var$Kb(c, f), null != k && g.unshift($a5d927e783c48bfa$var$tf(c, k, h))) : e || (k = $a5d927e783c48bfa$var$Kb(c, f), null != k && g.push($a5d927e783c48bfa$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $a5d927e783c48bfa$var$xf = /\r\n?/g, $a5d927e783c48bfa$var$yf = /\u0000|\uFFFD/g;
function $a5d927e783c48bfa$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($a5d927e783c48bfa$var$xf, "\n").replace($a5d927e783c48bfa$var$yf, "");
}
function $a5d927e783c48bfa$var$Af(a, b, c) {
    b = $a5d927e783c48bfa$var$zf(b);
    if ($a5d927e783c48bfa$var$zf(a) !== b && c) throw Error($a5d927e783c48bfa$var$p(425));
}
function $a5d927e783c48bfa$var$Bf() {}
var $a5d927e783c48bfa$var$Cf = null, $a5d927e783c48bfa$var$Df = null;
function $a5d927e783c48bfa$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $a5d927e783c48bfa$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $a5d927e783c48bfa$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $a5d927e783c48bfa$var$Hf = "function" === typeof Promise ? Promise : void 0, $a5d927e783c48bfa$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $a5d927e783c48bfa$var$Hf ? function(a) {
    return $a5d927e783c48bfa$var$Hf.resolve(null).then(a).catch($a5d927e783c48bfa$var$If);
} : $a5d927e783c48bfa$var$Ff;
function $a5d927e783c48bfa$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $a5d927e783c48bfa$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $a5d927e783c48bfa$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $a5d927e783c48bfa$var$bd(b);
}
function $a5d927e783c48bfa$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $a5d927e783c48bfa$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $a5d927e783c48bfa$var$Nf = Math.random().toString(36).slice(2), $a5d927e783c48bfa$var$Of = "__reactFiber$" + $a5d927e783c48bfa$var$Nf, $a5d927e783c48bfa$var$Pf = "__reactProps$" + $a5d927e783c48bfa$var$Nf, $a5d927e783c48bfa$var$uf = "__reactContainer$" + $a5d927e783c48bfa$var$Nf, $a5d927e783c48bfa$var$of = "__reactEvents$" + $a5d927e783c48bfa$var$Nf, $a5d927e783c48bfa$var$Qf = "__reactListeners$" + $a5d927e783c48bfa$var$Nf, $a5d927e783c48bfa$var$Rf = "__reactHandles$" + $a5d927e783c48bfa$var$Nf;
function $a5d927e783c48bfa$var$Wc(a) {
    var b = a[$a5d927e783c48bfa$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$a5d927e783c48bfa$var$uf] || c[$a5d927e783c48bfa$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $a5d927e783c48bfa$var$Mf(a); null !== a;){
                if (c = a[$a5d927e783c48bfa$var$Of]) return c;
                a = $a5d927e783c48bfa$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $a5d927e783c48bfa$var$Cb(a) {
    a = a[$a5d927e783c48bfa$var$Of] || a[$a5d927e783c48bfa$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $a5d927e783c48bfa$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($a5d927e783c48bfa$var$p(33));
}
function $a5d927e783c48bfa$var$Db(a) {
    return a[$a5d927e783c48bfa$var$Pf] || null;
}
var $a5d927e783c48bfa$var$Sf = [], $a5d927e783c48bfa$var$Tf = -1;
function $a5d927e783c48bfa$var$Uf(a) {
    return {
        current: a
    };
}
function $a5d927e783c48bfa$var$E(a) {
    0 > $a5d927e783c48bfa$var$Tf || (a.current = $a5d927e783c48bfa$var$Sf[$a5d927e783c48bfa$var$Tf], $a5d927e783c48bfa$var$Sf[$a5d927e783c48bfa$var$Tf] = null, $a5d927e783c48bfa$var$Tf--);
}
function $a5d927e783c48bfa$var$G(a, b) {
    $a5d927e783c48bfa$var$Tf++;
    $a5d927e783c48bfa$var$Sf[$a5d927e783c48bfa$var$Tf] = a.current;
    a.current = b;
}
var $a5d927e783c48bfa$var$Vf = {}, $a5d927e783c48bfa$var$H = $a5d927e783c48bfa$var$Uf($a5d927e783c48bfa$var$Vf), $a5d927e783c48bfa$var$Wf = $a5d927e783c48bfa$var$Uf(!1), $a5d927e783c48bfa$var$Xf = $a5d927e783c48bfa$var$Vf;
function $a5d927e783c48bfa$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $a5d927e783c48bfa$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $a5d927e783c48bfa$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $a5d927e783c48bfa$var$$f() {
    $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$Wf);
    $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$H);
}
function $a5d927e783c48bfa$var$ag(a, b, c) {
    if ($a5d927e783c48bfa$var$H.current !== $a5d927e783c48bfa$var$Vf) throw Error($a5d927e783c48bfa$var$p(168));
    $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$H, b);
    $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$Wf, c);
}
function $a5d927e783c48bfa$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($a5d927e783c48bfa$var$p(108, $a5d927e783c48bfa$var$Ra(a) || "Unknown", e));
    return $a5d927e783c48bfa$var$A({}, c, d);
}
function $a5d927e783c48bfa$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $a5d927e783c48bfa$var$Vf;
    $a5d927e783c48bfa$var$Xf = $a5d927e783c48bfa$var$H.current;
    $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$H, a);
    $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$Wf, $a5d927e783c48bfa$var$Wf.current);
    return !0;
}
function $a5d927e783c48bfa$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($a5d927e783c48bfa$var$p(169));
    c ? (a = $a5d927e783c48bfa$var$bg(a, b, $a5d927e783c48bfa$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$Wf), $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$H), $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$H, a)) : $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$Wf);
    $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$Wf, c);
}
var $a5d927e783c48bfa$var$eg = null, $a5d927e783c48bfa$var$fg = !1, $a5d927e783c48bfa$var$gg = !1;
function $a5d927e783c48bfa$var$hg(a) {
    null === $a5d927e783c48bfa$var$eg ? $a5d927e783c48bfa$var$eg = [
        a
    ] : $a5d927e783c48bfa$var$eg.push(a);
}
function $a5d927e783c48bfa$var$ig(a) {
    $a5d927e783c48bfa$var$fg = !0;
    $a5d927e783c48bfa$var$hg(a);
}
function $a5d927e783c48bfa$var$jg() {
    if (!$a5d927e783c48bfa$var$gg && null !== $a5d927e783c48bfa$var$eg) {
        $a5d927e783c48bfa$var$gg = !0;
        var a = 0, b = $a5d927e783c48bfa$var$C;
        try {
            var c = $a5d927e783c48bfa$var$eg;
            for($a5d927e783c48bfa$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $a5d927e783c48bfa$var$eg = null;
            $a5d927e783c48bfa$var$fg = !1;
        } catch (e) {
            throw null !== $a5d927e783c48bfa$var$eg && ($a5d927e783c48bfa$var$eg = $a5d927e783c48bfa$var$eg.slice(a + 1)), $a5d927e783c48bfa$var$ac($a5d927e783c48bfa$var$fc, $a5d927e783c48bfa$var$jg), e;
        } finally{
            $a5d927e783c48bfa$var$C = b, $a5d927e783c48bfa$var$gg = !1;
        }
    }
    return null;
}
var $a5d927e783c48bfa$var$kg = [], $a5d927e783c48bfa$var$lg = 0, $a5d927e783c48bfa$var$mg = null, $a5d927e783c48bfa$var$ng = 0, $a5d927e783c48bfa$var$og = [], $a5d927e783c48bfa$var$pg = 0, $a5d927e783c48bfa$var$qg = null, $a5d927e783c48bfa$var$rg = 1, $a5d927e783c48bfa$var$sg = "";
function $a5d927e783c48bfa$var$tg(a, b) {
    $a5d927e783c48bfa$var$kg[$a5d927e783c48bfa$var$lg++] = $a5d927e783c48bfa$var$ng;
    $a5d927e783c48bfa$var$kg[$a5d927e783c48bfa$var$lg++] = $a5d927e783c48bfa$var$mg;
    $a5d927e783c48bfa$var$mg = a;
    $a5d927e783c48bfa$var$ng = b;
}
function $a5d927e783c48bfa$var$ug(a, b, c) {
    $a5d927e783c48bfa$var$og[$a5d927e783c48bfa$var$pg++] = $a5d927e783c48bfa$var$rg;
    $a5d927e783c48bfa$var$og[$a5d927e783c48bfa$var$pg++] = $a5d927e783c48bfa$var$sg;
    $a5d927e783c48bfa$var$og[$a5d927e783c48bfa$var$pg++] = $a5d927e783c48bfa$var$qg;
    $a5d927e783c48bfa$var$qg = a;
    var d = $a5d927e783c48bfa$var$rg;
    a = $a5d927e783c48bfa$var$sg;
    var e = 32 - $a5d927e783c48bfa$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $a5d927e783c48bfa$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $a5d927e783c48bfa$var$rg = 1 << 32 - $a5d927e783c48bfa$var$oc(b) + e | c << e | d;
        $a5d927e783c48bfa$var$sg = f + a;
    } else $a5d927e783c48bfa$var$rg = 1 << f | c << e | d, $a5d927e783c48bfa$var$sg = a;
}
function $a5d927e783c48bfa$var$vg(a) {
    null !== a.return && ($a5d927e783c48bfa$var$tg(a, 1), $a5d927e783c48bfa$var$ug(a, 1, 0));
}
function $a5d927e783c48bfa$var$wg(a) {
    for(; a === $a5d927e783c48bfa$var$mg;)$a5d927e783c48bfa$var$mg = $a5d927e783c48bfa$var$kg[--$a5d927e783c48bfa$var$lg], $a5d927e783c48bfa$var$kg[$a5d927e783c48bfa$var$lg] = null, $a5d927e783c48bfa$var$ng = $a5d927e783c48bfa$var$kg[--$a5d927e783c48bfa$var$lg], $a5d927e783c48bfa$var$kg[$a5d927e783c48bfa$var$lg] = null;
    for(; a === $a5d927e783c48bfa$var$qg;)$a5d927e783c48bfa$var$qg = $a5d927e783c48bfa$var$og[--$a5d927e783c48bfa$var$pg], $a5d927e783c48bfa$var$og[$a5d927e783c48bfa$var$pg] = null, $a5d927e783c48bfa$var$sg = $a5d927e783c48bfa$var$og[--$a5d927e783c48bfa$var$pg], $a5d927e783c48bfa$var$og[$a5d927e783c48bfa$var$pg] = null, $a5d927e783c48bfa$var$rg = $a5d927e783c48bfa$var$og[--$a5d927e783c48bfa$var$pg], $a5d927e783c48bfa$var$og[$a5d927e783c48bfa$var$pg] = null;
}
var $a5d927e783c48bfa$var$xg = null, $a5d927e783c48bfa$var$yg = null, $a5d927e783c48bfa$var$I = !1, $a5d927e783c48bfa$var$zg = null;
function $a5d927e783c48bfa$var$Ag(a, b) {
    var c = $a5d927e783c48bfa$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $a5d927e783c48bfa$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $a5d927e783c48bfa$var$xg = a, $a5d927e783c48bfa$var$yg = $a5d927e783c48bfa$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $a5d927e783c48bfa$var$xg = a, $a5d927e783c48bfa$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $a5d927e783c48bfa$var$qg ? {
                id: $a5d927e783c48bfa$var$rg,
                overflow: $a5d927e783c48bfa$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $a5d927e783c48bfa$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $a5d927e783c48bfa$var$xg = a, $a5d927e783c48bfa$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $a5d927e783c48bfa$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $a5d927e783c48bfa$var$Eg(a) {
    if ($a5d927e783c48bfa$var$I) {
        var b = $a5d927e783c48bfa$var$yg;
        if (b) {
            var c = b;
            if (!$a5d927e783c48bfa$var$Cg(a, b)) {
                if ($a5d927e783c48bfa$var$Dg(a)) throw Error($a5d927e783c48bfa$var$p(418));
                b = $a5d927e783c48bfa$var$Lf(c.nextSibling);
                var d = $a5d927e783c48bfa$var$xg;
                b && $a5d927e783c48bfa$var$Cg(a, b) ? $a5d927e783c48bfa$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $a5d927e783c48bfa$var$I = !1, $a5d927e783c48bfa$var$xg = a);
            }
        } else {
            if ($a5d927e783c48bfa$var$Dg(a)) throw Error($a5d927e783c48bfa$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $a5d927e783c48bfa$var$I = !1;
            $a5d927e783c48bfa$var$xg = a;
        }
    }
}
function $a5d927e783c48bfa$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $a5d927e783c48bfa$var$xg = a;
}
function $a5d927e783c48bfa$var$Gg(a) {
    if (a !== $a5d927e783c48bfa$var$xg) return !1;
    if (!$a5d927e783c48bfa$var$I) return $a5d927e783c48bfa$var$Fg(a), $a5d927e783c48bfa$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$a5d927e783c48bfa$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $a5d927e783c48bfa$var$yg)) {
        if ($a5d927e783c48bfa$var$Dg(a)) throw $a5d927e783c48bfa$var$Hg(), Error($a5d927e783c48bfa$var$p(418));
        for(; b;)$a5d927e783c48bfa$var$Ag(a, b), b = $a5d927e783c48bfa$var$Lf(b.nextSibling);
    }
    $a5d927e783c48bfa$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($a5d927e783c48bfa$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $a5d927e783c48bfa$var$yg = $a5d927e783c48bfa$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $a5d927e783c48bfa$var$yg = null;
        }
    } else $a5d927e783c48bfa$var$yg = $a5d927e783c48bfa$var$xg ? $a5d927e783c48bfa$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $a5d927e783c48bfa$var$Hg() {
    for(var a = $a5d927e783c48bfa$var$yg; a;)a = $a5d927e783c48bfa$var$Lf(a.nextSibling);
}
function $a5d927e783c48bfa$var$Ig() {
    $a5d927e783c48bfa$var$yg = $a5d927e783c48bfa$var$xg = null;
    $a5d927e783c48bfa$var$I = !1;
}
function $a5d927e783c48bfa$var$Jg(a) {
    null === $a5d927e783c48bfa$var$zg ? $a5d927e783c48bfa$var$zg = [
        a
    ] : $a5d927e783c48bfa$var$zg.push(a);
}
var $a5d927e783c48bfa$var$Kg = $a5d927e783c48bfa$var$ua.ReactCurrentBatchConfig;
function $a5d927e783c48bfa$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $a5d927e783c48bfa$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $a5d927e783c48bfa$var$Mg = $a5d927e783c48bfa$var$Uf(null), $a5d927e783c48bfa$var$Ng = null, $a5d927e783c48bfa$var$Og = null, $a5d927e783c48bfa$var$Pg = null;
function $a5d927e783c48bfa$var$Qg() {
    $a5d927e783c48bfa$var$Pg = $a5d927e783c48bfa$var$Og = $a5d927e783c48bfa$var$Ng = null;
}
function $a5d927e783c48bfa$var$Rg(a) {
    var b = $a5d927e783c48bfa$var$Mg.current;
    $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$Mg);
    a._currentValue = b;
}
function $a5d927e783c48bfa$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $a5d927e783c48bfa$var$Tg(a, b) {
    $a5d927e783c48bfa$var$Ng = a;
    $a5d927e783c48bfa$var$Pg = $a5d927e783c48bfa$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($a5d927e783c48bfa$var$Ug = !0), a.firstContext = null);
}
function $a5d927e783c48bfa$var$Vg(a) {
    var b = a._currentValue;
    if ($a5d927e783c48bfa$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $a5d927e783c48bfa$var$Og) {
            if (null === $a5d927e783c48bfa$var$Ng) throw Error($a5d927e783c48bfa$var$p(308));
            $a5d927e783c48bfa$var$Og = a;
            $a5d927e783c48bfa$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $a5d927e783c48bfa$var$Og = $a5d927e783c48bfa$var$Og.next = a;
    }
    return b;
}
var $a5d927e783c48bfa$var$Wg = null;
function $a5d927e783c48bfa$var$Xg(a) {
    null === $a5d927e783c48bfa$var$Wg ? $a5d927e783c48bfa$var$Wg = [
        a
    ] : $a5d927e783c48bfa$var$Wg.push(a);
}
function $a5d927e783c48bfa$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $a5d927e783c48bfa$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $a5d927e783c48bfa$var$Zg(a, d);
}
function $a5d927e783c48bfa$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $a5d927e783c48bfa$var$$g = !1;
function $a5d927e783c48bfa$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $a5d927e783c48bfa$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $a5d927e783c48bfa$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $a5d927e783c48bfa$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($a5d927e783c48bfa$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $a5d927e783c48bfa$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $a5d927e783c48bfa$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $a5d927e783c48bfa$var$Zg(a, c);
}
function $a5d927e783c48bfa$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $a5d927e783c48bfa$var$Cc(a, c);
    }
}
function $a5d927e783c48bfa$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $a5d927e783c48bfa$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $a5d927e783c48bfa$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $a5d927e783c48bfa$var$A({}, q, r);
                            break a;
                        case 2:
                            $a5d927e783c48bfa$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $a5d927e783c48bfa$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $a5d927e783c48bfa$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($a5d927e783c48bfa$var$p(191, e));
            e.call(d);
        }
    }
}
var $a5d927e783c48bfa$var$jh = (new $35jnV.Component).refs;
function $a5d927e783c48bfa$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $a5d927e783c48bfa$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $a5d927e783c48bfa$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $a5d927e783c48bfa$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $a5d927e783c48bfa$var$L(), e = $a5d927e783c48bfa$var$lh(a), f = $a5d927e783c48bfa$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $a5d927e783c48bfa$var$dh(a, f, e);
        null !== b && ($a5d927e783c48bfa$var$mh(b, a, e, d), $a5d927e783c48bfa$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $a5d927e783c48bfa$var$L(), e = $a5d927e783c48bfa$var$lh(a), f = $a5d927e783c48bfa$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $a5d927e783c48bfa$var$dh(a, f, e);
        null !== b && ($a5d927e783c48bfa$var$mh(b, a, e, d), $a5d927e783c48bfa$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $a5d927e783c48bfa$var$L(), d = $a5d927e783c48bfa$var$lh(a), e = $a5d927e783c48bfa$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $a5d927e783c48bfa$var$dh(a, e, d);
        null !== b && ($a5d927e783c48bfa$var$mh(b, a, d, c), $a5d927e783c48bfa$var$eh(b, a, d));
    }
};
function $a5d927e783c48bfa$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$a5d927e783c48bfa$var$Ie(c, d) || !$a5d927e783c48bfa$var$Ie(e, f) : !0;
}
function $a5d927e783c48bfa$var$ph(a, b, c) {
    var d = !1, e = $a5d927e783c48bfa$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $a5d927e783c48bfa$var$Vg(f) : (e = $a5d927e783c48bfa$var$Zf(b) ? $a5d927e783c48bfa$var$Xf : $a5d927e783c48bfa$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $a5d927e783c48bfa$var$Yf(a, e) : $a5d927e783c48bfa$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $a5d927e783c48bfa$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $a5d927e783c48bfa$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $a5d927e783c48bfa$var$nh.enqueueReplaceState(b, b.state, null);
}
function $a5d927e783c48bfa$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $a5d927e783c48bfa$var$jh;
    $a5d927e783c48bfa$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $a5d927e783c48bfa$var$Vg(f) : (f = $a5d927e783c48bfa$var$Zf(b) ? $a5d927e783c48bfa$var$Xf : $a5d927e783c48bfa$var$H.current, e.context = $a5d927e783c48bfa$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($a5d927e783c48bfa$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $a5d927e783c48bfa$var$nh.enqueueReplaceState(e, e.state, null), $a5d927e783c48bfa$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $a5d927e783c48bfa$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($a5d927e783c48bfa$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($a5d927e783c48bfa$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $a5d927e783c48bfa$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($a5d927e783c48bfa$var$p(284));
        if (!c._owner) throw Error($a5d927e783c48bfa$var$p(290, a));
    }
    return a;
}
function $a5d927e783c48bfa$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($a5d927e783c48bfa$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $a5d927e783c48bfa$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $a5d927e783c48bfa$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $a5d927e783c48bfa$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $a5d927e783c48bfa$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $a5d927e783c48bfa$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $a5d927e783c48bfa$var$Ha && $a5d927e783c48bfa$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $a5d927e783c48bfa$var$sh(a, b, c), d.return = a, d;
        d = $a5d927e783c48bfa$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $a5d927e783c48bfa$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $a5d927e783c48bfa$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $a5d927e783c48bfa$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $a5d927e783c48bfa$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $a5d927e783c48bfa$var$va:
                    return c = $a5d927e783c48bfa$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $a5d927e783c48bfa$var$sh(a, null, b), c.return = a, c;
                case $a5d927e783c48bfa$var$wa:
                    return b = $a5d927e783c48bfa$var$zh(b, a.mode, c), b.return = a, b;
                case $a5d927e783c48bfa$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($a5d927e783c48bfa$var$eb(b) || $a5d927e783c48bfa$var$Ka(b)) return b = $a5d927e783c48bfa$var$Ah(b, a.mode, c, null), b.return = a, b;
            $a5d927e783c48bfa$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $a5d927e783c48bfa$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $a5d927e783c48bfa$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $a5d927e783c48bfa$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($a5d927e783c48bfa$var$eb(c) || $a5d927e783c48bfa$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $a5d927e783c48bfa$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $a5d927e783c48bfa$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $a5d927e783c48bfa$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $a5d927e783c48bfa$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($a5d927e783c48bfa$var$eb(d) || $a5d927e783c48bfa$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $a5d927e783c48bfa$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $a5d927e783c48bfa$var$I && $a5d927e783c48bfa$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $a5d927e783c48bfa$var$I && $a5d927e783c48bfa$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $a5d927e783c48bfa$var$I && $a5d927e783c48bfa$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $a5d927e783c48bfa$var$Ka(h);
        if ("function" !== typeof l) throw Error($a5d927e783c48bfa$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($a5d927e783c48bfa$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $a5d927e783c48bfa$var$I && $a5d927e783c48bfa$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $a5d927e783c48bfa$var$I && $a5d927e783c48bfa$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $a5d927e783c48bfa$var$I && $a5d927e783c48bfa$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $a5d927e783c48bfa$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $a5d927e783c48bfa$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $a5d927e783c48bfa$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $a5d927e783c48bfa$var$Ha && $a5d927e783c48bfa$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $a5d927e783c48bfa$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $a5d927e783c48bfa$var$ya ? (d = $a5d927e783c48bfa$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $a5d927e783c48bfa$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $a5d927e783c48bfa$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $a5d927e783c48bfa$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $a5d927e783c48bfa$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $a5d927e783c48bfa$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($a5d927e783c48bfa$var$eb(f)) return n(a, d, f, h);
            if ($a5d927e783c48bfa$var$Ka(f)) return t(a, d, f, h);
            $a5d927e783c48bfa$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $a5d927e783c48bfa$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $a5d927e783c48bfa$var$Bh = $a5d927e783c48bfa$var$vh(!0), $a5d927e783c48bfa$var$Ch = $a5d927e783c48bfa$var$vh(!1), $a5d927e783c48bfa$var$Dh = {}, $a5d927e783c48bfa$var$Eh = $a5d927e783c48bfa$var$Uf($a5d927e783c48bfa$var$Dh), $a5d927e783c48bfa$var$Fh = $a5d927e783c48bfa$var$Uf($a5d927e783c48bfa$var$Dh), $a5d927e783c48bfa$var$Gh = $a5d927e783c48bfa$var$Uf($a5d927e783c48bfa$var$Dh);
function $a5d927e783c48bfa$var$Hh(a) {
    if (a === $a5d927e783c48bfa$var$Dh) throw Error($a5d927e783c48bfa$var$p(174));
    return a;
}
function $a5d927e783c48bfa$var$Ih(a, b) {
    $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$Gh, b);
    $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$Fh, a);
    $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$Eh, $a5d927e783c48bfa$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $a5d927e783c48bfa$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $a5d927e783c48bfa$var$lb(b, a);
    }
    $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$Eh);
    $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$Eh, b);
}
function $a5d927e783c48bfa$var$Jh() {
    $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$Eh);
    $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$Fh);
    $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$Gh);
}
function $a5d927e783c48bfa$var$Kh(a) {
    $a5d927e783c48bfa$var$Hh($a5d927e783c48bfa$var$Gh.current);
    var b = $a5d927e783c48bfa$var$Hh($a5d927e783c48bfa$var$Eh.current);
    var c = $a5d927e783c48bfa$var$lb(b, a.type);
    b !== c && ($a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$Fh, a), $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$Eh, c));
}
function $a5d927e783c48bfa$var$Lh(a) {
    $a5d927e783c48bfa$var$Fh.current === a && ($a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$Eh), $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$Fh));
}
var $a5d927e783c48bfa$var$M = $a5d927e783c48bfa$var$Uf(0);
function $a5d927e783c48bfa$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $a5d927e783c48bfa$var$Nh = [];
function $a5d927e783c48bfa$var$Oh() {
    for(var a = 0; a < $a5d927e783c48bfa$var$Nh.length; a++)$a5d927e783c48bfa$var$Nh[a]._workInProgressVersionPrimary = null;
    $a5d927e783c48bfa$var$Nh.length = 0;
}
var $a5d927e783c48bfa$var$Ph = $a5d927e783c48bfa$var$ua.ReactCurrentDispatcher, $a5d927e783c48bfa$var$Qh = $a5d927e783c48bfa$var$ua.ReactCurrentBatchConfig, $a5d927e783c48bfa$var$Rh = 0, $a5d927e783c48bfa$var$N = null, $a5d927e783c48bfa$var$O = null, $a5d927e783c48bfa$var$P = null, $a5d927e783c48bfa$var$Sh = !1, $a5d927e783c48bfa$var$Th = !1, $a5d927e783c48bfa$var$Uh = 0, $a5d927e783c48bfa$var$Vh = 0;
function $a5d927e783c48bfa$var$Q() {
    throw Error($a5d927e783c48bfa$var$p(321));
}
function $a5d927e783c48bfa$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$a5d927e783c48bfa$var$He(a[c], b[c])) return !1;
    return !0;
}
function $a5d927e783c48bfa$var$Xh(a, b, c, d, e, f) {
    $a5d927e783c48bfa$var$Rh = f;
    $a5d927e783c48bfa$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $a5d927e783c48bfa$var$Ph.current = null === a || null === a.memoizedState ? $a5d927e783c48bfa$var$Yh : $a5d927e783c48bfa$var$Zh;
    a = c(d, e);
    if ($a5d927e783c48bfa$var$Th) {
        f = 0;
        do {
            $a5d927e783c48bfa$var$Th = !1;
            $a5d927e783c48bfa$var$Uh = 0;
            if (25 <= f) throw Error($a5d927e783c48bfa$var$p(301));
            f += 1;
            $a5d927e783c48bfa$var$P = $a5d927e783c48bfa$var$O = null;
            b.updateQueue = null;
            $a5d927e783c48bfa$var$Ph.current = $a5d927e783c48bfa$var$$h;
            a = c(d, e);
        }while ($a5d927e783c48bfa$var$Th);
    }
    $a5d927e783c48bfa$var$Ph.current = $a5d927e783c48bfa$var$ai;
    b = null !== $a5d927e783c48bfa$var$O && null !== $a5d927e783c48bfa$var$O.next;
    $a5d927e783c48bfa$var$Rh = 0;
    $a5d927e783c48bfa$var$P = $a5d927e783c48bfa$var$O = $a5d927e783c48bfa$var$N = null;
    $a5d927e783c48bfa$var$Sh = !1;
    if (b) throw Error($a5d927e783c48bfa$var$p(300));
    return a;
}
function $a5d927e783c48bfa$var$bi() {
    var a = 0 !== $a5d927e783c48bfa$var$Uh;
    $a5d927e783c48bfa$var$Uh = 0;
    return a;
}
function $a5d927e783c48bfa$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $a5d927e783c48bfa$var$P ? $a5d927e783c48bfa$var$N.memoizedState = $a5d927e783c48bfa$var$P = a : $a5d927e783c48bfa$var$P = $a5d927e783c48bfa$var$P.next = a;
    return $a5d927e783c48bfa$var$P;
}
function $a5d927e783c48bfa$var$di() {
    if (null === $a5d927e783c48bfa$var$O) {
        var a = $a5d927e783c48bfa$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $a5d927e783c48bfa$var$O.next;
    var b = null === $a5d927e783c48bfa$var$P ? $a5d927e783c48bfa$var$N.memoizedState : $a5d927e783c48bfa$var$P.next;
    if (null !== b) $a5d927e783c48bfa$var$P = b, $a5d927e783c48bfa$var$O = a;
    else {
        if (null === a) throw Error($a5d927e783c48bfa$var$p(310));
        $a5d927e783c48bfa$var$O = a;
        a = {
            memoizedState: $a5d927e783c48bfa$var$O.memoizedState,
            baseState: $a5d927e783c48bfa$var$O.baseState,
            baseQueue: $a5d927e783c48bfa$var$O.baseQueue,
            queue: $a5d927e783c48bfa$var$O.queue,
            next: null
        };
        null === $a5d927e783c48bfa$var$P ? $a5d927e783c48bfa$var$N.memoizedState = $a5d927e783c48bfa$var$P = a : $a5d927e783c48bfa$var$P = $a5d927e783c48bfa$var$P.next = a;
    }
    return $a5d927e783c48bfa$var$P;
}
function $a5d927e783c48bfa$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $a5d927e783c48bfa$var$fi(a) {
    var b = $a5d927e783c48bfa$var$di(), c = b.queue;
    if (null === c) throw Error($a5d927e783c48bfa$var$p(311));
    c.lastRenderedReducer = a;
    var d = $a5d927e783c48bfa$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($a5d927e783c48bfa$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $a5d927e783c48bfa$var$N.lanes |= m;
                $a5d927e783c48bfa$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $a5d927e783c48bfa$var$He(d, b.memoizedState) || ($a5d927e783c48bfa$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $a5d927e783c48bfa$var$N.lanes |= f, $a5d927e783c48bfa$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $a5d927e783c48bfa$var$gi(a) {
    var b = $a5d927e783c48bfa$var$di(), c = b.queue;
    if (null === c) throw Error($a5d927e783c48bfa$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $a5d927e783c48bfa$var$He(f, b.memoizedState) || ($a5d927e783c48bfa$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $a5d927e783c48bfa$var$hi() {}
function $a5d927e783c48bfa$var$ii(a, b) {
    var c = $a5d927e783c48bfa$var$N, d = $a5d927e783c48bfa$var$di(), e = b(), f = !$a5d927e783c48bfa$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $a5d927e783c48bfa$var$Ug = !0);
    d = d.queue;
    $a5d927e783c48bfa$var$ji($a5d927e783c48bfa$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $a5d927e783c48bfa$var$P && $a5d927e783c48bfa$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $a5d927e783c48bfa$var$li(9, $a5d927e783c48bfa$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $a5d927e783c48bfa$var$R) throw Error($a5d927e783c48bfa$var$p(349));
        0 !== ($a5d927e783c48bfa$var$Rh & 30) || $a5d927e783c48bfa$var$ni(c, b, e);
    }
    return e;
}
function $a5d927e783c48bfa$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $a5d927e783c48bfa$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $a5d927e783c48bfa$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $a5d927e783c48bfa$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $a5d927e783c48bfa$var$oi(b) && $a5d927e783c48bfa$var$pi(a);
}
function $a5d927e783c48bfa$var$ki(a, b, c) {
    return c(function() {
        $a5d927e783c48bfa$var$oi(b) && $a5d927e783c48bfa$var$pi(a);
    });
}
function $a5d927e783c48bfa$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$a5d927e783c48bfa$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $a5d927e783c48bfa$var$pi(a) {
    var b = $a5d927e783c48bfa$var$Zg(a, 1);
    null !== b && $a5d927e783c48bfa$var$mh(b, a, 1, -1);
}
function $a5d927e783c48bfa$var$qi(a) {
    var b = $a5d927e783c48bfa$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $a5d927e783c48bfa$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $a5d927e783c48bfa$var$ri.bind(null, $a5d927e783c48bfa$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $a5d927e783c48bfa$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $a5d927e783c48bfa$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $a5d927e783c48bfa$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $a5d927e783c48bfa$var$si() {
    return $a5d927e783c48bfa$var$di().memoizedState;
}
function $a5d927e783c48bfa$var$ti(a, b, c, d) {
    var e = $a5d927e783c48bfa$var$ci();
    $a5d927e783c48bfa$var$N.flags |= a;
    e.memoizedState = $a5d927e783c48bfa$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $a5d927e783c48bfa$var$ui(a, b, c, d) {
    var e = $a5d927e783c48bfa$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $a5d927e783c48bfa$var$O) {
        var g = $a5d927e783c48bfa$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $a5d927e783c48bfa$var$Wh(d, g.deps)) {
            e.memoizedState = $a5d927e783c48bfa$var$li(b, c, f, d);
            return;
        }
    }
    $a5d927e783c48bfa$var$N.flags |= a;
    e.memoizedState = $a5d927e783c48bfa$var$li(1 | b, c, f, d);
}
function $a5d927e783c48bfa$var$vi(a, b) {
    return $a5d927e783c48bfa$var$ti(8390656, 8, a, b);
}
function $a5d927e783c48bfa$var$ji(a, b) {
    return $a5d927e783c48bfa$var$ui(2048, 8, a, b);
}
function $a5d927e783c48bfa$var$wi(a, b) {
    return $a5d927e783c48bfa$var$ui(4, 2, a, b);
}
function $a5d927e783c48bfa$var$xi(a, b) {
    return $a5d927e783c48bfa$var$ui(4, 4, a, b);
}
function $a5d927e783c48bfa$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $a5d927e783c48bfa$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $a5d927e783c48bfa$var$ui(4, 4, $a5d927e783c48bfa$var$yi.bind(null, b, a), c);
}
function $a5d927e783c48bfa$var$Ai() {}
function $a5d927e783c48bfa$var$Bi(a, b) {
    var c = $a5d927e783c48bfa$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a5d927e783c48bfa$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a5d927e783c48bfa$var$Ci(a, b) {
    var c = $a5d927e783c48bfa$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a5d927e783c48bfa$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a5d927e783c48bfa$var$Di(a, b, c) {
    if (0 === ($a5d927e783c48bfa$var$Rh & 21)) return a.baseState && (a.baseState = !1, $a5d927e783c48bfa$var$Ug = !0), a.memoizedState = c;
    $a5d927e783c48bfa$var$He(c, b) || (c = $a5d927e783c48bfa$var$yc(), $a5d927e783c48bfa$var$N.lanes |= c, $a5d927e783c48bfa$var$hh |= c, a.baseState = !0);
    return b;
}
function $a5d927e783c48bfa$var$Ei(a, b) {
    var c = $a5d927e783c48bfa$var$C;
    $a5d927e783c48bfa$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $a5d927e783c48bfa$var$Qh.transition;
    $a5d927e783c48bfa$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $a5d927e783c48bfa$var$C = c, $a5d927e783c48bfa$var$Qh.transition = d;
    }
}
function $a5d927e783c48bfa$var$Fi() {
    return $a5d927e783c48bfa$var$di().memoizedState;
}
function $a5d927e783c48bfa$var$Gi(a, b, c) {
    var d = $a5d927e783c48bfa$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a5d927e783c48bfa$var$Hi(a)) $a5d927e783c48bfa$var$Ii(b, c);
    else if (c = $a5d927e783c48bfa$var$Yg(a, b, c, d), null !== c) {
        var e = $a5d927e783c48bfa$var$L();
        $a5d927e783c48bfa$var$mh(c, a, d, e);
        $a5d927e783c48bfa$var$Ji(c, b, d);
    }
}
function $a5d927e783c48bfa$var$ri(a, b, c) {
    var d = $a5d927e783c48bfa$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a5d927e783c48bfa$var$Hi(a)) $a5d927e783c48bfa$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($a5d927e783c48bfa$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $a5d927e783c48bfa$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $a5d927e783c48bfa$var$Yg(a, b, e, d);
        null !== c && (e = $a5d927e783c48bfa$var$L(), $a5d927e783c48bfa$var$mh(c, a, d, e), $a5d927e783c48bfa$var$Ji(c, b, d));
    }
}
function $a5d927e783c48bfa$var$Hi(a) {
    var b = a.alternate;
    return a === $a5d927e783c48bfa$var$N || null !== b && b === $a5d927e783c48bfa$var$N;
}
function $a5d927e783c48bfa$var$Ii(a, b) {
    $a5d927e783c48bfa$var$Th = $a5d927e783c48bfa$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $a5d927e783c48bfa$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $a5d927e783c48bfa$var$Cc(a, c);
    }
}
var $a5d927e783c48bfa$var$ai = {
    readContext: $a5d927e783c48bfa$var$Vg,
    useCallback: $a5d927e783c48bfa$var$Q,
    useContext: $a5d927e783c48bfa$var$Q,
    useEffect: $a5d927e783c48bfa$var$Q,
    useImperativeHandle: $a5d927e783c48bfa$var$Q,
    useInsertionEffect: $a5d927e783c48bfa$var$Q,
    useLayoutEffect: $a5d927e783c48bfa$var$Q,
    useMemo: $a5d927e783c48bfa$var$Q,
    useReducer: $a5d927e783c48bfa$var$Q,
    useRef: $a5d927e783c48bfa$var$Q,
    useState: $a5d927e783c48bfa$var$Q,
    useDebugValue: $a5d927e783c48bfa$var$Q,
    useDeferredValue: $a5d927e783c48bfa$var$Q,
    useTransition: $a5d927e783c48bfa$var$Q,
    useMutableSource: $a5d927e783c48bfa$var$Q,
    useSyncExternalStore: $a5d927e783c48bfa$var$Q,
    useId: $a5d927e783c48bfa$var$Q,
    unstable_isNewReconciler: !1
}, $a5d927e783c48bfa$var$Yh = {
    readContext: $a5d927e783c48bfa$var$Vg,
    useCallback: function(a, b) {
        $a5d927e783c48bfa$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $a5d927e783c48bfa$var$Vg,
    useEffect: $a5d927e783c48bfa$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $a5d927e783c48bfa$var$ti(4194308, 4, $a5d927e783c48bfa$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $a5d927e783c48bfa$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $a5d927e783c48bfa$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $a5d927e783c48bfa$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $a5d927e783c48bfa$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $a5d927e783c48bfa$var$Gi.bind(null, $a5d927e783c48bfa$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $a5d927e783c48bfa$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $a5d927e783c48bfa$var$qi,
    useDebugValue: $a5d927e783c48bfa$var$Ai,
    useDeferredValue: function(a) {
        return $a5d927e783c48bfa$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $a5d927e783c48bfa$var$qi(!1), b = a[0];
        a = $a5d927e783c48bfa$var$Ei.bind(null, a[1]);
        $a5d927e783c48bfa$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $a5d927e783c48bfa$var$N, e = $a5d927e783c48bfa$var$ci();
        if ($a5d927e783c48bfa$var$I) {
            if (void 0 === c) throw Error($a5d927e783c48bfa$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $a5d927e783c48bfa$var$R) throw Error($a5d927e783c48bfa$var$p(349));
            0 !== ($a5d927e783c48bfa$var$Rh & 30) || $a5d927e783c48bfa$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $a5d927e783c48bfa$var$vi($a5d927e783c48bfa$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $a5d927e783c48bfa$var$li(9, $a5d927e783c48bfa$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $a5d927e783c48bfa$var$ci(), b = $a5d927e783c48bfa$var$R.identifierPrefix;
        if ($a5d927e783c48bfa$var$I) {
            var c = $a5d927e783c48bfa$var$sg;
            var d = $a5d927e783c48bfa$var$rg;
            c = (d & ~(1 << 32 - $a5d927e783c48bfa$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $a5d927e783c48bfa$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $a5d927e783c48bfa$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $a5d927e783c48bfa$var$Zh = {
    readContext: $a5d927e783c48bfa$var$Vg,
    useCallback: $a5d927e783c48bfa$var$Bi,
    useContext: $a5d927e783c48bfa$var$Vg,
    useEffect: $a5d927e783c48bfa$var$ji,
    useImperativeHandle: $a5d927e783c48bfa$var$zi,
    useInsertionEffect: $a5d927e783c48bfa$var$wi,
    useLayoutEffect: $a5d927e783c48bfa$var$xi,
    useMemo: $a5d927e783c48bfa$var$Ci,
    useReducer: $a5d927e783c48bfa$var$fi,
    useRef: $a5d927e783c48bfa$var$si,
    useState: function() {
        return $a5d927e783c48bfa$var$fi($a5d927e783c48bfa$var$ei);
    },
    useDebugValue: $a5d927e783c48bfa$var$Ai,
    useDeferredValue: function(a) {
        var b = $a5d927e783c48bfa$var$di();
        return $a5d927e783c48bfa$var$Di(b, $a5d927e783c48bfa$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $a5d927e783c48bfa$var$fi($a5d927e783c48bfa$var$ei)[0], b = $a5d927e783c48bfa$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $a5d927e783c48bfa$var$hi,
    useSyncExternalStore: $a5d927e783c48bfa$var$ii,
    useId: $a5d927e783c48bfa$var$Fi,
    unstable_isNewReconciler: !1
}, $a5d927e783c48bfa$var$$h = {
    readContext: $a5d927e783c48bfa$var$Vg,
    useCallback: $a5d927e783c48bfa$var$Bi,
    useContext: $a5d927e783c48bfa$var$Vg,
    useEffect: $a5d927e783c48bfa$var$ji,
    useImperativeHandle: $a5d927e783c48bfa$var$zi,
    useInsertionEffect: $a5d927e783c48bfa$var$wi,
    useLayoutEffect: $a5d927e783c48bfa$var$xi,
    useMemo: $a5d927e783c48bfa$var$Ci,
    useReducer: $a5d927e783c48bfa$var$gi,
    useRef: $a5d927e783c48bfa$var$si,
    useState: function() {
        return $a5d927e783c48bfa$var$gi($a5d927e783c48bfa$var$ei);
    },
    useDebugValue: $a5d927e783c48bfa$var$Ai,
    useDeferredValue: function(a) {
        var b = $a5d927e783c48bfa$var$di();
        return null === $a5d927e783c48bfa$var$O ? b.memoizedState = a : $a5d927e783c48bfa$var$Di(b, $a5d927e783c48bfa$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $a5d927e783c48bfa$var$gi($a5d927e783c48bfa$var$ei)[0], b = $a5d927e783c48bfa$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $a5d927e783c48bfa$var$hi,
    useSyncExternalStore: $a5d927e783c48bfa$var$ii,
    useId: $a5d927e783c48bfa$var$Fi,
    unstable_isNewReconciler: !1
};
function $a5d927e783c48bfa$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $a5d927e783c48bfa$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $a5d927e783c48bfa$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $a5d927e783c48bfa$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $a5d927e783c48bfa$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $a5d927e783c48bfa$var$Oi(a, b, c) {
    c = $a5d927e783c48bfa$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $a5d927e783c48bfa$var$Pi || ($a5d927e783c48bfa$var$Pi = !0, $a5d927e783c48bfa$var$Qi = d);
        $a5d927e783c48bfa$var$Mi(a, b);
    };
    return c;
}
function $a5d927e783c48bfa$var$Ri(a, b, c) {
    c = $a5d927e783c48bfa$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $a5d927e783c48bfa$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $a5d927e783c48bfa$var$Mi(a, b);
        "function" !== typeof d && (null === $a5d927e783c48bfa$var$Si ? $a5d927e783c48bfa$var$Si = new Set([
            this
        ]) : $a5d927e783c48bfa$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $a5d927e783c48bfa$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $a5d927e783c48bfa$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $a5d927e783c48bfa$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $a5d927e783c48bfa$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $a5d927e783c48bfa$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $a5d927e783c48bfa$var$ch(-1, 1), b.tag = 2, $a5d927e783c48bfa$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $a5d927e783c48bfa$var$Xi = $a5d927e783c48bfa$var$ua.ReactCurrentOwner, $a5d927e783c48bfa$var$Ug = !1;
function $a5d927e783c48bfa$var$Yi(a, b, c, d) {
    b.child = null === a ? $a5d927e783c48bfa$var$Ch(b, null, c, d) : $a5d927e783c48bfa$var$Bh(b, a.child, c, d);
}
function $a5d927e783c48bfa$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $a5d927e783c48bfa$var$Tg(b, e);
    d = $a5d927e783c48bfa$var$Xh(a, b, c, d, f, e);
    c = $a5d927e783c48bfa$var$bi();
    if (null !== a && !$a5d927e783c48bfa$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $a5d927e783c48bfa$var$$i(a, b, e);
    $a5d927e783c48bfa$var$I && c && $a5d927e783c48bfa$var$vg(b);
    b.flags |= 1;
    $a5d927e783c48bfa$var$Yi(a, b, d, e);
    return b.child;
}
function $a5d927e783c48bfa$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$a5d927e783c48bfa$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $a5d927e783c48bfa$var$cj(a, b, f, d, e);
        a = $a5d927e783c48bfa$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $a5d927e783c48bfa$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $a5d927e783c48bfa$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $a5d927e783c48bfa$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $a5d927e783c48bfa$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($a5d927e783c48bfa$var$Ie(f, d) && a.ref === b.ref) {
            if ($a5d927e783c48bfa$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($a5d927e783c48bfa$var$Ug = !0);
            else return b.lanes = a.lanes, $a5d927e783c48bfa$var$$i(a, b, e);
        }
    }
    return $a5d927e783c48bfa$var$dj(a, b, c, d, e);
}
function $a5d927e783c48bfa$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$fj, $a5d927e783c48bfa$var$gj), $a5d927e783c48bfa$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$fj, $a5d927e783c48bfa$var$gj), $a5d927e783c48bfa$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$fj, $a5d927e783c48bfa$var$gj);
            $a5d927e783c48bfa$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$fj, $a5d927e783c48bfa$var$gj), $a5d927e783c48bfa$var$gj |= d;
    $a5d927e783c48bfa$var$Yi(a, b, e, c);
    return b.child;
}
function $a5d927e783c48bfa$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $a5d927e783c48bfa$var$dj(a, b, c, d, e) {
    var f = $a5d927e783c48bfa$var$Zf(c) ? $a5d927e783c48bfa$var$Xf : $a5d927e783c48bfa$var$H.current;
    f = $a5d927e783c48bfa$var$Yf(b, f);
    $a5d927e783c48bfa$var$Tg(b, e);
    c = $a5d927e783c48bfa$var$Xh(a, b, c, d, f, e);
    d = $a5d927e783c48bfa$var$bi();
    if (null !== a && !$a5d927e783c48bfa$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $a5d927e783c48bfa$var$$i(a, b, e);
    $a5d927e783c48bfa$var$I && d && $a5d927e783c48bfa$var$vg(b);
    b.flags |= 1;
    $a5d927e783c48bfa$var$Yi(a, b, c, e);
    return b.child;
}
function $a5d927e783c48bfa$var$ij(a, b, c, d, e) {
    if ($a5d927e783c48bfa$var$Zf(c)) {
        var f = !0;
        $a5d927e783c48bfa$var$cg(b);
    } else f = !1;
    $a5d927e783c48bfa$var$Tg(b, e);
    if (null === b.stateNode) $a5d927e783c48bfa$var$jj(a, b), $a5d927e783c48bfa$var$ph(b, c, d), $a5d927e783c48bfa$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $a5d927e783c48bfa$var$Vg(l) : (l = $a5d927e783c48bfa$var$Zf(c) ? $a5d927e783c48bfa$var$Xf : $a5d927e783c48bfa$var$H.current, l = $a5d927e783c48bfa$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $a5d927e783c48bfa$var$qh(b, g, d, l);
        $a5d927e783c48bfa$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $a5d927e783c48bfa$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $a5d927e783c48bfa$var$Wf.current || $a5d927e783c48bfa$var$$g ? ("function" === typeof m && ($a5d927e783c48bfa$var$kh(b, c, m, d), k = b.memoizedState), (h = $a5d927e783c48bfa$var$$g || $a5d927e783c48bfa$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $a5d927e783c48bfa$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $a5d927e783c48bfa$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $a5d927e783c48bfa$var$Vg(k) : (k = $a5d927e783c48bfa$var$Zf(c) ? $a5d927e783c48bfa$var$Xf : $a5d927e783c48bfa$var$H.current, k = $a5d927e783c48bfa$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $a5d927e783c48bfa$var$qh(b, g, d, k);
        $a5d927e783c48bfa$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $a5d927e783c48bfa$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $a5d927e783c48bfa$var$Wf.current || $a5d927e783c48bfa$var$$g ? ("function" === typeof y && ($a5d927e783c48bfa$var$kh(b, c, y, d), n = b.memoizedState), (l = $a5d927e783c48bfa$var$$g || $a5d927e783c48bfa$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $a5d927e783c48bfa$var$kj(a, b, c, d, f, e);
}
function $a5d927e783c48bfa$var$kj(a, b, c, d, e, f) {
    $a5d927e783c48bfa$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $a5d927e783c48bfa$var$dg(b, c, !1), $a5d927e783c48bfa$var$$i(a, b, f);
    d = b.stateNode;
    $a5d927e783c48bfa$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $a5d927e783c48bfa$var$Bh(b, a.child, null, f), b.child = $a5d927e783c48bfa$var$Bh(b, null, h, f)) : $a5d927e783c48bfa$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $a5d927e783c48bfa$var$dg(b, c, !0);
    return b.child;
}
function $a5d927e783c48bfa$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $a5d927e783c48bfa$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $a5d927e783c48bfa$var$ag(a, b.context, !1);
    $a5d927e783c48bfa$var$Ih(a, b.containerInfo);
}
function $a5d927e783c48bfa$var$mj(a, b, c, d, e) {
    $a5d927e783c48bfa$var$Ig();
    $a5d927e783c48bfa$var$Jg(e);
    b.flags |= 256;
    $a5d927e783c48bfa$var$Yi(a, b, c, d);
    return b.child;
}
var $a5d927e783c48bfa$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $a5d927e783c48bfa$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $a5d927e783c48bfa$var$pj(a, b, c) {
    var d = b.pendingProps, e = $a5d927e783c48bfa$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$M, e & 1);
    if (null === a) {
        $a5d927e783c48bfa$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $a5d927e783c48bfa$var$qj(g, d, 0, null), a = $a5d927e783c48bfa$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $a5d927e783c48bfa$var$oj(c), b.memoizedState = $a5d927e783c48bfa$var$nj, a) : $a5d927e783c48bfa$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $a5d927e783c48bfa$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $a5d927e783c48bfa$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $a5d927e783c48bfa$var$wh(h, f) : (f = $a5d927e783c48bfa$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $a5d927e783c48bfa$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $a5d927e783c48bfa$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $a5d927e783c48bfa$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $a5d927e783c48bfa$var$rj(a, b) {
    b = $a5d927e783c48bfa$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $a5d927e783c48bfa$var$tj(a, b, c, d) {
    null !== d && $a5d927e783c48bfa$var$Jg(d);
    $a5d927e783c48bfa$var$Bh(b, a.child, null, c);
    a = $a5d927e783c48bfa$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $a5d927e783c48bfa$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $a5d927e783c48bfa$var$Li(Error($a5d927e783c48bfa$var$p(422))), $a5d927e783c48bfa$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $a5d927e783c48bfa$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $a5d927e783c48bfa$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $a5d927e783c48bfa$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $a5d927e783c48bfa$var$oj(g);
        b.memoizedState = $a5d927e783c48bfa$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $a5d927e783c48bfa$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($a5d927e783c48bfa$var$p(419));
        d = $a5d927e783c48bfa$var$Li(f, d, void 0);
        return $a5d927e783c48bfa$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($a5d927e783c48bfa$var$Ug || h) {
        d = $a5d927e783c48bfa$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $a5d927e783c48bfa$var$Zg(a, e), $a5d927e783c48bfa$var$mh(d, a, e, -1));
        }
        $a5d927e783c48bfa$var$uj();
        d = $a5d927e783c48bfa$var$Li(Error($a5d927e783c48bfa$var$p(421)));
        return $a5d927e783c48bfa$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $a5d927e783c48bfa$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $a5d927e783c48bfa$var$yg = $a5d927e783c48bfa$var$Lf(e.nextSibling);
    $a5d927e783c48bfa$var$xg = b;
    $a5d927e783c48bfa$var$I = !0;
    $a5d927e783c48bfa$var$zg = null;
    null !== a && ($a5d927e783c48bfa$var$og[$a5d927e783c48bfa$var$pg++] = $a5d927e783c48bfa$var$rg, $a5d927e783c48bfa$var$og[$a5d927e783c48bfa$var$pg++] = $a5d927e783c48bfa$var$sg, $a5d927e783c48bfa$var$og[$a5d927e783c48bfa$var$pg++] = $a5d927e783c48bfa$var$qg, $a5d927e783c48bfa$var$rg = a.id, $a5d927e783c48bfa$var$sg = a.overflow, $a5d927e783c48bfa$var$qg = b);
    b = $a5d927e783c48bfa$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $a5d927e783c48bfa$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $a5d927e783c48bfa$var$Sg(a.return, b, c);
}
function $a5d927e783c48bfa$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $a5d927e783c48bfa$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $a5d927e783c48bfa$var$Yi(a, b, d.children, c);
    d = $a5d927e783c48bfa$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $a5d927e783c48bfa$var$wj(a, c, b);
            else if (19 === a.tag) $a5d927e783c48bfa$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $a5d927e783c48bfa$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $a5d927e783c48bfa$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $a5d927e783c48bfa$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $a5d927e783c48bfa$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $a5d927e783c48bfa$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $a5d927e783c48bfa$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $a5d927e783c48bfa$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $a5d927e783c48bfa$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($a5d927e783c48bfa$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $a5d927e783c48bfa$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $a5d927e783c48bfa$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $a5d927e783c48bfa$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $a5d927e783c48bfa$var$lj(b);
            $a5d927e783c48bfa$var$Ig();
            break;
        case 5:
            $a5d927e783c48bfa$var$Kh(b);
            break;
        case 1:
            $a5d927e783c48bfa$var$Zf(b.type) && $a5d927e783c48bfa$var$cg(b);
            break;
        case 4:
            $a5d927e783c48bfa$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$M, $a5d927e783c48bfa$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $a5d927e783c48bfa$var$pj(a, b, c);
                $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$M, $a5d927e783c48bfa$var$M.current & 1);
                a = $a5d927e783c48bfa$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$M, $a5d927e783c48bfa$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $a5d927e783c48bfa$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$M, $a5d927e783c48bfa$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $a5d927e783c48bfa$var$ej(a, b, c);
    }
    return $a5d927e783c48bfa$var$$i(a, b, c);
}
var $a5d927e783c48bfa$var$Aj, $a5d927e783c48bfa$var$Bj, $a5d927e783c48bfa$var$Cj, $a5d927e783c48bfa$var$Dj;
$a5d927e783c48bfa$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$a5d927e783c48bfa$var$Bj = function() {};
$a5d927e783c48bfa$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $a5d927e783c48bfa$var$Hh($a5d927e783c48bfa$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $a5d927e783c48bfa$var$Ya(a, e);
                d = $a5d927e783c48bfa$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $a5d927e783c48bfa$var$A({}, e, {
                    value: void 0
                });
                d = $a5d927e783c48bfa$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $a5d927e783c48bfa$var$gb(a, e);
                d = $a5d927e783c48bfa$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $a5d927e783c48bfa$var$Bf);
        }
        $a5d927e783c48bfa$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($a5d927e783c48bfa$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($a5d927e783c48bfa$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $a5d927e783c48bfa$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$a5d927e783c48bfa$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $a5d927e783c48bfa$var$Ej(a, b) {
    if (!$a5d927e783c48bfa$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $a5d927e783c48bfa$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $a5d927e783c48bfa$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $a5d927e783c48bfa$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $a5d927e783c48bfa$var$S(b), null;
        case 1:
            return $a5d927e783c48bfa$var$Zf(b.type) && $a5d927e783c48bfa$var$$f(), $a5d927e783c48bfa$var$S(b), null;
        case 3:
            d = b.stateNode;
            $a5d927e783c48bfa$var$Jh();
            $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$Wf);
            $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$H);
            $a5d927e783c48bfa$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $a5d927e783c48bfa$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $a5d927e783c48bfa$var$zg && ($a5d927e783c48bfa$var$Gj($a5d927e783c48bfa$var$zg), $a5d927e783c48bfa$var$zg = null));
            $a5d927e783c48bfa$var$Bj(a, b);
            $a5d927e783c48bfa$var$S(b);
            return null;
        case 5:
            $a5d927e783c48bfa$var$Lh(b);
            var e = $a5d927e783c48bfa$var$Hh($a5d927e783c48bfa$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $a5d927e783c48bfa$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($a5d927e783c48bfa$var$p(166));
                    $a5d927e783c48bfa$var$S(b);
                    return null;
                }
                a = $a5d927e783c48bfa$var$Hh($a5d927e783c48bfa$var$Eh.current);
                if ($a5d927e783c48bfa$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$a5d927e783c48bfa$var$Of] = b;
                    d[$a5d927e783c48bfa$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $a5d927e783c48bfa$var$D("cancel", d);
                            $a5d927e783c48bfa$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $a5d927e783c48bfa$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $a5d927e783c48bfa$var$lf.length; e++)$a5d927e783c48bfa$var$D($a5d927e783c48bfa$var$lf[e], d);
                            break;
                        case "source":
                            $a5d927e783c48bfa$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $a5d927e783c48bfa$var$D("error", d);
                            $a5d927e783c48bfa$var$D("load", d);
                            break;
                        case "details":
                            $a5d927e783c48bfa$var$D("toggle", d);
                            break;
                        case "input":
                            $a5d927e783c48bfa$var$Za(d, f);
                            $a5d927e783c48bfa$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $a5d927e783c48bfa$var$D("invalid", d);
                            break;
                        case "textarea":
                            $a5d927e783c48bfa$var$hb(d, f), $a5d927e783c48bfa$var$D("invalid", d);
                    }
                    $a5d927e783c48bfa$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $a5d927e783c48bfa$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $a5d927e783c48bfa$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $a5d927e783c48bfa$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $a5d927e783c48bfa$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $a5d927e783c48bfa$var$Va(d);
                            $a5d927e783c48bfa$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $a5d927e783c48bfa$var$Va(d);
                            $a5d927e783c48bfa$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $a5d927e783c48bfa$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $a5d927e783c48bfa$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$a5d927e783c48bfa$var$Of] = b;
                    a[$a5d927e783c48bfa$var$Pf] = d;
                    $a5d927e783c48bfa$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $a5d927e783c48bfa$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $a5d927e783c48bfa$var$D("cancel", a);
                                $a5d927e783c48bfa$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $a5d927e783c48bfa$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $a5d927e783c48bfa$var$lf.length; e++)$a5d927e783c48bfa$var$D($a5d927e783c48bfa$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $a5d927e783c48bfa$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $a5d927e783c48bfa$var$D("error", a);
                                $a5d927e783c48bfa$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $a5d927e783c48bfa$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $a5d927e783c48bfa$var$Za(a, d);
                                e = $a5d927e783c48bfa$var$Ya(a, d);
                                $a5d927e783c48bfa$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $a5d927e783c48bfa$var$A({}, d, {
                                    value: void 0
                                });
                                $a5d927e783c48bfa$var$D("invalid", a);
                                break;
                            case "textarea":
                                $a5d927e783c48bfa$var$hb(a, d);
                                e = $a5d927e783c48bfa$var$gb(a, d);
                                $a5d927e783c48bfa$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $a5d927e783c48bfa$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $a5d927e783c48bfa$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $a5d927e783c48bfa$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $a5d927e783c48bfa$var$ob(a, k) : "number" === typeof k && $a5d927e783c48bfa$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($a5d927e783c48bfa$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $a5d927e783c48bfa$var$D("scroll", a) : null != k && $a5d927e783c48bfa$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $a5d927e783c48bfa$var$Va(a);
                                $a5d927e783c48bfa$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $a5d927e783c48bfa$var$Va(a);
                                $a5d927e783c48bfa$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $a5d927e783c48bfa$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $a5d927e783c48bfa$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $a5d927e783c48bfa$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $a5d927e783c48bfa$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $a5d927e783c48bfa$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $a5d927e783c48bfa$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($a5d927e783c48bfa$var$p(166));
                c = $a5d927e783c48bfa$var$Hh($a5d927e783c48bfa$var$Gh.current);
                $a5d927e783c48bfa$var$Hh($a5d927e783c48bfa$var$Eh.current);
                if ($a5d927e783c48bfa$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$a5d927e783c48bfa$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $a5d927e783c48bfa$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $a5d927e783c48bfa$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $a5d927e783c48bfa$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$a5d927e783c48bfa$var$Of] = b, b.stateNode = d;
            }
            $a5d927e783c48bfa$var$S(b);
            return null;
        case 13:
            $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($a5d927e783c48bfa$var$I && null !== $a5d927e783c48bfa$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $a5d927e783c48bfa$var$Hg(), $a5d927e783c48bfa$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $a5d927e783c48bfa$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($a5d927e783c48bfa$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($a5d927e783c48bfa$var$p(317));
                        f[$a5d927e783c48bfa$var$Of] = b;
                    } else $a5d927e783c48bfa$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $a5d927e783c48bfa$var$S(b);
                    f = !1;
                } else null !== $a5d927e783c48bfa$var$zg && ($a5d927e783c48bfa$var$Gj($a5d927e783c48bfa$var$zg), $a5d927e783c48bfa$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($a5d927e783c48bfa$var$M.current & 1) ? 0 === $a5d927e783c48bfa$var$T && ($a5d927e783c48bfa$var$T = 3) : $a5d927e783c48bfa$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $a5d927e783c48bfa$var$S(b);
            return null;
        case 4:
            return $a5d927e783c48bfa$var$Jh(), $a5d927e783c48bfa$var$Bj(a, b), null === a && $a5d927e783c48bfa$var$sf(b.stateNode.containerInfo), $a5d927e783c48bfa$var$S(b), null;
        case 10:
            return $a5d927e783c48bfa$var$Rg(b.type._context), $a5d927e783c48bfa$var$S(b), null;
        case 17:
            return $a5d927e783c48bfa$var$Zf(b.type) && $a5d927e783c48bfa$var$$f(), $a5d927e783c48bfa$var$S(b), null;
        case 19:
            $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$M);
            f = b.memoizedState;
            if (null === f) return $a5d927e783c48bfa$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $a5d927e783c48bfa$var$Ej(f, !1);
                else {
                    if (0 !== $a5d927e783c48bfa$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $a5d927e783c48bfa$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $a5d927e783c48bfa$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$M, $a5d927e783c48bfa$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $a5d927e783c48bfa$var$B() > $a5d927e783c48bfa$var$Hj && (b.flags |= 128, d = !0, $a5d927e783c48bfa$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $a5d927e783c48bfa$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $a5d927e783c48bfa$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$a5d927e783c48bfa$var$I) return $a5d927e783c48bfa$var$S(b), null;
                    } else 2 * $a5d927e783c48bfa$var$B() - f.renderingStartTime > $a5d927e783c48bfa$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $a5d927e783c48bfa$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $a5d927e783c48bfa$var$B(), b.sibling = null, c = $a5d927e783c48bfa$var$M.current, $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$M, d ? c & 1 | 2 : c & 1), b;
            $a5d927e783c48bfa$var$S(b);
            return null;
        case 22:
        case 23:
            return $a5d927e783c48bfa$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($a5d927e783c48bfa$var$gj & 1073741824) && ($a5d927e783c48bfa$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $a5d927e783c48bfa$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($a5d927e783c48bfa$var$p(156, b.tag));
}
function $a5d927e783c48bfa$var$Jj(a, b) {
    $a5d927e783c48bfa$var$wg(b);
    switch(b.tag){
        case 1:
            return $a5d927e783c48bfa$var$Zf(b.type) && $a5d927e783c48bfa$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $a5d927e783c48bfa$var$Jh(), $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$Wf), $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$H), $a5d927e783c48bfa$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $a5d927e783c48bfa$var$Lh(b), null;
        case 13:
            $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($a5d927e783c48bfa$var$p(340));
                $a5d927e783c48bfa$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$M), null;
        case 4:
            return $a5d927e783c48bfa$var$Jh(), null;
        case 10:
            return $a5d927e783c48bfa$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $a5d927e783c48bfa$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $a5d927e783c48bfa$var$Kj = !1, $a5d927e783c48bfa$var$U = !1, $a5d927e783c48bfa$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $a5d927e783c48bfa$var$V = null;
function $a5d927e783c48bfa$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $a5d927e783c48bfa$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $a5d927e783c48bfa$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $a5d927e783c48bfa$var$W(a, b, d);
    }
}
var $a5d927e783c48bfa$var$Oj = !1;
function $a5d927e783c48bfa$var$Pj(a, b) {
    $a5d927e783c48bfa$var$Cf = $a5d927e783c48bfa$var$dd;
    a = $a5d927e783c48bfa$var$Me();
    if ($a5d927e783c48bfa$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $a5d927e783c48bfa$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $a5d927e783c48bfa$var$dd = !1;
    for($a5d927e783c48bfa$var$V = b; null !== $a5d927e783c48bfa$var$V;)if (b = $a5d927e783c48bfa$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $a5d927e783c48bfa$var$V = a;
    else for(; null !== $a5d927e783c48bfa$var$V;){
        b = $a5d927e783c48bfa$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $a5d927e783c48bfa$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($a5d927e783c48bfa$var$p(163));
            }
        } catch (F) {
            $a5d927e783c48bfa$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $a5d927e783c48bfa$var$V = a;
            break;
        }
        $a5d927e783c48bfa$var$V = b.return;
    }
    n = $a5d927e783c48bfa$var$Oj;
    $a5d927e783c48bfa$var$Oj = !1;
    return n;
}
function $a5d927e783c48bfa$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $a5d927e783c48bfa$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $a5d927e783c48bfa$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $a5d927e783c48bfa$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $a5d927e783c48bfa$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $a5d927e783c48bfa$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$a5d927e783c48bfa$var$Of], delete b[$a5d927e783c48bfa$var$Pf], delete b[$a5d927e783c48bfa$var$of], delete b[$a5d927e783c48bfa$var$Qf], delete b[$a5d927e783c48bfa$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $a5d927e783c48bfa$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $a5d927e783c48bfa$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $a5d927e783c48bfa$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $a5d927e783c48bfa$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $a5d927e783c48bfa$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($a5d927e783c48bfa$var$Wj(a, b, c), a = a.sibling; null !== a;)$a5d927e783c48bfa$var$Wj(a, b, c), a = a.sibling;
}
function $a5d927e783c48bfa$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($a5d927e783c48bfa$var$Xj(a, b, c), a = a.sibling; null !== a;)$a5d927e783c48bfa$var$Xj(a, b, c), a = a.sibling;
}
var $a5d927e783c48bfa$var$X = null, $a5d927e783c48bfa$var$Yj = !1;
function $a5d927e783c48bfa$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$a5d927e783c48bfa$var$ak(a, b, c), c = c.sibling;
}
function $a5d927e783c48bfa$var$ak(a, b, c) {
    if ($a5d927e783c48bfa$var$lc && "function" === typeof $a5d927e783c48bfa$var$lc.onCommitFiberUnmount) try {
        $a5d927e783c48bfa$var$lc.onCommitFiberUnmount($a5d927e783c48bfa$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $a5d927e783c48bfa$var$U || $a5d927e783c48bfa$var$Mj(c, b);
        case 6:
            var d = $a5d927e783c48bfa$var$X, e = $a5d927e783c48bfa$var$Yj;
            $a5d927e783c48bfa$var$X = null;
            $a5d927e783c48bfa$var$Zj(a, b, c);
            $a5d927e783c48bfa$var$X = d;
            $a5d927e783c48bfa$var$Yj = e;
            null !== $a5d927e783c48bfa$var$X && ($a5d927e783c48bfa$var$Yj ? (a = $a5d927e783c48bfa$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $a5d927e783c48bfa$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $a5d927e783c48bfa$var$X && ($a5d927e783c48bfa$var$Yj ? (a = $a5d927e783c48bfa$var$X, c = c.stateNode, 8 === a.nodeType ? $a5d927e783c48bfa$var$Kf(a.parentNode, c) : 1 === a.nodeType && $a5d927e783c48bfa$var$Kf(a, c), $a5d927e783c48bfa$var$bd(a)) : $a5d927e783c48bfa$var$Kf($a5d927e783c48bfa$var$X, c.stateNode));
            break;
        case 4:
            d = $a5d927e783c48bfa$var$X;
            e = $a5d927e783c48bfa$var$Yj;
            $a5d927e783c48bfa$var$X = c.stateNode.containerInfo;
            $a5d927e783c48bfa$var$Yj = !0;
            $a5d927e783c48bfa$var$Zj(a, b, c);
            $a5d927e783c48bfa$var$X = d;
            $a5d927e783c48bfa$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$a5d927e783c48bfa$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $a5d927e783c48bfa$var$Nj(c, b, g) : 0 !== (f & 4) && $a5d927e783c48bfa$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $a5d927e783c48bfa$var$Zj(a, b, c);
            break;
        case 1:
            if (!$a5d927e783c48bfa$var$U && ($a5d927e783c48bfa$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $a5d927e783c48bfa$var$W(c, b, h);
            }
            $a5d927e783c48bfa$var$Zj(a, b, c);
            break;
        case 21:
            $a5d927e783c48bfa$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($a5d927e783c48bfa$var$U = (d = $a5d927e783c48bfa$var$U) || null !== c.memoizedState, $a5d927e783c48bfa$var$Zj(a, b, c), $a5d927e783c48bfa$var$U = d) : $a5d927e783c48bfa$var$Zj(a, b, c);
            break;
        default:
            $a5d927e783c48bfa$var$Zj(a, b, c);
    }
}
function $a5d927e783c48bfa$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $a5d927e783c48bfa$var$Lj);
        b.forEach(function(b) {
            var d = $a5d927e783c48bfa$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $a5d927e783c48bfa$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $a5d927e783c48bfa$var$X = h.stateNode;
                        $a5d927e783c48bfa$var$Yj = !1;
                        break a;
                    case 3:
                        $a5d927e783c48bfa$var$X = h.stateNode.containerInfo;
                        $a5d927e783c48bfa$var$Yj = !0;
                        break a;
                    case 4:
                        $a5d927e783c48bfa$var$X = h.stateNode.containerInfo;
                        $a5d927e783c48bfa$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $a5d927e783c48bfa$var$X) throw Error($a5d927e783c48bfa$var$p(160));
            $a5d927e783c48bfa$var$ak(f, g, e);
            $a5d927e783c48bfa$var$X = null;
            $a5d927e783c48bfa$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $a5d927e783c48bfa$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$a5d927e783c48bfa$var$ek(b, a), b = b.sibling;
}
function $a5d927e783c48bfa$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $a5d927e783c48bfa$var$dk(b, a);
            $a5d927e783c48bfa$var$fk(a);
            if (d & 4) {
                try {
                    $a5d927e783c48bfa$var$Qj(3, a, a.return), $a5d927e783c48bfa$var$Rj(3, a);
                } catch (t) {
                    $a5d927e783c48bfa$var$W(a, a.return, t);
                }
                try {
                    $a5d927e783c48bfa$var$Qj(5, a, a.return);
                } catch (t) {
                    $a5d927e783c48bfa$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $a5d927e783c48bfa$var$dk(b, a);
            $a5d927e783c48bfa$var$fk(a);
            d & 512 && null !== c && $a5d927e783c48bfa$var$Mj(c, c.return);
            break;
        case 5:
            $a5d927e783c48bfa$var$dk(b, a);
            $a5d927e783c48bfa$var$fk(a);
            d & 512 && null !== c && $a5d927e783c48bfa$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $a5d927e783c48bfa$var$ob(e, "");
                } catch (t) {
                    $a5d927e783c48bfa$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $a5d927e783c48bfa$var$ab(e, f);
                    $a5d927e783c48bfa$var$vb(h, g);
                    var l = $a5d927e783c48bfa$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $a5d927e783c48bfa$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $a5d927e783c48bfa$var$nb(e, q) : "children" === m ? $a5d927e783c48bfa$var$ob(e, q) : $a5d927e783c48bfa$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $a5d927e783c48bfa$var$bb(e, f);
                            break;
                        case "textarea":
                            $a5d927e783c48bfa$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $a5d927e783c48bfa$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $a5d927e783c48bfa$var$fb(e, !!f.multiple, f.defaultValue, !0) : $a5d927e783c48bfa$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$a5d927e783c48bfa$var$Pf] = f;
                } catch (t) {
                    $a5d927e783c48bfa$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $a5d927e783c48bfa$var$dk(b, a);
            $a5d927e783c48bfa$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($a5d927e783c48bfa$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $a5d927e783c48bfa$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $a5d927e783c48bfa$var$dk(b, a);
            $a5d927e783c48bfa$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $a5d927e783c48bfa$var$bd(b.containerInfo);
            } catch (t) {
                $a5d927e783c48bfa$var$W(a, a.return, t);
            }
            break;
        case 4:
            $a5d927e783c48bfa$var$dk(b, a);
            $a5d927e783c48bfa$var$fk(a);
            break;
        case 13:
            $a5d927e783c48bfa$var$dk(b, a);
            $a5d927e783c48bfa$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($a5d927e783c48bfa$var$gk = $a5d927e783c48bfa$var$B()));
            d & 4 && $a5d927e783c48bfa$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($a5d927e783c48bfa$var$U = (l = $a5d927e783c48bfa$var$U) || m, $a5d927e783c48bfa$var$dk(b, a), $a5d927e783c48bfa$var$U = l) : $a5d927e783c48bfa$var$dk(b, a);
            $a5d927e783c48bfa$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($a5d927e783c48bfa$var$V = a, m = a.child; null !== m;){
                    for(q = $a5d927e783c48bfa$var$V = m; null !== $a5d927e783c48bfa$var$V;){
                        r = $a5d927e783c48bfa$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $a5d927e783c48bfa$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $a5d927e783c48bfa$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $a5d927e783c48bfa$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $a5d927e783c48bfa$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $a5d927e783c48bfa$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $a5d927e783c48bfa$var$V = y) : $a5d927e783c48bfa$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $a5d927e783c48bfa$var$rb("display", g));
                            } catch (t) {
                                $a5d927e783c48bfa$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $a5d927e783c48bfa$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $a5d927e783c48bfa$var$dk(b, a);
            $a5d927e783c48bfa$var$fk(a);
            d & 4 && $a5d927e783c48bfa$var$bk(a);
            break;
        case 21:
            break;
        default:
            $a5d927e783c48bfa$var$dk(b, a), $a5d927e783c48bfa$var$fk(a);
    }
}
function $a5d927e783c48bfa$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($a5d927e783c48bfa$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($a5d927e783c48bfa$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($a5d927e783c48bfa$var$ob(e, ""), d.flags &= -33);
                    var f = $a5d927e783c48bfa$var$Vj(a);
                    $a5d927e783c48bfa$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $a5d927e783c48bfa$var$Vj(a);
                    $a5d927e783c48bfa$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($a5d927e783c48bfa$var$p(161));
            }
        } catch (k) {
            $a5d927e783c48bfa$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $a5d927e783c48bfa$var$ik(a, b, c) {
    $a5d927e783c48bfa$var$V = a;
    $a5d927e783c48bfa$var$jk(a, b, c);
}
function $a5d927e783c48bfa$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $a5d927e783c48bfa$var$V;){
        var e = $a5d927e783c48bfa$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $a5d927e783c48bfa$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $a5d927e783c48bfa$var$U;
                h = $a5d927e783c48bfa$var$Kj;
                var l = $a5d927e783c48bfa$var$U;
                $a5d927e783c48bfa$var$Kj = g;
                if (($a5d927e783c48bfa$var$U = k) && !l) for($a5d927e783c48bfa$var$V = e; null !== $a5d927e783c48bfa$var$V;)g = $a5d927e783c48bfa$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $a5d927e783c48bfa$var$kk(e) : null !== k ? (k.return = g, $a5d927e783c48bfa$var$V = k) : $a5d927e783c48bfa$var$kk(e);
                for(; null !== f;)$a5d927e783c48bfa$var$V = f, $a5d927e783c48bfa$var$jk(f, b, c), f = f.sibling;
                $a5d927e783c48bfa$var$V = e;
                $a5d927e783c48bfa$var$Kj = h;
                $a5d927e783c48bfa$var$U = l;
            }
            $a5d927e783c48bfa$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $a5d927e783c48bfa$var$V = f) : $a5d927e783c48bfa$var$lk(a, b, c);
    }
}
function $a5d927e783c48bfa$var$lk(a) {
    for(; null !== $a5d927e783c48bfa$var$V;){
        var b = $a5d927e783c48bfa$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $a5d927e783c48bfa$var$U || $a5d927e783c48bfa$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$a5d927e783c48bfa$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $a5d927e783c48bfa$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $a5d927e783c48bfa$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $a5d927e783c48bfa$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $a5d927e783c48bfa$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($a5d927e783c48bfa$var$p(163));
                }
                $a5d927e783c48bfa$var$U || b.flags & 512 && $a5d927e783c48bfa$var$Sj(b);
            } catch (r) {
                $a5d927e783c48bfa$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $a5d927e783c48bfa$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $a5d927e783c48bfa$var$V = c;
            break;
        }
        $a5d927e783c48bfa$var$V = b.return;
    }
}
function $a5d927e783c48bfa$var$hk(a) {
    for(; null !== $a5d927e783c48bfa$var$V;){
        var b = $a5d927e783c48bfa$var$V;
        if (b === a) {
            $a5d927e783c48bfa$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $a5d927e783c48bfa$var$V = c;
            break;
        }
        $a5d927e783c48bfa$var$V = b.return;
    }
}
function $a5d927e783c48bfa$var$kk(a) {
    for(; null !== $a5d927e783c48bfa$var$V;){
        var b = $a5d927e783c48bfa$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $a5d927e783c48bfa$var$Rj(4, b);
                    } catch (k) {
                        $a5d927e783c48bfa$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $a5d927e783c48bfa$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $a5d927e783c48bfa$var$Sj(b);
                    } catch (k) {
                        $a5d927e783c48bfa$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $a5d927e783c48bfa$var$Sj(b);
                    } catch (k) {
                        $a5d927e783c48bfa$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $a5d927e783c48bfa$var$W(b, b.return, k);
        }
        if (b === a) {
            $a5d927e783c48bfa$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $a5d927e783c48bfa$var$V = h;
            break;
        }
        $a5d927e783c48bfa$var$V = b.return;
    }
}
var $a5d927e783c48bfa$var$mk = Math.ceil, $a5d927e783c48bfa$var$nk = $a5d927e783c48bfa$var$ua.ReactCurrentDispatcher, $a5d927e783c48bfa$var$ok = $a5d927e783c48bfa$var$ua.ReactCurrentOwner, $a5d927e783c48bfa$var$pk = $a5d927e783c48bfa$var$ua.ReactCurrentBatchConfig, $a5d927e783c48bfa$var$K = 0, $a5d927e783c48bfa$var$R = null, $a5d927e783c48bfa$var$Y = null, $a5d927e783c48bfa$var$Z = 0, $a5d927e783c48bfa$var$gj = 0, $a5d927e783c48bfa$var$fj = $a5d927e783c48bfa$var$Uf(0), $a5d927e783c48bfa$var$T = 0, $a5d927e783c48bfa$var$qk = null, $a5d927e783c48bfa$var$hh = 0, $a5d927e783c48bfa$var$rk = 0, $a5d927e783c48bfa$var$sk = 0, $a5d927e783c48bfa$var$tk = null, $a5d927e783c48bfa$var$uk = null, $a5d927e783c48bfa$var$gk = 0, $a5d927e783c48bfa$var$Hj = Infinity, $a5d927e783c48bfa$var$vk = null, $a5d927e783c48bfa$var$Pi = !1, $a5d927e783c48bfa$var$Qi = null, $a5d927e783c48bfa$var$Si = null, $a5d927e783c48bfa$var$wk = !1, $a5d927e783c48bfa$var$xk = null, $a5d927e783c48bfa$var$yk = 0, $a5d927e783c48bfa$var$zk = 0, $a5d927e783c48bfa$var$Ak = null, $a5d927e783c48bfa$var$Bk = -1, $a5d927e783c48bfa$var$Ck = 0;
function $a5d927e783c48bfa$var$L() {
    return 0 !== ($a5d927e783c48bfa$var$K & 6) ? $a5d927e783c48bfa$var$B() : -1 !== $a5d927e783c48bfa$var$Bk ? $a5d927e783c48bfa$var$Bk : $a5d927e783c48bfa$var$Bk = $a5d927e783c48bfa$var$B();
}
function $a5d927e783c48bfa$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($a5d927e783c48bfa$var$K & 2) && 0 !== $a5d927e783c48bfa$var$Z) return $a5d927e783c48bfa$var$Z & -$a5d927e783c48bfa$var$Z;
    if (null !== $a5d927e783c48bfa$var$Kg.transition) return 0 === $a5d927e783c48bfa$var$Ck && ($a5d927e783c48bfa$var$Ck = $a5d927e783c48bfa$var$yc()), $a5d927e783c48bfa$var$Ck;
    a = $a5d927e783c48bfa$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $a5d927e783c48bfa$var$jd(a.type);
    return a;
}
function $a5d927e783c48bfa$var$mh(a, b, c, d) {
    if (50 < $a5d927e783c48bfa$var$zk) throw $a5d927e783c48bfa$var$zk = 0, $a5d927e783c48bfa$var$Ak = null, Error($a5d927e783c48bfa$var$p(185));
    $a5d927e783c48bfa$var$Ac(a, c, d);
    if (0 === ($a5d927e783c48bfa$var$K & 2) || a !== $a5d927e783c48bfa$var$R) a === $a5d927e783c48bfa$var$R && (0 === ($a5d927e783c48bfa$var$K & 2) && ($a5d927e783c48bfa$var$rk |= c), 4 === $a5d927e783c48bfa$var$T && $a5d927e783c48bfa$var$Dk(a, $a5d927e783c48bfa$var$Z)), $a5d927e783c48bfa$var$Ek(a, d), 1 === c && 0 === $a5d927e783c48bfa$var$K && 0 === (b.mode & 1) && ($a5d927e783c48bfa$var$Hj = $a5d927e783c48bfa$var$B() + 500, $a5d927e783c48bfa$var$fg && $a5d927e783c48bfa$var$jg());
}
function $a5d927e783c48bfa$var$Ek(a, b) {
    var c = a.callbackNode;
    $a5d927e783c48bfa$var$wc(a, b);
    var d = $a5d927e783c48bfa$var$uc(a, a === $a5d927e783c48bfa$var$R ? $a5d927e783c48bfa$var$Z : 0);
    if (0 === d) null !== c && $a5d927e783c48bfa$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $a5d927e783c48bfa$var$bc(c);
        if (1 === b) 0 === a.tag ? $a5d927e783c48bfa$var$ig($a5d927e783c48bfa$var$Fk.bind(null, a)) : $a5d927e783c48bfa$var$hg($a5d927e783c48bfa$var$Fk.bind(null, a)), $a5d927e783c48bfa$var$Jf(function() {
            0 === ($a5d927e783c48bfa$var$K & 6) && $a5d927e783c48bfa$var$jg();
        }), c = null;
        else {
            switch($a5d927e783c48bfa$var$Dc(d)){
                case 1:
                    c = $a5d927e783c48bfa$var$fc;
                    break;
                case 4:
                    c = $a5d927e783c48bfa$var$gc;
                    break;
                case 16:
                    c = $a5d927e783c48bfa$var$hc;
                    break;
                case 536870912:
                    c = $a5d927e783c48bfa$var$jc;
                    break;
                default:
                    c = $a5d927e783c48bfa$var$hc;
            }
            c = $a5d927e783c48bfa$var$Gk(c, $a5d927e783c48bfa$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $a5d927e783c48bfa$var$Hk(a, b) {
    $a5d927e783c48bfa$var$Bk = -1;
    $a5d927e783c48bfa$var$Ck = 0;
    if (0 !== ($a5d927e783c48bfa$var$K & 6)) throw Error($a5d927e783c48bfa$var$p(327));
    var c = a.callbackNode;
    if ($a5d927e783c48bfa$var$Ik() && a.callbackNode !== c) return null;
    var d = $a5d927e783c48bfa$var$uc(a, a === $a5d927e783c48bfa$var$R ? $a5d927e783c48bfa$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $a5d927e783c48bfa$var$Jk(a, d);
    else {
        b = d;
        var e = $a5d927e783c48bfa$var$K;
        $a5d927e783c48bfa$var$K |= 2;
        var f = $a5d927e783c48bfa$var$Kk();
        if ($a5d927e783c48bfa$var$R !== a || $a5d927e783c48bfa$var$Z !== b) $a5d927e783c48bfa$var$vk = null, $a5d927e783c48bfa$var$Hj = $a5d927e783c48bfa$var$B() + 500, $a5d927e783c48bfa$var$Lk(a, b);
        for(;;)try {
            $a5d927e783c48bfa$var$Mk();
            break;
        } catch (h) {
            $a5d927e783c48bfa$var$Nk(a, h);
        }
        $a5d927e783c48bfa$var$Qg();
        $a5d927e783c48bfa$var$nk.current = f;
        $a5d927e783c48bfa$var$K = e;
        null !== $a5d927e783c48bfa$var$Y ? b = 0 : ($a5d927e783c48bfa$var$R = null, $a5d927e783c48bfa$var$Z = 0, b = $a5d927e783c48bfa$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $a5d927e783c48bfa$var$xc(a), 0 !== e && (d = e, b = $a5d927e783c48bfa$var$Ok(a, e)));
        if (1 === b) throw c = $a5d927e783c48bfa$var$qk, $a5d927e783c48bfa$var$Lk(a, 0), $a5d927e783c48bfa$var$Dk(a, d), $a5d927e783c48bfa$var$Ek(a, $a5d927e783c48bfa$var$B()), c;
        if (6 === b) $a5d927e783c48bfa$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$a5d927e783c48bfa$var$Pk(e) && (b = $a5d927e783c48bfa$var$Jk(a, d), 2 === b && (f = $a5d927e783c48bfa$var$xc(a), 0 !== f && (d = f, b = $a5d927e783c48bfa$var$Ok(a, f))), 1 === b)) throw c = $a5d927e783c48bfa$var$qk, $a5d927e783c48bfa$var$Lk(a, 0), $a5d927e783c48bfa$var$Dk(a, d), $a5d927e783c48bfa$var$Ek(a, $a5d927e783c48bfa$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($a5d927e783c48bfa$var$p(345));
                case 2:
                    $a5d927e783c48bfa$var$Qk(a, $a5d927e783c48bfa$var$uk, $a5d927e783c48bfa$var$vk);
                    break;
                case 3:
                    $a5d927e783c48bfa$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $a5d927e783c48bfa$var$gk + 500 - $a5d927e783c48bfa$var$B(), 10 < b)) {
                        if (0 !== $a5d927e783c48bfa$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $a5d927e783c48bfa$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $a5d927e783c48bfa$var$Ff($a5d927e783c48bfa$var$Qk.bind(null, a, $a5d927e783c48bfa$var$uk, $a5d927e783c48bfa$var$vk), b);
                        break;
                    }
                    $a5d927e783c48bfa$var$Qk(a, $a5d927e783c48bfa$var$uk, $a5d927e783c48bfa$var$vk);
                    break;
                case 4:
                    $a5d927e783c48bfa$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $a5d927e783c48bfa$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $a5d927e783c48bfa$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $a5d927e783c48bfa$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $a5d927e783c48bfa$var$Ff($a5d927e783c48bfa$var$Qk.bind(null, a, $a5d927e783c48bfa$var$uk, $a5d927e783c48bfa$var$vk), d);
                        break;
                    }
                    $a5d927e783c48bfa$var$Qk(a, $a5d927e783c48bfa$var$uk, $a5d927e783c48bfa$var$vk);
                    break;
                case 5:
                    $a5d927e783c48bfa$var$Qk(a, $a5d927e783c48bfa$var$uk, $a5d927e783c48bfa$var$vk);
                    break;
                default:
                    throw Error($a5d927e783c48bfa$var$p(329));
            }
        }
    }
    $a5d927e783c48bfa$var$Ek(a, $a5d927e783c48bfa$var$B());
    return a.callbackNode === c ? $a5d927e783c48bfa$var$Hk.bind(null, a) : null;
}
function $a5d927e783c48bfa$var$Ok(a, b) {
    var c = $a5d927e783c48bfa$var$tk;
    a.current.memoizedState.isDehydrated && ($a5d927e783c48bfa$var$Lk(a, b).flags |= 256);
    a = $a5d927e783c48bfa$var$Jk(a, b);
    2 !== a && (b = $a5d927e783c48bfa$var$uk, $a5d927e783c48bfa$var$uk = c, null !== b && $a5d927e783c48bfa$var$Gj(b));
    return a;
}
function $a5d927e783c48bfa$var$Gj(a) {
    null === $a5d927e783c48bfa$var$uk ? $a5d927e783c48bfa$var$uk = a : $a5d927e783c48bfa$var$uk.push.apply($a5d927e783c48bfa$var$uk, a);
}
function $a5d927e783c48bfa$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$a5d927e783c48bfa$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $a5d927e783c48bfa$var$Dk(a, b) {
    b &= ~$a5d927e783c48bfa$var$sk;
    b &= ~$a5d927e783c48bfa$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $a5d927e783c48bfa$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $a5d927e783c48bfa$var$Fk(a) {
    if (0 !== ($a5d927e783c48bfa$var$K & 6)) throw Error($a5d927e783c48bfa$var$p(327));
    $a5d927e783c48bfa$var$Ik();
    var b = $a5d927e783c48bfa$var$uc(a, 0);
    if (0 === (b & 1)) return $a5d927e783c48bfa$var$Ek(a, $a5d927e783c48bfa$var$B()), null;
    var c = $a5d927e783c48bfa$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $a5d927e783c48bfa$var$xc(a);
        0 !== d && (b = d, c = $a5d927e783c48bfa$var$Ok(a, d));
    }
    if (1 === c) throw c = $a5d927e783c48bfa$var$qk, $a5d927e783c48bfa$var$Lk(a, 0), $a5d927e783c48bfa$var$Dk(a, b), $a5d927e783c48bfa$var$Ek(a, $a5d927e783c48bfa$var$B()), c;
    if (6 === c) throw Error($a5d927e783c48bfa$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $a5d927e783c48bfa$var$Qk(a, $a5d927e783c48bfa$var$uk, $a5d927e783c48bfa$var$vk);
    $a5d927e783c48bfa$var$Ek(a, $a5d927e783c48bfa$var$B());
    return null;
}
function $a5d927e783c48bfa$var$Rk(a, b) {
    var c = $a5d927e783c48bfa$var$K;
    $a5d927e783c48bfa$var$K |= 1;
    try {
        return a(b);
    } finally{
        $a5d927e783c48bfa$var$K = c, 0 === $a5d927e783c48bfa$var$K && ($a5d927e783c48bfa$var$Hj = $a5d927e783c48bfa$var$B() + 500, $a5d927e783c48bfa$var$fg && $a5d927e783c48bfa$var$jg());
    }
}
function $a5d927e783c48bfa$var$Sk(a) {
    null !== $a5d927e783c48bfa$var$xk && 0 === $a5d927e783c48bfa$var$xk.tag && 0 === ($a5d927e783c48bfa$var$K & 6) && $a5d927e783c48bfa$var$Ik();
    var b = $a5d927e783c48bfa$var$K;
    $a5d927e783c48bfa$var$K |= 1;
    var c = $a5d927e783c48bfa$var$pk.transition, d = $a5d927e783c48bfa$var$C;
    try {
        if ($a5d927e783c48bfa$var$pk.transition = null, $a5d927e783c48bfa$var$C = 1, a) return a();
    } finally{
        $a5d927e783c48bfa$var$C = d, $a5d927e783c48bfa$var$pk.transition = c, $a5d927e783c48bfa$var$K = b, 0 === ($a5d927e783c48bfa$var$K & 6) && $a5d927e783c48bfa$var$jg();
    }
}
function $a5d927e783c48bfa$var$Ij() {
    $a5d927e783c48bfa$var$gj = $a5d927e783c48bfa$var$fj.current;
    $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$fj);
}
function $a5d927e783c48bfa$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $a5d927e783c48bfa$var$Gf(c));
    if (null !== $a5d927e783c48bfa$var$Y) for(c = $a5d927e783c48bfa$var$Y.return; null !== c;){
        var d = c;
        $a5d927e783c48bfa$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $a5d927e783c48bfa$var$$f();
                break;
            case 3:
                $a5d927e783c48bfa$var$Jh();
                $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$Wf);
                $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$H);
                $a5d927e783c48bfa$var$Oh();
                break;
            case 5:
                $a5d927e783c48bfa$var$Lh(d);
                break;
            case 4:
                $a5d927e783c48bfa$var$Jh();
                break;
            case 13:
                $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$M);
                break;
            case 19:
                $a5d927e783c48bfa$var$E($a5d927e783c48bfa$var$M);
                break;
            case 10:
                $a5d927e783c48bfa$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $a5d927e783c48bfa$var$Ij();
        }
        c = c.return;
    }
    $a5d927e783c48bfa$var$R = a;
    $a5d927e783c48bfa$var$Y = a = $a5d927e783c48bfa$var$wh(a.current, null);
    $a5d927e783c48bfa$var$Z = $a5d927e783c48bfa$var$gj = b;
    $a5d927e783c48bfa$var$T = 0;
    $a5d927e783c48bfa$var$qk = null;
    $a5d927e783c48bfa$var$sk = $a5d927e783c48bfa$var$rk = $a5d927e783c48bfa$var$hh = 0;
    $a5d927e783c48bfa$var$uk = $a5d927e783c48bfa$var$tk = null;
    if (null !== $a5d927e783c48bfa$var$Wg) {
        for(b = 0; b < $a5d927e783c48bfa$var$Wg.length; b++)if (c = $a5d927e783c48bfa$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $a5d927e783c48bfa$var$Wg = null;
    }
    return a;
}
function $a5d927e783c48bfa$var$Nk(a, b) {
    do {
        var c = $a5d927e783c48bfa$var$Y;
        try {
            $a5d927e783c48bfa$var$Qg();
            $a5d927e783c48bfa$var$Ph.current = $a5d927e783c48bfa$var$ai;
            if ($a5d927e783c48bfa$var$Sh) {
                for(var d = $a5d927e783c48bfa$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $a5d927e783c48bfa$var$Sh = !1;
            }
            $a5d927e783c48bfa$var$Rh = 0;
            $a5d927e783c48bfa$var$P = $a5d927e783c48bfa$var$O = $a5d927e783c48bfa$var$N = null;
            $a5d927e783c48bfa$var$Th = !1;
            $a5d927e783c48bfa$var$Uh = 0;
            $a5d927e783c48bfa$var$ok.current = null;
            if (null === c || null === c.return) {
                $a5d927e783c48bfa$var$T = 1;
                $a5d927e783c48bfa$var$qk = b;
                $a5d927e783c48bfa$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $a5d927e783c48bfa$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $a5d927e783c48bfa$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $a5d927e783c48bfa$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $a5d927e783c48bfa$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $a5d927e783c48bfa$var$Ti(f, l, b);
                            $a5d927e783c48bfa$var$uj();
                            break a;
                        }
                        k = Error($a5d927e783c48bfa$var$p(426));
                    }
                } else if ($a5d927e783c48bfa$var$I && h.mode & 1) {
                    var J = $a5d927e783c48bfa$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $a5d927e783c48bfa$var$Wi(J, g, h, f, b);
                        $a5d927e783c48bfa$var$Jg($a5d927e783c48bfa$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $a5d927e783c48bfa$var$Ki(k, h);
                4 !== $a5d927e783c48bfa$var$T && ($a5d927e783c48bfa$var$T = 2);
                null === $a5d927e783c48bfa$var$tk ? $a5d927e783c48bfa$var$tk = [
                    f
                ] : $a5d927e783c48bfa$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $a5d927e783c48bfa$var$Oi(f, k, b);
                            $a5d927e783c48bfa$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $a5d927e783c48bfa$var$Si || !$a5d927e783c48bfa$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $a5d927e783c48bfa$var$Ri(f, h, b);
                                $a5d927e783c48bfa$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $a5d927e783c48bfa$var$Tk(c);
        } catch (na) {
            b = na;
            $a5d927e783c48bfa$var$Y === c && null !== c && ($a5d927e783c48bfa$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $a5d927e783c48bfa$var$Kk() {
    var a = $a5d927e783c48bfa$var$nk.current;
    $a5d927e783c48bfa$var$nk.current = $a5d927e783c48bfa$var$ai;
    return null === a ? $a5d927e783c48bfa$var$ai : a;
}
function $a5d927e783c48bfa$var$uj() {
    if (0 === $a5d927e783c48bfa$var$T || 3 === $a5d927e783c48bfa$var$T || 2 === $a5d927e783c48bfa$var$T) $a5d927e783c48bfa$var$T = 4;
    null === $a5d927e783c48bfa$var$R || 0 === ($a5d927e783c48bfa$var$hh & 268435455) && 0 === ($a5d927e783c48bfa$var$rk & 268435455) || $a5d927e783c48bfa$var$Dk($a5d927e783c48bfa$var$R, $a5d927e783c48bfa$var$Z);
}
function $a5d927e783c48bfa$var$Jk(a, b) {
    var c = $a5d927e783c48bfa$var$K;
    $a5d927e783c48bfa$var$K |= 2;
    var d = $a5d927e783c48bfa$var$Kk();
    if ($a5d927e783c48bfa$var$R !== a || $a5d927e783c48bfa$var$Z !== b) $a5d927e783c48bfa$var$vk = null, $a5d927e783c48bfa$var$Lk(a, b);
    for(;;)try {
        $a5d927e783c48bfa$var$Uk();
        break;
    } catch (e) {
        $a5d927e783c48bfa$var$Nk(a, e);
    }
    $a5d927e783c48bfa$var$Qg();
    $a5d927e783c48bfa$var$K = c;
    $a5d927e783c48bfa$var$nk.current = d;
    if (null !== $a5d927e783c48bfa$var$Y) throw Error($a5d927e783c48bfa$var$p(261));
    $a5d927e783c48bfa$var$R = null;
    $a5d927e783c48bfa$var$Z = 0;
    return $a5d927e783c48bfa$var$T;
}
function $a5d927e783c48bfa$var$Uk() {
    for(; null !== $a5d927e783c48bfa$var$Y;)$a5d927e783c48bfa$var$Vk($a5d927e783c48bfa$var$Y);
}
function $a5d927e783c48bfa$var$Mk() {
    for(; null !== $a5d927e783c48bfa$var$Y && !$a5d927e783c48bfa$var$cc();)$a5d927e783c48bfa$var$Vk($a5d927e783c48bfa$var$Y);
}
function $a5d927e783c48bfa$var$Vk(a) {
    var b = $a5d927e783c48bfa$var$Wk(a.alternate, a, $a5d927e783c48bfa$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $a5d927e783c48bfa$var$Tk(a) : $a5d927e783c48bfa$var$Y = b;
    $a5d927e783c48bfa$var$ok.current = null;
}
function $a5d927e783c48bfa$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $a5d927e783c48bfa$var$Fj(c, b, $a5d927e783c48bfa$var$gj), null !== c) {
                $a5d927e783c48bfa$var$Y = c;
                return;
            }
        } else {
            c = $a5d927e783c48bfa$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $a5d927e783c48bfa$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $a5d927e783c48bfa$var$T = 6;
                $a5d927e783c48bfa$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $a5d927e783c48bfa$var$Y = b;
            return;
        }
        $a5d927e783c48bfa$var$Y = b = a;
    }while (null !== b);
    0 === $a5d927e783c48bfa$var$T && ($a5d927e783c48bfa$var$T = 5);
}
function $a5d927e783c48bfa$var$Qk(a, b, c) {
    var d = $a5d927e783c48bfa$var$C, e = $a5d927e783c48bfa$var$pk.transition;
    try {
        $a5d927e783c48bfa$var$pk.transition = null, $a5d927e783c48bfa$var$C = 1, $a5d927e783c48bfa$var$Xk(a, b, c, d);
    } finally{
        $a5d927e783c48bfa$var$pk.transition = e, $a5d927e783c48bfa$var$C = d;
    }
    return null;
}
function $a5d927e783c48bfa$var$Xk(a, b, c, d) {
    do $a5d927e783c48bfa$var$Ik();
    while (null !== $a5d927e783c48bfa$var$xk);
    if (0 !== ($a5d927e783c48bfa$var$K & 6)) throw Error($a5d927e783c48bfa$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($a5d927e783c48bfa$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $a5d927e783c48bfa$var$Bc(a, f);
    a === $a5d927e783c48bfa$var$R && ($a5d927e783c48bfa$var$Y = $a5d927e783c48bfa$var$R = null, $a5d927e783c48bfa$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $a5d927e783c48bfa$var$wk || ($a5d927e783c48bfa$var$wk = !0, $a5d927e783c48bfa$var$Gk($a5d927e783c48bfa$var$hc, function() {
        $a5d927e783c48bfa$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $a5d927e783c48bfa$var$pk.transition;
        $a5d927e783c48bfa$var$pk.transition = null;
        var g = $a5d927e783c48bfa$var$C;
        $a5d927e783c48bfa$var$C = 1;
        var h = $a5d927e783c48bfa$var$K;
        $a5d927e783c48bfa$var$K |= 4;
        $a5d927e783c48bfa$var$ok.current = null;
        $a5d927e783c48bfa$var$Pj(a, c);
        $a5d927e783c48bfa$var$ek(c, a);
        $a5d927e783c48bfa$var$Oe($a5d927e783c48bfa$var$Df);
        $a5d927e783c48bfa$var$dd = !!$a5d927e783c48bfa$var$Cf;
        $a5d927e783c48bfa$var$Df = $a5d927e783c48bfa$var$Cf = null;
        a.current = c;
        $a5d927e783c48bfa$var$ik(c, a, e);
        $a5d927e783c48bfa$var$dc();
        $a5d927e783c48bfa$var$K = h;
        $a5d927e783c48bfa$var$C = g;
        $a5d927e783c48bfa$var$pk.transition = f;
    } else a.current = c;
    $a5d927e783c48bfa$var$wk && ($a5d927e783c48bfa$var$wk = !1, $a5d927e783c48bfa$var$xk = a, $a5d927e783c48bfa$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($a5d927e783c48bfa$var$Si = null);
    $a5d927e783c48bfa$var$mc(c.stateNode, d);
    $a5d927e783c48bfa$var$Ek(a, $a5d927e783c48bfa$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($a5d927e783c48bfa$var$Pi) throw $a5d927e783c48bfa$var$Pi = !1, a = $a5d927e783c48bfa$var$Qi, $a5d927e783c48bfa$var$Qi = null, a;
    0 !== ($a5d927e783c48bfa$var$yk & 1) && 0 !== a.tag && $a5d927e783c48bfa$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $a5d927e783c48bfa$var$Ak ? $a5d927e783c48bfa$var$zk++ : ($a5d927e783c48bfa$var$zk = 0, $a5d927e783c48bfa$var$Ak = a) : $a5d927e783c48bfa$var$zk = 0;
    $a5d927e783c48bfa$var$jg();
    return null;
}
function $a5d927e783c48bfa$var$Ik() {
    if (null !== $a5d927e783c48bfa$var$xk) {
        var a = $a5d927e783c48bfa$var$Dc($a5d927e783c48bfa$var$yk), b = $a5d927e783c48bfa$var$pk.transition, c = $a5d927e783c48bfa$var$C;
        try {
            $a5d927e783c48bfa$var$pk.transition = null;
            $a5d927e783c48bfa$var$C = 16 > a ? 16 : a;
            if (null === $a5d927e783c48bfa$var$xk) var d = !1;
            else {
                a = $a5d927e783c48bfa$var$xk;
                $a5d927e783c48bfa$var$xk = null;
                $a5d927e783c48bfa$var$yk = 0;
                if (0 !== ($a5d927e783c48bfa$var$K & 6)) throw Error($a5d927e783c48bfa$var$p(331));
                var e = $a5d927e783c48bfa$var$K;
                $a5d927e783c48bfa$var$K |= 4;
                for($a5d927e783c48bfa$var$V = a.current; null !== $a5d927e783c48bfa$var$V;){
                    var f = $a5d927e783c48bfa$var$V, g = f.child;
                    if (0 !== ($a5d927e783c48bfa$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($a5d927e783c48bfa$var$V = l; null !== $a5d927e783c48bfa$var$V;){
                                    var m = $a5d927e783c48bfa$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $a5d927e783c48bfa$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $a5d927e783c48bfa$var$V = q;
                                    else for(; null !== $a5d927e783c48bfa$var$V;){
                                        m = $a5d927e783c48bfa$var$V;
                                        var r = m.sibling, y = m.return;
                                        $a5d927e783c48bfa$var$Tj(m);
                                        if (m === l) {
                                            $a5d927e783c48bfa$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $a5d927e783c48bfa$var$V = r;
                                            break;
                                        }
                                        $a5d927e783c48bfa$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $a5d927e783c48bfa$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $a5d927e783c48bfa$var$V = g;
                    else b: for(; null !== $a5d927e783c48bfa$var$V;){
                        f = $a5d927e783c48bfa$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $a5d927e783c48bfa$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $a5d927e783c48bfa$var$V = x;
                            break b;
                        }
                        $a5d927e783c48bfa$var$V = f.return;
                    }
                }
                var w = a.current;
                for($a5d927e783c48bfa$var$V = w; null !== $a5d927e783c48bfa$var$V;){
                    g = $a5d927e783c48bfa$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $a5d927e783c48bfa$var$V = u;
                    else b: for(g = w; null !== $a5d927e783c48bfa$var$V;){
                        h = $a5d927e783c48bfa$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $a5d927e783c48bfa$var$Rj(9, h);
                            }
                        } catch (na) {
                            $a5d927e783c48bfa$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $a5d927e783c48bfa$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $a5d927e783c48bfa$var$V = F;
                            break b;
                        }
                        $a5d927e783c48bfa$var$V = h.return;
                    }
                }
                $a5d927e783c48bfa$var$K = e;
                $a5d927e783c48bfa$var$jg();
                if ($a5d927e783c48bfa$var$lc && "function" === typeof $a5d927e783c48bfa$var$lc.onPostCommitFiberRoot) try {
                    $a5d927e783c48bfa$var$lc.onPostCommitFiberRoot($a5d927e783c48bfa$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $a5d927e783c48bfa$var$C = c, $a5d927e783c48bfa$var$pk.transition = b;
        }
    }
    return !1;
}
function $a5d927e783c48bfa$var$Yk(a, b, c) {
    b = $a5d927e783c48bfa$var$Ki(c, b);
    b = $a5d927e783c48bfa$var$Oi(a, b, 1);
    a = $a5d927e783c48bfa$var$dh(a, b, 1);
    b = $a5d927e783c48bfa$var$L();
    null !== a && ($a5d927e783c48bfa$var$Ac(a, 1, b), $a5d927e783c48bfa$var$Ek(a, b));
}
function $a5d927e783c48bfa$var$W(a, b, c) {
    if (3 === a.tag) $a5d927e783c48bfa$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $a5d927e783c48bfa$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $a5d927e783c48bfa$var$Si || !$a5d927e783c48bfa$var$Si.has(d))) {
                a = $a5d927e783c48bfa$var$Ki(c, a);
                a = $a5d927e783c48bfa$var$Ri(b, a, 1);
                b = $a5d927e783c48bfa$var$dh(b, a, 1);
                a = $a5d927e783c48bfa$var$L();
                null !== b && ($a5d927e783c48bfa$var$Ac(b, 1, a), $a5d927e783c48bfa$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $a5d927e783c48bfa$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $a5d927e783c48bfa$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $a5d927e783c48bfa$var$R === a && ($a5d927e783c48bfa$var$Z & c) === c && (4 === $a5d927e783c48bfa$var$T || 3 === $a5d927e783c48bfa$var$T && ($a5d927e783c48bfa$var$Z & 130023424) === $a5d927e783c48bfa$var$Z && 500 > $a5d927e783c48bfa$var$B() - $a5d927e783c48bfa$var$gk ? $a5d927e783c48bfa$var$Lk(a, 0) : $a5d927e783c48bfa$var$sk |= c);
    $a5d927e783c48bfa$var$Ek(a, b);
}
function $a5d927e783c48bfa$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $a5d927e783c48bfa$var$sc, $a5d927e783c48bfa$var$sc <<= 1, 0 === ($a5d927e783c48bfa$var$sc & 130023424) && ($a5d927e783c48bfa$var$sc = 4194304)));
    var c = $a5d927e783c48bfa$var$L();
    a = $a5d927e783c48bfa$var$Zg(a, b);
    null !== a && ($a5d927e783c48bfa$var$Ac(a, b, c), $a5d927e783c48bfa$var$Ek(a, c));
}
function $a5d927e783c48bfa$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $a5d927e783c48bfa$var$Zk(a, c);
}
function $a5d927e783c48bfa$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($a5d927e783c48bfa$var$p(314));
    }
    null !== d && d.delete(b);
    $a5d927e783c48bfa$var$Zk(a, c);
}
var $a5d927e783c48bfa$var$Wk;
$a5d927e783c48bfa$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $a5d927e783c48bfa$var$Wf.current) $a5d927e783c48bfa$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $a5d927e783c48bfa$var$Ug = !1, $a5d927e783c48bfa$var$zj(a, b, c);
            $a5d927e783c48bfa$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $a5d927e783c48bfa$var$Ug = !1, $a5d927e783c48bfa$var$I && 0 !== (b.flags & 1048576) && $a5d927e783c48bfa$var$ug(b, $a5d927e783c48bfa$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $a5d927e783c48bfa$var$jj(a, b);
            a = b.pendingProps;
            var e = $a5d927e783c48bfa$var$Yf(b, $a5d927e783c48bfa$var$H.current);
            $a5d927e783c48bfa$var$Tg(b, c);
            e = $a5d927e783c48bfa$var$Xh(null, b, d, a, e, c);
            var f = $a5d927e783c48bfa$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $a5d927e783c48bfa$var$Zf(d) ? (f = !0, $a5d927e783c48bfa$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $a5d927e783c48bfa$var$ah(b), e.updater = $a5d927e783c48bfa$var$nh, b.stateNode = e, e._reactInternals = b, $a5d927e783c48bfa$var$rh(b, d, a, c), b = $a5d927e783c48bfa$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $a5d927e783c48bfa$var$I && f && $a5d927e783c48bfa$var$vg(b), $a5d927e783c48bfa$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $a5d927e783c48bfa$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $a5d927e783c48bfa$var$$k(d);
                a = $a5d927e783c48bfa$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $a5d927e783c48bfa$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $a5d927e783c48bfa$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $a5d927e783c48bfa$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $a5d927e783c48bfa$var$aj(null, b, d, $a5d927e783c48bfa$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($a5d927e783c48bfa$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a5d927e783c48bfa$var$Lg(d, e), $a5d927e783c48bfa$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a5d927e783c48bfa$var$Lg(d, e), $a5d927e783c48bfa$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $a5d927e783c48bfa$var$lj(b);
                if (null === a) throw Error($a5d927e783c48bfa$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $a5d927e783c48bfa$var$bh(a, b);
                $a5d927e783c48bfa$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $a5d927e783c48bfa$var$Ki(Error($a5d927e783c48bfa$var$p(423)), b);
                        b = $a5d927e783c48bfa$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $a5d927e783c48bfa$var$Ki(Error($a5d927e783c48bfa$var$p(424)), b);
                        b = $a5d927e783c48bfa$var$mj(a, b, d, c, e);
                        break a;
                    } else for($a5d927e783c48bfa$var$yg = $a5d927e783c48bfa$var$Lf(b.stateNode.containerInfo.firstChild), $a5d927e783c48bfa$var$xg = b, $a5d927e783c48bfa$var$I = !0, $a5d927e783c48bfa$var$zg = null, c = $a5d927e783c48bfa$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $a5d927e783c48bfa$var$Ig();
                    if (d === e) {
                        b = $a5d927e783c48bfa$var$$i(a, b, c);
                        break a;
                    }
                    $a5d927e783c48bfa$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $a5d927e783c48bfa$var$Kh(b), null === a && $a5d927e783c48bfa$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $a5d927e783c48bfa$var$Ef(d, e) ? g = null : null !== f && $a5d927e783c48bfa$var$Ef(d, f) && (b.flags |= 32), $a5d927e783c48bfa$var$hj(a, b), $a5d927e783c48bfa$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $a5d927e783c48bfa$var$Eg(b), null;
        case 13:
            return $a5d927e783c48bfa$var$pj(a, b, c);
        case 4:
            return $a5d927e783c48bfa$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $a5d927e783c48bfa$var$Bh(b, null, d, c) : $a5d927e783c48bfa$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a5d927e783c48bfa$var$Lg(d, e), $a5d927e783c48bfa$var$Zi(a, b, d, e, c);
        case 7:
            return $a5d927e783c48bfa$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $a5d927e783c48bfa$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $a5d927e783c48bfa$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $a5d927e783c48bfa$var$G($a5d927e783c48bfa$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($a5d927e783c48bfa$var$He(f.value, g)) {
                        if (f.children === e.children && !$a5d927e783c48bfa$var$Wf.current) {
                            b = $a5d927e783c48bfa$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $a5d927e783c48bfa$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $a5d927e783c48bfa$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($a5d927e783c48bfa$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $a5d927e783c48bfa$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $a5d927e783c48bfa$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $a5d927e783c48bfa$var$Tg(b, c), e = $a5d927e783c48bfa$var$Vg(e), d = d(e), b.flags |= 1, $a5d927e783c48bfa$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $a5d927e783c48bfa$var$Lg(d, b.pendingProps), e = $a5d927e783c48bfa$var$Lg(d.type, e), $a5d927e783c48bfa$var$aj(a, b, d, e, c);
        case 15:
            return $a5d927e783c48bfa$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a5d927e783c48bfa$var$Lg(d, e), $a5d927e783c48bfa$var$jj(a, b), b.tag = 1, $a5d927e783c48bfa$var$Zf(d) ? (a = !0, $a5d927e783c48bfa$var$cg(b)) : a = !1, $a5d927e783c48bfa$var$Tg(b, c), $a5d927e783c48bfa$var$ph(b, d, e), $a5d927e783c48bfa$var$rh(b, d, e, c), $a5d927e783c48bfa$var$kj(null, b, d, !0, a, c);
        case 19:
            return $a5d927e783c48bfa$var$yj(a, b, c);
        case 22:
            return $a5d927e783c48bfa$var$ej(a, b, c);
    }
    throw Error($a5d927e783c48bfa$var$p(156, b.tag));
};
function $a5d927e783c48bfa$var$Gk(a, b) {
    return $a5d927e783c48bfa$var$ac(a, b);
}
function $a5d927e783c48bfa$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $a5d927e783c48bfa$var$Bg(a, b, c, d) {
    return new $a5d927e783c48bfa$var$al(a, b, c, d);
}
function $a5d927e783c48bfa$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $a5d927e783c48bfa$var$$k(a) {
    if ("function" === typeof a) return $a5d927e783c48bfa$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $a5d927e783c48bfa$var$Da) return 11;
        if (a === $a5d927e783c48bfa$var$Ga) return 14;
    }
    return 2;
}
function $a5d927e783c48bfa$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $a5d927e783c48bfa$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $a5d927e783c48bfa$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $a5d927e783c48bfa$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $a5d927e783c48bfa$var$ya:
            return $a5d927e783c48bfa$var$Ah(c.children, e, f, b);
        case $a5d927e783c48bfa$var$za:
            g = 8;
            e |= 8;
            break;
        case $a5d927e783c48bfa$var$Aa:
            return a = $a5d927e783c48bfa$var$Bg(12, c, b, e | 2), a.elementType = $a5d927e783c48bfa$var$Aa, a.lanes = f, a;
        case $a5d927e783c48bfa$var$Ea:
            return a = $a5d927e783c48bfa$var$Bg(13, c, b, e), a.elementType = $a5d927e783c48bfa$var$Ea, a.lanes = f, a;
        case $a5d927e783c48bfa$var$Fa:
            return a = $a5d927e783c48bfa$var$Bg(19, c, b, e), a.elementType = $a5d927e783c48bfa$var$Fa, a.lanes = f, a;
        case $a5d927e783c48bfa$var$Ia:
            return $a5d927e783c48bfa$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $a5d927e783c48bfa$var$Ba:
                    g = 10;
                    break a;
                case $a5d927e783c48bfa$var$Ca:
                    g = 9;
                    break a;
                case $a5d927e783c48bfa$var$Da:
                    g = 11;
                    break a;
                case $a5d927e783c48bfa$var$Ga:
                    g = 14;
                    break a;
                case $a5d927e783c48bfa$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($a5d927e783c48bfa$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $a5d927e783c48bfa$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $a5d927e783c48bfa$var$Ah(a, b, c, d) {
    a = $a5d927e783c48bfa$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $a5d927e783c48bfa$var$qj(a, b, c, d) {
    a = $a5d927e783c48bfa$var$Bg(22, a, d, b);
    a.elementType = $a5d927e783c48bfa$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $a5d927e783c48bfa$var$xh(a, b, c) {
    a = $a5d927e783c48bfa$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $a5d927e783c48bfa$var$zh(a, b, c) {
    b = $a5d927e783c48bfa$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $a5d927e783c48bfa$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $a5d927e783c48bfa$var$zc(0);
    this.expirationTimes = $a5d927e783c48bfa$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $a5d927e783c48bfa$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $a5d927e783c48bfa$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $a5d927e783c48bfa$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $a5d927e783c48bfa$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $a5d927e783c48bfa$var$ah(f);
    return a;
}
function $a5d927e783c48bfa$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a5d927e783c48bfa$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $a5d927e783c48bfa$var$el(a) {
    if (!a) return $a5d927e783c48bfa$var$Vf;
    a = a._reactInternals;
    a: {
        if ($a5d927e783c48bfa$var$Vb(a) !== a || 1 !== a.tag) throw Error($a5d927e783c48bfa$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($a5d927e783c48bfa$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($a5d927e783c48bfa$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($a5d927e783c48bfa$var$Zf(c)) return $a5d927e783c48bfa$var$bg(a, c, b);
    }
    return b;
}
function $a5d927e783c48bfa$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $a5d927e783c48bfa$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $a5d927e783c48bfa$var$el(null);
    c = a.current;
    d = $a5d927e783c48bfa$var$L();
    e = $a5d927e783c48bfa$var$lh(c);
    f = $a5d927e783c48bfa$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $a5d927e783c48bfa$var$dh(c, f, e);
    a.current.lanes = e;
    $a5d927e783c48bfa$var$Ac(a, e, d);
    $a5d927e783c48bfa$var$Ek(a, d);
    return a;
}
function $a5d927e783c48bfa$var$gl(a, b, c, d) {
    var e = b.current, f = $a5d927e783c48bfa$var$L(), g = $a5d927e783c48bfa$var$lh(e);
    c = $a5d927e783c48bfa$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $a5d927e783c48bfa$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $a5d927e783c48bfa$var$dh(e, b, g);
    null !== a && ($a5d927e783c48bfa$var$mh(a, e, g, f), $a5d927e783c48bfa$var$eh(a, e, g));
    return g;
}
function $a5d927e783c48bfa$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $a5d927e783c48bfa$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $a5d927e783c48bfa$var$jl(a, b) {
    $a5d927e783c48bfa$var$il(a, b);
    (a = a.alternate) && $a5d927e783c48bfa$var$il(a, b);
}
function $a5d927e783c48bfa$var$kl() {
    return null;
}
var $a5d927e783c48bfa$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $a5d927e783c48bfa$var$ml(a) {
    this._internalRoot = a;
}
$a5d927e783c48bfa$var$nl.prototype.render = $a5d927e783c48bfa$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($a5d927e783c48bfa$var$p(409));
    $a5d927e783c48bfa$var$gl(a, b, null, null);
};
$a5d927e783c48bfa$var$nl.prototype.unmount = $a5d927e783c48bfa$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $a5d927e783c48bfa$var$Sk(function() {
            $a5d927e783c48bfa$var$gl(null, a, null, null);
        });
        b[$a5d927e783c48bfa$var$uf] = null;
    }
};
function $a5d927e783c48bfa$var$nl(a) {
    this._internalRoot = a;
}
$a5d927e783c48bfa$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $a5d927e783c48bfa$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $a5d927e783c48bfa$var$Qc.length && 0 !== b && b < $a5d927e783c48bfa$var$Qc[c].priority; c++);
        $a5d927e783c48bfa$var$Qc.splice(c, 0, a);
        0 === c && $a5d927e783c48bfa$var$Vc(a);
    }
};
function $a5d927e783c48bfa$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $a5d927e783c48bfa$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $a5d927e783c48bfa$var$ql() {}
function $a5d927e783c48bfa$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $a5d927e783c48bfa$var$hl(g);
                f.call(a);
            };
        }
        var g = $a5d927e783c48bfa$var$fl(b, d, a, 0, null, !1, !1, "", $a5d927e783c48bfa$var$ql);
        a._reactRootContainer = g;
        a[$a5d927e783c48bfa$var$uf] = g.current;
        $a5d927e783c48bfa$var$sf(8 === a.nodeType ? a.parentNode : a);
        $a5d927e783c48bfa$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $a5d927e783c48bfa$var$hl(k);
            h.call(a);
        };
    }
    var k = $a5d927e783c48bfa$var$cl(a, 0, !1, null, null, !1, !1, "", $a5d927e783c48bfa$var$ql);
    a._reactRootContainer = k;
    a[$a5d927e783c48bfa$var$uf] = k.current;
    $a5d927e783c48bfa$var$sf(8 === a.nodeType ? a.parentNode : a);
    $a5d927e783c48bfa$var$Sk(function() {
        $a5d927e783c48bfa$var$gl(b, k, c, d);
    });
    return k;
}
function $a5d927e783c48bfa$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $a5d927e783c48bfa$var$hl(g);
                h.call(a);
            };
        }
        $a5d927e783c48bfa$var$gl(b, g, a, e);
    } else g = $a5d927e783c48bfa$var$rl(c, b, a, e, d);
    return $a5d927e783c48bfa$var$hl(g);
}
$a5d927e783c48bfa$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $a5d927e783c48bfa$var$tc(b.pendingLanes);
                0 !== c && ($a5d927e783c48bfa$var$Cc(b, c | 1), $a5d927e783c48bfa$var$Ek(b, $a5d927e783c48bfa$var$B()), 0 === ($a5d927e783c48bfa$var$K & 6) && ($a5d927e783c48bfa$var$Hj = $a5d927e783c48bfa$var$B() + 500, $a5d927e783c48bfa$var$jg()));
            }
            break;
        case 13:
            $a5d927e783c48bfa$var$Sk(function() {
                var b = $a5d927e783c48bfa$var$Zg(a, 1);
                if (null !== b) {
                    var c = $a5d927e783c48bfa$var$L();
                    $a5d927e783c48bfa$var$mh(b, a, 1, c);
                }
            }), $a5d927e783c48bfa$var$jl(a, 1);
    }
};
$a5d927e783c48bfa$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $a5d927e783c48bfa$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $a5d927e783c48bfa$var$L();
            $a5d927e783c48bfa$var$mh(b, a, 134217728, c);
        }
        $a5d927e783c48bfa$var$jl(a, 134217728);
    }
};
$a5d927e783c48bfa$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $a5d927e783c48bfa$var$lh(a), c = $a5d927e783c48bfa$var$Zg(a, b);
        if (null !== c) {
            var d = $a5d927e783c48bfa$var$L();
            $a5d927e783c48bfa$var$mh(c, a, b, d);
        }
        $a5d927e783c48bfa$var$jl(a, b);
    }
};
$a5d927e783c48bfa$var$Hc = function() {
    return $a5d927e783c48bfa$var$C;
};
$a5d927e783c48bfa$var$Ic = function(a, b) {
    var c = $a5d927e783c48bfa$var$C;
    try {
        return $a5d927e783c48bfa$var$C = a, b();
    } finally{
        $a5d927e783c48bfa$var$C = c;
    }
};
$a5d927e783c48bfa$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $a5d927e783c48bfa$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $a5d927e783c48bfa$var$Db(d);
                        if (!e) throw Error($a5d927e783c48bfa$var$p(90));
                        $a5d927e783c48bfa$var$Wa(d);
                        $a5d927e783c48bfa$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $a5d927e783c48bfa$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $a5d927e783c48bfa$var$fb(a, !!c.multiple, b, !1);
    }
};
$a5d927e783c48bfa$var$Gb = $a5d927e783c48bfa$var$Rk;
$a5d927e783c48bfa$var$Hb = $a5d927e783c48bfa$var$Sk;
var $a5d927e783c48bfa$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $a5d927e783c48bfa$var$Cb,
        $a5d927e783c48bfa$var$ue,
        $a5d927e783c48bfa$var$Db,
        $a5d927e783c48bfa$var$Eb,
        $a5d927e783c48bfa$var$Fb,
        $a5d927e783c48bfa$var$Rk
    ]
}, $a5d927e783c48bfa$var$ul = {
    findFiberByHostInstance: $a5d927e783c48bfa$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $a5d927e783c48bfa$var$vl = {
    bundleType: $a5d927e783c48bfa$var$ul.bundleType,
    version: $a5d927e783c48bfa$var$ul.version,
    rendererPackageName: $a5d927e783c48bfa$var$ul.rendererPackageName,
    rendererConfig: $a5d927e783c48bfa$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $a5d927e783c48bfa$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $a5d927e783c48bfa$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $a5d927e783c48bfa$var$ul.findFiberByHostInstance || $a5d927e783c48bfa$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $a5d927e783c48bfa$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$a5d927e783c48bfa$var$wl.isDisabled && $a5d927e783c48bfa$var$wl.supportsFiber) try {
        $a5d927e783c48bfa$var$kc = $a5d927e783c48bfa$var$wl.inject($a5d927e783c48bfa$var$vl), $a5d927e783c48bfa$var$lc = $a5d927e783c48bfa$var$wl;
    } catch (a) {}
}
$a5d927e783c48bfa$export$ae55be85d98224ed = $a5d927e783c48bfa$var$tl;
$a5d927e783c48bfa$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$a5d927e783c48bfa$var$ol(b)) throw Error($a5d927e783c48bfa$var$p(200));
    return $a5d927e783c48bfa$var$dl(a, b, null, c);
};
$a5d927e783c48bfa$export$882461b6382ed46c = function(a, b) {
    if (!$a5d927e783c48bfa$var$ol(a)) throw Error($a5d927e783c48bfa$var$p(299));
    var c = !1, d = "", e = $a5d927e783c48bfa$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $a5d927e783c48bfa$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$a5d927e783c48bfa$var$uf] = b.current;
    $a5d927e783c48bfa$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $a5d927e783c48bfa$var$ml(b);
};
$a5d927e783c48bfa$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($a5d927e783c48bfa$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($a5d927e783c48bfa$var$p(268, a));
    }
    a = $a5d927e783c48bfa$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$a5d927e783c48bfa$export$cd75ccfd720a3cd4 = function(a) {
    return $a5d927e783c48bfa$var$Sk(a);
};
$a5d927e783c48bfa$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$a5d927e783c48bfa$var$pl(b)) throw Error($a5d927e783c48bfa$var$p(200));
    return $a5d927e783c48bfa$var$sl(null, a, b, !0, c);
};
$a5d927e783c48bfa$export$757ceba2d55c277e = function(a, b, c) {
    if (!$a5d927e783c48bfa$var$ol(a)) throw Error($a5d927e783c48bfa$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $a5d927e783c48bfa$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $a5d927e783c48bfa$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$a5d927e783c48bfa$var$uf] = b.current;
    $a5d927e783c48bfa$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $a5d927e783c48bfa$var$nl(b);
};
$a5d927e783c48bfa$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$a5d927e783c48bfa$var$pl(b)) throw Error($a5d927e783c48bfa$var$p(200));
    return $a5d927e783c48bfa$var$sl(null, a, b, !1, c);
};
$a5d927e783c48bfa$export$502457920280e6be = function(a) {
    if (!$a5d927e783c48bfa$var$pl(a)) throw Error($a5d927e783c48bfa$var$p(40));
    return a._reactRootContainer ? ($a5d927e783c48bfa$var$Sk(function() {
        $a5d927e783c48bfa$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$a5d927e783c48bfa$var$uf] = null;
        });
    }), !0) : !1;
};
$a5d927e783c48bfa$export$c78a37762a8d58e1 = $a5d927e783c48bfa$var$Rk;
$a5d927e783c48bfa$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$a5d927e783c48bfa$var$pl(c)) throw Error($a5d927e783c48bfa$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($a5d927e783c48bfa$var$p(38));
    return $a5d927e783c48bfa$var$sl(a, b, c, !1, d);
};
$a5d927e783c48bfa$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("aUPxC", function(module, exports) {
"use strict";

module.exports = (parcelRequire("frLk0"));

});
parcelRequire.register("frLk0", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $b3ee15b724c807b2$export$c4744153514ff05d; }, function (v) { return $b3ee15b724c807b2$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $b3ee15b724c807b2$export$3e506c1ccc9cc1a7; }, function (v) { return $b3ee15b724c807b2$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $b3ee15b724c807b2$export$e26fe2ed2fa76875; }, function (v) { return $b3ee15b724c807b2$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $b3ee15b724c807b2$export$502329bbf4b505b1; }, function (v) { return $b3ee15b724c807b2$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $b3ee15b724c807b2$export$6e3807111c4874c4; }, function (v) { return $b3ee15b724c807b2$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $b3ee15b724c807b2$export$c27134553091fb3a; }, function (v) { return $b3ee15b724c807b2$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $b3ee15b724c807b2$export$33ee1acdc04fd2a2; }, function (v) { return $b3ee15b724c807b2$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $b3ee15b724c807b2$export$b00a404bbd5edef2; }, function (v) { return $b3ee15b724c807b2$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $b3ee15b724c807b2$export$8352ce38b91d0c62; }, function (v) { return $b3ee15b724c807b2$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $b3ee15b724c807b2$export$d66a1c1c77bd778b; }, function (v) { return $b3ee15b724c807b2$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $b3ee15b724c807b2$export$d3dfb8e4810cb555; }, function (v) { return $b3ee15b724c807b2$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $b3ee15b724c807b2$export$839f9183b0465a69; }, function (v) { return $b3ee15b724c807b2$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $b3ee15b724c807b2$export$72fdf0e06517287b; }, function (v) { return $b3ee15b724c807b2$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $b3ee15b724c807b2$export$4b844e58a3e414b4; }, function (v) { return $b3ee15b724c807b2$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $b3ee15b724c807b2$export$816d2913ae6b83b1; }, function (v) { return $b3ee15b724c807b2$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $b3ee15b724c807b2$export$61bcfe829111a1d0; }, function (v) { return $b3ee15b724c807b2$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $b3ee15b724c807b2$export$7ee8c9beb337bc3f; }, function (v) { return $b3ee15b724c807b2$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $b3ee15b724c807b2$export$b5836b71941fa3ed; }, function (v) { return $b3ee15b724c807b2$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $b3ee15b724c807b2$export$cf845f2c119da08a; }, function (v) { return $b3ee15b724c807b2$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b3ee15b724c807b2$export$c4744153514ff05d;
var $b3ee15b724c807b2$export$3e506c1ccc9cc1a7;
var $b3ee15b724c807b2$export$e26fe2ed2fa76875;
var $b3ee15b724c807b2$export$502329bbf4b505b1;
var $b3ee15b724c807b2$export$6e3807111c4874c4;
var $b3ee15b724c807b2$export$c27134553091fb3a;
var $b3ee15b724c807b2$export$33ee1acdc04fd2a2;
var $b3ee15b724c807b2$export$b00a404bbd5edef2;
var $b3ee15b724c807b2$export$8352ce38b91d0c62;
var $b3ee15b724c807b2$export$d66a1c1c77bd778b;
var $b3ee15b724c807b2$export$d3dfb8e4810cb555;
var $b3ee15b724c807b2$export$839f9183b0465a69;
var $b3ee15b724c807b2$export$72fdf0e06517287b;
var $b3ee15b724c807b2$export$4b844e58a3e414b4;
var $b3ee15b724c807b2$export$816d2913ae6b83b1;
var $b3ee15b724c807b2$export$61bcfe829111a1d0;
var $b3ee15b724c807b2$export$7ee8c9beb337bc3f;
var $b3ee15b724c807b2$export$b5836b71941fa3ed;
var $b3ee15b724c807b2$export$cf845f2c119da08a;
"use strict";
function $b3ee15b724c807b2$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $b3ee15b724c807b2$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $b3ee15b724c807b2$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $b3ee15b724c807b2$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $b3ee15b724c807b2$var$g(C, c)) n < e && 0 > $b3ee15b724c807b2$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $b3ee15b724c807b2$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $b3ee15b724c807b2$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $b3ee15b724c807b2$var$l = performance;
    $b3ee15b724c807b2$export$c4744153514ff05d = function() {
        return $b3ee15b724c807b2$var$l.now();
    };
} else {
    var $b3ee15b724c807b2$var$p = Date, $b3ee15b724c807b2$var$q = $b3ee15b724c807b2$var$p.now();
    $b3ee15b724c807b2$export$c4744153514ff05d = function() {
        return $b3ee15b724c807b2$var$p.now() - $b3ee15b724c807b2$var$q;
    };
}
var $b3ee15b724c807b2$var$r = [], $b3ee15b724c807b2$var$t = [], $b3ee15b724c807b2$var$u = 1, $b3ee15b724c807b2$var$v = null, $b3ee15b724c807b2$var$y = 3, $b3ee15b724c807b2$var$z = !1, $b3ee15b724c807b2$var$A = !1, $b3ee15b724c807b2$var$B = !1, $b3ee15b724c807b2$var$D = "function" === typeof setTimeout ? setTimeout : null, $b3ee15b724c807b2$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $b3ee15b724c807b2$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $b3ee15b724c807b2$var$G(a) {
    for(var b = $b3ee15b724c807b2$var$h($b3ee15b724c807b2$var$t); null !== b;){
        if (null === b.callback) $b3ee15b724c807b2$var$k($b3ee15b724c807b2$var$t);
        else if (b.startTime <= a) $b3ee15b724c807b2$var$k($b3ee15b724c807b2$var$t), b.sortIndex = b.expirationTime, $b3ee15b724c807b2$var$f($b3ee15b724c807b2$var$r, b);
        else break;
        b = $b3ee15b724c807b2$var$h($b3ee15b724c807b2$var$t);
    }
}
function $b3ee15b724c807b2$var$H(a) {
    $b3ee15b724c807b2$var$B = !1;
    $b3ee15b724c807b2$var$G(a);
    if (!$b3ee15b724c807b2$var$A) {
        if (null !== $b3ee15b724c807b2$var$h($b3ee15b724c807b2$var$r)) $b3ee15b724c807b2$var$A = !0, $b3ee15b724c807b2$var$I($b3ee15b724c807b2$var$J);
        else {
            var b = $b3ee15b724c807b2$var$h($b3ee15b724c807b2$var$t);
            null !== b && $b3ee15b724c807b2$var$K($b3ee15b724c807b2$var$H, b.startTime - a);
        }
    }
}
function $b3ee15b724c807b2$var$J(a, b) {
    $b3ee15b724c807b2$var$A = !1;
    $b3ee15b724c807b2$var$B && ($b3ee15b724c807b2$var$B = !1, $b3ee15b724c807b2$var$E($b3ee15b724c807b2$var$L), $b3ee15b724c807b2$var$L = -1);
    $b3ee15b724c807b2$var$z = !0;
    var c = $b3ee15b724c807b2$var$y;
    try {
        $b3ee15b724c807b2$var$G(b);
        for($b3ee15b724c807b2$var$v = $b3ee15b724c807b2$var$h($b3ee15b724c807b2$var$r); null !== $b3ee15b724c807b2$var$v && (!($b3ee15b724c807b2$var$v.expirationTime > b) || a && !$b3ee15b724c807b2$var$M());){
            var d = $b3ee15b724c807b2$var$v.callback;
            if ("function" === typeof d) {
                $b3ee15b724c807b2$var$v.callback = null;
                $b3ee15b724c807b2$var$y = $b3ee15b724c807b2$var$v.priorityLevel;
                var e = d($b3ee15b724c807b2$var$v.expirationTime <= b);
                b = $b3ee15b724c807b2$export$c4744153514ff05d();
                "function" === typeof e ? $b3ee15b724c807b2$var$v.callback = e : $b3ee15b724c807b2$var$v === $b3ee15b724c807b2$var$h($b3ee15b724c807b2$var$r) && $b3ee15b724c807b2$var$k($b3ee15b724c807b2$var$r);
                $b3ee15b724c807b2$var$G(b);
            } else $b3ee15b724c807b2$var$k($b3ee15b724c807b2$var$r);
            $b3ee15b724c807b2$var$v = $b3ee15b724c807b2$var$h($b3ee15b724c807b2$var$r);
        }
        if (null !== $b3ee15b724c807b2$var$v) var w = !0;
        else {
            var m = $b3ee15b724c807b2$var$h($b3ee15b724c807b2$var$t);
            null !== m && $b3ee15b724c807b2$var$K($b3ee15b724c807b2$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $b3ee15b724c807b2$var$v = null, $b3ee15b724c807b2$var$y = c, $b3ee15b724c807b2$var$z = !1;
    }
}
var $b3ee15b724c807b2$var$N = !1, $b3ee15b724c807b2$var$O = null, $b3ee15b724c807b2$var$L = -1, $b3ee15b724c807b2$var$P = 5, $b3ee15b724c807b2$var$Q = -1;
function $b3ee15b724c807b2$var$M() {
    return $b3ee15b724c807b2$export$c4744153514ff05d() - $b3ee15b724c807b2$var$Q < $b3ee15b724c807b2$var$P ? !1 : !0;
}
function $b3ee15b724c807b2$var$R() {
    if (null !== $b3ee15b724c807b2$var$O) {
        var a = $b3ee15b724c807b2$export$c4744153514ff05d();
        $b3ee15b724c807b2$var$Q = a;
        var b = !0;
        try {
            b = $b3ee15b724c807b2$var$O(!0, a);
        } finally{
            b ? $b3ee15b724c807b2$var$S() : ($b3ee15b724c807b2$var$N = !1, $b3ee15b724c807b2$var$O = null);
        }
    } else $b3ee15b724c807b2$var$N = !1;
}
var $b3ee15b724c807b2$var$S;
if ("function" === typeof $b3ee15b724c807b2$var$F) $b3ee15b724c807b2$var$S = function() {
    $b3ee15b724c807b2$var$F($b3ee15b724c807b2$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $b3ee15b724c807b2$var$T = new MessageChannel, $b3ee15b724c807b2$var$U = $b3ee15b724c807b2$var$T.port2;
    $b3ee15b724c807b2$var$T.port1.onmessage = $b3ee15b724c807b2$var$R;
    $b3ee15b724c807b2$var$S = function() {
        $b3ee15b724c807b2$var$U.postMessage(null);
    };
} else $b3ee15b724c807b2$var$S = function() {
    $b3ee15b724c807b2$var$D($b3ee15b724c807b2$var$R, 0);
};
function $b3ee15b724c807b2$var$I(a) {
    $b3ee15b724c807b2$var$O = a;
    $b3ee15b724c807b2$var$N || ($b3ee15b724c807b2$var$N = !0, $b3ee15b724c807b2$var$S());
}
function $b3ee15b724c807b2$var$K(a, b) {
    $b3ee15b724c807b2$var$L = $b3ee15b724c807b2$var$D(function() {
        a($b3ee15b724c807b2$export$c4744153514ff05d());
    }, b);
}
$b3ee15b724c807b2$export$3e506c1ccc9cc1a7 = 5;
$b3ee15b724c807b2$export$e26fe2ed2fa76875 = 1;
$b3ee15b724c807b2$export$502329bbf4b505b1 = 4;
$b3ee15b724c807b2$export$6e3807111c4874c4 = 3;
$b3ee15b724c807b2$export$c27134553091fb3a = null;
$b3ee15b724c807b2$export$33ee1acdc04fd2a2 = 2;
$b3ee15b724c807b2$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$b3ee15b724c807b2$export$8352ce38b91d0c62 = function() {
    $b3ee15b724c807b2$var$A || $b3ee15b724c807b2$var$z || ($b3ee15b724c807b2$var$A = !0, $b3ee15b724c807b2$var$I($b3ee15b724c807b2$var$J));
};
$b3ee15b724c807b2$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $b3ee15b724c807b2$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$b3ee15b724c807b2$export$d3dfb8e4810cb555 = function() {
    return $b3ee15b724c807b2$var$y;
};
$b3ee15b724c807b2$export$839f9183b0465a69 = function() {
    return $b3ee15b724c807b2$var$h($b3ee15b724c807b2$var$r);
};
$b3ee15b724c807b2$export$72fdf0e06517287b = function(a) {
    switch($b3ee15b724c807b2$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $b3ee15b724c807b2$var$y;
    }
    var c = $b3ee15b724c807b2$var$y;
    $b3ee15b724c807b2$var$y = b;
    try {
        return a();
    } finally{
        $b3ee15b724c807b2$var$y = c;
    }
};
$b3ee15b724c807b2$export$4b844e58a3e414b4 = function() {};
$b3ee15b724c807b2$export$816d2913ae6b83b1 = function() {};
$b3ee15b724c807b2$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $b3ee15b724c807b2$var$y;
    $b3ee15b724c807b2$var$y = a;
    try {
        return b();
    } finally{
        $b3ee15b724c807b2$var$y = c;
    }
};
$b3ee15b724c807b2$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $b3ee15b724c807b2$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $b3ee15b724c807b2$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $b3ee15b724c807b2$var$f($b3ee15b724c807b2$var$t, a), null === $b3ee15b724c807b2$var$h($b3ee15b724c807b2$var$r) && a === $b3ee15b724c807b2$var$h($b3ee15b724c807b2$var$t) && ($b3ee15b724c807b2$var$B ? ($b3ee15b724c807b2$var$E($b3ee15b724c807b2$var$L), $b3ee15b724c807b2$var$L = -1) : $b3ee15b724c807b2$var$B = !0, $b3ee15b724c807b2$var$K($b3ee15b724c807b2$var$H, c - d))) : (a.sortIndex = e, $b3ee15b724c807b2$var$f($b3ee15b724c807b2$var$r, a), $b3ee15b724c807b2$var$A || $b3ee15b724c807b2$var$z || ($b3ee15b724c807b2$var$A = !0, $b3ee15b724c807b2$var$I($b3ee15b724c807b2$var$J)));
    return a;
};
$b3ee15b724c807b2$export$b5836b71941fa3ed = $b3ee15b724c807b2$var$M;
$b3ee15b724c807b2$export$cf845f2c119da08a = function(a) {
    var b = $b3ee15b724c807b2$var$y;
    return function() {
        var c = $b3ee15b724c807b2$var$y;
        $b3ee15b724c807b2$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $b3ee15b724c807b2$var$y = c;
        }
    };
};

});



parcelRequire.register("3A0mV", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $29b505204ef157d3$export$2b8d127b894957b9; }, function (v) { return $29b505204ef157d3$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $29b505204ef157d3$export$cea3a54a6425200c; }, function (v) { return $29b505204ef157d3$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $29b505204ef157d3$export$a7c73072b1a182ae; }, function (v) { return $29b505204ef157d3$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $29b505204ef157d3$export$9f27bc3417b4524d; }, function (v) { return $29b505204ef157d3$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $29b505204ef157d3$export$db77ccec0bb4ccac; }, function (v) { return $29b505204ef157d3$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $29b505204ef157d3$export$8392c0c9d3dcbd35; }, function (v) { return $29b505204ef157d3$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $29b505204ef157d3$export$ffb0004e005737fa; }, function (v) { return $29b505204ef157d3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $29b505204ef157d3$export$b624eff549462981; }, function (v) { return $29b505204ef157d3$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $29b505204ef157d3$export$7897aa7841a5380c; }, function (v) { return $29b505204ef157d3$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $29b505204ef157d3$export$602eac185826482c; }, function (v) { return $29b505204ef157d3$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $29b505204ef157d3$export$e2c29f18771995cb; }, function (v) { return $29b505204ef157d3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $29b505204ef157d3$export$5f8d39834fd61797; }, function (v) { return $29b505204ef157d3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $29b505204ef157d3$export$74bf444e3cd11ea5; }, function (v) { return $29b505204ef157d3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $29b505204ef157d3$export$92387174baf9b227; }, function (v) { return $29b505204ef157d3$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $29b505204ef157d3$export$ec112efeb987d9c6; }, function (v) { return $29b505204ef157d3$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $29b505204ef157d3$export$b706b080d889d2c9; }, function (v) { return $29b505204ef157d3$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $29b505204ef157d3$export$5be5a87408f70ddc; }, function (v) { return $29b505204ef157d3$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $29b505204ef157d3$export$45a5e7f76e0caa8d; }, function (v) { return $29b505204ef157d3$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $29b505204ef157d3$export$455c2e768291efa6; }, function (v) { return $29b505204ef157d3$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $29b505204ef157d3$export$9522e17588c12572; }, function (v) { return $29b505204ef157d3$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $29b505204ef157d3$export$2110ac352bb060b9; }, function (v) { return $29b505204ef157d3$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $29b505204ef157d3$export$56885ab8b9c456ab; }, function (v) { return $29b505204ef157d3$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $29b505204ef157d3$export$d927fcb6adf8f9de; }, function (v) { return $29b505204ef157d3$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $29b505204ef157d3$export$b82d16f27459e05a; }, function (v) { return $29b505204ef157d3$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $29b505204ef157d3$export$522c17b4f5e123e8; }, function (v) { return $29b505204ef157d3$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $29b505204ef157d3$export$1aabd8a0274ecfd6; }, function (v) { return $29b505204ef157d3$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $29b505204ef157d3$export$9b621391a187a31a; }, function (v) { return $29b505204ef157d3$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $29b505204ef157d3$export$f5bbd400c2f4426f; }, function (v) { return $29b505204ef157d3$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $29b505204ef157d3$export$2b8d127b894957b9;
var $29b505204ef157d3$export$cea3a54a6425200c;
var $29b505204ef157d3$export$a7c73072b1a182ae;
var $29b505204ef157d3$export$9f27bc3417b4524d;
var $29b505204ef157d3$export$db77ccec0bb4ccac;
var $29b505204ef157d3$export$8392c0c9d3dcbd35;
var $29b505204ef157d3$export$ffb0004e005737fa;
var $29b505204ef157d3$export$b624eff549462981;
var $29b505204ef157d3$export$7897aa7841a5380c;
var $29b505204ef157d3$export$602eac185826482c;
var $29b505204ef157d3$export$e2c29f18771995cb;
var $29b505204ef157d3$export$5f8d39834fd61797;
var $29b505204ef157d3$export$74bf444e3cd11ea5;
var $29b505204ef157d3$export$92387174baf9b227;
var $29b505204ef157d3$export$ec112efeb987d9c6;
var $29b505204ef157d3$export$b706b080d889d2c9;
var $29b505204ef157d3$export$5be5a87408f70ddc;
var $29b505204ef157d3$export$45a5e7f76e0caa8d;
var $29b505204ef157d3$export$455c2e768291efa6;
var $29b505204ef157d3$export$9522e17588c12572;
var $29b505204ef157d3$export$2110ac352bb060b9;
var $29b505204ef157d3$export$56885ab8b9c456ab;
var $29b505204ef157d3$export$d927fcb6adf8f9de;
var $29b505204ef157d3$export$b82d16f27459e05a;
var $29b505204ef157d3$export$522c17b4f5e123e8;
var $29b505204ef157d3$export$1aabd8a0274ecfd6;
var $29b505204ef157d3$export$9b621391a187a31a;
var $29b505204ef157d3$export$f5bbd400c2f4426f;
"use strict";
var $29b505204ef157d3$var$b = "function" === typeof Symbol && Symbol.for, $29b505204ef157d3$var$c = $29b505204ef157d3$var$b ? Symbol.for("react.element") : 60103, $29b505204ef157d3$var$d = $29b505204ef157d3$var$b ? Symbol.for("react.portal") : 60106, $29b505204ef157d3$var$e = $29b505204ef157d3$var$b ? Symbol.for("react.fragment") : 60107, $29b505204ef157d3$var$f = $29b505204ef157d3$var$b ? Symbol.for("react.strict_mode") : 60108, $29b505204ef157d3$var$g = $29b505204ef157d3$var$b ? Symbol.for("react.profiler") : 60114, $29b505204ef157d3$var$h = $29b505204ef157d3$var$b ? Symbol.for("react.provider") : 60109, $29b505204ef157d3$var$k = $29b505204ef157d3$var$b ? Symbol.for("react.context") : 60110, $29b505204ef157d3$var$l = $29b505204ef157d3$var$b ? Symbol.for("react.async_mode") : 60111, $29b505204ef157d3$var$m = $29b505204ef157d3$var$b ? Symbol.for("react.concurrent_mode") : 60111, $29b505204ef157d3$var$n = $29b505204ef157d3$var$b ? Symbol.for("react.forward_ref") : 60112, $29b505204ef157d3$var$p = $29b505204ef157d3$var$b ? Symbol.for("react.suspense") : 60113, $29b505204ef157d3$var$q = $29b505204ef157d3$var$b ? Symbol.for("react.suspense_list") : 60120, $29b505204ef157d3$var$r = $29b505204ef157d3$var$b ? Symbol.for("react.memo") : 60115, $29b505204ef157d3$var$t = $29b505204ef157d3$var$b ? Symbol.for("react.lazy") : 60116, $29b505204ef157d3$var$v = $29b505204ef157d3$var$b ? Symbol.for("react.block") : 60121, $29b505204ef157d3$var$w = $29b505204ef157d3$var$b ? Symbol.for("react.fundamental") : 60117, $29b505204ef157d3$var$x = $29b505204ef157d3$var$b ? Symbol.for("react.responder") : 60118, $29b505204ef157d3$var$y = $29b505204ef157d3$var$b ? Symbol.for("react.scope") : 60119;
function $29b505204ef157d3$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $29b505204ef157d3$var$c:
                switch(a = a.type, a){
                    case $29b505204ef157d3$var$l:
                    case $29b505204ef157d3$var$m:
                    case $29b505204ef157d3$var$e:
                    case $29b505204ef157d3$var$g:
                    case $29b505204ef157d3$var$f:
                    case $29b505204ef157d3$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $29b505204ef157d3$var$k:
                            case $29b505204ef157d3$var$n:
                            case $29b505204ef157d3$var$t:
                            case $29b505204ef157d3$var$r:
                            case $29b505204ef157d3$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $29b505204ef157d3$var$d:
                return u;
        }
    }
}
function $29b505204ef157d3$var$A(a) {
    return $29b505204ef157d3$var$z(a) === $29b505204ef157d3$var$m;
}
$29b505204ef157d3$export$2b8d127b894957b9 = $29b505204ef157d3$var$l;
$29b505204ef157d3$export$cea3a54a6425200c = $29b505204ef157d3$var$m;
$29b505204ef157d3$export$a7c73072b1a182ae = $29b505204ef157d3$var$k;
$29b505204ef157d3$export$9f27bc3417b4524d = $29b505204ef157d3$var$h;
$29b505204ef157d3$export$db77ccec0bb4ccac = $29b505204ef157d3$var$c;
$29b505204ef157d3$export$8392c0c9d3dcbd35 = $29b505204ef157d3$var$n;
$29b505204ef157d3$export$ffb0004e005737fa = $29b505204ef157d3$var$e;
$29b505204ef157d3$export$b624eff549462981 = $29b505204ef157d3$var$t;
$29b505204ef157d3$export$7897aa7841a5380c = $29b505204ef157d3$var$r;
$29b505204ef157d3$export$602eac185826482c = $29b505204ef157d3$var$d;
$29b505204ef157d3$export$e2c29f18771995cb = $29b505204ef157d3$var$g;
$29b505204ef157d3$export$5f8d39834fd61797 = $29b505204ef157d3$var$f;
$29b505204ef157d3$export$74bf444e3cd11ea5 = $29b505204ef157d3$var$p;
$29b505204ef157d3$export$92387174baf9b227 = function(a) {
    return $29b505204ef157d3$var$A(a) || $29b505204ef157d3$var$z(a) === $29b505204ef157d3$var$l;
};
$29b505204ef157d3$export$ec112efeb987d9c6 = $29b505204ef157d3$var$A;
$29b505204ef157d3$export$b706b080d889d2c9 = function(a) {
    return $29b505204ef157d3$var$z(a) === $29b505204ef157d3$var$k;
};
$29b505204ef157d3$export$5be5a87408f70ddc = function(a) {
    return $29b505204ef157d3$var$z(a) === $29b505204ef157d3$var$h;
};
$29b505204ef157d3$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $29b505204ef157d3$var$c;
};
$29b505204ef157d3$export$455c2e768291efa6 = function(a) {
    return $29b505204ef157d3$var$z(a) === $29b505204ef157d3$var$n;
};
$29b505204ef157d3$export$9522e17588c12572 = function(a) {
    return $29b505204ef157d3$var$z(a) === $29b505204ef157d3$var$e;
};
$29b505204ef157d3$export$2110ac352bb060b9 = function(a) {
    return $29b505204ef157d3$var$z(a) === $29b505204ef157d3$var$t;
};
$29b505204ef157d3$export$56885ab8b9c456ab = function(a) {
    return $29b505204ef157d3$var$z(a) === $29b505204ef157d3$var$r;
};
$29b505204ef157d3$export$d927fcb6adf8f9de = function(a) {
    return $29b505204ef157d3$var$z(a) === $29b505204ef157d3$var$d;
};
$29b505204ef157d3$export$b82d16f27459e05a = function(a) {
    return $29b505204ef157d3$var$z(a) === $29b505204ef157d3$var$g;
};
$29b505204ef157d3$export$522c17b4f5e123e8 = function(a) {
    return $29b505204ef157d3$var$z(a) === $29b505204ef157d3$var$f;
};
$29b505204ef157d3$export$1aabd8a0274ecfd6 = function(a) {
    return $29b505204ef157d3$var$z(a) === $29b505204ef157d3$var$p;
};
$29b505204ef157d3$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $29b505204ef157d3$var$e || a === $29b505204ef157d3$var$m || a === $29b505204ef157d3$var$g || a === $29b505204ef157d3$var$f || a === $29b505204ef157d3$var$p || a === $29b505204ef157d3$var$q || "object" === typeof a && null !== a && (a.$$typeof === $29b505204ef157d3$var$t || a.$$typeof === $29b505204ef157d3$var$r || a.$$typeof === $29b505204ef157d3$var$h || a.$$typeof === $29b505204ef157d3$var$k || a.$$typeof === $29b505204ef157d3$var$n || a.$$typeof === $29b505204ef157d3$var$w || a.$$typeof === $29b505204ef157d3$var$x || a.$$typeof === $29b505204ef157d3$var$y || a.$$typeof === $29b505204ef157d3$var$v);
};
$29b505204ef157d3$export$f5bbd400c2f4426f = $29b505204ef157d3$var$z;

});

parcelRequire.register("bQ7uH", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $89ea5d373ae096bf$export$bf730a2d8bf68b42; }, function (v) { return $89ea5d373ae096bf$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $89ea5d373ae096bf$export$bf730a2d8bf68b42;
"use strict";

var $35jnV = parcelRequire("35jnV");

var $lfUeq = parcelRequire("lfUeq");
function $89ea5d373ae096bf$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $89ea5d373ae096bf$var$q = "function" === typeof Object.is ? Object.is : $89ea5d373ae096bf$var$p, $89ea5d373ae096bf$var$r = $lfUeq.useSyncExternalStore, $89ea5d373ae096bf$var$t = $35jnV.useRef, $89ea5d373ae096bf$var$u = $35jnV.useEffect, $89ea5d373ae096bf$var$v = $35jnV.useMemo, $89ea5d373ae096bf$var$w = $35jnV.useDebugValue;
$89ea5d373ae096bf$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $89ea5d373ae096bf$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $89ea5d373ae096bf$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($89ea5d373ae096bf$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $89ea5d373ae096bf$var$r(a, c[0], c[1]);
    $89ea5d373ae096bf$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $89ea5d373ae096bf$var$w(d);
    return d;
};

});
parcelRequire.register("lfUeq", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8uhJ7"));

});
parcelRequire.register("8uhJ7", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $62dee03c612d9b1b$export$306c0aa65ff9ec16; }, function (v) { return $62dee03c612d9b1b$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $62dee03c612d9b1b$export$306c0aa65ff9ec16;
"use strict";

var $35jnV = parcelRequire("35jnV");
function $62dee03c612d9b1b$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $62dee03c612d9b1b$var$k = "function" === typeof Object.is ? Object.is : $62dee03c612d9b1b$var$h, $62dee03c612d9b1b$var$l = $35jnV.useState, $62dee03c612d9b1b$var$m = $35jnV.useEffect, $62dee03c612d9b1b$var$n = $35jnV.useLayoutEffect, $62dee03c612d9b1b$var$p = $35jnV.useDebugValue;
function $62dee03c612d9b1b$var$q(a, b) {
    var d = b(), f = $62dee03c612d9b1b$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $62dee03c612d9b1b$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $62dee03c612d9b1b$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $62dee03c612d9b1b$var$m(function() {
        $62dee03c612d9b1b$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $62dee03c612d9b1b$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $62dee03c612d9b1b$var$p(d);
    return d;
}
function $62dee03c612d9b1b$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$62dee03c612d9b1b$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $62dee03c612d9b1b$var$t(a, b) {
    return b();
}
var $62dee03c612d9b1b$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $62dee03c612d9b1b$var$t : $62dee03c612d9b1b$var$q;
$62dee03c612d9b1b$export$306c0aa65ff9ec16 = void 0 !== $35jnV.useSyncExternalStore ? $35jnV.useSyncExternalStore : $62dee03c612d9b1b$var$u;

});



parcelRequire.register("2jyxe", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5gNfQ.default;
    }
});

var $5gNfQ = parcelRequire("5gNfQ");

});
parcelRequire.register("5gNfQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d64a750f3ccf59c$export$2e2bcd8739ae039; });

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");

var $jXkA8 = parcelRequire("jXkA8");

var $86rqb = parcelRequire("86rqb");
"use client";
function $3d64a750f3ccf59c$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $86rqb.jsx)((0, $jXkA8.default), (0, $lfXYn.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $jXkA8.default).muiName;
    return /*#__PURE__*/ $35jnV.memo(/*#__PURE__*/ $35jnV.forwardRef(Component));
}

});
parcelRequire.register("lfXYn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7998509993d1e1b$export$2e2bcd8739ae039; });
function $f7998509993d1e1b$export$2e2bcd8739ae039() {
    $f7998509993d1e1b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f7998509993d1e1b$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("jXkA8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8737e1d4bd246bf$export$2e2bcd8739ae039; });

var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");

var $1OAmh = parcelRequire("1OAmh");

var $hZybU = parcelRequire("hZybU");

var $jBVCU = parcelRequire("jBVCU");

var $4htP9 = parcelRequire("4htP9");

var $86rqb = parcelRequire("86rqb");
"use client";
const $e8737e1d4bd246bf$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $e8737e1d4bd246bf$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $1OAmh.default)(color)}`,
            `fontSize${(0, $1OAmh.default)(fontSize)}`
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $4htP9.getSvgIconUtilityClass), classes);
};
const $e8737e1d4bd246bf$var$SvgIconRoot = (0, $jBVCU.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $1OAmh.default)(ownerState.color)}`],
            styles[`fontSize${(0, $1OAmh.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $e8737e1d4bd246bf$var$SvgIcon = /*#__PURE__*/ $35jnV.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $5NWw9.default)(props, $e8737e1d4bd246bf$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $35jnV.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $lfXYn.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $e8737e1d4bd246bf$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsxs)($e8737e1d4bd246bf$var$SvgIconRoot, (0, $lfXYn.default)({
        as: component,
        className: (0, $3eTha.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $86rqb.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$e8737e1d4bd246bf$var$SvgIcon.muiName = "SvgIcon";
var $e8737e1d4bd246bf$export$2e2bcd8739ae039 = $e8737e1d4bd246bf$var$SvgIcon;

});
parcelRequire.register("5NWw9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $439eebb69e5d9be6$export$2e2bcd8739ae039; });
function $439eebb69e5d9be6$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRequire.register("3eTha", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4f047bce87308db$export$2e2bcd8739ae039; });
function $e4f047bce87308db$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $e4f047bce87308db$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $e4f047bce87308db$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $e4f047bce87308db$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $e4f047bce87308db$export$2e2bcd8739ae039 = $e4f047bce87308db$export$4f5d2d50c9deca37;

});

parcelRequire.register("5wpQH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4053fdff516297ed$export$2e2bcd8739ae039; });
function $4053fdff516297ed$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRequire.register("1OAmh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1526a9f167241578$export$2e2bcd8739ae039; });

var $7uiwM = parcelRequire("7uiwM");
var $1526a9f167241578$export$2e2bcd8739ae039 = (0, $7uiwM.default);

});
parcelRequire.register("7uiwM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5739b4f16d1ca06c$export$2e2bcd8739ae039; });

var $5r8Xx = parcelRequire("5r8Xx");
function $5739b4f16d1ca06c$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $5r8Xx.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRequire.register("5r8Xx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f566c79ba08e58d$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $3f566c79ba08e58d$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRequire.register("hZybU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d192a7cf5bc1d948$export$2e2bcd8739ae039; });

var $lBa3O = parcelRequire("lBa3O");

var $ghZ9O = parcelRequire("ghZ9O");

var $l5DLo = parcelRequire("l5DLo");
"use client";
function $d192a7cf5bc1d948$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $lBa3O.default)({
        props: props,
        name: name,
        defaultTheme: $ghZ9O.default,
        themeId: (0, $l5DLo.default)
    });
}

});
parcelRequire.register("lBa3O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb94db7f46538b72$export$2e2bcd8739ae039; });

var $ht9jn = parcelRequire("ht9jn");

var $lfge4 = parcelRequire("lfge4");
"use client";
function $fb94db7f46538b72$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $lfge4.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $ht9jn.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRequire.register("ht9jn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb7c5e2865b19b88$export$2e2bcd8739ae039; });

var $ircER = parcelRequire("ircER");
function $cb7c5e2865b19b88$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $ircER.default)(theme.components[name].defaultProps, props);
}

});
parcelRequire.register("ircER", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6c4913fab779519$export$2e2bcd8739ae039; });

var $lfXYn = parcelRequire("lfXYn");
function $d6c4913fab779519$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $lfXYn.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $lfXYn.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $lfXYn.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $d6c4913fab779519$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRequire.register("lfge4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f77795d242780ddd$export$2e2bcd8739ae039; });

var $6Ux7a = parcelRequire("6Ux7a");

var $kfqtZ = parcelRequire("kfqtZ");
"use client";
const $f77795d242780ddd$export$35e57303dbd8a66 = (0, $6Ux7a.default)();
function $f77795d242780ddd$var$useTheme(defaultTheme = $f77795d242780ddd$export$35e57303dbd8a66) {
    return (0, $kfqtZ.default)(defaultTheme);
}
var $f77795d242780ddd$export$2e2bcd8739ae039 = $f77795d242780ddd$var$useTheme;

});
parcelRequire.register("6Ux7a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5081a8ecaab7924d$export$2e2bcd8739ae039; });

var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $a2Szr = parcelRequire("a2Szr");

var $3lVPy = parcelRequire("3lVPy");

var $5GWKB = parcelRequire("5GWKB");

var $hvIIn = parcelRequire("hvIIn");

var $dm2f8 = parcelRequire("dm2f8");

var $d2FKK = parcelRequire("d2FKK");
const $5081a8ecaab7924d$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $5081a8ecaab7924d$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $5NWw9.default)(options, $5081a8ecaab7924d$var$_excluded);
    const breakpoints = (0, $3lVPy.default)(breakpointsInput);
    const spacing = (0, $hvIIn.default)(spacingInput);
    let muiTheme = (0, $a2Szr.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $lfXYn.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $lfXYn.default)({}, (0, $5GWKB.default), shapeInput)
    }, other);
    muiTheme = args.reduce((acc, argument)=>(0, $a2Szr.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $lfXYn.default)({}, (0, $d2FKK.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $dm2f8.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $5081a8ecaab7924d$export$2e2bcd8739ae039 = $5081a8ecaab7924d$var$createTheme;

});
parcelRequire.register("a2Szr", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $75046be4b99c4b1f$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $75046be4b99c4b1f$export$2e2bcd8739ae039; });

var $lfXYn = parcelRequire("lfXYn");
function $75046be4b99c4b1f$export$53b83ca8eaab0383(item) {
    return item !== null && typeof item === "object" && item.constructor === Object;
}
function $75046be4b99c4b1f$var$deepClone(source) {
    if (!$75046be4b99c4b1f$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $75046be4b99c4b1f$var$deepClone(source[key]);
    });
    return output;
}
function $75046be4b99c4b1f$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $lfXYn.default)({}, target) : target;
    if ($75046be4b99c4b1f$export$53b83ca8eaab0383(target) && $75046be4b99c4b1f$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($75046be4b99c4b1f$export$53b83ca8eaab0383(source[key]) && key in target && $75046be4b99c4b1f$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $75046be4b99c4b1f$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $75046be4b99c4b1f$export$53b83ca8eaab0383(source[key]) ? $75046be4b99c4b1f$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRequire.register("3lVPy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2710312e1d585c08$export$2e2bcd8739ae039; });

var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");
const $2710312e1d585c08$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $2710312e1d585c08$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $2710312e1d585c08$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $lfXYn.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $2710312e1d585c08$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $5NWw9.default)(breakpoints, $2710312e1d585c08$var$_excluded);
    const sortedValues = $2710312e1d585c08$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $lfXYn.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRequire.register("5GWKB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $424e72a89a81600a$export$2e2bcd8739ae039; });
const $424e72a89a81600a$var$shape = {
    borderRadius: 4
};
var $424e72a89a81600a$export$2e2bcd8739ae039 = $424e72a89a81600a$var$shape;

});

parcelRequire.register("hvIIn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbf80459809248cc$export$2e2bcd8739ae039; });

var $1fDcG = parcelRequire("1fDcG");
function $cbf80459809248cc$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $1fDcG.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRequire.register("1fDcG", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $0e959a3032ec8354$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $0e959a3032ec8354$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $0e959a3032ec8354$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $0e959a3032ec8354$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $0e959a3032ec8354$export$6f98e8eaf0be1996; });


var $GqBeq = parcelRequire("GqBeq");

var $6CWsN = parcelRequire("6CWsN");

var $heYVA = parcelRequire("heYVA");

var $7rI2q = parcelRequire("7rI2q");
const $0e959a3032ec8354$var$properties = {
    m: "margin",
    p: "padding"
};
const $0e959a3032ec8354$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $0e959a3032ec8354$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $0e959a3032ec8354$var$getCssProperties = (0, $7rI2q.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($0e959a3032ec8354$var$aliases[prop]) prop = $0e959a3032ec8354$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $0e959a3032ec8354$var$properties[a];
    const direction = $0e959a3032ec8354$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $0e959a3032ec8354$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $0e959a3032ec8354$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $0e959a3032ec8354$var$spacingKeys = [
    ...$0e959a3032ec8354$export$aab52a0dde05ad8a,
    ...$0e959a3032ec8354$export$f8397d44f03ab6ad
];
function $0e959a3032ec8354$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $6CWsN.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $0e959a3032ec8354$export$1def6f833384e3d1(theme) {
    return $0e959a3032ec8354$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $0e959a3032ec8354$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $0e959a3032ec8354$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $0e959a3032ec8354$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $0e959a3032ec8354$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $0e959a3032ec8354$var$getCssProperties(prop);
    const styleFromPropValue = $0e959a3032ec8354$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $GqBeq.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $0e959a3032ec8354$var$style(props, keys) {
    const transformer = $0e959a3032ec8354$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$0e959a3032ec8354$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $heYVA.default), {});
}
function $0e959a3032ec8354$export$7ede87f9b603dd3c(props) {
    return $0e959a3032ec8354$var$style(props, $0e959a3032ec8354$export$aab52a0dde05ad8a);
}
$0e959a3032ec8354$export$7ede87f9b603dd3c.propTypes = {};
$0e959a3032ec8354$export$7ede87f9b603dd3c.filterProps = $0e959a3032ec8354$export$aab52a0dde05ad8a;
function $0e959a3032ec8354$export$6f98e8eaf0be1996(props) {
    return $0e959a3032ec8354$var$style(props, $0e959a3032ec8354$export$f8397d44f03ab6ad);
}
$0e959a3032ec8354$export$6f98e8eaf0be1996.propTypes = {};
$0e959a3032ec8354$export$6f98e8eaf0be1996.filterProps = $0e959a3032ec8354$export$f8397d44f03ab6ad;
function $0e959a3032ec8354$var$spacing(props) {
    return $0e959a3032ec8354$var$style(props, $0e959a3032ec8354$var$spacingKeys);
}
$0e959a3032ec8354$var$spacing.propTypes = {};
$0e959a3032ec8354$var$spacing.filterProps = $0e959a3032ec8354$var$spacingKeys;
var $0e959a3032ec8354$export$2e2bcd8739ae039 = $0e959a3032ec8354$var$spacing;

});
parcelRequire.register("GqBeq", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $07f88e77ae19a146$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $07f88e77ae19a146$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $07f88e77ae19a146$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $07f88e77ae19a146$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $07f88e77ae19a146$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $07f88e77ae19a146$export$980e6a259d807490; });

var $lfXYn = parcelRequire("lfXYn");


var $a2Szr = parcelRequire("a2Szr");

var $heYVA = parcelRequire("heYVA");
const $07f88e77ae19a146$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $07f88e77ae19a146$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$07f88e77ae19a146$export$68c286be0e7e55b7[key]}px)`
};
function $07f88e77ae19a146$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $07f88e77ae19a146$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $07f88e77ae19a146$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $07f88e77ae19a146$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $07f88e77ae19a146$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $07f88e77ae19a146$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $lfXYn.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $heYVA.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $07f88e77ae19a146$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $07f88e77ae19a146$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $07f88e77ae19a146$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $07f88e77ae19a146$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $a2Szr.default)(prev, next), {});
    return $07f88e77ae19a146$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $07f88e77ae19a146$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $07f88e77ae19a146$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $07f88e77ae19a146$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $07f88e77ae19a146$export$2e2bcd8739ae039 = $07f88e77ae19a146$var$breakpoints;

});
parcelRequire.register("heYVA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8d3017722329374$export$2e2bcd8739ae039; });

var $a2Szr = parcelRequire("a2Szr");
function $c8d3017722329374$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $a2Szr.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $c8d3017722329374$export$2e2bcd8739ae039 = $c8d3017722329374$var$merge;

});


parcelRequire.register("6CWsN", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $4d33a44cb7ef5fd6$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $4d33a44cb7ef5fd6$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $4d33a44cb7ef5fd6$export$2e2bcd8739ae039; });

var $7uiwM = parcelRequire("7uiwM");


var $GqBeq = parcelRequire("GqBeq");
function $4d33a44cb7ef5fd6$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $4d33a44cb7ef5fd6$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $4d33a44cb7ef5fd6$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $4d33a44cb7ef5fd6$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $4d33a44cb7ef5fd6$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $4d33a44cb7ef5fd6$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $4d33a44cb7ef5fd6$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $7uiwM.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $GqBeq.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $4d33a44cb7ef5fd6$export$2e2bcd8739ae039 = $4d33a44cb7ef5fd6$var$style;

});

parcelRequire.register("7rI2q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56bd371677549422$export$2e2bcd8739ae039; });
function $56bd371677549422$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRequire.register("dm2f8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b8f11deb65db61f$export$2e2bcd8739ae039; });

var $7uiwM = parcelRequire("7uiwM");

var $heYVA = parcelRequire("heYVA");

var $6CWsN = parcelRequire("6CWsN");

var $GqBeq = parcelRequire("GqBeq");

var $d2FKK = parcelRequire("d2FKK");
function $9b8f11deb65db61f$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $9b8f11deb65db61f$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $9b8f11deb65db61f$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $6CWsN.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $6CWsN.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $6CWsN.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $7uiwM.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $GqBeq.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $d2FKK.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $GqBeq.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $9b8f11deb65db61f$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $heYVA.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $GqBeq.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($9b8f11deb65db61f$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $heYVA.default)(css, breakpointsValues);
                        }
                    } else css = (0, $heYVA.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $GqBeq.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $9b8f11deb65db61f$var$styleFunctionSx = $9b8f11deb65db61f$export$7d53d8bf2911e013();
$9b8f11deb65db61f$var$styleFunctionSx.filterProps = [
    "sx"
];
var $9b8f11deb65db61f$export$2e2bcd8739ae039 = $9b8f11deb65db61f$var$styleFunctionSx;

});
parcelRequire.register("d2FKK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97ebd98e676f02d7$export$2e2bcd8739ae039; });

var $1fDcG = parcelRequire("1fDcG");

var $euTd8 = parcelRequire("euTd8");

var $eDALi = parcelRequire("eDALi");

var $8qi3o = parcelRequire("8qi3o");

var $hp5Ar = parcelRequire("hp5Ar");
const $97ebd98e676f02d7$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $euTd8.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $euTd8.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $euTd8.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $euTd8.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $euTd8.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $euTd8.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $8qi3o.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $8qi3o.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $8qi3o.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $1fDcG.padding)
    },
    pt: {
        style: (0, $1fDcG.padding)
    },
    pr: {
        style: (0, $1fDcG.padding)
    },
    pb: {
        style: (0, $1fDcG.padding)
    },
    pl: {
        style: (0, $1fDcG.padding)
    },
    px: {
        style: (0, $1fDcG.padding)
    },
    py: {
        style: (0, $1fDcG.padding)
    },
    padding: {
        style: (0, $1fDcG.padding)
    },
    paddingTop: {
        style: (0, $1fDcG.padding)
    },
    paddingRight: {
        style: (0, $1fDcG.padding)
    },
    paddingBottom: {
        style: (0, $1fDcG.padding)
    },
    paddingLeft: {
        style: (0, $1fDcG.padding)
    },
    paddingX: {
        style: (0, $1fDcG.padding)
    },
    paddingY: {
        style: (0, $1fDcG.padding)
    },
    paddingInline: {
        style: (0, $1fDcG.padding)
    },
    paddingInlineStart: {
        style: (0, $1fDcG.padding)
    },
    paddingInlineEnd: {
        style: (0, $1fDcG.padding)
    },
    paddingBlock: {
        style: (0, $1fDcG.padding)
    },
    paddingBlockStart: {
        style: (0, $1fDcG.padding)
    },
    paddingBlockEnd: {
        style: (0, $1fDcG.padding)
    },
    m: {
        style: (0, $1fDcG.margin)
    },
    mt: {
        style: (0, $1fDcG.margin)
    },
    mr: {
        style: (0, $1fDcG.margin)
    },
    mb: {
        style: (0, $1fDcG.margin)
    },
    ml: {
        style: (0, $1fDcG.margin)
    },
    mx: {
        style: (0, $1fDcG.margin)
    },
    my: {
        style: (0, $1fDcG.margin)
    },
    margin: {
        style: (0, $1fDcG.margin)
    },
    marginTop: {
        style: (0, $1fDcG.margin)
    },
    marginRight: {
        style: (0, $1fDcG.margin)
    },
    marginBottom: {
        style: (0, $1fDcG.margin)
    },
    marginLeft: {
        style: (0, $1fDcG.margin)
    },
    marginX: {
        style: (0, $1fDcG.margin)
    },
    marginY: {
        style: (0, $1fDcG.margin)
    },
    marginInline: {
        style: (0, $1fDcG.margin)
    },
    marginInlineStart: {
        style: (0, $1fDcG.margin)
    },
    marginInlineEnd: {
        style: (0, $1fDcG.margin)
    },
    marginBlock: {
        style: (0, $1fDcG.margin)
    },
    marginBlockStart: {
        style: (0, $1fDcG.margin)
    },
    marginBlockEnd: {
        style: (0, $1fDcG.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $eDALi.gap)
    },
    rowGap: {
        style: (0, $eDALi.rowGap)
    },
    columnGap: {
        style: (0, $eDALi.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $hp5Ar.sizingTransform)
    },
    maxWidth: {
        style: (0, $hp5Ar.maxWidth)
    },
    minWidth: {
        transform: (0, $hp5Ar.sizingTransform)
    },
    height: {
        transform: (0, $hp5Ar.sizingTransform)
    },
    maxHeight: {
        transform: (0, $hp5Ar.sizingTransform)
    },
    minHeight: {
        transform: (0, $hp5Ar.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $97ebd98e676f02d7$export$2e2bcd8739ae039 = $97ebd98e676f02d7$var$defaultSxConfig;

});
parcelRequire.register("euTd8", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $a8deb1bb57e934ff$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $a8deb1bb57e934ff$export$7a57f79000377ca2; });


var $6CWsN = parcelRequire("6CWsN");

var $65bG0 = parcelRequire("65bG0");

var $1fDcG = parcelRequire("1fDcG");

var $GqBeq = parcelRequire("GqBeq");
function $a8deb1bb57e934ff$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
const $a8deb1bb57e934ff$export$1edee58a52776cd9 = (0, $6CWsN.default)({
    prop: "border",
    themeKey: "borders",
    transform: $a8deb1bb57e934ff$export$34e2febe53ae29cc
});
const $a8deb1bb57e934ff$export$f9a7b6bd24892946 = (0, $6CWsN.default)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $a8deb1bb57e934ff$export$34e2febe53ae29cc
});
const $a8deb1bb57e934ff$export$5abca33e6be905d2 = (0, $6CWsN.default)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $a8deb1bb57e934ff$export$34e2febe53ae29cc
});
const $a8deb1bb57e934ff$export$e2ce9f12a980a822 = (0, $6CWsN.default)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $a8deb1bb57e934ff$export$34e2febe53ae29cc
});
const $a8deb1bb57e934ff$export$47658cca1a909427 = (0, $6CWsN.default)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $a8deb1bb57e934ff$export$34e2febe53ae29cc
});
const $a8deb1bb57e934ff$export$e7fb0694ba2404fc = (0, $6CWsN.default)({
    prop: "borderColor",
    themeKey: "palette"
});
const $a8deb1bb57e934ff$export$126a92c968acdb85 = (0, $6CWsN.default)({
    prop: "borderTopColor",
    themeKey: "palette"
});
const $a8deb1bb57e934ff$export$85cc51cb8fbb8c0e = (0, $6CWsN.default)({
    prop: "borderRightColor",
    themeKey: "palette"
});
const $a8deb1bb57e934ff$export$340b0327727f6d1a = (0, $6CWsN.default)({
    prop: "borderBottomColor",
    themeKey: "palette"
});
const $a8deb1bb57e934ff$export$60beef91a985b4bf = (0, $6CWsN.default)({
    prop: "borderLeftColor",
    themeKey: "palette"
});
const $a8deb1bb57e934ff$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $1fDcG.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $1fDcG.getValue)(transformer, propValue)
            });
        return (0, $GqBeq.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$a8deb1bb57e934ff$export$7a57f79000377ca2.propTypes = {};
$a8deb1bb57e934ff$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $a8deb1bb57e934ff$var$borders = (0, $65bG0.default)($a8deb1bb57e934ff$export$1edee58a52776cd9, $a8deb1bb57e934ff$export$f9a7b6bd24892946, $a8deb1bb57e934ff$export$5abca33e6be905d2, $a8deb1bb57e934ff$export$e2ce9f12a980a822, $a8deb1bb57e934ff$export$47658cca1a909427, $a8deb1bb57e934ff$export$e7fb0694ba2404fc, $a8deb1bb57e934ff$export$126a92c968acdb85, $a8deb1bb57e934ff$export$85cc51cb8fbb8c0e, $a8deb1bb57e934ff$export$340b0327727f6d1a, $a8deb1bb57e934ff$export$60beef91a985b4bf, $a8deb1bb57e934ff$export$7a57f79000377ca2);
var $a8deb1bb57e934ff$export$2e2bcd8739ae039 = $a8deb1bb57e934ff$var$borders;

});
parcelRequire.register("65bG0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46dc4468ff4bc505$export$2e2bcd8739ae039; });

var $heYVA = parcelRequire("heYVA");
function $46dc4468ff4bc505$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $heYVA.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $46dc4468ff4bc505$export$2e2bcd8739ae039 = $46dc4468ff4bc505$var$compose;

});


parcelRequire.register("eDALi", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $aa81395defbe319b$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $aa81395defbe319b$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $aa81395defbe319b$export$8a833ffa5f5dbeda; });

var $6CWsN = parcelRequire("6CWsN");

var $65bG0 = parcelRequire("65bG0");

var $1fDcG = parcelRequire("1fDcG");

var $GqBeq = parcelRequire("GqBeq");

const $aa81395defbe319b$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $1fDcG.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $1fDcG.getValue)(transformer, propValue)
            });
        return (0, $GqBeq.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$aa81395defbe319b$export$5df9adcb0db95e1e.propTypes = {};
$aa81395defbe319b$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $aa81395defbe319b$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $1fDcG.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $1fDcG.getValue)(transformer, propValue)
            });
        return (0, $GqBeq.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$aa81395defbe319b$export$ec60d70ff941a580.propTypes = {};
$aa81395defbe319b$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $aa81395defbe319b$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $1fDcG.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $1fDcG.getValue)(transformer, propValue)
            });
        return (0, $GqBeq.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$aa81395defbe319b$export$8a833ffa5f5dbeda.propTypes = {};
$aa81395defbe319b$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $aa81395defbe319b$export$baf44164ca3a34e8 = (0, $6CWsN.default)({
    prop: "gridColumn"
});
const $aa81395defbe319b$export$8f7213a1cd01e832 = (0, $6CWsN.default)({
    prop: "gridRow"
});
const $aa81395defbe319b$export$b0e0abbc49ba668 = (0, $6CWsN.default)({
    prop: "gridAutoFlow"
});
const $aa81395defbe319b$export$bcd8b929d4b4142 = (0, $6CWsN.default)({
    prop: "gridAutoColumns"
});
const $aa81395defbe319b$export$e5039a674e14c828 = (0, $6CWsN.default)({
    prop: "gridAutoRows"
});
const $aa81395defbe319b$export$42bd9088661ffb03 = (0, $6CWsN.default)({
    prop: "gridTemplateColumns"
});
const $aa81395defbe319b$export$920682ae05b999bc = (0, $6CWsN.default)({
    prop: "gridTemplateRows"
});
const $aa81395defbe319b$export$1b88fbdd482fd33a = (0, $6CWsN.default)({
    prop: "gridTemplateAreas"
});
const $aa81395defbe319b$export$bdb486e40d52d26f = (0, $6CWsN.default)({
    prop: "gridArea"
});
const $aa81395defbe319b$var$grid = (0, $65bG0.default)($aa81395defbe319b$export$5df9adcb0db95e1e, $aa81395defbe319b$export$ec60d70ff941a580, $aa81395defbe319b$export$8a833ffa5f5dbeda, $aa81395defbe319b$export$baf44164ca3a34e8, $aa81395defbe319b$export$8f7213a1cd01e832, $aa81395defbe319b$export$b0e0abbc49ba668, $aa81395defbe319b$export$bcd8b929d4b4142, $aa81395defbe319b$export$e5039a674e14c828, $aa81395defbe319b$export$42bd9088661ffb03, $aa81395defbe319b$export$920682ae05b999bc, $aa81395defbe319b$export$1b88fbdd482fd33a, $aa81395defbe319b$export$bdb486e40d52d26f);
var $aa81395defbe319b$export$2e2bcd8739ae039 = $aa81395defbe319b$var$grid;

});

parcelRequire.register("8qi3o", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $621ec189a088b5e1$export$dbaffd4420ea0ac6; });

var $6CWsN = parcelRequire("6CWsN");

var $65bG0 = parcelRequire("65bG0");
function $621ec189a088b5e1$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $621ec189a088b5e1$export$35e9368ef982300f = (0, $6CWsN.default)({
    prop: "color",
    themeKey: "palette",
    transform: $621ec189a088b5e1$export$dbaffd4420ea0ac6
});
const $621ec189a088b5e1$export$2506f56c10355b33 = (0, $6CWsN.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $621ec189a088b5e1$export$dbaffd4420ea0ac6
});
const $621ec189a088b5e1$export$8c5a050822fd698c = (0, $6CWsN.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $621ec189a088b5e1$export$dbaffd4420ea0ac6
});
const $621ec189a088b5e1$var$palette = (0, $65bG0.default)($621ec189a088b5e1$export$35e9368ef982300f, $621ec189a088b5e1$export$2506f56c10355b33, $621ec189a088b5e1$export$8c5a050822fd698c);
var $621ec189a088b5e1$export$2e2bcd8739ae039 = $621ec189a088b5e1$var$palette;

});

parcelRequire.register("hp5Ar", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $cab91ae1319035f9$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $cab91ae1319035f9$export$488fda99655ff65a; });

var $6CWsN = parcelRequire("6CWsN");

var $65bG0 = parcelRequire("65bG0");

var $GqBeq = parcelRequire("GqBeq");
function $cab91ae1319035f9$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $cab91ae1319035f9$export$7e3df82ee760448c = (0, $6CWsN.default)({
    prop: "width",
    transform: $cab91ae1319035f9$export$8afece71750ec241
});
const $cab91ae1319035f9$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $GqBeq.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $cab91ae1319035f9$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $GqBeq.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$cab91ae1319035f9$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $cab91ae1319035f9$export$ee148fbbe8357dd2 = (0, $6CWsN.default)({
    prop: "minWidth",
    transform: $cab91ae1319035f9$export$8afece71750ec241
});
const $cab91ae1319035f9$export$ac607276a8fe9f0a = (0, $6CWsN.default)({
    prop: "height",
    transform: $cab91ae1319035f9$export$8afece71750ec241
});
const $cab91ae1319035f9$export$dc0d8bd0b94f8570 = (0, $6CWsN.default)({
    prop: "maxHeight",
    transform: $cab91ae1319035f9$export$8afece71750ec241
});
const $cab91ae1319035f9$export$a43cf604e12f3b17 = (0, $6CWsN.default)({
    prop: "minHeight",
    transform: $cab91ae1319035f9$export$8afece71750ec241
});
const $cab91ae1319035f9$export$ffed9f14fb65e276 = (0, $6CWsN.default)({
    prop: "size",
    cssProperty: "width",
    transform: $cab91ae1319035f9$export$8afece71750ec241
});
const $cab91ae1319035f9$export$905076ed6620e671 = (0, $6CWsN.default)({
    prop: "size",
    cssProperty: "height",
    transform: $cab91ae1319035f9$export$8afece71750ec241
});
const $cab91ae1319035f9$export$6ccc93f785106a58 = (0, $6CWsN.default)({
    prop: "boxSizing"
});
const $cab91ae1319035f9$var$sizing = (0, $65bG0.default)($cab91ae1319035f9$export$7e3df82ee760448c, $cab91ae1319035f9$export$488fda99655ff65a, $cab91ae1319035f9$export$ee148fbbe8357dd2, $cab91ae1319035f9$export$ac607276a8fe9f0a, $cab91ae1319035f9$export$dc0d8bd0b94f8570, $cab91ae1319035f9$export$a43cf604e12f3b17, $cab91ae1319035f9$export$6ccc93f785106a58);
var $cab91ae1319035f9$export$2e2bcd8739ae039 = $cab91ae1319035f9$var$sizing;

});




parcelRequire.register("kfqtZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebd9c0451927bc3a$export$2e2bcd8739ae039; });

var $35jnV = parcelRequire("35jnV");
parcelRequire("UnJZz");
var $liH5y = parcelRequire("liH5y");
"use client";
function $ebd9c0451927bc3a$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $ebd9c0451927bc3a$var$useTheme(defaultTheme = null) {
    const contextTheme = $35jnV.useContext((0, $liH5y.T));
    return !contextTheme || $ebd9c0451927bc3a$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $ebd9c0451927bc3a$export$2e2bcd8739ae039 = $ebd9c0451927bc3a$var$useTheme;

});
parcelRequire.register("UnJZz", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $0a97a581d0798c6c$export$98f03c5d19621d70; });
$parcel$export(module.exports, "keyframes", function () { return $0a97a581d0798c6c$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("liH5y")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("liH5y")).w; });

var $liH5y = parcelRequire("liH5y");

var $35jnV = parcelRequire("35jnV");

var $2QrJk = parcelRequire("2QrJk");

var $gedI2 = parcelRequire("gedI2");

var $5dZtc = parcelRequire("5dZtc");
parcelRequire("hTDq9");
parcelRequire("8BDNn");
parcelRequire("kjTqK");

parcelRequire("0nlaF");
var $0a97a581d0798c6c$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $0a97a581d0798c6c$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $liH5y.h).call(props, "css")) // $FlowFixMe
    return $35jnV.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $liH5y.E);
    createElementArgArray[1] = (0, $liH5y.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $35jnV.createElement.apply(null, createElementArgArray);
};
var $0a97a581d0798c6c$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $0a97a581d0798c6c$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $liH5y.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $5dZtc.serializeStyles)([
        styles
    ], undefined, $35jnV.useContext((0, $liH5y.T)));
    if (!(0, $liH5y.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $35jnV.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $35jnV.useRef();
    (0, $gedI2.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $gedI2.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $2QrJk.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $0a97a581d0798c6c$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $5dZtc.serializeStyles)(args);
}
var $0a97a581d0798c6c$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $0a97a581d0798c6c$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $0a97a581d0798c6c$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $0a97a581d0798c6c$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $2QrJk.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $0a97a581d0798c6c$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $gedI2.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $2QrJk.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $0a97a581d0798c6c$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $liH5y.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $5dZtc.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $2QrJk.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $0a97a581d0798c6c$var$merge(cache.registered, css, $0a97a581d0798c6c$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $35jnV.useContext((0, $liH5y.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $35jnV.createElement($35jnV.Fragment, null, /*#__PURE__*/ $35jnV.createElement($0a97a581d0798c6c$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $0a97a581d0798c6c$var$isBrowser, $0a97a581d0798c6c$var$isTestEnv, $0a97a581d0798c6c$var$globalContext, $0a97a581d0798c6c$var$globalKey;

});
parcelRequire.register("liH5y", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $f81cb3ec0e2beb44$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $f81cb3ec0e2beb44$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "w", function () { return $f81cb3ec0e2beb44$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $f81cb3ec0e2beb44$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $f81cb3ec0e2beb44$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $f81cb3ec0e2beb44$export$a9c23c6ac3fc3eca; });

var $35jnV = parcelRequire("35jnV");

var $hTDq9 = parcelRequire("hTDq9");

var $lfXYn = parcelRequire("lfXYn");

var $kjTqK = parcelRequire("kjTqK");

var $4MZGq = parcelRequire("4MZGq");

var $2QrJk = parcelRequire("2QrJk");

var $5dZtc = parcelRequire("5dZtc");

var $gedI2 = parcelRequire("gedI2");
var $f81cb3ec0e2beb44$export$23f2a1d2818174ef = true;
var $f81cb3ec0e2beb44$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $f81cb3ec0e2beb44$var$EmotionCacheContext = /* #__PURE__ */ $35jnV.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $hTDq9.default)({
    key: "css"
}) : null);
var $f81cb3ec0e2beb44$export$e7094788287c5e9b = $f81cb3ec0e2beb44$var$EmotionCacheContext.Provider;
var $f81cb3ec0e2beb44$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $35jnV.useContext)($f81cb3ec0e2beb44$var$EmotionCacheContext);
};
var $f81cb3ec0e2beb44$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $35jnV.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $35jnV.useContext)($f81cb3ec0e2beb44$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$f81cb3ec0e2beb44$export$23f2a1d2818174ef) $f81cb3ec0e2beb44$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $35jnV.useContext)($f81cb3ec0e2beb44$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $hTDq9.default)({
                key: "css"
            });
            return /*#__PURE__*/ $35jnV.createElement($f81cb3ec0e2beb44$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $f81cb3ec0e2beb44$export$971d5caa766a69d7 = /* #__PURE__ */ $35jnV.createContext({});
var $f81cb3ec0e2beb44$export$3b14a55fb2447963 = function useTheme() {
    return $35jnV.useContext($f81cb3ec0e2beb44$export$971d5caa766a69d7);
};
var $f81cb3ec0e2beb44$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $lfXYn.default)({}, outerTheme, theme);
};
var $f81cb3ec0e2beb44$var$createCacheWithTheme = /* #__PURE__ */ (0, $kjTqK.default)(function(outerTheme) {
    return (0, $kjTqK.default)(function(theme) {
        return $f81cb3ec0e2beb44$var$getTheme(outerTheme, theme);
    });
});
var $f81cb3ec0e2beb44$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $35jnV.useContext($f81cb3ec0e2beb44$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $f81cb3ec0e2beb44$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $35jnV.createElement($f81cb3ec0e2beb44$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $f81cb3ec0e2beb44$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $35jnV.useContext($f81cb3ec0e2beb44$export$971d5caa766a69d7);
        return /*#__PURE__*/ $35jnV.createElement(Component, (0, $lfXYn.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $35jnV.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $4MZGq.default)(WithTheme, Component);
}
var $f81cb3ec0e2beb44$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $f81cb3ec0e2beb44$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $f81cb3ec0e2beb44$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $f81cb3ec0e2beb44$var$getLastPart(match[1]);
    return undefined;
};
var $f81cb3ec0e2beb44$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $f81cb3ec0e2beb44$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $f81cb3ec0e2beb44$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $f81cb3ec0e2beb44$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($f81cb3ec0e2beb44$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $f81cb3ec0e2beb44$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $f81cb3ec0e2beb44$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $f81cb3ec0e2beb44$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $f81cb3ec0e2beb44$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($f81cb3ec0e2beb44$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$f81cb3ec0e2beb44$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $f81cb3ec0e2beb44$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $2QrJk.registerStyles)(cache, serialized, isStringTag);
    (0, $gedI2.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $2QrJk.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $f81cb3ec0e2beb44$var$Emotion = /* #__PURE__ */ $f81cb3ec0e2beb44$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$f81cb3ec0e2beb44$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $2QrJk.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $5dZtc.serializeStyles)(registeredStyles, undefined, $35jnV.useContext($f81cb3ec0e2beb44$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($f81cb3ec0e2beb44$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $f81cb3ec0e2beb44$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $35jnV.createElement($35jnV.Fragment, null, /*#__PURE__*/ $35jnV.createElement($f81cb3ec0e2beb44$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $35jnV.createElement(WrappedComponent, newProps));
});
var $f81cb3ec0e2beb44$export$a9c23c6ac3fc3eca = $f81cb3ec0e2beb44$var$Emotion;

});
parcelRequire.register("hTDq9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d07626e345a6d211$export$2e2bcd8739ae039; });

var $2dZAY = parcelRequire("2dZAY");

var $eFhBj = parcelRequire("eFhBj");
parcelRequire("kjTqK");
parcelRequire("61I3U");
var $d07626e345a6d211$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $eFhBj.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $eFhBj.token)(character)) break;
        (0, $eFhBj.next)();
    }
    return (0, $eFhBj.slice)(begin, (0, $eFhBj.position));
};
var $d07626e345a6d211$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $eFhBj.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $eFhBj.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $d07626e345a6d211$var$identifierWithPointTracking((0, $eFhBj.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $eFhBj.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $eFhBj.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $eFhBj.from)(character);
    }
    while (character = (0, $eFhBj.next)());
    return parsed;
};
var $d07626e345a6d211$var$getRules = function getRules(value, points) {
    return (0, $eFhBj.dealloc)($d07626e345a6d211$var$toRules((0, $eFhBj.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $d07626e345a6d211$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $d07626e345a6d211$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$d07626e345a6d211$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $d07626e345a6d211$var$fixedElements.set(element, true);
    var points = [];
    var rules = $d07626e345a6d211$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $d07626e345a6d211$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $d07626e345a6d211$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $d07626e345a6d211$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($d07626e345a6d211$var$ignoreFlag) > -1;
};
var $d07626e345a6d211$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($d07626e345a6d211$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $d07626e345a6d211$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $d07626e345a6d211$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$d07626e345a6d211$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $d07626e345a6d211$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $d07626e345a6d211$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$d07626e345a6d211$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $d07626e345a6d211$var$nullifyElement(element);
    } else if ($d07626e345a6d211$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $d07626e345a6d211$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $d07626e345a6d211$var$prefix(value, length) {
    switch((0, $eFhBj.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $eFhBj.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $eFhBj.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $eFhBj.WEBKIT) + value + (0, $eFhBj.MOZ) + value + (0, $eFhBj.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $eFhBj.WEBKIT) + value + (0, $eFhBj.MS) + value + value;
        // order
        case 6165:
            return (0, $eFhBj.WEBKIT) + value + (0, $eFhBj.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $eFhBj.WEBKIT) + value + (0, $eFhBj.replace)(value, /(\w+).+(:[^]+)/, (0, $eFhBj.WEBKIT) + "box-$1$2" + (0, $eFhBj.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $eFhBj.WEBKIT) + value + (0, $eFhBj.MS) + "flex-item-" + (0, $eFhBj.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $eFhBj.WEBKIT) + value + (0, $eFhBj.MS) + "flex-line-pack" + (0, $eFhBj.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $eFhBj.WEBKIT) + value + (0, $eFhBj.MS) + (0, $eFhBj.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $eFhBj.WEBKIT) + value + (0, $eFhBj.MS) + (0, $eFhBj.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $eFhBj.WEBKIT) + "box-" + (0, $eFhBj.replace)(value, "-grow", "") + (0, $eFhBj.WEBKIT) + value + (0, $eFhBj.MS) + (0, $eFhBj.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $eFhBj.WEBKIT) + (0, $eFhBj.replace)(value, /([^-])(transform)/g, "$1" + (0, $eFhBj.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $eFhBj.replace)((0, $eFhBj.replace)((0, $eFhBj.replace)(value, /(zoom-|grab)/, (0, $eFhBj.WEBKIT) + "$1"), /(image-set)/, (0, $eFhBj.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $eFhBj.replace)(value, /(image-set\([^]*)/, (0, $eFhBj.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $eFhBj.replace)((0, $eFhBj.replace)(value, /(.+:)(flex-)?(.*)/, (0, $eFhBj.WEBKIT) + "box-pack:$3" + (0, $eFhBj.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $eFhBj.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $eFhBj.replace)(value, /(.+)-inline(.+)/, (0, $eFhBj.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $eFhBj.strlen)(value) - 1 - length > 6) switch((0, $eFhBj.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $eFhBj.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $eFhBj.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $eFhBj.WEBKIT) + "$2-$3" + "$1" + (0, $eFhBj.MOZ) + ((0, $eFhBj.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $eFhBj.indexof)(value, "stretch") ? $d07626e345a6d211$var$prefix((0, $eFhBj.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $eFhBj.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $eFhBj.charat)(value, (0, $eFhBj.strlen)(value) - 3 - (~(0, $eFhBj.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $eFhBj.replace)(value, ":", ":" + (0, $eFhBj.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $eFhBj.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $eFhBj.WEBKIT) + ((0, $eFhBj.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $eFhBj.WEBKIT) + "$2$3" + "$1" + (0, $eFhBj.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $eFhBj.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $eFhBj.WEBKIT) + value + (0, $eFhBj.MS) + (0, $eFhBj.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $eFhBj.WEBKIT) + value + (0, $eFhBj.MS) + (0, $eFhBj.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $eFhBj.WEBKIT) + value + (0, $eFhBj.MS) + (0, $eFhBj.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $eFhBj.WEBKIT) + value + (0, $eFhBj.MS) + value + value;
    }
    return value;
}
var $d07626e345a6d211$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $eFhBj.DECLARATION:
                element["return"] = $d07626e345a6d211$var$prefix(element.value, element.length);
                break;
            case 0, $eFhBj.KEYFRAMES:
                return (0, $eFhBj.serialize)([
                    (0, $eFhBj.copy)(element, {
                        value: (0, $eFhBj.replace)(element.value, "@", "@" + (0, $eFhBj.WEBKIT))
                    })
                ], callback);
            case 0, $eFhBj.RULESET:
                if (element.length) return (0, $eFhBj.combine)(element.props, function(value) {
                    switch((0, $eFhBj.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $eFhBj.serialize)([
                                (0, $eFhBj.copy)(element, {
                                    props: [
                                        (0, $eFhBj.replace)(value, /:(read-\w+)/, ":" + (0, $eFhBj.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $eFhBj.serialize)([
                                (0, $eFhBj.copy)(element, {
                                    props: [
                                        (0, $eFhBj.replace)(value, /:(plac\w+)/, ":" + (0, $eFhBj.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $eFhBj.copy)(element, {
                                    props: [
                                        (0, $eFhBj.replace)(value, /:(plac\w+)/, ":" + (0, $eFhBj.MOZ) + "$1")
                                    ]
                                }),
                                (0, $eFhBj.copy)(element, {
                                    props: [
                                        (0, $eFhBj.replace)(value, /:(plac\w+)/, (0, $eFhBj.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $d07626e345a6d211$var$defaultStylisPlugins = [
    $d07626e345a6d211$var$prefixer
];
var $d07626e345a6d211$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $d07626e345a6d211$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $d07626e345a6d211$var$compat,
        $d07626e345a6d211$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $eFhBj.stringify),
        (0, $eFhBj.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $eFhBj.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $eFhBj.serialize)((0, $eFhBj.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $2dZAY.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRequire.register("2dZAY", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $19ec9338ce7ee4b0$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $19ec9338ce7ee4b0$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $19ec9338ce7ee4b0$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $19ec9338ce7ee4b0$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($19ec9338ce7ee4b0$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $19ec9338ce7ee4b0$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRequire.register("eFhBj", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $0fb38d8c0e179a73$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $0fb38d8c0e179a73$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $0fb38d8c0e179a73$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $0fb38d8c0e179a73$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $0fb38d8c0e179a73$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $0fb38d8c0e179a73$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $0fb38d8c0e179a73$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $0fb38d8c0e179a73$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $0fb38d8c0e179a73$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $0fb38d8c0e179a73$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $0fb38d8c0e179a73$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $0fb38d8c0e179a73$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $0fb38d8c0e179a73$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $0fb38d8c0e179a73$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $0fb38d8c0e179a73$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $0fb38d8c0e179a73$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $0fb38d8c0e179a73$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $0fb38d8c0e179a73$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $0fb38d8c0e179a73$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $0fb38d8c0e179a73$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $0fb38d8c0e179a73$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $0fb38d8c0e179a73$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $0fb38d8c0e179a73$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $0fb38d8c0e179a73$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $0fb38d8c0e179a73$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $0fb38d8c0e179a73$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $0fb38d8c0e179a73$export$38bcb760f1d4871c; });
var $0fb38d8c0e179a73$export$71ad59f2e432cfe8 = "-ms-";
var $0fb38d8c0e179a73$export$2c0f367103c8d01c = "-moz-";
var $0fb38d8c0e179a73$export$39dfd62a25e0fe93 = "-webkit-";
var $0fb38d8c0e179a73$export$a29989082612d0d9 = "comm";
var $0fb38d8c0e179a73$export$aa3a2e812ca8570d = "rule";
var $0fb38d8c0e179a73$export$527d108ccf083c2b = "decl";
var $0fb38d8c0e179a73$export$d3d35020fa5b54f0 = "@page";
var $0fb38d8c0e179a73$export$500415a86c544f73 = "@media";
var $0fb38d8c0e179a73$export$a763edbf796b780a = "@import";
var $0fb38d8c0e179a73$export$2790aeb8b4e5c826 = "@charset";
var $0fb38d8c0e179a73$export$1cc683e23b84b133 = "@viewport";
var $0fb38d8c0e179a73$export$9447a5efea57e862 = "@supports";
var $0fb38d8c0e179a73$export$ef011b4e114b1fba = "@document";
var $0fb38d8c0e179a73$export$6aad947bda0f3f46 = "@namespace";
var $0fb38d8c0e179a73$export$b44a8529a35fcb60 = "@keyframes";
var $0fb38d8c0e179a73$export$2c16de31893252e6 = "@font-face";
var $0fb38d8c0e179a73$export$3d846dd52e150c6f = "@counter-style";
var $0fb38d8c0e179a73$export$22314bfbb57653fe = "@font-feature-values";
var $0fb38d8c0e179a73$export$d773506282b3cfe6 = "@layer";
var $0fb38d8c0e179a73$export$2335f513bbd82c6d = Math.abs;
var $0fb38d8c0e179a73$export$6788812c4e6611e6 = String.fromCharCode;
var $0fb38d8c0e179a73$export$e6e34fd1f2686227 = Object.assign;
function $0fb38d8c0e179a73$export$d6af199866bfb566(e, r) {
    return $0fb38d8c0e179a73$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $0fb38d8c0e179a73$export$a9db5e087081082d(e, 0)) << 2 ^ $0fb38d8c0e179a73$export$a9db5e087081082d(e, 1)) << 2 ^ $0fb38d8c0e179a73$export$a9db5e087081082d(e, 2)) << 2 ^ $0fb38d8c0e179a73$export$a9db5e087081082d(e, 3) : 0;
}
function $0fb38d8c0e179a73$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $0fb38d8c0e179a73$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $0fb38d8c0e179a73$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $0fb38d8c0e179a73$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $0fb38d8c0e179a73$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $0fb38d8c0e179a73$export$36776f635604f274(e) {
    return e.length;
}
function $0fb38d8c0e179a73$export$f9084667e487ed46(e) {
    return e.length;
}
function $0fb38d8c0e179a73$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $0fb38d8c0e179a73$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $0fb38d8c0e179a73$export$53f1d5ea8de3d7c = 1;
var $0fb38d8c0e179a73$export$4e0c71f277ca26b3 = 1;
var $0fb38d8c0e179a73$export$f24224f1c91d8156 = 0;
var $0fb38d8c0e179a73$export$5880b8b5730aff45 = 0;
var $0fb38d8c0e179a73$export$c0306caf338ac095 = 0;
var $0fb38d8c0e179a73$export$30a86d91af8ff6e6 = "";
function $0fb38d8c0e179a73$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $0fb38d8c0e179a73$export$53f1d5ea8de3d7c,
        column: $0fb38d8c0e179a73$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $0fb38d8c0e179a73$export$784d13d8ee351f07(e, r) {
    return $0fb38d8c0e179a73$export$e6e34fd1f2686227($0fb38d8c0e179a73$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $0fb38d8c0e179a73$export$eba6f6f03b0a92e7() {
    return $0fb38d8c0e179a73$export$c0306caf338ac095;
}
function $0fb38d8c0e179a73$export$232faf9add678146() {
    $0fb38d8c0e179a73$export$c0306caf338ac095 = $0fb38d8c0e179a73$export$5880b8b5730aff45 > 0 ? $0fb38d8c0e179a73$export$a9db5e087081082d($0fb38d8c0e179a73$export$30a86d91af8ff6e6, --$0fb38d8c0e179a73$export$5880b8b5730aff45) : 0;
    if ($0fb38d8c0e179a73$export$4e0c71f277ca26b3--, $0fb38d8c0e179a73$export$c0306caf338ac095 === 10) $0fb38d8c0e179a73$export$4e0c71f277ca26b3 = 1, $0fb38d8c0e179a73$export$53f1d5ea8de3d7c--;
    return $0fb38d8c0e179a73$export$c0306caf338ac095;
}
function $0fb38d8c0e179a73$export$48cfd1e771a65c4f() {
    $0fb38d8c0e179a73$export$c0306caf338ac095 = $0fb38d8c0e179a73$export$5880b8b5730aff45 < $0fb38d8c0e179a73$export$f24224f1c91d8156 ? $0fb38d8c0e179a73$export$a9db5e087081082d($0fb38d8c0e179a73$export$30a86d91af8ff6e6, $0fb38d8c0e179a73$export$5880b8b5730aff45++) : 0;
    if ($0fb38d8c0e179a73$export$4e0c71f277ca26b3++, $0fb38d8c0e179a73$export$c0306caf338ac095 === 10) $0fb38d8c0e179a73$export$4e0c71f277ca26b3 = 1, $0fb38d8c0e179a73$export$53f1d5ea8de3d7c++;
    return $0fb38d8c0e179a73$export$c0306caf338ac095;
}
function $0fb38d8c0e179a73$export$4d3fb11e950abb9e() {
    return $0fb38d8c0e179a73$export$a9db5e087081082d($0fb38d8c0e179a73$export$30a86d91af8ff6e6, $0fb38d8c0e179a73$export$5880b8b5730aff45);
}
function $0fb38d8c0e179a73$export$e88cb2efb12ae807() {
    return $0fb38d8c0e179a73$export$5880b8b5730aff45;
}
function $0fb38d8c0e179a73$export$58adb3bec8346d0f(e, r) {
    return $0fb38d8c0e179a73$export$2f35ab04d2335697($0fb38d8c0e179a73$export$30a86d91af8ff6e6, e, r);
}
function $0fb38d8c0e179a73$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $0fb38d8c0e179a73$export$2de70f21292aac9e(e) {
    return $0fb38d8c0e179a73$export$53f1d5ea8de3d7c = $0fb38d8c0e179a73$export$4e0c71f277ca26b3 = 1, $0fb38d8c0e179a73$export$f24224f1c91d8156 = $0fb38d8c0e179a73$export$36776f635604f274($0fb38d8c0e179a73$export$30a86d91af8ff6e6 = e), $0fb38d8c0e179a73$export$5880b8b5730aff45 = 0, [];
}
function $0fb38d8c0e179a73$export$45918ac1574455b1(e) {
    return $0fb38d8c0e179a73$export$30a86d91af8ff6e6 = "", e;
}
function $0fb38d8c0e179a73$export$410ac95b9ec204b8(e) {
    return $0fb38d8c0e179a73$export$87c2784dc9fc4ab($0fb38d8c0e179a73$export$58adb3bec8346d0f($0fb38d8c0e179a73$export$5880b8b5730aff45 - 1, $0fb38d8c0e179a73$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $0fb38d8c0e179a73$export$660b2ee2d4fb4eff(e) {
    return $0fb38d8c0e179a73$export$45918ac1574455b1($0fb38d8c0e179a73$export$5f8c09e3ae6f64e1($0fb38d8c0e179a73$export$2de70f21292aac9e(e)));
}
function $0fb38d8c0e179a73$export$7af1228ff777d175(e) {
    while($0fb38d8c0e179a73$export$c0306caf338ac095 = $0fb38d8c0e179a73$export$4d3fb11e950abb9e())if ($0fb38d8c0e179a73$export$c0306caf338ac095 < 33) $0fb38d8c0e179a73$export$48cfd1e771a65c4f();
    else break;
    return $0fb38d8c0e179a73$export$9e1725a4cfeada27(e) > 2 || $0fb38d8c0e179a73$export$9e1725a4cfeada27($0fb38d8c0e179a73$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $0fb38d8c0e179a73$export$5f8c09e3ae6f64e1(e) {
    while($0fb38d8c0e179a73$export$48cfd1e771a65c4f())switch($0fb38d8c0e179a73$export$9e1725a4cfeada27($0fb38d8c0e179a73$export$c0306caf338ac095)){
        case 0:
            $0fb38d8c0e179a73$export$10d8903dec122b9d($0fb38d8c0e179a73$export$c2ab62c7bf24634($0fb38d8c0e179a73$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $0fb38d8c0e179a73$export$10d8903dec122b9d($0fb38d8c0e179a73$export$410ac95b9ec204b8($0fb38d8c0e179a73$export$c0306caf338ac095), e);
            break;
        default:
            $0fb38d8c0e179a73$export$10d8903dec122b9d($0fb38d8c0e179a73$export$6788812c4e6611e6($0fb38d8c0e179a73$export$c0306caf338ac095), e);
    }
    return e;
}
function $0fb38d8c0e179a73$export$955ba06d119e085e(e, r) {
    while(--r && $0fb38d8c0e179a73$export$48cfd1e771a65c4f())if ($0fb38d8c0e179a73$export$c0306caf338ac095 < 48 || $0fb38d8c0e179a73$export$c0306caf338ac095 > 102 || $0fb38d8c0e179a73$export$c0306caf338ac095 > 57 && $0fb38d8c0e179a73$export$c0306caf338ac095 < 65 || $0fb38d8c0e179a73$export$c0306caf338ac095 > 70 && $0fb38d8c0e179a73$export$c0306caf338ac095 < 97) break;
    return $0fb38d8c0e179a73$export$58adb3bec8346d0f(e, $0fb38d8c0e179a73$export$e88cb2efb12ae807() + (r < 6 && $0fb38d8c0e179a73$export$4d3fb11e950abb9e() == 32 && $0fb38d8c0e179a73$export$48cfd1e771a65c4f() == 32));
}
function $0fb38d8c0e179a73$export$c889f2fcc19dbf12(e) {
    while($0fb38d8c0e179a73$export$48cfd1e771a65c4f())switch($0fb38d8c0e179a73$export$c0306caf338ac095){
        case e:
            return $0fb38d8c0e179a73$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $0fb38d8c0e179a73$export$c889f2fcc19dbf12($0fb38d8c0e179a73$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $0fb38d8c0e179a73$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $0fb38d8c0e179a73$export$48cfd1e771a65c4f();
            break;
    }
    return $0fb38d8c0e179a73$export$5880b8b5730aff45;
}
function $0fb38d8c0e179a73$export$4254d4e2b3745c4c(e, r) {
    while($0fb38d8c0e179a73$export$48cfd1e771a65c4f())if (e + $0fb38d8c0e179a73$export$c0306caf338ac095 === 57) break;
    else if (e + $0fb38d8c0e179a73$export$c0306caf338ac095 === 84 && $0fb38d8c0e179a73$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $0fb38d8c0e179a73$export$58adb3bec8346d0f(r, $0fb38d8c0e179a73$export$5880b8b5730aff45 - 1) + "*" + $0fb38d8c0e179a73$export$6788812c4e6611e6(e === 47 ? e : $0fb38d8c0e179a73$export$48cfd1e771a65c4f());
}
function $0fb38d8c0e179a73$export$c2ab62c7bf24634(e) {
    while(!$0fb38d8c0e179a73$export$9e1725a4cfeada27($0fb38d8c0e179a73$export$4d3fb11e950abb9e()))$0fb38d8c0e179a73$export$48cfd1e771a65c4f();
    return $0fb38d8c0e179a73$export$58adb3bec8346d0f(e, $0fb38d8c0e179a73$export$5880b8b5730aff45);
}
function $0fb38d8c0e179a73$export$ef7acd7185315e22(e) {
    return $0fb38d8c0e179a73$export$45918ac1574455b1($0fb38d8c0e179a73$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $0fb38d8c0e179a73$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $0fb38d8c0e179a73$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $0fb38d8c0e179a73$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $0fb38d8c0e179a73$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($0fb38d8c0e179a73$export$f8e21b1e77979a08(j += $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed($0fb38d8c0e179a73$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $0fb38d8c0e179a73$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $0fb38d8c0e179a73$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $0fb38d8c0e179a73$export$955ba06d119e085e($0fb38d8c0e179a73$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($0fb38d8c0e179a73$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $0fb38d8c0e179a73$export$10d8903dec122b9d($0fb38d8c0e179a73$export$4a34f930e789283c($0fb38d8c0e179a73$export$4254d4e2b3745c4c($0fb38d8c0e179a73$export$48cfd1e771a65c4f(), $0fb38d8c0e179a73$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $0fb38d8c0e179a73$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $0fb38d8c0e179a73$export$36776f635604f274(j) - l) $0fb38d8c0e179a73$export$10d8903dec122b9d(p > 32 ? $0fb38d8c0e179a73$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $0fb38d8c0e179a73$export$f8483753829ec8f3($0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $0fb38d8c0e179a73$export$10d8903dec122b9d(y = $0fb38d8c0e179a73$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $0fb38d8c0e179a73$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $0fb38d8c0e179a73$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $0fb38d8c0e179a73$export$98e6a39c04603d36(e, y, y, n && $0fb38d8c0e179a73$export$10d8903dec122b9d($0fb38d8c0e179a73$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $0fb38d8c0e179a73$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $0fb38d8c0e179a73$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $0fb38d8c0e179a73$export$232faf9add678146() == 125) continue;
            }
            switch(j += $0fb38d8c0e179a73$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($0fb38d8c0e179a73$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($0fb38d8c0e179a73$export$4d3fb11e950abb9e() === 45) j += $0fb38d8c0e179a73$export$410ac95b9ec204b8($0fb38d8c0e179a73$export$48cfd1e771a65c4f());
                    v = $0fb38d8c0e179a73$export$4d3fb11e950abb9e(), o = l = $0fb38d8c0e179a73$export$36776f635604f274(g = j += $0fb38d8c0e179a73$export$c2ab62c7bf24634($0fb38d8c0e179a73$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $0fb38d8c0e179a73$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $0fb38d8c0e179a73$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $0fb38d8c0e179a73$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $0fb38d8c0e179a73$export$2f35ab04d2335697(e, v + 1, v = $0fb38d8c0e179a73$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $0fb38d8c0e179a73$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $0fb38d8c0e179a73$export$35059013cd4a06db(e, r, a, s === 0 ? $0fb38d8c0e179a73$export$aa3a2e812ca8570d : i, f, o, l);
}
function $0fb38d8c0e179a73$export$4a34f930e789283c(e, r, a) {
    return $0fb38d8c0e179a73$export$35059013cd4a06db(e, r, a, $0fb38d8c0e179a73$export$a29989082612d0d9, $0fb38d8c0e179a73$export$6788812c4e6611e6($0fb38d8c0e179a73$export$eba6f6f03b0a92e7()), $0fb38d8c0e179a73$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $0fb38d8c0e179a73$export$f8483753829ec8f3(e, r, a, n) {
    return $0fb38d8c0e179a73$export$35059013cd4a06db(e, r, a, $0fb38d8c0e179a73$export$527d108ccf083c2b, $0fb38d8c0e179a73$export$2f35ab04d2335697(e, 0, n), $0fb38d8c0e179a73$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $0fb38d8c0e179a73$export$82e9f45cca5ba907(n, c, s) {
    switch($0fb38d8c0e179a73$export$d6af199866bfb566(n, c)){
        case 5103:
            return $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $0fb38d8c0e179a73$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + n + $0fb38d8c0e179a73$export$2c0f367103c8d01c + n + $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($0fb38d8c0e179a73$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + n + $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + n + $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + n + $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + n + $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + n + $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + n + $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + "box-$1$2" + $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + n + $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + "flex-item-" + $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$0fb38d8c0e179a73$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + "grid-row-" + $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + n + $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + "flex-line-pack" + $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + n + $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + n + $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + "box-" + $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, "-grow", "") + $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + n + $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed($0fb38d8c0e179a73$export$77ad94ebf1c2b9ed($0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed($0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + "box-pack:$3" + $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$0fb38d8c0e179a73$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + "grid-column-align" + $0fb38d8c0e179a73$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $0fb38d8c0e179a73$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$0fb38d8c0e179a73$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$0fb38d8c0e179a73$export$f8e21b1e77979a08(s, "span") ? $0fb38d8c0e179a73$export$4659b591c19bdf3d(s, /\d+/) : +$0fb38d8c0e179a73$export$4659b591c19bdf3d(s, /\d+/) - +$0fb38d8c0e179a73$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $0fb38d8c0e179a73$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed($0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($0fb38d8c0e179a73$export$36776f635604f274(n) - 1 - c > 6) switch($0fb38d8c0e179a73$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($0fb38d8c0e179a73$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $0fb38d8c0e179a73$export$2c0f367103c8d01c + ($0fb38d8c0e179a73$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$0fb38d8c0e179a73$export$f8e21b1e77979a08(n, "stretch") ? $0fb38d8c0e179a73$export$82e9f45cca5ba907($0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($0fb38d8c0e179a73$export$a9db5e087081082d(n, c + 6) === 121) return $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, ":", ":" + $0fb38d8c0e179a73$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($0fb38d8c0e179a73$export$a9db5e087081082d(n, $0fb38d8c0e179a73$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + ($0fb38d8c0e179a73$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, ":", ":" + $0fb38d8c0e179a73$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $0fb38d8c0e179a73$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $0fb38d8c0e179a73$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $0fb38d8c0e179a73$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $0fb38d8c0e179a73$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $0fb38d8c0e179a73$export$a763edbf796b780a:
        case $0fb38d8c0e179a73$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $0fb38d8c0e179a73$export$a29989082612d0d9:
            return "";
        case $0fb38d8c0e179a73$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $0fb38d8c0e179a73$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $0fb38d8c0e179a73$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $0fb38d8c0e179a73$export$36776f635604f274(a = $0fb38d8c0e179a73$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $0fb38d8c0e179a73$export$5a7767152ae0305f(e) {
    var r = $0fb38d8c0e179a73$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $0fb38d8c0e179a73$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $0fb38d8c0e179a73$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $0fb38d8c0e179a73$export$527d108ccf083c2b:
                n.return = $0fb38d8c0e179a73$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $0fb38d8c0e179a73$export$b44a8529a35fcb60:
                return $0fb38d8c0e179a73$export$dfdc1655ccc5b9cb([
                    $0fb38d8c0e179a73$export$784d13d8ee351f07(n, {
                        value: $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $0fb38d8c0e179a73$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $0fb38d8c0e179a73$export$aa3a2e812ca8570d:
                if (n.length) return $0fb38d8c0e179a73$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($0fb38d8c0e179a73$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $0fb38d8c0e179a73$export$dfdc1655ccc5b9cb([
                                $0fb38d8c0e179a73$export$784d13d8ee351f07(n, {
                                    props: [
                                        $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $0fb38d8c0e179a73$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $0fb38d8c0e179a73$export$dfdc1655ccc5b9cb([
                                $0fb38d8c0e179a73$export$784d13d8ee351f07(n, {
                                    props: [
                                        $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $0fb38d8c0e179a73$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $0fb38d8c0e179a73$export$784d13d8ee351f07(n, {
                                    props: [
                                        $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $0fb38d8c0e179a73$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $0fb38d8c0e179a73$export$784d13d8ee351f07(n, {
                                    props: [
                                        $0fb38d8c0e179a73$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $0fb38d8c0e179a73$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $0fb38d8c0e179a73$export$76a88f7de6507443(e) {
    switch(e.type){
        case $0fb38d8c0e179a73$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $0fb38d8c0e179a73$export$1be1fc439b849fdf($0fb38d8c0e179a73$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($0fb38d8c0e179a73$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $0fb38d8c0e179a73$export$2f35ab04d2335697(r, 1, $0fb38d8c0e179a73$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $0fb38d8c0e179a73$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $0fb38d8c0e179a73$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $0fb38d8c0e179a73$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRequire.register("kjTqK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecb0945033e7fc25$export$2e2bcd8739ae039; });
var $ecb0945033e7fc25$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRequire.register("61I3U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $463503e18cb0978a$export$2e2bcd8739ae039; });
function $463503e18cb0978a$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRequire.register("4MZGq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37cb7e1c28edb176$export$2e2bcd8739ae039; });

var $0nlaF = parcelRequire("0nlaF");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $37cb7e1c28edb176$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($0nlaF)))(targetComponent, sourceComponent);
};

});
parcelRequire.register("0nlaF", function(module, exports) {
"use strict";

var $lXYpP = parcelRequire("lXYpP");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $00121b220b1a4416$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $00121b220b1a4416$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $00121b220b1a4416$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $00121b220b1a4416$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $00121b220b1a4416$var$TYPE_STATICS = {};
$00121b220b1a4416$var$TYPE_STATICS[$lXYpP.ForwardRef] = $00121b220b1a4416$var$FORWARD_REF_STATICS;
$00121b220b1a4416$var$TYPE_STATICS[$lXYpP.Memo] = $00121b220b1a4416$var$MEMO_STATICS;
function $00121b220b1a4416$var$getStatics(component) {
    // React v16.11 and below
    if ($lXYpP.isMemo(component)) return $00121b220b1a4416$var$MEMO_STATICS;
     // React v16.12 and above
    return $00121b220b1a4416$var$TYPE_STATICS[component["$$typeof"]] || $00121b220b1a4416$var$REACT_STATICS;
}
var $00121b220b1a4416$var$defineProperty = Object.defineProperty;
var $00121b220b1a4416$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $00121b220b1a4416$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $00121b220b1a4416$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $00121b220b1a4416$var$getPrototypeOf = Object.getPrototypeOf;
var $00121b220b1a4416$var$objectPrototype = Object.prototype;
function $00121b220b1a4416$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($00121b220b1a4416$var$objectPrototype) {
            var inheritedComponent = $00121b220b1a4416$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $00121b220b1a4416$var$objectPrototype) $00121b220b1a4416$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $00121b220b1a4416$var$getOwnPropertyNames(sourceComponent);
        if ($00121b220b1a4416$var$getOwnPropertySymbols) keys = keys.concat($00121b220b1a4416$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $00121b220b1a4416$var$getStatics(targetComponent);
        var sourceStatics = $00121b220b1a4416$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$00121b220b1a4416$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $00121b220b1a4416$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $00121b220b1a4416$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $00121b220b1a4416$var$hoistNonReactStatics;

});
parcelRequire.register("lXYpP", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3A0mV"));

});



parcelRequire.register("2QrJk", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $2125f2b9ad028307$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $2125f2b9ad028307$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $2125f2b9ad028307$export$6f077d94b33a01aa; });
var $2125f2b9ad028307$var$isBrowser = true;
function $2125f2b9ad028307$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $2125f2b9ad028307$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $2125f2b9ad028307$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $2125f2b9ad028307$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $2125f2b9ad028307$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRequire.register("5dZtc", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $3cddd9496f54ae85$export$6321afa313b251b5; });

var $8OlnJ = parcelRequire("8OlnJ");

var $4zgpo = parcelRequire("4zgpo");

var $61I3U = parcelRequire("61I3U");
var $3cddd9496f54ae85$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $3cddd9496f54ae85$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $3cddd9496f54ae85$var$hyphenateRegex = /[A-Z]|^ms/g;
var $3cddd9496f54ae85$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $3cddd9496f54ae85$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $3cddd9496f54ae85$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $3cddd9496f54ae85$var$processStyleName = /* #__PURE__ */ (0, $61I3U.default)(function(styleName) {
    return $3cddd9496f54ae85$var$isCustomProperty(styleName) ? styleName : styleName.replace($3cddd9496f54ae85$var$hyphenateRegex, "-$&").toLowerCase();
});
var $3cddd9496f54ae85$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($3cddd9496f54ae85$var$animationRegex, function(match, p1, p2) {
                $3cddd9496f54ae85$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $3cddd9496f54ae85$var$cursor
                };
                return p1;
            });
    }
    if ((0, $4zgpo.default)[key] !== 1 && !$3cddd9496f54ae85$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $3cddd9496f54ae85$var$contentValuePattern, $3cddd9496f54ae85$var$contentValues, $3cddd9496f54ae85$var$oldProcessStyleValue, $3cddd9496f54ae85$var$msPattern, $3cddd9496f54ae85$var$hyphenPattern, $3cddd9496f54ae85$var$hyphenatedCache;
var $3cddd9496f54ae85$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $3cddd9496f54ae85$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $3cddd9496f54ae85$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $3cddd9496f54ae85$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $3cddd9496f54ae85$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $3cddd9496f54ae85$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $3cddd9496f54ae85$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $3cddd9496f54ae85$var$cursor;
                var result = interpolation(mergedProps);
                $3cddd9496f54ae85$var$cursor = previousCursor;
                return $3cddd9496f54ae85$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $3cddd9496f54ae85$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $3cddd9496f54ae85$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($3cddd9496f54ae85$var$isProcessableValue(value)) string += $3cddd9496f54ae85$var$processStyleName(_key) + ":" + $3cddd9496f54ae85$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($3cddd9496f54ae85$var$isProcessableValue(value[_i])) string += $3cddd9496f54ae85$var$processStyleName(_key) + ":" + $3cddd9496f54ae85$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $3cddd9496f54ae85$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $3cddd9496f54ae85$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $3cddd9496f54ae85$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $3cddd9496f54ae85$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $3cddd9496f54ae85$var$cursor;
var $3cddd9496f54ae85$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $3cddd9496f54ae85$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $3cddd9496f54ae85$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $3cddd9496f54ae85$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $3cddd9496f54ae85$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $3cddd9496f54ae85$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $8OlnJ.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $3cddd9496f54ae85$var$cursor
    };
};

});
parcelRequire.register("8OlnJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66a39431b071a614$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $66a39431b071a614$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRequire.register("4zgpo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $353728b462df40e5$export$2e2bcd8739ae039; });
var $353728b462df40e5$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRequire.register("gedI2", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $bd089689b2da8ea3$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $bd089689b2da8ea3$export$811a713a7276cb9d; });

var $35jnV = parcelRequire("35jnV");
var $bd089689b2da8ea3$var$syncFallback = function syncFallback(create) {
    return create();
};
var $bd089689b2da8ea3$var$useInsertionEffect = $35jnV.useInsertionEffect ? $35jnV.useInsertionEffect : false;
var $bd089689b2da8ea3$export$db21c7ffa21794e7 = $bd089689b2da8ea3$var$useInsertionEffect || $bd089689b2da8ea3$var$syncFallback;
var $bd089689b2da8ea3$export$811a713a7276cb9d = $bd089689b2da8ea3$var$useInsertionEffect || $35jnV.useLayoutEffect;

});


parcelRequire.register("8BDNn", function(module, exports) {
function $6440a5f62a5292aa$var$_extends() {
    module.exports = $6440a5f62a5292aa$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $6440a5f62a5292aa$var$_extends.apply(this, arguments);
}
module.exports = $6440a5f62a5292aa$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRequire.register("ghZ9O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdbdac6c75d6689d$export$2e2bcd8739ae039; });

var $kPJLM = parcelRequire("kPJLM");
"use client";
const $bdbdac6c75d6689d$var$defaultTheme = (0, $kPJLM.default)();
var $bdbdac6c75d6689d$export$2e2bcd8739ae039 = $bdbdac6c75d6689d$var$defaultTheme;

});
parcelRequire.register("kPJLM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2ac12f7f559d7c8$export$2e2bcd8739ae039; });

var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $a2Szr = parcelRequire("a2Szr");
var $5r8Xx = parcelRequire("5r8Xx");

var $6Ux7a = parcelRequire("6Ux7a");
var $d2FKK = parcelRequire("d2FKK");
var $dm2f8 = parcelRequire("dm2f8");


var $boL35 = parcelRequire("boL35");

var $9mtfi = parcelRequire("9mtfi");

var $bbUSC = parcelRequire("bbUSC");

var $ePRUq = parcelRequire("ePRUq");

var $bY2uA = parcelRequire("bY2uA");

var $h6RHX = parcelRequire("h6RHX");
const $f2ac12f7f559d7c8$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $f2ac12f7f559d7c8$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $5NWw9.default)(options, $f2ac12f7f559d7c8$var$_excluded);
    if (options.vars) throw new Error((0, $5r8Xx.default)(18));
    const palette = (0, $9mtfi.default)(paletteInput);
    const systemTheme = (0, $6Ux7a.default)(options);
    let muiTheme = (0, $a2Szr.default)(systemTheme, {
        mixins: (0, $boL35.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $ePRUq.default).slice(),
        typography: (0, $bbUSC.default)(palette, typographyInput),
        transitions: (0, $bY2uA.default)(transitionsInput),
        zIndex: (0, $lfXYn.default)({}, (0, $h6RHX.default))
    });
    muiTheme = (0, $a2Szr.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $a2Szr.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $lfXYn.default)({}, (0, $d2FKK.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $dm2f8.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $f2ac12f7f559d7c8$var$warnedOnce = false;
function $f2ac12f7f559d7c8$export$c469355549431d9b(...args) {
    return $f2ac12f7f559d7c8$var$createTheme(...args);
}
var $f2ac12f7f559d7c8$export$2e2bcd8739ae039 = $f2ac12f7f559d7c8$var$createTheme;

});
parcelRequire.register("boL35", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84c66e869ba6ec80$export$2e2bcd8739ae039; });

var $lfXYn = parcelRequire("lfXYn");
function $84c66e869ba6ec80$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $lfXYn.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRequire.register("9mtfi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d0cdab6a3273e8a$export$2e2bcd8739ae039; });

var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $a2Szr = parcelRequire("a2Szr");
var $5r8Xx = parcelRequire("5r8Xx");

var $a7jdq = parcelRequire("a7jdq");

var $98vRS = parcelRequire("98vRS");

var $9Xwj1 = parcelRequire("9Xwj1");

var $dcBWi = parcelRequire("dcBWi");

var $bEab5 = parcelRequire("bEab5");

var $iWXJQ = parcelRequire("iWXJQ");

var $6udFr = parcelRequire("6udFr");

var $2cFGP = parcelRequire("2cFGP");

var $8O9jg = parcelRequire("8O9jg");
const $6d0cdab6a3273e8a$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $6d0cdab6a3273e8a$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $98vRS.default).white,
        default: (0, $98vRS.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $6d0cdab6a3273e8a$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $98vRS.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $98vRS.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $6d0cdab6a3273e8a$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $a7jdq.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $a7jdq.darken)(intent.main, tonalOffsetDark);
    }
}
function $6d0cdab6a3273e8a$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $6udFr.default)[200],
        light: (0, $6udFr.default)[50],
        dark: (0, $6udFr.default)[400]
    };
    return {
        main: (0, $6udFr.default)[700],
        light: (0, $6udFr.default)[400],
        dark: (0, $6udFr.default)[800]
    };
}
function $6d0cdab6a3273e8a$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $dcBWi.default)[200],
        light: (0, $dcBWi.default)[50],
        dark: (0, $dcBWi.default)[400]
    };
    return {
        main: (0, $dcBWi.default)[500],
        light: (0, $dcBWi.default)[300],
        dark: (0, $dcBWi.default)[700]
    };
}
function $6d0cdab6a3273e8a$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $bEab5.default)[500],
        light: (0, $bEab5.default)[300],
        dark: (0, $bEab5.default)[700]
    };
    return {
        main: (0, $bEab5.default)[700],
        light: (0, $bEab5.default)[400],
        dark: (0, $bEab5.default)[800]
    };
}
function $6d0cdab6a3273e8a$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $2cFGP.default)[400],
        light: (0, $2cFGP.default)[300],
        dark: (0, $2cFGP.default)[700]
    };
    return {
        main: (0, $2cFGP.default)[700],
        light: (0, $2cFGP.default)[500],
        dark: (0, $2cFGP.default)[900]
    };
}
function $6d0cdab6a3273e8a$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $8O9jg.default)[400],
        light: (0, $8O9jg.default)[300],
        dark: (0, $8O9jg.default)[700]
    };
    return {
        main: (0, $8O9jg.default)[800],
        light: (0, $8O9jg.default)[500],
        dark: (0, $8O9jg.default)[900]
    };
}
function $6d0cdab6a3273e8a$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $iWXJQ.default)[400],
        light: (0, $iWXJQ.default)[300],
        dark: (0, $iWXJQ.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $iWXJQ.default)[500],
        dark: (0, $iWXJQ.default)[900]
    };
}
function $6d0cdab6a3273e8a$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $5NWw9.default)(palette, $6d0cdab6a3273e8a$var$_excluded);
    const primary = palette.primary || $6d0cdab6a3273e8a$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $6d0cdab6a3273e8a$var$getDefaultSecondary(mode);
    const error = palette.error || $6d0cdab6a3273e8a$var$getDefaultError(mode);
    const info = palette.info || $6d0cdab6a3273e8a$var$getDefaultInfo(mode);
    const success = palette.success || $6d0cdab6a3273e8a$var$getDefaultSuccess(mode);
    const warning = palette.warning || $6d0cdab6a3273e8a$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $a7jdq.getContrastRatio)(background, $6d0cdab6a3273e8a$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $6d0cdab6a3273e8a$export$55ce6f3a06c59543.text.primary : $6d0cdab6a3273e8a$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $lfXYn.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $5r8Xx.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $5r8Xx.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $6d0cdab6a3273e8a$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $6d0cdab6a3273e8a$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $6d0cdab6a3273e8a$export$55ce6f3a06c59543,
        light: $6d0cdab6a3273e8a$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $a2Szr.default)((0, $lfXYn.default)({
        // A collection of common colors.
        common: (0, $lfXYn.default)({}, (0, $98vRS.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $9Xwj1.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRequire.register("a7jdq", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $75d9769f692d8e7f$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $75d9769f692d8e7f$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "darken", function () { return $75d9769f692d8e7f$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $75d9769f692d8e7f$export$c0816ed86df316af; });

var $5r8Xx = parcelRequire("5r8Xx");
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $75d9769f692d8e7f$var$clamp(value, min = 0, max = 1) {
    return Math.min(Math.max(min, value), max);
}
function $75d9769f692d8e7f$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $75d9769f692d8e7f$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $75d9769f692d8e7f$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $75d9769f692d8e7f$export$677b39864803984e($75d9769f692d8e7f$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $5r8Xx.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $5r8Xx.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $75d9769f692d8e7f$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $75d9769f692d8e7f$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $75d9769f692d8e7f$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $75d9769f692d8e7f$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $75d9769f692d8e7f$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $75d9769f692d8e7f$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $75d9769f692d8e7f$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$75d9769f692d8e7f$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $75d9769f692d8e7f$export$29fb7152bd3f781a(color) {
    color = $75d9769f692d8e7f$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $75d9769f692d8e7f$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $75d9769f692d8e7f$export$c852d90bf7403b62(color) {
    color = $75d9769f692d8e7f$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $75d9769f692d8e7f$export$677b39864803984e($75d9769f692d8e7f$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $75d9769f692d8e7f$export$d061e26956a60b0a(foreground, background) {
    const lumA = $75d9769f692d8e7f$export$c852d90bf7403b62(foreground);
    const lumB = $75d9769f692d8e7f$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $75d9769f692d8e7f$export$58f0f39f63f3cf42(color, value) {
    color = $75d9769f692d8e7f$export$677b39864803984e(color);
    value = $75d9769f692d8e7f$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $75d9769f692d8e7f$export$211a73f2b8c10ce4(color);
}
function $75d9769f692d8e7f$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $75d9769f692d8e7f$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $75d9769f692d8e7f$export$4b073707ff63303(color, coefficient) {
    color = $75d9769f692d8e7f$export$677b39864803984e(color);
    coefficient = $75d9769f692d8e7f$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $75d9769f692d8e7f$export$211a73f2b8c10ce4(color);
}
function $75d9769f692d8e7f$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $75d9769f692d8e7f$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $75d9769f692d8e7f$export$c0816ed86df316af(color, coefficient) {
    color = $75d9769f692d8e7f$export$677b39864803984e(color);
    coefficient = $75d9769f692d8e7f$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $75d9769f692d8e7f$export$211a73f2b8c10ce4(color);
}
function $75d9769f692d8e7f$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $75d9769f692d8e7f$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $75d9769f692d8e7f$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $75d9769f692d8e7f$export$c852d90bf7403b62(color) > 0.5 ? $75d9769f692d8e7f$export$4b073707ff63303(color, coefficient) : $75d9769f692d8e7f$export$c0816ed86df316af(color, coefficient);
}
function $75d9769f692d8e7f$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $75d9769f692d8e7f$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}

});

parcelRequire.register("98vRS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a6d94c0b65f4c91$export$2e2bcd8739ae039; });
const $6a6d94c0b65f4c91$var$common = {
    black: "#000",
    white: "#fff"
};
var $6a6d94c0b65f4c91$export$2e2bcd8739ae039 = $6a6d94c0b65f4c91$var$common;

});

parcelRequire.register("9Xwj1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7402af065314b130$export$2e2bcd8739ae039; });
const $7402af065314b130$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $7402af065314b130$export$2e2bcd8739ae039 = $7402af065314b130$var$grey;

});

parcelRequire.register("dcBWi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99c9d34edbe5b43f$export$2e2bcd8739ae039; });
const $99c9d34edbe5b43f$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $99c9d34edbe5b43f$export$2e2bcd8739ae039 = $99c9d34edbe5b43f$var$purple;

});

parcelRequire.register("bEab5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87ab533857858947$export$2e2bcd8739ae039; });
const $87ab533857858947$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $87ab533857858947$export$2e2bcd8739ae039 = $87ab533857858947$var$red;

});

parcelRequire.register("iWXJQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcbbfb93cfdcd9ba$export$2e2bcd8739ae039; });
const $dcbbfb93cfdcd9ba$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $dcbbfb93cfdcd9ba$export$2e2bcd8739ae039 = $dcbbfb93cfdcd9ba$var$orange;

});

parcelRequire.register("6udFr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b90257cd36874d9$export$2e2bcd8739ae039; });
const $4b90257cd36874d9$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $4b90257cd36874d9$export$2e2bcd8739ae039 = $4b90257cd36874d9$var$blue;

});

parcelRequire.register("2cFGP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19ad0a78245ce14e$export$2e2bcd8739ae039; });
const $19ad0a78245ce14e$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $19ad0a78245ce14e$export$2e2bcd8739ae039 = $19ad0a78245ce14e$var$lightBlue;

});

parcelRequire.register("8O9jg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $669a36f9f393d550$export$2e2bcd8739ae039; });
const $669a36f9f393d550$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $669a36f9f393d550$export$2e2bcd8739ae039 = $669a36f9f393d550$var$green;

});


parcelRequire.register("bbUSC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $825cd7f3d765f161$export$2e2bcd8739ae039; });

var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $a2Szr = parcelRequire("a2Szr");
const $825cd7f3d765f161$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $825cd7f3d765f161$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $825cd7f3d765f161$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $825cd7f3d765f161$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $825cd7f3d765f161$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $825cd7f3d765f161$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $5NWw9.default)(_ref, $825cd7f3d765f161$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $lfXYn.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $825cd7f3d765f161$var$defaultFontFamily ? {
            letterSpacing: `${$825cd7f3d765f161$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $825cd7f3d765f161$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $825cd7f3d765f161$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $a2Szr.default)((0, $lfXYn.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRequire.register("ePRUq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $accfa550a1e00763$export$2e2bcd8739ae039; });
const $accfa550a1e00763$var$shadowKeyUmbraOpacity = 0.2;
const $accfa550a1e00763$var$shadowKeyPenumbraOpacity = 0.14;
const $accfa550a1e00763$var$shadowAmbientShadowOpacity = 0.12;
function $accfa550a1e00763$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$accfa550a1e00763$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$accfa550a1e00763$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$accfa550a1e00763$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $accfa550a1e00763$var$shadows = [
    "none",
    $accfa550a1e00763$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $accfa550a1e00763$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $accfa550a1e00763$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $accfa550a1e00763$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $accfa550a1e00763$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $accfa550a1e00763$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $accfa550a1e00763$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $accfa550a1e00763$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $accfa550a1e00763$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $accfa550a1e00763$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $accfa550a1e00763$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $accfa550a1e00763$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $accfa550a1e00763$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $accfa550a1e00763$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $accfa550a1e00763$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $accfa550a1e00763$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $accfa550a1e00763$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $accfa550a1e00763$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $accfa550a1e00763$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $accfa550a1e00763$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $accfa550a1e00763$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $accfa550a1e00763$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $accfa550a1e00763$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $accfa550a1e00763$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $accfa550a1e00763$export$2e2bcd8739ae039 = $accfa550a1e00763$var$shadows;

});

parcelRequire.register("bY2uA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b673b398441991c$export$2e2bcd8739ae039; });

var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");
const $8b673b398441991c$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $8b673b398441991c$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $8b673b398441991c$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $8b673b398441991c$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $8b673b398441991c$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $8b673b398441991c$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $lfXYn.default)({}, $8b673b398441991c$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $lfXYn.default)({}, $8b673b398441991c$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $5NWw9.default)(options, $8b673b398441991c$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $8b673b398441991c$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $8b673b398441991c$var$formatMs(delay)}`).join(",");
    };
    return (0, $lfXYn.default)({
        getAutoHeightDuration: $8b673b398441991c$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRequire.register("h6RHX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c74ca881568470cd$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $c74ca881568470cd$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $c74ca881568470cd$export$2e2bcd8739ae039 = $c74ca881568470cd$var$zIndex;

});



parcelRequire.register("l5DLo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5a8e8cd338bca9b$export$2e2bcd8739ae039; });
var $f5a8e8cd338bca9b$export$2e2bcd8739ae039 = "$$material";

});


parcelRequire.register("jBVCU", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", function () { return $e46e2c72b100253a$export$effb20ecdbf4d6aa; });
$parcel$export(module.exports, "slotShouldForwardProp", function () { return $e46e2c72b100253a$export$f10c5a10d27438e5; });
$parcel$export(module.exports, "default", function () { return $e46e2c72b100253a$export$2e2bcd8739ae039; });

var $eTicN = parcelRequire("eTicN");

var $ghZ9O = parcelRequire("ghZ9O");

var $l5DLo = parcelRequire("l5DLo");
"use client";
const $e46e2c72b100253a$export$effb20ecdbf4d6aa = (prop)=>(0, $eTicN.shouldForwardProp)(prop) && prop !== "classes";
const $e46e2c72b100253a$export$f10c5a10d27438e5 = (0, $eTicN.shouldForwardProp);
const $e46e2c72b100253a$var$styled = (0, $eTicN.default)({
    themeId: (0, $l5DLo.default),
    defaultTheme: $ghZ9O.default,
    rootShouldForwardProp: $e46e2c72b100253a$export$effb20ecdbf4d6aa
});
var $e46e2c72b100253a$export$2e2bcd8739ae039 = $e46e2c72b100253a$var$styled;

});
parcelRequire.register("eTicN", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", function () { return $ad7452f733bd7f1f$export$3ba67b570e26eea0; });
$parcel$export(module.exports, "default", function () { return $ad7452f733bd7f1f$export$2e2bcd8739ae039; });

var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $dsIT1 = parcelRequire("dsIT1");

var $a2Szr = parcelRequire("a2Szr");

var $6Ux7a = parcelRequire("6Ux7a");

var $8PE7f = parcelRequire("8PE7f");

var $dm2f8 = parcelRequire("dm2f8");
const $ad7452f733bd7f1f$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $ad7452f733bd7f1f$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $ad7452f733bd7f1f$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
const $ad7452f733bd7f1f$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $ad7452f733bd7f1f$var$transformVariants = (variants)=>{
    const variantsStyles = {};
    if (variants) variants.forEach((definition)=>{
        const key = (0, $8PE7f.default)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $ad7452f733bd7f1f$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    return $ad7452f733bd7f1f$var$transformVariants(variants);
};
const $ad7452f733bd7f1f$var$variantsResolver = (props, styles, variants)=>{
    const { ownerState: ownerState = {} } = props;
    const variantsStyles = [];
    if (variants) variants.forEach((variant)=>{
        let isMatch = true;
        Object.keys(variant.props).forEach((key)=>{
            if (ownerState[key] !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
        });
        if (isMatch) variantsStyles.push(styles[(0, $8PE7f.default)(variant.props)]);
    });
    return variantsStyles;
};
const $ad7452f733bd7f1f$var$themeVariantsResolver = (props, styles, theme, name)=>{
    var _theme$components;
    const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[name]) == null ? void 0 : _theme$components.variants;
    return $ad7452f733bd7f1f$var$variantsResolver(props, styles, themeVariants);
};
function $ad7452f733bd7f1f$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $ad7452f733bd7f1f$export$35e57303dbd8a66 = (0, $6Ux7a.default)();
const $ad7452f733bd7f1f$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $ad7452f733bd7f1f$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $ad7452f733bd7f1f$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $ad7452f733bd7f1f$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
const $ad7452f733bd7f1f$var$muiStyledFunctionResolver = ({ styledArg: styledArg, props: props, defaultTheme: defaultTheme, themeId: themeId })=>{
    const resolvedStyles = styledArg((0, $lfXYn.default)({}, props, {
        theme: $ad7452f733bd7f1f$var$resolveTheme((0, $lfXYn.default)({}, props, {
            defaultTheme: defaultTheme,
            themeId: themeId
        }))
    }));
    let optionalVariants;
    if (resolvedStyles && resolvedStyles.variants) {
        optionalVariants = resolvedStyles.variants;
        delete resolvedStyles.variants;
    }
    if (optionalVariants) {
        const variantsStyles = $ad7452f733bd7f1f$var$variantsResolver(props, $ad7452f733bd7f1f$var$transformVariants(optionalVariants), optionalVariants);
        return [
            resolvedStyles,
            ...variantsStyles
        ];
    }
    return resolvedStyles;
};
function $ad7452f733bd7f1f$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $ad7452f733bd7f1f$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $ad7452f733bd7f1f$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $ad7452f733bd7f1f$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $dm2f8.default)((0, $lfXYn.default)({}, props, {
            theme: $ad7452f733bd7f1f$var$resolveTheme((0, $lfXYn.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $dsIT1.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $ad7452f733bd7f1f$var$defaultOverridesResolver($ad7452f733bd7f1f$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $5NWw9.default)(inputOptions, $ad7452f733bd7f1f$var$_excluded);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $ad7452f733bd7f1f$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($ad7452f733bd7f1f$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $dsIT1.default)(tag, (0, $lfXYn.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server Emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg) return (props)=>$ad7452f733bd7f1f$var$muiStyledFunctionResolver({
                        styledArg: stylesArg,
                        props: props,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    });
                if ((0, $a2Szr.isPlainObject)(stylesArg)) {
                    let transformedStylesArg = stylesArg;
                    let styledArgVariants;
                    if (stylesArg && stylesArg.variants) {
                        styledArgVariants = stylesArg.variants;
                        delete transformedStylesArg.variants;
                        transformedStylesArg = (props)=>{
                            let result = stylesArg;
                            const variantStyles = $ad7452f733bd7f1f$var$variantsResolver(props, $ad7452f733bd7f1f$var$transformVariants(styledArgVariants), styledArgVariants);
                            variantStyles.forEach((variantStyle)=>{
                                result = (0, $a2Szr.default)(result, variantStyle);
                            });
                            return result;
                        };
                    }
                    return transformedStylesArg;
                }
                return stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if ((0, $a2Szr.isPlainObject)(styleArg)) {
                let styledArgVariants;
                if (styleArg && styleArg.variants) {
                    styledArgVariants = styleArg.variants;
                    delete transformedStyleArg.variants;
                    transformedStyleArg = (props)=>{
                        let result = styleArg;
                        const variantStyles = $ad7452f733bd7f1f$var$variantsResolver(props, $ad7452f733bd7f1f$var$transformVariants(styledArgVariants), styledArgVariants);
                        variantStyles.forEach((variantStyle)=>{
                            result = (0, $a2Szr.default)(result, variantStyle);
                        });
                        return result;
                    };
                }
            } else if (typeof styleArg === "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (props)=>$ad7452f733bd7f1f$var$muiStyledFunctionResolver({
                    styledArg: styleArg,
                    props: props,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $ad7452f733bd7f1f$var$resolveTheme((0, $lfXYn.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const styleOverrides = $ad7452f733bd7f1f$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle((0, $lfXYn.default)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $ad7452f733bd7f1f$var$resolveTheme((0, $lfXYn.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                return $ad7452f733bd7f1f$var$themeVariantsResolver(props, $ad7452f733bd7f1f$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRequire.register("dsIT1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cd0b5609d26cc82$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $9cd0b5609d26cc82$export$e00380445f2b9e0c; });
/**
 * @mui/styled-engine v5.14.12
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $iOzPa = parcelRequire("iOzPa");
parcelRequire("UnJZz");
var $liH5y = parcelRequire("liH5y");
var $UnJZz = parcelRequire("UnJZz");


var $kaNGo = parcelRequire("kaNGo");
"use client";
function $9cd0b5609d26cc82$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $iOzPa.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $9cd0b5609d26cc82$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRequire.register("iOzPa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db28af7671a08818$export$2e2bcd8739ae039; });

var $d41jp = parcelRequire("d41jp");
parcelRequire("8BDNn");
parcelRequire("35jnV");
parcelRequire("lwfOH");

parcelRequire("2QrJk");
parcelRequire("5dZtc");
parcelRequire("gedI2");
var $db28af7671a08818$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $db28af7671a08818$export$2e2bcd8739ae039 = (0, $d41jp.default).bind();
$db28af7671a08818$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $db28af7671a08818$export$2e2bcd8739ae039[tagName] = $db28af7671a08818$export$2e2bcd8739ae039(tagName);
});

});
parcelRequire.register("d41jp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $982caa9db23c4d5d$export$2e2bcd8739ae039; });

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");

var $lwfOH = parcelRequire("lwfOH");
parcelRequire("UnJZz");
var $liH5y = parcelRequire("liH5y");

var $2QrJk = parcelRequire("2QrJk");

var $5dZtc = parcelRequire("5dZtc");

var $gedI2 = parcelRequire("gedI2");
var $982caa9db23c4d5d$var$testOmitPropsOnStringTag = (0, $lwfOH.default);
var $982caa9db23c4d5d$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $982caa9db23c4d5d$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $982caa9db23c4d5d$var$testOmitPropsOnStringTag : $982caa9db23c4d5d$var$testOmitPropsOnComponent;
};
var $982caa9db23c4d5d$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $982caa9db23c4d5d$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $982caa9db23c4d5d$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $2QrJk.registerStyles)(cache, serialized, isStringTag);
    (0, $gedI2.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $2QrJk.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $982caa9db23c4d5d$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $982caa9db23c4d5d$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $982caa9db23c4d5d$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $liH5y.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $35jnV.useContext((0, $liH5y.T));
            }
            if (typeof props.className === "string") className = (0, $2QrJk.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $5dZtc.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $982caa9db23c4d5d$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $35jnV.createElement($35jnV.Fragment, null, /*#__PURE__*/ $35jnV.createElement($982caa9db23c4d5d$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $35jnV.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $lfXYn.default)({}, options, nextOptions, {
                shouldForwardProp: $982caa9db23c4d5d$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRequire.register("lwfOH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faa8dafe7f67573d$export$2e2bcd8739ae039; });

var $61I3U = parcelRequire("61I3U");
var $faa8dafe7f67573d$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $faa8dafe7f67573d$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $61I3U.default)(function(prop) {
    return $faa8dafe7f67573d$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRequire.register("kaNGo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eafb47c22e8b4d1b$export$2e2bcd8739ae039; });
parcelRequire("35jnV");


var $UnJZz = parcelRequire("UnJZz");

var $86rqb = parcelRequire("86rqb");
"use client";
function $eafb47c22e8b4d1b$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $eafb47c22e8b4d1b$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($eafb47c22e8b4d1b$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $86rqb.jsx)((0, $UnJZz.Global), {
        styles: globalStyles
    });
}

});
parcelRequire.register("86rqb", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fQLEo"));

});



parcelRequire.register("8PE7f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66e234561cccbc1f$export$2e2bcd8739ae039; });

var $5NWw9 = parcelRequire("5NWw9");

var $7uiwM = parcelRequire("7uiwM");
const $66e234561cccbc1f$var$_excluded = [
    "variant"
];
function $66e234561cccbc1f$var$isEmpty(string) {
    return string.length === 0;
}
function $66e234561cccbc1f$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $5NWw9.default)(props, $66e234561cccbc1f$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $66e234561cccbc1f$var$isEmpty(classKey) ? props[key] : (0, $7uiwM.default)(props[key]);
        else classKey += `${$66e234561cccbc1f$var$isEmpty(classKey) ? key : (0, $7uiwM.default)(key)}${(0, $7uiwM.default)(props[key].toString())}`;
    });
    return classKey;
}

});



parcelRequire.register("4htP9", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $31dfe25bc340fc5b$export$c7c50641356bdfa5; });

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $31dfe25bc340fc5b$export$c7c50641356bdfa5(slot) {
    return (0, $1reLR.default)("MuiSvgIcon", slot);
}
const $31dfe25bc340fc5b$var$svgIconClasses = (0, $ibC2g.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $31dfe25bc340fc5b$export$2e2bcd8739ae039 = $31dfe25bc340fc5b$var$svgIconClasses;

});
parcelRequire.register("ibC2g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3d6c225e55ebbf7$export$2e2bcd8739ae039; });

var $1reLR = parcelRequire("1reLR");
function $d3d6c225e55ebbf7$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $1reLR.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRequire.register("1reLR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10c3c5428739f8e3$export$2e2bcd8739ae039; });

var $7WE1c = parcelRequire("7WE1c");
// If GlobalStateSlot is changed, GLOBAL_STATE_CLASSES in
// \packages\api-docs-builder\utils\parseSlotsAndClasses.ts must be updated accordingly.
const $10c3c5428739f8e3$var$globalStateClassesMapping = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $10c3c5428739f8e3$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $10c3c5428739f8e3$var$globalStateClassesMapping[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $7WE1c.default).generate(componentName)}-${slot}`;
}

});
parcelRequire.register("7WE1c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c8cfdf8420ec44a$export$2e2bcd8739ae039; });
const $5c8cfdf8420ec44a$var$defaultGenerator = (componentName)=>componentName;
const $5c8cfdf8420ec44a$var$createClassNameGenerator = ()=>{
    let generate = $5c8cfdf8420ec44a$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $5c8cfdf8420ec44a$var$defaultGenerator;
        }
    };
};
const $5c8cfdf8420ec44a$var$ClassNameGenerator = $5c8cfdf8420ec44a$var$createClassNameGenerator();
var $5c8cfdf8420ec44a$export$2e2bcd8739ae039 = $5c8cfdf8420ec44a$var$ClassNameGenerator;

});







parcelRequire.register("7BJOf", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $589f85e46d493524$export$a7c73072b1a182ae; }, function (v) { return $589f85e46d493524$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $589f85e46d493524$export$9f27bc3417b4524d; }, function (v) { return $589f85e46d493524$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $589f85e46d493524$export$db77ccec0bb4ccac; }, function (v) { return $589f85e46d493524$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $589f85e46d493524$export$8392c0c9d3dcbd35; }, function (v) { return $589f85e46d493524$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $589f85e46d493524$export$ffb0004e005737fa; }, function (v) { return $589f85e46d493524$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $589f85e46d493524$export$b624eff549462981; }, function (v) { return $589f85e46d493524$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $589f85e46d493524$export$7897aa7841a5380c; }, function (v) { return $589f85e46d493524$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $589f85e46d493524$export$602eac185826482c; }, function (v) { return $589f85e46d493524$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $589f85e46d493524$export$e2c29f18771995cb; }, function (v) { return $589f85e46d493524$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $589f85e46d493524$export$5f8d39834fd61797; }, function (v) { return $589f85e46d493524$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $589f85e46d493524$export$74bf444e3cd11ea5; }, function (v) { return $589f85e46d493524$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $589f85e46d493524$export$998bcd577473dd93; }, function (v) { return $589f85e46d493524$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $589f85e46d493524$export$92387174baf9b227; }, function (v) { return $589f85e46d493524$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $589f85e46d493524$export$ec112efeb987d9c6; }, function (v) { return $589f85e46d493524$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $589f85e46d493524$export$b706b080d889d2c9; }, function (v) { return $589f85e46d493524$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $589f85e46d493524$export$5be5a87408f70ddc; }, function (v) { return $589f85e46d493524$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $589f85e46d493524$export$45a5e7f76e0caa8d; }, function (v) { return $589f85e46d493524$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $589f85e46d493524$export$455c2e768291efa6; }, function (v) { return $589f85e46d493524$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $589f85e46d493524$export$9522e17588c12572; }, function (v) { return $589f85e46d493524$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $589f85e46d493524$export$2110ac352bb060b9; }, function (v) { return $589f85e46d493524$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $589f85e46d493524$export$56885ab8b9c456ab; }, function (v) { return $589f85e46d493524$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $589f85e46d493524$export$d927fcb6adf8f9de; }, function (v) { return $589f85e46d493524$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $589f85e46d493524$export$b82d16f27459e05a; }, function (v) { return $589f85e46d493524$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $589f85e46d493524$export$522c17b4f5e123e8; }, function (v) { return $589f85e46d493524$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $589f85e46d493524$export$1aabd8a0274ecfd6; }, function (v) { return $589f85e46d493524$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $589f85e46d493524$export$3d6c20d97e46b957; }, function (v) { return $589f85e46d493524$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $589f85e46d493524$export$9b621391a187a31a; }, function (v) { return $589f85e46d493524$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $589f85e46d493524$export$f5bbd400c2f4426f; }, function (v) { return $589f85e46d493524$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $589f85e46d493524$export$a7c73072b1a182ae;
var $589f85e46d493524$export$9f27bc3417b4524d;
var $589f85e46d493524$export$db77ccec0bb4ccac;
var $589f85e46d493524$export$8392c0c9d3dcbd35;
var $589f85e46d493524$export$ffb0004e005737fa;
var $589f85e46d493524$export$b624eff549462981;
var $589f85e46d493524$export$7897aa7841a5380c;
var $589f85e46d493524$export$602eac185826482c;
var $589f85e46d493524$export$e2c29f18771995cb;
var $589f85e46d493524$export$5f8d39834fd61797;
var $589f85e46d493524$export$74bf444e3cd11ea5;
var $589f85e46d493524$export$998bcd577473dd93;
var $589f85e46d493524$export$92387174baf9b227;
var $589f85e46d493524$export$ec112efeb987d9c6;
var $589f85e46d493524$export$b706b080d889d2c9;
var $589f85e46d493524$export$5be5a87408f70ddc;
var $589f85e46d493524$export$45a5e7f76e0caa8d;
var $589f85e46d493524$export$455c2e768291efa6;
var $589f85e46d493524$export$9522e17588c12572;
var $589f85e46d493524$export$2110ac352bb060b9;
var $589f85e46d493524$export$56885ab8b9c456ab;
var $589f85e46d493524$export$d927fcb6adf8f9de;
var $589f85e46d493524$export$b82d16f27459e05a;
var $589f85e46d493524$export$522c17b4f5e123e8;
var $589f85e46d493524$export$1aabd8a0274ecfd6;
var $589f85e46d493524$export$3d6c20d97e46b957;
var $589f85e46d493524$export$9b621391a187a31a;
var $589f85e46d493524$export$f5bbd400c2f4426f;
"use strict";
var $589f85e46d493524$var$b = Symbol.for("react.element"), $589f85e46d493524$var$c = Symbol.for("react.portal"), $589f85e46d493524$var$d = Symbol.for("react.fragment"), $589f85e46d493524$var$e = Symbol.for("react.strict_mode"), $589f85e46d493524$var$f = Symbol.for("react.profiler"), $589f85e46d493524$var$g = Symbol.for("react.provider"), $589f85e46d493524$var$h = Symbol.for("react.context"), $589f85e46d493524$var$k = Symbol.for("react.server_context"), $589f85e46d493524$var$l = Symbol.for("react.forward_ref"), $589f85e46d493524$var$m = Symbol.for("react.suspense"), $589f85e46d493524$var$n = Symbol.for("react.suspense_list"), $589f85e46d493524$var$p = Symbol.for("react.memo"), $589f85e46d493524$var$q = Symbol.for("react.lazy"), $589f85e46d493524$var$t = Symbol.for("react.offscreen"), $589f85e46d493524$var$u;
$589f85e46d493524$var$u = Symbol.for("react.module.reference");
function $589f85e46d493524$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $589f85e46d493524$var$b:
                switch(a = a.type, a){
                    case $589f85e46d493524$var$d:
                    case $589f85e46d493524$var$f:
                    case $589f85e46d493524$var$e:
                    case $589f85e46d493524$var$m:
                    case $589f85e46d493524$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $589f85e46d493524$var$k:
                            case $589f85e46d493524$var$h:
                            case $589f85e46d493524$var$l:
                            case $589f85e46d493524$var$q:
                            case $589f85e46d493524$var$p:
                            case $589f85e46d493524$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $589f85e46d493524$var$c:
                return r;
        }
    }
}
$589f85e46d493524$export$a7c73072b1a182ae = $589f85e46d493524$var$h;
$589f85e46d493524$export$9f27bc3417b4524d = $589f85e46d493524$var$g;
$589f85e46d493524$export$db77ccec0bb4ccac = $589f85e46d493524$var$b;
$589f85e46d493524$export$8392c0c9d3dcbd35 = $589f85e46d493524$var$l;
$589f85e46d493524$export$ffb0004e005737fa = $589f85e46d493524$var$d;
$589f85e46d493524$export$b624eff549462981 = $589f85e46d493524$var$q;
$589f85e46d493524$export$7897aa7841a5380c = $589f85e46d493524$var$p;
$589f85e46d493524$export$602eac185826482c = $589f85e46d493524$var$c;
$589f85e46d493524$export$e2c29f18771995cb = $589f85e46d493524$var$f;
$589f85e46d493524$export$5f8d39834fd61797 = $589f85e46d493524$var$e;
$589f85e46d493524$export$74bf444e3cd11ea5 = $589f85e46d493524$var$m;
$589f85e46d493524$export$998bcd577473dd93 = $589f85e46d493524$var$n;
$589f85e46d493524$export$92387174baf9b227 = function() {
    return !1;
};
$589f85e46d493524$export$ec112efeb987d9c6 = function() {
    return !1;
};
$589f85e46d493524$export$b706b080d889d2c9 = function(a) {
    return $589f85e46d493524$var$v(a) === $589f85e46d493524$var$h;
};
$589f85e46d493524$export$5be5a87408f70ddc = function(a) {
    return $589f85e46d493524$var$v(a) === $589f85e46d493524$var$g;
};
$589f85e46d493524$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $589f85e46d493524$var$b;
};
$589f85e46d493524$export$455c2e768291efa6 = function(a) {
    return $589f85e46d493524$var$v(a) === $589f85e46d493524$var$l;
};
$589f85e46d493524$export$9522e17588c12572 = function(a) {
    return $589f85e46d493524$var$v(a) === $589f85e46d493524$var$d;
};
$589f85e46d493524$export$2110ac352bb060b9 = function(a) {
    return $589f85e46d493524$var$v(a) === $589f85e46d493524$var$q;
};
$589f85e46d493524$export$56885ab8b9c456ab = function(a) {
    return $589f85e46d493524$var$v(a) === $589f85e46d493524$var$p;
};
$589f85e46d493524$export$d927fcb6adf8f9de = function(a) {
    return $589f85e46d493524$var$v(a) === $589f85e46d493524$var$c;
};
$589f85e46d493524$export$b82d16f27459e05a = function(a) {
    return $589f85e46d493524$var$v(a) === $589f85e46d493524$var$f;
};
$589f85e46d493524$export$522c17b4f5e123e8 = function(a) {
    return $589f85e46d493524$var$v(a) === $589f85e46d493524$var$e;
};
$589f85e46d493524$export$1aabd8a0274ecfd6 = function(a) {
    return $589f85e46d493524$var$v(a) === $589f85e46d493524$var$m;
};
$589f85e46d493524$export$3d6c20d97e46b957 = function(a) {
    return $589f85e46d493524$var$v(a) === $589f85e46d493524$var$n;
};
$589f85e46d493524$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $589f85e46d493524$var$d || a === $589f85e46d493524$var$f || a === $589f85e46d493524$var$e || a === $589f85e46d493524$var$m || a === $589f85e46d493524$var$n || a === $589f85e46d493524$var$t || "object" === typeof a && null !== a && (a.$$typeof === $589f85e46d493524$var$q || a.$$typeof === $589f85e46d493524$var$p || a.$$typeof === $589f85e46d493524$var$g || a.$$typeof === $589f85e46d493524$var$h || a.$$typeof === $589f85e46d493524$var$l || a.$$typeof === $589f85e46d493524$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$589f85e46d493524$export$f5bbd400c2f4426f = $589f85e46d493524$var$v;

});

parcelRequire.register("kAusa", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRequire.register("bxncQ", function(module, exports) {
"use strict";
var $8664c70ecff3ac03$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $kDob8 = parcelRequire("kDob8");
module.exports = function hasNativeSymbols() {
    if (typeof $8664c70ecff3ac03$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $8664c70ecff3ac03$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $kDob8();
};

});
parcelRequire.register("kDob8", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRequire.register("eQw7P", function(module, exports) {
"use strict";
var $aceed76fadf188c6$var$test = {
    foo: {}
};
var $aceed76fadf188c6$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $aceed76fadf188c6$var$test
    }).foo === $aceed76fadf188c6$var$test.foo && !(({
        __proto__: null
    }) instanceof $aceed76fadf188c6$var$$Object);
};

});


var $86rqb = parcelRequire("86rqb");
var $b66eb0f3e66056aa$export$882461b6382ed46c;
var $b66eb0f3e66056aa$export$757ceba2d55c277e;
"use strict";
var $90e5093ac8ea5052$exports = {};
"use strict";
function $90e5093ac8ea5052$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($90e5093ac8ea5052$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$90e5093ac8ea5052$var$checkDCE();

$90e5093ac8ea5052$exports = (parcelRequire("eeNZT"));


var $b66eb0f3e66056aa$var$i;
$b66eb0f3e66056aa$export$882461b6382ed46c = $90e5093ac8ea5052$exports.createRoot;
$b66eb0f3e66056aa$export$757ceba2d55c277e = $90e5093ac8ea5052$exports.hydrateRoot;





var $86rqb = parcelRequire("86rqb");

var $kPJLM = parcelRequire("kPJLM");
var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");
parcelRequire("35jnV");


var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");



var $35jnV = parcelRequire("35jnV");
const $39d6ad1fbd443909$var$ThemeContext = /*#__PURE__*/ $35jnV.createContext(null);
var $39d6ad1fbd443909$export$2e2bcd8739ae039 = $39d6ad1fbd443909$var$ThemeContext;



var $35jnV = parcelRequire("35jnV");

function $6b88d3e877f9e6c9$export$2e2bcd8739ae039() {
    const theme = $35jnV.useContext((0, $39d6ad1fbd443909$export$2e2bcd8739ae039));
    return theme;
}


const $82aabfbd3eadc981$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $82aabfbd3eadc981$export$2e2bcd8739ae039 = $82aabfbd3eadc981$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $86rqb = parcelRequire("86rqb");
function $44a5aec473fe3624$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $lfXYn.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $44a5aec473fe3624$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $6b88d3e877f9e6c9$export$2e2bcd8739ae039)();
    const theme = $35jnV.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $44a5aec473fe3624$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $82aabfbd3eadc981$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $86rqb.jsx)((0, $39d6ad1fbd443909$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $44a5aec473fe3624$export$2e2bcd8739ae039 = $44a5aec473fe3624$var$ThemeProvider;



parcelRequire("UnJZz");
var $liH5y = parcelRequire("liH5y");

var $kfqtZ = parcelRequire("kfqtZ");

var $86rqb = parcelRequire("86rqb");
"use client";
const $34857beb8d8aeb69$var$EMPTY_THEME = {};
function $34857beb8d8aeb69$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $35jnV.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $lfXYn.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $lfXYn.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $lfXYn.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $34857beb8d8aeb69$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $kfqtZ.default)($34857beb8d8aeb69$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $6b88d3e877f9e6c9$export$2e2bcd8739ae039)() || $34857beb8d8aeb69$var$EMPTY_THEME;
    const engineTheme = $34857beb8d8aeb69$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $34857beb8d8aeb69$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    return /*#__PURE__*/ (0, $86rqb.jsx)((0, $44a5aec473fe3624$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $86rqb.jsx)((0, $liH5y.T).Provider, {
            value: engineTheme,
            children: children
        })
    });
}
var $34857beb8d8aeb69$export$2e2bcd8739ae039 = $34857beb8d8aeb69$var$ThemeProvider;



var $l5DLo = parcelRequire("l5DLo");

var $86rqb = parcelRequire("86rqb");
"use client";
const $30ddd8ad23484c6a$var$_excluded = [
    "theme"
];
function $30ddd8ad23484c6a$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $5NWw9.default)(_ref, $30ddd8ad23484c6a$var$_excluded);
    const scopedTheme = themeInput[0, $l5DLo.default];
    return /*#__PURE__*/ (0, $86rqb.jsx)((0, $34857beb8d8aeb69$export$2e2bcd8739ae039), (0, $lfXYn.default)({}, props, {
        themeId: scopedTheme ? (0, $l5DLo.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}



var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $hZybU = parcelRequire("hZybU");

var $lfXYn = parcelRequire("lfXYn");
parcelRequire("35jnV");

parcelRequire("35jnV");


var $kaNGo = parcelRequire("kaNGo");

var $lfge4 = parcelRequire("lfge4");

var $86rqb = parcelRequire("86rqb");
"use client";
function $f2a3d8d15325ee77$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $lfge4.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $86rqb.jsx)((0, $kaNGo.default), {
        styles: globalStyles
    });
}
var $f2a3d8d15325ee77$export$2e2bcd8739ae039 = $f2a3d8d15325ee77$var$GlobalStyles;



var $ghZ9O = parcelRequire("ghZ9O");

var $l5DLo = parcelRequire("l5DLo");

var $86rqb = parcelRequire("86rqb");
"use client";
function $b1742c606b8942a6$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $86rqb.jsx)((0, $f2a3d8d15325ee77$export$2e2bcd8739ae039), (0, $lfXYn.default)({}, props, {
        defaultTheme: (0, $ghZ9O.default),
        themeId: (0, $l5DLo.default)
    }));
}
var $b1742c606b8942a6$export$2e2bcd8739ae039 = $b1742c606b8942a6$var$GlobalStyles;



var $86rqb = parcelRequire("86rqb");
"use client";
const $21f582aa7c0e8d71$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $lfXYn.default)({
        WebkitFontSmoothing: "antialiased",
        // Antialiasing.
        MozOsxFontSmoothing: "grayscale",
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: "border-box",
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: "100%"
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $21f582aa7c0e8d71$export$32180ef41b15b513 = (theme)=>(0, $lfXYn.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $21f582aa7c0e8d71$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, "")] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $lfXYn.default)({
        html: $21f582aa7c0e8d71$export$c0bb0b647f701bb5(theme, enableColorScheme),
        "*, *::before, *::after": {
            boxSizing: "inherit"
        },
        "strong, b": {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $lfXYn.default)({
            margin: 0
        }, $21f582aa7c0e8d71$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            "&::backdrop": {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $21f582aa7c0e8d71$var$CssBaseline(inProps) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiCssBaseline"
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $86rqb.jsxs)($35jnV.Fragment, {
        children: [
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $b1742c606b8942a6$export$2e2bcd8739ae039), {
                styles: (theme)=>$21f582aa7c0e8d71$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $21f582aa7c0e8d71$export$2e2bcd8739ae039 = $21f582aa7c0e8d71$var$CssBaseline;



var $86rqb = parcelRequire("86rqb");
var $fe4f26fe77e76922$exports = {};
"use strict";
var $31eb592b83cf9070$exports = {};
"use strict";
var $31eb592b83cf9070$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
};
var $31eb592b83cf9070$var$createStore = function createStore(createState) {
    return createState ? $31eb592b83cf9070$var$createStoreImpl(createState) : $31eb592b83cf9070$var$createStoreImpl;
};
var $31eb592b83cf9070$var$vanilla = function(createState) {
    return $31eb592b83cf9070$var$createStore(createState);
};
$31eb592b83cf9070$exports.createStore = $31eb592b83cf9070$var$createStore;
$31eb592b83cf9070$exports.default = $31eb592b83cf9070$var$vanilla;
$31eb592b83cf9070$exports = $31eb592b83cf9070$var$vanilla;
$31eb592b83cf9070$exports.createStore = $31eb592b83cf9070$var$createStore;
$31eb592b83cf9070$exports.default = $31eb592b83cf9070$exports;



var $35jnV = parcelRequire("35jnV");
var $bde5d6fa4950ca33$exports = {};
"use strict";

$bde5d6fa4950ca33$exports = (parcelRequire("bQ7uH"));


var $fe4f26fe77e76922$var$useDebugValue = $35jnV.useDebugValue;
var $fe4f26fe77e76922$var$useSyncExternalStoreWithSelector = $bde5d6fa4950ca33$exports.useSyncExternalStoreWithSelector;
var $fe4f26fe77e76922$var$didWarnAboutEqualityFn = false;
function $fe4f26fe77e76922$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = api.getState;
    var slice = $fe4f26fe77e76922$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getState, selector, equalityFn);
    $fe4f26fe77e76922$var$useDebugValue(slice);
    return slice;
}
var $fe4f26fe77e76922$var$createImpl = function createImpl(createState) {
    var api = typeof createState === "function" ? $31eb592b83cf9070$exports.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $fe4f26fe77e76922$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $fe4f26fe77e76922$var$create = function create(createState) {
    return createState ? $fe4f26fe77e76922$var$createImpl(createState) : $fe4f26fe77e76922$var$createImpl;
};
var $fe4f26fe77e76922$var$react = function(createState) {
    return $fe4f26fe77e76922$var$create(createState);
};
$fe4f26fe77e76922$exports.create = $fe4f26fe77e76922$var$create;
$fe4f26fe77e76922$exports.default = $fe4f26fe77e76922$var$react;
$fe4f26fe77e76922$exports.useStore = $fe4f26fe77e76922$var$useStore;
Object.keys($31eb592b83cf9070$exports).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call($fe4f26fe77e76922$exports, k)) Object.defineProperty($fe4f26fe77e76922$exports, k, {
        enumerable: true,
        get: function() {
            return $31eb592b83cf9070$exports[k];
        }
    });
});
$fe4f26fe77e76922$exports = $fe4f26fe77e76922$var$react;
$fe4f26fe77e76922$exports.create = $fe4f26fe77e76922$var$create;
$fe4f26fe77e76922$exports.useStore = $fe4f26fe77e76922$var$useStore;
$fe4f26fe77e76922$exports.createStore = $31eb592b83cf9070$exports.createStore;
$fe4f26fe77e76922$exports.default = $fe4f26fe77e76922$exports;


var $5124151a6726dbde$var$__defProp = Object.defineProperty;
var $5124151a6726dbde$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5124151a6726dbde$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5124151a6726dbde$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5124151a6726dbde$var$__defNormalProp = (obj, key, value)=>key in obj ? $5124151a6726dbde$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5124151a6726dbde$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5124151a6726dbde$var$__hasOwnProp.call(b, prop)) $5124151a6726dbde$var$__defNormalProp(a, prop, b[prop]);
    if ($5124151a6726dbde$var$__getOwnPropSymbols) {
        for (var prop of $5124151a6726dbde$var$__getOwnPropSymbols(b))if ($5124151a6726dbde$var$__propIsEnum.call(b, prop)) $5124151a6726dbde$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $5124151a6726dbde$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $5124151a6726dbde$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $5124151a6726dbde$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $5124151a6726dbde$var$errors = [];
function $5124151a6726dbde$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $5124151a6726dbde$var$getPrototypeOf = Object.getPrototypeOf;
function $5124151a6726dbde$export$541ac630993a4c84(value) {
    return !!value && !!value[$5124151a6726dbde$var$DRAFT_STATE];
}
function $5124151a6726dbde$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $5124151a6726dbde$var$isPlainObject(value) || Array.isArray(value) || !!value[$5124151a6726dbde$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$5124151a6726dbde$export$6ee2082928bcb0ee]) || $5124151a6726dbde$var$isMap(value) || $5124151a6726dbde$var$isSet(value);
}
var $5124151a6726dbde$var$objectCtorString = Object.prototype.constructor.toString();
function $5124151a6726dbde$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $5124151a6726dbde$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $5124151a6726dbde$var$objectCtorString;
}
function $5124151a6726dbde$export$22e8af3f75a010e3(value) {
    if (!$5124151a6726dbde$export$541ac630993a4c84(value)) $5124151a6726dbde$var$die(15, value);
    return value[$5124151a6726dbde$var$DRAFT_STATE].base_;
}
function $5124151a6726dbde$var$each(obj, iter) {
    if ($5124151a6726dbde$var$getArchtype(obj) === 0 /* Object */ ) Object.entries(obj).forEach(([key, value])=>{
        iter(key, value, obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $5124151a6726dbde$var$getArchtype(thing) {
    const state = thing[$5124151a6726dbde$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $5124151a6726dbde$var$isMap(thing) ? 2 /* Map */  : $5124151a6726dbde$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $5124151a6726dbde$var$has(thing, prop) {
    return $5124151a6726dbde$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $5124151a6726dbde$var$get(thing, prop) {
    return $5124151a6726dbde$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $5124151a6726dbde$var$set(thing, propOrOldValue, value) {
    const t = $5124151a6726dbde$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $5124151a6726dbde$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $5124151a6726dbde$var$isMap(target) {
    return target instanceof Map;
}
function $5124151a6726dbde$var$isSet(target) {
    return target instanceof Set;
}
function $5124151a6726dbde$var$latest(state) {
    return state.copy_ || state.base_;
}
function $5124151a6726dbde$var$shallowCopy(base, strict) {
    if ($5124151a6726dbde$var$isMap(base)) return new Map(base);
    if ($5124151a6726dbde$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    if (!strict && $5124151a6726dbde$var$isPlainObject(base)) {
        if (!$5124151a6726dbde$var$getPrototypeOf(base)) {
            const obj = /* @__PURE__ */ Object.create(null);
            return Object.assign(obj, base);
        }
        return $5124151a6726dbde$var$__spreadValues({}, base);
    }
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[$5124151a6726dbde$var$DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const desc = descriptors[key];
        if (desc.writable === false) {
            desc.writable = true;
            desc.configurable = true;
        }
        if (desc.get || desc.set) descriptors[key] = {
            configurable: true,
            writable: true,
            // could live with !!desc.set as well here...
            enumerable: desc.enumerable,
            value: base[key]
        };
    }
    return Object.create($5124151a6726dbde$var$getPrototypeOf(base), descriptors);
}
function $5124151a6726dbde$export$792f3d81ea979f55(obj, deep = false) {
    if ($5124151a6726dbde$var$isFrozen(obj) || $5124151a6726dbde$export$541ac630993a4c84(obj) || !$5124151a6726dbde$export$16e3aed3edb85946(obj)) return obj;
    if ($5124151a6726dbde$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $5124151a6726dbde$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) $5124151a6726dbde$var$each(obj, (_key, value)=>$5124151a6726dbde$export$792f3d81ea979f55(value, true), true);
    return obj;
}
function $5124151a6726dbde$var$dontMutateFrozenCollections() {
    $5124151a6726dbde$var$die(2);
}
function $5124151a6726dbde$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $5124151a6726dbde$var$plugins = {};
function $5124151a6726dbde$var$getPlugin(pluginKey) {
    const plugin = $5124151a6726dbde$var$plugins[pluginKey];
    if (!plugin) $5124151a6726dbde$var$die(0, pluginKey);
    return plugin;
}
function $5124151a6726dbde$var$loadPlugin(pluginKey, implementation) {
    if (!$5124151a6726dbde$var$plugins[pluginKey]) $5124151a6726dbde$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $5124151a6726dbde$var$currentScope;
function $5124151a6726dbde$var$getCurrentScope() {
    return $5124151a6726dbde$var$currentScope;
}
function $5124151a6726dbde$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $5124151a6726dbde$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $5124151a6726dbde$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $5124151a6726dbde$var$revokeScope(scope) {
    $5124151a6726dbde$var$leaveScope(scope);
    scope.drafts_.forEach($5124151a6726dbde$var$revokeDraft);
    scope.drafts_ = null;
}
function $5124151a6726dbde$var$leaveScope(scope) {
    if (scope === $5124151a6726dbde$var$currentScope) $5124151a6726dbde$var$currentScope = scope.parent_;
}
function $5124151a6726dbde$var$enterScope(immer2) {
    return $5124151a6726dbde$var$currentScope = $5124151a6726dbde$var$createScope($5124151a6726dbde$var$currentScope, immer2);
}
function $5124151a6726dbde$var$revokeDraft(draft) {
    const state = draft[$5124151a6726dbde$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $5124151a6726dbde$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$5124151a6726dbde$var$DRAFT_STATE].modified_) {
            $5124151a6726dbde$var$revokeScope(scope);
            $5124151a6726dbde$var$die(4);
        }
        if ($5124151a6726dbde$export$16e3aed3edb85946(result)) {
            result = $5124151a6726dbde$var$finalize(scope, result);
            if (!scope.parent_) $5124151a6726dbde$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $5124151a6726dbde$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$5124151a6726dbde$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $5124151a6726dbde$var$finalize(scope, baseDraft, []);
    $5124151a6726dbde$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $5124151a6726dbde$export$45b790e32b2810ee ? result : void 0;
}
function $5124151a6726dbde$var$finalize(rootScope, value, path) {
    if ($5124151a6726dbde$var$isFrozen(value)) return value;
    const state = value[$5124151a6726dbde$var$DRAFT_STATE];
    if (!state) {
        $5124151a6726dbde$var$each(value, (key, childValue)=>$5124151a6726dbde$var$finalizeProperty(rootScope, state, value, key, childValue, path), true);
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $5124151a6726dbde$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $5124151a6726dbde$var$each(resultEach, (key, childValue)=>$5124151a6726dbde$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $5124151a6726dbde$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $5124151a6726dbde$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $5124151a6726dbde$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($5124151a6726dbde$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$5124151a6726dbde$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $5124151a6726dbde$var$finalize(rootScope, childValue, path);
        $5124151a6726dbde$var$set(targetObject, prop, res);
        if ($5124151a6726dbde$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($5124151a6726dbde$export$16e3aed3edb85946(childValue) && !$5124151a6726dbde$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $5124151a6726dbde$var$finalize(rootScope, childValue);
        if (!parentState || !parentState.scope_.parent_) $5124151a6726dbde$var$maybeFreeze(rootScope, childValue);
    }
}
function $5124151a6726dbde$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $5124151a6726dbde$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $5124151a6726dbde$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $5124151a6726dbde$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $5124151a6726dbde$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $5124151a6726dbde$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $5124151a6726dbde$var$objectTraps = {
    get (state, prop) {
        if (prop === $5124151a6726dbde$var$DRAFT_STATE) return state;
        const source = $5124151a6726dbde$var$latest(state);
        if (!$5124151a6726dbde$var$has(source, prop)) return $5124151a6726dbde$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$5124151a6726dbde$export$16e3aed3edb85946(value)) return value;
        if (value === $5124151a6726dbde$var$peek(state.base_, prop)) {
            $5124151a6726dbde$var$prepareCopy(state);
            return state.copy_[prop] = $5124151a6726dbde$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $5124151a6726dbde$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($5124151a6726dbde$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $5124151a6726dbde$var$getDescriptorFromProto($5124151a6726dbde$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $5124151a6726dbde$var$peek($5124151a6726dbde$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$5124151a6726dbde$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($5124151a6726dbde$var$is(value, current2) && (value !== void 0 || $5124151a6726dbde$var$has(state.base_, prop))) return true;
            $5124151a6726dbde$var$prepareCopy(state);
            $5124151a6726dbde$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($5124151a6726dbde$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $5124151a6726dbde$var$prepareCopy(state);
            $5124151a6726dbde$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $5124151a6726dbde$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $5124151a6726dbde$var$die(11);
    },
    getPrototypeOf (state) {
        return $5124151a6726dbde$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $5124151a6726dbde$var$die(12);
    }
};
var $5124151a6726dbde$var$arrayTraps = {};
$5124151a6726dbde$var$each($5124151a6726dbde$var$objectTraps, (key, fn)=>{
    $5124151a6726dbde$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$5124151a6726dbde$var$arrayTraps.deleteProperty = function(state, prop) {
    return $5124151a6726dbde$var$arrayTraps.set.call(this, state, prop, void 0);
};
$5124151a6726dbde$var$arrayTraps.set = function(state, prop, value) {
    return $5124151a6726dbde$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $5124151a6726dbde$var$peek(draft, prop) {
    const state = draft[$5124151a6726dbde$var$DRAFT_STATE];
    const source = state ? $5124151a6726dbde$var$latest(state) : draft;
    return source[prop];
}
function $5124151a6726dbde$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $5124151a6726dbde$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $5124151a6726dbde$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $5124151a6726dbde$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $5124151a6726dbde$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $5124151a6726dbde$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $5124151a6726dbde$var$markChanged(state.parent_);
    }
}
function $5124151a6726dbde$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $5124151a6726dbde$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $5124151a6726dbde$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $5124151a6726dbde$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $5124151a6726dbde$var$die(7);
            let result;
            if ($5124151a6726dbde$export$16e3aed3edb85946(base)) {
                const scope = $5124151a6726dbde$var$enterScope(this);
                const proxy = $5124151a6726dbde$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $5124151a6726dbde$var$revokeScope(scope);
                    else $5124151a6726dbde$var$leaveScope(scope);
                }
                $5124151a6726dbde$var$usePatchesInScope(scope, patchListener);
                return $5124151a6726dbde$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $5124151a6726dbde$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $5124151a6726dbde$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $5124151a6726dbde$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $5124151a6726dbde$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$5124151a6726dbde$export$16e3aed3edb85946(base)) $5124151a6726dbde$var$die(8);
        if ($5124151a6726dbde$export$541ac630993a4c84(base)) base = $5124151a6726dbde$export$97aac956da55dae9(base);
        const scope = $5124151a6726dbde$var$enterScope(this);
        const proxy = $5124151a6726dbde$var$createProxy(base, void 0);
        proxy[$5124151a6726dbde$var$DRAFT_STATE].isManual_ = true;
        $5124151a6726dbde$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$5124151a6726dbde$var$DRAFT_STATE];
        if (!state || !state.isManual_) $5124151a6726dbde$var$die(9);
        const { scope_: scope } = state;
        $5124151a6726dbde$var$usePatchesInScope(scope, patchListener);
        return $5124151a6726dbde$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $5124151a6726dbde$var$getPlugin("Patches").applyPatches_;
        if ($5124151a6726dbde$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $5124151a6726dbde$var$createProxy(value, parent) {
    const draft = $5124151a6726dbde$var$isMap(value) ? $5124151a6726dbde$var$getPlugin("MapSet").proxyMap_(value, parent) : $5124151a6726dbde$var$isSet(value) ? $5124151a6726dbde$var$getPlugin("MapSet").proxySet_(value, parent) : $5124151a6726dbde$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $5124151a6726dbde$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $5124151a6726dbde$export$97aac956da55dae9(value) {
    if (!$5124151a6726dbde$export$541ac630993a4c84(value)) $5124151a6726dbde$var$die(10, value);
    return $5124151a6726dbde$var$currentImpl(value);
}
function $5124151a6726dbde$var$currentImpl(value) {
    if (!$5124151a6726dbde$export$16e3aed3edb85946(value) || $5124151a6726dbde$var$isFrozen(value)) return value;
    const state = value[$5124151a6726dbde$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $5124151a6726dbde$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $5124151a6726dbde$var$shallowCopy(value, true);
    $5124151a6726dbde$var$each(copy, (key, childValue)=>{
        $5124151a6726dbde$var$set(copy, key, $5124151a6726dbde$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $5124151a6726dbde$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $5124151a6726dbde$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $5124151a6726dbde$var$get(base_, key);
            const value = $5124151a6726dbde$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $5124151a6726dbde$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $5124151a6726dbde$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $5124151a6726dbde$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $5124151a6726dbde$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $5124151a6726dbde$var$die(errorOffset + 3);
                base = $5124151a6726dbde$var$get(base, p);
                if (typeof base !== "object") $5124151a6726dbde$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $5124151a6726dbde$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $5124151a6726dbde$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $5124151a6726dbde$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$5124151a6726dbde$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($5124151a6726dbde$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($5124151a6726dbde$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($5124151a6726dbde$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($5124151a6726dbde$var$has(obj, $5124151a6726dbde$export$6ee2082928bcb0ee)) cloned[$5124151a6726dbde$export$6ee2082928bcb0ee] = obj[$5124151a6726dbde$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($5124151a6726dbde$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $5124151a6726dbde$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $5124151a6726dbde$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$5124151a6726dbde$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5124151a6726dbde$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $5124151a6726dbde$var$latest(this[$5124151a6726dbde$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $5124151a6726dbde$var$latest(this[$5124151a6726dbde$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$5124151a6726dbde$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$5124151a6726dbde$var$latest(state).has(key) || $5124151a6726dbde$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $5124151a6726dbde$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$5124151a6726dbde$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $5124151a6726dbde$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$5124151a6726dbde$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5124151a6726dbde$var$latest(state).size) {
                prepareMapCopy(state);
                $5124151a6726dbde$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $5124151a6726dbde$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$5124151a6726dbde$var$DRAFT_STATE];
            $5124151a6726dbde$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$5124151a6726dbde$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $5124151a6726dbde$var$latest(state).get(key);
            if (state.finalized_ || !$5124151a6726dbde$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $5124151a6726dbde$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $5124151a6726dbde$var$latest(this[$5124151a6726dbde$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($5124151a6726dbde$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$5124151a6726dbde$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5124151a6726dbde$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $5124151a6726dbde$var$latest(this[$5124151a6726dbde$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$5124151a6726dbde$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$5124151a6726dbde$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $5124151a6726dbde$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$5124151a6726dbde$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $5124151a6726dbde$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$5124151a6726dbde$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5124151a6726dbde$var$latest(state).size) {
                prepareSetCopy(state);
                $5124151a6726dbde$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$5124151a6726dbde$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$5124151a6726dbde$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($5124151a6726dbde$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($5124151a6726dbde$export$16e3aed3edb85946(value)) {
                    const draft = $5124151a6726dbde$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $5124151a6726dbde$var$die(3, JSON.stringify($5124151a6726dbde$var$latest(state)));
    }
    $5124151a6726dbde$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $5124151a6726dbde$var$immer = new $5124151a6726dbde$export$aaadc6ff0f822719();
var $5124151a6726dbde$export$b46cabe22e78bc00 = $5124151a6726dbde$var$immer.produce;
var $5124151a6726dbde$export$4da66d41c9492c78 = $5124151a6726dbde$var$immer.produceWithPatches.bind($5124151a6726dbde$var$immer);
var $5124151a6726dbde$export$573f26f60825c493 = $5124151a6726dbde$var$immer.setAutoFreeze.bind($5124151a6726dbde$var$immer);
var $5124151a6726dbde$export$333ce65961cbe047 = $5124151a6726dbde$var$immer.setUseStrictShallowCopy.bind($5124151a6726dbde$var$immer);
var $5124151a6726dbde$export$a8b8e03e6bbe5473 = $5124151a6726dbde$var$immer.applyPatches.bind($5124151a6726dbde$var$immer);
var $5124151a6726dbde$export$3c3214997190395f = $5124151a6726dbde$var$immer.createDraft.bind($5124151a6726dbde$var$immer);
var $5124151a6726dbde$export$c60f5e69c521b528 = $5124151a6726dbde$var$immer.finishDraft.bind($5124151a6726dbde$var$immer);
function $5124151a6726dbde$export$c05b21e3257751e5(value) {
    return value;
}
function $5124151a6726dbde$export$20f911b3f8cf0b74(value) {
    return value;
}


const $078bc949f5227a17$var$useAppStore = (0, $fe4f26fe77e76922$exports.create)((set)=>({
        precision: 16,
        setPrecision: (v)=>set(()=>({
                    precision: Math.min(Math.max(v, 0), 16)
                })),
        tags: [],
        setTags: (v)=>set(()=>({
                    tags: v
                })),
        addTag: (v)=>set((0, $5124151a6726dbde$export$b46cabe22e78bc00)((state)=>{
                state.tags.push(v);
                state.tags = [
                    ...new Set(state.tags)
                ] // unique
                ;
            })),
        removeTag: (v)=>set((0, $5124151a6726dbde$export$b46cabe22e78bc00)((state)=>{
                state.tags = state.tags.filter((t)=>t !== v);
            }))
    }));
var $078bc949f5227a17$export$2e2bcd8739ae039 = $078bc949f5227a17$var$useAppStore;



const $5a88544a0e784883$var$useFileStore = (0, $fe4f26fe77e76922$exports.create)((set)=>({
        // current selected file
        selected: null,
        setSelected: (index)=>set(()=>({
                    selected: index
                })),
        // all files
        files: [],
        setFiles: (files)=>set(()=>({
                    files: files
                })),
        removeAll: ()=>set({
                files: []
            }),
        // last attached file time
        lastAttachedAt: null,
        setLastAttachedAt: (time)=>set(()=>({
                    lastAttachedAt: time
                }))
    }));
var $5a88544a0e784883$export$2e2bcd8739ae039 = $5a88544a0e784883$var$useFileStore;



const $2bb019ac2e75721b$var$useSceneStore = (0, $fe4f26fe77e76922$exports.create)((set)=>({
        // pixi container
        scene: null,
        setScene: (scene)=>set(()=>({
                    scene: scene
                })),
        // zoom (0.1x ~ 20x)
        scale: 1,
        setScale: (scale = 1)=>set(()=>({
                    scale: Math.max(0.1, Math.min(20, scale))
                })),
        addScale: (delta = 0)=>set((state)=>({
                    scale: Math.max(0.1, Math.min(20, state.scale + delta))
                }))
    }));
var $2bb019ac2e75721b$export$2e2bcd8739ae039 = $2bb019ac2e75721b$var$useSceneStore;




const $1a573d0e0cb11211$var$useShapeStore = (0, $fe4f26fe77e76922$exports.create)((set)=>({
        selected: null,
        setSelected: (shape)=>set({
                selected: shape
            }),
        shapesMap: {},
        add: (key, shape)=>set((0, $5124151a6726dbde$export$b46cabe22e78bc00)((state)=>{
                const shapes = state.shapesMap[key] || [];
                shapes.push(shape);
                state.shapesMap[key] = shapes;
            })),
        remove: (key, shape)=>set((0, $5124151a6726dbde$export$b46cabe22e78bc00)((state)=>{
                const shapes = state.shapesMap[key] || [];
                state.shapesMap[key] = shapes.filter((s)=>s.id !== shape.id);
            })),
        update: (fn)=>set((0, $5124151a6726dbde$export$b46cabe22e78bc00)(fn)),
        clear: ()=>set({
                shapesMap: {},
                selected: null
            })
    }));
var $1a573d0e0cb11211$export$2e2bcd8739ae039 = $1a573d0e0cb11211$var$useShapeStore;





var $35jnV = parcelRequire("35jnV");
class $de010c61f49f73ec$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($35jnV))).Component {
    constructor(){
        super();
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) return this.props.fallback;
        return this.props.children;
    }
}



var $86rqb = parcelRequire("86rqb");

var $35jnV = parcelRequire("35jnV");
var $2a17346401755832$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($2a17346401755832$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $2a17346401755832$exports = g;
});



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");

var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");

var $1OAmh = parcelRequire("1OAmh");

var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");


var $5wpQH = parcelRequire("5wpQH");

var $a7jdq = parcelRequire("a7jdq");

var $jBVCU = parcelRequire("jBVCU");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $fe2f4198fc7c85e5$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $fe2f4198fc7c85e5$export$2e2bcd8739ae039 = $fe2f4198fc7c85e5$var$getOverlayAlpha;



var $hZybU = parcelRequire("hZybU");


var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $057a8696a5b1fd2d$export$29cdb466b9b6f20b(slot) {
    return (0, $1reLR.default)("MuiPaper", slot);
}
const $057a8696a5b1fd2d$var$paperClasses = (0, $ibC2g.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $057a8696a5b1fd2d$export$2e2bcd8739ae039 = $057a8696a5b1fd2d$var$paperClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $2fbb4bae37b10470$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $2fbb4bae37b10470$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $057a8696a5b1fd2d$export$29cdb466b9b6f20b), classes);
};
const $2fbb4bae37b10470$var$PaperRoot = (0, $jBVCU.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $lfXYn.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $lfXYn.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $a7jdq.alpha)("#fff", (0, $fe2f4198fc7c85e5$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $a7jdq.alpha)("#fff", (0, $fe2f4198fc7c85e5$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $2fbb4bae37b10470$var$Paper = /*#__PURE__*/ $35jnV.forwardRef(function Paper(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $5NWw9.default)(props, $2fbb4bae37b10470$var$_excluded);
    const ownerState = (0, $lfXYn.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $2fbb4bae37b10470$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsx)($2fbb4bae37b10470$var$PaperRoot, (0, $lfXYn.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $3eTha.default)(classes.root, className),
        ref: ref
    }, other));
});
var $2fbb4bae37b10470$export$2e2bcd8739ae039 = $2fbb4bae37b10470$var$Paper;



var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $a664ed2ff095fe61$export$47a2da616e55e8e9(slot) {
    return (0, $1reLR.default)("MuiAppBar", slot);
}
const $a664ed2ff095fe61$var$appBarClasses = (0, $ibC2g.default)("MuiAppBar", [
    "root",
    "positionFixed",
    "positionAbsolute",
    "positionSticky",
    "positionStatic",
    "positionRelative",
    "colorDefault",
    "colorPrimary",
    "colorSecondary",
    "colorInherit",
    "colorTransparent"
]);
var $a664ed2ff095fe61$export$2e2bcd8739ae039 = $a664ed2ff095fe61$var$appBarClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $86dcc27043d7a1bd$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $86dcc27043d7a1bd$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $1OAmh.default)(color)}`,
            `position${(0, $1OAmh.default)(position)}`
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $a664ed2ff095fe61$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $86dcc27043d7a1bd$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(")", "")}, ${var2})` : var2;
const $86dcc27043d7a1bd$var$AppBarRoot = (0, $jBVCU.default)((0, $2fbb4bae37b10470$export$2e2bcd8739ae039), {
    name: "MuiAppBar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $1OAmh.default)(ownerState.position)}`],
            styles[`color${(0, $1OAmh.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $lfXYn.default)({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === "fixed" && {
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0,
        "@media print": {
            // Prevent the app bar to be visible on each printed page.
            position: "absolute"
        }
    }, ownerState.position === "absolute" && {
        position: "absolute",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "sticky" && {
        // ⚠️ sticky is not supported by IE11.
        position: "sticky",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "static" && {
        position: "static"
    }, ownerState.position === "relative" && {
        position: "relative"
    }, !theme.vars && (0, $lfXYn.default)({}, ownerState.color === "default" && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== "default" && ownerState.color !== "inherit" && ownerState.color !== "transparent" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, theme.palette.mode === "dark" && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === "transparent" && (0, $lfXYn.default)({
        backgroundColor: "transparent",
        color: "inherit"
    }, theme.palette.mode === "dark" && {
        backgroundImage: "none"
    })), theme.vars && (0, $lfXYn.default)({}, ownerState.color === "default" && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $86dcc27043d7a1bd$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $86dcc27043d7a1bd$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $86dcc27043d7a1bd$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $86dcc27043d7a1bd$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, {
        backgroundColor: "var(--AppBar-background)",
        color: ownerState.color === "inherit" ? "inherit" : "var(--AppBar-color)"
    }, ownerState.color === "transparent" && {
        backgroundImage: "none",
        backgroundColor: "transparent",
        color: "inherit"
    }));
});
const $86dcc27043d7a1bd$var$AppBar = /*#__PURE__*/ $35jnV.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiAppBar"
    });
    const { className: className, color: color = "primary", enableColorOnDark: enableColorOnDark = false, position: position = "fixed" } = props, other = (0, $5NWw9.default)(props, $86dcc27043d7a1bd$var$_excluded);
    const ownerState = (0, $lfXYn.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $86dcc27043d7a1bd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsx)($86dcc27043d7a1bd$var$AppBarRoot, (0, $lfXYn.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $3eTha.default)(classes.root, className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
var $86dcc27043d7a1bd$export$2e2bcd8739ae039 = $86dcc27043d7a1bd$var$AppBar;



var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $35jnV = parcelRequire("35jnV");

var $3eTha = parcelRequire("3eTha");

var $dsIT1 = parcelRequire("dsIT1");

var $dm2f8 = parcelRequire("dm2f8");
var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $a2Szr = parcelRequire("a2Szr");

var $d2FKK = parcelRequire("d2FKK");
const $5bbc7abd735c8dea$var$_excluded = [
    "sx"
];
const $5bbc7abd735c8dea$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $d2FKK.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $5bbc7abd735c8dea$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $5NWw9.default)(props, $5bbc7abd735c8dea$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $5bbc7abd735c8dea$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $a2Szr.isPlainObject)(result)) return systemProps;
        return (0, $lfXYn.default)({}, systemProps, result);
    };
    else finalSx = (0, $lfXYn.default)({}, systemProps, inSx);
    return (0, $lfXYn.default)({}, otherProps, {
        sx: finalSx
    });
}



var $lfge4 = parcelRequire("lfge4");

var $86rqb = parcelRequire("86rqb");
"use client";
const $1960e2e531a42f4e$var$_excluded = [
    "className",
    "component"
];
function $1960e2e531a42f4e$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $dsIT1.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $dm2f8.default));
    const Box = /*#__PURE__*/ $35jnV.forwardRef(function Box(inProps, ref) {
        const theme = (0, $lfge4.default)(defaultTheme);
        const _extendSxProp = (0, $5bbc7abd735c8dea$export$2e2bcd8739ae039)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $5NWw9.default)(_extendSxProp, $1960e2e531a42f4e$var$_excluded);
        return /*#__PURE__*/ (0, $86rqb.jsx)(BoxRoot, (0, $lfXYn.default)({
            as: component,
            ref: ref,
            className: (0, $3eTha.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $7WE1c = parcelRequire("7WE1c");

var $kPJLM = parcelRequire("kPJLM");

var $l5DLo = parcelRequire("l5DLo");
"use client";
const $f77466060e074182$var$defaultTheme = (0, $kPJLM.default)();
const $f77466060e074182$var$Box = (0, $1960e2e531a42f4e$export$2e2bcd8739ae039)({
    themeId: (0, $l5DLo.default),
    defaultTheme: $f77466060e074182$var$defaultTheme,
    defaultClassName: "MuiBox-root",
    generateClassName: (0, $7WE1c.default).generate
});
var $f77466060e074182$export$2e2bcd8739ae039 = $f77466060e074182$var$Box;



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");

var $hZybU = parcelRequire("hZybU");

var $jBVCU = parcelRequire("jBVCU");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $f57e8efd5999cc2a$export$b12cb262231eef32(slot) {
    return (0, $1reLR.default)("MuiToolbar", slot);
}
const $f57e8efd5999cc2a$var$toolbarClasses = (0, $ibC2g.default)("MuiToolbar", [
    "root",
    "gutters",
    "regular",
    "dense"
]);
var $f57e8efd5999cc2a$export$2e2bcd8739ae039 = $f57e8efd5999cc2a$var$toolbarClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $e29ac4f892082e51$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $e29ac4f892082e51$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            !disableGutters && "gutters",
            variant
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $f57e8efd5999cc2a$export$b12cb262231eef32), classes);
};
const $e29ac4f892082e51$var$ToolbarRoot = (0, $jBVCU.default)("div", {
    name: "MuiToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        position: "relative",
        display: "flex",
        alignItems: "center"
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === "dense" && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === "regular" && theme.mixins.toolbar);
const $e29ac4f892082e51$var$Toolbar = /*#__PURE__*/ $35jnV.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiToolbar"
    });
    const { className: className, component: component = "div", disableGutters: disableGutters = false, variant: variant = "regular" } = props, other = (0, $5NWw9.default)(props, $e29ac4f892082e51$var$_excluded);
    const ownerState = (0, $lfXYn.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $e29ac4f892082e51$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsx)($e29ac4f892082e51$var$ToolbarRoot, (0, $lfXYn.default)({
        as: component,
        className: (0, $3eTha.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $e29ac4f892082e51$export$2e2bcd8739ae039 = $e29ac4f892082e51$var$Toolbar;



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");


var $5wpQH = parcelRequire("5wpQH");

var $a7jdq = parcelRequire("a7jdq");

var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");

var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");


var $5wpQH = parcelRequire("5wpQH");

var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");

var $35jnV = parcelRequire("35jnV");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $c2bab75447a7e10d$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


"use client";
function $0516f23cce01a3cc$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $35jnV.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $c2bab75447a7e10d$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


"use client";
var $e6f4f6562381f94e$export$2e2bcd8739ae039 = (0, $0516f23cce01a3cc$export$2e2bcd8739ae039);



var $35jnV = parcelRequire("35jnV");

var $35jnV = parcelRequire("35jnV");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $6d8594980b4d41a4$var$useEnhancedEffect = typeof window !== "undefined" ? $35jnV.useLayoutEffect : $35jnV.useEffect;
var $6d8594980b4d41a4$export$2e2bcd8739ae039 = $6d8594980b4d41a4$var$useEnhancedEffect;


"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $6fd92d7c6a65060f$var$useEventCallback(fn) {
    const ref = $35jnV.useRef(fn);
    (0, $6d8594980b4d41a4$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $35jnV.useCallback((...args)=>// @ts-expect-error hide `this`
        // tslint:disable-next-line:ban-comma-operator
        (0, ref.current)(...args), []);
}
var $6fd92d7c6a65060f$export$2e2bcd8739ae039 = $6fd92d7c6a65060f$var$useEventCallback;


"use client";
var $177136a850dea437$export$2e2bcd8739ae039 = (0, $6fd92d7c6a65060f$export$2e2bcd8739ae039);



var $35jnV = parcelRequire("35jnV");
"use client";
let $4b23040a1d448740$var$hadKeyboardEvent = true;
let $4b23040a1d448740$var$hadFocusVisibleRecently = false;
let $4b23040a1d448740$var$hadFocusVisibleRecentlyTimeout;
const $4b23040a1d448740$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $4b23040a1d448740$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $4b23040a1d448740$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $4b23040a1d448740$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $4b23040a1d448740$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $4b23040a1d448740$var$handlePointerDown() {
    $4b23040a1d448740$var$hadKeyboardEvent = false;
}
function $4b23040a1d448740$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($4b23040a1d448740$var$hadFocusVisibleRecently) $4b23040a1d448740$var$hadKeyboardEvent = true;
    }
}
function $4b23040a1d448740$var$prepare(doc) {
    doc.addEventListener("keydown", $4b23040a1d448740$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $4b23040a1d448740$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $4b23040a1d448740$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $4b23040a1d448740$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $4b23040a1d448740$var$handleVisibilityChange, true);
}
function $4b23040a1d448740$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $4b23040a1d448740$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $4b23040a1d448740$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $4b23040a1d448740$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $4b23040a1d448740$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $4b23040a1d448740$var$handleVisibilityChange, true);
}
function $4b23040a1d448740$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $4b23040a1d448740$var$hadKeyboardEvent || $4b23040a1d448740$var$focusTriggersKeyboardModality(target);
}
function $4b23040a1d448740$export$2e2bcd8739ae039() {
    const ref = $35jnV.useCallback((node)=>{
        if (node != null) $4b23040a1d448740$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $35jnV.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $4b23040a1d448740$var$hadFocusVisibleRecently = true;
            window.clearTimeout($4b23040a1d448740$var$hadFocusVisibleRecentlyTimeout);
            $4b23040a1d448740$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(()=>{
                $4b23040a1d448740$var$hadFocusVisibleRecently = false;
            }, 100);
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($4b23040a1d448740$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


"use client";
var $b0ccb8cd06c388d8$export$2e2bcd8739ae039 = (0, $4b23040a1d448740$export$2e2bcd8739ae039);



var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $35jnV = parcelRequire("35jnV");


var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");
function $30c89250a9903203$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $a5ecb943f40eb316$export$2e2bcd8739ae039(o, p) {
    $a5ecb943f40eb316$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a5ecb943f40eb316$export$2e2bcd8739ae039(o, p);
}


function $bfc9633ee6338f89$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $a5ecb943f40eb316$export$2e2bcd8739ae039)(subClass, superClass);
}




var $35jnV = parcelRequire("35jnV");

var $35jnV = parcelRequire("35jnV");
var $e323f17231e6a093$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($35jnV))).createContext(null);



var $35jnV = parcelRequire("35jnV");
function $fc695d3fc6d79d47$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $35jnV.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $35jnV.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $fc695d3fc6d79d47$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $fc695d3fc6d79d47$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $fc695d3fc6d79d47$export$fa71e2345c31d7a2(props, onExited) {
    return $fc695d3fc6d79d47$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $35jnV.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $fc695d3fc6d79d47$var$getProp(child, "appear", props),
            enter: $fc695d3fc6d79d47$var$getProp(child, "enter", props),
            exit: $fc695d3fc6d79d47$var$getProp(child, "exit", props)
        });
    });
}
function $fc695d3fc6d79d47$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $fc695d3fc6d79d47$export$bbc8a025727ea824(nextProps.children);
    var children = $fc695d3fc6d79d47$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $35jnV.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $35jnV.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $35jnV.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $fc695d3fc6d79d47$var$getProp(child, "exit", nextProps),
            enter: $fc695d3fc6d79d47$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $35jnV.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $35jnV.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $35jnV.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $fc695d3fc6d79d47$var$getProp(child, "exit", nextProps),
            enter: $fc695d3fc6d79d47$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $256a34f64d1ef10c$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $256a34f64d1ef10c$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $256a34f64d1ef10c$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $bfc9633ee6338f89$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $30c89250a9903203$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $fc695d3fc6d79d47$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $fc695d3fc6d79d47$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $fc695d3fc6d79d47$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $lfXYn.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $5NWw9.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $256a34f64d1ef10c$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($35jnV))).createElement((0, $e323f17231e6a093$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($35jnV))).createElement((0, $e323f17231e6a093$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($35jnV))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($35jnV))).Component);
$256a34f64d1ef10c$var$TransitionGroup.propTypes = {};
$256a34f64d1ef10c$var$TransitionGroup.defaultProps = $256a34f64d1ef10c$var$defaultProps;
var $256a34f64d1ef10c$export$2e2bcd8739ae039 = $256a34f64d1ef10c$var$TransitionGroup;



var $3eTha = parcelRequire("3eTha");

var $UnJZz = parcelRequire("UnJZz");

var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $86rqb = parcelRequire("86rqb");
"use client";
function $c4a2e0f14f70ba58$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $35jnV.useState(false);
    const rippleClassName = (0, $3eTha.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $3eTha.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $35jnV.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $86rqb.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $86rqb.jsx)("span", {
            className: childClassName
        })
    });
}
var $c4a2e0f14f70ba58$export$2e2bcd8739ae039 = $c4a2e0f14f70ba58$var$Ripple;



var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $28f8c9534abde40a$export$b464606f735ab902(slot) {
    return (0, $1reLR.default)("MuiTouchRipple", slot);
}
const $28f8c9534abde40a$var$touchRippleClasses = (0, $ibC2g.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $28f8c9534abde40a$export$2e2bcd8739ae039 = $28f8c9534abde40a$var$touchRippleClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $2984a60cdb799879$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $2984a60cdb799879$var$_ = (t)=>t, $2984a60cdb799879$var$_t, $2984a60cdb799879$var$_t2, $2984a60cdb799879$var$_t3, $2984a60cdb799879$var$_t4;
const $2984a60cdb799879$var$DURATION = 550;
const $2984a60cdb799879$export$95d0c9356b2231a3 = 80;
const $2984a60cdb799879$var$enterKeyframe = (0, $UnJZz.keyframes)($2984a60cdb799879$var$_t || ($2984a60cdb799879$var$_t = $2984a60cdb799879$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $2984a60cdb799879$var$exitKeyframe = (0, $UnJZz.keyframes)($2984a60cdb799879$var$_t2 || ($2984a60cdb799879$var$_t2 = $2984a60cdb799879$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $2984a60cdb799879$var$pulsateKeyframe = (0, $UnJZz.keyframes)($2984a60cdb799879$var$_t3 || ($2984a60cdb799879$var$_t3 = $2984a60cdb799879$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $2984a60cdb799879$export$f6b7418508c72c25 = (0, $jBVCU.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $2984a60cdb799879$export$676cfe7b12693c4b = (0, $jBVCU.default)((0, $c4a2e0f14f70ba58$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($2984a60cdb799879$var$_t4 || ($2984a60cdb799879$var$_t4 = $2984a60cdb799879$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $28f8c9534abde40a$export$2e2bcd8739ae039).rippleVisible, $2984a60cdb799879$var$enterKeyframe, $2984a60cdb799879$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $28f8c9534abde40a$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $28f8c9534abde40a$export$2e2bcd8739ae039).child, (0, $28f8c9534abde40a$export$2e2bcd8739ae039).childLeaving, $2984a60cdb799879$var$exitKeyframe, $2984a60cdb799879$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $28f8c9534abde40a$export$2e2bcd8739ae039).childPulsate, $2984a60cdb799879$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $2984a60cdb799879$var$TouchRipple = /*#__PURE__*/ $35jnV.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $5NWw9.default)(props, $2984a60cdb799879$var$_excluded);
    const [ripples, setRipples] = $35jnV.useState([]);
    const nextKey = $35jnV.useRef(0);
    const rippleCallback = $35jnV.useRef(null);
    $35jnV.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $35jnV.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = $35jnV.useRef(0);
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $35jnV.useRef(null);
    const container = $35jnV.useRef(null);
    $35jnV.useEffect(()=>{
        return ()=>{
            if (startTimer.current) clearTimeout(startTimer.current);
        };
    }, []);
    const startCommit = $35jnV.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $86rqb.jsx)($2984a60cdb799879$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $3eTha.default)(classes.ripple, (0, $28f8c9534abde40a$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $3eTha.default)(classes.rippleVisible, (0, $28f8c9534abde40a$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $3eTha.default)(classes.ripplePulsate, (0, $28f8c9534abde40a$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $3eTha.default)(classes.child, (0, $28f8c9534abde40a$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $3eTha.default)(classes.childLeaving, (0, $28f8c9534abde40a$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $3eTha.default)(classes.childPulsate, (0, $28f8c9534abde40a$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $2984a60cdb799879$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $35jnV.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $2984a60cdb799879$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    const pulsate = $35jnV.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $35jnV.useCallback((event, cb)=>{
        clearTimeout(startTimer.current);
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $35jnV.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $86rqb.jsx)($2984a60cdb799879$export$f6b7418508c72c25, (0, $lfXYn.default)({
        className: (0, $3eTha.default)((0, $28f8c9534abde40a$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $86rqb.jsx)((0, $256a34f64d1ef10c$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $2984a60cdb799879$export$2e2bcd8739ae039 = $2984a60cdb799879$var$TouchRipple;



var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $337f92acd8c1e728$export$fccb0498dcd99783(slot) {
    return (0, $1reLR.default)("MuiButtonBase", slot);
}
const $337f92acd8c1e728$var$buttonBaseClasses = (0, $ibC2g.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $337f92acd8c1e728$export$2e2bcd8739ae039 = $337f92acd8c1e728$var$buttonBaseClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $38bba7b782da1f95$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $38bba7b782da1f95$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $5wpQH.default)(slots, (0, $337f92acd8c1e728$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $38bba7b782da1f95$export$7ec0dcc5e3cdcd36 = (0, $jBVCU.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $337f92acd8c1e728$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $38bba7b782da1f95$var$ButtonBase = /*#__PURE__*/ $35jnV.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $5NWw9.default)(props, $38bba7b782da1f95$var$_excluded);
    const buttonRef = $35jnV.useRef(null);
    const rippleRef = $35jnV.useRef(null);
    const handleRippleRef = (0, $e6f4f6562381f94e$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $b0ccb8cd06c388d8$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $35jnV.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $35jnV.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $35jnV.useState(false);
    $35jnV.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $35jnV.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $177136a850dea437$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $177136a850dea437$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $35jnV.useRef(false);
    const handleKeyDown = (0, $177136a850dea437$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $177136a850dea437$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $e6f4f6562381f94e$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $lfXYn.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $38bba7b782da1f95$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsxs)($38bba7b782da1f95$export$7ec0dcc5e3cdcd36, (0, $lfXYn.default)({
        as: ComponentProp,
        className: (0, $3eTha.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $86rqb.jsx)((0, $2984a60cdb799879$export$2e2bcd8739ae039), (0, $lfXYn.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $38bba7b782da1f95$export$2e2bcd8739ae039 = $38bba7b782da1f95$var$ButtonBase;



var $1OAmh = parcelRequire("1OAmh");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $4a0eb81a716bc138$export$5e8702d71474f093(slot) {
    return (0, $1reLR.default)("MuiIconButton", slot);
}
const $4a0eb81a716bc138$var$iconButtonClasses = (0, $ibC2g.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $4a0eb81a716bc138$export$2e2bcd8739ae039 = $4a0eb81a716bc138$var$iconButtonClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $0d33723cc471c46b$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $0d33723cc471c46b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $1OAmh.default)(color)}`,
            edge && `edge${(0, $1OAmh.default)(edge)}`,
            `size${(0, $1OAmh.default)(size)}`
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $4a0eb81a716bc138$export$5e8702d71474f093), classes);
};
const $0d33723cc471c46b$var$IconButtonRoot = (0, $jBVCU.default)((0, $38bba7b782da1f95$export$2e2bcd8739ae039), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $1OAmh.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $1OAmh.default)(ownerState.edge)}`],
            styles[`size${(0, $1OAmh.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $a7jdq.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $lfXYn.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $lfXYn.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $lfXYn.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $a7jdq.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $4a0eb81a716bc138$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $0d33723cc471c46b$var$IconButton = /*#__PURE__*/ $35jnV.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $5NWw9.default)(props, $0d33723cc471c46b$var$_excluded);
    const ownerState = (0, $lfXYn.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $0d33723cc471c46b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsx)($0d33723cc471c46b$var$IconButtonRoot, (0, $lfXYn.default)({
        className: (0, $3eTha.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $0d33723cc471c46b$export$2e2bcd8739ae039 = $0d33723cc471c46b$var$IconButton;



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");


var $lfXYn = parcelRequire("lfXYn");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $34edd9d120733306$export$e28348cc2430497(element) {
    return typeof element === "string";
}


function $04174780eb43f18a$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $34edd9d120733306$export$e28348cc2430497)(elementType)) return otherProps;
    return (0, $lfXYn.default)({}, otherProps, {
        ownerState: (0, $lfXYn.default)({}, otherProps.ownerState, ownerState)
    });
}


var $5wpQH = parcelRequire("5wpQH");

var $a7jdq = parcelRequire("a7jdq");

var $jBVCU = parcelRequire("jBVCU");
parcelRequire("35jnV");

var $lfge4 = parcelRequire("lfge4");

var $ghZ9O = parcelRequire("ghZ9O");

var $l5DLo = parcelRequire("l5DLo");
"use client";
function $e83902653e135773$export$2e2bcd8739ae039() {
    const theme = (0, $lfge4.default)((0, $ghZ9O.default));
    return theme[0, $l5DLo.default] || theme;
}



var $hZybU = parcelRequire("hZybU");

var $1OAmh = parcelRequire("1OAmh");

var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $35jnV = parcelRequire("35jnV");



var $5NWw9 = parcelRequire("5NWw9");



var $35jnV = parcelRequire("35jnV");

var $1332f67baac3a45c$export$2e2bcd8739ae039 = {
    disabled: false
};




var $760a5fcb0e3935ac$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $e6e36fc0496fc254$export$bb38bb9a1161268 = "unmounted";
var $e6e36fc0496fc254$export$84cbff306f539230 = "exited";
var $e6e36fc0496fc254$export$df38205c966be359 = "entering";
var $e6e36fc0496fc254$export$78e9e6e3e014d60a = "entered";
var $e6e36fc0496fc254$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $e6e36fc0496fc254$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bfc9633ee6338f89$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $e6e36fc0496fc254$export$84cbff306f539230;
                _this.appearStatus = $e6e36fc0496fc254$export$df38205c966be359;
            } else initialStatus = $e6e36fc0496fc254$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $e6e36fc0496fc254$export$bb38bb9a1161268;
        else initialStatus = $e6e36fc0496fc254$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $e6e36fc0496fc254$export$bb38bb9a1161268) return {
            status: $e6e36fc0496fc254$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $e6e36fc0496fc254$export$df38205c966be359 && status !== $e6e36fc0496fc254$export$78e9e6e3e014d60a) nextStatus = $e6e36fc0496fc254$export$df38205c966be359;
            } else if (status === $e6e36fc0496fc254$export$df38205c966be359 || status === $e6e36fc0496fc254$export$78e9e6e3e014d60a) nextStatus = $e6e36fc0496fc254$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $e6e36fc0496fc254$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($90e5093ac8ea5052$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $760a5fcb0e3935ac$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $e6e36fc0496fc254$export$84cbff306f539230) this.setState({
            status: $e6e36fc0496fc254$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($90e5093ac8ea5052$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $1332f67baac3a45c$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $e6e36fc0496fc254$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $e6e36fc0496fc254$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $e6e36fc0496fc254$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($90e5093ac8ea5052$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $1332f67baac3a45c$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $e6e36fc0496fc254$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $e6e36fc0496fc254$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $e6e36fc0496fc254$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($90e5093ac8ea5052$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $e6e36fc0496fc254$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $5NWw9.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($35jnV))).createElement((0, $e323f17231e6a093$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($35jnV))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($35jnV))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($35jnV))).Component);
$e6e36fc0496fc254$var$Transition.contextType = (0, $e323f17231e6a093$export$2e2bcd8739ae039);
$e6e36fc0496fc254$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $e6e36fc0496fc254$var$noop() {}
$e6e36fc0496fc254$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $e6e36fc0496fc254$var$noop,
    onEntering: $e6e36fc0496fc254$var$noop,
    onEntered: $e6e36fc0496fc254$var$noop,
    onExit: $e6e36fc0496fc254$var$noop,
    onExiting: $e6e36fc0496fc254$var$noop,
    onExited: $e6e36fc0496fc254$var$noop
};
$e6e36fc0496fc254$var$Transition.UNMOUNTED = $e6e36fc0496fc254$export$bb38bb9a1161268;
$e6e36fc0496fc254$var$Transition.EXITED = $e6e36fc0496fc254$export$84cbff306f539230;
$e6e36fc0496fc254$var$Transition.ENTERING = $e6e36fc0496fc254$export$df38205c966be359;
$e6e36fc0496fc254$var$Transition.ENTERED = $e6e36fc0496fc254$export$78e9e6e3e014d60a;
$e6e36fc0496fc254$var$Transition.EXITING = $e6e36fc0496fc254$export$4aacc83d4d59139f;
var $e6e36fc0496fc254$export$2e2bcd8739ae039 = $e6e36fc0496fc254$var$Transition;



const $0398bd8128d32282$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $0398bd8128d32282$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $86rqb = parcelRequire("86rqb");
"use client";
const $8d4b4494eba6d4ab$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $8d4b4494eba6d4ab$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $8d4b4494eba6d4ab$var$styles = {
    entering: {
        opacity: 1,
        transform: $8d4b4494eba6d4ab$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $8d4b4494eba6d4ab$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $8d4b4494eba6d4ab$var$Grow = /*#__PURE__*/ $35jnV.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $e6e36fc0496fc254$export$2e2bcd8739ae039) } = props, other = (0, $5NWw9.default)(props, $8d4b4494eba6d4ab$var$_excluded);
    const timer = $35jnV.useRef();
    const autoTimeout = $35jnV.useRef();
    const theme = (0, $e83902653e135773$export$2e2bcd8739ae039)();
    const nodeRef = $35jnV.useRef(null);
    const handleRef = (0, $e6f4f6562381f94e$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $0398bd8128d32282$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $0398bd8128d32282$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $8d4b4494eba6d4ab$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $0398bd8128d32282$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $8d4b4494eba6d4ab$var$isWebKit154 ? duration : duration * 0.666,
                delay: $8d4b4494eba6d4ab$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $8d4b4494eba6d4ab$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    $35jnV.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $86rqb.jsx)(TransitionComponent, (0, $lfXYn.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $35jnV.cloneElement(children, (0, $lfXYn.default)({
                style: (0, $lfXYn.default)({
                    opacity: 0,
                    transform: $8d4b4494eba6d4ab$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $8d4b4494eba6d4ab$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$8d4b4494eba6d4ab$var$Grow.muiSupportAuto = true;
var $8d4b4494eba6d4ab$export$2e2bcd8739ae039 = $8d4b4494eba6d4ab$var$Grow;



var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $35jnV = parcelRequire("35jnV");
function $0634ff1c5e38c440$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $a72988847d4d19be$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $3ea8ecfa2dbfffa5$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $a72988847d4d19be$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $3ea8ecfa2dbfffa5$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $a72988847d4d19be$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $3ea8ecfa2dbfffa5$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $a72988847d4d19be$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $8096dc88465fe03e$export$8960430cfd85939f = Math.max;
var $8096dc88465fe03e$export$96ec731ed4dcb222 = Math.min;
var $8096dc88465fe03e$export$2077e0241d6afd3c = Math.round;



function $d1b60a9a17dd53c6$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $b9c53df79f5170d0$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $d1b60a9a17dd53c6$export$2e2bcd8739ae039)());
}


function $5eba8ffe1dbc1891$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $3ea8ecfa2dbfffa5$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $8096dc88465fe03e$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $8096dc88465fe03e$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $3ea8ecfa2dbfffa5$export$45a5e7f76e0caa8d)(element) ? (0, $a72988847d4d19be$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b9c53df79f5170d0$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $7fd204fefda1191a$export$2e2bcd8739ae039(node) {
    var win = (0, $a72988847d4d19be$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $55e17a49c2068348$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $794f657e8ecfce10$export$2e2bcd8739ae039(node) {
    if (node === (0, $a72988847d4d19be$export$2e2bcd8739ae039)(node) || !(0, $3ea8ecfa2dbfffa5$export$1b3bfaa9684536aa)(node)) return (0, $7fd204fefda1191a$export$2e2bcd8739ae039)(node);
    else return (0, $55e17a49c2068348$export$2e2bcd8739ae039)(node);
}


function $004cc7277e047174$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $dc75c1f0aea19120$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $3ea8ecfa2dbfffa5$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $1039f17dbcdf1329$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $5eba8ffe1dbc1891$export$2e2bcd8739ae039)((0, $dc75c1f0aea19120$export$2e2bcd8739ae039)(element)).left + (0, $7fd204fefda1191a$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $078ff6cfbe93a3c8$export$2e2bcd8739ae039(element) {
    return (0, $a72988847d4d19be$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $3eed446b467f408f$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $078ff6cfbe93a3c8$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $9b64eae295e89c4f$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $8096dc88465fe03e$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $8096dc88465fe03e$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $9b64eae295e89c4f$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $3ea8ecfa2dbfffa5$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $3ea8ecfa2dbfffa5$export$1b3bfaa9684536aa)(offsetParent) && $9b64eae295e89c4f$var$isElementScaled(offsetParent);
    var documentElement = (0, $dc75c1f0aea19120$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $5eba8ffe1dbc1891$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $004cc7277e047174$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $3eed446b467f408f$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $794f657e8ecfce10$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $3ea8ecfa2dbfffa5$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $5eba8ffe1dbc1891$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $1039f17dbcdf1329$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $8d88b3bdebc3db01$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $5eba8ffe1dbc1891$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $cae02f0df539c0fb$export$2e2bcd8739ae039(element) {
    if ((0, $004cc7277e047174$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $3ea8ecfa2dbfffa5$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $dc75c1f0aea19120$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $21124b43d721fb7d$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $004cc7277e047174$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $3ea8ecfa2dbfffa5$export$1b3bfaa9684536aa)(node) && (0, $3eed446b467f408f$export$2e2bcd8739ae039)(node)) return node;
    return $21124b43d721fb7d$export$2e2bcd8739ae039((0, $cae02f0df539c0fb$export$2e2bcd8739ae039)(node));
}





function $86422ffee72ba78a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $21124b43d721fb7d$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $a72988847d4d19be$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $3eed446b467f408f$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($86422ffee72ba78a$export$2e2bcd8739ae039((0, $cae02f0df539c0fb$export$2e2bcd8739ae039)(target)));
}







function $adb50824f7157d77$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $004cc7277e047174$export$2e2bcd8739ae039)(element)) >= 0;
}




function $894c08f4f391dde2$var$getTrueOffsetParent(element) {
    if (!(0, $3ea8ecfa2dbfffa5$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $078ff6cfbe93a3c8$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $894c08f4f391dde2$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $d1b60a9a17dd53c6$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $d1b60a9a17dd53c6$export$2e2bcd8739ae039)());
    if (isIE && (0, $3ea8ecfa2dbfffa5$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $078ff6cfbe93a3c8$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $cae02f0df539c0fb$export$2e2bcd8739ae039)(element);
    if ((0, $3ea8ecfa2dbfffa5$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $3ea8ecfa2dbfffa5$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $004cc7277e047174$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $078ff6cfbe93a3c8$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $894c08f4f391dde2$export$2e2bcd8739ae039(element) {
    var window = (0, $a72988847d4d19be$export$2e2bcd8739ae039)(element);
    var offsetParent = $894c08f4f391dde2$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $adb50824f7157d77$export$2e2bcd8739ae039)(offsetParent) && (0, $078ff6cfbe93a3c8$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $894c08f4f391dde2$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $004cc7277e047174$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $004cc7277e047174$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $078ff6cfbe93a3c8$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $894c08f4f391dde2$var$getContainingBlock(element) || window;
}


var $cf2fc27dd4d7e6cb$export$1e95b668f3b82d = "top";
var $cf2fc27dd4d7e6cb$export$40e543e69a8b3fbb = "bottom";
var $cf2fc27dd4d7e6cb$export$79ffe56a765070d2 = "right";
var $cf2fc27dd4d7e6cb$export$eabcd2c8791e7bf4 = "left";
var $cf2fc27dd4d7e6cb$export$dfb5619354ba860 = "auto";
var $cf2fc27dd4d7e6cb$export$aec2ce47c367b8c3 = [
    $cf2fc27dd4d7e6cb$export$1e95b668f3b82d,
    $cf2fc27dd4d7e6cb$export$40e543e69a8b3fbb,
    $cf2fc27dd4d7e6cb$export$79ffe56a765070d2,
    $cf2fc27dd4d7e6cb$export$eabcd2c8791e7bf4
];
var $cf2fc27dd4d7e6cb$export$b3571188c770cc5a = "start";
var $cf2fc27dd4d7e6cb$export$bd5df0f255a350f8 = "end";
var $cf2fc27dd4d7e6cb$export$390fd549c5303b4d = "clippingParents";
var $cf2fc27dd4d7e6cb$export$d7b7311ec04a3e8f = "viewport";
var $cf2fc27dd4d7e6cb$export$ae5ab1c730825774 = "popper";
var $cf2fc27dd4d7e6cb$export$ca50aac9f3ba507f = "reference";
var $cf2fc27dd4d7e6cb$export$368f9a87e87fa4e1 = /*#__PURE__*/ $cf2fc27dd4d7e6cb$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $cf2fc27dd4d7e6cb$export$b3571188c770cc5a,
        placement + "-" + $cf2fc27dd4d7e6cb$export$bd5df0f255a350f8
    ]);
}, []);
var $cf2fc27dd4d7e6cb$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($cf2fc27dd4d7e6cb$export$aec2ce47c367b8c3, [
    $cf2fc27dd4d7e6cb$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $cf2fc27dd4d7e6cb$export$b3571188c770cc5a,
        placement + "-" + $cf2fc27dd4d7e6cb$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $cf2fc27dd4d7e6cb$export$421679a7c3d56e = "beforeRead";
var $cf2fc27dd4d7e6cb$export$aafa59e2e03f2942 = "read";
var $cf2fc27dd4d7e6cb$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $cf2fc27dd4d7e6cb$export$c65e99957a05207c = "beforeMain";
var $cf2fc27dd4d7e6cb$export$f22da7240b7add18 = "main";
var $cf2fc27dd4d7e6cb$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $cf2fc27dd4d7e6cb$export$8d4d2d70e7d46032 = "beforeWrite";
var $cf2fc27dd4d7e6cb$export$68d8715fc104d294 = "write";
var $cf2fc27dd4d7e6cb$export$70a6e5159acce2e6 = "afterWrite";
var $cf2fc27dd4d7e6cb$export$d087d3878fdf71d5 = [
    $cf2fc27dd4d7e6cb$export$421679a7c3d56e,
    $cf2fc27dd4d7e6cb$export$aafa59e2e03f2942,
    $cf2fc27dd4d7e6cb$export$6964f6c886723980,
    $cf2fc27dd4d7e6cb$export$c65e99957a05207c,
    $cf2fc27dd4d7e6cb$export$f22da7240b7add18,
    $cf2fc27dd4d7e6cb$export$bab79516f2d662fe,
    $cf2fc27dd4d7e6cb$export$8d4d2d70e7d46032,
    $cf2fc27dd4d7e6cb$export$68d8715fc104d294,
    $cf2fc27dd4d7e6cb$export$70a6e5159acce2e6
];


function $84d2db6e036c8574$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $84d2db6e036c8574$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $84d2db6e036c8574$var$order(modifiers); // order based on phase
    return (0, $cf2fc27dd4d7e6cb$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $b813eb9ba7885084$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $d2d028c5e70bc9c9$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $f44711f86c8d2d2a$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $f44711f86c8d2d2a$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $f44711f86c8d2d2a$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $f44711f86c8d2d2a$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $f44711f86c8d2d2a$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $3ea8ecfa2dbfffa5$export$45a5e7f76e0caa8d)(reference) ? (0, $86422ffee72ba78a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $86422ffee72ba78a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $86422ffee72ba78a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $84d2db6e036c8574$export$2e2bcd8739ae039)((0, $d2d028c5e70bc9c9$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$f44711f86c8d2d2a$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $9b64eae295e89c4f$export$2e2bcd8739ae039)(reference, (0, $894c08f4f391dde2$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $8d88b3bdebc3db01$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $b813eb9ba7885084$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$f44711f86c8d2d2a$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $f44711f86c8d2d2a$export$8f7491d57c8f97a9 = /*#__PURE__*/ $f44711f86c8d2d2a$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $ed63f1ef0feafe47$var$passive = {
    passive: true
};
function $ed63f1ef0feafe47$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $a72988847d4d19be$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $ed63f1ef0feafe47$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $ed63f1ef0feafe47$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $ed63f1ef0feafe47$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $ed63f1ef0feafe47$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ed63f1ef0feafe47$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $ed63f1ef0feafe47$var$effect,
    data: {}
};



function $8931f0a1d93d291b$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $51667b6461a28faf$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $e184ae44b9be6fe9$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $c624893b16bb870f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $8931f0a1d93d291b$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $51667b6461a28faf$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cf2fc27dd4d7e6cb$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cf2fc27dd4d7e6cb$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cf2fc27dd4d7e6cb$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cf2fc27dd4d7e6cb$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $e184ae44b9be6fe9$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $cf2fc27dd4d7e6cb$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cf2fc27dd4d7e6cb$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $759970408d9561b4$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $c624893b16bb870f$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $759970408d9561b4$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $759970408d9561b4$var$popperOffsets,
    data: {}
};










var $70740a9aec1dadc9$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $70740a9aec1dadc9$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $8096dc88465fe03e$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $8096dc88465fe03e$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $70740a9aec1dadc9$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $cf2fc27dd4d7e6cb$export$eabcd2c8791e7bf4);
    var sideY = (0, $cf2fc27dd4d7e6cb$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $894c08f4f391dde2$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $a72988847d4d19be$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $dc75c1f0aea19120$export$2e2bcd8739ae039)(popper);
            if ((0, $078ff6cfbe93a3c8$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cf2fc27dd4d7e6cb$export$1e95b668f3b82d) || (placement === (0, $cf2fc27dd4d7e6cb$export$eabcd2c8791e7bf4) || placement === (0, $cf2fc27dd4d7e6cb$export$79ffe56a765070d2)) && variation === (0, $cf2fc27dd4d7e6cb$export$bd5df0f255a350f8)) {
            sideY = (0, $cf2fc27dd4d7e6cb$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cf2fc27dd4d7e6cb$export$eabcd2c8791e7bf4) || (placement === (0, $cf2fc27dd4d7e6cb$export$1e95b668f3b82d) || placement === (0, $cf2fc27dd4d7e6cb$export$40e543e69a8b3fbb)) && variation === (0, $cf2fc27dd4d7e6cb$export$bd5df0f255a350f8)) {
            sideX = (0, $cf2fc27dd4d7e6cb$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $70740a9aec1dadc9$var$unsetSides);
    var _ref4 = roundOffsets === true ? $70740a9aec1dadc9$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $a72988847d4d19be$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $70740a9aec1dadc9$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $8931f0a1d93d291b$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $51667b6461a28faf$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $70740a9aec1dadc9$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $70740a9aec1dadc9$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $70740a9aec1dadc9$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $70740a9aec1dadc9$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $18dc2daf544f0a59$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $3ea8ecfa2dbfffa5$export$1b3bfaa9684536aa)(element) || !(0, $004cc7277e047174$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $18dc2daf544f0a59$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $3ea8ecfa2dbfffa5$export$1b3bfaa9684536aa)(element) || !(0, $004cc7277e047174$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $18dc2daf544f0a59$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $18dc2daf544f0a59$var$applyStyles,
    effect: $18dc2daf544f0a59$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $1499733bda508cbb$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $8931f0a1d93d291b$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $cf2fc27dd4d7e6cb$export$eabcd2c8791e7bf4),
        (0, $cf2fc27dd4d7e6cb$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cf2fc27dd4d7e6cb$export$eabcd2c8791e7bf4),
        (0, $cf2fc27dd4d7e6cb$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $1499733bda508cbb$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cf2fc27dd4d7e6cb$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $1499733bda508cbb$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $1499733bda508cbb$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $1499733bda508cbb$var$offset
};


var $de9bc93792e7867f$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $de9bc93792e7867f$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $de9bc93792e7867f$var$hash[matched];
    });
}



var $463e9131e1ad1df3$var$hash = {
    start: "end",
    end: "start"
};
function $463e9131e1ad1df3$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $463e9131e1ad1df3$var$hash[matched];
    });
}







function $0a70b4236bc6f063$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $a72988847d4d19be$export$2e2bcd8739ae039)(element);
    var html = (0, $dc75c1f0aea19120$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b9c53df79f5170d0$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $1039f17dbcdf1329$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $4347dd8eb4cb7e2c$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $dc75c1f0aea19120$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $7fd204fefda1191a$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $8096dc88465fe03e$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $8096dc88465fe03e$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $1039f17dbcdf1329$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $078ff6cfbe93a3c8$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $8096dc88465fe03e$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $74a82ac9eb49b07a$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $3ea8ecfa2dbfffa5$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $f5f65c567645342c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $832a43da156d4c37$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $5eba8ffe1dbc1891$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $832a43da156d4c37$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cf2fc27dd4d7e6cb$export$d7b7311ec04a3e8f) ? (0, $f5f65c567645342c$export$2e2bcd8739ae039)((0, $0a70b4236bc6f063$export$2e2bcd8739ae039)(element, strategy)) : (0, $3ea8ecfa2dbfffa5$export$45a5e7f76e0caa8d)(clippingParent) ? $832a43da156d4c37$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $f5f65c567645342c$export$2e2bcd8739ae039)((0, $4347dd8eb4cb7e2c$export$2e2bcd8739ae039)((0, $dc75c1f0aea19120$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $832a43da156d4c37$var$getClippingParents(element) {
    var clippingParents = (0, $86422ffee72ba78a$export$2e2bcd8739ae039)((0, $cae02f0df539c0fb$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $078ff6cfbe93a3c8$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $3ea8ecfa2dbfffa5$export$1b3bfaa9684536aa)(element) ? (0, $894c08f4f391dde2$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $3ea8ecfa2dbfffa5$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $3ea8ecfa2dbfffa5$export$45a5e7f76e0caa8d)(clippingParent) && (0, $74a82ac9eb49b07a$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $004cc7277e047174$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $832a43da156d4c37$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $832a43da156d4c37$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $832a43da156d4c37$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $8096dc88465fe03e$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $8096dc88465fe03e$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $8096dc88465fe03e$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8096dc88465fe03e$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $832a43da156d4c37$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $175ef2e2d451ecd3$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $701c761235ce1f30$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $175ef2e2d451ecd3$export$2e2bcd8739ae039)(), paddingObject);
}


function $082d295e1876594f$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $39f40cb1d0e1fe54$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cf2fc27dd4d7e6cb$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cf2fc27dd4d7e6cb$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cf2fc27dd4d7e6cb$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $701c761235ce1f30$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $082d295e1876594f$export$2e2bcd8739ae039)(padding, (0, $cf2fc27dd4d7e6cb$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $cf2fc27dd4d7e6cb$export$ae5ab1c730825774) ? (0, $cf2fc27dd4d7e6cb$export$ca50aac9f3ba507f) : (0, $cf2fc27dd4d7e6cb$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $832a43da156d4c37$export$2e2bcd8739ae039)((0, $3ea8ecfa2dbfffa5$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $dc75c1f0aea19120$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $5eba8ffe1dbc1891$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $c624893b16bb870f$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $f5f65c567645342c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cf2fc27dd4d7e6cb$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cf2fc27dd4d7e6cb$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cf2fc27dd4d7e6cb$export$79ffe56a765070d2),
                (0, $cf2fc27dd4d7e6cb$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cf2fc27dd4d7e6cb$export$1e95b668f3b82d),
                (0, $cf2fc27dd4d7e6cb$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $e7207bef36204a3a$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cf2fc27dd4d7e6cb$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $51667b6461a28faf$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $cf2fc27dd4d7e6cb$export$368f9a87e87fa4e1) : (0, $cf2fc27dd4d7e6cb$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $51667b6461a28faf$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $cf2fc27dd4d7e6cb$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $39f40cb1d0e1fe54$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $8931f0a1d93d291b$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $f62e347a854e6adb$var$getExpandedFallbackPlacements(placement) {
    if ((0, $8931f0a1d93d291b$export$2e2bcd8739ae039)(placement) === (0, $cf2fc27dd4d7e6cb$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $de9bc93792e7867f$export$2e2bcd8739ae039)(placement);
    return [
        (0, $463e9131e1ad1df3$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $463e9131e1ad1df3$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $f62e347a854e6adb$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $8931f0a1d93d291b$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $de9bc93792e7867f$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $f62e347a854e6adb$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $8931f0a1d93d291b$export$2e2bcd8739ae039)(placement) === (0, $cf2fc27dd4d7e6cb$export$dfb5619354ba860) ? (0, $e7207bef36204a3a$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $8931f0a1d93d291b$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $51667b6461a28faf$export$2e2bcd8739ae039)(placement) === (0, $cf2fc27dd4d7e6cb$export$b3571188c770cc5a);
        var isVertical = [
            (0, $cf2fc27dd4d7e6cb$export$1e95b668f3b82d),
            (0, $cf2fc27dd4d7e6cb$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $39f40cb1d0e1fe54$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cf2fc27dd4d7e6cb$export$79ffe56a765070d2) : (0, $cf2fc27dd4d7e6cb$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $cf2fc27dd4d7e6cb$export$40e543e69a8b3fbb) : (0, $cf2fc27dd4d7e6cb$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $de9bc93792e7867f$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $de9bc93792e7867f$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $f62e347a854e6adb$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $f62e347a854e6adb$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $a5898b651b0de42f$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $e5fcf3ad94b3fea3$export$f28d906d67a997f3(min, value, max) {
    return (0, $8096dc88465fe03e$export$8960430cfd85939f)(min, (0, $8096dc88465fe03e$export$96ec731ed4dcb222)(value, max));
}
function $e5fcf3ad94b3fea3$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $e5fcf3ad94b3fea3$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $cc9800261bdd9a80$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $39f40cb1d0e1fe54$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $8931f0a1d93d291b$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $51667b6461a28faf$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $e184ae44b9be6fe9$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $a5898b651b0de42f$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $cf2fc27dd4d7e6cb$export$1e95b668f3b82d) : (0, $cf2fc27dd4d7e6cb$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $cf2fc27dd4d7e6cb$export$40e543e69a8b3fbb) : (0, $cf2fc27dd4d7e6cb$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cf2fc27dd4d7e6cb$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cf2fc27dd4d7e6cb$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $8d88b3bdebc3db01$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $175ef2e2d451ecd3$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $e5fcf3ad94b3fea3$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $894c08f4f391dde2$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $e5fcf3ad94b3fea3$export$f28d906d67a997f3)(tether ? (0, $8096dc88465fe03e$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $8096dc88465fe03e$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $cf2fc27dd4d7e6cb$export$1e95b668f3b82d) : (0, $cf2fc27dd4d7e6cb$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $cf2fc27dd4d7e6cb$export$40e543e69a8b3fbb) : (0, $cf2fc27dd4d7e6cb$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cf2fc27dd4d7e6cb$export$1e95b668f3b82d),
            (0, $cf2fc27dd4d7e6cb$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $e5fcf3ad94b3fea3$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $e5fcf3ad94b3fea3$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cc9800261bdd9a80$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $cc9800261bdd9a80$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $22829263fb4dd936$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $701c761235ce1f30$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $082d295e1876594f$export$2e2bcd8739ae039)(padding, (0, $cf2fc27dd4d7e6cb$export$aec2ce47c367b8c3)));
};
function $22829263fb4dd936$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $8931f0a1d93d291b$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $e184ae44b9be6fe9$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $cf2fc27dd4d7e6cb$export$eabcd2c8791e7bf4),
        (0, $cf2fc27dd4d7e6cb$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $22829263fb4dd936$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $8d88b3bdebc3db01$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $cf2fc27dd4d7e6cb$export$1e95b668f3b82d) : (0, $cf2fc27dd4d7e6cb$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $cf2fc27dd4d7e6cb$export$40e543e69a8b3fbb) : (0, $cf2fc27dd4d7e6cb$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $894c08f4f391dde2$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $e5fcf3ad94b3fea3$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $22829263fb4dd936$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $74a82ac9eb49b07a$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $22829263fb4dd936$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $22829263fb4dd936$var$arrow,
    effect: $22829263fb4dd936$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $3116118a9eb50591$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $3116118a9eb50591$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cf2fc27dd4d7e6cb$export$1e95b668f3b82d),
        (0, $cf2fc27dd4d7e6cb$export$79ffe56a765070d2),
        (0, $cf2fc27dd4d7e6cb$export$40e543e69a8b3fbb),
        (0, $cf2fc27dd4d7e6cb$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $3116118a9eb50591$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $39f40cb1d0e1fe54$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $39f40cb1d0e1fe54$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $3116118a9eb50591$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $3116118a9eb50591$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $3116118a9eb50591$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $3116118a9eb50591$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $3116118a9eb50591$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $3116118a9eb50591$var$hide
};




var $20edfd5468513f4d$export$d34966752335dd47 = [
    (0, $ed63f1ef0feafe47$export$2e2bcd8739ae039),
    (0, $759970408d9561b4$export$2e2bcd8739ae039),
    (0, $70740a9aec1dadc9$export$2e2bcd8739ae039),
    (0, $18dc2daf544f0a59$export$2e2bcd8739ae039),
    (0, $1499733bda508cbb$export$2e2bcd8739ae039),
    (0, $f62e347a854e6adb$export$2e2bcd8739ae039),
    (0, $cc9800261bdd9a80$export$2e2bcd8739ae039),
    (0, $22829263fb4dd936$export$2e2bcd8739ae039),
    (0, $3116118a9eb50591$export$2e2bcd8739ae039)
];
var $20edfd5468513f4d$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $f44711f86c8d2d2a$export$ed5e13716264f202)({
    defaultModifiers: $20edfd5468513f4d$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $5wpQH = parcelRequire("5wpQH");

var $35jnV = parcelRequire("35jnV");




var $86rqb = parcelRequire("86rqb");
"use client";
function $37b10cb8da062c7a$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $37b10cb8da062c7a$export$602eac185826482c = /*#__PURE__*/ $35jnV.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $35jnV.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $0516f23cce01a3cc$export$2e2bcd8739ae039)(/*#__PURE__*/ $35jnV.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $6d8594980b4d41a4$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($37b10cb8da062c7a$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $6d8594980b4d41a4$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $c2bab75447a7e10d$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $c2bab75447a7e10d$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $35jnV.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $35jnV.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $86rqb.jsx)($35jnV.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $86rqb.jsx)($35jnV.Fragment, {
        children: mountNode ? /*#__PURE__*/ $90e5093ac8ea5052$exports.createPortal(children, mountNode) : mountNode
    });
});



var $1reLR = parcelRequire("1reLR");

var $ibC2g = parcelRequire("ibC2g");
function $cf0abb1c1c7eb162$export$1b69b6cd0fa638a1(slot) {
    return (0, $1reLR.default)("MuiPopper", slot);
}
const $cf0abb1c1c7eb162$export$b6aa214021e734b0 = (0, $ibC2g.default)("MuiPopper", [
    "root"
]);



var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");



var $lfXYn = parcelRequire("lfXYn");

var $3eTha = parcelRequire("3eTha");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $fdc0f5c8deb0c27f$export$24d5698b57eff81c(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $fb11bd7193d4456b$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $9cc205cd3af5ac3e$export$b01d1e419b049226(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $3eTha.default)(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
        const mergedStyle = (0, $lfXYn.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $lfXYn.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $fdc0f5c8deb0c27f$export$24d5698b57eff81c)((0, $lfXYn.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $fb11bd7193d4456b$export$2ac0fa4d3a39be45)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $fb11bd7193d4456b$export$2ac0fa4d3a39be45)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $3eTha.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $lfXYn.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $lfXYn.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $3856ea31f1e874f3$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}


"use client";
const $de1586982a0c1b8f$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $de1586982a0c1b8f$export$1e5c9e6e4e15efe3(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $5NWw9.default)(parameters, $de1586982a0c1b8f$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $3856ea31f1e874f3$export$308c24034cde71de)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $9cc205cd3af5ac3e$export$b01d1e419b049226)((0, $lfXYn.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $0516f23cce01a3cc$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $04174780eb43f18a$export$b089efb01a7bdf50)(elementType, (0, $lfXYn.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}



var $35jnV = parcelRequire("35jnV");

var $86rqb = parcelRequire("86rqb");
"use client";
const $e6049d1d101f7639$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $e6049d1d101f7639$var$ClassNameConfiguratorContext = /*#__PURE__*/ $35jnV.createContext($e6049d1d101f7639$var$defaultContextValue);
function $e6049d1d101f7639$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses } = $35jnV.useContext($e6049d1d101f7639$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function $e6049d1d101f7639$export$2efe1f5e70172ae9(props) {
    const { disableDefaultClasses: disableDefaultClasses, children: children } = props;
    const contextValue = $35jnV.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $86rqb.jsx)($e6049d1d101f7639$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}



var $86rqb = parcelRequire("86rqb");
"use client";
const $d4022d64d83ab0b5$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $d4022d64d83ab0b5$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $d4022d64d83ab0b5$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $d4022d64d83ab0b5$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $d4022d64d83ab0b5$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $d4022d64d83ab0b5$var$isVirtualElement(element) {
    return !$d4022d64d83ab0b5$var$isHTMLElement(element);
}
const $d4022d64d83ab0b5$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $e6049d1d101f7639$export$b0f7603cd2f9ee15)((0, $cf0abb1c1c7eb162$export$1b69b6cd0fa638a1)));
};
const $d4022d64d83ab0b5$var$defaultPopperOptions = {};
const $d4022d64d83ab0b5$var$PopperTooltip = /*#__PURE__*/ $35jnV.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $5NWw9.default)(props, $d4022d64d83ab0b5$var$_excluded);
    const tooltipRef = $35jnV.useRef(null);
    const ownRef = (0, $0516f23cce01a3cc$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $35jnV.useRef(null);
    const handlePopperRef = (0, $0516f23cce01a3cc$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $35jnV.useRef(handlePopperRef);
    (0, $6d8594980b4d41a4$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $35jnV.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $d4022d64d83ab0b5$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $35jnV.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $35jnV.useState($d4022d64d83ab0b5$var$resolveAnchorEl(anchorEl));
    $35jnV.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $35jnV.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($d4022d64d83ab0b5$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $6d8594980b4d41a4$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $20edfd5468513f4d$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $lfXYn.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $d4022d64d83ab0b5$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $de1586982a0c1b8f$export$1e5c9e6e4e15efe3)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $86rqb.jsx)(Root, (0, $lfXYn.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base-ui/react-popper/components-api/#popper)
 */ const $d4022d64d83ab0b5$export$badac9ada3a0bdf9 = /*#__PURE__*/ $35jnV.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $d4022d64d83ab0b5$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $5NWw9.default)(props, $d4022d64d83ab0b5$var$_excluded2);
    const [exited, setExited] = $35jnV.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $d4022d64d83ab0b5$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $d4022d64d83ab0b5$var$isHTMLElement(resolvedAnchorEl) ? (0, $0634ff1c5e38c440$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $0634ff1c5e38c440$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $86rqb.jsx)((0, $37b10cb8da062c7a$export$602eac185826482c), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $86rqb.jsx)($d4022d64d83ab0b5$var$PopperTooltip, (0, $lfXYn.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $lfXYn.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});



var $kfqtZ = parcelRequire("kfqtZ");



var $35jnV = parcelRequire("35jnV");

var $jBVCU = parcelRequire("jBVCU");
var $hZybU = parcelRequire("hZybU");

var $86rqb = parcelRequire("86rqb");
"use client";
const $c5eebed803150dc0$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $c5eebed803150dc0$var$PopperRoot = (0, $jBVCU.default)((0, $d4022d64d83ab0b5$export$badac9ada3a0bdf9), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $c5eebed803150dc0$var$Popper = /*#__PURE__*/ $35jnV.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, $kfqtZ.default)();
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $5NWw9.default)(props, $c5eebed803150dc0$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $lfXYn.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $86rqb.jsx)($c5eebed803150dc0$var$PopperRoot, (0, $lfXYn.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $c5eebed803150dc0$export$2e2bcd8739ae039 = $c5eebed803150dc0$var$Popper;





var $35jnV = parcelRequire("35jnV");
"use client";
let $cffc89667014c06e$var$globalId = 0;
function $cffc89667014c06e$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $35jnV.useState(idOverride);
    const id = idOverride || defaultId;
    $35jnV.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $cffc89667014c06e$var$globalId += 1;
            setDefaultId(`mui-${$cffc89667014c06e$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $cffc89667014c06e$var$maybeReactUseId = $35jnV["useId".toString()];
function $cffc89667014c06e$export$2e2bcd8739ae039(idOverride) {
    if ($cffc89667014c06e$var$maybeReactUseId !== undefined) {
        const reactId = $cffc89667014c06e$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $cffc89667014c06e$var$useGlobalId(idOverride);
}


"use client";
var $cce6719727d26444$export$2e2bcd8739ae039 = (0, $cffc89667014c06e$export$2e2bcd8739ae039);




var $35jnV = parcelRequire("35jnV");
"use client";
function $e107187cc2d89c6e$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $35jnV.useRef(controlled !== undefined);
    const [valueState, setValue] = $35jnV.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $35jnV.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


"use client";
var $6550431a21008320$export$2e2bcd8739ae039 = (0, $e107187cc2d89c6e$export$2e2bcd8739ae039);



var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $138c0544dfc62171$export$837848f5f6cee923(slot) {
    return (0, $1reLR.default)("MuiTooltip", slot);
}
const $138c0544dfc62171$var$tooltipClasses = (0, $ibC2g.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $138c0544dfc62171$export$2e2bcd8739ae039 = $138c0544dfc62171$var$tooltipClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $a6d0b4fce5ac3283$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $a6d0b4fce5ac3283$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $a6d0b4fce5ac3283$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $1OAmh.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $138c0544dfc62171$export$837848f5f6cee923), classes);
};
const $a6d0b4fce5ac3283$var$TooltipPopper = (0, $jBVCU.default)((0, $c5eebed803150dc0$export$2e2bcd8739ae039), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $lfXYn.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $138c0544dfc62171$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $138c0544dfc62171$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $138c0544dfc62171$export$2e2bcd8739ae039).arrow}`]: (0, $lfXYn.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $138c0544dfc62171$export$2e2bcd8739ae039).arrow}`]: (0, $lfXYn.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $a6d0b4fce5ac3283$var$TooltipTooltip = (0, $jBVCU.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $1OAmh.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $a7jdq.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$a6d0b4fce5ac3283$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $138c0544dfc62171$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $lfXYn.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $lfXYn.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $lfXYn.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $138c0544dfc62171$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $lfXYn.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $lfXYn.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $lfXYn.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $138c0544dfc62171$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $lfXYn.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $138c0544dfc62171$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $lfXYn.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $a6d0b4fce5ac3283$var$TooltipArrow = (0, $jBVCU.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $a7jdq.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $a6d0b4fce5ac3283$var$hystersisOpen = false;
let $a6d0b4fce5ac3283$var$hystersisTimer = null;
let $a6d0b4fce5ac3283$var$cursorPosition = {
    x: 0,
    y: 0
};
function $a6d0b4fce5ac3283$export$b9ee5a7ace0541f8() {
    $a6d0b4fce5ac3283$var$hystersisOpen = false;
    clearTimeout($a6d0b4fce5ac3283$var$hystersisTimer);
}
function $a6d0b4fce5ac3283$var$composeEventHandler(handler, eventHandler) {
    return (event)=>{
        if (eventHandler) eventHandler(event);
        handler(event);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $a6d0b4fce5ac3283$var$Tooltip = /*#__PURE__*/ $35jnV.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = "bottom", PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $8d4b4494eba6d4ab$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $5NWw9.default)(props, $a6d0b4fce5ac3283$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $35jnV.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $86rqb.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $e83902653e135773$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const [childNode, setChildNode] = $35jnV.useState();
    const [arrowRef, setArrowRef] = $35jnV.useState(null);
    const ignoreNonTouchEvents = $35jnV.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = $35jnV.useRef();
    const enterTimer = $35jnV.useRef();
    const leaveTimer = $35jnV.useRef();
    const touchTimer = $35jnV.useRef();
    const [openState, setOpenState] = (0, $6550431a21008320$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $cce6719727d26444$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $35jnV.useRef();
    const stopTouchInteraction = $35jnV.useCallback(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        clearTimeout(touchTimer.current);
    }, []);
    $35jnV.useEffect(()=>{
        return ()=>{
            clearTimeout(closeTimer.current);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            stopTouchInteraction();
        };
    }, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        clearTimeout($a6d0b4fce5ac3283$var$hystersisTimer);
        $a6d0b4fce5ac3283$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $177136a850dea437$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        clearTimeout($a6d0b4fce5ac3283$var$hystersisTimer);
        $a6d0b4fce5ac3283$var$hystersisTimer = setTimeout(()=>{
            $a6d0b4fce5ac3283$var$hystersisOpen = false;
        }, 800 + leaveDelay);
        setOpenState(false);
        if (onClose && open) onClose(event);
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(()=>{
            ignoreNonTouchEvents.current = false;
        }, theme.transitions.duration.shortest);
    });
    const handleEnter = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        if (enterDelay || $a6d0b4fce5ac3283$var$hystersisOpen && enterNextDelay) enterTimer.current = setTimeout(()=>{
            handleOpen(event);
        }, $a6d0b4fce5ac3283$var$hystersisOpen ? enterNextDelay : enterDelay);
        else handleOpen(event);
    };
    const handleLeave = (event)=>{
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveDelay);
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $b0ccb8cd06c388d8$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $35jnV.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleEnter(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleMouseOver = handleEnter;
    const handleMouseLeave = handleLeave;
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        clearTimeout(leaveTimer.current);
        clearTimeout(closeTimer.current);
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.current = setTimeout(()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleEnter(event);
        }, enterTouchDelay);
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveTouchDelay);
    };
    $35jnV.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $e6f4f6562381f94e$export$2e2bcd8739ae039)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    if (!title && title !== 0) open = false;
    const popperRef = $35jnV.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $a6d0b4fce5ac3283$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $lfXYn.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $3eTha.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $a6d0b4fce5ac3283$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $a6d0b4fce5ac3283$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $a6d0b4fce5ac3283$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $a6d0b4fce5ac3283$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $35jnV.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $lfXYn.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $lfXYn.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $a6d0b4fce5ac3283$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $a6d0b4fce5ac3283$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $8d4b4494eba6d4ab$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $a6d0b4fce5ac3283$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $a6d0b4fce5ac3283$var$TooltipArrow;
    const popperProps = (0, $04174780eb43f18a$export$b089efb01a7bdf50)(PopperComponent, (0, $lfXYn.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $3eTha.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $04174780eb43f18a$export$b089efb01a7bdf50)(TransitionComponent, (0, $lfXYn.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $04174780eb43f18a$export$b089efb01a7bdf50)(TooltipComponent, (0, $lfXYn.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $3eTha.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $04174780eb43f18a$export$b089efb01a7bdf50)(ArrowComponent, (0, $lfXYn.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $3eTha.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsxs)($35jnV.Fragment, {
        children: [
            /*#__PURE__*/ $35jnV.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $86rqb.jsx)(PopperComponent, (0, $lfXYn.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $c5eebed803150dc0$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $a6d0b4fce5ac3283$var$cursorPosition.y,
                            left: $a6d0b4fce5ac3283$var$cursorPosition.x,
                            right: $a6d0b4fce5ac3283$var$cursorPosition.x,
                            bottom: $a6d0b4fce5ac3283$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $86rqb.jsx)(TransitionComponent, (0, $lfXYn.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $86rqb.jsxs)(TooltipComponent, (0, $lfXYn.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $86rqb.jsx)(ArrowComponent, (0, $lfXYn.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $a6d0b4fce5ac3283$export$2e2bcd8739ae039 = $a6d0b4fce5ac3283$var$Tooltip;


var $a291d896251377a7$exports = {};
"use strict";
"use client";
var $dd204784e51ffdae$exports = {};
function $dd204784e51ffdae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$dd204784e51ffdae$exports = $dd204784e51ffdae$var$_interopRequireDefault, $dd204784e51ffdae$exports.__esModule = true, $dd204784e51ffdae$exports["default"] = $dd204784e51ffdae$exports;


Object.defineProperty($a291d896251377a7$exports, "__esModule", {
    value: true
});
$a291d896251377a7$exports.default = void 0;

var $a291d896251377a7$var$_createSvgIcon = $dd204784e51ffdae$exports((parcelRequire("2jyxe")));

var $86rqb = parcelRequire("86rqb");
var $a291d896251377a7$var$_default = (0, $a291d896251377a7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "M5 20h14v-2H5v2zm0-10h4v6h6v-6h4l-7-7-7 7z"
}), "Upload");
$a291d896251377a7$exports.default = $a291d896251377a7$var$_default;


var $f51a81b736208a40$exports = {};
"use strict";
"use client";

Object.defineProperty($f51a81b736208a40$exports, "__esModule", {
    value: true
});
$f51a81b736208a40$exports.default = void 0;

var $f51a81b736208a40$var$_createSvgIcon = $dd204784e51ffdae$exports((parcelRequire("2jyxe")));

var $86rqb = parcelRequire("86rqb");
var $f51a81b736208a40$var$_default = (0, $f51a81b736208a40$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
}), "AttachFile");
$f51a81b736208a40$exports.default = $f51a81b736208a40$var$_default;


var $e5afa28d79f20446$exports = {};
"use strict";
"use client";

Object.defineProperty($e5afa28d79f20446$exports, "__esModule", {
    value: true
});
$e5afa28d79f20446$exports.default = void 0;

var $e5afa28d79f20446$var$_createSvgIcon = $dd204784e51ffdae$exports((parcelRequire("2jyxe")));

var $86rqb = parcelRequire("86rqb");
var $e5afa28d79f20446$var$_default = (0, $e5afa28d79f20446$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
}), "FileDownload");
$e5afa28d79f20446$exports.default = $e5afa28d79f20446$var$_default;


var $e7c5fef7e731d063$exports = {};
"use strict";
"use client";

Object.defineProperty($e7c5fef7e731d063$exports, "__esModule", {
    value: true
});
$e7c5fef7e731d063$exports.default = void 0;

var $e7c5fef7e731d063$var$_createSvgIcon = $dd204784e51ffdae$exports((parcelRequire("2jyxe")));

var $86rqb = parcelRequire("86rqb");
var $e7c5fef7e731d063$var$_default = (0, $e7c5fef7e731d063$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
}), "Help");
$e7c5fef7e731d063$exports.default = $e7c5fef7e731d063$var$_default;


var $0de0642a46b293cc$exports = {};
"use strict";
"use client";

Object.defineProperty($0de0642a46b293cc$exports, "__esModule", {
    value: true
});
$0de0642a46b293cc$exports.default = void 0;

var $0de0642a46b293cc$var$React = $0de0642a46b293cc$var$_interopRequireWildcard((parcelRequire("35jnV")));

var $0de0642a46b293cc$var$_createSvgIcon = $dd204784e51ffdae$exports((parcelRequire("2jyxe")));

var $86rqb = parcelRequire("86rqb");
function $0de0642a46b293cc$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($0de0642a46b293cc$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $0de0642a46b293cc$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0de0642a46b293cc$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $0de0642a46b293cc$var$_default = (0, $0de0642a46b293cc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "M12 1.27a11 11 0 00-3.48 21.46c.55.09.73-.28.73-.55v-1.84c-3.03.64-3.67-1.46-3.67-1.46-.55-1.29-1.28-1.65-1.28-1.65-.92-.65.1-.65.1-.65 1.1 0 1.73 1.1 1.73 1.1.92 1.65 2.57 1.2 3.21.92a2 2 0 01.64-1.47c-2.47-.27-5.04-1.19-5.04-5.5 0-1.1.46-2.1 1.2-2.84a3.76 3.76 0 010-2.93s.91-.28 3.11 1.1c1.8-.49 3.7-.49 5.5 0 2.1-1.38 3.02-1.1 3.02-1.1a3.76 3.76 0 010 2.93c.83.74 1.2 1.74 1.2 2.94 0 4.21-2.57 5.13-5.04 5.4.45.37.82.92.82 2.02v3.03c0 .27.1.64.73.55A11 11 0 0012 1.27"
}), "GitHub");
$0de0642a46b293cc$exports.default = $0de0642a46b293cc$var$_default;


var $41eebd52a007629c$exports = {};
"use strict";
"use client";

Object.defineProperty($41eebd52a007629c$exports, "__esModule", {
    value: true
});
$41eebd52a007629c$exports.default = void 0;

var $41eebd52a007629c$var$_createSvgIcon = $dd204784e51ffdae$exports((parcelRequire("2jyxe")));

var $86rqb = parcelRequire("86rqb");
var $41eebd52a007629c$var$_default = (0, $41eebd52a007629c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
}), "Settings");
$41eebd52a007629c$exports.default = $41eebd52a007629c$var$_default;



class $ba2ebe3707174c7b$var$AsyncFileReader {
    constructor(){
        this.reader = new FileReader();
    }
    _readAs = (funcName)=>(...args)=>{
            return new Promise((resolve, reject)=>{
                const onLoad = ()=>resolve(this.reader.result);
                const onError = ()=>reject(this.reader.error);
                const release = ()=>{
                    this.reader.removeEventListener("load", onLoad);
                    this.reader.removeEventListener("error", onError);
                    this.reader.removeEventListener("loadend", release);
                    this.reader.removeEventListener("abort", release);
                };
                this.reader.addEventListener("load", onLoad);
                this.reader.addEventListener("error", onError);
                this.reader.addEventListener("loadend", release);
                this.reader.addEventListener("abort", release);
                this.reader[funcName](...args);
            });
        };
    readAsArrayBuffer = this._readAs("readAsArrayBuffer");
    readAsBinaryString = this._readAs("readAsBinaryString");
    readAsDataURL = this._readAs("readAsDataURL");
    readAsText = this._readAs("readAsText");
}
// singleton
const $ba2ebe3707174c7b$var$reader = new $ba2ebe3707174c7b$var$AsyncFileReader();
var $ba2ebe3707174c7b$export$2e2bcd8739ae039 = $ba2ebe3707174c7b$var$reader;


const $2ad56a64a2ca30f2$var$getSource = (src)=>{
    if (typeof src === "string") return src;
    if (src instanceof ArrayBuffer) return URL.createObjectURL(new Blob([
        new Uint8Array(src)
    ]));
    if (src instanceof Blob) return URL.createObjectURL(src);
    throw new Error("Invalid Image Source");
};
const $2ad56a64a2ca30f2$var$imageSize = (src)=>{
    return new Promise((resolve, reject)=>{
        const image = new Image();
        const source = $2ad56a64a2ca30f2$var$getSource(src);
        image.onerror = reject;
        image.onload = ()=>{
            if (src instanceof Blob) URL.revokeObjectURL(source);
            resolve({
                width: image.width,
                height: image.height
            });
        };
        image.src = source;
    });
};
var $2ad56a64a2ca30f2$export$2e2bcd8739ae039 = $2ad56a64a2ca30f2$var$imageSize;


class $3ab06b0b834e1fe0$var$IS {
    static exist(v) {
        return v !== undefined && v !== null;
    }
    static nil(v) {
        return v === undefined || v === null;
    }
    /**
   * ! Note: null / undefined => false
   */ static empty(v) {
        if ($3ab06b0b834e1fe0$var$IS.string(v) || $3ab06b0b834e1fe0$var$IS.array(v)) return v.length === 0;
        return !!v && Object.getOwnPropertyNames(v).length === 0 && Object.getOwnPropertySymbols(v).length === 0;
    }
    static numeric(v) {
        return /^[+-]?\d+(\.\d+)?$/.test(`${v}`);
    }
    static int(v) {
        return /^[+-]?\d+$/.test(`${v}`);
    }
    static truely(v) {
        return v === true || /^t(rue)?$/i.test(`${v}`) || `${v}` === "1";
    }
    static falsy(v) {
        return v === false || /^f(alse)?$/i.test(`${v}`) || `${v}` === "0";
    }
    static string(v) {
        return typeof v === "string" || v instanceof String;
    }
    static bool(v) {
        return v === true || v === false || v instanceof Boolean;
    }
    static array(v) {
        return Array.isArray ? Array.isArray(v) : Object.prototype.toString.call(v) === "[object Array]";
    }
    static date(v) {
        return v && Object.prototype.toString.call(v) === "[object Date]" && !Number.isNaN(v);
    }
    static func(v) {
        return typeof v === "function";
    }
    static promise(v) {
        return v && Object.prototype.toString.call(v) === "[object Promise]";
    }
    static primitive(v) {
        return typeof v !== "object" && typeof v !== "function" || v === null;
    }
}
var $3ab06b0b834e1fe0$export$2e2bcd8739ae039 = $3ab06b0b834e1fe0$var$IS;





var $86rqb = parcelRequire("86rqb");

var $3eTha = parcelRequire("3eTha");

var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");

var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");
parcelRequire("35jnV");

var $5gNfQ = parcelRequire("5gNfQ");

var $86rqb = parcelRequire("86rqb");
"use client";
var $4fdf5cf12cfafafa$export$2e2bcd8739ae039 = (0, $5gNfQ.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");



var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $6956206729abaa0f$export$ffd560f22c0ecf04(slot) {
    return (0, $1reLR.default)("MuiAvatar", slot);
}
const $6956206729abaa0f$var$avatarClasses = (0, $ibC2g.default)("MuiAvatar", [
    "root",
    "colorDefault",
    "circular",
    "rounded",
    "square",
    "img",
    "fallback"
]);
var $6956206729abaa0f$export$2e2bcd8739ae039 = $6956206729abaa0f$var$avatarClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $f9cfb77223705ddc$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $f9cfb77223705ddc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            colorDefault && "colorDefault"
        ],
        img: [
            "img"
        ],
        fallback: [
            "fallback"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $6956206729abaa0f$export$ffd560f22c0ecf04), classes);
};
const $f9cfb77223705ddc$var$AvatarRoot = (0, $jBVCU.default)("div", {
    name: "MuiAvatar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: "50%",
        overflow: "hidden",
        userSelect: "none"
    }, ownerState.variant === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.variant === "square" && {
        borderRadius: 0
    }, ownerState.colorDefault && (0, $lfXYn.default)({
        color: (theme.vars || theme).palette.background.default
    }, theme.vars ? {
        backgroundColor: theme.vars.palette.Avatar.defaultBg
    } : {
        backgroundColor: theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[600]
    })));
const $f9cfb77223705ddc$var$AvatarImg = (0, $jBVCU.default)("img", {
    name: "MuiAvatar",
    slot: "Img",
    overridesResolver: (props, styles)=>styles.img
})({
    width: "100%",
    height: "100%",
    textAlign: "center",
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: "cover",
    // Hide alt text.
    color: "transparent",
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $f9cfb77223705ddc$var$AvatarFallback = (0, $jBVCU.default)((0, $4fdf5cf12cfafafa$export$2e2bcd8739ae039), {
    name: "MuiAvatar",
    slot: "Fallback",
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: "75%",
    height: "75%"
});
function $f9cfb77223705ddc$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $35jnV.useState(false);
    $35jnV.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded("error");
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $f9cfb77223705ddc$var$Avatar = /*#__PURE__*/ $35jnV.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiAvatar"
    });
    const { alt: alt, children: childrenProp, className: className, component: component = "div", imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = "circular" } = props, other = (0, $5NWw9.default)(props, $f9cfb77223705ddc$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $f9cfb77223705ddc$var$useLoaded((0, $lfXYn.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== "error";
    const ownerState = (0, $lfXYn.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $f9cfb77223705ddc$var$useUtilityClasses(ownerState);
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $86rqb.jsx)($f9cfb77223705ddc$var$AvatarImg, (0, $lfXYn.default)({
        alt: alt,
        srcSet: srcSet,
        src: src,
        sizes: sizes,
        ownerState: ownerState,
        className: classes.img
    }, imgProps));
    else if (childrenProp != null) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $86rqb.jsx)($f9cfb77223705ddc$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $86rqb.jsx)($f9cfb77223705ddc$var$AvatarRoot, (0, $lfXYn.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $3eTha.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $f9cfb77223705ddc$export$2e2bcd8739ae039 = $f9cfb77223705ddc$var$Avatar;




var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");

var $a7jdq = parcelRequire("a7jdq");

var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $717ebd70c205b4d3$export$46f01d01378ec5a2(slot) {
    return (0, $1reLR.default)("MuiDivider", slot);
}
const $717ebd70c205b4d3$var$dividerClasses = (0, $ibC2g.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $717ebd70c205b4d3$export$2e2bcd8739ae039 = $717ebd70c205b4d3$var$dividerClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $99ad0a2ae7367ab9$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $99ad0a2ae7367ab9$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            absolute && "absolute",
            variant,
            light && "light",
            orientation === "vertical" && "vertical",
            flexItem && "flexItem",
            children && "withChildren",
            children && orientation === "vertical" && "withChildrenVertical",
            textAlign === "right" && orientation !== "vertical" && "textAlignRight",
            textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
        ],
        wrapper: [
            "wrapper",
            orientation === "vertical" && "wrapperVertical"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $717ebd70c205b4d3$export$46f01d01378ec5a2), classes);
};
const $99ad0a2ae7367ab9$var$DividerRoot = (0, $jBVCU.default)("div", {
    name: "MuiDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === "vertical" && styles.withChildrenVertical,
            ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
            ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: "thin"
    }, ownerState.absolute && {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%"
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $a7jdq.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === "inset" && {
        marginLeft: 72
    }, ownerState.variant === "middle" && ownerState.orientation === "horizontal" && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === "middle" && ownerState.orientation === "vertical" && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === "vertical" && {
        height: "100%",
        borderBottomWidth: 0,
        borderRightWidth: "thin"
    }, ownerState.flexItem && {
        alignSelf: "stretch",
        height: "auto"
    }), ({ ownerState: ownerState })=>(0, $lfXYn.default)({}, ownerState.children && {
        display: "flex",
        whiteSpace: "nowrap",
        textAlign: "center",
        border: 0,
        "&::before, &::after": {
            content: '""',
            alignSelf: "center"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({}, ownerState.children && ownerState.orientation !== "vertical" && {
        "&::before, &::after": {
            width: "100%",
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({}, ownerState.children && ownerState.orientation === "vertical" && {
        flexDirection: "column",
        "&::before, &::after": {
            height: "100%",
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ ownerState: ownerState })=>(0, $lfXYn.default)({}, ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "90%"
        },
        "&::after": {
            width: "10%"
        }
    }, ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "10%"
        },
        "&::after": {
            width: "90%"
        }
    }));
const $99ad0a2ae7367ab9$var$DividerWrapper = (0, $jBVCU.default)("span", {
    name: "MuiDivider",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === "vertical" && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        display: "inline-block",
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === "vertical" && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $99ad0a2ae7367ab9$var$Divider = /*#__PURE__*/ $35jnV.forwardRef(function Divider(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiDivider"
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? "div" : "hr", flexItem: flexItem = false, light: light = false, orientation: orientation = "horizontal", role: role = component !== "hr" ? "separator" : undefined, textAlign: textAlign = "center", variant: variant = "fullWidth" } = props, other = (0, $5NWw9.default)(props, $99ad0a2ae7367ab9$var$_excluded);
    const ownerState = (0, $lfXYn.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $99ad0a2ae7367ab9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsx)($99ad0a2ae7367ab9$var$DividerRoot, (0, $lfXYn.default)({
        as: component,
        className: (0, $3eTha.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $86rqb.jsx)($99ad0a2ae7367ab9$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $99ad0a2ae7367ab9$var$Divider.muiSkipListHighlight = true;
var $99ad0a2ae7367ab9$export$2e2bcd8739ae039 = $99ad0a2ae7367ab9$var$Divider;



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");


var $1OAmh = parcelRequire("1OAmh");

var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");



var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $840e8063793eba24$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}



// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $62f88e1db7bce5a8$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


function $5e11b4a87d60cb67$export$2e2bcd8739ae039(node) {
    const doc = (0, $0634ff1c5e38c440$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


// Is a vertical scrollbar displayed?
function $32b6a41c8deb45b0$var$isOverflowing(container) {
    const doc = (0, $0634ff1c5e38c440$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $5e11b4a87d60cb67$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $32b6a41c8deb45b0$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $32b6a41c8deb45b0$var$getPaddingRight(element) {
    return parseInt((0, $5e11b4a87d60cb67$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $32b6a41c8deb45b0$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $32b6a41c8deb45b0$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$32b6a41c8deb45b0$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $32b6a41c8deb45b0$export$e1bd0c6150f13d96(element, show);
    });
}
function $32b6a41c8deb45b0$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $32b6a41c8deb45b0$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($32b6a41c8deb45b0$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $62f88e1db7bce5a8$export$2e2bcd8739ae039)((0, $0634ff1c5e38c440$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$32b6a41c8deb45b0$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $0634ff1c5e38c440$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$32b6a41c8deb45b0$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $0634ff1c5e38c440$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $5e11b4a87d60cb67$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $32b6a41c8deb45b0$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $32b6a41c8deb45b0$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $32b6a41c8deb45b0$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $32b6a41c8deb45b0$var$getHiddenSiblings(container);
        $32b6a41c8deb45b0$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $32b6a41c8deb45b0$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $32b6a41c8deb45b0$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $32b6a41c8deb45b0$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $32b6a41c8deb45b0$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $32b6a41c8deb45b0$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $32b6a41c8deb45b0$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $32b6a41c8deb45b0$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


"use client";
function $207f71bb7a7e096d$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $207f71bb7a7e096d$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $207f71bb7a7e096d$var$defaultManager = new (0, $32b6a41c8deb45b0$export$ce11c4ecd08cea67)();
function $207f71bb7a7e096d$export$33ffd74ebf07f060(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $207f71bb7a7e096d$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $35jnV.useRef({});
    const mountNodeRef = $35jnV.useRef(null);
    const modalRef = $35jnV.useRef(null);
    const handleRef = (0, $0516f23cce01a3cc$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $35jnV.useState(!open);
    const hasTransition = $207f71bb7a7e096d$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $0634ff1c5e38c440$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $6fd92d7c6a65060f$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $207f71bb7a7e096d$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $35jnV.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $6fd92d7c6a65060f$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $32b6a41c8deb45b0$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $35jnV.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $35jnV.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $35jnV.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $fdc0f5c8deb0c27f$export$24d5698b57eff81c)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $lfXYn.default)({}, propsEventHandlers, otherHandlers);
        return (0, $lfXYn.default)({
            role: "presentation"
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $lfXYn.default)({
            "aria-hidden": true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $840e8063793eba24$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $840e8063793eba24$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}



var $5wpQH = parcelRequire("5wpQH");

var $35jnV = parcelRequire("35jnV");



var $86rqb = parcelRequire("86rqb");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $d6ae407b807f731c$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $d6ae407b807f731c$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $d6ae407b807f731c$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $d6ae407b807f731c$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $d6ae407b807f731c$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $d6ae407b807f731c$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($d6ae407b807f731c$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $d6ae407b807f731c$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$d6ae407b807f731c$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $d6ae407b807f731c$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $d6ae407b807f731c$export$34eba2437817a67b(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $d6ae407b807f731c$var$defaultGetTabbable, isEnabled: isEnabled = $d6ae407b807f731c$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $35jnV.useRef(false);
    const sentinelStart = $35jnV.useRef(null);
    const sentinelEnd = $35jnV.useRef(null);
    const nodeToRestore = $35jnV.useRef(null);
    const reactFocusEventTarget = $35jnV.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $35jnV.useRef(false);
    const rootRef = $35jnV.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $0516f23cce01a3cc$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $35jnV.useRef(null);
    $35jnV.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $35jnV.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $0634ff1c5e38c440$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $35jnV.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $0634ff1c5e38c440$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $86rqb.jsxs)($35jnV.Fragment, {
        children: [
            /*#__PURE__*/ (0, $86rqb.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $35jnV.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}




var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");

var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");

var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");

var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $35jnV = parcelRequire("35jnV");







var $86rqb = parcelRequire("86rqb");
"use client";
const $e657b67e4a98fb85$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $e657b67e4a98fb85$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $e657b67e4a98fb85$var$Fade = /*#__PURE__*/ $35jnV.forwardRef(function Fade(props, ref) {
    const theme = (0, $e83902653e135773$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $e6e36fc0496fc254$export$2e2bcd8739ae039) } = props, other = (0, $5NWw9.default)(props, $e657b67e4a98fb85$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $35jnV.useRef(null);
    const handleRef = (0, $e6f4f6562381f94e$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $0398bd8128d32282$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $0398bd8128d32282$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $0398bd8128d32282$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $86rqb.jsx)(TransitionComponent, (0, $lfXYn.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $35jnV.cloneElement(children, (0, $lfXYn.default)({
                style: (0, $lfXYn.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $e657b67e4a98fb85$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $e657b67e4a98fb85$export$2e2bcd8739ae039 = $e657b67e4a98fb85$var$Fade;



var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $0ff360c9d93d0352$export$9927a91fd93152bd(slot) {
    return (0, $1reLR.default)("MuiBackdrop", slot);
}
const $0ff360c9d93d0352$var$backdropClasses = (0, $ibC2g.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $0ff360c9d93d0352$export$2e2bcd8739ae039 = $0ff360c9d93d0352$var$backdropClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $2e28c6a582f9fef3$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $2e28c6a582f9fef3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $0ff360c9d93d0352$export$9927a91fd93152bd), classes);
};
const $2e28c6a582f9fef3$var$BackdropRoot = (0, $jBVCU.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $lfXYn.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $2e28c6a582f9fef3$var$Backdrop = /*#__PURE__*/ $35jnV.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $e657b67e4a98fb85$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $5NWw9.default)(props, $2e28c6a582f9fef3$var$_excluded);
    const ownerState = (0, $lfXYn.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $2e28c6a582f9fef3$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $86rqb.jsx)(TransitionComponent, (0, $lfXYn.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $86rqb.jsx)($2e28c6a582f9fef3$var$BackdropRoot, (0, $lfXYn.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $3eTha.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $lfXYn.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $2e28c6a582f9fef3$export$2e2bcd8739ae039 = $2e28c6a582f9fef3$var$Backdrop;



var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $7bbb144bc65c1711$export$67960e22b12a638d(slot) {
    return (0, $1reLR.default)("MuiModal", slot);
}
const $7bbb144bc65c1711$var$modalClasses = (0, $ibC2g.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $7bbb144bc65c1711$export$2e2bcd8739ae039 = $7bbb144bc65c1711$var$modalClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $31491128a3ec29b5$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $31491128a3ec29b5$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $7bbb144bc65c1711$export$67960e22b12a638d), classes);
};
const $31491128a3ec29b5$var$ModalRoot = (0, $jBVCU.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $31491128a3ec29b5$var$ModalBackdrop = (0, $jBVCU.default)((0, $2e28c6a582f9fef3$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $31491128a3ec29b5$var$Modal = /*#__PURE__*/ $35jnV.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $hZybU.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $31491128a3ec29b5$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $5NWw9.default)(props, $31491128a3ec29b5$var$_excluded);
    const propsWithDefaults = (0, $lfXYn.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $207f71bb7a7e096d$export$33ffd74ebf07f060)((0, $lfXYn.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $lfXYn.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $31491128a3ec29b5$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $31491128a3ec29b5$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $de1586982a0c1b8f$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $3eTha.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $de1586982a0c1b8f$export$1e5c9e6e4e15efe3)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $lfXYn.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $3eTha.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $86rqb.jsx)((0, $37b10cb8da062c7a$export$602eac185826482c), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $86rqb.jsxs)(RootSlot, (0, $lfXYn.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $86rqb.jsx)(BackdropSlot, (0, $lfXYn.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $86rqb.jsx)((0, $d6ae407b807f731c$export$34eba2437817a67b), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $35jnV.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $31491128a3ec29b5$export$2e2bcd8739ae039 = $31491128a3ec29b5$var$Modal;





var $hZybU = parcelRequire("hZybU");

var $jBVCU = parcelRequire("jBVCU");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $aed9b58fcc852152$export$2177af0aa15c34c2(slot) {
    return (0, $1reLR.default)("MuiDialog", slot);
}
const $aed9b58fcc852152$var$dialogClasses = (0, $ibC2g.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $aed9b58fcc852152$export$2e2bcd8739ae039 = $aed9b58fcc852152$var$dialogClasses;



var $35jnV = parcelRequire("35jnV");
const $0d855af2261a308f$var$DialogContext = /*#__PURE__*/ $35jnV.createContext({});
var $0d855af2261a308f$export$2e2bcd8739ae039 = $0d855af2261a308f$var$DialogContext;





var $86rqb = parcelRequire("86rqb");
"use client";
const $cc913c42c481126a$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $cc913c42c481126a$var$DialogBackdrop = (0, $jBVCU.default)((0, $2e28c6a582f9fef3$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $cc913c42c481126a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $1OAmh.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $1OAmh.default)(scroll)}`,
            `paperWidth${(0, $1OAmh.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $aed9b58fcc852152$export$2177af0aa15c34c2), classes);
};
const $cc913c42c481126a$var$DialogRoot = (0, $jBVCU.default)((0, $31491128a3ec29b5$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $cc913c42c481126a$var$DialogContainer = (0, $jBVCU.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $1OAmh.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $lfXYn.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&:after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $cc913c42c481126a$var$DialogPaper = (0, $jBVCU.default)((0, $2fbb4bae37b10470$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $1OAmh.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $1OAmh.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $aed9b58fcc852152$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $aed9b58fcc852152$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $aed9b58fcc852152$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $cc913c42c481126a$var$Dialog = /*#__PURE__*/ $35jnV.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $e83902653e135773$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $2fbb4bae37b10470$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $e657b67e4a98fb85$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $5NWw9.default)(props, $cc913c42c481126a$var$_excluded);
    const ownerState = (0, $lfXYn.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $cc913c42c481126a$var$useUtilityClasses(ownerState);
    const backdropClick = $35jnV.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $cffc89667014c06e$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $35jnV.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $86rqb.jsx)($cc913c42c481126a$var$DialogRoot, (0, $lfXYn.default)({
        className: (0, $3eTha.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $cc913c42c481126a$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $lfXYn.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $86rqb.jsx)(TransitionComponent, (0, $lfXYn.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $86rqb.jsx)($cc913c42c481126a$var$DialogContainer, {
                className: (0, $3eTha.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $86rqb.jsx)($cc913c42c481126a$var$DialogPaper, (0, $lfXYn.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $3eTha.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $86rqb.jsx)((0, $0d855af2261a308f$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $cc913c42c481126a$export$2e2bcd8739ae039 = $cc913c42c481126a$var$Dialog;



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");

var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $58dd4e5ed8469160$export$61b0ee1f05fb344e(slot) {
    return (0, $1reLR.default)("MuiDialogContent", slot);
}
const $58dd4e5ed8469160$var$dialogContentClasses = (0, $ibC2g.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $58dd4e5ed8469160$export$2e2bcd8739ae039 = $58dd4e5ed8469160$var$dialogContentClasses;



var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $d0b41d11eefd04da$export$f5d2ec7e4c47e088(slot) {
    return (0, $1reLR.default)("MuiDialogTitle", slot);
}
const $d0b41d11eefd04da$var$dialogTitleClasses = (0, $ibC2g.default)("MuiDialogTitle", [
    "root"
]);
var $d0b41d11eefd04da$export$2e2bcd8739ae039 = $d0b41d11eefd04da$var$dialogTitleClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $35e7b4998255ce79$var$_excluded = [
    "className",
    "dividers"
];
const $35e7b4998255ce79$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $58dd4e5ed8469160$export$61b0ee1f05fb344e), classes);
};
const $35e7b4998255ce79$var$DialogContentRoot = (0, $jBVCU.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $d0b41d11eefd04da$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $35e7b4998255ce79$var$DialogContent = /*#__PURE__*/ $35jnV.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $5NWw9.default)(props, $35e7b4998255ce79$var$_excluded);
    const ownerState = (0, $lfXYn.default)({}, props, {
        dividers: dividers
    });
    const classes = $35e7b4998255ce79$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsx)($35e7b4998255ce79$var$DialogContentRoot, (0, $lfXYn.default)({
        className: (0, $3eTha.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $35e7b4998255ce79$export$2e2bcd8739ae039 = $35e7b4998255ce79$var$DialogContent;



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");

var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");

var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");


var $5wpQH = parcelRequire("5wpQH");

var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");

var $1OAmh = parcelRequire("1OAmh");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $87035ff7ee8be406$export$24c1f8f60cbac79e(slot) {
    return (0, $1reLR.default)("MuiTypography", slot);
}
const $87035ff7ee8be406$var$typographyClasses = (0, $ibC2g.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $87035ff7ee8be406$export$2e2bcd8739ae039 = $87035ff7ee8be406$var$typographyClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $3d9a9295100a327d$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $3d9a9295100a327d$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $1OAmh.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $87035ff7ee8be406$export$24c1f8f60cbac79e), classes);
};
const $3d9a9295100a327d$export$140e2f5526d3cad8 = (0, $jBVCU.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $1OAmh.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $3d9a9295100a327d$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $3d9a9295100a327d$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $3d9a9295100a327d$var$transformDeprecatedColors = (color)=>{
    return $3d9a9295100a327d$var$colorTransformations[color] || color;
};
const $3d9a9295100a327d$var$Typography = /*#__PURE__*/ $35jnV.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $hZybU.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $3d9a9295100a327d$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $5bbc7abd735c8dea$export$2e2bcd8739ae039)((0, $lfXYn.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $3d9a9295100a327d$var$defaultVariantMapping } = props, other = (0, $5NWw9.default)(props, $3d9a9295100a327d$var$_excluded);
    const ownerState = (0, $lfXYn.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $3d9a9295100a327d$var$defaultVariantMapping[variant]) || "span";
    const classes = $3d9a9295100a327d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsx)($3d9a9295100a327d$export$140e2f5526d3cad8, (0, $lfXYn.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $3eTha.default)(classes.root, className)
    }, other));
});
var $3d9a9295100a327d$export$2e2bcd8739ae039 = $3d9a9295100a327d$var$Typography;



var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $df3dcdce8e666355$export$d9c6dc45f75b0e4f(slot) {
    return (0, $1reLR.default)("MuiDialogContentText", slot);
}
const $df3dcdce8e666355$var$dialogContentTextClasses = (0, $ibC2g.default)("MuiDialogContentText", [
    "root"
]);
var $df3dcdce8e666355$export$2e2bcd8739ae039 = $df3dcdce8e666355$var$dialogContentTextClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $cdb34482a76987c0$var$_excluded = [
    "children",
    "className"
];
const $cdb34482a76987c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    const composedClasses = (0, $5wpQH.default)(slots, (0, $df3dcdce8e666355$export$d9c6dc45f75b0e4f), classes);
    return (0, $lfXYn.default)({}, classes, composedClasses);
};
const $cdb34482a76987c0$var$DialogContentTextRoot = (0, $jBVCU.default)((0, $3d9a9295100a327d$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $jBVCU.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiDialogContentText",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $cdb34482a76987c0$var$DialogContentText = /*#__PURE__*/ $35jnV.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiDialogContentText"
    });
    const { className: className } = props, ownerState = (0, $5NWw9.default)(props, $cdb34482a76987c0$var$_excluded);
    const classes = $cdb34482a76987c0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsx)($cdb34482a76987c0$var$DialogContentTextRoot, (0, $lfXYn.default)({
        component: "p",
        variant: "body1",
        color: "text.secondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $3eTha.default)(classes.root, className)
    }, props, {
        classes: classes
    }));
});
var $cdb34482a76987c0$export$2e2bcd8739ae039 = $cdb34482a76987c0$var$DialogContentText;



var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");


var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");



var $86rqb = parcelRequire("86rqb");
"use client";
const $ae1b0976a75f7dc7$var$_excluded = [
    "className",
    "id"
];
const $ae1b0976a75f7dc7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $d0b41d11eefd04da$export$f5d2ec7e4c47e088), classes);
};
const $ae1b0976a75f7dc7$var$DialogTitleRoot = (0, $jBVCU.default)((0, $3d9a9295100a327d$export$2e2bcd8739ae039), {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: "16px 24px",
    flex: "0 0 auto"
});
const $ae1b0976a75f7dc7$var$DialogTitle = /*#__PURE__*/ $35jnV.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiDialogTitle"
    });
    const { className: className, id: idProp } = props, other = (0, $5NWw9.default)(props, $ae1b0976a75f7dc7$var$_excluded);
    const ownerState = props;
    const classes = $ae1b0976a75f7dc7$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $35jnV.useContext((0, $0d855af2261a308f$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $86rqb.jsx)($ae1b0976a75f7dc7$var$DialogTitleRoot, (0, $lfXYn.default)({
        component: "h2",
        className: (0, $3eTha.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $ae1b0976a75f7dc7$export$2e2bcd8739ae039 = $ae1b0976a75f7dc7$var$DialogTitle;





var $b8aafabe628b3703$exports = {};
"use strict";
"use client";

Object.defineProperty($b8aafabe628b3703$exports, "__esModule", {
    value: true
});
$b8aafabe628b3703$exports.default = void 0;

var $b8aafabe628b3703$var$_createSvgIcon = $dd204784e51ffdae$exports((parcelRequire("2jyxe")));

var $86rqb = parcelRequire("86rqb");
var $b8aafabe628b3703$var$_default = (0, $b8aafabe628b3703$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "M2 4v16h20V4H2zm18 14H4V6h16v12z"
}), "RectangleOutlined");
$b8aafabe628b3703$exports.default = $b8aafabe628b3703$var$_default;


var $4f8a499d1aa7e166$exports = {};
"use strict";
"use client";

Object.defineProperty($4f8a499d1aa7e166$exports, "__esModule", {
    value: true
});
$4f8a499d1aa7e166$exports.default = void 0;

var $4f8a499d1aa7e166$var$_createSvgIcon = $dd204784e51ffdae$exports((parcelRequire("2jyxe")));

var $86rqb = parcelRequire("86rqb");
var $4f8a499d1aa7e166$var$_default = (0, $4f8a499d1aa7e166$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "CircleOutlined");
$4f8a499d1aa7e166$exports.default = $4f8a499d1aa7e166$var$_default;



var $86rqb = parcelRequire("86rqb");
parcelRequire("35jnV");
const $da4c0e24f799b108$var$SvgMouseArrow = (props)=>/*#__PURE__*/ (0, $86rqb.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        ...props,
        children: /*#__PURE__*/ (0, $86rqb.jsx)("path", {
            d: "m8.3 3.213 9.468 8.836a.75.75 0 0 1-.447 1.296L13.2 13.7l2.807 6.21a1.2 1.2 0 1 1-2.192.97L11.1 14.6l-2.833 2.695A.75.75 0 0 1 7 16.751V3.778a.773.773 0 0 1 1.3-.565z"
        })
    });
var $da4c0e24f799b108$export$2e2bcd8739ae039 = $da4c0e24f799b108$var$SvgMouseArrow;



var $86rqb = parcelRequire("86rqb");
parcelRequire("35jnV");
const $dbc5c032f60b5085$var$SvgEllipse = (props)=>/*#__PURE__*/ (0, $86rqb.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "-8 0 74 64",
        ...props,
        children: /*#__PURE__*/ (0, $86rqb.jsx)("path", {
            stroke: "#fff",
            strokeWidth: 4,
            d: "M32 53c17.645 0 32-9.42 32-21S49.645 11 32 11 0 20.42 0 32s14.355 21 32 21zm0-40c16.542 0 30 8.523 30 19S48.542 51 32 51 2 42.477 2 32s13.458-19 30-19z"
        })
    });
var $dbc5c032f60b5085$export$2e2bcd8739ae039 = $dbc5c032f60b5085$var$SvgEllipse;



var $86rqb = parcelRequire("86rqb");
parcelRequire("35jnV");
const $747b01d3e1fed58f$var$SvgLineSegment = (props)=>/*#__PURE__*/ (0, $86rqb.jsxs)("svg", {
        viewBox: "0 0 256 256",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $86rqb.jsx)("path", {
                fill: "none",
                d: "M0 0h256v256H0z"
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)("circle", {
                cx: 64,
                cy: 192,
                r: 24,
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 16
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)("circle", {
                cx: 192,
                cy: 64,
                r: 24,
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 16
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 16,
                d: "m175 81-94 94"
            })
        ]
    });
var $747b01d3e1fed58f$export$2e2bcd8739ae039 = $747b01d3e1fed58f$var$SvgLineSegment;



var $86rqb = parcelRequire("86rqb");
parcelRequire("35jnV");
const $8707742c30a3cde3$var$SvgDecimalArrowRight = (props)=>/*#__PURE__*/ (0, $86rqb.jsxs)("svg", {
        fill: "#fff",
        height: 24,
        width: 24,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $86rqb.jsx)("path", {
                d: "M10 4a3 3 0 0 0-3 3v4a3 3 0 1 0 6 0V7a3 3 0 0 0-3-3Zm1.5 7a1.5 1.5 0 0 1-3 0V7a1.5 1.5 0 1 1 3 0v4ZM5 12.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM19.5 7v4c0 .104-.01.206-.03.304.488.155.952.366 1.383.626.095-.293.147-.605.147-.93V7a3 3 0 1 0-6 0v4c0 .164.013.325.039.482.463-.19.953-.327 1.463-.406A1.485 1.485 0 0 1 16.5 11V7a1.5 1.5 0 0 1 3 0Z"
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)("path", {
                d: "M23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-8.5-.5a.5.5 0 0 0 0 1h4.793l-1.647 1.646a.5.5 0 0 0 .708.708l2.5-2.5a.5.5 0 0 0 0-.708l-2.5-2.5a.5.5 0 0 0-.708.708L19.293 17H14.5Z"
            })
        ]
    });
var $8707742c30a3cde3$export$2e2bcd8739ae039 = $8707742c30a3cde3$var$SvgDecimalArrowRight;


var $b2c182026664191f$export$1ca1ec8b29a4ce27;
var $b2c182026664191f$export$48cb82150909807;
var $b2c182026664191f$export$8fa4e5556fd77a60;
$b2c182026664191f$export$1ca1ec8b29a4ce27 = `QVptDW_icon`;
$b2c182026664191f$export$48cb82150909807 = `QVptDW_txtItem`;
$b2c182026664191f$export$8fa4e5556fd77a60 = `QVptDW_white`;


const $86648bbeef8811c6$var$ActionBar = [
    {
        icon: /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a291d896251377a7$exports))), {
            sx: {
                color: "white"
            }
        }),
        description: "Import a file or multiple files. The files will be sorted by the number in the file name."
    },
    {
        icon: /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f51a81b736208a40$exports))), {
            sx: {
                color: "white"
            }
        }),
        description: "Attach a previously exported JSON file. You can attach multiple times, where the comparison is based on filename, and data that cannot be matched will be ignored."
    },
    {
        icon: /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e5afa28d79f20446$exports))), {
            sx: {
                color: "white"
            }
        }),
        description: "Export a JSON file."
    }
];
const $86648bbeef8811c6$var$ToolBar = [
    {
        icon: /*#__PURE__*/ (0, $86rqb.jsx)((0, $da4c0e24f799b108$export$2e2bcd8739ae039), {
            className: (0, $3eTha.default)($b2c182026664191f$export$1ca1ec8b29a4ce27, $b2c182026664191f$export$8fa4e5556fd77a60)
        }),
        description: "Select the shape on the canvas."
    },
    {
        icon: /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b8aafabe628b3703$exports))), {
            fontSize: "medium",
            color: "action"
        }),
        description: "Draw a rectangle."
    },
    {
        icon: /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4f8a499d1aa7e166$exports))), {
            fontSize: "medium",
            color: "action"
        }),
        description: "Draw a circle."
    },
    {
        icon: /*#__PURE__*/ (0, $86rqb.jsx)((0, $dbc5c032f60b5085$export$2e2bcd8739ae039), {
            className: (0, $3eTha.default)($b2c182026664191f$export$1ca1ec8b29a4ce27, $b2c182026664191f$export$8fa4e5556fd77a60)
        }),
        description: "Draw an ellipse."
    },
    {
        icon: /*#__PURE__*/ (0, $86rqb.jsx)((0, $747b01d3e1fed58f$export$2e2bcd8739ae039), {
            className: (0, $3eTha.default)($b2c182026664191f$export$1ca1ec8b29a4ce27, $b2c182026664191f$export$8fa4e5556fd77a60)
        }),
        description: "Draw a custom shape, which can be a point, many lines, or a polygon. You can use the Alt (Win) or Cmd (⌘) key to quickly add a point."
    }
];
const $86648bbeef8811c6$var$HelpDialog = (props)=>{
    const { isOpen: isOpen, onClose: onClose } = props;
    return /*#__PURE__*/ (0, $86rqb.jsxs)((0, $cc913c42c481126a$export$2e2bcd8739ae039), {
        open: isOpen,
        onClose: onClose,
        fullWidth: true,
        maxWidth: "md",
        scroll: "paper",
        children: [
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $ae1b0976a75f7dc7$export$2e2bcd8739ae039), {
                children: "Help"
            }),
            /*#__PURE__*/ (0, $86rqb.jsxs)((0, $35e7b4998255ce79$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $cdb34482a76987c0$export$2e2bcd8739ae039), {
                        sx: {
                            marginBottom: 1,
                            fontWeight: "bold"
                        },
                        children: "Action Bar"
                    }),
                    $86648bbeef8811c6$var$ActionBar.map((item, index)=>{
                        const margin = index === 0 || index === $86648bbeef8811c6$var$ActionBar.length - 1 ? 0 : "10px 0";
                        return /*#__PURE__*/ (0, $86rqb.jsxs)((0, $f77466060e074182$export$2e2bcd8739ae039), {
                            sx: {
                                display: "flex",
                                margin: margin,
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, $86rqb.jsx)((0, $f9cfb77223705ddc$export$2e2bcd8739ae039), {
                                    sx: {
                                        marginRight: 1
                                    },
                                    children: item.icon
                                }),
                                /*#__PURE__*/ (0, $86rqb.jsx)((0, $cdb34482a76987c0$export$2e2bcd8739ae039), {
                                    children: item.description
                                })
                            ]
                        }, index);
                    }),
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $99ad0a2ae7367ab9$export$2e2bcd8739ae039), {
                        sx: {
                            margin: "10px 0"
                        }
                    }),
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $cdb34482a76987c0$export$2e2bcd8739ae039), {
                        sx: {
                            marginBottom: 1,
                            fontWeight: "bold"
                        },
                        children: "Tools"
                    }),
                    $86648bbeef8811c6$var$ToolBar.map((item, index)=>{
                        const margin = index === 0 || index === $86648bbeef8811c6$var$ToolBar.length - 1 ? 0 : "10px 0";
                        return /*#__PURE__*/ (0, $86rqb.jsxs)((0, $f77466060e074182$export$2e2bcd8739ae039), {
                            sx: {
                                display: "flex",
                                margin: margin,
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, $86rqb.jsx)((0, $f9cfb77223705ddc$export$2e2bcd8739ae039), {
                                    sx: {
                                        marginRight: 1
                                    },
                                    children: item.icon
                                }),
                                /*#__PURE__*/ (0, $86rqb.jsx)((0, $cdb34482a76987c0$export$2e2bcd8739ae039), {
                                    children: item.description
                                })
                            ]
                        }, index);
                    }),
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $99ad0a2ae7367ab9$export$2e2bcd8739ae039), {
                        sx: {
                            margin: "10px 0"
                        }
                    }),
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $cdb34482a76987c0$export$2e2bcd8739ae039), {
                        sx: {
                            marginBottom: "8px",
                            fontWeight: "bold"
                        },
                        children: "Settings"
                    }),
                    /*#__PURE__*/ (0, $86rqb.jsxs)((0, $f77466060e074182$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            margin: 0,
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $86rqb.jsx)((0, $f9cfb77223705ddc$export$2e2bcd8739ae039), {
                                sx: {
                                    marginRight: 1
                                },
                                children: /*#__PURE__*/ (0, $86rqb.jsx)((0, $8707742c30a3cde3$export$2e2bcd8739ae039), {
                                    className: (0, $3eTha.default)($b2c182026664191f$export$1ca1ec8b29a4ce27, $b2c182026664191f$export$8fa4e5556fd77a60)
                                })
                            }),
                            /*#__PURE__*/ (0, $86rqb.jsx)((0, $cdb34482a76987c0$export$2e2bcd8739ae039), {
                                children: "Set the precision of coordinates."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $86rqb.jsxs)("div", {
                        className: $b2c182026664191f$export$48cb82150909807,
                        children: [
                            /*#__PURE__*/ (0, $86rqb.jsx)((0, $cdb34482a76987c0$export$2e2bcd8739ae039), {
                                sx: {
                                    margin: "15px 0 5px 0"
                                },
                                children: "Tags"
                            }),
                            /*#__PURE__*/ (0, $86rqb.jsx)((0, $cdb34482a76987c0$export$2e2bcd8739ae039), {
                                sx: {
                                    marginLeft: "15px"
                                },
                                children: "Global tag management, where tags are used to classify each shape. If a used tag is deleted, no automatic action will be taken; manual deletion is required for each individual case."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $86648bbeef8811c6$export$2e2bcd8739ae039 = $86648bbeef8811c6$var$HelpDialog;



var $86rqb = parcelRequire("86rqb");

var $35jnV = parcelRequire("35jnV");
var $9384c319ea675985$export$180f5a427f17c0fe;
"use strict";

var $35jnV = parcelRequire("35jnV");
function $9384c319ea675985$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9384c319ea675985$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9384c319ea675985$var$_arrayLikeToArray(o, minLen);
}
function $9384c319ea675985$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9384c319ea675985$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $9384c319ea675985$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9384c319ea675985$var$shallow(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    if (objA instanceof Map && objB instanceof Map) {
        if (objA.size !== objB.size) return false;
        for(var _iterator = $9384c319ea675985$var$_createForOfIteratorHelperLoose(objA), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            if (!Object.is(value, objB.get(key))) return false;
        }
        return true;
    }
    if (objA instanceof Set && objB instanceof Set) {
        if (objA.size !== objB.size) return false;
        for(var _iterator2 = $9384c319ea675985$var$_createForOfIteratorHelperLoose(objA), _step2; !(_step2 = _iterator2()).done;){
            var _value = _step2.value;
            if (!objB.has(_value)) return false;
        }
        return true;
    }
    var keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
var $9384c319ea675985$var$useRef = $35jnV.useRef;
function $9384c319ea675985$var$useShallow(selector) {
    var prev = $9384c319ea675985$var$useRef();
    return function(state) {
        var next = selector(state);
        return $9384c319ea675985$var$shallow(prev.current, next) ? prev.current : prev.current = next;
    };
}
$9384c319ea675985$export$180f5a427f17c0fe = $9384c319ea675985$var$useShallow;



var $3eTha = parcelRequire("3eTha");

var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");


var $5wpQH = parcelRequire("5wpQH");
var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");

var $35jnV = parcelRequire("35jnV");
"use client";
const $44f9eed6cd856ac3$var$usePreviousProps = (value)=>{
    const ref = $35jnV.useRef({});
    $35jnV.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $44f9eed6cd856ac3$export$2e2bcd8739ae039 = $44f9eed6cd856ac3$var$usePreviousProps;


"use client";
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $1d8a71be951804b3$var$stripDiacritics(string) {
    return typeof string.normalize !== "undefined" ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : string;
}
function $1d8a71be951804b3$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = "any", stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $1d8a71be951804b3$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $1d8a71be951804b3$var$stripDiacritics(candidate);
            return matchFrom === "start" ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === "number" ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $1d8a71be951804b3$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $1d8a71be951804b3$var$defaultFilterOptions = $1d8a71be951804b3$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $1d8a71be951804b3$var$pageSize = 5;
const $1d8a71be951804b3$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
function $1d8a71be951804b3$export$1e40b3ca02d92d21(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $1d8a71be951804b3$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = "Mui", autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = "useAutocomplete", defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $1d8a71be951804b3$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $cffc89667014c06e$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== "string") return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $35jnV.useRef(false);
    const firstFocus = $35jnV.useRef(true);
    const inputRef = $35jnV.useRef(null);
    const listboxRef = $35jnV.useRef(null);
    const [anchorEl, setAnchorEl] = $35jnV.useState(null);
    const [focusedTag, setFocusedTag] = $35jnV.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $35jnV.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $e107187cc2d89c6e$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $e107187cc2d89c6e$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: "",
        name: componentName,
        state: "inputValue"
    });
    const [focused, setFocused] = $35jnV.useState(false);
    const resetInputValue = $35jnV.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = "";
        else if (newValue == null) newInputValue = "";
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === "string" ? optionLabel : "";
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, "reset");
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $e107187cc2d89c6e$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: "open"
    });
    const [inputPristine, setInputPristine] = $35jnV.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? "" : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $44f9eed6cd856ac3$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $35jnV.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $6fd92d7c6a65060f$export$2e2bcd8739ae039)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $35jnV.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === filteredOptions.length || direction === "previous" && nextFocus === -1) return -1;
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute("aria-disabled") === "true";
            if (option && !option.hasAttribute("tabindex") || nextFocusDisabled) // Move to the next element.
            nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const setHighlightedIndex = (0, $6fd92d7c6a65060f$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason = "auto" })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute("aria-activedescendant");
        else inputRef.current.setAttribute("aria-activedescendant", `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute("role") !== "listbox") listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === "keyboard") option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== "mouse" && reason !== "touch") {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $6fd92d7c6a65060f$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = "next", reason: reason = "auto" })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === "reset") return defaultHighlighted;
            if (diff === "start") return 0;
            if (diff === "end") return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== "reset") {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const checkHighlightedOptionExists = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : "";
            const label2 = value2 ? getOptionLabel(value2) : "";
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) {
                const previousHighlightedOptionExists = filteredOptions.some((option)=>{
                    return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
                });
                if (previousHighlightedOptionExists) return true;
            }
        }
        return false;
    };
    const syncHighlightedIndex = $35jnV.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, return, otherwise continue execution
        if (checkHighlightedOptionExists()) return;
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: "reset"
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $1d8a71be951804b3$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $1d8a71be951804b3$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: "reset"
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $6fd92d7c6a65060f$export$2e2bcd8739ae039)((node)=>{
        (0, $c2bab75447a7e10d$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $35jnV.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $35jnV.useRef(false);
    const selectNewValue = (event, option, reasonProp = "selectOption", origin = "options")=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $1d8a71be951804b3$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== "freeSolo") {
                newValue.splice(itemIndex, 1);
                reason = "removeOption";
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === "touch" && isTouch.current || blurOnSelect === "mouse" && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === value.length || direction === "previous" && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute("tabindex") || option.disabled || option.getAttribute("aria-disabled") === "true") nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === "") handleClose(event, "toggleInput");
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === "" && direction === "previous") nextTag = value.length - 1;
        } else {
            nextTag += direction === "next" ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState("");
        if (onInputChange) onInputChange(event, "", "clear");
        handleValue(event, multiple ? [] : null, "clear");
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                "ArrowLeft",
                "ArrowRight"
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case "Home":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "start",
                            direction: "next",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "End":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "end",
                            direction: "previous",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "PageUp":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$1d8a71be951804b3$var$pageSize,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "PageDown":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $1d8a71be951804b3$var$pageSize,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowDown":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowUp":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowLeft":
                    handleFocusTag(event, "previous");
                    break;
                case "ArrowRight":
                    handleFocusTag(event, "next");
                    break;
                case "Enter":
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, "selectOption");
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== "" && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, "createOption", "freeSolo");
                    }
                    break;
                case "Escape":
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, "escape");
                    } else if (clearOnEscape && (inputValue !== "" || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case "Backspace":
                    if (multiple && !readOnly && inputValue === "" && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                case "Delete":
                    if (multiple && !readOnly && inputValue === "" && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], "blur");
        else if (autoSelect && freeSolo && inputValue !== "") selectNewValue(event, inputValue, "blur", "freeSolo");
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, "blur");
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, "input");
        }
        if (newValue === "") {
            if (!disableClearable && !multiple) handleValue(event, null, "clear");
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: "mouse"
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute("data-option-index")),
            reason: "touch"
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        selectNewValue(event, filteredOptions[index], "selectOption");
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, "removeOption", {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, "toggleInput");
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute("id") !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === "" || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $lfXYn.default)({
                "aria-owns": listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                "aria-activedescendant": popupOpen ? "" : null,
                "aria-autocomplete": autoComplete ? "both" : "list",
                "aria-controls": listboxAvailable ? `${id}-listbox` : undefined,
                "aria-expanded": listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: "off",
                ref: inputRef,
                autoCapitalize: "none",
                spellCheck: "false",
                role: "combobox",
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $lfXYn.default)({
                key: index,
                "data-tag-index": index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: "listbox",
                id: `${id}-listbox`,
                "aria-labelledby": `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: getOptionLabel(option),
                tabIndex: -1,
                role: "option",
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                "data-option-index": index,
                "aria-disabled": disabled,
                "aria-selected": selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}



var $a7jdq = parcelRequire("a7jdq");


var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");

var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");

var $1OAmh = parcelRequire("1OAmh");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $97e924382079f3b3$export$6816d4fc0981ec7(slot) {
    return (0, $1reLR.default)("MuiListSubheader", slot);
}
const $97e924382079f3b3$var$listSubheaderClasses = (0, $ibC2g.default)("MuiListSubheader", [
    "root",
    "colorPrimary",
    "colorInherit",
    "gutters",
    "inset",
    "sticky"
]);
var $97e924382079f3b3$export$2e2bcd8739ae039 = $97e924382079f3b3$var$listSubheaderClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $f67eed7cc94ded95$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $f67eed7cc94ded95$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "default" && `color${(0, $1OAmh.default)(color)}`,
            !disableGutters && "gutters",
            inset && "inset",
            !disableSticky && "sticky"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $97e924382079f3b3$export$6816d4fc0981ec7), classes);
};
const $f67eed7cc94ded95$var$ListSubheaderRoot = (0, $jBVCU.default)("li", {
    name: "MuiListSubheader",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $1OAmh.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        boxSizing: "border-box",
        lineHeight: "48px",
        listStyle: "none",
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === "primary" && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $f67eed7cc94ded95$var$ListSubheader = /*#__PURE__*/ $35jnV.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiListSubheader"
    });
    const { className: className, color: color = "default", component: component = "li", disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $5NWw9.default)(props, $f67eed7cc94ded95$var$_excluded);
    const ownerState = (0, $lfXYn.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $f67eed7cc94ded95$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsx)($f67eed7cc94ded95$var$ListSubheaderRoot, (0, $lfXYn.default)({
        as: component,
        className: (0, $3eTha.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$f67eed7cc94ded95$var$ListSubheader.muiSkipListHighlight = true;
var $f67eed7cc94ded95$export$2e2bcd8739ae039 = $f67eed7cc94ded95$var$ListSubheader;





var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");

var $a7jdq = parcelRequire("a7jdq");
parcelRequire("35jnV");

var $5gNfQ = parcelRequire("5gNfQ");

var $86rqb = parcelRequire("86rqb");
"use client";
var $a2e1c49e48e1371f$export$2e2bcd8739ae039 = (0, $5gNfQ.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");





var $1OAmh = parcelRequire("1OAmh");


var $hZybU = parcelRequire("hZybU");

var $jBVCU = parcelRequire("jBVCU");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $6260faa45a2e5882$export$31444911e4ee6fdd(slot) {
    return (0, $1reLR.default)("MuiChip", slot);
}
const $6260faa45a2e5882$var$chipClasses = (0, $ibC2g.default)("MuiChip", [
    "root",
    "sizeSmall",
    "sizeMedium",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "disabled",
    "clickable",
    "clickableColorPrimary",
    "clickableColorSecondary",
    "deletable",
    "deletableColorPrimary",
    "deletableColorSecondary",
    "outlined",
    "filled",
    "outlinedPrimary",
    "outlinedSecondary",
    "filledPrimary",
    "filledSecondary",
    "avatar",
    "avatarSmall",
    "avatarMedium",
    "avatarColorPrimary",
    "avatarColorSecondary",
    "icon",
    "iconSmall",
    "iconMedium",
    "iconColorPrimary",
    "iconColorSecondary",
    "label",
    "labelSmall",
    "labelMedium",
    "deleteIcon",
    "deleteIconSmall",
    "deleteIconMedium",
    "deleteIconColorPrimary",
    "deleteIconColorSecondary",
    "deleteIconOutlinedColorPrimary",
    "deleteIconOutlinedColorSecondary",
    "deleteIconFilledColorPrimary",
    "deleteIconFilledColorSecondary",
    "focusVisible"
]);
var $6260faa45a2e5882$export$2e2bcd8739ae039 = $6260faa45a2e5882$var$chipClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $36d0917beaa92939$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $36d0917beaa92939$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            disabled && "disabled",
            `size${(0, $1OAmh.default)(size)}`,
            `color${(0, $1OAmh.default)(color)}`,
            clickable && "clickable",
            clickable && `clickableColor${(0, $1OAmh.default)(color)}`,
            onDelete && "deletable",
            onDelete && `deletableColor${(0, $1OAmh.default)(color)}`,
            `${variant}${(0, $1OAmh.default)(color)}`
        ],
        label: [
            "label",
            `label${(0, $1OAmh.default)(size)}`
        ],
        avatar: [
            "avatar",
            `avatar${(0, $1OAmh.default)(size)}`,
            `avatarColor${(0, $1OAmh.default)(color)}`
        ],
        icon: [
            "icon",
            `icon${(0, $1OAmh.default)(size)}`,
            `iconColor${(0, $1OAmh.default)(iconColor)}`
        ],
        deleteIcon: [
            "deleteIcon",
            `deleteIcon${(0, $1OAmh.default)(size)}`,
            `deleteIconColor${(0, $1OAmh.default)(color)}`,
            `deleteIcon${(0, $1OAmh.default)(variant)}Color${(0, $1OAmh.default)(color)}`
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $6260faa45a2e5882$export$31444911e4ee6fdd), classes);
};
const $36d0917beaa92939$var$ChipRoot = (0, $jBVCU.default)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $1OAmh.default)(size)}`]
            },
            {
                [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $1OAmh.default)(color)}`]
            },
            {
                [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $1OAmh.default)(size)}`]
            },
            {
                [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $1OAmh.default)(iconColor)}`]
            },
            {
                [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $1OAmh.default)(size)}`]
            },
            {
                [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $1OAmh.default)(color)}`]
            },
            {
                [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $1OAmh.default)(variant)}Color${(0, $1OAmh.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $1OAmh.default)(size)}`],
            styles[`color${(0, $1OAmh.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== "default" && styles[`clickableColor${(0, $1OAmh.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== "default" && styles[`deletableColor${(0, $1OAmh.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $1OAmh.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $lfXYn.default)({
        maxWidth: "100%",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "background-color",
            "box-shadow"
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: "unset",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: "none",
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: "middle",
        boxSizing: "border-box",
        [`&.${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: "none"
        },
        [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).icon}`]: (0, $lfXYn.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === "small" && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $lfXYn.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== "default" && {
            color: "inherit"
        })),
        [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).deleteIcon}`]: (0, $lfXYn.default)({
            WebkitTapHighlightColor: "transparent",
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $a7jdq.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $a7jdq.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === "small" && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== "default" && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $a7jdq.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === "small" && {
        height: 24
    }, ownerState.color !== "default" && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $a7jdq.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== "default" && {
        [`&.${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({}, ownerState.clickable && {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $a7jdq.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $a7jdq.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== "default" && {
        [`&:hover, &.${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({}, ownerState.variant === "outlined" && {
        backgroundColor: "transparent",
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $a7jdq.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $a7jdq.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $a7jdq.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $6260faa45a2e5882$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $a7jdq.alpha)(theme.palette[ownerState.color].main, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $36d0917beaa92939$var$ChipLabel = (0, $jBVCU.default)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $1OAmh.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $lfXYn.default)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: "nowrap"
    }, ownerState.size === "small" && {
        paddingLeft: 8,
        paddingRight: 8
    }));
function $36d0917beaa92939$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $36d0917beaa92939$var$Chip = /*#__PURE__*/ $35jnV.forwardRef(function Chip(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiChip"
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = "default", component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = "medium", variant: variant = "filled", tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $5NWw9.default)(props, $36d0917beaa92939$var$_excluded);
    const chipRef = $35jnV.useRef(null);
    const handleRef = (0, $e6f4f6562381f94e$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $36d0917beaa92939$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $36d0917beaa92939$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $38bba7b782da1f95$export$2e2bcd8739ae039) : ComponentProp || "div";
    const ownerState = (0, $lfXYn.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $35jnV.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $36d0917beaa92939$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $38bba7b782da1f95$export$2e2bcd8739ae039) ? (0, $lfXYn.default)({
        component: ComponentProp || "div",
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $35jnV.isValidElement(deleteIconProp) ? /*#__PURE__*/ $35jnV.cloneElement(deleteIconProp, {
        className: (0, $3eTha.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $86rqb.jsx)((0, $a2e1c49e48e1371f$export$2e2bcd8739ae039), {
        className: (0, $3eTha.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $35jnV.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $35jnV.cloneElement(avatarProp, {
        className: (0, $3eTha.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $35jnV.isValidElement(iconProp)) icon = /*#__PURE__*/ $35jnV.cloneElement(iconProp, {
        className: (0, $3eTha.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $86rqb.jsxs)($36d0917beaa92939$var$ChipRoot, (0, $lfXYn.default)({
        as: component,
        className: (0, $3eTha.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $86rqb.jsx)($36d0917beaa92939$var$ChipLabel, {
                className: (0, $3eTha.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $36d0917beaa92939$export$2e2bcd8739ae039 = $36d0917beaa92939$var$Chip;



var $lfXYn = parcelRequire("lfXYn");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $d48daa28d0186235$export$ef57d5c8ca2278f6(slot) {
    return (0, $1reLR.default)("MuiInputBase", slot);
}
const $d48daa28d0186235$var$inputBaseClasses = (0, $ibC2g.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $d48daa28d0186235$export$2e2bcd8739ae039 = $d48daa28d0186235$var$inputBaseClasses;


function $d6f635ec999a1ace$export$cdb270390122322b(slot) {
    return (0, $1reLR.default)("MuiInput", slot);
}
const $d6f635ec999a1ace$var$inputClasses = (0, $lfXYn.default)({}, (0, $d48daa28d0186235$export$2e2bcd8739ae039), (0, $ibC2g.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $d6f635ec999a1ace$export$2e2bcd8739ae039 = $d6f635ec999a1ace$var$inputClasses;




var $lfXYn = parcelRequire("lfXYn");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");

function $b60b2c4386a650d8$export$89922944c7227687(slot) {
    return (0, $1reLR.default)("MuiOutlinedInput", slot);
}
const $b60b2c4386a650d8$var$outlinedInputClasses = (0, $lfXYn.default)({}, (0, $d48daa28d0186235$export$2e2bcd8739ae039), (0, $ibC2g.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $b60b2c4386a650d8$export$2e2bcd8739ae039 = $b60b2c4386a650d8$var$outlinedInputClasses;



var $lfXYn = parcelRequire("lfXYn");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");

function $14aca27c6ddfb069$export$3331e419f1a48437(slot) {
    return (0, $1reLR.default)("MuiFilledInput", slot);
}
const $14aca27c6ddfb069$var$filledInputClasses = (0, $lfXYn.default)({}, (0, $d48daa28d0186235$export$2e2bcd8739ae039), (0, $ibC2g.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $14aca27c6ddfb069$export$2e2bcd8739ae039 = $14aca27c6ddfb069$var$filledInputClasses;


parcelRequire("35jnV");

var $5gNfQ = parcelRequire("5gNfQ");

var $86rqb = parcelRequire("86rqb");
"use client";
var $2f7b73ad6860a068$export$2e2bcd8739ae039 = (0, $5gNfQ.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");


parcelRequire("35jnV");

var $5gNfQ = parcelRequire("5gNfQ");

var $86rqb = parcelRequire("86rqb");
"use client";
var $f2f57472eceea45b$export$2e2bcd8739ae039 = (0, $5gNfQ.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");



var $hZybU = parcelRequire("hZybU");

var $jBVCU = parcelRequire("jBVCU");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $06b7ce11b5032bfb$export$8ee01529667e66d9(slot) {
    return (0, $1reLR.default)("MuiAutocomplete", slot);
}
const $06b7ce11b5032bfb$var$autocompleteClasses = (0, $ibC2g.default)("MuiAutocomplete", [
    "root",
    "expanded",
    "fullWidth",
    "focused",
    "focusVisible",
    "tag",
    "tagSizeSmall",
    "tagSizeMedium",
    "hasPopupIcon",
    "hasClearIcon",
    "inputRoot",
    "input",
    "inputFocused",
    "endAdornment",
    "clearIndicator",
    "popupIndicator",
    "popupIndicatorOpen",
    "popper",
    "popperDisablePortal",
    "paper",
    "listbox",
    "loading",
    "noOptions",
    "option",
    "groupLabel",
    "groupUl"
]);
var $06b7ce11b5032bfb$export$2e2bcd8739ae039 = $06b7ce11b5032bfb$var$autocompleteClasses;



var $1OAmh = parcelRequire("1OAmh");


var $86rqb = parcelRequire("86rqb");
"use client";
var $126e412c1a491480$var$_ClearIcon, $126e412c1a491480$var$_ArrowDropDownIcon;
const $126e412c1a491480$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $126e412c1a491480$var$_excluded2 = [
    "ref"
];
const $126e412c1a491480$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            expanded && "expanded",
            focused && "focused",
            fullWidth && "fullWidth",
            hasClearIcon && "hasClearIcon",
            hasPopupIcon && "hasPopupIcon"
        ],
        inputRoot: [
            "inputRoot"
        ],
        input: [
            "input",
            inputFocused && "inputFocused"
        ],
        tag: [
            "tag",
            `tagSize${(0, $1OAmh.default)(size)}`
        ],
        endAdornment: [
            "endAdornment"
        ],
        clearIndicator: [
            "clearIndicator"
        ],
        popupIndicator: [
            "popupIndicator",
            popupOpen && "popupIndicatorOpen"
        ],
        popper: [
            "popper",
            disablePortal && "popperDisablePortal"
        ],
        paper: [
            "paper"
        ],
        listbox: [
            "listbox"
        ],
        loading: [
            "loading"
        ],
        noOptions: [
            "noOptions"
        ],
        option: [
            "option"
        ],
        groupLabel: [
            "groupLabel"
        ],
        groupUl: [
            "groupUl"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $06b7ce11b5032bfb$export$8ee01529667e66d9), classes);
};
const $126e412c1a491480$var$AutocompleteRoot = (0, $jBVCU.default)("div", {
    name: "MuiAutocomplete",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $1OAmh.default)(size)}`]
            },
            {
                [`& .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})(({ ownerState: ownerState })=>(0, $lfXYn.default)({
        [`&.${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).focused} .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: "visible"
        },
        /* Avoid double tap issue on iOS */ "@media (pointer: fine)": {
            [`&:hover .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).clearIndicator}`]: {
                visibility: "visible"
            }
        }
    }, ownerState.fullWidth && {
        width: "100%"
    }, {
        [`& .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).tag}`]: (0, $lfXYn.default)({
            margin: 3,
            maxWidth: "calc(100% - 6px)"
        }, ownerState.size === "small" && {
            margin: 2,
            maxWidth: "calc(100% - 4px)"
        }),
        [`& .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).inputRoot}`]: {
            flexWrap: "wrap",
            [`.${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 30
            },
            [`.${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 56
            },
            [`& .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).input}`]: {
                width: 0,
                minWidth: 30
            }
        },
        [`& .${(0, $d6f635ec999a1ace$export$2e2bcd8739ae039).root}`]: {
            paddingBottom: 1,
            "& .MuiInput-input": {
                padding: "4px 4px 4px 0px"
            }
        },
        [`& .${(0, $d6f635ec999a1ace$export$2e2bcd8739ae039).root}.${(0, $d48daa28d0186235$export$2e2bcd8739ae039).sizeSmall}`]: {
            [`& .${(0, $d6f635ec999a1ace$export$2e2bcd8739ae039).input}`]: {
                padding: "2px 4px 3px 0"
            }
        },
        [`& .${(0, $b60b2c4386a650d8$export$2e2bcd8739ae039).root}`]: {
            padding: 9,
            [`.${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).input}`]: {
                padding: "7.5px 4px 7.5px 5px"
            },
            [`& .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, $b60b2c4386a650d8$export$2e2bcd8739ae039).root}.${(0, $d48daa28d0186235$export$2e2bcd8739ae039).sizeSmall}`]: {
            // Don't specify paddingRight, as it overrides the default value set when there is only
            // one of the popup or clear icon as the specificity is equal so the latter one wins
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            [`& .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).input}`]: {
                padding: "2.5px 4px 2.5px 8px"
            }
        },
        [`& .${(0, $14aca27c6ddfb069$export$2e2bcd8739ae039).root}`]: {
            paddingTop: 19,
            paddingLeft: 8,
            [`.${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, $14aca27c6ddfb069$export$2e2bcd8739ae039).input}`]: {
                padding: "7px 4px"
            },
            [`& .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, $14aca27c6ddfb069$export$2e2bcd8739ae039).root}.${(0, $d48daa28d0186235$export$2e2bcd8739ae039).sizeSmall}`]: {
            paddingBottom: 1,
            [`& .${(0, $14aca27c6ddfb069$export$2e2bcd8739ae039).input}`]: {
                padding: "2.5px 4px"
            }
        },
        [`& .${(0, $d48daa28d0186235$export$2e2bcd8739ae039).hiddenLabel}`]: {
            paddingTop: 8
        },
        [`& .${(0, $14aca27c6ddfb069$export$2e2bcd8739ae039).root}.${(0, $d48daa28d0186235$export$2e2bcd8739ae039).hiddenLabel}`]: {
            paddingTop: 0,
            paddingBottom: 0,
            [`& .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).input}`]: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        [`& .${(0, $14aca27c6ddfb069$export$2e2bcd8739ae039).root}.${(0, $d48daa28d0186235$export$2e2bcd8739ae039).hiddenLabel}.${(0, $d48daa28d0186235$export$2e2bcd8739ae039).sizeSmall}`]: {
            [`& .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).input}`]: {
                paddingTop: 8,
                paddingBottom: 9
            }
        },
        [`& .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).input}`]: (0, $lfXYn.default)({
            flexGrow: 1,
            textOverflow: "ellipsis",
            opacity: 0
        }, ownerState.inputFocused && {
            opacity: 1
        })
    }));
const $126e412c1a491480$var$AutocompleteEndAdornment = (0, $jBVCU.default)("div", {
    name: "MuiAutocomplete",
    slot: "EndAdornment",
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: "absolute",
    right: 0,
    top: "calc(50% - 14px)" // Center vertically
});
const $126e412c1a491480$var$AutocompleteClearIndicator = (0, $jBVCU.default)((0, $0d33723cc471c46b$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "ClearIndicator",
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: "hidden"
});
const $126e412c1a491480$var$AutocompletePopupIndicator = (0, $jBVCU.default)((0, $0d33723cc471c46b$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "PopupIndicator",
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $lfXYn.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})(({ ownerState: ownerState })=>(0, $lfXYn.default)({
        padding: 2,
        marginRight: -2
    }, ownerState.popupOpen && {
        transform: "rotate(180deg)"
    }));
const $126e412c1a491480$var$AutocompletePopper = (0, $jBVCU.default)((0, $c5eebed803150dc0$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        zIndex: (theme.vars || theme).zIndex.modal
    }, ownerState.disablePortal && {
        position: "absolute"
    }));
const $126e412c1a491480$var$AutocompletePaper = (0, $jBVCU.default)((0, $2fbb4bae37b10470$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $lfXYn.default)({}, theme.typography.body1, {
        overflow: "auto"
    }));
const $126e412c1a491480$var$AutocompleteLoading = (0, $jBVCU.default)("div", {
    name: "MuiAutocomplete",
    slot: "Loading",
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $126e412c1a491480$var$AutocompleteNoOptions = (0, $jBVCU.default)("div", {
    name: "MuiAutocomplete",
    slot: "NoOptions",
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $126e412c1a491480$var$AutocompleteListbox = (0, $jBVCU.default)("div", {
    name: "MuiAutocomplete",
    slot: "Listbox",
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: "none",
        margin: 0,
        padding: "8px 0",
        maxHeight: "40vh",
        overflow: "auto",
        position: "relative",
        [`& .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: "flex",
            overflow: "hidden",
            justifyContent: "flex-start",
            alignItems: "center",
            cursor: "pointer",
            paddingTop: 6,
            boxSizing: "border-box",
            outline: "0",
            WebkitTapHighlightColor: "transparent",
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up("sm")]: {
                minHeight: "auto"
            },
            [`&.${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: "none"
            },
            [`&.${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $a7jdq.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $a7jdq.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $a7jdq.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $126e412c1a491480$var$AutocompleteGroupLabel = (0, $jBVCU.default)((0, $f67eed7cc94ded95$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "GroupLabel",
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $126e412c1a491480$var$AutocompleteGroupUl = (0, $jBVCU.default)("ul", {
    name: "MuiAutocomplete",
    slot: "GroupUl",
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $06b7ce11b5032bfb$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $126e412c1a491480$var$Autocomplete = /*#__PURE__*/ $35jnV.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiAutocomplete"
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $126e412c1a491480$var$_ClearIcon || ($126e412c1a491480$var$_ClearIcon = /*#__PURE__*/ (0, $86rqb.jsx)((0, $2f7b73ad6860a068$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = "Clear", closeText: closeText = "Close", componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = "auto", freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = "ul", ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading…", multiple: multiple = false, noOptionsText: noOptionsText = "No options", openOnFocus: openOnFocus = false, openText: openText = "Open", PaperComponent: PaperComponent = (0, $2fbb4bae37b10470$export$2e2bcd8739ae039), PopperComponent: PopperComponent = (0, $c5eebed803150dc0$export$2e2bcd8739ae039), popupIcon: popupIcon = $126e412c1a491480$var$_ArrowDropDownIcon || ($126e412c1a491480$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $86rqb.jsx)((0, $f2f57472eceea45b$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = "medium", slotProps: slotProps = {} } = props, other = (0, $5NWw9.default)(props, $126e412c1a491480$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $1d8a71be951804b3$export$1e40b3ca02d92d21)((0, $lfXYn.default)({}, props, {
        componentName: "Autocomplete"
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $5NWw9.default)(_getListboxProps, $126e412c1a491480$var$_excluded2);
    const combinedListboxRef = (0, $e6f4f6562381f94e$export$2e2bcd8739ae039)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $lfXYn.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $126e412c1a491480$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $lfXYn.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>/*#__PURE__*/ (0, $86rqb.jsx)((0, $36d0917beaa92939$export$2e2bcd8739ae039), (0, $lfXYn.default)({
                label: getOptionLabel(option),
                size: size
            }, getCustomizedTagProps({
                index: index
            }), ChipProps)));
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $86rqb.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $86rqb.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $86rqb.jsx)($126e412c1a491480$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $86rqb.jsx)($126e412c1a491480$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>/*#__PURE__*/ (0, $86rqb.jsx)("li", (0, $lfXYn.default)({}, props2, {
            children: getOptionLabel(option)
        }));
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $lfXYn.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps["aria-selected"],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    return /*#__PURE__*/ (0, $86rqb.jsxs)($35jnV.Fragment, {
        children: [
            /*#__PURE__*/ (0, $86rqb.jsx)($126e412c1a491480$var$AutocompleteRoot, (0, $lfXYn.default)({
                ref: ref,
                className: (0, $3eTha.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === "small" ? "small" : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $lfXYn.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $86rqb.jsxs)($126e412c1a491480$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $86rqb.jsx)($126e412c1a491480$var$AutocompleteClearIndicator, (0, $lfXYn.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $3eTha.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $86rqb.jsx)($126e412c1a491480$var$AutocompletePopupIndicator, (0, $lfXYn.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $3eTha.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $lfXYn.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? /*#__PURE__*/ (0, $86rqb.jsx)($126e412c1a491480$var$AutocompletePopper, (0, $lfXYn.default)({
                as: PopperComponent,
                disablePortal: disablePortal,
                style: {
                    width: anchorEl ? anchorEl.clientWidth : null
                },
                ownerState: ownerState,
                role: "presentation",
                anchorEl: anchorEl,
                open: popupOpen
            }, popperSlotProps, {
                className: (0, $3eTha.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
                children: /*#__PURE__*/ (0, $86rqb.jsxs)($126e412c1a491480$var$AutocompletePaper, (0, $lfXYn.default)({
                    ownerState: ownerState,
                    as: PaperComponent
                }, paperSlotProps, {
                    className: (0, $3eTha.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $86rqb.jsx)($126e412c1a491480$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $86rqb.jsx)($126e412c1a491480$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $86rqb.jsx)($126e412c1a491480$var$AutocompleteListbox, (0, $lfXYn.default)({
                            as: ListboxComponent,
                            className: classes.listbox,
                            ownerState: ownerState
                        }, otherListboxProps, ListboxProps, {
                            ref: combinedListboxRef,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            })) : null
        ]
    });
});
var $126e412c1a491480$export$2e2bcd8739ae039 = $126e412c1a491480$var$Autocomplete;



var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");


var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");

var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $5wpQH = parcelRequire("5wpQH");

var $a2Szr = parcelRequire("a2Szr");

var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $5r8Xx = parcelRequire("5r8Xx");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $35jnV = parcelRequire("35jnV");


// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $0a0d04c9abb87419$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}



var $86rqb = parcelRequire("86rqb");
"use client";
const $ed6921d02b7d4076$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $ed6921d02b7d4076$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $ed6921d02b7d4076$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $ed6921d02b7d4076$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflow;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $ed6921d02b7d4076$export$d1710922ecaf577a = /*#__PURE__*/ $35jnV.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $5NWw9.default)(props, $ed6921d02b7d4076$var$_excluded);
    const { current: isControlled } = $35jnV.useRef(value != null);
    const inputRef = $35jnV.useRef(null);
    const handleRef = (0, $0516f23cce01a3cc$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const shadowRef = $35jnV.useRef(null);
    const renders = $35jnV.useRef(0);
    const [state, setState] = $35jnV.useState({
        outerHeightStyle: 0
    });
    const getUpdatedState = $35jnV.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $5e11b4a87d60cb67$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $ed6921d02b7d4076$var$getStyleValue(computedStyle.paddingBottom) + $ed6921d02b7d4076$var$getStyleValue(computedStyle.paddingTop);
        const border = $ed6921d02b7d4076$var$getStyleValue(computedStyle.borderBottomWidth) + $ed6921d02b7d4076$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflow: overflow
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const updateState = (prevState, newState)=>{
        const { outerHeightStyle: outerHeightStyle, overflow: overflow } = newState;
        // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
            renders.current += 1;
            return {
                overflow: overflow,
                outerHeightStyle: outerHeightStyle
            };
        }
        return prevState;
    };
    const syncHeight = $35jnV.useCallback(()=>{
        const newState = getUpdatedState();
        if ($ed6921d02b7d4076$var$isEmpty(newState)) return;
        setState((prevState)=>updateState(prevState, newState));
    }, [
        getUpdatedState
    ]);
    (0, $6d8594980b4d41a4$export$2e2bcd8739ae039)(()=>{
        const syncHeightWithFlushSync = ()=>{
            const newState = getUpdatedState();
            if ($ed6921d02b7d4076$var$isEmpty(newState)) return;
            // In React 18, state updates in a ResizeObserver's callback are happening after
            // the paint, this leads to an infinite rendering.
            //
            // Using flushSync ensures that the states is updated before the next pain.
            // Related issue - https://github.com/facebook/react/issues/24331
            $90e5093ac8ea5052$exports.flushSync(()=>{
                setState((prevState)=>updateState(prevState, newState));
            });
        };
        const handleResize = ()=>{
            renders.current = 0;
            syncHeightWithFlushSync();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $0a0d04c9abb87419$export$2e2bcd8739ae039)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $5e11b4a87d60cb67$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener("resize", debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener("resize", debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        getUpdatedState
    ]);
    (0, $6d8594980b4d41a4$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    $35jnV.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $86rqb.jsxs)($35jnV.Fragment, {
        children: [
            /*#__PURE__*/ (0, $86rqb.jsx)("textarea", (0, $lfXYn.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: (0, $lfXYn.default)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? "hidden" : undefined
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $86rqb.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $lfXYn.default)({}, $ed6921d02b7d4076$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});


var $5wpQH = parcelRequire("5wpQH");
function $85be9b3ae8b6cb54$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $35jnV = parcelRequire("35jnV");
/**
 * @ignore - internal component.
 */ const $f512ba7eb8a37cdf$var$FormControlContext = /*#__PURE__*/ $35jnV.createContext(undefined);
var $f512ba7eb8a37cdf$export$2e2bcd8739ae039 = $f512ba7eb8a37cdf$var$FormControlContext;



var $35jnV = parcelRequire("35jnV");

"use client";
function $cbd44d6f2be34113$export$2e2bcd8739ae039() {
    return $35jnV.useContext((0, $f512ba7eb8a37cdf$export$2e2bcd8739ae039));
}



var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");

var $1OAmh = parcelRequire("1OAmh");


"use client";
var $485be479215a4887$export$2e2bcd8739ae039 = (0, $6d8594980b4d41a4$export$2e2bcd8739ae039);



// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $695f74257dda9627$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $695f74257dda9627$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($695f74257dda9627$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $695f74257dda9627$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $695f74257dda9627$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}




var $86rqb = parcelRequire("86rqb");
"use client";
const $8dbad49b9e916ab4$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $8dbad49b9e916ab4$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $1OAmh.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $8dbad49b9e916ab4$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $8dbad49b9e916ab4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $1OAmh.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, $1OAmh.default)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $d48daa28d0186235$export$ef57d5c8ca2278f6), classes);
};
const $8dbad49b9e916ab4$export$298a043133d72a38 = (0, $jBVCU.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $8dbad49b9e916ab4$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $d48daa28d0186235$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $lfXYn.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $8dbad49b9e916ab4$export$a1ad29c901026019 = (0, $jBVCU.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $8dbad49b9e916ab4$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $lfXYn.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $lfXYn.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $d48daa28d0186235$export$2e2bcd8739ae039).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $d48daa28d0186235$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $8dbad49b9e916ab4$var$inputGlobalStyles = /*#__PURE__*/ (0, $86rqb.jsx)((0, $b1742c606b8942a6$export$2e2bcd8739ae039), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $8dbad49b9e916ab4$var$InputBase = /*#__PURE__*/ $35jnV.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $5NWw9.default)(props, $8dbad49b9e916ab4$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $35jnV.useRef(value != null);
    const inputRef = $35jnV.useRef();
    const handleInputRefWarning = $35jnV.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $e6f4f6562381f94e$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $35jnV.useState(false);
    const muiFormControl = (0, $cbd44d6f2be34113$export$2e2bcd8739ae039)();
    const fcs = (0, $85be9b3ae8b6cb54$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $35jnV.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $35jnV.useCallback((obj)=>{
        if ((0, $695f74257dda9627$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $485be479215a4887$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $5r8Xx.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $35jnV.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $lfXYn.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $lfXYn.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $ed6921d02b7d4076$export$d1710922ecaf577a);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $35jnV.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $lfXYn.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $8dbad49b9e916ab4$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $8dbad49b9e916ab4$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $8dbad49b9e916ab4$export$a1ad29c901026019;
    inputProps = (0, $lfXYn.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $86rqb.jsxs)($35jnV.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $8dbad49b9e916ab4$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $86rqb.jsxs)(Root, (0, $lfXYn.default)({}, rootProps, !(0, $34edd9d120733306$export$e28348cc2430497)(Root) && {
                ownerState: (0, $lfXYn.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $3eTha.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $f512ba7eb8a37cdf$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $86rqb.jsx)(Input, (0, $lfXYn.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $34edd9d120733306$export$e28348cc2430497)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $lfXYn.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $3eTha.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $lfXYn.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $8dbad49b9e916ab4$export$2e2bcd8739ae039 = $8dbad49b9e916ab4$var$InputBase;



var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");



var $86rqb = parcelRequire("86rqb");
"use client";
const $f1f64ea3522afab8$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $f1f64ea3522afab8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $5wpQH.default)(slots, (0, $d6f635ec999a1ace$export$cdb270390122322b), classes);
    return (0, $lfXYn.default)({}, classes, composedClasses);
};
const $f1f64ea3522afab8$var$InputRoot = (0, $jBVCU.default)((0, $8dbad49b9e916ab4$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $jBVCU.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $8dbad49b9e916ab4$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $lfXYn.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $d6f635ec999a1ace$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $d6f635ec999a1ace$export$2e2bcd8739ae039).error}`]: {
            "&:before, &:after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&:before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $d6f635ec999a1ace$export$2e2bcd8739ae039).disabled}, .${(0, $d6f635ec999a1ace$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $d6f635ec999a1ace$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $f1f64ea3522afab8$var$InputInput = (0, $jBVCU.default)((0, $8dbad49b9e916ab4$export$a1ad29c901026019), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $8dbad49b9e916ab4$export$cf507b112810e72d)
})({});
const $f1f64ea3522afab8$var$Input = /*#__PURE__*/ $35jnV.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $5NWw9.default)(props, $f1f64ea3522afab8$var$_excluded);
    const classes = $f1f64ea3522afab8$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $a2Szr.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $f1f64ea3522afab8$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $f1f64ea3522afab8$var$InputInput;
    return /*#__PURE__*/ (0, $86rqb.jsx)((0, $8dbad49b9e916ab4$export$2e2bcd8739ae039), (0, $lfXYn.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$f1f64ea3522afab8$var$Input.muiName = "Input";
var $f1f64ea3522afab8$export$2e2bcd8739ae039 = $f1f64ea3522afab8$var$Input;



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");

var $a2Szr = parcelRequire("a2Szr");


var $5wpQH = parcelRequire("5wpQH");


var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");



var $86rqb = parcelRequire("86rqb");
"use client";
const $5d238b64b867cb55$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $5d238b64b867cb55$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $5wpQH.default)(slots, (0, $14aca27c6ddfb069$export$3331e419f1a48437), classes);
    return (0, $lfXYn.default)({}, classes, composedClasses);
};
const $5d238b64b867cb55$var$FilledInputRoot = (0, $jBVCU.default)((0, $8dbad49b9e916ab4$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $jBVCU.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $8dbad49b9e916ab4$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $lfXYn.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $14aca27c6ddfb069$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $14aca27c6ddfb069$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $14aca27c6ddfb069$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $14aca27c6ddfb069$export$2e2bcd8739ae039).error}`]: {
            "&:before, &:after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&:before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $14aca27c6ddfb069$export$2e2bcd8739ae039).disabled}, .${(0, $14aca27c6ddfb069$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $14aca27c6ddfb069$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $lfXYn.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }));
});
const $5d238b64b867cb55$var$FilledInputInput = (0, $jBVCU.default)((0, $8dbad49b9e916ab4$export$a1ad29c901026019), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $8dbad49b9e916ab4$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
const $5d238b64b867cb55$var$FilledInput = /*#__PURE__*/ $35jnV.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $5NWw9.default)(props, $5d238b64b867cb55$var$_excluded);
    const ownerState = (0, $lfXYn.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $5d238b64b867cb55$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $a2Szr.default)(slotProps != null ? slotProps : componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $5d238b64b867cb55$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $5d238b64b867cb55$var$FilledInputInput;
    return /*#__PURE__*/ (0, $86rqb.jsx)((0, $8dbad49b9e916ab4$export$2e2bcd8739ae039), (0, $lfXYn.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$5d238b64b867cb55$var$FilledInput.muiName = "Input";
var $5d238b64b867cb55$export$2e2bcd8739ae039 = $5d238b64b867cb55$var$FilledInput;



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");



var $5wpQH = parcelRequire("5wpQH");

var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");
parcelRequire("35jnV");


var $jBVCU = parcelRequire("jBVCU");

var $86rqb = parcelRequire("86rqb");
"use client";
var $f1cbef861f987c44$var$_span;
const $f1cbef861f987c44$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $f1cbef861f987c44$var$NotchedOutlineRoot = (0, $jBVCU.default)("fieldset")({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $f1cbef861f987c44$var$NotchedOutlineLegend = (0, $jBVCU.default)("legend")(({ ownerState: ownerState, theme: theme })=>(0, $lfXYn.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $lfXYn.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $f1cbef861f987c44$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $5NWw9.default)(props, $f1cbef861f987c44$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $lfXYn.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $86rqb.jsx)($f1cbef861f987c44$var$NotchedOutlineRoot, (0, $lfXYn.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $86rqb.jsx)($f1cbef861f987c44$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $86rqb.jsx)("span", {
                children: label
            }) : $f1cbef861f987c44$var$_span || ($f1cbef861f987c44$var$_span = /*#__PURE__*/ (0, $86rqb.jsx)("span", {
                className: "notranslate",
                children: "​"
            }))
        })
    }));
}





var $jBVCU = parcelRequire("jBVCU");



var $hZybU = parcelRequire("hZybU");

var $86rqb = parcelRequire("86rqb");
"use client";
const $127bdd49c97d847c$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $127bdd49c97d847c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $5wpQH.default)(slots, (0, $b60b2c4386a650d8$export$89922944c7227687), classes);
    return (0, $lfXYn.default)({}, classes, composedClasses);
};
const $127bdd49c97d847c$var$OutlinedInputRoot = (0, $jBVCU.default)((0, $8dbad49b9e916ab4$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $jBVCU.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $8dbad49b9e916ab4$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $lfXYn.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $b60b2c4386a650d8$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $b60b2c4386a650d8$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $b60b2c4386a650d8$export$2e2bcd8739ae039).focused} .${(0, $b60b2c4386a650d8$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $b60b2c4386a650d8$export$2e2bcd8739ae039).error} .${(0, $b60b2c4386a650d8$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $b60b2c4386a650d8$export$2e2bcd8739ae039).disabled} .${(0, $b60b2c4386a650d8$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $lfXYn.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $127bdd49c97d847c$var$NotchedOutlineRoot = (0, $jBVCU.default)((0, $f1cbef861f987c44$export$2e2bcd8739ae039), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $127bdd49c97d847c$var$OutlinedInputInput = (0, $jBVCU.default)((0, $8dbad49b9e916ab4$export$a1ad29c901026019), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $8dbad49b9e916ab4$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $127bdd49c97d847c$var$OutlinedInput = /*#__PURE__*/ $35jnV.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text" } = props, other = (0, $5NWw9.default)(props, $127bdd49c97d847c$var$_excluded);
    const classes = $127bdd49c97d847c$var$useUtilityClasses(props);
    const muiFormControl = (0, $cbd44d6f2be34113$export$2e2bcd8739ae039)();
    const fcs = (0, $85be9b3ae8b6cb54$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = (0, $lfXYn.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $127bdd49c97d847c$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $127bdd49c97d847c$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $86rqb.jsx)((0, $8dbad49b9e916ab4$export$2e2bcd8739ae039), (0, $lfXYn.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $86rqb.jsx)($127bdd49c97d847c$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $86rqb.jsxs)($35jnV.Fragment, {
                    children: [
                        label,
                        " ",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $lfXYn.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$127bdd49c97d847c$var$OutlinedInput.muiName = "Input";
var $127bdd49c97d847c$export$2e2bcd8739ae039 = $127bdd49c97d847c$var$OutlinedInput;



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $5wpQH = parcelRequire("5wpQH");

var $3eTha = parcelRequire("3eTha");



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");



var $1OAmh = parcelRequire("1OAmh");

var $hZybU = parcelRequire("hZybU");

var $jBVCU = parcelRequire("jBVCU");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $60f10b233b911eb3$export$f7d501e40371cd17(slot) {
    return (0, $1reLR.default)("MuiFormLabel", slot);
}
const $60f10b233b911eb3$var$formLabelClasses = (0, $ibC2g.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $60f10b233b911eb3$export$2e2bcd8739ae039 = $60f10b233b911eb3$var$formLabelClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $831ef180627ab2e0$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $831ef180627ab2e0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $1OAmh.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $60f10b233b911eb3$export$f7d501e40371cd17), classes);
};
const $831ef180627ab2e0$export$aa5bc7f8a4705b27 = (0, $jBVCU.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $lfXYn.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $60f10b233b911eb3$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $60f10b233b911eb3$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $60f10b233b911eb3$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $831ef180627ab2e0$var$AsteriskComponent = (0, $jBVCU.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $60f10b233b911eb3$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $831ef180627ab2e0$var$FormLabel = /*#__PURE__*/ $35jnV.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $5NWw9.default)(props, $831ef180627ab2e0$var$_excluded);
    const muiFormControl = (0, $cbd44d6f2be34113$export$2e2bcd8739ae039)();
    const fcs = (0, $85be9b3ae8b6cb54$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $lfXYn.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $831ef180627ab2e0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsxs)($831ef180627ab2e0$export$aa5bc7f8a4705b27, (0, $lfXYn.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $3eTha.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $86rqb.jsxs)($831ef180627ab2e0$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    " ",
                    "*"
                ]
            })
        ]
    }));
});
var $831ef180627ab2e0$export$2e2bcd8739ae039 = $831ef180627ab2e0$var$FormLabel;



var $hZybU = parcelRequire("hZybU");

var $1OAmh = parcelRequire("1OAmh");

var $jBVCU = parcelRequire("jBVCU");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $1c46464de8e7ab99$export$c1c4b4545ad2ea5f(slot) {
    return (0, $1reLR.default)("MuiInputLabel", slot);
}
const $1c46464de8e7ab99$var$inputLabelClasses = (0, $ibC2g.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $1c46464de8e7ab99$export$2e2bcd8739ae039 = $1c46464de8e7ab99$var$inputLabelClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $210ed30d4b06431e$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $210ed30d4b06431e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && `size${(0, $1OAmh.default)(size)}`,
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $5wpQH.default)(slots, (0, $1c46464de8e7ab99$export$c1c4b4545ad2ea5f), classes);
    return (0, $lfXYn.default)({}, classes, composedClasses);
};
const $210ed30d4b06431e$var$InputLabelRoot = (0, $jBVCU.default)((0, $831ef180627ab2e0$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $jBVCU.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $60f10b233b911eb3$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $lfXYn.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $lfXYn.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $lfXYn.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $210ed30d4b06431e$var$InputLabel = /*#__PURE__*/ $35jnV.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $hZybU.default)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $5NWw9.default)(props, $210ed30d4b06431e$var$_excluded);
    const muiFormControl = (0, $cbd44d6f2be34113$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $85be9b3ae8b6cb54$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required"
        ]
    });
    const ownerState = (0, $lfXYn.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required
    });
    const classes = $210ed30d4b06431e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsx)($210ed30d4b06431e$var$InputLabelRoot, (0, $lfXYn.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $3eTha.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $210ed30d4b06431e$export$2e2bcd8739ae039 = $210ed30d4b06431e$var$InputLabel;



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");

var $hZybU = parcelRequire("hZybU");

var $jBVCU = parcelRequire("jBVCU");


var $1OAmh = parcelRequire("1OAmh");

var $35jnV = parcelRequire("35jnV");
function $28a5f75e8db027f0$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $35jnV.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $c31dadfa498ee076$export$2e2bcd8739ae039 = (0, $28a5f75e8db027f0$export$2e2bcd8739ae039);




var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $b54be52f5cb1212f$export$149c8b8bab2289d1(slot) {
    return (0, $1reLR.default)("MuiFormControl", slot);
}
const $b54be52f5cb1212f$var$formControlClasses = (0, $ibC2g.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $b54be52f5cb1212f$export$2e2bcd8739ae039 = $b54be52f5cb1212f$var$formControlClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $4cc1e9d2fd604cbf$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $4cc1e9d2fd604cbf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $1OAmh.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $b54be52f5cb1212f$export$149c8b8bab2289d1), classes);
};
const $4cc1e9d2fd604cbf$var$FormControlRoot = (0, $jBVCU.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $lfXYn.default)({}, styles.root, styles[`margin${(0, $1OAmh.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $lfXYn.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $4cc1e9d2fd604cbf$var$FormControl = /*#__PURE__*/ $35jnV.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $5NWw9.default)(props, $4cc1e9d2fd604cbf$var$_excluded);
    const ownerState = (0, $lfXYn.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $4cc1e9d2fd604cbf$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $35jnV.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $35jnV.Children.forEach(children, (child)=>{
            if (!(0, $c31dadfa498ee076$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $c31dadfa498ee076$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $695f74257dda9627$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $35jnV.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $35jnV.Children.forEach(children, (child)=>{
            if (!(0, $c31dadfa498ee076$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $695f74257dda9627$export$d652b828d7fdeff8)(child.props, true) || (0, $695f74257dda9627$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $35jnV.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $35jnV.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $86rqb.jsx)((0, $f512ba7eb8a37cdf$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $86rqb.jsx)($4cc1e9d2fd604cbf$var$FormControlRoot, (0, $lfXYn.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $3eTha.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $4cc1e9d2fd604cbf$export$2e2bcd8739ae039 = $4cc1e9d2fd604cbf$var$FormControl;



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");



var $jBVCU = parcelRequire("jBVCU");

var $1OAmh = parcelRequire("1OAmh");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $add87de6c210f5e8$export$a394fa61b1d583a9(slot) {
    return (0, $1reLR.default)("MuiFormHelperText", slot);
}
const $add87de6c210f5e8$var$formHelperTextClasses = (0, $ibC2g.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $add87de6c210f5e8$export$2e2bcd8739ae039 = $add87de6c210f5e8$var$formHelperTextClasses;



var $hZybU = parcelRequire("hZybU");

var $86rqb = parcelRequire("86rqb");
"use client";
var $1a3a6c87e820c7f3$var$_span;
const $1a3a6c87e820c7f3$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $1a3a6c87e820c7f3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $1OAmh.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $add87de6c210f5e8$export$a394fa61b1d583a9), classes);
};
const $1a3a6c87e820c7f3$var$FormHelperTextRoot = (0, $jBVCU.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $1OAmh.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $add87de6c210f5e8$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $add87de6c210f5e8$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $1a3a6c87e820c7f3$var$FormHelperText = /*#__PURE__*/ $35jnV.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p" } = props, other = (0, $5NWw9.default)(props, $1a3a6c87e820c7f3$var$_excluded);
    const muiFormControl = (0, $cbd44d6f2be34113$export$2e2bcd8739ae039)();
    const fcs = (0, $85be9b3ae8b6cb54$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $lfXYn.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $1a3a6c87e820c7f3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsx)($1a3a6c87e820c7f3$var$FormHelperTextRoot, (0, $lfXYn.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $3eTha.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $1a3a6c87e820c7f3$var$_span || ($1a3a6c87e820c7f3$var$_span = /*#__PURE__*/ (0, $86rqb.jsx)("span", {
            className: "notranslate",
            children: "​"
        })) : children
    }));
});
var $1a3a6c87e820c7f3$export$2e2bcd8739ae039 = $1a3a6c87e820c7f3$var$FormHelperText;



var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $a2Szr = parcelRequire("a2Szr");

var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $5r8Xx = parcelRequire("5r8Xx");

var $35jnV = parcelRequire("35jnV");
var $1b28333f5ed6bf38$exports = {};
"use strict";

$1b28333f5ed6bf38$exports = (parcelRequire("7BJOf"));




var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");

var $d8bf0e283be53538$export$2e2bcd8739ae039 = (0, $0634ff1c5e38c440$export$2e2bcd8739ae039);



var $1OAmh = parcelRequire("1OAmh");

var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $35jnV = parcelRequire("35jnV");



var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");



var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $35jnV = parcelRequire("35jnV");




var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");

var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");

var $35jnV = parcelRequire("35jnV");
"use client";
/**
 * @ignore - internal component.
 */ const $e4ad3368c7db7760$var$ListContext = /*#__PURE__*/ $35jnV.createContext({});
var $e4ad3368c7db7760$export$2e2bcd8739ae039 = $e4ad3368c7db7760$var$ListContext;



var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $9db151825f31ed71$export$c6bd6795ed6e3203(slot) {
    return (0, $1reLR.default)("MuiList", slot);
}
const $9db151825f31ed71$var$listClasses = (0, $ibC2g.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $9db151825f31ed71$export$2e2bcd8739ae039 = $9db151825f31ed71$var$listClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $9babbdecd9fbf836$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $9babbdecd9fbf836$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $9db151825f31ed71$export$c6bd6795ed6e3203), classes);
};
const $9babbdecd9fbf836$var$ListRoot = (0, $jBVCU.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $lfXYn.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $9babbdecd9fbf836$var$List = /*#__PURE__*/ $35jnV.forwardRef(function List(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $5NWw9.default)(props, $9babbdecd9fbf836$var$_excluded);
    const context = $35jnV.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $lfXYn.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $9babbdecd9fbf836$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsx)((0, $e4ad3368c7db7760$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $86rqb.jsxs)($9babbdecd9fbf836$var$ListRoot, (0, $lfXYn.default)({
            as: component,
            className: (0, $3eTha.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $9babbdecd9fbf836$export$2e2bcd8739ae039 = $9babbdecd9fbf836$var$List;



var $1105ba8c067f56a8$export$2e2bcd8739ae039 = (0, $62f88e1db7bce5a8$export$2e2bcd8739ae039);





var $86rqb = parcelRequire("86rqb");
"use client";
const $209951368f96fa83$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $209951368f96fa83$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $209951368f96fa83$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $209951368f96fa83$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $209951368f96fa83$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$209951368f96fa83$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $209951368f96fa83$var$MenuList = /*#__PURE__*/ $35jnV.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $5NWw9.default)(props, $209951368f96fa83$var$_excluded);
    const listRef = $35jnV.useRef(null);
    const textCriteriaRef = $35jnV.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $485be479215a4887$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $35jnV.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $1105ba8c067f56a8$export$2e2bcd8739ae039)((0, $d8bf0e283be53538$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $d8bf0e283be53538$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $209951368f96fa83$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $209951368f96fa83$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $209951368f96fa83$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $209951368f96fa83$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $209951368f96fa83$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $209951368f96fa83$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $209951368f96fa83$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $209951368f96fa83$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $209951368f96fa83$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $209951368f96fa83$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $209951368f96fa83$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $e6f4f6562381f94e$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $35jnV.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $35jnV.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $35jnV.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $35jnV.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $86rqb.jsx)((0, $9babbdecd9fbf836$export$2e2bcd8739ae039), (0, $lfXYn.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $209951368f96fa83$export$2e2bcd8739ae039 = $209951368f96fa83$var$MenuList;



var $lfXYn = parcelRequire("lfXYn");

var $5NWw9 = parcelRequire("5NWw9");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");


var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");

var $7639ffcc5d5de862$export$2e2bcd8739ae039 = (0, $0a0d04c9abb87419$export$2e2bcd8739ae039);




var $c972a4f19f4c1e82$export$2e2bcd8739ae039 = (0, $5e11b4a87d60cb67$export$2e2bcd8739ae039);







var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $c936045414ed74c7$export$88f455dd56c95edb(slot) {
    return (0, $1reLR.default)("MuiPopover", slot);
}
const $c936045414ed74c7$var$popoverClasses = (0, $ibC2g.default)("MuiPopover", [
    "root",
    "paper"
]);
var $c936045414ed74c7$export$2e2bcd8739ae039 = $c936045414ed74c7$var$popoverClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $e375171cad256fa5$var$_excluded = [
    "onEntering"
], $e375171cad256fa5$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $e375171cad256fa5$var$_excluded3 = [
    "slotProps"
];
function $e375171cad256fa5$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $e375171cad256fa5$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $e375171cad256fa5$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $e375171cad256fa5$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $e375171cad256fa5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $c936045414ed74c7$export$88f455dd56c95edb), classes);
};
const $e375171cad256fa5$export$bcce13685275fc99 = (0, $jBVCU.default)((0, $31491128a3ec29b5$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $e375171cad256fa5$export$821346c38a2d9390 = (0, $jBVCU.default)((0, $2fbb4bae37b10470$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $e375171cad256fa5$var$Popover = /*#__PURE__*/ $35jnV.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $8d4b4494eba6d4ab$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $5NWw9.default)(props.TransitionProps, $e375171cad256fa5$var$_excluded), other = (0, $5NWw9.default)(props, $e375171cad256fa5$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $35jnV.useRef();
    const handlePaperRef = (0, $e6f4f6562381f94e$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $lfXYn.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $e375171cad256fa5$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $35jnV.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $e375171cad256fa5$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $d8bf0e283be53538$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $e375171cad256fa5$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $e375171cad256fa5$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $35jnV.useCallback((elemRect)=>{
        return {
            vertical: $e375171cad256fa5$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $e375171cad256fa5$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $35jnV.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $e375171cad256fa5$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $c972a4f19f4c1e82$export$2e2bcd8739ae039)($e375171cad256fa5$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $e375171cad256fa5$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $35jnV.useState(open);
    const setPositioningStyles = $35jnV.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $35jnV.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $35jnV.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $35jnV.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $35jnV.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $7639ffcc5d5de862$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $c972a4f19f4c1e82$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $d8bf0e283be53538$export$2e2bcd8739ae039)($e375171cad256fa5$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $e375171cad256fa5$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $e375171cad256fa5$export$821346c38a2d9390;
    const paperProps = (0, $de1586982a0c1b8f$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: (0, $lfXYn.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $lfXYn.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $3eTha.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $de1586982a0c1b8f$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $3eTha.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $5NWw9.default)(_useSlotProps, $e375171cad256fa5$var$_excluded3);
    return /*#__PURE__*/ (0, $86rqb.jsx)(RootSlot, (0, $lfXYn.default)({}, rootProps, !(0, $34edd9d120733306$export$e28348cc2430497)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $86rqb.jsx)(TransitionComponent, (0, $lfXYn.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $86rqb.jsx)(PaperSlot, (0, $lfXYn.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $e375171cad256fa5$export$2e2bcd8739ae039 = $e375171cad256fa5$var$Popover;



var $jBVCU = parcelRequire("jBVCU");


var $hZybU = parcelRequire("hZybU");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $c9f4a92106d31a62$export$2cf86a63a84fe23d(slot) {
    return (0, $1reLR.default)("MuiMenu", slot);
}
const $c9f4a92106d31a62$var$menuClasses = (0, $ibC2g.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $c9f4a92106d31a62$export$2e2bcd8739ae039 = $c9f4a92106d31a62$var$menuClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $44c8bace0f742f8e$var$_excluded = [
    "onEntering"
], $44c8bace0f742f8e$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $44c8bace0f742f8e$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $44c8bace0f742f8e$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $44c8bace0f742f8e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $c9f4a92106d31a62$export$2cf86a63a84fe23d), classes);
};
const $44c8bace0f742f8e$var$MenuRoot = (0, $jBVCU.default)((0, $e375171cad256fa5$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $jBVCU.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $44c8bace0f742f8e$export$4f7c51a5920c9f33 = (0, $jBVCU.default)((0, $e375171cad256fa5$export$821346c38a2d9390), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $44c8bace0f742f8e$var$MenuMenuList = (0, $jBVCU.default)((0, $209951368f96fa83$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $44c8bace0f742f8e$var$Menu = /*#__PURE__*/ $35jnV.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $5NWw9.default)(props.TransitionProps, $44c8bace0f742f8e$var$_excluded), other = (0, $5NWw9.default)(props, $44c8bace0f742f8e$var$_excluded2);
    const theme = (0, $e83902653e135773$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $lfXYn.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $44c8bace0f742f8e$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $35jnV.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $35jnV.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $35jnV.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $44c8bace0f742f8e$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $de1586982a0c1b8f$export$1e5c9e6e4e15efe3)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $de1586982a0c1b8f$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $86rqb.jsx)($44c8bace0f742f8e$var$MenuRoot, (0, $lfXYn.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $44c8bace0f742f8e$var$RTL_ORIGIN : $44c8bace0f742f8e$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $lfXYn.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $86rqb.jsx)($44c8bace0f742f8e$var$MenuMenuList, (0, $lfXYn.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $3eTha.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $44c8bace0f742f8e$export$2e2bcd8739ae039 = $44c8bace0f742f8e$var$Menu;



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");


var $5wpQH = parcelRequire("5wpQH");

var $1OAmh = parcelRequire("1OAmh");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $b89f49a9da5614ae$export$1ee13051fd9e2ab5(slot) {
    return (0, $1reLR.default)("MuiNativeSelect", slot);
}
const $b89f49a9da5614ae$var$nativeSelectClasses = (0, $ibC2g.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $b89f49a9da5614ae$export$2e2bcd8739ae039 = $b89f49a9da5614ae$var$nativeSelectClasses;



var $jBVCU = parcelRequire("jBVCU");

var $86rqb = parcelRequire("86rqb");
"use client";
const $b5be296a3fab77f1$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $b5be296a3fab77f1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $1OAmh.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $b89f49a9da5614ae$export$1ee13051fd9e2ab5), classes);
};
const $b5be296a3fab77f1$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $lfXYn.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $lfXYn.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $b89f49a9da5614ae$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $b5be296a3fab77f1$var$NativeSelectSelect = (0, $jBVCU.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $jBVCU.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $b89f49a9da5614ae$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($b5be296a3fab77f1$export$c1eccd1617458c87);
const $b5be296a3fab77f1$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $lfXYn.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $b89f49a9da5614ae$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $b5be296a3fab77f1$var$NativeSelectIcon = (0, $jBVCU.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $1OAmh.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($b5be296a3fab77f1$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $b5be296a3fab77f1$var$NativeSelectInput = /*#__PURE__*/ $35jnV.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $5NWw9.default)(props, $b5be296a3fab77f1$var$_excluded);
    const ownerState = (0, $lfXYn.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $b5be296a3fab77f1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsxs)($35jnV.Fragment, {
        children: [
            /*#__PURE__*/ (0, $86rqb.jsx)($b5be296a3fab77f1$var$NativeSelectSelect, (0, $lfXYn.default)({
                ownerState: ownerState,
                className: (0, $3eTha.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $86rqb.jsx)($b5be296a3fab77f1$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $b5be296a3fab77f1$export$2e2bcd8739ae039 = $b5be296a3fab77f1$var$NativeSelectInput;




var $jBVCU = parcelRequire("jBVCU");



var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $e696524b37d8d2e9$export$2c0c1ee5a3392e(slot) {
    return (0, $1reLR.default)("MuiSelect", slot);
}
const $e696524b37d8d2e9$var$selectClasses = (0, $ibC2g.default)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $e696524b37d8d2e9$export$2e2bcd8739ae039 = $e696524b37d8d2e9$var$selectClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
var $0f614b117373cc64$var$_span;
const $0f614b117373cc64$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $0f614b117373cc64$var$SelectSelect = (0, $jBVCU.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $e696524b37d8d2e9$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $e696524b37d8d2e9$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $e696524b37d8d2e9$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $e696524b37d8d2e9$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $b5be296a3fab77f1$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $e696524b37d8d2e9$export$2e2bcd8739ae039).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $0f614b117373cc64$var$SelectIcon = (0, $jBVCU.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $1OAmh.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $b5be296a3fab77f1$export$e7a817afd12a40d0));
const $0f614b117373cc64$var$SelectNativeInput = (0, $jBVCU.default)("input", {
    shouldForwardProp: (prop)=>(0, $jBVCU.slotShouldForwardProp)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $0f614b117373cc64$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $0f614b117373cc64$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $0f614b117373cc64$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $1OAmh.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $e696524b37d8d2e9$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $0f614b117373cc64$var$SelectInput = /*#__PURE__*/ $35jnV.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $5NWw9.default)(props, $0f614b117373cc64$var$_excluded);
    const [value, setValueState] = (0, $6550431a21008320$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $6550431a21008320$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $35jnV.useRef(null);
    const displayRef = $35jnV.useRef(null);
    const [displayNode, setDisplayNode] = $35jnV.useState(null);
    const { current: isOpenControlled } = $35jnV.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $35jnV.useState();
    const handleRef = (0, $e6f4f6562381f94e$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $35jnV.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $35jnV.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $35jnV.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $35jnV.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $35jnV.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $d8bf0e283be53538$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $35jnV.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $695f74257dda9627$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $35jnV.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $5r8Xx.default)(2));
            selected = value.some((v)=>$0f614b117373cc64$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $0f614b117373cc64$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $35jnV.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $lfXYn.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $0f614b117373cc64$var$useUtilityClasses(ownerState);
    const paperProps = (0, $lfXYn.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $cffc89667014c06e$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $86rqb.jsxs)($35jnV.Fragment, {
        children: [
            /*#__PURE__*/ (0, $86rqb.jsx)($0f614b117373cc64$var$SelectSelect, (0, $lfXYn.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $3eTha.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $0f614b117373cc64$var$isEmpty(display) ? $0f614b117373cc64$var$_span || ($0f614b117373cc64$var$_span = /*#__PURE__*/ (0, $86rqb.jsx)("span", {
                    className: "notranslate",
                    children: "​"
                })) : display
            })),
            /*#__PURE__*/ (0, $86rqb.jsx)($0f614b117373cc64$var$SelectNativeInput, (0, $lfXYn.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $86rqb.jsx)($0f614b117373cc64$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $44c8bace0f742f8e$export$2e2bcd8739ae039), (0, $lfXYn.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $lfXYn.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    "aria-multiselectable": multiple ? "true" : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $lfXYn.default)({}, MenuProps.slotProps, {
                    paper: (0, $lfXYn.default)({}, paperProps, {
                        style: (0, $lfXYn.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $0f614b117373cc64$export$2e2bcd8739ae039 = $0f614b117373cc64$var$SelectInput;










var $hZybU = parcelRequire("hZybU");


var $jBVCU = parcelRequire("jBVCU");

var $86rqb = parcelRequire("86rqb");
"use client";
const $73f6714a53bc701e$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $73f6714a53bc701e$var$_excluded2 = [
    "root"
];
const $73f6714a53bc701e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $73f6714a53bc701e$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $jBVCU.rootShouldForwardProp)(prop) && prop !== "variant",
    slot: "Root"
};
const $73f6714a53bc701e$var$StyledInput = (0, $jBVCU.default)((0, $f1f64ea3522afab8$export$2e2bcd8739ae039), $73f6714a53bc701e$var$styledRootConfig)("");
const $73f6714a53bc701e$var$StyledOutlinedInput = (0, $jBVCU.default)((0, $127bdd49c97d847c$export$2e2bcd8739ae039), $73f6714a53bc701e$var$styledRootConfig)("");
const $73f6714a53bc701e$var$StyledFilledInput = (0, $jBVCU.default)((0, $5d238b64b867cb55$export$2e2bcd8739ae039), $73f6714a53bc701e$var$styledRootConfig)("");
const $73f6714a53bc701e$var$Select = /*#__PURE__*/ $35jnV.forwardRef(function Select(inProps, ref) {
    const props = (0, $hZybU.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $f2f57472eceea45b$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $5NWw9.default)(props, $73f6714a53bc701e$var$_excluded);
    const inputComponent = native ? (0, $b5be296a3fab77f1$export$2e2bcd8739ae039) : (0, $0f614b117373cc64$export$2e2bcd8739ae039);
    const muiFormControl = (0, $cbd44d6f2be34113$export$2e2bcd8739ae039)();
    const fcs = (0, $85be9b3ae8b6cb54$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $lfXYn.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $73f6714a53bc701e$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $5NWw9.default)(classes, $73f6714a53bc701e$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $86rqb.jsx)($73f6714a53bc701e$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $86rqb.jsx)($73f6714a53bc701e$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $86rqb.jsx)($73f6714a53bc701e$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $e6f4f6562381f94e$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $86rqb.jsx)($35jnV.Fragment, {
        children: /*#__PURE__*/ $35jnV.cloneElement(InputComponent, (0, $lfXYn.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $lfXYn.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $lfXYn.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $a2Szr.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, multiple && native && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $3eTha.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$73f6714a53bc701e$var$Select.muiName = "Select";
var $73f6714a53bc701e$export$2e2bcd8739ae039 = $73f6714a53bc701e$var$Select;



var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $fb2f3093ec338df2$export$c1bdcbaf0596aeda(slot) {
    return (0, $1reLR.default)("MuiTextField", slot);
}
const $fb2f3093ec338df2$var$textFieldClasses = (0, $ibC2g.default)("MuiTextField", [
    "root"
]);
var $fb2f3093ec338df2$export$2e2bcd8739ae039 = $fb2f3093ec338df2$var$textFieldClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $d16e3bc6c7fd28e7$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $d16e3bc6c7fd28e7$var$variantComponent = {
    standard: (0, $f1f64ea3522afab8$export$2e2bcd8739ae039),
    filled: (0, $5d238b64b867cb55$export$2e2bcd8739ae039),
    outlined: (0, $127bdd49c97d847c$export$2e2bcd8739ae039)
};
const $d16e3bc6c7fd28e7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $fb2f3093ec338df2$export$c1bdcbaf0596aeda), classes);
};
const $d16e3bc6c7fd28e7$var$TextFieldRoot = (0, $jBVCU.default)((0, $4cc1e9d2fd604cbf$export$2e2bcd8739ae039), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $d16e3bc6c7fd28e7$var$TextField = /*#__PURE__*/ $35jnV.forwardRef(function TextField(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = "outlined" } = props, other = (0, $5NWw9.default)(props, $d16e3bc6c7fd28e7$var$_excluded);
    const ownerState = (0, $lfXYn.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $d16e3bc6c7fd28e7$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, $cffc89667014c06e$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $d16e3bc6c7fd28e7$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $86rqb.jsx)(InputComponent, (0, $lfXYn.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $86rqb.jsxs)($d16e3bc6c7fd28e7$var$TextFieldRoot, (0, $lfXYn.default)({
        className: (0, $3eTha.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $86rqb.jsx)((0, $210ed30d4b06431e$export$2e2bcd8739ae039), (0, $lfXYn.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $86rqb.jsx)((0, $73f6714a53bc701e$export$2e2bcd8739ae039), (0, $lfXYn.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $86rqb.jsx)((0, $1a3a6c87e820c7f3$export$2e2bcd8739ae039), (0, $lfXYn.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $d16e3bc6c7fd28e7$export$2e2bcd8739ae039 = $d16e3bc6c7fd28e7$var$TextField;



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");

var $1OAmh = parcelRequire("1OAmh");




var $jBVCU = parcelRequire("jBVCU");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $1c040c1061241457$export$4b135a4b3a6c4550(slot) {
    return (0, $1reLR.default)("MuiInputAdornment", slot);
}
const $1c040c1061241457$var$inputAdornmentClasses = (0, $ibC2g.default)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
var $1c040c1061241457$export$2e2bcd8739ae039 = $1c040c1061241457$var$inputAdornmentClasses;



var $hZybU = parcelRequire("hZybU");

var $86rqb = parcelRequire("86rqb");
"use client";
var $56852400260d9359$var$_span;
const $56852400260d9359$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $56852400260d9359$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $1OAmh.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $56852400260d9359$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, $1OAmh.default)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, $1OAmh.default)(size)}`
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $1c040c1061241457$export$4b135a4b3a6c4550), classes);
};
const $56852400260d9359$var$InputAdornmentRoot = (0, $jBVCU.default)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver: $56852400260d9359$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $1c040c1061241457$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $1c040c1061241457$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const $56852400260d9359$var$InputAdornment = /*#__PURE__*/ $35jnV.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children: children, className: className, component: component = "div", disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $5NWw9.default)(props, $56852400260d9359$var$_excluded);
    const muiFormControl = (0, $cbd44d6f2be34113$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $lfXYn.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $56852400260d9359$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsx)((0, $f512ba7eb8a37cdf$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $86rqb.jsx)($56852400260d9359$var$InputAdornmentRoot, (0, $lfXYn.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $3eTha.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, $86rqb.jsx)((0, $3d9a9295100a327d$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $86rqb.jsxs)($35jnV.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $56852400260d9359$var$_span || ($56852400260d9359$var$_span = /*#__PURE__*/ (0, $86rqb.jsx)("span", {
                        className: "notranslate",
                        children: "​"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $56852400260d9359$export$2e2bcd8739ae039 = $56852400260d9359$var$InputAdornment;







var $23e1e9f6bc9a4866$export$aba86695643891f5;
var $23e1e9f6bc9a4866$export$833790cc1d4cb8fb;
var $23e1e9f6bc9a4866$export$18301ad3f28f78a1;
var $23e1e9f6bc9a4866$export$1ca1ec8b29a4ce27;
var $23e1e9f6bc9a4866$export$8fa4e5556fd77a60;
$23e1e9f6bc9a4866$export$aba86695643891f5 = `QNAY1G_col`;
$23e1e9f6bc9a4866$export$833790cc1d4cb8fb = `QNAY1G_decimalIcon`;
$23e1e9f6bc9a4866$export$18301ad3f28f78a1 = `QNAY1G_decimalText`;
$23e1e9f6bc9a4866$export$1ca1ec8b29a4ce27 = `QNAY1G_icon`;
$23e1e9f6bc9a4866$export$8fa4e5556fd77a60 = `QNAY1G_white`;


const $89bc942a790c4e9c$var$SettingsDialog = (props)=>{
    const { isOpen: isOpen, onClose: onClose } = props;
    const [precision, setPrecision, tags, setTags] = (0, $078bc949f5227a17$export$2e2bcd8739ae039)((0, $9384c319ea675985$export$180f5a427f17c0fe)((state)=>[
            state.precision,
            state.setPrecision,
            state.tags,
            state.setTags
        ]));
    const onPrecisionChange = (0, $35jnV.useCallback)((ev)=>setPrecision(Math.floor(Math.min(Math.max(0, Number(ev.target.value)), 16))), [
        setPrecision
    ]);
    /**
   * update the precision of all shapes
   */ (0, $35jnV.useEffect)(()=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        const fs = (0, $5a88544a0e784883$export$2e2bcd8739ae039).getState();
        ss.update((state)=>{
            const { shapesMap: shapesMap } = state;
            for (const shapes of Object.values(shapesMap))for (const shape of shapes)shape.onPrecisionChange(precision);
            state.setSelected(state.selected);
        });
        // redraw
        const shapes = ss.shapesMap[fs.selected] || [];
        for (const shape of shapes)shape.draw();
    }, [
        precision
    ]);
    const onTagsChange = (0, $35jnV.useCallback)((ev, value)=>setTags(value), [
        setTags
    ]);
    return /*#__PURE__*/ (0, $86rqb.jsxs)((0, $cc913c42c481126a$export$2e2bcd8739ae039), {
        open: isOpen,
        onClose: onClose,
        fullWidth: true,
        maxWidth: "md",
        scroll: "paper",
        children: [
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $ae1b0976a75f7dc7$export$2e2bcd8739ae039), {
                children: "Settings"
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $35e7b4998255ce79$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $86rqb.jsxs)("div", {
                    className: $23e1e9f6bc9a4866$export$aba86695643891f5,
                    children: [
                        /*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                            className: $23e1e9f6bc9a4866$export$18301ad3f28f78a1,
                            type: "number",
                            variant: "standard",
                            InputProps: {
                                startAdornment: /*#__PURE__*/ (0, $86rqb.jsx)((0, $56852400260d9359$export$2e2bcd8739ae039), {
                                    position: "start",
                                    children: /*#__PURE__*/ (0, $86rqb.jsx)((0, $8707742c30a3cde3$export$2e2bcd8739ae039), {
                                        className: (0, $3eTha.default)($23e1e9f6bc9a4866$export$1ca1ec8b29a4ce27, $23e1e9f6bc9a4866$export$833790cc1d4cb8fb)
                                    })
                                })
                            },
                            value: precision,
                            onChange: onPrecisionChange
                        }),
                        /*#__PURE__*/ (0, $86rqb.jsx)((0, $126e412c1a491480$export$2e2bcd8739ae039), {
                            multiple: true,
                            freeSolo: true,
                            options: [],
                            value: tags,
                            onChange: onTagsChange,
                            renderInput: (params)=>/*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                                    ...params,
                                    label: "Tags",
                                    placeholder: "Tag"
                                })
                        })
                    ]
                })
            })
        ]
    });
};
var $89bc942a790c4e9c$export$2e2bcd8739ae039 = $89bc942a790c4e9c$var$SettingsDialog;


var $5912637ee8cf8b9f$export$83401e34d5e11bf4 = /* @__PURE__ */ ((ENV2)=>(ENV2[ENV2.WEBGL_LEGACY = 0] = "WEBGL_LEGACY", ENV2[ENV2.WEBGL = 1] = "WEBGL", ENV2[ENV2.WEBGL2 = 2] = "WEBGL2", ENV2))($5912637ee8cf8b9f$export$83401e34d5e11bf4 || {}), $5912637ee8cf8b9f$export$747c566515e2a1d9 = /* @__PURE__ */ ((RENDERER_TYPE2)=>(RENDERER_TYPE2[RENDERER_TYPE2.UNKNOWN = 0] = "UNKNOWN", RENDERER_TYPE2[RENDERER_TYPE2.WEBGL = 1] = "WEBGL", RENDERER_TYPE2[RENDERER_TYPE2.CANVAS = 2] = "CANVAS", RENDERER_TYPE2))($5912637ee8cf8b9f$export$747c566515e2a1d9 || {}), $5912637ee8cf8b9f$export$c07ea8ac66dac49 = /* @__PURE__ */ ((BUFFER_BITS2)=>(BUFFER_BITS2[BUFFER_BITS2.COLOR = 16384] = "COLOR", BUFFER_BITS2[BUFFER_BITS2.DEPTH = 256] = "DEPTH", BUFFER_BITS2[BUFFER_BITS2.STENCIL = 1024] = "STENCIL", BUFFER_BITS2))($5912637ee8cf8b9f$export$c07ea8ac66dac49 || {}), $5912637ee8cf8b9f$export$f821c68fe9beaecf = /* @__PURE__ */ ((BLEND_MODES2)=>(BLEND_MODES2[BLEND_MODES2.NORMAL = 0] = "NORMAL", BLEND_MODES2[BLEND_MODES2.ADD = 1] = "ADD", BLEND_MODES2[BLEND_MODES2.MULTIPLY = 2] = "MULTIPLY", BLEND_MODES2[BLEND_MODES2.SCREEN = 3] = "SCREEN", BLEND_MODES2[BLEND_MODES2.OVERLAY = 4] = "OVERLAY", BLEND_MODES2[BLEND_MODES2.DARKEN = 5] = "DARKEN", BLEND_MODES2[BLEND_MODES2.LIGHTEN = 6] = "LIGHTEN", BLEND_MODES2[BLEND_MODES2.COLOR_DODGE = 7] = "COLOR_DODGE", BLEND_MODES2[BLEND_MODES2.COLOR_BURN = 8] = "COLOR_BURN", BLEND_MODES2[BLEND_MODES2.HARD_LIGHT = 9] = "HARD_LIGHT", BLEND_MODES2[BLEND_MODES2.SOFT_LIGHT = 10] = "SOFT_LIGHT", BLEND_MODES2[BLEND_MODES2.DIFFERENCE = 11] = "DIFFERENCE", BLEND_MODES2[BLEND_MODES2.EXCLUSION = 12] = "EXCLUSION", BLEND_MODES2[BLEND_MODES2.HUE = 13] = "HUE", BLEND_MODES2[BLEND_MODES2.SATURATION = 14] = "SATURATION", BLEND_MODES2[BLEND_MODES2.COLOR = 15] = "COLOR", BLEND_MODES2[BLEND_MODES2.LUMINOSITY = 16] = "LUMINOSITY", BLEND_MODES2[BLEND_MODES2.NORMAL_NPM = 17] = "NORMAL_NPM", BLEND_MODES2[BLEND_MODES2.ADD_NPM = 18] = "ADD_NPM", BLEND_MODES2[BLEND_MODES2.SCREEN_NPM = 19] = "SCREEN_NPM", BLEND_MODES2[BLEND_MODES2.NONE = 20] = "NONE", BLEND_MODES2[BLEND_MODES2.SRC_OVER = 0] = "SRC_OVER", BLEND_MODES2[BLEND_MODES2.SRC_IN = 21] = "SRC_IN", BLEND_MODES2[BLEND_MODES2.SRC_OUT = 22] = "SRC_OUT", BLEND_MODES2[BLEND_MODES2.SRC_ATOP = 23] = "SRC_ATOP", BLEND_MODES2[BLEND_MODES2.DST_OVER = 24] = "DST_OVER", BLEND_MODES2[BLEND_MODES2.DST_IN = 25] = "DST_IN", BLEND_MODES2[BLEND_MODES2.DST_OUT = 26] = "DST_OUT", BLEND_MODES2[BLEND_MODES2.DST_ATOP = 27] = "DST_ATOP", BLEND_MODES2[BLEND_MODES2.ERASE = 26] = "ERASE", BLEND_MODES2[BLEND_MODES2.SUBTRACT = 28] = "SUBTRACT", BLEND_MODES2[BLEND_MODES2.XOR = 29] = "XOR", BLEND_MODES2))($5912637ee8cf8b9f$export$f821c68fe9beaecf || {}), $5912637ee8cf8b9f$export$91100badd8469338 = /* @__PURE__ */ ((DRAW_MODES2)=>(DRAW_MODES2[DRAW_MODES2.POINTS = 0] = "POINTS", DRAW_MODES2[DRAW_MODES2.LINES = 1] = "LINES", DRAW_MODES2[DRAW_MODES2.LINE_LOOP = 2] = "LINE_LOOP", DRAW_MODES2[DRAW_MODES2.LINE_STRIP = 3] = "LINE_STRIP", DRAW_MODES2[DRAW_MODES2.TRIANGLES = 4] = "TRIANGLES", DRAW_MODES2[DRAW_MODES2.TRIANGLE_STRIP = 5] = "TRIANGLE_STRIP", DRAW_MODES2[DRAW_MODES2.TRIANGLE_FAN = 6] = "TRIANGLE_FAN", DRAW_MODES2))($5912637ee8cf8b9f$export$91100badd8469338 || {}), $5912637ee8cf8b9f$export$e9c4b7b466aa8274 = /* @__PURE__ */ ((FORMATS2)=>(FORMATS2[FORMATS2.RGBA = 6408] = "RGBA", FORMATS2[FORMATS2.RGB = 6407] = "RGB", FORMATS2[FORMATS2.RG = 33319] = "RG", FORMATS2[FORMATS2.RED = 6403] = "RED", FORMATS2[FORMATS2.RGBA_INTEGER = 36249] = "RGBA_INTEGER", FORMATS2[FORMATS2.RGB_INTEGER = 36248] = "RGB_INTEGER", FORMATS2[FORMATS2.RG_INTEGER = 33320] = "RG_INTEGER", FORMATS2[FORMATS2.RED_INTEGER = 36244] = "RED_INTEGER", FORMATS2[FORMATS2.ALPHA = 6406] = "ALPHA", FORMATS2[FORMATS2.LUMINANCE = 6409] = "LUMINANCE", FORMATS2[FORMATS2.LUMINANCE_ALPHA = 6410] = "LUMINANCE_ALPHA", FORMATS2[FORMATS2.DEPTH_COMPONENT = 6402] = "DEPTH_COMPONENT", FORMATS2[FORMATS2.DEPTH_STENCIL = 34041] = "DEPTH_STENCIL", FORMATS2))($5912637ee8cf8b9f$export$e9c4b7b466aa8274 || {}), $5912637ee8cf8b9f$export$d1ff3caf57547dc5 = /* @__PURE__ */ ((TARGETS2)=>(TARGETS2[TARGETS2.TEXTURE_2D = 3553] = "TEXTURE_2D", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP = 34067] = "TEXTURE_CUBE_MAP", TARGETS2[TARGETS2.TEXTURE_2D_ARRAY = 35866] = "TEXTURE_2D_ARRAY", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP_POSITIVE_X = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP_NEGATIVE_X = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP_POSITIVE_Y = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP_NEGATIVE_Y = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP_POSITIVE_Z = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP_NEGATIVE_Z = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z", TARGETS2))($5912637ee8cf8b9f$export$d1ff3caf57547dc5 || {}), $5912637ee8cf8b9f$export$426db7a6155b7a80 = /* @__PURE__ */ ((TYPES2)=>(TYPES2[TYPES2.UNSIGNED_BYTE = 5121] = "UNSIGNED_BYTE", TYPES2[TYPES2.UNSIGNED_SHORT = 5123] = "UNSIGNED_SHORT", TYPES2[TYPES2.UNSIGNED_SHORT_5_6_5 = 33635] = "UNSIGNED_SHORT_5_6_5", TYPES2[TYPES2.UNSIGNED_SHORT_4_4_4_4 = 32819] = "UNSIGNED_SHORT_4_4_4_4", TYPES2[TYPES2.UNSIGNED_SHORT_5_5_5_1 = 32820] = "UNSIGNED_SHORT_5_5_5_1", TYPES2[TYPES2.UNSIGNED_INT = 5125] = "UNSIGNED_INT", TYPES2[TYPES2.UNSIGNED_INT_10F_11F_11F_REV = 35899] = "UNSIGNED_INT_10F_11F_11F_REV", TYPES2[TYPES2.UNSIGNED_INT_2_10_10_10_REV = 33640] = "UNSIGNED_INT_2_10_10_10_REV", TYPES2[TYPES2.UNSIGNED_INT_24_8 = 34042] = "UNSIGNED_INT_24_8", TYPES2[TYPES2.UNSIGNED_INT_5_9_9_9_REV = 35902] = "UNSIGNED_INT_5_9_9_9_REV", TYPES2[TYPES2.BYTE = 5120] = "BYTE", TYPES2[TYPES2.SHORT = 5122] = "SHORT", TYPES2[TYPES2.INT = 5124] = "INT", TYPES2[TYPES2.FLOAT = 5126] = "FLOAT", TYPES2[TYPES2.FLOAT_32_UNSIGNED_INT_24_8_REV = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV", TYPES2[TYPES2.HALF_FLOAT = 36193] = "HALF_FLOAT", TYPES2))($5912637ee8cf8b9f$export$426db7a6155b7a80 || {}), $5912637ee8cf8b9f$export$8ee8af3637d728f5 = /* @__PURE__ */ ((SAMPLER_TYPES2)=>(SAMPLER_TYPES2[SAMPLER_TYPES2.FLOAT = 0] = "FLOAT", SAMPLER_TYPES2[SAMPLER_TYPES2.INT = 1] = "INT", SAMPLER_TYPES2[SAMPLER_TYPES2.UINT = 2] = "UINT", SAMPLER_TYPES2))($5912637ee8cf8b9f$export$8ee8af3637d728f5 || {}), $5912637ee8cf8b9f$export$6b734c6a0bba8473 = /* @__PURE__ */ ((SCALE_MODES2)=>(SCALE_MODES2[SCALE_MODES2.NEAREST = 0] = "NEAREST", SCALE_MODES2[SCALE_MODES2.LINEAR = 1] = "LINEAR", SCALE_MODES2))($5912637ee8cf8b9f$export$6b734c6a0bba8473 || {}), $5912637ee8cf8b9f$export$2ab395cfb0dd2f0f = /* @__PURE__ */ ((WRAP_MODES2)=>(WRAP_MODES2[WRAP_MODES2.CLAMP = 33071] = "CLAMP", WRAP_MODES2[WRAP_MODES2.REPEAT = 10497] = "REPEAT", WRAP_MODES2[WRAP_MODES2.MIRRORED_REPEAT = 33648] = "MIRRORED_REPEAT", WRAP_MODES2))($5912637ee8cf8b9f$export$2ab395cfb0dd2f0f || {}), $5912637ee8cf8b9f$export$16f6fb5da874bbfd = /* @__PURE__ */ ((MIPMAP_MODES2)=>(MIPMAP_MODES2[MIPMAP_MODES2.OFF = 0] = "OFF", MIPMAP_MODES2[MIPMAP_MODES2.POW2 = 1] = "POW2", MIPMAP_MODES2[MIPMAP_MODES2.ON = 2] = "ON", MIPMAP_MODES2[MIPMAP_MODES2.ON_MANUAL = 3] = "ON_MANUAL", MIPMAP_MODES2))($5912637ee8cf8b9f$export$16f6fb5da874bbfd || {}), $5912637ee8cf8b9f$export$d56550d454401b73 = /* @__PURE__ */ ((ALPHA_MODES2)=>(ALPHA_MODES2[ALPHA_MODES2.NPM = 0] = "NPM", ALPHA_MODES2[ALPHA_MODES2.UNPACK = 1] = "UNPACK", ALPHA_MODES2[ALPHA_MODES2.PMA = 2] = "PMA", ALPHA_MODES2[ALPHA_MODES2.NO_PREMULTIPLIED_ALPHA = 0] = "NO_PREMULTIPLIED_ALPHA", ALPHA_MODES2[ALPHA_MODES2.PREMULTIPLY_ON_UPLOAD = 1] = "PREMULTIPLY_ON_UPLOAD", ALPHA_MODES2[ALPHA_MODES2.PREMULTIPLIED_ALPHA = 2] = "PREMULTIPLIED_ALPHA", ALPHA_MODES2))($5912637ee8cf8b9f$export$d56550d454401b73 || {}), $5912637ee8cf8b9f$export$784901839554cbc3 = /* @__PURE__ */ ((CLEAR_MODES2)=>(CLEAR_MODES2[CLEAR_MODES2.NO = 0] = "NO", CLEAR_MODES2[CLEAR_MODES2.YES = 1] = "YES", CLEAR_MODES2[CLEAR_MODES2.AUTO = 2] = "AUTO", CLEAR_MODES2[CLEAR_MODES2.BLEND = 0] = "BLEND", CLEAR_MODES2[CLEAR_MODES2.CLEAR = 1] = "CLEAR", CLEAR_MODES2[CLEAR_MODES2.BLIT = 2] = "BLIT", CLEAR_MODES2))($5912637ee8cf8b9f$export$784901839554cbc3 || {}), $5912637ee8cf8b9f$export$5c6ba89c1f52b344 = /* @__PURE__ */ ((GC_MODES2)=>(GC_MODES2[GC_MODES2.AUTO = 0] = "AUTO", GC_MODES2[GC_MODES2.MANUAL = 1] = "MANUAL", GC_MODES2))($5912637ee8cf8b9f$export$5c6ba89c1f52b344 || {}), $5912637ee8cf8b9f$export$d6d3992f3becc879 = /* @__PURE__ */ ((PRECISION2)=>(PRECISION2.LOW = "lowp", PRECISION2.MEDIUM = "mediump", PRECISION2.HIGH = "highp", PRECISION2))($5912637ee8cf8b9f$export$d6d3992f3becc879 || {}), $5912637ee8cf8b9f$export$dbbea138c5d144 = /* @__PURE__ */ ((MASK_TYPES2)=>(MASK_TYPES2[MASK_TYPES2.NONE = 0] = "NONE", MASK_TYPES2[MASK_TYPES2.SCISSOR = 1] = "SCISSOR", MASK_TYPES2[MASK_TYPES2.STENCIL = 2] = "STENCIL", MASK_TYPES2[MASK_TYPES2.SPRITE = 3] = "SPRITE", MASK_TYPES2[MASK_TYPES2.COLOR = 4] = "COLOR", MASK_TYPES2))($5912637ee8cf8b9f$export$dbbea138c5d144 || {}), $5912637ee8cf8b9f$export$c306f8e81b8d1ca7 = /* @__PURE__ */ ((COLOR_MASK_BITS2)=>(COLOR_MASK_BITS2[COLOR_MASK_BITS2.RED = 1] = "RED", COLOR_MASK_BITS2[COLOR_MASK_BITS2.GREEN = 2] = "GREEN", COLOR_MASK_BITS2[COLOR_MASK_BITS2.BLUE = 4] = "BLUE", COLOR_MASK_BITS2[COLOR_MASK_BITS2.ALPHA = 8] = "ALPHA", COLOR_MASK_BITS2))($5912637ee8cf8b9f$export$c306f8e81b8d1ca7 || {}), $5912637ee8cf8b9f$export$1eadd657d5acc2f2 = /* @__PURE__ */ ((MSAA_QUALITY2)=>(MSAA_QUALITY2[MSAA_QUALITY2.NONE = 0] = "NONE", MSAA_QUALITY2[MSAA_QUALITY2.LOW = 2] = "LOW", MSAA_QUALITY2[MSAA_QUALITY2.MEDIUM = 4] = "MEDIUM", MSAA_QUALITY2[MSAA_QUALITY2.HIGH = 8] = "HIGH", MSAA_QUALITY2))($5912637ee8cf8b9f$export$1eadd657d5acc2f2 || {}), $5912637ee8cf8b9f$export$b595a7e482202b96 = /* @__PURE__ */ ((BUFFER_TYPE2)=>(BUFFER_TYPE2[BUFFER_TYPE2.ELEMENT_ARRAY_BUFFER = 34963] = "ELEMENT_ARRAY_BUFFER", BUFFER_TYPE2[BUFFER_TYPE2.ARRAY_BUFFER = 34962] = "ARRAY_BUFFER", BUFFER_TYPE2[BUFFER_TYPE2.UNIFORM_BUFFER = 35345] = "UNIFORM_BUFFER", BUFFER_TYPE2))($5912637ee8cf8b9f$export$b595a7e482202b96 || {});


const $5fe0e77dcbff5ae7$export$e467cc3399500025 = {
    /**
   * Creates a canvas element of the given size.
   * This canvas is created using the browser's native canvas element.
   * @param width - width of the canvas
   * @param height - height of the canvas
   */ createCanvas: (width, height)=>{
        const canvas = document.createElement("canvas");
        return canvas.width = width, canvas.height = height, canvas;
    },
    getCanvasRenderingContext2D: ()=>CanvasRenderingContext2D,
    getWebGLRenderingContext: ()=>WebGLRenderingContext,
    getNavigator: ()=>navigator,
    getBaseUrl: ()=>document.baseURI ?? window.location.href,
    getFontFaceSet: ()=>document.fonts,
    fetch: (url, options)=>fetch(url, options),
    parseXML: (xml)=>new DOMParser().parseFromString(xml, "text/xml")
};







const $5340ccf8570d4063$export$a5a6e0b888b2c992 = {
    /**
   * This adapter is used to call methods that are platform dependent.
   * For example `document.createElement` only runs on the web but fails in node environments.
   * This allows us to support more platforms by abstracting away specific implementations per platform.
   *
   * By default the adapter is set to work in the browser. However you can create your own
   * by implementing the `IAdapter` interface. See `IAdapter` for more information.
   * @name ADAPTER
   * @memberof PIXI.settings
   * @type {PIXI.IAdapter}
   * @default PIXI.BrowserAdapter
   */ ADAPTER: (0, $5fe0e77dcbff5ae7$export$e467cc3399500025),
    /**
   * Default resolution / device pixel ratio of the renderer.
   * @static
   * @name RESOLUTION
   * @memberof PIXI.settings
   * @type {number}
   * @default 1
   */ RESOLUTION: 1,
    /**
   * Enables bitmap creation before image load. This feature is experimental.
   * @static
   * @name CREATE_IMAGE_BITMAP
   * @memberof PIXI.settings
   * @type {boolean}
   * @default false
   */ CREATE_IMAGE_BITMAP: !1,
    /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   * @static
   * @memberof PIXI.settings
   * @type {boolean}
   * @default false
   */ ROUND_PIXELS: !1
};


var $65c4f66416c1aaf8$var$appleIphone = /iPhone/i;
var $65c4f66416c1aaf8$var$appleIpod = /iPod/i;
var $65c4f66416c1aaf8$var$appleTablet = /iPad/i;
var $65c4f66416c1aaf8$var$appleUniversal = /\biOS-universal(?:.+)Mac\b/i;
var $65c4f66416c1aaf8$var$androidPhone = /\bAndroid(?:.+)Mobile\b/i;
var $65c4f66416c1aaf8$var$androidTablet = /Android/i;
var $65c4f66416c1aaf8$var$amazonPhone = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i;
var $65c4f66416c1aaf8$var$amazonTablet = /Silk/i;
var $65c4f66416c1aaf8$var$windowsPhone = /Windows Phone/i;
var $65c4f66416c1aaf8$var$windowsTablet = /\bWindows(?:.+)ARM\b/i;
var $65c4f66416c1aaf8$var$otherBlackBerry = /BlackBerry/i;
var $65c4f66416c1aaf8$var$otherBlackBerry10 = /BB10/i;
var $65c4f66416c1aaf8$var$otherOpera = /Opera Mini/i;
var $65c4f66416c1aaf8$var$otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var $65c4f66416c1aaf8$var$otherFirefox = /Mobile(?:.+)Firefox\b/i;
var $65c4f66416c1aaf8$var$isAppleTabletOnIos13 = function(navigator1) {
    return typeof navigator1 !== "undefined" && navigator1.platform === "MacIntel" && typeof navigator1.maxTouchPoints === "number" && navigator1.maxTouchPoints > 1 && typeof MSStream === "undefined";
};
function $65c4f66416c1aaf8$var$createMatch(userAgent) {
    return function(regex) {
        return regex.test(userAgent);
    };
}
function $65c4f66416c1aaf8$export$2e2bcd8739ae039(param) {
    var nav = {
        userAgent: "",
        platform: "",
        maxTouchPoints: 0
    };
    if (!param && typeof navigator !== "undefined") nav = {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        maxTouchPoints: navigator.maxTouchPoints || 0
    };
    else if (typeof param === "string") nav.userAgent = param;
    else if (param && param.userAgent) nav = {
        userAgent: param.userAgent,
        platform: param.platform,
        maxTouchPoints: param.maxTouchPoints || 0
    };
    var userAgent = nav.userAgent;
    var tmp = userAgent.split("[FBAN");
    if (typeof tmp[1] !== "undefined") userAgent = tmp[0];
    tmp = userAgent.split("Twitter");
    if (typeof tmp[1] !== "undefined") userAgent = tmp[0];
    var match = $65c4f66416c1aaf8$var$createMatch(userAgent);
    var result = {
        apple: {
            phone: match($65c4f66416c1aaf8$var$appleIphone) && !match($65c4f66416c1aaf8$var$windowsPhone),
            ipod: match($65c4f66416c1aaf8$var$appleIpod),
            tablet: !match($65c4f66416c1aaf8$var$appleIphone) && (match($65c4f66416c1aaf8$var$appleTablet) || $65c4f66416c1aaf8$var$isAppleTabletOnIos13(nav)) && !match($65c4f66416c1aaf8$var$windowsPhone),
            universal: match($65c4f66416c1aaf8$var$appleUniversal),
            device: (match($65c4f66416c1aaf8$var$appleIphone) || match($65c4f66416c1aaf8$var$appleIpod) || match($65c4f66416c1aaf8$var$appleTablet) || match($65c4f66416c1aaf8$var$appleUniversal) || $65c4f66416c1aaf8$var$isAppleTabletOnIos13(nav)) && !match($65c4f66416c1aaf8$var$windowsPhone)
        },
        amazon: {
            phone: match($65c4f66416c1aaf8$var$amazonPhone),
            tablet: !match($65c4f66416c1aaf8$var$amazonPhone) && match($65c4f66416c1aaf8$var$amazonTablet),
            device: match($65c4f66416c1aaf8$var$amazonPhone) || match($65c4f66416c1aaf8$var$amazonTablet)
        },
        android: {
            phone: !match($65c4f66416c1aaf8$var$windowsPhone) && match($65c4f66416c1aaf8$var$amazonPhone) || !match($65c4f66416c1aaf8$var$windowsPhone) && match($65c4f66416c1aaf8$var$androidPhone),
            tablet: !match($65c4f66416c1aaf8$var$windowsPhone) && !match($65c4f66416c1aaf8$var$amazonPhone) && !match($65c4f66416c1aaf8$var$androidPhone) && (match($65c4f66416c1aaf8$var$amazonTablet) || match($65c4f66416c1aaf8$var$androidTablet)),
            device: !match($65c4f66416c1aaf8$var$windowsPhone) && (match($65c4f66416c1aaf8$var$amazonPhone) || match($65c4f66416c1aaf8$var$amazonTablet) || match($65c4f66416c1aaf8$var$androidPhone) || match($65c4f66416c1aaf8$var$androidTablet)) || match(/\bokhttp\b/i)
        },
        windows: {
            phone: match($65c4f66416c1aaf8$var$windowsPhone),
            tablet: match($65c4f66416c1aaf8$var$windowsTablet),
            device: match($65c4f66416c1aaf8$var$windowsPhone) || match($65c4f66416c1aaf8$var$windowsTablet)
        },
        other: {
            blackberry: match($65c4f66416c1aaf8$var$otherBlackBerry),
            blackberry10: match($65c4f66416c1aaf8$var$otherBlackBerry10),
            opera: match($65c4f66416c1aaf8$var$otherOpera),
            firefox: match($65c4f66416c1aaf8$var$otherFirefox),
            chrome: match($65c4f66416c1aaf8$var$otherChrome),
            device: match($65c4f66416c1aaf8$var$otherBlackBerry) || match($65c4f66416c1aaf8$var$otherBlackBerry10) || match($65c4f66416c1aaf8$var$otherOpera) || match($65c4f66416c1aaf8$var$otherFirefox) || match($65c4f66416c1aaf8$var$otherChrome)
        },
        any: false,
        phone: false,
        tablet: false
    };
    result.any = result.apple.device || result.android.device || result.windows.device || result.other.device;
    result.phone = result.apple.phone || result.android.phone || result.windows.phone;
    result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
    return result;
}




const $97611d3d7aa4c02c$var$isMobileCall = (0, $65c4f66416c1aaf8$export$2e2bcd8739ae039).default ?? (0, $65c4f66416c1aaf8$export$2e2bcd8739ae039), $97611d3d7aa4c02c$export$d0a8044dce8ff2fc = $97611d3d7aa4c02c$var$isMobileCall(globalThis.navigator);




var $29e19754806f3a05$exports = {};

$parcel$export($29e19754806f3a05$exports, "BaseTextureCache", function () { return $e0cc893a6896296f$export$cec649a143d060b1; });
$parcel$export($29e19754806f3a05$exports, "BoundingBox", function () { return $82d36c4da6e0db49$export$63080c4de6cfc362; });
$parcel$export($29e19754806f3a05$exports, "CanvasRenderTarget", function () { return $b8191f7507539488$export$525943d4c7cdfa38; });
$parcel$export($29e19754806f3a05$exports, "DATA_URI", function () { return $bfcd1d022c72cb12$export$dbafa72958753fce; });
$parcel$export($29e19754806f3a05$exports, "EventEmitter", function () { return (/*@__PURE__*/$parcel$interopDefault($d82ec76d702398f8$exports)); });
$parcel$export($29e19754806f3a05$exports, "ProgramCache", function () { return $e0cc893a6896296f$export$d47c7e291d8b6e2c; });
$parcel$export($29e19754806f3a05$exports, "TextureCache", function () { return $e0cc893a6896296f$export$4254ab7c0971430e; });
$parcel$export($29e19754806f3a05$exports, "clearTextureCache", function () { return $e0cc893a6896296f$export$3ee9cef7c9878d34; });
$parcel$export($29e19754806f3a05$exports, "correctBlendMode", function () { return $7b974150e84e102b$export$3d793623cb0d1905; });
$parcel$export($29e19754806f3a05$exports, "createIndicesForQuads", function () { return $b5717530b0cb1d89$export$c56148e1bec42281; });
$parcel$export($29e19754806f3a05$exports, "decomposeDataUri", function () { return $cd2cb2555233f877$export$672224f9983ff723; });
$parcel$export($29e19754806f3a05$exports, "deprecation", function () { return $4835512019cf238f$export$afd31d834b512e89; });
$parcel$export($29e19754806f3a05$exports, "destroyTextureCache", function () { return $e0cc893a6896296f$export$b5c9bc385f713d5a; });
$parcel$export($29e19754806f3a05$exports, "detectVideoAlphaMode", function () { return $e279054245c1149e$export$8df68d58aae31877; });
$parcel$export($29e19754806f3a05$exports, "determineCrossOrigin", function () { return $4e976dc7290fc1f8$export$292083da55c5b406; });
$parcel$export($29e19754806f3a05$exports, "earcut", function () { return (/*@__PURE__*/$parcel$interopDefault($46f3f1e5e42c2c13$exports)); });
$parcel$export($29e19754806f3a05$exports, "getBufferType", function () { return $02309e39cc052e17$export$adf72b506413cb57; });
$parcel$export($29e19754806f3a05$exports, "getCanvasBoundingBox", function () { return $ac0967381ecb4c0f$export$550eedf6c679837d; });
$parcel$export($29e19754806f3a05$exports, "getResolutionOfUrl", function () { return $2afed8ad033adf62$export$8695ab2f322d2637; });
$parcel$export($29e19754806f3a05$exports, "hex2rgb", function () { return $75577435cc0a18d4$export$858a46ce014e0e87; });
$parcel$export($29e19754806f3a05$exports, "hex2string", function () { return $75577435cc0a18d4$export$7a57339af2222169; });
$parcel$export($29e19754806f3a05$exports, "interleaveTypedArrays", function () { return $0afb0cec4a7a033f$export$1ce3e224e969bb24; });
$parcel$export($29e19754806f3a05$exports, "isMobile", function () { return $97611d3d7aa4c02c$export$d0a8044dce8ff2fc; });
$parcel$export($29e19754806f3a05$exports, "isPow2", function () { return $1101e8b3767a1e48$export$eb50b9c078eb6ae7; });
$parcel$export($29e19754806f3a05$exports, "isWebGLSupported", function () { return $430338622e16bcef$export$83dc396b76015322; });
$parcel$export($29e19754806f3a05$exports, "log2", function () { return $1101e8b3767a1e48$export$b9fae0bba9d9094d; });
$parcel$export($29e19754806f3a05$exports, "nextPow2", function () { return $1101e8b3767a1e48$export$f0d90cf68bd426eb; });
$parcel$export($29e19754806f3a05$exports, "path", function () { return $6b9e77990c145458$export$bb654e07daaf8c3a; });
$parcel$export($29e19754806f3a05$exports, "premultiplyBlendMode", function () { return $7b974150e84e102b$export$799d0d31e2f4c737; });
$parcel$export($29e19754806f3a05$exports, "premultiplyRgba", function () { return $7b974150e84e102b$export$4fa4eaa2922d1869; });
$parcel$export($29e19754806f3a05$exports, "premultiplyTint", function () { return $7b974150e84e102b$export$1ddadce6229d3efd; });
$parcel$export($29e19754806f3a05$exports, "premultiplyTintToRgba", function () { return $7b974150e84e102b$export$c75351d34304eb8c; });
$parcel$export($29e19754806f3a05$exports, "removeItems", function () { return $b945f5e20f35d72d$export$8d47c0e1ce445404; });
$parcel$export($29e19754806f3a05$exports, "rgb2hex", function () { return $75577435cc0a18d4$export$883528fb0afa7177; });
$parcel$export($29e19754806f3a05$exports, "sayHello", function () { return $80be8fc77ca244ff$export$2c6a96c059a06e7c; });
$parcel$export($29e19754806f3a05$exports, "sign", function () { return $13791c34b1cb68aa$export$c5552dfdbc7cec71; });
$parcel$export($29e19754806f3a05$exports, "skipHello", function () { return $80be8fc77ca244ff$export$702210f86367d7ed; });
$parcel$export($29e19754806f3a05$exports, "string2hex", function () { return $75577435cc0a18d4$export$f6a774610dbc2f6; });
$parcel$export($29e19754806f3a05$exports, "trimCanvas", function () { return $64aa443bbb38aa93$export$658947b9914dd428; });
$parcel$export($29e19754806f3a05$exports, "uid", function () { return $4f05e7b7511900ff$export$e2a22331486dcca0; });
$parcel$export($29e19754806f3a05$exports, "url", function () { return $0947df3d3147e3f9$export$128fa18b7194ef; });

(0, $5340ccf8570d4063$export$a5a6e0b888b2c992).RETINA_PREFIX = /@([0-9\.]+)x/;
(0, $5340ccf8570d4063$export$a5a6e0b888b2c992).FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = !1;



var $d82ec76d702398f8$exports = {};
"use strict";
var $d82ec76d702398f8$var$has = Object.prototype.hasOwnProperty, $d82ec76d702398f8$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $d82ec76d702398f8$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $d82ec76d702398f8$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $d82ec76d702398f8$var$Events().__proto__) $d82ec76d702398f8$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $d82ec76d702398f8$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $d82ec76d702398f8$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $d82ec76d702398f8$var$EE(fn, context || emitter, once), evt = $d82ec76d702398f8$var$prefix ? $d82ec76d702398f8$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $d82ec76d702398f8$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $d82ec76d702398f8$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $d82ec76d702398f8$var$EventEmitter() {
    this._events = new $d82ec76d702398f8$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $d82ec76d702398f8$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($d82ec76d702398f8$var$has.call(events, name)) names.push($d82ec76d702398f8$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $d82ec76d702398f8$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $d82ec76d702398f8$var$prefix ? $d82ec76d702398f8$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $d82ec76d702398f8$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $d82ec76d702398f8$var$prefix ? $d82ec76d702398f8$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $d82ec76d702398f8$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $d82ec76d702398f8$var$prefix ? $d82ec76d702398f8$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d82ec76d702398f8$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $d82ec76d702398f8$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d82ec76d702398f8$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $d82ec76d702398f8$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d82ec76d702398f8$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $d82ec76d702398f8$var$prefix ? $d82ec76d702398f8$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $d82ec76d702398f8$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $d82ec76d702398f8$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $d82ec76d702398f8$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d82ec76d702398f8$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $d82ec76d702398f8$var$prefix ? $d82ec76d702398f8$var$prefix + event : event;
        if (this._events[evt]) $d82ec76d702398f8$var$clearEvent(this, evt);
    } else {
        this._events = new $d82ec76d702398f8$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$d82ec76d702398f8$var$EventEmitter.prototype.off = $d82ec76d702398f8$var$EventEmitter.prototype.removeListener;
$d82ec76d702398f8$var$EventEmitter.prototype.addListener = $d82ec76d702398f8$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$d82ec76d702398f8$var$EventEmitter.prefixed = $d82ec76d702398f8$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$d82ec76d702398f8$var$EventEmitter.EventEmitter = $d82ec76d702398f8$var$EventEmitter;
$d82ec76d702398f8$exports = $d82ec76d702398f8$var$EventEmitter;


var $46f3f1e5e42c2c13$exports = {};
"use strict";
$46f3f1e5e42c2c13$exports = $46f3f1e5e42c2c13$var$earcut;
$46f3f1e5e42c2c13$exports.default = $46f3f1e5e42c2c13$var$earcut;
function $46f3f1e5e42c2c13$var$earcut(data, holeIndices, dim) {
    dim = dim || 2;
    var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = $46f3f1e5e42c2c13$var$linkedList(data, 0, outerLen, dim, true), triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    var minX, minY, maxX, maxY, x, y, invSize;
    if (hasHoles) outerNode = $46f3f1e5e42c2c13$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];
        for(var i = dim; i < outerLen; i += dim){
            x = data[i];
            y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $46f3f1e5e42c2c13$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $46f3f1e5e42c2c13$var$linkedList(data, start, end, dim, clockwise) {
    var i, last;
    if (clockwise === $46f3f1e5e42c2c13$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $46f3f1e5e42c2c13$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $46f3f1e5e42c2c13$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $46f3f1e5e42c2c13$var$equals(last, last.next)) {
        $46f3f1e5e42c2c13$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $46f3f1e5e42c2c13$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    var p = start, again;
    do {
        again = false;
        if (!p.steiner && ($46f3f1e5e42c2c13$var$equals(p, p.next) || $46f3f1e5e42c2c13$var$area(p.prev, p, p.next) === 0)) {
            $46f3f1e5e42c2c13$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $46f3f1e5e42c2c13$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $46f3f1e5e42c2c13$var$indexCurve(ear, minX, minY, invSize);
    var stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $46f3f1e5e42c2c13$var$isEarHashed(ear, minX, minY, invSize) : $46f3f1e5e42c2c13$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $46f3f1e5e42c2c13$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $46f3f1e5e42c2c13$var$earcutLinked($46f3f1e5e42c2c13$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $46f3f1e5e42c2c13$var$cureLocalIntersections($46f3f1e5e42c2c13$var$filterPoints(ear), triangles, dim);
                $46f3f1e5e42c2c13$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $46f3f1e5e42c2c13$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $46f3f1e5e42c2c13$var$isEar(ear) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($46f3f1e5e42c2c13$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    var p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $46f3f1e5e42c2c13$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $46f3f1e5e42c2c13$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $46f3f1e5e42c2c13$var$isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($46f3f1e5e42c2c13$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    var minZ = $46f3f1e5e42c2c13$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $46f3f1e5e42c2c13$var$zOrder(x1, y1, minX, minY, invSize);
    var p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $46f3f1e5e42c2c13$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $46f3f1e5e42c2c13$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $46f3f1e5e42c2c13$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $46f3f1e5e42c2c13$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $46f3f1e5e42c2c13$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $46f3f1e5e42c2c13$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $46f3f1e5e42c2c13$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $46f3f1e5e42c2c13$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $46f3f1e5e42c2c13$var$cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev, b = p.next.next;
        if (!$46f3f1e5e42c2c13$var$equals(a, b) && $46f3f1e5e42c2c13$var$intersects(a, p, p.next, b) && $46f3f1e5e42c2c13$var$locallyInside(a, b) && $46f3f1e5e42c2c13$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $46f3f1e5e42c2c13$var$removeNode(p);
            $46f3f1e5e42c2c13$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $46f3f1e5e42c2c13$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $46f3f1e5e42c2c13$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $46f3f1e5e42c2c13$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = $46f3f1e5e42c2c13$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $46f3f1e5e42c2c13$var$filterPoints(a, a.next);
                c = $46f3f1e5e42c2c13$var$filterPoints(c, c.next);
                // run earcut on each half
                $46f3f1e5e42c2c13$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $46f3f1e5e42c2c13$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $46f3f1e5e42c2c13$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [], i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $46f3f1e5e42c2c13$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($46f3f1e5e42c2c13$var$getLeftmost(list));
    }
    queue.sort($46f3f1e5e42c2c13$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $46f3f1e5e42c2c13$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $46f3f1e5e42c2c13$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $46f3f1e5e42c2c13$var$eliminateHole(hole, outerNode) {
    var bridge = $46f3f1e5e42c2c13$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    var bridgeReverse = $46f3f1e5e42c2c13$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $46f3f1e5e42c2c13$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $46f3f1e5e42c2c13$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $46f3f1e5e42c2c13$var$findHoleBridge(hole, outerNode) {
    var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $46f3f1e5e42c2c13$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($46f3f1e5e42c2c13$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $46f3f1e5e42c2c13$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $46f3f1e5e42c2c13$var$sectorContainsSector(m, p) {
    return $46f3f1e5e42c2c13$var$area(m.prev, m, p.prev) < 0 && $46f3f1e5e42c2c13$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $46f3f1e5e42c2c13$var$indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === 0) p.z = $46f3f1e5e42c2c13$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $46f3f1e5e42c2c13$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $46f3f1e5e42c2c13$var$sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $46f3f1e5e42c2c13$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $46f3f1e5e42c2c13$var$getLeftmost(start) {
    var p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $46f3f1e5e42c2c13$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $46f3f1e5e42c2c13$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$46f3f1e5e42c2c13$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($46f3f1e5e42c2c13$var$locallyInside(a, b) && $46f3f1e5e42c2c13$var$locallyInside(b, a) && $46f3f1e5e42c2c13$var$middleInside(a, b) && // locally visible
    ($46f3f1e5e42c2c13$var$area(a.prev, a, b.prev) || $46f3f1e5e42c2c13$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $46f3f1e5e42c2c13$var$equals(a, b) && $46f3f1e5e42c2c13$var$area(a.prev, a, a.next) > 0 && $46f3f1e5e42c2c13$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $46f3f1e5e42c2c13$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $46f3f1e5e42c2c13$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $46f3f1e5e42c2c13$var$intersects(p1, q1, p2, q2) {
    var o1 = $46f3f1e5e42c2c13$var$sign($46f3f1e5e42c2c13$var$area(p1, q1, p2));
    var o2 = $46f3f1e5e42c2c13$var$sign($46f3f1e5e42c2c13$var$area(p1, q1, q2));
    var o3 = $46f3f1e5e42c2c13$var$sign($46f3f1e5e42c2c13$var$area(p2, q2, p1));
    var o4 = $46f3f1e5e42c2c13$var$sign($46f3f1e5e42c2c13$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $46f3f1e5e42c2c13$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $46f3f1e5e42c2c13$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $46f3f1e5e42c2c13$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $46f3f1e5e42c2c13$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $46f3f1e5e42c2c13$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $46f3f1e5e42c2c13$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $46f3f1e5e42c2c13$var$intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $46f3f1e5e42c2c13$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $46f3f1e5e42c2c13$var$locallyInside(a, b) {
    return $46f3f1e5e42c2c13$var$area(a.prev, a, a.next) < 0 ? $46f3f1e5e42c2c13$var$area(a, b, a.next) >= 0 && $46f3f1e5e42c2c13$var$area(a, a.prev, b) >= 0 : $46f3f1e5e42c2c13$var$area(a, b, a.prev) < 0 || $46f3f1e5e42c2c13$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $46f3f1e5e42c2c13$var$middleInside(a, b) {
    var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $46f3f1e5e42c2c13$var$splitPolygon(a, b) {
    var a2 = new $46f3f1e5e42c2c13$var$Node(a.i, a.x, a.y), b2 = new $46f3f1e5e42c2c13$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $46f3f1e5e42c2c13$var$insertNode(i, x, y, last) {
    var p = new $46f3f1e5e42c2c13$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $46f3f1e5e42c2c13$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $46f3f1e5e42c2c13$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
// return a percentage difference between the polygon area and its triangulation area;
// used to verify correctness of triangulation
$46f3f1e5e42c2c13$var$earcut.deviation = function(data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    var polygonArea = Math.abs($46f3f1e5e42c2c13$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(var i = 0, len = holeIndices.length; i < len; i++){
        var start = holeIndices[i] * dim;
        var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($46f3f1e5e42c2c13$var$signedArea(data, start, end, dim));
    }
    var trianglesArea = 0;
    for(i = 0; i < triangles.length; i += 3){
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
};
function $46f3f1e5e42c2c13$var$signedArea(data, start, end, dim) {
    var sum = 0;
    for(var i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
$46f3f1e5e42c2c13$var$earcut.flatten = function(data) {
    var dim = data[0][0].length, result = {
        vertices: [],
        holes: [],
        dimensions: dim
    }, holeIndex = 0;
    for(var i = 0; i < data.length; i++){
        for(var j = 0; j < data[i].length; j++)for(var d = 0; d < dim; d++)result.vertices.push(data[i][j][d]);
        if (i > 0) {
            holeIndex += data[i - 1].length;
            result.holes.push(holeIndex);
        }
    }
    return result;
};


/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ var $41ebac06f5b61af3$export$98e6a39c04603d36;
var $41ebac06f5b61af3$export$f7ad0328861e2f03;
var $41ebac06f5b61af3$export$7daf1a5d2f4dd018;
var $41ebac06f5b61af3$export$d9468344d3651243;
var $41ebac06f5b61af3$export$59d795186a5d3f58;
"use strict";

var $kAusa = parcelRequire("kAusa");
function $41ebac06f5b61af3$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var $41ebac06f5b61af3$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $41ebac06f5b61af3$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$41ebac06f5b61af3$var$simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ $41ebac06f5b61af3$var$delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
$41ebac06f5b61af3$var$unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat($41ebac06f5b61af3$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$41ebac06f5b61af3$var$autoEscape = [
    "'"
].concat($41ebac06f5b61af3$var$unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ $41ebac06f5b61af3$var$nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat($41ebac06f5b61af3$var$autoEscape), $41ebac06f5b61af3$var$hostEndingChars = [
    "/",
    "?",
    "#"
], $41ebac06f5b61af3$var$hostnameMaxLen = 255, $41ebac06f5b61af3$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $41ebac06f5b61af3$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
$41ebac06f5b61af3$var$unsafeProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that never have a hostname.
$41ebac06f5b61af3$var$hostlessProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that always contain a // bit.
$41ebac06f5b61af3$var$slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};
var $f315d0bfc2d2ff75$exports = {};
"use strict";
var $b08f4f7593fd06ae$exports = {};
"use strict";
var $838935246603441b$exports = {};
"use strict";
var $74055e204a233cd2$exports = {};
"use strict";
var $74055e204a233cd2$var$undefined;
var $74055e204a233cd2$var$$SyntaxError = SyntaxError;
var $74055e204a233cd2$var$$Function = Function;
var $74055e204a233cd2$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $74055e204a233cd2$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $74055e204a233cd2$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $74055e204a233cd2$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($74055e204a233cd2$var$$gOPD) try {
    $74055e204a233cd2$var$$gOPD({}, "");
} catch (e) {
    $74055e204a233cd2$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $74055e204a233cd2$var$throwTypeError = function() {
    throw new $74055e204a233cd2$var$$TypeError();
};
var $74055e204a233cd2$var$ThrowTypeError = $74055e204a233cd2$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $74055e204a233cd2$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $74055e204a233cd2$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $74055e204a233cd2$var$throwTypeError;
        }
    }
}() : $74055e204a233cd2$var$throwTypeError;

var $74055e204a233cd2$var$hasSymbols = (parcelRequire("bxncQ"))();

var $74055e204a233cd2$var$hasProto = (parcelRequire("eQw7P"))();
var $74055e204a233cd2$var$getProto = Object.getPrototypeOf || ($74055e204a233cd2$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $74055e204a233cd2$var$needsEval = {};
var $74055e204a233cd2$var$TypedArray = typeof Uint8Array === "undefined" || !$74055e204a233cd2$var$getProto ? $74055e204a233cd2$var$undefined : $74055e204a233cd2$var$getProto(Uint8Array);
var $74055e204a233cd2$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? $74055e204a233cd2$var$undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? $74055e204a233cd2$var$undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $74055e204a233cd2$var$hasSymbols && $74055e204a233cd2$var$getProto ? $74055e204a233cd2$var$getProto([][Symbol.iterator]()) : $74055e204a233cd2$var$undefined,
    "%AsyncFromSyncIteratorPrototype%": $74055e204a233cd2$var$undefined,
    "%AsyncFunction%": $74055e204a233cd2$var$needsEval,
    "%AsyncGenerator%": $74055e204a233cd2$var$needsEval,
    "%AsyncGeneratorFunction%": $74055e204a233cd2$var$needsEval,
    "%AsyncIteratorPrototype%": $74055e204a233cd2$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? $74055e204a233cd2$var$undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? $74055e204a233cd2$var$undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? $74055e204a233cd2$var$undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? $74055e204a233cd2$var$undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? $74055e204a233cd2$var$undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? $74055e204a233cd2$var$undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? $74055e204a233cd2$var$undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? $74055e204a233cd2$var$undefined : FinalizationRegistry,
    "%Function%": $74055e204a233cd2$var$$Function,
    "%GeneratorFunction%": $74055e204a233cd2$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? $74055e204a233cd2$var$undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? $74055e204a233cd2$var$undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? $74055e204a233cd2$var$undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $74055e204a233cd2$var$hasSymbols && $74055e204a233cd2$var$getProto ? $74055e204a233cd2$var$getProto($74055e204a233cd2$var$getProto([][Symbol.iterator]())) : $74055e204a233cd2$var$undefined,
    "%JSON%": typeof JSON === "object" ? JSON : $74055e204a233cd2$var$undefined,
    "%Map%": typeof Map === "undefined" ? $74055e204a233cd2$var$undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$74055e204a233cd2$var$hasSymbols || !$74055e204a233cd2$var$getProto ? $74055e204a233cd2$var$undefined : $74055e204a233cd2$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? $74055e204a233cd2$var$undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? $74055e204a233cd2$var$undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? $74055e204a233cd2$var$undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? $74055e204a233cd2$var$undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$74055e204a233cd2$var$hasSymbols || !$74055e204a233cd2$var$getProto ? $74055e204a233cd2$var$undefined : $74055e204a233cd2$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? $74055e204a233cd2$var$undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $74055e204a233cd2$var$hasSymbols && $74055e204a233cd2$var$getProto ? $74055e204a233cd2$var$getProto(""[Symbol.iterator]()) : $74055e204a233cd2$var$undefined,
    "%Symbol%": $74055e204a233cd2$var$hasSymbols ? Symbol : $74055e204a233cd2$var$undefined,
    "%SyntaxError%": $74055e204a233cd2$var$$SyntaxError,
    "%ThrowTypeError%": $74055e204a233cd2$var$ThrowTypeError,
    "%TypedArray%": $74055e204a233cd2$var$TypedArray,
    "%TypeError%": $74055e204a233cd2$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? $74055e204a233cd2$var$undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? $74055e204a233cd2$var$undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? $74055e204a233cd2$var$undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? $74055e204a233cd2$var$undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? $74055e204a233cd2$var$undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? $74055e204a233cd2$var$undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? $74055e204a233cd2$var$undefined : WeakSet
};
if ($74055e204a233cd2$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $74055e204a233cd2$var$errorProto = $74055e204a233cd2$var$getProto($74055e204a233cd2$var$getProto(e));
    $74055e204a233cd2$var$INTRINSICS["%Error.prototype%"] = $74055e204a233cd2$var$errorProto;
}
var $74055e204a233cd2$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $74055e204a233cd2$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $74055e204a233cd2$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $74055e204a233cd2$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $74055e204a233cd2$var$getProto) value = $74055e204a233cd2$var$getProto(gen.prototype);
    }
    $74055e204a233cd2$var$INTRINSICS[name] = value;
    return value;
};
var $74055e204a233cd2$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};
var $6fba7aae05899e3a$exports = {};
"use strict";
var $aec5803177b5b8c5$exports = {};
"use strict";
/* eslint no-invalid-this: 1 */ var $aec5803177b5b8c5$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $aec5803177b5b8c5$var$slice = Array.prototype.slice;
var $aec5803177b5b8c5$var$toStr = Object.prototype.toString;
var $aec5803177b5b8c5$var$funcType = "[object Function]";
$aec5803177b5b8c5$exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $aec5803177b5b8c5$var$toStr.call(target) !== $aec5803177b5b8c5$var$funcType) throw new TypeError($aec5803177b5b8c5$var$ERROR_MESSAGE + target);
    var args = $aec5803177b5b8c5$var$slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($aec5803177b5b8c5$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($aec5803177b5b8c5$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};


$6fba7aae05899e3a$exports = Function.prototype.bind || $aec5803177b5b8c5$exports;


var $630e832c050b095c$exports = {};
"use strict";
var $630e832c050b095c$var$hasOwnProperty = {}.hasOwnProperty;
var $630e832c050b095c$var$call = Function.prototype.call;
$630e832c050b095c$exports = $630e832c050b095c$var$call.bind ? $630e832c050b095c$var$call.bind($630e832c050b095c$var$hasOwnProperty) : function(O, P) {
    return $630e832c050b095c$var$call.call($630e832c050b095c$var$hasOwnProperty, O, P);
};


var $74055e204a233cd2$var$$concat = $6fba7aae05899e3a$exports.call(Function.call, Array.prototype.concat);
var $74055e204a233cd2$var$$spliceApply = $6fba7aae05899e3a$exports.call(Function.apply, Array.prototype.splice);
var $74055e204a233cd2$var$$replace = $6fba7aae05899e3a$exports.call(Function.call, String.prototype.replace);
var $74055e204a233cd2$var$$strSlice = $6fba7aae05899e3a$exports.call(Function.call, String.prototype.slice);
var $74055e204a233cd2$var$$exec = $6fba7aae05899e3a$exports.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $74055e204a233cd2$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $74055e204a233cd2$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $74055e204a233cd2$var$stringToPath = function stringToPath(string) {
    var first = $74055e204a233cd2$var$$strSlice(string, 0, 1);
    var last = $74055e204a233cd2$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $74055e204a233cd2$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $74055e204a233cd2$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $74055e204a233cd2$var$$replace(string, $74055e204a233cd2$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $74055e204a233cd2$var$$replace(subString, $74055e204a233cd2$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $74055e204a233cd2$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($630e832c050b095c$exports($74055e204a233cd2$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $74055e204a233cd2$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($630e832c050b095c$exports($74055e204a233cd2$var$INTRINSICS, intrinsicName)) {
        var value = $74055e204a233cd2$var$INTRINSICS[intrinsicName];
        if (value === $74055e204a233cd2$var$needsEval) value = $74055e204a233cd2$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $74055e204a233cd2$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $74055e204a233cd2$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
$74055e204a233cd2$exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $74055e204a233cd2$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $74055e204a233cd2$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($74055e204a233cd2$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $74055e204a233cd2$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $74055e204a233cd2$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $74055e204a233cd2$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $74055e204a233cd2$var$$spliceApply(parts, $74055e204a233cd2$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $74055e204a233cd2$var$$strSlice(part, 0, 1);
        var last = $74055e204a233cd2$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $74055e204a233cd2$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($630e832c050b095c$exports($74055e204a233cd2$var$INTRINSICS, intrinsicRealName)) value = $74055e204a233cd2$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $74055e204a233cd2$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($74055e204a233cd2$var$$gOPD && i + 1 >= parts.length) {
                var desc = $74055e204a233cd2$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $630e832c050b095c$exports(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $74055e204a233cd2$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};


var $4b3361f6f65dc5a9$exports = {};
"use strict";

var $085b513d8df7ce96$exports = {};
"use strict";


var $085b513d8df7ce96$var$$apply = $74055e204a233cd2$exports("%Function.prototype.apply%");
var $085b513d8df7ce96$var$$call = $74055e204a233cd2$exports("%Function.prototype.call%");
var $085b513d8df7ce96$var$$reflectApply = $74055e204a233cd2$exports("%Reflect.apply%", true) || $6fba7aae05899e3a$exports.call($085b513d8df7ce96$var$$call, $085b513d8df7ce96$var$$apply);
var $085b513d8df7ce96$var$$gOPD = $74055e204a233cd2$exports("%Object.getOwnPropertyDescriptor%", true);
var $085b513d8df7ce96$var$$defineProperty = $74055e204a233cd2$exports("%Object.defineProperty%", true);
var $085b513d8df7ce96$var$$max = $74055e204a233cd2$exports("%Math.max%");
if ($085b513d8df7ce96$var$$defineProperty) try {
    $085b513d8df7ce96$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $085b513d8df7ce96$var$$defineProperty = null;
}
$085b513d8df7ce96$exports = function callBind(originalFunction) {
    var func = $085b513d8df7ce96$var$$reflectApply($6fba7aae05899e3a$exports, $085b513d8df7ce96$var$$call, arguments);
    if ($085b513d8df7ce96$var$$gOPD && $085b513d8df7ce96$var$$defineProperty) {
        var desc = $085b513d8df7ce96$var$$gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $085b513d8df7ce96$var$$defineProperty(func, "length", {
            value: 1 + $085b513d8df7ce96$var$$max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var $085b513d8df7ce96$var$applyBind = function applyBind() {
    return $085b513d8df7ce96$var$$reflectApply($6fba7aae05899e3a$exports, $085b513d8df7ce96$var$$apply, arguments);
};
if ($085b513d8df7ce96$var$$defineProperty) $085b513d8df7ce96$var$$defineProperty($085b513d8df7ce96$exports, "apply", {
    value: $085b513d8df7ce96$var$applyBind
});
else $085b513d8df7ce96$exports.apply = $085b513d8df7ce96$var$applyBind;


var $4b3361f6f65dc5a9$var$$indexOf = $085b513d8df7ce96$exports($74055e204a233cd2$exports("String.prototype.indexOf"));
$4b3361f6f65dc5a9$exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $74055e204a233cd2$exports(name, !!allowMissing);
    if (typeof intrinsic === "function" && $4b3361f6f65dc5a9$var$$indexOf(name, ".prototype.") > -1) return $085b513d8df7ce96$exports(intrinsic);
    return intrinsic;
};


var $aaef4fab0e94b483$exports = {};
var $aaef4fab0e94b483$var$hasMap = typeof Map === "function" && Map.prototype;
var $aaef4fab0e94b483$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $aaef4fab0e94b483$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $aaef4fab0e94b483$var$mapSize = $aaef4fab0e94b483$var$hasMap && $aaef4fab0e94b483$var$mapSizeDescriptor && typeof $aaef4fab0e94b483$var$mapSizeDescriptor.get === "function" ? $aaef4fab0e94b483$var$mapSizeDescriptor.get : null;
var $aaef4fab0e94b483$var$mapForEach = $aaef4fab0e94b483$var$hasMap && Map.prototype.forEach;
var $aaef4fab0e94b483$var$hasSet = typeof Set === "function" && Set.prototype;
var $aaef4fab0e94b483$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $aaef4fab0e94b483$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $aaef4fab0e94b483$var$setSize = $aaef4fab0e94b483$var$hasSet && $aaef4fab0e94b483$var$setSizeDescriptor && typeof $aaef4fab0e94b483$var$setSizeDescriptor.get === "function" ? $aaef4fab0e94b483$var$setSizeDescriptor.get : null;
var $aaef4fab0e94b483$var$setForEach = $aaef4fab0e94b483$var$hasSet && Set.prototype.forEach;
var $aaef4fab0e94b483$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $aaef4fab0e94b483$var$weakMapHas = $aaef4fab0e94b483$var$hasWeakMap ? WeakMap.prototype.has : null;
var $aaef4fab0e94b483$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $aaef4fab0e94b483$var$weakSetHas = $aaef4fab0e94b483$var$hasWeakSet ? WeakSet.prototype.has : null;
var $aaef4fab0e94b483$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $aaef4fab0e94b483$var$weakRefDeref = $aaef4fab0e94b483$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $aaef4fab0e94b483$var$booleanValueOf = Boolean.prototype.valueOf;
var $aaef4fab0e94b483$var$objectToString = Object.prototype.toString;
var $aaef4fab0e94b483$var$functionToString = Function.prototype.toString;
var $aaef4fab0e94b483$var$$match = String.prototype.match;
var $aaef4fab0e94b483$var$$slice = String.prototype.slice;
var $aaef4fab0e94b483$var$$replace = String.prototype.replace;
var $aaef4fab0e94b483$var$$toUpperCase = String.prototype.toUpperCase;
var $aaef4fab0e94b483$var$$toLowerCase = String.prototype.toLowerCase;
var $aaef4fab0e94b483$var$$test = RegExp.prototype.test;
var $aaef4fab0e94b483$var$$concat = Array.prototype.concat;
var $aaef4fab0e94b483$var$$join = Array.prototype.join;
var $aaef4fab0e94b483$var$$arrSlice = Array.prototype.slice;
var $aaef4fab0e94b483$var$$floor = Math.floor;
var $aaef4fab0e94b483$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $aaef4fab0e94b483$var$gOPS = Object.getOwnPropertySymbols;
var $aaef4fab0e94b483$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $aaef4fab0e94b483$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $aaef4fab0e94b483$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $aaef4fab0e94b483$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $aaef4fab0e94b483$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $aaef4fab0e94b483$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $aaef4fab0e94b483$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $aaef4fab0e94b483$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$aaef4fab0e94b483$var$$floor(-num) : $aaef4fab0e94b483$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $aaef4fab0e94b483$var$$slice.call(str, intStr.length + 1);
            return $aaef4fab0e94b483$var$$replace.call(intStr, sepRegex, "$&_") + "." + $aaef4fab0e94b483$var$$replace.call($aaef4fab0e94b483$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $aaef4fab0e94b483$var$$replace.call(str, sepRegex, "$&_");
}
var $00924b40257ecbe5$exports = {};
"use strict";


var $aaef4fab0e94b483$var$inspectCustom = $00924b40257ecbe5$exports.custom;
var $aaef4fab0e94b483$var$inspectSymbol = $aaef4fab0e94b483$var$isSymbol($aaef4fab0e94b483$var$inspectCustom) ? $aaef4fab0e94b483$var$inspectCustom : null;
$aaef4fab0e94b483$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($aaef4fab0e94b483$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($aaef4fab0e94b483$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $aaef4fab0e94b483$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($aaef4fab0e94b483$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($aaef4fab0e94b483$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $aaef4fab0e94b483$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $aaef4fab0e94b483$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $aaef4fab0e94b483$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $aaef4fab0e94b483$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $aaef4fab0e94b483$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($aaef4fab0e94b483$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $aaef4fab0e94b483$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($aaef4fab0e94b483$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$aaef4fab0e94b483$var$isRegExp(obj)) {
        var name = $aaef4fab0e94b483$var$nameOf(obj);
        var keys = $aaef4fab0e94b483$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $aaef4fab0e94b483$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($aaef4fab0e94b483$var$isSymbol(obj)) {
        var symString = $aaef4fab0e94b483$var$hasShammedSymbols ? $aaef4fab0e94b483$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $aaef4fab0e94b483$var$symToString.call(obj);
        return typeof obj === "object" && !$aaef4fab0e94b483$var$hasShammedSymbols ? $aaef4fab0e94b483$var$markBoxed(symString) : symString;
    }
    if ($aaef4fab0e94b483$var$isElement(obj)) {
        var s = "<" + $aaef4fab0e94b483$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $aaef4fab0e94b483$var$wrapQuotes($aaef4fab0e94b483$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $aaef4fab0e94b483$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($aaef4fab0e94b483$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $aaef4fab0e94b483$var$arrObjKeys(obj, inspect);
        if (indent && !$aaef4fab0e94b483$var$singleLineValues(xs)) return "[" + $aaef4fab0e94b483$var$indentedJoin(xs, indent) + "]";
        return "[ " + $aaef4fab0e94b483$var$$join.call(xs, ", ") + " ]";
    }
    if ($aaef4fab0e94b483$var$isError(obj)) {
        var parts = $aaef4fab0e94b483$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$aaef4fab0e94b483$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $aaef4fab0e94b483$var$$join.call($aaef4fab0e94b483$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $aaef4fab0e94b483$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($aaef4fab0e94b483$var$inspectSymbol && typeof obj[$aaef4fab0e94b483$var$inspectSymbol] === "function" && $00924b40257ecbe5$exports) return $00924b40257ecbe5$exports(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($aaef4fab0e94b483$var$isMap(obj)) {
        var mapParts = [];
        if ($aaef4fab0e94b483$var$mapForEach) $aaef4fab0e94b483$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $aaef4fab0e94b483$var$collectionOf("Map", $aaef4fab0e94b483$var$mapSize.call(obj), mapParts, indent);
    }
    if ($aaef4fab0e94b483$var$isSet(obj)) {
        var setParts = [];
        if ($aaef4fab0e94b483$var$setForEach) $aaef4fab0e94b483$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $aaef4fab0e94b483$var$collectionOf("Set", $aaef4fab0e94b483$var$setSize.call(obj), setParts, indent);
    }
    if ($aaef4fab0e94b483$var$isWeakMap(obj)) return $aaef4fab0e94b483$var$weakCollectionOf("WeakMap");
    if ($aaef4fab0e94b483$var$isWeakSet(obj)) return $aaef4fab0e94b483$var$weakCollectionOf("WeakSet");
    if ($aaef4fab0e94b483$var$isWeakRef(obj)) return $aaef4fab0e94b483$var$weakCollectionOf("WeakRef");
    if ($aaef4fab0e94b483$var$isNumber(obj)) return $aaef4fab0e94b483$var$markBoxed(inspect(Number(obj)));
    if ($aaef4fab0e94b483$var$isBigInt(obj)) return $aaef4fab0e94b483$var$markBoxed(inspect($aaef4fab0e94b483$var$bigIntValueOf.call(obj)));
    if ($aaef4fab0e94b483$var$isBoolean(obj)) return $aaef4fab0e94b483$var$markBoxed($aaef4fab0e94b483$var$booleanValueOf.call(obj));
    if ($aaef4fab0e94b483$var$isString(obj)) return $aaef4fab0e94b483$var$markBoxed(inspect(String(obj)));
    if (!$aaef4fab0e94b483$var$isDate(obj) && !$aaef4fab0e94b483$var$isRegExp(obj)) {
        var ys = $aaef4fab0e94b483$var$arrObjKeys(obj, inspect);
        var isPlainObject = $aaef4fab0e94b483$var$gPO ? $aaef4fab0e94b483$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $aaef4fab0e94b483$var$toStringTag && Object(obj) === obj && $aaef4fab0e94b483$var$toStringTag in obj ? $aaef4fab0e94b483$var$$slice.call($aaef4fab0e94b483$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $aaef4fab0e94b483$var$$join.call($aaef4fab0e94b483$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $aaef4fab0e94b483$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $aaef4fab0e94b483$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $aaef4fab0e94b483$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $aaef4fab0e94b483$var$quote(s) {
    return $aaef4fab0e94b483$var$$replace.call(String(s), /"/g, "&quot;");
}
function $aaef4fab0e94b483$var$isArray(obj) {
    return $aaef4fab0e94b483$var$toStr(obj) === "[object Array]" && (!$aaef4fab0e94b483$var$toStringTag || !(typeof obj === "object" && $aaef4fab0e94b483$var$toStringTag in obj));
}
function $aaef4fab0e94b483$var$isDate(obj) {
    return $aaef4fab0e94b483$var$toStr(obj) === "[object Date]" && (!$aaef4fab0e94b483$var$toStringTag || !(typeof obj === "object" && $aaef4fab0e94b483$var$toStringTag in obj));
}
function $aaef4fab0e94b483$var$isRegExp(obj) {
    return $aaef4fab0e94b483$var$toStr(obj) === "[object RegExp]" && (!$aaef4fab0e94b483$var$toStringTag || !(typeof obj === "object" && $aaef4fab0e94b483$var$toStringTag in obj));
}
function $aaef4fab0e94b483$var$isError(obj) {
    return $aaef4fab0e94b483$var$toStr(obj) === "[object Error]" && (!$aaef4fab0e94b483$var$toStringTag || !(typeof obj === "object" && $aaef4fab0e94b483$var$toStringTag in obj));
}
function $aaef4fab0e94b483$var$isString(obj) {
    return $aaef4fab0e94b483$var$toStr(obj) === "[object String]" && (!$aaef4fab0e94b483$var$toStringTag || !(typeof obj === "object" && $aaef4fab0e94b483$var$toStringTag in obj));
}
function $aaef4fab0e94b483$var$isNumber(obj) {
    return $aaef4fab0e94b483$var$toStr(obj) === "[object Number]" && (!$aaef4fab0e94b483$var$toStringTag || !(typeof obj === "object" && $aaef4fab0e94b483$var$toStringTag in obj));
}
function $aaef4fab0e94b483$var$isBoolean(obj) {
    return $aaef4fab0e94b483$var$toStr(obj) === "[object Boolean]" && (!$aaef4fab0e94b483$var$toStringTag || !(typeof obj === "object" && $aaef4fab0e94b483$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $aaef4fab0e94b483$var$isSymbol(obj) {
    if ($aaef4fab0e94b483$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$aaef4fab0e94b483$var$symToString) return false;
    try {
        $aaef4fab0e94b483$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $aaef4fab0e94b483$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$aaef4fab0e94b483$var$bigIntValueOf) return false;
    try {
        $aaef4fab0e94b483$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $aaef4fab0e94b483$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $aaef4fab0e94b483$var$has(obj, key) {
    return $aaef4fab0e94b483$var$hasOwn.call(obj, key);
}
function $aaef4fab0e94b483$var$toStr(obj) {
    return $aaef4fab0e94b483$var$objectToString.call(obj);
}
function $aaef4fab0e94b483$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $aaef4fab0e94b483$var$$match.call($aaef4fab0e94b483$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $aaef4fab0e94b483$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $aaef4fab0e94b483$var$isMap(x) {
    if (!$aaef4fab0e94b483$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $aaef4fab0e94b483$var$mapSize.call(x);
        try {
            $aaef4fab0e94b483$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $aaef4fab0e94b483$var$isWeakMap(x) {
    if (!$aaef4fab0e94b483$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $aaef4fab0e94b483$var$weakMapHas.call(x, $aaef4fab0e94b483$var$weakMapHas);
        try {
            $aaef4fab0e94b483$var$weakSetHas.call(x, $aaef4fab0e94b483$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $aaef4fab0e94b483$var$isWeakRef(x) {
    if (!$aaef4fab0e94b483$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $aaef4fab0e94b483$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $aaef4fab0e94b483$var$isSet(x) {
    if (!$aaef4fab0e94b483$var$setSize || !x || typeof x !== "object") return false;
    try {
        $aaef4fab0e94b483$var$setSize.call(x);
        try {
            $aaef4fab0e94b483$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $aaef4fab0e94b483$var$isWeakSet(x) {
    if (!$aaef4fab0e94b483$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $aaef4fab0e94b483$var$weakSetHas.call(x, $aaef4fab0e94b483$var$weakSetHas);
        try {
            $aaef4fab0e94b483$var$weakMapHas.call(x, $aaef4fab0e94b483$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $aaef4fab0e94b483$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $aaef4fab0e94b483$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $aaef4fab0e94b483$var$inspectString($aaef4fab0e94b483$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $aaef4fab0e94b483$var$$replace.call($aaef4fab0e94b483$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $aaef4fab0e94b483$var$lowbyte);
    return $aaef4fab0e94b483$var$wrapQuotes(s, "single", opts);
}
function $aaef4fab0e94b483$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $aaef4fab0e94b483$var$$toUpperCase.call(n.toString(16));
}
function $aaef4fab0e94b483$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $aaef4fab0e94b483$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $aaef4fab0e94b483$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $aaef4fab0e94b483$var$indentedJoin(entries, indent) : $aaef4fab0e94b483$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $aaef4fab0e94b483$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($aaef4fab0e94b483$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $aaef4fab0e94b483$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $aaef4fab0e94b483$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $aaef4fab0e94b483$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $aaef4fab0e94b483$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $aaef4fab0e94b483$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $aaef4fab0e94b483$var$arrObjKeys(obj, inspect) {
    var isArr = $aaef4fab0e94b483$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $aaef4fab0e94b483$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $aaef4fab0e94b483$var$gOPS === "function" ? $aaef4fab0e94b483$var$gOPS(obj) : [];
    var symMap;
    if ($aaef4fab0e94b483$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$aaef4fab0e94b483$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($aaef4fab0e94b483$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($aaef4fab0e94b483$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $aaef4fab0e94b483$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($aaef4fab0e94b483$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}


var $838935246603441b$var$$TypeError = $74055e204a233cd2$exports("%TypeError%");
var $838935246603441b$var$$WeakMap = $74055e204a233cd2$exports("%WeakMap%", true);
var $838935246603441b$var$$Map = $74055e204a233cd2$exports("%Map%", true);
var $838935246603441b$var$$weakMapGet = $4b3361f6f65dc5a9$exports("WeakMap.prototype.get", true);
var $838935246603441b$var$$weakMapSet = $4b3361f6f65dc5a9$exports("WeakMap.prototype.set", true);
var $838935246603441b$var$$weakMapHas = $4b3361f6f65dc5a9$exports("WeakMap.prototype.has", true);
var $838935246603441b$var$$mapGet = $4b3361f6f65dc5a9$exports("Map.prototype.get", true);
var $838935246603441b$var$$mapSet = $4b3361f6f65dc5a9$exports("Map.prototype.set", true);
var $838935246603441b$var$$mapHas = $4b3361f6f65dc5a9$exports("Map.prototype.has", true);
/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */ var $838935246603441b$var$listGetNode = function(list, key) {
    for(var prev = list, curr; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        curr.next = list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
var $838935246603441b$var$listGet = function(objects, key) {
    var node = $838935246603441b$var$listGetNode(objects, key);
    return node && node.value;
};
var $838935246603441b$var$listSet = function(objects, key, value) {
    var node = $838935246603441b$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = {
        key: key,
        next: objects.next,
        value: value
    };
};
var $838935246603441b$var$listHas = function(objects, key) {
    return !!$838935246603441b$var$listGetNode(objects, key);
};
$838935246603441b$exports = function getSideChannel() {
    var $wm;
    var $m;
    var $o;
    var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $838935246603441b$var$$TypeError("Side channel does not contain " + $aaef4fab0e94b483$exports(key));
        },
        get: function(key) {
            if ($838935246603441b$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $838935246603441b$var$$weakMapGet($wm, key);
            } else if ($838935246603441b$var$$Map) {
                if ($m) return $838935246603441b$var$$mapGet($m, key);
            } else {
                if ($o) return $838935246603441b$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($838935246603441b$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $838935246603441b$var$$weakMapHas($wm, key);
            } else if ($838935246603441b$var$$Map) {
                if ($m) return $838935246603441b$var$$mapHas($m, key);
            } else {
                if ($o) return $838935246603441b$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($838935246603441b$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $838935246603441b$var$$WeakMap();
                $838935246603441b$var$$weakMapSet($wm, key, value);
            } else if ($838935246603441b$var$$Map) {
                if (!$m) $m = new $838935246603441b$var$$Map();
                $838935246603441b$var$$mapSet($m, key, value);
            } else {
                if (!$o) /*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */ $o = {
                    key: {},
                    next: null
                };
                $838935246603441b$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};


var $84af1df5a06ba97d$exports = {};
"use strict";
var $3efa3c8e3479eaac$exports = {};
"use strict";
var $3efa3c8e3479eaac$var$replace = String.prototype.replace;
var $3efa3c8e3479eaac$var$percentTwenties = /%20/g;
var $3efa3c8e3479eaac$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
$3efa3c8e3479eaac$exports = {
    "default": $3efa3c8e3479eaac$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $3efa3c8e3479eaac$var$replace.call(value, $3efa3c8e3479eaac$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $3efa3c8e3479eaac$var$Format.RFC1738,
    RFC3986: $3efa3c8e3479eaac$var$Format.RFC3986
};


var $84af1df5a06ba97d$var$has = Object.prototype.hasOwnProperty;
var $84af1df5a06ba97d$var$isArray = Array.isArray;
var $84af1df5a06ba97d$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $84af1df5a06ba97d$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($84af1df5a06ba97d$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $84af1df5a06ba97d$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $84af1df5a06ba97d$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($84af1df5a06ba97d$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$84af1df5a06ba97d$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($84af1df5a06ba97d$var$isArray(target) && !$84af1df5a06ba97d$var$isArray(source)) mergeTarget = $84af1df5a06ba97d$var$arrayToObject(target, options);
    if ($84af1df5a06ba97d$var$isArray(target) && $84af1df5a06ba97d$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($84af1df5a06ba97d$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($84af1df5a06ba97d$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $84af1df5a06ba97d$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $84af1df5a06ba97d$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $84af1df5a06ba97d$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $3efa3c8e3479eaac$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $84af1df5a06ba97d$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($84af1df5a06ba97d$var$hexTable[0xC0 | c >> 6] + $84af1df5a06ba97d$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($84af1df5a06ba97d$var$hexTable[0xE0 | c >> 12] + $84af1df5a06ba97d$var$hexTable[0x80 | c >> 6 & 0x3F] + $84af1df5a06ba97d$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $84af1df5a06ba97d$var$hexTable[0xF0 | c >> 18] + $84af1df5a06ba97d$var$hexTable[0x80 | c >> 12 & 0x3F] + $84af1df5a06ba97d$var$hexTable[0x80 | c >> 6 & 0x3F] + $84af1df5a06ba97d$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $84af1df5a06ba97d$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $84af1df5a06ba97d$var$compactQueue(queue);
    return value;
};
var $84af1df5a06ba97d$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $84af1df5a06ba97d$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $84af1df5a06ba97d$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $84af1df5a06ba97d$var$maybeMap = function maybeMap(val, fn) {
    if ($84af1df5a06ba97d$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$84af1df5a06ba97d$exports = {
    arrayToObject: $84af1df5a06ba97d$var$arrayToObject,
    assign: $84af1df5a06ba97d$var$assign,
    combine: $84af1df5a06ba97d$var$combine,
    compact: $84af1df5a06ba97d$var$compact,
    decode: $84af1df5a06ba97d$var$decode,
    encode: $84af1df5a06ba97d$var$encode,
    isBuffer: $84af1df5a06ba97d$var$isBuffer,
    isRegExp: $84af1df5a06ba97d$var$isRegExp,
    maybeMap: $84af1df5a06ba97d$var$maybeMap,
    merge: $84af1df5a06ba97d$var$merge
};



var $b08f4f7593fd06ae$var$has = Object.prototype.hasOwnProperty;
var $b08f4f7593fd06ae$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $b08f4f7593fd06ae$var$isArray = Array.isArray;
var $b08f4f7593fd06ae$var$push = Array.prototype.push;
var $b08f4f7593fd06ae$var$pushToArray = function(arr, valueOrArray) {
    $b08f4f7593fd06ae$var$push.apply(arr, $b08f4f7593fd06ae$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $b08f4f7593fd06ae$var$toISO = Date.prototype.toISOString;
var $b08f4f7593fd06ae$var$defaultFormat = $3efa3c8e3479eaac$exports.default;
var $b08f4f7593fd06ae$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: $84af1df5a06ba97d$exports.encode,
    encodeValuesOnly: false,
    format: $b08f4f7593fd06ae$var$defaultFormat,
    formatter: $3efa3c8e3479eaac$exports.formatters[$b08f4f7593fd06ae$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $b08f4f7593fd06ae$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $b08f4f7593fd06ae$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $b08f4f7593fd06ae$var$sentinel = {};
var $b08f4f7593fd06ae$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($b08f4f7593fd06ae$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($b08f4f7593fd06ae$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $b08f4f7593fd06ae$var$isArray(obj)) obj = $84af1df5a06ba97d$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $b08f4f7593fd06ae$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($b08f4f7593fd06ae$var$isNonNullishPrimitive(obj) || $84af1df5a06ba97d$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $b08f4f7593fd06ae$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $b08f4f7593fd06ae$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $b08f4f7593fd06ae$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $84af1df5a06ba97d$exports.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($b08f4f7593fd06ae$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var adjustedPrefix = commaRoundTrip && $b08f4f7593fd06ae$var$isArray(obj) && obj.length === 1 ? prefix + "[]" : prefix;
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $b08f4f7593fd06ae$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + key : "[" + key + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $838935246603441b$exports();
        valueSideChannel.set($b08f4f7593fd06ae$var$sentinel, sideChannel);
        $b08f4f7593fd06ae$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, generateArrayPrefix === "comma" && encodeValuesOnly && $b08f4f7593fd06ae$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $b08f4f7593fd06ae$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $b08f4f7593fd06ae$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $b08f4f7593fd06ae$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $3efa3c8e3479eaac$exports.default;
    if (typeof opts.format !== "undefined") {
        if (!$b08f4f7593fd06ae$var$has.call($3efa3c8e3479eaac$exports.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $3efa3c8e3479eaac$exports.formatters[format];
    var filter = $b08f4f7593fd06ae$var$defaults.filter;
    if (typeof opts.filter === "function" || $b08f4f7593fd06ae$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $b08f4f7593fd06ae$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? $b08f4f7593fd06ae$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $b08f4f7593fd06ae$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? $b08f4f7593fd06ae$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $b08f4f7593fd06ae$var$defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $b08f4f7593fd06ae$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $b08f4f7593fd06ae$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $b08f4f7593fd06ae$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $b08f4f7593fd06ae$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $b08f4f7593fd06ae$var$defaults.strictNullHandling
    };
};
$b08f4f7593fd06ae$exports = function(object, opts) {
    var obj = object;
    var options = $b08f4f7593fd06ae$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($b08f4f7593fd06ae$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in $b08f4f7593fd06ae$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = $b08f4f7593fd06ae$var$arrayPrefixGenerators[arrayFormat];
    if (opts && "commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var commaRoundTrip = generateArrayPrefix === "comma" && opts && opts.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $838935246603441b$exports();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $b08f4f7593fd06ae$var$pushToArray(keys, $b08f4f7593fd06ae$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};


var $2bbc57985f85e7e5$exports = {};
"use strict";

var $2bbc57985f85e7e5$var$has = Object.prototype.hasOwnProperty;
var $2bbc57985f85e7e5$var$isArray = Array.isArray;
var $2bbc57985f85e7e5$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: $84af1df5a06ba97d$exports.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $2bbc57985f85e7e5$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $2bbc57985f85e7e5$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $2bbc57985f85e7e5$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $2bbc57985f85e7e5$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $2bbc57985f85e7e5$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $2bbc57985f85e7e5$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $2bbc57985f85e7e5$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $2bbc57985f85e7e5$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $2bbc57985f85e7e5$var$defaults.decoder, charset, "key");
            val = $84af1df5a06ba97d$exports.maybeMap($2bbc57985f85e7e5$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $2bbc57985f85e7e5$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $2bbc57985f85e7e5$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $2bbc57985f85e7e5$var$isArray(val) ? [
            val
        ] : val;
        if ($2bbc57985f85e7e5$var$has.call(obj, key)) obj[key] = $84af1df5a06ba97d$exports.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $2bbc57985f85e7e5$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $2bbc57985f85e7e5$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $2bbc57985f85e7e5$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $2bbc57985f85e7e5$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $2bbc57985f85e7e5$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $2bbc57985f85e7e5$var$parseObject(keys, val, options, valuesParsed);
};
var $2bbc57985f85e7e5$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $2bbc57985f85e7e5$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $2bbc57985f85e7e5$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? $2bbc57985f85e7e5$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $2bbc57985f85e7e5$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $2bbc57985f85e7e5$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $2bbc57985f85e7e5$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $2bbc57985f85e7e5$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $2bbc57985f85e7e5$var$defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $2bbc57985f85e7e5$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $84af1df5a06ba97d$exports.isRegExp(opts.delimiter) ? opts.delimiter : $2bbc57985f85e7e5$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $2bbc57985f85e7e5$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $2bbc57985f85e7e5$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $2bbc57985f85e7e5$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $2bbc57985f85e7e5$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $2bbc57985f85e7e5$var$defaults.strictNullHandling
    };
};
$2bbc57985f85e7e5$exports = function(str, opts) {
    var options = $2bbc57985f85e7e5$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $2bbc57985f85e7e5$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $2bbc57985f85e7e5$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $84af1df5a06ba97d$exports.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $84af1df5a06ba97d$exports.compact(obj);
};



$f315d0bfc2d2ff75$exports = {
    formats: $3efa3c8e3479eaac$exports,
    parse: $2bbc57985f85e7e5$exports,
    stringify: $b08f4f7593fd06ae$exports
};


function $41ebac06f5b61af3$var$urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === "object" && url instanceof $41ebac06f5b61af3$var$Url) return url;
    var u = new $41ebac06f5b61af3$var$Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
$41ebac06f5b61af3$var$Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== "string") throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = $41ebac06f5b61af3$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $f315d0bfc2d2ff75$exports.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = $41ebac06f5b61af3$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && $41ebac06f5b61af3$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$41ebac06f5b61af3$var$hostlessProtocol[proto] && (slashes || proto && !$41ebac06f5b61af3$var$slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < $41ebac06f5b61af3$var$hostEndingChars.length; i++){
            var hec = rest.indexOf($41ebac06f5b61af3$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf("@", hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < $41ebac06f5b61af3$var$nonHostChars.length; i++){
            var hec = rest.indexOf($41ebac06f5b61af3$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || "";
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($41ebac06f5b61af3$var$hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($41ebac06f5b61af3$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($41ebac06f5b61af3$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $41ebac06f5b61af3$var$hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $kAusa.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!$41ebac06f5b61af3$var$unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = $41ebac06f5b61af3$var$autoEscape.length; i < l; i++){
        var ae = $41ebac06f5b61af3$var$autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $f315d0bfc2d2ff75$exports.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if ($41ebac06f5b61af3$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function $41ebac06f5b61af3$var$urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === "string") obj = $41ebac06f5b61af3$var$urlParse(obj);
    if (!(obj instanceof $41ebac06f5b61af3$var$Url)) return $41ebac06f5b61af3$var$Url.prototype.format.call(obj);
    return obj.format();
}
$41ebac06f5b61af3$var$Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && typeof this.query === "object" && Object.keys(this.query).length) query = $f315d0bfc2d2ff75$exports.stringify(this.query, {
        arrayFormat: "repeat",
        addQueryPrefix: false
    });
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || $41ebac06f5b61af3$var$slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function $41ebac06f5b61af3$var$urlResolve(source, relative) {
    return $41ebac06f5b61af3$var$urlParse(source, false, true).resolve(relative);
}
$41ebac06f5b61af3$var$Url.prototype.resolve = function(relative) {
    return this.resolveObject($41ebac06f5b61af3$var$urlParse(relative, false, true)).format();
};
function $41ebac06f5b61af3$var$urlResolveObject(source, relative) {
    if (!source) return relative;
    return $41ebac06f5b61af3$var$urlParse(source, false, true).resolveObject(relative);
}
$41ebac06f5b61af3$var$Url.prototype.resolveObject = function(relative) {
    if (typeof relative === "string") {
        var rel = new $41ebac06f5b61af3$var$Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new $41ebac06f5b61af3$var$Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if ($41ebac06f5b61af3$var$slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = "/";
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!$41ebac06f5b61af3$var$slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !$41ebac06f5b61af3$var$hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !$41ebac06f5b61af3$var$slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (srcPath.length > 0) result.pathname = srcPath.join("/");
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
$41ebac06f5b61af3$var$Url.prototype.parseHost = function() {
    var host = this.host;
    var port = $41ebac06f5b61af3$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
$41ebac06f5b61af3$export$98e6a39c04603d36 = $41ebac06f5b61af3$var$urlParse;
$41ebac06f5b61af3$export$f7ad0328861e2f03 = $41ebac06f5b61af3$var$urlResolve;
$41ebac06f5b61af3$export$7daf1a5d2f4dd018 = $41ebac06f5b61af3$var$urlResolveObject;
$41ebac06f5b61af3$export$d9468344d3651243 = $41ebac06f5b61af3$var$urlFormat;
$41ebac06f5b61af3$export$59d795186a5d3f58 = $41ebac06f5b61af3$var$Url;


const $4835512019cf238f$var$warnings = {};
function $4835512019cf238f$export$afd31d834b512e89(version, message, ignoreDepth = 3) {
    if ($4835512019cf238f$var$warnings[message]) return;
    let stack = new Error().stack;
    typeof stack > "u" ? console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`) : (stack = stack.split(`
`).splice(ignoreDepth).join(`
`), console.groupCollapsed ? (console.groupCollapsed("%cPixiJS Deprecation Warning: %c%s", "color:#614108;background:#fffbe6", "font-weight:normal;color:#614108;background:#fffbe6", `${message}
Deprecated since v${version}`), console.warn(stack), console.groupEnd()) : (console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`), console.warn(stack))), $4835512019cf238f$var$warnings[message] = !0;
}


const $0947df3d3147e3f9$export$128fa18b7194ef = {
    /**
   * @deprecated since 7.3.0
   */ get parse () {
        return (0, $4835512019cf238f$export$afd31d834b512e89)("7.3.0", "utils.url.parse is deprecated, use native URL API instead."), $41ebac06f5b61af3$export$98e6a39c04603d36;
    },
    /**
   * @deprecated since 7.3.0
   */ get format () {
        return (0, $4835512019cf238f$export$afd31d834b512e89)("7.3.0", "utils.url.format is deprecated, use native URL API instead."), $41ebac06f5b61af3$export$d9468344d3651243;
    },
    /**
   * @deprecated since 7.3.0
   */ get resolve () {
        return (0, $4835512019cf238f$export$afd31d834b512e89)("7.3.0", "utils.url.resolve is deprecated, use native URL API instead."), $41ebac06f5b61af3$export$f7ad0328861e2f03;
    }
};



function $6b9e77990c145458$var$assertPath(path2) {
    if (typeof path2 != "string") throw new TypeError(`Path must be a string. Received ${JSON.stringify(path2)}`);
}
function $6b9e77990c145458$var$removeUrlParams(url) {
    return url.split("?")[0].split("#")[0];
}
function $6b9e77990c145458$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $6b9e77990c145458$var$replaceAll(str, find, replace) {
    return str.replace(new RegExp($6b9e77990c145458$var$escapeRegExp(find), "g"), replace);
}
function $6b9e77990c145458$var$normalizeStringPosix(path2, allowAboveRoot) {
    let res = "", lastSegmentLength = 0, lastSlash = -1, dots = 0, code = -1;
    for(let i = 0; i <= path2.length; ++i){
        if (i < path2.length) code = path2.charCodeAt(i);
        else {
            if (code === 47) break;
            code = 47;
        }
        if (code === 47) {
            if (!(lastSlash === i - 1 || dots === 1)) {
                if (lastSlash !== i - 1 && dots === 2) {
                    if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
                        if (res.length > 2) {
                            const lastSlashIndex = res.lastIndexOf("/");
                            if (lastSlashIndex !== res.length - 1) {
                                lastSlashIndex === -1 ? (res = "", lastSegmentLength = 0) : (res = res.slice(0, lastSlashIndex), lastSegmentLength = res.length - 1 - res.lastIndexOf("/")), lastSlash = i, dots = 0;
                                continue;
                            }
                        } else if (res.length === 2 || res.length === 1) {
                            res = "", lastSegmentLength = 0, lastSlash = i, dots = 0;
                            continue;
                        }
                    }
                    allowAboveRoot && (res.length > 0 ? res += "/.." : res = "..", lastSegmentLength = 2);
                } else res.length > 0 ? res += `/${path2.slice(lastSlash + 1, i)}` : res = path2.slice(lastSlash + 1, i), lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i, dots = 0;
        } else code === 46 && dots !== -1 ? ++dots : dots = -1;
    }
    return res;
}
const $6b9e77990c145458$export$bb654e07daaf8c3a = {
    /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   */ toPosix (path2) {
        return $6b9e77990c145458$var$replaceAll(path2, "\\", "/");
    },
    /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   */ isUrl (path2) {
        return /^https?:/.test(this.toPosix(path2));
    },
    /**
   * Checks if the path is a data URL
   * @param path - The path to check
   */ isDataUrl (path2) {
        return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(path2);
    },
    /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   */ isBlobUrl (path2) {
        return path2.startsWith("blob:");
    },
    /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   */ hasProtocol (path2) {
        return /^[^/:]+:/.test(this.toPosix(path2));
    },
    /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   */ getProtocol (path2) {
        $6b9e77990c145458$var$assertPath(path2), path2 = this.toPosix(path2);
        const matchFile = /^file:\/\/\//.exec(path2);
        if (matchFile) return matchFile[0];
        const matchProtocol = /^[^/:]+:\/{0,2}/.exec(path2);
        return matchProtocol ? matchProtocol[0] : "";
    },
    /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   */ toAbsolute (url, customBaseUrl, customRootUrl) {
        if ($6b9e77990c145458$var$assertPath(url), this.isDataUrl(url) || this.isBlobUrl(url)) return url;
        const baseUrl = $6b9e77990c145458$var$removeUrlParams(this.toPosix(customBaseUrl ?? (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.getBaseUrl())), rootUrl = $6b9e77990c145458$var$removeUrlParams(this.toPosix(customRootUrl ?? this.rootname(baseUrl)));
        return url = this.toPosix(url), url.startsWith("/") ? $6b9e77990c145458$export$bb654e07daaf8c3a.join(rootUrl, url.slice(1)) : this.isAbsolute(url) ? url : this.join(baseUrl, url);
    },
    /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   */ normalize (path2) {
        if ($6b9e77990c145458$var$assertPath(path2), path2.length === 0) return ".";
        if (this.isDataUrl(path2) || this.isBlobUrl(path2)) return path2;
        path2 = this.toPosix(path2);
        let protocol = "";
        const isAbsolute = path2.startsWith("/");
        this.hasProtocol(path2) && (protocol = this.rootname(path2), path2 = path2.slice(protocol.length));
        const trailingSeparator = path2.endsWith("/");
        return path2 = $6b9e77990c145458$var$normalizeStringPosix(path2, !1), path2.length > 0 && trailingSeparator && (path2 += "/"), isAbsolute ? `/${path2}` : protocol + path2;
    },
    /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   */ isAbsolute (path2) {
        return $6b9e77990c145458$var$assertPath(path2), path2 = this.toPosix(path2), this.hasProtocol(path2) ? !0 : path2.startsWith("/");
    },
    /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   */ join (...segments) {
        if (segments.length === 0) return ".";
        let joined;
        for(let i = 0; i < segments.length; ++i){
            const arg = segments[i];
            if ($6b9e77990c145458$var$assertPath(arg), arg.length > 0) {
                if (joined === void 0) joined = arg;
                else {
                    const prevArg = segments[i - 1] ?? "";
                    this.extname(prevArg) ? joined += `/../${arg}` : joined += `/${arg}`;
                }
            }
        }
        return joined === void 0 ? "." : this.normalize(joined);
    },
    /**
   * Returns the directory name of a path
   * @param path - The path to parse
   */ dirname (path2) {
        if ($6b9e77990c145458$var$assertPath(path2), path2.length === 0) return ".";
        path2 = this.toPosix(path2);
        let code = path2.charCodeAt(0);
        const hasRoot = code === 47;
        let end = -1, matchedSlash = !0;
        const proto = this.getProtocol(path2), origpath = path2;
        path2 = path2.slice(proto.length);
        for(let i = path2.length - 1; i >= 1; --i)if (code = path2.charCodeAt(i), code === 47) {
            if (!matchedSlash) {
                end = i;
                break;
            }
        } else matchedSlash = !1;
        return end === -1 ? hasRoot ? "/" : this.isUrl(origpath) ? proto + path2 : proto : hasRoot && end === 1 ? "//" : proto + path2.slice(0, end);
    },
    /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   */ rootname (path2) {
        $6b9e77990c145458$var$assertPath(path2), path2 = this.toPosix(path2);
        let root = "";
        if (path2.startsWith("/") ? root = "/" : root = this.getProtocol(path2), this.isUrl(path2)) {
            const index = path2.indexOf("/", root.length);
            index !== -1 ? root = path2.slice(0, index) : root = path2, root.endsWith("/") || (root += "/");
        }
        return root;
    },
    /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   */ basename (path2, ext) {
        $6b9e77990c145458$var$assertPath(path2), ext && $6b9e77990c145458$var$assertPath(ext), path2 = $6b9e77990c145458$var$removeUrlParams(this.toPosix(path2));
        let start = 0, end = -1, matchedSlash = !0, i;
        if (ext !== void 0 && ext.length > 0 && ext.length <= path2.length) {
            if (ext.length === path2.length && ext === path2) return "";
            let extIdx = ext.length - 1, firstNonSlashEnd = -1;
            for(i = path2.length - 1; i >= 0; --i){
                const code = path2.charCodeAt(i);
                if (code === 47) {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else firstNonSlashEnd === -1 && (matchedSlash = !1, firstNonSlashEnd = i + 1), extIdx >= 0 && (code === ext.charCodeAt(extIdx) ? --extIdx === -1 && (end = i) : (extIdx = -1, end = firstNonSlashEnd));
            }
            return start === end ? end = firstNonSlashEnd : end === -1 && (end = path2.length), path2.slice(start, end);
        }
        for(i = path2.length - 1; i >= 0; --i)if (path2.charCodeAt(i) === 47) {
            if (!matchedSlash) {
                start = i + 1;
                break;
            }
        } else end === -1 && (matchedSlash = !1, end = i + 1);
        return end === -1 ? "" : path2.slice(start, end);
    },
    /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   */ extname (path2) {
        $6b9e77990c145458$var$assertPath(path2), path2 = $6b9e77990c145458$var$removeUrlParams(this.toPosix(path2));
        let startDot = -1, startPart = 0, end = -1, matchedSlash = !0, preDotState = 0;
        for(let i = path2.length - 1; i >= 0; --i){
            const code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            end === -1 && (matchedSlash = !1, end = i + 1), code === 46 ? startDot === -1 ? startDot = i : preDotState !== 1 && (preDotState = 1) : startDot !== -1 && (preDotState = -1);
        }
        return startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1 ? "" : path2.slice(startDot, end);
    },
    /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   */ parse (path2) {
        $6b9e77990c145458$var$assertPath(path2);
        const ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path2.length === 0) return ret;
        path2 = $6b9e77990c145458$var$removeUrlParams(this.toPosix(path2));
        let code = path2.charCodeAt(0);
        const isAbsolute = this.isAbsolute(path2);
        let start;
        const protocol = "";
        ret.root = this.rootname(path2), isAbsolute || this.hasProtocol(path2) ? start = 1 : start = 0;
        let startDot = -1, startPart = 0, end = -1, matchedSlash = !0, i = path2.length - 1, preDotState = 0;
        for(; i >= start; --i){
            if (code = path2.charCodeAt(i), code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            end === -1 && (matchedSlash = !1, end = i + 1), code === 46 ? startDot === -1 ? startDot = i : preDotState !== 1 && (preDotState = 1) : startDot !== -1 && (preDotState = -1);
        }
        return startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1 ? end !== -1 && (startPart === 0 && isAbsolute ? ret.base = ret.name = path2.slice(1, end) : ret.base = ret.name = path2.slice(startPart, end)) : (startPart === 0 && isAbsolute ? (ret.name = path2.slice(1, startDot), ret.base = path2.slice(1, end)) : (ret.name = path2.slice(startPart, startDot), ret.base = path2.slice(startPart, end)), ret.ext = path2.slice(startDot, end)), ret.dir = this.dirname(path2), protocol && (ret.dir = protocol + ret.dir), ret;
    },
    sep: "/",
    delimiter: ":"
};



let $e279054245c1149e$var$promise;
async function $e279054245c1149e$export$8df68d58aae31877() {
    return $e279054245c1149e$var$promise ?? ($e279054245c1149e$var$promise = (async ()=>{
        const gl = document.createElement("canvas").getContext("webgl");
        if (!gl) return (0, $5912637ee8cf8b9f$export$d56550d454401b73).UNPACK;
        const video = await new Promise((resolve)=>{
            const video2 = document.createElement("video");
            video2.onloadeddata = ()=>resolve(video2), video2.onerror = ()=>resolve(null), video2.autoplay = !1, video2.crossOrigin = "anonymous", video2.preload = "auto", video2.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=", video2.load();
        });
        if (!video) return (0, $5912637ee8cf8b9f$export$d56550d454401b73).UNPACK;
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        const framebuffer = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer), gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0), gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.NONE), gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video);
        const pixel = new Uint8Array(4);
        return gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixel), gl.deleteFramebuffer(framebuffer), gl.deleteTexture(texture), gl.getExtension("WEBGL_lose_context")?.loseContext(), pixel[0] <= pixel[3] ? (0, $5912637ee8cf8b9f$export$d56550d454401b73).PMA : (0, $5912637ee8cf8b9f$export$d56550d454401b73).UNPACK;
    })()), $e279054245c1149e$var$promise;
}



function $80be8fc77ca244ff$export$702210f86367d7ed() {
    (0, $4835512019cf238f$export$afd31d834b512e89)("7.0.0", "skipHello is deprecated, please use settings.RENDER_OPTIONS.hello");
}
function $80be8fc77ca244ff$export$2c6a96c059a06e7c() {
    (0, $4835512019cf238f$export$afd31d834b512e89)("7.0.0", `sayHello is deprecated, please use Renderer's "hello" option`);
}




let $430338622e16bcef$var$supported;
function $430338622e16bcef$export$83dc396b76015322() {
    return typeof $430338622e16bcef$var$supported > "u" && ($430338622e16bcef$var$supported = function() {
        const contextOptions = {
            stencil: !0,
            failIfMajorPerformanceCaveat: (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).FAIL_IF_MAJOR_PERFORMANCE_CAVEAT
        };
        try {
            if (!(0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.getWebGLRenderingContext()) return !1;
            const canvas = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.createCanvas();
            let gl = canvas.getContext("webgl", contextOptions) || canvas.getContext("experimental-webgl", contextOptions);
            const success = !!gl?.getContextAttributes()?.stencil;
            if (gl) {
                const loseContext = gl.getExtension("WEBGL_lose_context");
                loseContext && loseContext.loseContext();
            }
            return gl = null, success;
        } catch  {
            return !1;
        }
    }()), $430338622e16bcef$var$supported;
}


var $7399638ae19e1dd9$var$r = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $7399638ae19e1dd9$var$t = function(r) {
    return "string" == typeof r ? r.length > 0 : "number" == typeof r;
}, $7399638ae19e1dd9$var$n = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = Math.pow(10, t)), Math.round(n * r) / n + 0;
}, $7399638ae19e1dd9$var$e = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = 1), r > n ? n : r > t ? r : t;
}, $7399638ae19e1dd9$var$u = function(r) {
    return (r = isFinite(r) ? r % 360 : 0) > 0 ? r : r + 360;
}, $7399638ae19e1dd9$var$a = function(r) {
    return {
        r: $7399638ae19e1dd9$var$e(r.r, 0, 255),
        g: $7399638ae19e1dd9$var$e(r.g, 0, 255),
        b: $7399638ae19e1dd9$var$e(r.b, 0, 255),
        a: $7399638ae19e1dd9$var$e(r.a)
    };
}, $7399638ae19e1dd9$var$o = function(r) {
    return {
        r: $7399638ae19e1dd9$var$n(r.r),
        g: $7399638ae19e1dd9$var$n(r.g),
        b: $7399638ae19e1dd9$var$n(r.b),
        a: $7399638ae19e1dd9$var$n(r.a, 3)
    };
}, $7399638ae19e1dd9$var$i = /^#([0-9a-f]{3,8})$/i, $7399638ae19e1dd9$var$s = function(r) {
    var t = r.toString(16);
    return t.length < 2 ? "0" + t : t;
}, $7399638ae19e1dd9$var$h = function(r) {
    var t = r.r, n = r.g, e = r.b, u = r.a, a = Math.max(t, n, e), o = a - Math.min(t, n, e), i = o ? a === t ? (n - e) / o : a === n ? 2 + (e - t) / o : 4 + (t - n) / o : 0;
    return {
        h: 60 * (i < 0 ? i + 6 : i),
        s: a ? o / a * 100 : 0,
        v: a / 255 * 100,
        a: u
    };
}, $7399638ae19e1dd9$var$b = function(r) {
    var t = r.h, n = r.s, e = r.v, u = r.a;
    t = t / 360 * 6, n /= 100, e /= 100;
    var a = Math.floor(t), o = e * (1 - n), i = e * (1 - (t - a) * n), s = e * (1 - (1 - t + a) * n), h = a % 6;
    return {
        r: 255 * [
            e,
            i,
            o,
            o,
            s,
            e
        ][h],
        g: 255 * [
            s,
            e,
            e,
            i,
            o,
            o
        ][h],
        b: 255 * [
            o,
            o,
            s,
            e,
            e,
            i
        ][h],
        a: u
    };
}, $7399638ae19e1dd9$var$g = function(r) {
    return {
        h: $7399638ae19e1dd9$var$u(r.h),
        s: $7399638ae19e1dd9$var$e(r.s, 0, 100),
        l: $7399638ae19e1dd9$var$e(r.l, 0, 100),
        a: $7399638ae19e1dd9$var$e(r.a)
    };
}, $7399638ae19e1dd9$var$d = function(r) {
    return {
        h: $7399638ae19e1dd9$var$n(r.h),
        s: $7399638ae19e1dd9$var$n(r.s),
        l: $7399638ae19e1dd9$var$n(r.l),
        a: $7399638ae19e1dd9$var$n(r.a, 3)
    };
}, $7399638ae19e1dd9$var$f = function(r) {
    var t, n, e;
    return $7399638ae19e1dd9$var$b((n = (t = r).s, {
        h: t.h,
        s: (n *= ((e = t.l) < 50 ? e : 100 - e) / 100) > 0 ? 2 * n / (e + n) * 100 : 0,
        v: e + n,
        a: t.a
    }));
}, $7399638ae19e1dd9$var$c = function(r) {
    var t, n, e, u;
    return {
        h: (t = $7399638ae19e1dd9$var$h(r)).h,
        s: (u = (200 - (n = t.s)) * (e = t.v) / 100) > 0 && u < 200 ? n * e / 100 / (u <= 100 ? u : 200 - u) * 100 : 0,
        l: u / 2,
        a: t.a
    };
}, $7399638ae19e1dd9$var$l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $7399638ae19e1dd9$var$p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $7399638ae19e1dd9$var$v = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $7399638ae19e1dd9$var$m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $7399638ae19e1dd9$var$y = {
    string: [
        [
            function(r) {
                var t = $7399638ae19e1dd9$var$i.exec(r);
                return t ? (r = t[1]).length <= 4 ? {
                    r: parseInt(r[0] + r[0], 16),
                    g: parseInt(r[1] + r[1], 16),
                    b: parseInt(r[2] + r[2], 16),
                    a: 4 === r.length ? $7399638ae19e1dd9$var$n(parseInt(r[3] + r[3], 16) / 255, 2) : 1
                } : 6 === r.length || 8 === r.length ? {
                    r: parseInt(r.substr(0, 2), 16),
                    g: parseInt(r.substr(2, 2), 16),
                    b: parseInt(r.substr(4, 2), 16),
                    a: 8 === r.length ? $7399638ae19e1dd9$var$n(parseInt(r.substr(6, 2), 16) / 255, 2) : 1
                } : null : null;
            },
            "hex"
        ],
        [
            function(r) {
                var t = $7399638ae19e1dd9$var$v.exec(r) || $7399638ae19e1dd9$var$m.exec(r);
                return t ? t[2] !== t[4] || t[4] !== t[6] ? null : $7399638ae19e1dd9$var$a({
                    r: Number(t[1]) / (t[2] ? 100 / 255 : 1),
                    g: Number(t[3]) / (t[4] ? 100 / 255 : 1),
                    b: Number(t[5]) / (t[6] ? 100 / 255 : 1),
                    a: void 0 === t[7] ? 1 : Number(t[7]) / (t[8] ? 100 : 1)
                }) : null;
            },
            "rgb"
        ],
        [
            function(t) {
                var n = $7399638ae19e1dd9$var$l.exec(t) || $7399638ae19e1dd9$var$p.exec(t);
                if (!n) return null;
                var e, u, a = $7399638ae19e1dd9$var$g({
                    h: (e = n[1], u = n[2], void 0 === u && (u = "deg"), Number(e) * ($7399638ae19e1dd9$var$r[u] || 1)),
                    s: Number(n[3]),
                    l: Number(n[4]),
                    a: void 0 === n[5] ? 1 : Number(n[5]) / (n[6] ? 100 : 1)
                });
                return $7399638ae19e1dd9$var$f(a);
            },
            "hsl"
        ]
    ],
    object: [
        [
            function(r) {
                var n = r.r, e = r.g, u = r.b, o = r.a, i = void 0 === o ? 1 : o;
                return $7399638ae19e1dd9$var$t(n) && $7399638ae19e1dd9$var$t(e) && $7399638ae19e1dd9$var$t(u) ? $7399638ae19e1dd9$var$a({
                    r: Number(n),
                    g: Number(e),
                    b: Number(u),
                    a: Number(i)
                }) : null;
            },
            "rgb"
        ],
        [
            function(r) {
                var n = r.h, e = r.s, u = r.l, a = r.a, o = void 0 === a ? 1 : a;
                if (!$7399638ae19e1dd9$var$t(n) || !$7399638ae19e1dd9$var$t(e) || !$7399638ae19e1dd9$var$t(u)) return null;
                var i = $7399638ae19e1dd9$var$g({
                    h: Number(n),
                    s: Number(e),
                    l: Number(u),
                    a: Number(o)
                });
                return $7399638ae19e1dd9$var$f(i);
            },
            "hsl"
        ],
        [
            function(r) {
                var n = r.h, a = r.s, o = r.v, i = r.a, s = void 0 === i ? 1 : i;
                if (!$7399638ae19e1dd9$var$t(n) || !$7399638ae19e1dd9$var$t(a) || !$7399638ae19e1dd9$var$t(o)) return null;
                var h = function(r) {
                    return {
                        h: $7399638ae19e1dd9$var$u(r.h),
                        s: $7399638ae19e1dd9$var$e(r.s, 0, 100),
                        v: $7399638ae19e1dd9$var$e(r.v, 0, 100),
                        a: $7399638ae19e1dd9$var$e(r.a)
                    };
                }({
                    h: Number(n),
                    s: Number(a),
                    v: Number(o),
                    a: Number(s)
                });
                return $7399638ae19e1dd9$var$b(h);
            },
            "hsv"
        ]
    ]
}, $7399638ae19e1dd9$var$N = function(r, t) {
    for(var n = 0; n < t.length; n++){
        var e = t[n][0](r);
        if (e) return [
            e,
            t[n][1]
        ];
    }
    return [
        null,
        void 0
    ];
}, $7399638ae19e1dd9$var$x = function(r) {
    return "string" == typeof r ? $7399638ae19e1dd9$var$N(r.trim(), $7399638ae19e1dd9$var$y.string) : "object" == typeof r && null !== r ? $7399638ae19e1dd9$var$N(r, $7399638ae19e1dd9$var$y.object) : [
        null,
        void 0
    ];
}, $7399638ae19e1dd9$export$f61ac8b6f1f46202 = function(r) {
    return $7399638ae19e1dd9$var$x(r)[1];
}, $7399638ae19e1dd9$var$M = function(r, t) {
    var n = $7399638ae19e1dd9$var$c(r);
    return {
        h: n.h,
        s: $7399638ae19e1dd9$var$e(n.s + 100 * t, 0, 100),
        l: n.l,
        a: n.a
    };
}, $7399638ae19e1dd9$var$H = function(r) {
    return (299 * r.r + 587 * r.g + 114 * r.b) / 1e3 / 255;
}, $7399638ae19e1dd9$var$$ = function(r, t) {
    var n = $7399638ae19e1dd9$var$c(r);
    return {
        h: n.h,
        s: n.s,
        l: $7399638ae19e1dd9$var$e(n.l + 100 * t, 0, 100),
        a: n.a
    };
}, $7399638ae19e1dd9$export$4d30ed660ff08d0 = function() {
    function r(r) {
        this.parsed = $7399638ae19e1dd9$var$x(r)[0], this.rgba = this.parsed || {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
    }
    return r.prototype.isValid = function() {
        return null !== this.parsed;
    }, r.prototype.brightness = function() {
        return $7399638ae19e1dd9$var$n($7399638ae19e1dd9$var$H(this.rgba), 2);
    }, r.prototype.isDark = function() {
        return $7399638ae19e1dd9$var$H(this.rgba) < .5;
    }, r.prototype.isLight = function() {
        return $7399638ae19e1dd9$var$H(this.rgba) >= .5;
    }, r.prototype.toHex = function() {
        var r, t, e, u, a, i;
        return r = $7399638ae19e1dd9$var$o(this.rgba), t = r.r, e = r.g, u = r.b, i = (a = r.a) < 1 ? $7399638ae19e1dd9$var$s($7399638ae19e1dd9$var$n(255 * a)) : "", "#" + $7399638ae19e1dd9$var$s(t) + $7399638ae19e1dd9$var$s(e) + $7399638ae19e1dd9$var$s(u) + i;
    }, r.prototype.toRgb = function() {
        return $7399638ae19e1dd9$var$o(this.rgba);
    }, r.prototype.toRgbString = function() {
        var r, t, n, e, u;
        return r = $7399638ae19e1dd9$var$o(this.rgba), t = r.r, n = r.g, e = r.b, (u = r.a) < 1 ? "rgba(" + t + ", " + n + ", " + e + ", " + u + ")" : "rgb(" + t + ", " + n + ", " + e + ")";
    }, r.prototype.toHsl = function() {
        return $7399638ae19e1dd9$var$d($7399638ae19e1dd9$var$c(this.rgba));
    }, r.prototype.toHslString = function() {
        var r, t, n, e, u;
        return r = $7399638ae19e1dd9$var$d($7399638ae19e1dd9$var$c(this.rgba)), t = r.h, n = r.s, e = r.l, (u = r.a) < 1 ? "hsla(" + t + ", " + n + "%, " + e + "%, " + u + ")" : "hsl(" + t + ", " + n + "%, " + e + "%)";
    }, r.prototype.toHsv = function() {
        var r;
        return r = $7399638ae19e1dd9$var$h(this.rgba), {
            h: $7399638ae19e1dd9$var$n(r.h),
            s: $7399638ae19e1dd9$var$n(r.s),
            v: $7399638ae19e1dd9$var$n(r.v),
            a: $7399638ae19e1dd9$var$n(r.a, 3)
        };
    }, r.prototype.invert = function() {
        var r;
        return $7399638ae19e1dd9$export$c8efe09109f9cb9e({
            r: 255 - (r = this.rgba).r,
            g: 255 - r.g,
            b: 255 - r.b,
            a: r.a
        });
    }, r.prototype.saturate = function(r) {
        return void 0 === r && (r = .1), $7399638ae19e1dd9$export$c8efe09109f9cb9e($7399638ae19e1dd9$var$M(this.rgba, r));
    }, r.prototype.desaturate = function(r) {
        return void 0 === r && (r = .1), $7399638ae19e1dd9$export$c8efe09109f9cb9e($7399638ae19e1dd9$var$M(this.rgba, -r));
    }, r.prototype.grayscale = function() {
        return $7399638ae19e1dd9$export$c8efe09109f9cb9e($7399638ae19e1dd9$var$M(this.rgba, -1));
    }, r.prototype.lighten = function(r) {
        return void 0 === r && (r = .1), $7399638ae19e1dd9$export$c8efe09109f9cb9e($7399638ae19e1dd9$var$$(this.rgba, r));
    }, r.prototype.darken = function(r) {
        return void 0 === r && (r = .1), $7399638ae19e1dd9$export$c8efe09109f9cb9e($7399638ae19e1dd9$var$$(this.rgba, -r));
    }, r.prototype.rotate = function(r) {
        return void 0 === r && (r = 15), this.hue(this.hue() + r);
    }, r.prototype.alpha = function(r) {
        var t;
        return "number" == typeof r ? $7399638ae19e1dd9$export$c8efe09109f9cb9e({
            r: (t = this.rgba).r,
            g: t.g,
            b: t.b,
            a: r
        }) : $7399638ae19e1dd9$var$n(this.rgba.a, 3);
    }, r.prototype.hue = function(r) {
        var t = $7399638ae19e1dd9$var$c(this.rgba);
        return "number" == typeof r ? $7399638ae19e1dd9$export$c8efe09109f9cb9e({
            h: r,
            s: t.s,
            l: t.l,
            a: t.a
        }) : $7399638ae19e1dd9$var$n(t.h);
    }, r.prototype.isEqual = function(r) {
        return this.toHex() === $7399638ae19e1dd9$export$c8efe09109f9cb9e(r).toHex();
    }, r;
}(), $7399638ae19e1dd9$export$c8efe09109f9cb9e = function(r) {
    return r instanceof $7399638ae19e1dd9$export$4d30ed660ff08d0 ? r : new $7399638ae19e1dd9$export$4d30ed660ff08d0(r);
}, $7399638ae19e1dd9$var$S = [], $7399638ae19e1dd9$export$8b58be045bf06082 = function(r) {
    r.forEach(function(r) {
        $7399638ae19e1dd9$var$S.indexOf(r) < 0 && (r($7399638ae19e1dd9$export$4d30ed660ff08d0, $7399638ae19e1dd9$var$y), $7399638ae19e1dd9$var$S.push(r));
    });
}, $7399638ae19e1dd9$export$4385e60b38654f68 = function() {
    return new $7399638ae19e1dd9$export$4d30ed660ff08d0({
        r: 255 * Math.random(),
        g: 255 * Math.random(),
        b: 255 * Math.random()
    });
};


function $d112d00f8bcdd2b1$export$2e2bcd8739ae039(e, f) {
    var a = {
        white: "#ffffff",
        bisque: "#ffe4c4",
        blue: "#0000ff",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        azure: "#f0ffff",
        whitesmoke: "#f5f5f5",
        papayawhip: "#ffefd5",
        plum: "#dda0dd",
        blanchedalmond: "#ffebcd",
        black: "#000000",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gainsboro: "#dcdcdc",
        cornsilk: "#fff8dc",
        cornflowerblue: "#6495ed",
        burlywood: "#deb887",
        aquamarine: "#7fffd4",
        beige: "#f5f5dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkkhaki: "#bdb76b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        peachpuff: "#ffdab9",
        darkmagenta: "#8b008b",
        darkred: "#8b0000",
        darkorchid: "#9932cc",
        darkorange: "#ff8c00",
        darkslateblue: "#483d8b",
        gray: "#808080",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        wheat: "#f5deb3",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        ghostwhite: "#f8f8ff",
        darkviolet: "#9400d3",
        magenta: "#ff00ff",
        green: "#008000",
        dodgerblue: "#1e90ff",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        blueviolet: "#8a2be2",
        forestgreen: "#228b22",
        lawngreen: "#7cfc00",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        fuchsia: "#ff00ff",
        brown: "#a52a2a",
        maroon: "#800000",
        mediumblue: "#0000cd",
        lightcoral: "#f08080",
        darkturquoise: "#00ced1",
        lightcyan: "#e0ffff",
        ivory: "#fffff0",
        lightyellow: "#ffffe0",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        linen: "#faf0e6",
        mediumaquamarine: "#66cdaa",
        lemonchiffon: "#fffacd",
        lime: "#00ff00",
        khaki: "#f0e68c",
        mediumseagreen: "#3cb371",
        limegreen: "#32cd32",
        mediumspringgreen: "#00fa9a",
        lightskyblue: "#87cefa",
        lightblue: "#add8e6",
        midnightblue: "#191970",
        lightpink: "#ffb6c1",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        mintcream: "#f5fffa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        navajowhite: "#ffdead",
        navy: "#000080",
        mediumvioletred: "#c71585",
        powderblue: "#b0e0e6",
        palegoldenrod: "#eee8aa",
        oldlace: "#fdf5e6",
        paleturquoise: "#afeeee",
        mediumturquoise: "#48d1cc",
        mediumorchid: "#ba55d3",
        rebeccapurple: "#663399",
        lightsteelblue: "#b0c4de",
        mediumslateblue: "#7b68ee",
        thistle: "#d8bfd8",
        tan: "#d2b48c",
        orchid: "#da70d6",
        mediumpurple: "#9370db",
        purple: "#800080",
        pink: "#ffc0cb",
        skyblue: "#87ceeb",
        springgreen: "#00ff7f",
        palegreen: "#98fb98",
        red: "#ff0000",
        yellow: "#ffff00",
        slateblue: "#6a5acd",
        lavenderblush: "#fff0f5",
        peru: "#cd853f",
        palevioletred: "#db7093",
        violet: "#ee82ee",
        teal: "#008080",
        slategray: "#708090",
        slategrey: "#708090",
        aliceblue: "#f0f8ff",
        darkseagreen: "#8fbc8f",
        darkolivegreen: "#556b2f",
        greenyellow: "#adff2f",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        tomato: "#ff6347",
        silver: "#c0c0c0",
        sienna: "#a0522d",
        lavender: "#e6e6fa",
        lightgreen: "#90ee90",
        orange: "#ffa500",
        orangered: "#ff4500",
        steelblue: "#4682b4",
        royalblue: "#4169e1",
        turquoise: "#40e0d0",
        yellowgreen: "#9acd32",
        salmon: "#fa8072",
        saddlebrown: "#8b4513",
        sandybrown: "#f4a460",
        rosybrown: "#bc8f8f",
        darksalmon: "#e9967a",
        lightgoldenrodyellow: "#fafad2",
        snow: "#fffafa",
        lightgrey: "#d3d3d3",
        lightgray: "#d3d3d3",
        dimgray: "#696969",
        dimgrey: "#696969",
        olivedrab: "#6b8e23",
        olive: "#808000"
    }, r = {};
    for(var d in a)r[a[d]] = d;
    var l = {};
    e.prototype.toName = function(f) {
        if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
        var d, i, n = r[this.toHex()];
        if (n) return n;
        if (null == f ? void 0 : f.closest) {
            var o = this.toRgb(), t = 1 / 0, b = "black";
            if (!l.length) for(var c in a)l[c] = new e(a[c]).toRgb();
            for(var g in a){
                var u = (d = o, i = l[g], Math.pow(d.r - i.r, 2) + Math.pow(d.g - i.g, 2) + Math.pow(d.b - i.b, 2));
                u < t && (t = u, b = g);
            }
            return b;
        }
    };
    f.string.push([
        function(f) {
            var r = f.toLowerCase(), d = "transparent" === r ? "#0000" : a[r];
            return d ? new e(d).toRgb() : null;
        },
        "name"
    ]);
}


(0, $7399638ae19e1dd9$export$8b58be045bf06082)([
    (0, $d112d00f8bcdd2b1$export$2e2bcd8739ae039)
]);
const $3119899e085d9ccf$var$_Color = class _Color2 {
    /**
   * @param {PIXI.ColorSource} value - Optional value to use, if not provided, white is used.
   */ constructor(value = 16777215){
        this._value = null, this._components = new Float32Array(4), this._components.fill(1), this._int = 16777215, this.value = value;
    }
    /** Get red component (0 - 1) */ get red() {
        return this._components[0];
    }
    /** Get green component (0 - 1) */ get green() {
        return this._components[1];
    }
    /** Get blue component (0 - 1) */ get blue() {
        return this._components[2];
    }
    /** Get alpha component (0 - 1) */ get alpha() {
        return this._components[3];
    }
    /**
   * Set the value, suitable for chaining
   * @param value
   * @see PIXI.Color.value
   */ setValue(value) {
        return this.value = value, this;
    }
    /**
   * The current color source.
   *
   * When setting:
   * - Setting to an instance of `Color` will copy its color source and components.
   * - Otherwise, `Color` will try to normalize the color source and set the components.
   *   If the color source is invalid, an `Error` will be thrown and the `Color` will left unchanged.
   *
   * Note: The `null` in the setter's parameter type is added to match the TypeScript rule: return type of getter
   * must be assignable to its setter's parameter type. Setting `value` to `null` will throw an `Error`.
   *
   * When getting:
   * - A return value of `null` means the previous value was overridden (e.g., {@link PIXI.Color.multiply multiply},
   *   {@link PIXI.Color.premultiply premultiply} or {@link PIXI.Color.round round}).
   * - Otherwise, the color source used when setting is returned.
   * @type {PIXI.ColorSource}
   */ set value(value) {
        if (value instanceof _Color2) this._value = this.cloneSource(value._value), this._int = value._int, this._components.set(value._components);
        else {
            if (value === null) throw new Error("Cannot set PIXI.Color#value to null");
            (this._value === null || !this.isSourceEqual(this._value, value)) && (this.normalize(value), this._value = this.cloneSource(value));
        }
    }
    get value() {
        return this._value;
    }
    /**
   * Copy a color source internally.
   * @param value - Color source
   */ cloneSource(value) {
        return typeof value == "string" || typeof value == "number" || value instanceof Number || value === null ? value : Array.isArray(value) || ArrayBuffer.isView(value) ? value.slice(0) : typeof value == "object" && value !== null ? {
            ...value
        } : value;
    }
    /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */ isSourceEqual(value1, value2) {
        const type1 = typeof value1;
        if (type1 !== typeof value2) return !1;
        if (type1 === "number" || type1 === "string" || value1 instanceof Number) return value1 === value2;
        if (Array.isArray(value1) && Array.isArray(value2) || ArrayBuffer.isView(value1) && ArrayBuffer.isView(value2)) return value1.length !== value2.length ? !1 : value1.every((v, i)=>v === value2[i]);
        if (value1 !== null && value2 !== null) {
            const keys1 = Object.keys(value1), keys2 = Object.keys(value2);
            return keys1.length !== keys2.length ? !1 : keys1.every((key)=>value1[key] === value2[key]);
        }
        return value1 === value2;
    }
    /**
   * Convert to a RGBA color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1, a: 1 }
   */ toRgba() {
        const [r, g, b, a] = this._components;
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    }
    /**
   * Convert to a RGB color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1 }
   */ toRgb() {
        const [r, g, b] = this._components;
        return {
            r: r,
            g: g,
            b: b
        };
    }
    /** Convert to a CSS-style rgba string: `rgba(255,255,255,1.0)`. */ toRgbaString() {
        const [r, g, b] = this.toUint8RgbArray();
        return `rgba(${r},${g},${b},${this.alpha})`;
    }
    toUint8RgbArray(out) {
        const [r, g, b] = this._components;
        return out = out ?? [], out[0] = Math.round(r * 255), out[1] = Math.round(g * 255), out[2] = Math.round(b * 255), out;
    }
    toRgbArray(out) {
        out = out ?? [];
        const [r, g, b] = this._components;
        return out[0] = r, out[1] = g, out[2] = b, out;
    }
    /**
   * Convert to a hexadecimal number.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toNumber(); // returns 16777215
   */ toNumber() {
        return this._int;
    }
    /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   * @example
   * import { Color } from 'pixi.js';
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   * @returns {number} - The color as a number in little endian format.
   */ toLittleEndianNumber() {
        const value = this._int;
        return (value >> 16) + (value & 65280) + ((value & 255) << 16);
    }
    /**
   * Multiply with another color. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param {PIXI.ColorSource} value - The color to multiply by.
   */ multiply(value) {
        const [r, g, b, a] = _Color2.temp.setValue(value)._components;
        return this._components[0] *= r, this._components[1] *= g, this._components[2] *= b, this._components[3] *= a, this.refreshInt(), this._value = null, this;
    }
    /**
   * Converts color to a premultiplied alpha format. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {PIXI.Color} - Itself.
   */ premultiply(alpha, applyToRGB = !0) {
        return applyToRGB && (this._components[0] *= alpha, this._components[1] *= alpha, this._components[2] *= alpha), this._components[3] = alpha, this.refreshInt(), this._value = null, this;
    }
    /**
   * Premultiplies alpha with current color.
   * @param {number} alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {number} tint multiplied by alpha
   */ toPremultiplied(alpha, applyToRGB = !0) {
        if (alpha === 1) return -16777216 + this._int;
        if (alpha === 0) return applyToRGB ? 0 : this._int;
        let r = this._int >> 16 & 255, g = this._int >> 8 & 255, b = this._int & 255;
        return applyToRGB && (r = r * alpha + 0.5 | 0, g = g * alpha + 0.5 | 0, b = b * alpha + 0.5 | 0), (alpha * 255 << 24) + (r << 16) + (g << 8) + b;
    }
    /**
   * Convert to a hexidecimal string.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHex(); // returns "#ffffff"
   */ toHex() {
        const hexString = this._int.toString(16);
        return `#${"000000".substring(0, 6 - hexString.length) + hexString}`;
    }
    /**
   * Convert to a hexidecimal string with alpha.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHexa(); // returns "#ffffffff"
   */ toHexa() {
        const alphaString = Math.round(this._components[3] * 255).toString(16);
        return this.toHex() + "00".substring(0, 2 - alphaString.length) + alphaString;
    }
    /**
   * Set alpha, suitable for chaining.
   * @param alpha
   */ setAlpha(alpha) {
        return this._components[3] = this._clamp(alpha), this;
    }
    /**
   * Rounds the specified color according to the step. This action is destructive, and will
   * override the previous `value` property to be `null`. The alpha component is not rounded.
   * @param steps - Number of steps which will be used as a cap when rounding colors
   * @deprecated since 7.3.0
   */ round(steps) {
        const [r, g, b] = this._components;
        return this._components[0] = Math.round(r * steps) / steps, this._components[1] = Math.round(g * steps) / steps, this._components[2] = Math.round(b * steps) / steps, this.refreshInt(), this._value = null, this;
    }
    toArray(out) {
        out = out ?? [];
        const [r, g, b, a] = this._components;
        return out[0] = r, out[1] = g, out[2] = b, out[3] = a, out;
    }
    /**
   * Normalize the input value into rgba
   * @param value - Input value
   */ normalize(value) {
        let r, g, b, a;
        if ((typeof value == "number" || value instanceof Number) && value >= 0 && value <= 16777215) {
            const int = value;
            r = (int >> 16 & 255) / 255, g = (int >> 8 & 255) / 255, b = (int & 255) / 255, a = 1;
        } else if ((Array.isArray(value) || value instanceof Float32Array) && value.length >= 3 && value.length <= 4) value = this._clamp(value), [r, g, b, a = 1] = value;
        else if ((value instanceof Uint8Array || value instanceof Uint8ClampedArray) && value.length >= 3 && value.length <= 4) value = this._clamp(value, 0, 255), [r, g, b, a = 255] = value, r /= 255, g /= 255, b /= 255, a /= 255;
        else if (typeof value == "string" || typeof value == "object") {
            if (typeof value == "string") {
                const match = _Color2.HEX_PATTERN.exec(value);
                match && (value = `#${match[2]}`);
            }
            const color = (0, $7399638ae19e1dd9$export$c8efe09109f9cb9e)(value);
            color.isValid() && ({ r: r, g: g, b: b, a: a } = color.rgba, r /= 255, g /= 255, b /= 255);
        }
        if (r !== void 0) this._components[0] = r, this._components[1] = g, this._components[2] = b, this._components[3] = a, this.refreshInt();
        else throw new Error(`Unable to convert color ${value}`);
    }
    /** Refresh the internal color rgb number */ refreshInt() {
        this._clamp(this._components);
        const [r, g, b] = this._components;
        this._int = (r * 255 << 16) + (g * 255 << 8) + (b * 255 | 0);
    }
    /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */ _clamp(value, min = 0, max = 1) {
        return typeof value == "number" ? Math.min(Math.max(value, min), max) : (value.forEach((v, i)=>{
            value[i] = Math.min(Math.max(v, min), max);
        }), value);
    }
};
$3119899e085d9ccf$var$_Color.shared = new $3119899e085d9ccf$var$_Color(), /**
* Temporary Color object for static uses internally.
* As to not conflict with Color.shared.
* @ignore
*/ $3119899e085d9ccf$var$_Color.temp = new $3119899e085d9ccf$var$_Color(), /** Pattern for hex strings */ $3119899e085d9ccf$var$_Color.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let $3119899e085d9ccf$export$892596cec99bc70e = $3119899e085d9ccf$var$_Color;





function $75577435cc0a18d4$export$858a46ce014e0e87(hex, out = []) {
    return (0, $4835512019cf238f$export$afd31d834b512e89)("7.2.0", "utils.hex2rgb is deprecated, use Color#toRgbArray instead"), (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(hex).toRgbArray(out);
}
function $75577435cc0a18d4$export$7a57339af2222169(hex) {
    return (0, $4835512019cf238f$export$afd31d834b512e89)("7.2.0", "utils.hex2string is deprecated, use Color#toHex instead"), (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(hex).toHex();
}
function $75577435cc0a18d4$export$f6a774610dbc2f6(string) {
    return (0, $4835512019cf238f$export$afd31d834b512e89)("7.2.0", "utils.string2hex is deprecated, use Color#toNumber instead"), (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(string).toNumber();
}
function $75577435cc0a18d4$export$883528fb0afa7177(rgb) {
    return (0, $4835512019cf238f$export$afd31d834b512e89)("7.2.0", "utils.rgb2hex is deprecated, use Color#toNumber instead"), (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(rgb).toNumber();
}





function $7b974150e84e102b$var$mapPremultipliedBlendModes() {
    const pm = [], npm = [];
    for(let i = 0; i < 32; i++)pm[i] = i, npm[i] = i;
    pm[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).NORMAL_NPM] = (0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).NORMAL, pm[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).ADD_NPM] = (0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).ADD, pm[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).SCREEN_NPM] = (0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).SCREEN, npm[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).NORMAL] = (0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).NORMAL_NPM, npm[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).ADD] = (0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).ADD_NPM, npm[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).SCREEN] = (0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).SCREEN_NPM;
    const array = [];
    return array.push(npm), array.push(pm), array;
}
const $7b974150e84e102b$export$799d0d31e2f4c737 = $7b974150e84e102b$var$mapPremultipliedBlendModes();
function $7b974150e84e102b$export$3d793623cb0d1905(blendMode, premultiplied) {
    return $7b974150e84e102b$export$799d0d31e2f4c737[premultiplied ? 1 : 0][blendMode];
}
function $7b974150e84e102b$export$4fa4eaa2922d1869(rgb, alpha, out, premultiply = !0) {
    return (0, $4835512019cf238f$export$afd31d834b512e89)("7.2.0", "utils.premultiplyRgba has moved to Color.premultiply"), (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(rgb).premultiply(alpha, premultiply).toArray(out ?? new Float32Array(4));
}
function $7b974150e84e102b$export$1ddadce6229d3efd(tint, alpha) {
    return (0, $4835512019cf238f$export$afd31d834b512e89)("7.2.0", "utils.premultiplyTint has moved to Color.toPremultiplied"), (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(tint).toPremultiplied(alpha);
}
function $7b974150e84e102b$export$c75351d34304eb8c(tint, alpha, out, premultiply = !0) {
    return (0, $4835512019cf238f$export$afd31d834b512e89)("7.2.0", "utils.premultiplyTintToRgba has moved to Color.premultiply"), (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(tint).premultiply(alpha, premultiply).toArray(out ?? new Float32Array(4));
}


const $bfcd1d022c72cb12$export$dbafa72958753fce = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;


function $b5717530b0cb1d89$export$c56148e1bec42281(size, outBuffer = null) {
    const totalIndices = size * 6;
    if (outBuffer = outBuffer || new Uint16Array(totalIndices), outBuffer.length !== totalIndices) throw new Error(`Out buffer length is incorrect, got ${outBuffer.length} and expected ${totalIndices}`);
    for(let i = 0, j = 0; i < totalIndices; i += 6, j += 4)outBuffer[i + 0] = j + 0, outBuffer[i + 1] = j + 1, outBuffer[i + 2] = j + 2, outBuffer[i + 3] = j + 0, outBuffer[i + 4] = j + 2, outBuffer[i + 5] = j + 3;
    return outBuffer;
}


function $02309e39cc052e17$export$adf72b506413cb57(array) {
    if (array.BYTES_PER_ELEMENT === 4) return array instanceof Float32Array ? "Float32Array" : array instanceof Uint32Array ? "Uint32Array" : "Int32Array";
    if (array.BYTES_PER_ELEMENT === 2) {
        if (array instanceof Uint16Array) return "Uint16Array";
    } else if (array.BYTES_PER_ELEMENT === 1 && array instanceof Uint8Array) return "Uint8Array";
    return null;
}



const $0afb0cec4a7a033f$var$map = {
    Float32Array: Float32Array,
    Uint32Array: Uint32Array,
    Int32Array: Int32Array,
    Uint8Array: Uint8Array
};
function $0afb0cec4a7a033f$export$1ce3e224e969bb24(arrays, sizes) {
    let outSize = 0, stride = 0;
    const views = {};
    for(let i = 0; i < arrays.length; i++)stride += sizes[i], outSize += arrays[i].length;
    const buffer = new ArrayBuffer(outSize * 4);
    let out = null, littleOffset = 0;
    for(let i = 0; i < arrays.length; i++){
        const size = sizes[i], array = arrays[i], type = (0, $02309e39cc052e17$export$adf72b506413cb57)(array);
        views[type] || (views[type] = new $0afb0cec4a7a033f$var$map[type](buffer)), out = views[type];
        for(let j = 0; j < array.length; j++){
            const indexStart = (j / size | 0) * stride + littleOffset, index = j % size;
            out[indexStart + index] = array[j];
        }
        littleOffset += size;
    }
    return new Float32Array(buffer);
}


function $1101e8b3767a1e48$export$f0d90cf68bd426eb(v) {
    return v += v === 0 ? 1 : 0, --v, v |= v >>> 1, v |= v >>> 2, v |= v >>> 4, v |= v >>> 8, v |= v >>> 16, v + 1;
}
function $1101e8b3767a1e48$export$eb50b9c078eb6ae7(v) {
    return !(v & v - 1) && !!v;
}
function $1101e8b3767a1e48$export$b9fae0bba9d9094d(v) {
    let r = (v > 65535 ? 1 : 0) << 4;
    v >>>= r;
    let shift = (v > 255 ? 1 : 0) << 3;
    return v >>>= shift, r |= shift, shift = (v > 15 ? 1 : 0) << 2, v >>>= shift, r |= shift, shift = (v > 3 ? 1 : 0) << 1, v >>>= shift, r |= shift, r | v >> 1;
}


function $b945f5e20f35d72d$export$8d47c0e1ce445404(arr, startIdx, removeCount) {
    const length = arr.length;
    let i;
    if (startIdx >= length || removeCount === 0) return;
    removeCount = startIdx + removeCount > length ? length - startIdx : removeCount;
    const len = length - removeCount;
    for(i = startIdx; i < len; ++i)arr[i] = arr[i + removeCount];
    arr.length = len;
}


function $13791c34b1cb68aa$export$c5552dfdbc7cec71(n) {
    return n === 0 ? 0 : n < 0 ? -1 : 1;
}


let $4f05e7b7511900ff$var$nextUid = 0;
function $4f05e7b7511900ff$export$e2a22331486dcca0() {
    return ++$4f05e7b7511900ff$var$nextUid;
}



const $82d36c4da6e0db49$var$_BoundingBox = class {
    /**
   * @param left - The left coordinate value of the bounding box.
   * @param top - The top coordinate value of the bounding box.
   * @param right - The right coordinate value of the bounding box.
   * @param bottom - The bottom coordinate value of the bounding box.
   */ constructor(left, top, right, bottom){
        this.left = left, this.top = top, this.right = right, this.bottom = bottom;
    }
    /** The width of the bounding box. */ get width() {
        return this.right - this.left;
    }
    /** The height of the bounding box. */ get height() {
        return this.bottom - this.top;
    }
    /** Determines whether the BoundingBox is empty. */ isEmpty() {
        return this.left === this.right || this.top === this.bottom;
    }
};
$82d36c4da6e0db49$var$_BoundingBox.EMPTY = new $82d36c4da6e0db49$var$_BoundingBox(0, 0, 0, 0);
let $82d36c4da6e0db49$export$63080c4de6cfc362 = $82d36c4da6e0db49$var$_BoundingBox;


const $e0cc893a6896296f$export$d47c7e291d8b6e2c = {}, $e0cc893a6896296f$export$4254ab7c0971430e = /* @__PURE__ */ Object.create(null), $e0cc893a6896296f$export$cec649a143d060b1 = /* @__PURE__ */ Object.create(null);
function $e0cc893a6896296f$export$b5c9bc385f713d5a() {
    let key;
    for(key in $e0cc893a6896296f$export$4254ab7c0971430e)$e0cc893a6896296f$export$4254ab7c0971430e[key].destroy();
    for(key in $e0cc893a6896296f$export$cec649a143d060b1)$e0cc893a6896296f$export$cec649a143d060b1[key].destroy();
}
function $e0cc893a6896296f$export$3ee9cef7c9878d34() {
    let key;
    for(key in $e0cc893a6896296f$export$4254ab7c0971430e)delete $e0cc893a6896296f$export$4254ab7c0971430e[key];
    for(key in $e0cc893a6896296f$export$cec649a143d060b1)delete $e0cc893a6896296f$export$cec649a143d060b1[key];
}



class $b8191f7507539488$export$525943d4c7cdfa38 {
    /**
   * @param width - the width for the newly created canvas
   * @param height - the height for the newly created canvas
   * @param {number} [resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the canvas
   */ constructor(width, height, resolution){
        this._canvas = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.createCanvas(), this._context = this._canvas.getContext("2d"), this.resolution = resolution || (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).RESOLUTION, this.resize(width, height);
    }
    /**
   * Clears the canvas that was created by the CanvasRenderTarget class.
   * @private
   */ clear() {
        this._checkDestroyed(), this._context.setTransform(1, 0, 0, 1, 0, 0), this._context.clearRect(0, 0, this._canvas.width, this._canvas.height);
    }
    /**
   * Resizes the canvas to the specified width and height.
   * @param desiredWidth - the desired width of the canvas
   * @param desiredHeight - the desired height of the canvas
   */ resize(desiredWidth, desiredHeight) {
        this._checkDestroyed(), this._canvas.width = Math.round(desiredWidth * this.resolution), this._canvas.height = Math.round(desiredHeight * this.resolution);
    }
    /** Destroys this canvas. */ destroy() {
        this._context = null, this._canvas = null;
    }
    /**
   * The width of the canvas buffer in pixels.
   * @member {number}
   */ get width() {
        return this._checkDestroyed(), this._canvas.width;
    }
    set width(val) {
        this._checkDestroyed(), this._canvas.width = Math.round(val);
    }
    /**
   * The height of the canvas buffer in pixels.
   * @member {number}
   */ get height() {
        return this._checkDestroyed(), this._canvas.height;
    }
    set height(val) {
        this._checkDestroyed(), this._canvas.height = Math.round(val);
    }
    /** The Canvas object that belongs to this CanvasRenderTarget. */ get canvas() {
        return this._checkDestroyed(), this._canvas;
    }
    /** A CanvasRenderingContext2D object representing a two-dimensional rendering context. */ get context() {
        return this._checkDestroyed(), this._context;
    }
    _checkDestroyed() {
        if (this._canvas === null) throw new TypeError("The CanvasRenderTarget has already been destroyed");
    }
}



function $ac0967381ecb4c0f$var$checkRow(data, width, y) {
    for(let x = 0, index = 4 * y * width; x < width; ++x, index += 4)if (data[index + 3] !== 0) return !1;
    return !0;
}
function $ac0967381ecb4c0f$var$checkColumn(data, width, x, top, bottom) {
    const stride = 4 * width;
    for(let y = top, index = top * stride + 4 * x; y <= bottom; ++y, index += stride)if (data[index + 3] !== 0) return !1;
    return !0;
}
function $ac0967381ecb4c0f$export$550eedf6c679837d(canvas) {
    const { width: width, height: height } = canvas, context = canvas.getContext("2d", {
        willReadFrequently: !0
    });
    if (context === null) throw new TypeError("Failed to get canvas 2D context");
    const data = context.getImageData(0, 0, width, height).data;
    let left = 0, top = 0, right = width - 1, bottom = height - 1;
    for(; top < height && $ac0967381ecb4c0f$var$checkRow(data, width, top);)++top;
    if (top === height) return (0, $82d36c4da6e0db49$export$63080c4de6cfc362).EMPTY;
    for(; $ac0967381ecb4c0f$var$checkRow(data, width, bottom);)--bottom;
    for(; $ac0967381ecb4c0f$var$checkColumn(data, width, left, top, bottom);)++left;
    for(; $ac0967381ecb4c0f$var$checkColumn(data, width, right, top, bottom);)--right;
    return ++right, ++bottom, new (0, $82d36c4da6e0db49$export$63080c4de6cfc362)(left, top, right, bottom);
}



function $64aa443bbb38aa93$export$658947b9914dd428(canvas) {
    const boundingBox = (0, $ac0967381ecb4c0f$export$550eedf6c679837d)(canvas), { width: width, height: height } = boundingBox;
    let data = null;
    if (!boundingBox.isEmpty()) {
        const context = canvas.getContext("2d");
        if (context === null) throw new TypeError("Failed to get canvas 2D context");
        data = context.getImageData(boundingBox.left, boundingBox.top, width, height);
    }
    return {
        width: width,
        height: height,
        data: data
    };
}



function $cd2cb2555233f877$export$672224f9983ff723(dataUri) {
    const dataUriMatch = (0, $bfcd1d022c72cb12$export$dbafa72958753fce).exec(dataUri);
    if (dataUriMatch) return {
        mediaType: dataUriMatch[1] ? dataUriMatch[1].toLowerCase() : void 0,
        subType: dataUriMatch[2] ? dataUriMatch[2].toLowerCase() : void 0,
        charset: dataUriMatch[3] ? dataUriMatch[3].toLowerCase() : void 0,
        encoding: dataUriMatch[4] ? dataUriMatch[4].toLowerCase() : void 0,
        data: dataUriMatch[5]
    };
}


function $4e976dc7290fc1f8$export$292083da55c5b406(url, loc = globalThis.location) {
    if (url.startsWith("data:")) return "";
    loc = loc || globalThis.location;
    const parsedUrl = new URL(url, document.baseURI);
    return parsedUrl.hostname !== loc.hostname || parsedUrl.port !== loc.port || parsedUrl.protocol !== loc.protocol ? "anonymous" : "";
}




function $2afed8ad033adf62$export$8695ab2f322d2637(url, defaultValue = 1) {
    const resolution = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).RETINA_PREFIX?.exec(url);
    return resolution ? parseFloat(resolution[1]) : defaultValue;
}








var $69f9a88446c99188$export$4f037c6ec2da4eeb = /* @__PURE__ */ ((ExtensionType2)=>(ExtensionType2.Renderer = "renderer", ExtensionType2.Application = "application", ExtensionType2.RendererSystem = "renderer-webgl-system", ExtensionType2.RendererPlugin = "renderer-webgl-plugin", ExtensionType2.CanvasRendererSystem = "renderer-canvas-system", ExtensionType2.CanvasRendererPlugin = "renderer-canvas-plugin", ExtensionType2.Asset = "asset", ExtensionType2.LoadParser = "load-parser", ExtensionType2.ResolveParser = "resolve-parser", ExtensionType2.CacheParser = "cache-parser", ExtensionType2.DetectionParser = "detection-parser", ExtensionType2))($69f9a88446c99188$export$4f037c6ec2da4eeb || {});
const $69f9a88446c99188$var$normalizeExtension = (ext)=>{
    if (typeof ext == "function" || typeof ext == "object" && ext.extension) {
        if (!ext.extension) throw new Error("Extension class must have an extension object");
        ext = {
            ...typeof ext.extension != "object" ? {
                type: ext.extension
            } : ext.extension,
            ref: ext
        };
    }
    if (typeof ext == "object") ext = {
        ...ext
    };
    else throw new Error("Invalid extension type");
    return typeof ext.type == "string" && (ext.type = [
        ext.type
    ]), ext;
}, $69f9a88446c99188$var$normalizePriority = (ext, defaultPriority)=>$69f9a88446c99188$var$normalizeExtension(ext).priority ?? defaultPriority, $69f9a88446c99188$export$cc3e2d3244e01b7f = {
    /** @ignore */ _addHandlers: {},
    /** @ignore */ _removeHandlers: {},
    /** @ignore */ _queue: {},
    /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed.
   * @returns {PIXI.extensions} For chaining.
   */ remove (...extensions2) {
        return extensions2.map($69f9a88446c99188$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>this._removeHandlers[type]?.(ext));
        }), this;
    },
    /**
   * Register new extensions with PixiJS.
   * @param extensions - The spread of extensions to add to PixiJS.
   * @returns {PIXI.extensions} For chaining.
   */ add (...extensions2) {
        return extensions2.map($69f9a88446c99188$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>{
                const handlers = this._addHandlers, queue = this._queue;
                handlers[type] ? handlers[type](ext) : (queue[type] = queue[type] || [], queue[type].push(ext));
            });
        }), this;
    },
    /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function for handling when extensions are added/registered passes {@link PIXI.ExtensionFormat}.
   * @param onRemove  - Function for handling when extensions are removed/unregistered passes {@link PIXI.ExtensionFormat}.
   * @returns {PIXI.extensions} For chaining.
   */ handle (type, onAdd, onRemove) {
        const addHandlers = this._addHandlers, removeHandlers = this._removeHandlers;
        if (addHandlers[type] || removeHandlers[type]) throw new Error(`Extension type ${type} already has a handler`);
        addHandlers[type] = onAdd, removeHandlers[type] = onRemove;
        const queue = this._queue;
        return queue[type] && (queue[type].forEach((ext)=>onAdd(ext)), delete queue[type]), this;
    },
    /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns {PIXI.extensions} For chaining.
   */ handleByMap (type, map) {
        return this.handle(type, (extension)=>{
            map[extension.name] = extension.ref;
        }, (extension)=>{
            delete map[extension.name];
        });
    },
    /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns {PIXI.extensions} For chaining.
   */ handleByList (type, list, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            list.includes(extension.ref) || (list.push(extension.ref), list.sort((a, b)=>$69f9a88446c99188$var$normalizePriority(b, defaultPriority) - $69f9a88446c99188$var$normalizePriority(a, defaultPriority)));
        }, (extension)=>{
            const index = list.indexOf(extension.ref);
            index !== -1 && list.splice(index, 1);
        });
    }
};




class $91d9b5ed0541dc7e$export$4fdbf0662aa3047a {
    constructor(sizeOrBuffer){
        typeof sizeOrBuffer == "number" ? this.rawBinaryData = new ArrayBuffer(sizeOrBuffer) : sizeOrBuffer instanceof Uint8Array ? this.rawBinaryData = sizeOrBuffer.buffer : this.rawBinaryData = sizeOrBuffer, this.uint32View = new Uint32Array(this.rawBinaryData), this.float32View = new Float32Array(this.rawBinaryData);
    }
    /** View on the raw binary data as a `Int8Array`. */ get int8View() {
        return this._int8View || (this._int8View = new Int8Array(this.rawBinaryData)), this._int8View;
    }
    /** View on the raw binary data as a `Uint8Array`. */ get uint8View() {
        return this._uint8View || (this._uint8View = new Uint8Array(this.rawBinaryData)), this._uint8View;
    }
    /**  View on the raw binary data as a `Int16Array`. */ get int16View() {
        return this._int16View || (this._int16View = new Int16Array(this.rawBinaryData)), this._int16View;
    }
    /** View on the raw binary data as a `Uint16Array`. */ get uint16View() {
        return this._uint16View || (this._uint16View = new Uint16Array(this.rawBinaryData)), this._uint16View;
    }
    /** View on the raw binary data as a `Int32Array`. */ get int32View() {
        return this._int32View || (this._int32View = new Int32Array(this.rawBinaryData)), this._int32View;
    }
    /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */ view(type) {
        return this[`${type}View`];
    }
    /** Destroys all buffer references. Do not use after calling this. */ destroy() {
        this.rawBinaryData = null, this._int8View = null, this._uint8View = null, this._int16View = null, this._uint16View = null, this._int32View = null, this.uint32View = null, this.float32View = null;
    }
    static sizeOf(type) {
        switch(type){
            case "int8":
            case "uint8":
                return 1;
            case "int16":
            case "uint16":
                return 2;
            case "int32":
            case "uint32":
            case "float32":
                return 4;
            default:
                throw new Error(`${type} isn't a valid view type`);
        }
    }
}


const $8f69ead8a5e1d6ee$var$fragTemplate = [
    "precision mediump float;",
    "void main(void){",
    "float test = 0.1;",
    "%forloop%",
    "gl_FragColor = vec4(0.0);",
    "}"
].join(`
`);
function $8f69ead8a5e1d6ee$var$generateIfTestSrc(maxIfs) {
    let src = "";
    for(let i = 0; i < maxIfs; ++i)i > 0 && (src += `
else `), i < maxIfs - 1 && (src += `if(test == ${i}.0){}`);
    return src;
}
function $8f69ead8a5e1d6ee$export$fb6ad4e758d74cc0(maxIfs, gl) {
    if (maxIfs === 0) throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
    const shader = gl.createShader(gl.FRAGMENT_SHADER);
    for(;;){
        const fragmentSrc = $8f69ead8a5e1d6ee$var$fragTemplate.replace(/%forloop%/gi, $8f69ead8a5e1d6ee$var$generateIfTestSrc(maxIfs));
        if (gl.shaderSource(shader, fragmentSrc), gl.compileShader(shader), !gl.getShaderParameter(shader, gl.COMPILE_STATUS)) maxIfs = maxIfs / 2 | 0;
        else break;
    }
    return maxIfs;
}



const $05d0e9a749f67df1$var$BLEND = 0, $05d0e9a749f67df1$var$OFFSET = 1, $05d0e9a749f67df1$var$CULLING = 2, $05d0e9a749f67df1$var$DEPTH_TEST = 3, $05d0e9a749f67df1$var$WINDING = 4, $05d0e9a749f67df1$var$DEPTH_MASK = 5;
class $05d0e9a749f67df1$export$7254cc27399e90bd {
    constructor(){
        this.data = 0, this.blendMode = (0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).NORMAL, this.polygonOffset = 0, this.blend = !0, this.depthMask = !0;
    }
    /**
   * Activates blending of the computed fragment color values.
   * @default true
   */ get blend() {
        return !!(this.data & 1 << $05d0e9a749f67df1$var$BLEND);
    }
    set blend(value) {
        !!(this.data & 1 << $05d0e9a749f67df1$var$BLEND) !== value && (this.data ^= 1 << $05d0e9a749f67df1$var$BLEND);
    }
    /**
   * Activates adding an offset to depth values of polygon's fragments
   * @default false
   */ get offsets() {
        return !!(this.data & 1 << $05d0e9a749f67df1$var$OFFSET);
    }
    set offsets(value) {
        !!(this.data & 1 << $05d0e9a749f67df1$var$OFFSET) !== value && (this.data ^= 1 << $05d0e9a749f67df1$var$OFFSET);
    }
    /**
   * Activates culling of polygons.
   * @default false
   */ get culling() {
        return !!(this.data & 1 << $05d0e9a749f67df1$var$CULLING);
    }
    set culling(value) {
        !!(this.data & 1 << $05d0e9a749f67df1$var$CULLING) !== value && (this.data ^= 1 << $05d0e9a749f67df1$var$CULLING);
    }
    /**
   * Activates depth comparisons and updates to the depth buffer.
   * @default false
   */ get depthTest() {
        return !!(this.data & 1 << $05d0e9a749f67df1$var$DEPTH_TEST);
    }
    set depthTest(value) {
        !!(this.data & 1 << $05d0e9a749f67df1$var$DEPTH_TEST) !== value && (this.data ^= 1 << $05d0e9a749f67df1$var$DEPTH_TEST);
    }
    /**
   * Enables or disables writing to the depth buffer.
   * @default true
   */ get depthMask() {
        return !!(this.data & 1 << $05d0e9a749f67df1$var$DEPTH_MASK);
    }
    set depthMask(value) {
        !!(this.data & 1 << $05d0e9a749f67df1$var$DEPTH_MASK) !== value && (this.data ^= 1 << $05d0e9a749f67df1$var$DEPTH_MASK);
    }
    /**
   * Specifies whether or not front or back-facing polygons can be culled.
   * @default false
   */ get clockwiseFrontFace() {
        return !!(this.data & 1 << $05d0e9a749f67df1$var$WINDING);
    }
    set clockwiseFrontFace(value) {
        !!(this.data & 1 << $05d0e9a749f67df1$var$WINDING) !== value && (this.data ^= 1 << $05d0e9a749f67df1$var$WINDING);
    }
    /**
   * The blend mode to be applied when this state is set. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
   * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
   * @default PIXI.BLEND_MODES.NORMAL
   */ get blendMode() {
        return this._blendMode;
    }
    set blendMode(value) {
        this.blend = value !== (0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).NONE, this._blendMode = value;
    }
    /**
   * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
   * @default 0
   */ get polygonOffset() {
        return this._polygonOffset;
    }
    set polygonOffset(value) {
        this.offsets = !!value, this._polygonOffset = value;
    }
    static for2d() {
        const state = new $05d0e9a749f67df1$export$7254cc27399e90bd();
        return state.depthTest = !1, state.blend = !0, state;
    }
}
$05d0e9a749f67df1$export$7254cc27399e90bd.prototype.toString = function() {
    return `[@pixi/core:State blendMode=${this.blendMode} clockwiseFrontFace=${this.clockwiseFrontFace} culling=${this.culling} depthMask=${this.depthMask} polygonOffset=${this.polygonOffset}]`;
};





const $661901148c1d956b$export$7db5d8a07d9761e1 = [];
function $661901148c1d956b$export$5eb9e949a7ff46a7(source, options) {
    if (!source) return null;
    let extension = "";
    if (typeof source == "string") {
        const result = /\.(\w{3,4})(?:$|\?|#)/i.exec(source);
        result && (extension = result[1].toLowerCase());
    }
    for(let i = $661901148c1d956b$export$7db5d8a07d9761e1.length - 1; i >= 0; --i){
        const ResourcePlugin = $661901148c1d956b$export$7db5d8a07d9761e1[i];
        if (ResourcePlugin.test && ResourcePlugin.test(source, extension)) return new ResourcePlugin(source, options);
    }
    throw new Error("Unrecognized source type to auto-detect Resource");
}



class $e0a754815d73db73$export$571ad3bcba5a0c45 {
    /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */ constructor(name){
        this.items = [], this._name = name, this._aliasCount = 0;
    }
    /* eslint-disable jsdoc/require-param, jsdoc/check-param-names */ /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */ /*  eslint-enable jsdoc/require-param, jsdoc/check-param-names */ emit(a0, a1, a2, a3, a4, a5, a6, a7) {
        if (arguments.length > 8) throw new Error("max arguments reached");
        const { name: name, items: items } = this;
        this._aliasCount++;
        for(let i = 0, len = items.length; i < len; i++)items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
        return items === this.items && this._aliasCount--, this;
    }
    ensureNonAliasedItems() {
        this._aliasCount > 0 && this.items.length > 1 && (this._aliasCount = 0, this.items = this.items.slice(0));
    }
    /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * E.g. A listener passed to this Runner will require a 'complete' function.
   *
   * ```js
   * import { Runner } from '@pixi/runner';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */ add(item) {
        return item[this._name] && (this.ensureNonAliasedItems(), this.remove(item), this.items.push(item)), this;
    }
    /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */ remove(item) {
        const index = this.items.indexOf(item);
        return index !== -1 && (this.ensureNonAliasedItems(), this.items.splice(index, 1)), this;
    }
    /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */ contains(item) {
        return this.items.includes(item);
    }
    /** Remove all listeners from the Runner */ removeAll() {
        return this.ensureNonAliasedItems(), this.items.length = 0, this;
    }
    /** Remove all references, don't use after this. */ destroy() {
        this.removeAll(), this.items = null, this._name = null;
    }
    /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */ get empty() {
        return this.items.length === 0;
    }
    /**
   * The name of the runner.
   * @readonly
   */ get name() {
        return this._name;
    }
}
Object.defineProperties($e0a754815d73db73$export$571ad3bcba5a0c45.prototype, {
    /**
   * Alias for `emit`
   * @memberof PIXI.Runner#
   * @method dispatch
   * @see PIXI.Runner#emit
   */ dispatch: {
        value: $e0a754815d73db73$export$571ad3bcba5a0c45.prototype.emit
    },
    /**
   * Alias for `emit`
   * @memberof PIXI.Runner#
   * @method run
   * @see PIXI.Runner#emit
   */ run: {
        value: $e0a754815d73db73$export$571ad3bcba5a0c45.prototype.emit
    }
});




class $6049fedc760de0ea$export$39a853cfb5a94a63 {
    /**
   * @param width - Width of the resource
   * @param height - Height of the resource
   */ constructor(width = 0, height = 0){
        this._width = width, this._height = height, this.destroyed = !1, this.internal = !1, this.onResize = new (0, $e0a754815d73db73$export$571ad3bcba5a0c45)("setRealSize"), this.onUpdate = new (0, $e0a754815d73db73$export$571ad3bcba5a0c45)("update"), this.onError = new (0, $e0a754815d73db73$export$571ad3bcba5a0c45)("onError");
    }
    /**
   * Bind to a parent BaseTexture
   * @param baseTexture - Parent texture
   */ bind(baseTexture) {
        this.onResize.add(baseTexture), this.onUpdate.add(baseTexture), this.onError.add(baseTexture), (this._width || this._height) && this.onResize.emit(this._width, this._height);
    }
    /**
   * Unbind to a parent BaseTexture
   * @param baseTexture - Parent texture
   */ unbind(baseTexture) {
        this.onResize.remove(baseTexture), this.onUpdate.remove(baseTexture), this.onError.remove(baseTexture);
    }
    /**
   * Trigger a resize event
   * @param width - X dimension
   * @param height - Y dimension
   */ resize(width, height) {
        (width !== this._width || height !== this._height) && (this._width = width, this._height = height, this.onResize.emit(width, height));
    }
    /**
   * Has been validated
   * @readonly
   */ get valid() {
        return !!this._width && !!this._height;
    }
    /** Has been updated trigger event. */ update() {
        this.destroyed || this.onUpdate.emit();
    }
    /**
   * This can be overridden to start preloading a resource
   * or do any other prepare step.
   * @protected
   * @returns Handle the validate event
   */ load() {
        return Promise.resolve(this);
    }
    /**
   * The width of the resource.
   * @readonly
   */ get width() {
        return this._width;
    }
    /**
   * The height of the resource.
   * @readonly
   */ get height() {
        return this._height;
    }
    /**
   * Set the style, optional to override
   * @param _renderer - yeah, renderer!
   * @param _baseTexture - the texture
   * @param _glTexture - texture instance for this webgl context
   * @returns - `true` is success
   */ style(_renderer, _baseTexture, _glTexture) {
        return !1;
    }
    /** Clean up anything, this happens when destroying is ready. */ dispose() {}
    /**
   * Call when destroying resource, unbind any BaseTexture object
   * before calling this method, as reference counts are maintained
   * internally.
   */ destroy() {
        this.destroyed || (this.destroyed = !0, this.dispose(), this.onError.removeAll(), this.onError = null, this.onResize.removeAll(), this.onResize = null, this.onUpdate.removeAll(), this.onUpdate = null);
    }
    /**
   * Abstract, used to auto-detect resource type.
   * @param {*} _source - The source object
   * @param {string} _extension - The extension of source, if set
   */ static test(_source, _extension) {
        return !1;
    }
}


class $967525537d2ce935$export$a79ef781de624449 extends (0, $6049fedc760de0ea$export$39a853cfb5a94a63) {
    /**
   * @param source - Source buffer
   * @param options - Options
   * @param {number} options.width - Width of the texture
   * @param {number} options.height - Height of the texture
   * @param {1|2|4|8} [options.unpackAlignment=4] - The alignment of the pixel rows.
   */ constructor(source, options){
        const { width: width, height: height } = options || {};
        if (!width || !height) throw new Error("BufferResource width or height invalid");
        super(width, height), this.data = source, this.unpackAlignment = options.unpackAlignment ?? 4;
    }
    /**
   * Upload the texture to the GPU.
   * @param renderer - Upload to the renderer
   * @param baseTexture - Reference to parent texture
   * @param glTexture - glTexture
   * @returns - true is success
   */ upload(renderer, baseTexture, glTexture) {
        const gl = renderer.gl;
        gl.pixelStorei(gl.UNPACK_ALIGNMENT, this.unpackAlignment), gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.alphaMode === (0, $5912637ee8cf8b9f$export$d56550d454401b73).UNPACK);
        const width = baseTexture.realWidth, height = baseTexture.realHeight;
        return glTexture.width === width && glTexture.height === height ? gl.texSubImage2D(baseTexture.target, 0, 0, 0, width, height, baseTexture.format, glTexture.type, this.data) : (glTexture.width = width, glTexture.height = height, gl.texImage2D(baseTexture.target, 0, glTexture.internalFormat, width, height, 0, baseTexture.format, glTexture.type, this.data)), !0;
    }
    /** Destroy and don't use after this. */ dispose() {
        this.data = null;
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if buffer source
   */ static test(source) {
        return source === null || source instanceof Int8Array || source instanceof Uint8Array || source instanceof Uint8ClampedArray || source instanceof Int16Array || source instanceof Uint16Array || source instanceof Int32Array || source instanceof Uint32Array || source instanceof Float32Array;
    }
}



const $997b0e421c4045eb$var$defaultBufferOptions = {
    scaleMode: (0, $5912637ee8cf8b9f$export$6b734c6a0bba8473).NEAREST,
    alphaMode: (0, $5912637ee8cf8b9f$export$d56550d454401b73).NPM
}, $997b0e421c4045eb$var$_BaseTexture = class _BaseTexture2 extends (0, (/*@__PURE__*/$parcel$interopDefault($d82ec76d702398f8$exports))) {
    /**
   * @param {PIXI.Resource|HTMLImageElement|HTMLVideoElement|ImageBitmap|ICanvas|string} [resource=null] -
   *        The current resource to use, for things that aren't Resource objects, will be converted
   *        into a Resource.
   * @param options - Collection of options, default options inherited from {@link PIXI.BaseTexture.defaultOptions}.
   * @param {PIXI.MIPMAP_MODES} [options.mipmap] - If mipmapping is enabled for texture
   * @param {number} [options.anisotropicLevel] - Anisotropic filtering level of texture
   * @param {PIXI.WRAP_MODES} [options.wrapMode] - Wrap mode for textures
   * @param {PIXI.SCALE_MODES} [options.scaleMode] - Default scale mode, linear, nearest
   * @param {PIXI.FORMATS} [options.format] - GL format type
   * @param {PIXI.TYPES} [options.type] - GL data type
   * @param {PIXI.TARGETS} [options.target] - GL texture target
   * @param {PIXI.ALPHA_MODES} [options.alphaMode] - Pre multiply the image alpha
   * @param {number} [options.width=0] - Width of the texture
   * @param {number} [options.height=0] - Height of the texture
   * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - Resolution of the base texture
   * @param {object} [options.resourceOptions] - Optional resource options,
   *        see {@link PIXI.autoDetectResource autoDetectResource}
   */ constructor(resource = null, options = null){
        super(), options = Object.assign({}, _BaseTexture2.defaultOptions, options);
        const { alphaMode: alphaMode, mipmap: mipmap, anisotropicLevel: anisotropicLevel, scaleMode: scaleMode, width: width, height: height, wrapMode: wrapMode, format: format, type: type, target: target, resolution: resolution, resourceOptions: resourceOptions } = options;
        resource && !(resource instanceof (0, $6049fedc760de0ea$export$39a853cfb5a94a63)) && (resource = (0, $661901148c1d956b$export$5eb9e949a7ff46a7)(resource, resourceOptions), resource.internal = !0), this.resolution = resolution || (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).RESOLUTION, this.width = Math.round((width || 0) * this.resolution) / this.resolution, this.height = Math.round((height || 0) * this.resolution) / this.resolution, this._mipmap = mipmap, this.anisotropicLevel = anisotropicLevel, this._wrapMode = wrapMode, this._scaleMode = scaleMode, this.format = format, this.type = type, this.target = target, this.alphaMode = alphaMode, this.uid = (0, $4f05e7b7511900ff$export$e2a22331486dcca0)(), this.touched = 0, this.isPowerOfTwo = !1, this._refreshPOT(), this._glTextures = {}, this.dirtyId = 0, this.dirtyStyleId = 0, this.cacheId = null, this.valid = width > 0 && height > 0, this.textureCacheIds = [], this.destroyed = !1, this.resource = null, this._batchEnabled = 0, this._batchLocation = 0, this.parentTextureArray = null, this.setResource(resource);
    }
    /**
   * Pixel width of the source of this texture
   * @readonly
   */ get realWidth() {
        return Math.round(this.width * this.resolution);
    }
    /**
   * Pixel height of the source of this texture
   * @readonly
   */ get realHeight() {
        return Math.round(this.height * this.resolution);
    }
    /**
   * Mipmap mode of the texture, affects downscaled images
   * @default PIXI.MIPMAP_MODES.POW2
   */ get mipmap() {
        return this._mipmap;
    }
    set mipmap(value) {
        this._mipmap !== value && (this._mipmap = value, this.dirtyStyleId++);
    }
    /**
   * The scale mode to apply when scaling this texture
   * @default PIXI.SCALE_MODES.LINEAR
   */ get scaleMode() {
        return this._scaleMode;
    }
    set scaleMode(value) {
        this._scaleMode !== value && (this._scaleMode = value, this.dirtyStyleId++);
    }
    /**
   * How the texture wraps
   * @default PIXI.WRAP_MODES.CLAMP
   */ get wrapMode() {
        return this._wrapMode;
    }
    set wrapMode(value) {
        this._wrapMode !== value && (this._wrapMode = value, this.dirtyStyleId++);
    }
    /**
   * Changes style options of BaseTexture
   * @param scaleMode - Pixi scalemode
   * @param mipmap - enable mipmaps
   * @returns - this
   */ setStyle(scaleMode, mipmap) {
        let dirty;
        return scaleMode !== void 0 && scaleMode !== this.scaleMode && (this.scaleMode = scaleMode, dirty = !0), mipmap !== void 0 && mipmap !== this.mipmap && (this.mipmap = mipmap, dirty = !0), dirty && this.dirtyStyleId++, this;
    }
    /**
   * Changes w/h/resolution. Texture becomes valid if width and height are greater than zero.
   * @param desiredWidth - Desired visual width
   * @param desiredHeight - Desired visual height
   * @param resolution - Optionally set resolution
   * @returns - this
   */ setSize(desiredWidth, desiredHeight, resolution) {
        return resolution = resolution || this.resolution, this.setRealSize(desiredWidth * resolution, desiredHeight * resolution, resolution);
    }
    /**
   * Sets real size of baseTexture, preserves current resolution.
   * @param realWidth - Full rendered width
   * @param realHeight - Full rendered height
   * @param resolution - Optionally set resolution
   * @returns - this
   */ setRealSize(realWidth, realHeight, resolution) {
        return this.resolution = resolution || this.resolution, this.width = Math.round(realWidth) / this.resolution, this.height = Math.round(realHeight) / this.resolution, this._refreshPOT(), this.update(), this;
    }
    /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */ _refreshPOT() {
        this.isPowerOfTwo = (0, $1101e8b3767a1e48$export$eb50b9c078eb6ae7)(this.realWidth) && (0, $1101e8b3767a1e48$export$eb50b9c078eb6ae7)(this.realHeight);
    }
    /**
   * Changes resolution
   * @param resolution - res
   * @returns - this
   */ setResolution(resolution) {
        const oldResolution = this.resolution;
        return oldResolution === resolution ? this : (this.resolution = resolution, this.valid && (this.width = Math.round(this.width * oldResolution) / resolution, this.height = Math.round(this.height * oldResolution) / resolution, this.emit("update", this)), this._refreshPOT(), this);
    }
    /**
   * Sets the resource if it wasn't set. Throws error if resource already present
   * @param resource - that is managing this BaseTexture
   * @returns - this
   */ setResource(resource) {
        if (this.resource === resource) return this;
        if (this.resource) throw new Error("Resource can be set only once");
        return resource.bind(this), this.resource = resource, this;
    }
    /** Invalidates the object. Texture becomes valid if width and height are greater than zero. */ update() {
        this.valid ? (this.dirtyId++, this.dirtyStyleId++, this.emit("update", this)) : this.width > 0 && this.height > 0 && (this.valid = !0, this.emit("loaded", this), this.emit("update", this));
    }
    /**
   * Handle errors with resources.
   * @private
   * @param event - Error event emitted.
   */ onError(event) {
        this.emit("error", this, event);
    }
    /**
   * Destroys this base texture.
   * The method stops if resource doesn't want this texture to be destroyed.
   * Removes texture from all caches.
   * @fires PIXI.BaseTexture#destroyed
   */ destroy() {
        this.resource && (this.resource.unbind(this), this.resource.internal && this.resource.destroy(), this.resource = null), this.cacheId && (delete (0, $e0cc893a6896296f$export$cec649a143d060b1)[this.cacheId], delete (0, $e0cc893a6896296f$export$4254ab7c0971430e)[this.cacheId], this.cacheId = null), this.valid = !1, this.dispose(), _BaseTexture2.removeFromCache(this), this.textureCacheIds = null, this.destroyed = !0, this.emit("destroyed", this), this.removeAllListeners();
    }
    /**
   * Frees the texture from WebGL memory without destroying this texture object.
   * This means you can still use the texture later which will upload it to GPU
   * memory again.
   * @fires PIXI.BaseTexture#dispose
   */ dispose() {
        this.emit("dispose", this);
    }
    /** Utility function for BaseTexture|Texture cast. */ castToBaseTexture() {
        return this;
    }
    /**
   * Helper function that creates a base texture based on the source you provide.
   * The source can be - image url, image element, canvas element. If the
   * source is an image url or an image element and not in the base texture
   * cache, it will be created and loaded.
   * @static
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas|string|string[]} source - The
   *        source to create base texture from.
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   * @param {string} [options.pixiIdPrefix=pixiid] - If a source has no id, this is the prefix of the generated id
   * @param {boolean} [strict] - Enforce strict-mode, see {@link PIXI.settings.STRICT_TEXTURE_CACHE}.
   * @returns {PIXI.BaseTexture} The new base texture.
   */ static from(source, options, strict = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).STRICT_TEXTURE_CACHE) {
        const isFrame = typeof source == "string";
        let cacheId = null;
        if (isFrame) cacheId = source;
        else {
            if (!source._pixiId) {
                const prefix = options?.pixiIdPrefix || "pixiid";
                source._pixiId = `${prefix}_${(0, $4f05e7b7511900ff$export$e2a22331486dcca0)()}`;
            }
            cacheId = source._pixiId;
        }
        let baseTexture = (0, $e0cc893a6896296f$export$cec649a143d060b1)[cacheId];
        if (isFrame && strict && !baseTexture) throw new Error(`The cacheId "${cacheId}" does not exist in BaseTextureCache.`);
        return baseTexture || (baseTexture = new _BaseTexture2(source, options), baseTexture.cacheId = cacheId, _BaseTexture2.addToCache(baseTexture, cacheId)), baseTexture;
    }
    /**
   * Create a new Texture with a BufferResource from a typed array.
   * @param buffer - The optional array to use. If no data is provided, a new Float32Array is created.
   * @param width - Width of the resource
   * @param height - Height of the resource
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   *        Default properties are different from the constructor's defaults.
   * @param {PIXI.FORMATS} [options.format] - The format is not given, the type is inferred from the
   *        type of the buffer: `RGBA` if Float32Array, Int8Array, Uint8Array, or Uint8ClampedArray,
   *        otherwise `RGBA_INTEGER`.
   * @param {PIXI.TYPES} [options.type] - The type is not given, the type is inferred from the
   *        type of the buffer. Maps Float32Array to `FLOAT`, Int32Array to `INT`, Uint32Array to
   *        `UNSIGNED_INT`, Int16Array to `SHORT`, Uint16Array to `UNSIGNED_SHORT`, Int8Array to `BYTE`,
   *        Uint8Array/Uint8ClampedArray to `UNSIGNED_BYTE`.
   * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.NPM]
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.SCALE_MODES.NEAREST]
   * @returns - The resulting new BaseTexture
   */ static fromBuffer(buffer, width, height, options) {
        buffer = buffer || new Float32Array(width * height * 4);
        const resource = new (0, $967525537d2ce935$export$a79ef781de624449)(buffer, {
            width: width,
            height: height,
            ...options?.resourceOptions
        });
        let format, type;
        return buffer instanceof Float32Array ? (format = (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA, type = (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).FLOAT) : buffer instanceof Int32Array ? (format = (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA_INTEGER, type = (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).INT) : buffer instanceof Uint32Array ? (format = (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA_INTEGER, type = (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_INT) : buffer instanceof Int16Array ? (format = (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA_INTEGER, type = (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).SHORT) : buffer instanceof Uint16Array ? (format = (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA_INTEGER, type = (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_SHORT) : buffer instanceof Int8Array ? (format = (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA, type = (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).BYTE) : (format = (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA, type = (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_BYTE), resource.internal = !0, new _BaseTexture2(resource, Object.assign({}, $997b0e421c4045eb$var$defaultBufferOptions, {
            type: type,
            format: format
        }, options));
    }
    /**
   * Adds a BaseTexture to the global BaseTextureCache. This cache is shared across the whole PIXI object.
   * @param {PIXI.BaseTexture} baseTexture - The BaseTexture to add to the cache.
   * @param {string} id - The id that the BaseTexture will be stored against.
   */ static addToCache(baseTexture, id) {
        id && (baseTexture.textureCacheIds.includes(id) || baseTexture.textureCacheIds.push(id), (0, $e0cc893a6896296f$export$cec649a143d060b1)[id] && (0, $e0cc893a6896296f$export$cec649a143d060b1)[id] !== baseTexture && console.warn(`BaseTexture added to the cache with an id [${id}] that already had an entry`), (0, $e0cc893a6896296f$export$cec649a143d060b1)[id] = baseTexture);
    }
    /**
   * Remove a BaseTexture from the global BaseTextureCache.
   * @param {string|PIXI.BaseTexture} baseTexture - id of a BaseTexture to be removed, or a BaseTexture instance itself.
   * @returns {PIXI.BaseTexture|null} The BaseTexture that was removed.
   */ static removeFromCache(baseTexture) {
        if (typeof baseTexture == "string") {
            const baseTextureFromCache = (0, $e0cc893a6896296f$export$cec649a143d060b1)[baseTexture];
            if (baseTextureFromCache) {
                const index = baseTextureFromCache.textureCacheIds.indexOf(baseTexture);
                return index > -1 && baseTextureFromCache.textureCacheIds.splice(index, 1), delete (0, $e0cc893a6896296f$export$cec649a143d060b1)[baseTexture], baseTextureFromCache;
            }
        } else if (baseTexture?.textureCacheIds) {
            for(let i = 0; i < baseTexture.textureCacheIds.length; ++i)delete (0, $e0cc893a6896296f$export$cec649a143d060b1)[baseTexture.textureCacheIds[i]];
            return baseTexture.textureCacheIds.length = 0, baseTexture;
        }
        return null;
    }
};
$997b0e421c4045eb$var$_BaseTexture.defaultOptions = {
    /**
   * If mipmapping is enabled for texture.
   * @type {PIXI.MIPMAP_MODES}
   * @default PIXI.MIPMAP_MODES.POW2
   */ mipmap: (0, $5912637ee8cf8b9f$export$16f6fb5da874bbfd).POW2,
    /** Anisotropic filtering level of texture */ anisotropicLevel: 0,
    /**
   * Default scale mode, linear, nearest.
   * @type {PIXI.SCALE_MODES}
   * @default PIXI.SCALE_MODES.LINEAR
   */ scaleMode: (0, $5912637ee8cf8b9f$export$6b734c6a0bba8473).LINEAR,
    /**
   * Wrap mode for textures.
   * @type {PIXI.WRAP_MODES}
   * @default PIXI.WRAP_MODES.CLAMP
   */ wrapMode: (0, $5912637ee8cf8b9f$export$2ab395cfb0dd2f0f).CLAMP,
    /**
   * Pre multiply the image alpha
   * @type {PIXI.ALPHA_MODES}
   * @default PIXI.ALPHA_MODES.UNPACK
   */ alphaMode: (0, $5912637ee8cf8b9f$export$d56550d454401b73).UNPACK,
    /**
   * GL texture target
   * @type {PIXI.TARGETS}
   * @default PIXI.TARGETS.TEXTURE_2D
   */ target: (0, $5912637ee8cf8b9f$export$d1ff3caf57547dc5).TEXTURE_2D,
    /**
   * GL format type
   * @type {PIXI.FORMATS}
   * @default PIXI.FORMATS.RGBA
   */ format: (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA,
    /**
   * GL data type
   * @type {PIXI.TYPES}
   * @default PIXI.TYPES.UNSIGNED_BYTE
   */ type: (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_BYTE
}, /** Global number of the texture batch, used by multi-texture renderers. */ $997b0e421c4045eb$var$_BaseTexture._globalBatch = 0;
let $997b0e421c4045eb$export$d6306e508f184154 = $997b0e421c4045eb$var$_BaseTexture;



class $3c8543b1b17058da$export$664fd198634fda29 {
    constructor(){
        this.texArray = null, this.blend = 0, this.type = (0, $5912637ee8cf8b9f$export$91100badd8469338).TRIANGLES, this.start = 0, this.size = 0, this.data = null;
    }
}





let $4da95ef50ded5f29$var$UID = 0;
class $4da95ef50ded5f29$export$a143d493d941bafc {
    /**
   * @param {PIXI.IArrayBuffer} data - the data to store in the buffer.
   * @param _static - `true` for static buffer
   * @param index - `true` for index buffer
   */ constructor(data, _static = !0, index = !1){
        this.data = data || new Float32Array(1), this._glBuffers = {}, this._updateID = 0, this.index = index, this.static = _static, this.id = $4da95ef50ded5f29$var$UID++, this.disposeRunner = new (0, $e0a754815d73db73$export$571ad3bcba5a0c45)("disposeBuffer");
    }
    // TODO could explore flagging only a partial upload?
    /**
   * Flags this buffer as requiring an upload to the GPU.
   * @param {PIXI.IArrayBuffer|number[]} [data] - the data to update in the buffer.
   */ update(data) {
        data instanceof Array && (data = new Float32Array(data)), this.data = data || this.data, this._updateID++;
    }
    /** Disposes WebGL resources that are connected to this geometry. */ dispose() {
        this.disposeRunner.emit(this, !1);
    }
    /** Destroys the buffer. */ destroy() {
        this.dispose(), this.data = null;
    }
    /**
   * Flags whether this is an index buffer.
   *
   * Index buffers are of type `ELEMENT_ARRAY_BUFFER`. Note that setting this property to false will make
   * the buffer of type `ARRAY_BUFFER`.
   *
   * For backwards compatibility.
   */ set index(value) {
        this.type = value ? (0, $5912637ee8cf8b9f$export$b595a7e482202b96).ELEMENT_ARRAY_BUFFER : (0, $5912637ee8cf8b9f$export$b595a7e482202b96).ARRAY_BUFFER;
    }
    get index() {
        return this.type === (0, $5912637ee8cf8b9f$export$b595a7e482202b96).ELEMENT_ARRAY_BUFFER;
    }
    /**
   * Helper function that creates a buffer based on an array or TypedArray
   * @param {ArrayBufferView | number[]} data - the TypedArray that the buffer will store. If this is a regular Array it will be converted to a Float32Array.
   * @returns - A new Buffer based on the data provided.
   */ static from(data) {
        return data instanceof Array && (data = new Float32Array(data)), new $4da95ef50ded5f29$export$a143d493d941bafc(data);
    }
}






class $0f0d367ead58ef96$export$ab9c25261cd8c720 {
    /**
   * @param buffer - the id of the buffer that this attribute will look for
   * @param size - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2.
   * @param normalized - should the data be normalized.
   * @param {PIXI.TYPES} [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
   * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
   * @param [start=0] - How far into the array to start reading values (used for interleaving data)
   * @param [instance=false] - Whether the geometry is instanced.
   * @param [divisor=1] - Divisor to use when doing instanced rendering
   */ constructor(buffer, size = 0, normalized = !1, type = (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).FLOAT, stride, start, instance, divisor = 1){
        this.buffer = buffer, this.size = size, this.normalized = normalized, this.type = type, this.stride = stride, this.start = start, this.instance = instance, this.divisor = divisor;
    }
    /** Destroys the Attribute. */ destroy() {
        this.buffer = null;
    }
    /**
   * Helper function that creates an Attribute based on the information provided
   * @param buffer - the id of the buffer that this attribute will look for
   * @param [size=0] - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2
   * @param [normalized=false] - should the data be normalized.
   * @param [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
   * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
   * @returns - A new {@link PIXI.Attribute} based on the information provided
   */ static from(buffer, size, normalized, type, stride) {
        return new $0f0d367ead58ef96$export$ab9c25261cd8c720(buffer, size, normalized, type, stride);
    }
}




const $a2cd7d388fc1851d$var$map = {
    Float32Array: Float32Array,
    Uint32Array: Uint32Array,
    Int32Array: Int32Array,
    Uint8Array: Uint8Array
};
function $a2cd7d388fc1851d$export$1ce3e224e969bb24(arrays, sizes) {
    let outSize = 0, stride = 0;
    const views = {};
    for(let i = 0; i < arrays.length; i++)stride += sizes[i], outSize += arrays[i].length;
    const buffer = new ArrayBuffer(outSize * 4);
    let out = null, littleOffset = 0;
    for(let i = 0; i < arrays.length; i++){
        const size = sizes[i], array = arrays[i], type = (0, $02309e39cc052e17$export$adf72b506413cb57)(array);
        views[type] || (views[type] = new $a2cd7d388fc1851d$var$map[type](buffer)), out = views[type];
        for(let j = 0; j < array.length; j++){
            const indexStart = (j / size | 0) * stride + littleOffset, index = j % size;
            out[indexStart + index] = array[j];
        }
        littleOffset += size;
    }
    return new Float32Array(buffer);
}


const $dd93eefb01cd7345$var$byteSizeMap = {
    5126: 4,
    5123: 2,
    5121: 1
};
let $dd93eefb01cd7345$var$UID = 0;
const $dd93eefb01cd7345$var$map = {
    Float32Array: Float32Array,
    Uint32Array: Uint32Array,
    Int32Array: Int32Array,
    Uint8Array: Uint8Array,
    Uint16Array: Uint16Array
};
class $dd93eefb01cd7345$export$2db6c17465f94a2 {
    /**
   * @param buffers - An array of buffers. optional.
   * @param attributes - Of the geometry, optional structure of the attributes layout
   */ constructor(buffers = [], attributes = {}){
        this.buffers = buffers, this.indexBuffer = null, this.attributes = attributes, this.glVertexArrayObjects = {}, this.id = $dd93eefb01cd7345$var$UID++, this.instanced = !1, this.instanceCount = 1, this.disposeRunner = new (0, $e0a754815d73db73$export$571ad3bcba5a0c45)("disposeGeometry"), this.refCount = 0;
    }
    /**
   *
   * Adds an attribute to the geometry
   * Note: `stride` and `start` should be `undefined` if you dont know them, not 0!
   * @param id - the name of the attribute (matching up to a shader)
   * @param {PIXI.Buffer|number[]} buffer - the buffer that holds the data of the attribute . You can also provide an Array and a buffer will be created from it.
   * @param size - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2
   * @param normalized - should the data be normalized.
   * @param [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
   * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
   * @param [start=0] - How far into the array to start reading values (used for interleaving data)
   * @param instance - Instancing flag
   * @returns - Returns self, useful for chaining.
   */ addAttribute(id, buffer, size = 0, normalized = !1, type, stride, start, instance = !1) {
        if (!buffer) throw new Error("You must pass a buffer when creating an attribute");
        buffer instanceof (0, $4da95ef50ded5f29$export$a143d493d941bafc) || (buffer instanceof Array && (buffer = new Float32Array(buffer)), buffer = new (0, $4da95ef50ded5f29$export$a143d493d941bafc)(buffer));
        const ids = id.split("|");
        if (ids.length > 1) {
            for(let i = 0; i < ids.length; i++)this.addAttribute(ids[i], buffer, size, normalized, type);
            return this;
        }
        let bufferIndex = this.buffers.indexOf(buffer);
        return bufferIndex === -1 && (this.buffers.push(buffer), bufferIndex = this.buffers.length - 1), this.attributes[id] = new (0, $0f0d367ead58ef96$export$ab9c25261cd8c720)(bufferIndex, size, normalized, type, stride, start, instance), this.instanced = this.instanced || instance, this;
    }
    /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */ getAttribute(id) {
        return this.attributes[id];
    }
    /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */ getBuffer(id) {
        return this.buffers[this.getAttribute(id).buffer];
    }
    /**
   *
   * Adds an index buffer to the geometry
   * The index buffer contains integers, three for each triangle in the geometry, which reference the various attribute buffers (position, colour, UV coordinates, other UV coordinates, normal, …). There is only ONE index buffer.
   * @param {PIXI.Buffer|number[]} [buffer] - The buffer that holds the data of the index buffer. You can also provide an Array and a buffer will be created from it.
   * @returns - Returns self, useful for chaining.
   */ addIndex(buffer) {
        return buffer instanceof (0, $4da95ef50ded5f29$export$a143d493d941bafc) || (buffer instanceof Array && (buffer = new Uint16Array(buffer)), buffer = new (0, $4da95ef50ded5f29$export$a143d493d941bafc)(buffer)), buffer.type = (0, $5912637ee8cf8b9f$export$b595a7e482202b96).ELEMENT_ARRAY_BUFFER, this.indexBuffer = buffer, this.buffers.includes(buffer) || this.buffers.push(buffer), this;
    }
    /**
   * Returns the index buffer
   * @returns - The index buffer.
   */ getIndex() {
        return this.indexBuffer;
    }
    /**
   * This function modifies the structure so that all current attributes become interleaved into a single buffer
   * This can be useful if your model remains static as it offers a little performance boost
   * @returns - Returns self, useful for chaining.
   */ interleave() {
        if (this.buffers.length === 1 || this.buffers.length === 2 && this.indexBuffer) return this;
        const arrays = [], sizes = [], interleavedBuffer = new (0, $4da95ef50ded5f29$export$a143d493d941bafc)();
        let i;
        for(i in this.attributes){
            const attribute = this.attributes[i], buffer = this.buffers[attribute.buffer];
            arrays.push(buffer.data), sizes.push(attribute.size * $dd93eefb01cd7345$var$byteSizeMap[attribute.type] / 4), attribute.buffer = 0;
        }
        for(interleavedBuffer.data = (0, $a2cd7d388fc1851d$export$1ce3e224e969bb24)(arrays, sizes), i = 0; i < this.buffers.length; i++)this.buffers[i] !== this.indexBuffer && this.buffers[i].destroy();
        return this.buffers = [
            interleavedBuffer
        ], this.indexBuffer && this.buffers.push(this.indexBuffer), this;
    }
    /** Get the size of the geometries, in vertices. */ getSize() {
        for(const i in this.attributes){
            const attribute = this.attributes[i];
            return this.buffers[attribute.buffer].data.length / (attribute.stride / 4 || attribute.size);
        }
        return 0;
    }
    /** Disposes WebGL resources that are connected to this geometry. */ dispose() {
        this.disposeRunner.emit(this, !1);
    }
    /** Destroys the geometry. */ destroy() {
        this.dispose(), this.buffers = null, this.indexBuffer = null, this.attributes = null;
    }
    /**
   * Returns a clone of the geometry.
   * @returns - A new clone of this geometry.
   */ clone() {
        const geometry = new $dd93eefb01cd7345$export$2db6c17465f94a2();
        for(let i = 0; i < this.buffers.length; i++)geometry.buffers[i] = new (0, $4da95ef50ded5f29$export$a143d493d941bafc)(this.buffers[i].data.slice(0));
        for(const i in this.attributes){
            const attrib = this.attributes[i];
            geometry.attributes[i] = new (0, $0f0d367ead58ef96$export$ab9c25261cd8c720)(attrib.buffer, attrib.size, attrib.normalized, attrib.type, attrib.stride, attrib.start, attrib.instance);
        }
        return this.indexBuffer && (geometry.indexBuffer = geometry.buffers[this.buffers.indexOf(this.indexBuffer)], geometry.indexBuffer.type = (0, $5912637ee8cf8b9f$export$b595a7e482202b96).ELEMENT_ARRAY_BUFFER), geometry;
    }
    /**
   * Merges an array of geometries into a new single one.
   *
   * Geometry attribute styles must match for this operation to work.
   * @param geometries - array of geometries to merge
   * @returns - Shiny new geometry!
   */ static merge(geometries) {
        const geometryOut = new $dd93eefb01cd7345$export$2db6c17465f94a2(), arrays = [], sizes = [], offsets = [];
        let geometry;
        for(let i = 0; i < geometries.length; i++){
            geometry = geometries[i];
            for(let j = 0; j < geometry.buffers.length; j++)sizes[j] = sizes[j] || 0, sizes[j] += geometry.buffers[j].data.length, offsets[j] = 0;
        }
        for(let i = 0; i < geometry.buffers.length; i++)arrays[i] = new $dd93eefb01cd7345$var$map[(0, $02309e39cc052e17$export$adf72b506413cb57)(geometry.buffers[i].data)](sizes[i]), geometryOut.buffers[i] = new (0, $4da95ef50ded5f29$export$a143d493d941bafc)(arrays[i]);
        for(let i = 0; i < geometries.length; i++){
            geometry = geometries[i];
            for(let j = 0; j < geometry.buffers.length; j++)arrays[j].set(geometry.buffers[j].data, offsets[j]), offsets[j] += geometry.buffers[j].data.length;
        }
        if (geometryOut.attributes = geometry.attributes, geometry.indexBuffer) {
            geometryOut.indexBuffer = geometryOut.buffers[geometry.buffers.indexOf(geometry.indexBuffer)], geometryOut.indexBuffer.type = (0, $5912637ee8cf8b9f$export$b595a7e482202b96).ELEMENT_ARRAY_BUFFER;
            let offset = 0, stride = 0, offset2 = 0, bufferIndexToCount = 0;
            for(let i = 0; i < geometry.buffers.length; i++)if (geometry.buffers[i] !== geometry.indexBuffer) {
                bufferIndexToCount = i;
                break;
            }
            for(const i in geometry.attributes){
                const attribute = geometry.attributes[i];
                (attribute.buffer | 0) === bufferIndexToCount && (stride += attribute.size * $dd93eefb01cd7345$var$byteSizeMap[attribute.type] / 4);
            }
            for(let i = 0; i < geometries.length; i++){
                const indexBufferData = geometries[i].indexBuffer.data;
                for(let j = 0; j < indexBufferData.length; j++)geometryOut.indexBuffer.data[j + offset2] += offset;
                offset += geometries[i].buffers[bufferIndexToCount].data.length / stride, offset2 += indexBufferData.length;
            }
        }
        return geometryOut;
    }
}


class $8e8f1d0188b2afc6$export$449e8d355fd68e43 extends (0, $dd93eefb01cd7345$export$2db6c17465f94a2) {
    /**
   * @param {boolean} [_static=false] - Optimization flag, where `false`
   *        is updated every frame, `true` doesn't change frame-to-frame.
   */ constructor(_static = !1){
        super(), this._buffer = new (0, $4da95ef50ded5f29$export$a143d493d941bafc)(null, _static, !1), this._indexBuffer = new (0, $4da95ef50ded5f29$export$a143d493d941bafc)(null, _static, !0), this.addAttribute("aVertexPosition", this._buffer, 2, !1, (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).FLOAT).addAttribute("aTextureCoord", this._buffer, 2, !1, (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).FLOAT).addAttribute("aColor", this._buffer, 4, !0, (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_BYTE).addAttribute("aTextureId", this._buffer, 1, !0, (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).FLOAT).addIndex(this._indexBuffer);
    }
}


const $23fb2779a12001d8$export$59ed0a0a5de1084b = Math.PI * 2, $23fb2779a12001d8$export$3f91627dc85c5d57 = 180 / Math.PI, $23fb2779a12001d8$export$870617f62e3187f1 = Math.PI / 180;
var $23fb2779a12001d8$export$511e1d54a4a8684e = /* @__PURE__ */ ((SHAPES2)=>(SHAPES2[SHAPES2.POLY = 0] = "POLY", SHAPES2[SHAPES2.RECT = 1] = "RECT", SHAPES2[SHAPES2.CIRC = 2] = "CIRC", SHAPES2[SHAPES2.ELIP = 3] = "ELIP", SHAPES2[SHAPES2.RREC = 4] = "RREC", SHAPES2))($23fb2779a12001d8$export$511e1d54a4a8684e || {});



class $c283a5532acdbe2e$export$baf26146a414f24a {
    /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(x = 0, y = 0){
        this.x = 0, this.y = 0, this.x = x, this.y = y;
    }
    /**
   * Creates a clone of this point
   * @returns A clone of this point
   */ clone() {
        return new $c283a5532acdbe2e$export$baf26146a414f24a(this.x, this.y);
    }
    /**
   * Copies `x` and `y` from the given point into this point
   * @param p - The point to copy from
   * @returns The point instance itself
   */ copyFrom(p) {
        return this.set(p.x, p.y), this;
    }
    /**
   * Copies this point's x and y into the given point (`p`).
   * @param p - The point to copy to. Can be any of type that is or extends `IPointData`
   * @returns The point (`p`) with values updated
   */ copyTo(p) {
        return p.set(this.x, this.y), p;
    }
    /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */ equals(p) {
        return p.x === this.x && p.y === this.y;
    }
    /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the `x` axis
   * @param {number} [y=x] - position of the point on the `y` axis
   * @returns The point instance itself
   */ set(x = 0, y = x) {
        return this.x = x, this.y = y, this;
    }
}
$c283a5532acdbe2e$export$baf26146a414f24a.prototype.toString = function() {
    return `[@pixi/math:Point x=${this.x} y=${this.y}]`;
};


const $92248a7cf1facbda$var$tempPoints = [
    new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(),
    new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(),
    new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(),
    new (0, $c283a5532acdbe2e$export$baf26146a414f24a)()
];
class $92248a7cf1facbda$export$4617fb02663045ef {
    /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */ constructor(x = 0, y = 0, width = 0, height = 0){
        this.x = Number(x), this.y = Number(y), this.width = Number(width), this.height = Number(height), this.type = (0, $23fb2779a12001d8$export$511e1d54a4a8684e).RECT;
    }
    /** Returns the left edge of the rectangle. */ get left() {
        return this.x;
    }
    /** Returns the right edge of the rectangle. */ get right() {
        return this.x + this.width;
    }
    /** Returns the top edge of the rectangle. */ get top() {
        return this.y;
    }
    /** Returns the bottom edge of the rectangle. */ get bottom() {
        return this.y + this.height;
    }
    /** A constant empty rectangle. */ static get EMPTY() {
        return new $92248a7cf1facbda$export$4617fb02663045ef(0, 0, 0, 0);
    }
    /**
   * Creates a clone of this Rectangle
   * @returns a copy of the rectangle
   */ clone() {
        return new $92248a7cf1facbda$export$4617fb02663045ef(this.x, this.y, this.width, this.height);
    }
    /**
   * Copies another rectangle to this one.
   * @param rectangle - The rectangle to copy from.
   * @returns Returns itself.
   */ copyFrom(rectangle) {
        return this.x = rectangle.x, this.y = rectangle.y, this.width = rectangle.width, this.height = rectangle.height, this;
    }
    /**
   * Copies this rectangle to another one.
   * @param rectangle - The rectangle to copy to.
   * @returns Returns given parameter.
   */ copyTo(rectangle) {
        return rectangle.x = this.x, rectangle.y = this.y, rectangle.width = this.width, rectangle.height = this.height, rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   */ contains(x, y) {
        return this.width <= 0 || this.height <= 0 ? !1 : x >= this.x && x < this.x + this.width && y >= this.y && y < this.y + this.height;
    }
    /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */ intersects(other, transform) {
        if (!transform) {
            const x02 = this.x < other.x ? other.x : this.x;
            if ((this.right > other.right ? other.right : this.right) <= x02) return !1;
            const y02 = this.y < other.y ? other.y : this.y;
            return (this.bottom > other.bottom ? other.bottom : this.bottom) > y02;
        }
        const x0 = this.left, x1 = this.right, y0 = this.top, y1 = this.bottom;
        if (x1 <= x0 || y1 <= y0) return !1;
        const lt = $92248a7cf1facbda$var$tempPoints[0].set(other.left, other.top), lb = $92248a7cf1facbda$var$tempPoints[1].set(other.left, other.bottom), rt = $92248a7cf1facbda$var$tempPoints[2].set(other.right, other.top), rb = $92248a7cf1facbda$var$tempPoints[3].set(other.right, other.bottom);
        if (rt.x <= lt.x || lb.y <= lt.y) return !1;
        const s = Math.sign(transform.a * transform.d - transform.b * transform.c);
        if (s === 0 || (transform.apply(lt, lt), transform.apply(lb, lb), transform.apply(rt, rt), transform.apply(rb, rb), Math.max(lt.x, lb.x, rt.x, rb.x) <= x0 || Math.min(lt.x, lb.x, rt.x, rb.x) >= x1 || Math.max(lt.y, lb.y, rt.y, rb.y) <= y0 || Math.min(lt.y, lb.y, rt.y, rb.y) >= y1)) return !1;
        const nx = s * (lb.y - lt.y), ny = s * (lt.x - lb.x), n00 = nx * x0 + ny * y0, n10 = nx * x1 + ny * y0, n01 = nx * x0 + ny * y1, n11 = nx * x1 + ny * y1;
        if (Math.max(n00, n10, n01, n11) <= nx * lt.x + ny * lt.y || Math.min(n00, n10, n01, n11) >= nx * rb.x + ny * rb.y) return !1;
        const mx = s * (lt.y - rt.y), my = s * (rt.x - lt.x), m00 = mx * x0 + my * y0, m10 = mx * x1 + my * y0, m01 = mx * x0 + my * y1, m11 = mx * x1 + my * y1;
        return !(Math.max(m00, m10, m01, m11) <= mx * lt.x + my * lt.y || Math.min(m00, m10, m01, m11) >= mx * rb.x + my * rb.y);
    }
    /**
   * Pads the rectangle making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   * @returns Returns itself.
   */ pad(paddingX = 0, paddingY = paddingX) {
        return this.x -= paddingX, this.y -= paddingY, this.width += paddingX * 2, this.height += paddingY * 2, this;
    }
    /**
   * Fits this rectangle around the passed one.
   * @param rectangle - The rectangle to fit.
   * @returns Returns itself.
   */ fit(rectangle) {
        const x1 = Math.max(this.x, rectangle.x), x2 = Math.min(this.x + this.width, rectangle.x + rectangle.width), y1 = Math.max(this.y, rectangle.y), y2 = Math.min(this.y + this.height, rectangle.y + rectangle.height);
        return this.x = x1, this.width = Math.max(x2 - x1, 0), this.y = y1, this.height = Math.max(y2 - y1, 0), this;
    }
    /**
   * Enlarges rectangle that way its corners lie on grid
   * @param resolution - resolution
   * @param eps - precision
   * @returns Returns itself.
   */ ceil(resolution = 1, eps = 1e-3) {
        const x2 = Math.ceil((this.x + this.width - eps) * resolution) / resolution, y2 = Math.ceil((this.y + this.height - eps) * resolution) / resolution;
        return this.x = Math.floor((this.x + eps) * resolution) / resolution, this.y = Math.floor((this.y + eps) * resolution) / resolution, this.width = x2 - this.x, this.height = y2 - this.y, this;
    }
    /**
   * Enlarges this rectangle to include the passed rectangle.
   * @param rectangle - The rectangle to include.
   * @returns Returns itself.
   */ enlarge(rectangle) {
        const x1 = Math.min(this.x, rectangle.x), x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width), y1 = Math.min(this.y, rectangle.y), y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
        return this.x = x1, this.width = x2 - x1, this.y = y1, this.height = y2 - y1, this;
    }
}
$92248a7cf1facbda$export$4617fb02663045ef.prototype.toString = function() {
    return `[@pixi/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
};


class $d8ed8bfcdf19787b$export$c89a927ffc67e6fa {
    /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */ constructor(x = 0, y = 0, radius = 0){
        this.x = x, this.y = y, this.radius = radius, this.type = (0, $23fb2779a12001d8$export$511e1d54a4a8684e).CIRC;
    }
    /**
   * Creates a clone of this Circle instance
   * @returns A copy of the Circle
   */ clone() {
        return new $d8ed8bfcdf19787b$export$c89a927ffc67e6fa(this.x, this.y, this.radius);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   */ contains(x, y) {
        if (this.radius <= 0) return !1;
        const r2 = this.radius * this.radius;
        let dx = this.x - x, dy = this.y - y;
        return dx *= dx, dy *= dy, dx + dy <= r2;
    }
    /**
   * Returns the framing rectangle of the circle as a Rectangle object
   * @returns The framing rectangle
   */ getBounds() {
        return new (0, $92248a7cf1facbda$export$4617fb02663045ef)(this.x - this.radius, this.y - this.radius, this.radius * 2, this.radius * 2);
    }
}
$d8ed8bfcdf19787b$export$c89a927ffc67e6fa.prototype.toString = function() {
    return `[@pixi/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
};




class $60a4773ce5ad46af$export$80b0269ab108fa11 {
    /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */ constructor(x = 0, y = 0, halfWidth = 0, halfHeight = 0){
        this.x = x, this.y = y, this.width = halfWidth, this.height = halfHeight, this.type = (0, $23fb2779a12001d8$export$511e1d54a4a8684e).ELIP;
    }
    /**
   * Creates a clone of this Ellipse instance
   * @returns {PIXI.Ellipse} A copy of the ellipse
   */ clone() {
        return new $60a4773ce5ad46af$export$80b0269ab108fa11(this.x, this.y, this.width, this.height);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return !1;
        let normx = (x - this.x) / this.width, normy = (y - this.y) / this.height;
        return normx *= normx, normy *= normy, normx + normy <= 1;
    }
    /**
   * Returns the framing rectangle of the ellipse as a Rectangle object
   * @returns The framing rectangle
   */ getBounds() {
        return new (0, $92248a7cf1facbda$export$4617fb02663045ef)(this.x - this.width, this.y - this.height, this.width, this.height);
    }
}
$60a4773ce5ad46af$export$80b0269ab108fa11.prototype.toString = function() {
    return `[@pixi/math:Ellipse x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
};



class $c1a49bce64bda319$export$7d31b617c820d435 {
    /**
   * @param {PIXI.IPointData[]|number[]} points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */ constructor(...points){
        let flat = Array.isArray(points[0]) ? points[0] : points;
        if (typeof flat[0] != "number") {
            const p = [];
            for(let i = 0, il = flat.length; i < il; i++)p.push(flat[i].x, flat[i].y);
            flat = p;
        }
        this.points = flat, this.type = (0, $23fb2779a12001d8$export$511e1d54a4a8684e).POLY, this.closeStroke = !0;
    }
    /**
   * Creates a clone of this polygon.
   * @returns - A copy of the polygon.
   */ clone() {
        const points = this.points.slice(), polygon = new $c1a49bce64bda319$export$7d31b617c820d435(points);
        return polygon.closeStroke = this.closeStroke, polygon;
    }
    /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this polygon.
   */ contains(x, y) {
        let inside = !1;
        const length = this.points.length / 2;
        for(let i = 0, j = length - 1; i < length; j = i++){
            const xi = this.points[i * 2], yi = this.points[i * 2 + 1], xj = this.points[j * 2], yj = this.points[j * 2 + 1];
            yi > y != yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi && (inside = !inside);
        }
        return inside;
    }
}
$c1a49bce64bda319$export$7d31b617c820d435.prototype.toString = function() {
    return `[@pixi/math:PolygoncloseStroke=${this.closeStroke}points=${this.points.reduce((pointsDesc, currentPoint)=>`${pointsDesc}, ${currentPoint}`, "")}]`;
};




class $1a53fd4c44f959c9$export$d55ab2e3dc5a4263 {
    /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */ constructor(x = 0, y = 0, width = 0, height = 0, radius = 20){
        this.x = x, this.y = y, this.width = width, this.height = height, this.radius = radius, this.type = (0, $23fb2779a12001d8$export$511e1d54a4a8684e).RREC;
    }
    /**
   * Creates a clone of this Rounded Rectangle.
   * @returns - A copy of the rounded rectangle.
   */ clone() {
        return new $1a53fd4c44f959c9$export$d55ab2e3dc5a4263(this.x, this.y, this.width, this.height, this.radius);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this Rounded Rectangle.
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return !1;
        if (x >= this.x && x <= this.x + this.width && y >= this.y && y <= this.y + this.height) {
            const radius = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
            if (y >= this.y + radius && y <= this.y + this.height - radius || x >= this.x + radius && x <= this.x + this.width - radius) return !0;
            let dx = x - (this.x + radius), dy = y - (this.y + radius);
            const radius2 = radius * radius;
            if (dx * dx + dy * dy <= radius2 || (dx = x - (this.x + this.width - radius), dx * dx + dy * dy <= radius2) || (dy = y - (this.y + this.height - radius), dx * dx + dy * dy <= radius2) || (dx = x - (this.x + radius), dx * dx + dy * dy <= radius2)) return !0;
        }
        return !1;
    }
}
$1a53fd4c44f959c9$export$d55ab2e3dc5a4263.prototype.toString = function() {
    return `[@pixi/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
};




class $e3d55ad358e71dc4$export$5b12bf1653c0dd85 {
    /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */ constructor(a = 1, b = 0, c = 0, d = 1, tx = 0, ty = 0){
        this.array = null, this.a = a, this.b = b, this.c = c, this.d = d, this.tx = tx, this.ty = ty;
    }
    /**
   * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
   *
   * a = array[0]
   * b = array[1]
   * c = array[3]
   * d = array[4]
   * tx = array[2]
   * ty = array[5]
   * @param array - The array that the matrix will be populated from.
   */ fromArray(array) {
        this.a = array[0], this.b = array[1], this.c = array[3], this.d = array[4], this.tx = array[2], this.ty = array[5];
    }
    /**
   * Sets the matrix properties.
   * @param a - Matrix component
   * @param b - Matrix component
   * @param c - Matrix component
   * @param d - Matrix component
   * @param tx - Matrix component
   * @param ty - Matrix component
   * @returns This matrix. Good for chaining method calls.
   */ set(a, b, c, d, tx, ty) {
        return this.a = a, this.b = b, this.c = c, this.d = d, this.tx = tx, this.ty = ty, this;
    }
    /**
   * Creates an array from the current Matrix object.
   * @param transpose - Whether we need to transpose the matrix or not
   * @param [out=new Float32Array(9)] - If provided the array will be assigned to out
   * @returns The newly created array which contains the matrix
   */ toArray(transpose, out) {
        this.array || (this.array = new Float32Array(9));
        const array = out || this.array;
        return transpose ? (array[0] = this.a, array[1] = this.b, array[2] = 0, array[3] = this.c, array[4] = this.d, array[5] = 0, array[6] = this.tx, array[7] = this.ty, array[8] = 1) : (array[0] = this.a, array[1] = this.c, array[2] = this.tx, array[3] = this.b, array[4] = this.d, array[5] = this.ty, array[6] = 0, array[7] = 0, array[8] = 1), array;
    }
    /**
   * Get a new position with the current transformation applied.
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @param pos - The origin
   * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {PIXI.Point} The new point, transformed through this matrix
   */ apply(pos, newPos) {
        newPos = newPos || new (0, $c283a5532acdbe2e$export$baf26146a414f24a)();
        const x = pos.x, y = pos.y;
        return newPos.x = this.a * x + this.c * y + this.tx, newPos.y = this.b * x + this.d * y + this.ty, newPos;
    }
    /**
   * Get a new position with the inverse of the current transformation applied.
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @param pos - The origin
   * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {PIXI.Point} The new point, inverse-transformed through this matrix
   */ applyInverse(pos, newPos) {
        newPos = newPos || new (0, $c283a5532acdbe2e$export$baf26146a414f24a)();
        const id = 1 / (this.a * this.d + this.c * -this.b), x = pos.x, y = pos.y;
        return newPos.x = this.d * id * x + -this.c * id * y + (this.ty * this.c - this.tx * this.d) * id, newPos.y = this.a * id * y + -this.b * id * x + (-this.ty * this.a + this.tx * this.b) * id, newPos;
    }
    /**
   * Translates the matrix on the x and y.
   * @param x - How much to translate x by
   * @param y - How much to translate y by
   * @returns This matrix. Good for chaining method calls.
   */ translate(x, y) {
        return this.tx += x, this.ty += y, this;
    }
    /**
   * Applies a scale transformation to the matrix.
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   */ scale(x, y) {
        return this.a *= x, this.d *= y, this.c *= x, this.b *= y, this.tx *= x, this.ty *= y, this;
    }
    /**
   * Applies a rotation transformation to the matrix.
   * @param angle - The angle in radians.
   * @returns This matrix. Good for chaining method calls.
   */ rotate(angle) {
        const cos = Math.cos(angle), sin = Math.sin(angle), a1 = this.a, c1 = this.c, tx1 = this.tx;
        return this.a = a1 * cos - this.b * sin, this.b = a1 * sin + this.b * cos, this.c = c1 * cos - this.d * sin, this.d = c1 * sin + this.d * cos, this.tx = tx1 * cos - this.ty * sin, this.ty = tx1 * sin + this.ty * cos, this;
    }
    /**
   * Appends the given Matrix to this Matrix.
   * @param matrix - The matrix to append.
   * @returns This matrix. Good for chaining method calls.
   */ append(matrix) {
        const a1 = this.a, b1 = this.b, c1 = this.c, d1 = this.d;
        return this.a = matrix.a * a1 + matrix.b * c1, this.b = matrix.a * b1 + matrix.b * d1, this.c = matrix.c * a1 + matrix.d * c1, this.d = matrix.c * b1 + matrix.d * d1, this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx, this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty, this;
    }
    /**
   * Sets the matrix based on all the available properties
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   */ setTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
        return this.a = Math.cos(rotation + skewY) * scaleX, this.b = Math.sin(rotation + skewY) * scaleX, this.c = -Math.sin(rotation - skewX) * scaleY, this.d = Math.cos(rotation - skewX) * scaleY, this.tx = x - (pivotX * this.a + pivotY * this.c), this.ty = y - (pivotX * this.b + pivotY * this.d), this;
    }
    /**
   * Prepends the given Matrix to this Matrix.
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   */ prepend(matrix) {
        const tx1 = this.tx;
        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
            const a1 = this.a, c1 = this.c;
            this.a = a1 * matrix.a + this.b * matrix.c, this.b = a1 * matrix.b + this.b * matrix.d, this.c = c1 * matrix.a + this.d * matrix.c, this.d = c1 * matrix.b + this.d * matrix.d;
        }
        return this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx, this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty, this;
    }
    /**
   * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
   * @param transform - The transform to apply the properties to.
   * @returns The transform with the newly applied properties
   */ decompose(transform) {
        const a = this.a, b = this.b, c = this.c, d = this.d, pivot = transform.pivot, skewX = -Math.atan2(-c, d), skewY = Math.atan2(b, a), delta = Math.abs(skewX + skewY);
        return delta < 1e-5 || Math.abs((0, $23fb2779a12001d8$export$59ed0a0a5de1084b) - delta) < 1e-5 ? (transform.rotation = skewY, transform.skew.x = transform.skew.y = 0) : (transform.rotation = 0, transform.skew.x = skewX, transform.skew.y = skewY), transform.scale.x = Math.sqrt(a * a + b * b), transform.scale.y = Math.sqrt(c * c + d * d), transform.position.x = this.tx + (pivot.x * a + pivot.y * c), transform.position.y = this.ty + (pivot.x * b + pivot.y * d), transform;
    }
    /**
   * Inverts this matrix
   * @returns This matrix. Good for chaining method calls.
   */ invert() {
        const a1 = this.a, b1 = this.b, c1 = this.c, d1 = this.d, tx1 = this.tx, n = a1 * d1 - b1 * c1;
        return this.a = d1 / n, this.b = -b1 / n, this.c = -c1 / n, this.d = a1 / n, this.tx = (c1 * this.ty - d1 * tx1) / n, this.ty = -(a1 * this.ty - b1 * tx1) / n, this;
    }
    /**
   * Resets this Matrix to an identity (default) matrix.
   * @returns This matrix. Good for chaining method calls.
   */ identity() {
        return this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.tx = 0, this.ty = 0, this;
    }
    /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */ clone() {
        const matrix = new $e3d55ad358e71dc4$export$5b12bf1653c0dd85();
        return matrix.a = this.a, matrix.b = this.b, matrix.c = this.c, matrix.d = this.d, matrix.tx = this.tx, matrix.ty = this.ty, matrix;
    }
    /**
   * Changes the values of the given matrix to be the same as the ones in this matrix
   * @param matrix - The matrix to copy to.
   * @returns The matrix given in parameter with its values updated.
   */ copyTo(matrix) {
        return matrix.a = this.a, matrix.b = this.b, matrix.c = this.c, matrix.d = this.d, matrix.tx = this.tx, matrix.ty = this.ty, matrix;
    }
    /**
   * Changes the values of the matrix to be the same as the ones in given matrix
   * @param {PIXI.Matrix} matrix - The matrix to copy from.
   * @returns {PIXI.Matrix} this
   */ copyFrom(matrix) {
        return this.a = matrix.a, this.b = matrix.b, this.c = matrix.c, this.d = matrix.d, this.tx = matrix.tx, this.ty = matrix.ty, this;
    }
    /**
   * A default (identity) matrix
   * @readonly
   */ static get IDENTITY() {
        return new $e3d55ad358e71dc4$export$5b12bf1653c0dd85();
    }
    /**
   * A temp matrix
   * @readonly
   */ static get TEMP_MATRIX() {
        return new $e3d55ad358e71dc4$export$5b12bf1653c0dd85();
    }
}
$e3d55ad358e71dc4$export$5b12bf1653c0dd85.prototype.toString = function() {
    return `[@pixi/math:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
};


const $a6f7925408a5bc20$var$ux = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1
], $a6f7925408a5bc20$var$uy = [
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
], $a6f7925408a5bc20$var$vx = [
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
], $a6f7925408a5bc20$var$vy = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1
], $a6f7925408a5bc20$var$rotationCayley = [], $a6f7925408a5bc20$var$rotationMatrices = [], $a6f7925408a5bc20$var$signum = Math.sign;
function $a6f7925408a5bc20$var$init() {
    for(let i = 0; i < 16; i++){
        const row = [];
        $a6f7925408a5bc20$var$rotationCayley.push(row);
        for(let j = 0; j < 16; j++){
            const _ux = $a6f7925408a5bc20$var$signum($a6f7925408a5bc20$var$ux[i] * $a6f7925408a5bc20$var$ux[j] + $a6f7925408a5bc20$var$vx[i] * $a6f7925408a5bc20$var$uy[j]), _uy = $a6f7925408a5bc20$var$signum($a6f7925408a5bc20$var$uy[i] * $a6f7925408a5bc20$var$ux[j] + $a6f7925408a5bc20$var$vy[i] * $a6f7925408a5bc20$var$uy[j]), _vx = $a6f7925408a5bc20$var$signum($a6f7925408a5bc20$var$ux[i] * $a6f7925408a5bc20$var$vx[j] + $a6f7925408a5bc20$var$vx[i] * $a6f7925408a5bc20$var$vy[j]), _vy = $a6f7925408a5bc20$var$signum($a6f7925408a5bc20$var$uy[i] * $a6f7925408a5bc20$var$vx[j] + $a6f7925408a5bc20$var$vy[i] * $a6f7925408a5bc20$var$vy[j]);
            for(let k = 0; k < 16; k++)if ($a6f7925408a5bc20$var$ux[k] === _ux && $a6f7925408a5bc20$var$uy[k] === _uy && $a6f7925408a5bc20$var$vx[k] === _vx && $a6f7925408a5bc20$var$vy[k] === _vy) {
                row.push(k);
                break;
            }
        }
    }
    for(let i = 0; i < 16; i++){
        const mat = new (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85)();
        mat.set($a6f7925408a5bc20$var$ux[i], $a6f7925408a5bc20$var$uy[i], $a6f7925408a5bc20$var$vx[i], $a6f7925408a5bc20$var$vy[i], 0, 0), $a6f7925408a5bc20$var$rotationMatrices.push(mat);
    }
}
$a6f7925408a5bc20$var$init();
const $a6f7925408a5bc20$export$b7bb6a2a8d203102 = {
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @readonly
   */ E: 0,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @readonly
   */ SE: 1,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @readonly
   */ S: 2,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @readonly
   */ SW: 3,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @readonly
   */ W: 4,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @readonly
   */ NW: 5,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @readonly
   */ N: 6,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @readonly
   */ NE: 7,
    /**
   * Reflection about Y-axis.
   * @readonly
   */ MIRROR_VERTICAL: 8,
    /**
   * Reflection about the main diagonal.
   * @readonly
   */ MAIN_DIAGONAL: 10,
    /**
   * Reflection about X-axis.
   * @readonly
   */ MIRROR_HORIZONTAL: 12,
    /**
   * Reflection about reverse diagonal.
   * @readonly
   */ REVERSE_DIAGONAL: 14,
    /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */ uX: (ind)=>$a6f7925408a5bc20$var$ux[ind],
    /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */ uY: (ind)=>$a6f7925408a5bc20$var$uy[ind],
    /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */ vX: (ind)=>$a6f7925408a5bc20$var$vx[ind],
    /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */ vY: (ind)=>$a6f7925408a5bc20$var$vy[ind],
    /**
   * @param {PIXI.GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {PIXI.GD8Symmetry} The opposite symmetry of `rotation`
   */ inv: (rotation)=>rotation & 8 ? rotation & 15 : -rotation & 7,
    /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @param {PIXI.GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {PIXI.GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {PIXI.GD8Symmetry} Composed operation
   */ add: (rotationSecond, rotationFirst)=>$a6f7925408a5bc20$var$rotationCayley[rotationSecond][rotationFirst],
    /**
   * Reverse of `add`.
   * @param {PIXI.GD8Symmetry} rotationSecond - Second operation
   * @param {PIXI.GD8Symmetry} rotationFirst - First operation
   * @returns {PIXI.GD8Symmetry} Result
   */ sub: (rotationSecond, rotationFirst)=>$a6f7925408a5bc20$var$rotationCayley[rotationSecond][$a6f7925408a5bc20$export$b7bb6a2a8d203102.inv(rotationFirst)],
    /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */ rotate180: (rotation)=>rotation ^ 4,
    /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @param {PIXI.GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */ isVertical: (rotation)=>(rotation & 3) === 2,
    // rotation % 4 === 2
    /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {PIXI.GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */ byDirection: (dx, dy)=>Math.abs(dx) * 2 <= Math.abs(dy) ? dy >= 0 ? $a6f7925408a5bc20$export$b7bb6a2a8d203102.S : $a6f7925408a5bc20$export$b7bb6a2a8d203102.N : Math.abs(dy) * 2 <= Math.abs(dx) ? dx > 0 ? $a6f7925408a5bc20$export$b7bb6a2a8d203102.E : $a6f7925408a5bc20$export$b7bb6a2a8d203102.W : dy > 0 ? dx > 0 ? $a6f7925408a5bc20$export$b7bb6a2a8d203102.SE : $a6f7925408a5bc20$export$b7bb6a2a8d203102.SW : dx > 0 ? $a6f7925408a5bc20$export$b7bb6a2a8d203102.NE : $a6f7925408a5bc20$export$b7bb6a2a8d203102.NW,
    /**
   * Helps sprite to compensate texture packer rotation.
   * @param {PIXI.Matrix} matrix - sprite world matrix
   * @param {PIXI.GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   */ matrixAppendRotationInv: (matrix, rotation, tx = 0, ty = 0)=>{
        const mat = $a6f7925408a5bc20$var$rotationMatrices[$a6f7925408a5bc20$export$b7bb6a2a8d203102.inv(rotation)];
        mat.tx = tx, mat.ty = ty, matrix.append(mat);
    }
};







class $0c68ac15ddf7471c$export$3755aaad3fd42e52 {
    /**
   * Creates a new `ObservablePoint`
   * @param cb - callback function triggered when `x` and/or `y` are changed
   * @param scope - owner of callback
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(cb, scope, x = 0, y = 0){
        this._x = x, this._y = y, this.cb = cb, this.scope = scope;
    }
    /**
   * Creates a clone of this point.
   * The callback and scope params can be overridden otherwise they will default
   * to the clone object's values.
   * @override
   * @param cb - The callback function triggered when `x` and/or `y` are changed
   * @param scope - The owner of the callback
   * @returns a copy of this observable point
   */ clone(cb = this.cb, scope = this.scope) {
        return new $0c68ac15ddf7471c$export$3755aaad3fd42e52(cb, scope, this._x, this._y);
    }
    /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=x] - position of the point on the y axis
   * @returns The observable point instance itself
   */ set(x = 0, y = x) {
        return (this._x !== x || this._y !== y) && (this._x = x, this._y = y, this.cb.call(this.scope)), this;
    }
    /**
   * Copies x and y from the given point (`p`)
   * @param p - The point to copy from. Can be any of type that is or extends `IPointData`
   * @returns The observable point instance itself
   */ copyFrom(p) {
        return (this._x !== p.x || this._y !== p.y) && (this._x = p.x, this._y = p.y, this.cb.call(this.scope)), this;
    }
    /**
   * Copies this point's x and y into that of the given point (`p`)
   * @param p - The point to copy to. Can be any of type that is or extends `IPointData`
   * @returns The point (`p`) with values updated
   */ copyTo(p) {
        return p.set(this._x, this._y), p;
    }
    /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */ equals(p) {
        return p.x === this._x && p.y === this._y;
    }
    /** Position of the observable point on the x axis. */ get x() {
        return this._x;
    }
    set x(value) {
        this._x !== value && (this._x = value, this.cb.call(this.scope));
    }
    /** Position of the observable point on the y axis. */ get y() {
        return this._y;
    }
    set y(value) {
        this._y !== value && (this._y = value, this.cb.call(this.scope));
    }
}
$0c68ac15ddf7471c$export$3755aaad3fd42e52.prototype.toString = function() {
    return `[@pixi/math:ObservablePoint x=${this.x} y=${this.y} scope=${this.scope}]`;
};





const $a93d35f2e511a825$var$_Transform = class {
    constructor(){
        this.worldTransform = new (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85)(), this.localTransform = new (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85)(), this.position = new (0, $0c68ac15ddf7471c$export$3755aaad3fd42e52)(this.onChange, this, 0, 0), this.scale = new (0, $0c68ac15ddf7471c$export$3755aaad3fd42e52)(this.onChange, this, 1, 1), this.pivot = new (0, $0c68ac15ddf7471c$export$3755aaad3fd42e52)(this.onChange, this, 0, 0), this.skew = new (0, $0c68ac15ddf7471c$export$3755aaad3fd42e52)(this.updateSkew, this, 0, 0), this._rotation = 0, this._cx = 1, this._sx = 0, this._cy = 0, this._sy = 1, this._localID = 0, this._currentLocalID = 0, this._worldID = 0, this._parentID = 0;
    }
    /** Called when a value changes. */ onChange() {
        this._localID++;
    }
    /** Called when the skew or the rotation changes. */ updateSkew() {
        this._cx = Math.cos(this._rotation + this.skew.y), this._sx = Math.sin(this._rotation + this.skew.y), this._cy = -Math.sin(this._rotation - this.skew.x), this._sy = Math.cos(this._rotation - this.skew.x), this._localID++;
    }
    /** Updates the local transformation matrix. */ updateLocalTransform() {
        const lt = this.localTransform;
        this._localID !== this._currentLocalID && (lt.a = this._cx * this.scale.x, lt.b = this._sx * this.scale.x, lt.c = this._cy * this.scale.y, lt.d = this._sy * this.scale.y, lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c), lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d), this._currentLocalID = this._localID, this._parentID = -1);
    }
    /**
   * Updates the local and the world transformation matrices.
   * @param parentTransform - The parent transform
   */ updateTransform(parentTransform) {
        const lt = this.localTransform;
        if (this._localID !== this._currentLocalID && (lt.a = this._cx * this.scale.x, lt.b = this._sx * this.scale.x, lt.c = this._cy * this.scale.y, lt.d = this._sy * this.scale.y, lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c), lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d), this._currentLocalID = this._localID, this._parentID = -1), this._parentID !== parentTransform._worldID) {
            const pt = parentTransform.worldTransform, wt = this.worldTransform;
            wt.a = lt.a * pt.a + lt.b * pt.c, wt.b = lt.a * pt.b + lt.b * pt.d, wt.c = lt.c * pt.a + lt.d * pt.c, wt.d = lt.c * pt.b + lt.d * pt.d, wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx, wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty, this._parentID = parentTransform._worldID, this._worldID++;
        }
    }
    /**
   * Decomposes a matrix and sets the transforms properties based on it.
   * @param matrix - The matrix to decompose
   */ setFromMatrix(matrix) {
        matrix.decompose(this), this._localID++;
    }
    /** The rotation of the object in radians. */ get rotation() {
        return this._rotation;
    }
    set rotation(value) {
        this._rotation !== value && (this._rotation = value, this.updateSkew());
    }
};
$a93d35f2e511a825$var$_Transform.IDENTITY = new $a93d35f2e511a825$var$_Transform();
let $a93d35f2e511a825$export$563a914cafbdc389 = $a93d35f2e511a825$var$_Transform;
$a93d35f2e511a825$export$563a914cafbdc389.prototype.toString = function() {
    return `[@pixi/math:Transform position=(${this.position.x}, ${this.position.y}) rotation=${this.rotation} scale=(${this.scale.x}, ${this.scale.y}) skew=(${this.skew.x}, ${this.skew.y}) ]`;
};







var $dff0b50fc787d424$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;

void main(void){
   gl_FragColor *= texture2D(uSampler, vTextureCoord);
}`;


var $fa706684f903f0fd$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void){
   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
   vTextureCoord = aTextureCoord;
}
`;



function $804c80302f4ca5d0$export$9b5304f4eb007cf0(gl, type, src) {
    const shader = gl.createShader(type);
    return gl.shaderSource(shader, src), gl.compileShader(shader), shader;
}


function $8ab13255b022e772$var$booleanArray(size) {
    const array = new Array(size);
    for(let i = 0; i < array.length; i++)array[i] = !1;
    return array;
}
function $8ab13255b022e772$export$1a01ae0705bafd37(type, size) {
    switch(type){
        case "float":
            return 0;
        case "vec2":
            return new Float32Array(2 * size);
        case "vec3":
            return new Float32Array(3 * size);
        case "vec4":
            return new Float32Array(4 * size);
        case "int":
        case "uint":
        case "sampler2D":
        case "sampler2DArray":
            return 0;
        case "ivec2":
            return new Int32Array(2 * size);
        case "ivec3":
            return new Int32Array(3 * size);
        case "ivec4":
            return new Int32Array(4 * size);
        case "uvec2":
            return new Uint32Array(2 * size);
        case "uvec3":
            return new Uint32Array(3 * size);
        case "uvec4":
            return new Uint32Array(4 * size);
        case "bool":
            return !1;
        case "bvec2":
            return $8ab13255b022e772$var$booleanArray(2 * size);
        case "bvec3":
            return $8ab13255b022e772$var$booleanArray(3 * size);
        case "bvec4":
            return $8ab13255b022e772$var$booleanArray(4 * size);
        case "mat2":
            return new Float32Array([
                1,
                0,
                0,
                1
            ]);
        case "mat3":
            return new Float32Array([
                1,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                1
            ]);
        case "mat4":
            return new Float32Array([
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ]);
    }
    return null;
}


const $099125ae68d9308e$export$cf9f41a7e506e2d2 = [
    // a float cache layer
    {
        test: (data)=>data.type === "float" && data.size === 1 && !data.isArray,
        code: (name)=>`
            if(uv["${name}"] !== ud["${name}"].value)
            {
                ud["${name}"].value = uv["${name}"]
                gl.uniform1f(ud["${name}"].location, uv["${name}"])
            }
            `
    },
    // handling samplers
    {
        test: (data, uniform)=>// eslint-disable-next-line max-len,no-eq-null,eqeqeq
            (data.type === "sampler2D" || data.type === "samplerCube" || data.type === "sampler2DArray") && data.size === 1 && !data.isArray && (uniform == null || uniform.castToBaseTexture !== void 0),
        code: (name)=>`t = syncData.textureCount++;

            renderer.texture.bind(uv["${name}"], t);

            if(ud["${name}"].value !== t)
            {
                ud["${name}"].value = t;
                gl.uniform1i(ud["${name}"].location, t);
; // eslint-disable-line max-len
            }`
    },
    // uploading pixi matrix object to mat3
    {
        test: (data, uniform)=>data.type === "mat3" && data.size === 1 && !data.isArray && uniform.a !== void 0,
        code: (name)=>// TODO and some smart caching dirty ids here!
            `
            gl.uniformMatrix3fv(ud["${name}"].location, false, uv["${name}"].toArray(true));
            `,
        codeUbo: (name)=>`
                var ${name}_matrix = uv.${name}.toArray(true);

                data[offset] = ${name}_matrix[0];
                data[offset+1] = ${name}_matrix[1];
                data[offset+2] = ${name}_matrix[2];
        
                data[offset + 4] = ${name}_matrix[3];
                data[offset + 5] = ${name}_matrix[4];
                data[offset + 6] = ${name}_matrix[5];
        
                data[offset + 8] = ${name}_matrix[6];
                data[offset + 9] = ${name}_matrix[7];
                data[offset + 10] = ${name}_matrix[8];
            `
    },
    // uploading a pixi point as a vec2 with caching layer
    {
        test: (data, uniform)=>data.type === "vec2" && data.size === 1 && !data.isArray && uniform.x !== void 0,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v.x || cv[1] !== v.y)
                {
                    cv[0] = v.x;
                    cv[1] = v.y;
                    gl.uniform2f(ud["${name}"].location, v.x, v.y);
                }`,
        codeUbo: (name)=>`
                v = uv.${name};

                data[offset] = v.x;
                data[offset+1] = v.y;
            `
    },
    // caching layer for a vec2
    {
        test: (data)=>data.type === "vec2" && data.size === 1 && !data.isArray,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v[0] || cv[1] !== v[1])
                {
                    cv[0] = v[0];
                    cv[1] = v[1];
                    gl.uniform2f(ud["${name}"].location, v[0], v[1]);
                }
            `
    },
    // upload a pixi rectangle as a vec4 with caching layer
    {
        test: (data, uniform)=>data.type === "vec4" && data.size === 1 && !data.isArray && uniform.width !== void 0,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v.x || cv[1] !== v.y || cv[2] !== v.width || cv[3] !== v.height)
                {
                    cv[0] = v.x;
                    cv[1] = v.y;
                    cv[2] = v.width;
                    cv[3] = v.height;
                    gl.uniform4f(ud["${name}"].location, v.x, v.y, v.width, v.height)
                }`,
        codeUbo: (name)=>`
                    v = uv.${name};

                    data[offset] = v.x;
                    data[offset+1] = v.y;
                    data[offset+2] = v.width;
                    data[offset+3] = v.height;
                `
    },
    // upload a pixi color as vec4 with caching layer
    {
        test: (data, uniform)=>data.type === "vec4" && data.size === 1 && !data.isArray && uniform.red !== void 0,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue || cv[3] !== v.alpha)
                {
                    cv[0] = v.red;
                    cv[1] = v.green;
                    cv[2] = v.blue;
                    cv[3] = v.alpha;
                    gl.uniform4f(ud["${name}"].location, v.red, v.green, v.blue, v.alpha)
                }`,
        codeUbo: (name)=>`
                    v = uv.${name};

                    data[offset] = v.red;
                    data[offset+1] = v.green;
                    data[offset+2] = v.blue;
                    data[offset+3] = v.alpha;
                `
    },
    // upload a pixi color as a vec3 with caching layer
    {
        test: (data, uniform)=>data.type === "vec3" && data.size === 1 && !data.isArray && uniform.red !== void 0,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue || cv[3] !== v.a)
                {
                    cv[0] = v.red;
                    cv[1] = v.green;
                    cv[2] = v.blue;
    
                    gl.uniform3f(ud["${name}"].location, v.red, v.green, v.blue)
                }`,
        codeUbo: (name)=>`
                    v = uv.${name};

                    data[offset] = v.red;
                    data[offset+1] = v.green;
                    data[offset+2] = v.blue;
                `
    },
    // a caching layer for vec4 uploading
    {
        test: (data)=>data.type === "vec4" && data.size === 1 && !data.isArray,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
                {
                    cv[0] = v[0];
                    cv[1] = v[1];
                    cv[2] = v[2];
                    cv[3] = v[3];

                    gl.uniform4f(ud["${name}"].location, v[0], v[1], v[2], v[3])
                }`
    }
];


const $c6b47d55caf329c2$var$GLSL_TO_SINGLE_SETTERS_CACHED = {
    float: `
    if (cv !== v)
    {
        cu.value = v;
        gl.uniform1f(location, v);
    }`,
    vec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2f(location, v[0], v[1])
    }`,
    vec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3f(location, v[0], v[1], v[2])
    }`,
    vec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4f(location, v[0], v[1], v[2], v[3]);
    }`,
    int: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
    ivec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2i(location, v[0], v[1]);
    }`,
    ivec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3i(location, v[0], v[1], v[2]);
    }`,
    ivec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4i(location, v[0], v[1], v[2], v[3]);
    }`,
    uint: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1ui(location, v);
    }`,
    uvec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2ui(location, v[0], v[1]);
    }`,
    uvec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3ui(location, v[0], v[1], v[2]);
    }`,
    uvec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4ui(location, v[0], v[1], v[2], v[3]);
    }`,
    bool: `
    if (cv !== v)
    {
        cu.value = v;
        gl.uniform1i(location, v);
    }`,
    bvec2: `
    if (cv[0] != v[0] || cv[1] != v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2i(location, v[0], v[1]);
    }`,
    bvec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3i(location, v[0], v[1], v[2]);
    }`,
    bvec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4i(location, v[0], v[1], v[2], v[3]);
    }`,
    mat2: "gl.uniformMatrix2fv(location, false, v)",
    mat3: "gl.uniformMatrix3fv(location, false, v)",
    mat4: "gl.uniformMatrix4fv(location, false, v)",
    sampler2D: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
    samplerCube: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
    sampler2DArray: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`
}, $c6b47d55caf329c2$var$GLSL_TO_ARRAY_SETTERS = {
    float: "gl.uniform1fv(location, v)",
    vec2: "gl.uniform2fv(location, v)",
    vec3: "gl.uniform3fv(location, v)",
    vec4: "gl.uniform4fv(location, v)",
    mat4: "gl.uniformMatrix4fv(location, false, v)",
    mat3: "gl.uniformMatrix3fv(location, false, v)",
    mat2: "gl.uniformMatrix2fv(location, false, v)",
    int: "gl.uniform1iv(location, v)",
    ivec2: "gl.uniform2iv(location, v)",
    ivec3: "gl.uniform3iv(location, v)",
    ivec4: "gl.uniform4iv(location, v)",
    uint: "gl.uniform1uiv(location, v)",
    uvec2: "gl.uniform2uiv(location, v)",
    uvec3: "gl.uniform3uiv(location, v)",
    uvec4: "gl.uniform4uiv(location, v)",
    bool: "gl.uniform1iv(location, v)",
    bvec2: "gl.uniform2iv(location, v)",
    bvec3: "gl.uniform3iv(location, v)",
    bvec4: "gl.uniform4iv(location, v)",
    sampler2D: "gl.uniform1iv(location, v)",
    samplerCube: "gl.uniform1iv(location, v)",
    sampler2DArray: "gl.uniform1iv(location, v)"
};
function $c6b47d55caf329c2$export$20c95d1c2d5a6828(group, uniformData) {
    const funcFragments = [
        `
        var v = null;
        var cv = null;
        var cu = null;
        var t = 0;
        var gl = renderer.gl;
    `
    ];
    for(const i in group.uniforms){
        const data = uniformData[i];
        if (!data) {
            group.uniforms[i]?.group === !0 && (group.uniforms[i].ubo ? funcFragments.push(`
                        renderer.shader.syncUniformBufferGroup(uv.${i}, '${i}');
                    `) : funcFragments.push(`
                        renderer.shader.syncUniformGroup(uv.${i}, syncData);
                    `));
            continue;
        }
        const uniform = group.uniforms[i];
        let parsed = !1;
        for(let j = 0; j < (0, $099125ae68d9308e$export$cf9f41a7e506e2d2).length; j++)if ((0, $099125ae68d9308e$export$cf9f41a7e506e2d2)[j].test(data, uniform)) {
            funcFragments.push((0, $099125ae68d9308e$export$cf9f41a7e506e2d2)[j].code(i, uniform)), parsed = !0;
            break;
        }
        if (!parsed) {
            const template = (data.size === 1 && !data.isArray ? $c6b47d55caf329c2$var$GLSL_TO_SINGLE_SETTERS_CACHED : $c6b47d55caf329c2$var$GLSL_TO_ARRAY_SETTERS)[data.type].replace("location", `ud["${i}"].location`);
            funcFragments.push(`
            cu = ud["${i}"];
            cv = cu.value;
            v = uv["${i}"];
            ${template};`);
        }
    }
    return new Function("ud", "uv", "renderer", "syncData", funcFragments.join(`
`));
}





const $9de33861c0340ee5$var$unknownContext = {};
let $9de33861c0340ee5$var$context = $9de33861c0340ee5$var$unknownContext;
function $9de33861c0340ee5$export$f034b2d55f8df08b() {
    if ($9de33861c0340ee5$var$context === $9de33861c0340ee5$var$unknownContext || $9de33861c0340ee5$var$context?.isContextLost()) {
        const canvas = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.createCanvas();
        let gl;
        (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).PREFER_ENV >= (0, $5912637ee8cf8b9f$export$83401e34d5e11bf4).WEBGL2 && (gl = canvas.getContext("webgl2", {})), gl || (gl = canvas.getContext("webgl", {}) || canvas.getContext("experimental-webgl", {}), gl ? gl.getExtension("WEBGL_draw_buffers") : gl = null), $9de33861c0340ee5$var$context = gl;
    }
    return $9de33861c0340ee5$var$context;
}


let $350502192ad40a78$var$maxFragmentPrecision;
function $350502192ad40a78$export$428c38e64838140() {
    if (!$350502192ad40a78$var$maxFragmentPrecision) {
        $350502192ad40a78$var$maxFragmentPrecision = (0, $5912637ee8cf8b9f$export$d6d3992f3becc879).MEDIUM;
        const gl = (0, $9de33861c0340ee5$export$f034b2d55f8df08b)();
        gl && gl.getShaderPrecisionFormat && ($350502192ad40a78$var$maxFragmentPrecision = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision ? (0, $5912637ee8cf8b9f$export$d6d3992f3becc879).HIGH : (0, $5912637ee8cf8b9f$export$d6d3992f3becc879).MEDIUM);
    }
    return $350502192ad40a78$var$maxFragmentPrecision;
}



function $15f165c49a21601f$var$logPrettyShaderError(gl, shader) {
    const shaderSrc = gl.getShaderSource(shader).split(`
`).map((line, index)=>`${index}: ${line}`), shaderLog = gl.getShaderInfoLog(shader), splitShader = shaderLog.split(`
`), dedupe = {}, lineNumbers = splitShader.map((line)=>parseFloat(line.replace(/^ERROR\: 0\:([\d]+)\:.*$/, "$1"))).filter((n)=>n && !dedupe[n] ? (dedupe[n] = !0, !0) : !1), logArgs = [
        ""
    ];
    lineNumbers.forEach((number)=>{
        shaderSrc[number - 1] = `%c${shaderSrc[number - 1]}%c`, logArgs.push("background: #FF0000; color:#FFFFFF; font-size: 10px", "font-size: 10px");
    });
    const fragmentSourceToLog = shaderSrc.join(`
`);
    logArgs[0] = fragmentSourceToLog, console.error(shaderLog), console.groupCollapsed("click to view full shader code"), console.warn(...logArgs), console.groupEnd();
}
function $15f165c49a21601f$export$4b35d6c62dc992b0(gl, program, vertexShader, fragmentShader) {
    gl.getProgramParameter(program, gl.LINK_STATUS) || (gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS) || $15f165c49a21601f$var$logPrettyShaderError(gl, vertexShader), gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS) || $15f165c49a21601f$var$logPrettyShaderError(gl, fragmentShader), console.error("PixiJS Error: Could not initialize shader."), gl.getProgramInfoLog(program) !== "" && console.warn("PixiJS Warning: gl.getProgramInfoLog()", gl.getProgramInfoLog(program)));
}


const $aad17c1cf71ac7af$var$GLSL_TO_SIZE = {
    float: 1,
    vec2: 2,
    vec3: 3,
    vec4: 4,
    int: 1,
    ivec2: 2,
    ivec3: 3,
    ivec4: 4,
    uint: 1,
    uvec2: 2,
    uvec3: 3,
    uvec4: 4,
    bool: 1,
    bvec2: 2,
    bvec3: 3,
    bvec4: 4,
    mat2: 4,
    mat3: 9,
    mat4: 16,
    sampler2D: 1
};
function $aad17c1cf71ac7af$export$50ee69a11aa2abdb(type) {
    return $aad17c1cf71ac7af$var$GLSL_TO_SIZE[type];
}


let $ed555d453f4c2e4f$var$GL_TABLE = null;
const $ed555d453f4c2e4f$var$GL_TO_GLSL_TYPES = {
    FLOAT: "float",
    FLOAT_VEC2: "vec2",
    FLOAT_VEC3: "vec3",
    FLOAT_VEC4: "vec4",
    INT: "int",
    INT_VEC2: "ivec2",
    INT_VEC3: "ivec3",
    INT_VEC4: "ivec4",
    UNSIGNED_INT: "uint",
    UNSIGNED_INT_VEC2: "uvec2",
    UNSIGNED_INT_VEC3: "uvec3",
    UNSIGNED_INT_VEC4: "uvec4",
    BOOL: "bool",
    BOOL_VEC2: "bvec2",
    BOOL_VEC3: "bvec3",
    BOOL_VEC4: "bvec4",
    FLOAT_MAT2: "mat2",
    FLOAT_MAT3: "mat3",
    FLOAT_MAT4: "mat4",
    SAMPLER_2D: "sampler2D",
    INT_SAMPLER_2D: "sampler2D",
    UNSIGNED_INT_SAMPLER_2D: "sampler2D",
    SAMPLER_CUBE: "samplerCube",
    INT_SAMPLER_CUBE: "samplerCube",
    UNSIGNED_INT_SAMPLER_CUBE: "samplerCube",
    SAMPLER_2D_ARRAY: "sampler2DArray",
    INT_SAMPLER_2D_ARRAY: "sampler2DArray",
    UNSIGNED_INT_SAMPLER_2D_ARRAY: "sampler2DArray"
};
function $ed555d453f4c2e4f$export$4de3a94418d86ca7(gl, type) {
    if (!$ed555d453f4c2e4f$var$GL_TABLE) {
        const typeNames = Object.keys($ed555d453f4c2e4f$var$GL_TO_GLSL_TYPES);
        $ed555d453f4c2e4f$var$GL_TABLE = {};
        for(let i = 0; i < typeNames.length; ++i){
            const tn = typeNames[i];
            $ed555d453f4c2e4f$var$GL_TABLE[gl[tn]] = $ed555d453f4c2e4f$var$GL_TO_GLSL_TYPES[tn];
        }
    }
    return $ed555d453f4c2e4f$var$GL_TABLE[type];
}



function $a416b9c2731e4690$export$c4b85a3b3361e135(src, requestedPrecision, maxSupportedPrecision) {
    if (src.substring(0, 9) !== "precision") {
        let precision = requestedPrecision;
        return requestedPrecision === (0, $5912637ee8cf8b9f$export$d6d3992f3becc879).HIGH && maxSupportedPrecision !== (0, $5912637ee8cf8b9f$export$d6d3992f3becc879).HIGH && (precision = (0, $5912637ee8cf8b9f$export$d6d3992f3becc879).MEDIUM), `precision ${precision} float;
${src}`;
    } else if (maxSupportedPrecision !== (0, $5912637ee8cf8b9f$export$d6d3992f3becc879).HIGH && src.substring(0, 15) === "precision highp") return src.replace("precision highp", "precision mediump");
    return src;
}



let $e29403c21c4a3ad0$var$unsafeEval;
function $e29403c21c4a3ad0$export$70c0711f29adc5cf() {
    if (typeof $e29403c21c4a3ad0$var$unsafeEval == "boolean") return $e29403c21c4a3ad0$var$unsafeEval;
    try {
        $e29403c21c4a3ad0$var$unsafeEval = new Function("param1", "param2", "param3", "return param1[param2] === param3;")({
            a: "b"
        }, "a", "b") === !0;
    } catch  {
        $e29403c21c4a3ad0$var$unsafeEval = !1;
    }
    return $e29403c21c4a3ad0$var$unsafeEval;
}






let $529286cda46872bb$var$UID = 0;
const $529286cda46872bb$var$nameCache = {}, $529286cda46872bb$var$_Program = class _Program2 {
    /**
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param name - Name for shader
   * @param extra - Extra data for shader
   */ constructor(vertexSrc, fragmentSrc, name = "pixi-shader", extra = {}){
        this.extra = {}, this.id = $529286cda46872bb$var$UID++, this.vertexSrc = vertexSrc || _Program2.defaultVertexSrc, this.fragmentSrc = fragmentSrc || _Program2.defaultFragmentSrc, this.vertexSrc = this.vertexSrc.trim(), this.fragmentSrc = this.fragmentSrc.trim(), this.extra = extra, this.vertexSrc.substring(0, 8) !== "#version" && (name = name.replace(/\s+/g, "-"), $529286cda46872bb$var$nameCache[name] ? ($529286cda46872bb$var$nameCache[name]++, name += `-${$529286cda46872bb$var$nameCache[name]}`) : $529286cda46872bb$var$nameCache[name] = 1, this.vertexSrc = `#define SHADER_NAME ${name}
${this.vertexSrc}`, this.fragmentSrc = `#define SHADER_NAME ${name}
${this.fragmentSrc}`, this.vertexSrc = (0, $a416b9c2731e4690$export$c4b85a3b3361e135)(this.vertexSrc, _Program2.defaultVertexPrecision, (0, $5912637ee8cf8b9f$export$d6d3992f3becc879).HIGH), this.fragmentSrc = (0, $a416b9c2731e4690$export$c4b85a3b3361e135)(this.fragmentSrc, _Program2.defaultFragmentPrecision, (0, $350502192ad40a78$export$428c38e64838140)())), this.glPrograms = {}, this.syncUniforms = null;
    }
    /**
   * The default vertex shader source.
   * @readonly
   */ static get defaultVertexSrc() {
        return 0, $fa706684f903f0fd$export$2e2bcd8739ae039;
    }
    /**
   * The default fragment shader source.
   * @readonly
   */ static get defaultFragmentSrc() {
        return 0, $dff0b50fc787d424$export$2e2bcd8739ae039;
    }
    /**
   * A short hand function to create a program based of a vertex and fragment shader.
   *
   * This method will also check to see if there is a cached program.
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param name - Name for shader
   * @returns A shiny new PixiJS shader program!
   */ static from(vertexSrc, fragmentSrc, name) {
        const key = vertexSrc + fragmentSrc;
        let program = (0, $e0cc893a6896296f$export$d47c7e291d8b6e2c)[key];
        return program || ((0, $e0cc893a6896296f$export$d47c7e291d8b6e2c)[key] = program = new _Program2(vertexSrc, fragmentSrc, name)), program;
    }
};
$529286cda46872bb$var$_Program.defaultVertexPrecision = (0, $5912637ee8cf8b9f$export$d6d3992f3becc879).HIGH, /**
* Default specify float precision in fragment shader.
* iOS is best set at highp due to https://github.com/pixijs/pixijs/issues/3742
* @static
* @type {PIXI.PRECISION}
* @default PIXI.PRECISION.MEDIUM
*/ $529286cda46872bb$var$_Program.defaultFragmentPrecision = (0, $97611d3d7aa4c02c$export$d0a8044dce8ff2fc).apple.device ? (0, $5912637ee8cf8b9f$export$d6d3992f3becc879).HIGH : (0, $5912637ee8cf8b9f$export$d6d3992f3becc879).MEDIUM;
let $529286cda46872bb$export$b6c59b989905b650 = $529286cda46872bb$var$_Program;






let $f3ba15c3d8ec3ea5$var$UID = 0;
class $f3ba15c3d8ec3ea5$export$6601a7a2dcf79bf5 {
    /**
   * @param {object | Buffer} [uniforms] - Custom uniforms to use to augment the built-in ones. Or a pixi buffer.
   * @param isStatic - Uniforms wont be changed after creation.
   * @param isUbo - If true, will treat this uniform group as a uniform buffer object.
   */ constructor(uniforms, isStatic, isUbo){
        this.group = !0, this.syncUniforms = {}, this.dirtyId = 0, this.id = $f3ba15c3d8ec3ea5$var$UID++, this.static = !!isStatic, this.ubo = !!isUbo, uniforms instanceof (0, $4da95ef50ded5f29$export$a143d493d941bafc) ? (this.buffer = uniforms, this.buffer.type = (0, $5912637ee8cf8b9f$export$b595a7e482202b96).UNIFORM_BUFFER, this.autoManage = !1, this.ubo = !0) : (this.uniforms = uniforms, this.ubo && (this.buffer = new (0, $4da95ef50ded5f29$export$a143d493d941bafc)(new Float32Array(1)), this.buffer.type = (0, $5912637ee8cf8b9f$export$b595a7e482202b96).UNIFORM_BUFFER, this.autoManage = !0));
    }
    update() {
        this.dirtyId++, !this.autoManage && this.buffer && this.buffer.update();
    }
    add(name, uniforms, _static) {
        if (!this.ubo) this.uniforms[name] = new $f3ba15c3d8ec3ea5$export$6601a7a2dcf79bf5(uniforms, _static);
        else throw new Error("[UniformGroup] uniform groups in ubo mode cannot be modified, or have uniform groups nested in them");
    }
    static from(uniforms, _static, _ubo) {
        return new $f3ba15c3d8ec3ea5$export$6601a7a2dcf79bf5(uniforms, _static, _ubo);
    }
    /**
   * A short hand function for creating a static UBO UniformGroup.
   * @param uniforms - the ubo item
   * @param _static - should this be updated each time it is used? defaults to true here!
   */ static uboFrom(uniforms, _static) {
        return new $f3ba15c3d8ec3ea5$export$6601a7a2dcf79bf5(uniforms, _static ?? !0, !0);
    }
}


class $20320a9b1d80d7dc$export$462bb059fed9d9e5 {
    /**
   * @param program - The program the shader will use.
   * @param uniforms - Custom uniforms to use to augment the built-in ones.
   */ constructor(program, uniforms){
        this.uniformBindCount = 0, this.program = program, uniforms ? uniforms instanceof (0, $f3ba15c3d8ec3ea5$export$6601a7a2dcf79bf5) ? this.uniformGroup = uniforms : this.uniformGroup = new (0, $f3ba15c3d8ec3ea5$export$6601a7a2dcf79bf5)(uniforms) : this.uniformGroup = new (0, $f3ba15c3d8ec3ea5$export$6601a7a2dcf79bf5)({}), this.disposeRunner = new (0, $e0a754815d73db73$export$571ad3bcba5a0c45)("disposeShader");
    }
    // TODO move to shader system..
    checkUniformExists(name, group) {
        if (group.uniforms[name]) return !0;
        for(const i in group.uniforms){
            const uniform = group.uniforms[i];
            if (uniform.group === !0 && this.checkUniformExists(name, uniform)) return !0;
        }
        return !1;
    }
    destroy() {
        this.uniformGroup = null, this.disposeRunner.emit(this), this.disposeRunner.destroy();
    }
    /**
   * Shader uniform values, shortcut for `uniformGroup.uniforms`.
   * @readonly
   */ get uniforms() {
        return this.uniformGroup.uniforms;
    }
    /**
   * A short hand function to create a shader based of a vertex and fragment shader.
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param uniforms - Custom uniforms to use to augment the built-in ones.
   * @returns A shiny new PixiJS shader!
   */ static from(vertexSrc, fragmentSrc, uniforms) {
        const program = (0, $529286cda46872bb$export$b6c59b989905b650).from(vertexSrc, fragmentSrc);
        return new $20320a9b1d80d7dc$export$462bb059fed9d9e5(program, uniforms);
    }
}



class $1180236273efb0e4$export$9a4c4943b6fad72e {
    /**
   * @param vertexSrc - Vertex shader
   * @param fragTemplate - Fragment shader template
   */ constructor(vertexSrc, fragTemplate){
        if (this.vertexSrc = vertexSrc, this.fragTemplate = fragTemplate, this.programCache = {}, this.defaultGroupCache = {}, !fragTemplate.includes("%count%")) throw new Error('Fragment template must contain "%count%".');
        if (!fragTemplate.includes("%forloop%")) throw new Error('Fragment template must contain "%forloop%".');
    }
    generateShader(maxTextures) {
        if (!this.programCache[maxTextures]) {
            const sampleValues = new Int32Array(maxTextures);
            for(let i = 0; i < maxTextures; i++)sampleValues[i] = i;
            this.defaultGroupCache[maxTextures] = (0, $f3ba15c3d8ec3ea5$export$6601a7a2dcf79bf5).from({
                uSamplers: sampleValues
            }, !0);
            let fragmentSrc = this.fragTemplate;
            fragmentSrc = fragmentSrc.replace(/%count%/gi, `${maxTextures}`), fragmentSrc = fragmentSrc.replace(/%forloop%/gi, this.generateSampleSrc(maxTextures)), this.programCache[maxTextures] = new (0, $529286cda46872bb$export$b6c59b989905b650)(this.vertexSrc, fragmentSrc);
        }
        const uniforms = {
            tint: new Float32Array([
                1,
                1,
                1,
                1
            ]),
            translationMatrix: new (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85)(),
            default: this.defaultGroupCache[maxTextures]
        };
        return new (0, $20320a9b1d80d7dc$export$462bb059fed9d9e5)(this.programCache[maxTextures], uniforms);
    }
    generateSampleSrc(maxTextures) {
        let src = "";
        src += `
`, src += `
`;
        for(let i = 0; i < maxTextures; i++)i > 0 && (src += `
else `), i < maxTextures - 1 && (src += `if(vTextureId < ${i}.5)`), src += `
{`, src += `
	color = texture2D(uSamplers[${i}], vTextureCoord);`, src += `
}`;
        return src += `
`, src += `
`, src;
    }
}


class $b64836ebe443f6ff$export$aa760e0febf1a758 {
    constructor(){
        this.elements = [], this.ids = [], this.count = 0;
    }
    clear() {
        for(let i = 0; i < this.count; i++)this.elements[i] = null;
        this.count = 0;
    }
}



function $c7d7997ae5a06555$export$b839fdc6a85f84de() {
    return !(0, $97611d3d7aa4c02c$export$d0a8044dce8ff2fc).apple.device;
}



function $0214ec0c378bdd28$export$d7a652ff592da4b4(max) {
    let allowMax = !0;
    const navigator = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.getNavigator();
    if ((0, $97611d3d7aa4c02c$export$d0a8044dce8ff2fc).tablet || (0, $97611d3d7aa4c02c$export$d0a8044dce8ff2fc).phone) {
        if ((0, $97611d3d7aa4c02c$export$d0a8044dce8ff2fc).apple.device) {
            const match = navigator.userAgent.match(/OS (\d+)_(\d+)?/);
            match && parseInt(match[1], 10) < 11 && (allowMax = !1);
        }
        if ((0, $97611d3d7aa4c02c$export$d0a8044dce8ff2fc).android.device) {
            const match = navigator.userAgent.match(/Android\s([0-9.]*)/);
            match && parseInt(match[1], 10) < 7 && (allowMax = !1);
        }
    }
    return allowMax ? max : 4;
}


class $9b20378b287c50b2$export$ca67b0b0fa758253 {
    /**
   * @param renderer - The renderer this manager works for.
   */ constructor(renderer){
        this.renderer = renderer;
    }
    /** Stub method that should be used to empty the current batch by rendering objects now. */ flush() {}
    /** Generic destruction method that frees all resources. This should be called by subclasses. */ destroy() {
        this.renderer = null;
    }
    /**
   * Stub method that initializes any state required before
   * rendering starts. It is different from the `prerender`
   * signal, which occurs every frame, in that it is called
   * whenever an object requests _this_ renderer specifically.
   */ start() {}
    /** Stops the renderer. It should free up any state and become dormant. */ stop() {
        this.flush();
    }
    /**
   * Keeps the object to render. It doesn't have to be
   * rendered immediately.
   * @param {PIXI.DisplayObject} _object - The object to render.
   */ render(_object) {}
}


var $c7b4884a510f9a69$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;
varying vec4 vColor;
varying float vTextureId;
uniform sampler2D uSamplers[%count%];

void main(void){
    vec4 color;
    %forloop%
    gl_FragColor = color * vColor;
}
`;


var $1c09307484b52acc$export$2e2bcd8739ae039 = `precision highp float;
attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;
attribute vec4 aColor;
attribute float aTextureId;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform vec4 tint;

varying vec2 vTextureCoord;
varying vec4 vColor;
varying float vTextureId;

void main(void){
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = aTextureCoord;
    vTextureId = aTextureId;
    vColor = aColor * tint;
}
`;


const $2b8c6db29ee20881$var$_BatchRenderer = class _BatchRenderer2 extends (0, $9b20378b287c50b2$export$ca67b0b0fa758253) {
    /**
   * This will hook onto the renderer's `contextChange`
   * and `prerender` signals.
   * @param {PIXI.Renderer} renderer - The renderer this works for.
   */ constructor(renderer){
        super(renderer), this.setShaderGenerator(), this.geometryClass = (0, $8e8f1d0188b2afc6$export$449e8d355fd68e43), this.vertexSize = 6, this.state = (0, $05d0e9a749f67df1$export$7254cc27399e90bd).for2d(), this.size = _BatchRenderer2.defaultBatchSize * 4, this._vertexCount = 0, this._indexCount = 0, this._bufferedElements = [], this._bufferedTextures = [], this._bufferSize = 0, this._shader = null, this._packedGeometries = [], this._packedGeometryPoolSize = 2, this._flushId = 0, this._aBuffers = {}, this._iBuffers = {}, this.maxTextures = 1, this.renderer.on("prerender", this.onPrerender, this), renderer.runners.contextChange.add(this), this._dcIndex = 0, this._aIndex = 0, this._iIndex = 0, this._attributeBuffer = null, this._indexBuffer = null, this._tempBoundTextures = [];
    }
    /**
   * The maximum textures that this device supports.
   * @static
   * @default 32
   */ static get defaultMaxTextures() {
        return this._defaultMaxTextures = this._defaultMaxTextures ?? (0, $0214ec0c378bdd28$export$d7a652ff592da4b4)(32), this._defaultMaxTextures;
    }
    static set defaultMaxTextures(value) {
        this._defaultMaxTextures = value;
    }
    /**
   * Can we upload the same buffer in a single frame?
   * @static
   */ static get canUploadSameBuffer() {
        return this._canUploadSameBuffer = this._canUploadSameBuffer ?? (0, $c7d7997ae5a06555$export$b839fdc6a85f84de)(), this._canUploadSameBuffer;
    }
    static set canUploadSameBuffer(value) {
        this._canUploadSameBuffer = value;
    }
    /**
   * @see PIXI.BatchRenderer#maxTextures
   * @deprecated since 7.1.0
   * @readonly
   */ get MAX_TEXTURES() {
        return (0, $4835512019cf238f$export$afd31d834b512e89)("7.1.0", "BatchRenderer#MAX_TEXTURES renamed to BatchRenderer#maxTextures"), this.maxTextures;
    }
    /**
   * The default vertex shader source
   * @readonly
   */ static get defaultVertexSrc() {
        return 0, $1c09307484b52acc$export$2e2bcd8739ae039;
    }
    /**
   * The default fragment shader source
   * @readonly
   */ static get defaultFragmentTemplate() {
        return 0, $c7b4884a510f9a69$export$2e2bcd8739ae039;
    }
    /**
   * Set the shader generator.
   * @param {object} [options]
   * @param {string} [options.vertex=PIXI.BatchRenderer.defaultVertexSrc] - Vertex shader source
   * @param {string} [options.fragment=PIXI.BatchRenderer.defaultFragmentTemplate] - Fragment shader template
   */ setShaderGenerator({ vertex: vertex = _BatchRenderer2.defaultVertexSrc, fragment: fragment = _BatchRenderer2.defaultFragmentTemplate } = {}) {
        this.shaderGenerator = new (0, $1180236273efb0e4$export$9a4c4943b6fad72e)(vertex, fragment);
    }
    /**
   * Handles the `contextChange` signal.
   *
   * It calculates `this.maxTextures` and allocating the packed-geometry object pool.
   */ contextChange() {
        const gl = this.renderer.gl;
        (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).PREFER_ENV === (0, $5912637ee8cf8b9f$export$83401e34d5e11bf4).WEBGL_LEGACY ? this.maxTextures = 1 : (this.maxTextures = Math.min(gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS), _BatchRenderer2.defaultMaxTextures), this.maxTextures = (0, $8f69ead8a5e1d6ee$export$fb6ad4e758d74cc0)(this.maxTextures, gl)), this._shader = this.shaderGenerator.generateShader(this.maxTextures);
        for(let i = 0; i < this._packedGeometryPoolSize; i++)this._packedGeometries[i] = new this.geometryClass();
        this.initFlushBuffers();
    }
    /** Makes sure that static and dynamic flush pooled objects have correct dimensions. */ initFlushBuffers() {
        const { _drawCallPool: _drawCallPool, _textureArrayPool: _textureArrayPool } = _BatchRenderer2, MAX_SPRITES = this.size / 4, MAX_TA = Math.floor(MAX_SPRITES / this.maxTextures) + 1;
        for(; _drawCallPool.length < MAX_SPRITES;)_drawCallPool.push(new (0, $3c8543b1b17058da$export$664fd198634fda29)());
        for(; _textureArrayPool.length < MAX_TA;)_textureArrayPool.push(new (0, $b64836ebe443f6ff$export$aa760e0febf1a758)());
        for(let i = 0; i < this.maxTextures; i++)this._tempBoundTextures[i] = null;
    }
    /** Handles the `prerender` signal. It ensures that flushes start from the first geometry object again. */ onPrerender() {
        this._flushId = 0;
    }
    /**
   * Buffers the "batchable" object. It need not be rendered immediately.
   * @param {PIXI.DisplayObject} element - the element to render when
   *    using this renderer
   */ render(element) {
        element._texture.valid && (this._vertexCount + element.vertexData.length / 2 > this.size && this.flush(), this._vertexCount += element.vertexData.length / 2, this._indexCount += element.indices.length, this._bufferedTextures[this._bufferSize] = element._texture.baseTexture, this._bufferedElements[this._bufferSize++] = element);
    }
    buildTexturesAndDrawCalls() {
        const { _bufferedTextures: textures, maxTextures: maxTextures } = this, textureArrays = _BatchRenderer2._textureArrayPool, batch = this.renderer.batch, boundTextures = this._tempBoundTextures, touch = this.renderer.textureGC.count;
        let TICK = ++(0, $997b0e421c4045eb$export$d6306e508f184154)._globalBatch, countTexArrays = 0, texArray = textureArrays[0], start = 0;
        batch.copyBoundTextures(boundTextures, maxTextures);
        for(let i = 0; i < this._bufferSize; ++i){
            const tex = textures[i];
            textures[i] = null, tex._batchEnabled !== TICK && (texArray.count >= maxTextures && (batch.boundArray(texArray, boundTextures, TICK, maxTextures), this.buildDrawCalls(texArray, start, i), start = i, texArray = textureArrays[++countTexArrays], ++TICK), tex._batchEnabled = TICK, tex.touched = touch, texArray.elements[texArray.count++] = tex);
        }
        texArray.count > 0 && (batch.boundArray(texArray, boundTextures, TICK, maxTextures), this.buildDrawCalls(texArray, start, this._bufferSize), ++countTexArrays, ++TICK);
        for(let i = 0; i < boundTextures.length; i++)boundTextures[i] = null;
        (0, $997b0e421c4045eb$export$d6306e508f184154)._globalBatch = TICK;
    }
    /**
   * Populating drawcalls for rendering
   * @param texArray
   * @param start
   * @param finish
   */ buildDrawCalls(texArray, start, finish) {
        const { _bufferedElements: elements, _attributeBuffer: _attributeBuffer, _indexBuffer: _indexBuffer, vertexSize: vertexSize } = this, drawCalls = _BatchRenderer2._drawCallPool;
        let dcIndex = this._dcIndex, aIndex = this._aIndex, iIndex = this._iIndex, drawCall = drawCalls[dcIndex];
        drawCall.start = this._iIndex, drawCall.texArray = texArray;
        for(let i = start; i < finish; ++i){
            const sprite = elements[i], tex = sprite._texture.baseTexture, spriteBlendMode = (0, $7b974150e84e102b$export$799d0d31e2f4c737)[tex.alphaMode ? 1 : 0][sprite.blendMode];
            elements[i] = null, start < i && drawCall.blend !== spriteBlendMode && (drawCall.size = iIndex - drawCall.start, start = i, drawCall = drawCalls[++dcIndex], drawCall.texArray = texArray, drawCall.start = iIndex), this.packInterleavedGeometry(sprite, _attributeBuffer, _indexBuffer, aIndex, iIndex), aIndex += sprite.vertexData.length / 2 * vertexSize, iIndex += sprite.indices.length, drawCall.blend = spriteBlendMode;
        }
        start < finish && (drawCall.size = iIndex - drawCall.start, ++dcIndex), this._dcIndex = dcIndex, this._aIndex = aIndex, this._iIndex = iIndex;
    }
    /**
   * Bind textures for current rendering
   * @param texArray
   */ bindAndClearTexArray(texArray) {
        const textureSystem = this.renderer.texture;
        for(let j = 0; j < texArray.count; j++)textureSystem.bind(texArray.elements[j], texArray.ids[j]), texArray.elements[j] = null;
        texArray.count = 0;
    }
    updateGeometry() {
        const { _packedGeometries: packedGeometries, _attributeBuffer: attributeBuffer, _indexBuffer: indexBuffer } = this;
        _BatchRenderer2.canUploadSameBuffer ? (packedGeometries[this._flushId]._buffer.update(attributeBuffer.rawBinaryData), packedGeometries[this._flushId]._indexBuffer.update(indexBuffer), this.renderer.geometry.updateBuffers()) : (this._packedGeometryPoolSize <= this._flushId && (this._packedGeometryPoolSize++, packedGeometries[this._flushId] = new this.geometryClass()), packedGeometries[this._flushId]._buffer.update(attributeBuffer.rawBinaryData), packedGeometries[this._flushId]._indexBuffer.update(indexBuffer), this.renderer.geometry.bind(packedGeometries[this._flushId]), this.renderer.geometry.updateBuffers(), this._flushId++);
    }
    drawBatches() {
        const dcCount = this._dcIndex, { gl: gl, state: stateSystem } = this.renderer, drawCalls = _BatchRenderer2._drawCallPool;
        let curTexArray = null;
        for(let i = 0; i < dcCount; i++){
            const { texArray: texArray, type: type, size: size, start: start, blend: blend } = drawCalls[i];
            curTexArray !== texArray && (curTexArray = texArray, this.bindAndClearTexArray(texArray)), this.state.blendMode = blend, stateSystem.set(this.state), gl.drawElements(type, size, gl.UNSIGNED_SHORT, start * 2);
        }
    }
    /** Renders the content _now_ and empties the current batch. */ flush() {
        this._vertexCount !== 0 && (this._attributeBuffer = this.getAttributeBuffer(this._vertexCount), this._indexBuffer = this.getIndexBuffer(this._indexCount), this._aIndex = 0, this._iIndex = 0, this._dcIndex = 0, this.buildTexturesAndDrawCalls(), this.updateGeometry(), this.drawBatches(), this._bufferSize = 0, this._vertexCount = 0, this._indexCount = 0);
    }
    /** Starts a new sprite batch. */ start() {
        this.renderer.state.set(this.state), this.renderer.texture.ensureSamplerType(this.maxTextures), this.renderer.shader.bind(this._shader), _BatchRenderer2.canUploadSameBuffer && this.renderer.geometry.bind(this._packedGeometries[this._flushId]);
    }
    /** Stops and flushes the current batch. */ stop() {
        this.flush();
    }
    /** Destroys this `BatchRenderer`. It cannot be used again. */ destroy() {
        for(let i = 0; i < this._packedGeometryPoolSize; i++)this._packedGeometries[i] && this._packedGeometries[i].destroy();
        this.renderer.off("prerender", this.onPrerender, this), this._aBuffers = null, this._iBuffers = null, this._packedGeometries = null, this._attributeBuffer = null, this._indexBuffer = null, this._shader && (this._shader.destroy(), this._shader = null), super.destroy();
    }
    /**
   * Fetches an attribute buffer from `this._aBuffers` that can hold atleast `size` floats.
   * @param size - minimum capacity required
   * @returns - buffer than can hold atleast `size` floats
   */ getAttributeBuffer(size) {
        const roundedP2 = (0, $1101e8b3767a1e48$export$f0d90cf68bd426eb)(Math.ceil(size / 8)), roundedSizeIndex = (0, $1101e8b3767a1e48$export$b9fae0bba9d9094d)(roundedP2), roundedSize = roundedP2 * 8;
        this._aBuffers.length <= roundedSizeIndex && (this._iBuffers.length = roundedSizeIndex + 1);
        let buffer = this._aBuffers[roundedSize];
        return buffer || (this._aBuffers[roundedSize] = buffer = new (0, $91d9b5ed0541dc7e$export$4fdbf0662aa3047a)(roundedSize * this.vertexSize * 4)), buffer;
    }
    /**
   * Fetches an index buffer from `this._iBuffers` that can
   * have at least `size` capacity.
   * @param size - minimum required capacity
   * @returns - buffer that can fit `size` indices.
   */ getIndexBuffer(size) {
        const roundedP2 = (0, $1101e8b3767a1e48$export$f0d90cf68bd426eb)(Math.ceil(size / 12)), roundedSizeIndex = (0, $1101e8b3767a1e48$export$b9fae0bba9d9094d)(roundedP2), roundedSize = roundedP2 * 12;
        this._iBuffers.length <= roundedSizeIndex && (this._iBuffers.length = roundedSizeIndex + 1);
        let buffer = this._iBuffers[roundedSizeIndex];
        return buffer || (this._iBuffers[roundedSizeIndex] = buffer = new Uint16Array(roundedSize)), buffer;
    }
    /**
   * Takes the four batching parameters of `element`, interleaves
   * and pushes them into the batching attribute/index buffers given.
   *
   * It uses these properties: `vertexData` `uvs`, `textureId` and
   * `indicies`. It also uses the "tint" of the base-texture, if
   * present.
   * @param {PIXI.DisplayObject} element - element being rendered
   * @param attributeBuffer - attribute buffer.
   * @param indexBuffer - index buffer
   * @param aIndex - number of floats already in the attribute buffer
   * @param iIndex - number of indices already in `indexBuffer`
   */ packInterleavedGeometry(element, attributeBuffer, indexBuffer, aIndex, iIndex) {
        const { uint32View: uint32View, float32View: float32View } = attributeBuffer, packedVertices = aIndex / this.vertexSize, uvs = element.uvs, indicies = element.indices, vertexData = element.vertexData, textureId = element._texture.baseTexture._batchLocation, alpha = Math.min(element.worldAlpha, 1), argb = (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(element._tintRGB).toPremultiplied(alpha, element._texture.baseTexture.alphaMode > 0);
        for(let i = 0; i < vertexData.length; i += 2)float32View[aIndex++] = vertexData[i], float32View[aIndex++] = vertexData[i + 1], float32View[aIndex++] = uvs[i], float32View[aIndex++] = uvs[i + 1], uint32View[aIndex++] = argb, float32View[aIndex++] = textureId;
        for(let i = 0; i < indicies.length; i++)indexBuffer[iIndex++] = packedVertices + indicies[i];
    }
};
$2b8c6db29ee20881$var$_BatchRenderer.defaultBatchSize = 4096, /** @ignore */ $2b8c6db29ee20881$var$_BatchRenderer.extension = {
    name: "batch",
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererPlugin
}, /**
* Pool of `BatchDrawCall` objects that `flush` used
* to create "batches" of the objects being rendered.
*
* These are never re-allocated again.
* Shared between all batch renderers because it can be only one "flush" working at the moment.
* @member {PIXI.BatchDrawCall[]}
*/ $2b8c6db29ee20881$var$_BatchRenderer._drawCallPool = [], /**
* Pool of `BatchDrawCall` objects that `flush` used
* to create "batches" of the objects being rendered.
*
* These are never re-allocated again.
* Shared between all batch renderers because it can be only one "flush" working at the moment.
* @member {PIXI.BatchTextureArray[]}
*/ $2b8c6db29ee20881$var$_BatchRenderer._textureArrayPool = [];
let $2b8c6db29ee20881$export$c6a34b759a134e1d = $2b8c6db29ee20881$var$_BatchRenderer;
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($2b8c6db29ee20881$export$c6a34b759a134e1d);






var $74ae57cd816bd132$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;

void main(void){
   gl_FragColor = texture2D(uSampler, vTextureCoord);
}
`;


var $88aef4d55b9c6399$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}
`;


const $344aa8e787d8e10a$var$_Filter = class _Filter2 extends (0, $20320a9b1d80d7dc$export$462bb059fed9d9e5) {
    /**
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param uniforms - Custom uniforms to use to augment the built-in ones.
   */ constructor(vertexSrc, fragmentSrc, uniforms){
        const program = (0, $529286cda46872bb$export$b6c59b989905b650).from(vertexSrc || _Filter2.defaultVertexSrc, fragmentSrc || _Filter2.defaultFragmentSrc);
        super(program, uniforms), this.padding = 0, this.resolution = _Filter2.defaultResolution, this.multisample = _Filter2.defaultMultisample, this.enabled = !0, this.autoFit = !0, this.state = new (0, $05d0e9a749f67df1$export$7254cc27399e90bd)();
    }
    /**
   * Applies the filter
   * @param {PIXI.FilterSystem} filterManager - The renderer to retrieve the filter from
   * @param {PIXI.RenderTexture} input - The input render target.
   * @param {PIXI.RenderTexture} output - The target to output to.
   * @param {PIXI.CLEAR_MODES} [clearMode] - Should the output be cleared before rendering to it.
   * @param {object} [_currentState] - It's current state of filter.
   *        There are some useful properties in the currentState :
   *        target, filters, sourceFrame, destinationFrame, renderTarget, resolution
   */ apply(filterManager, input, output, clearMode, _currentState) {
        filterManager.applyFilter(this, input, output, clearMode);
    }
    /**
   * Sets the blend mode of the filter.
   * @default PIXI.BLEND_MODES.NORMAL
   */ get blendMode() {
        return this.state.blendMode;
    }
    set blendMode(value) {
        this.state.blendMode = value;
    }
    /**
   * The resolution of the filter. Setting this to be lower will lower the quality but
   * increase the performance of the filter.
   * If set to `null` or `0`, the resolution of the current render target is used.
   * @default PIXI.Filter.defaultResolution
   */ get resolution() {
        return this._resolution;
    }
    set resolution(value) {
        this._resolution = value;
    }
    /**
   * The default vertex shader source
   * @readonly
   */ static get defaultVertexSrc() {
        return 0, $88aef4d55b9c6399$export$2e2bcd8739ae039;
    }
    /**
   * The default fragment shader source
   * @readonly
   */ static get defaultFragmentSrc() {
        return 0, $74ae57cd816bd132$export$2e2bcd8739ae039;
    }
};
$344aa8e787d8e10a$var$_Filter.defaultResolution = 1, /**
* Default filter samples for any filter.
* @static
* @type {PIXI.MSAA_QUALITY|null}
* @default PIXI.MSAA_QUALITY.NONE
*/ $344aa8e787d8e10a$var$_Filter.defaultMultisample = (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).NONE;
let $344aa8e787d8e10a$export$ec91da630f36d5ea = $344aa8e787d8e10a$var$_Filter;





class $47dd118c3911f833$export$c69cd65c8827ac23 {
    constructor(){
        this.clearBeforeRender = !0, this._backgroundColor = new (0, $3119899e085d9ccf$export$892596cec99bc70e)(0), this.alpha = 1;
    }
    /**
   * initiates the background system
   * @param {PIXI.IRendererOptions} options - the options for the background colors
   */ init(options) {
        this.clearBeforeRender = options.clearBeforeRender;
        const { backgroundColor: backgroundColor, background: background, backgroundAlpha: backgroundAlpha } = options, color = background ?? backgroundColor;
        color !== void 0 && (this.color = color), this.alpha = backgroundAlpha;
    }
    /**
   * The background color to fill if not transparent.
   * @member {PIXI.ColorSource}
   */ get color() {
        return this._backgroundColor.value;
    }
    set color(value) {
        this._backgroundColor.setValue(value);
    }
    /**
   * The background color alpha. Setting this to 0 will make the canvas transparent.
   * @member {number}
   */ get alpha() {
        return this._backgroundColor.alpha;
    }
    set alpha(value) {
        this._backgroundColor.setAlpha(value);
    }
    /** The background color object. */ get backgroundColor() {
        return this._backgroundColor;
    }
    destroy() {}
}
$47dd118c3911f833$export$c69cd65c8827ac23.defaultOptions = {
    /**
   * {@link PIXI.IRendererOptions.backgroundAlpha}
   * @default 1
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ backgroundAlpha: 1,
    /**
   * {@link PIXI.IRendererOptions.backgroundColor}
   * @default 0x000000
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ backgroundColor: 0,
    /**
   * {@link PIXI.IRendererOptions.clearBeforeRender}
   * @default true
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ clearBeforeRender: !0
}, /** @ignore */ $47dd118c3911f833$export$c69cd65c8827ac23.extension = {
    type: [
        (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
        (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).CanvasRendererSystem
    ],
    name: "background"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($47dd118c3911f833$export$c69cd65c8827ac23);




class $8e4b715541ce95a6$export$beb481275b7bcccc {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.emptyRenderer = new (0, $9b20378b287c50b2$export$ca67b0b0fa758253)(renderer), this.currentRenderer = this.emptyRenderer;
    }
    /**
   * Changes the current renderer to the one given in parameter
   * @param objectRenderer - The object renderer to use.
   */ setObjectRenderer(objectRenderer) {
        this.currentRenderer !== objectRenderer && (this.currentRenderer.stop(), this.currentRenderer = objectRenderer, this.currentRenderer.start());
    }
    /**
   * This should be called if you wish to do some custom rendering
   * It will basically render anything that may be batched up such as sprites
   */ flush() {
        this.setObjectRenderer(this.emptyRenderer);
    }
    /** Reset the system to an empty renderer */ reset() {
        this.setObjectRenderer(this.emptyRenderer);
    }
    /**
   * Handy function for batch renderers: copies bound textures in first maxTextures locations to array
   * sets actual _batchLocation for them
   * @param arr - arr copy destination
   * @param maxTextures - number of copied elements
   */ copyBoundTextures(arr, maxTextures) {
        const { boundTextures: boundTextures } = this.renderer.texture;
        for(let i = maxTextures - 1; i >= 0; --i)arr[i] = boundTextures[i] || null, arr[i] && (arr[i]._batchLocation = i);
    }
    /**
   * Assigns batch locations to textures in array based on boundTextures state.
   * All textures in texArray should have `_batchEnabled = _batchId`,
   * and their count should be less than `maxTextures`.
   * @param texArray - textures to bound
   * @param boundTextures - current state of bound textures
   * @param batchId - marker for _batchEnabled param of textures in texArray
   * @param maxTextures - number of texture locations to manipulate
   */ boundArray(texArray, boundTextures, batchId, maxTextures) {
        const { elements: elements, ids: ids, count: count } = texArray;
        let j = 0;
        for(let i = 0; i < count; i++){
            const tex = elements[i], loc = tex._batchLocation;
            if (loc >= 0 && loc < maxTextures && boundTextures[loc] === tex) {
                ids[i] = loc;
                continue;
            }
            for(; j < maxTextures;){
                const bound = boundTextures[j];
                if (bound && bound._batchEnabled === batchId && bound._batchLocation === j) {
                    j++;
                    continue;
                }
                ids[i] = j, tex._batchLocation = j, boundTextures[j] = tex;
                break;
            }
        }
    }
    /**
   * @ignore
   */ destroy() {
        this.renderer = null;
    }
}
$8e4b715541ce95a6$export$beb481275b7bcccc.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
    name: "batch"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($8e4b715541ce95a6$export$beb481275b7bcccc);





let $6f1e1f74b744547a$var$CONTEXT_UID_COUNTER = 0;
class $6f1e1f74b744547a$export$fedaac80f6f9518c {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        this.renderer = renderer, this.webGLVersion = 1, this.extensions = {}, this.supports = {
            uint32Indices: !1
        }, this.handleContextLost = this.handleContextLost.bind(this), this.handleContextRestored = this.handleContextRestored.bind(this);
    }
    /**
   * `true` if the context is lost
   * @readonly
   */ get isLost() {
        return !this.gl || this.gl.isContextLost();
    }
    /**
   * Handles the context change event.
   * @param {WebGLRenderingContext} gl - New WebGL context.
   */ contextChange(gl) {
        this.gl = gl, this.renderer.gl = gl, this.renderer.CONTEXT_UID = $6f1e1f74b744547a$var$CONTEXT_UID_COUNTER++;
    }
    init(options) {
        if (options.context) this.initFromContext(options.context);
        else {
            const alpha = this.renderer.background.alpha < 1, premultipliedAlpha = options.premultipliedAlpha;
            this.preserveDrawingBuffer = options.preserveDrawingBuffer, this.useContextAlpha = options.useContextAlpha, this.powerPreference = options.powerPreference, this.initFromOptions({
                alpha: alpha,
                premultipliedAlpha: premultipliedAlpha,
                antialias: options.antialias,
                stencil: !0,
                preserveDrawingBuffer: options.preserveDrawingBuffer,
                powerPreference: options.powerPreference
            });
        }
    }
    /**
   * Initializes the context.
   * @protected
   * @param {WebGLRenderingContext} gl - WebGL context
   */ initFromContext(gl) {
        this.gl = gl, this.validateContext(gl), this.renderer.gl = gl, this.renderer.CONTEXT_UID = $6f1e1f74b744547a$var$CONTEXT_UID_COUNTER++, this.renderer.runners.contextChange.emit(gl);
        const view = this.renderer.view;
        view.addEventListener !== void 0 && (view.addEventListener("webglcontextlost", this.handleContextLost, !1), view.addEventListener("webglcontextrestored", this.handleContextRestored, !1));
    }
    /**
   * Initialize from context options
   * @protected
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/getContext
   * @param {object} options - context attributes
   */ initFromOptions(options) {
        const gl = this.createContext(this.renderer.view, options);
        this.initFromContext(gl);
    }
    /**
   * Helper class to create a WebGL Context
   * @param canvas - the canvas element that we will get the context from
   * @param options - An options object that gets passed in to the canvas element containing the
   *    context attributes
   * @see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext
   * @returns {WebGLRenderingContext} the WebGL context
   */ createContext(canvas, options) {
        let gl;
        if ((0, $5340ccf8570d4063$export$a5a6e0b888b2c992).PREFER_ENV >= (0, $5912637ee8cf8b9f$export$83401e34d5e11bf4).WEBGL2 && (gl = canvas.getContext("webgl2", options)), gl) this.webGLVersion = 2;
        else if (this.webGLVersion = 1, gl = canvas.getContext("webgl", options) || canvas.getContext("experimental-webgl", options), !gl) throw new Error("This browser does not support WebGL. Try using the canvas renderer");
        return this.gl = gl, this.getExtensions(), this.gl;
    }
    /** Auto-populate the {@link PIXI.ContextSystem.extensions extensions}. */ getExtensions() {
        const { gl: gl } = this, common = {
            loseContext: gl.getExtension("WEBGL_lose_context"),
            anisotropicFiltering: gl.getExtension("EXT_texture_filter_anisotropic"),
            floatTextureLinear: gl.getExtension("OES_texture_float_linear"),
            s3tc: gl.getExtension("WEBGL_compressed_texture_s3tc"),
            s3tc_sRGB: gl.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
            // eslint-disable-line camelcase
            etc: gl.getExtension("WEBGL_compressed_texture_etc"),
            etc1: gl.getExtension("WEBGL_compressed_texture_etc1"),
            pvrtc: gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
            atc: gl.getExtension("WEBGL_compressed_texture_atc"),
            astc: gl.getExtension("WEBGL_compressed_texture_astc")
        };
        this.webGLVersion === 1 ? Object.assign(this.extensions, common, {
            drawBuffers: gl.getExtension("WEBGL_draw_buffers"),
            depthTexture: gl.getExtension("WEBGL_depth_texture"),
            vertexArrayObject: gl.getExtension("OES_vertex_array_object") || gl.getExtension("MOZ_OES_vertex_array_object") || gl.getExtension("WEBKIT_OES_vertex_array_object"),
            uint32ElementIndex: gl.getExtension("OES_element_index_uint"),
            // Floats and half-floats
            floatTexture: gl.getExtension("OES_texture_float"),
            floatTextureLinear: gl.getExtension("OES_texture_float_linear"),
            textureHalfFloat: gl.getExtension("OES_texture_half_float"),
            textureHalfFloatLinear: gl.getExtension("OES_texture_half_float_linear")
        }) : this.webGLVersion === 2 && Object.assign(this.extensions, common, {
            // Floats and half-floats
            colorBufferFloat: gl.getExtension("EXT_color_buffer_float")
        });
    }
    /**
   * Handles a lost webgl context
   * @param {WebGLContextEvent} event - The context lost event.
   */ handleContextLost(event) {
        event.preventDefault(), setTimeout(()=>{
            this.gl.isContextLost() && this.extensions.loseContext && this.extensions.loseContext.restoreContext();
        }, 0);
    }
    /** Handles a restored webgl context. */ handleContextRestored() {
        this.renderer.runners.contextChange.emit(this.gl);
    }
    destroy() {
        const view = this.renderer.view;
        this.renderer = null, view.removeEventListener !== void 0 && (view.removeEventListener("webglcontextlost", this.handleContextLost), view.removeEventListener("webglcontextrestored", this.handleContextRestored)), this.gl.useProgram(null), this.extensions.loseContext && this.extensions.loseContext.loseContext();
    }
    /** Handle the post-render runner event. */ postrender() {
        this.renderer.objectRenderer.renderingToScreen && this.gl.flush();
    }
    /**
   * Validate context.
   * @param {WebGLRenderingContext} gl - Render context.
   */ validateContext(gl) {
        const attributes = gl.getContextAttributes(), isWebGl2 = "WebGL2RenderingContext" in globalThis && gl instanceof globalThis.WebGL2RenderingContext;
        isWebGl2 && (this.webGLVersion = 2), attributes && !attributes.stencil && console.warn("Provided WebGL context does not have a stencil buffer, masks may not render correctly");
        const hasuint32 = isWebGl2 || !!gl.getExtension("OES_element_index_uint");
        this.supports.uint32Indices = hasuint32, hasuint32 || console.warn("Provided WebGL context does not support 32 index buffer, complex graphics may not render correctly");
    }
}
$6f1e1f74b744547a$export$fedaac80f6f9518c.defaultOptions = {
    /**
   * {@link PIXI.IRendererOptions.context}
   * @default null
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ context: null,
    /**
   * {@link PIXI.IRendererOptions.antialias}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ antialias: !1,
    /**
   * {@link PIXI.IRendererOptions.premultipliedAlpha}
   * @default true
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ premultipliedAlpha: !0,
    /**
   * {@link PIXI.IRendererOptions.preserveDrawingBuffer}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ preserveDrawingBuffer: !1,
    /**
   * {@link PIXI.IRendererOptions.powerPreference}
   * @default default
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ powerPreference: "default"
}, /** @ignore */ $6f1e1f74b744547a$export$fedaac80f6f9518c.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
    name: "context"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($6f1e1f74b744547a$export$fedaac80f6f9518c);












class $8bbab5b5070242d8$export$eff95f126aa67cfb {
    /**
   * @param width - Width of the frame buffer
   * @param height - Height of the frame buffer
   */ constructor(width, height){
        if (this.width = Math.round(width), this.height = Math.round(height), !this.width || !this.height) throw new Error("Framebuffer width or height is zero");
        this.stencil = !1, this.depth = !1, this.dirtyId = 0, this.dirtyFormat = 0, this.dirtySize = 0, this.depthTexture = null, this.colorTextures = [], this.glFramebuffers = {}, this.disposeRunner = new (0, $e0a754815d73db73$export$571ad3bcba5a0c45)("disposeFramebuffer"), this.multisample = (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).NONE;
    }
    /**
   * Reference to the colorTexture.
   * @readonly
   */ get colorTexture() {
        return this.colorTextures[0];
    }
    /**
   * Add texture to the colorTexture array.
   * @param index - Index of the array to add the texture to
   * @param texture - Texture to add to the array
   */ addColorTexture(index = 0, texture) {
        return this.colorTextures[index] = texture || new (0, $997b0e421c4045eb$export$d6306e508f184154)(null, {
            scaleMode: (0, $5912637ee8cf8b9f$export$6b734c6a0bba8473).NEAREST,
            resolution: 1,
            mipmap: (0, $5912637ee8cf8b9f$export$16f6fb5da874bbfd).OFF,
            width: this.width,
            height: this.height
        }), this.dirtyId++, this.dirtyFormat++, this;
    }
    /**
   * Add a depth texture to the frame buffer.
   * @param texture - Texture to add.
   */ addDepthTexture(texture) {
        return this.depthTexture = texture || new (0, $997b0e421c4045eb$export$d6306e508f184154)(null, {
            scaleMode: (0, $5912637ee8cf8b9f$export$6b734c6a0bba8473).NEAREST,
            resolution: 1,
            width: this.width,
            height: this.height,
            mipmap: (0, $5912637ee8cf8b9f$export$16f6fb5da874bbfd).OFF,
            format: (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).DEPTH_COMPONENT,
            type: (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_SHORT
        }), this.dirtyId++, this.dirtyFormat++, this;
    }
    /** Enable depth on the frame buffer. */ enableDepth() {
        return this.depth = !0, this.dirtyId++, this.dirtyFormat++, this;
    }
    /** Enable stencil on the frame buffer. */ enableStencil() {
        return this.stencil = !0, this.dirtyId++, this.dirtyFormat++, this;
    }
    /**
   * Resize the frame buffer
   * @param width - Width of the frame buffer to resize to
   * @param height - Height of the frame buffer to resize to
   */ resize(width, height) {
        if (width = Math.round(width), height = Math.round(height), !width || !height) throw new Error("Framebuffer width and height must not be zero");
        if (!(width === this.width && height === this.height)) {
            this.width = width, this.height = height, this.dirtyId++, this.dirtySize++;
            for(let i = 0; i < this.colorTextures.length; i++){
                const texture = this.colorTextures[i], resolution = texture.resolution;
                texture.setSize(width / resolution, height / resolution);
            }
            if (this.depthTexture) {
                const resolution = this.depthTexture.resolution;
                this.depthTexture.setSize(width / resolution, height / resolution);
            }
        }
    }
    /** Disposes WebGL resources that are connected to this geometry. */ dispose() {
        this.disposeRunner.emit(this, !1);
    }
    /** Destroys and removes the depth texture added to this framebuffer. */ destroyDepthTexture() {
        this.depthTexture && (this.depthTexture.destroy(), this.depthTexture = null, ++this.dirtyId, ++this.dirtyFormat);
    }
}



class $d3103ef1e96b190b$export$18d268c71e34cf2c extends (0, $997b0e421c4045eb$export$d6306e508f184154) {
    /**
   * @param options
   * @param {number} [options.width=100] - The width of the base render texture.
   * @param {number} [options.height=100] - The height of the base render texture.
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.BaseTexture.defaultOptions.scaleMode] - See {@link PIXI.SCALE_MODES}
   *   for possible values.
   * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio
   *   of the texture being generated.
   * @param {PIXI.MSAA_QUALITY} [options.multisample=PIXI.MSAA_QUALITY.NONE] - The number of samples of the frame buffer.
   */ constructor(options = {}){
        if (typeof options == "number") {
            const width = arguments[0], height = arguments[1], scaleMode = arguments[2], resolution = arguments[3];
            options = {
                width: width,
                height: height,
                scaleMode: scaleMode,
                resolution: resolution
            };
        }
        options.width = options.width ?? 100, options.height = options.height ?? 100, options.multisample ?? (options.multisample = (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).NONE), super(null, options), this.mipmap = (0, $5912637ee8cf8b9f$export$16f6fb5da874bbfd).OFF, this.valid = !0, this._clear = new (0, $3119899e085d9ccf$export$892596cec99bc70e)([
            0,
            0,
            0,
            0
        ]), this.framebuffer = new (0, $8bbab5b5070242d8$export$eff95f126aa67cfb)(this.realWidth, this.realHeight).addColorTexture(0, this), this.framebuffer.multisample = options.multisample, this.maskStack = [], this.filterStack = [
            {}
        ];
    }
    /** Color when clearning the texture. */ set clearColor(value) {
        this._clear.setValue(value);
    }
    get clearColor() {
        return this._clear.value;
    }
    /**
   * Color object when clearning the texture.
   * @readonly
   * @since 7.2.0
   */ get clear() {
        return this._clear;
    }
    /**
   * Shortcut to `this.framebuffer.multisample`.
   * @default PIXI.MSAA_QUALITY.NONE
   */ get multisample() {
        return this.framebuffer.multisample;
    }
    set multisample(value) {
        this.framebuffer.multisample = value;
    }
    /**
   * Resizes the BaseRenderTexture.
   * @param desiredWidth - The desired width to resize to.
   * @param desiredHeight - The desired height to resize to.
   */ resize(desiredWidth, desiredHeight) {
        this.framebuffer.resize(desiredWidth * this.resolution, desiredHeight * this.resolution), this.setRealSize(this.framebuffer.width, this.framebuffer.height);
    }
    /**
   * Frees the texture and framebuffer from WebGL memory without destroying this texture object.
   * This means you can still use the texture later which will upload it to GPU
   * memory again.
   * @fires PIXI.BaseTexture#dispose
   */ dispose() {
        this.framebuffer.dispose(), super.dispose();
    }
    /** Destroys this texture. */ destroy() {
        super.destroy(), this.framebuffer.destroyDepthTexture(), this.framebuffer = null;
    }
}











class $6510438b65c3a417$export$c87b2a1e7e3bb4a6 extends (0, $6049fedc760de0ea$export$39a853cfb5a94a63) {
    /**
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas} source
   */ constructor(source){
        const sourceAny = source, width = sourceAny.naturalWidth || sourceAny.videoWidth || sourceAny.width, height = sourceAny.naturalHeight || sourceAny.videoHeight || sourceAny.height;
        super(width, height), this.source = source, this.noSubImage = !1;
    }
    /**
   * Set cross origin based detecting the url and the crossorigin
   * @param element - Element to apply crossOrigin
   * @param url - URL to check
   * @param crossorigin - Cross origin value to use
   */ static crossOrigin(element, url, crossorigin) {
        crossorigin === void 0 && !url.startsWith("data:") ? element.crossOrigin = (0, $4e976dc7290fc1f8$export$292083da55c5b406)(url) : crossorigin !== !1 && (element.crossOrigin = typeof crossorigin == "string" ? crossorigin : "anonymous");
    }
    /**
   * Upload the texture to the GPU.
   * @param renderer - Upload to the renderer
   * @param baseTexture - Reference to parent texture
   * @param glTexture
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas} [source] - (optional)
   * @returns - true is success
   */ upload(renderer, baseTexture, glTexture, source) {
        const gl = renderer.gl, width = baseTexture.realWidth, height = baseTexture.realHeight;
        if (source = source || this.source, typeof HTMLImageElement < "u" && source instanceof HTMLImageElement) {
            if (!source.complete || source.naturalWidth === 0) return !1;
        } else if (typeof HTMLVideoElement < "u" && source instanceof HTMLVideoElement && source.readyState <= 1) return !1;
        return gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.alphaMode === (0, $5912637ee8cf8b9f$export$d56550d454401b73).UNPACK), !this.noSubImage && baseTexture.target === gl.TEXTURE_2D && glTexture.width === width && glTexture.height === height ? gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, baseTexture.format, glTexture.type, source) : (glTexture.width = width, glTexture.height = height, gl.texImage2D(baseTexture.target, 0, glTexture.internalFormat, baseTexture.format, glTexture.type, source)), !0;
    }
    /**
   * Checks if source width/height was changed, resize can cause extra baseTexture update.
   * Triggers one update in any case.
   */ update() {
        if (this.destroyed) return;
        const source = this.source, width = source.naturalWidth || source.videoWidth || source.width, height = source.naturalHeight || source.videoHeight || source.height;
        this.resize(width, height), super.update();
    }
    /** Destroy this {@link PIXI.BaseImageResource} */ dispose() {
        this.source = null;
    }
}


class $b82f64230ade51a6$export$6d0d25e6e731a9a2 extends (0, $6510438b65c3a417$export$c87b2a1e7e3bb4a6) {
    /**
   * @param source - image source or URL
   * @param options
   * @param {boolean} [options.autoLoad=true] - start loading process
   * @param {boolean} [options.createBitmap=PIXI.settings.CREATE_IMAGE_BITMAP] - whether its required to create
   *        a bitmap before upload
   * @param {boolean} [options.crossorigin=true] - Load image using cross origin
   * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.UNPACK] - Premultiply image alpha in bitmap
   */ constructor(source, options){
        if (options = options || {}, typeof source == "string") {
            const imageElement = new Image();
            (0, $6510438b65c3a417$export$c87b2a1e7e3bb4a6).crossOrigin(imageElement, source, options.crossorigin), imageElement.src = source, source = imageElement;
        }
        super(source), !source.complete && this._width && this._height && (this._width = 0, this._height = 0), this.url = source.src, this._process = null, this.preserveBitmap = !1, this.createBitmap = (options.createBitmap ?? (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).CREATE_IMAGE_BITMAP) && !!globalThis.createImageBitmap, this.alphaMode = typeof options.alphaMode == "number" ? options.alphaMode : null, this.bitmap = null, this._load = null, options.autoLoad !== !1 && this.load();
    }
    /**
   * Returns a promise when image will be loaded and processed.
   * @param createBitmap - whether process image into bitmap
   */ load(createBitmap) {
        return this._load ? this._load : (createBitmap !== void 0 && (this.createBitmap = createBitmap), this._load = new Promise((resolve, reject)=>{
            const source = this.source;
            this.url = source.src;
            const completed = ()=>{
                this.destroyed || (source.onload = null, source.onerror = null, this.update(), this._load = null, this.createBitmap ? resolve(this.process()) : resolve(this));
            };
            source.complete && source.src ? completed() : (source.onload = completed, source.onerror = (event)=>{
                reject(event), this.onError.emit(event);
            });
        }), this._load);
    }
    /**
   * Called when we need to convert image into BitmapImage.
   * Can be called multiple times, real promise is cached inside.
   * @returns - Cached promise to fill that bitmap
   */ process() {
        const source = this.source;
        if (this._process !== null) return this._process;
        if (this.bitmap !== null || !globalThis.createImageBitmap) return Promise.resolve(this);
        const createImageBitmap = globalThis.createImageBitmap, cors = !source.crossOrigin || source.crossOrigin === "anonymous";
        return this._process = fetch(source.src, {
            mode: cors ? "cors" : "no-cors"
        }).then((r)=>r.blob()).then((blob)=>createImageBitmap(blob, 0, 0, source.width, source.height, {
                premultiplyAlpha: this.alphaMode === null || this.alphaMode === (0, $5912637ee8cf8b9f$export$d56550d454401b73).UNPACK ? "premultiply" : "none"
            })).then((bitmap)=>this.destroyed ? Promise.reject() : (this.bitmap = bitmap, this.update(), this._process = null, Promise.resolve(this))), this._process;
    }
    /**
   * Upload the image resource to GPU.
   * @param renderer - Renderer to upload to
   * @param baseTexture - BaseTexture for this resource
   * @param glTexture - GLTexture to use
   * @returns {boolean} true is success
   */ upload(renderer, baseTexture, glTexture) {
        if (typeof this.alphaMode == "number" && (baseTexture.alphaMode = this.alphaMode), !this.createBitmap) return super.upload(renderer, baseTexture, glTexture);
        if (!this.bitmap && (this.process(), !this.bitmap)) return !1;
        if (super.upload(renderer, baseTexture, glTexture, this.bitmap), !this.preserveBitmap) {
            let flag = !0;
            const glTextures = baseTexture._glTextures;
            for(const key in glTextures){
                const otherTex = glTextures[key];
                if (otherTex !== glTexture && otherTex.dirtyId !== baseTexture.dirtyId) {
                    flag = !1;
                    break;
                }
            }
            flag && (this.bitmap.close && this.bitmap.close(), this.bitmap = null);
        }
        return !0;
    }
    /** Destroys this resource. */ dispose() {
        this.source.onload = null, this.source.onerror = null, super.dispose(), this.bitmap && (this.bitmap.close(), this.bitmap = null), this._process = null, this._load = null;
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if current environment support HTMLImageElement, and source is string or HTMLImageElement
   */ static test(source) {
        return typeof HTMLImageElement < "u" && (typeof source == "string" || source instanceof HTMLImageElement);
    }
}



class $1fbc66b2220add5b$export$4efdf5c542d7171e {
    constructor(){
        this.x0 = 0, this.y0 = 0, this.x1 = 1, this.y1 = 0, this.x2 = 1, this.y2 = 1, this.x3 = 0, this.y3 = 1, this.uvsFloat32 = new Float32Array(8);
    }
    /**
   * Sets the texture Uvs based on the given frame information.
   * @protected
   * @param frame - The frame of the texture
   * @param baseFrame - The base frame of the texture
   * @param rotate - Rotation of frame, see {@link PIXI.groupD8}
   */ set(frame, baseFrame, rotate) {
        const tw = baseFrame.width, th = baseFrame.height;
        if (rotate) {
            const w2 = frame.width / 2 / tw, h2 = frame.height / 2 / th, cX = frame.x / tw + w2, cY = frame.y / th + h2;
            rotate = (0, $a6f7925408a5bc20$export$b7bb6a2a8d203102).add(rotate, (0, $a6f7925408a5bc20$export$b7bb6a2a8d203102).NW), this.x0 = cX + w2 * (0, $a6f7925408a5bc20$export$b7bb6a2a8d203102).uX(rotate), this.y0 = cY + h2 * (0, $a6f7925408a5bc20$export$b7bb6a2a8d203102).uY(rotate), rotate = (0, $a6f7925408a5bc20$export$b7bb6a2a8d203102).add(rotate, 2), this.x1 = cX + w2 * (0, $a6f7925408a5bc20$export$b7bb6a2a8d203102).uX(rotate), this.y1 = cY + h2 * (0, $a6f7925408a5bc20$export$b7bb6a2a8d203102).uY(rotate), rotate = (0, $a6f7925408a5bc20$export$b7bb6a2a8d203102).add(rotate, 2), this.x2 = cX + w2 * (0, $a6f7925408a5bc20$export$b7bb6a2a8d203102).uX(rotate), this.y2 = cY + h2 * (0, $a6f7925408a5bc20$export$b7bb6a2a8d203102).uY(rotate), rotate = (0, $a6f7925408a5bc20$export$b7bb6a2a8d203102).add(rotate, 2), this.x3 = cX + w2 * (0, $a6f7925408a5bc20$export$b7bb6a2a8d203102).uX(rotate), this.y3 = cY + h2 * (0, $a6f7925408a5bc20$export$b7bb6a2a8d203102).uY(rotate);
        } else this.x0 = frame.x / tw, this.y0 = frame.y / th, this.x1 = (frame.x + frame.width) / tw, this.y1 = frame.y / th, this.x2 = (frame.x + frame.width) / tw, this.y2 = (frame.y + frame.height) / th, this.x3 = frame.x / tw, this.y3 = (frame.y + frame.height) / th;
        this.uvsFloat32[0] = this.x0, this.uvsFloat32[1] = this.y0, this.uvsFloat32[2] = this.x1, this.uvsFloat32[3] = this.y1, this.uvsFloat32[4] = this.x2, this.uvsFloat32[5] = this.y2, this.uvsFloat32[6] = this.x3, this.uvsFloat32[7] = this.y3;
    }
}
$1fbc66b2220add5b$export$4efdf5c542d7171e.prototype.toString = function() {
    return `[@pixi/core:TextureUvs x0=${this.x0} y0=${this.y0} x1=${this.x1} y1=${this.y1} x2=${this.x2} y2=${this.y2} x3=${this.x3} y3=${this.y3}]`;
};


const $ad1fffd072a707c2$var$DEFAULT_UVS = new (0, $1fbc66b2220add5b$export$4efdf5c542d7171e)();
function $ad1fffd072a707c2$var$removeAllHandlers(tex) {
    tex.destroy = function() {}, tex.on = function() {}, tex.once = function() {}, tex.emit = function() {};
}
class $ad1fffd072a707c2$export$5431306cf43de24a extends (0, (/*@__PURE__*/$parcel$interopDefault($d82ec76d702398f8$exports))) {
    /**
   * @param baseTexture - The base texture source to create the texture from
   * @param frame - The rectangle frame of the texture to show
   * @param orig - The area of original texture
   * @param trim - Trimmed rectangle of original texture
   * @param rotate - indicates how the texture was rotated by texture packer. See {@link PIXI.groupD8}
   * @param anchor - Default anchor point used for sprite placement / rotation
   * @param borders - Default borders used for 9-slice scaling. See {@link PIXI.NineSlicePlane}
   */ constructor(baseTexture, frame, orig, trim, rotate, anchor, borders){
        if (super(), this.noFrame = !1, frame || (this.noFrame = !0, frame = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(0, 0, 1, 1)), baseTexture instanceof $ad1fffd072a707c2$export$5431306cf43de24a && (baseTexture = baseTexture.baseTexture), this.baseTexture = baseTexture, this._frame = frame, this.trim = trim, this.valid = !1, this.destroyed = !1, this._uvs = $ad1fffd072a707c2$var$DEFAULT_UVS, this.uvMatrix = null, this.orig = orig || frame, this._rotate = Number(rotate || 0), rotate === !0) this._rotate = 2;
        else if (this._rotate % 2 !== 0) throw new Error("attempt to use diamond-shaped UVs. If you are sure, set rotation manually");
        this.defaultAnchor = anchor ? new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(anchor.x, anchor.y) : new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(0, 0), this.defaultBorders = borders, this._updateID = 0, this.textureCacheIds = [], baseTexture.valid ? this.noFrame ? baseTexture.valid && this.onBaseTextureUpdated(baseTexture) : this.frame = frame : baseTexture.once("loaded", this.onBaseTextureUpdated, this), this.noFrame && baseTexture.on("update", this.onBaseTextureUpdated, this);
    }
    /**
   * Updates this texture on the gpu.
   *
   * Calls the TextureResource update.
   *
   * If you adjusted `frame` manually, please call `updateUvs()` instead.
   */ update() {
        this.baseTexture.resource && this.baseTexture.resource.update();
    }
    /**
   * Called when the base texture is updated
   * @protected
   * @param baseTexture - The base texture.
   */ onBaseTextureUpdated(baseTexture) {
        if (this.noFrame) {
            if (!this.baseTexture.valid) return;
            this._frame.width = baseTexture.width, this._frame.height = baseTexture.height, this.valid = !0, this.updateUvs();
        } else this.frame = this._frame;
        this.emit("update", this);
    }
    /**
   * Destroys this texture
   * @param [destroyBase=false] - Whether to destroy the base texture as well
   * @fires PIXI.Texture#destroyed
   */ destroy(destroyBase) {
        if (this.baseTexture) {
            if (destroyBase) {
                const { resource: resource } = this.baseTexture;
                resource?.url && (0, $e0cc893a6896296f$export$4254ab7c0971430e)[resource.url] && $ad1fffd072a707c2$export$5431306cf43de24a.removeFromCache(resource.url), this.baseTexture.destroy();
            }
            this.baseTexture.off("loaded", this.onBaseTextureUpdated, this), this.baseTexture.off("update", this.onBaseTextureUpdated, this), this.baseTexture = null;
        }
        this._frame = null, this._uvs = null, this.trim = null, this.orig = null, this.valid = !1, $ad1fffd072a707c2$export$5431306cf43de24a.removeFromCache(this), this.textureCacheIds = null, this.destroyed = !0, this.emit("destroyed", this), this.removeAllListeners();
    }
    /**
   * Creates a new texture object that acts the same as this one.
   * @returns - The new texture
   */ clone() {
        const clonedFrame = this._frame.clone(), clonedOrig = this._frame === this.orig ? clonedFrame : this.orig.clone(), clonedTexture = new $ad1fffd072a707c2$export$5431306cf43de24a(this.baseTexture, !this.noFrame && clonedFrame, clonedOrig, this.trim?.clone(), this.rotate, this.defaultAnchor, this.defaultBorders);
        return this.noFrame && (clonedTexture._frame = clonedFrame), clonedTexture;
    }
    /**
   * Updates the internal WebGL UV cache. Use it after you change `frame` or `trim` of the texture.
   * Call it after changing the frame
   */ updateUvs() {
        this._uvs === $ad1fffd072a707c2$var$DEFAULT_UVS && (this._uvs = new (0, $1fbc66b2220add5b$export$4efdf5c542d7171e)()), this._uvs.set(this._frame, this.baseTexture, this.rotate), this._updateID++;
    }
    /**
   * Helper function that creates a new Texture based on the source you provide.
   * The source can be - frame id, image url, video url, canvas element, video element, base texture
   * @param {string|PIXI.BaseTexture|HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas} source -
   *        Source or array of sources to create texture from
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   * @param {string} [options.pixiIdPrefix=pixiid] - If a source has no id, this is the prefix of the generated id
   * @param {boolean} [strict] - Enforce strict-mode, see {@link PIXI.settings.STRICT_TEXTURE_CACHE}.
   * @returns {PIXI.Texture} The newly created texture
   */ static from(source, options = {}, strict = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).STRICT_TEXTURE_CACHE) {
        const isFrame = typeof source == "string";
        let cacheId = null;
        if (isFrame) cacheId = source;
        else if (source instanceof (0, $997b0e421c4045eb$export$d6306e508f184154)) {
            if (!source.cacheId) {
                const prefix = options?.pixiIdPrefix || "pixiid";
                source.cacheId = `${prefix}-${(0, $4f05e7b7511900ff$export$e2a22331486dcca0)()}`, (0, $997b0e421c4045eb$export$d6306e508f184154).addToCache(source, source.cacheId);
            }
            cacheId = source.cacheId;
        } else {
            if (!source._pixiId) {
                const prefix = options?.pixiIdPrefix || "pixiid";
                source._pixiId = `${prefix}_${(0, $4f05e7b7511900ff$export$e2a22331486dcca0)()}`;
            }
            cacheId = source._pixiId;
        }
        let texture = (0, $e0cc893a6896296f$export$4254ab7c0971430e)[cacheId];
        if (isFrame && strict && !texture) throw new Error(`The cacheId "${cacheId}" does not exist in TextureCache.`);
        return !texture && !(source instanceof (0, $997b0e421c4045eb$export$d6306e508f184154)) ? (options.resolution || (options.resolution = (0, $2afed8ad033adf62$export$8695ab2f322d2637)(source)), texture = new $ad1fffd072a707c2$export$5431306cf43de24a(new (0, $997b0e421c4045eb$export$d6306e508f184154)(source, options)), texture.baseTexture.cacheId = cacheId, (0, $997b0e421c4045eb$export$d6306e508f184154).addToCache(texture.baseTexture, cacheId), $ad1fffd072a707c2$export$5431306cf43de24a.addToCache(texture, cacheId)) : !texture && source instanceof (0, $997b0e421c4045eb$export$d6306e508f184154) && (texture = new $ad1fffd072a707c2$export$5431306cf43de24a(source), $ad1fffd072a707c2$export$5431306cf43de24a.addToCache(texture, cacheId)), texture;
    }
    /**
   * Useful for loading textures via URLs. Use instead of `Texture.from` because
   * it does a better job of handling failed URLs more effectively. This also ignores
   * `PIXI.settings.STRICT_TEXTURE_CACHE`. Works for Videos, SVGs, Images.
   * @param url - The remote URL or array of URLs to load.
   * @param options - Optional options to include
   * @returns - A Promise that resolves to a Texture.
   */ static fromURL(url, options) {
        const resourceOptions = Object.assign({
            autoLoad: !1
        }, options?.resourceOptions), texture = $ad1fffd072a707c2$export$5431306cf43de24a.from(url, Object.assign({
            resourceOptions: resourceOptions
        }, options), !1), resource = texture.baseTexture.resource;
        return texture.baseTexture.valid ? Promise.resolve(texture) : resource.load().then(()=>Promise.resolve(texture));
    }
    /**
   * Create a new Texture with a BufferResource from a typed array.
   * @param buffer - The optional array to use. If no data is provided, a new Float32Array is created.
   * @param width - Width of the resource
   * @param height - Height of the resource
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   *        Default properties are different from the constructor's defaults.
   * @param {PIXI.FORMATS} [options.format] - The format is not given, the type is inferred from the
   *        type of the buffer: `RGBA` if Float32Array, Int8Array, Uint8Array, or Uint8ClampedArray,
   *        otherwise `RGBA_INTEGER`.
   * @param {PIXI.TYPES} [options.type] - The type is not given, the type is inferred from the
   *        type of the buffer. Maps Float32Array to `FLOAT`, Int32Array to `INT`, Uint32Array to
   *        `UNSIGNED_INT`, Int16Array to `SHORT`, Uint16Array to `UNSIGNED_SHORT`, Int8Array to `BYTE`,
   *        Uint8Array/Uint8ClampedArray to `UNSIGNED_BYTE`.
   * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.NPM]
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.SCALE_MODES.NEAREST]
   * @returns - The resulting new BaseTexture
   */ static fromBuffer(buffer, width, height, options) {
        return new $ad1fffd072a707c2$export$5431306cf43de24a((0, $997b0e421c4045eb$export$d6306e508f184154).fromBuffer(buffer, width, height, options));
    }
    /**
   * Create a texture from a source and add to the cache.
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas|string} source - The input source.
   * @param imageUrl - File name of texture, for cache and resolving resolution.
   * @param name - Human readable name for the texture cache. If no name is
   *        specified, only `imageUrl` will be used as the cache ID.
   * @param options
   * @returns - Output texture
   */ static fromLoader(source, imageUrl, name, options) {
        const baseTexture = new (0, $997b0e421c4045eb$export$d6306e508f184154)(source, Object.assign({
            scaleMode: (0, $997b0e421c4045eb$export$d6306e508f184154).defaultOptions.scaleMode,
            resolution: (0, $2afed8ad033adf62$export$8695ab2f322d2637)(imageUrl)
        }, options)), { resource: resource } = baseTexture;
        resource instanceof (0, $b82f64230ade51a6$export$6d0d25e6e731a9a2) && (resource.url = imageUrl);
        const texture = new $ad1fffd072a707c2$export$5431306cf43de24a(baseTexture);
        return name || (name = imageUrl), (0, $997b0e421c4045eb$export$d6306e508f184154).addToCache(texture.baseTexture, name), $ad1fffd072a707c2$export$5431306cf43de24a.addToCache(texture, name), name !== imageUrl && ((0, $997b0e421c4045eb$export$d6306e508f184154).addToCache(texture.baseTexture, imageUrl), $ad1fffd072a707c2$export$5431306cf43de24a.addToCache(texture, imageUrl)), texture.baseTexture.valid ? Promise.resolve(texture) : new Promise((resolve)=>{
            texture.baseTexture.once("loaded", ()=>resolve(texture));
        });
    }
    /**
   * Adds a Texture to the global TextureCache. This cache is shared across the whole PIXI object.
   * @param texture - The Texture to add to the cache.
   * @param id - The id that the Texture will be stored against.
   */ static addToCache(texture, id) {
        id && (texture.textureCacheIds.includes(id) || texture.textureCacheIds.push(id), (0, $e0cc893a6896296f$export$4254ab7c0971430e)[id] && (0, $e0cc893a6896296f$export$4254ab7c0971430e)[id] !== texture && console.warn(`Texture added to the cache with an id [${id}] that already had an entry`), (0, $e0cc893a6896296f$export$4254ab7c0971430e)[id] = texture);
    }
    /**
   * Remove a Texture from the global TextureCache.
   * @param texture - id of a Texture to be removed, or a Texture instance itself
   * @returns - The Texture that was removed
   */ static removeFromCache(texture) {
        if (typeof texture == "string") {
            const textureFromCache = (0, $e0cc893a6896296f$export$4254ab7c0971430e)[texture];
            if (textureFromCache) {
                const index = textureFromCache.textureCacheIds.indexOf(texture);
                return index > -1 && textureFromCache.textureCacheIds.splice(index, 1), delete (0, $e0cc893a6896296f$export$4254ab7c0971430e)[texture], textureFromCache;
            }
        } else if (texture?.textureCacheIds) {
            for(let i = 0; i < texture.textureCacheIds.length; ++i)(0, $e0cc893a6896296f$export$4254ab7c0971430e)[texture.textureCacheIds[i]] === texture && delete (0, $e0cc893a6896296f$export$4254ab7c0971430e)[texture.textureCacheIds[i]];
            return texture.textureCacheIds.length = 0, texture;
        }
        return null;
    }
    /**
   * Returns resolution of baseTexture
   * @readonly
   */ get resolution() {
        return this.baseTexture.resolution;
    }
    /**
   * The frame specifies the region of the base texture that this texture uses.
   * Please call `updateUvs()` after you change coordinates of `frame` manually.
   */ get frame() {
        return this._frame;
    }
    set frame(frame) {
        this._frame = frame, this.noFrame = !1;
        const { x: x, y: y, width: width, height: height } = frame, xNotFit = x + width > this.baseTexture.width, yNotFit = y + height > this.baseTexture.height;
        if (xNotFit || yNotFit) {
            const relationship = xNotFit && yNotFit ? "and" : "or", errorX = `X: ${x} + ${width} = ${x + width} > ${this.baseTexture.width}`, errorY = `Y: ${y} + ${height} = ${y + height} > ${this.baseTexture.height}`;
            throw new Error(`Texture Error: frame does not fit inside the base Texture dimensions: ${errorX} ${relationship} ${errorY}`);
        }
        this.valid = width && height && this.baseTexture.valid, !this.trim && !this.rotate && (this.orig = frame), this.valid && this.updateUvs();
    }
    /**
   * Indicates whether the texture is rotated inside the atlas
   * set to 2 to compensate for texture packer rotation
   * set to 6 to compensate for spine packer rotation
   * can be used to rotate or mirror sprites
   * See {@link PIXI.groupD8} for explanation
   */ get rotate() {
        return this._rotate;
    }
    set rotate(rotate) {
        this._rotate = rotate, this.valid && this.updateUvs();
    }
    /** The width of the Texture in pixels. */ get width() {
        return this.orig.width;
    }
    /** The height of the Texture in pixels. */ get height() {
        return this.orig.height;
    }
    /** Utility function for BaseTexture|Texture cast. */ castToBaseTexture() {
        return this.baseTexture;
    }
    /** An empty texture, used often to not have to create multiple empty textures. Can not be destroyed. */ static get EMPTY() {
        return $ad1fffd072a707c2$export$5431306cf43de24a._EMPTY || ($ad1fffd072a707c2$export$5431306cf43de24a._EMPTY = new $ad1fffd072a707c2$export$5431306cf43de24a(new (0, $997b0e421c4045eb$export$d6306e508f184154)()), $ad1fffd072a707c2$var$removeAllHandlers($ad1fffd072a707c2$export$5431306cf43de24a._EMPTY), $ad1fffd072a707c2$var$removeAllHandlers($ad1fffd072a707c2$export$5431306cf43de24a._EMPTY.baseTexture)), $ad1fffd072a707c2$export$5431306cf43de24a._EMPTY;
    }
    /** A white texture of 16x16 size, used for graphics and other things Can not be destroyed. */ static get WHITE() {
        if (!$ad1fffd072a707c2$export$5431306cf43de24a._WHITE) {
            const canvas = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.createCanvas(16, 16), context = canvas.getContext("2d");
            canvas.width = 16, canvas.height = 16, context.fillStyle = "white", context.fillRect(0, 0, 16, 16), $ad1fffd072a707c2$export$5431306cf43de24a._WHITE = new $ad1fffd072a707c2$export$5431306cf43de24a((0, $997b0e421c4045eb$export$d6306e508f184154).from(canvas)), $ad1fffd072a707c2$var$removeAllHandlers($ad1fffd072a707c2$export$5431306cf43de24a._WHITE), $ad1fffd072a707c2$var$removeAllHandlers($ad1fffd072a707c2$export$5431306cf43de24a._WHITE.baseTexture);
        }
        return $ad1fffd072a707c2$export$5431306cf43de24a._WHITE;
    }
}



class $bbacc38491f82d4b$export$813984f7330b4d72 extends (0, $ad1fffd072a707c2$export$5431306cf43de24a) {
    /**
   * @param baseRenderTexture - The base texture object that this texture uses.
   * @param frame - The rectangle frame of the texture to show.
   */ constructor(baseRenderTexture, frame){
        super(baseRenderTexture, frame), this.valid = !0, this.filterFrame = null, this.filterPoolKey = null, this.updateUvs();
    }
    /**
   * Shortcut to `this.baseTexture.framebuffer`, saves baseTexture cast.
   * @readonly
   */ get framebuffer() {
        return this.baseTexture.framebuffer;
    }
    /**
   * Shortcut to `this.framebuffer.multisample`.
   * @default PIXI.MSAA_QUALITY.NONE
   */ get multisample() {
        return this.framebuffer.multisample;
    }
    set multisample(value) {
        this.framebuffer.multisample = value;
    }
    /**
   * Resizes the RenderTexture.
   * @param desiredWidth - The desired width to resize to.
   * @param desiredHeight - The desired height to resize to.
   * @param resizeBaseTexture - Should the baseTexture.width and height values be resized as well?
   */ resize(desiredWidth, desiredHeight, resizeBaseTexture = !0) {
        const resolution = this.baseTexture.resolution, width = Math.round(desiredWidth * resolution) / resolution, height = Math.round(desiredHeight * resolution) / resolution;
        this.valid = width > 0 && height > 0, this._frame.width = this.orig.width = width, this._frame.height = this.orig.height = height, resizeBaseTexture && this.baseTexture.resize(width, height), this.updateUvs();
    }
    /**
   * Changes the resolution of baseTexture, but does not change framebuffer size.
   * @param resolution - The new resolution to apply to RenderTexture
   */ setResolution(resolution) {
        const { baseTexture: baseTexture } = this;
        baseTexture.resolution !== resolution && (baseTexture.setResolution(resolution), this.resize(baseTexture.width, baseTexture.height, !1));
    }
    /**
   * A short hand way of creating a render texture.
   * @param options - Options
   * @param {number} [options.width=100] - The width of the render texture
   * @param {number} [options.height=100] - The height of the render texture
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.BaseTexture.defaultOptions.scaleMode] - See {@link PIXI.SCALE_MODES}
   *    for possible values
   * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the texture
   *    being generated
   * @param {PIXI.MSAA_QUALITY} [options.multisample=PIXI.MSAA_QUALITY.NONE] - The number of samples of the frame buffer
   * @returns The new render texture
   */ static create(options) {
        return new $bbacc38491f82d4b$export$813984f7330b4d72(new (0, $d3103ef1e96b190b$export$18d268c71e34cf2c)(options));
    }
}


class $6a212e2812c87852$export$1a441d2b5f37dfd7 {
    /**
   * @param textureOptions - options that will be passed to BaseRenderTexture constructor
   * @param {PIXI.SCALE_MODES} [textureOptions.scaleMode] - See {@link PIXI.SCALE_MODES} for possible values.
   */ constructor(textureOptions){
        this.texturePool = {}, this.textureOptions = textureOptions || {}, this.enableFullScreen = !1, this._pixelsWidth = 0, this._pixelsHeight = 0;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param realWidth - Width of texture in pixels.
   * @param realHeight - Height of texture in pixels.
   * @param multisample - Number of samples of the framebuffer.
   */ createTexture(realWidth, realHeight, multisample = (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).NONE) {
        const baseRenderTexture = new (0, $d3103ef1e96b190b$export$18d268c71e34cf2c)(Object.assign({
            width: realWidth,
            height: realHeight,
            resolution: 1,
            multisample: multisample
        }, this.textureOptions));
        return new (0, $bbacc38491f82d4b$export$813984f7330b4d72)(baseRenderTexture);
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @param multisample - Number of samples of the render texture.
   * @returns The new render texture.
   */ getOptimalTexture(minWidth, minHeight, resolution = 1, multisample = (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).NONE) {
        let key;
        minWidth = Math.max(Math.ceil(minWidth * resolution - 1e-6), 1), minHeight = Math.max(Math.ceil(minHeight * resolution - 1e-6), 1), !this.enableFullScreen || minWidth !== this._pixelsWidth || minHeight !== this._pixelsHeight ? (minWidth = (0, $1101e8b3767a1e48$export$f0d90cf68bd426eb)(minWidth), minHeight = (0, $1101e8b3767a1e48$export$f0d90cf68bd426eb)(minHeight), key = ((minWidth & 65535) << 16 | minHeight & 65535) >>> 0, multisample > 1 && (key += multisample * 4294967296)) : key = multisample > 1 ? -multisample : -1, this.texturePool[key] || (this.texturePool[key] = []);
        let renderTexture = this.texturePool[key].pop();
        return renderTexture || (renderTexture = this.createTexture(minWidth, minHeight, multisample)), renderTexture.filterPoolKey = key, renderTexture.setResolution(resolution), renderTexture;
    }
    /**
   * Gets extra texture of the same size as input renderTexture
   *
   * `getFilterTexture(input, 0.5)` or `getFilterTexture(0.5, input)`
   * @param input - renderTexture from which size and resolution will be copied
   * @param resolution - override resolution of the renderTexture
   *  It overrides, it does not multiply
   * @param multisample - number of samples of the renderTexture
   */ getFilterTexture(input, resolution, multisample) {
        const filterTexture = this.getOptimalTexture(input.width, input.height, resolution || input.resolution, multisample || (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).NONE);
        return filterTexture.filterFrame = input.filterFrame, filterTexture;
    }
    /**
   * Place a render texture back into the pool.
   * @param renderTexture - The renderTexture to free
   */ returnTexture(renderTexture) {
        const key = renderTexture.filterPoolKey;
        renderTexture.filterFrame = null, this.texturePool[key].push(renderTexture);
    }
    /**
   * Alias for returnTexture, to be compliant with FilterSystem interface.
   * @param renderTexture - The renderTexture to free
   */ returnFilterTexture(renderTexture) {
        this.returnTexture(renderTexture);
    }
    /**
   * Clears the pool.
   * @param destroyTextures - Destroy all stored textures.
   */ clear(destroyTextures) {
        if (destroyTextures = destroyTextures !== !1, destroyTextures) for(const i in this.texturePool){
            const textures = this.texturePool[i];
            if (textures) for(let j = 0; j < textures.length; j++)textures[j].destroy(!0);
        }
        this.texturePool = {};
    }
    /**
   * If screen size was changed, drops all screen-sized textures,
   * sets new screen size, sets `enableFullScreen` to true
   *
   * Size is measured in pixels, `renderer.view` can be passed here, not `renderer.screen`
   * @param size - Initial size of screen.
   */ setScreenSize(size) {
        if (!(size.width === this._pixelsWidth && size.height === this._pixelsHeight)) {
            this.enableFullScreen = size.width > 0 && size.height > 0;
            for(const i in this.texturePool){
                if (!(Number(i) < 0)) continue;
                const textures = this.texturePool[i];
                if (textures) for(let j = 0; j < textures.length; j++)textures[j].destroy(!0);
                this.texturePool[i] = [];
            }
            this._pixelsWidth = size.width, this._pixelsHeight = size.height;
        }
    }
}
$6a212e2812c87852$export$1a441d2b5f37dfd7.SCREEN_KEY = -1;




class $34f4d9f6a33a5dca$export$7005c9eb6671414d extends (0, $dd93eefb01cd7345$export$2db6c17465f94a2) {
    constructor(){
        super(), this.addAttribute("aVertexPosition", new Float32Array([
            0,
            0,
            1,
            0,
            1,
            1,
            0,
            1
        ])).addIndex([
            0,
            1,
            3,
            2
        ]);
    }
}




class $fa61408e8cb2fded$export$4f70783f37e4ec0b extends (0, $dd93eefb01cd7345$export$2db6c17465f94a2) {
    constructor(){
        super(), this.vertices = new Float32Array([
            -1,
            -1,
            1,
            -1,
            1,
            1,
            -1,
            1
        ]), this.uvs = new Float32Array([
            0,
            0,
            1,
            0,
            1,
            1,
            0,
            1
        ]), this.vertexBuffer = new (0, $4da95ef50ded5f29$export$a143d493d941bafc)(this.vertices), this.uvBuffer = new (0, $4da95ef50ded5f29$export$a143d493d941bafc)(this.uvs), this.addAttribute("aVertexPosition", this.vertexBuffer).addAttribute("aTextureCoord", this.uvBuffer).addIndex([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
    }
    /**
   * Maps two Rectangle to the quad.
   * @param targetTextureFrame - The first rectangle
   * @param destinationFrame - The second rectangle
   * @returns - Returns itself.
   */ map(targetTextureFrame, destinationFrame) {
        let x = 0, y = 0;
        return this.uvs[0] = x, this.uvs[1] = y, this.uvs[2] = x + destinationFrame.width / targetTextureFrame.width, this.uvs[3] = y, this.uvs[4] = x + destinationFrame.width / targetTextureFrame.width, this.uvs[5] = y + destinationFrame.height / targetTextureFrame.height, this.uvs[6] = x, this.uvs[7] = y + destinationFrame.height / targetTextureFrame.height, x = destinationFrame.x, y = destinationFrame.y, this.vertices[0] = x, this.vertices[1] = y, this.vertices[2] = x + destinationFrame.width, this.vertices[3] = y, this.vertices[4] = x + destinationFrame.width, this.vertices[5] = y + destinationFrame.height, this.vertices[6] = x, this.vertices[7] = y + destinationFrame.height, this.invalidate(), this;
    }
    /**
   * Legacy upload method, just marks buffers dirty.
   * @returns - Returns itself.
   */ invalidate() {
        return this.vertexBuffer._updateID++, this.uvBuffer._updateID++, this;
    }
}




class $32f38861858d54e8$export$ac6e0205a419d6d6 {
    constructor(){
        this.renderTexture = null, this.target = null, this.legacy = !1, this.resolution = 1, this.multisample = (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).NONE, this.sourceFrame = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(), this.destinationFrame = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(), this.bindingSourceFrame = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(), this.bindingDestinationFrame = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(), this.filters = [], this.transform = null;
    }
    /** Clears the state */ clear() {
        this.target = null, this.filters = null, this.renderTexture = null;
    }
}


const $f374cceea6c34796$var$tempPoints = [
    new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(),
    new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(),
    new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(),
    new (0, $c283a5532acdbe2e$export$baf26146a414f24a)()
], $f374cceea6c34796$var$tempMatrix = new (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85)();
class $f374cceea6c34796$export$e94225c0dfac29cf {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.defaultFilterStack = [
            {}
        ], this.texturePool = new (0, $6a212e2812c87852$export$1a441d2b5f37dfd7)(), this.statePool = [], this.quad = new (0, $34f4d9f6a33a5dca$export$7005c9eb6671414d)(), this.quadUv = new (0, $fa61408e8cb2fded$export$4f70783f37e4ec0b)(), this.tempRect = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(), this.activeState = {}, this.globalUniforms = new (0, $f3ba15c3d8ec3ea5$export$6601a7a2dcf79bf5)({
            outputFrame: new (0, $92248a7cf1facbda$export$4617fb02663045ef)(),
            inputSize: new Float32Array(4),
            inputPixel: new Float32Array(4),
            inputClamp: new Float32Array(4),
            resolution: 1,
            // legacy variables
            filterArea: new Float32Array(4),
            filterClamp: new Float32Array(4)
        }, !0), this.forceClear = !1, this.useMaxPadding = !1;
    }
    init() {
        this.texturePool.setScreenSize(this.renderer.view);
    }
    /**
   * Pushes a set of filters to be applied later to the system. This will redirect further rendering into an
   * input render-texture for the rest of the filtering pipeline.
   * @param {PIXI.DisplayObject} target - The target of the filter to render.
   * @param filters - The filters to apply.
   */ push(target, filters) {
        const renderer = this.renderer, filterStack = this.defaultFilterStack, state = this.statePool.pop() || new (0, $32f38861858d54e8$export$ac6e0205a419d6d6)(), renderTextureSystem = renderer.renderTexture;
        let currentResolution, currentMultisample;
        if (renderTextureSystem.current) {
            const renderTexture = renderTextureSystem.current;
            currentResolution = renderTexture.resolution, currentMultisample = renderTexture.multisample;
        } else currentResolution = renderer.resolution, currentMultisample = renderer.multisample;
        let resolution = filters[0].resolution || currentResolution, multisample = filters[0].multisample ?? currentMultisample, padding = filters[0].padding, autoFit = filters[0].autoFit, legacy = filters[0].legacy ?? !0;
        for(let i = 1; i < filters.length; i++){
            const filter = filters[i];
            resolution = Math.min(resolution, filter.resolution || currentResolution), multisample = Math.min(multisample, filter.multisample ?? currentMultisample), padding = this.useMaxPadding ? Math.max(padding, filter.padding) : padding + filter.padding, autoFit = autoFit && filter.autoFit, legacy = legacy || (filter.legacy ?? !0);
        }
        filterStack.length === 1 && (this.defaultFilterStack[0].renderTexture = renderTextureSystem.current), filterStack.push(state), state.resolution = resolution, state.multisample = multisample, state.legacy = legacy, state.target = target, state.sourceFrame.copyFrom(target.filterArea || target.getBounds(!0)), state.sourceFrame.pad(padding);
        const sourceFrameProjected = this.tempRect.copyFrom(renderTextureSystem.sourceFrame);
        renderer.projection.transform && this.transformAABB($f374cceea6c34796$var$tempMatrix.copyFrom(renderer.projection.transform).invert(), sourceFrameProjected), autoFit ? (state.sourceFrame.fit(sourceFrameProjected), (state.sourceFrame.width <= 0 || state.sourceFrame.height <= 0) && (state.sourceFrame.width = 0, state.sourceFrame.height = 0)) : state.sourceFrame.intersects(sourceFrameProjected) || (state.sourceFrame.width = 0, state.sourceFrame.height = 0), this.roundFrame(state.sourceFrame, renderTextureSystem.current ? renderTextureSystem.current.resolution : renderer.resolution, renderTextureSystem.sourceFrame, renderTextureSystem.destinationFrame, renderer.projection.transform), state.renderTexture = this.getOptimalFilterTexture(state.sourceFrame.width, state.sourceFrame.height, resolution, multisample), state.filters = filters, state.destinationFrame.width = state.renderTexture.width, state.destinationFrame.height = state.renderTexture.height;
        const destinationFrame = this.tempRect;
        destinationFrame.x = 0, destinationFrame.y = 0, destinationFrame.width = state.sourceFrame.width, destinationFrame.height = state.sourceFrame.height, state.renderTexture.filterFrame = state.sourceFrame, state.bindingSourceFrame.copyFrom(renderTextureSystem.sourceFrame), state.bindingDestinationFrame.copyFrom(renderTextureSystem.destinationFrame), state.transform = renderer.projection.transform, renderer.projection.transform = null, renderTextureSystem.bind(state.renderTexture, state.sourceFrame, destinationFrame), renderer.framebuffer.clear(0, 0, 0, 0);
    }
    /** Pops off the filter and applies it. */ pop() {
        const filterStack = this.defaultFilterStack, state = filterStack.pop(), filters = state.filters;
        this.activeState = state;
        const globalUniforms = this.globalUniforms.uniforms;
        globalUniforms.outputFrame = state.sourceFrame, globalUniforms.resolution = state.resolution;
        const inputSize = globalUniforms.inputSize, inputPixel = globalUniforms.inputPixel, inputClamp = globalUniforms.inputClamp;
        if (inputSize[0] = state.destinationFrame.width, inputSize[1] = state.destinationFrame.height, inputSize[2] = 1 / inputSize[0], inputSize[3] = 1 / inputSize[1], inputPixel[0] = Math.round(inputSize[0] * state.resolution), inputPixel[1] = Math.round(inputSize[1] * state.resolution), inputPixel[2] = 1 / inputPixel[0], inputPixel[3] = 1 / inputPixel[1], inputClamp[0] = 0.5 * inputPixel[2], inputClamp[1] = 0.5 * inputPixel[3], inputClamp[2] = state.sourceFrame.width * inputSize[2] - 0.5 * inputPixel[2], inputClamp[3] = state.sourceFrame.height * inputSize[3] - 0.5 * inputPixel[3], state.legacy) {
            const filterArea = globalUniforms.filterArea;
            filterArea[0] = state.destinationFrame.width, filterArea[1] = state.destinationFrame.height, filterArea[2] = state.sourceFrame.x, filterArea[3] = state.sourceFrame.y, globalUniforms.filterClamp = globalUniforms.inputClamp;
        }
        this.globalUniforms.update();
        const lastState = filterStack[filterStack.length - 1];
        if (this.renderer.framebuffer.blit(), filters.length === 1) filters[0].apply(this, state.renderTexture, lastState.renderTexture, (0, $5912637ee8cf8b9f$export$784901839554cbc3).BLEND, state), this.returnFilterTexture(state.renderTexture);
        else {
            let flip = state.renderTexture, flop = this.getOptimalFilterTexture(flip.width, flip.height, state.resolution);
            flop.filterFrame = flip.filterFrame;
            let i = 0;
            for(i = 0; i < filters.length - 1; ++i){
                i === 1 && state.multisample > 1 && (flop = this.getOptimalFilterTexture(flip.width, flip.height, state.resolution), flop.filterFrame = flip.filterFrame), filters[i].apply(this, flip, flop, (0, $5912637ee8cf8b9f$export$784901839554cbc3).CLEAR, state);
                const t = flip;
                flip = flop, flop = t;
            }
            filters[i].apply(this, flip, lastState.renderTexture, (0, $5912637ee8cf8b9f$export$784901839554cbc3).BLEND, state), i > 1 && state.multisample > 1 && this.returnFilterTexture(state.renderTexture), this.returnFilterTexture(flip), this.returnFilterTexture(flop);
        }
        state.clear(), this.statePool.push(state);
    }
    /**
   * Binds a renderTexture with corresponding `filterFrame`, clears it if mode corresponds.
   * @param filterTexture - renderTexture to bind, should belong to filter pool or filter stack
   * @param clearMode - clearMode, by default its CLEAR/YES. See {@link PIXI.CLEAR_MODES}
   */ bindAndClear(filterTexture, clearMode = (0, $5912637ee8cf8b9f$export$784901839554cbc3).CLEAR) {
        const { renderTexture: renderTextureSystem, state: stateSystem } = this.renderer;
        if (filterTexture === this.defaultFilterStack[this.defaultFilterStack.length - 1].renderTexture ? this.renderer.projection.transform = this.activeState.transform : this.renderer.projection.transform = null, filterTexture?.filterFrame) {
            const destinationFrame = this.tempRect;
            destinationFrame.x = 0, destinationFrame.y = 0, destinationFrame.width = filterTexture.filterFrame.width, destinationFrame.height = filterTexture.filterFrame.height, renderTextureSystem.bind(filterTexture, filterTexture.filterFrame, destinationFrame);
        } else filterTexture !== this.defaultFilterStack[this.defaultFilterStack.length - 1].renderTexture ? renderTextureSystem.bind(filterTexture) : this.renderer.renderTexture.bind(filterTexture, this.activeState.bindingSourceFrame, this.activeState.bindingDestinationFrame);
        const autoClear = stateSystem.stateId & 1 || this.forceClear;
        (clearMode === (0, $5912637ee8cf8b9f$export$784901839554cbc3).CLEAR || clearMode === (0, $5912637ee8cf8b9f$export$784901839554cbc3).BLIT && autoClear) && this.renderer.framebuffer.clear(0, 0, 0, 0);
    }
    /**
   * Draws a filter using the default rendering process.
   *
   * This should be called only by {@link PIXI.Filter#apply}.
   * @param filter - The filter to draw.
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it
   */ applyFilter(filter, input, output, clearMode) {
        const renderer = this.renderer;
        renderer.state.set(filter.state), this.bindAndClear(output, clearMode), filter.uniforms.uSampler = input, filter.uniforms.filterGlobals = this.globalUniforms, renderer.shader.bind(filter), filter.legacy = !!filter.program.attributeData.aTextureCoord, filter.legacy ? (this.quadUv.map(input._frame, input.filterFrame), renderer.geometry.bind(this.quadUv), renderer.geometry.draw((0, $5912637ee8cf8b9f$export$91100badd8469338).TRIANGLES)) : (renderer.geometry.bind(this.quad), renderer.geometry.draw((0, $5912637ee8cf8b9f$export$91100badd8469338).TRIANGLE_STRIP));
    }
    /**
   * Multiply _input normalized coordinates_ to this matrix to get _sprite texture normalized coordinates_.
   *
   * Use `outputMatrix * vTextureCoord` in the shader.
   * @param outputMatrix - The matrix to output to.
   * @param {PIXI.Sprite} sprite - The sprite to map to.
   * @returns The mapped matrix.
   */ calculateSpriteMatrix(outputMatrix, sprite) {
        const { sourceFrame: sourceFrame, destinationFrame: destinationFrame } = this.activeState, { orig: orig } = sprite._texture, mappedMatrix = outputMatrix.set(destinationFrame.width, 0, 0, destinationFrame.height, sourceFrame.x, sourceFrame.y), worldTransform = sprite.worldTransform.copyTo((0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85).TEMP_MATRIX);
        return worldTransform.invert(), mappedMatrix.prepend(worldTransform), mappedMatrix.scale(1 / orig.width, 1 / orig.height), mappedMatrix.translate(sprite.anchor.x, sprite.anchor.y), mappedMatrix;
    }
    /** Destroys this Filter System. */ destroy() {
        this.renderer = null, this.texturePool.clear(!1);
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture in real pixels.
   * @param minHeight - The minimum height of the render texture in real pixels.
   * @param resolution - The resolution of the render texture.
   * @param multisample - Number of samples of the render texture.
   * @returns - The new render texture.
   */ getOptimalFilterTexture(minWidth, minHeight, resolution = 1, multisample = (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).NONE) {
        return this.texturePool.getOptimalTexture(minWidth, minHeight, resolution, multisample);
    }
    /**
   * Gets extra render texture to use inside current filter
   * To be compliant with older filters, you can use params in any order
   * @param input - renderTexture from which size and resolution will be copied
   * @param resolution - override resolution of the renderTexture
   * @param multisample - number of samples of the renderTexture
   */ getFilterTexture(input, resolution, multisample) {
        if (typeof input == "number") {
            const swap = input;
            input = resolution, resolution = swap;
        }
        input = input || this.activeState.renderTexture;
        const filterTexture = this.texturePool.getOptimalTexture(input.width, input.height, resolution || input.resolution, multisample || (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).NONE);
        return filterTexture.filterFrame = input.filterFrame, filterTexture;
    }
    /**
   * Frees a render texture back into the pool.
   * @param renderTexture - The renderTarget to free
   */ returnFilterTexture(renderTexture) {
        this.texturePool.returnTexture(renderTexture);
    }
    /** Empties the texture pool. */ emptyPool() {
        this.texturePool.clear(!0);
    }
    /** Calls `texturePool.resize()`, affects fullScreen renderTextures. */ resize() {
        this.texturePool.setScreenSize(this.renderer.view);
    }
    /**
   * @param matrix - first param
   * @param rect - second param
   */ transformAABB(matrix, rect) {
        const lt = $f374cceea6c34796$var$tempPoints[0], lb = $f374cceea6c34796$var$tempPoints[1], rt = $f374cceea6c34796$var$tempPoints[2], rb = $f374cceea6c34796$var$tempPoints[3];
        lt.set(rect.left, rect.top), lb.set(rect.left, rect.bottom), rt.set(rect.right, rect.top), rb.set(rect.right, rect.bottom), matrix.apply(lt, lt), matrix.apply(lb, lb), matrix.apply(rt, rt), matrix.apply(rb, rb);
        const x0 = Math.min(lt.x, lb.x, rt.x, rb.x), y0 = Math.min(lt.y, lb.y, rt.y, rb.y), x1 = Math.max(lt.x, lb.x, rt.x, rb.x), y1 = Math.max(lt.y, lb.y, rt.y, rb.y);
        rect.x = x0, rect.y = y0, rect.width = x1 - x0, rect.height = y1 - y0;
    }
    roundFrame(frame, resolution, bindingSourceFrame, bindingDestinationFrame, transform) {
        if (!(frame.width <= 0 || frame.height <= 0 || bindingSourceFrame.width <= 0 || bindingSourceFrame.height <= 0)) {
            if (transform) {
                const { a: a, b: b, c: c, d: d } = transform;
                if ((Math.abs(b) > 1e-4 || Math.abs(c) > 1e-4) && (Math.abs(a) > 1e-4 || Math.abs(d) > 1e-4)) return;
            }
            transform = transform ? $f374cceea6c34796$var$tempMatrix.copyFrom(transform) : $f374cceea6c34796$var$tempMatrix.identity(), transform.translate(-bindingSourceFrame.x, -bindingSourceFrame.y).scale(bindingDestinationFrame.width / bindingSourceFrame.width, bindingDestinationFrame.height / bindingSourceFrame.height).translate(bindingDestinationFrame.x, bindingDestinationFrame.y), this.transformAABB(transform, frame), frame.ceil(resolution), this.transformAABB(transform.invert(), frame);
        }
    }
}
$f374cceea6c34796$export$e94225c0dfac29cf.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
    name: "filter"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($f374cceea6c34796$export$e94225c0dfac29cf);








class $0f352a8632e5737c$export$47f6dbf489220e22 {
    constructor(framebuffer){
        this.framebuffer = framebuffer, this.stencil = null, this.dirtyId = -1, this.dirtyFormat = -1, this.dirtySize = -1, this.multisample = (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).NONE, this.msaaBuffer = null, this.blitFramebuffer = null, this.mipLevel = 0;
    }
}


const $e8b9bd1f9f3749d4$var$tempRectangle = new (0, $92248a7cf1facbda$export$4617fb02663045ef)();
class $e8b9bd1f9f3749d4$export$3f472331251297cd {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.managedFramebuffers = [], this.unknownFramebuffer = new (0, $8bbab5b5070242d8$export$eff95f126aa67cfb)(10, 10), this.msaaSamples = null;
    }
    /** Sets up the renderer context and necessary buffers. */ contextChange() {
        this.disposeAll(!0);
        const gl = this.gl = this.renderer.gl;
        if (this.CONTEXT_UID = this.renderer.CONTEXT_UID, this.current = this.unknownFramebuffer, this.viewport = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(), this.hasMRT = !0, this.writeDepthTexture = !0, this.renderer.context.webGLVersion === 1) {
            let nativeDrawBuffersExtension = this.renderer.context.extensions.drawBuffers, nativeDepthTextureExtension = this.renderer.context.extensions.depthTexture;
            (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).PREFER_ENV === (0, $5912637ee8cf8b9f$export$83401e34d5e11bf4).WEBGL_LEGACY && (nativeDrawBuffersExtension = null, nativeDepthTextureExtension = null), nativeDrawBuffersExtension ? gl.drawBuffers = (activeTextures)=>nativeDrawBuffersExtension.drawBuffersWEBGL(activeTextures) : (this.hasMRT = !1, gl.drawBuffers = ()=>{}), nativeDepthTextureExtension || (this.writeDepthTexture = !1);
        } else this.msaaSamples = gl.getInternalformatParameter(gl.RENDERBUFFER, gl.RGBA8, gl.SAMPLES);
    }
    /**
   * Bind a framebuffer.
   * @param framebuffer
   * @param frame - frame, default is framebuffer size
   * @param mipLevel - optional mip level to set on the framebuffer - defaults to 0
   */ bind(framebuffer, frame, mipLevel = 0) {
        const { gl: gl } = this;
        if (framebuffer) {
            const fbo = framebuffer.glFramebuffers[this.CONTEXT_UID] || this.initFramebuffer(framebuffer);
            this.current !== framebuffer && (this.current = framebuffer, gl.bindFramebuffer(gl.FRAMEBUFFER, fbo.framebuffer)), fbo.mipLevel !== mipLevel && (framebuffer.dirtyId++, framebuffer.dirtyFormat++, fbo.mipLevel = mipLevel), fbo.dirtyId !== framebuffer.dirtyId && (fbo.dirtyId = framebuffer.dirtyId, fbo.dirtyFormat !== framebuffer.dirtyFormat ? (fbo.dirtyFormat = framebuffer.dirtyFormat, fbo.dirtySize = framebuffer.dirtySize, this.updateFramebuffer(framebuffer, mipLevel)) : fbo.dirtySize !== framebuffer.dirtySize && (fbo.dirtySize = framebuffer.dirtySize, this.resizeFramebuffer(framebuffer)));
            for(let i = 0; i < framebuffer.colorTextures.length; i++){
                const tex = framebuffer.colorTextures[i];
                this.renderer.texture.unbind(tex.parentTextureArray || tex);
            }
            if (framebuffer.depthTexture && this.renderer.texture.unbind(framebuffer.depthTexture), frame) {
                const mipWidth = frame.width >> mipLevel, mipHeight = frame.height >> mipLevel, scale = mipWidth / frame.width;
                this.setViewport(frame.x * scale, frame.y * scale, mipWidth, mipHeight);
            } else {
                const mipWidth = framebuffer.width >> mipLevel, mipHeight = framebuffer.height >> mipLevel;
                this.setViewport(0, 0, mipWidth, mipHeight);
            }
        } else this.current && (this.current = null, gl.bindFramebuffer(gl.FRAMEBUFFER, null)), frame ? this.setViewport(frame.x, frame.y, frame.width, frame.height) : this.setViewport(0, 0, this.renderer.width, this.renderer.height);
    }
    /**
   * Set the WebGLRenderingContext's viewport.
   * @param x - X position of viewport
   * @param y - Y position of viewport
   * @param width - Width of viewport
   * @param height - Height of viewport
   */ setViewport(x, y, width, height) {
        const v = this.viewport;
        x = Math.round(x), y = Math.round(y), width = Math.round(width), height = Math.round(height), (v.width !== width || v.height !== height || v.x !== x || v.y !== y) && (v.x = x, v.y = y, v.width = width, v.height = height, this.gl.viewport(x, y, width, height));
    }
    /**
   * Get the size of the current width and height. Returns object with `width` and `height` values.
   * @readonly
   */ get size() {
        return this.current ? {
            x: 0,
            y: 0,
            width: this.current.width,
            height: this.current.height
        } : {
            x: 0,
            y: 0,
            width: this.renderer.width,
            height: this.renderer.height
        };
    }
    /**
   * Clear the color of the context
   * @param r - Red value from 0 to 1
   * @param g - Green value from 0 to 1
   * @param b - Blue value from 0 to 1
   * @param a - Alpha value from 0 to 1
   * @param {PIXI.BUFFER_BITS} [mask=BUFFER_BITS.COLOR | BUFFER_BITS.DEPTH] - Bitwise OR of masks
   *  that indicate the buffers to be cleared, by default COLOR and DEPTH buffers.
   */ clear(r, g, b, a, mask = (0, $5912637ee8cf8b9f$export$c07ea8ac66dac49).COLOR | (0, $5912637ee8cf8b9f$export$c07ea8ac66dac49).DEPTH) {
        const { gl: gl } = this;
        gl.clearColor(r, g, b, a), gl.clear(mask);
    }
    /**
   * Initialize framebuffer for this context
   * @protected
   * @param framebuffer
   * @returns - created GLFramebuffer
   */ initFramebuffer(framebuffer) {
        const { gl: gl } = this, fbo = new (0, $0f352a8632e5737c$export$47f6dbf489220e22)(gl.createFramebuffer());
        return fbo.multisample = this.detectSamples(framebuffer.multisample), framebuffer.glFramebuffers[this.CONTEXT_UID] = fbo, this.managedFramebuffers.push(framebuffer), framebuffer.disposeRunner.add(this), fbo;
    }
    /**
   * Resize the framebuffer
   * @param framebuffer
   * @protected
   */ resizeFramebuffer(framebuffer) {
        const { gl: gl } = this, fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
        if (fbo.stencil) {
            gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.stencil);
            let stencilFormat;
            this.renderer.context.webGLVersion === 1 ? stencilFormat = gl.DEPTH_STENCIL : framebuffer.depth && framebuffer.stencil ? stencilFormat = gl.DEPTH24_STENCIL8 : framebuffer.depth ? stencilFormat = gl.DEPTH_COMPONENT24 : stencilFormat = gl.STENCIL_INDEX8, fbo.msaaBuffer ? gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, stencilFormat, framebuffer.width, framebuffer.height) : gl.renderbufferStorage(gl.RENDERBUFFER, stencilFormat, framebuffer.width, framebuffer.height);
        }
        const colorTextures = framebuffer.colorTextures;
        let count = colorTextures.length;
        gl.drawBuffers || (count = Math.min(count, 1));
        for(let i = 0; i < count; i++){
            const texture = colorTextures[i], parentTexture = texture.parentTextureArray || texture;
            this.renderer.texture.bind(parentTexture, 0), i === 0 && fbo.msaaBuffer && (gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.msaaBuffer), gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, parentTexture._glTextures[this.CONTEXT_UID].internalFormat, framebuffer.width, framebuffer.height));
        }
        framebuffer.depthTexture && this.writeDepthTexture && this.renderer.texture.bind(framebuffer.depthTexture, 0);
    }
    /**
   * Update the framebuffer
   * @param framebuffer
   * @param mipLevel
   * @protected
   */ updateFramebuffer(framebuffer, mipLevel) {
        const { gl: gl } = this, fbo = framebuffer.glFramebuffers[this.CONTEXT_UID], colorTextures = framebuffer.colorTextures;
        let count = colorTextures.length;
        gl.drawBuffers || (count = Math.min(count, 1)), fbo.multisample > 1 && this.canMultisampleFramebuffer(framebuffer) ? fbo.msaaBuffer = fbo.msaaBuffer || gl.createRenderbuffer() : fbo.msaaBuffer && (gl.deleteRenderbuffer(fbo.msaaBuffer), fbo.msaaBuffer = null, fbo.blitFramebuffer && (fbo.blitFramebuffer.dispose(), fbo.blitFramebuffer = null));
        const activeTextures = [];
        for(let i = 0; i < count; i++){
            const texture = colorTextures[i], parentTexture = texture.parentTextureArray || texture;
            this.renderer.texture.bind(parentTexture, 0), i === 0 && fbo.msaaBuffer ? (gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.msaaBuffer), gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, parentTexture._glTextures[this.CONTEXT_UID].internalFormat, framebuffer.width, framebuffer.height), gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.RENDERBUFFER, fbo.msaaBuffer)) : (gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, texture.target, parentTexture._glTextures[this.CONTEXT_UID].texture, mipLevel), activeTextures.push(gl.COLOR_ATTACHMENT0 + i));
        }
        if (activeTextures.length > 1 && gl.drawBuffers(activeTextures), framebuffer.depthTexture && this.writeDepthTexture) {
            const depthTexture = framebuffer.depthTexture;
            this.renderer.texture.bind(depthTexture, 0), gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.TEXTURE_2D, depthTexture._glTextures[this.CONTEXT_UID].texture, mipLevel);
        }
        if ((framebuffer.stencil || framebuffer.depth) && !(framebuffer.depthTexture && this.writeDepthTexture)) {
            fbo.stencil = fbo.stencil || gl.createRenderbuffer();
            let stencilAttachment, stencilFormat;
            this.renderer.context.webGLVersion === 1 ? (stencilAttachment = gl.DEPTH_STENCIL_ATTACHMENT, stencilFormat = gl.DEPTH_STENCIL) : framebuffer.depth && framebuffer.stencil ? (stencilAttachment = gl.DEPTH_STENCIL_ATTACHMENT, stencilFormat = gl.DEPTH24_STENCIL8) : framebuffer.depth ? (stencilAttachment = gl.DEPTH_ATTACHMENT, stencilFormat = gl.DEPTH_COMPONENT24) : (stencilAttachment = gl.STENCIL_ATTACHMENT, stencilFormat = gl.STENCIL_INDEX8), gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.stencil), fbo.msaaBuffer ? gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, stencilFormat, framebuffer.width, framebuffer.height) : gl.renderbufferStorage(gl.RENDERBUFFER, stencilFormat, framebuffer.width, framebuffer.height), gl.framebufferRenderbuffer(gl.FRAMEBUFFER, stencilAttachment, gl.RENDERBUFFER, fbo.stencil);
        } else fbo.stencil && (gl.deleteRenderbuffer(fbo.stencil), fbo.stencil = null);
    }
    /**
   * Returns true if the frame buffer can be multisampled.
   * @param framebuffer
   */ canMultisampleFramebuffer(framebuffer) {
        return this.renderer.context.webGLVersion !== 1 && framebuffer.colorTextures.length <= 1 && !framebuffer.depthTexture;
    }
    /**
   * Detects number of samples that is not more than a param but as close to it as possible
   * @param samples - number of samples
   * @returns - recommended number of samples
   */ detectSamples(samples) {
        const { msaaSamples: msaaSamples } = this;
        let res = (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).NONE;
        if (samples <= 1 || msaaSamples === null) return res;
        for(let i = 0; i < msaaSamples.length; i++)if (msaaSamples[i] <= samples) {
            res = msaaSamples[i];
            break;
        }
        return res === 1 && (res = (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).NONE), res;
    }
    /**
   * Only works with WebGL2
   *
   * blits framebuffer to another of the same or bigger size
   * after that target framebuffer is bound
   *
   * Fails with WebGL warning if blits multisample framebuffer to different size
   * @param framebuffer - by default it blits "into itself", from renderBuffer to texture.
   * @param sourcePixels - source rectangle in pixels
   * @param destPixels - dest rectangle in pixels, assumed to be the same as sourcePixels
   */ blit(framebuffer, sourcePixels, destPixels) {
        const { current: current, renderer: renderer, gl: gl, CONTEXT_UID: CONTEXT_UID } = this;
        if (renderer.context.webGLVersion !== 2 || !current) return;
        const fbo = current.glFramebuffers[CONTEXT_UID];
        if (!fbo) return;
        if (!framebuffer) {
            if (!fbo.msaaBuffer) return;
            const colorTexture = current.colorTextures[0];
            if (!colorTexture) return;
            fbo.blitFramebuffer || (fbo.blitFramebuffer = new (0, $8bbab5b5070242d8$export$eff95f126aa67cfb)(current.width, current.height), fbo.blitFramebuffer.addColorTexture(0, colorTexture)), framebuffer = fbo.blitFramebuffer, framebuffer.colorTextures[0] !== colorTexture && (framebuffer.colorTextures[0] = colorTexture, framebuffer.dirtyId++, framebuffer.dirtyFormat++), (framebuffer.width !== current.width || framebuffer.height !== current.height) && (framebuffer.width = current.width, framebuffer.height = current.height, framebuffer.dirtyId++, framebuffer.dirtySize++);
        }
        sourcePixels || (sourcePixels = $e8b9bd1f9f3749d4$var$tempRectangle, sourcePixels.width = current.width, sourcePixels.height = current.height), destPixels || (destPixels = sourcePixels);
        const sameSize = sourcePixels.width === destPixels.width && sourcePixels.height === destPixels.height;
        this.bind(framebuffer), gl.bindFramebuffer(gl.READ_FRAMEBUFFER, fbo.framebuffer), gl.blitFramebuffer(sourcePixels.left, sourcePixels.top, sourcePixels.right, sourcePixels.bottom, destPixels.left, destPixels.top, destPixels.right, destPixels.bottom, gl.COLOR_BUFFER_BIT, sameSize ? gl.NEAREST : gl.LINEAR), gl.bindFramebuffer(gl.READ_FRAMEBUFFER, framebuffer.glFramebuffers[this.CONTEXT_UID].framebuffer);
    }
    /**
   * Disposes framebuffer.
   * @param framebuffer - framebuffer that has to be disposed of
   * @param contextLost - If context was lost, we suppress all delete function calls
   */ disposeFramebuffer(framebuffer, contextLost) {
        const fbo = framebuffer.glFramebuffers[this.CONTEXT_UID], gl = this.gl;
        if (!fbo) return;
        delete framebuffer.glFramebuffers[this.CONTEXT_UID];
        const index = this.managedFramebuffers.indexOf(framebuffer);
        index >= 0 && this.managedFramebuffers.splice(index, 1), framebuffer.disposeRunner.remove(this), contextLost || (gl.deleteFramebuffer(fbo.framebuffer), fbo.msaaBuffer && gl.deleteRenderbuffer(fbo.msaaBuffer), fbo.stencil && gl.deleteRenderbuffer(fbo.stencil)), fbo.blitFramebuffer && this.disposeFramebuffer(fbo.blitFramebuffer, contextLost);
    }
    /**
   * Disposes all framebuffers, but not textures bound to them.
   * @param [contextLost=false] - If context was lost, we suppress all delete function calls
   */ disposeAll(contextLost) {
        const list = this.managedFramebuffers;
        this.managedFramebuffers = [];
        for(let i = 0; i < list.length; i++)this.disposeFramebuffer(list[i], contextLost);
    }
    /**
   * Forcing creation of stencil buffer for current framebuffer, if it wasn't done before.
   * Used by MaskSystem, when its time to use stencil mask for Graphics element.
   *
   * Its an alternative for public lazy `framebuffer.enableStencil`, in case we need stencil without rebind.
   * @private
   */ forceStencil() {
        const framebuffer = this.current;
        if (!framebuffer) return;
        const fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
        if (!fbo || fbo.stencil && framebuffer.stencil) return;
        framebuffer.stencil = !0;
        const w = framebuffer.width, h = framebuffer.height, gl = this.gl, stencil = fbo.stencil = gl.createRenderbuffer();
        gl.bindRenderbuffer(gl.RENDERBUFFER, stencil);
        let stencilAttachment, stencilFormat;
        this.renderer.context.webGLVersion === 1 ? (stencilAttachment = gl.DEPTH_STENCIL_ATTACHMENT, stencilFormat = gl.DEPTH_STENCIL) : framebuffer.depth ? (stencilAttachment = gl.DEPTH_STENCIL_ATTACHMENT, stencilFormat = gl.DEPTH24_STENCIL8) : (stencilAttachment = gl.STENCIL_ATTACHMENT, stencilFormat = gl.STENCIL_INDEX8), fbo.msaaBuffer ? gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, stencilFormat, w, h) : gl.renderbufferStorage(gl.RENDERBUFFER, stencilFormat, w, h), gl.framebufferRenderbuffer(gl.FRAMEBUFFER, stencilAttachment, gl.RENDERBUFFER, stencil);
    }
    /** Resets framebuffer stored state, binds screen framebuffer. Should be called before renderTexture reset(). */ reset() {
        this.current = this.unknownFramebuffer, this.viewport = new (0, $92248a7cf1facbda$export$4617fb02663045ef)();
    }
    destroy() {
        this.renderer = null;
    }
}
$e8b9bd1f9f3749d4$export$3f472331251297cd.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
    name: "framebuffer"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($e8b9bd1f9f3749d4$export$3f472331251297cd);





const $2da9c67c9b0dfff2$var$byteSizeMap = {
    5126: 4,
    5123: 2,
    5121: 1
};
class $2da9c67c9b0dfff2$export$c83da0f390a7459c {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        this.renderer = renderer, this._activeGeometry = null, this._activeVao = null, this.hasVao = !0, this.hasInstance = !0, this.canUseUInt32ElementIndex = !1, this.managedGeometries = {};
    }
    /** Sets up the renderer context and necessary buffers. */ contextChange() {
        this.disposeAll(!0);
        const gl = this.gl = this.renderer.gl, context = this.renderer.context;
        if (this.CONTEXT_UID = this.renderer.CONTEXT_UID, context.webGLVersion !== 2) {
            let nativeVaoExtension = this.renderer.context.extensions.vertexArrayObject;
            (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).PREFER_ENV === (0, $5912637ee8cf8b9f$export$83401e34d5e11bf4).WEBGL_LEGACY && (nativeVaoExtension = null), nativeVaoExtension ? (gl.createVertexArray = ()=>nativeVaoExtension.createVertexArrayOES(), gl.bindVertexArray = (vao)=>nativeVaoExtension.bindVertexArrayOES(vao), gl.deleteVertexArray = (vao)=>nativeVaoExtension.deleteVertexArrayOES(vao)) : (this.hasVao = !1, gl.createVertexArray = ()=>null, gl.bindVertexArray = ()=>null, gl.deleteVertexArray = ()=>null);
        }
        if (context.webGLVersion !== 2) {
            const instanceExt = gl.getExtension("ANGLE_instanced_arrays");
            instanceExt ? (gl.vertexAttribDivisor = (a, b)=>instanceExt.vertexAttribDivisorANGLE(a, b), gl.drawElementsInstanced = (a, b, c, d, e)=>instanceExt.drawElementsInstancedANGLE(a, b, c, d, e), gl.drawArraysInstanced = (a, b, c, d)=>instanceExt.drawArraysInstancedANGLE(a, b, c, d)) : this.hasInstance = !1;
        }
        this.canUseUInt32ElementIndex = context.webGLVersion === 2 || !!context.extensions.uint32ElementIndex;
    }
    /**
   * Binds geometry so that is can be drawn. Creating a Vao if required
   * @param geometry - Instance of geometry to bind.
   * @param shader - Instance of shader to use vao for.
   */ bind(geometry, shader) {
        shader = shader || this.renderer.shader.shader;
        const { gl: gl } = this;
        let vaos = geometry.glVertexArrayObjects[this.CONTEXT_UID], incRefCount = !1;
        vaos || (this.managedGeometries[geometry.id] = geometry, geometry.disposeRunner.add(this), geometry.glVertexArrayObjects[this.CONTEXT_UID] = vaos = {}, incRefCount = !0);
        const vao = vaos[shader.program.id] || this.initGeometryVao(geometry, shader, incRefCount);
        this._activeGeometry = geometry, this._activeVao !== vao && (this._activeVao = vao, this.hasVao ? gl.bindVertexArray(vao) : this.activateVao(geometry, shader.program)), this.updateBuffers();
    }
    /** Reset and unbind any active VAO and geometry. */ reset() {
        this.unbind();
    }
    /** Update buffers of the currently bound geometry. */ updateBuffers() {
        const geometry = this._activeGeometry, bufferSystem = this.renderer.buffer;
        for(let i = 0; i < geometry.buffers.length; i++){
            const buffer = geometry.buffers[i];
            bufferSystem.update(buffer);
        }
    }
    /**
   * Check compatibility between a geometry and a program
   * @param geometry - Geometry instance.
   * @param program - Program instance.
   */ checkCompatibility(geometry, program) {
        const geometryAttributes = geometry.attributes, shaderAttributes = program.attributeData;
        for(const j in shaderAttributes)if (!geometryAttributes[j]) throw new Error(`shader and geometry incompatible, geometry missing the "${j}" attribute`);
    }
    /**
   * Takes a geometry and program and generates a unique signature for them.
   * @param geometry - To get signature from.
   * @param program - To test geometry against.
   * @returns - Unique signature of the geometry and program
   */ getSignature(geometry, program) {
        const attribs = geometry.attributes, shaderAttributes = program.attributeData, strings = [
            "g",
            geometry.id
        ];
        for(const i in attribs)shaderAttributes[i] && strings.push(i, shaderAttributes[i].location);
        return strings.join("-");
    }
    /**
   * Creates or gets Vao with the same structure as the geometry and stores it on the geometry.
   * If vao is created, it is bound automatically. We use a shader to infer what and how to set up the
   * attribute locations.
   * @param geometry - Instance of geometry to to generate Vao for.
   * @param shader - Instance of the shader.
   * @param incRefCount - Increment refCount of all geometry buffers.
   */ initGeometryVao(geometry, shader, incRefCount = !0) {
        const gl = this.gl, CONTEXT_UID = this.CONTEXT_UID, bufferSystem = this.renderer.buffer, program = shader.program;
        program.glPrograms[CONTEXT_UID] || this.renderer.shader.generateProgram(shader), this.checkCompatibility(geometry, program);
        const signature = this.getSignature(geometry, program), vaoObjectHash = geometry.glVertexArrayObjects[this.CONTEXT_UID];
        let vao = vaoObjectHash[signature];
        if (vao) return vaoObjectHash[program.id] = vao, vao;
        const buffers = geometry.buffers, attributes = geometry.attributes, tempStride = {}, tempStart = {};
        for(const j in buffers)tempStride[j] = 0, tempStart[j] = 0;
        for(const j in attributes)!attributes[j].size && program.attributeData[j] ? attributes[j].size = program.attributeData[j].size : attributes[j].size || console.warn(`PIXI Geometry attribute '${j}' size cannot be determined (likely the bound shader does not have the attribute)`), tempStride[attributes[j].buffer] += attributes[j].size * $2da9c67c9b0dfff2$var$byteSizeMap[attributes[j].type];
        for(const j in attributes){
            const attribute = attributes[j], attribSize = attribute.size;
            attribute.stride === void 0 && (tempStride[attribute.buffer] === attribSize * $2da9c67c9b0dfff2$var$byteSizeMap[attribute.type] ? attribute.stride = 0 : attribute.stride = tempStride[attribute.buffer]), attribute.start === void 0 && (attribute.start = tempStart[attribute.buffer], tempStart[attribute.buffer] += attribSize * $2da9c67c9b0dfff2$var$byteSizeMap[attribute.type]);
        }
        vao = gl.createVertexArray(), gl.bindVertexArray(vao);
        for(let i = 0; i < buffers.length; i++){
            const buffer = buffers[i];
            bufferSystem.bind(buffer), incRefCount && buffer._glBuffers[CONTEXT_UID].refCount++;
        }
        return this.activateVao(geometry, program), vaoObjectHash[program.id] = vao, vaoObjectHash[signature] = vao, gl.bindVertexArray(null), bufferSystem.unbind((0, $5912637ee8cf8b9f$export$b595a7e482202b96).ARRAY_BUFFER), vao;
    }
    /**
   * Disposes geometry.
   * @param geometry - Geometry with buffers. Only VAO will be disposed
   * @param [contextLost=false] - If context was lost, we suppress deleteVertexArray
   */ disposeGeometry(geometry, contextLost) {
        if (!this.managedGeometries[geometry.id]) return;
        delete this.managedGeometries[geometry.id];
        const vaos = geometry.glVertexArrayObjects[this.CONTEXT_UID], gl = this.gl, buffers = geometry.buffers, bufferSystem = this.renderer?.buffer;
        if (geometry.disposeRunner.remove(this), !!vaos) {
            if (bufferSystem) for(let i = 0; i < buffers.length; i++){
                const buf = buffers[i]._glBuffers[this.CONTEXT_UID];
                buf && (buf.refCount--, buf.refCount === 0 && !contextLost && bufferSystem.dispose(buffers[i], contextLost));
            }
            if (!contextLost) {
                for(const vaoId in vaos)if (vaoId[0] === "g") {
                    const vao = vaos[vaoId];
                    this._activeVao === vao && this.unbind(), gl.deleteVertexArray(vao);
                }
            }
            delete geometry.glVertexArrayObjects[this.CONTEXT_UID];
        }
    }
    /**
   * Dispose all WebGL resources of all managed geometries.
   * @param [contextLost=false] - If context was lost, we suppress `gl.delete` calls
   */ disposeAll(contextLost) {
        const all = Object.keys(this.managedGeometries);
        for(let i = 0; i < all.length; i++)this.disposeGeometry(this.managedGeometries[all[i]], contextLost);
    }
    /**
   * Activate vertex array object.
   * @param geometry - Geometry instance.
   * @param program - Shader program instance.
   */ activateVao(geometry, program) {
        const gl = this.gl, CONTEXT_UID = this.CONTEXT_UID, bufferSystem = this.renderer.buffer, buffers = geometry.buffers, attributes = geometry.attributes;
        geometry.indexBuffer && bufferSystem.bind(geometry.indexBuffer);
        let lastBuffer = null;
        for(const j in attributes){
            const attribute = attributes[j], buffer = buffers[attribute.buffer], glBuffer = buffer._glBuffers[CONTEXT_UID];
            if (program.attributeData[j]) {
                lastBuffer !== glBuffer && (bufferSystem.bind(buffer), lastBuffer = glBuffer);
                const location = program.attributeData[j].location;
                if (gl.enableVertexAttribArray(location), gl.vertexAttribPointer(location, attribute.size, attribute.type || gl.FLOAT, attribute.normalized, attribute.stride, attribute.start), attribute.instance) {
                    if (this.hasInstance) gl.vertexAttribDivisor(location, attribute.divisor);
                    else throw new Error("geometry error, GPU Instancing is not supported on this device");
                }
            }
        }
    }
    /**
   * Draws the currently bound geometry.
   * @param type - The type primitive to render.
   * @param size - The number of elements to be rendered. If not specified, all vertices after the
   *  starting vertex will be drawn.
   * @param start - The starting vertex in the geometry to start drawing from. If not specified,
   *  drawing will start from the first vertex.
   * @param instanceCount - The number of instances of the set of elements to execute. If not specified,
   *  all instances will be drawn.
   */ draw(type, size, start, instanceCount) {
        const { gl: gl } = this, geometry = this._activeGeometry;
        if (geometry.indexBuffer) {
            const byteSize = geometry.indexBuffer.data.BYTES_PER_ELEMENT, glType = byteSize === 2 ? gl.UNSIGNED_SHORT : gl.UNSIGNED_INT;
            byteSize === 2 || byteSize === 4 && this.canUseUInt32ElementIndex ? geometry.instanced ? gl.drawElementsInstanced(type, size || geometry.indexBuffer.data.length, glType, (start || 0) * byteSize, instanceCount || 1) : gl.drawElements(type, size || geometry.indexBuffer.data.length, glType, (start || 0) * byteSize) : console.warn("unsupported index buffer type: uint32");
        } else geometry.instanced ? gl.drawArraysInstanced(type, start, size || geometry.getSize(), instanceCount || 1) : gl.drawArrays(type, start, size || geometry.getSize());
        return this;
    }
    /** Unbind/reset everything. */ unbind() {
        this.gl.bindVertexArray(null), this._activeVao = null, this._activeGeometry = null;
    }
    destroy() {
        this.renderer = null;
    }
}
$2da9c67c9b0dfff2$export$c83da0f390a7459c.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
    name: "geometry"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($2da9c67c9b0dfff2$export$c83da0f390a7459c);






const $132bbbe3a3fc729e$var$tempMat = new (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85)();
class $132bbbe3a3fc729e$export$dbea3135e9da48cb {
    /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */ constructor(texture, clampMargin){
        this._texture = texture, this.mapCoord = new (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85)(), this.uClampFrame = new Float32Array(4), this.uClampOffset = new Float32Array(2), this._textureID = -1, this._updateID = 0, this.clampOffset = 0, this.clampMargin = typeof clampMargin > "u" ? 0.5 : clampMargin, this.isSimple = !1;
    }
    /** Texture property. */ get texture() {
        return this._texture;
    }
    set texture(value) {
        this._texture = value, this._textureID = -1;
    }
    /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */ multiplyUvs(uvs, out) {
        out === void 0 && (out = uvs);
        const mat = this.mapCoord;
        for(let i = 0; i < uvs.length; i += 2){
            const x = uvs[i], y = uvs[i + 1];
            out[i] = x * mat.a + y * mat.c + mat.tx, out[i + 1] = x * mat.b + y * mat.d + mat.ty;
        }
        return out;
    }
    /**
   * Updates matrices if texture was changed.
   * @param [forceUpdate=false] - if true, matrices will be updated any case
   * @returns - Whether or not it was updated
   */ update(forceUpdate) {
        const tex = this._texture;
        if (!tex || !tex.valid || !forceUpdate && this._textureID === tex._updateID) return !1;
        this._textureID = tex._updateID, this._updateID++;
        const uvs = tex._uvs;
        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
        const orig = tex.orig, trim = tex.trim;
        trim && ($132bbbe3a3fc729e$var$tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height), this.mapCoord.append($132bbbe3a3fc729e$var$tempMat));
        const texBase = tex.baseTexture, frame = this.uClampFrame, margin = this.clampMargin / texBase.resolution, offset = this.clampOffset;
        return frame[0] = (tex._frame.x + margin + offset) / texBase.width, frame[1] = (tex._frame.y + margin + offset) / texBase.height, frame[2] = (tex._frame.x + tex._frame.width - margin + offset) / texBase.width, frame[3] = (tex._frame.y + tex._frame.height - margin + offset) / texBase.height, this.uClampOffset[0] = offset / texBase.realWidth, this.uClampOffset[1] = offset / texBase.realHeight, this.isSimple = tex._frame.width === texBase.width && tex._frame.height === texBase.height && tex.rotate === 0, !0;
    }
}



var $f9f1f528368dad19$export$2e2bcd8739ae039 = `varying vec2 vMaskCoord;
varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform sampler2D mask;
uniform float alpha;
uniform float npmAlpha;
uniform vec4 maskClamp;

void main(void)
{
    float clip = step(3.5,
        step(maskClamp.x, vMaskCoord.x) +
        step(maskClamp.y, vMaskCoord.y) +
        step(vMaskCoord.x, maskClamp.z) +
        step(vMaskCoord.y, maskClamp.w));

    vec4 original = texture2D(uSampler, vTextureCoord);
    vec4 masky = texture2D(mask, vMaskCoord);
    float alphaMul = 1.0 - npmAlpha * (1.0 - masky.a);

    original *= (alphaMul * masky.r * alpha * clip);

    gl_FragColor = original;
}
`;


var $3ac338cccb6e2d44$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 otherMatrix;

varying vec2 vMaskCoord;
varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = aTextureCoord;
    vMaskCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;
}
`;


class $dc281bc0d03f9ba6$export$6b66f8c14dea0d0 extends (0, $344aa8e787d8e10a$export$ec91da630f36d5ea) {
    /** @ignore */ constructor(vertexSrc, fragmentSrc, uniforms){
        let sprite = null;
        typeof vertexSrc != "string" && fragmentSrc === void 0 && uniforms === void 0 && (sprite = vertexSrc, vertexSrc = void 0, fragmentSrc = void 0, uniforms = void 0), super(vertexSrc || (0, $3ac338cccb6e2d44$export$2e2bcd8739ae039), fragmentSrc || (0, $f9f1f528368dad19$export$2e2bcd8739ae039), uniforms), this.maskSprite = sprite, this.maskMatrix = new (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85)();
    }
    /**
   * Sprite mask
   * @type {PIXI.DisplayObject}
   */ get maskSprite() {
        return this._maskSprite;
    }
    set maskSprite(value) {
        this._maskSprite = value, this._maskSprite && (this._maskSprite.renderable = !1);
    }
    /**
   * Applies the filter
   * @param filterManager - The renderer to retrieve the filter from
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it.
   */ apply(filterManager, input, output, clearMode) {
        const maskSprite = this._maskSprite, tex = maskSprite._texture;
        tex.valid && (tex.uvMatrix || (tex.uvMatrix = new (0, $132bbbe3a3fc729e$export$dbea3135e9da48cb)(tex, 0)), tex.uvMatrix.update(), this.uniforms.npmAlpha = tex.baseTexture.alphaMode ? 0 : 1, this.uniforms.mask = tex, this.uniforms.otherMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, maskSprite).prepend(tex.uvMatrix.mapCoord), this.uniforms.alpha = maskSprite.worldAlpha, this.uniforms.maskClamp = tex.uvMatrix.uClampFrame, filterManager.applyFilter(this, input, output, clearMode));
    }
}




class $9963fee637a526b9$export$c75dec3795e98612 {
    /**
   * Create MaskData
   * @param {PIXI.DisplayObject} [maskObject=null] - object that describes the mask
   */ constructor(maskObject = null){
        this.type = (0, $5912637ee8cf8b9f$export$dbbea138c5d144).NONE, this.autoDetect = !0, this.maskObject = maskObject || null, this.pooled = !1, this.isMaskData = !0, this.resolution = null, this.multisample = (0, $344aa8e787d8e10a$export$ec91da630f36d5ea).defaultMultisample, this.enabled = !0, this.colorMask = 15, this._filters = null, this._stencilCounter = 0, this._scissorCounter = 0, this._scissorRect = null, this._scissorRectLocal = null, this._colorMask = 15, this._target = null;
    }
    /**
   * The sprite mask filter.
   * If set to `null`, the default sprite mask filter is used.
   * @default null
   */ get filter() {
        return this._filters ? this._filters[0] : null;
    }
    set filter(value) {
        value ? this._filters ? this._filters[0] = value : this._filters = [
            value
        ] : this._filters = null;
    }
    /** Resets the mask data after popMask(). */ reset() {
        this.pooled && (this.maskObject = null, this.type = (0, $5912637ee8cf8b9f$export$dbbea138c5d144).NONE, this.autoDetect = !0), this._target = null, this._scissorRectLocal = null;
    }
    /**
   * Copies counters from maskData above, called from pushMask().
   * @param maskAbove
   */ copyCountersOrReset(maskAbove) {
        maskAbove ? (this._stencilCounter = maskAbove._stencilCounter, this._scissorCounter = maskAbove._scissorCounter, this._scissorRect = maskAbove._scissorRect) : (this._stencilCounter = 0, this._scissorCounter = 0, this._scissorRect = null);
    }
}


class $6707e782a6bd8c86$export$a1fbfb1b9cf60ed0 {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.enableScissor = !0, this.alphaMaskPool = [], this.maskDataPool = [], this.maskStack = [], this.alphaMaskIndex = 0;
    }
    /**
   * Changes the mask stack that is used by this System.
   * @param maskStack - The mask stack
   */ setMaskStack(maskStack) {
        this.maskStack = maskStack, this.renderer.scissor.setMaskStack(maskStack), this.renderer.stencil.setMaskStack(maskStack);
    }
    /**
   * Enables the mask and appends it to the current mask stack.
   *
   * NOTE: The batch renderer should be flushed beforehand to prevent pending renders from being masked.
   * @param {PIXI.DisplayObject} target - Display Object to push the mask to
   * @param {PIXI.MaskData|PIXI.Sprite|PIXI.Graphics|PIXI.DisplayObject} maskDataOrTarget - The masking data.
   */ push(target, maskDataOrTarget) {
        let maskData = maskDataOrTarget;
        if (!maskData.isMaskData) {
            const d = this.maskDataPool.pop() || new (0, $9963fee637a526b9$export$c75dec3795e98612)();
            d.pooled = !0, d.maskObject = maskDataOrTarget, maskData = d;
        }
        const maskAbove = this.maskStack.length !== 0 ? this.maskStack[this.maskStack.length - 1] : null;
        if (maskData.copyCountersOrReset(maskAbove), maskData._colorMask = maskAbove ? maskAbove._colorMask : 15, maskData.autoDetect && this.detect(maskData), maskData._target = target, maskData.type !== (0, $5912637ee8cf8b9f$export$dbbea138c5d144).SPRITE && this.maskStack.push(maskData), maskData.enabled) switch(maskData.type){
            case (0, $5912637ee8cf8b9f$export$dbbea138c5d144).SCISSOR:
                this.renderer.scissor.push(maskData);
                break;
            case (0, $5912637ee8cf8b9f$export$dbbea138c5d144).STENCIL:
                this.renderer.stencil.push(maskData);
                break;
            case (0, $5912637ee8cf8b9f$export$dbbea138c5d144).SPRITE:
                maskData.copyCountersOrReset(null), this.pushSpriteMask(maskData);
                break;
            case (0, $5912637ee8cf8b9f$export$dbbea138c5d144).COLOR:
                this.pushColorMask(maskData);
                break;
            default:
                break;
        }
        maskData.type === (0, $5912637ee8cf8b9f$export$dbbea138c5d144).SPRITE && this.maskStack.push(maskData);
    }
    /**
   * Removes the last mask from the mask stack and doesn't return it.
   *
   * NOTE: The batch renderer should be flushed beforehand to render the masked contents before the mask is removed.
   * @param {PIXI.IMaskTarget} target - Display Object to pop the mask from
   */ pop(target) {
        const maskData = this.maskStack.pop();
        if (!(!maskData || maskData._target !== target)) {
            if (maskData.enabled) switch(maskData.type){
                case (0, $5912637ee8cf8b9f$export$dbbea138c5d144).SCISSOR:
                    this.renderer.scissor.pop(maskData);
                    break;
                case (0, $5912637ee8cf8b9f$export$dbbea138c5d144).STENCIL:
                    this.renderer.stencil.pop(maskData.maskObject);
                    break;
                case (0, $5912637ee8cf8b9f$export$dbbea138c5d144).SPRITE:
                    this.popSpriteMask(maskData);
                    break;
                case (0, $5912637ee8cf8b9f$export$dbbea138c5d144).COLOR:
                    this.popColorMask(maskData);
                    break;
                default:
                    break;
            }
            if (maskData.reset(), maskData.pooled && this.maskDataPool.push(maskData), this.maskStack.length !== 0) {
                const maskCurrent = this.maskStack[this.maskStack.length - 1];
                maskCurrent.type === (0, $5912637ee8cf8b9f$export$dbbea138c5d144).SPRITE && maskCurrent._filters && (maskCurrent._filters[0].maskSprite = maskCurrent.maskObject);
            }
        }
    }
    /**
   * Sets type of MaskData based on its maskObject.
   * @param maskData
   */ detect(maskData) {
        const maskObject = maskData.maskObject;
        maskObject ? maskObject.isSprite ? maskData.type = (0, $5912637ee8cf8b9f$export$dbbea138c5d144).SPRITE : this.enableScissor && this.renderer.scissor.testScissor(maskData) ? maskData.type = (0, $5912637ee8cf8b9f$export$dbbea138c5d144).SCISSOR : maskData.type = (0, $5912637ee8cf8b9f$export$dbbea138c5d144).STENCIL : maskData.type = (0, $5912637ee8cf8b9f$export$dbbea138c5d144).COLOR;
    }
    /**
   * Applies the Mask and adds it to the current filter stack.
   * @param maskData - Sprite to be used as the mask.
   */ pushSpriteMask(maskData) {
        const { maskObject: maskObject } = maskData, target = maskData._target;
        let alphaMaskFilter = maskData._filters;
        alphaMaskFilter || (alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex], alphaMaskFilter || (alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex] = [
            new (0, $dc281bc0d03f9ba6$export$6b66f8c14dea0d0)()
        ])), alphaMaskFilter[0].resolution = maskData.resolution, alphaMaskFilter[0].multisample = maskData.multisample, alphaMaskFilter[0].maskSprite = maskObject;
        const stashFilterArea = target.filterArea;
        target.filterArea = maskObject.getBounds(!0), this.renderer.filter.push(target, alphaMaskFilter), target.filterArea = stashFilterArea, maskData._filters || this.alphaMaskIndex++;
    }
    /**
   * Removes the last filter from the filter stack and doesn't return it.
   * @param maskData - Sprite to be used as the mask.
   */ popSpriteMask(maskData) {
        this.renderer.filter.pop(), maskData._filters ? maskData._filters[0].maskSprite = null : (this.alphaMaskIndex--, this.alphaMaskPool[this.alphaMaskIndex][0].maskSprite = null);
    }
    /**
   * Pushes the color mask.
   * @param maskData - The mask data
   */ pushColorMask(maskData) {
        const currColorMask = maskData._colorMask, nextColorMask = maskData._colorMask = currColorMask & maskData.colorMask;
        nextColorMask !== currColorMask && this.renderer.gl.colorMask((nextColorMask & 1) !== 0, (nextColorMask & 2) !== 0, (nextColorMask & 4) !== 0, (nextColorMask & 8) !== 0);
    }
    /**
   * Pops the color mask.
   * @param maskData - The mask data
   */ popColorMask(maskData) {
        const currColorMask = maskData._colorMask, nextColorMask = this.maskStack.length > 0 ? this.maskStack[this.maskStack.length - 1]._colorMask : 15;
        nextColorMask !== currColorMask && this.renderer.gl.colorMask((nextColorMask & 1) !== 0, (nextColorMask & 2) !== 0, (nextColorMask & 4) !== 0, (nextColorMask & 8) !== 0);
    }
    destroy() {
        this.renderer = null;
    }
}
$6707e782a6bd8c86$export$a1fbfb1b9cf60ed0.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
    name: "mask"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($6707e782a6bd8c86$export$a1fbfb1b9cf60ed0);





class $f8d70a92afb8cc48$export$c83199503f0366e9 {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.maskStack = [], this.glConst = 0;
    }
    /** Gets count of masks of certain type. */ getStackLength() {
        return this.maskStack.length;
    }
    /**
   * Changes the mask stack that is used by this System.
   * @param {PIXI.MaskData[]} maskStack - The mask stack
   */ setMaskStack(maskStack) {
        const { gl: gl } = this.renderer, curStackLen = this.getStackLength();
        this.maskStack = maskStack;
        const newStackLen = this.getStackLength();
        newStackLen !== curStackLen && (newStackLen === 0 ? gl.disable(this.glConst) : (gl.enable(this.glConst), this._useCurrent()));
    }
    /**
   * Setup renderer to use the current mask data.
   * @private
   */ _useCurrent() {}
    /** Destroys the mask stack. */ destroy() {
        this.renderer = null, this.maskStack = null;
    }
}


const $8a293501d955804a$var$tempMatrix = new (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85)(), $8a293501d955804a$var$rectPool = [], $8a293501d955804a$var$_ScissorSystem = class _ScissorSystem2 extends (0, $f8d70a92afb8cc48$export$c83199503f0366e9) {
    /**
   * @param {PIXI.Renderer} renderer - The renderer this System works for.
   */ constructor(renderer){
        super(renderer), this.glConst = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.getWebGLRenderingContext().SCISSOR_TEST;
    }
    getStackLength() {
        const maskData = this.maskStack[this.maskStack.length - 1];
        return maskData ? maskData._scissorCounter : 0;
    }
    /**
   * evaluates _boundsTransformed, _scissorRect for MaskData
   * @param maskData
   */ calcScissorRect(maskData) {
        if (maskData._scissorRectLocal) return;
        const prevData = maskData._scissorRect, { maskObject: maskObject } = maskData, { renderer: renderer } = this, renderTextureSystem = renderer.renderTexture, rect = maskObject.getBounds(!0, $8a293501d955804a$var$rectPool.pop() ?? new (0, $92248a7cf1facbda$export$4617fb02663045ef)());
        this.roundFrameToPixels(rect, renderTextureSystem.current ? renderTextureSystem.current.resolution : renderer.resolution, renderTextureSystem.sourceFrame, renderTextureSystem.destinationFrame, renderer.projection.transform), prevData && rect.fit(prevData), maskData._scissorRectLocal = rect;
    }
    static isMatrixRotated(matrix) {
        if (!matrix) return !1;
        const { a: a, b: b, c: c, d: d } = matrix;
        return (Math.abs(b) > 1e-4 || Math.abs(c) > 1e-4) && (Math.abs(a) > 1e-4 || Math.abs(d) > 1e-4);
    }
    /**
   * Test, whether the object can be scissor mask with current renderer projection.
   * Calls "calcScissorRect()" if its true.
   * @param maskData - mask data
   * @returns whether Whether the object can be scissor mask
   */ testScissor(maskData) {
        const { maskObject: maskObject } = maskData;
        if (!maskObject.isFastRect || !maskObject.isFastRect() || _ScissorSystem2.isMatrixRotated(maskObject.worldTransform) || _ScissorSystem2.isMatrixRotated(this.renderer.projection.transform)) return !1;
        this.calcScissorRect(maskData);
        const rect = maskData._scissorRectLocal;
        return rect.width > 0 && rect.height > 0;
    }
    roundFrameToPixels(frame, resolution, bindingSourceFrame, bindingDestinationFrame, transform) {
        _ScissorSystem2.isMatrixRotated(transform) || (transform = transform ? $8a293501d955804a$var$tempMatrix.copyFrom(transform) : $8a293501d955804a$var$tempMatrix.identity(), transform.translate(-bindingSourceFrame.x, -bindingSourceFrame.y).scale(bindingDestinationFrame.width / bindingSourceFrame.width, bindingDestinationFrame.height / bindingSourceFrame.height).translate(bindingDestinationFrame.x, bindingDestinationFrame.y), this.renderer.filter.transformAABB(transform, frame), frame.fit(bindingDestinationFrame), frame.x = Math.round(frame.x * resolution), frame.y = Math.round(frame.y * resolution), frame.width = Math.round(frame.width * resolution), frame.height = Math.round(frame.height * resolution));
    }
    /**
   * Applies the Mask and adds it to the current stencil stack.
   * @author alvin
   * @param maskData - The mask data.
   */ push(maskData) {
        maskData._scissorRectLocal || this.calcScissorRect(maskData);
        const { gl: gl } = this.renderer;
        maskData._scissorRect || gl.enable(gl.SCISSOR_TEST), maskData._scissorCounter++, maskData._scissorRect = maskData._scissorRectLocal, this._useCurrent();
    }
    /**
   * This should be called after a mask is popped off the mask stack. It will rebind the scissor box to be latest with the
   * last mask in the stack.
   *
   * This can also be called when you directly modify the scissor box and want to restore PixiJS state.
   * @param maskData - The mask data.
   */ pop(maskData) {
        const { gl: gl } = this.renderer;
        maskData && $8a293501d955804a$var$rectPool.push(maskData._scissorRectLocal), this.getStackLength() > 0 ? this._useCurrent() : gl.disable(gl.SCISSOR_TEST);
    }
    /**
   * Setup renderer to use the current scissor data.
   * @private
   */ _useCurrent() {
        const rect = this.maskStack[this.maskStack.length - 1]._scissorRect;
        let y;
        this.renderer.renderTexture.current ? y = rect.y : y = this.renderer.height - rect.height - rect.y, this.renderer.gl.scissor(rect.x, y, rect.width, rect.height);
    }
};
$8a293501d955804a$var$_ScissorSystem.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
    name: "scissor"
};
let $8a293501d955804a$export$1851870585e6357f = $8a293501d955804a$var$_ScissorSystem;
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($8a293501d955804a$export$1851870585e6357f);





class $d98424dd0cd2768e$export$d3824b839b1639a2 extends (0, $f8d70a92afb8cc48$export$c83199503f0366e9) {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        super(renderer), this.glConst = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.getWebGLRenderingContext().STENCIL_TEST;
    }
    getStackLength() {
        const maskData = this.maskStack[this.maskStack.length - 1];
        return maskData ? maskData._stencilCounter : 0;
    }
    /**
   * Applies the Mask and adds it to the current stencil stack.
   * @param maskData - The mask data
   */ push(maskData) {
        const maskObject = maskData.maskObject, { gl: gl } = this.renderer, prevMaskCount = maskData._stencilCounter;
        prevMaskCount === 0 && (this.renderer.framebuffer.forceStencil(), gl.clearStencil(0), gl.clear(gl.STENCIL_BUFFER_BIT), gl.enable(gl.STENCIL_TEST)), maskData._stencilCounter++;
        const colorMask = maskData._colorMask;
        colorMask !== 0 && (maskData._colorMask = 0, gl.colorMask(!1, !1, !1, !1)), gl.stencilFunc(gl.EQUAL, prevMaskCount, 4294967295), gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR), maskObject.renderable = !0, maskObject.render(this.renderer), this.renderer.batch.flush(), maskObject.renderable = !1, colorMask !== 0 && (maskData._colorMask = colorMask, gl.colorMask((colorMask & 1) !== 0, (colorMask & 2) !== 0, (colorMask & 4) !== 0, (colorMask & 8) !== 0)), this._useCurrent();
    }
    /**
   * Pops stencil mask. MaskData is already removed from stack
   * @param {PIXI.DisplayObject} maskObject - object of popped mask data
   */ pop(maskObject) {
        const gl = this.renderer.gl;
        if (this.getStackLength() === 0) gl.disable(gl.STENCIL_TEST);
        else {
            const maskData = this.maskStack.length !== 0 ? this.maskStack[this.maskStack.length - 1] : null, colorMask = maskData ? maskData._colorMask : 15;
            colorMask !== 0 && (maskData._colorMask = 0, gl.colorMask(!1, !1, !1, !1)), gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR), maskObject.renderable = !0, maskObject.render(this.renderer), this.renderer.batch.flush(), maskObject.renderable = !1, colorMask !== 0 && (maskData._colorMask = colorMask, gl.colorMask((colorMask & 1) !== 0, (colorMask & 2) !== 0, (colorMask & 4) !== 0, (colorMask & 8) !== 0)), this._useCurrent();
        }
    }
    /**
   * Setup renderer to use the current stencil data.
   * @private
   */ _useCurrent() {
        const gl = this.renderer.gl;
        gl.stencilFunc(gl.EQUAL, this.getStackLength(), 4294967295), gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
    }
}
$d98424dd0cd2768e$export$d3824b839b1639a2.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
    name: "stencil"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($d98424dd0cd2768e$export$d3824b839b1639a2);




class $49f28852b66b5b20$export$b037d01b38347d8b {
    constructor(renderer){
        this.renderer = renderer, this.plugins = {}, Object.defineProperties(this.plugins, {
            extract: {
                enumerable: !1,
                get () {
                    return (0, $4835512019cf238f$export$afd31d834b512e89)("7.0.0", "renderer.plugins.extract has moved to renderer.extract"), renderer.extract;
                }
            },
            prepare: {
                enumerable: !1,
                get () {
                    return (0, $4835512019cf238f$export$afd31d834b512e89)("7.0.0", "renderer.plugins.prepare has moved to renderer.prepare"), renderer.prepare;
                }
            },
            interaction: {
                enumerable: !1,
                get () {
                    return (0, $4835512019cf238f$export$afd31d834b512e89)("7.0.0", "renderer.plugins.interaction has been deprecated, use renderer.events"), renderer.events;
                }
            }
        });
    }
    /**
   * Initialize the plugins.
   * @protected
   */ init() {
        const staticMap = this.rendererPlugins;
        for(const o in staticMap)this.plugins[o] = new staticMap[o](this.renderer);
    }
    destroy() {
        for(const o in this.plugins)this.plugins[o].destroy(), this.plugins[o] = null;
    }
}
$49f28852b66b5b20$export$b037d01b38347d8b.extension = {
    type: [
        (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
        (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).CanvasRendererSystem
    ],
    name: "_plugin"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($49f28852b66b5b20$export$b037d01b38347d8b);




class $ab14e2c1d467227a$export$84be2be6fb3066d2 {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        this.renderer = renderer, this.destinationFrame = null, this.sourceFrame = null, this.defaultFrame = null, this.projectionMatrix = new (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85)(), this.transform = null;
    }
    /**
   * Updates the projection-matrix based on the sourceFrame → destinationFrame mapping provided.
   *
   * NOTE: It is expected you call `renderer.framebuffer.setViewport(destinationFrame)` after this. This is because
   * the framebuffer viewport converts shader vertex output in normalized device coordinates to window coordinates.
   *
   * NOTE-2: {@link PIXI.RenderTextureSystem#bind} updates the projection-matrix when you bind a render-texture.
   * It is expected
   * that you dirty the current bindings when calling this manually.
   * @param destinationFrame - The rectangle in the render-target to render the contents into. If rendering to the canvas,
   *  the origin is on the top-left; if rendering to a render-texture, the origin is on the bottom-left.
   * @param sourceFrame - The rectangle in world space that contains the contents being rendered.
   * @param resolution - The resolution of the render-target, which is the ratio of
   *  world-space (or CSS) pixels to physical pixels.
   * @param root - Whether the render-target is the screen. This is required because rendering to textures
   *  is y-flipped (i.e. upside down relative to the screen).
   */ update(destinationFrame, sourceFrame, resolution, root) {
        this.destinationFrame = destinationFrame || this.destinationFrame || this.defaultFrame, this.sourceFrame = sourceFrame || this.sourceFrame || destinationFrame, this.calculateProjection(this.destinationFrame, this.sourceFrame, resolution, root), this.transform && this.projectionMatrix.append(this.transform);
        const renderer = this.renderer;
        renderer.globalUniforms.uniforms.projectionMatrix = this.projectionMatrix, renderer.globalUniforms.update(), renderer.shader.shader && renderer.shader.syncUniformGroup(renderer.shader.shader.uniforms.globals);
    }
    /**
   * Calculates the `projectionMatrix` to map points inside `sourceFrame` to inside `destinationFrame`.
   * @param _destinationFrame - The destination frame in the render-target.
   * @param sourceFrame - The source frame in world space.
   * @param _resolution - The render-target's resolution, i.e. ratio of CSS to physical pixels.
   * @param root - Whether rendering into the screen. Otherwise, if rendering to a framebuffer, the projection
   *  is y-flipped.
   */ calculateProjection(_destinationFrame, sourceFrame, _resolution, root) {
        const pm = this.projectionMatrix, sign = root ? -1 : 1;
        pm.identity(), pm.a = 1 / sourceFrame.width * 2, pm.d = sign * (1 / sourceFrame.height * 2), pm.tx = -1 - sourceFrame.x * pm.a, pm.ty = -sign - sourceFrame.y * pm.d;
    }
    /**
   * Sets the transform of the active render target to the given matrix.
   * @param _matrix - The transformation matrix
   */ setTransform(_matrix) {}
    destroy() {
        this.renderer = null;
    }
}
$ab14e2c1d467227a$export$84be2be6fb3066d2.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
    name: "projection"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($ab14e2c1d467227a$export$84be2be6fb3066d2);





const $76b0b7d9ead859db$var$tempTransform = new (0, $a93d35f2e511a825$export$563a914cafbdc389)(), $76b0b7d9ead859db$var$tempRect = new (0, $92248a7cf1facbda$export$4617fb02663045ef)();
class $76b0b7d9ead859db$export$690776504ee197a6 {
    constructor(renderer){
        this.renderer = renderer, this._tempMatrix = new (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85)();
    }
    /**
   * A Useful function that returns a texture of the display object that can then be used to create sprites
   * This can be quite useful if your displayObject is complicated and needs to be reused multiple times.
   * @param displayObject - The displayObject the object will be generated from.
   * @param {IGenerateTextureOptions} options - Generate texture options.
   * @param {PIXI.Rectangle} options.region - The region of the displayObject, that shall be rendered,
   *        if no region is specified, defaults to the local bounds of the displayObject.
   * @param {number} [options.resolution] - If not given, the renderer's resolution is used.
   * @param {PIXI.MSAA_QUALITY} [options.multisample] - If not given, the renderer's multisample is used.
   * @returns a shiny new texture of the display object passed in
   */ generateTexture(displayObject, options) {
        const { region: manualRegion, ...textureOptions } = options || {}, region = manualRegion?.copyTo($76b0b7d9ead859db$var$tempRect) || displayObject.getLocalBounds($76b0b7d9ead859db$var$tempRect, !0), resolution = textureOptions.resolution || this.renderer.resolution;
        region.width = Math.max(region.width, 1 / resolution), region.height = Math.max(region.height, 1 / resolution), textureOptions.width = region.width, textureOptions.height = region.height, textureOptions.resolution = resolution, textureOptions.multisample ?? (textureOptions.multisample = this.renderer.multisample);
        const renderTexture = (0, $bbacc38491f82d4b$export$813984f7330b4d72).create(textureOptions);
        this._tempMatrix.tx = -region.x, this._tempMatrix.ty = -region.y;
        const transform = displayObject.transform;
        return displayObject.transform = $76b0b7d9ead859db$var$tempTransform, this.renderer.render(displayObject, {
            renderTexture: renderTexture,
            transform: this._tempMatrix,
            skipUpdateTransform: !!displayObject.parent,
            blit: !0
        }), displayObject.transform = transform, renderTexture;
    }
    destroy() {}
}
$76b0b7d9ead859db$export$690776504ee197a6.extension = {
    type: [
        (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
        (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).CanvasRendererSystem
    ],
    name: "textureGenerator"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($76b0b7d9ead859db$export$690776504ee197a6);





const $b171f96653949d35$var$tempRect = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(), $b171f96653949d35$var$tempRect2 = new (0, $92248a7cf1facbda$export$4617fb02663045ef)();
class $b171f96653949d35$export$5fd756363f54136f {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.defaultMaskStack = [], this.current = null, this.sourceFrame = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(), this.destinationFrame = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(), this.viewportFrame = new (0, $92248a7cf1facbda$export$4617fb02663045ef)();
    }
    contextChange() {
        const attributes = this.renderer?.gl.getContextAttributes();
        this._rendererPremultipliedAlpha = !!(attributes && attributes.alpha && attributes.premultipliedAlpha);
    }
    /**
   * Bind the current render texture.
   * @param renderTexture - RenderTexture to bind, by default its `null` - the screen.
   * @param sourceFrame - Part of world that is mapped to the renderTexture.
   * @param destinationFrame - Part of renderTexture, by default it has the same size as sourceFrame.
   */ bind(renderTexture = null, sourceFrame, destinationFrame) {
        const renderer = this.renderer;
        this.current = renderTexture;
        let baseTexture, framebuffer, resolution;
        renderTexture ? (baseTexture = renderTexture.baseTexture, resolution = baseTexture.resolution, sourceFrame || ($b171f96653949d35$var$tempRect.width = renderTexture.frame.width, $b171f96653949d35$var$tempRect.height = renderTexture.frame.height, sourceFrame = $b171f96653949d35$var$tempRect), destinationFrame || ($b171f96653949d35$var$tempRect2.x = renderTexture.frame.x, $b171f96653949d35$var$tempRect2.y = renderTexture.frame.y, $b171f96653949d35$var$tempRect2.width = sourceFrame.width, $b171f96653949d35$var$tempRect2.height = sourceFrame.height, destinationFrame = $b171f96653949d35$var$tempRect2), framebuffer = baseTexture.framebuffer) : (resolution = renderer.resolution, sourceFrame || ($b171f96653949d35$var$tempRect.width = renderer._view.screen.width, $b171f96653949d35$var$tempRect.height = renderer._view.screen.height, sourceFrame = $b171f96653949d35$var$tempRect), destinationFrame || (destinationFrame = $b171f96653949d35$var$tempRect, destinationFrame.width = sourceFrame.width, destinationFrame.height = sourceFrame.height));
        const viewportFrame = this.viewportFrame;
        viewportFrame.x = destinationFrame.x * resolution, viewportFrame.y = destinationFrame.y * resolution, viewportFrame.width = destinationFrame.width * resolution, viewportFrame.height = destinationFrame.height * resolution, renderTexture || (viewportFrame.y = renderer.view.height - (viewportFrame.y + viewportFrame.height)), viewportFrame.ceil(), this.renderer.framebuffer.bind(framebuffer, viewportFrame), this.renderer.projection.update(destinationFrame, sourceFrame, resolution, !framebuffer), renderTexture ? this.renderer.mask.setMaskStack(baseTexture.maskStack) : this.renderer.mask.setMaskStack(this.defaultMaskStack), this.sourceFrame.copyFrom(sourceFrame), this.destinationFrame.copyFrom(destinationFrame);
    }
    /**
   * Erases the render texture and fills the drawing area with a colour.
   * @param clearColor - The color as rgba, default to use the renderer backgroundColor
   * @param [mask=BUFFER_BITS.COLOR | BUFFER_BITS.DEPTH] - Bitwise OR of masks
   *  that indicate the buffers to be cleared, by default COLOR and DEPTH buffers.
   */ clear(clearColor, mask) {
        const fallbackColor = this.current ? this.current.baseTexture.clear : this.renderer.background.backgroundColor, color = (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(clearColor || fallbackColor);
        (this.current && this.current.baseTexture.alphaMode > 0 || !this.current && this._rendererPremultipliedAlpha) && color.premultiply(color.alpha);
        const destinationFrame = this.destinationFrame, baseFrame = this.current ? this.current.baseTexture : this.renderer._view.screen, clearMask = destinationFrame.width !== baseFrame.width || destinationFrame.height !== baseFrame.height;
        if (clearMask) {
            let { x: x, y: y, width: width, height: height } = this.viewportFrame;
            x = Math.round(x), y = Math.round(y), width = Math.round(width), height = Math.round(height), this.renderer.gl.enable(this.renderer.gl.SCISSOR_TEST), this.renderer.gl.scissor(x, y, width, height);
        }
        this.renderer.framebuffer.clear(color.red, color.green, color.blue, color.alpha, mask), clearMask && this.renderer.scissor.pop();
    }
    resize() {
        this.bind(null);
    }
    /** Resets render-texture state. */ reset() {
        this.bind(null);
    }
    destroy() {
        this.renderer = null;
    }
}
$b171f96653949d35$export$5fd756363f54136f.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
    name: "renderTexture"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($b171f96653949d35$export$5fd756363f54136f);




class $c2987ad7830145dc$export$181be621ce68aec5 {
}
class $c2987ad7830145dc$export$bf1479c8ce91afd5 {
    /**
   * Makes a new Pixi program.
   * @param program - webgl program
   * @param uniformData - uniforms
   */ constructor(program, uniformData){
        this.program = program, this.uniformData = uniformData, this.uniformGroups = {}, this.uniformDirtyGroups = {}, this.uniformBufferBindings = {};
    }
    /** Destroys this program. */ destroy() {
        this.uniformData = null, this.uniformGroups = null, this.uniformDirtyGroups = null, this.uniformBufferBindings = null, this.program = null;
    }
}






function $861db60ede5be4e3$export$c73f9ceeec70bdfb(program, gl) {
    const attributes = {}, totalAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < totalAttributes; i++){
        const attribData = gl.getActiveAttrib(program, i);
        if (attribData.name.startsWith("gl_")) continue;
        const type = (0, $ed555d453f4c2e4f$export$4de3a94418d86ca7)(gl, attribData.type), data = {
            type: type,
            name: attribData.name,
            size: (0, $aad17c1cf71ac7af$export$50ee69a11aa2abdb)(type),
            location: gl.getAttribLocation(program, attribData.name)
        };
        attributes[attribData.name] = data;
    }
    return attributes;
}




function $fcf1927d16005118$export$d38fd6033d9429a5(program, gl) {
    const uniforms = {}, totalUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
    for(let i = 0; i < totalUniforms; i++){
        const uniformData = gl.getActiveUniform(program, i), name = uniformData.name.replace(/\[.*?\]$/, ""), isArray = !!uniformData.name.match(/\[.*?\]$/), type = (0, $ed555d453f4c2e4f$export$4de3a94418d86ca7)(gl, uniformData.type);
        uniforms[name] = {
            name: name,
            index: i,
            type: type,
            size: uniformData.size,
            isArray: isArray,
            value: (0, $8ab13255b022e772$export$1a01ae0705bafd37)(type, uniformData.size)
        };
    }
    return uniforms;
}



function $8a05b527d8017bdf$export$44c84e8c8e54bce9(gl, program) {
    const glVertShader = (0, $804c80302f4ca5d0$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, program.vertexSrc), glFragShader = (0, $804c80302f4ca5d0$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, program.fragmentSrc), webGLProgram = gl.createProgram();
    gl.attachShader(webGLProgram, glVertShader), gl.attachShader(webGLProgram, glFragShader);
    const transformFeedbackVaryings = program.extra?.transformFeedbackVaryings;
    if (transformFeedbackVaryings && (typeof gl.transformFeedbackVaryings != "function" ? console.warn("TransformFeedback is not supported but TransformFeedbackVaryings are given.") : gl.transformFeedbackVaryings(webGLProgram, transformFeedbackVaryings.names, transformFeedbackVaryings.bufferMode === "separate" ? gl.SEPARATE_ATTRIBS : gl.INTERLEAVED_ATTRIBS)), gl.linkProgram(webGLProgram), gl.getProgramParameter(webGLProgram, gl.LINK_STATUS) || (0, $15f165c49a21601f$export$4b35d6c62dc992b0)(gl, webGLProgram, glVertShader, glFragShader), program.attributeData = (0, $861db60ede5be4e3$export$c73f9ceeec70bdfb)(webGLProgram, gl), program.uniformData = (0, $fcf1927d16005118$export$d38fd6033d9429a5)(webGLProgram, gl), !/^[ \t]*#[ \t]*version[ \t]+300[ \t]+es[ \t]*$/m.test(program.vertexSrc)) {
        const keys = Object.keys(program.attributeData);
        keys.sort((a, b)=>a > b ? 1 : -1);
        for(let i = 0; i < keys.length; i++)program.attributeData[keys[i]].location = i, gl.bindAttribLocation(webGLProgram, i, keys[i]);
        gl.linkProgram(webGLProgram);
    }
    gl.deleteShader(glVertShader), gl.deleteShader(glFragShader);
    const uniformData = {};
    for(const i in program.uniformData){
        const data = program.uniformData[i];
        uniformData[i] = {
            location: gl.getUniformLocation(webGLProgram, i),
            value: (0, $8ab13255b022e772$export$1a01ae0705bafd37)(data.type, data.size)
        };
    }
    return new (0, $c2987ad7830145dc$export$bf1479c8ce91afd5)(webGLProgram, uniformData);
}





function $8b4290fb778f9cf0$var$uboUpdate(_ud, _uv, _renderer, _syncData, buffer) {
    _renderer.buffer.update(buffer);
}
const $8b4290fb778f9cf0$var$UBO_TO_SINGLE_SETTERS = {
    float: `
        data[offset] = v;
    `,
    vec2: `
        data[offset] = v[0];
        data[offset+1] = v[1];
    `,
    vec3: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];

    `,
    vec4: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];
        data[offset+3] = v[3];
    `,
    mat2: `
        data[offset] = v[0];
        data[offset+1] = v[1];

        data[offset+4] = v[2];
        data[offset+5] = v[3];
    `,
    mat3: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];

        data[offset + 4] = v[3];
        data[offset + 5] = v[4];
        data[offset + 6] = v[5];

        data[offset + 8] = v[6];
        data[offset + 9] = v[7];
        data[offset + 10] = v[8];
    `,
    mat4: `
        for(var i = 0; i < 16; i++)
        {
            data[offset + i] = v[i];
        }
    `
}, $8b4290fb778f9cf0$var$GLSL_TO_STD40_SIZE = {
    float: 4,
    vec2: 8,
    vec3: 12,
    vec4: 16,
    int: 4,
    ivec2: 8,
    ivec3: 12,
    ivec4: 16,
    uint: 4,
    uvec2: 8,
    uvec3: 12,
    uvec4: 16,
    bool: 4,
    bvec2: 8,
    bvec3: 12,
    bvec4: 16,
    mat2: 32,
    mat3: 48,
    mat4: 64
};
function $8b4290fb778f9cf0$export$3c4fb828fecb3ead(uniformData) {
    const uboElements = uniformData.map((data)=>({
            data: data,
            offset: 0,
            dataLen: 0,
            dirty: 0
        }));
    let size = 0, chunkSize = 0, offset = 0;
    for(let i = 0; i < uboElements.length; i++){
        const uboElement = uboElements[i];
        if (size = $8b4290fb778f9cf0$var$GLSL_TO_STD40_SIZE[uboElement.data.type], uboElement.data.size > 1 && (size = Math.max(size, 16) * uboElement.data.size), uboElement.dataLen = size, chunkSize % size !== 0 && chunkSize < 16) {
            const lineUpValue = chunkSize % size % 16;
            chunkSize += lineUpValue, offset += lineUpValue;
        }
        chunkSize + size > 16 ? (offset = Math.ceil(offset / 16) * 16, uboElement.offset = offset, offset += size, chunkSize = size) : (uboElement.offset = offset, chunkSize += size, offset += size);
    }
    return offset = Math.ceil(offset / 16) * 16, {
        uboElements: uboElements,
        size: offset
    };
}
function $8b4290fb778f9cf0$export$56f32278ebf30ea0(uniforms, uniformData) {
    const usedUniformDatas = [];
    for(const i in uniforms)uniformData[i] && usedUniformDatas.push(uniformData[i]);
    return usedUniformDatas.sort((a, b)=>a.index - b.index), usedUniformDatas;
}
function $8b4290fb778f9cf0$export$39fbc1d5b3f112e4(group, uniformData) {
    if (!group.autoManage) return {
        size: 0,
        syncFunc: $8b4290fb778f9cf0$var$uboUpdate
    };
    const usedUniformDatas = $8b4290fb778f9cf0$export$56f32278ebf30ea0(group.uniforms, uniformData), { uboElements: uboElements, size: size } = $8b4290fb778f9cf0$export$3c4fb828fecb3ead(usedUniformDatas), funcFragments = [
        `
    var v = null;
    var v2 = null;
    var cv = null;
    var t = 0;
    var gl = renderer.gl
    var index = 0;
    var data = buffer.data;
    `
    ];
    for(let i = 0; i < uboElements.length; i++){
        const uboElement = uboElements[i], uniform = group.uniforms[uboElement.data.name], name = uboElement.data.name;
        let parsed = !1;
        for(let j = 0; j < (0, $099125ae68d9308e$export$cf9f41a7e506e2d2).length; j++){
            const uniformParser = (0, $099125ae68d9308e$export$cf9f41a7e506e2d2)[j];
            if (uniformParser.codeUbo && uniformParser.test(uboElement.data, uniform)) {
                funcFragments.push(`offset = ${uboElement.offset / 4};`, (0, $099125ae68d9308e$export$cf9f41a7e506e2d2)[j].codeUbo(uboElement.data.name, uniform)), parsed = !0;
                break;
            }
        }
        if (!parsed) {
            if (uboElement.data.size > 1) {
                const size2 = (0, $aad17c1cf71ac7af$export$50ee69a11aa2abdb)(uboElement.data.type), rowSize = Math.max($8b4290fb778f9cf0$var$GLSL_TO_STD40_SIZE[uboElement.data.type] / 16, 1), elementSize = size2 / rowSize, remainder = (4 - elementSize % 4) % 4;
                funcFragments.push(`
                cv = ud.${name}.value;
                v = uv.${name};
                offset = ${uboElement.offset / 4};

                t = 0;

                for(var i=0; i < ${uboElement.data.size * rowSize}; i++)
                {
                    for(var j = 0; j < ${elementSize}; j++)
                    {
                        data[offset++] = v[t++];
                    }
                    offset += ${remainder};
                }

                `);
            } else {
                const template = $8b4290fb778f9cf0$var$UBO_TO_SINGLE_SETTERS[uboElement.data.type];
                funcFragments.push(`
                cv = ud.${name}.value;
                v = uv.${name};
                offset = ${uboElement.offset / 4};
                ${template};
                `);
            }
        }
    }
    return funcFragments.push(`
       renderer.buffer.update(buffer);
    `), {
        size: size,
        // eslint-disable-next-line no-new-func
        syncFunc: new Function("ud", "uv", "renderer", "syncData", "buffer", funcFragments.join(`
`))
    };
}




let $03bec598ea9bb481$var$UID = 0;
const $03bec598ea9bb481$var$defaultSyncData = {
    textureCount: 0,
    uboCount: 0
};
class $03bec598ea9bb481$export$d91933f5c44096f4 {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        this.destroyed = !1, this.renderer = renderer, this.systemCheck(), this.gl = null, this.shader = null, this.program = null, this.cache = {}, this._uboCache = {}, this.id = $03bec598ea9bb481$var$UID++;
    }
    /**
   * Overrideable function by `@pixi/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   */ systemCheck() {
        if (!(0, $e29403c21c4a3ad0$export$70c0711f29adc5cf)()) throw new Error("Current environment does not allow unsafe-eval, please use @pixi/unsafe-eval module to enable support.");
    }
    contextChange(gl) {
        this.gl = gl, this.reset();
    }
    /**
   * Changes the current shader to the one given in parameter.
   * @param shader - the new shader
   * @param dontSync - false if the shader should automatically sync its uniforms.
   * @returns the glProgram that belongs to the shader.
   */ bind(shader, dontSync) {
        shader.disposeRunner.add(this), shader.uniforms.globals = this.renderer.globalUniforms;
        const program = shader.program, glProgram = program.glPrograms[this.renderer.CONTEXT_UID] || this.generateProgram(shader);
        return this.shader = shader, this.program !== program && (this.program = program, this.gl.useProgram(glProgram.program)), dontSync || ($03bec598ea9bb481$var$defaultSyncData.textureCount = 0, $03bec598ea9bb481$var$defaultSyncData.uboCount = 0, this.syncUniformGroup(shader.uniformGroup, $03bec598ea9bb481$var$defaultSyncData)), glProgram;
    }
    /**
   * Uploads the uniforms values to the currently bound shader.
   * @param uniforms - the uniforms values that be applied to the current shader
   */ setUniforms(uniforms) {
        const shader = this.shader.program, glProgram = shader.glPrograms[this.renderer.CONTEXT_UID];
        shader.syncUniforms(glProgram.uniformData, uniforms, this.renderer);
    }
    /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /**
   * Syncs uniforms on the group
   * @param group - the uniform group to sync
   * @param syncData - this is data that is passed to the sync function and any nested sync functions
   */ syncUniformGroup(group, syncData) {
        const glProgram = this.getGlProgram();
        (!group.static || group.dirtyId !== glProgram.uniformDirtyGroups[group.id]) && (glProgram.uniformDirtyGroups[group.id] = group.dirtyId, this.syncUniforms(group, glProgram, syncData));
    }
    /**
   * Overrideable by the @pixi/unsafe-eval package to use static syncUniforms instead.
   * @param group
   * @param glProgram
   * @param syncData
   */ syncUniforms(group, glProgram, syncData) {
        (group.syncUniforms[this.shader.program.id] || this.createSyncGroups(group))(glProgram.uniformData, group.uniforms, this.renderer, syncData);
    }
    createSyncGroups(group) {
        const id = this.getSignature(group, this.shader.program.uniformData, "u");
        return this.cache[id] || (this.cache[id] = (0, $c6b47d55caf329c2$export$20c95d1c2d5a6828)(group, this.shader.program.uniformData)), group.syncUniforms[this.shader.program.id] = this.cache[id], group.syncUniforms[this.shader.program.id];
    }
    /**
   * Syncs uniform buffers
   * @param group - the uniform buffer group to sync
   * @param name - the name of the uniform buffer
   */ syncUniformBufferGroup(group, name) {
        const glProgram = this.getGlProgram();
        if (!group.static || group.dirtyId !== 0 || !glProgram.uniformGroups[group.id]) {
            group.dirtyId = 0;
            const syncFunc = glProgram.uniformGroups[group.id] || this.createSyncBufferGroup(group, glProgram, name);
            group.buffer.update(), syncFunc(glProgram.uniformData, group.uniforms, this.renderer, $03bec598ea9bb481$var$defaultSyncData, group.buffer);
        }
        this.renderer.buffer.bindBufferBase(group.buffer, glProgram.uniformBufferBindings[name]);
    }
    /**
   * Will create a function that uploads a uniform buffer using the STD140 standard.
   * The upload function will then be cached for future calls
   * If a group is manually managed, then a simple upload function is generated
   * @param group - the uniform buffer group to sync
   * @param glProgram - the gl program to attach the uniform bindings to
   * @param name - the name of the uniform buffer (must exist on the shader)
   */ createSyncBufferGroup(group, glProgram, name) {
        const { gl: gl } = this.renderer;
        this.renderer.buffer.bind(group.buffer);
        const uniformBlockIndex = this.gl.getUniformBlockIndex(glProgram.program, name);
        glProgram.uniformBufferBindings[name] = this.shader.uniformBindCount, gl.uniformBlockBinding(glProgram.program, uniformBlockIndex, this.shader.uniformBindCount), this.shader.uniformBindCount++;
        const id = this.getSignature(group, this.shader.program.uniformData, "ubo");
        let uboData = this._uboCache[id];
        if (uboData || (uboData = this._uboCache[id] = (0, $8b4290fb778f9cf0$export$39fbc1d5b3f112e4)(group, this.shader.program.uniformData)), group.autoManage) {
            const data = new Float32Array(uboData.size / 4);
            group.buffer.update(data);
        }
        return glProgram.uniformGroups[group.id] = uboData.syncFunc, glProgram.uniformGroups[group.id];
    }
    /**
   * Takes a uniform group and data and generates a unique signature for them.
   * @param group - The uniform group to get signature of
   * @param group.uniforms
   * @param uniformData - Uniform information generated by the shader
   * @param preFix
   * @returns Unique signature of the uniform group
   */ getSignature(group, uniformData, preFix) {
        const uniforms = group.uniforms, strings = [
            `${preFix}-`
        ];
        for(const i in uniforms)strings.push(i), uniformData[i] && strings.push(uniformData[i].type);
        return strings.join("-");
    }
    /**
   * Returns the underlying GLShade rof the currently bound shader.
   *
   * This can be handy for when you to have a little more control over the setting of your uniforms.
   * @returns The glProgram for the currently bound Shader for this context
   */ getGlProgram() {
        return this.shader ? this.shader.program.glPrograms[this.renderer.CONTEXT_UID] : null;
    }
    /**
   * Generates a glProgram version of the Shader provided.
   * @param shader - The shader that the glProgram will be based on.
   * @returns A shiny new glProgram!
   */ generateProgram(shader) {
        const gl = this.gl, program = shader.program, glProgram = (0, $8a05b527d8017bdf$export$44c84e8c8e54bce9)(gl, program);
        return program.glPrograms[this.renderer.CONTEXT_UID] = glProgram, glProgram;
    }
    /** Resets ShaderSystem state, does not affect WebGL state. */ reset() {
        this.program = null, this.shader = null;
    }
    /**
   * Disposes shader.
   * If disposing one equals with current shader, set current as null.
   * @param shader - Shader object
   */ disposeShader(shader) {
        this.shader === shader && (this.shader = null);
    }
    /** Destroys this System and removes all its textures. */ destroy() {
        this.renderer = null, this.destroyed = !0;
    }
}
$03bec598ea9bb481$export$d91933f5c44096f4.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
    name: "shader"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($03bec598ea9bb481$export$d91933f5c44096f4);



class $cbb89fc966da5db7$export$8b298d2bda604a05 {
    constructor(renderer){
        this.renderer = renderer;
    }
    /**
   * It all starts here! This initiates every system, passing in the options for any system by name.
   * @param options - the config for the renderer and all its systems
   */ run(options) {
        const { renderer: renderer } = this;
        renderer.runners.init.emit(renderer.options), options.hello && console.log(`PixiJS 7.3.1 - ${renderer.rendererLogId} - https://pixijs.com`), renderer.resize(renderer.screen.width, renderer.screen.height);
    }
    destroy() {}
}
$cbb89fc966da5db7$export$8b298d2bda604a05.defaultOptions = {
    /**
   * {@link PIXI.IRendererOptions.hello}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ hello: !1
}, /** @ignore */ $cbb89fc966da5db7$export$8b298d2bda604a05.extension = {
    type: [
        (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
        (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).CanvasRendererSystem
    ],
    name: "startup"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($cbb89fc966da5db7$export$8b298d2bda604a05);






function $537d5a5b4971f89f$export$57ed86928a8d2aa1(gl, array = []) {
    return array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).NORMAL] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).ADD] = [
        gl.ONE,
        gl.ONE
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).MULTIPLY] = [
        gl.DST_COLOR,
        gl.ONE_MINUS_SRC_ALPHA,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).SCREEN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_COLOR,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).OVERLAY] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).DARKEN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).LIGHTEN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).COLOR_DODGE] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).COLOR_BURN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).HARD_LIGHT] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).SOFT_LIGHT] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).DIFFERENCE] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).EXCLUSION] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).HUE] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).SATURATION] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).COLOR] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).LUMINOSITY] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).NONE] = [
        0,
        0
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).NORMAL_NPM] = [
        gl.SRC_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).ADD_NPM] = [
        gl.SRC_ALPHA,
        gl.ONE,
        gl.ONE,
        gl.ONE
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).SCREEN_NPM] = [
        gl.SRC_ALPHA,
        gl.ONE_MINUS_SRC_COLOR,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).SRC_IN] = [
        gl.DST_ALPHA,
        gl.ZERO
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).SRC_OUT] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.ZERO
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).SRC_ATOP] = [
        gl.DST_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).DST_OVER] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.ONE
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).DST_IN] = [
        gl.ZERO,
        gl.SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).DST_OUT] = [
        gl.ZERO,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).DST_ATOP] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).XOR] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).SUBTRACT] = [
        gl.ONE,
        gl.ONE,
        gl.ONE,
        gl.ONE,
        gl.FUNC_REVERSE_SUBTRACT,
        gl.FUNC_ADD
    ], array;
}


const $117c032e2cf45e7b$var$BLEND = 0, $117c032e2cf45e7b$var$OFFSET = 1, $117c032e2cf45e7b$var$CULLING = 2, $117c032e2cf45e7b$var$DEPTH_TEST = 3, $117c032e2cf45e7b$var$WINDING = 4, $117c032e2cf45e7b$var$DEPTH_MASK = 5, $117c032e2cf45e7b$var$_StateSystem = class _StateSystem2 {
    constructor(){
        this.gl = null, this.stateId = 0, this.polygonOffset = 0, this.blendMode = (0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).NONE, this._blendEq = !1, this.map = [], this.map[$117c032e2cf45e7b$var$BLEND] = this.setBlend, this.map[$117c032e2cf45e7b$var$OFFSET] = this.setOffset, this.map[$117c032e2cf45e7b$var$CULLING] = this.setCullFace, this.map[$117c032e2cf45e7b$var$DEPTH_TEST] = this.setDepthTest, this.map[$117c032e2cf45e7b$var$WINDING] = this.setFrontFace, this.map[$117c032e2cf45e7b$var$DEPTH_MASK] = this.setDepthMask, this.checks = [], this.defaultState = new (0, $05d0e9a749f67df1$export$7254cc27399e90bd)(), this.defaultState.blend = !0;
    }
    contextChange(gl) {
        this.gl = gl, this.blendModes = (0, $537d5a5b4971f89f$export$57ed86928a8d2aa1)(gl), this.set(this.defaultState), this.reset();
    }
    /**
   * Sets the current state
   * @param {*} state - The state to set.
   */ set(state) {
        if (state = state || this.defaultState, this.stateId !== state.data) {
            let diff = this.stateId ^ state.data, i = 0;
            for(; diff;)diff & 1 && this.map[i].call(this, !!(state.data & 1 << i)), diff = diff >> 1, i++;
            this.stateId = state.data;
        }
        for(let i = 0; i < this.checks.length; i++)this.checks[i](this, state);
    }
    /**
   * Sets the state, when previous state is unknown.
   * @param {*} state - The state to set
   */ forceState(state) {
        state = state || this.defaultState;
        for(let i = 0; i < this.map.length; i++)this.map[i].call(this, !!(state.data & 1 << i));
        for(let i = 0; i < this.checks.length; i++)this.checks[i](this, state);
        this.stateId = state.data;
    }
    /**
   * Sets whether to enable or disable blending.
   * @param value - Turn on or off WebGl blending.
   */ setBlend(value) {
        this.updateCheck(_StateSystem2.checkBlendMode, value), this.gl[value ? "enable" : "disable"](this.gl.BLEND);
    }
    /**
   * Sets whether to enable or disable polygon offset fill.
   * @param value - Turn on or off webgl polygon offset testing.
   */ setOffset(value) {
        this.updateCheck(_StateSystem2.checkPolygonOffset, value), this.gl[value ? "enable" : "disable"](this.gl.POLYGON_OFFSET_FILL);
    }
    /**
   * Sets whether to enable or disable depth test.
   * @param value - Turn on or off webgl depth testing.
   */ setDepthTest(value) {
        this.gl[value ? "enable" : "disable"](this.gl.DEPTH_TEST);
    }
    /**
   * Sets whether to enable or disable depth mask.
   * @param value - Turn on or off webgl depth mask.
   */ setDepthMask(value) {
        this.gl.depthMask(value);
    }
    /**
   * Sets whether to enable or disable cull face.
   * @param {boolean} value - Turn on or off webgl cull face.
   */ setCullFace(value) {
        this.gl[value ? "enable" : "disable"](this.gl.CULL_FACE);
    }
    /**
   * Sets the gl front face.
   * @param {boolean} value - true is clockwise and false is counter-clockwise
   */ setFrontFace(value) {
        this.gl.frontFace(this.gl[value ? "CW" : "CCW"]);
    }
    /**
   * Sets the blend mode.
   * @param {number} value - The blend mode to set to.
   */ setBlendMode(value) {
        if (value === this.blendMode) return;
        this.blendMode = value;
        const mode = this.blendModes[value], gl = this.gl;
        mode.length === 2 ? gl.blendFunc(mode[0], mode[1]) : gl.blendFuncSeparate(mode[0], mode[1], mode[2], mode[3]), mode.length === 6 ? (this._blendEq = !0, gl.blendEquationSeparate(mode[4], mode[5])) : this._blendEq && (this._blendEq = !1, gl.blendEquationSeparate(gl.FUNC_ADD, gl.FUNC_ADD));
    }
    /**
   * Sets the polygon offset.
   * @param {number} value - the polygon offset
   * @param {number} scale - the polygon offset scale
   */ setPolygonOffset(value, scale) {
        this.gl.polygonOffset(value, scale);
    }
    // used
    /** Resets all the logic and disables the VAOs. */ reset() {
        this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, !1), this.forceState(this.defaultState), this._blendEq = !0, this.blendMode = -1, this.setBlendMode(0);
    }
    /**
   * Checks to see which updates should be checked based on which settings have been activated.
   *
   * For example, if blend is enabled then we should check the blend modes each time the state is changed
   * or if polygon fill is activated then we need to check if the polygon offset changes.
   * The idea is that we only check what we have too.
   * @param func - the checking function to add or remove
   * @param value - should the check function be added or removed.
   */ updateCheck(func, value) {
        const index = this.checks.indexOf(func);
        value && index === -1 ? this.checks.push(func) : !value && index !== -1 && this.checks.splice(index, 1);
    }
    /**
   * A private little wrapper function that we call to check the blend mode.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */ static checkBlendMode(system, state) {
        system.setBlendMode(state.blendMode);
    }
    /**
   * A private little wrapper function that we call to check the polygon offset.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */ static checkPolygonOffset(system, state) {
        system.setPolygonOffset(1, state.polygonOffset);
    }
    /**
   * @ignore
   */ destroy() {
        this.gl = null;
    }
};
$117c032e2cf45e7b$var$_StateSystem.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
    name: "state"
};
let $117c032e2cf45e7b$export$d47ea6626863db49 = $117c032e2cf45e7b$var$_StateSystem;
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($117c032e2cf45e7b$export$d47ea6626863db49);




class $e09db8c512cd5256$export$a12e67a4b4590901 extends (0, (/*@__PURE__*/$parcel$interopDefault($d82ec76d702398f8$exports))) {
    constructor(){
        super(...arguments), this.runners = {}, this._systemsHash = {};
    }
    /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */ setup(config) {
        this.addRunners(...config.runners);
        const priority = (config.priority ?? []).filter((key)=>config.systems[key]), orderByPriority = [
            ...priority,
            ...Object.keys(config.systems).filter((key)=>!priority.includes(key))
        ];
        for (const i of orderByPriority)this.addSystem(config.systems[i], i);
    }
    /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */ addRunners(...runnerIds) {
        runnerIds.forEach((runnerId)=>{
            this.runners[runnerId] = new (0, $e0a754815d73db73$export$571ad3bcba5a0c45)(runnerId);
        });
    }
    /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */ addSystem(ClassRef, name) {
        const system = new ClassRef(this);
        if (this[name]) throw new Error(`Whoops! The name "${name}" is already in use`);
        this[name] = system, this._systemsHash[name] = system;
        for(const i in this.runners)this.runners[i].add(system);
        return this;
    }
    /**
   * A function that will run a runner and call the runners function but pass in different options
   * to each system based on there name.
   *
   * E.g. If you have two systems added called `systemA` and `systemB` you could call do the following:
   *
   * ```js
   * system.emitWithCustomOptions(init, {
   *     systemA: {...optionsForA},
   *     systemB: {...optionsForB},
   * });
   * ```
   *
   * `init` would be called on system A passing `optionsForA` and on system B passing `optionsForB`.
   * @param runner - the runner to target
   * @param options - key value options for each system
   */ emitWithCustomOptions(runner, options) {
        const systemHashKeys = Object.keys(this._systemsHash);
        runner.items.forEach((system)=>{
            const systemName = systemHashKeys.find((systemId)=>this._systemsHash[systemId] === system);
            system[runner.name](options[systemName]);
        });
    }
    /** destroy the all runners and systems. Its apps job to */ destroy() {
        Object.values(this.runners).forEach((runner)=>{
            runner.destroy();
        }), this._systemsHash = {};
    }
}




const $52173f2806dd0f7c$var$_TextureGCSystem = class _TextureGCSystem2 {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        this.renderer = renderer, this.count = 0, this.checkCount = 0, this.maxIdle = _TextureGCSystem2.defaultMaxIdle, this.checkCountMax = _TextureGCSystem2.defaultCheckCountMax, this.mode = _TextureGCSystem2.defaultMode;
    }
    /**
   * Checks to see when the last time a texture was used.
   * If the texture has not been used for a specified amount of time, it will be removed from the GPU.
   */ postrender() {
        this.renderer.objectRenderer.renderingToScreen && (this.count++, this.mode !== (0, $5912637ee8cf8b9f$export$5c6ba89c1f52b344).MANUAL && (this.checkCount++, this.checkCount > this.checkCountMax && (this.checkCount = 0, this.run())));
    }
    /**
   * Checks to see when the last time a texture was used.
   * If the texture has not been used for a specified amount of time, it will be removed from the GPU.
   */ run() {
        const tm = this.renderer.texture, managedTextures = tm.managedTextures;
        let wasRemoved = !1;
        for(let i = 0; i < managedTextures.length; i++){
            const texture = managedTextures[i];
            texture.resource && this.count - texture.touched > this.maxIdle && (tm.destroyTexture(texture, !0), managedTextures[i] = null, wasRemoved = !0);
        }
        if (wasRemoved) {
            let j = 0;
            for(let i = 0; i < managedTextures.length; i++)managedTextures[i] !== null && (managedTextures[j++] = managedTextures[i]);
            managedTextures.length = j;
        }
    }
    /**
   * Removes all the textures within the specified displayObject and its children from the GPU.
   * @param {PIXI.DisplayObject} displayObject - the displayObject to remove the textures from.
   */ unload(displayObject) {
        const tm = this.renderer.texture, texture = displayObject._texture;
        texture && !texture.framebuffer && tm.destroyTexture(texture);
        for(let i = displayObject.children.length - 1; i >= 0; i--)this.unload(displayObject.children[i]);
    }
    destroy() {
        this.renderer = null;
    }
};
$52173f2806dd0f7c$var$_TextureGCSystem.defaultMode = (0, $5912637ee8cf8b9f$export$5c6ba89c1f52b344).AUTO, /**
* Default maximum idle frames before a texture is destroyed by garbage collection.
* @static
* @default 3600
* @see PIXI.TextureGCSystem#maxIdle
*/ $52173f2806dd0f7c$var$_TextureGCSystem.defaultMaxIdle = 3600, /**
* Default frames between two garbage collections.
* @static
* @default 600
* @see PIXI.TextureGCSystem#checkCountMax
*/ $52173f2806dd0f7c$var$_TextureGCSystem.defaultCheckCountMax = 600, /** @ignore */ $52173f2806dd0f7c$var$_TextureGCSystem.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
    name: "textureGC"
};
let $52173f2806dd0f7c$export$a47b032752d8e393 = $52173f2806dd0f7c$var$_TextureGCSystem;
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($52173f2806dd0f7c$export$a47b032752d8e393);







class $914c50517c8572f6$export$6c73c2a4561c07a2 {
    constructor(texture){
        this.texture = texture, this.width = -1, this.height = -1, this.dirtyId = -1, this.dirtyStyleId = -1, this.mipmap = !1, this.wrapMode = 33071, this.type = (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_BYTE, this.internalFormat = (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA, this.samplerType = 0;
    }
}



function $502f5c8e0763fda4$export$4d44a566e4889fac(gl) {
    let table;
    return "WebGL2RenderingContext" in globalThis && gl instanceof globalThis.WebGL2RenderingContext ? table = {
        [gl.RGB]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RGBA]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.ALPHA]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.LUMINANCE]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.LUMINANCE_ALPHA]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.R8]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.R8_SNORM]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RG8]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RG8_SNORM]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RGB8]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RGB8_SNORM]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RGB565]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RGBA4]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RGB5_A1]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RGBA8]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RGBA8_SNORM]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RGB10_A2]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RGB10_A2UI]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.SRGB8]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.SRGB8_ALPHA8]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.R16F]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RG16F]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RGB16F]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RGBA16F]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.R32F]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RG32F]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RGB32F]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RGBA32F]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.R11F_G11F_B10F]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RGB9_E5]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.R8I]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).INT,
        [gl.R8UI]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).UINT,
        [gl.R16I]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).INT,
        [gl.R16UI]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).UINT,
        [gl.R32I]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).INT,
        [gl.R32UI]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).UINT,
        [gl.RG8I]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).INT,
        [gl.RG8UI]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).UINT,
        [gl.RG16I]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).INT,
        [gl.RG16UI]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).UINT,
        [gl.RG32I]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).INT,
        [gl.RG32UI]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).UINT,
        [gl.RGB8I]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).INT,
        [gl.RGB8UI]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).UINT,
        [gl.RGB16I]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).INT,
        [gl.RGB16UI]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).UINT,
        [gl.RGB32I]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).INT,
        [gl.RGB32UI]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).UINT,
        [gl.RGBA8I]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).INT,
        [gl.RGBA8UI]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).UINT,
        [gl.RGBA16I]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).INT,
        [gl.RGBA16UI]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).UINT,
        [gl.RGBA32I]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).INT,
        [gl.RGBA32UI]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).UINT,
        [gl.DEPTH_COMPONENT16]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.DEPTH_COMPONENT24]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.DEPTH_COMPONENT32F]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.DEPTH_STENCIL]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.DEPTH24_STENCIL8]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.DEPTH32F_STENCIL8]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT
    } : table = {
        [gl.RGB]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.RGBA]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.ALPHA]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.LUMINANCE]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.LUMINANCE_ALPHA]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT,
        [gl.DEPTH_STENCIL]: (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT
    }, table;
}



function $be82274d0612d145$export$af038b9b93a51a84(gl) {
    let table;
    return "WebGL2RenderingContext" in globalThis && gl instanceof globalThis.WebGL2RenderingContext ? table = {
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_BYTE]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA]: gl.RGBA8,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGB]: gl.RGB8,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RG]: gl.RG8,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RED]: gl.R8,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGBA8UI,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGB_INTEGER]: gl.RGB8UI,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RG_INTEGER]: gl.RG8UI,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RED_INTEGER]: gl.R8UI,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).ALPHA]: gl.ALPHA,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).LUMINANCE]: gl.LUMINANCE,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).LUMINANCE_ALPHA]: gl.LUMINANCE_ALPHA
        },
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).BYTE]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA]: gl.RGBA8_SNORM,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGB]: gl.RGB8_SNORM,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RG]: gl.RG8_SNORM,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RED]: gl.R8_SNORM,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGBA8I,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGB_INTEGER]: gl.RGB8I,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RG_INTEGER]: gl.RG8I,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RED_INTEGER]: gl.R8I
        },
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_SHORT]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGBA16UI,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGB_INTEGER]: gl.RGB16UI,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RG_INTEGER]: gl.RG16UI,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RED_INTEGER]: gl.R16UI,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).DEPTH_COMPONENT]: gl.DEPTH_COMPONENT16
        },
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).SHORT]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGBA16I,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGB_INTEGER]: gl.RGB16I,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RG_INTEGER]: gl.RG16I,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RED_INTEGER]: gl.R16I
        },
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_INT]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGBA32UI,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGB_INTEGER]: gl.RGB32UI,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RG_INTEGER]: gl.RG32UI,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RED_INTEGER]: gl.R32UI,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).DEPTH_COMPONENT]: gl.DEPTH_COMPONENT24
        },
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).INT]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGBA32I,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGB_INTEGER]: gl.RGB32I,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RG_INTEGER]: gl.RG32I,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RED_INTEGER]: gl.R32I
        },
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).FLOAT]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA]: gl.RGBA32F,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGB]: gl.RGB32F,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RG]: gl.RG32F,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RED]: gl.R32F,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).DEPTH_COMPONENT]: gl.DEPTH_COMPONENT32F
        },
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).HALF_FLOAT]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA]: gl.RGBA16F,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGB]: gl.RGB16F,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RG]: gl.RG16F,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RED]: gl.R16F
        },
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_SHORT_5_6_5]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGB]: gl.RGB565
        },
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_SHORT_4_4_4_4]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA]: gl.RGBA4
        },
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_SHORT_5_5_5_1]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA]: gl.RGB5_A1
        },
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_INT_2_10_10_10_REV]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA]: gl.RGB10_A2,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGB10_A2UI
        },
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_INT_10F_11F_11F_REV]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGB]: gl.R11F_G11F_B10F
        },
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_INT_5_9_9_9_REV]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGB]: gl.RGB9_E5
        },
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_INT_24_8]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).DEPTH_STENCIL]: gl.DEPTH24_STENCIL8
        },
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).FLOAT_32_UNSIGNED_INT_24_8_REV]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).DEPTH_STENCIL]: gl.DEPTH32F_STENCIL8
        }
    } : table = {
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_BYTE]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA]: gl.RGBA,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGB]: gl.RGB,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).ALPHA]: gl.ALPHA,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).LUMINANCE]: gl.LUMINANCE,
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).LUMINANCE_ALPHA]: gl.LUMINANCE_ALPHA
        },
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_SHORT_5_6_5]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGB]: gl.RGB
        },
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_SHORT_4_4_4_4]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA]: gl.RGBA
        },
        [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_SHORT_5_5_5_1]: {
            [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA]: gl.RGBA
        }
    }, table;
}


class $7b8ff210855e008b$export$6312da36f198968 {
    /**
   * @param renderer - The renderer this system works for.
   */ constructor(renderer){
        this.renderer = renderer, this.boundTextures = [], this.currentLocation = -1, this.managedTextures = [], this._unknownBoundTextures = !1, this.unknownTexture = new (0, $997b0e421c4045eb$export$d6306e508f184154)(), this.hasIntegerTextures = !1;
    }
    /** Sets up the renderer context and necessary buffers. */ contextChange() {
        const gl = this.gl = this.renderer.gl;
        this.CONTEXT_UID = this.renderer.CONTEXT_UID, this.webGLVersion = this.renderer.context.webGLVersion, this.internalFormats = (0, $be82274d0612d145$export$af038b9b93a51a84)(gl), this.samplerTypes = (0, $502f5c8e0763fda4$export$4d44a566e4889fac)(gl);
        const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
        this.boundTextures.length = maxTextures;
        for(let i = 0; i < maxTextures; i++)this.boundTextures[i] = null;
        this.emptyTextures = {};
        const emptyTexture2D = new (0, $914c50517c8572f6$export$6c73c2a4561c07a2)(gl.createTexture());
        gl.bindTexture(gl.TEXTURE_2D, emptyTexture2D.texture), gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array(4)), this.emptyTextures[gl.TEXTURE_2D] = emptyTexture2D, this.emptyTextures[gl.TEXTURE_CUBE_MAP] = new (0, $914c50517c8572f6$export$6c73c2a4561c07a2)(gl.createTexture()), gl.bindTexture(gl.TEXTURE_CUBE_MAP, this.emptyTextures[gl.TEXTURE_CUBE_MAP].texture);
        for(let i = 0; i < 6; i++)gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR), gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        for(let i = 0; i < this.boundTextures.length; i++)this.bind(null, i);
    }
    /**
   * Bind a texture to a specific location
   *
   * If you want to unbind something, please use `unbind(texture)` instead of `bind(null, textureLocation)`
   * @param texture - Texture to bind
   * @param [location=0] - Location to bind at
   */ bind(texture, location = 0) {
        const { gl: gl } = this;
        if (texture = texture?.castToBaseTexture(), texture?.valid && !texture.parentTextureArray) {
            texture.touched = this.renderer.textureGC.count;
            const glTexture = texture._glTextures[this.CONTEXT_UID] || this.initTexture(texture);
            this.boundTextures[location] !== texture && (this.currentLocation !== location && (this.currentLocation = location, gl.activeTexture(gl.TEXTURE0 + location)), gl.bindTexture(texture.target, glTexture.texture)), glTexture.dirtyId !== texture.dirtyId ? (this.currentLocation !== location && (this.currentLocation = location, gl.activeTexture(gl.TEXTURE0 + location)), this.updateTexture(texture)) : glTexture.dirtyStyleId !== texture.dirtyStyleId && this.updateTextureStyle(texture), this.boundTextures[location] = texture;
        } else this.currentLocation !== location && (this.currentLocation = location, gl.activeTexture(gl.TEXTURE0 + location)), gl.bindTexture(gl.TEXTURE_2D, this.emptyTextures[gl.TEXTURE_2D].texture), this.boundTextures[location] = null;
    }
    /** Resets texture location and bound textures Actual `bind(null, i)` calls will be performed at next `unbind()` call */ reset() {
        this._unknownBoundTextures = !0, this.hasIntegerTextures = !1, this.currentLocation = -1;
        for(let i = 0; i < this.boundTextures.length; i++)this.boundTextures[i] = this.unknownTexture;
    }
    /**
   * Unbind a texture.
   * @param texture - Texture to bind
   */ unbind(texture) {
        const { gl: gl, boundTextures: boundTextures } = this;
        if (this._unknownBoundTextures) {
            this._unknownBoundTextures = !1;
            for(let i = 0; i < boundTextures.length; i++)boundTextures[i] === this.unknownTexture && this.bind(null, i);
        }
        for(let i = 0; i < boundTextures.length; i++)boundTextures[i] === texture && (this.currentLocation !== i && (gl.activeTexture(gl.TEXTURE0 + i), this.currentLocation = i), gl.bindTexture(texture.target, this.emptyTextures[texture.target].texture), boundTextures[i] = null);
    }
    /**
   * Ensures that current boundTextures all have FLOAT sampler type,
   * see {@link PIXI.SAMPLER_TYPES} for explanation.
   * @param maxTextures - number of locations to check
   */ ensureSamplerType(maxTextures) {
        const { boundTextures: boundTextures, hasIntegerTextures: hasIntegerTextures, CONTEXT_UID: CONTEXT_UID } = this;
        if (hasIntegerTextures) for(let i = maxTextures - 1; i >= 0; --i){
            const tex = boundTextures[i];
            tex && tex._glTextures[CONTEXT_UID].samplerType !== (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT && this.renderer.texture.unbind(tex);
        }
    }
    /**
   * Initialize a texture
   * @private
   * @param texture - Texture to initialize
   */ initTexture(texture) {
        const glTexture = new (0, $914c50517c8572f6$export$6c73c2a4561c07a2)(this.gl.createTexture());
        return glTexture.dirtyId = -1, texture._glTextures[this.CONTEXT_UID] = glTexture, this.managedTextures.push(texture), texture.on("dispose", this.destroyTexture, this), glTexture;
    }
    initTextureType(texture, glTexture) {
        glTexture.internalFormat = this.internalFormats[texture.type]?.[texture.format] ?? texture.format, glTexture.samplerType = this.samplerTypes[glTexture.internalFormat] ?? (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT, this.webGLVersion === 2 && texture.type === (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).HALF_FLOAT ? glTexture.type = this.gl.HALF_FLOAT : glTexture.type = texture.type;
    }
    /**
   * Update a texture
   * @private
   * @param {PIXI.BaseTexture} texture - Texture to initialize
   */ updateTexture(texture) {
        const glTexture = texture._glTextures[this.CONTEXT_UID];
        if (!glTexture) return;
        const renderer = this.renderer;
        if (this.initTextureType(texture, glTexture), texture.resource?.upload(renderer, texture, glTexture)) glTexture.samplerType !== (0, $5912637ee8cf8b9f$export$8ee8af3637d728f5).FLOAT && (this.hasIntegerTextures = !0);
        else {
            const width = texture.realWidth, height = texture.realHeight, gl = renderer.gl;
            (glTexture.width !== width || glTexture.height !== height || glTexture.dirtyId < 0) && (glTexture.width = width, glTexture.height = height, gl.texImage2D(texture.target, 0, glTexture.internalFormat, width, height, 0, texture.format, glTexture.type, null));
        }
        texture.dirtyStyleId !== glTexture.dirtyStyleId && this.updateTextureStyle(texture), glTexture.dirtyId = texture.dirtyId;
    }
    /**
   * Deletes the texture from WebGL
   * @private
   * @param texture - the texture to destroy
   * @param [skipRemove=false] - Whether to skip removing the texture from the TextureManager.
   */ destroyTexture(texture, skipRemove) {
        const { gl: gl } = this;
        if (texture = texture.castToBaseTexture(), texture._glTextures[this.CONTEXT_UID] && (this.unbind(texture), gl.deleteTexture(texture._glTextures[this.CONTEXT_UID].texture), texture.off("dispose", this.destroyTexture, this), delete texture._glTextures[this.CONTEXT_UID], !skipRemove)) {
            const i = this.managedTextures.indexOf(texture);
            i !== -1 && (0, $b945f5e20f35d72d$export$8d47c0e1ce445404)(this.managedTextures, i, 1);
        }
    }
    /**
   * Update texture style such as mipmap flag
   * @private
   * @param {PIXI.BaseTexture} texture - Texture to update
   */ updateTextureStyle(texture) {
        const glTexture = texture._glTextures[this.CONTEXT_UID];
        glTexture && ((texture.mipmap === (0, $5912637ee8cf8b9f$export$16f6fb5da874bbfd).POW2 || this.webGLVersion !== 2) && !texture.isPowerOfTwo ? glTexture.mipmap = !1 : glTexture.mipmap = texture.mipmap >= 1, this.webGLVersion !== 2 && !texture.isPowerOfTwo ? glTexture.wrapMode = (0, $5912637ee8cf8b9f$export$2ab395cfb0dd2f0f).CLAMP : glTexture.wrapMode = texture.wrapMode, texture.resource?.style(this.renderer, texture, glTexture) || this.setStyle(texture, glTexture), glTexture.dirtyStyleId = texture.dirtyStyleId);
    }
    /**
   * Set style for texture
   * @private
   * @param texture - Texture to update
   * @param glTexture
   */ setStyle(texture, glTexture) {
        const gl = this.gl;
        if (glTexture.mipmap && texture.mipmap !== (0, $5912637ee8cf8b9f$export$16f6fb5da874bbfd).ON_MANUAL && gl.generateMipmap(texture.target), gl.texParameteri(texture.target, gl.TEXTURE_WRAP_S, glTexture.wrapMode), gl.texParameteri(texture.target, gl.TEXTURE_WRAP_T, glTexture.wrapMode), glTexture.mipmap) {
            gl.texParameteri(texture.target, gl.TEXTURE_MIN_FILTER, texture.scaleMode === (0, $5912637ee8cf8b9f$export$6b734c6a0bba8473).LINEAR ? gl.LINEAR_MIPMAP_LINEAR : gl.NEAREST_MIPMAP_NEAREST);
            const anisotropicExt = this.renderer.context.extensions.anisotropicFiltering;
            if (anisotropicExt && texture.anisotropicLevel > 0 && texture.scaleMode === (0, $5912637ee8cf8b9f$export$6b734c6a0bba8473).LINEAR) {
                const level = Math.min(texture.anisotropicLevel, gl.getParameter(anisotropicExt.MAX_TEXTURE_MAX_ANISOTROPY_EXT));
                gl.texParameterf(texture.target, anisotropicExt.TEXTURE_MAX_ANISOTROPY_EXT, level);
            }
        } else gl.texParameteri(texture.target, gl.TEXTURE_MIN_FILTER, texture.scaleMode === (0, $5912637ee8cf8b9f$export$6b734c6a0bba8473).LINEAR ? gl.LINEAR : gl.NEAREST);
        gl.texParameteri(texture.target, gl.TEXTURE_MAG_FILTER, texture.scaleMode === (0, $5912637ee8cf8b9f$export$6b734c6a0bba8473).LINEAR ? gl.LINEAR : gl.NEAREST);
    }
    destroy() {
        this.renderer = null;
    }
}
$7b8ff210855e008b$export$6312da36f198968.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
    name: "texture"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($7b8ff210855e008b$export$6312da36f198968);



class $cb7d1e0c4ab1d80b$export$82410eeab0646070 {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer;
    }
    /** Sets up the renderer context and necessary buffers. */ contextChange() {
        this.gl = this.renderer.gl, this.CONTEXT_UID = this.renderer.CONTEXT_UID;
    }
    /**
   * Bind TransformFeedback and buffers
   * @param transformFeedback - TransformFeedback to bind
   */ bind(transformFeedback) {
        const { gl: gl, CONTEXT_UID: CONTEXT_UID } = this, glTransformFeedback = transformFeedback._glTransformFeedbacks[CONTEXT_UID] || this.createGLTransformFeedback(transformFeedback);
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, glTransformFeedback);
    }
    /** Unbind TransformFeedback */ unbind() {
        const { gl: gl } = this;
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null);
    }
    /**
   * Begin TransformFeedback
   * @param drawMode - DrawMode for TransformFeedback
   * @param shader - A Shader used by TransformFeedback. Current bound shader will be used if not provided.
   */ beginTransformFeedback(drawMode, shader) {
        const { gl: gl, renderer: renderer } = this;
        shader && renderer.shader.bind(shader), gl.beginTransformFeedback(drawMode);
    }
    /** End TransformFeedback */ endTransformFeedback() {
        const { gl: gl } = this;
        gl.endTransformFeedback();
    }
    /**
   * Create TransformFeedback and bind buffers
   * @param tf - TransformFeedback
   * @returns WebGLTransformFeedback
   */ createGLTransformFeedback(tf) {
        const { gl: gl, renderer: renderer, CONTEXT_UID: CONTEXT_UID } = this, glTransformFeedback = gl.createTransformFeedback();
        tf._glTransformFeedbacks[CONTEXT_UID] = glTransformFeedback, gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, glTransformFeedback);
        for(let i = 0; i < tf.buffers.length; i++){
            const buffer = tf.buffers[i];
            buffer && (renderer.buffer.update(buffer), buffer._glBuffers[CONTEXT_UID].refCount++, gl.bindBufferBase(gl.TRANSFORM_FEEDBACK_BUFFER, i, buffer._glBuffers[CONTEXT_UID].buffer || null));
        }
        return gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null), tf.disposeRunner.add(this), glTransformFeedback;
    }
    /**
   * Disposes TransfromFeedback
   * @param {PIXI.TransformFeedback} tf - TransformFeedback
   * @param {boolean} [contextLost=false] - If context was lost, we suppress delete TransformFeedback
   */ disposeTransformFeedback(tf, contextLost) {
        const glTF = tf._glTransformFeedbacks[this.CONTEXT_UID], gl = this.gl;
        tf.disposeRunner.remove(this);
        const bufferSystem = this.renderer.buffer;
        if (bufferSystem) for(let i = 0; i < tf.buffers.length; i++){
            const buffer = tf.buffers[i];
            if (!buffer) continue;
            const buf = buffer._glBuffers[this.CONTEXT_UID];
            buf && (buf.refCount--, buf.refCount === 0 && !contextLost && bufferSystem.dispose(buffer, contextLost));
        }
        glTF && (contextLost || gl.deleteTransformFeedback(glTF), delete tf._glTransformFeedbacks[this.CONTEXT_UID]);
    }
    destroy() {
        this.renderer = null;
    }
}
$cb7d1e0c4ab1d80b$export$82410eeab0646070.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
    name: "transformFeedback"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($cb7d1e0c4ab1d80b$export$82410eeab0646070);





class $2bdb4044dfbca41d$export$6f21c3d5af6602af {
    constructor(renderer){
        this.renderer = renderer;
    }
    /**
   * initiates the view system
   * @param {PIXI.ViewOptions} options - the options for the view
   */ init(options) {
        this.screen = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(0, 0, options.width, options.height), this.element = options.view || (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.createCanvas(), this.resolution = options.resolution || (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).RESOLUTION, this.autoDensity = !!options.autoDensity;
    }
    /**
   * Resizes the screen and canvas to the specified dimensions.
   * @param desiredScreenWidth - The new width of the screen.
   * @param desiredScreenHeight - The new height of the screen.
   */ resizeView(desiredScreenWidth, desiredScreenHeight) {
        this.element.width = Math.round(desiredScreenWidth * this.resolution), this.element.height = Math.round(desiredScreenHeight * this.resolution);
        const screenWidth = this.element.width / this.resolution, screenHeight = this.element.height / this.resolution;
        this.screen.width = screenWidth, this.screen.height = screenHeight, this.autoDensity && (this.element.style.width = `${screenWidth}px`, this.element.style.height = `${screenHeight}px`), this.renderer.emit("resize", screenWidth, screenHeight), this.renderer.runners.resize.emit(this.screen.width, this.screen.height);
    }
    /**
   * Destroys this System and optionally removes the canvas from the dom.
   * @param {boolean} [removeView=false] - Whether to remove the canvas from the DOM.
   */ destroy(removeView) {
        removeView && this.element.parentNode?.removeChild(this.element), this.renderer = null, this.element = null, this.screen = null;
    }
}
$2bdb4044dfbca41d$export$6f21c3d5af6602af.defaultOptions = {
    /**
   * {@link PIXI.IRendererOptions.width}
   * @default 800
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ width: 800,
    /**
   * {@link PIXI.IRendererOptions.height}
   * @default 600
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ height: 600,
    /**
   * {@link PIXI.IRendererOptions.resolution}
   * @type {number}
   * @default PIXI.settings.RESOLUTION
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ resolution: void 0,
    /**
   * {@link PIXI.IRendererOptions.autoDensity}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ autoDensity: !1
}, /** @ignore */ $2bdb4044dfbca41d$export$6f21c3d5af6602af.extension = {
    type: [
        (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
        (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).CanvasRendererSystem
    ],
    name: "_view"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($2bdb4044dfbca41d$export$6f21c3d5af6602af);










(0, $5340ccf8570d4063$export$a5a6e0b888b2c992).PREFER_ENV = (0, $5912637ee8cf8b9f$export$83401e34d5e11bf4).WEBGL2;
(0, $5340ccf8570d4063$export$a5a6e0b888b2c992).STRICT_TEXTURE_CACHE = !1;
(0, $5340ccf8570d4063$export$a5a6e0b888b2c992).RENDER_OPTIONS = {
    ...(0, $6f1e1f74b744547a$export$fedaac80f6f9518c).defaultOptions,
    ...(0, $47dd118c3911f833$export$c69cd65c8827ac23).defaultOptions,
    ...(0, $2bdb4044dfbca41d$export$6f21c3d5af6602af).defaultOptions,
    ...(0, $cbb89fc966da5db7$export$8b298d2bda604a05).defaultOptions
};
Object.defineProperties((0, $5340ccf8570d4063$export$a5a6e0b888b2c992), {
    /**
   * @static
   * @name WRAP_MODE
   * @memberof PIXI.settings
   * @type {PIXI.WRAP_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.wrapMode
   */ WRAP_MODE: {
        get () {
            return (0, $997b0e421c4045eb$export$d6306e508f184154).defaultOptions.wrapMode;
        },
        set (value) {
            (0, $4835512019cf238f$export$afd31d834b512e89)("7.1.0", "settings.WRAP_MODE is deprecated, use BaseTexture.defaultOptions.wrapMode"), (0, $997b0e421c4045eb$export$d6306e508f184154).defaultOptions.wrapMode = value;
        }
    },
    /**
   * @static
   * @name SCALE_MODE
   * @memberof PIXI.settings
   * @type {PIXI.SCALE_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.scaleMode
   */ SCALE_MODE: {
        get () {
            return (0, $997b0e421c4045eb$export$d6306e508f184154).defaultOptions.scaleMode;
        },
        set (value) {
            (0, $4835512019cf238f$export$afd31d834b512e89)("7.1.0", "settings.SCALE_MODE is deprecated, use BaseTexture.defaultOptions.scaleMode"), (0, $997b0e421c4045eb$export$d6306e508f184154).defaultOptions.scaleMode = value;
        }
    },
    /**
   * @static
   * @name MIPMAP_TEXTURES
   * @memberof PIXI.settings
   * @type {PIXI.MIPMAP_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.mipmap
   */ MIPMAP_TEXTURES: {
        get () {
            return (0, $997b0e421c4045eb$export$d6306e508f184154).defaultOptions.mipmap;
        },
        set (value) {
            (0, $4835512019cf238f$export$afd31d834b512e89)("7.1.0", "settings.MIPMAP_TEXTURES is deprecated, use BaseTexture.defaultOptions.mipmap"), (0, $997b0e421c4045eb$export$d6306e508f184154).defaultOptions.mipmap = value;
        }
    },
    /**
   * @static
   * @name ANISOTROPIC_LEVEL
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.anisotropicLevel
   */ ANISOTROPIC_LEVEL: {
        get () {
            return (0, $997b0e421c4045eb$export$d6306e508f184154).defaultOptions.anisotropicLevel;
        },
        set (value) {
            (0, $4835512019cf238f$export$afd31d834b512e89)("7.1.0", "settings.ANISOTROPIC_LEVEL is deprecated, use BaseTexture.defaultOptions.anisotropicLevel"), (0, $997b0e421c4045eb$export$d6306e508f184154).defaultOptions.anisotropicLevel = value;
        }
    },
    /**
   * Default filter resolution.
   * @static
   * @name FILTER_RESOLUTION
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @type {number|null}
   * @see PIXI.Filter.defaultResolution
   */ FILTER_RESOLUTION: {
        get () {
            return (0, $4835512019cf238f$export$afd31d834b512e89)("7.1.0", "settings.FILTER_RESOLUTION is deprecated, use Filter.defaultResolution"), (0, $344aa8e787d8e10a$export$ec91da630f36d5ea).defaultResolution;
        },
        set (value) {
            (0, $344aa8e787d8e10a$export$ec91da630f36d5ea).defaultResolution = value;
        }
    },
    /**
   * Default filter samples.
   * @static
   * @name FILTER_MULTISAMPLE
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @type {PIXI.MSAA_QUALITY}
   * @see PIXI.Filter.defaultMultisample
   */ FILTER_MULTISAMPLE: {
        get () {
            return (0, $4835512019cf238f$export$afd31d834b512e89)("7.1.0", "settings.FILTER_MULTISAMPLE is deprecated, use Filter.defaultMultisample"), (0, $344aa8e787d8e10a$export$ec91da630f36d5ea).defaultMultisample;
        },
        set (value) {
            (0, $344aa8e787d8e10a$export$ec91da630f36d5ea).defaultMultisample = value;
        }
    },
    /**
   * The maximum textures that this device supports.
   * @static
   * @name SPRITE_MAX_TEXTURES
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @see PIXI.BatchRenderer.defaultMaxTextures
   * @type {number}
   */ SPRITE_MAX_TEXTURES: {
        get () {
            return (0, $2b8c6db29ee20881$export$c6a34b759a134e1d).defaultMaxTextures;
        },
        set (value) {
            (0, $4835512019cf238f$export$afd31d834b512e89)("7.1.0", "settings.SPRITE_MAX_TEXTURES is deprecated, use BatchRenderer.defaultMaxTextures"), (0, $2b8c6db29ee20881$export$c6a34b759a134e1d).defaultMaxTextures = value;
        }
    },
    /**
   * The default sprite batch size.
   *
   * The default aims to balance desktop and mobile devices.
   * @static
   * @name SPRITE_BATCH_SIZE
   * @memberof PIXI.settings
   * @see PIXI.BatchRenderer.defaultBatchSize
   * @deprecated since 7.1.0
   * @type {number}
   */ SPRITE_BATCH_SIZE: {
        get () {
            return (0, $2b8c6db29ee20881$export$c6a34b759a134e1d).defaultBatchSize;
        },
        set (value) {
            (0, $4835512019cf238f$export$afd31d834b512e89)("7.1.0", "settings.SPRITE_BATCH_SIZE is deprecated, use BatchRenderer.defaultBatchSize"), (0, $2b8c6db29ee20881$export$c6a34b759a134e1d).defaultBatchSize = value;
        }
    },
    /**
   * Can we upload the same buffer in a single frame?
   * @static
   * @name CAN_UPLOAD_SAME_BUFFER
   * @memberof PIXI.settings
   * @see PIXI.BatchRenderer.canUploadSameBuffer
   * @deprecated since 7.1.0
   * @type {boolean}
   */ CAN_UPLOAD_SAME_BUFFER: {
        get () {
            return (0, $2b8c6db29ee20881$export$c6a34b759a134e1d).canUploadSameBuffer;
        },
        set (value) {
            (0, $4835512019cf238f$export$afd31d834b512e89)("7.1.0", "settings.CAN_UPLOAD_SAME_BUFFER is deprecated, use BatchRenderer.canUploadSameBuffer"), (0, $2b8c6db29ee20881$export$c6a34b759a134e1d).canUploadSameBuffer = value;
        }
    },
    /**
   * Default Garbage Collection mode.
   * @static
   * @name GC_MODE
   * @memberof PIXI.settings
   * @type {PIXI.GC_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.TextureGCSystem.defaultMode
   */ GC_MODE: {
        get () {
            return (0, $52173f2806dd0f7c$export$a47b032752d8e393).defaultMode;
        },
        set (value) {
            (0, $4835512019cf238f$export$afd31d834b512e89)("7.1.0", "settings.GC_MODE is deprecated, use TextureGCSystem.defaultMode"), (0, $52173f2806dd0f7c$export$a47b032752d8e393).defaultMode = value;
        }
    },
    /**
   * Default Garbage Collection max idle.
   * @static
   * @name GC_MAX_IDLE
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.TextureGCSystem.defaultMaxIdle
   */ GC_MAX_IDLE: {
        get () {
            return (0, $52173f2806dd0f7c$export$a47b032752d8e393).defaultMaxIdle;
        },
        set (value) {
            (0, $4835512019cf238f$export$afd31d834b512e89)("7.1.0", "settings.GC_MAX_IDLE is deprecated, use TextureGCSystem.defaultMaxIdle"), (0, $52173f2806dd0f7c$export$a47b032752d8e393).defaultMaxIdle = value;
        }
    },
    /**
   * Default Garbage Collection maximum check count.
   * @static
   * @name GC_MAX_CHECK_COUNT
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.TextureGCSystem.defaultCheckCountMax
   */ GC_MAX_CHECK_COUNT: {
        get () {
            return (0, $52173f2806dd0f7c$export$a47b032752d8e393).defaultCheckCountMax;
        },
        set (value) {
            (0, $4835512019cf238f$export$afd31d834b512e89)("7.1.0", "settings.GC_MAX_CHECK_COUNT is deprecated, use TextureGCSystem.defaultCheckCountMax"), (0, $52173f2806dd0f7c$export$a47b032752d8e393).defaultCheckCountMax = value;
        }
    },
    /**
   * Default specify float precision in vertex shader.
   * @static
   * @name PRECISION_VERTEX
   * @memberof PIXI.settings
   * @type {PIXI.PRECISION}
   * @deprecated since 7.1.0
   * @see PIXI.Program.defaultVertexPrecision
   */ PRECISION_VERTEX: {
        get () {
            return (0, $529286cda46872bb$export$b6c59b989905b650).defaultVertexPrecision;
        },
        set (value) {
            (0, $4835512019cf238f$export$afd31d834b512e89)("7.1.0", "settings.PRECISION_VERTEX is deprecated, use Program.defaultVertexPrecision"), (0, $529286cda46872bb$export$b6c59b989905b650).defaultVertexPrecision = value;
        }
    },
    /**
   * Default specify float precision in fragment shader.
   * @static
   * @name PRECISION_FRAGMENT
   * @memberof PIXI.settings
   * @type {PIXI.PRECISION}
   * @deprecated since 7.1.0
   * @see PIXI.Program.defaultFragmentPrecision
   */ PRECISION_FRAGMENT: {
        get () {
            return (0, $529286cda46872bb$export$b6c59b989905b650).defaultFragmentPrecision;
        },
        set (value) {
            (0, $4835512019cf238f$export$afd31d834b512e89)("7.1.0", "settings.PRECISION_FRAGMENT is deprecated, use Program.defaultFragmentPrecision"), (0, $529286cda46872bb$export$b6c59b989905b650).defaultFragmentPrecision = value;
        }
    }
});










var $4cc823daa6dd1896$export$688aaf132ba9b379 = /* @__PURE__ */ ((UPDATE_PRIORITY2)=>(UPDATE_PRIORITY2[UPDATE_PRIORITY2.INTERACTION = 50] = "INTERACTION", UPDATE_PRIORITY2[UPDATE_PRIORITY2.HIGH = 25] = "HIGH", UPDATE_PRIORITY2[UPDATE_PRIORITY2.NORMAL = 0] = "NORMAL", UPDATE_PRIORITY2[UPDATE_PRIORITY2.LOW = -25] = "LOW", UPDATE_PRIORITY2[UPDATE_PRIORITY2.UTILITY = -50] = "UTILITY", UPDATE_PRIORITY2))($4cc823daa6dd1896$export$688aaf132ba9b379 || {});


class $7a3d503c727a79ad$export$579021a5759a260f {
    /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */ constructor(fn, context = null, priority = 0, once = !1){
        this.next = null, this.previous = null, this._destroyed = !1, this.fn = fn, this.context = context, this.priority = priority, this.once = once;
    }
    /**
   * Simple compare function to figure out if a function and context match.
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */ match(fn, context = null) {
        return this.fn === fn && this.context === context;
    }
    /**
   * Emit by calling the current function.
   * @private
   * @param deltaTime - time since the last emit.
   * @returns Next ticker
   */ emit(deltaTime) {
        this.fn && (this.context ? this.fn.call(this.context, deltaTime) : this.fn(deltaTime));
        const redirect = this.next;
        return this.once && this.destroy(!0), this._destroyed && (this.next = null), redirect;
    }
    /**
   * Connect to the list.
   * @private
   * @param previous - Input node, previous listener
   */ connect(previous) {
        this.previous = previous, previous.next && (previous.next.previous = this), this.next = previous.next, previous.next = this;
    }
    /**
   * Destroy and don't use after this.
   * @private
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */ destroy(hard = !1) {
        this._destroyed = !0, this.fn = null, this.context = null, this.previous && (this.previous.next = this.next), this.next && (this.next.previous = this.previous);
        const redirect = this.next;
        return this.next = hard ? null : redirect, this.previous = null, redirect;
    }
}


const $f044fd65ebec6baf$var$_Ticker = class _Ticker2 {
    constructor(){
        this.autoStart = !1, this.deltaTime = 1, this.lastTime = -1, this.speed = 1, this.started = !1, this._requestId = null, this._maxElapsedMS = 100, this._minElapsedMS = 0, this._protected = !1, this._lastFrame = -1, this._head = new (0, $7a3d503c727a79ad$export$579021a5759a260f)(null, null, 1 / 0), this.deltaMS = 1 / _Ticker2.targetFPMS, this.elapsedMS = 1 / _Ticker2.targetFPMS, this._tick = (time)=>{
            this._requestId = null, this.started && (this.update(time), this.started && this._requestId === null && this._head.next && (this._requestId = requestAnimationFrame(this._tick)));
        };
    }
    /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   * @private
   */ _requestIfNeeded() {
        this._requestId === null && this._head.next && (this.lastTime = performance.now(), this._lastFrame = this.lastTime, this._requestId = requestAnimationFrame(this._tick));
    }
    /**
   * Conditionally cancels a pending animation frame.
   * @private
   */ _cancelIfNeeded() {
        this._requestId !== null && (cancelAnimationFrame(this._requestId), this._requestId = null);
    }
    /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   * @private
   */ _startIfPossible() {
        this.started ? this._requestIfNeeded() : this.autoStart && this.start();
    }
    /**
   * Register a handler for tick events. Calls continuously unless
   * it is removed or the ticker is stopped.
   * @param fn - The listener function to be added for updates
   * @param context - The listener context
   * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */ add(fn, context, priority = (0, $4cc823daa6dd1896$export$688aaf132ba9b379).NORMAL) {
        return this._addListener(new (0, $7a3d503c727a79ad$export$579021a5759a260f)(fn, context, priority));
    }
    /**
   * Add a handler for the tick event which is only execute once.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */ addOnce(fn, context, priority = (0, $4cc823daa6dd1896$export$688aaf132ba9b379).NORMAL) {
        return this._addListener(new (0, $7a3d503c727a79ad$export$579021a5759a260f)(fn, context, priority, !0));
    }
    /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */ _addListener(listener) {
        let current = this._head.next, previous = this._head;
        if (!current) listener.connect(previous);
        else {
            for(; current;){
                if (listener.priority > current.priority) {
                    listener.connect(previous);
                    break;
                }
                previous = current, current = current.next;
            }
            listener.previous || listener.connect(previous);
        }
        return this._startIfPossible(), this;
    }
    /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   */ remove(fn, context) {
        let listener = this._head.next;
        for(; listener;)listener.match(fn, context) ? listener = listener.destroy() : listener = listener.next;
        return this._head.next || this._cancelIfNeeded(), this;
    }
    /**
   * The number of listeners on this ticker, calculated by walking through linked list
   * @readonly
   * @member {number}
   */ get count() {
        if (!this._head) return 0;
        let count = 0, current = this._head;
        for(; current = current.next;)count++;
        return count;
    }
    /** Starts the ticker. If the ticker has listeners a new animation frame is requested at this point. */ start() {
        this.started || (this.started = !0, this._requestIfNeeded());
    }
    /** Stops the ticker. If the ticker has requested an animation frame it is canceled at this point. */ stop() {
        this.started && (this.started = !1, this._cancelIfNeeded());
    }
    /** Destroy the ticker and don't use after this. Calling this method removes all references to internal events. */ destroy() {
        if (!this._protected) {
            this.stop();
            let listener = this._head.next;
            for(; listener;)listener = listener.destroy(!0);
            this._head.destroy(), this._head = null;
        }
    }
    /**
   * Triggers an update. An update entails setting the
   * current {@link PIXI.Ticker#elapsedMS},
   * the current {@link PIXI.Ticker#deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link PIXI.Ticker#lastTime}
   * with the value of currentTime that was provided.
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @param {number} [currentTime=performance.now()] - the current time of execution
   */ update(currentTime = performance.now()) {
        let elapsedMS;
        if (currentTime > this.lastTime) {
            if (elapsedMS = this.elapsedMS = currentTime - this.lastTime, elapsedMS > this._maxElapsedMS && (elapsedMS = this._maxElapsedMS), elapsedMS *= this.speed, this._minElapsedMS) {
                const delta = currentTime - this._lastFrame | 0;
                if (delta < this._minElapsedMS) return;
                this._lastFrame = currentTime - delta % this._minElapsedMS;
            }
            this.deltaMS = elapsedMS, this.deltaTime = this.deltaMS * _Ticker2.targetFPMS;
            const head = this._head;
            let listener = head.next;
            for(; listener;)listener = listener.emit(this.deltaTime);
            head.next || this._cancelIfNeeded();
        } else this.deltaTime = this.deltaMS = this.elapsedMS = 0;
        this.lastTime = currentTime;
    }
    /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * **Note:** This does not factor in the value of
   * {@link PIXI.Ticker#speed}, which is specific
   * to scaling {@link PIXI.Ticker#deltaTime}.
   * @member {number}
   * @readonly
   */ get FPS() {
        return 1e3 / this.elapsedMS;
    }
    /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link PIXI.Ticker#update}.
   * This value is used to cap {@link PIXI.Ticker#deltaTime},
   * but does not effect the measured value of {@link PIXI.Ticker#FPS}.
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000`.
   * @member {number}
   * @default 10
   */ get minFPS() {
        return 1e3 / this._maxElapsedMS;
    }
    set minFPS(fps) {
        const minFPS = Math.min(this.maxFPS, fps), minFPMS = Math.min(Math.max(0, minFPS) / 1e3, _Ticker2.targetFPMS);
        this._maxElapsedMS = 1 / minFPMS;
    }
    /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link PIXI.Ticker#update}.
   * This will effect the measured value of {@link PIXI.Ticker#FPS}.
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`
   * @member {number}
   * @default 0
   */ get maxFPS() {
        return this._minElapsedMS ? Math.round(1e3 / this._minElapsedMS) : 0;
    }
    set maxFPS(fps) {
        if (fps === 0) this._minElapsedMS = 0;
        else {
            const maxFPS = Math.max(this.minFPS, fps);
            this._minElapsedMS = 1 / (maxFPS / 1e3);
        }
    }
    /**
   * The shared ticker instance used by {@link PIXI.AnimatedSprite} and by
   * {@link PIXI.VideoResource} to update animation frames / video textures.
   *
   * It may also be used by {@link PIXI.Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link PIXI.Ticker#autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the PIXI.Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @member {PIXI.Ticker}
   * @static
   */ static get shared() {
        if (!_Ticker2._shared) {
            const shared = _Ticker2._shared = new _Ticker2();
            shared.autoStart = !0, shared._protected = !0;
        }
        return _Ticker2._shared;
    }
    /**
   * The system ticker instance used by {@link PIXI.BasePrepare} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link PIXI.Ticker#autoStart} is set to `true` for this instance.
   * @member {PIXI.Ticker}
   * @static
   */ static get system() {
        if (!_Ticker2._system) {
            const system = _Ticker2._system = new _Ticker2();
            system.autoStart = !0, system._protected = !0;
        }
        return _Ticker2._system;
    }
};
$f044fd65ebec6baf$var$_Ticker.targetFPMS = 0.06;
let $f044fd65ebec6baf$export$39c54bcc89dcee11 = $f044fd65ebec6baf$var$_Ticker;


Object.defineProperties((0, $5340ccf8570d4063$export$a5a6e0b888b2c992), {
    /**
   * Target frames per millisecond.
   * @static
   * @name TARGET_FPMS
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.Ticker.targetFPMS
   */ TARGET_FPMS: {
        get () {
            return (0, $f044fd65ebec6baf$export$39c54bcc89dcee11).targetFPMS;
        },
        set (value) {
            (0, $4835512019cf238f$export$afd31d834b512e89)("7.1.0", "settings.TARGET_FPMS is deprecated, use Ticker.targetFPMS"), (0, $f044fd65ebec6baf$export$39c54bcc89dcee11).targetFPMS = value;
        }
    }
});







class $81338e6285c4361c$export$50c361ceb4e2f4f0 {
    /**
   * Initialize the plugin with scope of application instance
   * @static
   * @private
   * @param {object} [options] - See application options
   */ static init(options) {
        options = Object.assign({
            autoStart: !0,
            sharedTicker: !1
        }, options), Object.defineProperty(this, "ticker", {
            set (ticker) {
                this._ticker && this._ticker.remove(this.render, this), this._ticker = ticker, ticker && ticker.add(this.render, this, (0, $4cc823daa6dd1896$export$688aaf132ba9b379).LOW);
            },
            get () {
                return this._ticker;
            }
        }), this.stop = ()=>{
            this._ticker.stop();
        }, this.start = ()=>{
            this._ticker.start();
        }, this._ticker = null, this.ticker = options.sharedTicker ? (0, $f044fd65ebec6baf$export$39c54bcc89dcee11).shared : new (0, $f044fd65ebec6baf$export$39c54bcc89dcee11)(), options.autoStart && this.start();
    }
    /**
   * Clean up the ticker, scoped to application.
   * @static
   * @private
   */ static destroy() {
        if (this._ticker) {
            const oldTicker = this._ticker;
            this.ticker = null, oldTicker.destroy();
        }
    }
}
$81338e6285c4361c$export$50c361ceb4e2f4f0.extension = (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).Application;
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($81338e6285c4361c$export$50c361ceb4e2f4f0);






const $97850c06f85b1ff7$var$renderers = [];
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).handleByList((0, $69f9a88446c99188$export$4f037c6ec2da4eeb).Renderer, $97850c06f85b1ff7$var$renderers);
function $97850c06f85b1ff7$export$3583b92ab8150eb6(options) {
    for (const RendererType of $97850c06f85b1ff7$var$renderers)if (RendererType.test(options)) return new RendererType(options);
    throw new Error("Unable to auto-detect a suitable renderer.");
}

















var $7f220c00897e4d86$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`;


var $224fde8442ac0be3$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}
`;


const $f21ee941aa65a4c7$export$4a1a95006fc6b0f1 = (0, $7f220c00897e4d86$export$2e2bcd8739ae039), $f21ee941aa65a4c7$export$198627d10d1d088f = (0, $224fde8442ac0be3$export$2e2bcd8739ae039);







class $d7ff0ecb00feaf34$export$714ab7ecf6d70c30 {
    constructor(renderer){
        this.renderer = renderer;
    }
    contextChange(gl) {
        let samples;
        if (this.renderer.context.webGLVersion === 1) {
            const framebuffer = gl.getParameter(gl.FRAMEBUFFER_BINDING);
            gl.bindFramebuffer(gl.FRAMEBUFFER, null), samples = gl.getParameter(gl.SAMPLES), gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        } else {
            const framebuffer = gl.getParameter(gl.DRAW_FRAMEBUFFER_BINDING);
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null), samples = gl.getParameter(gl.SAMPLES), gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, framebuffer);
        }
        samples >= (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).HIGH ? this.multisample = (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).HIGH : samples >= (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).MEDIUM ? this.multisample = (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).MEDIUM : samples >= (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).LOW ? this.multisample = (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).LOW : this.multisample = (0, $5912637ee8cf8b9f$export$1eadd657d5acc2f2).NONE;
    }
    destroy() {}
}
$d7ff0ecb00feaf34$export$714ab7ecf6d70c30.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
    name: "_multisample"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($d7ff0ecb00feaf34$export$714ab7ecf6d70c30);





class $6b35963c256e70ac$export$5185dfb57661e267 {
    constructor(buffer){
        this.buffer = buffer || null, this.updateID = -1, this.byteLength = -1, this.refCount = 0;
    }
}


class $a65b4cd4e299774f$export$4010e50dab7d72d0 {
    /**
   * @param {PIXI.Renderer} renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.managedBuffers = {}, this.boundBufferBases = {};
    }
    /**
   * @ignore
   */ destroy() {
        this.renderer = null;
    }
    /** Sets up the renderer context and necessary buffers. */ contextChange() {
        this.disposeAll(!0), this.gl = this.renderer.gl, this.CONTEXT_UID = this.renderer.CONTEXT_UID;
    }
    /**
   * This binds specified buffer. On first run, it will create the webGL buffers for the context too
   * @param buffer - the buffer to bind to the renderer
   */ bind(buffer) {
        const { gl: gl, CONTEXT_UID: CONTEXT_UID } = this, glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
        gl.bindBuffer(buffer.type, glBuffer.buffer);
    }
    unbind(type) {
        const { gl: gl } = this;
        gl.bindBuffer(type, null);
    }
    /**
   * Binds an uniform buffer to at the given index.
   *
   * A cache is used so a buffer will not be bound again if already bound.
   * @param buffer - the buffer to bind
   * @param index - the base index to bind it to.
   */ bindBufferBase(buffer, index) {
        const { gl: gl, CONTEXT_UID: CONTEXT_UID } = this;
        if (this.boundBufferBases[index] !== buffer) {
            const glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
            this.boundBufferBases[index] = buffer, gl.bindBufferBase(gl.UNIFORM_BUFFER, index, glBuffer.buffer);
        }
    }
    /**
   * Binds a buffer whilst also binding its range.
   * This will make the buffer start from the offset supplied rather than 0 when it is read.
   * @param buffer - the buffer to bind
   * @param index - the base index to bind at, defaults to 0
   * @param offset - the offset to bind at (this is blocks of 256). 0 = 0, 1 = 256, 2 = 512 etc
   */ bindBufferRange(buffer, index, offset) {
        const { gl: gl, CONTEXT_UID: CONTEXT_UID } = this;
        offset = offset || 0;
        const glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
        gl.bindBufferRange(gl.UNIFORM_BUFFER, index || 0, glBuffer.buffer, offset * 256, 256);
    }
    /**
   * Will ensure the data in the buffer is uploaded to the GPU.
   * @param {PIXI.Buffer} buffer - the buffer to update
   */ update(buffer) {
        const { gl: gl, CONTEXT_UID: CONTEXT_UID } = this, glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
        if (buffer._updateID !== glBuffer.updateID) {
            if (glBuffer.updateID = buffer._updateID, gl.bindBuffer(buffer.type, glBuffer.buffer), glBuffer.byteLength >= buffer.data.byteLength) gl.bufferSubData(buffer.type, 0, buffer.data);
            else {
                const drawType = buffer.static ? gl.STATIC_DRAW : gl.DYNAMIC_DRAW;
                glBuffer.byteLength = buffer.data.byteLength, gl.bufferData(buffer.type, buffer.data, drawType);
            }
        }
    }
    /**
   * Disposes buffer
   * @param {PIXI.Buffer} buffer - buffer with data
   * @param {boolean} [contextLost=false] - If context was lost, we suppress deleteVertexArray
   */ dispose(buffer, contextLost) {
        if (!this.managedBuffers[buffer.id]) return;
        delete this.managedBuffers[buffer.id];
        const glBuffer = buffer._glBuffers[this.CONTEXT_UID], gl = this.gl;
        buffer.disposeRunner.remove(this), glBuffer && (contextLost || gl.deleteBuffer(glBuffer.buffer), delete buffer._glBuffers[this.CONTEXT_UID]);
    }
    /**
   * dispose all WebGL resources of all managed buffers
   * @param {boolean} [contextLost=false] - If context was lost, we suppress `gl.delete` calls
   */ disposeAll(contextLost) {
        const all = Object.keys(this.managedBuffers);
        for(let i = 0; i < all.length; i++)this.dispose(this.managedBuffers[all[i]], contextLost);
    }
    /**
   * creates and attaches a GLBuffer object tied to the current context.
   * @param buffer
   * @protected
   */ createGLBuffer(buffer) {
        const { CONTEXT_UID: CONTEXT_UID, gl: gl } = this;
        return buffer._glBuffers[CONTEXT_UID] = new (0, $6b35963c256e70ac$export$5185dfb57661e267)(gl.createBuffer()), this.managedBuffers[buffer.id] = buffer, buffer.disposeRunner.add(this), buffer._glBuffers[CONTEXT_UID];
    }
}
$a65b4cd4e299774f$export$4010e50dab7d72d0.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
    name: "buffer"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($a65b4cd4e299774f$export$4010e50dab7d72d0);














class $1b8c743652c7c5be$export$50cc3c4d71ad3547 {
    // renderers scene graph!
    constructor(renderer){
        this.renderer = renderer;
    }
    /**
   * Renders the object to its WebGL view.
   * @param displayObject - The object to be rendered.
   * @param options - the options to be passed to the renderer
   */ render(displayObject, options) {
        const renderer = this.renderer;
        let renderTexture, clear, transform, skipUpdateTransform;
        if (options && (renderTexture = options.renderTexture, clear = options.clear, transform = options.transform, skipUpdateTransform = options.skipUpdateTransform), this.renderingToScreen = !renderTexture, renderer.runners.prerender.emit(), renderer.emit("prerender"), renderer.projection.transform = transform, !renderer.context.isLost) {
            if (renderTexture || (this.lastObjectRendered = displayObject), !skipUpdateTransform) {
                const cacheParent = displayObject.enableTempParent();
                displayObject.updateTransform(), displayObject.disableTempParent(cacheParent);
            }
            renderer.renderTexture.bind(renderTexture), renderer.batch.currentRenderer.start(), (clear ?? renderer.background.clearBeforeRender) && renderer.renderTexture.clear(), displayObject.render(renderer), renderer.batch.currentRenderer.flush(), renderTexture && (options.blit && renderer.framebuffer.blit(), renderTexture.baseTexture.update()), renderer.runners.postrender.emit(), renderer.projection.transform = null, renderer.emit("postrender");
        }
    }
    destroy() {
        this.renderer = null, this.lastObjectRendered = null;
    }
}
$1b8c743652c7c5be$export$50cc3c4d71ad3547.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
    name: "objectRenderer"
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($1b8c743652c7c5be$export$50cc3c4d71ad3547);









const $ef6478792aba1c91$var$_Renderer = class _Renderer2 extends (0, $e09db8c512cd5256$export$a12e67a4b4590901) {
    /**
   * @param {PIXI.IRendererOptions} [options] - See {@link PIXI.settings.RENDER_OPTIONS} for defaults.
   */ constructor(options){
        super(), this.type = (0, $5912637ee8cf8b9f$export$747c566515e2a1d9).WEBGL, options = Object.assign({}, (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).RENDER_OPTIONS, options), this.gl = null, this.CONTEXT_UID = 0, this.globalUniforms = new (0, $f3ba15c3d8ec3ea5$export$6601a7a2dcf79bf5)({
            projectionMatrix: new (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85)()
        }, !0);
        const systemConfig = {
            runners: [
                "init",
                "destroy",
                "contextChange",
                "resolutionChange",
                "reset",
                "update",
                "postrender",
                "prerender",
                "resize"
            ],
            systems: _Renderer2.__systems,
            priority: [
                "_view",
                "textureGenerator",
                "background",
                "_plugin",
                "startup",
                // low level WebGL systems
                "context",
                "state",
                "texture",
                "buffer",
                "geometry",
                "framebuffer",
                "transformFeedback",
                // high level pixi specific rendering
                "mask",
                "scissor",
                "stencil",
                "projection",
                "textureGC",
                "filter",
                "renderTexture",
                "batch",
                "objectRenderer",
                "_multisample"
            ]
        };
        this.setup(systemConfig), "useContextAlpha" in options && ((0, $4835512019cf238f$export$afd31d834b512e89)("7.0.0", "options.useContextAlpha is deprecated, use options.premultipliedAlpha and options.backgroundAlpha instead"), options.premultipliedAlpha = options.useContextAlpha && options.useContextAlpha !== "notMultiplied", options.backgroundAlpha = options.useContextAlpha === !1 ? 1 : options.backgroundAlpha), this._plugin.rendererPlugins = _Renderer2.__plugins, this.options = options, this.startup.run(this.options);
    }
    /**
   * Create renderer if WebGL is available. Overrideable
   * by the **@pixi/canvas-renderer** package to allow fallback.
   * throws error if WebGL is not available.
   * @param options
   * @private
   */ static test(options) {
        return options?.forceCanvas ? !1 : (0, $430338622e16bcef$export$83dc396b76015322)();
    }
    /**
   * Renders the object to its WebGL view.
   * @param displayObject - The object to be rendered.
   * @param {object} [options] - Object to use for render options.
   * @param {PIXI.RenderTexture} [options.renderTexture] - The render texture to render to.
   * @param {boolean} [options.clear=true] - Should the canvas be cleared before the new render.
   * @param {PIXI.Matrix} [options.transform] - A transform to apply to the render texture before rendering.
   * @param {boolean} [options.skipUpdateTransform=false] - Should we skip the update transform pass?
   */ render(displayObject, options) {
        this.objectRenderer.render(displayObject, options);
    }
    /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   */ resize(desiredScreenWidth, desiredScreenHeight) {
        this._view.resizeView(desiredScreenWidth, desiredScreenHeight);
    }
    /**
   * Resets the WebGL state so you can render things however you fancy!
   * @returns Returns itself.
   */ reset() {
        return this.runners.reset.emit(), this;
    }
    /** Clear the frame buffer. */ clear() {
        this.renderTexture.bind(), this.renderTexture.clear();
    }
    /**
   * Removes everything from the renderer (event listeners, spritebatch, etc...)
   * @param [removeView=false] - Removes the Canvas element from the DOM.
   *  See: https://github.com/pixijs/pixijs/issues/2233
   */ destroy(removeView = !1) {
        this.runners.destroy.items.reverse(), this.emitWithCustomOptions(this.runners.destroy, {
            _view: removeView
        }), super.destroy();
    }
    /** Collection of plugins */ get plugins() {
        return this._plugin.plugins;
    }
    /** The number of msaa samples of the canvas. */ get multisample() {
        return this._multisample.multisample;
    }
    /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @member {number}
   * @readonly
   * @default 800
   */ get width() {
        return this._view.element.width;
    }
    /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */ get height() {
        return this._view.element.height;
    }
    /** The resolution / device pixel ratio of the renderer. */ get resolution() {
        return this._view.resolution;
    }
    set resolution(value) {
        this._view.resolution = value, this.runners.resolutionChange.emit(value);
    }
    /** Whether CSS dimensions of canvas view should be resized to screen dimensions automatically. */ get autoDensity() {
        return this._view.autoDensity;
    }
    /** The canvas element that everything is drawn to.*/ get view() {
        return this._view.element;
    }
    /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   * @member {PIXI.Rectangle}
   */ get screen() {
        return this._view.screen;
    }
    /** the last object rendered by the renderer. Useful for other plugins like interaction managers */ get lastObjectRendered() {
        return this.objectRenderer.lastObjectRendered;
    }
    /** Flag if we are rendering to the screen vs renderTexture */ get renderingToScreen() {
        return this.objectRenderer.renderingToScreen;
    }
    /** When logging Pixi to the console, this is the name we will show */ get rendererLogId() {
        return `WebGL ${this.context.webGLVersion}`;
    }
    /**
   * This sets weather the screen is totally cleared between each frame withthe background color and alpha
   * @deprecated since 7.0.0
   */ get clearBeforeRender() {
        return (0, $4835512019cf238f$export$afd31d834b512e89)("7.0.0", "renderer.clearBeforeRender has been deprecated, please use renderer.background.clearBeforeRender instead."), this.background.clearBeforeRender;
    }
    /**
   * Pass-thru setting for the canvas' context `alpha` property. This is typically
   * not something you need to fiddle with. If you want transparency, use `backgroundAlpha`.
   * @deprecated since 7.0.0
   * @member {boolean}
   */ get useContextAlpha() {
        return (0, $4835512019cf238f$export$afd31d834b512e89)("7.0.0", "renderer.useContextAlpha has been deprecated, please use renderer.context.premultipliedAlpha instead."), this.context.useContextAlpha;
    }
    /**
   * readonly drawing buffer preservation
   * we can only know this if Pixi created the context
   * @deprecated since 7.0.0
   */ get preserveDrawingBuffer() {
        return (0, $4835512019cf238f$export$afd31d834b512e89)("7.0.0", "renderer.preserveDrawingBuffer has been deprecated, we cannot truly know this unless pixi created the context"), this.context.preserveDrawingBuffer;
    }
    /**
   * The background color to fill if not transparent
   * @member {number}
   * @deprecated since 7.0.0
   */ get backgroundColor() {
        return (0, $4835512019cf238f$export$afd31d834b512e89)("7.0.0", "renderer.backgroundColor has been deprecated, use renderer.background.color instead."), this.background.color;
    }
    set backgroundColor(value) {
        (0, $4835512019cf238f$export$afd31d834b512e89)("7.0.0", "renderer.backgroundColor has been deprecated, use renderer.background.color instead."), this.background.color = value;
    }
    /**
   * The background color alpha. Setting this to 0 will make the canvas transparent.
   * @member {number}
   * @deprecated since 7.0.0
   */ get backgroundAlpha() {
        return (0, $4835512019cf238f$export$afd31d834b512e89)("7.0.0", "renderer.backgroundAlpha has been deprecated, use renderer.background.alpha instead."), this.background.alpha;
    }
    /**
   * @deprecated since 7.0.0
   */ set backgroundAlpha(value) {
        (0, $4835512019cf238f$export$afd31d834b512e89)("7.0.0", "renderer.backgroundAlpha has been deprecated, use renderer.background.alpha instead."), this.background.alpha = value;
    }
    /**
   * @deprecated since 7.0.0
   */ get powerPreference() {
        return (0, $4835512019cf238f$export$afd31d834b512e89)("7.0.0", "renderer.powerPreference has been deprecated, we can only know this if pixi creates the context"), this.context.powerPreference;
    }
    /**
   * Useful function that returns a texture of the display object that can then be used to create sprites
   * This can be quite useful if your displayObject is complicated and needs to be reused multiple times.
   * @param displayObject - The displayObject the object will be generated from.
   * @param {IGenerateTextureOptions} options - Generate texture options.
   * @param {PIXI.Rectangle} options.region - The region of the displayObject, that shall be rendered,
   *        if no region is specified, defaults to the local bounds of the displayObject.
   * @param {number} [options.resolution] - If not given, the renderer's resolution is used.
   * @param {PIXI.MSAA_QUALITY} [options.multisample] - If not given, the renderer's multisample is used.
   * @returns A texture of the graphics object.
   */ generateTexture(displayObject, options) {
        return this.textureGenerator.generateTexture(displayObject, options);
    }
};
$ef6478792aba1c91$var$_Renderer.extension = {
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).Renderer,
    priority: 1
}, /**
* Collection of installed plugins. These are included by default in PIXI, but can be excluded
* by creating a custom build. Consult the README for more information about creating custom
* builds and excluding plugins.
* @private
*/ $ef6478792aba1c91$var$_Renderer.__plugins = {}, /**
* The collection of installed systems.
* @private
*/ $ef6478792aba1c91$var$_Renderer.__systems = {};
let $ef6478792aba1c91$export$88530751e3977073 = $ef6478792aba1c91$var$_Renderer;
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).handleByMap((0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererPlugin, $ef6478792aba1c91$export$88530751e3977073.__plugins);
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).handleByMap((0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem, $ef6478792aba1c91$export$88530751e3977073.__systems);
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($ef6478792aba1c91$export$88530751e3977073);






























class $de426d46c4fd5797$export$195275694901de82 extends (0, $6049fedc760de0ea$export$39a853cfb5a94a63) {
    /**
   * @param length
   * @param options - Options to for Resource constructor
   * @param {number} [options.width] - Width of the resource
   * @param {number} [options.height] - Height of the resource
   */ constructor(length, options){
        const { width: width, height: height } = options || {};
        super(width, height), this.items = [], this.itemDirtyIds = [];
        for(let i = 0; i < length; i++){
            const partTexture = new (0, $997b0e421c4045eb$export$d6306e508f184154)();
            this.items.push(partTexture), this.itemDirtyIds.push(-2);
        }
        this.length = length, this._load = null, this.baseTexture = null;
    }
    /**
   * Used from ArrayResource and CubeResource constructors.
   * @param resources - Can be resources, image elements, canvas, etc. ,
   *  length should be same as constructor length
   * @param options - Detect options for resources
   */ initFromArray(resources, options) {
        for(let i = 0; i < this.length; i++)resources[i] && (resources[i].castToBaseTexture ? this.addBaseTextureAt(resources[i].castToBaseTexture(), i) : resources[i] instanceof (0, $6049fedc760de0ea$export$39a853cfb5a94a63) ? this.addResourceAt(resources[i], i) : this.addResourceAt((0, $661901148c1d956b$export$5eb9e949a7ff46a7)(resources[i], options), i));
    }
    /** Destroy this BaseImageResource. */ dispose() {
        for(let i = 0, len = this.length; i < len; i++)this.items[i].destroy();
        this.items = null, this.itemDirtyIds = null, this._load = null;
    }
    /**
   * Set a resource by ID
   * @param resource
   * @param index - Zero-based index of resource to set
   * @returns - Instance for chaining
   */ addResourceAt(resource, index) {
        if (!this.items[index]) throw new Error(`Index ${index} is out of bounds`);
        return resource.valid && !this.valid && this.resize(resource.width, resource.height), this.items[index].setResource(resource), this;
    }
    /**
   * Set the parent base texture.
   * @param baseTexture
   */ bind(baseTexture) {
        if (this.baseTexture !== null) throw new Error("Only one base texture per TextureArray is allowed");
        super.bind(baseTexture);
        for(let i = 0; i < this.length; i++)this.items[i].parentTextureArray = baseTexture, this.items[i].on("update", baseTexture.update, baseTexture);
    }
    /**
   * Unset the parent base texture.
   * @param baseTexture
   */ unbind(baseTexture) {
        super.unbind(baseTexture);
        for(let i = 0; i < this.length; i++)this.items[i].parentTextureArray = null, this.items[i].off("update", baseTexture.update, baseTexture);
    }
    /**
   * Load all the resources simultaneously
   * @returns - When load is resolved
   */ load() {
        if (this._load) return this._load;
        const promises = this.items.map((item)=>item.resource).filter((item)=>item).map((item)=>item.load());
        return this._load = Promise.all(promises).then(()=>{
            const { realWidth: realWidth, realHeight: realHeight } = this.items[0];
            return this.resize(realWidth, realHeight), this.update(), Promise.resolve(this);
        }), this._load;
    }
}


class $56af84c06dac7e59$export$aa0af7255ee278f1 extends (0, $de426d46c4fd5797$export$195275694901de82) {
    /**
   * @param source - Number of items in array or the collection
   *        of image URLs to use. Can also be resources, image elements, canvas, etc.
   * @param options - Options to apply to {@link PIXI.autoDetectResource}
   * @param {number} [options.width] - Width of the resource
   * @param {number} [options.height] - Height of the resource
   */ constructor(source, options){
        const { width: width, height: height } = options || {};
        let urls, length;
        Array.isArray(source) ? (urls = source, length = source.length) : length = source, super(length, {
            width: width,
            height: height
        }), urls && this.initFromArray(urls, options);
    }
    /**
   * Set a baseTexture by ID,
   * ArrayResource just takes resource from it, nothing more
   * @param baseTexture
   * @param index - Zero-based index of resource to set
   * @returns - Instance for chaining
   */ addBaseTextureAt(baseTexture, index) {
        if (baseTexture.resource) this.addResourceAt(baseTexture.resource, index);
        else throw new Error("ArrayResource does not support RenderTexture");
        return this;
    }
    /**
   * Add binding
   * @param baseTexture
   */ bind(baseTexture) {
        super.bind(baseTexture), baseTexture.target = (0, $5912637ee8cf8b9f$export$d1ff3caf57547dc5).TEXTURE_2D_ARRAY;
    }
    /**
   * Upload the resources to the GPU.
   * @param renderer
   * @param texture
   * @param glTexture
   * @returns - whether texture was uploaded
   */ upload(renderer, texture, glTexture) {
        const { length: length, itemDirtyIds: itemDirtyIds, items: items } = this, { gl: gl } = renderer;
        glTexture.dirtyId < 0 && gl.texImage3D(gl.TEXTURE_2D_ARRAY, 0, glTexture.internalFormat, this._width, this._height, length, 0, texture.format, glTexture.type, null);
        for(let i = 0; i < length; i++){
            const item = items[i];
            itemDirtyIds[i] < item.dirtyId && (itemDirtyIds[i] = item.dirtyId, item.valid && gl.texSubImage3D(gl.TEXTURE_2D_ARRAY, 0, 0, // xoffset
            0, // yoffset
            i, // zoffset
            item.resource.width, item.resource.height, 1, texture.format, glTexture.type, item.resource.source));
        }
        return !0;
    }
}





class $6cca7fee76858e81$export$3bea879ce3e5cb51 extends (0, $6510438b65c3a417$export$c87b2a1e7e3bb4a6) {
    /**
   * @param source - Canvas element to use
   */ // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(source){
        super(source);
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if source is HTMLCanvasElement or OffscreenCanvas
   */ static test(source) {
        const { OffscreenCanvas: OffscreenCanvas } = globalThis;
        return OffscreenCanvas && source instanceof OffscreenCanvas ? !0 : globalThis.HTMLCanvasElement && source instanceof HTMLCanvasElement;
    }
}




const $7bf7b26de79a5366$var$_CubeResource = class _CubeResource2 extends (0, $de426d46c4fd5797$export$195275694901de82) {
    /**
   * @param {Array<string|PIXI.Resource>} [source] - Collection of URLs or resources
   *        to use as the sides of the cube.
   * @param options - ImageResource options
   * @param {number} [options.width] - Width of resource
   * @param {number} [options.height] - Height of resource
   * @param {number} [options.autoLoad=true] - Whether to auto-load resources
   * @param {number} [options.linkBaseTexture=true] - In case BaseTextures are supplied,
   *   whether to copy them or use
   */ constructor(source, options){
        const { width: width, height: height, autoLoad: autoLoad, linkBaseTexture: linkBaseTexture } = options || {};
        if (source && source.length !== _CubeResource2.SIDES) throw new Error(`Invalid length. Got ${source.length}, expected 6`);
        super(6, {
            width: width,
            height: height
        });
        for(let i = 0; i < _CubeResource2.SIDES; i++)this.items[i].target = (0, $5912637ee8cf8b9f$export$d1ff3caf57547dc5).TEXTURE_CUBE_MAP_POSITIVE_X + i;
        this.linkBaseTexture = linkBaseTexture !== !1, source && this.initFromArray(source, options), autoLoad !== !1 && this.load();
    }
    /**
   * Add binding.
   * @param baseTexture - parent base texture
   */ bind(baseTexture) {
        super.bind(baseTexture), baseTexture.target = (0, $5912637ee8cf8b9f$export$d1ff3caf57547dc5).TEXTURE_CUBE_MAP;
    }
    addBaseTextureAt(baseTexture, index, linkBaseTexture) {
        if (linkBaseTexture === void 0 && (linkBaseTexture = this.linkBaseTexture), !this.items[index]) throw new Error(`Index ${index} is out of bounds`);
        if (!this.linkBaseTexture || baseTexture.parentTextureArray || Object.keys(baseTexture._glTextures).length > 0) {
            if (baseTexture.resource) this.addResourceAt(baseTexture.resource, index);
            else throw new Error("CubeResource does not support copying of renderTexture.");
        } else baseTexture.target = (0, $5912637ee8cf8b9f$export$d1ff3caf57547dc5).TEXTURE_CUBE_MAP_POSITIVE_X + index, baseTexture.parentTextureArray = this.baseTexture, this.items[index] = baseTexture;
        return baseTexture.valid && !this.valid && this.resize(baseTexture.realWidth, baseTexture.realHeight), this.items[index] = baseTexture, this;
    }
    /**
   * Upload the resource
   * @param renderer
   * @param _baseTexture
   * @param glTexture
   * @returns {boolean} true is success
   */ upload(renderer, _baseTexture, glTexture) {
        const dirty = this.itemDirtyIds;
        for(let i = 0; i < _CubeResource2.SIDES; i++){
            const side = this.items[i];
            (dirty[i] < side.dirtyId || glTexture.dirtyId < _baseTexture.dirtyId) && (side.valid && side.resource ? (side.resource.upload(renderer, side, glTexture), dirty[i] = side.dirtyId) : dirty[i] < -1 && (renderer.gl.texImage2D(side.target, 0, glTexture.internalFormat, _baseTexture.realWidth, _baseTexture.realHeight, 0, _baseTexture.format, glTexture.type, null), dirty[i] = -1));
        }
        return !0;
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if source is an array of 6 elements
   */ static test(source) {
        return Array.isArray(source) && source.length === _CubeResource2.SIDES;
    }
};
$7bf7b26de79a5366$var$_CubeResource.SIDES = 6;
let $7bf7b26de79a5366$export$c786bc8247db64cb = $7bf7b26de79a5366$var$_CubeResource;





class $5998393889100d82$export$422084391f3a58a3 extends (0, $6510438b65c3a417$export$c87b2a1e7e3bb4a6) {
    /**
   * @param source - ImageBitmap or URL to use.
   * @param options - Options to use.
   */ constructor(source, options){
        options = options || {};
        let baseSource, url, ownsImageBitmap;
        typeof source == "string" ? (baseSource = $5998393889100d82$export$422084391f3a58a3.EMPTY, url = source, ownsImageBitmap = !0) : (baseSource = source, url = null, ownsImageBitmap = !1), super(baseSource), this.url = url, this.crossOrigin = options.crossOrigin ?? !0, this.alphaMode = typeof options.alphaMode == "number" ? options.alphaMode : null, this.ownsImageBitmap = options.ownsImageBitmap ?? ownsImageBitmap, this._load = null, options.autoLoad !== !1 && this.load();
    }
    load() {
        return this._load ? this._load : (this._load = new Promise(async (resolve, reject)=>{
            if (this.url === null) {
                resolve(this);
                return;
            }
            try {
                const response = await (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.fetch(this.url, {
                    mode: this.crossOrigin ? "cors" : "no-cors"
                });
                if (this.destroyed) return;
                const imageBlob = await response.blob();
                if (this.destroyed) return;
                const imageBitmap = await createImageBitmap(imageBlob, {
                    premultiplyAlpha: this.alphaMode === null || this.alphaMode === (0, $5912637ee8cf8b9f$export$d56550d454401b73).UNPACK ? "premultiply" : "none"
                });
                if (this.destroyed) {
                    imageBitmap.close();
                    return;
                }
                this.source = imageBitmap, this.update(), resolve(this);
            } catch (e) {
                if (this.destroyed) return;
                reject(e), this.onError.emit(e);
            }
        }), this._load);
    }
    /**
   * Upload the image bitmap resource to GPU.
   * @param renderer - Renderer to upload to
   * @param baseTexture - BaseTexture for this resource
   * @param glTexture - GLTexture to use
   * @returns {boolean} true is success
   */ upload(renderer, baseTexture, glTexture) {
        return this.source instanceof ImageBitmap ? (typeof this.alphaMode == "number" && (baseTexture.alphaMode = this.alphaMode), super.upload(renderer, baseTexture, glTexture)) : (this.load(), !1);
    }
    /** Destroys this resource. */ dispose() {
        this.ownsImageBitmap && this.source instanceof ImageBitmap && this.source.close(), super.dispose(), this._load = null;
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if current environment support ImageBitmap, and source is string or ImageBitmap
   */ static test(source) {
        return !!globalThis.createImageBitmap && typeof ImageBitmap < "u" && (typeof source == "string" || source instanceof ImageBitmap);
    }
    /**
   * ImageBitmap cannot be created synchronously, so a empty placeholder canvas is needed when loading from URLs.
   * Only for internal usage.
   * @returns The cached placeholder canvas.
   */ static get EMPTY() {
        return $5998393889100d82$export$422084391f3a58a3._EMPTY = $5998393889100d82$export$422084391f3a58a3._EMPTY ?? (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.createCanvas(0, 0), $5998393889100d82$export$422084391f3a58a3._EMPTY;
    }
}






const $603cb3d5e6d79782$var$_SVGResource = class _SVGResource2 extends (0, $6510438b65c3a417$export$c87b2a1e7e3bb4a6) {
    /**
   * @param sourceBase64 - Base64 encoded SVG element or URL for SVG file.
   * @param {object} [options] - Options to use
   * @param {number} [options.scale=1] - Scale to apply to SVG. Overridden by...
   * @param {number} [options.width] - Rasterize SVG this wide. Aspect ratio preserved if height not specified.
   * @param {number} [options.height] - Rasterize SVG this high. Aspect ratio preserved if width not specified.
   * @param {boolean} [options.autoLoad=true] - Start loading right away.
   */ constructor(sourceBase64, options){
        options = options || {}, super((0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.createCanvas()), this._width = 0, this._height = 0, this.svg = sourceBase64, this.scale = options.scale || 1, this._overrideWidth = options.width, this._overrideHeight = options.height, this._resolve = null, this._crossorigin = options.crossorigin, this._load = null, options.autoLoad !== !1 && this.load();
    }
    load() {
        return this._load ? this._load : (this._load = new Promise((resolve)=>{
            if (this._resolve = ()=>{
                this.update(), resolve(this);
            }, _SVGResource2.SVG_XML.test(this.svg.trim())) {
                if (!btoa) throw new Error("Your browser doesn't support base64 conversions.");
                this.svg = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(this.svg)))}`;
            }
            this._loadSvg();
        }), this._load);
    }
    /** Loads an SVG image from `imageUrl` or `data URL`. */ _loadSvg() {
        const tempImage = new Image();
        (0, $6510438b65c3a417$export$c87b2a1e7e3bb4a6).crossOrigin(tempImage, this.svg, this._crossorigin), tempImage.src = this.svg, tempImage.onerror = (event)=>{
            this._resolve && (tempImage.onerror = null, this.onError.emit(event));
        }, tempImage.onload = ()=>{
            if (!this._resolve) return;
            const svgWidth = tempImage.width, svgHeight = tempImage.height;
            if (!svgWidth || !svgHeight) throw new Error("The SVG image must have width and height defined (in pixels), canvas API needs them.");
            let width = svgWidth * this.scale, height = svgHeight * this.scale;
            (this._overrideWidth || this._overrideHeight) && (width = this._overrideWidth || this._overrideHeight / svgHeight * svgWidth, height = this._overrideHeight || this._overrideWidth / svgWidth * svgHeight), width = Math.round(width), height = Math.round(height);
            const canvas = this.source;
            canvas.width = width, canvas.height = height, canvas._pixiId = `canvas_${(0, $4f05e7b7511900ff$export$e2a22331486dcca0)()}`, canvas.getContext("2d").drawImage(tempImage, 0, 0, svgWidth, svgHeight, 0, 0, width, height), this._resolve(), this._resolve = null;
        };
    }
    /**
   * Get size from an svg string using a regular expression.
   * @param svgString - a serialized svg element
   * @returns - image extension
   */ static getSize(svgString) {
        const sizeMatch = _SVGResource2.SVG_SIZE.exec(svgString), size = {};
        return sizeMatch && (size[sizeMatch[1]] = Math.round(parseFloat(sizeMatch[3])), size[sizeMatch[5]] = Math.round(parseFloat(sizeMatch[7]))), size;
    }
    /** Destroys this texture. */ dispose() {
        super.dispose(), this._resolve = null, this._crossorigin = null;
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @param {string} extension - The extension of source, if set
   * @returns {boolean} - If the source is a SVG source or data file
   */ static test(source, extension) {
        return extension === "svg" || typeof source == "string" && source.startsWith("data:image/svg+xml") || typeof source == "string" && _SVGResource2.SVG_XML.test(source);
    }
};
$603cb3d5e6d79782$var$_SVGResource.SVG_XML = /^(<\?xml[^?]+\?>)?\s*(<!--[^(-->)]*-->)?\s*\<svg/m, /**
* Regular expression for SVG size.
* @example &lt;svg width="100" height="100"&gt;&lt;/svg&gt;
* @readonly
*/ $603cb3d5e6d79782$var$_SVGResource.SVG_SIZE = /<svg[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*>/i;
let $603cb3d5e6d79782$export$aeb8ac9a3d5d46a0 = $603cb3d5e6d79782$var$_SVGResource;




const $2d1ab4fdb46ab7fe$var$_VideoResource = class _VideoResource2 extends (0, $6510438b65c3a417$export$c87b2a1e7e3bb4a6) {
    /**
   * @param {HTMLVideoElement|object|string|Array<string|object>} source - Video element to use.
   * @param {object} [options] - Options to use
   * @param {boolean} [options.autoLoad=true] - Start loading the video immediately
   * @param {boolean} [options.autoPlay=true] - Start playing video immediately
   * @param {number} [options.updateFPS=0] - How many times a second to update the texture from the video.
   * Leave at 0 to update at every render.
   * @param {boolean} [options.crossorigin=true] - Load image using cross origin
   * @param {boolean} [options.loop=false] - Loops the video
   * @param {boolean} [options.muted=false] - Mutes the video audio, useful for autoplay
   * @param {boolean} [options.playsinline=true] - Prevents opening the video on mobile devices
   */ constructor(source, options){
        if (options = options || {}, !(source instanceof HTMLVideoElement)) {
            const videoElement = document.createElement("video");
            options.autoLoad !== !1 && videoElement.setAttribute("preload", "auto"), options.playsinline !== !1 && (videoElement.setAttribute("webkit-playsinline", ""), videoElement.setAttribute("playsinline", "")), options.muted === !0 && (videoElement.setAttribute("muted", ""), videoElement.muted = !0), options.loop === !0 && videoElement.setAttribute("loop", ""), options.autoPlay !== !1 && videoElement.setAttribute("autoplay", ""), typeof source == "string" && (source = [
                source
            ]);
            const firstSrc = source[0].src || source[0];
            (0, $6510438b65c3a417$export$c87b2a1e7e3bb4a6).crossOrigin(videoElement, firstSrc, options.crossorigin);
            for(let i = 0; i < source.length; ++i){
                const sourceElement = document.createElement("source");
                let { src: src, mime: mime } = source[i];
                if (src = src || source[i], src.startsWith("data:")) mime = src.slice(5, src.indexOf(";"));
                else if (!src.startsWith("blob:")) {
                    const baseSrc = src.split("?").shift().toLowerCase(), ext = baseSrc.slice(baseSrc.lastIndexOf(".") + 1);
                    mime = mime || _VideoResource2.MIME_TYPES[ext] || `video/${ext}`;
                }
                sourceElement.src = src, mime && (sourceElement.type = mime), videoElement.appendChild(sourceElement);
            }
            source = videoElement;
        }
        super(source), this.noSubImage = !0, this._autoUpdate = !0, this._isConnectedToTicker = !1, this._updateFPS = options.updateFPS || 0, this._msToNextUpdate = 0, this.autoPlay = options.autoPlay !== !1, this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this), this._videoFrameRequestCallbackHandle = null, this._load = null, this._resolve = null, this._reject = null, this._onCanPlay = this._onCanPlay.bind(this), this._onError = this._onError.bind(this), this._onPlayStart = this._onPlayStart.bind(this), this._onPlayStop = this._onPlayStop.bind(this), this._onSeeked = this._onSeeked.bind(this), options.autoLoad !== !1 && this.load();
    }
    /**
   * Trigger updating of the texture.
   * @param _deltaTime - time delta since last tick
   */ update(_deltaTime = 0) {
        if (!this.destroyed) {
            if (this._updateFPS) {
                const elapsedMS = (0, $f044fd65ebec6baf$export$39c54bcc89dcee11).shared.elapsedMS * this.source.playbackRate;
                this._msToNextUpdate = Math.floor(this._msToNextUpdate - elapsedMS);
            }
            (!this._updateFPS || this._msToNextUpdate <= 0) && (super.update(), this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0);
        }
    }
    _videoFrameRequestCallback() {
        this.update(), this.destroyed ? this._videoFrameRequestCallbackHandle = null : this._videoFrameRequestCallbackHandle = this.source.requestVideoFrameCallback(this._videoFrameRequestCallback);
    }
    /**
   * Start preloading the video resource.
   * @returns {Promise<void>} Handle the validate event
   */ load() {
        if (this._load) return this._load;
        const source = this.source;
        return (source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height && (source.complete = !0), source.addEventListener("play", this._onPlayStart), source.addEventListener("pause", this._onPlayStop), source.addEventListener("seeked", this._onSeeked), this._isSourceReady() ? this._onCanPlay() : (source.addEventListener("canplay", this._onCanPlay), source.addEventListener("canplaythrough", this._onCanPlay), source.addEventListener("error", this._onError, !0)), this._load = new Promise((resolve, reject)=>{
            this.valid ? resolve(this) : (this._resolve = resolve, this._reject = reject, source.load());
        }), this._load;
    }
    /**
   * Handle video error events.
   * @param event
   */ _onError(event) {
        this.source.removeEventListener("error", this._onError, !0), this.onError.emit(event), this._reject && (this._reject(event), this._reject = null, this._resolve = null);
    }
    /**
   * Returns true if the underlying source is playing.
   * @returns - True if playing.
   */ _isSourcePlaying() {
        const source = this.source;
        return !source.paused && !source.ended && this._isSourceReady();
    }
    /**
   * Returns true if the underlying source is ready for playing.
   * @returns - True if ready.
   */ _isSourceReady() {
        return this.source.readyState > 2;
    }
    /** Runs the update loop when the video is ready to play. */ _onPlayStart() {
        this.valid || this._onCanPlay(), this._configureAutoUpdate();
    }
    /** Fired when a pause event is triggered, stops the update loop. */ _onPlayStop() {
        this._configureAutoUpdate();
    }
    /** Fired when the video is completed seeking to the current playback position. */ _onSeeked() {
        this._autoUpdate && !this._isSourcePlaying() && (this._msToNextUpdate = 0, this.update(), this._msToNextUpdate = 0);
    }
    /** Fired when the video is loaded and ready to play. */ _onCanPlay() {
        const source = this.source;
        source.removeEventListener("canplay", this._onCanPlay), source.removeEventListener("canplaythrough", this._onCanPlay);
        const valid = this.valid;
        this._msToNextUpdate = 0, this.update(), this._msToNextUpdate = 0, !valid && this._resolve && (this._resolve(this), this._resolve = null, this._reject = null), this._isSourcePlaying() ? this._onPlayStart() : this.autoPlay && source.play();
    }
    /** Destroys this texture. */ dispose() {
        this._configureAutoUpdate();
        const source = this.source;
        source && (source.removeEventListener("play", this._onPlayStart), source.removeEventListener("pause", this._onPlayStop), source.removeEventListener("seeked", this._onSeeked), source.removeEventListener("canplay", this._onCanPlay), source.removeEventListener("canplaythrough", this._onCanPlay), source.removeEventListener("error", this._onError, !0), source.pause(), source.src = "", source.load()), super.dispose();
    }
    /** Should the base texture automatically update itself, set to true by default. */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        value !== this._autoUpdate && (this._autoUpdate = value, this._configureAutoUpdate());
    }
    /**
   * How many times a second to update the texture from the video. Leave at 0 to update at every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */ get updateFPS() {
        return this._updateFPS;
    }
    set updateFPS(value) {
        value !== this._updateFPS && (this._updateFPS = value, this._configureAutoUpdate());
    }
    _configureAutoUpdate() {
        this._autoUpdate && this._isSourcePlaying() ? !this._updateFPS && this.source.requestVideoFrameCallback ? (this._isConnectedToTicker && ((0, $f044fd65ebec6baf$export$39c54bcc89dcee11).shared.remove(this.update, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0), this._videoFrameRequestCallbackHandle === null && (this._videoFrameRequestCallbackHandle = this.source.requestVideoFrameCallback(this._videoFrameRequestCallback))) : (this._videoFrameRequestCallbackHandle !== null && (this.source.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker || ((0, $f044fd65ebec6baf$export$39c54bcc89dcee11).shared.add(this.update, this), this._isConnectedToTicker = !0, this._msToNextUpdate = 0)) : (this._videoFrameRequestCallbackHandle !== null && (this.source.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker && ((0, $f044fd65ebec6baf$export$39c54bcc89dcee11).shared.remove(this.update, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0));
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @param {string} extension - The extension of source, if set
   * @returns {boolean} `true` if video source
   */ static test(source, extension) {
        return globalThis.HTMLVideoElement && source instanceof HTMLVideoElement || _VideoResource2.TYPES.includes(extension);
    }
};
$2d1ab4fdb46ab7fe$var$_VideoResource.TYPES = [
    "mp4",
    "m4v",
    "webm",
    "ogg",
    "ogv",
    "h264",
    "avi",
    "mov"
], /**
* Map of video MIME types that can't be directly derived from file extensions.
* @readonly
*/ $2d1ab4fdb46ab7fe$var$_VideoResource.MIME_TYPES = {
    ogv: "video/ogg",
    mov: "video/quicktime",
    m4v: "video/mp4"
};
let $2d1ab4fdb46ab7fe$export$f7dd53bb53e9c0d7 = $2d1ab4fdb46ab7fe$var$_VideoResource;





(0, $661901148c1d956b$export$7db5d8a07d9761e1).push((0, $5998393889100d82$export$422084391f3a58a3), (0, $b82f64230ade51a6$export$6d0d25e6e731a9a2), (0, $6cca7fee76858e81$export$3bea879ce3e5cb51), (0, $2d1ab4fdb46ab7fe$export$f7dd53bb53e9c0d7), (0, $603cb3d5e6d79782$export$aeb8ac9a3d5d46a0), (0, $967525537d2ce935$export$a79ef781de624449), (0, $7bf7b26de79a5366$export$c786bc8247db64cb), (0, $56af84c06dac7e59$export$aa0af7255ee278f1));








class $86d48808ca00b6a8$export$1f7c70f8d6979c19 {
    constructor(){
        this._glTransformFeedbacks = {}, this.buffers = [], this.disposeRunner = new (0, $e0a754815d73db73$export$571ad3bcba5a0c45)("disposeTransformFeedback");
    }
    /**
   * Bind buffer to TransformFeedback
   * @param index - index to bind
   * @param buffer - buffer to bind
   */ bindBuffer(index, buffer) {
        this.buffers[index] = buffer;
    }
    /** Destroy WebGL resources that are connected to this TransformFeedback. */ destroy() {
        this.disposeRunner.emit(this, !1);
    }
}



















const $b9881e1bbc5363a9$export$a4ad2735b021c132 = "7.3.1";






class $70e54ebfdc4c7d64$export$c4e9d269599ab4b4 {
    constructor(){
        this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0, this.rect = null, this.updateID = -1;
    }
    /**
   * Checks if bounds are empty.
   * @returns - True if empty.
   */ isEmpty() {
        return this.minX > this.maxX || this.minY > this.maxY;
    }
    /** Clears the bounds and resets. */ clear() {
        this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0;
    }
    /**
   * Can return Rectangle.EMPTY constant, either construct new rectangle, either use your rectangle
   * It is not guaranteed that it will return tempRect
   * @param rect - Temporary object will be used if AABB is not empty
   * @returns - A rectangle of the bounds
   */ getRectangle(rect) {
        return this.minX > this.maxX || this.minY > this.maxY ? (0, $92248a7cf1facbda$export$4617fb02663045ef).EMPTY : (rect = rect || new (0, $92248a7cf1facbda$export$4617fb02663045ef)(0, 0, 1, 1), rect.x = this.minX, rect.y = this.minY, rect.width = this.maxX - this.minX, rect.height = this.maxY - this.minY, rect);
    }
    /**
   * This function should be inlined when its possible.
   * @param point - The point to add.
   */ addPoint(point) {
        this.minX = Math.min(this.minX, point.x), this.maxX = Math.max(this.maxX, point.x), this.minY = Math.min(this.minY, point.y), this.maxY = Math.max(this.maxY, point.y);
    }
    /**
   * Adds a point, after transformed. This should be inlined when its possible.
   * @param matrix
   * @param point
   */ addPointMatrix(matrix, point) {
        const { a: a, b: b, c: c, d: d, tx: tx, ty: ty } = matrix, x = a * point.x + c * point.y + tx, y = b * point.x + d * point.y + ty;
        this.minX = Math.min(this.minX, x), this.maxX = Math.max(this.maxX, x), this.minY = Math.min(this.minY, y), this.maxY = Math.max(this.maxY, y);
    }
    /**
   * Adds a quad, not transformed
   * @param vertices - The verts to add.
   */ addQuad(vertices) {
        let minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY, x = vertices[0], y = vertices[1];
        minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, x = vertices[2], y = vertices[3], minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, x = vertices[4], y = vertices[5], minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, x = vertices[6], y = vertices[7], minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, this.minX = minX, this.minY = minY, this.maxX = maxX, this.maxY = maxY;
    }
    /**
   * Adds sprite frame, transformed.
   * @param transform - transform to apply
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   */ addFrame(transform, x0, y0, x1, y1) {
        this.addFrameMatrix(transform.worldTransform, x0, y0, x1, y1);
    }
    /**
   * Adds sprite frame, multiplied by matrix
   * @param matrix - matrix to apply
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   */ addFrameMatrix(matrix, x0, y0, x1, y1) {
        const a = matrix.a, b = matrix.b, c = matrix.c, d = matrix.d, tx = matrix.tx, ty = matrix.ty;
        let minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY, x = a * x0 + c * y0 + tx, y = b * x0 + d * y0 + ty;
        minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, x = a * x1 + c * y0 + tx, y = b * x1 + d * y0 + ty, minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, x = a * x0 + c * y1 + tx, y = b * x0 + d * y1 + ty, minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, x = a * x1 + c * y1 + tx, y = b * x1 + d * y1 + ty, minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, this.minX = minX, this.minY = minY, this.maxX = maxX, this.maxY = maxY;
    }
    /**
   * Adds screen vertices from array
   * @param vertexData - calculated vertices
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   */ addVertexData(vertexData, beginOffset, endOffset) {
        let minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY;
        for(let i = beginOffset; i < endOffset; i += 2){
            const x = vertexData[i], y = vertexData[i + 1];
            minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY;
        }
        this.minX = minX, this.minY = minY, this.maxX = maxX, this.maxY = maxY;
    }
    /**
   * Add an array of mesh vertices
   * @param transform - mesh transform
   * @param vertices - mesh coordinates in array
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   */ addVertices(transform, vertices, beginOffset, endOffset) {
        this.addVerticesMatrix(transform.worldTransform, vertices, beginOffset, endOffset);
    }
    /**
   * Add an array of mesh vertices.
   * @param matrix - mesh matrix
   * @param vertices - mesh coordinates in array
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   * @param padX - x padding
   * @param padY - y padding
   */ addVerticesMatrix(matrix, vertices, beginOffset, endOffset, padX = 0, padY = padX) {
        const a = matrix.a, b = matrix.b, c = matrix.c, d = matrix.d, tx = matrix.tx, ty = matrix.ty;
        let minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY;
        for(let i = beginOffset; i < endOffset; i += 2){
            const rawX = vertices[i], rawY = vertices[i + 1], x = a * rawX + c * rawY + tx, y = d * rawY + b * rawX + ty;
            minX = Math.min(minX, x - padX), maxX = Math.max(maxX, x + padX), minY = Math.min(minY, y - padY), maxY = Math.max(maxY, y + padY);
        }
        this.minX = minX, this.minY = minY, this.maxX = maxX, this.maxY = maxY;
    }
    /**
   * Adds other {@link PIXI.Bounds}.
   * @param bounds - The Bounds to be added
   */ addBounds(bounds) {
        const minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY;
        this.minX = bounds.minX < minX ? bounds.minX : minX, this.minY = bounds.minY < minY ? bounds.minY : minY, this.maxX = bounds.maxX > maxX ? bounds.maxX : maxX, this.maxY = bounds.maxY > maxY ? bounds.maxY : maxY;
    }
    /**
   * Adds other Bounds, masked with Bounds.
   * @param bounds - The Bounds to be added.
   * @param mask - TODO
   */ addBoundsMask(bounds, mask) {
        const _minX = bounds.minX > mask.minX ? bounds.minX : mask.minX, _minY = bounds.minY > mask.minY ? bounds.minY : mask.minY, _maxX = bounds.maxX < mask.maxX ? bounds.maxX : mask.maxX, _maxY = bounds.maxY < mask.maxY ? bounds.maxY : mask.maxY;
        if (_minX <= _maxX && _minY <= _maxY) {
            const minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY;
            this.minX = _minX < minX ? _minX : minX, this.minY = _minY < minY ? _minY : minY, this.maxX = _maxX > maxX ? _maxX : maxX, this.maxY = _maxY > maxY ? _maxY : maxY;
        }
    }
    /**
   * Adds other Bounds, multiplied by matrix. Bounds shouldn't be empty.
   * @param bounds - other bounds
   * @param matrix - multiplicator
   */ addBoundsMatrix(bounds, matrix) {
        this.addFrameMatrix(matrix, bounds.minX, bounds.minY, bounds.maxX, bounds.maxY);
    }
    /**
   * Adds other Bounds, masked with Rectangle.
   * @param bounds - TODO
   * @param area - TODO
   */ addBoundsArea(bounds, area) {
        const _minX = bounds.minX > area.x ? bounds.minX : area.x, _minY = bounds.minY > area.y ? bounds.minY : area.y, _maxX = bounds.maxX < area.x + area.width ? bounds.maxX : area.x + area.width, _maxY = bounds.maxY < area.y + area.height ? bounds.maxY : area.y + area.height;
        if (_minX <= _maxX && _minY <= _maxY) {
            const minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY;
            this.minX = _minX < minX ? _minX : minX, this.minY = _minY < minY ? _minY : minY, this.maxX = _maxX > maxX ? _maxX : maxX, this.maxY = _maxY > maxY ? _maxY : maxY;
        }
    }
    /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   */ pad(paddingX = 0, paddingY = paddingX) {
        this.isEmpty() || (this.minX -= paddingX, this.maxX += paddingX, this.minY -= paddingY, this.maxY += paddingY);
    }
    /**
   * Adds padded frame. (x0, y0) should be strictly less than (x1, y1)
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   * @param padX - padding X
   * @param padY - padding Y
   */ addFramePad(x0, y0, x1, y1, padX, padY) {
        x0 -= padX, y0 -= padY, x1 += padX, y1 += padY, this.minX = this.minX < x0 ? this.minX : x0, this.maxX = this.maxX > x1 ? this.maxX : x1, this.minY = this.minY < y0 ? this.minY : y0, this.maxY = this.maxY > y1 ? this.maxY : y1;
    }
}


class $495c730e932693d1$export$1f679544f90d7d7c extends (0, $29e19754806f3a05$exports).EventEmitter {
    constructor(){
        super(), this.tempDisplayObjectParent = null, this.transform = new (0, $a93d35f2e511a825$export$563a914cafbdc389)(), this.alpha = 1, this.visible = !0, this.renderable = !0, this.cullable = !1, this.cullArea = null, this.parent = null, this.worldAlpha = 1, this._lastSortedIndex = 0, this._zIndex = 0, this.filterArea = null, this.filters = null, this._enabledFilters = null, this._bounds = new (0, $70e54ebfdc4c7d64$export$c4e9d269599ab4b4)(), this._localBounds = null, this._boundsID = 0, this._boundsRect = null, this._localBoundsRect = null, this._mask = null, this._maskRefCount = 0, this._destroyed = !1, this.isSprite = !1, this.isMask = !1;
    }
    /**
   * Mixes all enumerable properties and methods from a source object to DisplayObject.
   * @param source - The source of properties and methods to mix in.
   */ static mixin(source) {
        const keys = Object.keys(source);
        for(let i = 0; i < keys.length; ++i){
            const propertyName = keys[i];
            Object.defineProperty($495c730e932693d1$export$1f679544f90d7d7c.prototype, propertyName, Object.getOwnPropertyDescriptor(source, propertyName));
        }
    }
    /**
   * Fired when this DisplayObject is added to a Container.
   * @instance
   * @event added
   * @param {PIXI.Container} container - The container added to.
   */ /**
   * Fired when this DisplayObject is removed from a Container.
   * @instance
   * @event removed
   * @param {PIXI.Container} container - The container removed from.
   */ /**
   * Fired when this DisplayObject is destroyed. This event is emitted once
   * destroy is finished.
   * @instance
   * @event destroyed
   */ /** Readonly flag for destroyed display objects. */ get destroyed() {
        return this._destroyed;
    }
    /** Recursively updates transform of all objects from the root to this one internal function for toLocal() */ _recursivePostUpdateTransform() {
        this.parent ? (this.parent._recursivePostUpdateTransform(), this.transform.updateTransform(this.parent.transform)) : this.transform.updateTransform(this._tempDisplayObjectParent.transform);
    }
    /** Updates the object transform for rendering. TODO - Optimization pass! */ updateTransform() {
        this._boundsID++, this.transform.updateTransform(this.parent.transform), this.worldAlpha = this.alpha * this.parent.worldAlpha;
    }
    /**
   * Calculates and returns the (world) bounds of the display object as a [Rectangle]{@link PIXI.Rectangle}.
   *
   * This method is expensive on containers with a large subtree (like the stage). This is because the bounds
   * of a container depend on its children's bounds, which recursively causes all bounds in the subtree to
   * be recalculated. The upside, however, is that calling `getBounds` once on a container will indeed update
   * the bounds of all children (the whole subtree, in fact). This side effect should be exploited by using
   * `displayObject._bounds.getRectangle()` when traversing through all the bounds in a scene graph. Otherwise,
   * calling `getBounds` on each object in a subtree will cause the total cost to increase quadratically as
   * its height increases.
   *
   * The transforms of all objects in a container's **subtree** and of all **ancestors** are updated.
   * The world bounds of all display objects in a container's **subtree** will also be recalculated.
   *
   * The `_bounds` object stores the last calculation of the bounds. You can use to entirely skip bounds
   * calculation if needed.
   *
   * ```js
   * const lastCalculatedBounds = displayObject._bounds.getRectangle(optionalRect);
   * ```
   *
   * Do know that usage of `getLocalBounds` can corrupt the `_bounds` of children (the whole subtree, actually). This
   * is a known issue that has not been solved. See [getLocalBounds]{@link PIXI.DisplayObject#getLocalBounds} for more
   * details.
   *
   * `getBounds` should be called with `skipUpdate` equal to `true` in a render() call. This is because the transforms
   * are guaranteed to be update-to-date. In fact, recalculating inside a render() call may cause corruption in certain
   * cases.
   * @param skipUpdate - Setting to `true` will stop the transforms of the scene graph from
   *  being updated. This means the calculation returned MAY be out of date BUT will give you a
   *  nice performance boost.
   * @param rect - Optional rectangle to store the result of the bounds calculation.
   * @returns - The minimum axis-aligned rectangle in world space that fits around this object.
   */ getBounds(skipUpdate, rect) {
        return skipUpdate || (this.parent ? (this._recursivePostUpdateTransform(), this.updateTransform()) : (this.parent = this._tempDisplayObjectParent, this.updateTransform(), this.parent = null)), this._bounds.updateID !== this._boundsID && (this.calculateBounds(), this._bounds.updateID = this._boundsID), rect || (this._boundsRect || (this._boundsRect = new (0, $92248a7cf1facbda$export$4617fb02663045ef)()), rect = this._boundsRect), this._bounds.getRectangle(rect);
    }
    /**
   * Retrieves the local bounds of the displayObject as a rectangle object.
   * @param rect - Optional rectangle to store the result of the bounds calculation.
   * @returns - The rectangular bounding area.
   */ getLocalBounds(rect) {
        rect || (this._localBoundsRect || (this._localBoundsRect = new (0, $92248a7cf1facbda$export$4617fb02663045ef)()), rect = this._localBoundsRect), this._localBounds || (this._localBounds = new (0, $70e54ebfdc4c7d64$export$c4e9d269599ab4b4)());
        const transformRef = this.transform, parentRef = this.parent;
        this.parent = null, this._tempDisplayObjectParent.worldAlpha = parentRef?.worldAlpha ?? 1, this.transform = this._tempDisplayObjectParent.transform;
        const worldBounds = this._bounds, worldBoundsID = this._boundsID;
        this._bounds = this._localBounds;
        const bounds = this.getBounds(!1, rect);
        return this.parent = parentRef, this.transform = transformRef, this._bounds = worldBounds, this._bounds.updateID += this._boundsID - worldBoundsID, bounds;
    }
    /**
   * Calculates the global position of the display object.
   * @param position - The world origin to calculate from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform.
   * @returns - A point object representing the position of this object.
   */ toGlobal(position, point, skipUpdate = !1) {
        return skipUpdate || (this._recursivePostUpdateTransform(), this.parent ? this.displayObjectUpdateTransform() : (this.parent = this._tempDisplayObjectParent, this.displayObjectUpdateTransform(), this.parent = null)), this.worldTransform.apply(position, point);
    }
    /**
   * Calculates the local position of the display object relative to another point.
   * @param position - The world origin to calculate from.
   * @param from - The DisplayObject to calculate the global position from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform
   * @returns - A point object representing the position of this object
   */ toLocal(position, from, point, skipUpdate) {
        return from && (position = from.toGlobal(position, point, skipUpdate)), skipUpdate || (this._recursivePostUpdateTransform(), this.parent ? this.displayObjectUpdateTransform() : (this.parent = this._tempDisplayObjectParent, this.displayObjectUpdateTransform(), this.parent = null)), this.worldTransform.applyInverse(position, point);
    }
    /**
   * Set the parent Container of this DisplayObject.
   * @param container - The Container to add this DisplayObject to.
   * @returns - The Container that this DisplayObject was added to.
   */ setParent(container) {
        if (!container || !container.addChild) throw new Error("setParent: Argument must be a Container");
        return container.addChild(this), container;
    }
    /** Remove the DisplayObject from its parent Container. If the DisplayObject has no parent, do nothing. */ removeFromParent() {
        this.parent?.removeChild(this);
    }
    /**
   * Convenience function to set the position, scale, skew and pivot at once.
   * @param x - The X position
   * @param y - The Y position
   * @param scaleX - The X scale value
   * @param scaleY - The Y scale value
   * @param rotation - The rotation
   * @param skewX - The X skew value
   * @param skewY - The Y skew value
   * @param pivotX - The X pivot value
   * @param pivotY - The Y pivot value
   * @returns - The DisplayObject instance
   */ setTransform(x = 0, y = 0, scaleX = 1, scaleY = 1, rotation = 0, skewX = 0, skewY = 0, pivotX = 0, pivotY = 0) {
        return this.position.x = x, this.position.y = y, this.scale.x = scaleX || 1, this.scale.y = scaleY || 1, this.rotation = rotation, this.skew.x = skewX, this.skew.y = skewY, this.pivot.x = pivotX, this.pivot.y = pivotY, this;
    }
    /**
   * Base destroy method for generic display objects. This will automatically
   * remove the display object from its parent Container as well as remove
   * all current event listeners and internal references. Do not use a DisplayObject
   * after calling `destroy()`.
   * @param _options
   */ destroy(_options) {
        this.removeFromParent(), this._destroyed = !0, this.transform = null, this.parent = null, this._bounds = null, this.mask = null, this.cullArea = null, this.filters = null, this.filterArea = null, this.hitArea = null, this.eventMode = "auto", this.interactiveChildren = !1, this.emit("destroyed"), this.removeAllListeners();
    }
    /**
   * @protected
   * @member {PIXI.Container}
   */ get _tempDisplayObjectParent() {
        return this.tempDisplayObjectParent === null && (this.tempDisplayObjectParent = new $495c730e932693d1$export$a35515d77cade20d()), this.tempDisplayObjectParent;
    }
    /**
   * Used in Renderer, cacheAsBitmap and other places where you call an `updateTransform` on root.
   *
   * ```js
   * const cacheParent = elem.enableTempParent();
   * elem.updateTransform();
   * elem.disableTempParent(cacheParent);
   * ```
   * @returns - Current parent
   */ enableTempParent() {
        const myParent = this.parent;
        return this.parent = this._tempDisplayObjectParent, myParent;
    }
    /**
   * Pair method for `enableTempParent`
   * @param cacheParent - Actual parent of element
   */ disableTempParent(cacheParent) {
        this.parent = cacheParent;
    }
    /**
   * The position of the displayObject on the x axis relative to the local coordinates of the parent.
   * An alias to position.x
   */ get x() {
        return this.position.x;
    }
    set x(value) {
        this.transform.position.x = value;
    }
    /**
   * The position of the displayObject on the y axis relative to the local coordinates of the parent.
   * An alias to position.y
   */ get y() {
        return this.position.y;
    }
    set y(value) {
        this.transform.position.y = value;
    }
    /**
   * Current transform of the object based on world (parent) factors.
   * @readonly
   */ get worldTransform() {
        return this.transform.worldTransform;
    }
    /**
   * Current transform of the object based on local factors: position, scale, other stuff.
   * @readonly
   */ get localTransform() {
        return this.transform.localTransform;
    }
    /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @since 4.0.0
   */ get position() {
        return this.transform.position;
    }
    set position(value) {
        this.transform.position.copyFrom(value);
    }
    /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @since 4.0.0
   */ get scale() {
        return this.transform.scale;
    }
    set scale(value) {
        this.transform.scale.copyFrom(value);
    }
    /**
   * The center of rotation, scaling, and skewing for this display object in its local space. The `position`
   * is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @since 4.0.0
   */ get pivot() {
        return this.transform.pivot;
    }
    set pivot(value) {
        this.transform.pivot.copyFrom(value);
    }
    /**
   * The skew factor for the object in radians.
   * @since 4.0.0
   */ get skew() {
        return this.transform.skew;
    }
    set skew(value) {
        this.transform.skew.copyFrom(value);
    }
    /**
   * The rotation of the object in radians.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */ get rotation() {
        return this.transform.rotation;
    }
    set rotation(value) {
        this.transform.rotation = value;
    }
    /**
   * The angle of the object in degrees.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */ get angle() {
        return this.transform.rotation * (0, $23fb2779a12001d8$export$3f91627dc85c5d57);
    }
    set angle(value) {
        this.transform.rotation = value * (0, $23fb2779a12001d8$export$870617f62e3187f1);
    }
    /**
   * The zIndex of the displayObject.
   *
   * If a container has the sortableChildren property set to true, children will be automatically
   * sorted by zIndex value; a higher value will mean it will be moved towards the end of the array,
   * and thus rendered on top of other display objects within the same container.
   * @see PIXI.Container#sortableChildren
   */ get zIndex() {
        return this._zIndex;
    }
    set zIndex(value) {
        this._zIndex = value, this.parent && (this.parent.sortDirty = !0);
    }
    /**
   * Indicates if the object is globally visible.
   * @readonly
   */ get worldVisible() {
        let item = this;
        do {
            if (!item.visible) return !1;
            item = item.parent;
        }while (item);
        return !0;
    }
    /**
   * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
   * object to the shape of the mask applied to it. In PixiJS a regular mask must be a
   * {@link PIXI.Graphics} or a {@link PIXI.Sprite} object. This allows for much faster masking in canvas as it
   * utilities shape clipping. Furthermore, a mask of an object must be in the subtree of its parent.
   * Otherwise, `getLocalBounds` may calculate incorrect bounds, which makes the container's width and height wrong.
   * To remove a mask, set this property to `null`.
   *
   * For sprite mask both alpha and red channel are used. Black mask is the same as transparent mask.
   * @example
   * import { Graphics, Sprite } from 'pixi.js';
   *
   * const graphics = new Graphics();
   * graphics.beginFill(0xFF3300);
   * graphics.drawRect(50, 250, 100, 100);
   * graphics.endFill();
   *
   * const sprite = new Sprite(texture);
   * sprite.mask = graphics;
   * @todo At the moment, CanvasRenderer doesn't support Sprite as mask.
   */ get mask() {
        return this._mask;
    }
    set mask(value) {
        if (this._mask !== value) {
            if (this._mask) {
                const maskObject = this._mask.isMaskData ? this._mask.maskObject : this._mask;
                maskObject && (maskObject._maskRefCount--, maskObject._maskRefCount === 0 && (maskObject.renderable = !0, maskObject.isMask = !1));
            }
            if (this._mask = value, this._mask) {
                const maskObject = this._mask.isMaskData ? this._mask.maskObject : this._mask;
                maskObject && (maskObject._maskRefCount === 0 && (maskObject.renderable = !1, maskObject.isMask = !0), maskObject._maskRefCount++);
            }
        }
    }
}
class $495c730e932693d1$export$a35515d77cade20d extends $495c730e932693d1$export$1f679544f90d7d7c {
    constructor(){
        super(...arguments), this.sortDirty = null;
    }
}
$495c730e932693d1$export$1f679544f90d7d7c.prototype.displayObjectUpdateTransform = $495c730e932693d1$export$1f679544f90d7d7c.prototype.updateTransform;


const $3878067a77b781d9$var$tempMatrix = new (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85)();
function $3878067a77b781d9$var$sortChildren(a, b) {
    return a.zIndex === b.zIndex ? a._lastSortedIndex - b._lastSortedIndex : a.zIndex - b.zIndex;
}
const $3878067a77b781d9$var$_Container = class _Container2 extends (0, $495c730e932693d1$export$1f679544f90d7d7c) {
    constructor(){
        super(), this.children = [], this.sortableChildren = _Container2.defaultSortableChildren, this.sortDirty = !1;
    }
    /**
   * Overridable method that can be used by Container subclasses whenever the children array is modified.
   * @param _length
   */ onChildrenChange(_length) {}
    /**
   * Adds one or more children to the container.
   *
   * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
   * @param {...PIXI.DisplayObject} children - The DisplayObject(s) to add to the container
   * @returns {PIXI.DisplayObject} - The first child that was added.
   */ addChild(...children) {
        if (children.length > 1) for(let i = 0; i < children.length; i++)this.addChild(children[i]);
        else {
            const child = children[0];
            child.parent && child.parent.removeChild(child), child.parent = this, this.sortDirty = !0, child.transform._parentID = -1, this.children.push(child), this._boundsID++, this.onChildrenChange(this.children.length - 1), this.emit("childAdded", child, this, this.children.length - 1), child.emit("added", this);
        }
        return children[0];
    }
    /**
   * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown.
   * If the child is already in this container, it will be moved to the specified index.
   * @param {PIXI.DisplayObject} child - The child to add.
   * @param {number} index - The absolute index where the child will be positioned at the end of the operation.
   * @returns {PIXI.DisplayObject} The child that was added.
   */ addChildAt(child, index) {
        if (index < 0 || index > this.children.length) throw new Error(`${child}addChildAt: The index ${index} supplied is out of bounds ${this.children.length}`);
        return child.parent && child.parent.removeChild(child), child.parent = this, this.sortDirty = !0, child.transform._parentID = -1, this.children.splice(index, 0, child), this._boundsID++, this.onChildrenChange(index), child.emit("added", this), this.emit("childAdded", child, this, index), child;
    }
    /**
   * Swaps the position of 2 Display Objects within this container.
   * @param child - First display object to swap
   * @param child2 - Second display object to swap
   */ swapChildren(child, child2) {
        if (child === child2) return;
        const index1 = this.getChildIndex(child), index2 = this.getChildIndex(child2);
        this.children[index1] = child2, this.children[index2] = child, this.onChildrenChange(index1 < index2 ? index1 : index2);
    }
    /**
   * Returns the index position of a child DisplayObject instance
   * @param child - The DisplayObject instance to identify
   * @returns - The index position of the child display object to identify
   */ getChildIndex(child) {
        const index = this.children.indexOf(child);
        if (index === -1) throw new Error("The supplied DisplayObject must be a child of the caller");
        return index;
    }
    /**
   * Changes the position of an existing child in the display object container
   * @param child - The child DisplayObject instance for which you want to change the index number
   * @param index - The resulting index number for the child display object
   */ setChildIndex(child, index) {
        if (index < 0 || index >= this.children.length) throw new Error(`The index ${index} supplied is out of bounds ${this.children.length}`);
        const currentIndex = this.getChildIndex(child);
        (0, $29e19754806f3a05$exports).removeItems(this.children, currentIndex, 1), this.children.splice(index, 0, child), this.onChildrenChange(index);
    }
    /**
   * Returns the child at the specified index
   * @param index - The index to get the child at
   * @returns - The child at the given index, if any.
   */ getChildAt(index) {
        if (index < 0 || index >= this.children.length) throw new Error(`getChildAt: Index (${index}) does not exist.`);
        return this.children[index];
    }
    /**
   * Removes one or more children from the container.
   * @param {...PIXI.DisplayObject} children - The DisplayObject(s) to remove
   * @returns {PIXI.DisplayObject} The first child that was removed.
   */ removeChild(...children) {
        if (children.length > 1) for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
        else {
            const child = children[0], index = this.children.indexOf(child);
            if (index === -1) return null;
            child.parent = null, child.transform._parentID = -1, (0, $29e19754806f3a05$exports).removeItems(this.children, index, 1), this._boundsID++, this.onChildrenChange(index), child.emit("removed", this), this.emit("childRemoved", child, this, index);
        }
        return children[0];
    }
    /**
   * Removes a child from the specified index position.
   * @param index - The index to get the child from
   * @returns The child that was removed.
   */ removeChildAt(index) {
        const child = this.getChildAt(index);
        return child.parent = null, child.transform._parentID = -1, (0, $29e19754806f3a05$exports).removeItems(this.children, index, 1), this._boundsID++, this.onChildrenChange(index), child.emit("removed", this), this.emit("childRemoved", child, this, index), child;
    }
    /**
   * Removes all children from this container that are within the begin and end indexes.
   * @param beginIndex - The beginning position.
   * @param endIndex - The ending position. Default value is size of the container.
   * @returns - List of removed children
   */ removeChildren(beginIndex = 0, endIndex = this.children.length) {
        const begin = beginIndex, end = endIndex, range = end - begin;
        let removed;
        if (range > 0 && range <= end) {
            removed = this.children.splice(begin, range);
            for(let i = 0; i < removed.length; ++i)removed[i].parent = null, removed[i].transform && (removed[i].transform._parentID = -1);
            this._boundsID++, this.onChildrenChange(beginIndex);
            for(let i = 0; i < removed.length; ++i)removed[i].emit("removed", this), this.emit("childRemoved", removed[i], this, i);
            return removed;
        } else if (range === 0 && this.children.length === 0) return [];
        throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
    }
    /** Sorts children by zIndex. Previous order is maintained for 2 children with the same zIndex. */ sortChildren() {
        let sortRequired = !1;
        for(let i = 0, j = this.children.length; i < j; ++i){
            const child = this.children[i];
            child._lastSortedIndex = i, !sortRequired && child.zIndex !== 0 && (sortRequired = !0);
        }
        sortRequired && this.children.length > 1 && this.children.sort($3878067a77b781d9$var$sortChildren), this.sortDirty = !1;
    }
    /** Updates the transform on all children of this container for rendering. */ updateTransform() {
        this.sortableChildren && this.sortDirty && this.sortChildren(), this._boundsID++, this.transform.updateTransform(this.parent.transform), this.worldAlpha = this.alpha * this.parent.worldAlpha;
        for(let i = 0, j = this.children.length; i < j; ++i){
            const child = this.children[i];
            child.visible && child.updateTransform();
        }
    }
    /**
   * Recalculates the bounds of the container.
   *
   * This implementation will automatically fit the children's bounds into the calculation. Each child's bounds
   * is limited to its mask's bounds or filterArea, if any is applied.
   */ calculateBounds() {
        this._bounds.clear(), this._calculateBounds();
        for(let i = 0; i < this.children.length; i++){
            const child = this.children[i];
            if (!(!child.visible || !child.renderable)) {
                if (child.calculateBounds(), child._mask) {
                    const maskObject = child._mask.isMaskData ? child._mask.maskObject : child._mask;
                    maskObject ? (maskObject.calculateBounds(), this._bounds.addBoundsMask(child._bounds, maskObject._bounds)) : this._bounds.addBounds(child._bounds);
                } else child.filterArea ? this._bounds.addBoundsArea(child._bounds, child.filterArea) : this._bounds.addBounds(child._bounds);
            }
        }
        this._bounds.updateID = this._boundsID;
    }
    /**
   * Retrieves the local bounds of the displayObject as a rectangle object.
   *
   * Calling `getLocalBounds` may invalidate the `_bounds` of the whole subtree below. If using it inside a render()
   * call, it is advised to call `getBounds()` immediately after to recalculate the world bounds of the subtree.
   * @param rect - Optional rectangle to store the result of the bounds calculation.
   * @param skipChildrenUpdate - Setting to `true` will stop re-calculation of children transforms,
   *  it was default behaviour of pixi 4.0-5.2 and caused many problems to users.
   * @returns - The rectangular bounding area.
   */ getLocalBounds(rect, skipChildrenUpdate = !1) {
        const result = super.getLocalBounds(rect);
        if (!skipChildrenUpdate) for(let i = 0, j = this.children.length; i < j; ++i){
            const child = this.children[i];
            child.visible && child.updateTransform();
        }
        return result;
    }
    /**
   * Recalculates the content bounds of this object. This should be overriden to
   * calculate the bounds of this specific object (not including children).
   * @protected
   */ _calculateBounds() {}
    /**
   * Renders this object and its children with culling.
   * @protected
   * @param {PIXI.Renderer} renderer - The renderer
   */ _renderWithCulling(renderer) {
        const sourceFrame = renderer.renderTexture.sourceFrame;
        if (!(sourceFrame.width > 0 && sourceFrame.height > 0)) return;
        let bounds, transform;
        this.cullArea ? (bounds = this.cullArea, transform = this.worldTransform) : this._render !== _Container2.prototype._render && (bounds = this.getBounds(!0));
        const projectionTransform = renderer.projection.transform;
        if (projectionTransform && (transform ? (transform = $3878067a77b781d9$var$tempMatrix.copyFrom(transform), transform.prepend(projectionTransform)) : transform = projectionTransform), bounds && sourceFrame.intersects(bounds, transform)) this._render(renderer);
        else if (this.cullArea) return;
        for(let i = 0, j = this.children.length; i < j; ++i){
            const child = this.children[i], childCullable = child.cullable;
            child.cullable = childCullable || !this.cullArea, child.render(renderer), child.cullable = childCullable;
        }
    }
    /**
   * Renders the object using the WebGL renderer.
   *
   * The [_render]{@link PIXI.Container#_render} method is be overriden for rendering the contents of the
   * container itself. This `render` method will invoke it, and also invoke the `render` methods of all
   * children afterward.
   *
   * If `renderable` or `visible` is false or if `worldAlpha` is not positive or if `cullable` is true and
   * the bounds of this object are out of frame, this implementation will entirely skip rendering.
   * See {@link PIXI.DisplayObject} for choosing between `renderable` or `visible`. Generally,
   * setting alpha to zero is not recommended for purely skipping rendering.
   *
   * When your scene becomes large (especially when it is larger than can be viewed in a single screen), it is
   * advised to employ **culling** to automatically skip rendering objects outside of the current screen.
   * See [cullable]{@link PIXI.DisplayObject#cullable} and [cullArea]{@link PIXI.DisplayObject#cullArea}.
   * Other culling methods might be better suited for a large number static objects; see
   * [@pixi-essentials/cull]{@link https://www.npmjs.com/package/@pixi-essentials/cull} and
   * [pixi-cull]{@link https://www.npmjs.com/package/pixi-cull}.
   *
   * The [renderAdvanced]{@link PIXI.Container#renderAdvanced} method is internally used when when masking or
   * filtering is applied on a container. This does, however, break batching and can affect performance when
   * masking and filtering is applied extensively throughout the scene graph.
   * @param renderer - The renderer
   */ render(renderer) {
        if (!(!this.visible || this.worldAlpha <= 0 || !this.renderable)) {
            if (this._mask || this.filters?.length) this.renderAdvanced(renderer);
            else if (this.cullable) this._renderWithCulling(renderer);
            else {
                this._render(renderer);
                for(let i = 0, j = this.children.length; i < j; ++i)this.children[i].render(renderer);
            }
        }
    }
    /**
   * Render the object using the WebGL renderer and advanced features.
   * @param renderer - The renderer
   */ renderAdvanced(renderer) {
        const filters = this.filters, mask = this._mask;
        if (filters) {
            this._enabledFilters || (this._enabledFilters = []), this._enabledFilters.length = 0;
            for(let i = 0; i < filters.length; i++)filters[i].enabled && this._enabledFilters.push(filters[i]);
        }
        const flush = filters && this._enabledFilters?.length || mask && (!mask.isMaskData || mask.enabled && (mask.autoDetect || mask.type !== (0, $5912637ee8cf8b9f$export$dbbea138c5d144).NONE));
        if (flush && renderer.batch.flush(), filters && this._enabledFilters?.length && renderer.filter.push(this, this._enabledFilters), mask && renderer.mask.push(this, this._mask), this.cullable) this._renderWithCulling(renderer);
        else {
            this._render(renderer);
            for(let i = 0, j = this.children.length; i < j; ++i)this.children[i].render(renderer);
        }
        flush && renderer.batch.flush(), mask && renderer.mask.pop(this), filters && this._enabledFilters?.length && renderer.filter.pop();
    }
    /**
   * To be overridden by the subclasses.
   * @param _renderer - The renderer
   */ _render(_renderer) {}
    /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
   *  method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the texture of the child sprite
   * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the base texture of the child sprite
   */ destroy(options) {
        super.destroy(), this.sortDirty = !1;
        const destroyChildren = typeof options == "boolean" ? options : options?.children, oldChildren = this.removeChildren(0, this.children.length);
        if (destroyChildren) for(let i = 0; i < oldChildren.length; ++i)oldChildren[i].destroy(options);
    }
    /** The width of the Container, setting this will actually modify the scale to achieve the value set. */ get width() {
        return this.scale.x * this.getLocalBounds().width;
    }
    set width(value) {
        const width = this.getLocalBounds().width;
        width !== 0 ? this.scale.x = value / width : this.scale.x = 1, this._width = value;
    }
    /** The height of the Container, setting this will actually modify the scale to achieve the value set. */ get height() {
        return this.scale.y * this.getLocalBounds().height;
    }
    set height(value) {
        const height = this.getLocalBounds().height;
        height !== 0 ? this.scale.y = value / height : this.scale.y = 1, this._height = value;
    }
};
$3878067a77b781d9$var$_Container.defaultSortableChildren = !1;
let $3878067a77b781d9$export$42a852a2b6b56249 = $3878067a77b781d9$var$_Container;
$3878067a77b781d9$export$42a852a2b6b56249.prototype.containerUpdateTransform = $3878067a77b781d9$export$42a852a2b6b56249.prototype.updateTransform;


Object.defineProperties((0, $5340ccf8570d4063$export$a5a6e0b888b2c992), {
    /**
   * Sets the default value for the container property 'sortableChildren'.
   * @static
   * @name SORTABLE_CHILDREN
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @type {boolean}
   * @see PIXI.Container.defaultSortableChildren
   */ SORTABLE_CHILDREN: {
        get () {
            return (0, $3878067a77b781d9$export$42a852a2b6b56249).defaultSortableChildren;
        },
        set (value) {
            (0, $29e19754806f3a05$exports).deprecation("7.1.0", "settings.SORTABLE_CHILDREN is deprecated, use Container.defaultSortableChildren"), (0, $3878067a77b781d9$export$42a852a2b6b56249).defaultSortableChildren = value;
        }
    }
});









const $f092bed24e72671b$var$tempPoint = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(), $f092bed24e72671b$var$indices = new Uint16Array([
    0,
    1,
    2,
    0,
    2,
    3
]);
class $f092bed24e72671b$export$3075603db8e6204c extends (0, $3878067a77b781d9$export$42a852a2b6b56249) {
    /** @param texture - The texture for this sprite. */ constructor(texture){
        super(), this._anchor = new (0, $0c68ac15ddf7471c$export$3755aaad3fd42e52)(this._onAnchorUpdate, this, texture ? texture.defaultAnchor.x : 0, texture ? texture.defaultAnchor.y : 0), this._texture = null, this._width = 0, this._height = 0, this._tintColor = new (0, $3119899e085d9ccf$export$892596cec99bc70e)(16777215), this._tintRGB = null, this.tint = 16777215, this.blendMode = (0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).NORMAL, this._cachedTint = 16777215, this.uvs = null, this.texture = texture || (0, $ad1fffd072a707c2$export$5431306cf43de24a).EMPTY, this.vertexData = new Float32Array(8), this.vertexTrimmedData = null, this._transformID = -1, this._textureID = -1, this._transformTrimmedID = -1, this._textureTrimmedID = -1, this.indices = $f092bed24e72671b$var$indices, this.pluginName = "batch", this.isSprite = !0, this._roundPixels = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ROUND_PIXELS;
    }
    /** When the texture is updated, this event will fire to update the scale and frame. */ _onTextureUpdate() {
        this._textureID = -1, this._textureTrimmedID = -1, this._cachedTint = 16777215, this._width && (this.scale.x = (0, $29e19754806f3a05$exports).sign(this.scale.x) * this._width / this._texture.orig.width), this._height && (this.scale.y = (0, $29e19754806f3a05$exports).sign(this.scale.y) * this._height / this._texture.orig.height);
    }
    /** Called when the anchor position updates. */ _onAnchorUpdate() {
        this._transformID = -1, this._transformTrimmedID = -1;
    }
    /** Calculates worldTransform * vertices, store it in vertexData. */ calculateVertices() {
        const texture = this._texture;
        if (this._transformID === this.transform._worldID && this._textureID === texture._updateID) return;
        this._textureID !== texture._updateID && (this.uvs = this._texture._uvs.uvsFloat32), this._transformID = this.transform._worldID, this._textureID = texture._updateID;
        const wt = this.transform.worldTransform, a = wt.a, b = wt.b, c = wt.c, d = wt.d, tx = wt.tx, ty = wt.ty, vertexData = this.vertexData, trim = texture.trim, orig = texture.orig, anchor = this._anchor;
        let w0 = 0, w1 = 0, h0 = 0, h1 = 0;
        if (trim ? (w1 = trim.x - anchor._x * orig.width, w0 = w1 + trim.width, h1 = trim.y - anchor._y * orig.height, h0 = h1 + trim.height) : (w1 = -anchor._x * orig.width, w0 = w1 + orig.width, h1 = -anchor._y * orig.height, h0 = h1 + orig.height), vertexData[0] = a * w1 + c * h1 + tx, vertexData[1] = d * h1 + b * w1 + ty, vertexData[2] = a * w0 + c * h1 + tx, vertexData[3] = d * h1 + b * w0 + ty, vertexData[4] = a * w0 + c * h0 + tx, vertexData[5] = d * h0 + b * w0 + ty, vertexData[6] = a * w1 + c * h0 + tx, vertexData[7] = d * h0 + b * w1 + ty, this._roundPixels) {
            const resolution = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).RESOLUTION;
            for(let i = 0; i < vertexData.length; ++i)vertexData[i] = Math.round(vertexData[i] * resolution) / resolution;
        }
    }
    /**
   * Calculates worldTransform * vertices for a non texture with a trim. store it in vertexTrimmedData.
   *
   * This is used to ensure that the true width and height of a trimmed texture is respected.
   */ calculateTrimmedVertices() {
        if (!this.vertexTrimmedData) this.vertexTrimmedData = new Float32Array(8);
        else if (this._transformTrimmedID === this.transform._worldID && this._textureTrimmedID === this._texture._updateID) return;
        this._transformTrimmedID = this.transform._worldID, this._textureTrimmedID = this._texture._updateID;
        const texture = this._texture, vertexData = this.vertexTrimmedData, orig = texture.orig, anchor = this._anchor, wt = this.transform.worldTransform, a = wt.a, b = wt.b, c = wt.c, d = wt.d, tx = wt.tx, ty = wt.ty, w1 = -anchor._x * orig.width, w0 = w1 + orig.width, h1 = -anchor._y * orig.height, h0 = h1 + orig.height;
        if (vertexData[0] = a * w1 + c * h1 + tx, vertexData[1] = d * h1 + b * w1 + ty, vertexData[2] = a * w0 + c * h1 + tx, vertexData[3] = d * h1 + b * w0 + ty, vertexData[4] = a * w0 + c * h0 + tx, vertexData[5] = d * h0 + b * w0 + ty, vertexData[6] = a * w1 + c * h0 + tx, vertexData[7] = d * h0 + b * w1 + ty, this._roundPixels) {
            const resolution = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).RESOLUTION;
            for(let i = 0; i < vertexData.length; ++i)vertexData[i] = Math.round(vertexData[i] * resolution) / resolution;
        }
    }
    /**
   *
   * Renders the object using the WebGL renderer
   * @param renderer - The webgl renderer to use.
   */ _render(renderer) {
        this.calculateVertices(), renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]), renderer.plugins[this.pluginName].render(this);
    }
    /** Updates the bounds of the sprite. */ _calculateBounds() {
        const trim = this._texture.trim, orig = this._texture.orig;
        !trim || trim.width === orig.width && trim.height === orig.height ? (this.calculateVertices(), this._bounds.addQuad(this.vertexData)) : (this.calculateTrimmedVertices(), this._bounds.addQuad(this.vertexTrimmedData));
    }
    /**
   * Gets the local bounds of the sprite object.
   * @param rect - Optional output rectangle.
   * @returns The bounds.
   */ getLocalBounds(rect) {
        return this.children.length === 0 ? (this._localBounds || (this._localBounds = new (0, $70e54ebfdc4c7d64$export$c4e9d269599ab4b4)()), this._localBounds.minX = this._texture.orig.width * -this._anchor._x, this._localBounds.minY = this._texture.orig.height * -this._anchor._y, this._localBounds.maxX = this._texture.orig.width * (1 - this._anchor._x), this._localBounds.maxY = this._texture.orig.height * (1 - this._anchor._y), rect || (this._localBoundsRect || (this._localBoundsRect = new (0, $92248a7cf1facbda$export$4617fb02663045ef)()), rect = this._localBoundsRect), this._localBounds.getRectangle(rect)) : super.getLocalBounds.call(this, rect);
    }
    /**
   * Tests if a point is inside this sprite
   * @param point - the point to test
   * @returns The result of the test
   */ containsPoint(point) {
        this.worldTransform.applyInverse(point, $f092bed24e72671b$var$tempPoint);
        const width = this._texture.orig.width, height = this._texture.orig.height, x1 = -width * this.anchor.x;
        let y1 = 0;
        return $f092bed24e72671b$var$tempPoint.x >= x1 && $f092bed24e72671b$var$tempPoint.x < x1 + width && (y1 = -height * this.anchor.y, $f092bed24e72671b$var$tempPoint.y >= y1 && $f092bed24e72671b$var$tempPoint.y < y1 + height);
    }
    /**
   * Destroys this sprite and optionally its texture and children.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param [options.children=false] - if set to true, all the children will have their destroy
   *      method called as well. 'options' will be passed on to those calls.
   * @param [options.texture=false] - Should it destroy the current texture of the sprite as well
   * @param [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
   */ destroy(options) {
        if (super.destroy(options), this._texture.off("update", this._onTextureUpdate, this), this._anchor = null, typeof options == "boolean" ? options : options?.texture) {
            const destroyBaseTexture = typeof options == "boolean" ? options : options?.baseTexture;
            this._texture.destroy(!!destroyBaseTexture);
        }
        this._texture = null;
    }
    // some helper functions..
    /**
   * Helper function that creates a new sprite based on the source you provide.
   * The source can be - frame id, image url, video url, canvas element, video element, base texture
   * @param {string|PIXI.Texture|HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas} source
   *     - Source to create texture from
   * @param {object} [options] - See {@link PIXI.BaseTexture}'s constructor for options.
   * @returns The newly created sprite
   */ static from(source, options) {
        const texture = source instanceof (0, $ad1fffd072a707c2$export$5431306cf43de24a) ? source : (0, $ad1fffd072a707c2$export$5431306cf43de24a).from(source, options);
        return new $f092bed24e72671b$export$3075603db8e6204c(texture);
    }
    /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   *
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   *
   * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}.
   * @default false
   */ set roundPixels(value) {
        this._roundPixels !== value && (this._transformID = -1, this._transformTrimmedID = -1), this._roundPixels = value;
    }
    get roundPixels() {
        return this._roundPixels;
    }
    /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */ get width() {
        return Math.abs(this.scale.x) * this._texture.orig.width;
    }
    set width(value) {
        const s = (0, $29e19754806f3a05$exports).sign(this.scale.x) || 1;
        this.scale.x = s * value / this._texture.orig.width, this._width = value;
    }
    /** The height of the sprite, setting this will actually modify the scale to achieve the value set. */ get height() {
        return Math.abs(this.scale.y) * this._texture.orig.height;
    }
    set height(value) {
        const s = (0, $29e19754806f3a05$exports).sign(this.scale.y) || 1;
        this.scale.y = s * value / this._texture.orig.height, this._height = value;
    }
    /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link PIXI.Texture|Texture}
   * and passed to the constructor.
   *
   * The default is `(0,0)`, this means the sprite's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   *
   * Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * import { Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite(Texture.WHITE);
   * sprite.anchor.set(0.5); // This will set the origin to center. (0.5) is same as (0.5, 0.5).
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        this._anchor.copyFrom(value);
    }
    /**
   * The tint applied to the sprite. This is a hex value.
   *
   * A value of 0xFFFFFF will remove any tint effect.
   * @default 0xFFFFFF
   */ get tint() {
        return this._tintColor.value;
    }
    set tint(value) {
        this._tintColor.setValue(value), this._tintRGB = this._tintColor.toLittleEndianNumber();
    }
    /**
   * Get the tint as a RGB integer.
   * @ignore
   */ get tintValue() {
        return this._tintColor.toNumber();
    }
    /** The texture that the sprite is using. */ get texture() {
        return this._texture;
    }
    set texture(value) {
        this._texture !== value && (this._texture && this._texture.off("update", this._onTextureUpdate, this), this._texture = value || (0, $ad1fffd072a707c2$export$5431306cf43de24a).EMPTY, this._cachedTint = 16777215, this._textureID = -1, this._textureTrimmedID = -1, value && (value.baseTexture.valid ? this._onTextureUpdate() : value.once("update", this._onTextureUpdate, this)));
    }
}




const $2ac4a71b6bcc6c70$var$_tempMatrix = new (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85)();
(0, $495c730e932693d1$export$1f679544f90d7d7c).prototype._cacheAsBitmap = !1;
(0, $495c730e932693d1$export$1f679544f90d7d7c).prototype._cacheData = null;
(0, $495c730e932693d1$export$1f679544f90d7d7c).prototype._cacheAsBitmapResolution = null;
(0, $495c730e932693d1$export$1f679544f90d7d7c).prototype._cacheAsBitmapMultisample = null;
class $2ac4a71b6bcc6c70$export$3e19bdfd927f283c {
    constructor(){
        this.textureCacheId = null, this.originalRender = null, this.originalRenderCanvas = null, this.originalCalculateBounds = null, this.originalGetLocalBounds = null, this.originalUpdateTransform = null, this.originalDestroy = null, this.originalMask = null, this.originalFilterArea = null, this.originalContainsPoint = null, this.sprite = null;
    }
}
Object.defineProperties((0, $495c730e932693d1$export$1f679544f90d7d7c).prototype, {
    /**
   * The resolution to use for cacheAsBitmap. By default this will use the renderer's resolution
   * but can be overriden for performance. Lower values will reduce memory usage at the expense
   * of render quality. A falsey value of `null` or `0` will default to the renderer's resolution.
   * If `cacheAsBitmap` is set to `true`, this will re-render with the new resolution.
   * @member {number|null} cacheAsBitmapResolution
   * @memberof PIXI.DisplayObject#
   * @default null
   */ cacheAsBitmapResolution: {
        get () {
            return this._cacheAsBitmapResolution;
        },
        set (resolution) {
            resolution !== this._cacheAsBitmapResolution && (this._cacheAsBitmapResolution = resolution, this.cacheAsBitmap && (this.cacheAsBitmap = !1, this.cacheAsBitmap = !0));
        }
    },
    /**
   * The number of samples to use for cacheAsBitmap. If set to `null`, the renderer's
   * sample count is used.
   * If `cacheAsBitmap` is set to `true`, this will re-render with the new number of samples.
   * @member {number|null} cacheAsBitmapMultisample
   * @memberof PIXI.DisplayObject#
   * @default null
   */ cacheAsBitmapMultisample: {
        get () {
            return this._cacheAsBitmapMultisample;
        },
        set (multisample) {
            multisample !== this._cacheAsBitmapMultisample && (this._cacheAsBitmapMultisample = multisample, this.cacheAsBitmap && (this.cacheAsBitmap = !1, this.cacheAsBitmap = !0));
        }
    },
    /**
   * Set this to true if you want this display object to be cached as a bitmap.
   * This basically takes a snapshot of the display object as it is at that moment. It can
   * provide a performance benefit for complex static displayObjects.
   * To remove simply set this property to `false`
   *
   * IMPORTANT GOTCHA - Make sure that all your textures are preloaded BEFORE setting this property to true
   * as it will take a snapshot of what is currently there. If the textures have not loaded then they will not appear.
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   */ cacheAsBitmap: {
        get () {
            return this._cacheAsBitmap;
        },
        set (value) {
            if (this._cacheAsBitmap === value) return;
            this._cacheAsBitmap = value;
            let data;
            value ? (this._cacheData || (this._cacheData = new $2ac4a71b6bcc6c70$export$3e19bdfd927f283c()), data = this._cacheData, data.originalRender = this.render, data.originalRenderCanvas = this.renderCanvas, data.originalUpdateTransform = this.updateTransform, data.originalCalculateBounds = this.calculateBounds, data.originalGetLocalBounds = this.getLocalBounds, data.originalDestroy = this.destroy, data.originalContainsPoint = this.containsPoint, data.originalMask = this._mask, data.originalFilterArea = this.filterArea, this.render = this._renderCached, this.renderCanvas = this._renderCachedCanvas, this.destroy = this._cacheAsBitmapDestroy) : (data = this._cacheData, data.sprite && this._destroyCachedDisplayObject(), this.render = data.originalRender, this.renderCanvas = data.originalRenderCanvas, this.calculateBounds = data.originalCalculateBounds, this.getLocalBounds = data.originalGetLocalBounds, this.destroy = data.originalDestroy, this.updateTransform = data.originalUpdateTransform, this.containsPoint = data.originalContainsPoint, this._mask = data.originalMask, this.filterArea = data.originalFilterArea);
        }
    }
});
(0, $495c730e932693d1$export$1f679544f90d7d7c).prototype._renderCached = function(renderer) {
    !this.visible || this.worldAlpha <= 0 || !this.renderable || (this._initCachedDisplayObject(renderer), this._cacheData.sprite.transform._worldID = this.transform._worldID, this._cacheData.sprite.worldAlpha = this.worldAlpha, this._cacheData.sprite._render(renderer));
};
(0, $495c730e932693d1$export$1f679544f90d7d7c).prototype._initCachedDisplayObject = function(renderer) {
    if (this._cacheData?.sprite) return;
    const cacheAlpha = this.alpha;
    this.alpha = 1, renderer.batch.flush();
    const bounds = this.getLocalBounds(new (0, $92248a7cf1facbda$export$4617fb02663045ef)(), !0);
    if (this.filters?.length) {
        const padding = this.filters[0].padding;
        bounds.pad(padding);
    }
    const resolution = this.cacheAsBitmapResolution || renderer.resolution;
    bounds.ceil(resolution), bounds.width = Math.max(bounds.width, 1 / resolution), bounds.height = Math.max(bounds.height, 1 / resolution);
    const cachedRenderTexture = renderer.renderTexture.current, cachedSourceFrame = renderer.renderTexture.sourceFrame.clone(), cachedDestinationFrame = renderer.renderTexture.destinationFrame.clone(), cachedProjectionTransform = renderer.projection.transform, renderTexture = (0, $bbacc38491f82d4b$export$813984f7330b4d72).create({
        width: bounds.width,
        height: bounds.height,
        resolution: resolution,
        multisample: this.cacheAsBitmapMultisample ?? renderer.multisample
    }), textureCacheId = `cacheAsBitmap_${(0, $29e19754806f3a05$exports).uid()}`;
    this._cacheData.textureCacheId = textureCacheId, (0, $997b0e421c4045eb$export$d6306e508f184154).addToCache(renderTexture.baseTexture, textureCacheId), (0, $ad1fffd072a707c2$export$5431306cf43de24a).addToCache(renderTexture, textureCacheId);
    const m = this.transform.localTransform.copyTo($2ac4a71b6bcc6c70$var$_tempMatrix).invert().translate(-bounds.x, -bounds.y);
    this.render = this._cacheData.originalRender, renderer.render(this, {
        renderTexture: renderTexture,
        clear: !0,
        transform: m,
        skipUpdateTransform: !1
    }), renderer.framebuffer.blit(), renderer.projection.transform = cachedProjectionTransform, renderer.renderTexture.bind(cachedRenderTexture, cachedSourceFrame, cachedDestinationFrame), this.render = this._renderCached, this.updateTransform = this.displayObjectUpdateTransform, this.calculateBounds = this._calculateCachedBounds, this.getLocalBounds = this._getCachedLocalBounds, this._mask = null, this.filterArea = null, this.alpha = cacheAlpha;
    const cachedSprite = new (0, $f092bed24e72671b$export$3075603db8e6204c)(renderTexture);
    cachedSprite.transform.worldTransform = this.transform.worldTransform, cachedSprite.anchor.x = -(bounds.x / bounds.width), cachedSprite.anchor.y = -(bounds.y / bounds.height), cachedSprite.alpha = cacheAlpha, cachedSprite._bounds = this._bounds, this._cacheData.sprite = cachedSprite, this.transform._parentID = -1, this.parent ? this.updateTransform() : (this.enableTempParent(), this.updateTransform(), this.disableTempParent(null)), this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
};
(0, $495c730e932693d1$export$1f679544f90d7d7c).prototype._renderCachedCanvas = function(renderer) {
    !this.visible || this.worldAlpha <= 0 || !this.renderable || (this._initCachedDisplayObjectCanvas(renderer), this._cacheData.sprite.worldAlpha = this.worldAlpha, this._cacheData.sprite._renderCanvas(renderer));
};
(0, $495c730e932693d1$export$1f679544f90d7d7c).prototype._initCachedDisplayObjectCanvas = function(renderer) {
    if (this._cacheData?.sprite) return;
    const bounds = this.getLocalBounds(new (0, $92248a7cf1facbda$export$4617fb02663045ef)(), !0), cacheAlpha = this.alpha;
    this.alpha = 1;
    const cachedRenderTarget = renderer.canvasContext.activeContext, cachedProjectionTransform = renderer._projTransform, resolution = this.cacheAsBitmapResolution || renderer.resolution;
    bounds.ceil(resolution), bounds.width = Math.max(bounds.width, 1 / resolution), bounds.height = Math.max(bounds.height, 1 / resolution);
    const renderTexture = (0, $bbacc38491f82d4b$export$813984f7330b4d72).create({
        width: bounds.width,
        height: bounds.height,
        resolution: resolution
    }), textureCacheId = `cacheAsBitmap_${(0, $29e19754806f3a05$exports).uid()}`;
    this._cacheData.textureCacheId = textureCacheId, (0, $997b0e421c4045eb$export$d6306e508f184154).addToCache(renderTexture.baseTexture, textureCacheId), (0, $ad1fffd072a707c2$export$5431306cf43de24a).addToCache(renderTexture, textureCacheId);
    const m = $2ac4a71b6bcc6c70$var$_tempMatrix;
    this.transform.localTransform.copyTo(m), m.invert(), m.tx -= bounds.x, m.ty -= bounds.y, this.renderCanvas = this._cacheData.originalRenderCanvas, renderer.render(this, {
        renderTexture: renderTexture,
        clear: !0,
        transform: m,
        skipUpdateTransform: !1
    }), renderer.canvasContext.activeContext = cachedRenderTarget, renderer._projTransform = cachedProjectionTransform, this.renderCanvas = this._renderCachedCanvas, this.updateTransform = this.displayObjectUpdateTransform, this.calculateBounds = this._calculateCachedBounds, this.getLocalBounds = this._getCachedLocalBounds, this._mask = null, this.filterArea = null, this.alpha = cacheAlpha;
    const cachedSprite = new (0, $f092bed24e72671b$export$3075603db8e6204c)(renderTexture);
    cachedSprite.transform.worldTransform = this.transform.worldTransform, cachedSprite.anchor.x = -(bounds.x / bounds.width), cachedSprite.anchor.y = -(bounds.y / bounds.height), cachedSprite.alpha = cacheAlpha, cachedSprite._bounds = this._bounds, this._cacheData.sprite = cachedSprite, this.transform._parentID = -1, this.parent ? this.updateTransform() : (this.parent = renderer._tempDisplayObjectParent, this.updateTransform(), this.parent = null), this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
};
(0, $495c730e932693d1$export$1f679544f90d7d7c).prototype._calculateCachedBounds = function() {
    this._bounds.clear(), this._cacheData.sprite.transform._worldID = this.transform._worldID, this._cacheData.sprite._calculateBounds(), this._bounds.updateID = this._boundsID;
};
(0, $495c730e932693d1$export$1f679544f90d7d7c).prototype._getCachedLocalBounds = function() {
    return this._cacheData.sprite.getLocalBounds(null);
};
(0, $495c730e932693d1$export$1f679544f90d7d7c).prototype._destroyCachedDisplayObject = function() {
    this._cacheData.sprite._texture.destroy(!0), this._cacheData.sprite = null, (0, $997b0e421c4045eb$export$d6306e508f184154).removeFromCache(this._cacheData.textureCacheId), (0, $ad1fffd072a707c2$export$5431306cf43de24a).removeFromCache(this._cacheData.textureCacheId), this._cacheData.textureCacheId = null;
};
(0, $495c730e932693d1$export$1f679544f90d7d7c).prototype._cacheAsBitmapDestroy = function(options) {
    this.cacheAsBitmap = !1, this.destroy(options);
};



(0, $495c730e932693d1$export$1f679544f90d7d7c).prototype.name = null;
(0, $3878067a77b781d9$export$42a852a2b6b56249).prototype.getChildByName = function(name, deep) {
    for(let i = 0, j = this.children.length; i < j; i++)if (this.children[i].name === name) return this.children[i];
    if (deep) for(let i = 0, j = this.children.length; i < j; i++){
        const child = this.children[i];
        if (!child.getChildByName) continue;
        const target = child.getChildByName(name, !0);
        if (target) return target;
    }
    return null;
};




(0, $495c730e932693d1$export$1f679544f90d7d7c).prototype.getGlobalPosition = function(point = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(), skipUpdate = !1) {
    return this.parent ? this.parent.toGlobal(this.position, point, skipUpdate) : (point.x = this.position.x, point.y = this.position.y), point;
};




var $9df161eab6370473$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform float uAlpha;

void main(void)
{
   gl_FragColor = texture2D(uSampler, vTextureCoord) * uAlpha;
}
`;


class $62a43d40c27314f7$export$adbaa0de008b0d7a extends (0, $344aa8e787d8e10a$export$ec91da630f36d5ea) {
    /**
   * @param alpha - Amount of alpha from 0 to 1, where 0 is transparent
   */ constructor(alpha = 1){
        super((0, $f21ee941aa65a4c7$export$4a1a95006fc6b0f1), (0, $9df161eab6370473$export$2e2bcd8739ae039), {
            uAlpha: 1
        }), this.alpha = alpha;
    }
    /**
   * Coefficient for alpha multiplication
   * @default 1
   */ get alpha() {
        return this.uniforms.uAlpha;
    }
    set alpha(value) {
        this.uniforms.uAlpha = value;
    }
}






const $5fd73e704e9ecd0a$var$GAUSSIAN_VALUES = {
    5: [
        0.153388,
        0.221461,
        0.250301
    ],
    7: [
        0.071303,
        0.131514,
        0.189879,
        0.214607
    ],
    9: [
        0.028532,
        0.067234,
        0.124009,
        0.179044,
        0.20236
    ],
    11: [
        93e-4,
        0.028002,
        0.065984,
        0.121703,
        0.175713,
        0.198596
    ],
    13: [
        2406e-6,
        9255e-6,
        0.027867,
        0.065666,
        0.121117,
        0.174868,
        0.197641
    ],
    15: [
        489e-6,
        2403e-6,
        9246e-6,
        0.02784,
        0.065602,
        0.120999,
        0.174697,
        0.197448
    ]
}, $5fd73e704e9ecd0a$var$fragTemplate = [
    "varying vec2 vBlurTexCoords[%size%];",
    "uniform sampler2D uSampler;",
    "void main(void)",
    "{",
    "    gl_FragColor = vec4(0.0);",
    "    %blur%",
    "}"
].join(`
`);
function $5fd73e704e9ecd0a$export$1b0dcf101eb6a1c9(kernelSize) {
    const kernel = $5fd73e704e9ecd0a$var$GAUSSIAN_VALUES[kernelSize], halfLength = kernel.length;
    let fragSource = $5fd73e704e9ecd0a$var$fragTemplate, blurLoop = "";
    const template = "gl_FragColor += texture2D(uSampler, vBlurTexCoords[%index%]) * %value%;";
    let value;
    for(let i = 0; i < kernelSize; i++){
        let blur = template.replace("%index%", i.toString());
        value = i, i >= halfLength && (value = kernelSize - i - 1), blur = blur.replace("%value%", kernel[value].toString()), blurLoop += blur, blurLoop += `
`;
    }
    return fragSource = fragSource.replace("%blur%", blurLoop), fragSource = fragSource.replace("%size%", kernelSize.toString()), fragSource;
}


const $3cd5210c656753fd$var$vertTemplate = `
    attribute vec2 aVertexPosition;

    uniform mat3 projectionMatrix;

    uniform float strength;

    varying vec2 vBlurTexCoords[%size%];

    uniform vec4 inputSize;
    uniform vec4 outputFrame;

    vec4 filterVertexPosition( void )
    {
        vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

        return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
    }

    vec2 filterTextureCoord( void )
    {
        return aVertexPosition * (outputFrame.zw * inputSize.zw);
    }

    void main(void)
    {
        gl_Position = filterVertexPosition();

        vec2 textureCoord = filterTextureCoord();
        %blur%
    }`;
function $3cd5210c656753fd$export$7a7fb9d9d09c33af(kernelSize, x) {
    const halfLength = Math.ceil(kernelSize / 2);
    let vertSource = $3cd5210c656753fd$var$vertTemplate, blurLoop = "", template;
    x ? template = "vBlurTexCoords[%index%] =  textureCoord + vec2(%sampleIndex% * strength, 0.0);" : template = "vBlurTexCoords[%index%] =  textureCoord + vec2(0.0, %sampleIndex% * strength);";
    for(let i = 0; i < kernelSize; i++){
        let blur = template.replace("%index%", i.toString());
        blur = blur.replace("%sampleIndex%", `${i - (halfLength - 1)}.0`), blurLoop += blur, blurLoop += `
`;
    }
    return vertSource = vertSource.replace("%blur%", blurLoop), vertSource = vertSource.replace("%size%", kernelSize.toString()), vertSource;
}


class $82ffcd9fe78c8b55$export$b100a8e8116621cf extends (0, $344aa8e787d8e10a$export$ec91da630f36d5ea) {
    /**
   * @param horizontal - Do pass along the x-axis (`true`) or y-axis (`false`).
   * @param strength - The strength of the blur filter.
   * @param quality - The quality of the blur filter.
   * @param {number|null} [resolution=PIXI.Filter.defaultResolution] - The resolution of the blur filter.
   * @param kernelSize - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
   */ constructor(horizontal, strength = 8, quality = 4, resolution = (0, $344aa8e787d8e10a$export$ec91da630f36d5ea).defaultResolution, kernelSize = 5){
        const vertSrc = (0, $3cd5210c656753fd$export$7a7fb9d9d09c33af)(kernelSize, horizontal), fragSrc = (0, $5fd73e704e9ecd0a$export$1b0dcf101eb6a1c9)(kernelSize);
        super(// vertex shader
        vertSrc, // fragment shader
        fragSrc), this.horizontal = horizontal, this.resolution = resolution, this._quality = 0, this.quality = quality, this.blur = strength;
    }
    /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - How to clear
   */ apply(filterManager, input, output, clearMode) {
        if (output ? this.horizontal ? this.uniforms.strength = 1 / output.width * (output.width / input.width) : this.uniforms.strength = 1 / output.height * (output.height / input.height) : this.horizontal ? this.uniforms.strength = 1 / filterManager.renderer.width * (filterManager.renderer.width / input.width) : this.uniforms.strength = 1 / filterManager.renderer.height * (filterManager.renderer.height / input.height), this.uniforms.strength *= this.strength, this.uniforms.strength /= this.passes, this.passes === 1) filterManager.applyFilter(this, input, output, clearMode);
        else {
            const renderTarget = filterManager.getFilterTexture(), renderer = filterManager.renderer;
            let flip = input, flop = renderTarget;
            this.state.blend = !1, filterManager.applyFilter(this, flip, flop, (0, $5912637ee8cf8b9f$export$784901839554cbc3).CLEAR);
            for(let i = 1; i < this.passes - 1; i++){
                filterManager.bindAndClear(flip, (0, $5912637ee8cf8b9f$export$784901839554cbc3).BLIT), this.uniforms.uSampler = flop;
                const temp = flop;
                flop = flip, flip = temp, renderer.shader.bind(this), renderer.geometry.draw(5);
            }
            this.state.blend = !0, filterManager.applyFilter(this, flop, output, clearMode), filterManager.returnFilterTexture(renderTarget);
        }
    }
    /**
   * Sets the strength of both the blur.
   * @default 16
   */ get blur() {
        return this.strength;
    }
    set blur(value) {
        this.padding = 1 + Math.abs(value) * 2, this.strength = value;
    }
    /**
   * Sets the quality of the blur by modifying the number of passes. More passes means higher
   * quality bluring but the lower the performance.
   * @default 4
   */ get quality() {
        return this._quality;
    }
    set quality(value) {
        this._quality = value, this.passes = value;
    }
}


class $acbfb52240310598$export$424348d09d827f49 extends (0, $344aa8e787d8e10a$export$ec91da630f36d5ea) {
    /**
   * @param strength - The strength of the blur filter.
   * @param quality - The quality of the blur filter.
   * @param {number|null} [resolution=PIXI.Filter.defaultResolution] - The resolution of the blur filter.
   * @param kernelSize - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
   */ constructor(strength = 8, quality = 4, resolution = (0, $344aa8e787d8e10a$export$ec91da630f36d5ea).defaultResolution, kernelSize = 5){
        super(), this._repeatEdgePixels = !1, this.blurXFilter = new (0, $82ffcd9fe78c8b55$export$b100a8e8116621cf)(!0, strength, quality, resolution, kernelSize), this.blurYFilter = new (0, $82ffcd9fe78c8b55$export$b100a8e8116621cf)(!1, strength, quality, resolution, kernelSize), this.resolution = resolution, this.quality = quality, this.blur = strength, this.repeatEdgePixels = !1;
    }
    /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - How to clear
   */ apply(filterManager, input, output, clearMode) {
        const xStrength = Math.abs(this.blurXFilter.strength), yStrength = Math.abs(this.blurYFilter.strength);
        if (xStrength && yStrength) {
            const renderTarget = filterManager.getFilterTexture();
            this.blurXFilter.apply(filterManager, input, renderTarget, (0, $5912637ee8cf8b9f$export$784901839554cbc3).CLEAR), this.blurYFilter.apply(filterManager, renderTarget, output, clearMode), filterManager.returnFilterTexture(renderTarget);
        } else yStrength ? this.blurYFilter.apply(filterManager, input, output, clearMode) : this.blurXFilter.apply(filterManager, input, output, clearMode);
    }
    updatePadding() {
        this._repeatEdgePixels ? this.padding = 0 : this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
    }
    /**
   * Sets the strength of both the blurX and blurY properties simultaneously
   * @default 2
   */ get blur() {
        return this.blurXFilter.blur;
    }
    set blur(value) {
        this.blurXFilter.blur = this.blurYFilter.blur = value, this.updatePadding();
    }
    /**
   * Sets the number of passes for blur. More passes means higher quality bluring.
   * @default 1
   */ get quality() {
        return this.blurXFilter.quality;
    }
    set quality(value) {
        this.blurXFilter.quality = this.blurYFilter.quality = value;
    }
    /**
   * Sets the strength of the blurX property
   * @default 2
   */ get blurX() {
        return this.blurXFilter.blur;
    }
    set blurX(value) {
        this.blurXFilter.blur = value, this.updatePadding();
    }
    /**
   * Sets the strength of the blurY property
   * @default 2
   */ get blurY() {
        return this.blurYFilter.blur;
    }
    set blurY(value) {
        this.blurYFilter.blur = value, this.updatePadding();
    }
    /**
   * Sets the blendmode of the filter
   * @default PIXI.BLEND_MODES.NORMAL
   */ get blendMode() {
        return this.blurYFilter.blendMode;
    }
    set blendMode(value) {
        this.blurYFilter.blendMode = value;
    }
    /**
   * If set to true the edge of the target will be clamped
   * @default false
   */ get repeatEdgePixels() {
        return this._repeatEdgePixels;
    }
    set repeatEdgePixels(value) {
        this._repeatEdgePixels = value, this.updatePadding();
    }
}






var $1e1223f98ecd43a8$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform float m[20];
uniform float uAlpha;

void main(void)
{
    vec4 c = texture2D(uSampler, vTextureCoord);

    if (uAlpha == 0.0) {
        gl_FragColor = c;
        return;
    }

    // Un-premultiply alpha before applying the color matrix. See issue #3539.
    if (c.a > 0.0) {
      c.rgb /= c.a;
    }

    vec4 result;

    result.r = (m[0] * c.r);
        result.r += (m[1] * c.g);
        result.r += (m[2] * c.b);
        result.r += (m[3] * c.a);
        result.r += m[4];

    result.g = (m[5] * c.r);
        result.g += (m[6] * c.g);
        result.g += (m[7] * c.b);
        result.g += (m[8] * c.a);
        result.g += m[9];

    result.b = (m[10] * c.r);
       result.b += (m[11] * c.g);
       result.b += (m[12] * c.b);
       result.b += (m[13] * c.a);
       result.b += m[14];

    result.a = (m[15] * c.r);
       result.a += (m[16] * c.g);
       result.a += (m[17] * c.b);
       result.a += (m[18] * c.a);
       result.a += m[19];

    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);

    // Premultiply alpha again.
    rgb *= result.a;

    gl_FragColor = vec4(rgb, result.a);
}
`;


class $b12901ca4d3f3f74$export$6547db23997fcec5 extends (0, $344aa8e787d8e10a$export$ec91da630f36d5ea) {
    constructor(){
        const uniforms = {
            m: new Float32Array([
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ]),
            uAlpha: 1
        };
        super((0, $f21ee941aa65a4c7$export$198627d10d1d088f), (0, $1e1223f98ecd43a8$export$2e2bcd8739ae039), uniforms), this.alpha = 1;
    }
    /**
   * Transforms current matrix and set the new one
   * @param {number[]} matrix - 5x4 matrix
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ _loadMatrix(matrix, multiply = !1) {
        let newMatrix = matrix;
        multiply && (this._multiply(newMatrix, this.uniforms.m, matrix), newMatrix = this._colorMatrix(newMatrix)), this.uniforms.m = newMatrix;
    }
    /**
   * Multiplies two mat5's
   * @private
   * @param out - 5x4 matrix the receiving matrix
   * @param a - 5x4 matrix the first operand
   * @param b - 5x4 matrix the second operand
   * @returns {number[]} 5x4 matrix
   */ _multiply(out, a, b) {
        return out[0] = a[0] * b[0] + a[1] * b[5] + a[2] * b[10] + a[3] * b[15], out[1] = a[0] * b[1] + a[1] * b[6] + a[2] * b[11] + a[3] * b[16], out[2] = a[0] * b[2] + a[1] * b[7] + a[2] * b[12] + a[3] * b[17], out[3] = a[0] * b[3] + a[1] * b[8] + a[2] * b[13] + a[3] * b[18], out[4] = a[0] * b[4] + a[1] * b[9] + a[2] * b[14] + a[3] * b[19] + a[4], out[5] = a[5] * b[0] + a[6] * b[5] + a[7] * b[10] + a[8] * b[15], out[6] = a[5] * b[1] + a[6] * b[6] + a[7] * b[11] + a[8] * b[16], out[7] = a[5] * b[2] + a[6] * b[7] + a[7] * b[12] + a[8] * b[17], out[8] = a[5] * b[3] + a[6] * b[8] + a[7] * b[13] + a[8] * b[18], out[9] = a[5] * b[4] + a[6] * b[9] + a[7] * b[14] + a[8] * b[19] + a[9], out[10] = a[10] * b[0] + a[11] * b[5] + a[12] * b[10] + a[13] * b[15], out[11] = a[10] * b[1] + a[11] * b[6] + a[12] * b[11] + a[13] * b[16], out[12] = a[10] * b[2] + a[11] * b[7] + a[12] * b[12] + a[13] * b[17], out[13] = a[10] * b[3] + a[11] * b[8] + a[12] * b[13] + a[13] * b[18], out[14] = a[10] * b[4] + a[11] * b[9] + a[12] * b[14] + a[13] * b[19] + a[14], out[15] = a[15] * b[0] + a[16] * b[5] + a[17] * b[10] + a[18] * b[15], out[16] = a[15] * b[1] + a[16] * b[6] + a[17] * b[11] + a[18] * b[16], out[17] = a[15] * b[2] + a[16] * b[7] + a[17] * b[12] + a[18] * b[17], out[18] = a[15] * b[3] + a[16] * b[8] + a[17] * b[13] + a[18] * b[18], out[19] = a[15] * b[4] + a[16] * b[9] + a[17] * b[14] + a[18] * b[19] + a[19], out;
    }
    /**
   * Create a Float32 Array and normalize the offset component to 0-1
   * @param {number[]} matrix - 5x4 matrix
   * @returns {number[]} 5x4 matrix with all values between 0-1
   */ _colorMatrix(matrix) {
        const m = new Float32Array(matrix);
        return m[4] /= 255, m[9] /= 255, m[14] /= 255, m[19] /= 255, m;
    }
    /**
   * Adjusts brightness
   * @param b - value of the brigthness (0-1, where 0 is black)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ brightness(b, multiply) {
        const matrix = [
            b,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Sets each channel on the diagonal of the color matrix.
   * This can be used to achieve a tinting effect on Containers similar to the tint field of some
   * display objects like Sprite, Text, Graphics, and Mesh.
   * @param color - Color of the tint. This is a hex value.
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ tint(color, multiply) {
        const [r, g, b] = (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(color).toArray(), matrix = [
            r,
            0,
            0,
            0,
            0,
            0,
            g,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Set the matrices in grey scales
   * @param scale - value of the grey (0-1, where 0 is black)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ greyscale(scale, multiply) {
        const matrix = [
            scale,
            scale,
            scale,
            0,
            0,
            scale,
            scale,
            scale,
            0,
            0,
            scale,
            scale,
            scale,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Set the black and white matrice.
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ blackAndWhite(multiply) {
        const matrix = [
            0.3,
            0.6,
            0.1,
            0,
            0,
            0.3,
            0.6,
            0.1,
            0,
            0,
            0.3,
            0.6,
            0.1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Set the hue property of the color
   * @param rotation - in degrees
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ hue(rotation, multiply) {
        rotation = (rotation || 0) / 180 * Math.PI;
        const cosR = Math.cos(rotation), sinR = Math.sin(rotation), sqrt = Math.sqrt, w = 1 / 3, sqrW = sqrt(w), a00 = cosR + (1 - cosR) * w, a01 = w * (1 - cosR) - sqrW * sinR, a02 = w * (1 - cosR) + sqrW * sinR, a10 = w * (1 - cosR) + sqrW * sinR, a11 = cosR + w * (1 - cosR), a12 = w * (1 - cosR) - sqrW * sinR, a20 = w * (1 - cosR) - sqrW * sinR, a21 = w * (1 - cosR) + sqrW * sinR, a22 = cosR + w * (1 - cosR), matrix = [
            a00,
            a01,
            a02,
            0,
            0,
            a10,
            a11,
            a12,
            0,
            0,
            a20,
            a21,
            a22,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Set the contrast matrix, increase the separation between dark and bright
   * Increase contrast : shadows darker and highlights brighter
   * Decrease contrast : bring the shadows up and the highlights down
   * @param amount - value of the contrast (0-1)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ contrast(amount, multiply) {
        const v = (amount || 0) + 1, o = -0.5 * (v - 1), matrix = [
            v,
            0,
            0,
            0,
            o,
            0,
            v,
            0,
            0,
            o,
            0,
            0,
            v,
            0,
            o,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Set the saturation matrix, increase the separation between colors
   * Increase saturation : increase contrast, brightness, and sharpness
   * @param amount - The saturation amount (0-1)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ saturate(amount = 0, multiply) {
        const x = amount * 2 / 3 + 1, y = (x - 1) * -0.5, matrix = [
            x,
            y,
            y,
            0,
            0,
            y,
            x,
            y,
            0,
            0,
            y,
            y,
            x,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /** Desaturate image (remove color) Call the saturate function */ desaturate() {
        this.saturate(-1);
    }
    /**
   * Negative image (inverse of classic rgb matrix)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ negative(multiply) {
        const matrix = [
            -1,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            -1,
            1,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Sepia image
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ sepia(multiply) {
        const matrix = [
            0.393,
            0.7689999,
            0.18899999,
            0,
            0,
            0.349,
            0.6859999,
            0.16799999,
            0,
            0,
            0.272,
            0.5339999,
            0.13099999,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Color motion picture process invented in 1916 (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ technicolor(multiply) {
        const matrix = [
            1.9125277891456083,
            -0.8545344976951645,
            -0.09155508482755585,
            0,
            11.793603434377337,
            -0.3087833385928097,
            1.7658908555458428,
            -0.10601743074722245,
            0,
            -70.35205161461398,
            -0.231103377548616,
            -0.7501899197440212,
            1.847597816108189,
            0,
            30.950940869491138,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Polaroid filter
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ polaroid(multiply) {
        const matrix = [
            1.438,
            -0.062,
            -0.062,
            0,
            0,
            -0.122,
            1.378,
            -0.122,
            0,
            0,
            -0.016,
            -0.016,
            1.483,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Filter who transforms : Red -> Blue and Blue -> Red
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ toBGR(multiply) {
        const matrix = [
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Color reversal film introduced by Eastman Kodak in 1935. (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ kodachrome(multiply) {
        const matrix = [
            1.1285582396593525,
            -0.3967382283601348,
            -0.03992559172921793,
            0,
            63.72958762196502,
            -0.16404339962244616,
            1.0835251566291304,
            -0.05498805115633132,
            0,
            24.732407896706203,
            -0.16786010706155763,
            -0.5603416277695248,
            1.6014850761964943,
            0,
            35.62982807460946,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Brown delicious browni filter (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ browni(multiply) {
        const matrix = [
            0.5997023498159715,
            0.34553243048391263,
            -0.2708298674538042,
            0,
            47.43192855600873,
            -0.037703249837783157,
            0.8609577587992641,
            0.15059552388459913,
            0,
            -36.96841498319127,
            0.24113635128153335,
            -0.07441037908422492,
            0.44972182064877153,
            0,
            -7.562075277591283,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Vintage filter (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ vintage(multiply) {
        const matrix = [
            0.6279345635605994,
            0.3202183420819367,
            -0.03965408211312453,
            0,
            9.651285835294123,
            0.02578397704808868,
            0.6441188644374771,
            0.03259127616149294,
            0,
            7.462829176470591,
            0.0466055556782719,
            -0.0851232987247891,
            0.5241648018700465,
            0,
            5.159190588235296,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * We don't know exactly what it does, kind of gradient map, but funny to play with!
   * @param desaturation - Tone values.
   * @param toned - Tone values.
   * @param lightColor - Tone values, example: `0xFFE580`
   * @param darkColor - Tone values, example: `0xFFE580`
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ colorTone(desaturation, toned, lightColor, darkColor, multiply) {
        desaturation = desaturation || 0.2, toned = toned || 0.15, lightColor = lightColor || 16770432, darkColor = darkColor || 3375104;
        const temp = (0, $3119899e085d9ccf$export$892596cec99bc70e).shared, [lR, lG, lB] = temp.setValue(lightColor).toArray(), [dR, dG, dB] = temp.setValue(darkColor).toArray(), matrix = [
            0.3,
            0.59,
            0.11,
            0,
            0,
            lR,
            lG,
            lB,
            desaturation,
            0,
            dR,
            dG,
            dB,
            toned,
            0,
            lR - dR,
            lG - dG,
            lB - dB,
            0,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Night effect
   * @param intensity - The intensity of the night effect.
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ night(intensity, multiply) {
        intensity = intensity || 0.1;
        const matrix = [
            intensity * -2,
            -intensity,
            0,
            0,
            0,
            -intensity,
            0,
            intensity,
            0,
            0,
            0,
            intensity,
            intensity * 2,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Predator effect
   *
   * Erase the current matrix by setting a new indepent one
   * @param amount - how much the predator feels his future victim
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ predator(amount, multiply) {
        const matrix = [
            // row 1
            11.224130630493164 * amount,
            -4.794486999511719 * amount,
            -2.8746118545532227 * amount,
            0 * amount,
            0.40342438220977783 * amount,
            // row 2
            -3.6330697536468506 * amount,
            9.193157196044922 * amount,
            -2.951810836791992 * amount,
            0 * amount,
            -1.316135048866272 * amount,
            // row 3
            -3.2184197902679443 * amount,
            -4.2375030517578125 * amount,
            7.476448059082031 * amount,
            0 * amount,
            0.8044459223747253 * amount,
            // row 4
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * LSD effect
   *
   * Multiply the current matrix
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ lsd(multiply) {
        const matrix = [
            2,
            -0.4,
            0.5,
            0,
            0,
            -0.5,
            2,
            -0.4,
            0,
            0,
            -0.4,
            -0.5,
            3,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /** Erase the current matrix by setting the default one. */ reset() {
        const matrix = [
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, !1);
    }
    /**
   * The matrix of the color matrix filter
   * @member {number[]}
   * @default [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
   */ get matrix() {
        return this.uniforms.m;
    }
    set matrix(value) {
        this.uniforms.m = value;
    }
    /**
   * The opacity value to use when mixing the original and resultant colors.
   *
   * When the value is 0, the original color is used without modification.
   * When the value is 1, the result color is used.
   * When in the range (0, 1) the color is interpolated between the original and result by this amount.
   * @default 1
   */ get alpha() {
        return this.uniforms.uAlpha;
    }
    set alpha(value) {
        this.uniforms.uAlpha = value;
    }
}
$b12901ca4d3f3f74$export$6547db23997fcec5.prototype.grayscale = $b12901ca4d3f3f74$export$6547db23997fcec5.prototype.greyscale;





var $3de37206e36ea1b0$export$2e2bcd8739ae039 = `varying vec2 vFilterCoord;
varying vec2 vTextureCoord;

uniform vec2 scale;
uniform mat2 rotation;
uniform sampler2D uSampler;
uniform sampler2D mapSampler;

uniform highp vec4 inputSize;
uniform vec4 inputClamp;

void main(void)
{
  vec4 map =  texture2D(mapSampler, vFilterCoord);

  map -= 0.5;
  map.xy = scale * inputSize.zw * (rotation * map.xy);

  gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), inputClamp.xy, inputClamp.zw));
}
`;


var $46b9403ffee5ed80$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;
uniform mat3 filterMatrix;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
	gl_Position = filterVertexPosition();
	vTextureCoord = filterTextureCoord();
	vFilterCoord = ( filterMatrix * vec3( vTextureCoord, 1.0)  ).xy;
}
`;


class $58e7ed4f836a92f5$export$8ebf3229158e2895 extends (0, $344aa8e787d8e10a$export$ec91da630f36d5ea) {
    /**
   * @param {PIXI.Sprite} sprite - The sprite used for the displacement map. (make sure its added to the scene!)
   * @param scale - The scale of the displacement
   */ constructor(sprite, scale){
        const maskMatrix = new (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85)();
        sprite.renderable = !1, super((0, $46b9403ffee5ed80$export$2e2bcd8739ae039), (0, $3de37206e36ea1b0$export$2e2bcd8739ae039), {
            mapSampler: sprite._texture,
            filterMatrix: maskMatrix,
            scale: {
                x: 1,
                y: 1
            },
            rotation: new Float32Array([
                1,
                0,
                0,
                1
            ])
        }), this.maskSprite = sprite, this.maskMatrix = maskMatrix, scale == null && (scale = 20), this.scale = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(scale, scale);
    }
    /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - clearMode.
   */ apply(filterManager, input, output, clearMode) {
        this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, this.maskSprite), this.uniforms.scale.x = this.scale.x, this.uniforms.scale.y = this.scale.y;
        const wt = this.maskSprite.worldTransform, lenX = Math.sqrt(wt.a * wt.a + wt.b * wt.b), lenY = Math.sqrt(wt.c * wt.c + wt.d * wt.d);
        lenX !== 0 && lenY !== 0 && (this.uniforms.rotation[0] = wt.a / lenX, this.uniforms.rotation[1] = wt.b / lenX, this.uniforms.rotation[2] = wt.c / lenY, this.uniforms.rotation[3] = wt.d / lenY), filterManager.applyFilter(this, input, output, clearMode);
    }
    /** The texture used for the displacement map. Must be power of 2 sized texture. */ get map() {
        return this.uniforms.mapSampler;
    }
    set map(value) {
        this.uniforms.mapSampler = value;
    }
}





var $e01883c4cf4cc23c$export$2e2bcd8739ae039 = `varying vec2 v_rgbNW;
varying vec2 v_rgbNE;
varying vec2 v_rgbSW;
varying vec2 v_rgbSE;
varying vec2 v_rgbM;

varying vec2 vFragCoord;
uniform sampler2D uSampler;
uniform highp vec4 inputSize;


/**
 Basic FXAA implementation based on the code on geeks3d.com with the
 modification that the texture2DLod stuff was removed since it's
 unsupported by WebGL.

 --

 From:
 https://github.com/mitsuhiko/webgl-meincraft

 Copyright (c) 2011 by Armin Ronacher.

 Some rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are
 met:

 * Redistributions of source code must retain the above copyright
 notice, this list of conditions and the following disclaimer.

 * Redistributions in binary form must reproduce the above
 copyright notice, this list of conditions and the following
 disclaimer in the documentation and/or other materials provided
 with the distribution.

 * The names of the contributors may not be used to endorse or
 promote products derived from this software without specific
 prior written permission.

 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

#ifndef FXAA_REDUCE_MIN
#define FXAA_REDUCE_MIN   (1.0/ 128.0)
#endif
#ifndef FXAA_REDUCE_MUL
#define FXAA_REDUCE_MUL   (1.0 / 8.0)
#endif
#ifndef FXAA_SPAN_MAX
#define FXAA_SPAN_MAX     8.0
#endif

//optimized version for mobile, where dependent
//texture reads can be a bottleneck
vec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 inverseVP,
          vec2 v_rgbNW, vec2 v_rgbNE,
          vec2 v_rgbSW, vec2 v_rgbSE,
          vec2 v_rgbM) {
    vec4 color;
    vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;
    vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;
    vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;
    vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;
    vec4 texColor = texture2D(tex, v_rgbM);
    vec3 rgbM  = texColor.xyz;
    vec3 luma = vec3(0.299, 0.587, 0.114);
    float lumaNW = dot(rgbNW, luma);
    float lumaNE = dot(rgbNE, luma);
    float lumaSW = dot(rgbSW, luma);
    float lumaSE = dot(rgbSE, luma);
    float lumaM  = dot(rgbM,  luma);
    float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));
    float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));

    mediump vec2 dir;
    dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));
    dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));

    float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *
                          (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);

    float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);
    dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),
              max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),
                  dir * rcpDirMin)) * inverseVP;

    vec3 rgbA = 0.5 * (
                       texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)).xyz +
                       texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)).xyz);
    vec3 rgbB = rgbA * 0.5 + 0.25 * (
                                     texture2D(tex, fragCoord * inverseVP + dir * -0.5).xyz +
                                     texture2D(tex, fragCoord * inverseVP + dir * 0.5).xyz);

    float lumaB = dot(rgbB, luma);
    if ((lumaB < lumaMin) || (lumaB > lumaMax))
        color = vec4(rgbA, texColor.a);
    else
        color = vec4(rgbB, texColor.a);
    return color;
}

void main() {

      vec4 color;

      color = fxaa(uSampler, vFragCoord, inputSize.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);

      gl_FragColor = color;
}
`;


var $aa6c1bce547d0712$export$2e2bcd8739ae039 = `
attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;

varying vec2 v_rgbNW;
varying vec2 v_rgbNE;
varying vec2 v_rgbSW;
varying vec2 v_rgbSE;
varying vec2 v_rgbM;

varying vec2 vFragCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

void texcoords(vec2 fragCoord, vec2 inverseVP,
               out vec2 v_rgbNW, out vec2 v_rgbNE,
               out vec2 v_rgbSW, out vec2 v_rgbSE,
               out vec2 v_rgbM) {
    v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;
    v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;
    v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;
    v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;
    v_rgbM = vec2(fragCoord * inverseVP);
}

void main(void) {

   gl_Position = filterVertexPosition();

   vFragCoord = aVertexPosition * outputFrame.zw;

   texcoords(vFragCoord, inputSize.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);
}
`;


class $a04f98b094eb3fe0$export$86086ddb5389b795 extends (0, $344aa8e787d8e10a$export$ec91da630f36d5ea) {
    constructor(){
        super((0, $aa6c1bce547d0712$export$2e2bcd8739ae039), (0, $e01883c4cf4cc23c$export$2e2bcd8739ae039));
    }
}





var $0d6ecfd90ad9798d$export$2e2bcd8739ae039 = `precision highp float;

varying vec2 vTextureCoord;
varying vec4 vColor;

uniform float uNoise;
uniform float uSeed;
uniform sampler2D uSampler;

float rand(vec2 co)
{
    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);
}

void main()
{
    vec4 color = texture2D(uSampler, vTextureCoord);
    float randomValue = rand(gl_FragCoord.xy * uSeed);
    float diff = (randomValue - 0.5) * uNoise;

    // Un-premultiply alpha before applying the color matrix. See issue #3539.
    if (color.a > 0.0) {
        color.rgb /= color.a;
    }

    color.r += diff;
    color.g += diff;
    color.b += diff;

    // Premultiply alpha again.
    color.rgb *= color.a;

    gl_FragColor = color;
}
`;


class $ffcf2999f85b501e$export$2d7a5b72233a5183 extends (0, $344aa8e787d8e10a$export$ec91da630f36d5ea) {
    /**
   * @param {number} [noise=0.5] - The noise intensity, should be a normalized value in the range [0, 1].
   * @param {number} [seed] - A random seed for the noise generation. Default is `Math.random()`.
   */ constructor(noise = 0.5, seed = Math.random()){
        super((0, $f21ee941aa65a4c7$export$198627d10d1d088f), (0, $0d6ecfd90ad9798d$export$2e2bcd8739ae039), {
            uNoise: 0,
            uSeed: 0
        }), this.noise = noise, this.seed = seed;
    }
    /**
   * The amount of noise to apply, this value should be in the range (0, 1].
   * @default 0.5
   */ get noise() {
        return this.uniforms.uNoise;
    }
    set noise(value) {
        this.uniforms.uNoise = value;
    }
    /** A seed value to apply to the random noise generation. `Math.random()` is a good value to use. */ get seed() {
        return this.uniforms.uSeed;
    }
    set seed(value) {
        this.uniforms.uSeed = value;
    }
}




const $d02ca78f2b1dedab$export$82462a21aead86ed = {
    AlphaFilter: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.AlphaFilter
   */ $62a43d40c27314f7$export$adbaa0de008b0d7a,
    BlurFilter: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.BlurFilter
   */ $acbfb52240310598$export$424348d09d827f49,
    BlurFilterPass: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.BlurFilterPass
   */ $82ffcd9fe78c8b55$export$b100a8e8116621cf,
    ColorMatrixFilter: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.ColorMatrixFilter
   */ $b12901ca4d3f3f74$export$6547db23997fcec5,
    DisplacementFilter: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.DisplacementFilter
   */ $58e7ed4f836a92f5$export$8ebf3229158e2895,
    FXAAFilter: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.FXAAFilter
   */ $a04f98b094eb3fe0$export$86086ddb5389b795,
    NoiseFilter: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.NoiseFilter
   */ $ffcf2999f85b501e$export$2d7a5b72233a5183
};
Object.entries($d02ca78f2b1dedab$export$82462a21aead86ed).forEach(([key, FilterClass])=>{
    Object.defineProperty($d02ca78f2b1dedab$export$82462a21aead86ed, key, {
        get () {
            return (0, $29e19754806f3a05$exports).deprecation("7.1.0", `filters.${key} has moved to ${key}`), FilterClass;
        }
    });
});






class $bf2f5db7b3ae66d6$var$EventsTickerClass {
    constructor(){
        this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this.tickerAdded = !1, this._pauseUpdate = !0;
    }
    /**
   * Initializes the event ticker.
   * @param events - The event system.
   */ init(events) {
        this.removeTickerListener(), this.events = events, this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this.tickerAdded = !1, this._pauseUpdate = !0;
    }
    /** Whether to pause the update checks or not. */ get pauseUpdate() {
        return this._pauseUpdate;
    }
    set pauseUpdate(paused) {
        this._pauseUpdate = paused;
    }
    /** Adds the ticker listener. */ addTickerListener() {
        this.tickerAdded || !this.domElement || ((0, $f044fd65ebec6baf$export$39c54bcc89dcee11).system.add(this.tickerUpdate, this, (0, $4cc823daa6dd1896$export$688aaf132ba9b379).INTERACTION), this.tickerAdded = !0);
    }
    /** Removes the ticker listener. */ removeTickerListener() {
        this.tickerAdded && ((0, $f044fd65ebec6baf$export$39c54bcc89dcee11).system.remove(this.tickerUpdate, this), this.tickerAdded = !1);
    }
    /** Sets flag to not fire extra events when the user has already moved there mouse */ pointerMoved() {
        this._didMove = !0;
    }
    /** Updates the state of interactive objects. */ update() {
        if (!this.domElement || this._pauseUpdate) return;
        if (this._didMove) {
            this._didMove = !1;
            return;
        }
        const rootPointerEvent = this.events.rootPointerEvent;
        this.events.supportsTouchEvents && rootPointerEvent.pointerType === "touch" || globalThis.document.dispatchEvent(new PointerEvent("pointermove", {
            clientX: rootPointerEvent.clientX,
            clientY: rootPointerEvent.clientY
        }));
    }
    /**
   * Updates the state of interactive objects if at least {@link interactionFrequency}
   * milliseconds have passed since the last invocation.
   *
   * Invoked by a throttled ticker update from {@link PIXI.Ticker.system}.
   * @param deltaTime - time delta since the last call
   */ tickerUpdate(deltaTime) {
        this._deltaTime += deltaTime, !(this._deltaTime < this.interactionFrequency) && (this._deltaTime = 0, this.update());
    }
}
const $bf2f5db7b3ae66d6$export$57a493ed609e53ea = new $bf2f5db7b3ae66d6$var$EventsTickerClass();




class $25100a59ab004189$export$5d10db92bb959d8a {
    /**
   * @param manager - The event boundary which manages this event. Propagation can only occur
   *  within the boundary's jurisdiction.
   */ constructor(manager){
        this.bubbles = !0, this.cancelBubble = !0, this.cancelable = !1, this.composed = !1, this.defaultPrevented = !1, this.eventPhase = $25100a59ab004189$export$5d10db92bb959d8a.prototype.NONE, this.propagationStopped = !1, this.propagationImmediatelyStopped = !1, this.layer = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(), this.page = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(), this.NONE = 0, this.CAPTURING_PHASE = 1, this.AT_TARGET = 2, this.BUBBLING_PHASE = 3, this.manager = manager;
    }
    /** @readonly */ get layerX() {
        return this.layer.x;
    }
    /** @readonly */ get layerY() {
        return this.layer.y;
    }
    /** @readonly */ get pageX() {
        return this.page.x;
    }
    /** @readonly */ get pageY() {
        return this.page.y;
    }
    /**
   * Fallback for the deprecated @code{PIXI.InteractionEvent.data}.
   * @deprecated since 7.0.0
   */ get data() {
        return this;
    }
    /** The propagation path for this event. Alias for {@link PIXI.EventBoundary.propagationPath}. */ composedPath() {
        return this.manager && (!this.path || this.path[this.path.length - 1] !== this.target) && (this.path = this.target ? this.manager.propagationPath(this.target) : []), this.path;
    }
    /**
   * Unimplemented method included for implementing the DOM interface {@code Event}. It will throw an {@code Error}.
   * @deprecated
   * @param _type
   * @param _bubbles
   * @param _cancelable
   */ initEvent(_type, _bubbles, _cancelable) {
        throw new Error("initEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
    }
    /**
   * Unimplemented method included for implementing the DOM interface {@code UIEvent}. It will throw an {@code Error}.
   * @deprecated
   * @param _typeArg
   * @param _bubblesArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   */ initUIEvent(_typeArg, _bubblesArg, _cancelableArg, _viewArg, _detailArg) {
        throw new Error("initUIEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
    }
    /** Prevent default behavior of PixiJS and the user agent. */ preventDefault() {
        this.nativeEvent instanceof Event && this.nativeEvent.cancelable && this.nativeEvent.preventDefault(), this.defaultPrevented = !0;
    }
    /**
   * Stop this event from propagating to any addition listeners, including on the
   * {@link PIXI.FederatedEventTarget.currentTarget currentTarget} and also the following
   * event targets on the propagation path.
   */ stopImmediatePropagation() {
        this.propagationImmediatelyStopped = !0;
    }
    /**
   * Stop this event from propagating to the next {@link PIXI.FederatedEventTarget}. The rest of the listeners
   * on the {@link PIXI.FederatedEventTarget.currentTarget currentTarget} will still be notified.
   */ stopPropagation() {
        this.propagationStopped = !0;
    }
}


class $d540efb1b674497f$export$aeb79caab92d155a extends (0, $25100a59ab004189$export$5d10db92bb959d8a) {
    constructor(){
        super(...arguments), this.client = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(), this.movement = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(), this.offset = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(), this.global = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(), this.screen = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)();
    }
    /** @readonly */ get clientX() {
        return this.client.x;
    }
    /** @readonly */ get clientY() {
        return this.client.y;
    }
    /**
   * Alias for {@link PIXI.FederatedMouseEvent.clientX this.clientX}.
   * @readonly
   */ get x() {
        return this.clientX;
    }
    /**
   * Alias for {@link PIXI.FederatedMouseEvent.clientY this.clientY}.
   * @readonly
   */ get y() {
        return this.clientY;
    }
    /** @readonly */ get movementX() {
        return this.movement.x;
    }
    /** @readonly */ get movementY() {
        return this.movement.y;
    }
    /** @readonly */ get offsetX() {
        return this.offset.x;
    }
    /** @readonly */ get offsetY() {
        return this.offset.y;
    }
    /** @readonly */ get globalX() {
        return this.global.x;
    }
    /** @readonly */ get globalY() {
        return this.global.y;
    }
    /**
   * The pointer coordinates in the renderer's screen. Alias for {@code screen.x}.
   * @readonly
   */ get screenX() {
        return this.screen.x;
    }
    /**
   * The pointer coordinates in the renderer's screen. Alias for {@code screen.y}.
   * @readonly
   */ get screenY() {
        return this.screen.y;
    }
    /**
   * This will return the local coordinates of the specified displayObject for this InteractionData
   * @param {PIXI.DisplayObject} displayObject - The DisplayObject that you would like the local
   *  coords off
   * @param {PIXI.IPointData} point - A Point object in which to store the value, optional (otherwise
   *  will create a new point)
   * @param {PIXI.IPointData} globalPos - A Point object containing your custom global coords, optional
   *  (otherwise will use the current global coords)
   * @returns - A point containing the coordinates of the InteractionData position relative
   *  to the DisplayObject
   */ getLocalPosition(displayObject, point, globalPos) {
        return displayObject.worldTransform.applyInverse(globalPos || this.global, point);
    }
    /**
   * Whether the modifier key was pressed when this event natively occurred.
   * @param key - The modifier key.
   */ getModifierState(key) {
        return "getModifierState" in this.nativeEvent && this.nativeEvent.getModifierState(key);
    }
    /**
   * Not supported.
   * @param _typeArg
   * @param _canBubbleArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   * @param _screenXArg
   * @param _screenYArg
   * @param _clientXArg
   * @param _clientYArg
   * @param _ctrlKeyArg
   * @param _altKeyArg
   * @param _shiftKeyArg
   * @param _metaKeyArg
   * @param _buttonArg
   * @param _relatedTargetArg
   * @deprecated since 7.0.0
   */ // eslint-disable-next-line max-params
    initMouseEvent(_typeArg, _canBubbleArg, _cancelableArg, _viewArg, _detailArg, _screenXArg, _screenYArg, _clientXArg, _clientYArg, _ctrlKeyArg, _altKeyArg, _shiftKeyArg, _metaKeyArg, _buttonArg, _relatedTargetArg) {
        throw new Error("Method not implemented.");
    }
}



class $fc74eb6c62c05ba7$export$44ac16aa0ab81db6 extends (0, $d540efb1b674497f$export$aeb79caab92d155a) {
    constructor(){
        super(...arguments), this.width = 0, this.height = 0, this.isPrimary = !1;
    }
    // Only included for completeness for now
    getCoalescedEvents() {
        return this.type === "pointermove" || this.type === "mousemove" || this.type === "touchmove" ? [
            this
        ] : [];
    }
    // Only included for completeness for now
    getPredictedEvents() {
        throw new Error("getPredictedEvents is not supported!");
    }
}



class $e5c2f6fae5caee4d$export$1fd8b94eb532974d extends (0, $d540efb1b674497f$export$aeb79caab92d155a) {
    constructor(){
        super(...arguments), this.DOM_DELTA_PIXEL = 0, this.DOM_DELTA_LINE = 1, this.DOM_DELTA_PAGE = 2;
    }
}
$e5c2f6fae5caee4d$export$1fd8b94eb532974d.DOM_DELTA_PIXEL = 0, /** Units specified in lines. */ $e5c2f6fae5caee4d$export$1fd8b94eb532974d.DOM_DELTA_LINE = 1, /** Units specified in pages. */ $e5c2f6fae5caee4d$export$1fd8b94eb532974d.DOM_DELTA_PAGE = 2;


const $30a5f6c629b26b97$var$PROPAGATION_LIMIT = 2048, $30a5f6c629b26b97$var$tempHitLocation = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(), $30a5f6c629b26b97$var$tempLocalMapping = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)();
class $30a5f6c629b26b97$export$532e8c243078d2cd {
    /**
   * @param rootTarget - The holder of the event boundary.
   */ constructor(rootTarget){
        this.dispatch = new (0, $29e19754806f3a05$exports).EventEmitter(), this.moveOnAll = !1, this.enableGlobalMoveEvents = !0, this.mappingState = {
            trackingData: {}
        }, this.eventPool = /* @__PURE__ */ new Map(), this._allInteractiveElements = [], this._hitElements = [], this._isPointerMoveEvent = !1, this.rootTarget = rootTarget, this.hitPruneFn = this.hitPruneFn.bind(this), this.hitTestFn = this.hitTestFn.bind(this), this.mapPointerDown = this.mapPointerDown.bind(this), this.mapPointerMove = this.mapPointerMove.bind(this), this.mapPointerOut = this.mapPointerOut.bind(this), this.mapPointerOver = this.mapPointerOver.bind(this), this.mapPointerUp = this.mapPointerUp.bind(this), this.mapPointerUpOutside = this.mapPointerUpOutside.bind(this), this.mapWheel = this.mapWheel.bind(this), this.mappingTable = {}, this.addEventMapping("pointerdown", this.mapPointerDown), this.addEventMapping("pointermove", this.mapPointerMove), this.addEventMapping("pointerout", this.mapPointerOut), this.addEventMapping("pointerleave", this.mapPointerOut), this.addEventMapping("pointerover", this.mapPointerOver), this.addEventMapping("pointerup", this.mapPointerUp), this.addEventMapping("pointerupoutside", this.mapPointerUpOutside), this.addEventMapping("wheel", this.mapWheel);
    }
    /**
   * Adds an event mapping for the event `type` handled by `fn`.
   *
   * Event mappings can be used to implement additional or custom events. They take an event
   * coming from the upstream scene (or directly from the {@link PIXI.EventSystem}) and dispatch new downstream events
   * generally trickling down and bubbling up to {@link PIXI.EventBoundary.rootTarget this.rootTarget}.
   *
   * To modify the semantics of existing events, the built-in mapping methods of EventBoundary should be overridden
   * instead.
   * @param type - The type of upstream event to map.
   * @param fn - The mapping method. The context of this function must be bound manually, if desired.
   */ addEventMapping(type, fn) {
        this.mappingTable[type] || (this.mappingTable[type] = []), this.mappingTable[type].push({
            fn: fn,
            priority: 0
        }), this.mappingTable[type].sort((a, b)=>a.priority - b.priority);
    }
    /**
   * Dispatches the given event
   * @param e
   * @param type
   */ dispatchEvent(e, type) {
        e.propagationStopped = !1, e.propagationImmediatelyStopped = !1, this.propagate(e, type), this.dispatch.emit(type || e.type, e);
    }
    /**
   * Maps the given upstream event through the event boundary and propagates it downstream.
   * @param e
   */ mapEvent(e) {
        if (!this.rootTarget) return;
        const mappers = this.mappingTable[e.type];
        if (mappers) for(let i = 0, j = mappers.length; i < j; i++)mappers[i].fn(e);
        else console.warn(`[EventBoundary]: Event mapping not defined for ${e.type}`);
    }
    /**
   * Finds the DisplayObject that is the target of a event at the given coordinates.
   *
   * The passed (x,y) coordinates are in the world space above this event boundary.
   * @param x
   * @param y
   */ hitTest(x, y) {
        (0, $bf2f5db7b3ae66d6$export$57a493ed609e53ea).pauseUpdate = !0;
        const fn = this._isPointerMoveEvent && this.enableGlobalMoveEvents ? "hitTestMoveRecursive" : "hitTestRecursive", invertedPath = this[fn](this.rootTarget, this.rootTarget.eventMode, $30a5f6c629b26b97$var$tempHitLocation.set(x, y), this.hitTestFn, this.hitPruneFn);
        return invertedPath && invertedPath[0];
    }
    /**
   * Propagate the passed event from from {@link PIXI.EventBoundary.rootTarget this.rootTarget} to its
   * target {@code e.target}.
   * @param e - The event to propagate.
   * @param type
   */ propagate(e, type) {
        if (!e.target) return;
        const composedPath = e.composedPath();
        e.eventPhase = e.CAPTURING_PHASE;
        for(let i = 0, j = composedPath.length - 1; i < j; i++)if (e.currentTarget = composedPath[i], this.notifyTarget(e, type), e.propagationStopped || e.propagationImmediatelyStopped) return;
        if (e.eventPhase = e.AT_TARGET, e.currentTarget = e.target, this.notifyTarget(e, type), !(e.propagationStopped || e.propagationImmediatelyStopped)) {
            e.eventPhase = e.BUBBLING_PHASE;
            for(let i = composedPath.length - 2; i >= 0; i--)if (e.currentTarget = composedPath[i], this.notifyTarget(e, type), e.propagationStopped || e.propagationImmediatelyStopped) return;
        }
    }
    /**
   * Emits the event {@code e} to all interactive display objects. The event is propagated in the bubbling phase always.
   *
   * This is used in the `globalpointermove` event.
   * @param e - The emitted event.
   * @param type - The listeners to notify.
   * @param targets - The targets to notify.
   */ all(e, type, targets = this._allInteractiveElements) {
        if (targets.length === 0) return;
        e.eventPhase = e.BUBBLING_PHASE;
        const events = Array.isArray(type) ? type : [
            type
        ];
        for(let i = targets.length - 1; i >= 0; i--)events.forEach((event)=>{
            e.currentTarget = targets[i], this.notifyTarget(e, event);
        });
    }
    /**
   * Finds the propagation path from {@link PIXI.EventBoundary.rootTarget rootTarget} to the passed
   * {@code target}. The last element in the path is {@code target}.
   * @param target
   */ propagationPath(target) {
        const propagationPath = [
            target
        ];
        for(let i = 0; i < $30a5f6c629b26b97$var$PROPAGATION_LIMIT && target !== this.rootTarget; i++){
            if (!target.parent) throw new Error("Cannot find propagation path to disconnected target");
            propagationPath.push(target.parent), target = target.parent;
        }
        return propagationPath.reverse(), propagationPath;
    }
    hitTestMoveRecursive(currentTarget, eventMode, location, testFn, pruneFn, ignore = !1) {
        let shouldReturn = !1;
        if (this._interactivePrune(currentTarget)) return null;
        if ((currentTarget.eventMode === "dynamic" || eventMode === "dynamic") && ((0, $bf2f5db7b3ae66d6$export$57a493ed609e53ea).pauseUpdate = !1), currentTarget.interactiveChildren && currentTarget.children) {
            const children = currentTarget.children;
            for(let i = children.length - 1; i >= 0; i--){
                const child = children[i], nestedHit = this.hitTestMoveRecursive(child, this._isInteractive(eventMode) ? eventMode : child.eventMode, location, testFn, pruneFn, ignore || pruneFn(currentTarget, location));
                if (nestedHit) {
                    if (nestedHit.length > 0 && !nestedHit[nestedHit.length - 1].parent) continue;
                    const isInteractive = currentTarget.isInteractive();
                    (nestedHit.length > 0 || isInteractive) && (isInteractive && this._allInteractiveElements.push(currentTarget), nestedHit.push(currentTarget)), this._hitElements.length === 0 && (this._hitElements = nestedHit), shouldReturn = !0;
                }
            }
        }
        const isInteractiveMode = this._isInteractive(eventMode), isInteractiveTarget = currentTarget.isInteractive();
        return isInteractiveTarget && isInteractiveTarget && this._allInteractiveElements.push(currentTarget), ignore || this._hitElements.length > 0 ? null : shouldReturn ? this._hitElements : isInteractiveMode && !pruneFn(currentTarget, location) && testFn(currentTarget, location) ? isInteractiveTarget ? [
            currentTarget
        ] : [] : null;
    }
    /**
   * Recursive implementation for {@link PIXI.EventBoundary.hitTest hitTest}.
   * @param currentTarget - The DisplayObject that is to be hit tested.
   * @param eventMode - The event mode for the `currentTarget` or one of its parents.
   * @param location - The location that is being tested for overlap.
   * @param testFn - Callback that determines whether the target passes hit testing. This callback
   *  can assume that `pruneFn` failed to prune the display object.
   * @param pruneFn - Callback that determiness whether the target and all of its children
   *  cannot pass the hit test. It is used as a preliminary optimization to prune entire subtrees
   *  of the scene graph.
   * @returns An array holding the hit testing target and all its ancestors in order. The first element
   *  is the target itself and the last is {@link PIXI.EventBoundary.rootTarget rootTarget}. This is the opposite
   *  order w.r.t. the propagation path. If no hit testing target is found, null is returned.
   */ hitTestRecursive(currentTarget, eventMode, location, testFn, pruneFn) {
        if (this._interactivePrune(currentTarget) || pruneFn(currentTarget, location)) return null;
        if ((currentTarget.eventMode === "dynamic" || eventMode === "dynamic") && ((0, $bf2f5db7b3ae66d6$export$57a493ed609e53ea).pauseUpdate = !1), currentTarget.interactiveChildren && currentTarget.children) {
            const children = currentTarget.children;
            for(let i = children.length - 1; i >= 0; i--){
                const child = children[i], nestedHit = this.hitTestRecursive(child, this._isInteractive(eventMode) ? eventMode : child.eventMode, location, testFn, pruneFn);
                if (nestedHit) {
                    if (nestedHit.length > 0 && !nestedHit[nestedHit.length - 1].parent) continue;
                    const isInteractive = currentTarget.isInteractive();
                    return (nestedHit.length > 0 || isInteractive) && nestedHit.push(currentTarget), nestedHit;
                }
            }
        }
        const isInteractiveMode = this._isInteractive(eventMode), isInteractiveTarget = currentTarget.isInteractive();
        return isInteractiveMode && testFn(currentTarget, location) ? isInteractiveTarget ? [
            currentTarget
        ] : [] : null;
    }
    _isInteractive(int) {
        return int === "static" || int === "dynamic";
    }
    _interactivePrune(displayObject) {
        return !!(!displayObject || displayObject.isMask || !displayObject.visible || !displayObject.renderable || displayObject.eventMode === "none" || displayObject.eventMode === "passive" && !displayObject.interactiveChildren || displayObject.isMask);
    }
    /**
   * Checks whether the display object or any of its children cannot pass the hit test at all.
   *
   * {@link PIXI.EventBoundary}'s implementation uses the {@link PIXI.DisplayObject.hitArea hitArea}
   * and {@link PIXI.DisplayObject._mask} for pruning.
   * @param displayObject
   * @param location
   */ hitPruneFn(displayObject, location) {
        if (displayObject.hitArea && (displayObject.worldTransform.applyInverse(location, $30a5f6c629b26b97$var$tempLocalMapping), !displayObject.hitArea.contains($30a5f6c629b26b97$var$tempLocalMapping.x, $30a5f6c629b26b97$var$tempLocalMapping.y))) return !0;
        if (displayObject._mask) {
            const maskObject = displayObject._mask.isMaskData ? displayObject._mask.maskObject : displayObject._mask;
            if (maskObject && !maskObject.containsPoint?.(location)) return !0;
        }
        return !1;
    }
    /**
   * Checks whether the display object passes hit testing for the given location.
   * @param displayObject
   * @param location
   * @returns - Whether `displayObject` passes hit testing for `location`.
   */ hitTestFn(displayObject, location) {
        return displayObject.eventMode === "passive" ? !1 : displayObject.hitArea ? !0 : displayObject.containsPoint ? displayObject.containsPoint(location) : !1;
    }
    /**
   * Notify all the listeners to the event's `currentTarget`.
   *
   * If the `currentTarget` contains the property `on<type>`, then it is called here,
   * simulating the behavior from version 6.x and prior.
   * @param e - The event passed to the target.
   * @param type
   */ notifyTarget(e, type) {
        type = type ?? e.type;
        const handlerKey = `on${type}`;
        e.currentTarget[handlerKey]?.(e);
        const key = e.eventPhase === e.CAPTURING_PHASE || e.eventPhase === e.AT_TARGET ? `${type}capture` : type;
        this.notifyListeners(e, key), e.eventPhase === e.AT_TARGET && this.notifyListeners(e, type);
    }
    /**
   * Maps the upstream `pointerdown` events to a downstream `pointerdown` event.
   *
   * `touchstart`, `rightdown`, `mousedown` events are also dispatched for specific pointer types.
   * @param from
   */ mapPointerDown(from) {
        if (!(from instanceof (0, $fc74eb6c62c05ba7$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const e = this.createPointerEvent(from);
        if (this.dispatchEvent(e, "pointerdown"), e.pointerType === "touch") this.dispatchEvent(e, "touchstart");
        else if (e.pointerType === "mouse" || e.pointerType === "pen") {
            const isRightButton = e.button === 2;
            this.dispatchEvent(e, isRightButton ? "rightdown" : "mousedown");
        }
        const trackingData = this.trackingData(from.pointerId);
        trackingData.pressTargetsByButton[from.button] = e.composedPath(), this.freeEvent(e);
    }
    /**
   * Maps the upstream `pointermove` to downstream `pointerout`, `pointerover`, and `pointermove` events, in that order.
   *
   * The tracking data for the specific pointer has an updated `overTarget`. `mouseout`, `mouseover`,
   * `mousemove`, and `touchmove` events are fired as well for specific pointer types.
   * @param from - The upstream `pointermove` event.
   */ mapPointerMove(from) {
        if (!(from instanceof (0, $fc74eb6c62c05ba7$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        this._allInteractiveElements.length = 0, this._hitElements.length = 0, this._isPointerMoveEvent = !0;
        const e = this.createPointerEvent(from);
        this._isPointerMoveEvent = !1;
        const isMouse = e.pointerType === "mouse" || e.pointerType === "pen", trackingData = this.trackingData(from.pointerId), outTarget = this.findMountedTarget(trackingData.overTargets);
        if (trackingData.overTargets?.length > 0 && outTarget !== e.target) {
            const outType = from.type === "mousemove" ? "mouseout" : "pointerout", outEvent = this.createPointerEvent(from, outType, outTarget);
            if (this.dispatchEvent(outEvent, "pointerout"), isMouse && this.dispatchEvent(outEvent, "mouseout"), !e.composedPath().includes(outTarget)) {
                const leaveEvent = this.createPointerEvent(from, "pointerleave", outTarget);
                for(leaveEvent.eventPhase = leaveEvent.AT_TARGET; leaveEvent.target && !e.composedPath().includes(leaveEvent.target);)leaveEvent.currentTarget = leaveEvent.target, this.notifyTarget(leaveEvent), isMouse && this.notifyTarget(leaveEvent, "mouseleave"), leaveEvent.target = leaveEvent.target.parent;
                this.freeEvent(leaveEvent);
            }
            this.freeEvent(outEvent);
        }
        if (outTarget !== e.target) {
            const overType = from.type === "mousemove" ? "mouseover" : "pointerover", overEvent = this.clonePointerEvent(e, overType);
            this.dispatchEvent(overEvent, "pointerover"), isMouse && this.dispatchEvent(overEvent, "mouseover");
            let overTargetAncestor = outTarget?.parent;
            for(; overTargetAncestor && overTargetAncestor !== this.rootTarget.parent && overTargetAncestor !== e.target;)overTargetAncestor = overTargetAncestor.parent;
            if (!overTargetAncestor || overTargetAncestor === this.rootTarget.parent) {
                const enterEvent = this.clonePointerEvent(e, "pointerenter");
                for(enterEvent.eventPhase = enterEvent.AT_TARGET; enterEvent.target && enterEvent.target !== outTarget && enterEvent.target !== this.rootTarget.parent;)enterEvent.currentTarget = enterEvent.target, this.notifyTarget(enterEvent), isMouse && this.notifyTarget(enterEvent, "mouseenter"), enterEvent.target = enterEvent.target.parent;
                this.freeEvent(enterEvent);
            }
            this.freeEvent(overEvent);
        }
        const allMethods = [], allowGlobalPointerEvents = this.enableGlobalMoveEvents ?? !0;
        this.moveOnAll ? allMethods.push("pointermove") : this.dispatchEvent(e, "pointermove"), allowGlobalPointerEvents && allMethods.push("globalpointermove"), e.pointerType === "touch" && (this.moveOnAll ? allMethods.splice(1, 0, "touchmove") : this.dispatchEvent(e, "touchmove"), allowGlobalPointerEvents && allMethods.push("globaltouchmove")), isMouse && (this.moveOnAll ? allMethods.splice(1, 0, "mousemove") : this.dispatchEvent(e, "mousemove"), allowGlobalPointerEvents && allMethods.push("globalmousemove"), this.cursor = e.target?.cursor), allMethods.length > 0 && this.all(e, allMethods), this._allInteractiveElements.length = 0, this._hitElements.length = 0, trackingData.overTargets = e.composedPath(), this.freeEvent(e);
    }
    /**
   * Maps the upstream `pointerover` to downstream `pointerover` and `pointerenter` events, in that order.
   *
   * The tracking data for the specific pointer gets a new `overTarget`.
   * @param from - The upstream `pointerover` event.
   */ mapPointerOver(from) {
        if (!(from instanceof (0, $fc74eb6c62c05ba7$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const trackingData = this.trackingData(from.pointerId), e = this.createPointerEvent(from), isMouse = e.pointerType === "mouse" || e.pointerType === "pen";
        this.dispatchEvent(e, "pointerover"), isMouse && this.dispatchEvent(e, "mouseover"), e.pointerType === "mouse" && (this.cursor = e.target?.cursor);
        const enterEvent = this.clonePointerEvent(e, "pointerenter");
        for(enterEvent.eventPhase = enterEvent.AT_TARGET; enterEvent.target && enterEvent.target !== this.rootTarget.parent;)enterEvent.currentTarget = enterEvent.target, this.notifyTarget(enterEvent), isMouse && this.notifyTarget(enterEvent, "mouseenter"), enterEvent.target = enterEvent.target.parent;
        trackingData.overTargets = e.composedPath(), this.freeEvent(e), this.freeEvent(enterEvent);
    }
    /**
   * Maps the upstream `pointerout` to downstream `pointerout`, `pointerleave` events, in that order.
   *
   * The tracking data for the specific pointer is cleared of a `overTarget`.
   * @param from - The upstream `pointerout` event.
   */ mapPointerOut(from) {
        if (!(from instanceof (0, $fc74eb6c62c05ba7$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const trackingData = this.trackingData(from.pointerId);
        if (trackingData.overTargets) {
            const isMouse = from.pointerType === "mouse" || from.pointerType === "pen", outTarget = this.findMountedTarget(trackingData.overTargets), outEvent = this.createPointerEvent(from, "pointerout", outTarget);
            this.dispatchEvent(outEvent), isMouse && this.dispatchEvent(outEvent, "mouseout");
            const leaveEvent = this.createPointerEvent(from, "pointerleave", outTarget);
            for(leaveEvent.eventPhase = leaveEvent.AT_TARGET; leaveEvent.target && leaveEvent.target !== this.rootTarget.parent;)leaveEvent.currentTarget = leaveEvent.target, this.notifyTarget(leaveEvent), isMouse && this.notifyTarget(leaveEvent, "mouseleave"), leaveEvent.target = leaveEvent.target.parent;
            trackingData.overTargets = null, this.freeEvent(outEvent), this.freeEvent(leaveEvent);
        }
        this.cursor = null;
    }
    /**
   * Maps the upstream `pointerup` event to downstream `pointerup`, `pointerupoutside`,
   * and `click`/`rightclick`/`pointertap` events, in that order.
   *
   * The `pointerupoutside` event bubbles from the original `pointerdown` target to the most specific
   * ancestor of the `pointerdown` and `pointerup` targets, which is also the `click` event's target. `touchend`,
   * `rightup`, `mouseup`, `touchendoutside`, `rightupoutside`, `mouseupoutside`, and `tap` are fired as well for
   * specific pointer types.
   * @param from - The upstream `pointerup` event.
   */ mapPointerUp(from) {
        if (!(from instanceof (0, $fc74eb6c62c05ba7$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const now = performance.now(), e = this.createPointerEvent(from);
        if (this.dispatchEvent(e, "pointerup"), e.pointerType === "touch") this.dispatchEvent(e, "touchend");
        else if (e.pointerType === "mouse" || e.pointerType === "pen") {
            const isRightButton = e.button === 2;
            this.dispatchEvent(e, isRightButton ? "rightup" : "mouseup");
        }
        const trackingData = this.trackingData(from.pointerId), pressTarget = this.findMountedTarget(trackingData.pressTargetsByButton[from.button]);
        let clickTarget = pressTarget;
        if (pressTarget && !e.composedPath().includes(pressTarget)) {
            let currentTarget = pressTarget;
            for(; currentTarget && !e.composedPath().includes(currentTarget);){
                if (e.currentTarget = currentTarget, this.notifyTarget(e, "pointerupoutside"), e.pointerType === "touch") this.notifyTarget(e, "touchendoutside");
                else if (e.pointerType === "mouse" || e.pointerType === "pen") {
                    const isRightButton = e.button === 2;
                    this.notifyTarget(e, isRightButton ? "rightupoutside" : "mouseupoutside");
                }
                currentTarget = currentTarget.parent;
            }
            delete trackingData.pressTargetsByButton[from.button], clickTarget = currentTarget;
        }
        if (clickTarget) {
            const clickEvent = this.clonePointerEvent(e, "click");
            clickEvent.target = clickTarget, clickEvent.path = null, trackingData.clicksByButton[from.button] || (trackingData.clicksByButton[from.button] = {
                clickCount: 0,
                target: clickEvent.target,
                timeStamp: now
            });
            const clickHistory = trackingData.clicksByButton[from.button];
            if (clickHistory.target === clickEvent.target && now - clickHistory.timeStamp < 200 ? ++clickHistory.clickCount : clickHistory.clickCount = 1, clickHistory.target = clickEvent.target, clickHistory.timeStamp = now, clickEvent.detail = clickHistory.clickCount, clickEvent.pointerType === "mouse") {
                const isRightButton = clickEvent.button === 2;
                this.dispatchEvent(clickEvent, isRightButton ? "rightclick" : "click");
            } else clickEvent.pointerType === "touch" && this.dispatchEvent(clickEvent, "tap");
            this.dispatchEvent(clickEvent, "pointertap"), this.freeEvent(clickEvent);
        }
        this.freeEvent(e);
    }
    /**
   * Maps the upstream `pointerupoutside` event to a downstream `pointerupoutside` event, bubbling from the original
   * `pointerdown` target to `rootTarget`.
   *
   * (The most specific ancestor of the `pointerdown` event and the `pointerup` event must the
   * `{@link PIXI.EventBoundary}'s root because the `pointerup` event occurred outside of the boundary.)
   *
   * `touchendoutside`, `mouseupoutside`, and `rightupoutside` events are fired as well for specific pointer
   * types. The tracking data for the specific pointer is cleared of a `pressTarget`.
   * @param from - The upstream `pointerupoutside` event.
   */ mapPointerUpOutside(from) {
        if (!(from instanceof (0, $fc74eb6c62c05ba7$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const trackingData = this.trackingData(from.pointerId), pressTarget = this.findMountedTarget(trackingData.pressTargetsByButton[from.button]), e = this.createPointerEvent(from);
        if (pressTarget) {
            let currentTarget = pressTarget;
            for(; currentTarget;)e.currentTarget = currentTarget, this.notifyTarget(e, "pointerupoutside"), e.pointerType === "touch" ? this.notifyTarget(e, "touchendoutside") : (e.pointerType === "mouse" || e.pointerType === "pen") && this.notifyTarget(e, e.button === 2 ? "rightupoutside" : "mouseupoutside"), currentTarget = currentTarget.parent;
            delete trackingData.pressTargetsByButton[from.button];
        }
        this.freeEvent(e);
    }
    /**
   * Maps the upstream `wheel` event to a downstream `wheel` event.
   * @param from - The upstream `wheel` event.
   */ mapWheel(from) {
        if (!(from instanceof (0, $e5c2f6fae5caee4d$export$1fd8b94eb532974d))) {
            console.warn("EventBoundary cannot map a non-wheel event as a wheel event");
            return;
        }
        const wheelEvent = this.createWheelEvent(from);
        this.dispatchEvent(wheelEvent), this.freeEvent(wheelEvent);
    }
    /**
   * Finds the most specific event-target in the given propagation path that is still mounted in the scene graph.
   *
   * This is used to find the correct `pointerup` and `pointerout` target in the case that the original `pointerdown`
   * or `pointerover` target was unmounted from the scene graph.
   * @param propagationPath - The propagation path was valid in the past.
   * @returns - The most specific event-target still mounted at the same location in the scene graph.
   */ findMountedTarget(propagationPath) {
        if (!propagationPath) return null;
        let currentTarget = propagationPath[0];
        for(let i = 1; i < propagationPath.length && propagationPath[i].parent === currentTarget; i++)currentTarget = propagationPath[i];
        return currentTarget;
    }
    /**
   * Creates an event whose {@code originalEvent} is {@code from}, with an optional `type` and `target` override.
   *
   * The event is allocated using {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The {@code originalEvent} for the returned event.
   * @param [type=from.type] - The type of the returned event.
   * @param target - The target of the returned event.
   */ createPointerEvent(from, type, target) {
        const event = this.allocateEvent((0, $fc74eb6c62c05ba7$export$44ac16aa0ab81db6));
        return this.copyPointerData(from, event), this.copyMouseData(from, event), this.copyData(from, event), event.nativeEvent = from.nativeEvent, event.originalEvent = from, event.target = target ?? this.hitTest(event.global.x, event.global.y) ?? this._hitElements[0], typeof type == "string" && (event.type = type), event;
    }
    /**
   * Creates a wheel event whose {@code originalEvent} is {@code from}.
   *
   * The event is allocated using {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The upstream wheel event.
   */ createWheelEvent(from) {
        const event = this.allocateEvent((0, $e5c2f6fae5caee4d$export$1fd8b94eb532974d));
        return this.copyWheelData(from, event), this.copyMouseData(from, event), this.copyData(from, event), event.nativeEvent = from.nativeEvent, event.originalEvent = from, event.target = this.hitTest(event.global.x, event.global.y), event;
    }
    /**
   * Clones the event {@code from}, with an optional {@code type} override.
   *
   * The event is allocated using {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The event to clone.
   * @param [type=from.type] - The type of the returned event.
   */ clonePointerEvent(from, type) {
        const event = this.allocateEvent((0, $fc74eb6c62c05ba7$export$44ac16aa0ab81db6));
        return event.nativeEvent = from.nativeEvent, event.originalEvent = from.originalEvent, this.copyPointerData(from, event), this.copyMouseData(from, event), this.copyData(from, event), event.target = from.target, event.path = from.composedPath().slice(), event.type = type ?? event.type, event;
    }
    /**
   * Copies wheel {@link PIXI.FederatedWheelEvent} data from {@code from} into {@code to}.
   *
   * The following properties are copied:
   * + deltaMode
   * + deltaX
   * + deltaY
   * + deltaZ
   * @param from
   * @param to
   */ copyWheelData(from, to) {
        to.deltaMode = from.deltaMode, to.deltaX = from.deltaX, to.deltaY = from.deltaY, to.deltaZ = from.deltaZ;
    }
    /**
   * Copies pointer {@link PIXI.FederatedPointerEvent} data from {@code from} into {@code to}.
   *
   * The following properties are copied:
   * + pointerId
   * + width
   * + height
   * + isPrimary
   * + pointerType
   * + pressure
   * + tangentialPressure
   * + tiltX
   * + tiltY
   * @param from
   * @param to
   */ copyPointerData(from, to) {
        from instanceof (0, $fc74eb6c62c05ba7$export$44ac16aa0ab81db6) && to instanceof (0, $fc74eb6c62c05ba7$export$44ac16aa0ab81db6) && (to.pointerId = from.pointerId, to.width = from.width, to.height = from.height, to.isPrimary = from.isPrimary, to.pointerType = from.pointerType, to.pressure = from.pressure, to.tangentialPressure = from.tangentialPressure, to.tiltX = from.tiltX, to.tiltY = from.tiltY, to.twist = from.twist);
    }
    /**
   * Copies mouse {@link PIXI.FederatedMouseEvent} data from {@code from} to {@code to}.
   *
   * The following properties are copied:
   * + altKey
   * + button
   * + buttons
   * + clientX
   * + clientY
   * + metaKey
   * + movementX
   * + movementY
   * + pageX
   * + pageY
   * + x
   * + y
   * + screen
   * + shiftKey
   * + global
   * @param from
   * @param to
   */ copyMouseData(from, to) {
        from instanceof (0, $d540efb1b674497f$export$aeb79caab92d155a) && to instanceof (0, $d540efb1b674497f$export$aeb79caab92d155a) && (to.altKey = from.altKey, to.button = from.button, to.buttons = from.buttons, to.client.copyFrom(from.client), to.ctrlKey = from.ctrlKey, to.metaKey = from.metaKey, to.movement.copyFrom(from.movement), to.screen.copyFrom(from.screen), to.shiftKey = from.shiftKey, to.global.copyFrom(from.global));
    }
    /**
   * Copies base {@link PIXI.FederatedEvent} data from {@code from} into {@code to}.
   *
   * The following properties are copied:
   * + isTrusted
   * + srcElement
   * + timeStamp
   * + type
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */ copyData(from, to) {
        to.isTrusted = from.isTrusted, to.srcElement = from.srcElement, to.timeStamp = performance.now(), to.type = from.type, to.detail = from.detail, to.view = from.view, to.which = from.which, to.layer.copyFrom(from.layer), to.page.copyFrom(from.page);
    }
    /**
   * @param id - The pointer ID.
   * @returns The tracking data stored for the given pointer. If no data exists, a blank
   *  state will be created.
   */ trackingData(id) {
        return this.mappingState.trackingData[id] || (this.mappingState.trackingData[id] = {
            pressTargetsByButton: {},
            clicksByButton: {},
            overTarget: null
        }), this.mappingState.trackingData[id];
    }
    /**
   * Allocate a specific type of event from {@link PIXI.EventBoundary#eventPool this.eventPool}.
   *
   * This allocation is constructor-agnostic, as long as it only takes one argument - this event
   * boundary.
   * @param constructor - The event's constructor.
   */ allocateEvent(constructor) {
        this.eventPool.has(constructor) || this.eventPool.set(constructor, []);
        const event = this.eventPool.get(constructor).pop() || new constructor(this);
        return event.eventPhase = event.NONE, event.currentTarget = null, event.path = null, event.target = null, event;
    }
    /**
   * Frees the event and puts it back into the event pool.
   *
   * It is illegal to reuse the event until it is allocated again, using `this.allocateEvent`.
   *
   * It is also advised that events not allocated from {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}
   * not be freed. This is because of the possibility that the same event is freed twice, which can cause
   * it to be allocated twice & result in overwriting.
   * @param event - The event to be freed.
   * @throws Error if the event is managed by another event boundary.
   */ freeEvent(event) {
        if (event.manager !== this) throw new Error("It is illegal to free an event not managed by this EventBoundary!");
        const constructor = event.constructor;
        this.eventPool.has(constructor) || this.eventPool.set(constructor, []), this.eventPool.get(constructor).push(event);
    }
    /**
   * Similar to {@link PIXI.EventEmitter.emit}, except it stops if the `propagationImmediatelyStopped` flag
   * is set on the event.
   * @param e - The event to call each listener with.
   * @param type - The event key.
   */ notifyListeners(e, type) {
        const listeners = e.currentTarget._events[type];
        if (listeners && e.currentTarget.isInteractive()) {
            if ("fn" in listeners) listeners.once && e.currentTarget.removeListener(type, listeners.fn, void 0, !0), listeners.fn.call(listeners.context, e);
            else for(let i = 0, j = listeners.length; i < j && !e.propagationImmediatelyStopped; i++)listeners[i].once && e.currentTarget.removeListener(type, listeners[i].fn, void 0, !0), listeners[i].fn.call(listeners[i].context, e);
        }
    }
}







const $92e7fcd540bd3f4e$var$MOUSE_POINTER_ID = 1, $92e7fcd540bd3f4e$var$TOUCH_TO_POINTER = {
    touchstart: "pointerdown",
    touchend: "pointerup",
    touchendoutside: "pointerupoutside",
    touchmove: "pointermove",
    touchcancel: "pointercancel"
}, $92e7fcd540bd3f4e$var$_EventSystem = class _EventSystem2 {
    /**
   * @param {PIXI.Renderer} renderer
   */ constructor(renderer){
        this.supportsTouchEvents = "ontouchstart" in globalThis, this.supportsPointerEvents = !!globalThis.PointerEvent, this.domElement = null, this.resolution = 1, this.renderer = renderer, this.rootBoundary = new (0, $30a5f6c629b26b97$export$532e8c243078d2cd)(null), (0, $bf2f5db7b3ae66d6$export$57a493ed609e53ea).init(this), this.autoPreventDefault = !0, this.eventsAdded = !1, this.rootPointerEvent = new (0, $fc74eb6c62c05ba7$export$44ac16aa0ab81db6)(null), this.rootWheelEvent = new (0, $e5c2f6fae5caee4d$export$1fd8b94eb532974d)(null), this.cursorStyles = {
            default: "inherit",
            pointer: "pointer"
        }, this.features = new Proxy({
            ..._EventSystem2.defaultEventFeatures
        }, {
            set: (target, key, value)=>(key === "globalMove" && (this.rootBoundary.enableGlobalMoveEvents = value), target[key] = value, !0)
        }), this.onPointerDown = this.onPointerDown.bind(this), this.onPointerMove = this.onPointerMove.bind(this), this.onPointerUp = this.onPointerUp.bind(this), this.onPointerOverOut = this.onPointerOverOut.bind(this), this.onWheel = this.onWheel.bind(this);
    }
    /**
   * The default interaction mode for all display objects.
   * @see PIXI.DisplayObject.eventMode
   * @type {PIXI.EventMode}
   * @readonly
   * @since 7.2.0
   */ static get defaultEventMode() {
        return this._defaultEventMode;
    }
    /**
   * Runner init called, view is available at this point.
   * @ignore
   */ init(options) {
        const { view: view, resolution: resolution } = this.renderer;
        this.setTargetElement(view), this.resolution = resolution, _EventSystem2._defaultEventMode = options.eventMode ?? "auto", Object.assign(this.features, options.eventFeatures ?? {}), this.rootBoundary.enableGlobalMoveEvents = this.features.globalMove;
    }
    /**
   * Handle changing resolution.
   * @ignore
   */ resolutionChange(resolution) {
        this.resolution = resolution;
    }
    /** Destroys all event listeners and detaches the renderer. */ destroy() {
        this.setTargetElement(null), this.renderer = null;
    }
    /**
   * Sets the current cursor mode, handling any callbacks or CSS style changes.
   * @param mode - cursor mode, a key from the cursorStyles dictionary
   */ setCursor(mode) {
        mode = mode || "default";
        let applyStyles = !0;
        if (globalThis.OffscreenCanvas && this.domElement instanceof OffscreenCanvas && (applyStyles = !1), this.currentCursor === mode) return;
        this.currentCursor = mode;
        const style = this.cursorStyles[mode];
        if (style) switch(typeof style){
            case "string":
                applyStyles && (this.domElement.style.cursor = style);
                break;
            case "function":
                style(mode);
                break;
            case "object":
                applyStyles && Object.assign(this.domElement.style, style);
                break;
        }
        else applyStyles && typeof mode == "string" && !Object.prototype.hasOwnProperty.call(this.cursorStyles, mode) && (this.domElement.style.cursor = mode);
    }
    /**
   * The global pointer event.
   * Useful for getting the pointer position without listening to events.
   * @since 7.2.0
   */ get pointer() {
        return this.rootPointerEvent;
    }
    /**
   * Event handler for pointer down events on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */ onPointerDown(nativeEvent) {
        if (!this.features.click) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        const events = this.normalizeToPointerData(nativeEvent);
        this.autoPreventDefault && events[0].isNormalized && (nativeEvent.cancelable || !("cancelable" in nativeEvent)) && nativeEvent.preventDefault();
        for(let i = 0, j = events.length; i < j; i++){
            const nativeEvent2 = events[i], federatedEvent = this.bootstrapEvent(this.rootPointerEvent, nativeEvent2);
            this.rootBoundary.mapEvent(federatedEvent);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    /**
   * Event handler for pointer move events on on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch events.
   */ onPointerMove(nativeEvent) {
        if (!this.features.move) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, (0, $bf2f5db7b3ae66d6$export$57a493ed609e53ea).pointerMoved();
        const normalizedEvents = this.normalizeToPointerData(nativeEvent);
        for(let i = 0, j = normalizedEvents.length; i < j; i++){
            const event = this.bootstrapEvent(this.rootPointerEvent, normalizedEvents[i]);
            this.rootBoundary.mapEvent(event);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    /**
   * Event handler for pointer up events on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */ onPointerUp(nativeEvent) {
        if (!this.features.click) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        let target = nativeEvent.target;
        nativeEvent.composedPath && nativeEvent.composedPath().length > 0 && (target = nativeEvent.composedPath()[0]);
        const outside = target !== this.domElement ? "outside" : "", normalizedEvents = this.normalizeToPointerData(nativeEvent);
        for(let i = 0, j = normalizedEvents.length; i < j; i++){
            const event = this.bootstrapEvent(this.rootPointerEvent, normalizedEvents[i]);
            event.type += outside, this.rootBoundary.mapEvent(event);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    /**
   * Event handler for pointer over & out events on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */ onPointerOverOut(nativeEvent) {
        if (!this.features.click) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        const normalizedEvents = this.normalizeToPointerData(nativeEvent);
        for(let i = 0, j = normalizedEvents.length; i < j; i++){
            const event = this.bootstrapEvent(this.rootPointerEvent, normalizedEvents[i]);
            this.rootBoundary.mapEvent(event);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    /**
   * Passive handler for `wheel` events on {@link PIXI.EventSystem.domElement this.domElement}.
   * @param nativeEvent - The native wheel event.
   */ onWheel(nativeEvent) {
        if (!this.features.wheel) return;
        const wheelEvent = this.normalizeWheelEvent(nativeEvent);
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, this.rootBoundary.mapEvent(wheelEvent);
    }
    /**
   * Sets the {@link PIXI.EventSystem#domElement domElement} and binds event listeners.
   *
   * To deregister the current DOM element without setting a new one, pass {@code null}.
   * @param element - The new DOM element.
   */ setTargetElement(element) {
        this.removeEvents(), this.domElement = element, (0, $bf2f5db7b3ae66d6$export$57a493ed609e53ea).domElement = element, this.addEvents();
    }
    /** Register event listeners on {@link PIXI.Renderer#domElement this.domElement}. */ addEvents() {
        if (this.eventsAdded || !this.domElement) return;
        (0, $bf2f5db7b3ae66d6$export$57a493ed609e53ea).addTickerListener();
        const style = this.domElement.style;
        style && (globalThis.navigator.msPointerEnabled ? (style.msContentZooming = "none", style.msTouchAction = "none") : this.supportsPointerEvents && (style.touchAction = "none")), this.supportsPointerEvents ? (globalThis.document.addEventListener("pointermove", this.onPointerMove, !0), this.domElement.addEventListener("pointerdown", this.onPointerDown, !0), this.domElement.addEventListener("pointerleave", this.onPointerOverOut, !0), this.domElement.addEventListener("pointerover", this.onPointerOverOut, !0), globalThis.addEventListener("pointerup", this.onPointerUp, !0)) : (globalThis.document.addEventListener("mousemove", this.onPointerMove, !0), this.domElement.addEventListener("mousedown", this.onPointerDown, !0), this.domElement.addEventListener("mouseout", this.onPointerOverOut, !0), this.domElement.addEventListener("mouseover", this.onPointerOverOut, !0), globalThis.addEventListener("mouseup", this.onPointerUp, !0), this.supportsTouchEvents && (this.domElement.addEventListener("touchstart", this.onPointerDown, !0), this.domElement.addEventListener("touchend", this.onPointerUp, !0), this.domElement.addEventListener("touchmove", this.onPointerMove, !0))), this.domElement.addEventListener("wheel", this.onWheel, {
            passive: !0,
            capture: !0
        }), this.eventsAdded = !0;
    }
    /** Unregister event listeners on {@link PIXI.EventSystem#domElement this.domElement}. */ removeEvents() {
        if (!this.eventsAdded || !this.domElement) return;
        (0, $bf2f5db7b3ae66d6$export$57a493ed609e53ea).removeTickerListener();
        const style = this.domElement.style;
        globalThis.navigator.msPointerEnabled ? (style.msContentZooming = "", style.msTouchAction = "") : this.supportsPointerEvents && (style.touchAction = ""), this.supportsPointerEvents ? (globalThis.document.removeEventListener("pointermove", this.onPointerMove, !0), this.domElement.removeEventListener("pointerdown", this.onPointerDown, !0), this.domElement.removeEventListener("pointerleave", this.onPointerOverOut, !0), this.domElement.removeEventListener("pointerover", this.onPointerOverOut, !0), globalThis.removeEventListener("pointerup", this.onPointerUp, !0)) : (globalThis.document.removeEventListener("mousemove", this.onPointerMove, !0), this.domElement.removeEventListener("mousedown", this.onPointerDown, !0), this.domElement.removeEventListener("mouseout", this.onPointerOverOut, !0), this.domElement.removeEventListener("mouseover", this.onPointerOverOut, !0), globalThis.removeEventListener("mouseup", this.onPointerUp, !0), this.supportsTouchEvents && (this.domElement.removeEventListener("touchstart", this.onPointerDown, !0), this.domElement.removeEventListener("touchend", this.onPointerUp, !0), this.domElement.removeEventListener("touchmove", this.onPointerMove, !0))), this.domElement.removeEventListener("wheel", this.onWheel, !0), this.domElement = null, this.eventsAdded = !1;
    }
    /**
   * Maps x and y coords from a DOM object and maps them correctly to the PixiJS view. The
   * resulting value is stored in the point. This takes into account the fact that the DOM
   * element could be scaled and positioned anywhere on the screen.
   * @param  {PIXI.IPointData} point - the point that the result will be stored in
   * @param  {number} x - the x coord of the position to map
   * @param  {number} y - the y coord of the position to map
   */ mapPositionToPoint(point, x, y) {
        const rect = this.domElement.isConnected ? this.domElement.getBoundingClientRect() : {
            x: 0,
            y: 0,
            width: this.domElement.width,
            height: this.domElement.height,
            left: 0,
            top: 0
        }, resolutionMultiplier = 1 / this.resolution;
        point.x = (x - rect.left) * (this.domElement.width / rect.width) * resolutionMultiplier, point.y = (y - rect.top) * (this.domElement.height / rect.height) * resolutionMultiplier;
    }
    /**
   * Ensures that the original event object contains all data that a regular pointer event would have
   * @param event - The original event data from a touch or mouse event
   * @returns An array containing a single normalized pointer event, in the case of a pointer
   *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
   */ normalizeToPointerData(event) {
        const normalizedEvents = [];
        if (this.supportsTouchEvents && event instanceof TouchEvent) for(let i = 0, li = event.changedTouches.length; i < li; i++){
            const touch = event.changedTouches[i];
            typeof touch.button > "u" && (touch.button = 0), typeof touch.buttons > "u" && (touch.buttons = 1), typeof touch.isPrimary > "u" && (touch.isPrimary = event.touches.length === 1 && event.type === "touchstart"), typeof touch.width > "u" && (touch.width = touch.radiusX || 1), typeof touch.height > "u" && (touch.height = touch.radiusY || 1), typeof touch.tiltX > "u" && (touch.tiltX = 0), typeof touch.tiltY > "u" && (touch.tiltY = 0), typeof touch.pointerType > "u" && (touch.pointerType = "touch"), typeof touch.pointerId > "u" && (touch.pointerId = touch.identifier || 0), typeof touch.pressure > "u" && (touch.pressure = touch.force || 0.5), typeof touch.twist > "u" && (touch.twist = 0), typeof touch.tangentialPressure > "u" && (touch.tangentialPressure = 0), typeof touch.layerX > "u" && (touch.layerX = touch.offsetX = touch.clientX), typeof touch.layerY > "u" && (touch.layerY = touch.offsetY = touch.clientY), touch.isNormalized = !0, touch.type = event.type, normalizedEvents.push(touch);
        }
        else if (!globalThis.MouseEvent || event instanceof MouseEvent && (!this.supportsPointerEvents || !(event instanceof globalThis.PointerEvent))) {
            const tempEvent = event;
            typeof tempEvent.isPrimary > "u" && (tempEvent.isPrimary = !0), typeof tempEvent.width > "u" && (tempEvent.width = 1), typeof tempEvent.height > "u" && (tempEvent.height = 1), typeof tempEvent.tiltX > "u" && (tempEvent.tiltX = 0), typeof tempEvent.tiltY > "u" && (tempEvent.tiltY = 0), typeof tempEvent.pointerType > "u" && (tempEvent.pointerType = "mouse"), typeof tempEvent.pointerId > "u" && (tempEvent.pointerId = $92e7fcd540bd3f4e$var$MOUSE_POINTER_ID), typeof tempEvent.pressure > "u" && (tempEvent.pressure = 0.5), typeof tempEvent.twist > "u" && (tempEvent.twist = 0), typeof tempEvent.tangentialPressure > "u" && (tempEvent.tangentialPressure = 0), tempEvent.isNormalized = !0, normalizedEvents.push(tempEvent);
        } else normalizedEvents.push(event);
        return normalizedEvents;
    }
    /**
   * Normalizes the native {@link https://w3c.github.io/uievents/#interface-wheelevent WheelEvent}.
   *
   * The returned {@link PIXI.FederatedWheelEvent} is a shared instance. It will not persist across
   * multiple native wheel events.
   * @param nativeEvent - The native wheel event that occurred on the canvas.
   * @returns A federated wheel event.
   */ normalizeWheelEvent(nativeEvent) {
        const event = this.rootWheelEvent;
        return this.transferMouseData(event, nativeEvent), event.deltaX = nativeEvent.deltaX, event.deltaY = nativeEvent.deltaY, event.deltaZ = nativeEvent.deltaZ, event.deltaMode = nativeEvent.deltaMode, this.mapPositionToPoint(event.screen, nativeEvent.clientX, nativeEvent.clientY), event.global.copyFrom(event.screen), event.offset.copyFrom(event.screen), event.nativeEvent = nativeEvent, event.type = nativeEvent.type, event;
    }
    /**
   * Normalizes the `nativeEvent` into a federateed {@link PIXI.FederatedPointerEvent}.
   * @param event
   * @param nativeEvent
   */ bootstrapEvent(event, nativeEvent) {
        return event.originalEvent = null, event.nativeEvent = nativeEvent, event.pointerId = nativeEvent.pointerId, event.width = nativeEvent.width, event.height = nativeEvent.height, event.isPrimary = nativeEvent.isPrimary, event.pointerType = nativeEvent.pointerType, event.pressure = nativeEvent.pressure, event.tangentialPressure = nativeEvent.tangentialPressure, event.tiltX = nativeEvent.tiltX, event.tiltY = nativeEvent.tiltY, event.twist = nativeEvent.twist, this.transferMouseData(event, nativeEvent), this.mapPositionToPoint(event.screen, nativeEvent.clientX, nativeEvent.clientY), event.global.copyFrom(event.screen), event.offset.copyFrom(event.screen), event.isTrusted = nativeEvent.isTrusted, event.type === "pointerleave" && (event.type = "pointerout"), event.type.startsWith("mouse") && (event.type = event.type.replace("mouse", "pointer")), event.type.startsWith("touch") && (event.type = $92e7fcd540bd3f4e$var$TOUCH_TO_POINTER[event.type] || event.type), event;
    }
    /**
   * Transfers base & mouse event data from the {@code nativeEvent} to the federated event.
   * @param event
   * @param nativeEvent
   */ transferMouseData(event, nativeEvent) {
        event.isTrusted = nativeEvent.isTrusted, event.srcElement = nativeEvent.srcElement, event.timeStamp = performance.now(), event.type = nativeEvent.type, event.altKey = nativeEvent.altKey, event.button = nativeEvent.button, event.buttons = nativeEvent.buttons, event.client.x = nativeEvent.clientX, event.client.y = nativeEvent.clientY, event.ctrlKey = nativeEvent.ctrlKey, event.metaKey = nativeEvent.metaKey, event.movement.x = nativeEvent.movementX, event.movement.y = nativeEvent.movementY, event.page.x = nativeEvent.pageX, event.page.y = nativeEvent.pageY, event.relatedTarget = null, event.shiftKey = nativeEvent.shiftKey;
    }
};
$92e7fcd540bd3f4e$var$_EventSystem.extension = {
    name: "events",
    type: [
        (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem,
        (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).CanvasRendererSystem
    ]
}, /**
* The event features that are enabled by the EventSystem
* This option only is available when using **@pixi/events** package
* (included in the **pixi.js** and **pixi.js-legacy** bundle), otherwise it will be ignored.
* @since 7.2.0
*/ $92e7fcd540bd3f4e$var$_EventSystem.defaultEventFeatures = {
    move: !0,
    globalMove: !0,
    click: !0,
    wheel: !0
};
let $92e7fcd540bd3f4e$export$bf477d624b56bf15 = $92e7fcd540bd3f4e$var$_EventSystem;
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($92e7fcd540bd3f4e$export$bf477d624b56bf15);









function $936bb6fe4d7cea33$var$convertEventModeToInteractiveMode(mode) {
    return mode === "dynamic" || mode === "static";
}
const $936bb6fe4d7cea33$export$6a5b99a7f30af1d9 = {
    /**
   * Property-based event handler for the `click` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onclick = (event) => {
   *  //some function here that happens on click
   * }
   */ onclick: null,
    /**
   * Property-based event handler for the `mousedown` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmousedown = (event) => {
   *  //some function here that happens on mousedown
   * }
   */ onmousedown: null,
    /**
   * Property-based event handler for the `mouseenter` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseenter = (event) => {
   *  //some function here that happens on mouseenter
   * }
   */ onmouseenter: null,
    /**
   * Property-based event handler for the `mouseleave` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseleave = (event) => {
   *  //some function here that happens on mouseleave
   * }
   */ onmouseleave: null,
    /**
   * Property-based event handler for the `mousemove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmousemove = (event) => {
   *  //some function here that happens on mousemove
   * }
   */ onmousemove: null,
    /**
   * Property-based event handler for the `globalmousemove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onglobalmousemove = (event) => {
   *  //some function here that happens on globalmousemove
   * }
   */ onglobalmousemove: null,
    /**
   * Property-based event handler for the `mouseout` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseout = (event) => {
   *  //some function here that happens on mouseout
   * }
   */ onmouseout: null,
    /**
   * Property-based event handler for the `mouseover` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseover = (event) => {
   *  //some function here that happens on mouseover
   * }
   */ onmouseover: null,
    /**
   * Property-based event handler for the `mouseup` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseup = (event) => {
   *  //some function here that happens on mouseup
   * }
   */ onmouseup: null,
    /**
   * Property-based event handler for the `mouseupoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseupoutside = (event) => {
   *  //some function here that happens on mouseupoutside
   * }
   */ onmouseupoutside: null,
    /**
   * Property-based event handler for the `pointercancel` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointercancel = (event) => {
   *  //some function here that happens on pointercancel
   * }
   */ onpointercancel: null,
    /**
   * Property-based event handler for the `pointerdown` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerdown = (event) => {
   *  //some function here that happens on pointerdown
   * }
   */ onpointerdown: null,
    /**
   * Property-based event handler for the `pointerenter` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerenter = (event) => {
   *  //some function here that happens on pointerenter
   * }
   */ onpointerenter: null,
    /**
   * Property-based event handler for the `pointerleave` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerleave = (event) => {
   *  //some function here that happens on pointerleave
   * }
   */ onpointerleave: null,
    /**
   * Property-based event handler for the `pointermove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointermove = (event) => {
   *  //some function here that happens on pointermove
   * }
   */ onpointermove: null,
    /**
   * Property-based event handler for the `globalpointermove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onglobalpointermove = (event) => {
   *  //some function here that happens on globalpointermove
   * }
   */ onglobalpointermove: null,
    /**
   * Property-based event handler for the `pointerout` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerout = (event) => {
   *  //some function here that happens on pointerout
   * }
   */ onpointerout: null,
    /**
   * Property-based event handler for the `pointerover` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerover = (event) => {
   *  //some function here that happens on pointerover
   * }
   */ onpointerover: null,
    /**
   * Property-based event handler for the `pointertap` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointertap = (event) => {
   *  //some function here that happens on pointertap
   * }
   */ onpointertap: null,
    /**
   * Property-based event handler for the `pointerup` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerup = (event) => {
   *  //some function here that happens on pointerup
   * }
   */ onpointerup: null,
    /**
   * Property-based event handler for the `pointerupoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerupoutside = (event) => {
   *  //some function here that happens on pointerupoutside
   * }
   */ onpointerupoutside: null,
    /**
   * Property-based event handler for the `rightclick` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightclick = (event) => {
   *  //some function here that happens on rightclick
   * }
   */ onrightclick: null,
    /**
   * Property-based event handler for the `rightdown` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightdown = (event) => {
   *  //some function here that happens on rightdown
   * }
   */ onrightdown: null,
    /**
   * Property-based event handler for the `rightup` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightup = (event) => {
   *  //some function here that happens on rightup
   * }
   */ onrightup: null,
    /**
   * Property-based event handler for the `rightupoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightupoutside = (event) => {
   *  //some function here that happens on rightupoutside
   * }
   */ onrightupoutside: null,
    /**
   * Property-based event handler for the `tap` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontap = (event) => {
   *  //some function here that happens on tap
   * }
   */ ontap: null,
    /**
   * Property-based event handler for the `touchcancel` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchcancel = (event) => {
   *  //some function here that happens on touchcancel
   * }
   */ ontouchcancel: null,
    /**
   * Property-based event handler for the `touchend` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchend = (event) => {
   *  //some function here that happens on touchend
   * }
   */ ontouchend: null,
    /**
   * Property-based event handler for the `touchendoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchendoutside = (event) => {
   *  //some function here that happens on touchendoutside
   * }
   */ ontouchendoutside: null,
    /**
   * Property-based event handler for the `touchmove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchmove = (event) => {
   *  //some function here that happens on touchmove
   * }
   */ ontouchmove: null,
    /**
   * Property-based event handler for the `globaltouchmove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onglobaltouchmove = (event) => {
   *  //some function here that happens on globaltouchmove
   * }
   */ onglobaltouchmove: null,
    /**
   * Property-based event handler for the `touchstart` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchstart = (event) => {
   *  //some function here that happens on touchstart
   * }
   */ ontouchstart: null,
    /**
   * Property-based event handler for the `wheel` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onwheel = (event) => {
   *  //some function here that happens on wheel
   * }
   */ onwheel: null,
    /**
   * @ignore
   */ _internalInteractive: void 0,
    /**
   * Enable interaction events for the DisplayObject. Touch, pointer and mouse
   * @memberof PIXI.DisplayObject#
   */ get interactive () {
        return this._internalInteractive ?? $936bb6fe4d7cea33$var$convertEventModeToInteractiveMode((0, $92e7fcd540bd3f4e$export$bf477d624b56bf15).defaultEventMode);
    },
    set interactive (value){
        (0, $29e19754806f3a05$exports).deprecation("7.2.0", // eslint-disable-next-line max-len
        "Setting interactive is deprecated, use eventMode = 'none'/'passive'/'auto'/'static'/'dynamic' instead."), this._internalInteractive = value, this.eventMode = value ? "static" : "auto";
    },
    /**
   * @ignore
   */ _internalEventMode: void 0,
    /**
   * Enable interaction events for the DisplayObject. Touch, pointer and mouse.
   * This now replaces the `interactive` property.
   * There are 5 types of interaction settings:
   * - `'none'`: Ignores all interaction events, even on its children.
   * - `'passive'`: Does not emit events and ignores all hit testing on itself and non-interactive children.
   * Interactive children will still emit events.
   * - `'auto'`: Does not emit events but is hit tested if parent is interactive. Same as `interactive = false` in v7
   * - `'static'`: Emit events and is hit tested. Same as `interaction = true` in v7
   * - `'dynamic'`: Emits events and is hit tested but will also receive mock interaction events fired from a ticker to
   * allow for interaction when the mouse isn't moving
   * @example
   * import { Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite(texture);
   * sprite.eventMode = 'static';
   * sprite.on('tap', (event) => {
   *     // Handle event
   * });
   * @memberof PIXI.DisplayObject#
   * @since 7.2.0
   */ get eventMode () {
        return this._internalEventMode ?? (0, $92e7fcd540bd3f4e$export$bf477d624b56bf15).defaultEventMode;
    },
    set eventMode (value){
        this._internalInteractive = $936bb6fe4d7cea33$var$convertEventModeToInteractiveMode(value), this._internalEventMode = value;
    },
    /**
   * Determines if the displayObject is interactive or not
   * @returns {boolean} Whether the displayObject is interactive or not
   * @memberof PIXI.DisplayObject#
   * @since 7.2.0
   * @example
   * import { Sprite } from 'pixi.js';
   * const sprite = new Sprite(texture);
   * sprite.eventMode = 'static';
   * sprite.isInteractive(); // true
   *
   * sprite.eventMode = 'dynamic';
   * sprite.isInteractive(); // true
   *
   * sprite.eventMode = 'none';
   * sprite.isInteractive(); // false
   *
   * sprite.eventMode = 'passive';
   * sprite.isInteractive(); // false
   *
   * sprite.eventMode = 'auto';
   * sprite.isInteractive(); // false
   */ isInteractive () {
        return this.eventMode === "static" || this.eventMode === "dynamic";
    },
    /**
   * Determines if the children to the displayObject can be clicked/touched
   * Setting this to false allows PixiJS to bypass a recursive `hitTest` function
   * @memberof PIXI.Container#
   */ interactiveChildren: !0,
    /**
   * Interaction shape. Children will be hit first, then this shape will be checked.
   * Setting this will cause this shape to be checked in hit tests rather than the displayObject's bounds.
   * @example
   * import { Rectangle, Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite(texture);
   * sprite.interactive = true;
   * sprite.hitArea = new Rectangle(0, 0, 100, 100);
   * @member {PIXI.IHitArea}
   * @memberof PIXI.DisplayObject#
   */ hitArea: null,
    /**
   * Unlike `on` or `addListener` which are methods from EventEmitter, `addEventListener`
   * seeks to be compatible with the DOM's `addEventListener` with support for options.
   * **IMPORTANT:** _Only_ available if using the `@pixi/events` package.
   * @memberof PIXI.DisplayObject
   * @param type - The type of event to listen to.
   * @param listener - The listener callback or object.
   * @param options - Listener options, used for capture phase.
   * @example
   * // Tell the user whether they did a single, double, triple, or nth click.
   * button.addEventListener('click', {
   *     handleEvent(e): {
   *         let prefix;
   *
   *         switch (e.detail) {
   *             case 1: prefix = 'single'; break;
   *             case 2: prefix = 'double'; break;
   *             case 3: prefix = 'triple'; break;
   *             default: prefix = e.detail + 'th'; break;
   *         }
   *
   *         console.log('That was a ' + prefix + 'click');
   *     }
   * });
   *
   * // But skip the first click!
   * button.parent.addEventListener('click', function blockClickOnce(e) {
   *     e.stopImmediatePropagation();
   *     button.parent.removeEventListener('click', blockClickOnce, true);
   * }, {
   *     capture: true,
   * });
   */ addEventListener (type, listener, options) {
        const capture = typeof options == "boolean" && options || typeof options == "object" && options.capture, context = typeof listener == "function" ? void 0 : listener;
        type = capture ? `${type}capture` : type, listener = typeof listener == "function" ? listener : listener.handleEvent, this.on(type, listener, context);
    },
    /**
   * Unlike `off` or `removeListener` which are methods from EventEmitter, `removeEventListener`
   * seeks to be compatible with the DOM's `removeEventListener` with support for options.
   * **IMPORTANT:** _Only_ available if using the `@pixi/events` package.
   * @memberof PIXI.DisplayObject
   * @param type - The type of event the listener is bound to.
   * @param listener - The listener callback or object.
   * @param options - The original listener options. This is required to deregister a capture phase listener.
   */ removeEventListener (type, listener, options) {
        const capture = typeof options == "boolean" && options || typeof options == "object" && options.capture, context = typeof listener == "function" ? void 0 : listener;
        type = capture ? `${type}capture` : type, listener = typeof listener == "function" ? listener : listener.handleEvent, this.off(type, listener, context);
    },
    /**
   * Dispatch the event on this {@link PIXI.DisplayObject} using the event's {@link PIXI.EventBoundary}.
   *
   * The target of the event is set to `this` and the `defaultPrevented` flag is cleared before dispatch.
   *
   * **IMPORTANT:** _Only_ available if using the `@pixi/events` package.
   * @memberof PIXI.DisplayObject
   * @param e - The event to dispatch.
   * @returns Whether the {@link PIXI.FederatedEvent.preventDefault preventDefault}() method was not invoked.
   * @example
   * // Reuse a click event!
   * button.dispatchEvent(clickEvent);
   */ dispatchEvent (e) {
        if (!(e instanceof (0, $25100a59ab004189$export$5d10db92bb959d8a))) throw new Error("DisplayObject cannot propagate events outside of the Federated Events API");
        return e.defaultPrevented = !1, e.path = null, e.target = this, e.manager.dispatchEvent(e), !e.defaultPrevented;
    }
};
(0, $495c730e932693d1$export$1f679544f90d7d7c).mixin($936bb6fe4d7cea33$export$6a5b99a7f30af1d9);







const $9026e91ac4d8b28d$export$2c6c5fc5694bba8e = {
    /**
   *  Flag for if the object is accessible. If true AccessibilityManager will overlay a
   *   shadow div with attributes set
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   */ accessible: !1,
    /**
   * Sets the title attribute of the shadow div
   * If accessibleTitle AND accessibleHint has not been this will default to 'displayObject [tabIndex]'
   * @member {?string}
   * @memberof PIXI.DisplayObject#
   */ accessibleTitle: null,
    /**
   * Sets the aria-label attribute of the shadow div
   * @member {string}
   * @memberof PIXI.DisplayObject#
   */ accessibleHint: null,
    /**
   * @member {number}
   * @memberof PIXI.DisplayObject#
   * @private
   * @todo Needs docs.
   */ tabIndex: 0,
    /**
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   * @todo Needs docs.
   */ _accessibleActive: !1,
    /**
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   * @todo Needs docs.
   */ _accessibleDiv: null,
    /**
   * Specify the type of div the accessible layer is. Screen readers treat the element differently
   * depending on this type. Defaults to button.
   * @member {string}
   * @memberof PIXI.DisplayObject#
   * @default 'button'
   */ accessibleType: "button",
    /**
   * Specify the pointer-events the accessible div will use
   * Defaults to auto.
   * @member {string}
   * @memberof PIXI.DisplayObject#
   * @default 'auto'
   */ accessiblePointerEvents: "auto",
    /**
   * Setting to false will prevent any children inside this container to
   * be accessible. Defaults to true.
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   * @default true
   */ accessibleChildren: !0,
    renderId: -1
};


(0, $495c730e932693d1$export$1f679544f90d7d7c).mixin((0, $9026e91ac4d8b28d$export$2c6c5fc5694bba8e));
const $0262918e23f25451$var$KEY_CODE_TAB = 9, $0262918e23f25451$var$DIV_TOUCH_SIZE = 100, $0262918e23f25451$var$DIV_TOUCH_POS_X = 0, $0262918e23f25451$var$DIV_TOUCH_POS_Y = 0, $0262918e23f25451$var$DIV_TOUCH_ZINDEX = 2, $0262918e23f25451$var$DIV_HOOK_SIZE = 1, $0262918e23f25451$var$DIV_HOOK_POS_X = -1000, $0262918e23f25451$var$DIV_HOOK_POS_Y = -1000, $0262918e23f25451$var$DIV_HOOK_ZINDEX = 2;
class $0262918e23f25451$export$a2c2de1efa8671eb {
    // 2fps
    /**
   * @param {PIXI.CanvasRenderer|PIXI.Renderer} renderer - A reference to the current renderer
   */ constructor(renderer){
        this.debug = !1, this._isActive = !1, this._isMobileAccessibility = !1, this.pool = [], this.renderId = 0, this.children = [], this.androidUpdateCount = 0, this.androidUpdateFrequency = 500, this._hookDiv = null, ((0, $29e19754806f3a05$exports).isMobile.tablet || (0, $29e19754806f3a05$exports).isMobile.phone) && this.createTouchHook();
        const div = document.createElement("div");
        div.style.width = `${$0262918e23f25451$var$DIV_TOUCH_SIZE}px`, div.style.height = `${$0262918e23f25451$var$DIV_TOUCH_SIZE}px`, div.style.position = "absolute", div.style.top = `${$0262918e23f25451$var$DIV_TOUCH_POS_X}px`, div.style.left = `${$0262918e23f25451$var$DIV_TOUCH_POS_Y}px`, div.style.zIndex = $0262918e23f25451$var$DIV_TOUCH_ZINDEX.toString(), this.div = div, this.renderer = renderer, this._onKeyDown = this._onKeyDown.bind(this), this._onMouseMove = this._onMouseMove.bind(this), globalThis.addEventListener("keydown", this._onKeyDown, !1);
    }
    /**
   * Value of `true` if accessibility is currently active and accessibility layers are showing.
   * @member {boolean}
   * @readonly
   */ get isActive() {
        return this._isActive;
    }
    /**
   * Value of `true` if accessibility is enabled for touch devices.
   * @member {boolean}
   * @readonly
   */ get isMobileAccessibility() {
        return this._isMobileAccessibility;
    }
    /**
   * Creates the touch hooks.
   * @private
   */ createTouchHook() {
        const hookDiv = document.createElement("button");
        hookDiv.style.width = `${$0262918e23f25451$var$DIV_HOOK_SIZE}px`, hookDiv.style.height = `${$0262918e23f25451$var$DIV_HOOK_SIZE}px`, hookDiv.style.position = "absolute", hookDiv.style.top = `${$0262918e23f25451$var$DIV_HOOK_POS_X}px`, hookDiv.style.left = `${$0262918e23f25451$var$DIV_HOOK_POS_Y}px`, hookDiv.style.zIndex = $0262918e23f25451$var$DIV_HOOK_ZINDEX.toString(), hookDiv.style.backgroundColor = "#FF0000", hookDiv.title = "select to enable accessibility for this content", hookDiv.addEventListener("focus", ()=>{
            this._isMobileAccessibility = !0, this.activate(), this.destroyTouchHook();
        }), document.body.appendChild(hookDiv), this._hookDiv = hookDiv;
    }
    /**
   * Destroys the touch hooks.
   * @private
   */ destroyTouchHook() {
        this._hookDiv && (document.body.removeChild(this._hookDiv), this._hookDiv = null);
    }
    /**
   * Activating will cause the Accessibility layer to be shown.
   * This is called when a user presses the tab key.
   * @private
   */ activate() {
        this._isActive || (this._isActive = !0, globalThis.document.addEventListener("mousemove", this._onMouseMove, !0), globalThis.removeEventListener("keydown", this._onKeyDown, !1), this.renderer.on("postrender", this.update, this), this.renderer.view.parentNode?.appendChild(this.div));
    }
    /**
   * Deactivating will cause the Accessibility layer to be hidden.
   * This is called when a user moves the mouse.
   * @private
   */ deactivate() {
        !this._isActive || this._isMobileAccessibility || (this._isActive = !1, globalThis.document.removeEventListener("mousemove", this._onMouseMove, !0), globalThis.addEventListener("keydown", this._onKeyDown, !1), this.renderer.off("postrender", this.update), this.div.parentNode?.removeChild(this.div));
    }
    /**
   * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
   * @private
   * @param {PIXI.Container} displayObject - The DisplayObject to check.
   */ updateAccessibleObjects(displayObject) {
        if (!displayObject.visible || !displayObject.accessibleChildren) return;
        displayObject.accessible && displayObject.isInteractive() && (displayObject._accessibleActive || this.addChild(displayObject), displayObject.renderId = this.renderId);
        const children = displayObject.children;
        if (children) for(let i = 0; i < children.length; i++)this.updateAccessibleObjects(children[i]);
    }
    /**
   * Before each render this function will ensure that all divs are mapped correctly to their DisplayObjects.
   * @private
   */ update() {
        const now = performance.now();
        if ((0, $29e19754806f3a05$exports).isMobile.android.device && now < this.androidUpdateCount || (this.androidUpdateCount = now + this.androidUpdateFrequency, !this.renderer.renderingToScreen)) return;
        this.renderer.lastObjectRendered && this.updateAccessibleObjects(this.renderer.lastObjectRendered);
        const { x: x, y: y, width: width, height: height } = this.renderer.view.getBoundingClientRect(), { width: viewWidth, height: viewHeight, resolution: resolution } = this.renderer, sx = width / viewWidth * resolution, sy = height / viewHeight * resolution;
        let div = this.div;
        div.style.left = `${x}px`, div.style.top = `${y}px`, div.style.width = `${viewWidth}px`, div.style.height = `${viewHeight}px`;
        for(let i = 0; i < this.children.length; i++){
            const child = this.children[i];
            if (child.renderId !== this.renderId) child._accessibleActive = !1, (0, $29e19754806f3a05$exports).removeItems(this.children, i, 1), this.div.removeChild(child._accessibleDiv), this.pool.push(child._accessibleDiv), child._accessibleDiv = null, i--;
            else {
                div = child._accessibleDiv;
                let hitArea = child.hitArea;
                const wt = child.worldTransform;
                child.hitArea ? (div.style.left = `${(wt.tx + hitArea.x * wt.a) * sx}px`, div.style.top = `${(wt.ty + hitArea.y * wt.d) * sy}px`, div.style.width = `${hitArea.width * wt.a * sx}px`, div.style.height = `${hitArea.height * wt.d * sy}px`) : (hitArea = child.getBounds(), this.capHitArea(hitArea), div.style.left = `${hitArea.x * sx}px`, div.style.top = `${hitArea.y * sy}px`, div.style.width = `${hitArea.width * sx}px`, div.style.height = `${hitArea.height * sy}px`, div.title !== child.accessibleTitle && child.accessibleTitle !== null && (div.title = child.accessibleTitle), div.getAttribute("aria-label") !== child.accessibleHint && child.accessibleHint !== null && div.setAttribute("aria-label", child.accessibleHint)), (child.accessibleTitle !== div.title || child.tabIndex !== div.tabIndex) && (div.title = child.accessibleTitle, div.tabIndex = child.tabIndex, this.debug && this.updateDebugHTML(div));
            }
        }
        this.renderId++;
    }
    /**
   * private function that will visually add the information to the
   * accessability div
   * @param {HTMLElement} div -
   */ updateDebugHTML(div) {
        div.innerHTML = `type: ${div.type}</br> title : ${div.title}</br> tabIndex: ${div.tabIndex}`;
    }
    /**
   * Adjust the hit area based on the bounds of a display object
   * @param {PIXI.Rectangle} hitArea - Bounds of the child
   */ capHitArea(hitArea) {
        hitArea.x < 0 && (hitArea.width += hitArea.x, hitArea.x = 0), hitArea.y < 0 && (hitArea.height += hitArea.y, hitArea.y = 0);
        const { width: viewWidth, height: viewHeight } = this.renderer;
        hitArea.x + hitArea.width > viewWidth && (hitArea.width = viewWidth - hitArea.x), hitArea.y + hitArea.height > viewHeight && (hitArea.height = viewHeight - hitArea.y);
    }
    /**
   * Adds a DisplayObject to the accessibility manager
   * @private
   * @param {PIXI.DisplayObject} displayObject - The child to make accessible.
   */ addChild(displayObject) {
        let div = this.pool.pop();
        div || (div = document.createElement("button"), div.style.width = `${$0262918e23f25451$var$DIV_TOUCH_SIZE}px`, div.style.height = `${$0262918e23f25451$var$DIV_TOUCH_SIZE}px`, div.style.backgroundColor = this.debug ? "rgba(255,255,255,0.5)" : "transparent", div.style.position = "absolute", div.style.zIndex = $0262918e23f25451$var$DIV_TOUCH_ZINDEX.toString(), div.style.borderStyle = "none", navigator.userAgent.toLowerCase().includes("chrome") ? div.setAttribute("aria-live", "off") : div.setAttribute("aria-live", "polite"), navigator.userAgent.match(/rv:.*Gecko\//) ? div.setAttribute("aria-relevant", "additions") : div.setAttribute("aria-relevant", "text"), div.addEventListener("click", this._onClick.bind(this)), div.addEventListener("focus", this._onFocus.bind(this)), div.addEventListener("focusout", this._onFocusOut.bind(this))), div.style.pointerEvents = displayObject.accessiblePointerEvents, div.type = displayObject.accessibleType, displayObject.accessibleTitle && displayObject.accessibleTitle !== null ? div.title = displayObject.accessibleTitle : (!displayObject.accessibleHint || displayObject.accessibleHint === null) && (div.title = `displayObject ${displayObject.tabIndex}`), displayObject.accessibleHint && displayObject.accessibleHint !== null && div.setAttribute("aria-label", displayObject.accessibleHint), this.debug && this.updateDebugHTML(div), displayObject._accessibleActive = !0, displayObject._accessibleDiv = div, div.displayObject = displayObject, this.children.push(displayObject), this.div.appendChild(displayObject._accessibleDiv), displayObject._accessibleDiv.tabIndex = displayObject.tabIndex;
    }
    /**
   * Dispatch events with the EventSystem.
   * @param e
   * @param type
   * @private
   */ _dispatchEvent(e, type) {
        const { displayObject: target } = e.target, boundry = this.renderer.events.rootBoundary, event = Object.assign(new (0, $25100a59ab004189$export$5d10db92bb959d8a)(boundry), {
            target: target
        });
        boundry.rootTarget = this.renderer.lastObjectRendered, type.forEach((type2)=>boundry.dispatchEvent(event, type2));
    }
    /**
   * Maps the div button press to pixi's EventSystem (click)
   * @private
   * @param {MouseEvent} e - The click event.
   */ _onClick(e) {
        this._dispatchEvent(e, [
            "click",
            "pointertap",
            "tap"
        ]);
    }
    /**
   * Maps the div focus events to pixi's EventSystem (mouseover)
   * @private
   * @param {FocusEvent} e - The focus event.
   */ _onFocus(e) {
        e.target.getAttribute("aria-live") || e.target.setAttribute("aria-live", "assertive"), this._dispatchEvent(e, [
            "mouseover"
        ]);
    }
    /**
   * Maps the div focus events to pixi's EventSystem (mouseout)
   * @private
   * @param {FocusEvent} e - The focusout event.
   */ _onFocusOut(e) {
        e.target.getAttribute("aria-live") || e.target.setAttribute("aria-live", "polite"), this._dispatchEvent(e, [
            "mouseout"
        ]);
    }
    /**
   * Is called when a key is pressed
   * @private
   * @param {KeyboardEvent} e - The keydown event.
   */ _onKeyDown(e) {
        e.keyCode === $0262918e23f25451$var$KEY_CODE_TAB && this.activate();
    }
    /**
   * Is called when the mouse moves across the renderer element
   * @private
   * @param {MouseEvent} e - The mouse event.
   */ _onMouseMove(e) {
        e.movementX === 0 && e.movementY === 0 || this.deactivate();
    }
    /** Destroys the accessibility manager */ destroy() {
        this.destroyTouchHook(), this.div = null, globalThis.document.removeEventListener("mousemove", this._onMouseMove, !0), globalThis.removeEventListener("keydown", this._onKeyDown), this.pool = null, this.children = null, this.renderer = null;
    }
}
$0262918e23f25451$export$a2c2de1efa8671eb.extension = {
    name: "accessibility",
    type: [
        (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererPlugin,
        (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).CanvasRendererPlugin
    ]
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($0262918e23f25451$export$a2c2de1efa8671eb);







const $1102c0d10394bdf6$var$_Application = class _Application2 {
    /**
   * @param options - The optional application and renderer parameters.
   */ constructor(options){
        this.stage = new (0, $3878067a77b781d9$export$42a852a2b6b56249)(), options = Object.assign({
            forceCanvas: !1
        }, options), this.renderer = (0, $97850c06f85b1ff7$export$3583b92ab8150eb6)(options), _Application2._plugins.forEach((plugin)=>{
            plugin.init.call(this, options);
        });
    }
    /** Render the current stage. */ render() {
        this.renderer.render(this.stage);
    }
    /**
   * Reference to the renderer's canvas element.
   * @member {PIXI.ICanvas}
   * @readonly
   */ get view() {
        return this.renderer?.view;
    }
    /**
   * Reference to the renderer's screen rectangle. Its safe to use as `filterArea` or `hitArea` for the whole screen.
   * @member {PIXI.Rectangle}
   * @readonly
   */ get screen() {
        return this.renderer?.screen;
    }
    /**
   * Destroy and don't use after this.
   * @param {boolean} [removeView=false] - Automatically remove canvas from DOM.
   * @param {object|boolean} [stageOptions] - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [stageOptions.children=false] - if set to true, all the children will have their destroy
   *  method called as well. 'stageOptions' will be passed on to those calls.
   * @param {boolean} [stageOptions.texture=false] - Only used for child Sprites if stageOptions.children is set
   *  to true. Should it destroy the texture of the child sprite
   * @param {boolean} [stageOptions.baseTexture=false] - Only used for child Sprites if stageOptions.children is set
   *  to true. Should it destroy the base texture of the child sprite
   */ destroy(removeView, stageOptions) {
        const plugins = _Application2._plugins.slice(0);
        plugins.reverse(), plugins.forEach((plugin)=>{
            plugin.destroy.call(this);
        }), this.stage.destroy(stageOptions), this.stage = null, this.renderer.destroy(removeView), this.renderer = null;
    }
};
$1102c0d10394bdf6$var$_Application._plugins = [];
let $1102c0d10394bdf6$export$16975c34e60e1e61 = $1102c0d10394bdf6$var$_Application;
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).handleByList((0, $69f9a88446c99188$export$4f037c6ec2da4eeb).Application, $1102c0d10394bdf6$export$16975c34e60e1e61._plugins);



class $7222cc73d51bf9ee$export$6453cd852defe94a {
    /**
   * Initialize the plugin with scope of application instance
   * @static
   * @private
   * @param {object} [options] - See application options
   */ static init(options) {
        Object.defineProperty(this, "resizeTo", /**
       * The HTML element or window to automatically resize the
       * renderer's view element to match width and height.
       * @member {Window|HTMLElement}
       * @name resizeTo
       * @memberof PIXI.Application#
       */ {
            set (dom) {
                globalThis.removeEventListener("resize", this.queueResize), this._resizeTo = dom, dom && (globalThis.addEventListener("resize", this.queueResize), this.resize());
            },
            get () {
                return this._resizeTo;
            }
        }), this.queueResize = ()=>{
            this._resizeTo && (this.cancelResize(), this._resizeId = requestAnimationFrame(()=>this.resize()));
        }, this.cancelResize = ()=>{
            this._resizeId && (cancelAnimationFrame(this._resizeId), this._resizeId = null);
        }, this.resize = ()=>{
            if (!this._resizeTo) return;
            this.cancelResize();
            let width, height;
            if (this._resizeTo === globalThis.window) width = globalThis.innerWidth, height = globalThis.innerHeight;
            else {
                const { clientWidth: clientWidth, clientHeight: clientHeight } = this._resizeTo;
                width = clientWidth, height = clientHeight;
            }
            this.renderer.resize(width, height), this.render();
        }, this._resizeId = null, this._resizeTo = null, this.resizeTo = options.resizeTo || null;
    }
    /**
   * Clean up the ticker, scoped to application
   * @static
   * @private
   */ static destroy() {
        globalThis.removeEventListener("resize", this.queueResize), this.cancelResize(), this.cancelResize = null, this.queueResize = null, this.resizeTo = null, this.resize = null;
    }
}
$7222cc73d51bf9ee$export$6453cd852defe94a.extension = (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).Application;
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($7222cc73d51bf9ee$export$6453cd852defe94a);





const $e4ab886a26d3f6e6$var$assetKeyMap = {
    loader: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).LoadParser,
    resolver: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).ResolveParser,
    cache: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).CacheParser,
    detection: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).DetectionParser
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).handle((0, $69f9a88446c99188$export$4f037c6ec2da4eeb).Asset, (extension)=>{
    const ref = extension.ref;
    Object.entries($e4ab886a26d3f6e6$var$assetKeyMap).filter(([key])=>!!ref[key]).forEach(([key, type])=>(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add(Object.assign(ref[key], // Allow the function to optionally define it's own
        // ExtensionMetadata, the use cases here is priority for LoaderParsers
        {
            extension: ref[key].extension ?? type
        })));
}, (extension)=>{
    const ref = extension.ref;
    Object.keys($e4ab886a26d3f6e6$var$assetKeyMap).filter((key)=>!!ref[key]).forEach((key)=>(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).remove(ref[key]));
});



class $fabaa3b26410279e$export$1949379a83b843d5 {
    /**
   * @param loader
   * @param verbose - should the loader log to the console
   */ constructor(loader, verbose = !1){
        this._loader = loader, this._assetList = [], this._isLoading = !1, this._maxConcurrent = 1, this.verbose = verbose;
    }
    /**
   * Adds an array of assets to load.
   * @param assetUrls - assets to load
   */ add(assetUrls) {
        assetUrls.forEach((a)=>{
            this._assetList.push(a);
        }), this.verbose && console.log("[BackgroundLoader] assets: ", this._assetList), this._isActive && !this._isLoading && this._next();
    }
    /**
   * Loads the next set of assets. Will try to load as many assets as it can at the same time.
   *
   * The max assets it will try to load at one time will be 4.
   */ async _next() {
        if (this._assetList.length && this._isActive) {
            this._isLoading = !0;
            const toLoad = [], toLoadAmount = Math.min(this._assetList.length, this._maxConcurrent);
            for(let i = 0; i < toLoadAmount; i++)toLoad.push(this._assetList.pop());
            await this._loader.load(toLoad), this._isLoading = !1, this._next();
        }
    }
    /**
   * Activate/Deactivate the loading. If set to true then it will immediately continue to load the next asset.
   * @returns whether the class is active
   */ get active() {
        return this._isActive;
    }
    set active(value) {
        this._isActive !== value && (this._isActive = value, value && !this._isLoading && this._next());
    }
}



function $bd308d1d651fe041$export$7ff8b059fb914323(url, mimes) {
    if (Array.isArray(mimes)) {
        for (const mime of mimes)if (url.startsWith(`data:${mime}`)) return !0;
        return !1;
    }
    return url.startsWith(`data:${mimes}`);
}



function $10add1021e67fe4f$export$fd0180357b95b812(url, extension) {
    const tempURL = url.split("?")[0], ext = (0, $29e19754806f3a05$exports).path.extname(tempURL).toLowerCase();
    return Array.isArray(extension) ? extension.includes(ext) : ext === extension;
}


const $68c70bf6b66546ba$export$b01be8e180bf3d9b = (input, transform, forceTransform = !1)=>(Array.isArray(input) || (input = [
        input
    ]), transform ? input.map((item)=>typeof item == "string" || forceTransform ? transform(item) : item) : input);


const $a909d8f65000d92c$export$f57b97ef8be10dda = (targetUrl, sourceUrl)=>{
    const searchParams = sourceUrl.split("?")[1];
    return searchParams && (targetUrl += `?${searchParams}`), targetUrl;
};


function $7c993261e76bf0b3$var$processX(base, ids, depth, result, tags) {
    const id = ids[depth];
    for(let i = 0; i < id.length; i++){
        const value = id[i];
        depth < ids.length - 1 ? $7c993261e76bf0b3$var$processX(base.replace(result[depth], value), ids, depth + 1, result, tags) : tags.push(base.replace(result[depth], value));
    }
}
function $7c993261e76bf0b3$export$738117acc6638004(string) {
    const regex = /\{(.*?)\}/g, result = string.match(regex), tags = [];
    if (result) {
        const ids = [];
        result.forEach((vars)=>{
            const split = vars.substring(1, vars.length - 1).split(",");
            ids.push(split);
        }), $7c993261e76bf0b3$var$processX(string, ids, 0, result, tags);
    } else tags.push(string);
    return tags;
}


const $9faa0c91da8fd682$export$16a80d27953452d4 = (item)=>!Array.isArray(item);





class $7a71e956bc8f61a8$var$CacheClass {
    constructor(){
        this._parsers = [], this._cache = /* @__PURE__ */ new Map(), this._cacheMap = /* @__PURE__ */ new Map();
    }
    /** Clear all entries. */ reset() {
        this._cacheMap.clear(), this._cache.clear();
    }
    /**
   * Check if the key exists
   * @param key - The key to check
   */ has(key) {
        return this._cache.has(key);
    }
    /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */ get(key) {
        const result = this._cache.get(key);
        return result || console.warn(`[Assets] Asset id ${key} was not found in the Cache`), result;
    }
    /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */ set(key, value) {
        const keys = (0, $68c70bf6b66546ba$export$b01be8e180bf3d9b)(key);
        let cacheableAssets;
        for(let i = 0; i < this.parsers.length; i++){
            const parser = this.parsers[i];
            if (parser.test(value)) {
                cacheableAssets = parser.getCacheableAssets(keys, value);
                break;
            }
        }
        cacheableAssets || (cacheableAssets = {}, keys.forEach((key2)=>{
            cacheableAssets[key2] = value;
        }));
        const cacheKeys = Object.keys(cacheableAssets), cachedAssets = {
            cacheKeys: cacheKeys,
            keys: keys
        };
        if (keys.forEach((key2)=>{
            this._cacheMap.set(key2, cachedAssets);
        }), cacheKeys.forEach((key2)=>{
            this._cache.has(key2) && this._cache.get(key2) !== value && console.warn("[Cache] already has key:", key2), this._cache.set(key2, cacheableAssets[key2]);
        }), value instanceof (0, $ad1fffd072a707c2$export$5431306cf43de24a)) {
            const texture = value;
            keys.forEach((key2)=>{
                texture.baseTexture !== (0, $ad1fffd072a707c2$export$5431306cf43de24a).EMPTY.baseTexture && (0, $997b0e421c4045eb$export$d6306e508f184154).addToCache(texture.baseTexture, key2), (0, $ad1fffd072a707c2$export$5431306cf43de24a).addToCache(texture, key2);
            });
        }
    }
    /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */ remove(key) {
        if (!this._cacheMap.has(key)) {
            console.warn(`[Assets] Asset id ${key} was not found in the Cache`);
            return;
        }
        const cacheMap = this._cacheMap.get(key);
        cacheMap.cacheKeys.forEach((key2)=>{
            this._cache.delete(key2);
        }), cacheMap.keys.forEach((key2)=>{
            this._cacheMap.delete(key2);
        });
    }
    /** All loader parsers registered */ get parsers() {
        return this._parsers;
    }
}
const $7a71e956bc8f61a8$export$94affb487e701bf2 = new $7a71e956bc8f61a8$var$CacheClass();






class $6573053e2cf89c65$export$3b0d6d7590275603 {
    constructor(){
        this._parsers = [], this._parsersValidated = !1, this.parsers = new Proxy(this._parsers, {
            set: (target, key, value)=>(this._parsersValidated = !1, target[key] = value, !0)
        }), this.promiseCache = {};
    }
    /** function used for testing */ reset() {
        this._parsersValidated = !1, this.promiseCache = {};
    }
    /**
   * Used internally to generate a promise for the asset to be loaded.
   * @param url - The URL to be loaded
   * @param data - any custom additional information relevant to the asset being loaded
   * @returns - a promise that will resolve to an Asset for example a Texture of a JSON object
   */ _getLoadPromiseAndParser(url, data) {
        const result = {
            promise: null,
            parser: null
        };
        return result.promise = (async ()=>{
            let asset = null, parser = null;
            if (data.loadParser && (parser = this._parserHash[data.loadParser], parser || console.warn(`[Assets] specified load parser "${data.loadParser}" not found while loading ${url}`)), !parser) {
                for(let i = 0; i < this.parsers.length; i++){
                    const parserX = this.parsers[i];
                    if (parserX.load && parserX.test?.(url, data, this)) {
                        parser = parserX;
                        break;
                    }
                }
                if (!parser) return console.warn(`[Assets] ${url} could not be loaded as we don't know how to parse it, ensure the correct parser has been added`), null;
            }
            asset = await parser.load(url, data, this), result.parser = parser;
            for(let i = 0; i < this.parsers.length; i++){
                const parser2 = this.parsers[i];
                parser2.parse && parser2.parse && await parser2.testParse?.(asset, data, this) && (asset = await parser2.parse(asset, data, this) || asset, result.parser = parser2);
            }
            return asset;
        })(), result;
    }
    async load(assetsToLoadIn, onProgress) {
        this._parsersValidated || this._validateParsers();
        let count = 0;
        const assets = {}, singleAsset = (0, $9faa0c91da8fd682$export$16a80d27953452d4)(assetsToLoadIn), assetsToLoad = (0, $68c70bf6b66546ba$export$b01be8e180bf3d9b)(assetsToLoadIn, (item)=>({
                alias: [
                    item
                ],
                src: item
            })), total = assetsToLoad.length, promises = assetsToLoad.map(async (asset)=>{
            const url = (0, $29e19754806f3a05$exports).path.toAbsolute(asset.src);
            if (!assets[asset.src]) try {
                this.promiseCache[url] || (this.promiseCache[url] = this._getLoadPromiseAndParser(url, asset)), assets[asset.src] = await this.promiseCache[url].promise, onProgress && onProgress(++count / total);
            } catch (e) {
                throw delete this.promiseCache[url], delete assets[asset.src], new Error(`[Loader.load] Failed to load ${url}.
${e}`);
            }
        });
        return await Promise.all(promises), singleAsset ? assets[assetsToLoad[0].src] : assets;
    }
    /**
   * Unloads one or more assets. Any unloaded assets will be destroyed, freeing up memory for your app.
   * The parser that created the asset, will be the one that unloads it.
   * @example
   * // Single asset:
   * const asset = await Loader.load('cool.png');
   *
   * await Loader.unload('cool.png');
   *
   * console.log(asset.destroyed); // true
   * @param assetsToUnloadIn - urls that you want to unload, or a single one!
   */ async unload(assetsToUnloadIn) {
        const promises = (0, $68c70bf6b66546ba$export$b01be8e180bf3d9b)(assetsToUnloadIn, (item)=>({
                alias: [
                    item
                ],
                src: item
            })).map(async (asset)=>{
            const url = (0, $29e19754806f3a05$exports).path.toAbsolute(asset.src), loadPromise = this.promiseCache[url];
            if (loadPromise) {
                const loadedAsset = await loadPromise.promise;
                delete this.promiseCache[url], loadPromise.parser?.unload?.(loadedAsset, asset, this);
            }
        });
        await Promise.all(promises);
    }
    /** validates our parsers, right now it only checks for name conflicts but we can add more here as required! */ _validateParsers() {
        this._parsersValidated = !0, this._parserHash = this._parsers.filter((parser)=>parser.name).reduce((hash, parser)=>(hash[parser.name] && console.warn(`[Assets] loadParser name conflict "${parser.name}"`), {
                ...hash,
                [parser.name]: parser
            }), {});
    }
}


var $d0164a963de0e9b4$export$820ed6348c4f2750 = /* @__PURE__ */ ((LoaderParserPriority2)=>(LoaderParserPriority2[LoaderParserPriority2.Low = 0] = "Low", LoaderParserPriority2[LoaderParserPriority2.Normal = 1] = "Normal", LoaderParserPriority2[LoaderParserPriority2.High = 2] = "High", LoaderParserPriority2))($d0164a963de0e9b4$export$820ed6348c4f2750 || {});






const $9c8f79114f4b62ed$var$validJSONExtension = ".json", $9c8f79114f4b62ed$var$validJSONMIME = "application/json", $9c8f79114f4b62ed$export$e7c8553478f3aac7 = {
    extension: {
        type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $d0164a963de0e9b4$export$820ed6348c4f2750).Low
    },
    name: "loadJson",
    test (url) {
        return (0, $bd308d1d651fe041$export$7ff8b059fb914323)(url, $9c8f79114f4b62ed$var$validJSONMIME) || (0, $10add1021e67fe4f$export$fd0180357b95b812)(url, $9c8f79114f4b62ed$var$validJSONExtension);
    },
    async load (url) {
        return await (await (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.fetch(url)).json();
    }
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($9c8f79114f4b62ed$export$e7c8553478f3aac7);






const $e9be4066c40a912f$var$validTXTExtension = ".txt", $e9be4066c40a912f$var$validTXTMIME = "text/plain", $e9be4066c40a912f$export$3835b7ee6dbebde8 = {
    name: "loadTxt",
    extension: {
        type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $d0164a963de0e9b4$export$820ed6348c4f2750).Low
    },
    test (url) {
        return (0, $bd308d1d651fe041$export$7ff8b059fb914323)(url, $e9be4066c40a912f$var$validTXTMIME) || (0, $10add1021e67fe4f$export$fd0180357b95b812)(url, $e9be4066c40a912f$var$validTXTExtension);
    },
    async load (url) {
        return await (await (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.fetch(url)).text();
    }
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($e9be4066c40a912f$export$3835b7ee6dbebde8);






const $ff36b37f15d547f8$var$validWeights = [
    "normal",
    "bold",
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900"
], $ff36b37f15d547f8$var$validFontExtensions = [
    ".ttf",
    ".otf",
    ".woff",
    ".woff2"
], $ff36b37f15d547f8$var$validFontMIMEs = [
    "font/ttf",
    "font/otf",
    "font/woff",
    "font/woff2"
], $ff36b37f15d547f8$var$CSS_IDENT_TOKEN_REGEX = /^(--|-?[A-Z_])[0-9A-Z_-]*$/i;
function $ff36b37f15d547f8$export$c461ca8f39d93d9b(url) {
    const ext = (0, $29e19754806f3a05$exports).path.extname(url), nameTokens = (0, $29e19754806f3a05$exports).path.basename(url, ext).replace(/(-|_)/g, " ").toLowerCase().split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1));
    let valid = nameTokens.length > 0;
    for (const token of nameTokens)if (!token.match($ff36b37f15d547f8$var$CSS_IDENT_TOKEN_REGEX)) {
        valid = !1;
        break;
    }
    let fontFamilyName = nameTokens.join(" ");
    return valid || (fontFamilyName = `"${fontFamilyName.replace(/[\\"]/g, "\\$&")}"`), fontFamilyName;
}
const $ff36b37f15d547f8$export$129ed93ad26b0298 = {
    extension: {
        type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $d0164a963de0e9b4$export$820ed6348c4f2750).Low
    },
    name: "loadWebFont",
    test (url) {
        return (0, $bd308d1d651fe041$export$7ff8b059fb914323)(url, $ff36b37f15d547f8$var$validFontMIMEs) || (0, $10add1021e67fe4f$export$fd0180357b95b812)(url, $ff36b37f15d547f8$var$validFontExtensions);
    },
    async load (url, options) {
        const fonts = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.getFontFaceSet();
        if (fonts) {
            const fontFaces = [], name = options.data?.family ?? $ff36b37f15d547f8$export$c461ca8f39d93d9b(url), weights = options.data?.weights?.filter((weight)=>$ff36b37f15d547f8$var$validWeights.includes(weight)) ?? [
                "normal"
            ], data = options.data ?? {};
            for(let i = 0; i < weights.length; i++){
                const weight = weights[i], font = new FontFace(name, `url(${encodeURI(url)})`, {
                    ...data,
                    weight: weight
                });
                await font.load(), fonts.add(font), fontFaces.push(font);
            }
            return fontFaces.length === 1 ? fontFaces[0] : fontFaces;
        }
        return console.warn("[loadWebFont] FontFace API is not supported. Skipping loading font"), null;
    },
    unload (font) {
        (Array.isArray(font) ? font : [
            font
        ]).forEach((t)=>(0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.getFontFaceSet().delete(t));
    }
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($ff36b37f15d547f8$export$129ed93ad26b0298);










let $5a34bf116bc17e77$var$UUID = 0, $5a34bf116bc17e77$var$MAX_WORKERS;
const $5a34bf116bc17e77$var$WHITE_PNG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=", $5a34bf116bc17e77$var$checkImageBitmapCode = {
    id: "checkImageBitmap",
    code: `
    async function checkImageBitmap()
    {
        try
        {
            if (typeof createImageBitmap !== 'function') return false;

            const response = await fetch('${$5a34bf116bc17e77$var$WHITE_PNG}');
            const imageBlob =  await response.blob();
            const imageBitmap = await createImageBitmap(imageBlob);

            return imageBitmap.width === 1 && imageBitmap.height === 1;
        }
        catch (e)
        {
            return false;
        }
    }
    checkImageBitmap().then((result) => { self.postMessage(result); });
    `
}, $5a34bf116bc17e77$var$workerCode = {
    id: "loadImageBitmap",
    code: `
    async function loadImageBitmap(url)
    {
        const response = await fetch(url);

        if (!response.ok)
        {
            throw new Error(\`[WorkerManager.loadImageBitmap] Failed to fetch \${url}: \`
                + \`\${response.status} \${response.statusText}\`);
        }

        const imageBlob =  await response.blob();
        const imageBitmap = await createImageBitmap(imageBlob);

        return imageBitmap;
    }
    self.onmessage = async (event) =>
    {
        try
        {
            const imageBitmap = await loadImageBitmap(event.data.data[0]);

            self.postMessage({
                data: imageBitmap,
                uuid: event.data.uuid,
                id: event.data.id,
            }, [imageBitmap]);
        }
        catch(e)
        {
            self.postMessage({
                error: e,
                uuid: event.data.uuid,
                id: event.data.id,
            });
        }
    };`
};
let $5a34bf116bc17e77$var$workerURL;
class $5a34bf116bc17e77$var$WorkerManagerClass {
    constructor(){
        this._initialized = !1, this._createdWorkers = 0, this.workerPool = [], this.queue = [], this.resolveHash = {};
    }
    isImageBitmapSupported() {
        return this._isImageBitmapSupported !== void 0 ? this._isImageBitmapSupported : (this._isImageBitmapSupported = new Promise((resolve)=>{
            const workerURL2 = URL.createObjectURL(new Blob([
                $5a34bf116bc17e77$var$checkImageBitmapCode.code
            ], {
                type: "application/javascript"
            })), worker = new Worker(workerURL2);
            worker.addEventListener("message", (event)=>{
                worker.terminate(), URL.revokeObjectURL(workerURL2), resolve(event.data);
            });
        }), this._isImageBitmapSupported);
    }
    loadImageBitmap(src) {
        return this._run("loadImageBitmap", [
            src
        ]);
    }
    async _initWorkers() {
        this._initialized || (this._initialized = !0);
    }
    getWorker() {
        $5a34bf116bc17e77$var$MAX_WORKERS === void 0 && ($5a34bf116bc17e77$var$MAX_WORKERS = navigator.hardwareConcurrency || 4);
        let worker = this.workerPool.pop();
        return !worker && this._createdWorkers < $5a34bf116bc17e77$var$MAX_WORKERS && ($5a34bf116bc17e77$var$workerURL || ($5a34bf116bc17e77$var$workerURL = URL.createObjectURL(new Blob([
            $5a34bf116bc17e77$var$workerCode.code
        ], {
            type: "application/javascript"
        }))), this._createdWorkers++, worker = new Worker($5a34bf116bc17e77$var$workerURL), worker.addEventListener("message", (event)=>{
            this.complete(event.data), this.returnWorker(event.target), this.next();
        })), worker;
    }
    returnWorker(worker) {
        this.workerPool.push(worker);
    }
    complete(data) {
        data.error !== void 0 ? this.resolveHash[data.uuid].reject(data.error) : this.resolveHash[data.uuid].resolve(data.data), this.resolveHash[data.uuid] = null;
    }
    async _run(id, args) {
        await this._initWorkers();
        const promise = new Promise((resolve, reject)=>{
            this.queue.push({
                id: id,
                arguments: args,
                resolve: resolve,
                reject: reject
            });
        });
        return this.next(), promise;
    }
    next() {
        if (!this.queue.length) return;
        const worker = this.getWorker();
        if (!worker) return;
        const toDo = this.queue.pop(), id = toDo.id;
        this.resolveHash[$5a34bf116bc17e77$var$UUID] = {
            resolve: toDo.resolve,
            reject: toDo.reject
        }, worker.postMessage({
            data: toDo.arguments,
            uuid: $5a34bf116bc17e77$var$UUID++,
            id: id
        });
    }
}
const $5a34bf116bc17e77$export$bcff6015853c67ce = new $5a34bf116bc17e77$var$WorkerManagerClass();




function $ee9b3b11b833a834$export$37b981a8c575f415(base, loader, url) {
    base.resource.internal = !0;
    const texture = new (0, $ad1fffd072a707c2$export$5431306cf43de24a)(base), unload = ()=>{
        delete loader.promiseCache[url], (0, $7a71e956bc8f61a8$export$94affb487e701bf2).has(url) && (0, $7a71e956bc8f61a8$export$94affb487e701bf2).remove(url);
    };
    return texture.baseTexture.once("destroyed", ()=>{
        url in loader.promiseCache && (console.warn("[Assets] A BaseTexture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the BaseTexture."), unload());
    }), texture.once("destroyed", ()=>{
        base.destroyed || (console.warn("[Assets] A Texture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the Texture."), unload());
    }), texture;
}


const $4c6161e6a38c0c4a$var$validImageExtensions = [
    ".jpeg",
    ".jpg",
    ".png",
    ".webp",
    ".avif"
], $4c6161e6a38c0c4a$var$validImageMIMEs = [
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/avif"
];
async function $4c6161e6a38c0c4a$export$c614e6247302006d(url) {
    const response = await (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.fetch(url);
    if (!response.ok) throw new Error(`[loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);
    const imageBlob = await response.blob();
    return await createImageBitmap(imageBlob);
}
const $4c6161e6a38c0c4a$export$897b113ee8307cd0 = {
    name: "loadTextures",
    extension: {
        type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $d0164a963de0e9b4$export$820ed6348c4f2750).High
    },
    config: {
        preferWorkers: !0,
        preferCreateImageBitmap: !0,
        crossOrigin: "anonymous"
    },
    test (url) {
        return (0, $bd308d1d651fe041$export$7ff8b059fb914323)(url, $4c6161e6a38c0c4a$var$validImageMIMEs) || (0, $10add1021e67fe4f$export$fd0180357b95b812)(url, $4c6161e6a38c0c4a$var$validImageExtensions);
    },
    async load (url, asset, loader) {
        const useImageBitmap = globalThis.createImageBitmap && this.config.preferCreateImageBitmap;
        let src;
        useImageBitmap ? this.config.preferWorkers && await (0, $5a34bf116bc17e77$export$bcff6015853c67ce).isImageBitmapSupported() ? src = await (0, $5a34bf116bc17e77$export$bcff6015853c67ce).loadImageBitmap(url) : src = await $4c6161e6a38c0c4a$export$c614e6247302006d(url) : src = await new Promise((resolve, reject)=>{
            const src2 = new Image();
            src2.crossOrigin = this.config.crossOrigin, src2.src = url, src2.complete ? resolve(src2) : (src2.onload = ()=>resolve(src2), src2.onerror = (e)=>reject(e));
        });
        const options = {
            ...asset.data
        };
        options.resolution ?? (options.resolution = (0, $29e19754806f3a05$exports).getResolutionOfUrl(url)), useImageBitmap && options.resourceOptions?.ownsImageBitmap === void 0 && (options.resourceOptions = {
            ...options.resourceOptions
        }, options.resourceOptions.ownsImageBitmap = !0);
        const base = new (0, $997b0e421c4045eb$export$d6306e508f184154)(src, options);
        return base.resource.src = url, (0, $ee9b3b11b833a834$export$37b981a8c575f415)(base, loader, url);
    },
    unload (texture) {
        texture.destroy(!0);
    }
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($4c6161e6a38c0c4a$export$897b113ee8307cd0);



const $c9d82867e6993027$var$validSVGExtension = ".svg", $c9d82867e6993027$var$validSVGMIME = "image/svg+xml", $c9d82867e6993027$export$c32505ea942c7f01 = {
    extension: {
        type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $d0164a963de0e9b4$export$820ed6348c4f2750).High
    },
    name: "loadSVG",
    test (url) {
        return (0, $bd308d1d651fe041$export$7ff8b059fb914323)(url, $c9d82867e6993027$var$validSVGMIME) || (0, $10add1021e67fe4f$export$fd0180357b95b812)(url, $c9d82867e6993027$var$validSVGExtension);
    },
    async testParse (data) {
        return (0, $603cb3d5e6d79782$export$aeb8ac9a3d5d46a0).test(data);
    },
    async parse (asset, data, loader) {
        const src = new (0, $603cb3d5e6d79782$export$aeb8ac9a3d5d46a0)(asset, data?.data?.resourceOptions);
        await src.load();
        const base = new (0, $997b0e421c4045eb$export$d6306e508f184154)(src, {
            resolution: (0, $29e19754806f3a05$exports).getResolutionOfUrl(asset),
            ...data?.data
        });
        return base.resource.src = data.src, (0, $ee9b3b11b833a834$export$37b981a8c575f415)(base, loader, data.src);
    },
    async load (url, _options) {
        return (await (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.fetch(url)).text();
    },
    unload: (0, $4c6161e6a38c0c4a$export$897b113ee8307cd0).unload
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($c9d82867e6993027$export$c32505ea942c7f01);








const $e2e6559257c2f29b$var$validVideoExtensions = [
    ".mp4",
    ".m4v",
    ".webm",
    ".ogv"
], $e2e6559257c2f29b$var$validVideoMIMEs = [
    "video/mp4",
    "video/webm",
    "video/ogg"
], $e2e6559257c2f29b$export$d2b008984942555e = {
    name: "loadVideo",
    extension: {
        type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $d0164a963de0e9b4$export$820ed6348c4f2750).High
    },
    config: {
        defaultAutoPlay: !0
    },
    test (url) {
        return (0, $bd308d1d651fe041$export$7ff8b059fb914323)(url, $e2e6559257c2f29b$var$validVideoMIMEs) || (0, $10add1021e67fe4f$export$fd0180357b95b812)(url, $e2e6559257c2f29b$var$validVideoExtensions);
    },
    async load (url, loadAsset, loader) {
        let texture;
        const blob = await (await (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.fetch(url)).blob(), blobURL = URL.createObjectURL(blob);
        try {
            const options = {
                autoPlay: this.config.defaultAutoPlay,
                ...loadAsset?.data?.resourceOptions
            }, src = new (0, $2d1ab4fdb46ab7fe$export$f7dd53bb53e9c0d7)(blobURL, options);
            await src.load();
            const base = new (0, $997b0e421c4045eb$export$d6306e508f184154)(src, {
                alphaMode: await (0, $29e19754806f3a05$exports).detectVideoAlphaMode(),
                resolution: (0, $29e19754806f3a05$exports).getResolutionOfUrl(url),
                ...loadAsset?.data
            });
            base.resource.src = url, texture = (0, $ee9b3b11b833a834$export$37b981a8c575f415)(base, loader, url), texture.baseTexture.once("destroyed", ()=>{
                URL.revokeObjectURL(blobURL);
            });
        } catch (e) {
            throw URL.revokeObjectURL(blobURL), e;
        }
        return texture;
    },
    unload (texture) {
        texture.destroy(!0);
    }
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($e2e6559257c2f29b$export$d2b008984942555e);













class $c30441cb10e63693$export$8b4c839865b08288 {
    constructor(){
        this._defaultBundleIdentifierOptions = {
            connector: "-",
            createBundleAssetId: (bundleId, assetId)=>`${bundleId}${this._bundleIdConnector}${assetId}`,
            extractAssetIdFromBundle: (bundleId, assetBundleId)=>assetBundleId.replace(`${bundleId}${this._bundleIdConnector}`, "")
        }, this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector, this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId, this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle, this._assetMap = {}, this._preferredOrder = [], this._parsers = [], this._resolverHash = {}, this._bundles = {};
    }
    /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */ setBundleIdentifier(bundleIdentifier) {
        if (this._bundleIdConnector = bundleIdentifier.connector ?? this._bundleIdConnector, this._createBundleAssetId = bundleIdentifier.createBundleAssetId ?? this._createBundleAssetId, this._extractAssetIdFromBundle = bundleIdentifier.extractAssetIdFromBundle ?? this._extractAssetIdFromBundle, this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar") throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
    }
    /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */ prefer(...preferOrders) {
        preferOrders.forEach((prefer)=>{
            this._preferredOrder.push(prefer), prefer.priority || (prefer.priority = Object.keys(prefer.params));
        }), this._resolverHash = {};
    }
    /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */ set basePath(basePath) {
        this._basePath = basePath;
    }
    get basePath() {
        return this._basePath;
    }
    /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */ set rootPath(rootPath) {
        this._rootPath = rootPath;
    }
    get rootPath() {
        return this._rootPath;
    }
    /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(settings.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */ get parsers() {
        return this._parsers;
    }
    /** Used for testing, this resets the resolver to its initial state */ reset() {
        this.setBundleIdentifier(this._defaultBundleIdentifierOptions), this._assetMap = {}, this._preferredOrder = [], this._resolverHash = {}, this._rootPath = null, this._basePath = null, this._manifest = null, this._bundles = {}, this._defaultSearchParams = null;
    }
    /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */ setDefaultSearchParams(searchParams) {
        if (typeof searchParams == "string") this._defaultSearchParams = searchParams;
        else {
            const queryValues = searchParams;
            this._defaultSearchParams = Object.keys(queryValues).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(queryValues[key])}`).join("&");
        }
    }
    /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */ getAlias(asset) {
        const { alias: alias, name: name, src: src, srcs: srcs } = asset;
        return (0, $68c70bf6b66546ba$export$b01be8e180bf3d9b)(alias || name || src || srcs, (value)=>typeof value == "string" ? value : Array.isArray(value) ? value.map((v)=>v?.src ?? v?.srcs ?? v) : value?.src || value?.srcs ? value.src ?? value.srcs : value, !0);
    }
    /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */ addManifest(manifest) {
        this._manifest && console.warn("[Resolver] Manifest already exists, this will be overwritten"), this._manifest = manifest, manifest.bundles.forEach((bundle)=>{
            this.addBundle(bundle.name, bundle.assets);
        });
    }
    /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */ addBundle(bundleId, assets) {
        const assetNames = [];
        Array.isArray(assets) ? assets.forEach((asset)=>{
            const srcs = asset.src ?? asset.srcs, aliases = asset.alias ?? asset.name;
            let ids;
            if (typeof aliases == "string") {
                const bundleAssetId = this._createBundleAssetId(bundleId, aliases);
                assetNames.push(bundleAssetId), ids = [
                    aliases,
                    bundleAssetId
                ];
            } else {
                const bundleIds = aliases.map((name)=>this._createBundleAssetId(bundleId, name));
                assetNames.push(...bundleIds), ids = [
                    ...aliases,
                    ...bundleIds
                ];
            }
            this.add({
                ...asset,
                alias: ids,
                src: srcs
            });
        }) : Object.keys(assets).forEach((key)=>{
            const aliases = [
                key,
                this._createBundleAssetId(bundleId, key)
            ];
            if (typeof assets[key] == "string") this.add({
                alias: aliases,
                src: assets[key]
            });
            else if (Array.isArray(assets[key])) this.add({
                alias: aliases,
                src: assets[key]
            });
            else {
                const asset = assets[key], assetSrc = asset.src ?? asset.srcs;
                this.add({
                    ...asset,
                    alias: aliases,
                    src: Array.isArray(assetSrc) ? assetSrc : [
                        assetSrc
                    ]
                });
            }
            assetNames.push(...aliases);
        }), this._bundles[bundleId] = assetNames;
    }
    /**
   * Tells the resolver what keys are associated with witch asset.
   * The most important thing the resolver does
   * @example
   * // Single key, single asset:
   * resolver.add({alias: 'foo', src: 'bar.png');
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Multiple keys, single asset:
   * resolver.add({alias: ['foo', 'boo'], src: 'bar.png'});
   * resolver.resolveUrl('foo') // => 'bar.png'
   * resolver.resolveUrl('boo') // => 'bar.png'
   *
   * // Multiple keys, multiple assets:
   * resolver.add({alias: ['foo', 'boo'], src: ['bar.png', 'bar.webp']});
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Add custom data attached to the resolver
   * Resolver.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode:SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * resolver.resolve('bunnyBooBooSmooth') // => { src: 'bunny.png', data: { scaleMode: SCALE_MODES.NEAREST } }
   * @param aliases - the key or keys that you will reference when loading this asset
   * @param srcs - the asset or assets that will be chosen from when loading via the specified key
   * @param data - asset-specific data that will be passed to the loaders
   * - Useful if you want to initiate loaded objects with specific data
   * @param format - the format of the asset
   * @param loadParser - the name of the load parser to use
   */ add(aliases, srcs, data, format, loadParser) {
        const assets = [];
        typeof aliases == "string" || Array.isArray(aliases) && typeof aliases[0] == "string" ? ((0, $29e19754806f3a05$exports).deprecation("7.2.0", `Assets.add now uses an object instead of individual parameters.
Please use Assets.add({ alias, src, data, format, loadParser }) instead.`), assets.push({
            alias: aliases,
            src: srcs,
            data: data,
            format: format,
            loadParser: loadParser
        })) : Array.isArray(aliases) ? assets.push(...aliases) : assets.push(aliases);
        let keyCheck;
        keyCheck = (key)=>{
            this.hasKey(key) && console.warn(`[Resolver] already has key: ${key} overwriting`);
        }, (0, $68c70bf6b66546ba$export$b01be8e180bf3d9b)(assets).forEach((asset)=>{
            const { src: src, srcs: srcs2 } = asset;
            let { data: data2, format: format2, loadParser: loadParser2 } = asset;
            const srcsToUse = (0, $68c70bf6b66546ba$export$b01be8e180bf3d9b)(src || srcs2).map((src2)=>typeof src2 == "string" ? (0, $7c993261e76bf0b3$export$738117acc6638004)(src2) : Array.isArray(src2) ? src2 : [
                    src2
                ]), aliasesToUse = this.getAlias(asset);
            Array.isArray(aliasesToUse) ? aliasesToUse.forEach(keyCheck) : keyCheck(aliasesToUse);
            const resolvedAssets = [];
            srcsToUse.forEach((srcs3)=>{
                srcs3.forEach((src2)=>{
                    let formattedAsset = {};
                    if (typeof src2 != "object") {
                        formattedAsset.src = src2;
                        for(let i = 0; i < this._parsers.length; i++){
                            const parser = this._parsers[i];
                            if (parser.test(src2)) {
                                formattedAsset = parser.parse(src2);
                                break;
                            }
                        }
                    } else data2 = src2.data ?? data2, format2 = src2.format ?? format2, loadParser2 = src2.loadParser ?? loadParser2, formattedAsset = {
                        ...formattedAsset,
                        ...src2
                    };
                    if (!aliasesToUse) throw new Error(`[Resolver] alias is undefined for this asset: ${formattedAsset.src}`);
                    formattedAsset = this.buildResolvedAsset(formattedAsset, {
                        aliases: aliasesToUse,
                        data: data2,
                        format: format2,
                        loadParser: loadParser2
                    }), resolvedAssets.push(formattedAsset);
                });
            }), aliasesToUse.forEach((alias)=>{
                this._assetMap[alias] = resolvedAssets;
            });
        });
    }
    // TODO: this needs an overload like load did in Assets
    /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     name: 'background',
   *                     srcs: 'sunset.png',
   *                 },
   *                 {
   *                     name: 'bar',
   *                     srcs: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     name: 'character',
   *                     srcs: 'robot.png',
   *                 },
   *                 {
   *                     name: 'enemy',
   *                     srcs: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */ resolveBundle(bundleIds) {
        const singleAsset = (0, $9faa0c91da8fd682$export$16a80d27953452d4)(bundleIds);
        bundleIds = (0, $68c70bf6b66546ba$export$b01be8e180bf3d9b)(bundleIds);
        const out = {};
        return bundleIds.forEach((bundleId)=>{
            const assetNames = this._bundles[bundleId];
            if (assetNames) {
                const results = this.resolve(assetNames), assets = {};
                for(const key in results){
                    const asset = results[key];
                    assets[this._extractAssetIdFromBundle(bundleId, key)] = asset;
                }
                out[bundleId] = assets;
            }
        }), singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */ resolveUrl(key) {
        const result = this.resolve(key);
        if (typeof key != "string") {
            const out = {};
            for(const i in result)out[i] = result[i].src;
            return out;
        }
        return result.src;
    }
    resolve(keys) {
        const singleAsset = (0, $9faa0c91da8fd682$export$16a80d27953452d4)(keys);
        keys = (0, $68c70bf6b66546ba$export$b01be8e180bf3d9b)(keys);
        const result = {};
        return keys.forEach((key)=>{
            if (!this._resolverHash[key]) {
                if (this._assetMap[key]) {
                    let assets = this._assetMap[key];
                    const bestAsset = assets[0], preferredOrder = this._getPreferredOrder(assets);
                    preferredOrder?.priority.forEach((priorityKey)=>{
                        preferredOrder.params[priorityKey].forEach((value)=>{
                            const filteredAssets = assets.filter((asset)=>asset[priorityKey] ? asset[priorityKey] === value : !1);
                            filteredAssets.length && (assets = filteredAssets);
                        });
                    }), this._resolverHash[key] = assets[0] ?? bestAsset;
                } else this._resolverHash[key] = this.buildResolvedAsset({
                    alias: [
                        key
                    ],
                    src: key
                }, {});
            }
            result[key] = this._resolverHash[key];
        }), singleAsset ? result[keys[0]] : result;
    }
    /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */ hasKey(key) {
        return !!this._assetMap[key];
    }
    /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */ hasBundle(key) {
        return !!this._bundles[key];
    }
    /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */ _getPreferredOrder(assets) {
        for(let i = 0; i < assets.length; i++){
            const asset = assets[0], preferred = this._preferredOrder.find((preference)=>preference.params.format.includes(asset.format));
            if (preferred) return preferred;
        }
        return this._preferredOrder[0];
    }
    /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */ _appendDefaultSearchParams(url) {
        if (!this._defaultSearchParams) return url;
        const paramConnector = /\?/.test(url) ? "&" : "?";
        return `${url}${paramConnector}${this._defaultSearchParams}`;
    }
    buildResolvedAsset(formattedAsset, data) {
        const { aliases: aliases, data: assetData, loadParser: loadParser, format: format } = data;
        return (this._basePath || this._rootPath) && (formattedAsset.src = (0, $29e19754806f3a05$exports).path.toAbsolute(formattedAsset.src, this._basePath, this._rootPath)), formattedAsset.alias = aliases ?? formattedAsset.alias ?? [
            formattedAsset.src
        ], formattedAsset.src = this._appendDefaultSearchParams(formattedAsset.src), formattedAsset.data = {
            ...assetData || {},
            ...formattedAsset.data
        }, formattedAsset.loadParser = loadParser ?? formattedAsset.loadParser, formattedAsset.format = format ?? formattedAsset.src.split(".").pop(), formattedAsset.srcs = formattedAsset.src, formattedAsset.name = formattedAsset.alias, formattedAsset;
    }
}





class $5da168d5c5fa57e0$export$137d4dd907afac85 {
    constructor(){
        this._detections = [], this._initialized = !1, this.resolver = new (0, $c30441cb10e63693$export$8b4c839865b08288)(), this.loader = new (0, $6573053e2cf89c65$export$3b0d6d7590275603)(), this.cache = (0, $7a71e956bc8f61a8$export$94affb487e701bf2), this._backgroundLoader = new (0, $fabaa3b26410279e$export$1949379a83b843d5)(this.loader), this._backgroundLoader.active = !0, this.reset();
    }
    /**
   * Best practice is to call this function before any loading commences
   * Initiating is the best time to add any customization to the way things are loaded.
   *
   * you do not need to call this for the Asset class to work, only if you want to set any initial properties
   * @param options - options to initialize the Asset manager with
   */ async init(options = {}) {
        if (this._initialized) {
            console.warn("[Assets]AssetManager already initialized, did you load before calling this Asset.init()?");
            return;
        }
        if (this._initialized = !0, options.defaultSearchParams && this.resolver.setDefaultSearchParams(options.defaultSearchParams), options.basePath && (this.resolver.basePath = options.basePath), options.bundleIdentifier && this.resolver.setBundleIdentifier(options.bundleIdentifier), options.manifest) {
            let manifest = options.manifest;
            typeof manifest == "string" && (manifest = await this.load(manifest)), this.resolver.addManifest(manifest);
        }
        const resolutionPref = options.texturePreference?.resolution ?? 1, resolution = typeof resolutionPref == "number" ? [
            resolutionPref
        ] : resolutionPref, formats = await this._detectFormats({
            preferredFormats: options.texturePreference?.format,
            skipDetections: options.skipDetections,
            detections: this._detections
        });
        this.resolver.prefer({
            params: {
                format: formats,
                resolution: resolution
            }
        }), options.preferences && this.setPreferences(options.preferences);
    }
    /**
   * Allows you to specify how to resolve any assets load requests.
   * There are a few ways to add things here as shown below:
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Simple
   * Assets.add({alias: 'bunnyBooBoo', src: 'bunny.png'});
   * const bunny = await Assets.load('bunnyBooBoo');
   *
   * // Multiple keys:
   * Assets.add({alias: ['burger', 'chicken'], src: 'bunny.png'});
   *
   * const bunny = await Assets.load('burger');
   * const bunny2 = await Assets.load('chicken');
   *
   * // passing options to to the object
   * Assets.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode: SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * // Multiple assets
   *
   * // The following all do the same thing:
   *
   * Assets.add({alias: 'bunnyBooBoo', src: 'bunny{png,webp}'});
   *
   * Assets.add({
   *     alias: 'bunnyBooBoo',
   *     src: [
   *         'bunny.png',
   *         'bunny.webp',
   *    ],
   * });
   *
   * const bunny = await Assets.load('bunnyBooBoo'); // Will try to load WebP if available
   * @param aliases - the key or keys that you will reference when loading this asset
   * @param srcs - the asset or assets that will be chosen from when loading via the specified key
   * @param data - asset-specific data that will be passed to the loaders
   * - Useful if you want to initiate loaded objects with specific data
   * @param format - the format of the asset
   * @param loadParser - the name of the load parser to use
   */ add(aliases, srcs, data, format, loadParser) {
        this.resolver.add(aliases, srcs, data, format, loadParser);
    }
    async load(urls, onProgress) {
        this._initialized || await this.init();
        const singleAsset = (0, $9faa0c91da8fd682$export$16a80d27953452d4)(urls), urlArray = (0, $68c70bf6b66546ba$export$b01be8e180bf3d9b)(urls).map((url)=>{
            if (typeof url != "string") {
                const aliases = this.resolver.getAlias(url);
                return aliases.some((alias)=>!this.resolver.hasKey(alias)) && this.add(url), Array.isArray(aliases) ? aliases[0] : aliases;
            }
            return this.resolver.hasKey(url) || this.add({
                alias: url,
                src: url
            }), url;
        }), resolveResults = this.resolver.resolve(urlArray), out = await this._mapLoadToResolve(resolveResults, onProgress);
        return singleAsset ? out[urlArray[0]] : out;
    }
    /**
   * This adds a bundle of assets in one go so that you can load them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const assets = await Assets.loadBundle('animals');
   * @param bundleId - the id of the bundle to add
   * @param assets - a record of the asset or assets that will be chosen from when loading via the specified key
   */ addBundle(bundleId, assets) {
        this.resolver.addBundle(bundleId, assets);
    }
    /**
   * Bundles are a way to load multiple assets at once.
   * If a manifest has been provided to the init function then you can load a bundle, or bundles.
   * you can also add bundles via `addBundle`
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     name: 'background',
   *                     srcs: 'sunset.png',
   *                 },
   *                 {
   *                     name: 'bar',
   *                     srcs: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     name: 'character',
   *                     srcs: 'robot.png',
   *                 },
   *                 {
   *                     name: 'enemy',
   *                     srcs: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * await Asset.init({ manifest });
   *
   * // Load a bundle...
   * loadScreenAssets = await Assets.loadBundle('load-screen');
   * // Load another bundle...
   * gameScreenAssets = await Assets.loadBundle('game-screen');
   * @param bundleIds - the bundle id or ids to load
   * @param onProgress - Optional function that is called when progress on asset loading is made.
   * The function is passed a single parameter, `progress`, which represents the percentage (0.0 - 1.0)
   * of the assets loaded. Do not use this function to detect when assets are complete and available,
   * instead use the Promise returned by this function.
   * @returns all the bundles assets or a hash of assets for each bundle specified
   */ async loadBundle(bundleIds, onProgress) {
        this._initialized || await this.init();
        let singleAsset = !1;
        typeof bundleIds == "string" && (singleAsset = !0, bundleIds = [
            bundleIds
        ]);
        const resolveResults = this.resolver.resolveBundle(bundleIds), out = {}, keys = Object.keys(resolveResults);
        let count = 0, total = 0;
        const _onProgress = ()=>{
            onProgress?.(++count / total);
        }, promises = keys.map((bundleId)=>{
            const resolveResult = resolveResults[bundleId];
            return total += Object.keys(resolveResult).length, this._mapLoadToResolve(resolveResult, _onProgress).then((resolveResult2)=>{
                out[bundleId] = resolveResult2;
            });
        });
        return await Promise.all(promises), singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Initiate a background load of some assets. It will passively begin to load these assets in the background.
   * So when you actually come to loading them you will get a promise that resolves to the loaded assets immediately
   *
   * An example of this might be that you would background load game assets after your inital load.
   * then when you got to actually load your game screen assets when a player goes to the game - the loading
   * would already have stared or may even be complete, saving you having to show an interim load bar.
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.backgroundLoad('bunny.png');
   *
   * // later on in your app...
   * await Assets.loadBundle('bunny.png'); // Will resolve quicker as loading may have completed!
   * @param urls - the url / urls you want to background load
   */ async backgroundLoad(urls) {
        this._initialized || await this.init(), typeof urls == "string" && (urls = [
            urls
        ]);
        const resolveResults = this.resolver.resolve(urls);
        this._backgroundLoader.add(Object.values(resolveResults));
    }
    /**
   * Initiate a background of a bundle, works exactly like backgroundLoad but for bundles.
   * this can only be used if the loader has been initiated with a manifest
   * @example
   * import { Assets } from 'pixi.js';
   *
   * await Assets.init({
   *     manifest: {
   *         bundles: [
   *             {
   *                 name: 'load-screen',
   *                 assets: [...],
   *             },
   *             ...
   *         ],
   *     },
   * });
   *
   * Assets.backgroundLoadBundle('load-screen');
   *
   * // Later on in your app...
   * await Assets.loadBundle('load-screen'); // Will resolve quicker as loading may have completed!
   * @param bundleIds - the bundleId / bundleIds you want to background load
   */ async backgroundLoadBundle(bundleIds) {
        this._initialized || await this.init(), typeof bundleIds == "string" && (bundleIds = [
            bundleIds
        ]);
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        Object.values(resolveResults).forEach((resolveResult)=>{
            this._backgroundLoader.add(Object.values(resolveResult));
        });
    }
    /**
   * Only intended for development purposes.
   * This will wipe the resolver and caches.
   * You will need to reinitialize the Asset
   */ reset() {
        this.resolver.reset(), this.loader.reset(), this.cache.reset(), this._initialized = !1;
    }
    get(keys) {
        if (typeof keys == "string") return (0, $7a71e956bc8f61a8$export$94affb487e701bf2).get(keys);
        const assets = {};
        for(let i = 0; i < keys.length; i++)assets[i] = (0, $7a71e956bc8f61a8$export$94affb487e701bf2).get(keys[i]);
        return assets;
    }
    /**
   * helper function to map resolved assets back to loaded assets
   * @param resolveResults - the resolve results from the resolver
   * @param onProgress - the progress callback
   */ async _mapLoadToResolve(resolveResults, onProgress) {
        const resolveArray = Object.values(resolveResults), resolveKeys = Object.keys(resolveResults);
        this._backgroundLoader.active = !1;
        const loadedAssets = await this.loader.load(resolveArray, onProgress);
        this._backgroundLoader.active = !0;
        const out = {};
        return resolveArray.forEach((resolveResult, i)=>{
            const asset = loadedAssets[resolveResult.src], keys = [
                resolveResult.src
            ];
            resolveResult.alias && keys.push(...resolveResult.alias), out[resolveKeys[i]] = asset, (0, $7a71e956bc8f61a8$export$94affb487e701bf2).set(keys, asset);
        }), out;
    }
    /**
   * Unload an asset or assets. As the Assets class is responsible for creating the assets via the `load` function
   * this will make sure to destroy any assets and release them from memory.
   * Once unloaded, you will need to load the asset again.
   *
   * Use this to help manage assets if you find that you have a large app and you want to free up memory.
   *
   * - it's up to you as the developer to make sure that textures are not actively being used when you unload them,
   * Pixi won't break but you will end up with missing assets. Not a good look for the user!
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Load a URL:
   * const myImageTexture = await Assets.load('http://some.url.com/image.png'); // => returns a texture
   *
   * await Assets.unload('http://some.url.com/image.png')
   *
   * // myImageTexture will be destroyed now.
   *
   * // Unload multiple assets:
   * const textures = await Assets.unload(['thumper', 'chicko']);
   * @param urls - the urls to unload
   */ async unload(urls) {
        this._initialized || await this.init();
        const urlArray = (0, $68c70bf6b66546ba$export$b01be8e180bf3d9b)(urls).map((url)=>typeof url != "string" ? url.src : url), resolveResults = this.resolver.resolve(urlArray);
        await this._unloadFromResolved(resolveResults);
    }
    /**
   * Bundles are a way to manage multiple assets at once.
   * this will unload all files in a bundle.
   *
   * once a bundle has been unloaded, you need to load it again to have access to the assets.
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.addBundle({
   *     'thumper': 'http://some.url.com/thumper.png',
   * })
   *
   * const assets = await Assets.loadBundle('thumper');
   *
   * // Now to unload...
   *
   * await Assets.unloadBundle('thumper');
   *
   * // All assets in the assets object will now have been destroyed and purged from the cache
   * @param bundleIds - the bundle id or ids to unload
   */ async unloadBundle(bundleIds) {
        this._initialized || await this.init(), bundleIds = (0, $68c70bf6b66546ba$export$b01be8e180bf3d9b)(bundleIds);
        const resolveResults = this.resolver.resolveBundle(bundleIds), promises = Object.keys(resolveResults).map((bundleId)=>this._unloadFromResolved(resolveResults[bundleId]));
        await Promise.all(promises);
    }
    async _unloadFromResolved(resolveResult) {
        const resolveArray = Object.values(resolveResult);
        resolveArray.forEach((resolveResult2)=>{
            (0, $7a71e956bc8f61a8$export$94affb487e701bf2).remove(resolveResult2.src);
        }), await this.loader.unload(resolveArray);
    }
    /**
   * Detects the supported formats for the browser, and returns an array of supported formats, respecting
   * the users preferred formats order.
   * @param options - the options to use when detecting formats
   * @param options.preferredFormats - the preferred formats to use
   * @param options.skipDetections - if we should skip the detections altogether
   * @param options.detections - the detections to use
   * @returns - the detected formats
   */ async _detectFormats(options) {
        let formats = [];
        options.preferredFormats && (formats = Array.isArray(options.preferredFormats) ? options.preferredFormats : [
            options.preferredFormats
        ]);
        for (const detection of options.detections)options.skipDetections || await detection.test() ? formats = await detection.add(formats) : options.skipDetections || (formats = await detection.remove(formats));
        return formats = formats.filter((format, index)=>formats.indexOf(format) === index), formats;
    }
    /** All the detection parsers currently added to the Assets class. */ get detections() {
        return this._detections;
    }
    /**
   * @deprecated since 7.2.0
   * @see {@link Assets.setPreferences}
   */ get preferWorkers() {
        return (0, $4c6161e6a38c0c4a$export$897b113ee8307cd0).config.preferWorkers;
    }
    set preferWorkers(value) {
        (0, $29e19754806f3a05$exports).deprecation("7.2.0", "Assets.prefersWorkers is deprecated, use Assets.setPreferences({ preferWorkers: true }) instead."), this.setPreferences({
            preferWorkers: value
        });
    }
    /**
   * General setter for preferences. This is a helper function to set preferences on all parsers.
   * @param preferences - the preferences to set
   */ setPreferences(preferences) {
        this.loader.parsers.forEach((parser)=>{
            parser.config && Object.keys(parser.config).filter((key)=>key in preferences).forEach((key)=>{
                parser.config[key] = preferences[key];
            });
        });
    }
}
const $5da168d5c5fa57e0$export$c8eca95e306f7116 = new $5da168d5c5fa57e0$export$137d4dd907afac85();
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).handleByList((0, $69f9a88446c99188$export$4f037c6ec2da4eeb).LoadParser, $5da168d5c5fa57e0$export$c8eca95e306f7116.loader.parsers).handleByList((0, $69f9a88446c99188$export$4f037c6ec2da4eeb).ResolveParser, $5da168d5c5fa57e0$export$c8eca95e306f7116.resolver.parsers).handleByList((0, $69f9a88446c99188$export$4f037c6ec2da4eeb).CacheParser, $5da168d5c5fa57e0$export$c8eca95e306f7116.cache.parsers).handleByList((0, $69f9a88446c99188$export$4f037c6ec2da4eeb).DetectionParser, $5da168d5c5fa57e0$export$c8eca95e306f7116.detections);






const $19d2e944c1b52196$export$407b4625a915919d = {
    extension: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).CacheParser,
    test: (asset)=>Array.isArray(asset) && asset.every((t)=>t instanceof (0, $ad1fffd072a707c2$export$5431306cf43de24a)),
    getCacheableAssets: (keys, asset)=>{
        const out = {};
        return keys.forEach((key)=>{
            asset.forEach((item, i)=>{
                out[key + (i === 0 ? "" : i + 1)] = item;
            });
        }), out;
    }
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($19d2e944c1b52196$export$407b4625a915919d);







const $f1676df27181f605$export$a60d2d4a3c570783 = {
    extension: {
        type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).DetectionParser,
        priority: 1
    },
    test: async ()=>{
        const avifData = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=";
        return new Promise((resolve)=>{
            const avif = new Image();
            avif.onload = ()=>{
                resolve(!0);
            }, avif.onerror = ()=>{
                resolve(!1);
            }, avif.src = avifData;
        });
    },
    add: async (formats)=>[
            ...formats,
            "avif"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "avif")
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($f1676df27181f605$export$a60d2d4a3c570783);



const $6bb0ff14dc370642$export$d19529a9ed9823d4 = {
    extension: {
        type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).DetectionParser,
        priority: 0
    },
    test: async ()=>{
        const webpData = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=";
        return new Promise((resolve)=>{
            const webp = new Image();
            webp.onload = ()=>{
                resolve(!0);
            }, webp.onerror = ()=>{
                resolve(!1);
            }, webp.src = webpData;
        });
    },
    add: async (formats)=>[
            ...formats,
            "webp"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webp")
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($6bb0ff14dc370642$export$d19529a9ed9823d4);



const $97a89e34b0f96f24$var$imageFormats = [
    "png",
    "jpg",
    "jpeg"
], $97a89e34b0f96f24$export$b106d7c2de3b4d89 = {
    extension: {
        type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).DetectionParser,
        priority: -1
    },
    test: ()=>Promise.resolve(!0),
    add: async (formats)=>[
            ...formats,
            ...$97a89e34b0f96f24$var$imageFormats
        ],
    remove: async (formats)=>formats.filter((f)=>!$97a89e34b0f96f24$var$imageFormats.includes(f))
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($97a89e34b0f96f24$export$b106d7c2de3b4d89);



const $33b5ad8953ebbe4d$var$inWorker = "WorkerGlobalScope" in globalThis && globalThis instanceof globalThis.WorkerGlobalScope;
function $33b5ad8953ebbe4d$export$7a571c147b03abb1(mimeType) {
    return $33b5ad8953ebbe4d$var$inWorker ? !1 : document.createElement("video").canPlayType(mimeType) !== "";
}


const $77bf8e358f4ace5e$export$a041d698a1896657 = {
    extension: {
        type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $33b5ad8953ebbe4d$export$7a571c147b03abb1)("video/webm"),
    add: async (formats)=>[
            ...formats,
            "webm"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webm")
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($77bf8e358f4ace5e$export$a041d698a1896657);




const $69488df095a576d7$export$7726d83fee274e25 = {
    extension: {
        type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $33b5ad8953ebbe4d$export$7a571c147b03abb1)("video/mp4"),
    add: async (formats)=>[
            ...formats,
            "mp4",
            "m4v"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "mp4" && f !== "m4v")
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($69488df095a576d7$export$7726d83fee274e25);




const $a2fea3d4520b589b$export$5a1da481121f806a = {
    extension: {
        type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $33b5ad8953ebbe4d$export$7a571c147b03abb1)("video/ogg"),
    add: async (formats)=>[
            ...formats,
            "ogv"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "ogv")
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($a2fea3d4520b589b$export$5a1da481121f806a);












const $30556d89784e3324$export$cc356fa83de02bea = {
    extension: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).ResolveParser,
    test: (0, $4c6161e6a38c0c4a$export$897b113ee8307cd0).test,
    parse: (value)=>({
            resolution: parseFloat((0, $5340ccf8570d4063$export$a5a6e0b888b2c992).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
            format: value.split(".").pop(),
            src: value
        })
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($30556d89784e3324$export$cc356fa83de02bea);




































var $24e929601ce4a949$export$9a3c57b95f3e5f5d = /* @__PURE__ */ ((INTERNAL_FORMATS2)=>(INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB_S3TC_DXT1_EXT = 33776] = "COMPRESSED_RGB_S3TC_DXT1_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_S3TC_DXT1_EXT = 33777] = "COMPRESSED_RGBA_S3TC_DXT1_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_S3TC_DXT3_EXT = 33778] = "COMPRESSED_RGBA_S3TC_DXT3_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_S3TC_DXT5_EXT = 33779] = "COMPRESSED_RGBA_S3TC_DXT5_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT = 35917] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT = 35918] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT = 35919] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB_S3TC_DXT1_EXT = 35916] = "COMPRESSED_SRGB_S3TC_DXT1_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_R11_EAC = 37488] = "COMPRESSED_R11_EAC", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SIGNED_R11_EAC = 37489] = "COMPRESSED_SIGNED_R11_EAC", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RG11_EAC = 37490] = "COMPRESSED_RG11_EAC", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SIGNED_RG11_EAC = 37491] = "COMPRESSED_SIGNED_RG11_EAC", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB8_ETC2 = 37492] = "COMPRESSED_RGB8_ETC2", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA8_ETC2_EAC = 37496] = "COMPRESSED_RGBA8_ETC2_EAC", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB8_ETC2 = 37493] = "COMPRESSED_SRGB8_ETC2", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC = 37497] = "COMPRESSED_SRGB8_ALPHA8_ETC2_EAC", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37494] = "COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37495] = "COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB_PVRTC_4BPPV1_IMG = 35840] = "COMPRESSED_RGB_PVRTC_4BPPV1_IMG", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG = 35842] = "COMPRESSED_RGBA_PVRTC_4BPPV1_IMG", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB_PVRTC_2BPPV1_IMG = 35841] = "COMPRESSED_RGB_PVRTC_2BPPV1_IMG", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG = 35843] = "COMPRESSED_RGBA_PVRTC_2BPPV1_IMG", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB_ETC1_WEBGL = 36196] = "COMPRESSED_RGB_ETC1_WEBGL", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB_ATC_WEBGL = 35986] = "COMPRESSED_RGB_ATC_WEBGL", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL = 35986] = "COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL = 34798] = "COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_ASTC_4x4_KHR = 37808] = "COMPRESSED_RGBA_ASTC_4x4_KHR", INTERNAL_FORMATS2))($24e929601ce4a949$export$9a3c57b95f3e5f5d || {});
const $24e929601ce4a949$export$fb888e587c979eee = {
    // WEBGL_compressed_texture_s3tc
    33776: 0.5,
    33777: 0.5,
    33778: 1,
    33779: 1,
    // WEBGL_compressed_texture_s3tc
    35916: 0.5,
    35917: 0.5,
    35918: 1,
    35919: 1,
    // WEBGL_compressed_texture_etc
    37488: 0.5,
    37489: 0.5,
    37490: 1,
    37491: 1,
    37492: 0.5,
    37496: 1,
    37493: 0.5,
    37497: 1,
    37494: 0.5,
    // ~~
    37495: 0.5,
    // ~~
    // WEBGL_compressed_texture_pvrtc
    35840: 0.5,
    35842: 0.5,
    35841: 0.25,
    35843: 0.25,
    // WEBGL_compressed_texture_etc1
    36196: 0.5,
    // @see https://www.khronos.org/registry/OpenGL/extensions/AMD/AMD_compressed_ATC_texture.txt
    // WEBGL_compressed_texture_atc
    35986: 0.5,
    35986: 1,
    34798: 1,
    // @see https://registry.khronos.org/OpenGL/extensions/KHR/KHR_texture_compression_astc_hdr.txt
    // WEBGL_compressed_texture_astc
    /* eslint-disable-next-line camelcase */ 37808: 1
};





let $3145f43565e0453f$var$storedGl, $3145f43565e0453f$var$extensions;
function $3145f43565e0453f$var$getCompressedTextureExtensions() {
    $3145f43565e0453f$var$extensions = {
        s3tc: $3145f43565e0453f$var$storedGl.getExtension("WEBGL_compressed_texture_s3tc"),
        s3tc_sRGB: $3145f43565e0453f$var$storedGl.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
        /* eslint-disable-line camelcase */ etc: $3145f43565e0453f$var$storedGl.getExtension("WEBGL_compressed_texture_etc"),
        etc1: $3145f43565e0453f$var$storedGl.getExtension("WEBGL_compressed_texture_etc1"),
        pvrtc: $3145f43565e0453f$var$storedGl.getExtension("WEBGL_compressed_texture_pvrtc") || $3145f43565e0453f$var$storedGl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
        atc: $3145f43565e0453f$var$storedGl.getExtension("WEBGL_compressed_texture_atc"),
        astc: $3145f43565e0453f$var$storedGl.getExtension("WEBGL_compressed_texture_astc")
    };
}
const $3145f43565e0453f$export$82cf9629b7380430 = {
    extension: {
        type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).DetectionParser,
        priority: 2
    },
    test: async ()=>{
        const gl = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.createCanvas().getContext("webgl");
        return gl ? ($3145f43565e0453f$var$storedGl = gl, !0) : (console.warn("WebGL not available for compressed textures."), !1);
    },
    add: async (formats)=>{
        $3145f43565e0453f$var$extensions || $3145f43565e0453f$var$getCompressedTextureExtensions();
        const textureFormats = [];
        for(const extensionName in $3145f43565e0453f$var$extensions)$3145f43565e0453f$var$extensions[extensionName] && textureFormats.push(extensionName);
        return [
            ...textureFormats,
            ...formats
        ];
    },
    remove: async (formats)=>($3145f43565e0453f$var$extensions || $3145f43565e0453f$var$getCompressedTextureExtensions(), formats.filter((f)=>!(f in $3145f43565e0453f$var$extensions)))
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($3145f43565e0453f$export$82cf9629b7380430);






class $724cf118529cf5cf$export$f257f839012584a2 extends (0, $967525537d2ce935$export$a79ef781de624449) {
    /**
   * @param source - The buffer/URL of the texture file.
   * @param {PIXI.IBlobResourceOptions} [options]
   * @param {boolean} [options.autoLoad=false] - Whether to fetch the data immediately;
   *  you can fetch it later via {@link PIXI.BlobResource#load}.
   * @param {number} [options.width=1] - The width in pixels.
   * @param {number} [options.height=1] - The height in pixels.
   * @param {1|2|4|8} [options.unpackAlignment=4] - The alignment of the pixel rows.
   */ constructor(source, options = {
        width: 1,
        height: 1,
        autoLoad: !0
    }){
        let origin, data;
        typeof source == "string" ? (origin = source, data = new Uint8Array()) : (origin = null, data = source), super(data, options), this.origin = origin, this.buffer = data ? new (0, $91d9b5ed0541dc7e$export$4fdbf0662aa3047a)(data) : null, this._load = null, this.loaded = !1, this.origin !== null && options.autoLoad !== !1 && this.load(), this.origin === null && this.buffer && (this._load = Promise.resolve(this), this.loaded = !0, this.onBlobLoaded(this.buffer.rawBinaryData));
    }
    onBlobLoaded(_data) {}
    /** Loads the blob */ load() {
        return this._load ? this._load : (this._load = fetch(this.origin).then((response)=>response.blob()).then((blob)=>blob.arrayBuffer()).then((arrayBuffer)=>(this.data = new Uint32Array(arrayBuffer), this.buffer = new (0, $91d9b5ed0541dc7e$export$4fdbf0662aa3047a)(arrayBuffer), this.loaded = !0, this.onBlobLoaded(arrayBuffer), this.update(), this)), this._load);
    }
}




class $8b74d5c244726983$export$1982af6892f05657 extends (0, $724cf118529cf5cf$export$f257f839012584a2) {
    /**
   * @param source - the buffer/URL holding the compressed texture data
   * @param options
   * @param {PIXI.INTERNAL_FORMATS} options.format - the compression format
   * @param {number} options.width - the image width in pixels.
   * @param {number} options.height - the image height in pixels.
   * @param {number} [options.level=1] - the mipmap levels stored in the compressed texture, including level 0.
   * @param {number} [options.levelBuffers] - the buffers for each mipmap level. `CompressedTextureResource` can allows you
   *      to pass `null` for `source`, for cases where each level is stored in non-contiguous memory.
   */ constructor(source, options){
        super(source, options), this.format = options.format, this.levels = options.levels || 1, this._width = options.width, this._height = options.height, this._extension = $8b74d5c244726983$export$1982af6892f05657._formatToExtension(this.format), (options.levelBuffers || this.buffer) && (this._levelBuffers = options.levelBuffers || $8b74d5c244726983$export$1982af6892f05657._createLevelBuffers(source instanceof Uint8Array ? source : this.buffer.uint8View, this.format, this.levels, 4, 4, // PVRTC has 8x4 blocks in 2bpp mode
        this.width, this.height));
    }
    /**
   * @override
   * @param renderer - A reference to the current renderer
   * @param _texture - the texture
   * @param _glTexture - texture instance for this webgl context
   */ upload(renderer, _texture, _glTexture) {
        const gl = renderer.gl;
        if (!renderer.context.extensions[this._extension]) throw new Error(`${this._extension} textures are not supported on the current machine`);
        if (!this._levelBuffers) return !1;
        gl.pixelStorei(gl.UNPACK_ALIGNMENT, 4);
        for(let i = 0, j = this.levels; i < j; i++){
            const { levelID: levelID, levelWidth: levelWidth, levelHeight: levelHeight, levelBuffer: levelBuffer } = this._levelBuffers[i];
            gl.compressedTexImage2D(gl.TEXTURE_2D, levelID, this.format, levelWidth, levelHeight, 0, levelBuffer);
        }
        return !0;
    }
    /** @protected */ onBlobLoaded() {
        this._levelBuffers = $8b74d5c244726983$export$1982af6892f05657._createLevelBuffers(this.buffer.uint8View, this.format, this.levels, 4, 4, // PVRTC has 8x4 blocks in 2bpp mode
        this.width, this.height);
    }
    /**
   * Returns the key (to ContextSystem#extensions) for the WebGL extension supporting the compression format
   * @private
   * @param format - the compression format to get the extension for.
   */ static _formatToExtension(format) {
        if (format >= 33776 && format <= 33779) return "s3tc";
        if (format >= 37488 && format <= 37497) return "etc";
        if (format >= 35840 && format <= 35843) return "pvrtc";
        if (format >= 36196) return "etc1";
        if (format >= 35986 && format <= 34798) return "atc";
        throw new Error("Invalid (compressed) texture format given!");
    }
    /**
   * Pre-creates buffer views for each mipmap level
   * @private
   * @param buffer -
   * @param format - compression formats
   * @param levels - mipmap levels
   * @param blockWidth -
   * @param blockHeight -
   * @param imageWidth - width of the image in pixels
   * @param imageHeight - height of the image in pixels
   */ static _createLevelBuffers(buffer, format, levels, blockWidth, blockHeight, imageWidth, imageHeight) {
        const buffers = new Array(levels);
        let offset = buffer.byteOffset, levelWidth = imageWidth, levelHeight = imageHeight, alignedLevelWidth = levelWidth + blockWidth - 1 & ~(blockWidth - 1), alignedLevelHeight = levelHeight + blockHeight - 1 & ~(blockHeight - 1), levelSize = alignedLevelWidth * alignedLevelHeight * (0, $24e929601ce4a949$export$fb888e587c979eee)[format];
        for(let i = 0; i < levels; i++)buffers[i] = {
            levelID: i,
            levelWidth: levels > 1 ? levelWidth : alignedLevelWidth,
            levelHeight: levels > 1 ? levelHeight : alignedLevelHeight,
            levelBuffer: new Uint8Array(buffer.buffer, offset, levelSize)
        }, offset += levelSize, levelWidth = levelWidth >> 1 || 1, levelHeight = levelHeight >> 1 || 1, alignedLevelWidth = levelWidth + blockWidth - 1 & ~(blockWidth - 1), alignedLevelHeight = levelHeight + blockHeight - 1 & ~(blockHeight - 1), levelSize = alignedLevelWidth * alignedLevelHeight * (0, $24e929601ce4a949$export$fb888e587c979eee)[format];
        return buffers;
    }
}





const $8feea74fdb87b284$var$DDS_MAGIC_SIZE = 4, $8feea74fdb87b284$var$DDS_HEADER_SIZE = 124, $8feea74fdb87b284$var$DDS_HEADER_PF_SIZE = 32, $8feea74fdb87b284$var$DDS_HEADER_DX10_SIZE = 20, $8feea74fdb87b284$var$DDS_MAGIC = 542327876, $8feea74fdb87b284$var$DDS_FIELDS = {
    SIZE: 1,
    FLAGS: 2,
    HEIGHT: 3,
    WIDTH: 4,
    MIPMAP_COUNT: 7,
    PIXEL_FORMAT: 19
}, $8feea74fdb87b284$var$DDS_PF_FIELDS = {
    SIZE: 0,
    FLAGS: 1,
    FOURCC: 2,
    RGB_BITCOUNT: 3,
    R_BIT_MASK: 4,
    G_BIT_MASK: 5,
    B_BIT_MASK: 6,
    A_BIT_MASK: 7
}, $8feea74fdb87b284$var$DDS_DX10_FIELDS = {
    DXGI_FORMAT: 0,
    RESOURCE_DIMENSION: 1,
    MISC_FLAG: 2,
    ARRAY_SIZE: 3,
    MISC_FLAGS2: 4
}, $8feea74fdb87b284$var$PF_FLAGS = 1, $8feea74fdb87b284$var$DDPF_ALPHA = 2, $8feea74fdb87b284$var$DDPF_FOURCC = 4, $8feea74fdb87b284$var$DDPF_RGB = 64, $8feea74fdb87b284$var$DDPF_YUV = 512, $8feea74fdb87b284$var$DDPF_LUMINANCE = 131072, $8feea74fdb87b284$var$FOURCC_DXT1 = 827611204, $8feea74fdb87b284$var$FOURCC_DXT3 = 861165636, $8feea74fdb87b284$var$FOURCC_DXT5 = 894720068, $8feea74fdb87b284$var$FOURCC_DX10 = 808540228, $8feea74fdb87b284$var$DDS_RESOURCE_MISC_TEXTURECUBE = 4, $8feea74fdb87b284$var$FOURCC_TO_FORMAT = {
    [$8feea74fdb87b284$var$FOURCC_DXT1]: (0, $24e929601ce4a949$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT1_EXT,
    [$8feea74fdb87b284$var$FOURCC_DXT3]: (0, $24e929601ce4a949$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT3_EXT,
    [$8feea74fdb87b284$var$FOURCC_DXT5]: (0, $24e929601ce4a949$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT5_EXT
}, $8feea74fdb87b284$var$DXGI_TO_FORMAT = {
    // WEBGL_compressed_texture_s3tc
    70: (0, $24e929601ce4a949$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT1_EXT,
    71: (0, $24e929601ce4a949$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT1_EXT,
    73: (0, $24e929601ce4a949$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT3_EXT,
    74: (0, $24e929601ce4a949$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT3_EXT,
    76: (0, $24e929601ce4a949$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT5_EXT,
    77: (0, $24e929601ce4a949$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT5_EXT,
    // WEBGL_compressed_texture_s3tc_srgb
    72: (0, $24e929601ce4a949$export$9a3c57b95f3e5f5d).COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT,
    75: (0, $24e929601ce4a949$export$9a3c57b95f3e5f5d).COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT,
    78: (0, $24e929601ce4a949$export$9a3c57b95f3e5f5d).COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT
};
function $8feea74fdb87b284$export$cddc4925efe88ac(arrayBuffer) {
    const data = new Uint32Array(arrayBuffer);
    if (data[0] !== $8feea74fdb87b284$var$DDS_MAGIC) throw new Error("Invalid DDS file magic word");
    const header = new Uint32Array(arrayBuffer, 0, $8feea74fdb87b284$var$DDS_HEADER_SIZE / Uint32Array.BYTES_PER_ELEMENT), height = header[$8feea74fdb87b284$var$DDS_FIELDS.HEIGHT], width = header[$8feea74fdb87b284$var$DDS_FIELDS.WIDTH], mipmapCount = header[$8feea74fdb87b284$var$DDS_FIELDS.MIPMAP_COUNT], pixelFormat = new Uint32Array(arrayBuffer, $8feea74fdb87b284$var$DDS_FIELDS.PIXEL_FORMAT * Uint32Array.BYTES_PER_ELEMENT, $8feea74fdb87b284$var$DDS_HEADER_PF_SIZE / Uint32Array.BYTES_PER_ELEMENT), formatFlags = pixelFormat[$8feea74fdb87b284$var$PF_FLAGS];
    if (formatFlags & $8feea74fdb87b284$var$DDPF_FOURCC) {
        const fourCC = pixelFormat[$8feea74fdb87b284$var$DDS_PF_FIELDS.FOURCC];
        if (fourCC !== $8feea74fdb87b284$var$FOURCC_DX10) {
            const internalFormat2 = $8feea74fdb87b284$var$FOURCC_TO_FORMAT[fourCC], dataOffset2 = $8feea74fdb87b284$var$DDS_MAGIC_SIZE + $8feea74fdb87b284$var$DDS_HEADER_SIZE, texData = new Uint8Array(arrayBuffer, dataOffset2);
            return [
                new (0, $8b74d5c244726983$export$1982af6892f05657)(texData, {
                    format: internalFormat2,
                    width: width,
                    height: height,
                    levels: mipmapCount
                })
            ];
        }
        const dx10Offset = $8feea74fdb87b284$var$DDS_MAGIC_SIZE + $8feea74fdb87b284$var$DDS_HEADER_SIZE, dx10Header = new Uint32Array(data.buffer, dx10Offset, $8feea74fdb87b284$var$DDS_HEADER_DX10_SIZE / Uint32Array.BYTES_PER_ELEMENT), dxgiFormat = dx10Header[$8feea74fdb87b284$var$DDS_DX10_FIELDS.DXGI_FORMAT], resourceDimension = dx10Header[$8feea74fdb87b284$var$DDS_DX10_FIELDS.RESOURCE_DIMENSION], miscFlag = dx10Header[$8feea74fdb87b284$var$DDS_DX10_FIELDS.MISC_FLAG], arraySize = dx10Header[$8feea74fdb87b284$var$DDS_DX10_FIELDS.ARRAY_SIZE], internalFormat = $8feea74fdb87b284$var$DXGI_TO_FORMAT[dxgiFormat];
        if (internalFormat === void 0) throw new Error(`DDSParser cannot parse texture data with DXGI format ${dxgiFormat}`);
        if (miscFlag === $8feea74fdb87b284$var$DDS_RESOURCE_MISC_TEXTURECUBE) throw new Error("DDSParser does not support cubemap textures");
        if (resourceDimension === 6) throw new Error("DDSParser does not supported 3D texture data");
        const imageBuffers = new Array(), dataOffset = $8feea74fdb87b284$var$DDS_MAGIC_SIZE + $8feea74fdb87b284$var$DDS_HEADER_SIZE + $8feea74fdb87b284$var$DDS_HEADER_DX10_SIZE;
        if (arraySize === 1) imageBuffers.push(new Uint8Array(arrayBuffer, dataOffset));
        else {
            const pixelSize = (0, $24e929601ce4a949$export$fb888e587c979eee)[internalFormat];
            let imageSize = 0, levelWidth = width, levelHeight = height;
            for(let i = 0; i < mipmapCount; i++){
                const alignedLevelWidth = Math.max(1, levelWidth + 3 & -4), alignedLevelHeight = Math.max(1, levelHeight + 3 & -4), levelSize = alignedLevelWidth * alignedLevelHeight * pixelSize;
                imageSize += levelSize, levelWidth = levelWidth >>> 1, levelHeight = levelHeight >>> 1;
            }
            let imageOffset = dataOffset;
            for(let i = 0; i < arraySize; i++)imageBuffers.push(new Uint8Array(arrayBuffer, imageOffset, imageSize)), imageOffset += imageSize;
        }
        return imageBuffers.map((buffer)=>new (0, $8b74d5c244726983$export$1982af6892f05657)(buffer, {
                format: internalFormat,
                width: width,
                height: height,
                levels: mipmapCount
            }));
    }
    throw formatFlags & $8feea74fdb87b284$var$DDPF_RGB ? new Error("DDSParser does not support uncompressed texture data.") : formatFlags & $8feea74fdb87b284$var$DDPF_YUV ? new Error("DDSParser does not supported YUV uncompressed texture data.") : formatFlags & $8feea74fdb87b284$var$DDPF_LUMINANCE ? new Error("DDSParser does not support single-channel (lumninance) texture data!") : formatFlags & $8feea74fdb87b284$var$DDPF_ALPHA ? new Error("DDSParser does not support single-channel (alpha) texture data!") : new Error("DDSParser failed to load a texture file due to an unknown reason!");
}






const $9517a47e40ad0885$var$FILE_IDENTIFIER = [
    171,
    75,
    84,
    88,
    32,
    49,
    49,
    187,
    13,
    10,
    26,
    10
], $9517a47e40ad0885$var$ENDIANNESS = 67305985, $9517a47e40ad0885$var$KTX_FIELDS = {
    FILE_IDENTIFIER: 0,
    ENDIANNESS: 12,
    GL_TYPE: 16,
    GL_TYPE_SIZE: 20,
    GL_FORMAT: 24,
    GL_INTERNAL_FORMAT: 28,
    GL_BASE_INTERNAL_FORMAT: 32,
    PIXEL_WIDTH: 36,
    PIXEL_HEIGHT: 40,
    PIXEL_DEPTH: 44,
    NUMBER_OF_ARRAY_ELEMENTS: 48,
    NUMBER_OF_FACES: 52,
    NUMBER_OF_MIPMAP_LEVELS: 56,
    BYTES_OF_KEY_VALUE_DATA: 60
}, $9517a47e40ad0885$var$FILE_HEADER_SIZE = 64, $9517a47e40ad0885$export$96c88eb9c7372a0b = {
    [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_BYTE]: 1,
    [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_SHORT]: 2,
    [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).INT]: 4,
    [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_INT]: 4,
    [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).FLOAT]: 4,
    [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).HALF_FLOAT]: 8
}, $9517a47e40ad0885$export$ace48b1390b9b0c2 = {
    [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA]: 4,
    [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGB]: 3,
    [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RG]: 2,
    [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RED]: 1,
    [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).LUMINANCE]: 1,
    [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).LUMINANCE_ALPHA]: 2,
    [(0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).ALPHA]: 1
}, $9517a47e40ad0885$export$2ca26443044e8798 = {
    [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_SHORT_4_4_4_4]: 2,
    [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_SHORT_5_5_5_1]: 2,
    [(0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_SHORT_5_6_5]: 2
};
function $9517a47e40ad0885$export$58a6abed7fd55190(url, arrayBuffer, loadKeyValueData = !1) {
    const dataView = new DataView(arrayBuffer);
    if (!$9517a47e40ad0885$var$validate(url, dataView)) return null;
    const littleEndian = dataView.getUint32($9517a47e40ad0885$var$KTX_FIELDS.ENDIANNESS, !0) === $9517a47e40ad0885$var$ENDIANNESS, glType = dataView.getUint32($9517a47e40ad0885$var$KTX_FIELDS.GL_TYPE, littleEndian), glFormat = dataView.getUint32($9517a47e40ad0885$var$KTX_FIELDS.GL_FORMAT, littleEndian), glInternalFormat = dataView.getUint32($9517a47e40ad0885$var$KTX_FIELDS.GL_INTERNAL_FORMAT, littleEndian), pixelWidth = dataView.getUint32($9517a47e40ad0885$var$KTX_FIELDS.PIXEL_WIDTH, littleEndian), pixelHeight = dataView.getUint32($9517a47e40ad0885$var$KTX_FIELDS.PIXEL_HEIGHT, littleEndian) || 1, pixelDepth = dataView.getUint32($9517a47e40ad0885$var$KTX_FIELDS.PIXEL_DEPTH, littleEndian) || 1, numberOfArrayElements = dataView.getUint32($9517a47e40ad0885$var$KTX_FIELDS.NUMBER_OF_ARRAY_ELEMENTS, littleEndian) || 1, numberOfFaces = dataView.getUint32($9517a47e40ad0885$var$KTX_FIELDS.NUMBER_OF_FACES, littleEndian), numberOfMipmapLevels = dataView.getUint32($9517a47e40ad0885$var$KTX_FIELDS.NUMBER_OF_MIPMAP_LEVELS, littleEndian), bytesOfKeyValueData = dataView.getUint32($9517a47e40ad0885$var$KTX_FIELDS.BYTES_OF_KEY_VALUE_DATA, littleEndian);
    if (pixelHeight === 0 || pixelDepth !== 1) throw new Error("Only 2D textures are supported");
    if (numberOfFaces !== 1) throw new Error("CubeTextures are not supported by KTXLoader yet!");
    if (numberOfArrayElements !== 1) throw new Error("WebGL does not support array textures");
    const blockWidth = 4, blockHeight = 4, alignedWidth = pixelWidth + 3 & -4, alignedHeight = pixelHeight + 3 & -4, imageBuffers = new Array(numberOfArrayElements);
    let imagePixels = pixelWidth * pixelHeight;
    glType === 0 && (imagePixels = alignedWidth * alignedHeight);
    let imagePixelByteSize;
    if (glType !== 0 ? $9517a47e40ad0885$export$96c88eb9c7372a0b[glType] ? imagePixelByteSize = $9517a47e40ad0885$export$96c88eb9c7372a0b[glType] * $9517a47e40ad0885$export$ace48b1390b9b0c2[glFormat] : imagePixelByteSize = $9517a47e40ad0885$export$2ca26443044e8798[glType] : imagePixelByteSize = (0, $24e929601ce4a949$export$fb888e587c979eee)[glInternalFormat], imagePixelByteSize === void 0) throw new Error("Unable to resolve the pixel format stored in the *.ktx file!");
    const kvData = loadKeyValueData ? $9517a47e40ad0885$var$parseKvData(dataView, bytesOfKeyValueData, littleEndian) : null;
    let mipByteSize = imagePixels * imagePixelByteSize, mipWidth = pixelWidth, mipHeight = pixelHeight, alignedMipWidth = alignedWidth, alignedMipHeight = alignedHeight, imageOffset = $9517a47e40ad0885$var$FILE_HEADER_SIZE + bytesOfKeyValueData;
    for(let mipmapLevel = 0; mipmapLevel < numberOfMipmapLevels; mipmapLevel++){
        const imageSize = dataView.getUint32(imageOffset, littleEndian);
        let elementOffset = imageOffset + 4;
        for(let arrayElement = 0; arrayElement < numberOfArrayElements; arrayElement++){
            let mips = imageBuffers[arrayElement];
            mips || (mips = imageBuffers[arrayElement] = new Array(numberOfMipmapLevels)), mips[mipmapLevel] = {
                levelID: mipmapLevel,
                // don't align mipWidth when texture not compressed! (glType not zero)
                levelWidth: numberOfMipmapLevels > 1 || glType !== 0 ? mipWidth : alignedMipWidth,
                levelHeight: numberOfMipmapLevels > 1 || glType !== 0 ? mipHeight : alignedMipHeight,
                levelBuffer: new Uint8Array(arrayBuffer, elementOffset, mipByteSize)
            }, elementOffset += mipByteSize;
        }
        imageOffset += imageSize + 4, imageOffset = imageOffset % 4 !== 0 ? imageOffset + 4 - imageOffset % 4 : imageOffset, mipWidth = mipWidth >> 1 || 1, mipHeight = mipHeight >> 1 || 1, alignedMipWidth = mipWidth + blockWidth - 1 & ~(blockWidth - 1), alignedMipHeight = mipHeight + blockHeight - 1 & ~(blockHeight - 1), mipByteSize = alignedMipWidth * alignedMipHeight * imagePixelByteSize;
    }
    return glType !== 0 ? {
        uncompressed: imageBuffers.map((levelBuffers)=>{
            let buffer = levelBuffers[0].levelBuffer, convertToInt = !1;
            return glType === (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).FLOAT ? buffer = new Float32Array(levelBuffers[0].levelBuffer.buffer, levelBuffers[0].levelBuffer.byteOffset, levelBuffers[0].levelBuffer.byteLength / 4) : glType === (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_INT ? (convertToInt = !0, buffer = new Uint32Array(levelBuffers[0].levelBuffer.buffer, levelBuffers[0].levelBuffer.byteOffset, levelBuffers[0].levelBuffer.byteLength / 4)) : glType === (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).INT && (convertToInt = !0, buffer = new Int32Array(levelBuffers[0].levelBuffer.buffer, levelBuffers[0].levelBuffer.byteOffset, levelBuffers[0].levelBuffer.byteLength / 4)), {
                resource: new (0, $967525537d2ce935$export$a79ef781de624449)(buffer, {
                    width: levelBuffers[0].levelWidth,
                    height: levelBuffers[0].levelHeight
                }),
                type: glType,
                format: convertToInt ? $9517a47e40ad0885$var$convertFormatToInteger(glFormat) : glFormat
            };
        }),
        kvData: kvData
    } : {
        compressed: imageBuffers.map((levelBuffers)=>new (0, $8b74d5c244726983$export$1982af6892f05657)(null, {
                format: glInternalFormat,
                width: pixelWidth,
                height: pixelHeight,
                levels: numberOfMipmapLevels,
                levelBuffers: levelBuffers
            })),
        kvData: kvData
    };
}
function $9517a47e40ad0885$var$validate(url, dataView) {
    for(let i = 0; i < $9517a47e40ad0885$var$FILE_IDENTIFIER.length; i++)if (dataView.getUint8(i) !== $9517a47e40ad0885$var$FILE_IDENTIFIER[i]) return console.error(`${url} is not a valid *.ktx file!`), !1;
    return !0;
}
function $9517a47e40ad0885$var$convertFormatToInteger(format) {
    switch(format){
        case (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA:
            return (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA_INTEGER;
        case (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGB:
            return (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGB_INTEGER;
        case (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RG:
            return (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RG_INTEGER;
        case (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RED:
            return (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RED_INTEGER;
        default:
            return format;
    }
}
function $9517a47e40ad0885$var$parseKvData(dataView, bytesOfKeyValueData, littleEndian) {
    const kvData = /* @__PURE__ */ new Map();
    let bytesIntoKeyValueData = 0;
    for(; bytesIntoKeyValueData < bytesOfKeyValueData;){
        const keyAndValueByteSize = dataView.getUint32($9517a47e40ad0885$var$FILE_HEADER_SIZE + bytesIntoKeyValueData, littleEndian), keyAndValueByteOffset = $9517a47e40ad0885$var$FILE_HEADER_SIZE + bytesIntoKeyValueData + 4, valuePadding = 3 - (keyAndValueByteSize + 3) % 4;
        if (keyAndValueByteSize === 0 || keyAndValueByteSize > bytesOfKeyValueData - bytesIntoKeyValueData) {
            console.error("KTXLoader: keyAndValueByteSize out of bounds");
            break;
        }
        let keyNulByte = 0;
        for(; keyNulByte < keyAndValueByteSize && dataView.getUint8(keyAndValueByteOffset + keyNulByte) !== 0; keyNulByte++);
        if (keyNulByte === -1) {
            console.error("KTXLoader: Failed to find null byte terminating kvData key");
            break;
        }
        const key = new TextDecoder().decode(new Uint8Array(dataView.buffer, keyAndValueByteOffset, keyNulByte)), value = new DataView(dataView.buffer, keyAndValueByteOffset + keyNulByte + 1, keyAndValueByteSize - keyNulByte - 1);
        kvData.set(key, value), bytesIntoKeyValueData += 4 + keyAndValueByteSize + valuePadding;
    }
    return kvData;
}





const $d789d75e83befc14$export$20ea358dd867fe3e = {
    extension: {
        type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $d0164a963de0e9b4$export$820ed6348c4f2750).High
    },
    name: "loadDDS",
    test (url) {
        return (0, $10add1021e67fe4f$export$fd0180357b95b812)(url, ".dds");
    },
    async load (url, asset, loader) {
        const arrayBuffer = await (await (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.fetch(url)).arrayBuffer(), textures = (0, $8feea74fdb87b284$export$cddc4925efe88ac)(arrayBuffer).map((resource)=>{
            const base = new (0, $997b0e421c4045eb$export$d6306e508f184154)(resource, {
                mipmap: (0, $5912637ee8cf8b9f$export$16f6fb5da874bbfd).OFF,
                alphaMode: (0, $5912637ee8cf8b9f$export$d56550d454401b73).NO_PREMULTIPLIED_ALPHA,
                resolution: (0, $29e19754806f3a05$exports).getResolutionOfUrl(url),
                ...asset.data
            });
            return (0, $ee9b3b11b833a834$export$37b981a8c575f415)(base, loader, url);
        });
        return textures.length === 1 ? textures[0] : textures;
    },
    unload (texture) {
        Array.isArray(texture) ? texture.forEach((t)=>t.destroy(!0)) : texture.destroy(!0);
    }
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($d789d75e83befc14$export$20ea358dd867fe3e);






const $942cb017f2bc6951$export$e59f5413434dd0e3 = {
    extension: {
        type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $d0164a963de0e9b4$export$820ed6348c4f2750).High
    },
    name: "loadKTX",
    test (url) {
        return (0, $10add1021e67fe4f$export$fd0180357b95b812)(url, ".ktx");
    },
    async load (url, asset, loader) {
        const arrayBuffer = await (await (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.fetch(url)).arrayBuffer(), { compressed: compressed, uncompressed: uncompressed, kvData: kvData } = (0, $9517a47e40ad0885$export$58a6abed7fd55190)(url, arrayBuffer), resources = compressed ?? uncompressed, options = {
            mipmap: (0, $5912637ee8cf8b9f$export$16f6fb5da874bbfd).OFF,
            alphaMode: (0, $5912637ee8cf8b9f$export$d56550d454401b73).NO_PREMULTIPLIED_ALPHA,
            resolution: (0, $29e19754806f3a05$exports).getResolutionOfUrl(url),
            ...asset.data
        }, textures = resources.map((resource)=>{
            resources === uncompressed && Object.assign(options, {
                type: resource.type,
                format: resource.format
            });
            const res = resource.resource ?? resource, base = new (0, $997b0e421c4045eb$export$d6306e508f184154)(res, options);
            return base.ktxKeyValueData = kvData, (0, $ee9b3b11b833a834$export$37b981a8c575f415)(base, loader, url);
        });
        return textures.length === 1 ? textures[0] : textures;
    },
    unload (texture) {
        Array.isArray(texture) ? texture.forEach((t)=>t.destroy(!0)) : texture.destroy(!0);
    }
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($942cb017f2bc6951$export$e59f5413434dd0e3);



const $8e884761d9ee6e01$export$513de45dc484f3ba = {
    extension: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).ResolveParser,
    test: (value)=>{
        const extension = value.split("?")[0].split(".").pop();
        return [
            "basis",
            "ktx",
            "dds"
        ].includes(extension);
    },
    parse: (value)=>{
        if (value.split("?")[0].split(".").pop() === "ktx") {
            const extensions2 = [
                ".s3tc.ktx",
                ".s3tc_sRGB.ktx",
                ".etc.ktx",
                ".etc1.ktx",
                ".pvrt.ktx",
                ".atc.ktx",
                ".astc.ktx"
            ];
            if (extensions2.some((ext)=>value.endsWith(ext))) return {
                resolution: parseFloat((0, $5340ccf8570d4063$export$a5a6e0b888b2c992).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
                format: extensions2.find((ext)=>value.endsWith(ext)),
                src: value
            };
        }
        return {
            resolution: parseFloat((0, $5340ccf8570d4063$export$a5a6e0b888b2c992).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
            format: value.split(".").pop(),
            src: value
        };
    }
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($8e884761d9ee6e01$export$513de45dc484f3ba);




















const $5d7f937aa7da4ef8$var$TEMP_RECT = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(), $5d7f937aa7da4ef8$var$BYTES_PER_PIXEL = 4, $5d7f937aa7da4ef8$var$_Extract = class _Extract2 {
    /**
   * @param renderer - A reference to the current renderer
   */ constructor(renderer){
        this.renderer = renderer, this._rendererPremultipliedAlpha = !1;
    }
    contextChange() {
        const attributes = this.renderer?.gl.getContextAttributes();
        this._rendererPremultipliedAlpha = !!(attributes && attributes.alpha && attributes.premultipliedAlpha);
    }
    /**
   * Will return a HTML Image of the target
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param format - Image format, e.g. "image/jpeg" or "image/webp".
   * @param quality - JPEG or Webp compression from 0 to 1. Default is 0.92.
   * @param frame - The frame the extraction is restricted to.
   * @returns - HTML Image of the target
   */ async image(target, format, quality, frame) {
        const image = new Image();
        return image.src = await this.base64(target, format, quality, frame), image;
    }
    /**
   * Will return a base64 encoded string of this target. It works by calling
   *  `Extract.canvas` and then running toDataURL on that.
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param format - Image format, e.g. "image/jpeg" or "image/webp".
   * @param quality - JPEG or Webp compression from 0 to 1. Default is 0.92.
   * @param frame - The frame the extraction is restricted to.
   * @returns - A base64 encoded string of the texture.
   */ async base64(target, format, quality, frame) {
        const canvas = this.canvas(target, frame);
        if (canvas.toBlob !== void 0) return new Promise((resolve, reject)=>{
            canvas.toBlob((blob)=>{
                if (!blob) {
                    reject(new Error("ICanvas.toBlob failed!"));
                    return;
                }
                const reader = new FileReader();
                reader.onload = ()=>resolve(reader.result), reader.onerror = reject, reader.readAsDataURL(blob);
            }, format, quality);
        });
        if (canvas.toDataURL !== void 0) return canvas.toDataURL(format, quality);
        if (canvas.convertToBlob !== void 0) {
            const blob = await canvas.convertToBlob({
                type: format,
                quality: quality
            });
            return new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.onload = ()=>resolve(reader.result), reader.onerror = reject, reader.readAsDataURL(blob);
            });
        }
        throw new Error("Extract.base64() requires ICanvas.toDataURL, ICanvas.toBlob, or ICanvas.convertToBlob to be implemented");
    }
    /**
   * Creates a Canvas element, renders this target to it and then returns it.
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param frame - The frame the extraction is restricted to.
   * @returns - A Canvas element with the texture rendered on.
   */ canvas(target, frame) {
        const { pixels: pixels, width: width, height: height, flipY: flipY, premultipliedAlpha: premultipliedAlpha } = this._rawPixels(target, frame);
        flipY && _Extract2._flipY(pixels, width, height), premultipliedAlpha && _Extract2._unpremultiplyAlpha(pixels);
        const canvasBuffer = new (0, $29e19754806f3a05$exports).CanvasRenderTarget(width, height, 1), imageData = new ImageData(new Uint8ClampedArray(pixels.buffer), width, height);
        return canvasBuffer.context.putImageData(imageData, 0, 0), canvasBuffer.canvas;
    }
    /**
   * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
   * order, with integer values between 0 and 255 (included).
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param frame - The frame the extraction is restricted to.
   * @returns - One-dimensional array containing the pixel data of the entire texture
   */ pixels(target, frame) {
        const { pixels: pixels, width: width, height: height, flipY: flipY, premultipliedAlpha: premultipliedAlpha } = this._rawPixels(target, frame);
        return flipY && _Extract2._flipY(pixels, width, height), premultipliedAlpha && _Extract2._unpremultiplyAlpha(pixels), pixels;
    }
    _rawPixels(target, frame) {
        const renderer = this.renderer;
        if (!renderer) throw new Error("The Extract has already been destroyed");
        let resolution, flipY = !1, premultipliedAlpha = !1, renderTexture, generated = !1;
        target && (target instanceof (0, $bbacc38491f82d4b$export$813984f7330b4d72) ? renderTexture = target : (renderTexture = renderer.generateTexture(target, {
            region: frame,
            resolution: renderer.resolution,
            multisample: renderer.multisample
        }), generated = !0, frame && ($5d7f937aa7da4ef8$var$TEMP_RECT.width = frame.width, $5d7f937aa7da4ef8$var$TEMP_RECT.height = frame.height, frame = $5d7f937aa7da4ef8$var$TEMP_RECT)));
        const gl = renderer.gl;
        if (renderTexture) {
            if (resolution = renderTexture.baseTexture.resolution, frame = frame ?? renderTexture.frame, flipY = !1, premultipliedAlpha = renderTexture.baseTexture.alphaMode > 0 && renderTexture.baseTexture.format === (0, $5912637ee8cf8b9f$export$e9c4b7b466aa8274).RGBA, !generated) {
                renderer.renderTexture.bind(renderTexture);
                const fbo = renderTexture.framebuffer.glFramebuffers[renderer.CONTEXT_UID];
                fbo.blitFramebuffer && renderer.framebuffer.bind(fbo.blitFramebuffer);
            }
        } else resolution = renderer.resolution, frame || (frame = $5d7f937aa7da4ef8$var$TEMP_RECT, frame.width = renderer.width / resolution, frame.height = renderer.height / resolution), flipY = !0, premultipliedAlpha = this._rendererPremultipliedAlpha, renderer.renderTexture.bind();
        const width = Math.max(Math.round(frame.width * resolution), 1), height = Math.max(Math.round(frame.height * resolution), 1), pixels = new Uint8Array($5d7f937aa7da4ef8$var$BYTES_PER_PIXEL * width * height);
        return gl.readPixels(Math.round(frame.x * resolution), Math.round(frame.y * resolution), width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels), generated && renderTexture?.destroy(!0), {
            pixels: pixels,
            width: width,
            height: height,
            flipY: flipY,
            premultipliedAlpha: premultipliedAlpha
        };
    }
    /** Destroys the extract. */ destroy() {
        this.renderer = null;
    }
    static _flipY(pixels, width, height) {
        const w = width << 2, h = height >> 1, temp = new Uint8Array(w);
        for(let y = 0; y < h; y++){
            const t = y * w, b = (height - y - 1) * w;
            temp.set(pixels.subarray(t, t + w)), pixels.copyWithin(t, b, b + w), pixels.set(temp, b);
        }
    }
    static _unpremultiplyAlpha(pixels) {
        pixels instanceof Uint8ClampedArray && (pixels = new Uint8Array(pixels.buffer));
        const n = pixels.length;
        for(let i = 0; i < n; i += 4){
            const alpha = pixels[i + 3];
            if (alpha !== 0) {
                const a = 255.001 / alpha;
                pixels[i] = pixels[i] * a + 0.5, pixels[i + 1] = pixels[i + 1] * a + 0.5, pixels[i + 2] = pixels[i + 2] * a + 0.5;
            }
        }
    }
};
$5d7f937aa7da4ef8$var$_Extract.extension = {
    name: "extract",
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem
};
let $5d7f937aa7da4ef8$export$296daa4fd2384194 = $5d7f937aa7da4ef8$var$_Extract;
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($5d7f937aa7da4ef8$export$296daa4fd2384194);












const $dc7a2cff433cc948$export$a3541b2d8ecbfcf2 = {
    build (graphicsData) {
        const points = graphicsData.points;
        let x, y, dx, dy, rx, ry;
        if (graphicsData.type === (0, $23fb2779a12001d8$export$511e1d54a4a8684e).CIRC) {
            const circle = graphicsData.shape;
            x = circle.x, y = circle.y, rx = ry = circle.radius, dx = dy = 0;
        } else if (graphicsData.type === (0, $23fb2779a12001d8$export$511e1d54a4a8684e).ELIP) {
            const ellipse = graphicsData.shape;
            x = ellipse.x, y = ellipse.y, rx = ellipse.width, ry = ellipse.height, dx = dy = 0;
        } else {
            const roundedRect = graphicsData.shape, halfWidth = roundedRect.width / 2, halfHeight = roundedRect.height / 2;
            x = roundedRect.x + halfWidth, y = roundedRect.y + halfHeight, rx = ry = Math.max(0, Math.min(roundedRect.radius, Math.min(halfWidth, halfHeight))), dx = halfWidth - rx, dy = halfHeight - ry;
        }
        if (!(rx >= 0 && ry >= 0 && dx >= 0 && dy >= 0)) {
            points.length = 0;
            return;
        }
        const n = Math.ceil(2.3 * Math.sqrt(rx + ry)), m = n * 8 + (dx ? 4 : 0) + (dy ? 4 : 0);
        if (points.length = m, m === 0) return;
        if (n === 0) {
            points.length = 8, points[0] = points[6] = x + dx, points[1] = points[3] = y + dy, points[2] = points[4] = x - dx, points[5] = points[7] = y - dy;
            return;
        }
        let j1 = 0, j2 = n * 4 + (dx ? 2 : 0) + 2, j3 = j2, j4 = m;
        {
            const x0 = dx + rx, y0 = dy, x1 = x + x0, x2 = x - x0, y1 = y + y0;
            if (points[j1++] = x1, points[j1++] = y1, points[--j2] = y1, points[--j2] = x2, dy) {
                const y2 = y - y0;
                points[j3++] = x2, points[j3++] = y2, points[--j4] = y2, points[--j4] = x1;
            }
        }
        for(let i = 1; i < n; i++){
            const a = Math.PI / 2 * (i / n), x0 = dx + Math.cos(a) * rx, y0 = dy + Math.sin(a) * ry, x1 = x + x0, x2 = x - x0, y1 = y + y0, y2 = y - y0;
            points[j1++] = x1, points[j1++] = y1, points[--j2] = y1, points[--j2] = x2, points[j3++] = x2, points[j3++] = y2, points[--j4] = y2, points[--j4] = x1;
        }
        {
            const x0 = dx, y0 = dy + ry, x1 = x + x0, x2 = x - x0, y1 = y + y0, y2 = y - y0;
            points[j1++] = x1, points[j1++] = y1, points[--j4] = y2, points[--j4] = x1, dx && (points[j1++] = x2, points[j1++] = y1, points[--j4] = y2, points[--j4] = x2);
        }
    },
    triangulate (graphicsData, graphicsGeometry) {
        const points = graphicsData.points, verts = graphicsGeometry.points, indices = graphicsGeometry.indices;
        if (points.length === 0) return;
        let vertPos = verts.length / 2;
        const center = vertPos;
        let x, y;
        if (graphicsData.type !== (0, $23fb2779a12001d8$export$511e1d54a4a8684e).RREC) {
            const circle = graphicsData.shape;
            x = circle.x, y = circle.y;
        } else {
            const roundedRect = graphicsData.shape;
            x = roundedRect.x + roundedRect.width / 2, y = roundedRect.y + roundedRect.height / 2;
        }
        const matrix = graphicsData.matrix;
        verts.push(graphicsData.matrix ? matrix.a * x + matrix.c * y + matrix.tx : x, graphicsData.matrix ? matrix.b * x + matrix.d * y + matrix.ty : y), vertPos++, verts.push(points[0], points[1]);
        for(let i = 2; i < points.length; i += 2)verts.push(points[i], points[i + 1]), indices.push(vertPos++, center, vertPos);
        indices.push(center + 1, center, vertPos);
    }
};



function $0d97ff17134e4d4b$var$fixOrientation(points, hole = !1) {
    const m = points.length;
    if (m < 6) return;
    let area = 0;
    for(let i = 0, x1 = points[m - 2], y1 = points[m - 1]; i < m; i += 2){
        const x2 = points[i], y2 = points[i + 1];
        area += (x2 - x1) * (y2 + y1), x1 = x2, y1 = y2;
    }
    if (!hole && area > 0 || hole && area <= 0) {
        const n = m / 2;
        for(let i = n + n % 2; i < m; i += 2){
            const i1 = m - i - 2, i2 = m - i - 1, i3 = i, i4 = i + 1;
            [points[i1], points[i3]] = [
                points[i3],
                points[i1]
            ], [points[i2], points[i4]] = [
                points[i4],
                points[i2]
            ];
        }
    }
}
const $0d97ff17134e4d4b$export$7de1a57618f21e1f = {
    build (graphicsData) {
        graphicsData.points = graphicsData.shape.points.slice();
    },
    triangulate (graphicsData, graphicsGeometry) {
        let points = graphicsData.points;
        const holes = graphicsData.holes, verts = graphicsGeometry.points, indices = graphicsGeometry.indices;
        if (points.length >= 6) {
            $0d97ff17134e4d4b$var$fixOrientation(points, !1);
            const holeArray = [];
            for(let i = 0; i < holes.length; i++){
                const hole = holes[i];
                $0d97ff17134e4d4b$var$fixOrientation(hole.points, !0), holeArray.push(points.length / 2), points = points.concat(hole.points);
            }
            const triangles = (0, $29e19754806f3a05$exports).earcut(points, holeArray, 2);
            if (!triangles) return;
            const vertPos = verts.length / 2;
            for(let i = 0; i < triangles.length; i += 3)indices.push(triangles[i] + vertPos), indices.push(triangles[i + 1] + vertPos), indices.push(triangles[i + 2] + vertPos);
            for(let i = 0; i < points.length; i++)verts.push(points[i]);
        }
    }
};


const $e302c0242e07d250$export$cbe813d11f2192b2 = {
    build (graphicsData) {
        const rectData = graphicsData.shape, x = rectData.x, y = rectData.y, width = rectData.width, height = rectData.height, points = graphicsData.points;
        points.length = 0, width >= 0 && height >= 0 && points.push(x, y, x + width, y, x + width, y + height, x, y + height);
    },
    triangulate (graphicsData, graphicsGeometry) {
        const points = graphicsData.points, verts = graphicsGeometry.points;
        if (points.length === 0) return;
        const vertPos = verts.length / 2;
        verts.push(points[0], points[1], points[2], points[3], points[6], points[7], points[4], points[5]), graphicsGeometry.indices.push(vertPos, vertPos + 1, vertPos + 2, vertPos + 1, vertPos + 2, vertPos + 3);
    }
};



const $52c527c07f16e6a8$export$4b54fce47d2ae7f4 = {
    build (graphicsData) {
        (0, $dc7a2cff433cc948$export$a3541b2d8ecbfcf2).build(graphicsData);
    },
    triangulate (graphicsData, graphicsGeometry) {
        (0, $dc7a2cff433cc948$export$a3541b2d8ecbfcf2).triangulate(graphicsData, graphicsGeometry);
    }
};



var $eeb8675c180a59bd$export$c6a6e344be1302e7 = /* @__PURE__ */ ((LINE_JOIN2)=>(LINE_JOIN2.MITER = "miter", LINE_JOIN2.BEVEL = "bevel", LINE_JOIN2.ROUND = "round", LINE_JOIN2))($eeb8675c180a59bd$export$c6a6e344be1302e7 || {}), $eeb8675c180a59bd$export$b113e22c48c75d2e = /* @__PURE__ */ ((LINE_CAP2)=>(LINE_CAP2.BUTT = "butt", LINE_CAP2.ROUND = "round", LINE_CAP2.SQUARE = "square", LINE_CAP2))($eeb8675c180a59bd$export$b113e22c48c75d2e || {});
const $eeb8675c180a59bd$export$6894093bf294bea5 = {
    adaptive: !0,
    maxLength: 10,
    minSegments: 8,
    maxSegments: 2048,
    epsilon: 1e-4,
    _segmentsCount (length, defaultSegments = 20) {
        if (!this.adaptive || !length || isNaN(length)) return defaultSegments;
        let result = Math.ceil(length / this.maxLength);
        return result < this.minSegments ? result = this.minSegments : result > this.maxSegments && (result = this.maxSegments), result;
    }
}, $eeb8675c180a59bd$export$8331f8d2be429f2c = $eeb8675c180a59bd$export$6894093bf294bea5;


class $2e29f2857641ca18$export$e6c43ec4db262573 {
    /**
   * Calculate information of the arc for {@link PIXI.Graphics.arcTo}.
   * @private
   * @param x1 - The x-coordinate of the first control point of the arc
   * @param y1 - The y-coordinate of the first control point of the arc
   * @param x2 - The x-coordinate of the second control point of the arc
   * @param y2 - The y-coordinate of the second control point of the arc
   * @param radius - The radius of the arc
   * @param points - Collection of points to add to
   * @returns - If the arc length is valid, return center of circle, radius and other info otherwise `null`.
   */ static curveTo(x1, y1, x2, y2, radius, points) {
        const fromX = points[points.length - 2], a1 = points[points.length - 1] - y1, b1 = fromX - x1, a2 = y2 - y1, b2 = x2 - x1, mm = Math.abs(a1 * b2 - b1 * a2);
        if (mm < 1e-8 || radius === 0) return (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) && points.push(x1, y1), null;
        const dd = a1 * a1 + b1 * b1, cc = a2 * a2 + b2 * b2, tt = a1 * a2 + b1 * b2, k1 = radius * Math.sqrt(dd) / mm, k2 = radius * Math.sqrt(cc) / mm, j1 = k1 * tt / dd, j2 = k2 * tt / cc, cx = k1 * b2 + k2 * b1, cy = k1 * a2 + k2 * a1, px = b1 * (k2 + j1), py = a1 * (k2 + j1), qx = b2 * (k1 + j2), qy = a2 * (k1 + j2), startAngle = Math.atan2(py - cy, px - cx), endAngle = Math.atan2(qy - cy, qx - cx);
        return {
            cx: cx + x1,
            cy: cy + y1,
            radius: radius,
            startAngle: startAngle,
            endAngle: endAngle,
            anticlockwise: b1 * a2 > b2 * a1
        };
    }
    /**
   * The arc method creates an arc/curve (used to create circles, or parts of circles).
   * @private
   * @param _startX - Start x location of arc
   * @param _startY - Start y location of arc
   * @param cx - The x-coordinate of the center of the circle
   * @param cy - The y-coordinate of the center of the circle
   * @param radius - The radius of the circle
   * @param startAngle - The starting angle, in radians (0 is at the 3 o'clock position
   *  of the arc's circle)
   * @param endAngle - The ending angle, in radians
   * @param _anticlockwise - Specifies whether the drawing should be
   *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
   *  indicates counter-clockwise.
   * @param points - Collection of points to add to
   */ static arc(_startX, _startY, cx, cy, radius, startAngle, endAngle, _anticlockwise, points) {
        const sweep = endAngle - startAngle, n = (0, $eeb8675c180a59bd$export$6894093bf294bea5)._segmentsCount(Math.abs(sweep) * radius, Math.ceil(Math.abs(sweep) / (0, $23fb2779a12001d8$export$59ed0a0a5de1084b)) * 40), theta = sweep / (n * 2), theta2 = theta * 2, cTheta = Math.cos(theta), sTheta = Math.sin(theta), segMinus = n - 1, remainder = segMinus % 1 / segMinus;
        for(let i = 0; i <= segMinus; ++i){
            const real = i + remainder * i, angle = theta + startAngle + theta2 * real, c = Math.cos(angle), s = -Math.sin(angle);
            points.push((cTheta * c + sTheta * s) * radius + cx, (cTheta * -s + sTheta * c) * radius + cy);
        }
    }
}


class $58a0c93698fbf54e$export$3abbb88a93faeec2 {
    constructor(){
        this.reset();
    }
    /**
   * Begin batch part.
   * @param style
   * @param startIndex
   * @param attribStart
   */ begin(style, startIndex, attribStart) {
        this.reset(), this.style = style, this.start = startIndex, this.attribStart = attribStart;
    }
    /**
   * End batch part.
   * @param endIndex
   * @param endAttrib
   */ end(endIndex, endAttrib) {
        this.attribSize = endAttrib - this.attribStart, this.size = endIndex - this.start;
    }
    reset() {
        this.style = null, this.size = 0, this.start = 0, this.attribStart = 0, this.attribSize = 0;
    }
}



class $a099de60470e6789$export$994e59e1556c01e9 {
    /**
   * Calculate length of bezier curve.
   * Analytical solution is impossible, since it involves an integral that does not integrate in general.
   * Therefore numerical solution is used.
   * @private
   * @param fromX - Starting point x
   * @param fromY - Starting point y
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param cpX2 - Second Control point x
   * @param cpY2 - Second Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @returns - Length of bezier curve
   */ static curveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY) {
        let result = 0, t = 0, t2 = 0, t3 = 0, nt = 0, nt2 = 0, nt3 = 0, x = 0, y = 0, dx = 0, dy = 0, prevX = fromX, prevY = fromY;
        for(let i = 1; i <= 10; ++i)t = i / 10, t2 = t * t, t3 = t2 * t, nt = 1 - t, nt2 = nt * nt, nt3 = nt2 * nt, x = nt3 * fromX + 3 * nt2 * t * cpX + 3 * nt * t2 * cpX2 + t3 * toX, y = nt3 * fromY + 3 * nt2 * t * cpY + 3 * nt * t2 * cpY2 + t3 * toY, dx = prevX - x, dy = prevY - y, prevX = x, prevY = y, result += Math.sqrt(dx * dx + dy * dy);
        return result;
    }
    /**
   * Calculate the points for a bezier curve and then draws it.
   *
   * Ignored from docs since it is not directly exposed.
   * @ignore
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param cpX2 - Second Control point x
   * @param cpY2 - Second Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @param points - Path array to push points into
   */ static curveTo(cpX, cpY, cpX2, cpY2, toX, toY, points) {
        const fromX = points[points.length - 2], fromY = points[points.length - 1];
        points.length -= 2;
        const n = (0, $eeb8675c180a59bd$export$6894093bf294bea5)._segmentsCount($a099de60470e6789$export$994e59e1556c01e9.curveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY));
        let dt = 0, dt2 = 0, dt3 = 0, t2 = 0, t3 = 0;
        points.push(fromX, fromY);
        for(let i = 1, j = 0; i <= n; ++i)j = i / n, dt = 1 - j, dt2 = dt * dt, dt3 = dt2 * dt, t2 = j * j, t3 = t2 * j, points.push(dt3 * fromX + 3 * dt2 * j * cpX + 3 * dt * t2 * cpX2 + t3 * toX, dt3 * fromY + 3 * dt2 * j * cpY + 3 * dt * t2 * cpY2 + t3 * toY);
    }
}




function $885e7a4f193e58ac$var$square(x, y, nx, ny, innerWeight, outerWeight, clockwise, verts) {
    const ix = x - nx * innerWeight, iy = y - ny * innerWeight, ox = x + nx * outerWeight, oy = y + ny * outerWeight;
    let exx, eyy;
    clockwise ? (exx = ny, eyy = -nx) : (exx = -ny, eyy = nx);
    const eix = ix + exx, eiy = iy + eyy, eox = ox + exx, eoy = oy + eyy;
    return verts.push(eix, eiy, eox, eoy), 2;
}
function $885e7a4f193e58ac$var$round(cx, cy, sx, sy, ex, ey, verts, clockwise) {
    const cx2p0x = sx - cx, cy2p0y = sy - cy;
    let angle0 = Math.atan2(cx2p0x, cy2p0y), angle1 = Math.atan2(ex - cx, ey - cy);
    clockwise && angle0 < angle1 ? angle0 += Math.PI * 2 : !clockwise && angle0 > angle1 && (angle1 += Math.PI * 2);
    let startAngle = angle0;
    const angleDiff = angle1 - angle0, absAngleDiff = Math.abs(angleDiff), radius = Math.sqrt(cx2p0x * cx2p0x + cy2p0y * cy2p0y), segCount = (15 * absAngleDiff * Math.sqrt(radius) / Math.PI >> 0) + 1, angleInc = angleDiff / segCount;
    if (startAngle += angleInc, clockwise) {
        verts.push(cx, cy, sx, sy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc)verts.push(cx, cy, cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
        verts.push(cx, cy, ex, ey);
    } else {
        verts.push(sx, sy, cx, cy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc)verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius, cx, cy);
        verts.push(ex, ey, cx, cy);
    }
    return segCount * 2;
}
function $885e7a4f193e58ac$var$buildNonNativeLine(graphicsData, graphicsGeometry) {
    const shape = graphicsData.shape;
    let points = graphicsData.points || shape.points.slice();
    const eps = graphicsGeometry.closePointEps;
    if (points.length === 0) return;
    const style = graphicsData.lineStyle, firstPoint = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(points[0], points[1]), lastPoint = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(points[points.length - 2], points[points.length - 1]), closedShape = shape.type !== (0, $23fb2779a12001d8$export$511e1d54a4a8684e).POLY || shape.closeStroke, closedPath = Math.abs(firstPoint.x - lastPoint.x) < eps && Math.abs(firstPoint.y - lastPoint.y) < eps;
    if (closedShape) {
        points = points.slice(), closedPath && (points.pop(), points.pop(), lastPoint.set(points[points.length - 2], points[points.length - 1]));
        const midPointX = (firstPoint.x + lastPoint.x) * 0.5, midPointY = (lastPoint.y + firstPoint.y) * 0.5;
        points.unshift(midPointX, midPointY), points.push(midPointX, midPointY);
    }
    const verts = graphicsGeometry.points, length = points.length / 2;
    let indexCount = points.length;
    const indexStart = verts.length / 2, width = style.width / 2, widthSquared = width * width, miterLimitSquared = style.miterLimit * style.miterLimit;
    let x0 = points[0], y0 = points[1], x1 = points[2], y1 = points[3], x2 = 0, y2 = 0, perpx = -(y0 - y1), perpy = x0 - x1, perp1x = 0, perp1y = 0, dist = Math.sqrt(perpx * perpx + perpy * perpy);
    perpx /= dist, perpy /= dist, perpx *= width, perpy *= width;
    const ratio = style.alignment, innerWeight = (1 - ratio) * 2, outerWeight = ratio * 2;
    closedShape || (style.cap === (0, $eeb8675c180a59bd$export$b113e22c48c75d2e).ROUND ? indexCount += $885e7a4f193e58ac$var$round(x0 - perpx * (innerWeight - outerWeight) * 0.5, y0 - perpy * (innerWeight - outerWeight) * 0.5, x0 - perpx * innerWeight, y0 - perpy * innerWeight, x0 + perpx * outerWeight, y0 + perpy * outerWeight, verts, !0) + 2 : style.cap === (0, $eeb8675c180a59bd$export$b113e22c48c75d2e).SQUARE && (indexCount += $885e7a4f193e58ac$var$square(x0, y0, perpx, perpy, innerWeight, outerWeight, !0, verts))), verts.push(x0 - perpx * innerWeight, y0 - perpy * innerWeight, x0 + perpx * outerWeight, y0 + perpy * outerWeight);
    for(let i = 1; i < length - 1; ++i){
        x0 = points[(i - 1) * 2], y0 = points[(i - 1) * 2 + 1], x1 = points[i * 2], y1 = points[i * 2 + 1], x2 = points[(i + 1) * 2], y2 = points[(i + 1) * 2 + 1], perpx = -(y0 - y1), perpy = x0 - x1, dist = Math.sqrt(perpx * perpx + perpy * perpy), perpx /= dist, perpy /= dist, perpx *= width, perpy *= width, perp1x = -(y1 - y2), perp1y = x1 - x2, dist = Math.sqrt(perp1x * perp1x + perp1y * perp1y), perp1x /= dist, perp1y /= dist, perp1x *= width, perp1y *= width;
        const dx0 = x1 - x0, dy0 = y0 - y1, dx1 = x1 - x2, dy1 = y2 - y1, dot = dx0 * dx1 + dy0 * dy1, cross = dy0 * dx1 - dy1 * dx0, clockwise = cross < 0;
        if (Math.abs(cross) < 1e-3 * Math.abs(dot)) {
            verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 + perpx * outerWeight, y1 + perpy * outerWeight), dot >= 0 && (style.join === (0, $eeb8675c180a59bd$export$c6a6e344be1302e7).ROUND ? indexCount += $885e7a4f193e58ac$var$round(x1, y1, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, !1) + 4 : indexCount += 2, verts.push(x1 - perp1x * outerWeight, y1 - perp1y * outerWeight, x1 + perp1x * innerWeight, y1 + perp1y * innerWeight));
            continue;
        }
        const c1 = (-perpx + x0) * (-perpy + y1) - (-perpx + x1) * (-perpy + y0), c2 = (-perp1x + x2) * (-perp1y + y1) - (-perp1x + x1) * (-perp1y + y2), px = (dx0 * c2 - dx1 * c1) / cross, py = (dy1 * c1 - dy0 * c2) / cross, pdist = (px - x1) * (px - x1) + (py - y1) * (py - y1), imx = x1 + (px - x1) * innerWeight, imy = y1 + (py - y1) * innerWeight, omx = x1 - (px - x1) * outerWeight, omy = y1 - (py - y1) * outerWeight, smallerInsideSegmentSq = Math.min(dx0 * dx0 + dy0 * dy0, dx1 * dx1 + dy1 * dy1), insideWeight = clockwise ? innerWeight : outerWeight, smallerInsideDiagonalSq = smallerInsideSegmentSq + insideWeight * insideWeight * widthSquared, insideMiterOk = pdist <= smallerInsideDiagonalSq;
        let join = style.join;
        if (join === (0, $eeb8675c180a59bd$export$c6a6e344be1302e7).MITER && pdist / widthSquared > miterLimitSquared && (join = (0, $eeb8675c180a59bd$export$c6a6e344be1302e7).BEVEL), insideMiterOk) switch(join){
            case (0, $eeb8675c180a59bd$export$c6a6e344be1302e7).MITER:
                verts.push(imx, imy, omx, omy);
                break;
            case (0, $eeb8675c180a59bd$export$c6a6e344be1302e7).BEVEL:
                clockwise ? verts.push(imx, imy, // inner miter point
                x1 + perpx * outerWeight, y1 + perpy * outerWeight, // first segment's outer vertex
                imx, imy, // inner miter point
                x1 + perp1x * outerWeight, y1 + perp1y * outerWeight) : verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, // first segment's inner vertex
                omx, omy, // outer miter point
                x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, // second segment's outer vertex
                omx, omy), indexCount += 2;
                break;
            case (0, $eeb8675c180a59bd$export$c6a6e344be1302e7).ROUND:
                clockwise ? (verts.push(imx, imy, x1 + perpx * outerWeight, y1 + perpy * outerWeight), indexCount += $885e7a4f193e58ac$var$round(x1, y1, x1 + perpx * outerWeight, y1 + perpy * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, !0) + 4, verts.push(imx, imy, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight)) : (verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, omx, omy), indexCount += $885e7a4f193e58ac$var$round(x1, y1, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, !1) + 4, verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, omx, omy));
                break;
        }
        else {
            switch(verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, // first segment's inner vertex
            x1 + perpx * outerWeight, y1 + perpy * outerWeight), join){
                case (0, $eeb8675c180a59bd$export$c6a6e344be1302e7).MITER:
                    clockwise ? verts.push(omx, omy, // inner miter point
                    omx, omy) : verts.push(imx, imy, // outer miter point
                    imx, imy), indexCount += 2;
                    break;
                case (0, $eeb8675c180a59bd$export$c6a6e344be1302e7).ROUND:
                    clockwise ? indexCount += $885e7a4f193e58ac$var$round(x1, y1, x1 + perpx * outerWeight, y1 + perpy * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, !0) + 2 : indexCount += $885e7a4f193e58ac$var$round(x1, y1, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, !1) + 2;
                    break;
            }
            verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, // second segment's inner vertex
            x1 + perp1x * outerWeight, y1 + perp1y * outerWeight), indexCount += 2;
        }
    }
    x0 = points[(length - 2) * 2], y0 = points[(length - 2) * 2 + 1], x1 = points[(length - 1) * 2], y1 = points[(length - 1) * 2 + 1], perpx = -(y0 - y1), perpy = x0 - x1, dist = Math.sqrt(perpx * perpx + perpy * perpy), perpx /= dist, perpy /= dist, perpx *= width, perpy *= width, verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 + perpx * outerWeight, y1 + perpy * outerWeight), closedShape || (style.cap === (0, $eeb8675c180a59bd$export$b113e22c48c75d2e).ROUND ? indexCount += $885e7a4f193e58ac$var$round(x1 - perpx * (innerWeight - outerWeight) * 0.5, y1 - perpy * (innerWeight - outerWeight) * 0.5, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 + perpx * outerWeight, y1 + perpy * outerWeight, verts, !1) + 2 : style.cap === (0, $eeb8675c180a59bd$export$b113e22c48c75d2e).SQUARE && (indexCount += $885e7a4f193e58ac$var$square(x1, y1, perpx, perpy, innerWeight, outerWeight, !1, verts)));
    const indices = graphicsGeometry.indices, eps2 = (0, $eeb8675c180a59bd$export$6894093bf294bea5).epsilon * (0, $eeb8675c180a59bd$export$6894093bf294bea5).epsilon;
    for(let i = indexStart; i < indexCount + indexStart - 2; ++i)x0 = verts[i * 2], y0 = verts[i * 2 + 1], x1 = verts[(i + 1) * 2], y1 = verts[(i + 1) * 2 + 1], x2 = verts[(i + 2) * 2], y2 = verts[(i + 2) * 2 + 1], !(Math.abs(x0 * (y1 - y2) + x1 * (y2 - y0) + x2 * (y0 - y1)) < eps2) && indices.push(i, i + 1, i + 2);
}
function $885e7a4f193e58ac$var$buildNativeLine(graphicsData, graphicsGeometry) {
    let i = 0;
    const shape = graphicsData.shape, points = graphicsData.points || shape.points, closedShape = shape.type !== (0, $23fb2779a12001d8$export$511e1d54a4a8684e).POLY || shape.closeStroke;
    if (points.length === 0) return;
    const verts = graphicsGeometry.points, indices = graphicsGeometry.indices, length = points.length / 2, startIndex = verts.length / 2;
    let currentIndex = startIndex;
    for(verts.push(points[0], points[1]), i = 1; i < length; i++)verts.push(points[i * 2], points[i * 2 + 1]), indices.push(currentIndex, currentIndex + 1), currentIndex++;
    closedShape && indices.push(currentIndex, startIndex);
}
function $885e7a4f193e58ac$export$45986ccf08e93b0b(graphicsData, graphicsGeometry) {
    graphicsData.lineStyle.native ? $885e7a4f193e58ac$var$buildNativeLine(graphicsData, graphicsGeometry) : $885e7a4f193e58ac$var$buildNonNativeLine(graphicsData, graphicsGeometry);
}



class $d353c290f9584e5f$export$616649c7d4fcacf2 {
    /**
   * Calculate length of quadratic curve
   * @see {@link http://www.malczak.linuxpl.com/blog/quadratic-bezier-curve-length/}
   * for the detailed explanation of math behind this.
   * @private
   * @param fromX - x-coordinate of curve start point
   * @param fromY - y-coordinate of curve start point
   * @param cpX - x-coordinate of curve control point
   * @param cpY - y-coordinate of curve control point
   * @param toX - x-coordinate of curve end point
   * @param toY - y-coordinate of curve end point
   * @returns - Length of quadratic curve
   */ static curveLength(fromX, fromY, cpX, cpY, toX, toY) {
        const ax = fromX - 2 * cpX + toX, ay = fromY - 2 * cpY + toY, bx = 2 * cpX - 2 * fromX, by = 2 * cpY - 2 * fromY, a = 4 * (ax * ax + ay * ay), b = 4 * (ax * bx + ay * by), c = bx * bx + by * by, s = 2 * Math.sqrt(a + b + c), a2 = Math.sqrt(a), a32 = 2 * a * a2, c2 = 2 * Math.sqrt(c), ba = b / a2;
        return (a32 * s + a2 * b * (s - c2) + (4 * c * a - b * b) * Math.log((2 * a2 + ba + s) / (ba + c2))) / (4 * a32);
    }
    /**
   * Calculate the points for a quadratic bezier curve and then draws it.
   * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
   * @private
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @param points - Points to add segments to.
   */ static curveTo(cpX, cpY, toX, toY, points) {
        const fromX = points[points.length - 2], fromY = points[points.length - 1], n = (0, $eeb8675c180a59bd$export$6894093bf294bea5)._segmentsCount($d353c290f9584e5f$export$616649c7d4fcacf2.curveLength(fromX, fromY, cpX, cpY, toX, toY));
        let xa = 0, ya = 0;
        for(let i = 1; i <= n; ++i){
            const j = i / n;
            xa = fromX + (cpX - fromX) * j, ya = fromY + (cpY - fromY) * j, points.push(xa + (cpX + (toX - cpX) * j - xa) * j, ya + (cpY + (toY - cpY) * j - ya) * j);
        }
    }
}


const $cfd96406afbcfaa9$export$b738057f7c88a634 = {
    [(0, $23fb2779a12001d8$export$511e1d54a4a8684e).POLY]: (0, $0d97ff17134e4d4b$export$7de1a57618f21e1f),
    [(0, $23fb2779a12001d8$export$511e1d54a4a8684e).CIRC]: (0, $dc7a2cff433cc948$export$a3541b2d8ecbfcf2),
    [(0, $23fb2779a12001d8$export$511e1d54a4a8684e).ELIP]: (0, $dc7a2cff433cc948$export$a3541b2d8ecbfcf2),
    [(0, $23fb2779a12001d8$export$511e1d54a4a8684e).RECT]: (0, $e302c0242e07d250$export$cbe813d11f2192b2),
    [(0, $23fb2779a12001d8$export$511e1d54a4a8684e).RREC]: (0, $52c527c07f16e6a8$export$4b54fce47d2ae7f4)
}, $cfd96406afbcfaa9$export$78aca0cfc72b8d6 = [], $cfd96406afbcfaa9$export$e520c68c6872beed = [];








class $2586c036ebb3d977$export$94accce0eb494446 {
    /**
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
   * @param fillStyle - the width of the line to draw
   * @param lineStyle - the color of the line to draw
   * @param matrix - Transform matrix
   */ constructor(shape, fillStyle = null, lineStyle = null, matrix = null){
        this.points = [], this.holes = [], this.shape = shape, this.lineStyle = lineStyle, this.fillStyle = fillStyle, this.matrix = matrix, this.type = shape.type;
    }
    /**
   * Creates a new GraphicsData object with the same values as this one.
   * @returns - Cloned GraphicsData object
   */ clone() {
        return new $2586c036ebb3d977$export$94accce0eb494446(this.shape, this.fillStyle, this.lineStyle, this.matrix);
    }
    /** Destroys the Graphics data. */ destroy() {
        this.shape = null, this.holes.length = 0, this.holes = null, this.points.length = 0, this.points = null, this.lineStyle = null, this.fillStyle = null;
    }
}






const $88814080d5f1cdd7$var$tmpPoint = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(), $88814080d5f1cdd7$var$_GraphicsGeometry = class _GraphicsGeometry2 extends (0, $8e8f1d0188b2afc6$export$449e8d355fd68e43) {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(){
        super(), this.closePointEps = 1e-4, this.boundsPadding = 0, this.uvsFloat32 = null, this.indicesUint16 = null, this.batchable = !1, this.points = [], this.colors = [], this.uvs = [], this.indices = [], this.textureIds = [], this.graphicsData = [], this.drawCalls = [], this.batchDirty = -1, this.batches = [], this.dirty = 0, this.cacheDirty = -1, this.clearDirty = 0, this.shapeIndex = 0, this._bounds = new (0, $70e54ebfdc4c7d64$export$c4e9d269599ab4b4)(), this.boundsDirty = -1;
    }
    /**
   * Get the current bounds of the graphic geometry.
   *
   * Since 6.5.0, bounds of the graphics geometry are calculated based on the vertices of generated geometry.
   * Since shapes or strokes with full transparency (`alpha: 0`) will not generate geometry, they are not considered
   * when calculating bounds for the graphics geometry. See PR [#8343]{@link https://github.com/pixijs/pixijs/pull/8343}
   * and issue [#8623]{@link https://github.com/pixijs/pixijs/pull/8623}.
   * @readonly
   */ get bounds() {
        return this.updateBatches(), this.boundsDirty !== this.dirty && (this.boundsDirty = this.dirty, this.calculateBounds()), this._bounds;
    }
    /** Call if you changed graphicsData manually. Empties all batch buffers. */ invalidate() {
        this.boundsDirty = -1, this.dirty++, this.batchDirty++, this.shapeIndex = 0, this.points.length = 0, this.colors.length = 0, this.uvs.length = 0, this.indices.length = 0, this.textureIds.length = 0;
        for(let i = 0; i < this.drawCalls.length; i++)this.drawCalls[i].texArray.clear(), (0, $cfd96406afbcfaa9$export$e520c68c6872beed).push(this.drawCalls[i]);
        this.drawCalls.length = 0;
        for(let i = 0; i < this.batches.length; i++){
            const batchPart = this.batches[i];
            batchPart.reset(), (0, $cfd96406afbcfaa9$export$78aca0cfc72b8d6).push(batchPart);
        }
        this.batches.length = 0;
    }
    /**
   * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
   * @returns - This GraphicsGeometry object. Good for chaining method calls
   */ clear() {
        return this.graphicsData.length > 0 && (this.invalidate(), this.clearDirty++, this.graphicsData.length = 0), this;
    }
    /**
   * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
   * @param fillStyle - Defines style of the fill.
   * @param lineStyle - Defines style of the lines.
   * @param matrix - Transform applied to the points of the shape.
   * @returns - Returns geometry for chaining.
   */ drawShape(shape, fillStyle = null, lineStyle = null, matrix = null) {
        const data = new (0, $2586c036ebb3d977$export$94accce0eb494446)(shape, fillStyle, lineStyle, matrix);
        return this.graphicsData.push(data), this.dirty++, this;
    }
    /**
   * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
   * @param matrix - Transform applied to the points of the shape.
   * @returns - Returns geometry for chaining.
   */ drawHole(shape, matrix = null) {
        if (!this.graphicsData.length) return null;
        const data = new (0, $2586c036ebb3d977$export$94accce0eb494446)(shape, null, null, matrix), lastShape = this.graphicsData[this.graphicsData.length - 1];
        return data.lineStyle = lastShape.lineStyle, lastShape.holes.push(data), this.dirty++, this;
    }
    /** Destroys the GraphicsGeometry object. */ destroy() {
        super.destroy();
        for(let i = 0; i < this.graphicsData.length; ++i)this.graphicsData[i].destroy();
        this.points.length = 0, this.points = null, this.colors.length = 0, this.colors = null, this.uvs.length = 0, this.uvs = null, this.indices.length = 0, this.indices = null, this.indexBuffer.destroy(), this.indexBuffer = null, this.graphicsData.length = 0, this.graphicsData = null, this.drawCalls.length = 0, this.drawCalls = null, this.batches.length = 0, this.batches = null, this._bounds = null;
    }
    /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */ containsPoint(point) {
        const graphicsData = this.graphicsData;
        for(let i = 0; i < graphicsData.length; ++i){
            const data = graphicsData[i];
            if (data.fillStyle.visible && data.shape && (data.matrix ? data.matrix.applyInverse(point, $88814080d5f1cdd7$var$tmpPoint) : $88814080d5f1cdd7$var$tmpPoint.copyFrom(point), data.shape.contains($88814080d5f1cdd7$var$tmpPoint.x, $88814080d5f1cdd7$var$tmpPoint.y))) {
                let hitHole = !1;
                if (data.holes) {
                    for(let i2 = 0; i2 < data.holes.length; i2++)if (data.holes[i2].shape.contains($88814080d5f1cdd7$var$tmpPoint.x, $88814080d5f1cdd7$var$tmpPoint.y)) {
                        hitHole = !0;
                        break;
                    }
                }
                if (!hitHole) return !0;
            }
        }
        return !1;
    }
    /**
   * Generates intermediate batch data. Either gets converted to drawCalls
   * or used to convert to batch objects directly by the Graphics object.
   */ updateBatches() {
        if (!this.graphicsData.length) {
            this.batchable = !0;
            return;
        }
        if (!this.validateBatching()) return;
        this.cacheDirty = this.dirty;
        const uvs = this.uvs, graphicsData = this.graphicsData;
        let batchPart = null, currentStyle = null;
        this.batches.length > 0 && (batchPart = this.batches[this.batches.length - 1], currentStyle = batchPart.style);
        for(let i = this.shapeIndex; i < graphicsData.length; i++){
            this.shapeIndex++;
            const data = graphicsData[i], fillStyle = data.fillStyle, lineStyle = data.lineStyle;
            (0, $cfd96406afbcfaa9$export$b738057f7c88a634)[data.type].build(data), data.matrix && this.transformPoints(data.points, data.matrix), (fillStyle.visible || lineStyle.visible) && this.processHoles(data.holes);
            for(let j = 0; j < 2; j++){
                const style = j === 0 ? fillStyle : lineStyle;
                if (!style.visible) continue;
                const nextTexture = style.texture.baseTexture, index2 = this.indices.length, attribIndex = this.points.length / 2;
                nextTexture.wrapMode = (0, $5912637ee8cf8b9f$export$2ab395cfb0dd2f0f).REPEAT, j === 0 ? this.processFill(data) : this.processLine(data);
                const size = this.points.length / 2 - attribIndex;
                size !== 0 && (batchPart && !this._compareStyles(currentStyle, style) && (batchPart.end(index2, attribIndex), batchPart = null), batchPart || (batchPart = (0, $cfd96406afbcfaa9$export$78aca0cfc72b8d6).pop() || new (0, $58a0c93698fbf54e$export$3abbb88a93faeec2)(), batchPart.begin(style, index2, attribIndex), this.batches.push(batchPart), currentStyle = style), this.addUvs(this.points, uvs, style.texture, attribIndex, size, style.matrix));
            }
        }
        const index = this.indices.length, attrib = this.points.length / 2;
        if (batchPart && batchPart.end(index, attrib), this.batches.length === 0) {
            this.batchable = !0;
            return;
        }
        const need32 = attrib > 65535;
        this.indicesUint16 && this.indices.length === this.indicesUint16.length && need32 === this.indicesUint16.BYTES_PER_ELEMENT > 2 ? this.indicesUint16.set(this.indices) : this.indicesUint16 = need32 ? new Uint32Array(this.indices) : new Uint16Array(this.indices), this.batchable = this.isBatchable(), this.batchable ? this.packBatches() : this.buildDrawCalls();
    }
    /**
   * Affinity check
   * @param styleA
   * @param styleB
   */ _compareStyles(styleA, styleB) {
        return !(!styleA || !styleB || styleA.texture.baseTexture !== styleB.texture.baseTexture || styleA.color + styleA.alpha !== styleB.color + styleB.alpha || !!styleA.native != !!styleB.native);
    }
    /** Test geometry for batching process. */ validateBatching() {
        if (this.dirty === this.cacheDirty || !this.graphicsData.length) return !1;
        for(let i = 0, l = this.graphicsData.length; i < l; i++){
            const data = this.graphicsData[i], fill = data.fillStyle, line = data.lineStyle;
            if (fill && !fill.texture.baseTexture.valid || line && !line.texture.baseTexture.valid) return !1;
        }
        return !0;
    }
    /** Offset the indices so that it works with the batcher. */ packBatches() {
        this.batchDirty++, this.uvsFloat32 = new Float32Array(this.uvs);
        const batches = this.batches;
        for(let i = 0, l = batches.length; i < l; i++){
            const batch = batches[i];
            for(let j = 0; j < batch.size; j++){
                const index = batch.start + j;
                this.indicesUint16[index] = this.indicesUint16[index] - batch.attribStart;
            }
        }
    }
    /**
   * Checks to see if this graphics geometry can be batched.
   * Currently it needs to be small enough and not contain any native lines.
   */ isBatchable() {
        if (this.points.length > 131070) return !1;
        const batches = this.batches;
        for(let i = 0; i < batches.length; i++)if (batches[i].style.native) return !1;
        return this.points.length < _GraphicsGeometry2.BATCHABLE_SIZE * 2;
    }
    /** Converts intermediate batches data to drawCalls. */ buildDrawCalls() {
        let TICK = ++(0, $997b0e421c4045eb$export$d6306e508f184154)._globalBatch;
        for(let i = 0; i < this.drawCalls.length; i++)this.drawCalls[i].texArray.clear(), (0, $cfd96406afbcfaa9$export$e520c68c6872beed).push(this.drawCalls[i]);
        this.drawCalls.length = 0;
        const colors = this.colors, textureIds = this.textureIds;
        let currentGroup = (0, $cfd96406afbcfaa9$export$e520c68c6872beed).pop();
        currentGroup || (currentGroup = new (0, $3c8543b1b17058da$export$664fd198634fda29)(), currentGroup.texArray = new (0, $b64836ebe443f6ff$export$aa760e0febf1a758)()), currentGroup.texArray.count = 0, currentGroup.start = 0, currentGroup.size = 0, currentGroup.type = (0, $5912637ee8cf8b9f$export$91100badd8469338).TRIANGLES;
        let textureCount = 0, currentTexture = null, textureId = 0, native = !1, drawMode = (0, $5912637ee8cf8b9f$export$91100badd8469338).TRIANGLES, index = 0;
        this.drawCalls.push(currentGroup);
        for(let i = 0; i < this.batches.length; i++){
            const data = this.batches[i], maxTextures = 8, style = data.style, nextTexture = style.texture.baseTexture;
            native !== !!style.native && (native = !!style.native, drawMode = native ? (0, $5912637ee8cf8b9f$export$91100badd8469338).LINES : (0, $5912637ee8cf8b9f$export$91100badd8469338).TRIANGLES, currentTexture = null, textureCount = maxTextures, TICK++), currentTexture !== nextTexture && (currentTexture = nextTexture, nextTexture._batchEnabled !== TICK && (textureCount === maxTextures && (TICK++, textureCount = 0, currentGroup.size > 0 && (currentGroup = (0, $cfd96406afbcfaa9$export$e520c68c6872beed).pop(), currentGroup || (currentGroup = new (0, $3c8543b1b17058da$export$664fd198634fda29)(), currentGroup.texArray = new (0, $b64836ebe443f6ff$export$aa760e0febf1a758)()), this.drawCalls.push(currentGroup)), currentGroup.start = index, currentGroup.size = 0, currentGroup.texArray.count = 0, currentGroup.type = drawMode), nextTexture.touched = 1, nextTexture._batchEnabled = TICK, nextTexture._batchLocation = textureCount, nextTexture.wrapMode = (0, $5912637ee8cf8b9f$export$2ab395cfb0dd2f0f).REPEAT, currentGroup.texArray.elements[currentGroup.texArray.count++] = nextTexture, textureCount++)), currentGroup.size += data.size, index += data.size, textureId = nextTexture._batchLocation, this.addColors(colors, style.color, style.alpha, data.attribSize, data.attribStart), this.addTextureIds(textureIds, textureId, data.attribSize, data.attribStart);
        }
        (0, $997b0e421c4045eb$export$d6306e508f184154)._globalBatch = TICK, this.packAttributes();
    }
    /** Packs attributes to single buffer. */ packAttributes() {
        const verts = this.points, uvs = this.uvs, colors = this.colors, textureIds = this.textureIds, glPoints = new ArrayBuffer(verts.length * 12), f32 = new Float32Array(glPoints), u32 = new Uint32Array(glPoints);
        let p = 0;
        for(let i = 0; i < verts.length / 2; i++)f32[p++] = verts[i * 2], f32[p++] = verts[i * 2 + 1], f32[p++] = uvs[i * 2], f32[p++] = uvs[i * 2 + 1], u32[p++] = colors[i], f32[p++] = textureIds[i];
        this._buffer.update(glPoints), this._indexBuffer.update(this.indicesUint16);
    }
    /**
   * Process fill part of Graphics.
   * @param data
   */ processFill(data) {
        data.holes.length ? (0, $0d97ff17134e4d4b$export$7de1a57618f21e1f).triangulate(data, this) : (0, $cfd96406afbcfaa9$export$b738057f7c88a634)[data.type].triangulate(data, this);
    }
    /**
   * Process line part of Graphics.
   * @param data
   */ processLine(data) {
        (0, $885e7a4f193e58ac$export$45986ccf08e93b0b)(data, this);
        for(let i = 0; i < data.holes.length; i++)(0, $885e7a4f193e58ac$export$45986ccf08e93b0b)(data.holes[i], this);
    }
    /**
   * Process the holes data.
   * @param holes
   */ processHoles(holes) {
        for(let i = 0; i < holes.length; i++){
            const hole = holes[i];
            (0, $cfd96406afbcfaa9$export$b738057f7c88a634)[hole.type].build(hole), hole.matrix && this.transformPoints(hole.points, hole.matrix);
        }
    }
    /** Update the local bounds of the object. Expensive to use performance-wise. */ calculateBounds() {
        const bounds = this._bounds;
        bounds.clear(), bounds.addVertexData(this.points, 0, this.points.length), bounds.pad(this.boundsPadding, this.boundsPadding);
    }
    /**
   * Transform points using matrix.
   * @param points - Points to transform
   * @param matrix - Transform matrix
   */ transformPoints(points, matrix) {
        for(let i = 0; i < points.length / 2; i++){
            const x = points[i * 2], y = points[i * 2 + 1];
            points[i * 2] = matrix.a * x + matrix.c * y + matrix.tx, points[i * 2 + 1] = matrix.b * x + matrix.d * y + matrix.ty;
        }
    }
    /**
   * Add colors.
   * @param colors - List of colors to add to
   * @param color - Color to add
   * @param alpha - Alpha to use
   * @param size - Number of colors to add
   * @param offset
   */ addColors(colors, color, alpha, size, offset = 0) {
        const bgr = (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(color).toLittleEndianNumber(), result = (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(bgr).toPremultiplied(alpha);
        colors.length = Math.max(colors.length, offset + size);
        for(let i = 0; i < size; i++)colors[offset + i] = result;
    }
    /**
   * Add texture id that the shader/fragment wants to use.
   * @param textureIds
   * @param id
   * @param size
   * @param offset
   */ addTextureIds(textureIds, id, size, offset = 0) {
        textureIds.length = Math.max(textureIds.length, offset + size);
        for(let i = 0; i < size; i++)textureIds[offset + i] = id;
    }
    /**
   * Generates the UVs for a shape.
   * @param verts - Vertices
   * @param uvs - UVs
   * @param texture - Reference to Texture
   * @param start - Index buffer start index.
   * @param size - The size/length for index buffer.
   * @param matrix - Optional transform for all points.
   */ addUvs(verts, uvs, texture, start, size, matrix = null) {
        let index = 0;
        const uvsStart = uvs.length, frame = texture.frame;
        for(; index < size;){
            let x = verts[(start + index) * 2], y = verts[(start + index) * 2 + 1];
            if (matrix) {
                const nx = matrix.a * x + matrix.c * y + matrix.tx;
                y = matrix.b * x + matrix.d * y + matrix.ty, x = nx;
            }
            index++, uvs.push(x / frame.width, y / frame.height);
        }
        const baseTexture = texture.baseTexture;
        (frame.width < baseTexture.width || frame.height < baseTexture.height) && this.adjustUvs(uvs, texture, uvsStart, size);
    }
    /**
   * Modify uvs array according to position of texture region
   * Does not work with rotated or trimmed textures
   * @param uvs - array
   * @param texture - region
   * @param start - starting index for uvs
   * @param size - how many points to adjust
   */ adjustUvs(uvs, texture, start, size) {
        const baseTexture = texture.baseTexture, eps = 1e-6, finish = start + size * 2, frame = texture.frame, scaleX = frame.width / baseTexture.width, scaleY = frame.height / baseTexture.height;
        let offsetX = frame.x / frame.width, offsetY = frame.y / frame.height, minX = Math.floor(uvs[start] + eps), minY = Math.floor(uvs[start + 1] + eps);
        for(let i = start + 2; i < finish; i += 2)minX = Math.min(minX, Math.floor(uvs[i] + eps)), minY = Math.min(minY, Math.floor(uvs[i + 1] + eps));
        offsetX -= minX, offsetY -= minY;
        for(let i = start; i < finish; i += 2)uvs[i] = (uvs[i] + offsetX) * scaleX, uvs[i + 1] = (uvs[i + 1] + offsetY) * scaleY;
    }
};
$88814080d5f1cdd7$var$_GraphicsGeometry.BATCHABLE_SIZE = 100;
let $88814080d5f1cdd7$export$c707987b44ce3a12 = $88814080d5f1cdd7$var$_GraphicsGeometry;



class $585597836ef02630$export$c42b166860ccdbd8 {
    constructor(){
        this.color = 16777215, this.alpha = 1, this.texture = (0, $ad1fffd072a707c2$export$5431306cf43de24a).WHITE, this.matrix = null, this.visible = !1, this.reset();
    }
    /** Clones the object */ clone() {
        const obj = new $585597836ef02630$export$c42b166860ccdbd8();
        return obj.color = this.color, obj.alpha = this.alpha, obj.texture = this.texture, obj.matrix = this.matrix, obj.visible = this.visible, obj;
    }
    /** Reset */ reset() {
        this.color = 16777215, this.alpha = 1, this.texture = (0, $ad1fffd072a707c2$export$5431306cf43de24a).WHITE, this.matrix = null, this.visible = !1;
    }
    /** Destroy and don't use after this. */ destroy() {
        this.texture = null, this.matrix = null;
    }
}




class $7632f40d9dcd7aa9$export$5d24e00cfde59887 extends (0, $585597836ef02630$export$c42b166860ccdbd8) {
    constructor(){
        super(...arguments), this.width = 0, this.alignment = 0.5, this.native = !1, this.cap = (0, $eeb8675c180a59bd$export$b113e22c48c75d2e).BUTT, this.join = (0, $eeb8675c180a59bd$export$c6a6e344be1302e7).MITER, this.miterLimit = 10;
    }
    /** Clones the object. */ clone() {
        const obj = new $7632f40d9dcd7aa9$export$5d24e00cfde59887();
        return obj.color = this.color, obj.alpha = this.alpha, obj.texture = this.texture, obj.matrix = this.matrix, obj.visible = this.visible, obj.width = this.width, obj.alignment = this.alignment, obj.native = this.native, obj.cap = this.cap, obj.join = this.join, obj.miterLimit = this.miterLimit, obj;
    }
    /** Reset the line style to default. */ reset() {
        super.reset(), this.color = 0, this.alignment = 0.5, this.width = 0, this.native = !1, this.cap = (0, $eeb8675c180a59bd$export$b113e22c48c75d2e).BUTT, this.join = (0, $eeb8675c180a59bd$export$c6a6e344be1302e7).MITER, this.miterLimit = 10;
    }
}






const $d21713afb1bb29fd$var$DEFAULT_SHADERS = {}, $d21713afb1bb29fd$var$_Graphics = class _Graphics2 extends (0, $3878067a77b781d9$export$42a852a2b6b56249) {
    /**
   * @param geometry - Geometry to use, if omitted will create a new GraphicsGeometry instance.
   */ constructor(geometry = null){
        super(), this.shader = null, this.pluginName = "batch", this.currentPath = null, this.batches = [], this.batchTint = -1, this.batchDirty = -1, this.vertexData = null, this._fillStyle = new (0, $585597836ef02630$export$c42b166860ccdbd8)(), this._lineStyle = new (0, $7632f40d9dcd7aa9$export$5d24e00cfde59887)(), this._matrix = null, this._holeMode = !1, this.state = (0, $05d0e9a749f67df1$export$7254cc27399e90bd).for2d(), this._geometry = geometry || new (0, $88814080d5f1cdd7$export$c707987b44ce3a12)(), this._geometry.refCount++, this._transformID = -1, this._tintColor = new (0, $3119899e085d9ccf$export$892596cec99bc70e)(16777215), this.blendMode = (0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).NORMAL;
    }
    /**
   * Includes vertex positions, face indices, normals, colors, UVs, and
   * custom attributes within buffers, reducing the cost of passing all
   * this data to the GPU. Can be shared between multiple Mesh or Graphics objects.
   * @readonly
   */ get geometry() {
        return this._geometry;
    }
    /**
   * Creates a new Graphics object with the same values as this one.
   * Note that only the geometry of the object is cloned, not its transform (position,scale,etc)
   * @returns - A clone of the graphics object
   */ clone() {
        return this.finishPoly(), new _Graphics2(this._geometry);
    }
    /**
   * The blend mode to be applied to the graphic shape. Apply a value of
   * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.  Note that, since each
   * primitive in the GraphicsGeometry list is rendered sequentially, modes
   * such as `PIXI.BLEND_MODES.ADD` and `PIXI.BLEND_MODES.MULTIPLY` will
   * be applied per-primitive.
   * @default PIXI.BLEND_MODES.NORMAL
   */ set blendMode(value) {
        this.state.blendMode = value;
    }
    get blendMode() {
        return this.state.blendMode;
    }
    /**
   * The tint applied to each graphic shape. This is a hex value. A value of
   * 0xFFFFFF will remove any tint effect.
   * @default 0xFFFFFF
   */ get tint() {
        return this._tintColor.value;
    }
    set tint(value) {
        this._tintColor.setValue(value);
    }
    /**
   * The current fill style.
   * @readonly
   */ get fill() {
        return this._fillStyle;
    }
    /**
   * The current line style.
   * @readonly
   */ get line() {
        return this._lineStyle;
    }
    lineStyle(options = null, color = 0, alpha, alignment = 0.5, native = !1) {
        return typeof options == "number" && (options = {
            width: options,
            color: color,
            alpha: alpha,
            alignment: alignment,
            native: native
        }), this.lineTextureStyle(options);
    }
    /**
   * Like line style but support texture for line fill.
   * @param [options] - Collection of options for setting line style.
   * @param {number} [options.width=0] - width of the line to draw, will update the objects stored style
   * @param {PIXI.Texture} [options.texture=PIXI.Texture.WHITE] - Texture to use
   * @param {PIXI.ColorSource} [options.color=0x0] - color of the line to draw, will update the objects stored style.
   *  Default 0xFFFFFF if texture present.
   * @param {number} [options.alpha=1] - alpha of the line to draw, will update the objects stored style
   * @param {PIXI.Matrix} [options.matrix=null] - Texture matrix to transform texture
   * @param {number} [options.alignment=0.5] - alignment of the line to draw, (0 = inner, 0.5 = middle, 1 = outer).
   *        WebGL only.
   * @param {boolean} [options.native=false] - If true the lines will be draw using LINES instead of TRIANGLE_STRIP
   * @param {PIXI.LINE_CAP}[options.cap=PIXI.LINE_CAP.BUTT] - line cap style
   * @param {PIXI.LINE_JOIN}[options.join=PIXI.LINE_JOIN.MITER] - line join style
   * @param {number}[options.miterLimit=10] - miter limit ratio
   * @returns {PIXI.Graphics} This Graphics object. Good for chaining method calls
   */ lineTextureStyle(options) {
        const defaultLineStyleOptions = {
            width: 0,
            texture: (0, $ad1fffd072a707c2$export$5431306cf43de24a).WHITE,
            color: options?.texture ? 16777215 : 0,
            matrix: null,
            alignment: 0.5,
            native: !1,
            cap: (0, $eeb8675c180a59bd$export$b113e22c48c75d2e).BUTT,
            join: (0, $eeb8675c180a59bd$export$c6a6e344be1302e7).MITER,
            miterLimit: 10
        };
        options = Object.assign(defaultLineStyleOptions, options), this.normalizeColor(options), this.currentPath && this.startPoly();
        const visible = options.width > 0 && options.alpha > 0;
        return visible ? (options.matrix && (options.matrix = options.matrix.clone(), options.matrix.invert()), Object.assign(this._lineStyle, {
            visible: visible
        }, options)) : this._lineStyle.reset(), this;
    }
    /**
   * Start a polygon object internally.
   * @protected
   */ startPoly() {
        if (this.currentPath) {
            const points = this.currentPath.points, len = this.currentPath.points.length;
            len > 2 && (this.drawShape(this.currentPath), this.currentPath = new (0, $c1a49bce64bda319$export$7d31b617c820d435)(), this.currentPath.closeStroke = !1, this.currentPath.points.push(points[len - 2], points[len - 1]));
        } else this.currentPath = new (0, $c1a49bce64bda319$export$7d31b617c820d435)(), this.currentPath.closeStroke = !1;
    }
    /**
   * Finish the polygon object.
   * @protected
   */ finishPoly() {
        this.currentPath && (this.currentPath.points.length > 2 ? (this.drawShape(this.currentPath), this.currentPath = null) : this.currentPath.points.length = 0);
    }
    /**
   * Moves the current drawing position to x, y.
   * @param x - the X coordinate to move to
   * @param y - the Y coordinate to move to
   * @returns - This Graphics object. Good for chaining method calls
   */ moveTo(x, y) {
        return this.startPoly(), this.currentPath.points[0] = x, this.currentPath.points[1] = y, this;
    }
    /**
   * Draws a line using the current line style from the current drawing position to (x, y);
   * The current drawing position is then set to (x, y).
   * @param x - the X coordinate to draw to
   * @param y - the Y coordinate to draw to
   * @returns - This Graphics object. Good for chaining method calls
   */ lineTo(x, y) {
        this.currentPath || this.moveTo(0, 0);
        const points = this.currentPath.points, fromX = points[points.length - 2], fromY = points[points.length - 1];
        return (fromX !== x || fromY !== y) && points.push(x, y), this;
    }
    /**
   * Initialize the curve
   * @param x
   * @param y
   */ _initCurve(x = 0, y = 0) {
        this.currentPath ? this.currentPath.points.length === 0 && (this.currentPath.points = [
            x,
            y
        ]) : this.moveTo(x, y);
    }
    /**
   * Calculate the points for a quadratic bezier curve and then draws it.
   * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @returns - This Graphics object. Good for chaining method calls
   */ quadraticCurveTo(cpX, cpY, toX, toY) {
        this._initCurve();
        const points = this.currentPath.points;
        return points.length === 0 && this.moveTo(0, 0), (0, $d353c290f9584e5f$export$616649c7d4fcacf2).curveTo(cpX, cpY, toX, toY, points), this;
    }
    /**
   * Calculate the points for a bezier curve and then draws it.
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param cpX2 - Second Control point x
   * @param cpY2 - Second Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @returns This Graphics object. Good for chaining method calls
   */ bezierCurveTo(cpX, cpY, cpX2, cpY2, toX, toY) {
        return this._initCurve(), (0, $a099de60470e6789$export$994e59e1556c01e9).curveTo(cpX, cpY, cpX2, cpY2, toX, toY, this.currentPath.points), this;
    }
    /**
   * The `arcTo` method creates an arc/curve between two tangents on the canvas.
   * The first tangent is from the start point to the first control point,
   * and the second tangent is from the first control point to the second control point.
   * Note that the second control point is not necessarily the end point of the arc.
   *
   * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
   * @param x1 - The x-coordinate of the first control point of the arc
   * @param y1 - The y-coordinate of the first control point of the arc
   * @param x2 - The x-coordinate of the second control point of the arc
   * @param y2 - The y-coordinate of the second control point of the arc
   * @param radius - The radius of the arc
   * @returns - This Graphics object. Good for chaining method calls
   */ arcTo(x1, y1, x2, y2, radius) {
        this._initCurve(x1, y1);
        const points = this.currentPath.points, result = (0, $2e29f2857641ca18$export$e6c43ec4db262573).curveTo(x1, y1, x2, y2, radius, points);
        if (result) {
            const { cx: cx, cy: cy, radius: radius2, startAngle: startAngle, endAngle: endAngle, anticlockwise: anticlockwise } = result;
            this.arc(cx, cy, radius2, startAngle, endAngle, anticlockwise);
        }
        return this;
    }
    /**
   * The arc method creates an arc/curve (used to create circles, or parts of circles).
   * @param cx - The x-coordinate of the center of the circle
   * @param cy - The y-coordinate of the center of the circle
   * @param radius - The radius of the circle
   * @param startAngle - The starting angle, in radians (0 is at the 3 o'clock position
   *  of the arc's circle)
   * @param endAngle - The ending angle, in radians
   * @param anticlockwise - Specifies whether the drawing should be
   *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
   *  indicates counter-clockwise.
   * @returns - This Graphics object. Good for chaining method calls
   */ arc(cx, cy, radius, startAngle, endAngle, anticlockwise = !1) {
        if (startAngle === endAngle) return this;
        if (!anticlockwise && endAngle <= startAngle ? endAngle += (0, $23fb2779a12001d8$export$59ed0a0a5de1084b) : anticlockwise && startAngle <= endAngle && (startAngle += (0, $23fb2779a12001d8$export$59ed0a0a5de1084b)), endAngle - startAngle === 0) return this;
        const startX = cx + Math.cos(startAngle) * radius, startY = cy + Math.sin(startAngle) * radius, eps = this._geometry.closePointEps;
        let points = this.currentPath ? this.currentPath.points : null;
        if (points) {
            const xDiff = Math.abs(points[points.length - 2] - startX), yDiff = Math.abs(points[points.length - 1] - startY);
            xDiff < eps && yDiff < eps || points.push(startX, startY);
        } else this.moveTo(startX, startY), points = this.currentPath.points;
        return (0, $2e29f2857641ca18$export$e6c43ec4db262573).arc(startX, startY, cx, cy, radius, startAngle, endAngle, anticlockwise, points), this;
    }
    /**
   * Specifies a simple one-color fill that subsequent calls to other Graphics methods
   * (such as lineTo() or drawCircle()) use when drawing.
   * @param {PIXI.ColorSource} color - the color of the fill
   * @param alpha - the alpha of the fill, will override the color's alpha
   * @returns - This Graphics object. Suitable for chaining method calls
   */ beginFill(color = 0, alpha) {
        return this.beginTextureFill({
            texture: (0, $ad1fffd072a707c2$export$5431306cf43de24a).WHITE,
            color: color,
            alpha: alpha
        });
    }
    /**
   * Normalize the color input from options for line style or fill
   * @param {PIXI.IFillStyleOptions} options - Fill style object.
   */ normalizeColor(options) {
        const temp = (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(options.color ?? 0);
        options.color = temp.toNumber(), options.alpha ?? (options.alpha = temp.alpha);
    }
    /**
   * Begin the texture fill.
   * Note: The wrap mode of the texture is forced to REPEAT on render.
   * @param options - Fill style object.
   * @param {PIXI.Texture} [options.texture=PIXI.Texture.WHITE] - Texture to fill
   * @param {PIXI.ColorSource} [options.color=0xffffff] - Background to fill behind texture
   * @param {number} [options.alpha] - Alpha of fill, overrides the color's alpha
   * @param {PIXI.Matrix} [options.matrix=null] - Transform matrix
   * @returns {PIXI.Graphics} This Graphics object. Good for chaining method calls
   */ beginTextureFill(options) {
        const defaultOptions = {
            texture: (0, $ad1fffd072a707c2$export$5431306cf43de24a).WHITE,
            color: 16777215,
            matrix: null
        };
        options = Object.assign(defaultOptions, options), this.normalizeColor(options), this.currentPath && this.startPoly();
        const visible = options.alpha > 0;
        return visible ? (options.matrix && (options.matrix = options.matrix.clone(), options.matrix.invert()), Object.assign(this._fillStyle, {
            visible: visible
        }, options)) : this._fillStyle.reset(), this;
    }
    /**
   * Applies a fill to the lines and shapes that were added since the last call to the beginFill() method.
   * @returns - This Graphics object. Good for chaining method calls
   */ endFill() {
        return this.finishPoly(), this._fillStyle.reset(), this;
    }
    /**
   * Draws a rectangle shape.
   * @param x - The X coord of the top-left of the rectangle
   * @param y - The Y coord of the top-left of the rectangle
   * @param width - The width of the rectangle
   * @param height - The height of the rectangle
   * @returns - This Graphics object. Good for chaining method calls
   */ drawRect(x, y, width, height) {
        return this.drawShape(new (0, $92248a7cf1facbda$export$4617fb02663045ef)(x, y, width, height));
    }
    /**
   * Draw a rectangle shape with rounded/beveled corners.
   * @param x - The X coord of the top-left of the rectangle
   * @param y - The Y coord of the top-left of the rectangle
   * @param width - The width of the rectangle
   * @param height - The height of the rectangle
   * @param radius - Radius of the rectangle corners
   * @returns - This Graphics object. Good for chaining method calls
   */ drawRoundedRect(x, y, width, height, radius) {
        return this.drawShape(new (0, $1a53fd4c44f959c9$export$d55ab2e3dc5a4263)(x, y, width, height, radius));
    }
    /**
   * Draws a circle.
   * @param x - The X coordinate of the center of the circle
   * @param y - The Y coordinate of the center of the circle
   * @param radius - The radius of the circle
   * @returns - This Graphics object. Good for chaining method calls
   */ drawCircle(x, y, radius) {
        return this.drawShape(new (0, $d8ed8bfcdf19787b$export$c89a927ffc67e6fa)(x, y, radius));
    }
    /**
   * Draws an ellipse.
   * @param x - The X coordinate of the center of the ellipse
   * @param y - The Y coordinate of the center of the ellipse
   * @param width - The half width of the ellipse
   * @param height - The half height of the ellipse
   * @returns - This Graphics object. Good for chaining method calls
   */ drawEllipse(x, y, width, height) {
        return this.drawShape(new (0, $60a4773ce5ad46af$export$80b0269ab108fa11)(x, y, width, height));
    }
    /**
   * Draws a polygon using the given path.
   * @param {number[]|PIXI.IPointData[]|PIXI.Polygon} path - The path data used to construct the polygon.
   * @returns - This Graphics object. Good for chaining method calls
   */ drawPolygon(...path) {
        let points, closeStroke = !0;
        const poly = path[0];
        poly.points ? (closeStroke = poly.closeStroke, points = poly.points) : Array.isArray(path[0]) ? points = path[0] : points = path;
        const shape = new (0, $c1a49bce64bda319$export$7d31b617c820d435)(points);
        return shape.closeStroke = closeStroke, this.drawShape(shape), this;
    }
    /**
   * Draw any shape.
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - Shape to draw
   * @returns - This Graphics object. Good for chaining method calls
   */ drawShape(shape) {
        return this._holeMode ? this._geometry.drawHole(shape, this._matrix) : this._geometry.drawShape(shape, this._fillStyle.clone(), this._lineStyle.clone(), this._matrix), this;
    }
    /**
   * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
   * @returns - This Graphics object. Good for chaining method calls
   */ clear() {
        return this._geometry.clear(), this._lineStyle.reset(), this._fillStyle.reset(), this._boundsID++, this._matrix = null, this._holeMode = !1, this.currentPath = null, this;
    }
    /**
   * True if graphics consists of one rectangle, and thus, can be drawn like a Sprite and
   * masked with gl.scissor.
   * @returns - True if only 1 rect.
   */ isFastRect() {
        const data = this._geometry.graphicsData;
        return data.length === 1 && data[0].shape.type === (0, $23fb2779a12001d8$export$511e1d54a4a8684e).RECT && !data[0].matrix && !data[0].holes.length && !(data[0].lineStyle.visible && data[0].lineStyle.width);
    }
    /**
   * Renders the object using the WebGL renderer
   * @param renderer - The renderer
   */ _render(renderer) {
        this.finishPoly();
        const geometry = this._geometry;
        geometry.updateBatches(), geometry.batchable ? (this.batchDirty !== geometry.batchDirty && this._populateBatches(), this._renderBatched(renderer)) : (renderer.batch.flush(), this._renderDirect(renderer));
    }
    /** Populating batches for rendering. */ _populateBatches() {
        const geometry = this._geometry, blendMode = this.blendMode, len = geometry.batches.length;
        this.batchTint = -1, this._transformID = -1, this.batchDirty = geometry.batchDirty, this.batches.length = len, this.vertexData = new Float32Array(geometry.points);
        for(let i = 0; i < len; i++){
            const gI = geometry.batches[i], color = gI.style.color, vertexData = new Float32Array(this.vertexData.buffer, gI.attribStart * 8, gI.attribSize * 2), uvs = new Float32Array(geometry.uvsFloat32.buffer, gI.attribStart * 8, gI.attribSize * 2), indices = new Uint16Array(geometry.indicesUint16.buffer, gI.start * 2, gI.size), batch = {
                vertexData: vertexData,
                blendMode: blendMode,
                indices: indices,
                uvs: uvs,
                _batchRGB: (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(color).toRgbArray(),
                _tintRGB: color,
                _texture: gI.style.texture,
                alpha: gI.style.alpha,
                worldAlpha: 1
            };
            this.batches[i] = batch;
        }
    }
    /**
   * Renders the batches using the BathedRenderer plugin
   * @param renderer - The renderer
   */ _renderBatched(renderer) {
        if (this.batches.length) {
            renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]), this.calculateVertices(), this.calculateTints();
            for(let i = 0, l = this.batches.length; i < l; i++){
                const batch = this.batches[i];
                batch.worldAlpha = this.worldAlpha * batch.alpha, renderer.plugins[this.pluginName].render(batch);
            }
        }
    }
    /**
   * Renders the graphics direct
   * @param renderer - The renderer
   */ _renderDirect(renderer) {
        const shader = this._resolveDirectShader(renderer), geometry = this._geometry, worldAlpha = this.worldAlpha, uniforms = shader.uniforms, drawCalls = geometry.drawCalls;
        uniforms.translationMatrix = this.transform.worldTransform, (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(this._tintColor).premultiply(worldAlpha).toArray(uniforms.tint), renderer.shader.bind(shader), renderer.geometry.bind(geometry, shader), renderer.state.set(this.state);
        for(let i = 0, l = drawCalls.length; i < l; i++)this._renderDrawCallDirect(renderer, geometry.drawCalls[i]);
    }
    /**
   * Renders specific DrawCall
   * @param renderer
   * @param drawCall
   */ _renderDrawCallDirect(renderer, drawCall) {
        const { texArray: texArray, type: type, size: size, start: start } = drawCall, groupTextureCount = texArray.count;
        for(let j = 0; j < groupTextureCount; j++)renderer.texture.bind(texArray.elements[j], j);
        renderer.geometry.draw(type, size, start);
    }
    /**
   * Resolves shader for direct rendering
   * @param renderer - The renderer
   */ _resolveDirectShader(renderer) {
        let shader = this.shader;
        const pluginName = this.pluginName;
        if (!shader) {
            if (!$d21713afb1bb29fd$var$DEFAULT_SHADERS[pluginName]) {
                const { maxTextures: maxTextures } = renderer.plugins[pluginName], sampleValues = new Int32Array(maxTextures);
                for(let i = 0; i < maxTextures; i++)sampleValues[i] = i;
                const uniforms = {
                    tint: new Float32Array([
                        1,
                        1,
                        1,
                        1
                    ]),
                    translationMatrix: new (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85)(),
                    default: (0, $f3ba15c3d8ec3ea5$export$6601a7a2dcf79bf5).from({
                        uSamplers: sampleValues
                    }, !0)
                }, program = renderer.plugins[pluginName]._shader.program;
                $d21713afb1bb29fd$var$DEFAULT_SHADERS[pluginName] = new (0, $20320a9b1d80d7dc$export$462bb059fed9d9e5)(program, uniforms);
            }
            shader = $d21713afb1bb29fd$var$DEFAULT_SHADERS[pluginName];
        }
        return shader;
    }
    /**
   * Retrieves the bounds of the graphic shape as a rectangle object.
   * @see PIXI.GraphicsGeometry#bounds
   */ _calculateBounds() {
        this.finishPoly();
        const geometry = this._geometry;
        if (!geometry.graphicsData.length) return;
        const { minX: minX, minY: minY, maxX: maxX, maxY: maxY } = geometry.bounds;
        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
    }
    /**
   * Tests if a point is inside this graphics object
   * @param point - the point to test
   * @returns - the result of the test
   */ containsPoint(point) {
        return this.worldTransform.applyInverse(point, _Graphics2._TEMP_POINT), this._geometry.containsPoint(_Graphics2._TEMP_POINT);
    }
    /** Recalculate the tint by applying tint to batches using Graphics tint. */ calculateTints() {
        if (this.batchTint !== this.tint) {
            this.batchTint = this._tintColor.toNumber();
            for(let i = 0; i < this.batches.length; i++){
                const batch = this.batches[i];
                batch._tintRGB = (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(this._tintColor).multiply(batch._batchRGB).toLittleEndianNumber();
            }
        }
    }
    /** If there's a transform update or a change to the shape of the geometry, recalculate the vertices. */ calculateVertices() {
        const wtID = this.transform._worldID;
        if (this._transformID === wtID) return;
        this._transformID = wtID;
        const wt = this.transform.worldTransform, a = wt.a, b = wt.b, c = wt.c, d = wt.d, tx = wt.tx, ty = wt.ty, data = this._geometry.points, vertexData = this.vertexData;
        let count = 0;
        for(let i = 0; i < data.length; i += 2){
            const x = data[i], y = data[i + 1];
            vertexData[count++] = a * x + c * y + tx, vertexData[count++] = d * y + b * x + ty;
        }
    }
    /**
   * Closes the current path.
   * @returns - Returns itself.
   */ closePath() {
        const currentPath = this.currentPath;
        return currentPath && (currentPath.closeStroke = !0, this.finishPoly()), this;
    }
    /**
   * Apply a matrix to the positional data.
   * @param matrix - Matrix to use for transform current shape.
   * @returns - Returns itself.
   */ setMatrix(matrix) {
        return this._matrix = matrix, this;
    }
    /**
   * Begin adding holes to the last draw shape
   * IMPORTANT: holes must be fully inside a shape to work
   * Also weirdness ensues if holes overlap!
   * Ellipses, Circles, Rectangles and Rounded Rectangles cannot be holes or host for holes in CanvasRenderer,
   * please use `moveTo` `lineTo`, `quadraticCurveTo` if you rely on pixi-legacy bundle.
   * @returns - Returns itself.
   */ beginHole() {
        return this.finishPoly(), this._holeMode = !0, this;
    }
    /**
   * End adding holes to the last draw shape.
   * @returns - Returns itself.
   */ endHole() {
        return this.finishPoly(), this._holeMode = !1, this;
    }
    /**
   * Destroys the Graphics object.
   * @param options - Options parameter. A boolean will act as if all
   *  options have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have
   *  their destroy method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the texture of the child sprite
   * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the base texture of the child sprite
   */ destroy(options) {
        this._geometry.refCount--, this._geometry.refCount === 0 && this._geometry.dispose(), this._matrix = null, this.currentPath = null, this._lineStyle.destroy(), this._lineStyle = null, this._fillStyle.destroy(), this._fillStyle = null, this._geometry = null, this.shader = null, this.vertexData = null, this.batches.length = 0, this.batches = null, super.destroy(options);
    }
};
$d21713afb1bb29fd$var$_Graphics.curves = (0, $eeb8675c180a59bd$export$6894093bf294bea5), /**
* Temporary point to use for containsPoint.
* @private
*/ $d21713afb1bb29fd$var$_Graphics._TEMP_POINT = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)();
let $d21713afb1bb29fd$export$29d3e417456abdad = $d21713afb1bb29fd$var$_Graphics;















const $b5fa70d898ce06fc$export$efc72ad5bf88689 = {
    buildPoly: $0d97ff17134e4d4b$export$7de1a57618f21e1f,
    buildCircle: $dc7a2cff433cc948$export$a3541b2d8ecbfcf2,
    buildRectangle: $e302c0242e07d250$export$cbe813d11f2192b2,
    buildRoundedRectangle: $52c527c07f16e6a8$export$4b54fce47d2ae7f4,
    buildLine: $885e7a4f193e58ac$export$45986ccf08e93b0b,
    ArcUtils: $2e29f2857641ca18$export$e6c43ec4db262573,
    BezierUtils: $a099de60470e6789$export$994e59e1556c01e9,
    QuadraticUtils: $d353c290f9584e5f$export$616649c7d4fcacf2,
    BatchPart: $58a0c93698fbf54e$export$3abbb88a93faeec2,
    FILL_COMMANDS: $cfd96406afbcfaa9$export$b738057f7c88a634,
    BATCH_POOL: $cfd96406afbcfaa9$export$78aca0cfc72b8d6,
    DRAW_CALL_POOL: $cfd96406afbcfaa9$export$e520c68c6872beed
};




class $c63997705b7d5c0a$export$49cc356fa6ba0e7b {
    /**
   * @param uvBuffer - Buffer with normalized uv's
   * @param uvMatrix - Material UV matrix
   */ constructor(uvBuffer, uvMatrix){
        this.uvBuffer = uvBuffer, this.uvMatrix = uvMatrix, this.data = null, this._bufferUpdateId = -1, this._textureUpdateId = -1, this._updateID = 0;
    }
    /**
   * Updates
   * @param forceUpdate - force the update
   */ update(forceUpdate) {
        if (!forceUpdate && this._bufferUpdateId === this.uvBuffer._updateID && this._textureUpdateId === this.uvMatrix._updateID) return;
        this._bufferUpdateId = this.uvBuffer._updateID, this._textureUpdateId = this.uvMatrix._updateID;
        const data = this.uvBuffer.data;
        (!this.data || this.data.length !== data.length) && (this.data = new Float32Array(data.length)), this.uvMatrix.multiplyUvs(data, this.data), this._updateID++;
    }
}


const $64c4acb8821d317d$var$tempPoint = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(), $64c4acb8821d317d$var$tempPolygon = new (0, $c1a49bce64bda319$export$7d31b617c820d435)(), $64c4acb8821d317d$var$_Mesh = class _Mesh2 extends (0, $3878067a77b781d9$export$42a852a2b6b56249) {
    /**
   * @param geometry - The geometry the mesh will use.
   * @param {PIXI.MeshMaterial} shader - The shader the mesh will use.
   * @param state - The state that the WebGL context is required to be in to render the mesh
   *        if no state is provided, uses {@link PIXI.State.for2d} to create a 2D state for PixiJS.
   * @param drawMode - The drawMode, can be any of the {@link PIXI.DRAW_MODES} constants.
   */ constructor(geometry, shader, state, drawMode = (0, $5912637ee8cf8b9f$export$91100badd8469338).TRIANGLES){
        super(), this.geometry = geometry, this.shader = shader, this.state = state || (0, $05d0e9a749f67df1$export$7254cc27399e90bd).for2d(), this.drawMode = drawMode, this.start = 0, this.size = 0, this.uvs = null, this.indices = null, this.vertexData = new Float32Array(1), this.vertexDirty = -1, this._transformID = -1, this._roundPixels = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ROUND_PIXELS, this.batchUvs = null;
    }
    /**
   * Includes vertex positions, face indices, normals, colors, UVs, and
   * custom attributes within buffers, reducing the cost of passing all
   * this data to the GPU. Can be shared between multiple Mesh objects.
   */ get geometry() {
        return this._geometry;
    }
    set geometry(value) {
        this._geometry !== value && (this._geometry && (this._geometry.refCount--, this._geometry.refCount === 0 && this._geometry.dispose()), this._geometry = value, this._geometry && this._geometry.refCount++, this.vertexDirty = -1);
    }
    /**
   * To change mesh uv's, change its uvBuffer data and increment its _updateID.
   * @readonly
   */ get uvBuffer() {
        return this.geometry.buffers[1];
    }
    /**
   * To change mesh vertices, change its uvBuffer data and increment its _updateID.
   * Incrementing _updateID is optional because most of Mesh objects do it anyway.
   * @readonly
   */ get verticesBuffer() {
        return this.geometry.buffers[0];
    }
    /** Alias for {@link PIXI.Mesh#shader}. */ set material(value) {
        this.shader = value;
    }
    get material() {
        return this.shader;
    }
    /**
   * The blend mode to be applied to the Mesh. Apply a value of
   * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
   * @default PIXI.BLEND_MODES.NORMAL;
   */ set blendMode(value) {
        this.state.blendMode = value;
    }
    get blendMode() {
        return this.state.blendMode;
    }
    /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
   * @default false
   */ set roundPixels(value) {
        this._roundPixels !== value && (this._transformID = -1), this._roundPixels = value;
    }
    get roundPixels() {
        return this._roundPixels;
    }
    /**
   * The multiply tint applied to the Mesh. This is a hex value. A value of
   * `0xFFFFFF` will remove any tint effect.
   *
   * Null for non-MeshMaterial shaders
   * @default 0xFFFFFF
   */ get tint() {
        return "tint" in this.shader ? this.shader.tint : null;
    }
    set tint(value) {
        this.shader.tint = value;
    }
    /**
   * The tint color as a RGB integer
   * @ignore
   */ get tintValue() {
        return this.shader.tintValue;
    }
    /** The texture that the Mesh uses. Null for non-MeshMaterial shaders */ get texture() {
        return "texture" in this.shader ? this.shader.texture : null;
    }
    set texture(value) {
        this.shader.texture = value;
    }
    /**
   * Standard renderer draw.
   * @param renderer - Instance to renderer.
   */ _render(renderer) {
        const vertices = this.geometry.buffers[0].data;
        this.shader.batchable && this.drawMode === (0, $5912637ee8cf8b9f$export$91100badd8469338).TRIANGLES && vertices.length < _Mesh2.BATCHABLE_SIZE * 2 ? this._renderToBatch(renderer) : this._renderDefault(renderer);
    }
    /**
   * Standard non-batching way of rendering.
   * @param renderer - Instance to renderer.
   */ _renderDefault(renderer) {
        const shader = this.shader;
        shader.alpha = this.worldAlpha, shader.update && shader.update(), renderer.batch.flush(), shader.uniforms.translationMatrix = this.transform.worldTransform.toArray(!0), renderer.shader.bind(shader), renderer.state.set(this.state), renderer.geometry.bind(this.geometry, shader), renderer.geometry.draw(this.drawMode, this.size, this.start, this.geometry.instanceCount);
    }
    /**
   * Rendering by using the Batch system.
   * @param renderer - Instance to renderer.
   */ _renderToBatch(renderer) {
        const geometry = this.geometry, shader = this.shader;
        shader.uvMatrix && (shader.uvMatrix.update(), this.calculateUvs()), this.calculateVertices(), this.indices = geometry.indexBuffer.data, this._tintRGB = shader._tintRGB, this._texture = shader.texture;
        const pluginName = this.material.pluginName;
        renderer.batch.setObjectRenderer(renderer.plugins[pluginName]), renderer.plugins[pluginName].render(this);
    }
    /** Updates vertexData field based on transform and vertices. */ calculateVertices() {
        const verticesBuffer = this.geometry.buffers[0], vertices = verticesBuffer.data, vertexDirtyId = verticesBuffer._updateID;
        if (vertexDirtyId === this.vertexDirty && this._transformID === this.transform._worldID) return;
        this._transformID = this.transform._worldID, this.vertexData.length !== vertices.length && (this.vertexData = new Float32Array(vertices.length));
        const wt = this.transform.worldTransform, a = wt.a, b = wt.b, c = wt.c, d = wt.d, tx = wt.tx, ty = wt.ty, vertexData = this.vertexData;
        for(let i = 0; i < vertexData.length / 2; i++){
            const x = vertices[i * 2], y = vertices[i * 2 + 1];
            vertexData[i * 2] = a * x + c * y + tx, vertexData[i * 2 + 1] = b * x + d * y + ty;
        }
        if (this._roundPixels) {
            const resolution = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).RESOLUTION;
            for(let i = 0; i < vertexData.length; ++i)vertexData[i] = Math.round(vertexData[i] * resolution) / resolution;
        }
        this.vertexDirty = vertexDirtyId;
    }
    /** Updates uv field based on from geometry uv's or batchUvs. */ calculateUvs() {
        const geomUvs = this.geometry.buffers[1], shader = this.shader;
        shader.uvMatrix.isSimple ? this.uvs = geomUvs.data : (this.batchUvs || (this.batchUvs = new (0, $c63997705b7d5c0a$export$49cc356fa6ba0e7b)(geomUvs, shader.uvMatrix)), this.batchUvs.update(), this.uvs = this.batchUvs.data);
    }
    /**
   * Updates the bounds of the mesh as a rectangle. The bounds calculation takes the worldTransform into account.
   * there must be a aVertexPosition attribute present in the geometry for bounds to be calculated correctly.
   */ _calculateBounds() {
        this.calculateVertices(), this._bounds.addVertexData(this.vertexData, 0, this.vertexData.length);
    }
    /**
   * Tests if a point is inside this mesh. Works only for PIXI.DRAW_MODES.TRIANGLES.
   * @param point - The point to test.
   * @returns - The result of the test.
   */ containsPoint(point) {
        if (!this.getBounds().contains(point.x, point.y)) return !1;
        this.worldTransform.applyInverse(point, $64c4acb8821d317d$var$tempPoint);
        const vertices = this.geometry.getBuffer("aVertexPosition").data, points = $64c4acb8821d317d$var$tempPolygon.points, indices = this.geometry.getIndex().data, len = indices.length, step = this.drawMode === 4 ? 3 : 1;
        for(let i = 0; i + 2 < len; i += step){
            const ind0 = indices[i] * 2, ind1 = indices[i + 1] * 2, ind2 = indices[i + 2] * 2;
            if (points[0] = vertices[ind0], points[1] = vertices[ind0 + 1], points[2] = vertices[ind1], points[3] = vertices[ind1 + 1], points[4] = vertices[ind2], points[5] = vertices[ind2 + 1], $64c4acb8821d317d$var$tempPolygon.contains($64c4acb8821d317d$var$tempPoint.x, $64c4acb8821d317d$var$tempPoint.y)) return !0;
        }
        return !1;
    }
    destroy(options) {
        super.destroy(options), this._cachedTexture && (this._cachedTexture.destroy(), this._cachedTexture = null), this.geometry = null, this.shader = null, this.state = null, this.uvs = null, this.indices = null, this.vertexData = null;
    }
};
$64c4acb8821d317d$var$_Mesh.BATCHABLE_SIZE = 100;
let $64c4acb8821d317d$export$e176487c05830cc5 = $64c4acb8821d317d$var$_Mesh;




class $1acafc55b3767469$export$8d075a36a73d54bc extends (0, $dd93eefb01cd7345$export$2db6c17465f94a2) {
    /**
   * @param {Float32Array|number[]} [vertices] - Positional data on geometry.
   * @param {Float32Array|number[]} [uvs] - Texture UVs.
   * @param {Uint16Array|number[]} [index] - IndexBuffer
   */ constructor(vertices, uvs, index){
        super();
        const verticesBuffer = new (0, $4da95ef50ded5f29$export$a143d493d941bafc)(vertices), uvsBuffer = new (0, $4da95ef50ded5f29$export$a143d493d941bafc)(uvs, !0), indexBuffer = new (0, $4da95ef50ded5f29$export$a143d493d941bafc)(index, !0, !0);
        this.addAttribute("aVertexPosition", verticesBuffer, 2, !1, (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).FLOAT).addAttribute("aTextureCoord", uvsBuffer, 2, !1, (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).FLOAT).addIndex(indexBuffer), this._updateId = -1;
    }
    /**
   * If the vertex position is updated.
   * @readonly
   * @private
   */ get vertexDirtyId() {
        return this.buffers[0]._updateID;
    }
}



var $f069c8847429c6ac$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;
uniform vec4 uColor;

uniform sampler2D uSampler;

void main(void)
{
    gl_FragColor = texture2D(uSampler, vTextureCoord) * uColor;
}
`;


var $d26ef7040d518a18$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTextureMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;
}
`;


class $7b5a5666c23f04ad$export$d552dadfd66cc650 extends (0, $20320a9b1d80d7dc$export$462bb059fed9d9e5) {
    /**
   * @param uSampler - Texture that material uses to render.
   * @param options - Additional options
   * @param {number} [options.alpha=1] - Default alpha.
   * @param {PIXI.ColorSource} [options.tint=0xFFFFFF] - Default tint.
   * @param {string} [options.pluginName='batch'] - Renderer plugin for batching.
   * @param {PIXI.Program} [options.program=0xFFFFFF] - Custom program.
   * @param {object} [options.uniforms] - Custom uniforms.
   */ constructor(uSampler, options){
        const uniforms = {
            uSampler: uSampler,
            alpha: 1,
            uTextureMatrix: (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85).IDENTITY,
            uColor: new Float32Array([
                1,
                1,
                1,
                1
            ])
        };
        options = Object.assign({
            tint: 16777215,
            alpha: 1,
            pluginName: "batch"
        }, options), options.uniforms && Object.assign(uniforms, options.uniforms), super(options.program || (0, $529286cda46872bb$export$b6c59b989905b650).from((0, $d26ef7040d518a18$export$2e2bcd8739ae039), (0, $f069c8847429c6ac$export$2e2bcd8739ae039)), uniforms), this._colorDirty = !1, this.uvMatrix = new (0, $132bbbe3a3fc729e$export$dbea3135e9da48cb)(uSampler), this.batchable = options.program === void 0, this.pluginName = options.pluginName, this._tintColor = new (0, $3119899e085d9ccf$export$892596cec99bc70e)(options.tint), this._tintRGB = this._tintColor.toLittleEndianNumber(), this._colorDirty = !0, this.alpha = options.alpha;
    }
    /** Reference to the texture being rendered. */ get texture() {
        return this.uniforms.uSampler;
    }
    set texture(value) {
        this.uniforms.uSampler !== value && (!this.uniforms.uSampler.baseTexture.alphaMode != !value.baseTexture.alphaMode && (this._colorDirty = !0), this.uniforms.uSampler = value, this.uvMatrix.texture = value);
    }
    /**
   * This gets automatically set by the object using this.
   * @default 1
   */ set alpha(value) {
        value !== this._alpha && (this._alpha = value, this._colorDirty = !0);
    }
    get alpha() {
        return this._alpha;
    }
    /**
   * Multiply tint for the material.
   * @default 0xFFFFFF
   */ set tint(value) {
        value !== this.tint && (this._tintColor.setValue(value), this._tintRGB = this._tintColor.toLittleEndianNumber(), this._colorDirty = !0);
    }
    get tint() {
        return this._tintColor.value;
    }
    /**
   * Get the internal number from tint color
   * @ignore
   */ get tintValue() {
        return this._tintColor.toNumber();
    }
    /** Gets called automatically by the Mesh. Intended to be overridden for custom {@link PIXI.MeshMaterial} objects. */ update() {
        if (this._colorDirty) {
            this._colorDirty = !1;
            const applyToChannels = this.texture.baseTexture.alphaMode;
            (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(this._tintColor).premultiply(this._alpha, applyToChannels).toArray(this.uniforms.uColor);
        }
        this.uvMatrix.update() && (this.uniforms.uTextureMatrix = this.uvMatrix.mapCoord);
    }
}





class $f586347bc634a8c3$export$967d831af31f69ce extends (0, $1acafc55b3767469$export$8d075a36a73d54bc) {
    /**
   * @param width - The width of the plane.
   * @param height - The height of the plane.
   * @param segWidth - Number of horizontal segments.
   * @param segHeight - Number of vertical segments.
   */ constructor(width = 100, height = 100, segWidth = 10, segHeight = 10){
        super(), this.segWidth = segWidth, this.segHeight = segHeight, this.width = width, this.height = height, this.build();
    }
    /**
   * Refreshes plane coordinates
   * @private
   */ build() {
        const total = this.segWidth * this.segHeight, verts = [], uvs = [], indices = [], segmentsX = this.segWidth - 1, segmentsY = this.segHeight - 1, sizeX = this.width / segmentsX, sizeY = this.height / segmentsY;
        for(let i = 0; i < total; i++){
            const x = i % this.segWidth, y = i / this.segWidth | 0;
            verts.push(x * sizeX, y * sizeY), uvs.push(x / segmentsX, y / segmentsY);
        }
        const totalSub = segmentsX * segmentsY;
        for(let i = 0; i < totalSub; i++){
            const xpos = i % segmentsX, ypos = i / segmentsX | 0, value = ypos * this.segWidth + xpos, value2 = ypos * this.segWidth + xpos + 1, value3 = (ypos + 1) * this.segWidth + xpos, value4 = (ypos + 1) * this.segWidth + xpos + 1;
            indices.push(value, value2, value3, value2, value4, value3);
        }
        this.buffers[0].data = new Float32Array(verts), this.buffers[1].data = new Float32Array(uvs), this.indexBuffer.data = new Uint16Array(indices), this.buffers[0].update(), this.buffers[1].update(), this.indexBuffer.update();
    }
}



class $9baefda0bece441a$export$6a9827483976bf64 extends (0, $1acafc55b3767469$export$8d075a36a73d54bc) {
    /**
   * @param width - The width (i.e., thickness) of the rope.
   * @param points - An array of {@link PIXI.Point} objects to construct this rope.
   * @param textureScale - By default the rope texture will be stretched to match
   *     rope length. If textureScale is positive this value will be treated as a scaling
   *     factor and the texture will preserve its aspect ratio instead. To create a tiling rope
   *     set baseTexture.wrapMode to {@link PIXI.WRAP_MODES.REPEAT} and use a power of two texture,
   *     then set textureScale=1 to keep the original texture pixel size.
   *     In order to reduce alpha channel artifacts provide a larger texture and downsample -
   *     i.e. set textureScale=0.5 to scale it down twice.
   */ constructor(width = 200, points, textureScale = 0){
        super(new Float32Array(points.length * 4), new Float32Array(points.length * 4), new Uint16Array((points.length - 1) * 6)), this.points = points, this._width = width, this.textureScale = textureScale, this.build();
    }
    /**
   * The width (i.e., thickness) of the rope.
   * @readonly
   */ get width() {
        return this._width;
    }
    /** Refreshes Rope indices and uvs */ build() {
        const points = this.points;
        if (!points) return;
        const vertexBuffer = this.getBuffer("aVertexPosition"), uvBuffer = this.getBuffer("aTextureCoord"), indexBuffer = this.getIndex();
        if (points.length < 1) return;
        vertexBuffer.data.length / 4 !== points.length && (vertexBuffer.data = new Float32Array(points.length * 4), uvBuffer.data = new Float32Array(points.length * 4), indexBuffer.data = new Uint16Array((points.length - 1) * 6));
        const uvs = uvBuffer.data, indices = indexBuffer.data;
        uvs[0] = 0, uvs[1] = 0, uvs[2] = 0, uvs[3] = 1;
        let amount = 0, prev = points[0];
        const textureWidth = this._width * this.textureScale, total = points.length;
        for(let i = 0; i < total; i++){
            const index = i * 4;
            if (this.textureScale > 0) {
                const dx = prev.x - points[i].x, dy = prev.y - points[i].y, distance = Math.sqrt(dx * dx + dy * dy);
                prev = points[i], amount += distance / textureWidth;
            } else amount = i / (total - 1);
            uvs[index] = amount, uvs[index + 1] = 0, uvs[index + 2] = amount, uvs[index + 3] = 1;
        }
        let indexCount = 0;
        for(let i = 0; i < total - 1; i++){
            const index = i * 2;
            indices[indexCount++] = index, indices[indexCount++] = index + 1, indices[indexCount++] = index + 2, indices[indexCount++] = index + 2, indices[indexCount++] = index + 1, indices[indexCount++] = index + 3;
        }
        uvBuffer.update(), indexBuffer.update(), this.updateVertices();
    }
    /** refreshes vertices of Rope mesh */ updateVertices() {
        const points = this.points;
        if (points.length < 1) return;
        let lastPoint = points[0], nextPoint, perpX = 0, perpY = 0;
        const vertices = this.buffers[0].data, total = points.length, halfWidth = this.textureScale > 0 ? this.textureScale * this._width / 2 : this._width / 2;
        for(let i = 0; i < total; i++){
            const point = points[i], index = i * 4;
            i < points.length - 1 ? nextPoint = points[i + 1] : nextPoint = point, perpY = -(nextPoint.x - lastPoint.x), perpX = nextPoint.y - lastPoint.y;
            let ratio = (1 - i / (total - 1)) * 10;
            ratio > 1 && (ratio = 1);
            const perpLength = Math.sqrt(perpX * perpX + perpY * perpY);
            perpLength < 1e-6 ? (perpX = 0, perpY = 0) : (perpX /= perpLength, perpY /= perpLength, perpX *= halfWidth, perpY *= halfWidth), vertices[index] = point.x + perpX, vertices[index + 1] = point.y + perpY, vertices[index + 2] = point.x - perpX, vertices[index + 3] = point.y - perpY, lastPoint = point;
        }
        this.buffers[0].update();
    }
    update() {
        this.textureScale > 0 ? this.build() : this.updateVertices();
    }
}






class $ad0f602e4876b79a$export$d47c1aa7111669b9 extends (0, $64c4acb8821d317d$export$e176487c05830cc5) {
    /**
   * @param texture - The texture to use on the SimplePlane.
   * @param verticesX - The number of vertices in the x-axis
   * @param verticesY - The number of vertices in the y-axis
   */ constructor(texture, verticesX, verticesY){
        const planeGeometry = new (0, $f586347bc634a8c3$export$967d831af31f69ce)(texture.width, texture.height, verticesX, verticesY), meshMaterial = new (0, $7b5a5666c23f04ad$export$d552dadfd66cc650)((0, $ad1fffd072a707c2$export$5431306cf43de24a).WHITE);
        super(planeGeometry, meshMaterial), this.texture = texture, this.autoResize = !0;
    }
    /**
   * Method used for overrides, to do something in case texture frame was changed.
   * Meshes based on plane can override it and change more details based on texture.
   */ textureUpdated() {
        this._textureID = this.shader.texture._updateID;
        const geometry = this.geometry, { width: width, height: height } = this.shader.texture;
        this.autoResize && (geometry.width !== width || geometry.height !== height) && (geometry.width = this.shader.texture.width, geometry.height = this.shader.texture.height, geometry.build());
    }
    set texture(value) {
        this.shader.texture !== value && (this.shader.texture = value, this._textureID = -1, value.baseTexture.valid ? this.textureUpdated() : value.once("update", this.textureUpdated, this));
    }
    get texture() {
        return this.shader.texture;
    }
    _render(renderer) {
        this._textureID !== this.shader.texture._updateID && this.textureUpdated(), super._render(renderer);
    }
    destroy(options) {
        this.shader.texture.off("update", this.textureUpdated, this), super.destroy(options);
    }
}


const $5b008dcfed371399$var$DEFAULT_BORDER_SIZE = 10;
class $5b008dcfed371399$export$acdf4cb3f489544e extends (0, $ad0f602e4876b79a$export$d47c1aa7111669b9) {
    /**
   * @param texture - The texture to use on the NineSlicePlane.
   * @param {number} [leftWidth=10] - size of the left vertical bar (A)
   * @param {number} [topHeight=10] - size of the top horizontal bar (C)
   * @param {number} [rightWidth=10] - size of the right vertical bar (B)
   * @param {number} [bottomHeight=10] - size of the bottom horizontal bar (D)
   */ constructor(texture, leftWidth, topHeight, rightWidth, bottomHeight){
        super((0, $ad1fffd072a707c2$export$5431306cf43de24a).WHITE, 4, 4), this._origWidth = texture.orig.width, this._origHeight = texture.orig.height, this._width = this._origWidth, this._height = this._origHeight, this._leftWidth = leftWidth ?? texture.defaultBorders?.left ?? $5b008dcfed371399$var$DEFAULT_BORDER_SIZE, this._rightWidth = rightWidth ?? texture.defaultBorders?.right ?? $5b008dcfed371399$var$DEFAULT_BORDER_SIZE, this._topHeight = topHeight ?? texture.defaultBorders?.top ?? $5b008dcfed371399$var$DEFAULT_BORDER_SIZE, this._bottomHeight = bottomHeight ?? texture.defaultBorders?.bottom ?? $5b008dcfed371399$var$DEFAULT_BORDER_SIZE, this.texture = texture;
    }
    textureUpdated() {
        this._textureID = this.shader.texture._updateID, this._refresh();
    }
    get vertices() {
        return this.geometry.getBuffer("aVertexPosition").data;
    }
    set vertices(value) {
        this.geometry.getBuffer("aVertexPosition").data = value;
    }
    /** Updates the horizontal vertices. */ updateHorizontalVertices() {
        const vertices = this.vertices, scale = this._getMinScale();
        vertices[9] = vertices[11] = vertices[13] = vertices[15] = this._topHeight * scale, vertices[17] = vertices[19] = vertices[21] = vertices[23] = this._height - this._bottomHeight * scale, vertices[25] = vertices[27] = vertices[29] = vertices[31] = this._height;
    }
    /** Updates the vertical vertices. */ updateVerticalVertices() {
        const vertices = this.vertices, scale = this._getMinScale();
        vertices[2] = vertices[10] = vertices[18] = vertices[26] = this._leftWidth * scale, vertices[4] = vertices[12] = vertices[20] = vertices[28] = this._width - this._rightWidth * scale, vertices[6] = vertices[14] = vertices[22] = vertices[30] = this._width;
    }
    /**
   * Returns the smaller of a set of vertical and horizontal scale of nine slice corners.
   * @returns Smaller number of vertical and horizontal scale.
   */ _getMinScale() {
        const w = this._leftWidth + this._rightWidth, scaleW = this._width > w ? 1 : this._width / w, h = this._topHeight + this._bottomHeight, scaleH = this._height > h ? 1 : this._height / h;
        return Math.min(scaleW, scaleH);
    }
    /** The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */ get width() {
        return this._width;
    }
    set width(value) {
        this._width = value, this._refresh();
    }
    /** The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */ get height() {
        return this._height;
    }
    set height(value) {
        this._height = value, this._refresh();
    }
    /** The width of the left column. */ get leftWidth() {
        return this._leftWidth;
    }
    set leftWidth(value) {
        this._leftWidth = value, this._refresh();
    }
    /** The width of the right column. */ get rightWidth() {
        return this._rightWidth;
    }
    set rightWidth(value) {
        this._rightWidth = value, this._refresh();
    }
    /** The height of the top row. */ get topHeight() {
        return this._topHeight;
    }
    set topHeight(value) {
        this._topHeight = value, this._refresh();
    }
    /** The height of the bottom row. */ get bottomHeight() {
        return this._bottomHeight;
    }
    set bottomHeight(value) {
        this._bottomHeight = value, this._refresh();
    }
    /** Refreshes NineSlicePlane coords. All of them. */ _refresh() {
        const texture = this.texture, uvs = this.geometry.buffers[1].data;
        this._origWidth = texture.orig.width, this._origHeight = texture.orig.height;
        const _uvw = 1 / this._origWidth, _uvh = 1 / this._origHeight;
        uvs[0] = uvs[8] = uvs[16] = uvs[24] = 0, uvs[1] = uvs[3] = uvs[5] = uvs[7] = 0, uvs[6] = uvs[14] = uvs[22] = uvs[30] = 1, uvs[25] = uvs[27] = uvs[29] = uvs[31] = 1, uvs[2] = uvs[10] = uvs[18] = uvs[26] = _uvw * this._leftWidth, uvs[4] = uvs[12] = uvs[20] = uvs[28] = 1 - _uvw * this._rightWidth, uvs[9] = uvs[11] = uvs[13] = uvs[15] = _uvh * this._topHeight, uvs[17] = uvs[19] = uvs[21] = uvs[23] = 1 - _uvh * this._bottomHeight, this.updateHorizontalVertices(), this.updateVerticalVertices(), this.geometry.buffers[0].update(), this.geometry.buffers[1].update();
    }
}




class $053d3dfb74318514$export$81b9e78682e7feca extends (0, $64c4acb8821d317d$export$e176487c05830cc5) {
    /**
   * @param texture - The texture to use
   * @param {Float32Array} [vertices] - if you want to specify the vertices
   * @param {Float32Array} [uvs] - if you want to specify the uvs
   * @param {Uint16Array} [indices] - if you want to specify the indices
   * @param drawMode - the drawMode, can be any of the Mesh.DRAW_MODES consts
   */ constructor(texture = (0, $ad1fffd072a707c2$export$5431306cf43de24a).EMPTY, vertices, uvs, indices, drawMode){
        const geometry = new (0, $1acafc55b3767469$export$8d075a36a73d54bc)(vertices, uvs, indices);
        geometry.getBuffer("aVertexPosition").static = !1;
        const meshMaterial = new (0, $7b5a5666c23f04ad$export$d552dadfd66cc650)(texture);
        super(geometry, meshMaterial, null, drawMode), this.autoUpdate = !0;
    }
    /**
   * Collection of vertices data.
   * @type {Float32Array}
   */ get vertices() {
        return this.geometry.getBuffer("aVertexPosition").data;
    }
    set vertices(value) {
        this.geometry.getBuffer("aVertexPosition").data = value;
    }
    _render(renderer) {
        this.autoUpdate && this.geometry.getBuffer("aVertexPosition").update(), super._render(renderer);
    }
}






class $b5392b4228c578b9$export$f009a14c3f00879e extends (0, $64c4acb8821d317d$export$e176487c05830cc5) {
    /**
   * Note: The wrap mode of the texture is set to REPEAT if `textureScale` is positive.
   * @param texture - The texture to use on the rope.
   * @param points - An array of {@link PIXI.Point} objects to construct this rope.
   * @param {number} textureScale - Optional. Positive values scale rope texture
   * keeping its aspect ratio. You can reduce alpha channel artifacts by providing a larger texture
   * and downsampling here. If set to zero, texture will be stretched instead.
   */ constructor(texture, points, textureScale = 0){
        const ropeGeometry = new (0, $9baefda0bece441a$export$6a9827483976bf64)(texture.height, points, textureScale), meshMaterial = new (0, $7b5a5666c23f04ad$export$d552dadfd66cc650)(texture);
        textureScale > 0 && (texture.baseTexture.wrapMode = (0, $5912637ee8cf8b9f$export$2ab395cfb0dd2f0f).REPEAT), super(ropeGeometry, meshMaterial), this.autoUpdate = !0;
    }
    _render(renderer) {
        const geometry = this.geometry;
        (this.autoUpdate || geometry._width !== this.shader.texture.height) && (geometry._width = this.shader.texture.height, geometry.update()), super._render(renderer);
    }
}






class $6333b1ac9ecaaa21$export$e63bf72b2cfda112 extends (0, $3878067a77b781d9$export$42a852a2b6b56249) {
    /**
   * @param maxSize - The maximum number of particles that can be rendered by the container.
   *  Affects size of allocated buffers.
   * @param properties - The properties of children that should be uploaded to the gpu and applied.
   * @param {boolean} [properties.vertices=false] - When true, vertices be uploaded and applied.
   *                  if sprite's ` scale/anchor/trim/frame/orig` is dynamic, please set `true`.
   * @param {boolean} [properties.position=true] - When true, position be uploaded and applied.
   * @param {boolean} [properties.rotation=false] - When true, rotation be uploaded and applied.
   * @param {boolean} [properties.uvs=false] - When true, uvs be uploaded and applied.
   * @param {boolean} [properties.tint=false] - When true, alpha and tint be uploaded and applied.
   * @param {number} [batchSize=16384] - Number of particles per batch. If less than maxSize, it uses maxSize instead.
   * @param {boolean} [autoResize=false] - If true, container allocates more batches in case
   *  there are more than `maxSize` particles.
   */ constructor(maxSize = 1500, properties, batchSize = 16384, autoResize = !1){
        super();
        const maxBatchSize = 16384;
        batchSize > maxBatchSize && (batchSize = maxBatchSize), this._properties = [
            !1,
            !0,
            !1,
            !1,
            !1
        ], this._maxSize = maxSize, this._batchSize = batchSize, this._buffers = null, this._bufferUpdateIDs = [], this._updateID = 0, this.interactiveChildren = !1, this.blendMode = (0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).NORMAL, this.autoResize = autoResize, this.roundPixels = !0, this.baseTexture = null, this.setProperties(properties), this._tintColor = new (0, $3119899e085d9ccf$export$892596cec99bc70e)(0), this.tintRgb = new Float32Array(3), this.tint = 16777215;
    }
    /**
   * Sets the private properties array to dynamic / static based on the passed properties object
   * @param properties - The properties to be uploaded
   */ setProperties(properties) {
        properties && (this._properties[0] = "vertices" in properties || "scale" in properties ? !!properties.vertices || !!properties.scale : this._properties[0], this._properties[1] = "position" in properties ? !!properties.position : this._properties[1], this._properties[2] = "rotation" in properties ? !!properties.rotation : this._properties[2], this._properties[3] = "uvs" in properties ? !!properties.uvs : this._properties[3], this._properties[4] = "tint" in properties || "alpha" in properties ? !!properties.tint || !!properties.alpha : this._properties[4]);
    }
    updateTransform() {
        this.displayObjectUpdateTransform();
    }
    /**
   * The tint applied to the container. This is a hex value.
   * A value of 0xFFFFFF will remove any tint effect.
   * IMPORTANT: This is a WebGL only feature and will be ignored by the canvas renderer.
   * @default 0xFFFFFF
   */ get tint() {
        return this._tintColor.value;
    }
    set tint(value) {
        this._tintColor.setValue(value), this._tintColor.toRgbArray(this.tintRgb);
    }
    /**
   * Renders the container using the WebGL renderer.
   * @param renderer - The WebGL renderer.
   */ render(renderer) {
        !this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable || (this.baseTexture || (this.baseTexture = this.children[0]._texture.baseTexture, this.baseTexture.valid || this.baseTexture.once("update", ()=>this.onChildrenChange(0))), renderer.batch.setObjectRenderer(renderer.plugins.particle), renderer.plugins.particle.render(this));
    }
    /**
   * Set the flag that static data should be updated to true
   * @param smallestChildIndex - The smallest child index.
   */ onChildrenChange(smallestChildIndex) {
        const bufferIndex = Math.floor(smallestChildIndex / this._batchSize);
        for(; this._bufferUpdateIDs.length < bufferIndex;)this._bufferUpdateIDs.push(0);
        this._bufferUpdateIDs[bufferIndex] = ++this._updateID;
    }
    dispose() {
        if (this._buffers) {
            for(let i = 0; i < this._buffers.length; ++i)this._buffers[i].destroy();
            this._buffers = null;
        }
    }
    /**
   * Destroys the container
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their
   *  destroy method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the texture of the child sprite
   * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the base texture of the child sprite
   */ destroy(options) {
        super.destroy(options), this.dispose(), this._properties = null, this._buffers = null, this._bufferUpdateIDs = null;
    }
}




class $b13569ae4c80a30d$export$ef6bb3c375ab2229 {
    /**
   * @param {object} properties - The properties to upload.
   * @param {boolean[]} dynamicPropertyFlags - Flags for which properties are dynamic.
   * @param {number} size - The size of the batch.
   */ constructor(properties, dynamicPropertyFlags, size){
        this.geometry = new (0, $dd93eefb01cd7345$export$2db6c17465f94a2)(), this.indexBuffer = null, this.size = size, this.dynamicProperties = [], this.staticProperties = [];
        for(let i = 0; i < properties.length; ++i){
            let property = properties[i];
            property = {
                attributeName: property.attributeName,
                size: property.size,
                uploadFunction: property.uploadFunction,
                type: property.type || (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).FLOAT,
                offset: property.offset
            }, dynamicPropertyFlags[i] ? this.dynamicProperties.push(property) : this.staticProperties.push(property);
        }
        this.staticStride = 0, this.staticBuffer = null, this.staticData = null, this.staticDataUint32 = null, this.dynamicStride = 0, this.dynamicBuffer = null, this.dynamicData = null, this.dynamicDataUint32 = null, this._updateID = 0, this.initBuffers();
    }
    /** Sets up the renderer context and necessary buffers. */ initBuffers() {
        const geometry = this.geometry;
        let dynamicOffset = 0;
        this.indexBuffer = new (0, $4da95ef50ded5f29$export$a143d493d941bafc)((0, $29e19754806f3a05$exports).createIndicesForQuads(this.size), !0, !0), geometry.addIndex(this.indexBuffer), this.dynamicStride = 0;
        for(let i = 0; i < this.dynamicProperties.length; ++i){
            const property = this.dynamicProperties[i];
            property.offset = dynamicOffset, dynamicOffset += property.size, this.dynamicStride += property.size;
        }
        const dynBuffer = new ArrayBuffer(this.size * this.dynamicStride * 16);
        this.dynamicData = new Float32Array(dynBuffer), this.dynamicDataUint32 = new Uint32Array(dynBuffer), this.dynamicBuffer = new (0, $4da95ef50ded5f29$export$a143d493d941bafc)(this.dynamicData, !1, !1);
        let staticOffset = 0;
        this.staticStride = 0;
        for(let i = 0; i < this.staticProperties.length; ++i){
            const property = this.staticProperties[i];
            property.offset = staticOffset, staticOffset += property.size, this.staticStride += property.size;
        }
        const statBuffer = new ArrayBuffer(this.size * this.staticStride * 16);
        this.staticData = new Float32Array(statBuffer), this.staticDataUint32 = new Uint32Array(statBuffer), this.staticBuffer = new (0, $4da95ef50ded5f29$export$a143d493d941bafc)(this.staticData, !0, !1);
        for(let i = 0; i < this.dynamicProperties.length; ++i){
            const property = this.dynamicProperties[i];
            geometry.addAttribute(property.attributeName, this.dynamicBuffer, 0, property.type === (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_BYTE, property.type, this.dynamicStride * 4, property.offset * 4);
        }
        for(let i = 0; i < this.staticProperties.length; ++i){
            const property = this.staticProperties[i];
            geometry.addAttribute(property.attributeName, this.staticBuffer, 0, property.type === (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_BYTE, property.type, this.staticStride * 4, property.offset * 4);
        }
    }
    /**
   * Uploads the dynamic properties.
   * @param children - The children to upload.
   * @param startIndex - The index to start at.
   * @param amount - The number to upload.
   */ uploadDynamic(children, startIndex, amount) {
        for(let i = 0; i < this.dynamicProperties.length; i++){
            const property = this.dynamicProperties[i];
            property.uploadFunction(children, startIndex, amount, property.type === (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_BYTE ? this.dynamicDataUint32 : this.dynamicData, this.dynamicStride, property.offset);
        }
        this.dynamicBuffer._updateID++;
    }
    /**
   * Uploads the static properties.
   * @param children - The children to upload.
   * @param startIndex - The index to start at.
   * @param amount - The number to upload.
   */ uploadStatic(children, startIndex, amount) {
        for(let i = 0; i < this.staticProperties.length; i++){
            const property = this.staticProperties[i];
            property.uploadFunction(children, startIndex, amount, property.type === (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_BYTE ? this.staticDataUint32 : this.staticData, this.staticStride, property.offset);
        }
        this.staticBuffer._updateID++;
    }
    /** Destroys the ParticleBuffer. */ destroy() {
        this.indexBuffer = null, this.dynamicProperties = null, this.dynamicBuffer = null, this.dynamicData = null, this.dynamicDataUint32 = null, this.staticProperties = null, this.staticBuffer = null, this.staticData = null, this.staticDataUint32 = null, this.geometry.destroy();
    }
}


var $eab0affdd1f7d64b$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;
varying vec4 vColor;

uniform sampler2D uSampler;

void main(void){
    vec4 color = texture2D(uSampler, vTextureCoord) * vColor;
    gl_FragColor = color;
}`;


var $6e9a622b4a355811$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;
attribute vec4 aColor;

attribute vec2 aPositionCoord;
attribute float aRotation;

uniform mat3 translationMatrix;
uniform vec4 uColor;

varying vec2 vTextureCoord;
varying vec4 vColor;

void main(void){
    float x = (aVertexPosition.x) * cos(aRotation) - (aVertexPosition.y) * sin(aRotation);
    float y = (aVertexPosition.x) * sin(aRotation) + (aVertexPosition.y) * cos(aRotation);

    vec2 v = vec2(x, y);
    v = v + aPositionCoord;

    gl_Position = vec4((translationMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = aTextureCoord;
    vColor = aColor * uColor;
}
`;


class $73fe2c75e9ac7ff4$export$42cbb08a275c7ff9 extends (0, $9b20378b287c50b2$export$ca67b0b0fa758253) {
    /**
   * @param renderer - The renderer this sprite batch works for.
   */ constructor(renderer){
        super(renderer), this.shader = null, this.properties = null, this.tempMatrix = new (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85)(), this.properties = [
            // verticesData
            {
                attributeName: "aVertexPosition",
                size: 2,
                uploadFunction: this.uploadVertices,
                offset: 0
            },
            // positionData
            {
                attributeName: "aPositionCoord",
                size: 2,
                uploadFunction: this.uploadPosition,
                offset: 0
            },
            // rotationData
            {
                attributeName: "aRotation",
                size: 1,
                uploadFunction: this.uploadRotation,
                offset: 0
            },
            // uvsData
            {
                attributeName: "aTextureCoord",
                size: 2,
                uploadFunction: this.uploadUvs,
                offset: 0
            },
            // tintData
            {
                attributeName: "aColor",
                size: 1,
                type: (0, $5912637ee8cf8b9f$export$426db7a6155b7a80).UNSIGNED_BYTE,
                uploadFunction: this.uploadTint,
                offset: 0
            }
        ], this.shader = (0, $20320a9b1d80d7dc$export$462bb059fed9d9e5).from((0, $6e9a622b4a355811$export$2e2bcd8739ae039), (0, $eab0affdd1f7d64b$export$2e2bcd8739ae039), {}), this.state = (0, $05d0e9a749f67df1$export$7254cc27399e90bd).for2d();
    }
    /**
   * Renders the particle container object.
   * @param container - The container to render using this ParticleRenderer.
   */ render(container) {
        const children = container.children, maxSize = container._maxSize, batchSize = container._batchSize, renderer = this.renderer;
        let totalChildren = children.length;
        if (totalChildren === 0) return;
        totalChildren > maxSize && !container.autoResize && (totalChildren = maxSize);
        let buffers = container._buffers;
        buffers || (buffers = container._buffers = this.generateBuffers(container));
        const baseTexture = children[0]._texture.baseTexture, premultiplied = baseTexture.alphaMode > 0;
        this.state.blendMode = (0, $29e19754806f3a05$exports).correctBlendMode(container.blendMode, premultiplied), renderer.state.set(this.state);
        const gl = renderer.gl, m = container.worldTransform.copyTo(this.tempMatrix);
        m.prepend(renderer.globalUniforms.uniforms.projectionMatrix), this.shader.uniforms.translationMatrix = m.toArray(!0), this.shader.uniforms.uColor = (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(container.tintRgb).premultiply(container.worldAlpha, premultiplied).toArray(this.shader.uniforms.uColor), this.shader.uniforms.uSampler = baseTexture, this.renderer.shader.bind(this.shader);
        let updateStatic = !1;
        for(let i = 0, j = 0; i < totalChildren; i += batchSize, j += 1){
            let amount = totalChildren - i;
            amount > batchSize && (amount = batchSize), j >= buffers.length && buffers.push(this._generateOneMoreBuffer(container));
            const buffer = buffers[j];
            buffer.uploadDynamic(children, i, amount);
            const bid = container._bufferUpdateIDs[j] || 0;
            updateStatic = updateStatic || buffer._updateID < bid, updateStatic && (buffer._updateID = container._updateID, buffer.uploadStatic(children, i, amount)), renderer.geometry.bind(buffer.geometry), gl.drawElements(gl.TRIANGLES, amount * 6, gl.UNSIGNED_SHORT, 0);
        }
    }
    /**
   * Creates one particle buffer for each child in the container we want to render and updates internal properties.
   * @param container - The container to render using this ParticleRenderer
   * @returns - The buffers
   */ generateBuffers(container) {
        const buffers = [], size = container._maxSize, batchSize = container._batchSize, dynamicPropertyFlags = container._properties;
        for(let i = 0; i < size; i += batchSize)buffers.push(new (0, $b13569ae4c80a30d$export$ef6bb3c375ab2229)(this.properties, dynamicPropertyFlags, batchSize));
        return buffers;
    }
    /**
   * Creates one more particle buffer, because container has autoResize feature.
   * @param container - The container to render using this ParticleRenderer
   * @returns - The generated buffer
   */ _generateOneMoreBuffer(container) {
        const batchSize = container._batchSize, dynamicPropertyFlags = container._properties;
        return new (0, $b13569ae4c80a30d$export$ef6bb3c375ab2229)(this.properties, dynamicPropertyFlags, batchSize);
    }
    /**
   * Uploads the vertices.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their vertices uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */ uploadVertices(children, startIndex, amount, array, stride, offset) {
        let w0 = 0, w1 = 0, h0 = 0, h1 = 0;
        for(let i = 0; i < amount; ++i){
            const sprite = children[startIndex + i], texture = sprite._texture, sx = sprite.scale.x, sy = sprite.scale.y, trim = texture.trim, orig = texture.orig;
            trim ? (w1 = trim.x - sprite.anchor.x * orig.width, w0 = w1 + trim.width, h1 = trim.y - sprite.anchor.y * orig.height, h0 = h1 + trim.height) : (w0 = orig.width * (1 - sprite.anchor.x), w1 = orig.width * -sprite.anchor.x, h0 = orig.height * (1 - sprite.anchor.y), h1 = orig.height * -sprite.anchor.y), array[offset] = w1 * sx, array[offset + 1] = h1 * sy, array[offset + stride] = w0 * sx, array[offset + stride + 1] = h1 * sy, array[offset + stride * 2] = w0 * sx, array[offset + stride * 2 + 1] = h0 * sy, array[offset + stride * 3] = w1 * sx, array[offset + stride * 3 + 1] = h0 * sy, offset += stride * 4;
        }
    }
    /**
   * Uploads the position.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their positions uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */ uploadPosition(children, startIndex, amount, array, stride, offset) {
        for(let i = 0; i < amount; i++){
            const spritePosition = children[startIndex + i].position;
            array[offset] = spritePosition.x, array[offset + 1] = spritePosition.y, array[offset + stride] = spritePosition.x, array[offset + stride + 1] = spritePosition.y, array[offset + stride * 2] = spritePosition.x, array[offset + stride * 2 + 1] = spritePosition.y, array[offset + stride * 3] = spritePosition.x, array[offset + stride * 3 + 1] = spritePosition.y, offset += stride * 4;
        }
    }
    /**
   * Uploads the rotation.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their rotation uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */ uploadRotation(children, startIndex, amount, array, stride, offset) {
        for(let i = 0; i < amount; i++){
            const spriteRotation = children[startIndex + i].rotation;
            array[offset] = spriteRotation, array[offset + stride] = spriteRotation, array[offset + stride * 2] = spriteRotation, array[offset + stride * 3] = spriteRotation, offset += stride * 4;
        }
    }
    /**
   * Uploads the UVs.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their rotation uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */ uploadUvs(children, startIndex, amount, array, stride, offset) {
        for(let i = 0; i < amount; ++i){
            const textureUvs = children[startIndex + i]._texture._uvs;
            textureUvs ? (array[offset] = textureUvs.x0, array[offset + 1] = textureUvs.y0, array[offset + stride] = textureUvs.x1, array[offset + stride + 1] = textureUvs.y1, array[offset + stride * 2] = textureUvs.x2, array[offset + stride * 2 + 1] = textureUvs.y2, array[offset + stride * 3] = textureUvs.x3, array[offset + stride * 3 + 1] = textureUvs.y3, offset += stride * 4) : (array[offset] = 0, array[offset + 1] = 0, array[offset + stride] = 0, array[offset + stride + 1] = 0, array[offset + stride * 2] = 0, array[offset + stride * 2 + 1] = 0, array[offset + stride * 3] = 0, array[offset + stride * 3 + 1] = 0, offset += stride * 4);
        }
    }
    /**
   * Uploads the tint.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their rotation uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */ uploadTint(children, startIndex, amount, array, stride, offset) {
        for(let i = 0; i < amount; ++i){
            const sprite = children[startIndex + i], result = (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(sprite._tintRGB).toPremultiplied(sprite.alpha, sprite.texture.baseTexture.alphaMode > 0);
            array[offset] = result, array[offset + stride] = result, array[offset + stride * 2] = result, array[offset + stride * 3] = result, offset += stride * 4;
        }
    }
    /** Destroys the ParticleRenderer. */ destroy() {
        super.destroy(), this.shader && (this.shader.destroy(), this.shader = null), this.tempMatrix = null;
    }
}
$73fe2c75e9ac7ff4$export$42cbb08a275c7ff9.extension = {
    name: "particle",
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererPlugin
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($73fe2c75e9ac7ff4$export$42cbb08a275c7ff9);







var $db11ad4206a572b4$export$131daa784848984 = /* @__PURE__ */ ((TEXT_GRADIENT2)=>(TEXT_GRADIENT2[TEXT_GRADIENT2.LINEAR_VERTICAL = 0] = "LINEAR_VERTICAL", TEXT_GRADIENT2[TEXT_GRADIENT2.LINEAR_HORIZONTAL = 1] = "LINEAR_HORIZONTAL", TEXT_GRADIENT2))($db11ad4206a572b4$export$131daa784848984 || {});






const $a3232095b7fc32d6$var$contextSettings = {
    // TextMetrics requires getImageData readback for measuring fonts.
    willReadFrequently: !0
}, $a3232095b7fc32d6$var$_TextMetrics = class _TextMetrics2 {
    /**
   * Checking that we can use modern canvas 2D API.
   *
   * Note: This is an unstable API, Chrome < 94 use `textLetterSpacing`, later versions use `letterSpacing`.
   * @see PIXI.TextMetrics.experimentalLetterSpacing
   * @see https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/letterSpacing
   * @see https://developer.chrome.com/origintrials/#/view_trial/3585991203293757441
   */ static get experimentalLetterSpacingSupported() {
        let result = _TextMetrics2._experimentalLetterSpacingSupported;
        if (result !== void 0) {
            const proto = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.getCanvasRenderingContext2D().prototype;
            result = _TextMetrics2._experimentalLetterSpacingSupported = "letterSpacing" in proto || "textLetterSpacing" in proto;
        }
        return result;
    }
    /**
   * @param text - the text that was measured
   * @param style - the style that was measured
   * @param width - the measured width of the text
   * @param height - the measured height of the text
   * @param lines - an array of the lines of text broken by new lines and wrapping if specified in style
   * @param lineWidths - an array of the line widths for each line matched to `lines`
   * @param lineHeight - the measured line height for this style
   * @param maxLineWidth - the maximum line width for all measured lines
   * @param {PIXI.IFontMetrics} fontProperties - the font properties object from TextMetrics.measureFont
   */ constructor(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties){
        this.text = text, this.style = style, this.width = width, this.height = height, this.lines = lines, this.lineWidths = lineWidths, this.lineHeight = lineHeight, this.maxLineWidth = maxLineWidth, this.fontProperties = fontProperties;
    }
    /**
   * Measures the supplied string of text and returns a Rectangle.
   * @param text - The text to measure.
   * @param style - The text style to use for measuring
   * @param wordWrap - Override for if word-wrap should be applied to the text.
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns Measured width and height of the text.
   */ static measureText(text, style, wordWrap, canvas = _TextMetrics2._canvas) {
        wordWrap = wordWrap ?? style.wordWrap;
        const font = style.toFontString(), fontProperties = _TextMetrics2.measureFont(font);
        fontProperties.fontSize === 0 && (fontProperties.fontSize = style.fontSize, fontProperties.ascent = style.fontSize);
        const context = canvas.getContext("2d", $a3232095b7fc32d6$var$contextSettings);
        context.font = font;
        const lines = (wordWrap ? _TextMetrics2.wordWrap(text, style, canvas) : text).split(/(?:\r\n|\r|\n)/), lineWidths = new Array(lines.length);
        let maxLineWidth = 0;
        for(let i = 0; i < lines.length; i++){
            const lineWidth = _TextMetrics2._measureText(lines[i], style.letterSpacing, context);
            lineWidths[i] = lineWidth, maxLineWidth = Math.max(maxLineWidth, lineWidth);
        }
        let width = maxLineWidth + style.strokeThickness;
        style.dropShadow && (width += style.dropShadowDistance);
        const lineHeight = style.lineHeight || fontProperties.fontSize + style.strokeThickness;
        let height = Math.max(lineHeight, fontProperties.fontSize + style.strokeThickness * 2) + style.leading + (lines.length - 1) * (lineHeight + style.leading);
        return style.dropShadow && (height += style.dropShadowDistance), new _TextMetrics2(text, style, width, height, lines, lineWidths, lineHeight + style.leading, maxLineWidth, fontProperties);
    }
    static _measureText(text, letterSpacing, context) {
        let useExperimentalLetterSpacing = !1;
        _TextMetrics2.experimentalLetterSpacingSupported && (_TextMetrics2.experimentalLetterSpacing ? (context.letterSpacing = `${letterSpacing}px`, context.textLetterSpacing = `${letterSpacing}px`, useExperimentalLetterSpacing = !0) : (context.letterSpacing = "0px", context.textLetterSpacing = "0px"));
        let width = context.measureText(text).width;
        return width > 0 && (useExperimentalLetterSpacing ? width -= letterSpacing : width += (_TextMetrics2.graphemeSegmenter(text).length - 1) * letterSpacing), width;
    }
    /**
   * Applies newlines to a string to have it optimally fit into the horizontal
   * bounds set by the Text object's wordWrapWidth property.
   * @param text - String to apply word wrapping to
   * @param style - the style to use when wrapping
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns New string with new lines applied where required
   */ static wordWrap(text, style, canvas = _TextMetrics2._canvas) {
        const context = canvas.getContext("2d", $a3232095b7fc32d6$var$contextSettings);
        let width = 0, line = "", lines = "";
        const cache = /* @__PURE__ */ Object.create(null), { letterSpacing: letterSpacing, whiteSpace: whiteSpace } = style, collapseSpaces = _TextMetrics2.collapseSpaces(whiteSpace), collapseNewlines = _TextMetrics2.collapseNewlines(whiteSpace);
        let canPrependSpaces = !collapseSpaces;
        const wordWrapWidth = style.wordWrapWidth + letterSpacing, tokens = _TextMetrics2.tokenize(text);
        for(let i = 0; i < tokens.length; i++){
            let token = tokens[i];
            if (_TextMetrics2.isNewline(token)) {
                if (!collapseNewlines) {
                    lines += _TextMetrics2.addLine(line), canPrependSpaces = !collapseSpaces, line = "", width = 0;
                    continue;
                }
                token = " ";
            }
            if (collapseSpaces) {
                const currIsBreakingSpace = _TextMetrics2.isBreakingSpace(token), lastIsBreakingSpace = _TextMetrics2.isBreakingSpace(line[line.length - 1]);
                if (currIsBreakingSpace && lastIsBreakingSpace) continue;
            }
            const tokenWidth = _TextMetrics2.getFromCache(token, letterSpacing, cache, context);
            if (tokenWidth > wordWrapWidth) {
                if (line !== "" && (lines += _TextMetrics2.addLine(line), line = "", width = 0), _TextMetrics2.canBreakWords(token, style.breakWords)) {
                    const characters = _TextMetrics2.wordWrapSplit(token);
                    for(let j = 0; j < characters.length; j++){
                        let char = characters[j], lastChar = char, k = 1;
                        for(; characters[j + k];){
                            const nextChar = characters[j + k];
                            if (!_TextMetrics2.canBreakChars(lastChar, nextChar, token, j, style.breakWords)) char += nextChar;
                            else break;
                            lastChar = nextChar, k++;
                        }
                        j += k - 1;
                        const characterWidth = _TextMetrics2.getFromCache(char, letterSpacing, cache, context);
                        characterWidth + width > wordWrapWidth && (lines += _TextMetrics2.addLine(line), canPrependSpaces = !1, line = "", width = 0), line += char, width += characterWidth;
                    }
                } else {
                    line.length > 0 && (lines += _TextMetrics2.addLine(line), line = "", width = 0);
                    const isLastToken = i === tokens.length - 1;
                    lines += _TextMetrics2.addLine(token, !isLastToken), canPrependSpaces = !1, line = "", width = 0;
                }
            } else tokenWidth + width > wordWrapWidth && (canPrependSpaces = !1, lines += _TextMetrics2.addLine(line), line = "", width = 0), (line.length > 0 || !_TextMetrics2.isBreakingSpace(token) || canPrependSpaces) && (line += token, width += tokenWidth);
        }
        return lines += _TextMetrics2.addLine(line, !1), lines;
    }
    /**
   * Convienience function for logging each line added during the wordWrap method.
   * @param line    - The line of text to add
   * @param newLine - Add new line character to end
   * @returns A formatted line
   */ static addLine(line, newLine = !0) {
        return line = _TextMetrics2.trimRight(line), line = newLine ? `${line}
` : line, line;
    }
    /**
   * Gets & sets the widths of calculated characters in a cache object
   * @param key            - The key
   * @param letterSpacing  - The letter spacing
   * @param cache          - The cache
   * @param context        - The canvas context
   * @returns The from cache.
   */ static getFromCache(key, letterSpacing, cache, context) {
        let width = cache[key];
        return typeof width != "number" && (width = _TextMetrics2._measureText(key, letterSpacing, context) + letterSpacing, cache[key] = width), width;
    }
    /**
   * Determines whether we should collapse breaking spaces.
   * @param whiteSpace - The TextStyle property whiteSpace
   * @returns Should collapse
   */ static collapseSpaces(whiteSpace) {
        return whiteSpace === "normal" || whiteSpace === "pre-line";
    }
    /**
   * Determines whether we should collapse newLine chars.
   * @param whiteSpace - The white space
   * @returns should collapse
   */ static collapseNewlines(whiteSpace) {
        return whiteSpace === "normal";
    }
    /**
   * Trims breaking whitespaces from string.
   * @param text - The text
   * @returns Trimmed string
   */ static trimRight(text) {
        if (typeof text != "string") return "";
        for(let i = text.length - 1; i >= 0; i--){
            const char = text[i];
            if (!_TextMetrics2.isBreakingSpace(char)) break;
            text = text.slice(0, -1);
        }
        return text;
    }
    /**
   * Determines if char is a newline.
   * @param char - The character
   * @returns True if newline, False otherwise.
   */ static isNewline(char) {
        return typeof char != "string" ? !1 : _TextMetrics2._newlines.includes(char.charCodeAt(0));
    }
    /**
   * Determines if char is a breaking whitespace.
   *
   * It allows one to determine whether char should be a breaking whitespace
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param char - The character
   * @param [_nextChar] - The next character
   * @returns True if whitespace, False otherwise.
   */ static isBreakingSpace(char, _nextChar) {
        return typeof char != "string" ? !1 : _TextMetrics2._breakingSpaces.includes(char.charCodeAt(0));
    }
    /**
   * Splits a string into words, breaking-spaces and newLine characters
   * @param text - The text
   * @returns A tokenized array
   */ static tokenize(text) {
        const tokens = [];
        let token = "";
        if (typeof text != "string") return tokens;
        for(let i = 0; i < text.length; i++){
            const char = text[i], nextChar = text[i + 1];
            if (_TextMetrics2.isBreakingSpace(char, nextChar) || _TextMetrics2.isNewline(char)) {
                token !== "" && (tokens.push(token), token = ""), tokens.push(char);
                continue;
            }
            token += char;
        }
        return token !== "" && tokens.push(token), tokens;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to customise which words should break
   * Examples are if the token is CJK or numbers.
   * It must return a boolean.
   * @param _token - The token
   * @param breakWords - The style attr break words
   * @returns Whether to break word or not
   */ static canBreakWords(_token, breakWords) {
        return breakWords;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to determine whether a pair of characters
   * should be broken by newlines
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param _char - The character
   * @param _nextChar - The next character
   * @param _token - The token/word the characters are from
   * @param _index - The index in the token of the char
   * @param _breakWords - The style attr break words
   * @returns whether to break word or not
   */ static canBreakChars(_char, _nextChar, _token, _index, _breakWords) {
        return !0;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It is called when a token (usually a word) has to be split into separate pieces
   * in order to determine the point to break a word.
   * It must return an array of characters.
   * @param token - The token to split
   * @returns The characters of the token
   * @see TextMetrics.graphemeSegmenter
   */ static wordWrapSplit(token) {
        return _TextMetrics2.graphemeSegmenter(token);
    }
    /**
   * Calculates the ascent, descent and fontSize of a given font-style
   * @param font - String representing the style of the font
   * @returns Font properties object
   */ static measureFont(font) {
        if (_TextMetrics2._fonts[font]) return _TextMetrics2._fonts[font];
        const properties = {
            ascent: 0,
            descent: 0,
            fontSize: 0
        }, canvas = _TextMetrics2._canvas, context = _TextMetrics2._context;
        context.font = font;
        const metricsString = _TextMetrics2.METRICS_STRING + _TextMetrics2.BASELINE_SYMBOL, width = Math.ceil(context.measureText(metricsString).width);
        let baseline = Math.ceil(context.measureText(_TextMetrics2.BASELINE_SYMBOL).width);
        const height = Math.ceil(_TextMetrics2.HEIGHT_MULTIPLIER * baseline);
        if (baseline = baseline * _TextMetrics2.BASELINE_MULTIPLIER | 0, width === 0 || height === 0) return _TextMetrics2._fonts[font] = properties, properties;
        canvas.width = width, canvas.height = height, context.fillStyle = "#f00", context.fillRect(0, 0, width, height), context.font = font, context.textBaseline = "alphabetic", context.fillStyle = "#000", context.fillText(metricsString, 0, baseline);
        const imagedata = context.getImageData(0, 0, width, height).data, pixels = imagedata.length, line = width * 4;
        let i = 0, idx = 0, stop = !1;
        for(i = 0; i < baseline; ++i){
            for(let j = 0; j < line; j += 4)if (imagedata[idx + j] !== 255) {
                stop = !0;
                break;
            }
            if (!stop) idx += line;
            else break;
        }
        for(properties.ascent = baseline - i, idx = pixels - line, stop = !1, i = height; i > baseline; --i){
            for(let j = 0; j < line; j += 4)if (imagedata[idx + j] !== 255) {
                stop = !0;
                break;
            }
            if (!stop) idx -= line;
            else break;
        }
        return properties.descent = i - baseline, properties.fontSize = properties.ascent + properties.descent, _TextMetrics2._fonts[font] = properties, properties;
    }
    /**
   * Clear font metrics in metrics cache.
   * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
   */ static clearMetrics(font = "") {
        font ? delete _TextMetrics2._fonts[font] : _TextMetrics2._fonts = {};
    }
    /**
   * Cached canvas element for measuring text
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */ static get _canvas() {
        if (!_TextMetrics2.__canvas) {
            let canvas;
            try {
                const c = new OffscreenCanvas(0, 0);
                if (c.getContext("2d", $a3232095b7fc32d6$var$contextSettings)?.measureText) return _TextMetrics2.__canvas = c, c;
                canvas = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.createCanvas();
            } catch  {
                canvas = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.createCanvas();
            }
            canvas.width = canvas.height = 10, _TextMetrics2.__canvas = canvas;
        }
        return _TextMetrics2.__canvas;
    }
    /**
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */ static get _context() {
        return _TextMetrics2.__context || (_TextMetrics2.__context = _TextMetrics2._canvas.getContext("2d", $a3232095b7fc32d6$var$contextSettings)), _TextMetrics2.__context;
    }
};
$a3232095b7fc32d6$var$_TextMetrics.METRICS_STRING = "|\xc9q\xc5", /** Baseline symbol for calculate font metrics. */ $a3232095b7fc32d6$var$_TextMetrics.BASELINE_SYMBOL = "M", /** Baseline multiplier for calculate font metrics. */ $a3232095b7fc32d6$var$_TextMetrics.BASELINE_MULTIPLIER = 1.4, /** Height multiplier for setting height of canvas to calculate font metrics. */ $a3232095b7fc32d6$var$_TextMetrics.HEIGHT_MULTIPLIER = 2, /**
* A Unicode "character", or "grapheme cluster", can be composed of multiple Unicode code points,
* such as letters with diacritical marks (e.g. `'\u0065\u0301'`, letter e with acute)
* or emojis with modifiers (e.g. `'\uD83E\uDDD1\u200D\uD83D\uDCBB'`, technologist).
* The new `Intl.Segmenter` API in ES2022 can split the string into grapheme clusters correctly. If it is not available,
* PixiJS will fallback to use the iterator of String, which can only spilt the string into code points.
* If you want to get full functionality in environments that don't support `Intl.Segmenter` (such as Firefox),
* you can use other libraries such as [grapheme-splitter]{@link https://www.npmjs.com/package/grapheme-splitter}
* or [graphemer]{@link https://www.npmjs.com/package/graphemer} to create a polyfill. Since these libraries can be
* relatively large in size to handle various Unicode grapheme clusters properly, PixiJS won't use them directly.
*/ $a3232095b7fc32d6$var$_TextMetrics.graphemeSegmenter = (()=>{
    if (typeof Intl?.Segmenter == "function") {
        const segmenter = new Intl.Segmenter();
        return (s)=>[
                ...segmenter.segment(s)
            ].map((x)=>x.segment);
    }
    return (s)=>[
            ...s
        ];
})(), /**
* New rendering behavior for letter-spacing which uses Chrome's new native API. This will
* lead to more accurate letter-spacing results because it does not try to manually draw
* each character. However, this Chrome API is experimental and may not serve all cases yet.
* @see PIXI.TextMetrics.experimentalLetterSpacingSupported
*/ $a3232095b7fc32d6$var$_TextMetrics.experimentalLetterSpacing = !1, /** Cache of {@see PIXI.TextMetrics.FontMetrics} objects. */ $a3232095b7fc32d6$var$_TextMetrics._fonts = {}, /** Cache of new line chars. */ $a3232095b7fc32d6$var$_TextMetrics._newlines = [
    10,
    // line feed
    13
], /** Cache of breaking spaces. */ $a3232095b7fc32d6$var$_TextMetrics._breakingSpaces = [
    9,
    // character tabulation
    32,
    // space
    8192,
    // en quad
    8193,
    // em quad
    8194,
    // en space
    8195,
    // em space
    8196,
    // three-per-em space
    8197,
    // four-per-em space
    8198,
    // six-per-em space
    8200,
    // punctuation space
    8201,
    // thin space
    8202,
    // hair space
    8287,
    // medium mathematical space
    12288
];
let $a3232095b7fc32d6$export$4c5a129a59e1ef34 = $a3232095b7fc32d6$var$_TextMetrics;




const $95ce52d18dddb804$var$genericFontFamilies = [
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui"
], $95ce52d18dddb804$var$_TextStyle = class _TextStyle2 {
    /**
   * @param style - TextStyle properties to be set on the text. See {@link PIXI.TextStyle.defaultStyle}
   *       for the default values.
   */ constructor(style){
        this.styleID = 0, this.reset(), $95ce52d18dddb804$var$deepCopyProperties(this, style, style);
    }
    /**
   * Creates a new TextStyle object with the same values as this one.
   * Note that the only the properties of the object are cloned.
   *
   * @return New cloned TextStyle object
   */ clone() {
        const clonedProperties = {};
        return $95ce52d18dddb804$var$deepCopyProperties(clonedProperties, this, _TextStyle2.defaultStyle), new _TextStyle2(clonedProperties);
    }
    /** Resets all properties to the defaults specified in TextStyle.prototype._default */ reset() {
        $95ce52d18dddb804$var$deepCopyProperties(this, _TextStyle2.defaultStyle, _TextStyle2.defaultStyle);
    }
    /**
   * Alignment for multiline text, does not affect single line text.
   *
   * @member {'left'|'center'|'right'|'justify'}
   */ get align() {
        return this._align;
    }
    set align(align) {
        this._align !== align && (this._align = align, this.styleID++);
    }
    /** Indicates if lines can be wrapped within words, it needs wordWrap to be set to true. */ get breakWords() {
        return this._breakWords;
    }
    set breakWords(breakWords) {
        this._breakWords !== breakWords && (this._breakWords = breakWords, this.styleID++);
    }
    /** Set a drop shadow for the text. */ get dropShadow() {
        return this._dropShadow;
    }
    set dropShadow(dropShadow) {
        this._dropShadow !== dropShadow && (this._dropShadow = dropShadow, this.styleID++);
    }
    /** Set alpha for the drop shadow. */ get dropShadowAlpha() {
        return this._dropShadowAlpha;
    }
    set dropShadowAlpha(dropShadowAlpha) {
        this._dropShadowAlpha !== dropShadowAlpha && (this._dropShadowAlpha = dropShadowAlpha, this.styleID++);
    }
    /** Set a angle of the drop shadow. */ get dropShadowAngle() {
        return this._dropShadowAngle;
    }
    set dropShadowAngle(dropShadowAngle) {
        this._dropShadowAngle !== dropShadowAngle && (this._dropShadowAngle = dropShadowAngle, this.styleID++);
    }
    /** Set a shadow blur radius. */ get dropShadowBlur() {
        return this._dropShadowBlur;
    }
    set dropShadowBlur(dropShadowBlur) {
        this._dropShadowBlur !== dropShadowBlur && (this._dropShadowBlur = dropShadowBlur, this.styleID++);
    }
    /** A fill style to be used on the dropshadow e.g., 'red', '#00FF00'. */ get dropShadowColor() {
        return this._dropShadowColor;
    }
    set dropShadowColor(dropShadowColor) {
        const outputColor = $95ce52d18dddb804$var$getColor(dropShadowColor);
        this._dropShadowColor !== outputColor && (this._dropShadowColor = outputColor, this.styleID++);
    }
    /** Set a distance of the drop shadow. */ get dropShadowDistance() {
        return this._dropShadowDistance;
    }
    set dropShadowDistance(dropShadowDistance) {
        this._dropShadowDistance !== dropShadowDistance && (this._dropShadowDistance = dropShadowDistance, this.styleID++);
    }
    /**
   * A canvas fillstyle that will be used on the text e.g., 'red', '#00FF00'.
   *
   * Can be an array to create a gradient e.g., `['#000000','#FFFFFF']`
   * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
   *
   * @member {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
   */ get fill() {
        return this._fill;
    }
    set fill(fill) {
        const outputColor = $95ce52d18dddb804$var$getColor(fill);
        this._fill !== outputColor && (this._fill = outputColor, this.styleID++);
    }
    /**
   * If fill is an array of colours to create a gradient, this can change the type/direction of the gradient.
   *
   * @type {PIXI.TEXT_GRADIENT}
   */ get fillGradientType() {
        return this._fillGradientType;
    }
    set fillGradientType(fillGradientType) {
        this._fillGradientType !== fillGradientType && (this._fillGradientType = fillGradientType, this.styleID++);
    }
    /**
   * If fill is an array of colours to create a gradient, this array can set the stop points
   * (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
   */ get fillGradientStops() {
        return this._fillGradientStops;
    }
    set fillGradientStops(fillGradientStops) {
        $95ce52d18dddb804$var$areArraysEqual(this._fillGradientStops, fillGradientStops) || (this._fillGradientStops = fillGradientStops, this.styleID++);
    }
    /**
   * The font family, can be a single font name, or a list of names where the first
   * is the preferred font.
   */ get fontFamily() {
        return this._fontFamily;
    }
    set fontFamily(fontFamily) {
        this.fontFamily !== fontFamily && (this._fontFamily = fontFamily, this.styleID++);
    }
    /**
   * The font size
   * (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em')
   */ get fontSize() {
        return this._fontSize;
    }
    set fontSize(fontSize) {
        this._fontSize !== fontSize && (this._fontSize = fontSize, this.styleID++);
    }
    /**
   * The font style.
   *
   * @member {'normal'|'italic'|'oblique'}
   */ get fontStyle() {
        return this._fontStyle;
    }
    set fontStyle(fontStyle) {
        this._fontStyle !== fontStyle && (this._fontStyle = fontStyle, this.styleID++);
    }
    /**
   * The font variant.
   *
   * @member {'normal'|'small-caps'}
   */ get fontVariant() {
        return this._fontVariant;
    }
    set fontVariant(fontVariant) {
        this._fontVariant !== fontVariant && (this._fontVariant = fontVariant, this.styleID++);
    }
    /**
   * The font weight.
   *
   * @member {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */ get fontWeight() {
        return this._fontWeight;
    }
    set fontWeight(fontWeight) {
        this._fontWeight !== fontWeight && (this._fontWeight = fontWeight, this.styleID++);
    }
    /** The amount of spacing between letters, default is 0. */ get letterSpacing() {
        return this._letterSpacing;
    }
    set letterSpacing(letterSpacing) {
        this._letterSpacing !== letterSpacing && (this._letterSpacing = letterSpacing, this.styleID++);
    }
    /** The line height, a number that represents the vertical space that a letter uses. */ get lineHeight() {
        return this._lineHeight;
    }
    set lineHeight(lineHeight) {
        this._lineHeight !== lineHeight && (this._lineHeight = lineHeight, this.styleID++);
    }
    /** The space between lines. */ get leading() {
        return this._leading;
    }
    set leading(leading) {
        this._leading !== leading && (this._leading = leading, this.styleID++);
    }
    /**
   * The lineJoin property sets the type of corner created, it can resolve spiked text issues.
   * Default is 'miter' (creates a sharp corner).
   *
   * @member {'miter'|'round'|'bevel'}
   */ get lineJoin() {
        return this._lineJoin;
    }
    set lineJoin(lineJoin) {
        this._lineJoin !== lineJoin && (this._lineJoin = lineJoin, this.styleID++);
    }
    /**
   * The miter limit to use when using the 'miter' lineJoin mode.
   *
   * This can reduce or increase the spikiness of rendered text.
   */ get miterLimit() {
        return this._miterLimit;
    }
    set miterLimit(miterLimit) {
        this._miterLimit !== miterLimit && (this._miterLimit = miterLimit, this.styleID++);
    }
    /**
   * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
   * by adding padding to all sides of the text.
   */ get padding() {
        return this._padding;
    }
    set padding(padding) {
        this._padding !== padding && (this._padding = padding, this.styleID++);
    }
    /**
   * A canvas fillstyle that will be used on the text stroke, e.g., 'blue', '#FCFF00'
   */ get stroke() {
        return this._stroke;
    }
    set stroke(stroke) {
        const outputColor = $95ce52d18dddb804$var$getColor(stroke);
        this._stroke !== outputColor && (this._stroke = outputColor, this.styleID++);
    }
    /**
   * A number that represents the thickness of the stroke.
   *
   * @default 0
   */ get strokeThickness() {
        return this._strokeThickness;
    }
    set strokeThickness(strokeThickness) {
        this._strokeThickness !== strokeThickness && (this._strokeThickness = strokeThickness, this.styleID++);
    }
    /**
   * The baseline of the text that is rendered.
   *
   * @member {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */ get textBaseline() {
        return this._textBaseline;
    }
    set textBaseline(textBaseline) {
        this._textBaseline !== textBaseline && (this._textBaseline = textBaseline, this.styleID++);
    }
    /** Trim transparent borders. */ get trim() {
        return this._trim;
    }
    set trim(trim) {
        this._trim !== trim && (this._trim = trim, this.styleID++);
    }
    /**
   * How newlines and spaces should be handled.
   * Default is 'pre' (preserve, preserve).
   *
   *  value       | New lines     |   Spaces
   *  ---         | ---           |   ---
   * 'normal'     | Collapse      |   Collapse
   * 'pre'        | Preserve      |   Preserve
   * 'pre-line'   | Preserve      |   Collapse
   *
   * @member {'normal'|'pre'|'pre-line'}
   */ get whiteSpace() {
        return this._whiteSpace;
    }
    set whiteSpace(whiteSpace) {
        this._whiteSpace !== whiteSpace && (this._whiteSpace = whiteSpace, this.styleID++);
    }
    /** Indicates if word wrap should be used. */ get wordWrap() {
        return this._wordWrap;
    }
    set wordWrap(wordWrap) {
        this._wordWrap !== wordWrap && (this._wordWrap = wordWrap, this.styleID++);
    }
    /** The width at which text will wrap, it needs wordWrap to be set to true. */ get wordWrapWidth() {
        return this._wordWrapWidth;
    }
    set wordWrapWidth(wordWrapWidth) {
        this._wordWrapWidth !== wordWrapWidth && (this._wordWrapWidth = wordWrapWidth, this.styleID++);
    }
    /**
   * Generates a font style string to use for `TextMetrics.measureFont()`.
   *
   * @return Font style string, for passing to `TextMetrics.measureFont()`
   */ toFontString() {
        const fontSizeString = typeof this.fontSize == "number" ? `${this.fontSize}px` : this.fontSize;
        let fontFamilies = this.fontFamily;
        Array.isArray(this.fontFamily) || (fontFamilies = this.fontFamily.split(","));
        for(let i = fontFamilies.length - 1; i >= 0; i--){
            let fontFamily = fontFamilies[i].trim();
            !/([\"\'])[^\'\"]+\1/.test(fontFamily) && !$95ce52d18dddb804$var$genericFontFamilies.includes(fontFamily) && (fontFamily = `"${fontFamily}"`), fontFamilies[i] = fontFamily;
        }
        return `${this.fontStyle} ${this.fontVariant} ${this.fontWeight} ${fontSizeString} ${fontFamilies.join(",")}`;
    }
};
$95ce52d18dddb804$var$_TextStyle.defaultStyle = {
    /**
   * See {@link PIXI.TextStyle.align}
   * @type {'left'|'center'|'right'|'justify'}
   */ align: "left",
    /** See {@link PIXI.TextStyle.breakWords} */ breakWords: !1,
    /** See {@link PIXI.TextStyle.dropShadow} */ dropShadow: !1,
    /** See {@link PIXI.TextStyle.dropShadowAlpha} */ dropShadowAlpha: 1,
    /**
   * See {@link PIXI.TextStyle.dropShadowAngle}
   * @type {number}
   * @default Math.PI / 6
   */ dropShadowAngle: Math.PI / 6,
    /** See {@link PIXI.TextStyle.dropShadowBlur} */ dropShadowBlur: 0,
    /**
   * See {@link PIXI.TextStyle.dropShadowColor}
   * @type {string|number}
   */ dropShadowColor: "black",
    /** See {@link PIXI.TextStyle.dropShadowDistance} */ dropShadowDistance: 5,
    /**
   * See {@link PIXI.TextStyle.fill}
   * @type {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
   */ fill: "black",
    /**
   * See {@link PIXI.TextStyle.fillGradientType}
   * @type {PIXI.TEXT_GRADIENT}
   * @default PIXI.TEXT_GRADIENT.LINEAR_VERTICAL
   */ fillGradientType: (0, $db11ad4206a572b4$export$131daa784848984).LINEAR_VERTICAL,
    /**
   * See {@link PIXI.TextStyle.fillGradientStops}
   * @type {number[]}
   * @default []
   */ fillGradientStops: [],
    /**
   * See {@link PIXI.TextStyle.fontFamily}
   * @type {string|string[]}
   */ fontFamily: "Arial",
    /**
   * See {@link PIXI.TextStyle.fontSize}
   * @type {number|string} 
   */ fontSize: 26,
    /**
   * See {@link PIXI.TextStyle.fontStyle}
   * @type {'normal'|'italic'|'oblique'}
   */ fontStyle: "normal",
    /**
   * See {@link PIXI.TextStyle.fontVariant}
   * @type {'normal'|'small-caps'}
   */ fontVariant: "normal",
    /**
   * See {@link PIXI.TextStyle.fontWeight}
   * @type {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */ fontWeight: "normal",
    /** See {@link PIXI.TextStyle.leading} */ leading: 0,
    /** See {@link PIXI.TextStyle.letterSpacing} */ letterSpacing: 0,
    /** See {@link PIXI.TextStyle.lineHeight} */ lineHeight: 0,
    /**
   * See {@link PIXI.TextStyle.lineJoin}
   * @type {'miter'|'round'|'bevel'}
   */ lineJoin: "miter",
    /** See {@link PIXI.TextStyle.miterLimit} */ miterLimit: 10,
    /** See {@link PIXI.TextStyle.padding} */ padding: 0,
    /**
   * See {@link PIXI.TextStyle.stroke}
   * @type {string|number}
   */ stroke: "black",
    /** See {@link PIXI.TextStyle.strokeThickness} */ strokeThickness: 0,
    /**
   * See {@link PIXI.TextStyle.textBaseline} 
   * @type {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */ textBaseline: "alphabetic",
    /** See {@link PIXI.TextStyle.trim} */ trim: !1,
    /**
   * See {@link PIXI.TextStyle.whiteSpace}
   * @type {'normal'|'pre'|'pre-line'}
   */ whiteSpace: "pre",
    /** See {@link PIXI.TextStyle.wordWrap} */ wordWrap: !1,
    /** See {@link PIXI.TextStyle.wordWrapWidth} */ wordWrapWidth: 100
};
let $95ce52d18dddb804$export$1df879243bf2e42d = $95ce52d18dddb804$var$_TextStyle;
function $95ce52d18dddb804$var$getColor(color) {
    const temp = (0, $3119899e085d9ccf$export$892596cec99bc70e).shared, format = (color2)=>{
        const res = temp.setValue(color2);
        return res.alpha === 1 ? res.toHex() : res.toRgbaString();
    };
    return Array.isArray(color) ? color.map(format) : format(color);
}
function $95ce52d18dddb804$var$areArraysEqual(array1, array2) {
    if (!Array.isArray(array1) || !Array.isArray(array2) || array1.length !== array2.length) return !1;
    for(let i = 0; i < array1.length; ++i)if (array1[i] !== array2[i]) return !1;
    return !0;
}
function $95ce52d18dddb804$var$deepCopyProperties(target, source, propertyObj) {
    for(const prop in propertyObj)Array.isArray(source[prop]) ? target[prop] = source[prop].slice() : target[prop] = source[prop];
}


const $5bff0fb5a186a11a$var$defaultDestroyOptions = {
    texture: !0,
    children: !1,
    baseTexture: !0
}, $5bff0fb5a186a11a$var$_Text = class _Text2 extends (0, $f092bed24e72671b$export$3075603db8e6204c) {
    /**
   * @param text - The string that you would like the text to display
   * @param style - The style parameters
   * @param canvas - The canvas element for drawing text
   */ constructor(text, style, canvas){
        let ownCanvas = !1;
        canvas || (canvas = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.createCanvas(), ownCanvas = !0), canvas.width = 3, canvas.height = 3;
        const texture = (0, $ad1fffd072a707c2$export$5431306cf43de24a).from(canvas);
        texture.orig = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(), texture.trim = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(), super(texture), this._ownCanvas = ownCanvas, this.canvas = canvas, this.context = canvas.getContext("2d", {
            // required for trimming to work without warnings
            willReadFrequently: !0
        }), this._resolution = _Text2.defaultResolution ?? (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).RESOLUTION, this._autoResolution = _Text2.defaultAutoResolution, this._text = null, this._style = null, this._styleListener = null, this._font = "", this.text = text, this.style = style, this.localStyleID = -1;
    }
    /**
   * @see PIXI.TextMetrics.experimentalLetterSpacing
   * @deprecated since 7.1.0
   */ static get experimentalLetterSpacing() {
        return (0, $a3232095b7fc32d6$export$4c5a129a59e1ef34).experimentalLetterSpacing;
    }
    static set experimentalLetterSpacing(value) {
        (0, $29e19754806f3a05$exports).deprecation("7.1.0", "Text.experimentalLetterSpacing is deprecated, use TextMetrics.experimentalLetterSpacing"), (0, $a3232095b7fc32d6$export$4c5a129a59e1ef34).experimentalLetterSpacing = value;
    }
    /**
   * Renders text to its canvas, and updates its texture.
   *
   * By default this is used internally to ensure the texture is correct before rendering,
   * but it can be used called externally, for example from this class to 'pre-generate' the texture from a piece of text,
   * and then shared across multiple Sprites.
   * @param respectDirty - Whether to abort updating the text if the Text isn't dirty and the function is called.
   */ updateText(respectDirty) {
        const style = this._style;
        if (this.localStyleID !== style.styleID && (this.dirty = !0, this.localStyleID = style.styleID), !this.dirty && respectDirty) return;
        this._font = this._style.toFontString();
        const context = this.context, measured = (0, $a3232095b7fc32d6$export$4c5a129a59e1ef34).measureText(this._text || " ", this._style, this._style.wordWrap, this.canvas), width = measured.width, height = measured.height, lines = measured.lines, lineHeight = measured.lineHeight, lineWidths = measured.lineWidths, maxLineWidth = measured.maxLineWidth, fontProperties = measured.fontProperties;
        this.canvas.width = Math.ceil(Math.ceil(Math.max(1, width) + style.padding * 2) * this._resolution), this.canvas.height = Math.ceil(Math.ceil(Math.max(1, height) + style.padding * 2) * this._resolution), context.scale(this._resolution, this._resolution), context.clearRect(0, 0, this.canvas.width, this.canvas.height), context.font = this._font, context.lineWidth = style.strokeThickness, context.textBaseline = style.textBaseline, context.lineJoin = style.lineJoin, context.miterLimit = style.miterLimit;
        let linePositionX, linePositionY;
        const passesCount = style.dropShadow ? 2 : 1;
        for(let i = 0; i < passesCount; ++i){
            const isShadowPass = style.dropShadow && i === 0, dsOffsetText = isShadowPass ? Math.ceil(Math.max(1, height) + style.padding * 2) : 0, dsOffsetShadow = dsOffsetText * this._resolution;
            if (isShadowPass) {
                context.fillStyle = "black", context.strokeStyle = "black";
                const dropShadowColor = style.dropShadowColor, dropShadowBlur = style.dropShadowBlur * this._resolution, dropShadowDistance = style.dropShadowDistance * this._resolution;
                context.shadowColor = (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(dropShadowColor).setAlpha(style.dropShadowAlpha).toRgbaString(), context.shadowBlur = dropShadowBlur, context.shadowOffsetX = Math.cos(style.dropShadowAngle) * dropShadowDistance, context.shadowOffsetY = Math.sin(style.dropShadowAngle) * dropShadowDistance + dsOffsetShadow;
            } else context.fillStyle = this._generateFillStyle(style, lines, measured), context.strokeStyle = style.stroke, context.shadowColor = "black", context.shadowBlur = 0, context.shadowOffsetX = 0, context.shadowOffsetY = 0;
            let linePositionYShift = (lineHeight - fontProperties.fontSize) / 2;
            lineHeight - fontProperties.fontSize < 0 && (linePositionYShift = 0);
            for(let i2 = 0; i2 < lines.length; i2++)linePositionX = style.strokeThickness / 2, linePositionY = style.strokeThickness / 2 + i2 * lineHeight + fontProperties.ascent + linePositionYShift, style.align === "right" ? linePositionX += maxLineWidth - lineWidths[i2] : style.align === "center" && (linePositionX += (maxLineWidth - lineWidths[i2]) / 2), style.stroke && style.strokeThickness && this.drawLetterSpacing(lines[i2], linePositionX + style.padding, linePositionY + style.padding - dsOffsetText, !0), style.fill && this.drawLetterSpacing(lines[i2], linePositionX + style.padding, linePositionY + style.padding - dsOffsetText);
        }
        this.updateTexture();
    }
    /**
   * Render the text with letter-spacing.
   * @param text - The text to draw
   * @param x - Horizontal position to draw the text
   * @param y - Vertical position to draw the text
   * @param isStroke - Is this drawing for the outside stroke of the
   *  text? If not, it's for the inside fill
   */ drawLetterSpacing(text, x, y, isStroke = !1) {
        const letterSpacing = this._style.letterSpacing;
        let useExperimentalLetterSpacing = !1;
        if ((0, $a3232095b7fc32d6$export$4c5a129a59e1ef34).experimentalLetterSpacingSupported && ((0, $a3232095b7fc32d6$export$4c5a129a59e1ef34).experimentalLetterSpacing ? (this.context.letterSpacing = `${letterSpacing}px`, this.context.textLetterSpacing = `${letterSpacing}px`, useExperimentalLetterSpacing = !0) : (this.context.letterSpacing = "0px", this.context.textLetterSpacing = "0px")), letterSpacing === 0 || useExperimentalLetterSpacing) {
            isStroke ? this.context.strokeText(text, x, y) : this.context.fillText(text, x, y);
            return;
        }
        let currentPosition = x;
        const stringArray = (0, $a3232095b7fc32d6$export$4c5a129a59e1ef34).graphemeSegmenter(text);
        let previousWidth = this.context.measureText(text).width, currentWidth = 0;
        for(let i = 0; i < stringArray.length; ++i){
            const currentChar = stringArray[i];
            isStroke ? this.context.strokeText(currentChar, currentPosition, y) : this.context.fillText(currentChar, currentPosition, y);
            let textStr = "";
            for(let j = i + 1; j < stringArray.length; ++j)textStr += stringArray[j];
            currentWidth = this.context.measureText(textStr).width, currentPosition += previousWidth - currentWidth + letterSpacing, previousWidth = currentWidth;
        }
    }
    /** Updates texture size based on canvas size. */ updateTexture() {
        const canvas = this.canvas;
        if (this._style.trim) {
            const trimmed = (0, $29e19754806f3a05$exports).trimCanvas(canvas);
            trimmed.data && (canvas.width = trimmed.width, canvas.height = trimmed.height, this.context.putImageData(trimmed.data, 0, 0));
        }
        const texture = this._texture, style = this._style, padding = style.trim ? 0 : style.padding, baseTexture = texture.baseTexture;
        texture.trim.width = texture._frame.width = canvas.width / this._resolution, texture.trim.height = texture._frame.height = canvas.height / this._resolution, texture.trim.x = -padding, texture.trim.y = -padding, texture.orig.width = texture._frame.width - padding * 2, texture.orig.height = texture._frame.height - padding * 2, this._onTextureUpdate(), baseTexture.setRealSize(canvas.width, canvas.height, this._resolution), texture.updateUvs(), this.dirty = !1;
    }
    /**
   * Renders the object using the WebGL renderer
   * @param renderer - The renderer
   */ _render(renderer) {
        this._autoResolution && this._resolution !== renderer.resolution && (this._resolution = renderer.resolution, this.dirty = !0), this.updateText(!0), super._render(renderer);
    }
    /** Updates the transform on all children of this container for rendering. */ updateTransform() {
        this.updateText(!0), super.updateTransform();
    }
    getBounds(skipUpdate, rect) {
        return this.updateText(!0), this._textureID === -1 && (skipUpdate = !1), super.getBounds(skipUpdate, rect);
    }
    /**
   * Gets the local bounds of the text object.
   * @param rect - The output rectangle.
   * @returns The bounds.
   */ getLocalBounds(rect) {
        return this.updateText(!0), super.getLocalBounds.call(this, rect);
    }
    /** Calculates the bounds of the Text as a rectangle. The bounds calculation takes the worldTransform into account. */ _calculateBounds() {
        this.calculateVertices(), this._bounds.addQuad(this.vertexData);
    }
    /**
   * Generates the fill style. Can automatically generate a gradient based on the fill style being an array
   * @param style - The style.
   * @param lines - The lines of text.
   * @param metrics
   * @returns The fill style
   */ _generateFillStyle(style, lines, metrics) {
        const fillStyle = style.fill;
        if (Array.isArray(fillStyle)) {
            if (fillStyle.length === 1) return fillStyle[0];
        } else return fillStyle;
        let gradient;
        const dropShadowCorrection = style.dropShadow ? style.dropShadowDistance : 0, padding = style.padding || 0, width = this.canvas.width / this._resolution - dropShadowCorrection - padding * 2, height = this.canvas.height / this._resolution - dropShadowCorrection - padding * 2, fill = fillStyle.slice(), fillGradientStops = style.fillGradientStops.slice();
        if (!fillGradientStops.length) {
            const lengthPlus1 = fill.length + 1;
            for(let i = 1; i < lengthPlus1; ++i)fillGradientStops.push(i / lengthPlus1);
        }
        if (fill.unshift(fillStyle[0]), fillGradientStops.unshift(0), fill.push(fillStyle[fillStyle.length - 1]), fillGradientStops.push(1), style.fillGradientType === (0, $db11ad4206a572b4$export$131daa784848984).LINEAR_VERTICAL) {
            gradient = this.context.createLinearGradient(width / 2, padding, width / 2, height + padding);
            const textHeight = metrics.fontProperties.fontSize + style.strokeThickness;
            for(let i = 0; i < lines.length; i++){
                const lastLineBottom = metrics.lineHeight * (i - 1) + textHeight, thisLineTop = metrics.lineHeight * i;
                let thisLineGradientStart = thisLineTop;
                i > 0 && lastLineBottom > thisLineTop && (thisLineGradientStart = (thisLineTop + lastLineBottom) / 2);
                const thisLineBottom = thisLineTop + textHeight, nextLineTop = metrics.lineHeight * (i + 1);
                let thisLineGradientEnd = thisLineBottom;
                i + 1 < lines.length && nextLineTop < thisLineBottom && (thisLineGradientEnd = (thisLineBottom + nextLineTop) / 2);
                const gradStopLineHeight = (thisLineGradientEnd - thisLineGradientStart) / height;
                for(let j = 0; j < fill.length; j++){
                    let lineStop = 0;
                    typeof fillGradientStops[j] == "number" ? lineStop = fillGradientStops[j] : lineStop = j / fill.length;
                    let globalStop = Math.min(1, Math.max(0, thisLineGradientStart / height + lineStop * gradStopLineHeight));
                    globalStop = Number(globalStop.toFixed(5)), gradient.addColorStop(globalStop, fill[j]);
                }
            }
        } else {
            gradient = this.context.createLinearGradient(padding, height / 2, width + padding, height / 2);
            const totalIterations = fill.length + 1;
            let currentIteration = 1;
            for(let i = 0; i < fill.length; i++){
                let stop;
                typeof fillGradientStops[i] == "number" ? stop = fillGradientStops[i] : stop = currentIteration / totalIterations, gradient.addColorStop(stop, fill[i]), currentIteration++;
            }
        }
        return gradient;
    }
    /**
   * Destroys this text object.
   *
   * Note* Unlike a Sprite, a Text object will automatically destroy its baseTexture and texture as
   * the majority of the time the texture will not be shared with any other Sprites.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their
   *  destroy method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=true] - Should it destroy the current texture of the sprite as well
   * @param {boolean} [options.baseTexture=true] - Should it destroy the base texture of the sprite as well
   */ destroy(options) {
        typeof options == "boolean" && (options = {
            children: options
        }), options = Object.assign({}, $5bff0fb5a186a11a$var$defaultDestroyOptions, options), super.destroy(options), this._ownCanvas && (this.canvas.height = this.canvas.width = 0), this.context = null, this.canvas = null, this._style = null;
    }
    /** The width of the Text, setting this will actually modify the scale to achieve the value set. */ get width() {
        return this.updateText(!0), Math.abs(this.scale.x) * this._texture.orig.width;
    }
    set width(value) {
        this.updateText(!0);
        const s = (0, $29e19754806f3a05$exports).sign(this.scale.x) || 1;
        this.scale.x = s * value / this._texture.orig.width, this._width = value;
    }
    /** The height of the Text, setting this will actually modify the scale to achieve the value set. */ get height() {
        return this.updateText(!0), Math.abs(this.scale.y) * this._texture.orig.height;
    }
    set height(value) {
        this.updateText(!0);
        const s = (0, $29e19754806f3a05$exports).sign(this.scale.y) || 1;
        this.scale.y = s * value / this._texture.orig.height, this._height = value;
    }
    /**
   * Set the style of the text.
   *
   * Set up an event listener to listen for changes on the style object and mark the text as dirty.
   *
   * If setting the `style` can also be partial {@link PIXI.ITextStyle}.
   */ get style() {
        return this._style;
    }
    set style(style) {
        style = style || {}, style instanceof (0, $95ce52d18dddb804$export$1df879243bf2e42d) ? this._style = style : this._style = new (0, $95ce52d18dddb804$export$1df879243bf2e42d)(style), this.localStyleID = -1, this.dirty = !0;
    }
    /** Set the copy for the text object. To split a line you can use '\n'. */ get text() {
        return this._text;
    }
    set text(text) {
        text = String(text ?? ""), this._text !== text && (this._text = text, this.dirty = !0);
    }
    /**
   * The resolution / device pixel ratio of the canvas.
   *
   * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
   * @default 1
   */ get resolution() {
        return this._resolution;
    }
    set resolution(value) {
        this._autoResolution = !1, this._resolution !== value && (this._resolution = value, this.dirty = !0);
    }
};
$5bff0fb5a186a11a$var$_Text.defaultAutoResolution = !0;
let $5bff0fb5a186a11a$export$5f1af8db9871e1d6 = $5bff0fb5a186a11a$var$_Text;






class $5e9823a1ac2297fb$export$29966907153718d8 {
    /**
   * @param maxItemsPerFrame - The maximum number of items that can be prepared each frame.
   */ constructor(maxItemsPerFrame){
        this.maxItemsPerFrame = maxItemsPerFrame, this.itemsLeft = 0;
    }
    /** Resets any counting properties to start fresh on a new frame. */ beginFrame() {
        this.itemsLeft = this.maxItemsPerFrame;
    }
    /**
   * Checks to see if another item can be uploaded. This should only be called once per item.
   * @returns If the item is allowed to be uploaded.
   */ allowedToUpload() {
        return this.itemsLeft-- > 0;
    }
}


function $43c7d77f48b94e9f$var$findMultipleBaseTextures(item, queue) {
    let result = !1;
    if (item?._textures?.length) {
        for(let i = 0; i < item._textures.length; i++)if (item._textures[i] instanceof (0, $ad1fffd072a707c2$export$5431306cf43de24a)) {
            const baseTexture = item._textures[i].baseTexture;
            queue.includes(baseTexture) || (queue.push(baseTexture), result = !0);
        }
    }
    return result;
}
function $43c7d77f48b94e9f$var$findBaseTexture(item, queue) {
    if (item.baseTexture instanceof (0, $997b0e421c4045eb$export$d6306e508f184154)) {
        const texture = item.baseTexture;
        return queue.includes(texture) || queue.push(texture), !0;
    }
    return !1;
}
function $43c7d77f48b94e9f$var$findTexture(item, queue) {
    if (item._texture && item._texture instanceof (0, $ad1fffd072a707c2$export$5431306cf43de24a)) {
        const texture = item._texture.baseTexture;
        return queue.includes(texture) || queue.push(texture), !0;
    }
    return !1;
}
function $43c7d77f48b94e9f$var$drawText(_helper, item) {
    return item instanceof (0, $5bff0fb5a186a11a$export$5f1af8db9871e1d6) ? (item.updateText(!0), !0) : !1;
}
function $43c7d77f48b94e9f$var$calculateTextStyle(_helper, item) {
    if (item instanceof (0, $95ce52d18dddb804$export$1df879243bf2e42d)) {
        const font = item.toFontString();
        return (0, $a3232095b7fc32d6$export$4c5a129a59e1ef34).measureFont(font), !0;
    }
    return !1;
}
function $43c7d77f48b94e9f$var$findText(item, queue) {
    if (item instanceof (0, $5bff0fb5a186a11a$export$5f1af8db9871e1d6)) {
        queue.includes(item.style) || queue.push(item.style), queue.includes(item) || queue.push(item);
        const texture = item._texture.baseTexture;
        return queue.includes(texture) || queue.push(texture), !0;
    }
    return !1;
}
function $43c7d77f48b94e9f$var$findTextStyle(item, queue) {
    return item instanceof (0, $95ce52d18dddb804$export$1df879243bf2e42d) ? (queue.includes(item) || queue.push(item), !0) : !1;
}
const $43c7d77f48b94e9f$var$_BasePrepare = class _BasePrepare2 {
    /**
   * @param {PIXI.IRenderer} renderer - A reference to the current renderer
   */ constructor(renderer){
        this.limiter = new (0, $5e9823a1ac2297fb$export$29966907153718d8)(_BasePrepare2.uploadsPerFrame), this.renderer = renderer, this.uploadHookHelper = null, this.queue = [], this.addHooks = [], this.uploadHooks = [], this.completes = [], this.ticking = !1, this.delayedTick = ()=>{
            this.queue && this.prepareItems();
        }, this.registerFindHook($43c7d77f48b94e9f$var$findText), this.registerFindHook($43c7d77f48b94e9f$var$findTextStyle), this.registerFindHook($43c7d77f48b94e9f$var$findMultipleBaseTextures), this.registerFindHook($43c7d77f48b94e9f$var$findBaseTexture), this.registerFindHook($43c7d77f48b94e9f$var$findTexture), this.registerUploadHook($43c7d77f48b94e9f$var$drawText), this.registerUploadHook($43c7d77f48b94e9f$var$calculateTextStyle);
    }
    /**
   * Upload all the textures and graphics to the GPU.
   * @method PIXI.BasePrepare#upload
   * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text} [item] -
   *        Container or display object to search for items to upload or the items to upload themselves,
   *        or optionally ommitted, if items have been added using {@link PIXI.BasePrepare#add `prepare.add`}.
   */ upload(item) {
        return new Promise((resolve)=>{
            item && this.add(item), this.queue.length ? (this.completes.push(resolve), this.ticking || (this.ticking = !0, (0, $f044fd65ebec6baf$export$39c54bcc89dcee11).system.addOnce(this.tick, this, (0, $4cc823daa6dd1896$export$688aaf132ba9b379).UTILITY))) : resolve();
        });
    }
    /**
   * Handle tick update
   * @private
   */ tick() {
        setTimeout(this.delayedTick, 0);
    }
    /**
   * Actually prepare items. This is handled outside of the tick because it will take a while
   * and we do NOT want to block the current animation frame from rendering.
   * @private
   */ prepareItems() {
        for(this.limiter.beginFrame(); this.queue.length && this.limiter.allowedToUpload();){
            const item = this.queue[0];
            let uploaded = !1;
            if (item && !item._destroyed) {
                for(let i = 0, len = this.uploadHooks.length; i < len; i++)if (this.uploadHooks[i](this.uploadHookHelper, item)) {
                    this.queue.shift(), uploaded = !0;
                    break;
                }
            }
            uploaded || this.queue.shift();
        }
        if (this.queue.length) (0, $f044fd65ebec6baf$export$39c54bcc89dcee11).system.addOnce(this.tick, this, (0, $4cc823daa6dd1896$export$688aaf132ba9b379).UTILITY);
        else {
            this.ticking = !1;
            const completes = this.completes.slice(0);
            this.completes.length = 0;
            for(let i = 0, len = completes.length; i < len; i++)completes[i]();
        }
    }
    /**
   * Adds hooks for finding items.
   * @param {Function} addHook - Function call that takes two parameters: `item:*, queue:Array`
   *          function must return `true` if it was able to add item to the queue.
   * @returns Instance of plugin for chaining.
   */ registerFindHook(addHook) {
        return addHook && this.addHooks.push(addHook), this;
    }
    /**
   * Adds hooks for uploading items.
   * @param {Function} uploadHook - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
   *          function must return `true` if it was able to handle upload of item.
   * @returns Instance of plugin for chaining.
   */ registerUploadHook(uploadHook) {
        return uploadHook && this.uploadHooks.push(uploadHook), this;
    }
    /**
   * Manually add an item to the uploading queue.
   * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text|*} item - Object to
   *        add to the queue
   * @returns Instance of plugin for chaining.
   */ add(item) {
        for(let i = 0, len = this.addHooks.length; i < len && !this.addHooks[i](item, this.queue); i++);
        if (item instanceof (0, $3878067a77b781d9$export$42a852a2b6b56249)) for(let i = item.children.length - 1; i >= 0; i--)this.add(item.children[i]);
        return this;
    }
    /** Destroys the plugin, don't use after this. */ destroy() {
        this.ticking && (0, $f044fd65ebec6baf$export$39c54bcc89dcee11).system.remove(this.tick, this), this.ticking = !1, this.addHooks = null, this.uploadHooks = null, this.renderer = null, this.completes = null, this.queue = null, this.limiter = null, this.uploadHookHelper = null;
    }
};
$43c7d77f48b94e9f$var$_BasePrepare.uploadsPerFrame = 4;
let $43c7d77f48b94e9f$export$189fb89547161769 = $43c7d77f48b94e9f$var$_BasePrepare;


Object.defineProperties((0, $5340ccf8570d4063$export$a5a6e0b888b2c992), {
    /**
   * Default number of uploads per frame using prepare plugin.
   * @static
   * @memberof PIXI.settings
   * @name UPLOADS_PER_FRAME
   * @deprecated since 7.1.0
   * @see PIXI.BasePrepare.uploadsPerFrame
   * @type {number}
   */ UPLOADS_PER_FRAME: {
        get () {
            return (0, $43c7d77f48b94e9f$export$189fb89547161769).uploadsPerFrame;
        },
        set (value) {
            (0, $29e19754806f3a05$exports).deprecation("7.1.0", "settings.UPLOADS_PER_FRAME is deprecated, use prepare.BasePrepare.uploadsPerFrame"), (0, $43c7d77f48b94e9f$export$189fb89547161769).uploadsPerFrame = value;
        }
    }
});







function $2a4e09fed2c0b5c9$var$uploadBaseTextures(renderer, item) {
    return item instanceof (0, $997b0e421c4045eb$export$d6306e508f184154) ? (item._glTextures[renderer.CONTEXT_UID] || renderer.texture.bind(item), !0) : !1;
}
function $2a4e09fed2c0b5c9$var$uploadGraphics(renderer, item) {
    if (!(item instanceof (0, $d21713afb1bb29fd$export$29d3e417456abdad))) return !1;
    const { geometry: geometry } = item;
    item.finishPoly(), geometry.updateBatches();
    const { batches: batches } = geometry;
    for(let i = 0; i < batches.length; i++){
        const { texture: texture } = batches[i].style;
        texture && $2a4e09fed2c0b5c9$var$uploadBaseTextures(renderer, texture.baseTexture);
    }
    return geometry.batchable || renderer.geometry.bind(geometry, item._resolveDirectShader(renderer)), !0;
}
function $2a4e09fed2c0b5c9$var$findGraphics(item, queue) {
    return item instanceof (0, $d21713afb1bb29fd$export$29d3e417456abdad) ? (queue.push(item), !0) : !1;
}
class $2a4e09fed2c0b5c9$export$6475b8f46e7e39d6 extends (0, $43c7d77f48b94e9f$export$189fb89547161769) {
    /**
   * @param {PIXI.Renderer} renderer - A reference to the current renderer
   */ constructor(renderer){
        super(renderer), this.uploadHookHelper = this.renderer, this.registerFindHook($2a4e09fed2c0b5c9$var$findGraphics), this.registerUploadHook($2a4e09fed2c0b5c9$var$uploadBaseTextures), this.registerUploadHook($2a4e09fed2c0b5c9$var$uploadGraphics);
    }
}
$2a4e09fed2c0b5c9$export$6475b8f46e7e39d6.extension = {
    name: "prepare",
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererSystem
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($2a4e09fed2c0b5c9$export$6475b8f46e7e39d6);


class $f54e1debe563c902$export$82e43921ff85c600 {
    /** @param maxMilliseconds - The maximum milliseconds that can be spent preparing items each frame. */ constructor(maxMilliseconds){
        this.maxMilliseconds = maxMilliseconds, this.frameStart = 0;
    }
    /** Resets any counting properties to start fresh on a new frame. */ beginFrame() {
        this.frameStart = Date.now();
    }
    /**
   * Checks to see if another item can be uploaded. This should only be called once per item.
   * @returns - If the item is allowed to be uploaded.
   */ allowedToUpload() {
        return Date.now() - this.frameStart < this.maxMilliseconds;
    }
}







class $931ccc42eb9caa3e$export$dae599798687ad3c extends (0, $f092bed24e72671b$export$3075603db8e6204c) {
    /**
   * @param textures - An array of {@link PIXI.Texture} or frame
   *  objects that make up the animation.
   * @param {boolean} [autoUpdate=true] - Whether to use Ticker.shared to auto update animation time.
   */ constructor(textures, autoUpdate = !0){
        super(textures[0] instanceof (0, $ad1fffd072a707c2$export$5431306cf43de24a) ? textures[0] : textures[0].texture), this._textures = null, this._durations = null, this._autoUpdate = autoUpdate, this._isConnectedToTicker = !1, this.animationSpeed = 1, this.loop = !0, this.updateAnchor = !1, this.onComplete = null, this.onFrameChange = null, this.onLoop = null, this._currentTime = 0, this._playing = !1, this._previousFrame = null, this.textures = textures;
    }
    /** Stops the AnimatedSprite. */ stop() {
        this._playing && (this._playing = !1, this._autoUpdate && this._isConnectedToTicker && ((0, $f044fd65ebec6baf$export$39c54bcc89dcee11).shared.remove(this.update, this), this._isConnectedToTicker = !1));
    }
    /** Plays the AnimatedSprite. */ play() {
        this._playing || (this._playing = !0, this._autoUpdate && !this._isConnectedToTicker && ((0, $f044fd65ebec6baf$export$39c54bcc89dcee11).shared.add(this.update, this, (0, $4cc823daa6dd1896$export$688aaf132ba9b379).HIGH), this._isConnectedToTicker = !0));
    }
    /**
   * Stops the AnimatedSprite and goes to a specific frame.
   * @param frameNumber - Frame index to stop at.
   */ gotoAndStop(frameNumber) {
        this.stop(), this.currentFrame = frameNumber;
    }
    /**
   * Goes to a specific frame and begins playing the AnimatedSprite.
   * @param frameNumber - Frame index to start at.
   */ gotoAndPlay(frameNumber) {
        this.currentFrame = frameNumber, this.play();
    }
    /**
   * Updates the object transform for rendering.
   * @param deltaTime - Time since last tick.
   */ update(deltaTime) {
        if (!this._playing) return;
        const elapsed = this.animationSpeed * deltaTime, previousFrame = this.currentFrame;
        if (this._durations !== null) {
            let lag = this._currentTime % 1 * this._durations[this.currentFrame];
            for(lag += elapsed / 60 * 1e3; lag < 0;)this._currentTime--, lag += this._durations[this.currentFrame];
            const sign = Math.sign(this.animationSpeed * deltaTime);
            for(this._currentTime = Math.floor(this._currentTime); lag >= this._durations[this.currentFrame];)lag -= this._durations[this.currentFrame] * sign, this._currentTime += sign;
            this._currentTime += lag / this._durations[this.currentFrame];
        } else this._currentTime += elapsed;
        this._currentTime < 0 && !this.loop ? (this.gotoAndStop(0), this.onComplete && this.onComplete()) : this._currentTime >= this._textures.length && !this.loop ? (this.gotoAndStop(this._textures.length - 1), this.onComplete && this.onComplete()) : previousFrame !== this.currentFrame && (this.loop && this.onLoop && (this.animationSpeed > 0 && this.currentFrame < previousFrame || this.animationSpeed < 0 && this.currentFrame > previousFrame) && this.onLoop(), this.updateTexture());
    }
    /** Updates the displayed texture to match the current frame index. */ updateTexture() {
        const currentFrame = this.currentFrame;
        this._previousFrame !== currentFrame && (this._previousFrame = currentFrame, this._texture = this._textures[currentFrame], this._textureID = -1, this._textureTrimmedID = -1, this._cachedTint = 16777215, this.uvs = this._texture._uvs.uvsFloat32, this.updateAnchor && this._anchor.copyFrom(this._texture.defaultAnchor), this.onFrameChange && this.onFrameChange(this.currentFrame));
    }
    /**
   * Stops the AnimatedSprite and destroys it.
   * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
   *  have been set to that value.
   * @param {boolean} [options.children=false] - If set to true, all the children will have their destroy
   *      method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well.
   * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well.
   */ destroy(options) {
        this.stop(), super.destroy(options), this.onComplete = null, this.onFrameChange = null, this.onLoop = null;
    }
    /**
   * A short hand way of creating an AnimatedSprite from an array of frame ids.
   * @param frames - The array of frames ids the AnimatedSprite will use as its texture frames.
   * @returns - The new animated sprite with the specified frames.
   */ static fromFrames(frames) {
        const textures = [];
        for(let i = 0; i < frames.length; ++i)textures.push((0, $ad1fffd072a707c2$export$5431306cf43de24a).from(frames[i]));
        return new $931ccc42eb9caa3e$export$dae599798687ad3c(textures);
    }
    /**
   * A short hand way of creating an AnimatedSprite from an array of image ids.
   * @param images - The array of image urls the AnimatedSprite will use as its texture frames.
   * @returns The new animate sprite with the specified images as frames.
   */ static fromImages(images) {
        const textures = [];
        for(let i = 0; i < images.length; ++i)textures.push((0, $ad1fffd072a707c2$export$5431306cf43de24a).from(images[i]));
        return new $931ccc42eb9caa3e$export$dae599798687ad3c(textures);
    }
    /**
   * The total number of frames in the AnimatedSprite. This is the same as number of textures
   * assigned to the AnimatedSprite.
   * @readonly
   * @default 0
   */ get totalFrames() {
        return this._textures.length;
    }
    /** The array of textures used for this AnimatedSprite. */ get textures() {
        return this._textures;
    }
    set textures(value) {
        if (value[0] instanceof (0, $ad1fffd072a707c2$export$5431306cf43de24a)) this._textures = value, this._durations = null;
        else {
            this._textures = [], this._durations = [];
            for(let i = 0; i < value.length; i++)this._textures.push(value[i].texture), this._durations.push(value[i].time);
        }
        this._previousFrame = null, this.gotoAndStop(0), this.updateTexture();
    }
    /** The AnimatedSprite's current frame index. */ get currentFrame() {
        let currentFrame = Math.floor(this._currentTime) % this._textures.length;
        return currentFrame < 0 && (currentFrame += this._textures.length), currentFrame;
    }
    set currentFrame(value) {
        if (value < 0 || value > this.totalFrames - 1) throw new Error(`[AnimatedSprite]: Invalid frame index value ${value}, expected to be between 0 and totalFrames ${this.totalFrames}.`);
        const previousFrame = this.currentFrame;
        this._currentTime = value, previousFrame !== this.currentFrame && this.updateTexture();
    }
    /**
   * Indicates if the AnimatedSprite is currently playing.
   * @readonly
   */ get playing() {
        return this._playing;
    }
    /** Whether to use Ticker.shared to auto update animation time. */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        value !== this._autoUpdate && (this._autoUpdate = value, !this._autoUpdate && this._isConnectedToTicker ? ((0, $f044fd65ebec6baf$export$39c54bcc89dcee11).shared.remove(this.update, this), this._isConnectedToTicker = !1) : this._autoUpdate && !this._isConnectedToTicker && this._playing && ((0, $f044fd65ebec6baf$export$39c54bcc89dcee11).shared.add(this.update, this), this._isConnectedToTicker = !0));
    }
}






const $49e70eb3bfcb2400$var$tempPoint = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)();
class $49e70eb3bfcb2400$export$db8370cd1ebcc819 extends (0, $f092bed24e72671b$export$3075603db8e6204c) {
    /**
   * Note: The wrap mode of the texture is forced to REPEAT on render if the size of the texture
   * is a power of two, the texture's wrap mode is CLAMP, and the texture hasn't been bound yet.
   * @param texture - The texture of the tiling sprite.
   * @param width - The width of the tiling sprite.
   * @param height - The height of the tiling sprite.
   */ constructor(texture, width = 100, height = 100){
        super(texture), this.tileTransform = new (0, $a93d35f2e511a825$export$563a914cafbdc389)(), this._width = width, this._height = height, this.uvMatrix = this.texture.uvMatrix || new (0, $132bbbe3a3fc729e$export$dbea3135e9da48cb)(texture), this.pluginName = "tilingSprite", this.uvRespectAnchor = !1;
    }
    /**
   * Changes frame clamping in corresponding textureTransform, shortcut
   * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
   * @default 0.5
   * @member {number}
   */ get clampMargin() {
        return this.uvMatrix.clampMargin;
    }
    set clampMargin(value) {
        this.uvMatrix.clampMargin = value, this.uvMatrix.update(!0);
    }
    /** The scaling of the image that is being tiled. */ get tileScale() {
        return this.tileTransform.scale;
    }
    set tileScale(value) {
        this.tileTransform.scale.copyFrom(value);
    }
    /** The offset of the image that is being tiled. */ get tilePosition() {
        return this.tileTransform.position;
    }
    set tilePosition(value) {
        this.tileTransform.position.copyFrom(value);
    }
    /**
   * @protected
   */ _onTextureUpdate() {
        this.uvMatrix && (this.uvMatrix.texture = this._texture), this._cachedTint = 16777215;
    }
    /**
   * Renders the object using the WebGL renderer
   * @param renderer - The renderer
   */ _render(renderer) {
        const texture = this._texture;
        !texture || !texture.valid || (this.tileTransform.updateLocalTransform(), this.uvMatrix.update(), renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]), renderer.plugins[this.pluginName].render(this));
    }
    /** Updates the bounds of the tiling sprite. */ _calculateBounds() {
        const minX = this._width * -this._anchor._x, minY = this._height * -this._anchor._y, maxX = this._width * (1 - this._anchor._x), maxY = this._height * (1 - this._anchor._y);
        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
    }
    /**
   * Gets the local bounds of the sprite object.
   * @param rect - Optional output rectangle.
   * @returns The bounds.
   */ getLocalBounds(rect) {
        return this.children.length === 0 ? (this._bounds.minX = this._width * -this._anchor._x, this._bounds.minY = this._height * -this._anchor._y, this._bounds.maxX = this._width * (1 - this._anchor._x), this._bounds.maxY = this._height * (1 - this._anchor._y), rect || (this._localBoundsRect || (this._localBoundsRect = new (0, $92248a7cf1facbda$export$4617fb02663045ef)()), rect = this._localBoundsRect), this._bounds.getRectangle(rect)) : super.getLocalBounds.call(this, rect);
    }
    /**
   * Checks if a point is inside this tiling sprite.
   * @param point - The point to check.
   * @returns Whether or not the sprite contains the point.
   */ containsPoint(point) {
        this.worldTransform.applyInverse(point, $49e70eb3bfcb2400$var$tempPoint);
        const width = this._width, height = this._height, x1 = -width * this.anchor._x;
        if ($49e70eb3bfcb2400$var$tempPoint.x >= x1 && $49e70eb3bfcb2400$var$tempPoint.x < x1 + width) {
            const y1 = -height * this.anchor._y;
            if ($49e70eb3bfcb2400$var$tempPoint.y >= y1 && $49e70eb3bfcb2400$var$tempPoint.y < y1 + height) return !0;
        }
        return !1;
    }
    /**
   * Destroys this sprite and optionally its texture and children
   * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
   *      method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
   * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
   */ destroy(options) {
        super.destroy(options), this.tileTransform = null, this.uvMatrix = null;
    }
    /**
   * Helper function that creates a new tiling sprite based on the source you provide.
   * The source can be - frame id, image url, video url, canvas element, video element, base texture
   * @static
   * @param {string|PIXI.Texture|HTMLCanvasElement|HTMLVideoElement} source - Source to create texture from
   * @param {object} options - See {@link PIXI.BaseTexture}'s constructor for options.
   * @param {number} options.width - required width of the tiling sprite
   * @param {number} options.height - required height of the tiling sprite
   * @returns {PIXI.TilingSprite} The newly created texture
   */ static from(source, options) {
        const texture = source instanceof (0, $ad1fffd072a707c2$export$5431306cf43de24a) ? source : (0, $ad1fffd072a707c2$export$5431306cf43de24a).from(source, options);
        return new $49e70eb3bfcb2400$export$db8370cd1ebcc819(texture, options.width, options.height);
    }
    /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */ get width() {
        return this._width;
    }
    set width(value) {
        this._width = value;
    }
    /** The height of the TilingSprite, setting this will actually modify the scale to achieve the value set. */ get height() {
        return this._height;
    }
    set height(value) {
        this._height = value;
    }
}



var $9a24ad360c1838a0$export$2e2bcd8739ae039 = `#version 300 es
#define SHADER_NAME Tiling-Sprite-100

precision lowp float;

in vec2 vTextureCoord;

out vec4 fragmentColor;

uniform sampler2D uSampler;
uniform vec4 uColor;
uniform mat3 uMapCoord;
uniform vec4 uClampFrame;
uniform vec2 uClampOffset;

void main(void)
{
    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);
    coord = (uMapCoord * vec3(coord, 1.0)).xy;
    vec2 unclamped = coord;
    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);

    vec4 texSample = texture(uSampler, coord, unclamped == coord ? 0.0f : -32.0f);// lod-bias very negative to force lod 0

    fragmentColor = texSample * uColor;
}
`;


var $8c6e884fa4733139$export$2e2bcd8739ae039 = `#version 300 es
#define SHADER_NAME Tiling-Sprite-300

precision lowp float;

in vec2 aVertexPosition;
in vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTransform;

out vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;
}
`;


var $078f6e0aff9e6d8f$export$2e2bcd8739ae039 = `#version 100
#ifdef GL_EXT_shader_texture_lod
    #extension GL_EXT_shader_texture_lod : enable
#endif
#define SHADER_NAME Tiling-Sprite-100

precision lowp float;

varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform vec4 uColor;
uniform mat3 uMapCoord;
uniform vec4 uClampFrame;
uniform vec2 uClampOffset;

void main(void)
{
    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);
    coord = (uMapCoord * vec3(coord, 1.0)).xy;
    vec2 unclamped = coord;
    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);

    #ifdef GL_EXT_shader_texture_lod
        vec4 texSample = unclamped == coord
            ? texture2D(uSampler, coord) 
            : texture2DLodEXT(uSampler, coord, 0);
    #else
        vec4 texSample = texture2D(uSampler, coord);
    #endif

    gl_FragColor = texSample * uColor;
}
`;


var $ead3d67b225e4543$export$2e2bcd8739ae039 = `#version 100
#define SHADER_NAME Tiling-Sprite-100

precision lowp float;

attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTransform;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;
}
`;


var $f779987dc0480f52$export$2e2bcd8739ae039 = `#version 100
#define SHADER_NAME Tiling-Sprite-Simple-100

precision lowp float;

varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform vec4 uColor;

void main(void)
{
    vec4 texSample = texture2D(uSampler, vTextureCoord);
    gl_FragColor = texSample * uColor;
}
`;


const $619399f52e019784$var$tempMat = new (0, $e3d55ad358e71dc4$export$5b12bf1653c0dd85)();
class $619399f52e019784$export$8b7f6ad84090f14c extends (0, $9b20378b287c50b2$export$ca67b0b0fa758253) {
    /**
   * constructor for renderer
   * @param {PIXI.Renderer} renderer - The renderer this tiling awesomeness works for.
   */ constructor(renderer){
        super(renderer), renderer.runners.contextChange.add(this), this.quad = new (0, $fa61408e8cb2fded$export$4f70783f37e4ec0b)(), this.state = (0, $05d0e9a749f67df1$export$7254cc27399e90bd).for2d();
    }
    /** Creates shaders when context is initialized. */ contextChange() {
        const renderer = this.renderer, uniforms = {
            globals: renderer.globalUniforms
        };
        this.simpleShader = (0, $20320a9b1d80d7dc$export$462bb059fed9d9e5).from((0, $ead3d67b225e4543$export$2e2bcd8739ae039), (0, $f779987dc0480f52$export$2e2bcd8739ae039), uniforms), this.shader = renderer.context.webGLVersion > 1 ? (0, $20320a9b1d80d7dc$export$462bb059fed9d9e5).from((0, $8c6e884fa4733139$export$2e2bcd8739ae039), (0, $9a24ad360c1838a0$export$2e2bcd8739ae039), uniforms) : (0, $20320a9b1d80d7dc$export$462bb059fed9d9e5).from((0, $ead3d67b225e4543$export$2e2bcd8739ae039), (0, $078f6e0aff9e6d8f$export$2e2bcd8739ae039), uniforms);
    }
    /**
   * @param {PIXI.TilingSprite} ts - tilingSprite to be rendered
   */ render(ts) {
        const renderer = this.renderer, quad = this.quad;
        let vertices = quad.vertices;
        vertices[0] = vertices[6] = ts._width * -ts.anchor.x, vertices[1] = vertices[3] = ts._height * -ts.anchor.y, vertices[2] = vertices[4] = ts._width * (1 - ts.anchor.x), vertices[5] = vertices[7] = ts._height * (1 - ts.anchor.y);
        const anchorX = ts.uvRespectAnchor ? ts.anchor.x : 0, anchorY = ts.uvRespectAnchor ? ts.anchor.y : 0;
        vertices = quad.uvs, vertices[0] = vertices[6] = -anchorX, vertices[1] = vertices[3] = -anchorY, vertices[2] = vertices[4] = 1 - anchorX, vertices[5] = vertices[7] = 1 - anchorY, quad.invalidate();
        const tex = ts._texture, baseTex = tex.baseTexture, premultiplied = baseTex.alphaMode > 0, lt = ts.tileTransform.localTransform, uv = ts.uvMatrix;
        let isSimple = baseTex.isPowerOfTwo && tex.frame.width === baseTex.width && tex.frame.height === baseTex.height;
        isSimple && (baseTex._glTextures[renderer.CONTEXT_UID] ? isSimple = baseTex.wrapMode !== (0, $5912637ee8cf8b9f$export$2ab395cfb0dd2f0f).CLAMP : baseTex.wrapMode === (0, $5912637ee8cf8b9f$export$2ab395cfb0dd2f0f).CLAMP && (baseTex.wrapMode = (0, $5912637ee8cf8b9f$export$2ab395cfb0dd2f0f).REPEAT));
        const shader = isSimple ? this.simpleShader : this.shader, w = tex.width, h = tex.height, W = ts._width, H = ts._height;
        $619399f52e019784$var$tempMat.set(lt.a * w / W, lt.b * w / H, lt.c * h / W, lt.d * h / H, lt.tx / W, lt.ty / H), $619399f52e019784$var$tempMat.invert(), isSimple ? $619399f52e019784$var$tempMat.prepend(uv.mapCoord) : (shader.uniforms.uMapCoord = uv.mapCoord.toArray(!0), shader.uniforms.uClampFrame = uv.uClampFrame, shader.uniforms.uClampOffset = uv.uClampOffset), shader.uniforms.uTransform = $619399f52e019784$var$tempMat.toArray(!0), shader.uniforms.uColor = (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(ts.tint).premultiply(ts.worldAlpha, premultiplied).toArray(shader.uniforms.uColor), shader.uniforms.translationMatrix = ts.transform.worldTransform.toArray(!0), shader.uniforms.uSampler = tex, renderer.shader.bind(shader), renderer.geometry.bind(quad), this.state.blendMode = (0, $29e19754806f3a05$exports).correctBlendMode(ts.blendMode, premultiplied), renderer.state.set(this.state), renderer.geometry.draw(this.renderer.gl.TRIANGLES, 6, 0);
    }
}
$619399f52e019784$export$8b7f6ad84090f14c.extension = {
    name: "tilingSprite",
    type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).RendererPlugin
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($619399f52e019784$export$8b7f6ad84090f14c);





const $e61f93fc159e7ca6$var$_Spritesheet = class _Spritesheet2 {
    /**
   * @param texture - Reference to the source BaseTexture object.
   * @param {object} data - Spritesheet image data.
   * @param resolutionFilename - The filename to consider when determining
   *        the resolution of the spritesheet. If not provided, the imageUrl will
   *        be used on the BaseTexture.
   */ constructor(texture, data, resolutionFilename = null){
        this.linkedSheets = [], this._texture = texture instanceof (0, $ad1fffd072a707c2$export$5431306cf43de24a) ? texture : null, this.baseTexture = texture instanceof (0, $997b0e421c4045eb$export$d6306e508f184154) ? texture : this._texture.baseTexture, this.textures = {}, this.animations = {}, this.data = data;
        const resource = this.baseTexture.resource;
        this.resolution = this._updateResolution(resolutionFilename || (resource ? resource.url : null)), this._frames = this.data.frames, this._frameKeys = Object.keys(this._frames), this._batchIndex = 0, this._callback = null;
    }
    /**
   * Generate the resolution from the filename or fallback
   * to the meta.scale field of the JSON data.
   * @param resolutionFilename - The filename to use for resolving
   *        the default resolution.
   * @returns Resolution to use for spritesheet.
   */ _updateResolution(resolutionFilename = null) {
        const { scale: scale } = this.data.meta;
        let resolution = (0, $29e19754806f3a05$exports).getResolutionOfUrl(resolutionFilename, null);
        return resolution === null && (resolution = parseFloat(scale ?? "1")), resolution !== 1 && this.baseTexture.setResolution(resolution), resolution;
    }
    /**
   * Parser spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   * @method PIXI.Spritesheet#parse
   */ parse() {
        return new Promise((resolve)=>{
            this._callback = resolve, this._batchIndex = 0, this._frameKeys.length <= _Spritesheet2.BATCH_SIZE ? (this._processFrames(0), this._processAnimations(), this._parseComplete()) : this._nextBatch();
        });
    }
    /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   */ _processFrames(initialFrameIndex) {
        let frameIndex = initialFrameIndex;
        const maxFrames = _Spritesheet2.BATCH_SIZE;
        for(; frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length;){
            const i = this._frameKeys[frameIndex], data = this._frames[i], rect = data.frame;
            if (rect) {
                let frame = null, trim = null;
                const sourceSize = data.trimmed !== !1 && data.sourceSize ? data.sourceSize : data.frame, orig = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(0, 0, Math.floor(sourceSize.w) / this.resolution, Math.floor(sourceSize.h) / this.resolution);
                data.rotated ? frame = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.h) / this.resolution, Math.floor(rect.w) / this.resolution) : frame = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution), data.trimmed !== !1 && data.spriteSourceSize && (trim = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(Math.floor(data.spriteSourceSize.x) / this.resolution, Math.floor(data.spriteSourceSize.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution)), this.textures[i] = new (0, $ad1fffd072a707c2$export$5431306cf43de24a)(this.baseTexture, frame, orig, trim, data.rotated ? 2 : 0, data.anchor, data.borders), (0, $ad1fffd072a707c2$export$5431306cf43de24a).addToCache(this.textures[i], i.toString());
            }
            frameIndex++;
        }
    }
    /** Parse animations config. */ _processAnimations() {
        const animations = this.data.animations || {};
        for(const animName in animations){
            this.animations[animName] = [];
            for(let i = 0; i < animations[animName].length; i++){
                const frameName = animations[animName][i];
                this.animations[animName].push(this.textures[frameName]);
            }
        }
    }
    /** The parse has completed. */ _parseComplete() {
        const callback = this._callback;
        this._callback = null, this._batchIndex = 0, callback.call(this, this.textures);
    }
    /** Begin the next batch of textures. */ _nextBatch() {
        this._processFrames(this._batchIndex * _Spritesheet2.BATCH_SIZE), this._batchIndex++, setTimeout(()=>{
            this._batchIndex * _Spritesheet2.BATCH_SIZE < this._frameKeys.length ? this._nextBatch() : (this._processAnimations(), this._parseComplete());
        }, 0);
    }
    /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */ destroy(destroyBase = !1) {
        for(const i in this.textures)this.textures[i].destroy();
        this._frames = null, this._frameKeys = null, this.data = null, this.textures = null, destroyBase && (this._texture?.destroy(), this.baseTexture.destroy()), this._texture = null, this.baseTexture = null, this.linkedSheets = [];
    }
};
$e61f93fc159e7ca6$var$_Spritesheet.BATCH_SIZE = 1e3;
let $e61f93fc159e7ca6$export$674d2eb4debbef0c = $e61f93fc159e7ca6$var$_Spritesheet;





const $0f51ee195926ac4f$var$validImages = [
    "jpg",
    "png",
    "jpeg",
    "avif",
    "webp"
];
function $0f51ee195926ac4f$var$getCacheableAssets(keys, asset, ignoreMultiPack) {
    const out = {};
    if (keys.forEach((key)=>{
        out[key] = asset;
    }), Object.keys(asset.textures).forEach((key)=>{
        out[key] = asset.textures[key];
    }), !ignoreMultiPack) {
        const basePath = (0, $29e19754806f3a05$exports).path.dirname(keys[0]);
        asset.linkedSheets.forEach((item, i)=>{
            const out2 = $0f51ee195926ac4f$var$getCacheableAssets([
                `${basePath}/${asset.data.meta.related_multi_packs[i]}`
            ], item, !0);
            Object.assign(out, out2);
        });
    }
    return out;
}
const $0f51ee195926ac4f$export$46dcda4f1cdd80fe = {
    extension: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).Asset,
    /** Handle the caching of the related Spritesheet Textures */ cache: {
        test: (asset)=>asset instanceof (0, $e61f93fc159e7ca6$export$674d2eb4debbef0c),
        getCacheableAssets: (keys, asset)=>$0f51ee195926ac4f$var$getCacheableAssets(keys, asset, !1)
    },
    /** Resolve the the resolution of the asset. */ resolver: {
        test: (value)=>{
            const split = value.split("?")[0].split("."), extension = split.pop(), format = split.pop();
            return extension === "json" && $0f51ee195926ac4f$var$validImages.includes(format);
        },
        parse: (value)=>{
            const split = value.split(".");
            return {
                resolution: parseFloat((0, $5340ccf8570d4063$export$a5a6e0b888b2c992).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
                format: split[split.length - 2],
                src: value
            };
        }
    },
    /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into PIXI.Spritesheet
   * All textures in the sprite sheet are then added to the cache
   * @ignore
   */ loader: {
        name: "spritesheetLoader",
        extension: {
            type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).LoadParser,
            priority: (0, $d0164a963de0e9b4$export$820ed6348c4f2750).Normal
        },
        async testParse (asset, options) {
            return (0, $29e19754806f3a05$exports).path.extname(options.src).toLowerCase() === ".json" && !!asset.frames;
        },
        async parse (asset, options, loader) {
            let basePath = (0, $29e19754806f3a05$exports).path.dirname(options.src);
            basePath && basePath.lastIndexOf("/") !== basePath.length - 1 && (basePath += "/");
            let imagePath = basePath + asset.meta.image;
            imagePath = (0, $a909d8f65000d92c$export$f57b97ef8be10dda)(imagePath, options.src);
            const texture = (await loader.load([
                imagePath
            ]))[imagePath], spritesheet = new (0, $e61f93fc159e7ca6$export$674d2eb4debbef0c)(texture.baseTexture, asset, options.src);
            await spritesheet.parse();
            const multiPacks = asset?.meta?.related_multi_packs;
            if (Array.isArray(multiPacks)) {
                const promises = [];
                for (const item of multiPacks){
                    if (typeof item != "string") continue;
                    let itemUrl = basePath + item;
                    options.data?.ignoreMultiPack || (itemUrl = (0, $a909d8f65000d92c$export$f57b97ef8be10dda)(itemUrl, options.src), promises.push(loader.load({
                        src: itemUrl,
                        data: {
                            ignoreMultiPack: !0
                        }
                    })));
                }
                const res = await Promise.all(promises);
                spritesheet.linkedSheets = res, res.forEach((item)=>{
                    item.linkedSheets = [
                        spritesheet
                    ].concat(spritesheet.linkedSheets.filter((sp)=>sp !== item));
                });
            }
            return spritesheet;
        },
        unload (spritesheet) {
            spritesheet.destroy(!0);
        }
    }
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($0f51ee195926ac4f$export$46dcda4f1cdd80fe);







class $23a8002c4fe0a425$export$2fb2a0e272ba703b {
    constructor(){
        this.info = [], this.common = [], this.page = [], this.char = [], this.kerning = [], this.distanceField = [];
    }
}



class $84e22c003f0f7a96$export$ff5bf922eba68a09 {
    /**
   * Check if resource refers to txt font data.
   * @param data
   * @returns - True if resource could be treated as font data, false otherwise.
   */ static test(data) {
        return typeof data == "string" && data.startsWith("info face=");
    }
    /**
   * Convert text font data to a javascript object.
   * @param txt - Raw string data to be converted
   * @returns - Parsed font data
   */ static parse(txt) {
        const items = txt.match(/^[a-z]+\s+.+$/gm), rawData = {
            info: [],
            common: [],
            page: [],
            char: [],
            chars: [],
            kerning: [],
            kernings: [],
            distanceField: []
        };
        for(const i in items){
            const name = items[i].match(/^[a-z]+/gm)[0], attributeList = items[i].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm), itemData = {};
            for(const i2 in attributeList){
                const split = attributeList[i2].split("="), key = split[0], strValue = split[1].replace(/"/gm, ""), floatValue = parseFloat(strValue), value = isNaN(floatValue) ? strValue : floatValue;
                itemData[key] = value;
            }
            rawData[name].push(itemData);
        }
        const font = new (0, $23a8002c4fe0a425$export$2fb2a0e272ba703b)();
        return rawData.info.forEach((info)=>font.info.push({
                face: info.face,
                size: parseInt(info.size, 10)
            })), rawData.common.forEach((common)=>font.common.push({
                lineHeight: parseInt(common.lineHeight, 10)
            })), rawData.page.forEach((page)=>font.page.push({
                id: parseInt(page.id, 10),
                file: page.file
            })), rawData.char.forEach((char)=>font.char.push({
                id: parseInt(char.id, 10),
                page: parseInt(char.page, 10),
                x: parseInt(char.x, 10),
                y: parseInt(char.y, 10),
                width: parseInt(char.width, 10),
                height: parseInt(char.height, 10),
                xoffset: parseInt(char.xoffset, 10),
                yoffset: parseInt(char.yoffset, 10),
                xadvance: parseInt(char.xadvance, 10)
            })), rawData.kerning.forEach((kerning)=>font.kerning.push({
                first: parseInt(kerning.first, 10),
                second: parseInt(kerning.second, 10),
                amount: parseInt(kerning.amount, 10)
            })), rawData.distanceField.forEach((df)=>font.distanceField.push({
                distanceRange: parseInt(df.distanceRange, 10),
                fieldType: df.fieldType
            })), font;
    }
}



class $c5c80c9244157ce3$export$4e1527335cae8d18 {
    /**
   * Check if resource refers to xml font data.
   * @param data
   * @returns - True if resource could be treated as font data, false otherwise.
   */ static test(data) {
        const xml = data;
        return typeof data != "string" && "getElementsByTagName" in data && xml.getElementsByTagName("page").length && xml.getElementsByTagName("info")[0].getAttribute("face") !== null;
    }
    /**
   * Convert the XML into BitmapFontData that we can use.
   * @param xml
   * @returns - Data to use for BitmapFont
   */ static parse(xml) {
        const data = new (0, $23a8002c4fe0a425$export$2fb2a0e272ba703b)(), info = xml.getElementsByTagName("info"), common = xml.getElementsByTagName("common"), page = xml.getElementsByTagName("page"), char = xml.getElementsByTagName("char"), kerning = xml.getElementsByTagName("kerning"), distanceField = xml.getElementsByTagName("distanceField");
        for(let i = 0; i < info.length; i++)data.info.push({
            face: info[i].getAttribute("face"),
            size: parseInt(info[i].getAttribute("size"), 10)
        });
        for(let i = 0; i < common.length; i++)data.common.push({
            lineHeight: parseInt(common[i].getAttribute("lineHeight"), 10)
        });
        for(let i = 0; i < page.length; i++)data.page.push({
            id: parseInt(page[i].getAttribute("id"), 10) || 0,
            file: page[i].getAttribute("file")
        });
        for(let i = 0; i < char.length; i++){
            const letter = char[i];
            data.char.push({
                id: parseInt(letter.getAttribute("id"), 10),
                page: parseInt(letter.getAttribute("page"), 10) || 0,
                x: parseInt(letter.getAttribute("x"), 10),
                y: parseInt(letter.getAttribute("y"), 10),
                width: parseInt(letter.getAttribute("width"), 10),
                height: parseInt(letter.getAttribute("height"), 10),
                xoffset: parseInt(letter.getAttribute("xoffset"), 10),
                yoffset: parseInt(letter.getAttribute("yoffset"), 10),
                xadvance: parseInt(letter.getAttribute("xadvance"), 10)
            });
        }
        for(let i = 0; i < kerning.length; i++)data.kerning.push({
            first: parseInt(kerning[i].getAttribute("first"), 10),
            second: parseInt(kerning[i].getAttribute("second"), 10),
            amount: parseInt(kerning[i].getAttribute("amount"), 10)
        });
        for(let i = 0; i < distanceField.length; i++)data.distanceField.push({
            fieldType: distanceField[i].getAttribute("fieldType"),
            distanceRange: parseInt(distanceField[i].getAttribute("distanceRange"), 10)
        });
        return data;
    }
}




class $27e747bf3387c31c$export$9322acbf234f5703 {
    /**
   * Check if resource refers to text xml font data.
   * @param data
   * @returns - True if resource could be treated as font data, false otherwise.
   */ static test(data) {
        return typeof data == "string" && data.includes("<font>") ? (0, $c5c80c9244157ce3$export$4e1527335cae8d18).test((0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.parseXML(data)) : !1;
    }
    /**
   * Convert the text XML into BitmapFontData that we can use.
   * @param xmlTxt
   * @returns - Data to use for BitmapFont
   */ static parse(xmlTxt) {
        return (0, $c5c80c9244157ce3$export$4e1527335cae8d18).parse((0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.parseXML(xmlTxt));
    }
}


const $3b593c10b702f86a$var$formats = [
    (0, $84e22c003f0f7a96$export$ff5bf922eba68a09),
    (0, $c5c80c9244157ce3$export$4e1527335cae8d18),
    (0, $27e747bf3387c31c$export$9322acbf234f5703)
];
function $3b593c10b702f86a$export$260d11d424c8eebd(data) {
    for(let i = 0; i < $3b593c10b702f86a$var$formats.length; i++)if ($3b593c10b702f86a$var$formats[i].test(data)) return $3b593c10b702f86a$var$formats[i];
    return null;
}




function $d74564093caad3fc$export$f6a80096f20930c(canvas, context, style, resolution, lines, metrics) {
    const fillStyle = style.fill;
    if (Array.isArray(fillStyle)) {
        if (fillStyle.length === 1) return fillStyle[0];
    } else return fillStyle;
    let gradient;
    const dropShadowCorrection = style.dropShadow ? style.dropShadowDistance : 0, padding = style.padding || 0, width = canvas.width / resolution - dropShadowCorrection - padding * 2, height = canvas.height / resolution - dropShadowCorrection - padding * 2, fill = fillStyle.slice(), fillGradientStops = style.fillGradientStops.slice();
    if (!fillGradientStops.length) {
        const lengthPlus1 = fill.length + 1;
        for(let i = 1; i < lengthPlus1; ++i)fillGradientStops.push(i / lengthPlus1);
    }
    if (fill.unshift(fillStyle[0]), fillGradientStops.unshift(0), fill.push(fillStyle[fillStyle.length - 1]), fillGradientStops.push(1), style.fillGradientType === (0, $db11ad4206a572b4$export$131daa784848984).LINEAR_VERTICAL) {
        gradient = context.createLinearGradient(width / 2, padding, width / 2, height + padding);
        let lastIterationStop = 0;
        const gradStopLineHeight = (metrics.fontProperties.fontSize + style.strokeThickness) / height;
        for(let i = 0; i < lines.length; i++){
            const thisLineTop = metrics.lineHeight * i;
            for(let j = 0; j < fill.length; j++){
                let lineStop = 0;
                typeof fillGradientStops[j] == "number" ? lineStop = fillGradientStops[j] : lineStop = j / fill.length;
                const globalStop = thisLineTop / height + lineStop * gradStopLineHeight;
                let clampedStop = Math.max(lastIterationStop, globalStop);
                clampedStop = Math.min(clampedStop, 1), gradient.addColorStop(clampedStop, fill[j]), lastIterationStop = clampedStop;
            }
        }
    } else {
        gradient = context.createLinearGradient(padding, height / 2, width + padding, height / 2);
        const totalIterations = fill.length + 1;
        let currentIteration = 1;
        for(let i = 0; i < fill.length; i++){
            let stop;
            typeof fillGradientStops[i] == "number" ? stop = fillGradientStops[i] : stop = currentIteration / totalIterations, gradient.addColorStop(stop, fill[i]), currentIteration++;
        }
    }
    return gradient;
}


function $2b80fd7db5dc4cf7$export$d41775f6694ba493(canvas, context, metrics, x, y, resolution, style) {
    const char = metrics.text, fontProperties = metrics.fontProperties;
    context.translate(x, y), context.scale(resolution, resolution);
    const tx = style.strokeThickness / 2, ty = -(style.strokeThickness / 2);
    if (context.font = style.toFontString(), context.lineWidth = style.strokeThickness, context.textBaseline = style.textBaseline, context.lineJoin = style.lineJoin, context.miterLimit = style.miterLimit, context.fillStyle = (0, $d74564093caad3fc$export$f6a80096f20930c)(canvas, context, style, resolution, [
        char
    ], metrics), context.strokeStyle = style.stroke, style.dropShadow) {
        const dropShadowColor = style.dropShadowColor, dropShadowBlur = style.dropShadowBlur * resolution, dropShadowDistance = style.dropShadowDistance * resolution;
        context.shadowColor = (0, $3119899e085d9ccf$export$892596cec99bc70e).shared.setValue(dropShadowColor).setAlpha(style.dropShadowAlpha).toRgbaString(), context.shadowBlur = dropShadowBlur, context.shadowOffsetX = Math.cos(style.dropShadowAngle) * dropShadowDistance, context.shadowOffsetY = Math.sin(style.dropShadowAngle) * dropShadowDistance;
    } else context.shadowColor = "black", context.shadowBlur = 0, context.shadowOffsetX = 0, context.shadowOffsetY = 0;
    style.stroke && style.strokeThickness && context.strokeText(char, tx, ty + metrics.lineHeight - fontProperties.descent), style.fill && context.fillText(char, tx, ty + metrics.lineHeight - fontProperties.descent), context.setTransform(1, 0, 0, 1, 0, 0), context.fillStyle = "rgba(0, 0, 0, 0)";
}


function $b2c066f2e241b8b2$export$ee42a04f33018f4b(str) {
    return str.codePointAt ? str.codePointAt(0) : str.charCodeAt(0);
}



function $4f88b90df2fa602a$export$b2c801ee49e0a334(text) {
    return Array.from ? Array.from(text) : text.split("");
}


function $4020225e3cdba5ec$export$221291e5031b03d8(chars) {
    typeof chars == "string" && (chars = [
        chars
    ]);
    const result = [];
    for(let i = 0, j = chars.length; i < j; i++){
        const item = chars[i];
        if (Array.isArray(item)) {
            if (item.length !== 2) throw new Error(`[BitmapFont]: Invalid character range length, expecting 2 got ${item.length}.`);
            const startCode = item[0].charCodeAt(0), endCode = item[1].charCodeAt(0);
            if (endCode < startCode) throw new Error("[BitmapFont]: Invalid character range.");
            for(let i2 = startCode, j2 = endCode; i2 <= j2; i2++)result.push(String.fromCharCode(i2));
        } else result.push(...(0, $4f88b90df2fa602a$export$b2c801ee49e0a334)(item));
    }
    if (result.length === 0) throw new Error("[BitmapFont]: Empty set when resolving characters.");
    return result;
}








const $c74b315148ca8ba9$var$_BitmapFont = class _BitmapFont2 {
    /**
   * @param data
   * @param textures
   * @param ownsTextures - Setting to `true` will destroy page textures
   *        when the font is uninstalled.
   */ constructor(data, textures, ownsTextures){
        const [info] = data.info, [common] = data.common, [page] = data.page, [distanceField] = data.distanceField, res = (0, $29e19754806f3a05$exports).getResolutionOfUrl(page.file), pageTextures = {};
        this._ownsTextures = ownsTextures, this.font = info.face, this.size = info.size, this.lineHeight = common.lineHeight / res, this.chars = {}, this.pageTextures = pageTextures;
        for(let i = 0; i < data.page.length; i++){
            const { id: id, file: file } = data.page[i];
            pageTextures[id] = textures instanceof Array ? textures[i] : textures[file], distanceField?.fieldType && distanceField.fieldType !== "none" && (pageTextures[id].baseTexture.alphaMode = (0, $5912637ee8cf8b9f$export$d56550d454401b73).NO_PREMULTIPLIED_ALPHA, pageTextures[id].baseTexture.mipmap = (0, $5912637ee8cf8b9f$export$16f6fb5da874bbfd).OFF);
        }
        for(let i = 0; i < data.char.length; i++){
            const { id: id, page: page2 } = data.char[i];
            let { x: x, y: y, width: width, height: height, xoffset: xoffset, yoffset: yoffset, xadvance: xadvance } = data.char[i];
            x /= res, y /= res, width /= res, height /= res, xoffset /= res, yoffset /= res, xadvance /= res;
            const rect = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(x + pageTextures[page2].frame.x / res, y + pageTextures[page2].frame.y / res, width, height);
            this.chars[id] = {
                xOffset: xoffset,
                yOffset: yoffset,
                xAdvance: xadvance,
                kerning: {},
                texture: new (0, $ad1fffd072a707c2$export$5431306cf43de24a)(pageTextures[page2].baseTexture, rect),
                page: page2
            };
        }
        for(let i = 0; i < data.kerning.length; i++){
            let { first: first, second: second, amount: amount } = data.kerning[i];
            first /= res, second /= res, amount /= res, this.chars[second] && (this.chars[second].kerning[first] = amount);
        }
        this.distanceFieldRange = distanceField?.distanceRange, this.distanceFieldType = distanceField?.fieldType?.toLowerCase() ?? "none";
    }
    /** Remove references to created glyph textures. */ destroy() {
        for(const id in this.chars)this.chars[id].texture.destroy(), this.chars[id].texture = null;
        for(const id in this.pageTextures)this._ownsTextures && this.pageTextures[id].destroy(!0), this.pageTextures[id] = null;
        this.chars = null, this.pageTextures = null;
    }
    /**
   * Register a new bitmap font.
   * @param data - The
   *        characters map that could be provided as xml or raw string.
   * @param textures - List of textures for each page.
   * @param ownsTextures - Set to `true` to destroy page textures
   *        when the font is uninstalled. By default fonts created with
   *        `BitmapFont.from` or from the `BitmapFontLoader` are `true`.
   * @returns {PIXI.BitmapFont} Result font object with font, size, lineHeight
   *         and char fields.
   */ static install(data, textures, ownsTextures) {
        let fontData;
        if (data instanceof (0, $23a8002c4fe0a425$export$2fb2a0e272ba703b)) fontData = data;
        else {
            const format = (0, $3b593c10b702f86a$export$260d11d424c8eebd)(data);
            if (!format) throw new Error("Unrecognized data format for font.");
            fontData = format.parse(data);
        }
        textures instanceof (0, $ad1fffd072a707c2$export$5431306cf43de24a) && (textures = [
            textures
        ]);
        const font = new _BitmapFont2(fontData, textures, ownsTextures);
        return _BitmapFont2.available[font.font] = font, font;
    }
    /**
   * Remove bitmap font by name.
   * @param name - Name of the font to uninstall.
   */ static uninstall(name) {
        const font = _BitmapFont2.available[name];
        if (!font) throw new Error(`No font found named '${name}'`);
        font.destroy(), delete _BitmapFont2.available[name];
    }
    /**
   * Generates a bitmap-font for the given style and character set. This does not support
   * kernings yet. With `style` properties, only the following non-layout properties are used:
   *
   * - {@link PIXI.TextStyle#dropShadow|dropShadow}
   * - {@link PIXI.TextStyle#dropShadowDistance|dropShadowDistance}
   * - {@link PIXI.TextStyle#dropShadowColor|dropShadowColor}
   * - {@link PIXI.TextStyle#dropShadowBlur|dropShadowBlur}
   * - {@link PIXI.TextStyle#dropShadowAngle|dropShadowAngle}
   * - {@link PIXI.TextStyle#fill|fill}
   * - {@link PIXI.TextStyle#fillGradientStops|fillGradientStops}
   * - {@link PIXI.TextStyle#fillGradientType|fillGradientType}
   * - {@link PIXI.TextStyle#fontFamily|fontFamily}
   * - {@link PIXI.TextStyle#fontSize|fontSize}
   * - {@link PIXI.TextStyle#fontVariant|fontVariant}
   * - {@link PIXI.TextStyle#fontWeight|fontWeight}
   * - {@link PIXI.TextStyle#lineJoin|lineJoin}
   * - {@link PIXI.TextStyle#miterLimit|miterLimit}
   * - {@link PIXI.TextStyle#stroke|stroke}
   * - {@link PIXI.TextStyle#strokeThickness|strokeThickness}
   * - {@link PIXI.TextStyle#textBaseline|textBaseline}
   * @param name - The name of the custom font to use with BitmapText.
   * @param textStyle - Style options to render with BitmapFont.
   * @param options - Setup options for font or name of the font.
   * @returns Font generated by style options.
   * @example
   * import { BitmapFont, BitmapText } from 'pixi.js';
   *
   * BitmapFont.from('TitleFont', {
   *     fontFamily: 'Arial',
   *     fontSize: 12,
   *     strokeThickness: 2,
   *     fill: 'purple',
   * });
   *
   * const title = new BitmapText('This is the title', { fontName: 'TitleFont' });
   */ static from(name, textStyle, options) {
        if (!name) throw new Error("[BitmapFont] Property `name` is required.");
        const { chars: chars, padding: padding, resolution: resolution, textureWidth: textureWidth, textureHeight: textureHeight, ...baseOptions } = Object.assign({}, _BitmapFont2.defaultOptions, options), charsList = (0, $4020225e3cdba5ec$export$221291e5031b03d8)(chars), style = textStyle instanceof (0, $95ce52d18dddb804$export$1df879243bf2e42d) ? textStyle : new (0, $95ce52d18dddb804$export$1df879243bf2e42d)(textStyle), lineWidth = textureWidth, fontData = new (0, $23a8002c4fe0a425$export$2fb2a0e272ba703b)();
        fontData.info[0] = {
            face: style.fontFamily,
            size: style.fontSize
        }, fontData.common[0] = {
            lineHeight: style.fontSize
        };
        let positionX = 0, positionY = 0, canvas, context, baseTexture, maxCharHeight = 0;
        const baseTextures = [], textures = [];
        for(let i = 0; i < charsList.length; i++){
            canvas || (canvas = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.createCanvas(), canvas.width = textureWidth, canvas.height = textureHeight, context = canvas.getContext("2d"), baseTexture = new (0, $997b0e421c4045eb$export$d6306e508f184154)(canvas, {
                resolution: resolution,
                ...baseOptions
            }), baseTextures.push(baseTexture), textures.push(new (0, $ad1fffd072a707c2$export$5431306cf43de24a)(baseTexture)), fontData.page.push({
                id: textures.length - 1,
                file: ""
            }));
            const character = charsList[i], metrics = (0, $a3232095b7fc32d6$export$4c5a129a59e1ef34).measureText(character, style, !1, canvas), width = metrics.width, height = Math.ceil(metrics.height), textureGlyphWidth = Math.ceil((style.fontStyle === "italic" ? 2 : 1) * width);
            if (positionY >= textureHeight - height * resolution) {
                if (positionY === 0) throw new Error(`[BitmapFont] textureHeight ${textureHeight}px is too small (fontFamily: '${style.fontFamily}', fontSize: ${style.fontSize}px, char: '${character}')`);
                --i, canvas = null, context = null, baseTexture = null, positionY = 0, positionX = 0, maxCharHeight = 0;
                continue;
            }
            if (maxCharHeight = Math.max(height + metrics.fontProperties.descent, maxCharHeight), textureGlyphWidth * resolution + positionX >= lineWidth) {
                if (positionX === 0) throw new Error(`[BitmapFont] textureWidth ${textureWidth}px is too small (fontFamily: '${style.fontFamily}', fontSize: ${style.fontSize}px, char: '${character}')`);
                --i, positionY += maxCharHeight * resolution, positionY = Math.ceil(positionY), positionX = 0, maxCharHeight = 0;
                continue;
            }
            (0, $2b80fd7db5dc4cf7$export$d41775f6694ba493)(canvas, context, metrics, positionX, positionY, resolution, style);
            const id = (0, $b2c066f2e241b8b2$export$ee42a04f33018f4b)(metrics.text);
            fontData.char.push({
                id: id,
                page: textures.length - 1,
                x: positionX / resolution,
                y: positionY / resolution,
                width: textureGlyphWidth,
                height: height,
                xoffset: 0,
                yoffset: 0,
                xadvance: width - (style.dropShadow ? style.dropShadowDistance : 0) - (style.stroke ? style.strokeThickness : 0)
            }), positionX += (textureGlyphWidth + 2 * padding) * resolution, positionX = Math.ceil(positionX);
        }
        if (!options?.skipKerning) for(let i = 0, len = charsList.length; i < len; i++){
            const first = charsList[i];
            for(let j = 0; j < len; j++){
                const second = charsList[j], c1 = context.measureText(first).width, c2 = context.measureText(second).width, amount = context.measureText(first + second).width - (c1 + c2);
                amount && fontData.kerning.push({
                    first: (0, $b2c066f2e241b8b2$export$ee42a04f33018f4b)(first),
                    second: (0, $b2c066f2e241b8b2$export$ee42a04f33018f4b)(second),
                    amount: amount
                });
            }
        }
        const font = new _BitmapFont2(fontData, textures, !0);
        return _BitmapFont2.available[name] !== void 0 && _BitmapFont2.uninstall(name), _BitmapFont2.available[name] = font, font;
    }
};
$c74b315148ca8ba9$var$_BitmapFont.ALPHA = [
    [
        "a",
        "z"
    ],
    [
        "A",
        "Z"
    ],
    " "
], /**
* This character set includes all decimal digits (from 0 to 9).
* @type {string[][]}
* @example
* BitmapFont.from('ExampleFont', style, { chars: BitmapFont.NUMERIC })
*/ $c74b315148ca8ba9$var$_BitmapFont.NUMERIC = [
    [
        "0",
        "9"
    ]
], /**
* This character set is the union of `BitmapFont.ALPHA` and `BitmapFont.NUMERIC`.
* @type {string[][]}
*/ $c74b315148ca8ba9$var$_BitmapFont.ALPHANUMERIC = [
    [
        "a",
        "z"
    ],
    [
        "A",
        "Z"
    ],
    [
        "0",
        "9"
    ],
    " "
], /**
* This character set consists of all the ASCII table.
* @member {string[][]}
* @see http://www.asciitable.com/
*/ $c74b315148ca8ba9$var$_BitmapFont.ASCII = [
    [
        " ",
        "~"
    ]
], /**
* Collection of default options when using `BitmapFont.from`.
* @property {number} [resolution=1] -
* @property {number} [textureWidth=512] -
* @property {number} [textureHeight=512] -
* @property {number} [padding=4] -
* @property {string|string[]|string[][]} chars = PIXI.BitmapFont.ALPHANUMERIC
*/ $c74b315148ca8ba9$var$_BitmapFont.defaultOptions = {
    resolution: 1,
    textureWidth: 512,
    textureHeight: 512,
    padding: 4,
    chars: $c74b315148ca8ba9$var$_BitmapFont.ALPHANUMERIC
}, /** Collection of available/installed fonts. */ $c74b315148ca8ba9$var$_BitmapFont.available = {};
let $c74b315148ca8ba9$export$17957a09927cadc7 = $c74b315148ca8ba9$var$_BitmapFont;







var $51fc188d68987379$export$2e2bcd8739ae039 = `// Pixi texture info\r
varying vec2 vTextureCoord;\r
uniform sampler2D uSampler;\r
\r
// Tint\r
uniform vec4 uColor;\r
\r
// on 2D applications fwidth is screenScale / glyphAtlasScale * distanceFieldRange\r
uniform float uFWidth;\r
\r
void main(void) {\r
\r
  // To stack MSDF and SDF we need a non-pre-multiplied-alpha texture.\r
  vec4 texColor = texture2D(uSampler, vTextureCoord);\r
\r
  // MSDF\r
  float median = texColor.r + texColor.g + texColor.b -\r
                  min(texColor.r, min(texColor.g, texColor.b)) -\r
                  max(texColor.r, max(texColor.g, texColor.b));\r
  // SDF\r
  median = min(median, texColor.a);\r
\r
  float screenPxDistance = uFWidth * (median - 0.5);\r
  float alpha = clamp(screenPxDistance + 0.5, 0.0, 1.0);\r
  if (median < 0.01) {\r
    alpha = 0.0;\r
  } else if (median > 0.99) {\r
    alpha = 1.0;\r
  }\r
\r
  // Gamma correction for coverage-like alpha\r
  float luma = dot(uColor.rgb, vec3(0.299, 0.587, 0.114));\r
  float gamma = mix(1.0, 1.0 / 2.2, luma);\r
  float coverage = pow(uColor.a * alpha, gamma);  \r
\r
  // NPM Textures, NPM outputs\r
  gl_FragColor = vec4(uColor.rgb, coverage);\r
}\r
`;


var $b654ebbe81584b6d$export$2e2bcd8739ae039 = `// Mesh material default fragment\r
attribute vec2 aVertexPosition;\r
attribute vec2 aTextureCoord;\r
\r
uniform mat3 projectionMatrix;\r
uniform mat3 translationMatrix;\r
uniform mat3 uTextureMatrix;\r
\r
varying vec2 vTextureCoord;\r
\r
void main(void)\r
{\r
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\r
\r
    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;\r
}\r
`;





const $1fbbc2534b095e89$var$pageMeshDataDefaultPageMeshData = [], $1fbbc2534b095e89$var$pageMeshDataMSDFPageMeshData = [], $1fbbc2534b095e89$var$charRenderDataPool = [], $1fbbc2534b095e89$var$_BitmapText = class _BitmapText2 extends (0, $3878067a77b781d9$export$42a852a2b6b56249) {
    /**
   * @param text - A string that you would like the text to display.
   * @param style - The style parameters.
   * @param {string} style.fontName - The installed BitmapFont name.
   * @param {number} [style.fontSize] - The size of the font in pixels, e.g. 24. If undefined,
   *.     this will default to the BitmapFont size.
   * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center', 'right' or 'justify'),
   *      does not affect single line text.
   * @param {PIXI.ColorSource} [style.tint=0xFFFFFF] - The tint color.
   * @param {number} [style.letterSpacing=0] - The amount of spacing between letters.
   * @param {number} [style.maxWidth=0] - The max width of the text before line wrapping.
   */ constructor(text, style = {}){
        super();
        const { align: align, tint: tint, maxWidth: maxWidth, letterSpacing: letterSpacing, fontName: fontName, fontSize: fontSize } = Object.assign({}, _BitmapText2.styleDefaults, style);
        if (!(0, $c74b315148ca8ba9$export$17957a09927cadc7).available[fontName]) throw new Error(`Missing BitmapFont "${fontName}"`);
        this._activePagesMeshData = [], this._textWidth = 0, this._textHeight = 0, this._align = align, this._tintColor = new (0, $3119899e085d9ccf$export$892596cec99bc70e)(tint), this._font = void 0, this._fontName = fontName, this._fontSize = fontSize, this.text = text, this._maxWidth = maxWidth, this._maxLineHeight = 0, this._letterSpacing = letterSpacing, this._anchor = new (0, $0c68ac15ddf7471c$export$3755aaad3fd42e52)(()=>{
            this.dirty = !0;
        }, this, 0, 0), this._roundPixels = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ROUND_PIXELS, this.dirty = !0, this._resolution = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).RESOLUTION, this._autoResolution = !0, this._textureCache = {};
    }
    /** Renders text and updates it when needed. This should only be called if the BitmapFont is regenerated. */ updateText() {
        const data = (0, $c74b315148ca8ba9$export$17957a09927cadc7).available[this._fontName], fontSize = this.fontSize, scale = fontSize / data.size, pos = new (0, $c283a5532acdbe2e$export$baf26146a414f24a)(), chars = [], lineWidths = [], lineSpaces = [], text = this._text.replace(/(?:\r\n|\r)/g, `
`) || " ", charsInput = (0, $4f88b90df2fa602a$export$b2c801ee49e0a334)(text), maxWidth = this._maxWidth * data.size / fontSize, pageMeshDataPool = data.distanceFieldType === "none" ? $1fbbc2534b095e89$var$pageMeshDataDefaultPageMeshData : $1fbbc2534b095e89$var$pageMeshDataMSDFPageMeshData;
        let prevCharCode = null, lastLineWidth = 0, maxLineWidth = 0, line = 0, lastBreakPos = -1, lastBreakWidth = 0, spacesRemoved = 0, maxLineHeight = 0, spaceCount = 0;
        for(let i = 0; i < charsInput.length; i++){
            const char = charsInput[i], charCode = (0, $b2c066f2e241b8b2$export$ee42a04f33018f4b)(char);
            if (/(?:\s)/.test(char) && (lastBreakPos = i, lastBreakWidth = lastLineWidth, spaceCount++), char === "\r" || char === `
`) {
                lineWidths.push(lastLineWidth), lineSpaces.push(-1), maxLineWidth = Math.max(maxLineWidth, lastLineWidth), ++line, ++spacesRemoved, pos.x = 0, pos.y += data.lineHeight, prevCharCode = null, spaceCount = 0;
                continue;
            }
            const charData = data.chars[charCode];
            if (!charData) continue;
            prevCharCode && charData.kerning[prevCharCode] && (pos.x += charData.kerning[prevCharCode]);
            const charRenderData = $1fbbc2534b095e89$var$charRenderDataPool.pop() || {
                texture: (0, $ad1fffd072a707c2$export$5431306cf43de24a).EMPTY,
                line: 0,
                charCode: 0,
                prevSpaces: 0,
                position: new (0, $c283a5532acdbe2e$export$baf26146a414f24a)()
            };
            charRenderData.texture = charData.texture, charRenderData.line = line, charRenderData.charCode = charCode, charRenderData.position.x = Math.round(pos.x + charData.xOffset + this._letterSpacing / 2), charRenderData.position.y = Math.round(pos.y + charData.yOffset), charRenderData.prevSpaces = spaceCount, chars.push(charRenderData), lastLineWidth = charRenderData.position.x + Math.max(charData.xAdvance - charData.xOffset, charData.texture.orig.width), pos.x += charData.xAdvance + this._letterSpacing, maxLineHeight = Math.max(maxLineHeight, charData.yOffset + charData.texture.height), prevCharCode = charCode, lastBreakPos !== -1 && maxWidth > 0 && pos.x > maxWidth && (++spacesRemoved, (0, $29e19754806f3a05$exports).removeItems(chars, 1 + lastBreakPos - spacesRemoved, 1 + i - lastBreakPos), i = lastBreakPos, lastBreakPos = -1, lineWidths.push(lastBreakWidth), lineSpaces.push(chars.length > 0 ? chars[chars.length - 1].prevSpaces : 0), maxLineWidth = Math.max(maxLineWidth, lastBreakWidth), line++, pos.x = 0, pos.y += data.lineHeight, prevCharCode = null, spaceCount = 0);
        }
        const lastChar = charsInput[charsInput.length - 1];
        lastChar !== "\r" && lastChar !== `
` && (/(?:\s)/.test(lastChar) && (lastLineWidth = lastBreakWidth), lineWidths.push(lastLineWidth), maxLineWidth = Math.max(maxLineWidth, lastLineWidth), lineSpaces.push(-1));
        const lineAlignOffsets = [];
        for(let i = 0; i <= line; i++){
            let alignOffset = 0;
            this._align === "right" ? alignOffset = maxLineWidth - lineWidths[i] : this._align === "center" ? alignOffset = (maxLineWidth - lineWidths[i]) / 2 : this._align === "justify" && (alignOffset = lineSpaces[i] < 0 ? 0 : (maxLineWidth - lineWidths[i]) / lineSpaces[i]), lineAlignOffsets.push(alignOffset);
        }
        const lenChars = chars.length, pagesMeshData = {}, newPagesMeshData = [], activePagesMeshData = this._activePagesMeshData;
        pageMeshDataPool.push(...activePagesMeshData);
        for(let i = 0; i < lenChars; i++){
            const texture = chars[i].texture, baseTextureUid = texture.baseTexture.uid;
            if (!pagesMeshData[baseTextureUid]) {
                let pageMeshData = pageMeshDataPool.pop();
                if (!pageMeshData) {
                    const geometry = new (0, $1acafc55b3767469$export$8d075a36a73d54bc)();
                    let material, meshBlendMode;
                    data.distanceFieldType === "none" ? (material = new (0, $7b5a5666c23f04ad$export$d552dadfd66cc650)((0, $ad1fffd072a707c2$export$5431306cf43de24a).EMPTY), meshBlendMode = (0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).NORMAL) : (material = new (0, $7b5a5666c23f04ad$export$d552dadfd66cc650)((0, $ad1fffd072a707c2$export$5431306cf43de24a).EMPTY, {
                        program: (0, $529286cda46872bb$export$b6c59b989905b650).from((0, $b654ebbe81584b6d$export$2e2bcd8739ae039), (0, $51fc188d68987379$export$2e2bcd8739ae039)),
                        uniforms: {
                            uFWidth: 0
                        }
                    }), meshBlendMode = (0, $5912637ee8cf8b9f$export$f821c68fe9beaecf).NORMAL_NPM);
                    const mesh = new (0, $64c4acb8821d317d$export$e176487c05830cc5)(geometry, material);
                    mesh.blendMode = meshBlendMode, pageMeshData = {
                        index: 0,
                        indexCount: 0,
                        vertexCount: 0,
                        uvsCount: 0,
                        total: 0,
                        mesh: mesh,
                        vertices: null,
                        uvs: null,
                        indices: null
                    };
                }
                pageMeshData.index = 0, pageMeshData.indexCount = 0, pageMeshData.vertexCount = 0, pageMeshData.uvsCount = 0, pageMeshData.total = 0;
                const { _textureCache: _textureCache } = this;
                _textureCache[baseTextureUid] = _textureCache[baseTextureUid] || new (0, $ad1fffd072a707c2$export$5431306cf43de24a)(texture.baseTexture), pageMeshData.mesh.texture = _textureCache[baseTextureUid], pageMeshData.mesh.tint = this._tintColor.value, newPagesMeshData.push(pageMeshData), pagesMeshData[baseTextureUid] = pageMeshData;
            }
            pagesMeshData[baseTextureUid].total++;
        }
        for(let i = 0; i < activePagesMeshData.length; i++)newPagesMeshData.includes(activePagesMeshData[i]) || this.removeChild(activePagesMeshData[i].mesh);
        for(let i = 0; i < newPagesMeshData.length; i++)newPagesMeshData[i].mesh.parent !== this && this.addChild(newPagesMeshData[i].mesh);
        this._activePagesMeshData = newPagesMeshData;
        for(const i in pagesMeshData){
            const pageMeshData = pagesMeshData[i], total = pageMeshData.total;
            if (!(pageMeshData.indices?.length > 6 * total) || pageMeshData.vertices.length < (0, $64c4acb8821d317d$export$e176487c05830cc5).BATCHABLE_SIZE * 2) pageMeshData.vertices = new Float32Array(8 * total), pageMeshData.uvs = new Float32Array(8 * total), pageMeshData.indices = new Uint16Array(6 * total);
            else {
                const total2 = pageMeshData.total, vertices = pageMeshData.vertices;
                for(let i2 = total2 * 8; i2 < vertices.length; i2++)vertices[i2] = 0;
            }
            pageMeshData.mesh.size = 6 * total;
        }
        for(let i = 0; i < lenChars; i++){
            const char = chars[i];
            let offset = char.position.x + lineAlignOffsets[char.line] * (this._align === "justify" ? char.prevSpaces : 1);
            this._roundPixels && (offset = Math.round(offset));
            const xPos = offset * scale, yPos = char.position.y * scale, texture = char.texture, pageMesh = pagesMeshData[texture.baseTexture.uid], textureFrame = texture.frame, textureUvs = texture._uvs, index = pageMesh.index++;
            pageMesh.indices[index * 6 + 0] = 0 + index * 4, pageMesh.indices[index * 6 + 1] = 1 + index * 4, pageMesh.indices[index * 6 + 2] = 2 + index * 4, pageMesh.indices[index * 6 + 3] = 0 + index * 4, pageMesh.indices[index * 6 + 4] = 2 + index * 4, pageMesh.indices[index * 6 + 5] = 3 + index * 4, pageMesh.vertices[index * 8 + 0] = xPos, pageMesh.vertices[index * 8 + 1] = yPos, pageMesh.vertices[index * 8 + 2] = xPos + textureFrame.width * scale, pageMesh.vertices[index * 8 + 3] = yPos, pageMesh.vertices[index * 8 + 4] = xPos + textureFrame.width * scale, pageMesh.vertices[index * 8 + 5] = yPos + textureFrame.height * scale, pageMesh.vertices[index * 8 + 6] = xPos, pageMesh.vertices[index * 8 + 7] = yPos + textureFrame.height * scale, pageMesh.uvs[index * 8 + 0] = textureUvs.x0, pageMesh.uvs[index * 8 + 1] = textureUvs.y0, pageMesh.uvs[index * 8 + 2] = textureUvs.x1, pageMesh.uvs[index * 8 + 3] = textureUvs.y1, pageMesh.uvs[index * 8 + 4] = textureUvs.x2, pageMesh.uvs[index * 8 + 5] = textureUvs.y2, pageMesh.uvs[index * 8 + 6] = textureUvs.x3, pageMesh.uvs[index * 8 + 7] = textureUvs.y3;
        }
        this._textWidth = maxLineWidth * scale, this._textHeight = (pos.y + data.lineHeight) * scale;
        for(const i in pagesMeshData){
            const pageMeshData = pagesMeshData[i];
            if (this.anchor.x !== 0 || this.anchor.y !== 0) {
                let vertexCount = 0;
                const anchorOffsetX = this._textWidth * this.anchor.x, anchorOffsetY = this._textHeight * this.anchor.y;
                for(let i2 = 0; i2 < pageMeshData.total; i2++)pageMeshData.vertices[vertexCount++] -= anchorOffsetX, pageMeshData.vertices[vertexCount++] -= anchorOffsetY, pageMeshData.vertices[vertexCount++] -= anchorOffsetX, pageMeshData.vertices[vertexCount++] -= anchorOffsetY, pageMeshData.vertices[vertexCount++] -= anchorOffsetX, pageMeshData.vertices[vertexCount++] -= anchorOffsetY, pageMeshData.vertices[vertexCount++] -= anchorOffsetX, pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
            }
            this._maxLineHeight = maxLineHeight * scale;
            const vertexBuffer = pageMeshData.mesh.geometry.getBuffer("aVertexPosition"), textureBuffer = pageMeshData.mesh.geometry.getBuffer("aTextureCoord"), indexBuffer = pageMeshData.mesh.geometry.getIndex();
            vertexBuffer.data = pageMeshData.vertices, textureBuffer.data = pageMeshData.uvs, indexBuffer.data = pageMeshData.indices, vertexBuffer.update(), textureBuffer.update(), indexBuffer.update();
        }
        for(let i = 0; i < chars.length; i++)$1fbbc2534b095e89$var$charRenderDataPool.push(chars[i]);
        this._font = data, this.dirty = !1;
    }
    updateTransform() {
        this.validate(), this.containerUpdateTransform();
    }
    _render(renderer) {
        this._autoResolution && this._resolution !== renderer.resolution && (this._resolution = renderer.resolution, this.dirty = !0);
        const { distanceFieldRange: distanceFieldRange, distanceFieldType: distanceFieldType, size: size } = (0, $c74b315148ca8ba9$export$17957a09927cadc7).available[this._fontName];
        if (distanceFieldType !== "none") {
            const { a: a, b: b, c: c, d: d } = this.worldTransform, dx = Math.sqrt(a * a + b * b), dy = Math.sqrt(c * c + d * d), worldScale = (Math.abs(dx) + Math.abs(dy)) / 2, fontScale = this.fontSize / size, resolution = renderer._view.resolution;
            for (const mesh of this._activePagesMeshData)mesh.mesh.shader.uniforms.uFWidth = worldScale * distanceFieldRange * fontScale * resolution;
        }
        super._render(renderer);
    }
    /**
   * Validates text before calling parent's getLocalBounds
   * @returns - The rectangular bounding area
   */ getLocalBounds() {
        return this.validate(), super.getLocalBounds();
    }
    /**
   * Updates text when needed
   * @private
   */ validate() {
        const font = (0, $c74b315148ca8ba9$export$17957a09927cadc7).available[this._fontName];
        if (!font) throw new Error(`Missing BitmapFont "${this._fontName}"`);
        this._font !== font && (this.dirty = !0), this.dirty && this.updateText();
    }
    /**
   * The tint of the BitmapText object.
   * @default 0xffffff
   */ get tint() {
        return this._tintColor.value;
    }
    set tint(value) {
        if (this.tint !== value) {
            this._tintColor.setValue(value);
            for(let i = 0; i < this._activePagesMeshData.length; i++)this._activePagesMeshData[i].mesh.tint = value;
        }
    }
    /**
   * The alignment of the BitmapText object.
   * @member {string}
   * @default 'left'
   */ get align() {
        return this._align;
    }
    set align(value) {
        this._align !== value && (this._align = value, this.dirty = !0);
    }
    /** The name of the BitmapFont. */ get fontName() {
        return this._fontName;
    }
    set fontName(value) {
        if (!(0, $c74b315148ca8ba9$export$17957a09927cadc7).available[value]) throw new Error(`Missing BitmapFont "${value}"`);
        this._fontName !== value && (this._fontName = value, this.dirty = !0);
    }
    /** The size of the font to display. */ get fontSize() {
        return this._fontSize ?? (0, $c74b315148ca8ba9$export$17957a09927cadc7).available[this._fontName].size;
    }
    set fontSize(value) {
        this._fontSize !== value && (this._fontSize = value, this.dirty = !0);
    }
    /**
   * The anchor sets the origin point of the text.
   *
   * The default is `(0,0)`, this means the text's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the text's origin is centered.
   *
   * Setting the anchor to `(1,1)` would mean the text's origin point will be the bottom right corner.
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value == "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /** The text of the BitmapText object. */ get text() {
        return this._text;
    }
    set text(text) {
        text = String(text ?? ""), this._text !== text && (this._text = text, this.dirty = !0);
    }
    /**
   * The max width of this bitmap text in pixels. If the text provided is longer than the
   * value provided, line breaks will be automatically inserted in the last whitespace.
   * Disable by setting the value to 0.
   */ get maxWidth() {
        return this._maxWidth;
    }
    set maxWidth(value) {
        this._maxWidth !== value && (this._maxWidth = value, this.dirty = !0);
    }
    /**
   * The max line height. This is useful when trying to use the total height of the Text,
   * i.e. when trying to vertically align.
   * @readonly
   */ get maxLineHeight() {
        return this.validate(), this._maxLineHeight;
    }
    /**
   * The width of the overall text, different from fontSize,
   * which is defined in the style object.
   * @readonly
   */ get textWidth() {
        return this.validate(), this._textWidth;
    }
    /** Additional space between characters. */ get letterSpacing() {
        return this._letterSpacing;
    }
    set letterSpacing(value) {
        this._letterSpacing !== value && (this._letterSpacing = value, this.dirty = !0);
    }
    /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
   * @default PIXI.settings.ROUND_PIXELS
   */ get roundPixels() {
        return this._roundPixels;
    }
    set roundPixels(value) {
        value !== this._roundPixels && (this._roundPixels = value, this.dirty = !0);
    }
    /**
   * The height of the overall text, different from fontSize,
   * which is defined in the style object.
   * @readonly
   */ get textHeight() {
        return this.validate(), this._textHeight;
    }
    /**
   * The resolution / device pixel ratio of the canvas.
   *
   * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
   * @default 1
   */ get resolution() {
        return this._resolution;
    }
    set resolution(value) {
        this._autoResolution = !1, this._resolution !== value && (this._resolution = value, this.dirty = !0);
    }
    destroy(options) {
        const { _textureCache: _textureCache } = this, pageMeshDataPool = (0, $c74b315148ca8ba9$export$17957a09927cadc7).available[this._fontName].distanceFieldType === "none" ? $1fbbc2534b095e89$var$pageMeshDataDefaultPageMeshData : $1fbbc2534b095e89$var$pageMeshDataMSDFPageMeshData;
        pageMeshDataPool.push(...this._activePagesMeshData);
        for (const pageMeshData of this._activePagesMeshData)this.removeChild(pageMeshData.mesh);
        this._activePagesMeshData = [], pageMeshDataPool.filter((page)=>_textureCache[page.mesh.texture.baseTexture.uid]).forEach((page)=>{
            page.mesh.texture = (0, $ad1fffd072a707c2$export$5431306cf43de24a).EMPTY;
        });
        for(const id in _textureCache)_textureCache[id].destroy(), delete _textureCache[id];
        this._font = null, this._tintColor = null, this._textureCache = null, super.destroy(options);
    }
};
$1fbbc2534b095e89$var$_BitmapText.styleDefaults = {
    align: "left",
    tint: 16777215,
    maxWidth: 0,
    letterSpacing: 0
};
let $1fbbc2534b095e89$export$ae0da96467efdba0 = $1fbbc2534b095e89$var$_BitmapText;











const $9d687afeb9ae6b5e$var$validExtensions = [
    ".xml",
    ".fnt"
], $9d687afeb9ae6b5e$export$402edee29ac8bed4 = {
    extension: {
        type: (0, $69f9a88446c99188$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $d0164a963de0e9b4$export$820ed6348c4f2750).Normal
    },
    name: "loadBitmapFont",
    test (url) {
        return $9d687afeb9ae6b5e$var$validExtensions.includes((0, $29e19754806f3a05$exports).path.extname(url).toLowerCase());
    },
    async testParse (data) {
        return (0, $84e22c003f0f7a96$export$ff5bf922eba68a09).test(data) || (0, $27e747bf3387c31c$export$9322acbf234f5703).test(data);
    },
    async parse (asset, data, loader) {
        const fontData = (0, $84e22c003f0f7a96$export$ff5bf922eba68a09).test(asset) ? (0, $84e22c003f0f7a96$export$ff5bf922eba68a09).parse(asset) : (0, $27e747bf3387c31c$export$9322acbf234f5703).parse(asset), { src: src } = data, { page: pages } = fontData, textureUrls = [];
        for(let i = 0; i < pages.length; ++i){
            const pageFile = pages[i].file;
            let imagePath = (0, $29e19754806f3a05$exports).path.join((0, $29e19754806f3a05$exports).path.dirname(src), pageFile);
            imagePath = (0, $a909d8f65000d92c$export$f57b97ef8be10dda)(imagePath, src), textureUrls.push(imagePath);
        }
        const loadedTextures = await loader.load(textureUrls), textures = textureUrls.map((url)=>loadedTextures[url]);
        return (0, $c74b315148ca8ba9$export$17957a09927cadc7).install(fontData, textures, !0);
    },
    async load (url, _options) {
        return (await (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.fetch(url)).text();
    },
    unload (bitmapFont) {
        bitmapFont.destroy();
    }
};
(0, $69f9a88446c99188$export$cc3e2d3244e01b7f).add($9d687afeb9ae6b5e$export$402edee29ac8bed4);












const $8041040552e1a27e$var$_HTMLTextStyle = class _HTMLTextStyle2 extends (0, $95ce52d18dddb804$export$1df879243bf2e42d) {
    constructor(){
        super(...arguments), this._fonts = [], this._overrides = [], this._stylesheet = "", this.fontsDirty = !1;
    }
    /**
   * Convert a TextStyle to HTMLTextStyle
   * @param originalStyle
   * @example
   * import {TextStyle } from 'pixi.js';
   * import {HTMLTextStyle} from '@pixi/text-html';
   * const style = new TextStyle();
   * const htmlStyle = HTMLTextStyle.from(style);
   */ static from(originalStyle) {
        return new _HTMLTextStyle2(Object.keys(_HTMLTextStyle2.defaultOptions).reduce((obj, prop)=>({
                ...obj,
                [prop]: originalStyle[prop]
            }), {}));
    }
    /** Clear the current font */ cleanFonts() {
        this._fonts.length > 0 && (this._fonts.forEach((font)=>{
            URL.revokeObjectURL(font.src), font.refs--, font.refs === 0 && (font.fontFace && document.fonts.delete(font.fontFace), delete _HTMLTextStyle2.availableFonts[font.originalUrl]);
        }), this.fontFamily = "Arial", this._fonts.length = 0, this.styleID++, this.fontsDirty = !0);
    }
    /**
   * Because of how HTMLText renders, fonts need to be imported
   * @param url
   * @param options
   */ loadFont(url, options = {}) {
        const { availableFonts: availableFonts } = _HTMLTextStyle2;
        if (availableFonts[url]) {
            const font = availableFonts[url];
            return this._fonts.push(font), font.refs++, this.styleID++, this.fontsDirty = !0, Promise.resolve();
        }
        return (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.fetch(url).then((response)=>response.blob()).then(async (blob)=>new Promise((resolve, reject)=>{
                const src = URL.createObjectURL(blob), reader = new FileReader();
                reader.onload = ()=>resolve([
                        src,
                        reader.result
                    ]), reader.onerror = reject, reader.readAsDataURL(blob);
            })).then(async ([src, dataSrc])=>{
            const font = Object.assign({
                family: (0, $29e19754806f3a05$exports).path.basename(url, (0, $29e19754806f3a05$exports).path.extname(url)),
                weight: "normal",
                style: "normal",
                display: "auto",
                src: src,
                dataSrc: dataSrc,
                refs: 1,
                originalUrl: url,
                fontFace: null
            }, options);
            availableFonts[url] = font, this._fonts.push(font), this.styleID++;
            const fontFace = new FontFace(font.family, `url(${font.src})`, {
                weight: font.weight,
                style: font.style,
                display: font.display
            });
            font.fontFace = fontFace, await fontFace.load(), document.fonts.add(fontFace), await document.fonts.ready, this.styleID++, this.fontsDirty = !0;
        });
    }
    /**
   * Add a style override, this can be any CSS property
   * it will override any built-in style. This is the
   * property and the value as a string (e.g., `color: red`).
   * This will override any other internal style.
   * @param {string} value - CSS style(s) to add.
   * @example
   * style.addOverride('background-color: red');
   */ addOverride(...value) {
        const toAdd = value.filter((v)=>!this._overrides.includes(v));
        toAdd.length > 0 && (this._overrides.push(...toAdd), this.styleID++);
    }
    /**
   * Remove any overrides that match the value.
   * @param {string} value - CSS style to remove.
   * @example
   * style.removeOverride('background-color: red');
   */ removeOverride(...value) {
        const toRemove = value.filter((v)=>this._overrides.includes(v));
        toRemove.length > 0 && (this._overrides = this._overrides.filter((v)=>!toRemove.includes(v)), this.styleID++);
    }
    /**
   * Internally converts all of the style properties into CSS equivalents.
   * @param scale
   * @returns The CSS style string, for setting `style` property of root HTMLElement.
   */ toCSS(scale) {
        return [
            `transform: scale(${scale})`,
            "transform-origin: top left",
            "display: inline-block",
            `color: ${this.normalizeColor(this.fill)}`,
            `font-size: ${this.fontSize}px`,
            `font-family: ${this.fontFamily}`,
            `font-weight: ${this.fontWeight}`,
            `font-style: ${this.fontStyle}`,
            `font-variant: ${this.fontVariant}`,
            `letter-spacing: ${this.letterSpacing}px`,
            `text-align: ${this.align}`,
            `padding: ${this.padding}px`,
            `white-space: ${this.whiteSpace}`,
            ...this.lineHeight ? [
                `line-height: ${this.lineHeight}px`
            ] : [],
            ...this.wordWrap ? [
                `word-wrap: ${this.breakWords ? "break-all" : "break-word"}`,
                `max-width: ${this.wordWrapWidth}px`
            ] : [],
            ...this.strokeThickness ? [
                `-webkit-text-stroke-width: ${this.strokeThickness}px`,
                `-webkit-text-stroke-color: ${this.normalizeColor(this.stroke)}`,
                `text-stroke-width: ${this.strokeThickness}px`,
                `text-stroke-color: ${this.normalizeColor(this.stroke)}`,
                "paint-order: stroke"
            ] : [],
            ...this.dropShadow ? [
                this.dropShadowToCSS()
            ] : [],
            ...this._overrides
        ].join(";");
    }
    /** Get the font CSS styles from the loaded font, If available. */ toGlobalCSS() {
        return this._fonts.reduce((result, font)=>`${result}
            @font-face {
                font-family: "${font.family}";
                src: url('${font.dataSrc}');
                font-weight: ${font.weight};
                font-style: ${font.style};
                font-display: ${font.display};
            }`, this._stylesheet);
    }
    /** Internal stylesheet contents, useful for creating rules for rendering */ get stylesheet() {
        return this._stylesheet;
    }
    set stylesheet(value) {
        this._stylesheet !== value && (this._stylesheet = value, this.styleID++);
    }
    /**
   * Convert numerical colors into hex-strings
   * @param color
   */ normalizeColor(color) {
        return Array.isArray(color) && (color = (0, $29e19754806f3a05$exports).rgb2hex(color)), typeof color == "number" ? (0, $29e19754806f3a05$exports).hex2string(color) : color;
    }
    /** Convert the internal drop-shadow settings to CSS text-shadow */ dropShadowToCSS() {
        let color = this.normalizeColor(this.dropShadowColor);
        const alpha = this.dropShadowAlpha, x = Math.round(Math.cos(this.dropShadowAngle) * this.dropShadowDistance), y = Math.round(Math.sin(this.dropShadowAngle) * this.dropShadowDistance);
        color.startsWith("#") && alpha < 1 && (color += (alpha * 255 | 0).toString(16).padStart(2, "0"));
        const position = `${x}px ${y}px`;
        return this.dropShadowBlur > 0 ? `text-shadow: ${position} ${this.dropShadowBlur}px ${color}` : `text-shadow: ${position} ${color}`;
    }
    /** Resets all properties to the defaults specified in TextStyle.prototype._default */ reset() {
        Object.assign(this, _HTMLTextStyle2.defaultOptions);
    }
    /**
   * Called after the image is loaded but before drawing to the canvas.
   * Mostly used to handle Safari's font loading bug.
   * @ignore
   */ onBeforeDraw() {
        const { fontsDirty: prevFontsDirty } = this;
        return this.fontsDirty = !1, this.isSafari && this._fonts.length > 0 && prevFontsDirty ? new Promise((resolve)=>setTimeout(resolve, 100)) : Promise.resolve();
    }
    /**
   * Proving that Safari is the new IE
   * @ignore
   */ get isSafari() {
        const { userAgent: userAgent } = (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).ADAPTER.getNavigator();
        return /^((?!chrome|android).)*safari/i.test(userAgent);
    }
    set fillGradientStops(_value) {
        console.warn("[HTMLTextStyle] fillGradientStops is not supported by HTMLText");
    }
    get fillGradientStops() {
        return super.fillGradientStops;
    }
    set fillGradientType(_value) {
        console.warn("[HTMLTextStyle] fillGradientType is not supported by HTMLText");
    }
    get fillGradientType() {
        return super.fillGradientType;
    }
    set miterLimit(_value) {
        console.warn("[HTMLTextStyle] miterLimit is not supported by HTMLText");
    }
    get miterLimit() {
        return super.miterLimit;
    }
    set trim(_value) {
        console.warn("[HTMLTextStyle] trim is not supported by HTMLText");
    }
    get trim() {
        return super.trim;
    }
    set textBaseline(_value) {
        console.warn("[HTMLTextStyle] textBaseline is not supported by HTMLText");
    }
    get textBaseline() {
        return super.textBaseline;
    }
    set leading(_value) {
        console.warn("[HTMLTextStyle] leading is not supported by HTMLText");
    }
    get leading() {
        return super.leading;
    }
    set lineJoin(_value) {
        console.warn("[HTMLTextStyle] lineJoin is not supported by HTMLText");
    }
    get lineJoin() {
        return super.lineJoin;
    }
};
$8041040552e1a27e$var$_HTMLTextStyle.availableFonts = {}, /**
* List of default options, these are largely the same as TextStyle,
* with the exception of whiteSpace, which is set to 'normal' by default.
*/ $8041040552e1a27e$var$_HTMLTextStyle.defaultOptions = {
    /** Align */ align: "left",
    /** Break words */ breakWords: !1,
    /** Drop shadow */ dropShadow: !1,
    /** Drop shadow alpha */ dropShadowAlpha: 1,
    /**
   * Drop shadow angle
   * @type {number}
   * @default Math.PI / 6
   */ dropShadowAngle: Math.PI / 6,
    /** Drop shadow blur */ dropShadowBlur: 0,
    /** Drop shadow color */ dropShadowColor: "black",
    /** Drop shadow distance */ dropShadowDistance: 5,
    /** Fill */ fill: "black",
    /** Font family */ fontFamily: "Arial",
    /** Font size */ fontSize: 26,
    /** Font style */ fontStyle: "normal",
    /** Font variant */ fontVariant: "normal",
    /** Font weight */ fontWeight: "normal",
    /** Letter spacing */ letterSpacing: 0,
    /** Line height */ lineHeight: 0,
    /** Padding */ padding: 0,
    /** Stroke */ stroke: "black",
    /** Stroke thickness */ strokeThickness: 0,
    /** White space */ whiteSpace: "normal",
    /** Word wrap */ wordWrap: !1,
    /** Word wrap width */ wordWrapWidth: 100
};
let $8041040552e1a27e$export$a2664b42ece43c6c = $8041040552e1a27e$var$_HTMLTextStyle;


const $9615addd3a9282d3$var$_HTMLText = class _HTMLText2 extends (0, $f092bed24e72671b$export$3075603db8e6204c) {
    /**
   * @param {string} [text] - Text contents
   * @param {PIXI.HTMLTextStyle|PIXI.TextStyle|PIXI.ITextStyle} [style] - Style setting to use.
   *        Strongly recommend using an HTMLTextStyle object. Providing a PIXI.TextStyle
   *        will convert the TextStyle to an HTMLTextStyle and will no longer be linked.
   */ constructor(text = "", style = {}){
        super((0, $ad1fffd072a707c2$export$5431306cf43de24a).EMPTY), this._text = null, this._style = null, this._autoResolution = !0, this.localStyleID = -1, this.dirty = !1, this._updateID = 0, this.ownsStyle = !1;
        const image = new Image(), texture = (0, $ad1fffd072a707c2$export$5431306cf43de24a).from(image, {
            scaleMode: (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).SCALE_MODE,
            resourceOptions: {
                autoLoad: !1
            }
        });
        texture.orig = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(), texture.trim = new (0, $92248a7cf1facbda$export$4617fb02663045ef)(), this.texture = texture;
        const nssvg = "http://www.w3.org/2000/svg", nsxhtml = "http://www.w3.org/1999/xhtml", svgRoot = document.createElementNS(nssvg, "svg"), foreignObject = document.createElementNS(nssvg, "foreignObject"), domElement = document.createElementNS(nsxhtml, "div"), styleElement = document.createElementNS(nsxhtml, "style");
        foreignObject.setAttribute("width", "10000"), foreignObject.setAttribute("height", "10000"), foreignObject.style.overflow = "hidden", svgRoot.appendChild(foreignObject), this.maxWidth = _HTMLText2.defaultMaxWidth, this.maxHeight = _HTMLText2.defaultMaxHeight, this._domElement = domElement, this._styleElement = styleElement, this._svgRoot = svgRoot, this._foreignObject = foreignObject, this._foreignObject.appendChild(styleElement), this._foreignObject.appendChild(domElement), this._image = image, this._loadImage = new Image(), this._autoResolution = _HTMLText2.defaultAutoResolution, this._resolution = _HTMLText2.defaultResolution ?? (0, $5340ccf8570d4063$export$a5a6e0b888b2c992).RESOLUTION, this.text = text, this.style = style;
    }
    /**
   * Calculate the size of the output text without actually drawing it.
   * This includes the `padding` in the `style` object.
   * This can be used as a fast-pass to do things like text-fitting.
   * @param {object} [overrides] - Overrides for the text, style, and resolution.
   * @param {string} [overrides.text] - The text to measure, if not specified, the current text is used.
   * @param {PIXI.HTMLTextStyle} [overrides.style] - The style to measure, if not specified, the current style is used.
   * @param {number} [overrides.resolution] - The resolution to measure, if not specified, the current resolution is used.
   * @returns {PIXI.ISize} Width and height of the measured text.
   */ measureText(overrides) {
        const { text: text, style: style, resolution: resolution } = Object.assign({
            text: this._text,
            style: this._style,
            resolution: this._resolution
        }, overrides);
        Object.assign(this._domElement, {
            innerHTML: text,
            style: style.toCSS(resolution)
        }), this._styleElement.textContent = style.toGlobalCSS(), document.body.appendChild(this._svgRoot);
        const contentBounds = this._domElement.getBoundingClientRect();
        this._svgRoot.remove();
        const { width: width, height: height } = contentBounds;
        (width > this.maxWidth || height > this.maxHeight) && console.warn("[HTMLText] Large expanse of text, increase HTMLText.maxWidth or HTMLText.maxHeight property.");
        const contentWidth = Math.min(this.maxWidth, Math.ceil(width)), contentHeight = Math.min(this.maxHeight, Math.ceil(height));
        return this._svgRoot.setAttribute("width", contentWidth.toString()), this._svgRoot.setAttribute("height", contentHeight.toString()), text !== this._text && (this._domElement.innerHTML = this._text), style !== this._style && (Object.assign(this._domElement, {
            style: this._style?.toCSS(resolution)
        }), this._styleElement.textContent = this._style?.toGlobalCSS()), {
            width: contentWidth + style.padding * 2,
            height: contentHeight + style.padding * 2
        };
    }
    /**
   * Manually refresh the text.
   * @public
   * @param {boolean} respectDirty - Whether to abort updating the
   *        text if the Text isn't dirty and the function is called.
   */ async updateText(respectDirty = !0) {
        const { style: style, _image: image, _loadImage: loadImage } = this;
        if (this.localStyleID !== style.styleID && (this.dirty = !0, this.localStyleID = style.styleID), !this.dirty && respectDirty) return;
        const { width: width, height: height } = this.measureText();
        image.width = loadImage.width = Math.ceil(Math.max(1, width)), image.height = loadImage.height = Math.ceil(Math.max(1, height)), this._updateID++;
        const updateID = this._updateID;
        await new Promise((resolve)=>{
            loadImage.onload = async ()=>{
                if (updateID < this._updateID) {
                    resolve();
                    return;
                }
                await style.onBeforeDraw(), image.src = loadImage.src, loadImage.onload = null, loadImage.src = "", this.updateTexture(), resolve();
            };
            const svgURL = new XMLSerializer().serializeToString(this._svgRoot);
            loadImage.src = `data:image/svg+xml;charset=utf8,${encodeURIComponent(svgURL)}`;
        });
    }
    /** The raw image element that is rendered under-the-hood. */ get source() {
        return this._image;
    }
    /**
   * Update the texture resource.
   * @private
   */ updateTexture() {
        const { style: style, texture: texture, _image: image, resolution: resolution } = this, { padding: padding } = style, { baseTexture: baseTexture } = texture;
        texture.trim.width = texture._frame.width = image.width / resolution, texture.trim.height = texture._frame.height = image.height / resolution, texture.trim.x = -padding, texture.trim.y = -padding, texture.orig.width = texture._frame.width - padding * 2, texture.orig.height = texture._frame.height - padding * 2, this._onTextureUpdate(), baseTexture.setRealSize(image.width, image.height, resolution), this.dirty = !1;
    }
    /**
   * Renders the object using the WebGL renderer
   * @param {PIXI.Renderer} renderer - The renderer
   * @private
   */ _render(renderer) {
        this._autoResolution && this._resolution !== renderer.resolution && (this._resolution = renderer.resolution, this.dirty = !0), this.updateText(!0), super._render(renderer);
    }
    /**
   * Renders the object using the Canvas Renderer.
   * @private
   * @param {PIXI.CanvasRenderer} renderer - The renderer
   */ _renderCanvas(renderer) {
        this._autoResolution && this._resolution !== renderer.resolution && (this._resolution = renderer.resolution, this.dirty = !0), this.updateText(!0), super._renderCanvas(renderer);
    }
    /**
   * Get the local bounds.
   * @param {PIXI.Rectangle} rect - Input rectangle.
   * @returns {PIXI.Rectangle} Local bounds
   */ getLocalBounds(rect) {
        return this.updateText(!0), super.getLocalBounds(rect);
    }
    _calculateBounds() {
        this.updateText(!0), this.calculateVertices(), this._bounds.addQuad(this.vertexData);
    }
    /**
   * Handle dirty style changes
   * @private
   */ _onStyleChange() {
        this.dirty = !0;
    }
    /**
   * Destroy this Text object. Don't use after calling.
   * @param {boolean|object} options - Same as Sprite destroy options.
   */ destroy(options) {
        typeof options == "boolean" && (options = {
            children: options
        }), options = Object.assign({}, _HTMLText2.defaultDestroyOptions, options), super.destroy(options);
        const forceClear = null;
        this.ownsStyle && this._style?.cleanFonts(), this._style = forceClear, this._svgRoot?.remove(), this._svgRoot = forceClear, this._domElement?.remove(), this._domElement = forceClear, this._foreignObject?.remove(), this._foreignObject = forceClear, this._styleElement?.remove(), this._styleElement = forceClear, this._loadImage.src = "", this._loadImage.onload = null, this._loadImage = forceClear, this._image.src = "", this._image = forceClear;
    }
    /**
   * Get the width in pixels.
   * @member {number}
   */ get width() {
        return this.updateText(!0), Math.abs(this.scale.x) * this._image.width / this.resolution;
    }
    set width(value) {
        this.updateText(!0);
        const s = (0, $29e19754806f3a05$exports).sign(this.scale.x) || 1;
        this.scale.x = s * value / this._image.width / this.resolution, this._width = value;
    }
    /**
   * Get the height in pixels.
   * @member {number}
   */ get height() {
        return this.updateText(!0), Math.abs(this.scale.y) * this._image.height / this.resolution;
    }
    set height(value) {
        this.updateText(!0);
        const s = (0, $29e19754806f3a05$exports).sign(this.scale.y) || 1;
        this.scale.y = s * value / this._image.height / this.resolution, this._height = value;
    }
    /** The base style to render with text. */ get style() {
        return this._style;
    }
    set style(style) {
        this._style !== style && (style = style || {}, style instanceof (0, $8041040552e1a27e$export$a2664b42ece43c6c) ? (this.ownsStyle = !1, this._style = style) : style instanceof (0, $95ce52d18dddb804$export$1df879243bf2e42d) ? (console.warn("[HTMLText] Cloning TextStyle, if this is not what you want, use HTMLTextStyle"), this.ownsStyle = !0, this._style = (0, $8041040552e1a27e$export$a2664b42ece43c6c).from(style)) : (this.ownsStyle = !0, this._style = new (0, $8041040552e1a27e$export$a2664b42ece43c6c)(style)), this.localStyleID = -1, this.dirty = !0);
    }
    /**
   * Contents of text. This can be HTML text and include tags.
   * @example
   * const text = new HTMLText('This is a <em>styled</em> text!');
   * @member {string}
   */ get text() {
        return this._text;
    }
    set text(text) {
        text = String(text === "" || text === null || text === void 0 ? " " : text), text = this.sanitiseText(text), this._text !== text && (this._text = text, this.dirty = !0);
    }
    /**
   * The resolution / device pixel ratio of the canvas.
   * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
   * @member {number}
   * @default 1
   */ get resolution() {
        return this._resolution;
    }
    set resolution(value) {
        this._autoResolution = !1, this._resolution !== value && (this._resolution = value, this.dirty = !0);
    }
    /**
   * Sanitise text - replace `<br>` with `<br/>`, `&nbsp;` with `&#160;`
   * @param text
   * @see https://www.sitepoint.com/community/t/xhtml-1-0-transitional-xml-parsing-error-entity-nbsp-not-defined/3392/3
   */ sanitiseText(text) {
        return text.replace(/<br>/gi, "<br/>").replace(/<hr>/gi, "<hr/>").replace(/&nbsp;/gi, "&#160;");
    }
};
$9615addd3a9282d3$var$_HTMLText.defaultDestroyOptions = {
    texture: !0,
    children: !1,
    baseTexture: !0
}, /** Default maxWidth, set at construction */ $9615addd3a9282d3$var$_HTMLText.defaultMaxWidth = 2024, /** Default maxHeight, set at construction */ $9615addd3a9282d3$var$_HTMLText.defaultMaxHeight = 2024, /** Default autoResolution for all HTMLText objects */ $9615addd3a9282d3$var$_HTMLText.defaultAutoResolution = !0;
let $9615addd3a9282d3$export$4b42bbc5a42896a1 = $9615addd3a9282d3$var$_HTMLText;







class $c749fe39302942ca$var$Numeric {
    static round(value, precision) {
        const factor = 10 ** precision;
        return Math.round(value * factor) / factor;
    }
}
var $c749fe39302942ca$export$2e2bcd8739ae039 = $c749fe39302942ca$var$Numeric;



const $55488263fdb1fe72$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $55488263fdb1fe72$export$2e2bcd8739ae039 = {
    randomUUID: $55488263fdb1fe72$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $ed20e420fc5d378a$var$getRandomValues;
const $ed20e420fc5d378a$var$rnds8 = new Uint8Array(16);
function $ed20e420fc5d378a$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$ed20e420fc5d378a$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $ed20e420fc5d378a$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$ed20e420fc5d378a$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $ed20e420fc5d378a$var$getRandomValues($ed20e420fc5d378a$var$rnds8);
}


var $eb9c5708e9f20c98$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $5ad0553e5f3f58d9$var$validate(uuid) {
    return typeof uuid === "string" && (0, $eb9c5708e9f20c98$export$2e2bcd8739ae039).test(uuid);
}
var $5ad0553e5f3f58d9$export$2e2bcd8739ae039 = $5ad0553e5f3f58d9$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $186bd17d8b95de91$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$186bd17d8b95de91$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $186bd17d8b95de91$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $186bd17d8b95de91$var$byteToHex[arr[offset + 0]] + $186bd17d8b95de91$var$byteToHex[arr[offset + 1]] + $186bd17d8b95de91$var$byteToHex[arr[offset + 2]] + $186bd17d8b95de91$var$byteToHex[arr[offset + 3]] + "-" + $186bd17d8b95de91$var$byteToHex[arr[offset + 4]] + $186bd17d8b95de91$var$byteToHex[arr[offset + 5]] + "-" + $186bd17d8b95de91$var$byteToHex[arr[offset + 6]] + $186bd17d8b95de91$var$byteToHex[arr[offset + 7]] + "-" + $186bd17d8b95de91$var$byteToHex[arr[offset + 8]] + $186bd17d8b95de91$var$byteToHex[arr[offset + 9]] + "-" + $186bd17d8b95de91$var$byteToHex[arr[offset + 10]] + $186bd17d8b95de91$var$byteToHex[arr[offset + 11]] + $186bd17d8b95de91$var$byteToHex[arr[offset + 12]] + $186bd17d8b95de91$var$byteToHex[arr[offset + 13]] + $186bd17d8b95de91$var$byteToHex[arr[offset + 14]] + $186bd17d8b95de91$var$byteToHex[arr[offset + 15]];
}
function $186bd17d8b95de91$var$stringify(arr, offset = 0) {
    const uuid = $186bd17d8b95de91$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $5ad0553e5f3f58d9$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $186bd17d8b95de91$export$2e2bcd8739ae039 = $186bd17d8b95de91$var$stringify;


function $abbd070778bb526c$var$v4(options, buf, offset) {
    if ((0, $55488263fdb1fe72$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $55488263fdb1fe72$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $ed20e420fc5d378a$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $186bd17d8b95de91$export$8fb373d660548968)(rnds);
}
var $abbd070778bb526c$export$2e2bcd8739ae039 = $abbd070778bb526c$var$v4;


class $170ef886b9fe1618$export$2e2bcd8739ae039 {
    id = (0, $abbd070778bb526c$export$2e2bcd8739ae039)();
    type = "shape";
    container = new $3878067a77b781d9$export$42a852a2b6b56249();
    // mainly used to trigger control update
    modifiedAt = 0;
    tags = [];
    name = "";
    constructor(type, params){
        this.type = type || "shape";
        this.tags = params.tags || [];
        this.name = params.name || "";
        this.serialize = this.serialize.bind(this);
        this.draw = this.draw.bind(this);
        this.onPrecisionChange = this.onPrecisionChange.bind(this);
        this.move = this.move.bind(this);
        this.destroy = this.destroy.bind(this);
        this.container.eventMode = "static";
        this.container.data = this // ! Note: inject data to container
        ;
    }
    draw() {
        throw new Error(`'draw' must be overridden`);
    }
    onPrecisionChange(precision) {
        throw new Error(`'onPrecisionChange' must be overridden`);
    }
    move(x, y) {
        throw new Error(`'move' must be overridden`);
    }
    /**
   * ! Note: do not use a Container after calling destroy
   */ destroy(children = false) {
        this.container.destroy({
            children: children
        });
        delete this.container.data;
    }
    serialize() {
        return {
            type: this.type,
            tags: this.tags,
            name: this.name
        };
    }
}


class $af6c0ee5e13a9ec0$var$Circle extends (0, $170ef886b9fe1618$export$2e2bcd8739ae039) {
    constructor(params){
        super("circle", params);
        this._graphics = new $d21713afb1bb29fd$export$29d3e417456abdad();
        this._graphics.alpha = 0.25;
        this.container.addChild(this._graphics);
        this.x = params.x || 0;
        this.y = params.y || 0;
        this.radius = params.radius || 0;
    }
    static parse(params) {
        return new $af6c0ee5e13a9ec0$var$Circle(params);
    }
    draw = ()=>{
        this._graphics.clear().lineStyle(0) // without outline
        .beginFill(0xFF0000, 1).drawCircle(0, 0, this.radius || 0).endFill();
        this.container.position.set(this.x, this.y);
        return this;
    };
    onPrecisionChange = (precision)=>{
        this.x = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(this.x, precision);
        this.y = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(this.y, precision);
        this.radius = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(this.radius, precision);
        this.modifiedAt = Date.now();
    };
    destroy = (children)=>{
        super.destroy(children);
        if (!children) this._graphics.destroy();
    };
    serialize = ()=>{
        return {
            ...super.serialize(),
            x: this.x,
            y: this.y,
            radius: this.radius
        };
    };
}
var $af6c0ee5e13a9ec0$export$2e2bcd8739ae039 = $af6c0ee5e13a9ec0$var$Circle;





class $1331010475b0a998$var$Ellipse extends (0, $170ef886b9fe1618$export$2e2bcd8739ae039) {
    constructor(params){
        super("ellipse", params);
        this._graphics = new $d21713afb1bb29fd$export$29d3e417456abdad();
        this._graphics.alpha = 0.25;
        this.container.addChild(this._graphics);
        this.x = params.x || 0;
        this.y = params.y || 0;
        this.width = params.width || 0;
        this.height = params.height || 0;
    }
    static parse(params) {
        return new $1331010475b0a998$var$Ellipse(params);
    }
    draw = ()=>{
        this._graphics.clear().lineStyle(0) // without outline
        .beginFill(0xFF0000, 1).drawEllipse(0, 0, this.width, this.height).endFill();
        this.container.position.set(this.x, this.y);
        return this;
    };
    onPrecisionChange = (precision)=>{
        this.x = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(this.x, precision);
        this.y = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(this.y, precision);
        this.width = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(this.width, precision);
        this.height = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(this.height, precision);
        this.modifiedAt = Date.now();
    };
    destroy = (children)=>{
        super.destroy(children);
        if (!children) this._graphics.destroy();
    };
    serialize = ()=>{
        return {
            ...super.serialize(),
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    };
}
var $1331010475b0a998$export$2e2bcd8739ae039 = $1331010475b0a998$var$Ellipse;






/**
 * a point, a few lines, or a polygon
 */ class $ccee98958081e0ad$var$Customized extends (0, $170ef886b9fe1618$export$2e2bcd8739ae039) {
    constructor(params){
        super("customized", params);
        this._graphics = new $d21713afb1bb29fd$export$29d3e417456abdad();
        this._graphics.alpha = 0.25;
        this.container.addChild(this._graphics);
        this.points = params.points?.map((p)=>({
                id: (0, $abbd070778bb526c$export$2e2bcd8739ae039)(),
                x: p.x || 0,
                y: p.y || 0
            })) || [];
        this.isClose = params.isClose || true;
    }
    static parse(params) {
        return new $ccee98958081e0ad$var$Customized(params);
    }
    addPoint = (x, y)=>{
        this.points.push({
            id: (0, $abbd070778bb526c$export$2e2bcd8739ae039)(),
            x: x,
            y: y
        });
        this.modifiedAt = Date.now();
    };
    removePoint = (id)=>{
        this.points = this.points.filter((p)=>p.id !== id);
        this.modifiedAt = Date.now();
    };
    swapPoint = (aIdx, bIdx)=>{
        if (aIdx === bIdx) return;
        const tmp = this.points[aIdx];
        this.points[aIdx] = this.points[bIdx];
        this.points[bIdx] = tmp;
        this.modifiedAt = Date.now();
    };
    draw = ()=>{
        this._graphics.clear();
        if (this.isClose) {
            if (this.points.length <= 2) this._graphics.lineStyle(0.5, 0xFF0000, 1);
            this._graphics.beginFill(0xFF0000, 1);
        } else this._graphics.lineStyle(0.5, 0xFF0000, 1);
        for(let i = 0; i < this.points.length; i++){
            const p = this.points[i];
            if (i === 0) this._graphics.moveTo(p.x, p.y);
            else this._graphics.lineTo(p.x, p.y);
        }
        if (this.isClose) {
            if (this.points.length > 2) this._graphics.closePath();
            this._graphics.endFill();
        }
        return this;
    };
    onPrecisionChange = (precision)=>{
        this.points = this.points.map((p)=>({
                id: p.id,
                x: (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(p.x, precision),
                y: (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(p.y, precision)
            }));
        this.modifiedAt = Date.now();
    };
    destroy = (children)=>{
        super.destroy(children);
        if (!children) this._graphics.destroy();
    };
    serialize = ()=>{
        return {
            ...super.serialize(),
            points: this.points.map((p)=>({
                    x: p.x,
                    y: p.y
                })),
            isClose: this.isClose
        };
    };
}
var $ccee98958081e0ad$export$2e2bcd8739ae039 = $ccee98958081e0ad$var$Customized;





class $95ac5fae7f41c817$var$Rect extends (0, $170ef886b9fe1618$export$2e2bcd8739ae039) {
    constructor(params){
        super("rect", params);
        this._graphics = new $d21713afb1bb29fd$export$29d3e417456abdad();
        this._graphics.alpha = 0.25;
        this.container.addChild(this._graphics);
        this.x = params.x || 0;
        this.y = params.y || 0;
        this.width = params.width || 0;
        this.height = params.height || 0;
    }
    static parse(params) {
        return new $95ac5fae7f41c817$var$Rect(params);
    }
    draw = ()=>{
        this._graphics.clear().beginFill(0xFF0000, 1).drawRect(0, 0, this.width, this.height).endFill();
        this.container.position.set(this.x - this.width / 2, this.y - this.height / 2);
        return this;
    };
    onPrecisionChange = (precision)=>{
        this.x = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(this.x, precision);
        this.y = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(this.y, precision);
        this.width = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(this.width, precision);
        this.height = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(this.height, precision);
        this.modifiedAt = Date.now();
    };
    destroy = (children)=>{
        super.destroy(children);
        if (!children) this._graphics.destroy();
    };
    serialize = ()=>{
        return {
            ...super.serialize(),
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    };
}
var $95ac5fae7f41c817$export$2e2bcd8739ae039 = $95ac5fae7f41c817$var$Rect;






function $dca3625b8704c4f7$export$2e2bcd8739ae039(shape) {
    switch(shape?.type){
        case "circle":
            return (0, $af6c0ee5e13a9ec0$export$2e2bcd8739ae039).parse(shape);
        case "customized":
            return (0, $ccee98958081e0ad$export$2e2bcd8739ae039).parse(shape);
        case "ellipse":
            return (0, $1331010475b0a998$export$2e2bcd8739ae039).parse(shape);
        case "rect":
            return (0, $95ac5fae7f41c817$export$2e2bcd8739ae039).parse(shape);
        default:
            return null;
    }
}




function $a70d4173f38562f9$var$Header(props) {
    const importRef = (0, $35jnV.useRef)(null);
    const attachRef = (0, $35jnV.useRef)(null);
    const [showHelp, setShowHelp] = (0, $35jnV.useState)(false);
    const [showSettings, setShowSettings] = (0, $35jnV.useState)(false);
    const lastAttachedAt = (0, $5a88544a0e784883$export$2e2bcd8739ae039)((state)=>state.lastAttachedAt);
    const importFile = (0, $35jnV.useCallback)(()=>importRef.current?.click(), []);
    const attachJSON = (0, $35jnV.useCallback)(()=>attachRef.current?.click(), []);
    const openHelp = (0, $35jnV.useCallback)(()=>setShowHelp(true), [
        setShowHelp
    ]);
    const closeHelp = (0, $35jnV.useCallback)(()=>setShowHelp(false), [
        setShowHelp
    ]);
    const openSettings = (0, $35jnV.useCallback)(()=>setShowSettings(true), [
        setShowSettings
    ]);
    const closeSettings = (0, $35jnV.useCallback)(()=>setShowSettings(false), [
        setShowSettings
    ]);
    const exportJSON = (0, $35jnV.useCallback)(()=>{
        try {
            const { shapesMap: shapesMap } = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
            const { files: files } = (0, $5a88544a0e784883$export$2e2bcd8739ae039).getState();
            const { precision: precision, tags: tags } = (0, $078bc949f5227a17$export$2e2bcd8739ae039).getState();
            const data = {
                version: 1,
                shapes: {},
                settings: {
                    precision: precision,
                    tags: tags
                }
            };
            for (const [index, shapes] of Object.entries(shapesMap)){
                const { name: name } = files[index];
                data.shapes[name] = shapes?.map((shape)=>shape.serialize()) || [];
            }
            (0, $2a17346401755832$exports.saveAs)(new Blob([
                JSON.stringify(data, null, 2)
            ], {
                type: "text/plain;charset=utf-8"
            }), "collision.json");
        } catch (err) {
        //
        }
    }, []);
    const onFileChange = (0, $35jnV.useCallback)(async (ev)=>{
        try {
            const files = await Promise.all(Array.from(ev.target.files).sort((a, b)=>{
                /**
               * If there are numbers in the file name, sort by the last number,
               * otherwise sort by string
               */ const [an] = a.name.match(/(\d+)(?!.*\d)/) || [];
                const [bn] = b.name.match(/(\d+)(?!.*\d)/) || [];
                if (an && bn) return Number(an) - Number(bn);
                return a > b ? 1 : -1;
            }).map(async (file)=>{
                const info = await (0, $2ad56a64a2ca30f2$export$2e2bcd8739ae039)(file);
                // ! Note: inject width / height
                file.width = info.width;
                file.height = info.height;
                return file;
            }));
            if (!files.length) return;
             // do nothing
            const { setFiles: setFiles, setSelected: setSelected } = (0, $5a88544a0e784883$export$2e2bcd8739ae039).getState();
            const { shapesMap: shapesMap, clear: clear } = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
            // destroy all previous shapes
            Object.values(shapesMap).forEach((shapes)=>{
                shapes.forEach((shape)=>shape.destroy(true));
            });
            clear();
            setFiles(files);
            setSelected(0);
        } catch (err) {
        //
        }
    }, []);
    const onAttachChange = (0, $35jnV.useCallback)(async (ev)=>{
        try {
            const [file] = ev.target.files;
            if (!file) return;
             // do nothing
            // parse json
            const json = await (0, $ba2ebe3707174c7b$export$2e2bcd8739ae039).readAsText(file);
            const parsed = JSON.parse(json);
            if (!parsed || parsed.version !== 1) return; // do nothing
            // settings
            const { setPrecision: setPrecision, setTags: setTags } = (0, $078bc949f5227a17$export$2e2bcd8739ae039).getState();
            const precision = Number(parsed.settings?.precision);
            setPrecision(Number.isNaN(precision) ? 16 : precision);
            setTags(parsed.settings?.tags || []);
            // gen filename -> index map
            const { files: files, setLastAttachedAt: setLastAttachedAt } = (0, $5a88544a0e784883$export$2e2bcd8739ae039).getState();
            const idxMap = {} // { [filename]: index }
            ;
            for (const [idx, file] of files.entries())idxMap[file.name] = idx;
            // add shapes
            const { add: add } = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
            for (const [name, shapes] of Object.entries(parsed.shapes || {}))for (const shape of shapes){
                const index = idxMap[name];
                const s = (0, $dca3625b8704c4f7$export$2e2bcd8739ae039)(shape);
                if (!s || !(0, $3ab06b0b834e1fe0$export$2e2bcd8739ae039).exist(index)) continue;
                s.draw();
                add(idxMap[name], s);
            }
            setLastAttachedAt(Date.now());
        } catch (err) {
        //
        }
    }, []);
    return /*#__PURE__*/ (0, $86rqb.jsxs)((0, $86dcc27043d7a1bd$export$2e2bcd8739ae039), {
        position: "static",
        children: [
            /*#__PURE__*/ (0, $86rqb.jsxs)((0, $e29ac4f892082e51$export$2e2bcd8739ae039), {
                variant: "dense",
                children: [
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $f77466060e074182$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $86rqb.jsx)((0, $a6d0b4fce5ac3283$export$2e2bcd8739ae039), {
                            title: "Import files",
                            children: /*#__PURE__*/ (0, $86rqb.jsxs)((0, $0d33723cc471c46b$export$2e2bcd8739ae039), {
                                "aria-label": "import",
                                color: "inherit",
                                onClick: importFile,
                                children: [
                                    /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a291d896251377a7$exports))), {}),
                                    /*#__PURE__*/ (0, $86rqb.jsx)("input", {
                                        type: "file",
                                        ref: importRef,
                                        multiple: true,
                                        accept: "image/png,jpeg,jpg,bmp",
                                        style: {
                                            display: "none"
                                        },
                                        onChange: onFileChange
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $f77466060e074182$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $86rqb.jsx)((0, $a6d0b4fce5ac3283$export$2e2bcd8739ae039), {
                            title: "Attach JSON",
                            children: /*#__PURE__*/ (0, $86rqb.jsxs)((0, $0d33723cc471c46b$export$2e2bcd8739ae039), {
                                "aria-label": "attach",
                                color: "inherit",
                                onClick: attachJSON,
                                children: [
                                    /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f51a81b736208a40$exports))), {}),
                                    /*#__PURE__*/ (0, $86rqb.jsx)("input", {
                                        type: "file",
                                        ref: attachRef,
                                        accept: "application/json",
                                        style: {
                                            display: "none"
                                        },
                                        onChange: onAttachChange
                                    }, lastAttachedAt)
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $f77466060e074182$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $86rqb.jsx)((0, $a6d0b4fce5ac3283$export$2e2bcd8739ae039), {
                            title: "Export JSON",
                            children: /*#__PURE__*/ (0, $86rqb.jsx)((0, $0d33723cc471c46b$export$2e2bcd8739ae039), {
                                "aria-label": "export",
                                color: "inherit",
                                onClick: exportJSON,
                                children: /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e5afa28d79f20446$exports))), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $f77466060e074182$export$2e2bcd8739ae039), {
                        sx: {
                            flexGrow: 1
                        }
                    }),
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $f77466060e074182$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $86rqb.jsx)((0, $0d33723cc471c46b$export$2e2bcd8739ae039), {
                            "aria-label": "settings",
                            color: "inherit",
                            onClick: openSettings,
                            children: /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($41eebd52a007629c$exports))), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $f77466060e074182$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $86rqb.jsx)((0, $0d33723cc471c46b$export$2e2bcd8739ae039), {
                            "aria-label": "help",
                            color: "inherit",
                            onClick: openHelp,
                            children: /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e7c5fef7e731d063$exports))), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $f77466060e074182$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $86rqb.jsx)("a", {
                            href: "https://github.com/noih/collision-painter",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0, $86rqb.jsx)((0, $0d33723cc471c46b$export$2e2bcd8739ae039), {
                                "aria-label": "github",
                                color: "inherit",
                                children: /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0de0642a46b293cc$exports))), {})
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $86648bbeef8811c6$export$2e2bcd8739ae039), {
                isOpen: showHelp,
                onClose: closeHelp
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $89bc942a790c4e9c$export$2e2bcd8739ae039), {
                isOpen: showSettings,
                onClose: closeSettings
            })
        ]
    });
}
var $a70d4173f38562f9$export$2e2bcd8739ae039 = $a70d4173f38562f9$var$Header;



var $86rqb = parcelRequire("86rqb");

var $35jnV = parcelRequire("35jnV");



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");

var $a7jdq = parcelRequire("a7jdq");

var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");





var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $68f4e38c53560d1e$export$c09531d8563c67a5(slot) {
    return (0, $1reLR.default)("MuiListItemButton", slot);
}
const $68f4e38c53560d1e$var$listItemButtonClasses = (0, $ibC2g.default)("MuiListItemButton", [
    "root",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $68f4e38c53560d1e$export$2e2bcd8739ae039 = $68f4e38c53560d1e$var$listItemButtonClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $8c1eb9cd3fc5e2f1$var$_excluded = [
    "alignItems",
    "autoFocus",
    "component",
    "children",
    "dense",
    "disableGutters",
    "divider",
    "focusVisibleClassName",
    "selected",
    "className"
];
const $8c1eb9cd3fc5e2f1$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $8c1eb9cd3fc5e2f1$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            divider && "divider",
            disabled && "disabled",
            alignItems === "flex-start" && "alignItemsFlexStart",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $5wpQH.default)(slots, (0, $68f4e38c53560d1e$export$c09531d8563c67a5), classes);
    return (0, $lfXYn.default)({}, classes, composedClasses);
};
const $8c1eb9cd3fc5e2f1$var$ListItemButtonRoot = (0, $jBVCU.default)((0, $38bba7b782da1f95$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $jBVCU.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiListItemButton",
    slot: "Root",
    overridesResolver: $8c1eb9cd3fc5e2f1$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        display: "flex",
        flexGrow: 1,
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minWidth: 0,
        boxSizing: "border-box",
        textAlign: "left",
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $68f4e38c53560d1e$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $a7jdq.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $68f4e38c53560d1e$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $a7jdq.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $68f4e38c53560d1e$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $a7jdq.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $a7jdq.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $68f4e38c53560d1e$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $68f4e38c53560d1e$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }));
const $8c1eb9cd3fc5e2f1$var$ListItemButton = /*#__PURE__*/ $35jnV.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiListItemButton"
    });
    const { alignItems: alignItems = "center", autoFocus: autoFocus = false, component: component = "div", children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className } = props, other = (0, $5NWw9.default)(props, $8c1eb9cd3fc5e2f1$var$_excluded);
    const context = $35jnV.useContext((0, $e4ad3368c7db7760$export$2e2bcd8739ae039));
    const childContext = $35jnV.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $35jnV.useRef(null);
    (0, $485be479215a4887$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $lfXYn.default)({}, props, {
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    });
    const classes = $8c1eb9cd3fc5e2f1$var$useUtilityClasses(ownerState);
    const handleRef = (0, $e6f4f6562381f94e$export$2e2bcd8739ae039)(listItemRef, ref);
    return /*#__PURE__*/ (0, $86rqb.jsx)((0, $e4ad3368c7db7760$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $86rqb.jsx)($8c1eb9cd3fc5e2f1$var$ListItemButtonRoot, (0, $lfXYn.default)({
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === "div" ? "button" : component,
            focusVisibleClassName: (0, $3eTha.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $3eTha.default)(classes.root, className)
        }, other, {
            classes: classes,
            children: children
        }))
    });
});
var $8c1eb9cd3fc5e2f1$export$2e2bcd8739ae039 = $8c1eb9cd3fc5e2f1$var$ListItemButton;



var $f84bd618ca9b5f5b$export$803ec79ae6ca0678;
var $f84bd618ca9b5f5b$export$463b44d9bf3628be;
var $f84bd618ca9b5f5b$export$7061c75fc5af8b7e;
var $f84bd618ca9b5f5b$export$1237798dc640739a;
$f84bd618ca9b5f5b$export$803ec79ae6ca0678 = `XTP5Ba_explorer`;
$f84bd618ca9b5f5b$export$463b44d9bf3628be = `XTP5Ba_img`;
$f84bd618ca9b5f5b$export$7061c75fc5af8b7e = `XTP5Ba_item`;
$f84bd618ca9b5f5b$export$1237798dc640739a = `XTP5Ba_label`;


function $f323bcb48dd1f187$var$Explorer(props) {
    const [files, selectedFile] = (0, $5a88544a0e784883$export$2e2bcd8739ae039)((0, $9384c319ea675985$export$180f5a427f17c0fe)((state)=>[
            state.files,
            state.selected
        ]));
    const onItemClick = (0, $35jnV.useCallback)((idx)=>{
        const shape = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        const file = (0, $5a88544a0e784883$export$2e2bcd8739ae039).getState();
        file.setSelected(idx);
        shape.setSelected(null);
    }, []);
    return /*#__PURE__*/ (0, $86rqb.jsx)("div", {
        className: $f84bd618ca9b5f5b$export$803ec79ae6ca0678,
        children: /*#__PURE__*/ (0, $86rqb.jsx)((0, $9babbdecd9fbf836$export$2e2bcd8739ae039), {
            children: files.map((file, idx)=>/*#__PURE__*/ (0, $86rqb.jsxs)((0, $8c1eb9cd3fc5e2f1$export$2e2bcd8739ae039), {
                    className: $f84bd618ca9b5f5b$export$7061c75fc5af8b7e,
                    selected: selectedFile === idx,
                    disableRipple: true,
                    onClick: ()=>onItemClick(idx),
                    children: [
                        /*#__PURE__*/ (0, $86rqb.jsx)("img", {
                            className: $f84bd618ca9b5f5b$export$463b44d9bf3628be,
                            src: URL.createObjectURL(file),
                            alt: file.name
                        }),
                        /*#__PURE__*/ (0, $86rqb.jsx)("div", {
                            className: $f84bd618ca9b5f5b$export$1237798dc640739a,
                            children: file.name
                        })
                    ]
                }, file.name))
        })
    });
}
var $f323bcb48dd1f187$export$2e2bcd8739ae039 = $f323bcb48dd1f187$var$Explorer;



var $86rqb = parcelRequire("86rqb");

var $3eTha = parcelRequire("3eTha");
var $c2a10be0cbf8bf10$export$a4f0684a6ca45673;
$c2a10be0cbf8bf10$export$a4f0684a6ca45673 = `AznL8G_painter`;



var $35jnV = parcelRequire("35jnV");

$997b0e421c4045eb$export$d6306e508f184154.defaultOptions.scaleMode = $5912637ee8cf8b9f$export$6b734c6a0bba8473.NEAREST;
const $260bc60dd9aca28f$var$App = new $1102c0d10394bdf6$export$16975c34e60e1e61({
    view: document.getElementById("canvas"),
    backgroundColor: 0x3c3c3c,
    resolution: window.devicePixelRatio || 1,
    autoDensity: true,
    antialias: true
});
// events for tools
$260bc60dd9aca28f$var$App.stage.eventMode = "static";
$260bc60dd9aca28f$var$App.stage.hitArea = $260bc60dd9aca28f$var$App.screen;
var $260bc60dd9aca28f$export$2e2bcd8739ae039 = $260bc60dd9aca28f$var$App;



var $35jnV = parcelRequire("35jnV");
function $5b787ed4fc37c9be$export$2e2bcd8739ae039(callback, options) {
    const [size, setSize] = (0, $35jnV.useState)({
        width: window.innerWidth,
        height: window.innerHeight
    });
    const callbackRef = (0, $35jnV.useRef)(null);
    callbackRef.current = callback;
    (0, $35jnV.useEffect)(()=>{
        const onResize = ()=>setSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        window.addEventListener("resize", onResize, options);
        return ()=>{
            window.removeEventListener("resize", onResize, options);
        };
    }, [
        setSize,
        options
    ]);
    (0, $35jnV.useEffect)(()=>{
        callbackRef.current?.(size);
        return ()=>{};
    }, [
        size
    ]);
}


function $2beb14bb77e10bd9$export$2e2bcd8739ae039() {
    const resize = (0, $35jnV.useCallback)(()=>{
        const painter = document.getElementById("painter");
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).renderer.resize(painter.offsetWidth, painter.offsetHeight);
    }, []);
    (0, $35jnV.useLayoutEffect)(()=>{
        const painter = document.getElementById("painter");
        painter.appendChild((0, $260bc60dd9aca28f$export$2e2bcd8739ae039).view);
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).view.style = "position: absolute; z-index: 0;";
        resize();
        return ()=>{
            painter.removeChild((0, $260bc60dd9aca28f$export$2e2bcd8739ae039).view);
        };
    }, [
        resize
    ]);
    (0, $5b787ed4fc37c9be$export$2e2bcd8739ae039)(resize);
}



var $35jnV = parcelRequire("35jnV");





const $9c80ac49e8126ad9$export$1391212d75b2ee65 = (ms)=>new Promise((res)=>setTimeout(res, ms));


function $1286ec25d7a39e01$export$2e2bcd8739ae039() {
    const scene = (0, $2bb019ac2e75721b$export$2e2bcd8739ae039)((state)=>state.scene);
    const [files, selected, lastAttachedAt] = (0, $5a88544a0e784883$export$2e2bcd8739ae039)((0, $9384c319ea675985$export$180f5a427f17c0fe)((state)=>[
            state.files,
            state.selected,
            state.lastAttachedAt
        ]));
    /**
   * init the selected scene
   */ (0, $35jnV.useLayoutEffect)(()=>{
        const file = files[selected];
        if (!file) return ()=>{};
        const { setScene: setScene } = (0, $2bb019ac2e75721b$export$2e2bcd8739ae039).getState();
        const c = new $3878067a77b781d9$export$42a852a2b6b56249();
        c.sortableChildren = true;
        c.pivot.set(file.width / 2, file.height / 2);
        // border
        const border = new $d21713afb1bb29fd$export$29d3e417456abdad();
        border.zIndex = -1;
        border.lineStyle(0.5, 0x2a6b3b, 0.5).drawRect(-0.25, -0.25, file.width + 0.5, file.height + 0.5);
        c.addChild(border);
        setScene(c) // ! Note: set before draw (coz async)
        ;
        let sprite = null;
        const draw = async (retry = 3)=>{
            try {
                const base64 = await (0, $ba2ebe3707174c7b$export$2e2bcd8739ae039).readAsDataURL(file);
                sprite = $f092bed24e72671b$export$3075603db8e6204c.from(base64);
                sprite.zIndex = 0 // always at the bottom
                ;
                c.addChild(sprite);
                (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.addChild(c);
            } catch (err) {
                if (retry <= 0) throw err;
                await (0, $9c80ac49e8126ad9$export$1391212d75b2ee65)(1000);
                return draw(retry - 1);
            }
        };
        draw();
        return ()=>{
            (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.removeChildren();
            border.destroy(true);
            c.destroy(false) // only destroy the container (exclude children)
            ;
            sprite?.destroy(true);
        };
    }, [
        files,
        selected
    ]);
    /**
   * add back shapes (if exists)
   */ (0, $35jnV.useEffect)(()=>{
        if (!scene) return ()=>{};
        const { selected: fileSelected } = (0, $5a88544a0e784883$export$2e2bcd8739ae039).getState();
        const { shapesMap: shapesMap, setSelected: setSelected } = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        const shapes = (shapesMap[fileSelected] || []).map((shape, idx)=>{
            shape.container.zIndex = idx + 1 // default zIndex
            ;
            return shape.container;
        });
        if (shapes.length) {
            scene.addChild(...shapes);
            setSelected(shapesMap[fileSelected][0]);
        }
        return ()=>{};
    }, [
        scene,
        lastAttachedAt
    ]);
}



var $35jnV = parcelRequire("35jnV");



var $0e49edf52d44a577$exports = {};
"use strict";
var $a2d095b2e93d1b74$exports = {};

$parcel$defineInteropFlag($a2d095b2e93d1b74$exports);

$parcel$export($a2d095b2e93d1b74$exports, "default", function () { return $a2d095b2e93d1b74$export$2e2bcd8739ae039; });
class $a2d095b2e93d1b74$export$2e2bcd8739ae039 {
    constructor(data = [], compare = $a2d095b2e93d1b74$var$defaultCompare){
        this.data = data;
        this.length = this.data.length;
        this.compare = compare;
        if (this.length > 0) for(let i = (this.length >> 1) - 1; i >= 0; i--)this._down(i);
    }
    push(item) {
        this.data.push(item);
        this.length++;
        this._up(this.length - 1);
    }
    pop() {
        if (this.length === 0) return undefined;
        const top = this.data[0];
        const bottom = this.data.pop();
        this.length--;
        if (this.length > 0) {
            this.data[0] = bottom;
            this._down(0);
        }
        return top;
    }
    peek() {
        return this.data[0];
    }
    _up(pos) {
        const { data: data, compare: compare } = this;
        const item = data[pos];
        while(pos > 0){
            const parent = pos - 1 >> 1;
            const current = data[parent];
            if (compare(item, current) >= 0) break;
            data[pos] = current;
            pos = parent;
        }
        data[pos] = item;
    }
    _down(pos) {
        const { data: data, compare: compare } = this;
        const halfLength = this.length >> 1;
        const item = data[pos];
        while(pos < halfLength){
            let left = (pos << 1) + 1;
            let best = data[left];
            const right = left + 1;
            if (right < this.length && compare(data[right], best) < 0) {
                left = right;
                best = data[right];
            }
            if (compare(best, item) >= 0) break;
            data[pos] = best;
            pos = left;
        }
        data[pos] = item;
    }
}
function $a2d095b2e93d1b74$var$defaultCompare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}


var $0e49edf52d44a577$require$Queue = $a2d095b2e93d1b74$exports;
if ($0e49edf52d44a577$require$Queue.default) $0e49edf52d44a577$require$Queue = $0e49edf52d44a577$require$Queue.default; // temporary webpack fix
$0e49edf52d44a577$exports = $0e49edf52d44a577$var$polylabel;
$0e49edf52d44a577$exports.default = $0e49edf52d44a577$var$polylabel;
function $0e49edf52d44a577$var$polylabel(polygon, precision, debug) {
    precision = precision || 1.0;
    // find the bounding box of the outer ring
    var minX, minY, maxX, maxY;
    for(var i = 0; i < polygon[0].length; i++){
        var p = polygon[0][i];
        if (!i || p[0] < minX) minX = p[0];
        if (!i || p[1] < minY) minY = p[1];
        if (!i || p[0] > maxX) maxX = p[0];
        if (!i || p[1] > maxY) maxY = p[1];
    }
    var width = maxX - minX;
    var height = maxY - minY;
    var cellSize = Math.min(width, height);
    var h = cellSize / 2;
    if (cellSize === 0) {
        var degeneratePoleOfInaccessibility = [
            minX,
            minY
        ];
        degeneratePoleOfInaccessibility.distance = 0;
        return degeneratePoleOfInaccessibility;
    }
    // a priority queue of cells in order of their "potential" (max distance to polygon)
    var cellQueue = new $0e49edf52d44a577$require$Queue(undefined, $0e49edf52d44a577$var$compareMax);
    // cover polygon with initial cells
    for(var x = minX; x < maxX; x += cellSize)for(var y = minY; y < maxY; y += cellSize)cellQueue.push(new $0e49edf52d44a577$var$Cell(x + h, y + h, h, polygon));
    // take centroid as the first best guess
    var bestCell = $0e49edf52d44a577$var$getCentroidCell(polygon);
    // special case for rectangular polygons
    var bboxCell = new $0e49edf52d44a577$var$Cell(minX + width / 2, minY + height / 2, 0, polygon);
    if (bboxCell.d > bestCell.d) bestCell = bboxCell;
    var numProbes = cellQueue.length;
    while(cellQueue.length){
        // pick the most promising cell from the queue
        var cell = cellQueue.pop();
        // update the best cell if we found a better one
        if (cell.d > bestCell.d) {
            bestCell = cell;
            if (debug) console.log("found best %d after %d probes", Math.round(1e4 * cell.d) / 1e4, numProbes);
        }
        // do not drill down further if there's no chance of a better solution
        if (cell.max - bestCell.d <= precision) continue;
        // split the cell into four cells
        h = cell.h / 2;
        cellQueue.push(new $0e49edf52d44a577$var$Cell(cell.x - h, cell.y - h, h, polygon));
        cellQueue.push(new $0e49edf52d44a577$var$Cell(cell.x + h, cell.y - h, h, polygon));
        cellQueue.push(new $0e49edf52d44a577$var$Cell(cell.x - h, cell.y + h, h, polygon));
        cellQueue.push(new $0e49edf52d44a577$var$Cell(cell.x + h, cell.y + h, h, polygon));
        numProbes += 4;
    }
    if (debug) {
        console.log("num probes: " + numProbes);
        console.log("best distance: " + bestCell.d);
    }
    var poleOfInaccessibility = [
        bestCell.x,
        bestCell.y
    ];
    poleOfInaccessibility.distance = bestCell.d;
    return poleOfInaccessibility;
}
function $0e49edf52d44a577$var$compareMax(a, b) {
    return b.max - a.max;
}
function $0e49edf52d44a577$var$Cell(x, y, h, polygon) {
    this.x = x; // cell center x
    this.y = y; // cell center y
    this.h = h; // half the cell size
    this.d = $0e49edf52d44a577$var$pointToPolygonDist(x, y, polygon); // distance from cell center to polygon
    this.max = this.d + this.h * Math.SQRT2; // max distance to polygon within a cell
}
// signed distance from point to polygon outline (negative if point is outside)
function $0e49edf52d44a577$var$pointToPolygonDist(x, y, polygon) {
    var inside = false;
    var minDistSq = Infinity;
    for(var k = 0; k < polygon.length; k++){
        var ring = polygon[k];
        for(var i = 0, len = ring.length, j = len - 1; i < len; j = i++){
            var a = ring[i];
            var b = ring[j];
            if (a[1] > y !== b[1] > y && x < (b[0] - a[0]) * (y - a[1]) / (b[1] - a[1]) + a[0]) inside = !inside;
            minDistSq = Math.min(minDistSq, $0e49edf52d44a577$var$getSegDistSq(x, y, a, b));
        }
    }
    return minDistSq === 0 ? 0 : (inside ? 1 : -1) * Math.sqrt(minDistSq);
}
// get polygon centroid
function $0e49edf52d44a577$var$getCentroidCell(polygon) {
    var area = 0;
    var x = 0;
    var y = 0;
    var points = polygon[0];
    for(var i = 0, len = points.length, j = len - 1; i < len; j = i++){
        var a = points[i];
        var b = points[j];
        var f = a[0] * b[1] - b[0] * a[1];
        x += (a[0] + b[0]) * f;
        y += (a[1] + b[1]) * f;
        area += f * 3;
    }
    if (area === 0) return new $0e49edf52d44a577$var$Cell(points[0][0], points[0][1], 0, polygon);
    return new $0e49edf52d44a577$var$Cell(x / area, y / area, 0, polygon);
}
// get squared distance from a point to a segment
function $0e49edf52d44a577$var$getSegDistSq(px, py, a, b) {
    var x = a[0];
    var y = a[1];
    var dx = b[0] - x;
    var dy = b[1] - y;
    if (dx !== 0 || dy !== 0) {
        var t = ((px - x) * dx + (py - y) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x = b[0];
            y = b[1];
        } else if (t > 0) {
            x += dx * t;
            y += dy * t;
        }
    }
    dx = px - x;
    dy = py - y;
    return dx * dx + dy * dy;
}




class $164017d7d98ab38e$export$2e2bcd8739ae039 {
    zIndex = 1000;
    color = 0x00FF00;
    graphics = null;
    isDragging = false;
    callbacks = {
        onDragStart: null,
        onDragEnd: null,
        onMove: null
    };
    constructor(zIndex = 1000, color = 0x00FF00){
        this.zIndex = zIndex;
        this.color = color;
        this.create = this.create.bind(this);
        this.setup = this.setup.bind(this);
        this.draw = this.draw.bind(this);
        this.clear = this.clear.bind(this);
        this.destroy = this.destroy.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.onDragMove = this.onDragMove.bind(this);
    }
    create() {
        if (this.graphics) return;
        this.graphics = new $d21713afb1bb29fd$export$29d3e417456abdad();
        this.graphics.eventMode = "static";
        this.graphics.cursor = "move";
        this.graphics.zIndex = this.zIndex;
        this.graphics.on("pointerdown", this.onDragStart);
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.on("pointerup", this.onDragEnd);
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.on("pointerupoutside", this.onDragEnd);
        return this;
    }
    setup(callbacks) {
        this.callbacks = callbacks;
        return this;
    }
    clear() {
        this.graphics?.clear();
        return this;
    }
    draw(x, y, scale) {
        if (!this.graphics) return;
        this.graphics.clear();
        this.graphics.position.set(x, y);
        this.graphics.lineStyle(1 / scale, 0x00000, 1).beginFill(this.color, 1).drawCircle(0, 0, 6 / scale).endFill();
        return this;
    }
    destroy() {
        this.graphics.off("pointerdown", this.onDragStart);
        this.graphics.destroy();
        this.graphics = null;
        this.isDragging = false;
        this.callbacks = {};
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.off("pointerup", this.onDragEnd);
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.off("pointerupoutside", this.onDragEnd);
        return this;
    }
    onDragStart(ev) {
        this.callbacks.onDragStart && this.callbacks.onDragStart();
        this.isDragging = true;
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.on("pointermove", this.onDragMove);
    }
    onDragEnd(ev) {
        if (!this.isDragging) return;
        this.callbacks.onDragEnd && this.callbacks.onDragEnd();
        this.isDragging = false;
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.off("pointermove", this.onDragMove);
    }
    onDragMove(ev) {
        if (this.isDragging) {
            const pos = ev.data.getLocalPosition(this.graphics.parent);
            this.callbacks.onMove && this.callbacks.onMove(pos);
        }
    }
}


class $8a12bb47c9e2e0f1$var$ShapeMovingControl extends (0, $164017d7d98ab38e$export$2e2bcd8739ae039) {
    update = (shape, scale, callbacks)=>{
        const center = this.getCenter(shape);
        if (!center) {
            this.clear();
            return;
        }
        this.setup(callbacks).draw(center.x, center.y, scale);
    };
    getCenter = (shape)=>{
        switch(shape?.type){
            case "customized":
                {
                    if (shape.points.length < 2) return null;
                    if (shape.points.length === 2) return {
                        x: (shape.points[0].x + shape.points[1].x) / 2,
                        y: (shape.points[0].y + shape.points[1].y) / 2
                    };
                    const center = (0, (/*@__PURE__*/$parcel$interopDefault($0e49edf52d44a577$exports)))([
                        shape.points.map((p)=>[
                                p.x,
                                p.y
                            ])
                    ], 1.0);
                    return {
                        x: center[0],
                        y: center[1]
                    };
                }
            case "rect":
            case "circle":
            case "ellipse":
                return {
                    x: shape.x,
                    y: shape.y
                };
            default:
                return null;
        }
    };
}
const $8a12bb47c9e2e0f1$var$ctrl = new $8a12bb47c9e2e0f1$var$ShapeMovingControl(1000, 0x00FF00);
var $8a12bb47c9e2e0f1$export$2e2bcd8739ae039 = $8a12bb47c9e2e0f1$var$ctrl;


function $c16b01349e242332$export$2e2bcd8739ae039() {
    // FIXME: shallow
    const [selected] = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039)((state)=>[
            state.selected
        ]);
    const [scene, scale] = (0, $2bb019ac2e75721b$export$2e2bcd8739ae039)((0, $9384c319ea675985$export$180f5a427f17c0fe)((state)=>[
            state.scene,
            state.scale
        ]));
    const distances = (0, $35jnV.useRef)([]);
    const modifiedAt = selected?.modifiedAt || 0;
    const onDragStart = (0, $35jnV.useCallback)(()=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        if (ss.selected.type === "customized") {
            const center = (0, $8a12bb47c9e2e0f1$export$2e2bcd8739ae039).getCenter(ss.selected);
            distances.current = ss.selected.points.map((p)=>{
                return {
                    x: p.x - center.x,
                    y: p.y - center.y
                };
            });
        }
    }, []);
    const onDragEnd = (0, $35jnV.useCallback)(()=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        if (ss.selected.type === "customized") distances.current = [];
    }, []);
    const onMove = (0, $35jnV.useCallback)((pos)=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        const { precision: precision } = (0, $078bc949f5227a17$export$2e2bcd8739ae039).getState();
        switch(ss.selected.type){
            case "customized":
                if (ss.selected.points.length !== distances.current.length) return;
                ss.selected.points = ss.selected.points.map((p, i)=>{
                    return {
                        ...p,
                        x: (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(pos.x + distances.current[i].x, precision),
                        y: (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(pos.y + distances.current[i].y, precision)
                    };
                });
                break;
            case "rect":
            case "ellipse":
            case "circle":
                ss.selected.x = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(pos.x, precision);
                ss.selected.y = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(pos.y, precision);
                break;
            default:
        }
        ss.selected.modifiedAt = Date.now();
        // ! Note: for performance
        requestAnimationFrame(()=>{
            ss.setSelected(ss.selected);
        });
        ss.selected.draw();
    }, []);
    const update = (0, $35jnV.useCallback)(()=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        const sc = (0, $2bb019ac2e75721b$export$2e2bcd8739ae039).getState();
        (0, $8a12bb47c9e2e0f1$export$2e2bcd8739ae039).update(ss.selected, sc.scale, {
            onMove: onMove,
            onDragStart: onDragStart,
            onDragEnd: onDragEnd
        });
    }, [
        onMove,
        onDragStart,
        onDragEnd
    ]);
    /**
   * create / destroy
   */ (0, $35jnV.useEffect)(()=>{
        if (!scene) return ()=>{};
        (0, $8a12bb47c9e2e0f1$export$2e2bcd8739ae039).create();
        return ()=>{
            (0, $8a12bb47c9e2e0f1$export$2e2bcd8739ae039).destroy();
        };
    }, [
        !!scene
    ]);
    /**
   * selected
   */ (0, $35jnV.useEffect)(()=>{
        if (!selected) return ()=>{};
        scene.addChild((0, $8a12bb47c9e2e0f1$export$2e2bcd8739ae039).graphics);
        update();
        return ()=>{
            scene.removeChild((0, $8a12bb47c9e2e0f1$export$2e2bcd8739ae039).graphics);
        };
    }, [
        selected,
        update
    ]);
    /**
   * update
   */ (0, $35jnV.useEffect)(()=>{
        update();
        return ()=>{};
    }, [
        scale,
        modifiedAt,
        update
    ]);
}



var $35jnV = parcelRequire("35jnV");





class $9cb2ce2dab848b76$var$CustomizedPointsControl {
    container = null;
    points = [];
    callbacks = {
        onMove: null
    };
    create = ()=>{
        if (this.container) return;
        this.container = new $3878067a77b781d9$export$42a852a2b6b56249();
        this.container.zIndex = 1000;
    };
    setup = (callbacks)=>{
        this.callbacks = callbacks;
    };
    update = (shape, scale)=>{
        if (shape?.type !== "customized") return;
        // if points length changed
        if (this.points.length !== shape.points.length) {
            this.points.forEach((p)=>p.destroy());
            this.points = shape.points.map((p)=>{
                const point = new (0, $164017d7d98ab38e$export$2e2bcd8739ae039)(0, 0x9fcfed);
                return point.create();
            });
        }
        for(let i = 0; i < this.points.length; i++)this.points[i].setup(this.genCallbacks(shape.points[i])).draw(shape.points[i].x, shape.points[i].y, scale);
        // if container children length not equal to points length
        if (this.container.children.length !== this.points.length) {
            this.container.removeChildren();
            for(let i = 0; i < this.points.length; i++)this.container.addChild(this.points[i].graphics);
        }
    };
    genCallbacks = (point)=>{
        return {
            onMove: this.callbacks.onMove ? (pos)=>this.callbacks.onMove(point, pos) : null
        };
    };
    destroy = ()=>{
        this.points.forEach((p)=>p.destroy());
        this.points.length = 0;
        this.container.destroy();
        this.container = null;
    };
}
const $9cb2ce2dab848b76$var$ctrl = new $9cb2ce2dab848b76$var$CustomizedPointsControl();
var $9cb2ce2dab848b76$export$2e2bcd8739ae039 = $9cb2ce2dab848b76$var$ctrl;


function $0f2d0b3cb68c6af1$export$2e2bcd8739ae039() {
    const selected = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039)((state)=>state.selected);
    const [scene, scale] = (0, $2bb019ac2e75721b$export$2e2bcd8739ae039)((0, $9384c319ea675985$export$180f5a427f17c0fe)((state)=>[
            state.scene,
            state.scale
        ]));
    const modifiedAt = selected?.modifiedAt || 0;
    const onMove = (0, $35jnV.useCallback)((point, pos)=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        const { precision: precision } = (0, $078bc949f5227a17$export$2e2bcd8739ae039).getState();
        point.x = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(pos.x, precision);
        point.y = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(pos.y, precision);
        ss.selected.modifiedAt = Date.now();
        // ! Note: for performance
        requestAnimationFrame(()=>{
            ss.setSelected(ss.selected);
        });
        ss.selected.draw();
    }, []);
    const update = (0, $35jnV.useCallback)(()=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        const sc = (0, $2bb019ac2e75721b$export$2e2bcd8739ae039).getState();
        (0, $9cb2ce2dab848b76$export$2e2bcd8739ae039).setup({
            onMove: onMove
        });
        (0, $9cb2ce2dab848b76$export$2e2bcd8739ae039).update(ss.selected, sc.scale);
    }, [
        onMove
    ]);
    /**
   * create / destroy
   */ (0, $35jnV.useEffect)(()=>{
        if (!scene) return ()=>{};
        (0, $9cb2ce2dab848b76$export$2e2bcd8739ae039).create();
        return ()=>{
            (0, $9cb2ce2dab848b76$export$2e2bcd8739ae039).destroy();
        };
    }, [
        !!scene
    ]);
    /**
   * selected
   */ (0, $35jnV.useEffect)(()=>{
        if (selected?.type !== "customized") return ()=>{};
        scene.addChild((0, $9cb2ce2dab848b76$export$2e2bcd8739ae039).container);
        update();
        return ()=>{
            scene.removeChild((0, $9cb2ce2dab848b76$export$2e2bcd8739ae039).container);
        };
    }, [
        selected,
        update
    ]);
    /**
   * update
   */ (0, $35jnV.useEffect)(()=>{
        update();
        return ()=>{};
    }, [
        scale,
        modifiedAt,
        update
    ]);
}



var $35jnV = parcelRequire("35jnV");




function $a7a97618d75ace1b$export$2e2bcd8739ae039() {
    const [scene, scale] = (0, $2bb019ac2e75721b$export$2e2bcd8739ae039)((0, $9384c319ea675985$export$180f5a427f17c0fe)((state)=>[
            state.scene,
            state.scale
        ]));
    const zoom = (0, $35jnV.useCallback)((v)=>{
        try {
            const currentScene = (0, $2bb019ac2e75721b$export$2e2bcd8739ae039).getState().scene;
            if (currentScene) {
                currentScene.scale.set(v || 1);
                currentScene.position.set((0, $260bc60dd9aca28f$export$2e2bcd8739ae039).screen.width / 2, (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).screen.height / 2);
            }
        } catch (err) {
        // ignore
        }
    }, []);
    /**
   * set scale when scene changed
   */ (0, $35jnV.useEffect)(()=>zoom((0, $2bb019ac2e75721b$export$2e2bcd8739ae039).getState().scale), [
        zoom,
        scene
    ]);
    /**
   * zoom when scale changed
   */ (0, $35jnV.useEffect)(()=>{
        zoom(scale);
        return ()=>{};
    }, [
        zoom,
        scale
    ]);
    /**
   * wheel
   */ (0, $35jnV.useEffect)(()=>{
        const painter = document.getElementById("painter");
        const onWheel = (ev)=>{
            const { addScale: addScale } = (0, $2bb019ac2e75721b$export$2e2bcd8739ae039).getState();
            addScale(ev.deltaY * 0.1);
        };
        painter.addEventListener("wheel", onWheel, {
            passive: true
        });
        return ()=>{
            painter.removeEventListener("wheel", onWheel);
        };
    }, []);
    (0, $5b787ed4fc37c9be$export$2e2bcd8739ae039)(()=>zoom(scale));
}


function $7b549ec00ade720c$var$Painter(props) {
    (0, $2beb14bb77e10bd9$export$2e2bcd8739ae039)();
    (0, $1286ec25d7a39e01$export$2e2bcd8739ae039)();
    (0, $a7a97618d75ace1b$export$2e2bcd8739ae039)();
    (0, $0f2d0b3cb68c6af1$export$2e2bcd8739ae039)();
    (0, $c16b01349e242332$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $86rqb.jsx)("div", {
        id: "painter",
        className: (0, $3eTha.default)($c2a10be0cbf8bf10$export$a4f0684a6ca45673, props.className)
    });
}
var $7b549ec00ade720c$export$2e2bcd8739ae039 = $7b549ec00ade720c$var$Painter;



var $86rqb = parcelRequire("86rqb");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $ircER = parcelRequire("ircER");

var $5wpQH = parcelRequire("5wpQH");

var $a7jdq = parcelRequire("a7jdq");

var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");


var $1OAmh = parcelRequire("1OAmh");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $8f26ece5093fb5fc$export$5a6f9035944c8119(slot) {
    return (0, $1reLR.default)("MuiButton", slot);
}
const $8f26ece5093fb5fc$var$buttonClasses = (0, $ibC2g.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $8f26ece5093fb5fc$export$2e2bcd8739ae039 = $8f26ece5093fb5fc$var$buttonClasses;



var $35jnV = parcelRequire("35jnV");
/**
 * @ignore - internal component.
 */ const $ad9dec4e1d6265e4$var$ButtonGroupContext = /*#__PURE__*/ $35jnV.createContext({});
var $ad9dec4e1d6265e4$export$2e2bcd8739ae039 = $ad9dec4e1d6265e4$var$ButtonGroupContext;



var $35jnV = parcelRequire("35jnV");
/**
 * @ignore - internal component.
 */ const $df33c2baf328385b$var$ButtonGroupButtonContext = /*#__PURE__*/ $35jnV.createContext(undefined);
var $df33c2baf328385b$export$2e2bcd8739ae039 = $df33c2baf328385b$var$ButtonGroupButtonContext;



var $86rqb = parcelRequire("86rqb");
"use client";
const $c94a9b0aec52d6ff$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $c94a9b0aec52d6ff$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $1OAmh.default)(color)}`,
            `size${(0, $1OAmh.default)(size)}`,
            `${variant}Size${(0, $1OAmh.default)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, $1OAmh.default)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, $1OAmh.default)(size)}`
        ]
    };
    const composedClasses = (0, $5wpQH.default)(slots, (0, $8f26ece5093fb5fc$export$5a6f9035944c8119), classes);
    return (0, $lfXYn.default)({}, classes, composedClasses);
};
const $c94a9b0aec52d6ff$var$commonIconStyles = (ownerState)=>(0, $lfXYn.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $c94a9b0aec52d6ff$var$ButtonRoot = (0, $jBVCU.default)((0, $38bba7b782da1f95$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $jBVCU.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $1OAmh.default)(ownerState.color)}`],
            styles[`size${(0, $1OAmh.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $1OAmh.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $lfXYn.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $lfXYn.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $a7jdq.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $a7jdq.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $a7jdq.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $lfXYn.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $8f26ece5093fb5fc$export$2e2bcd8739ae039).focusVisible}`]: (0, $lfXYn.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $8f26ece5093fb5fc$export$2e2bcd8739ae039).disabled}`]: (0, $lfXYn.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $a7jdq.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $8f26ece5093fb5fc$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $8f26ece5093fb5fc$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $c94a9b0aec52d6ff$var$ButtonStartIcon = (0, $jBVCU.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $1OAmh.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $lfXYn.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $c94a9b0aec52d6ff$var$commonIconStyles(ownerState)));
const $c94a9b0aec52d6ff$var$ButtonEndIcon = (0, $jBVCU.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $1OAmh.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $lfXYn.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $c94a9b0aec52d6ff$var$commonIconStyles(ownerState)));
const $c94a9b0aec52d6ff$var$Button = /*#__PURE__*/ $35jnV.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $35jnV.useContext((0, $ad9dec4e1d6265e4$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $35jnV.useContext((0, $df33c2baf328385b$export$2e2bcd8739ae039));
    const resolvedProps = (0, $ircER.default)(contextProps, inProps);
    const props = (0, $hZybU.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $5NWw9.default)(props, $c94a9b0aec52d6ff$var$_excluded);
    const ownerState = (0, $lfXYn.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $c94a9b0aec52d6ff$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $86rqb.jsx)($c94a9b0aec52d6ff$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $86rqb.jsx)($c94a9b0aec52d6ff$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $86rqb.jsxs)($c94a9b0aec52d6ff$var$ButtonRoot, (0, $lfXYn.default)({
        ownerState: ownerState,
        className: (0, $3eTha.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $3eTha.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $c94a9b0aec52d6ff$export$2e2bcd8739ae039 = $c94a9b0aec52d6ff$var$Button;








var $32a8212dd292bdfe$export$1ca1ec8b29a4ce27;
var $32a8212dd292bdfe$export$120ff0929b202a6d;
var $32a8212dd292bdfe$export$f727f52c778e92d5;
var $32a8212dd292bdfe$export$8fa4e5556fd77a60;
$32a8212dd292bdfe$export$1ca1ec8b29a4ce27 = `T4gzya_icon`;
$32a8212dd292bdfe$export$120ff0929b202a6d = `T4gzya_row`;
$32a8212dd292bdfe$export$f727f52c778e92d5 = `T4gzya_toolbar`;
$32a8212dd292bdfe$export$8fa4e5556fd77a60 = `T4gzya_white`;





class $1510fee9219beb86$export$2e2bcd8739ae039 {
    /**
   * mainly used to avoid instanceof checks
   */ name = "tool";
    constructor(name){
        this.name = name;
        // setup when activate
        this.state = {
            scene: null,
            shape: null,
            precision: null
        };
        this.actions = {
            setTool: null,
            setShape: null,
            addShape: null,
            removeShape: null,
            updateShape: null
        };
        this.activate = this.activate.bind(this);
        this.deActivate = this.deActivate.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onPointerOut = this.onPointerOut.bind(this);
        this.onPointerOver = this.onPointerOver.bind(this);
        this.onPointerOuteside = this.onPointerOuteside.bind(this);
    }
    activate({ state: state, actions: actions }) {
        console.log(`${this.name}.activate`);
        this.state = state;
        this.actions = actions;
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.addEventListener("pointerup", this.onPointerUp);
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.addEventListener("pointerdown", this.onPointerDown);
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.addEventListener("pointermove", this.onPointerMove);
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.addEventListener("pointerout", this.onPointerOut);
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.addEventListener("pointerover", this.onPointerOver);
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.addEventListener("pointerupoutside", this.onPointerOuteside);
        window.addEventListener("keyup", this.onKeyUp, true);
        window.addEventListener("keydown", this.onKeyDown, true);
    }
    deActivate() {
        console.log(`${this.name}.deActivate`);
        this.state = {};
        this.actions = {};
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.removeEventListener("pointerup", this.onPointerUp);
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.removeEventListener("pointerdown", this.onPointerDown);
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.removeEventListener("pointermove", this.onPointerMove);
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.removeEventListener("pointerout", this.onPointerOut);
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.removeEventListener("pointerover", this.onPointerOver);
        (0, $260bc60dd9aca28f$export$2e2bcd8739ae039).stage.removeEventListener("pointerupoutside", this.onPointerOuteside);
        window.removeEventListener("keyup", this.onKeyUp, true);
        window.removeEventListener("keydown", this.onKeyDown, true);
    }
    onKeyDown(ev) {}
    onKeyUp(ev) {}
    onPointerDown(ev) {}
    onPointerMove(ev) {}
    onPointerUp(ev) {}
    onPointerOut(ev) {}
    onPointerOver(ev) {}
    onPointerOuteside(ev) {}
}



class $5e8c48b66a5cfdb2$var$CircleTool extends (0, $1510fee9219beb86$export$2e2bcd8739ae039) {
    constructor(){
        super("circle");
    }
    onPointerUp = (ev)=>{
        console.log("Circle.onPointerUp", ev);
        const { scene: scene } = this.state;
        const local = scene.toLocal(ev.data.global);
        const c = new (0, $af6c0ee5e13a9ec0$export$2e2bcd8739ae039)({
            x: (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(local.x, this.state.precision),
            y: (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(local.y, this.state.precision),
            radius: 4
        }).draw();
        // zIndex 0 = sprite (background)
        c.container.zIndex = scene.children.length;
        scene.addChild(c.container);
        this.actions.addShape(c);
        this.actions.setShape(c);
        this.actions.setTool($e1100aa3998188ed$export$2e2bcd8739ae039);
    };
}
// singleton
const $5e8c48b66a5cfdb2$var$tool = new $5e8c48b66a5cfdb2$var$CircleTool();
var $5e8c48b66a5cfdb2$export$2e2bcd8739ae039 = $5e8c48b66a5cfdb2$var$tool;






class $415adcf31d57ed3a$var$EllipseTool extends (0, $1510fee9219beb86$export$2e2bcd8739ae039) {
    constructor(){
        super("ellipse");
    }
    onPointerUp = (ev)=>{
        console.log("Ellipse.onPointerUp", ev);
        const { scene: scene } = this.state;
        const local = scene.toLocal(ev.data.global);
        const e = new (0, $1331010475b0a998$export$2e2bcd8739ae039)({
            x: (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(local.x, this.state.precision),
            y: (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(local.y, this.state.precision),
            width: 4,
            height: 3
        }).draw();
        // zIndex 0 = sprite (background)
        e.container.zIndex = scene.children.length;
        scene.addChild(e.container);
        this.actions.addShape(e);
        this.actions.setShape(e);
        this.actions.setTool($e1100aa3998188ed$export$2e2bcd8739ae039);
    };
}
// singleton
const $415adcf31d57ed3a$var$tool = new $415adcf31d57ed3a$var$EllipseTool();
var $415adcf31d57ed3a$export$2e2bcd8739ae039 = $415adcf31d57ed3a$var$tool;






class $7a118ec64e6e60c8$var$CustomizedTool extends (0, $1510fee9219beb86$export$2e2bcd8739ae039) {
    constructor(){
        super("customized");
        this.mode = "normal" // normal | add
        ;
    }
    activate = (params)=>{
        super.activate(params);
        this.clear();
    };
    deActivate = ()=>{
        super.deActivate();
        this.clear();
    };
    clear = ()=>{
        this.setMode("normal");
    };
    setMode = (mode, shape = null)=>{
        switch(mode){
            case "normal":
                document.documentElement.style.cursor = "auto";
                break;
            case "add":
                if (!shape) return;
                document.documentElement.style.cursor = "crosshair";
                break;
            default:
        }
        this.mode = mode;
    };
    onKeyDown = (ev, source = this)=>{
        if (ev.key === "Alt" || ev.key === "Meta") this.setMode("add", source.state.shape);
    };
    onKeyUp = (ev, source = this)=>{
        if (ev.key === "Alt" || ev.key === "Meta") this.setMode("normal", source.state.shape);
    };
    _create = (source, pos)=>{
        const { state: state, actions: actions } = source;
        const { scene: scene } = state;
        const c = new (0, $ccee98958081e0ad$export$2e2bcd8739ae039)({
            points: [
                {
                    x: (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(pos.x, state.precision),
                    y: (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(pos.y, state.precision)
                }
            ]
        }).draw();
        // zIndex 0 = sprite (background)
        c.container.zIndex = scene.children.length;
        scene.addChild(c.container);
        actions.addShape(c);
        actions.setShape(c);
    };
    onPointerUp = (ev, source = this)=>{
        console.log("Customized.onPointerUp", ev);
        const { scene: scene, shape: shape } = source.state;
        const local = scene.toLocal(ev.data.global);
        switch(this.mode){
            case "normal":
                if (source !== this) return;
                this._create(source, local);
                source.actions.setTool($e1100aa3998188ed$export$2e2bcd8739ae039);
                break;
            case "add":
                if (!shape) {
                    this._create(source, local);
                    source.actions.setTool($e1100aa3998188ed$export$2e2bcd8739ae039);
                    return;
                }
                source.actions.updateShape((state)=>{
                    const { selected: selected } = state;
                    selected.addPoint((0, $c749fe39302942ca$export$2e2bcd8739ae039).round(local.x, source.state.precision), (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(local.y, source.state.precision));
                    state.setSelected(selected);
                    selected.draw();
                });
            default:
        }
    };
}
// singleton
const $7a118ec64e6e60c8$var$tool = new $7a118ec64e6e60c8$var$CustomizedTool();
var $7a118ec64e6e60c8$export$2e2bcd8739ae039 = $7a118ec64e6e60c8$var$tool;






class $583123352b65d5f1$var$RectTool extends (0, $1510fee9219beb86$export$2e2bcd8739ae039) {
    constructor(){
        super("rect");
    }
    onPointerUp = (ev)=>{
        console.log("Rect.onPointerUp", ev);
        const { scene: scene } = this.state;
        const local = scene.toLocal(ev.data.global);
        const r = new (0, $95ac5fae7f41c817$export$2e2bcd8739ae039)({
            x: (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(local.x, this.state.precision),
            y: (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(local.y, this.state.precision),
            width: 8,
            height: 8
        }).draw();
        // zIndex 0 = sprite (background)
        r.container.zIndex = scene.children.length;
        scene.addChild(r.container);
        this.actions.addShape(r);
        this.actions.setShape(r);
        this.actions.setTool($e1100aa3998188ed$export$2e2bcd8739ae039);
    };
}
// singleton
const $583123352b65d5f1$var$tool = new $583123352b65d5f1$var$RectTool();
var $583123352b65d5f1$export$2e2bcd8739ae039 = $583123352b65d5f1$var$tool;




/**
 * When any key is down and a shape is selected,
 * the 'pointer' event will be forwarded to the corresponding tool.
 */ class $e1100aa3998188ed$var$SelectTool extends (0, $1510fee9219beb86$export$2e2bcd8739ae039) {
    isKeyDown = false;
    constructor(){
        super("select");
    }
    deActivate = ()=>{
        super.deActivate();
        (0, $7a118ec64e6e60c8$export$2e2bcd8739ae039).clear();
    };
    onKeyDown = (ev)=>{
        this.isKeyDown = true;
        switch(this.state.shape?.type){
            case "customized":
                return (0, $7a118ec64e6e60c8$export$2e2bcd8739ae039).onKeyDown(ev, this);
            case "ellipse":
            case "rect":
            case "circle":
            default:
        }
    };
    onKeyUp = (ev)=>{
        this.isKeyDown = false;
        switch(this.state.shape?.type){
            case "customized":
                return (0, $7a118ec64e6e60c8$export$2e2bcd8739ae039).onKeyUp(ev, this);
            case "ellipse":
            case "rect":
            case "circle":
            default:
        }
    };
    onPointerUp = (ev)=>{
        console.log("Select.onPointerUp", ev);
        if (!this.isKeyDown) {
            if (ev.target?.data) this.actions.setShape(ev.target?.data);
            return;
        }
        switch(this.state.shape?.type){
            case "customized":
                return (0, $7a118ec64e6e60c8$export$2e2bcd8739ae039).onPointerUp(ev, this);
            case "ellipse":
            case "rect":
            case "circle":
            default:
        }
    };
}
// singleton
const $e1100aa3998188ed$var$tool = new $e1100aa3998188ed$var$SelectTool();
var $e1100aa3998188ed$export$2e2bcd8739ae039 = $e1100aa3998188ed$var$tool;





var $35jnV = parcelRequire("35jnV");



function $cde751e4fd90e476$export$2e2bcd8739ae039() {
    const [tool, setTool] = (0, $35jnV.useState)((0, $e1100aa3998188ed$export$2e2bcd8739ae039));
    const scene = (0, $2bb019ac2e75721b$export$2e2bcd8739ae039)((state)=>state.scene);
    const selectedFile = (0, $5a88544a0e784883$export$2e2bcd8739ae039)((state)=>state.selected);
    const [selectedShape, setSelectedShape, addShape, removeShape, updateShape] = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039)((0, $9384c319ea675985$export$180f5a427f17c0fe)((state)=>[
            state.selected,
            state.setSelected,
            state.add,
            state.remove,
            state.update
        ]));
    const precision = (0, $078bc949f5227a17$export$2e2bcd8739ae039)((state)=>state.precision);
    (0, $35jnV.useEffect)(()=>{
        tool.activate({
            state: {
                scene: scene,
                shape: selectedShape,
                precision: precision
            },
            actions: {
                setTool: setTool,
                addShape: (shape)=>addShape(selectedFile, shape),
                removeShape: (shape)=>removeShape(selectedFile, shape),
                updateShape: updateShape,
                setShape: setSelectedShape
            }
        });
        return ()=>{
            tool.deActivate();
        };
    }, [
        tool,
        scene,
        setTool,
        selectedFile,
        selectedShape,
        setSelectedShape,
        addShape,
        removeShape,
        precision
    ]);
    return (0, $35jnV.useMemo)(()=>[
            tool,
            setTool
        ], [
        tool,
        setTool
    ]);
}


const $63e50d6a5d2e89f9$var$ToolSet = [
    {
        icon: /*#__PURE__*/ (0, $86rqb.jsx)((0, $da4c0e24f799b108$export$2e2bcd8739ae039), {
            className: (0, $3eTha.default)($32a8212dd292bdfe$export$1ca1ec8b29a4ce27, $32a8212dd292bdfe$export$8fa4e5556fd77a60)
        }),
        tool: $e1100aa3998188ed$export$2e2bcd8739ae039
    },
    {
        icon: /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b8aafabe628b3703$exports))), {
            fontSize: "medium",
            color: "action"
        }),
        tool: $583123352b65d5f1$export$2e2bcd8739ae039
    },
    {
        icon: /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4f8a499d1aa7e166$exports))), {
            fontSize: "medium",
            color: "action"
        }),
        tool: $5e8c48b66a5cfdb2$export$2e2bcd8739ae039
    },
    {
        icon: /*#__PURE__*/ (0, $86rqb.jsx)((0, $dbc5c032f60b5085$export$2e2bcd8739ae039), {
            className: (0, $3eTha.default)($32a8212dd292bdfe$export$1ca1ec8b29a4ce27, $32a8212dd292bdfe$export$8fa4e5556fd77a60)
        }),
        tool: $415adcf31d57ed3a$export$2e2bcd8739ae039
    },
    {
        icon: /*#__PURE__*/ (0, $86rqb.jsx)((0, $747b01d3e1fed58f$export$2e2bcd8739ae039), {
            className: (0, $3eTha.default)($32a8212dd292bdfe$export$1ca1ec8b29a4ce27, $32a8212dd292bdfe$export$8fa4e5556fd77a60)
        }),
        tool: $7a118ec64e6e60c8$export$2e2bcd8739ae039
    }
];
const $63e50d6a5d2e89f9$var$TopToolBar = (props)=>{
    const [tool, setTool] = (0, $cde751e4fd90e476$export$2e2bcd8739ae039)();
    const files = (0, $5a88544a0e784883$export$2e2bcd8739ae039)((state)=>state.files);
    const [selected, setSelected] = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039)((0, $9384c319ea675985$export$180f5a427f17c0fe)((state)=>[
            state.selected,
            state.setSelected
        ]));
    const onToolClick = (0, $35jnV.useCallback)((t)=>{
        setTool(t);
        if (t.name !== "select") setSelected(null);
    }, [
        setTool
    ]);
    (0, $35jnV.useEffect)(()=>{
        if (selected && tool.name !== "select") setTool($e1100aa3998188ed$export$2e2bcd8739ae039);
        return ()=>{};
    }, [
        tool,
        selected
    ]);
    return files.length ? /*#__PURE__*/ (0, $86rqb.jsx)("div", {
        className: (0, $3eTha.default)($32a8212dd292bdfe$export$f727f52c778e92d5, props.className),
        children: /*#__PURE__*/ (0, $86rqb.jsx)("div", {
            className: $32a8212dd292bdfe$export$120ff0929b202a6d,
            children: $63e50d6a5d2e89f9$var$ToolSet.map((t)=>/*#__PURE__*/ (0, $86rqb.jsx)((0, $c94a9b0aec52d6ff$export$2e2bcd8739ae039), {
                    variant: tool.name === t.tool.name ? "outlined" : "text",
                    onClick: ()=>onToolClick(t.tool),
                    children: t.icon
                }, t.tool.name))
        })
    }) : null;
};
var $63e50d6a5d2e89f9$export$2e2bcd8739ae039 = $63e50d6a5d2e89f9$var$TopToolBar;



var $86rqb = parcelRequire("86rqb");

var $35jnV = parcelRequire("35jnV");

var $3eTha = parcelRequire("3eTha");


var $jBVCU = parcelRequire("jBVCU");

var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");


var $5wpQH = parcelRequire("5wpQH");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");
const $9a7bdf9018d474e7$var$visuallyHidden = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
};
var $9a7bdf9018d474e7$export$2e2bcd8739ae039 = $9a7bdf9018d474e7$var$visuallyHidden;


function $849b44a0869272fb$export$94fd53d40f0652a(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}


"use client";
const $ae5a206caee59654$var$INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function $ae5a206caee59654$var$asc(a, b) {
    return a - b;
}
function $ae5a206caee59654$var$clamp(value, min, max) {
    if (value == null) return min;
    return Math.min(Math.max(min, value), max);
}
function $ae5a206caee59654$var$findClosest(values, currentValue) {
    var _values$reduce;
    const { index: closestIndex } = (_values$reduce = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null)) != null ? _values$reduce : {};
    return closestIndex;
}
function $ae5a206caee59654$var$trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $ae5a206caee59654$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $ae5a206caee59654$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $ae5a206caee59654$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split("e-");
        const matissaDecimalPart = parts[0].split(".")[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split(".")[1];
    return decimalPart ? decimalPart.length : 0;
}
function $ae5a206caee59654$var$roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($ae5a206caee59654$var$getDecimalPrecision(step)));
}
function $ae5a206caee59654$var$setValueIndex({ values: values, newValue: newValue, index: index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort($ae5a206caee59654$var$asc);
}
function $ae5a206caee59654$var$focusThumb({ sliderRef: sliderRef, activeIndex: activeIndex, setActive: setActive }) {
    var _sliderRef$current, _doc$activeElement;
    const doc = (0, $0634ff1c5e38c440$export$2e2bcd8739ae039)(sliderRef.current);
    if (!((_sliderRef$current = sliderRef.current) != null && _sliderRef$current.contains(doc.activeElement)) || Number(doc == null || (_doc$activeElement = doc.activeElement) == null ? void 0 : _doc$activeElement.getAttribute("data-index")) !== activeIndex) {
        var _sliderRef$current2;
        (_sliderRef$current2 = sliderRef.current) == null || _sliderRef$current2.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    }
    if (setActive) setActive(activeIndex);
}
function $ae5a206caee59654$var$areValuesEqual(newValue, oldValue) {
    if (typeof newValue === "number" && typeof oldValue === "number") return newValue === oldValue;
    if (typeof newValue === "object" && typeof oldValue === "object") return (0, $849b44a0869272fb$export$94fd53d40f0652a)(newValue, oldValue);
    return false;
}
const $ae5a206caee59654$var$axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    "horizontal-reverse": {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const $ae5a206caee59654$export$544bf02140fa9a77 = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let $ae5a206caee59654$var$cachedSupportsTouchActionNone;
function $ae5a206caee59654$var$doesSupportTouchActionNone() {
    if ($ae5a206caee59654$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== "undefined" && typeof CSS.supports === "function") $ae5a206caee59654$var$cachedSupportsTouchActionNone = CSS.supports("touch-action", "none");
        else $ae5a206caee59654$var$cachedSupportsTouchActionNone = true;
    }
    return $ae5a206caee59654$var$cachedSupportsTouchActionNone;
}
function $ae5a206caee59654$export$56b2c08e277f365(parameters) {
    const { "aria-labelledby": ariaLabelledby, defaultValue: defaultValue, disabled: disabled = false, disableSwap: disableSwap = false, isRtl: isRtl = false, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = "horizontal", rootRef: ref, scale: scale = $ae5a206caee59654$export$544bf02140fa9a77, step: step = 1, tabIndex: tabIndex, value: valueProp } = parameters;
    const touchId = $35jnV.useRef();
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = $35jnV.useState(-1);
    const [open, setOpen] = $35jnV.useState(-1);
    const [dragging, setDragging] = $35jnV.useState(false);
    const moveCount = $35jnV.useRef(0);
    const [valueDerived, setValueState] = (0, $e107187cc2d89c6e$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue != null ? defaultValue : min,
        name: "Slider"
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, "target", {
            writable: true,
            value: {
                value: value,
                name: name
            }
        });
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort($ae5a206caee59654$var$asc) : [
        valueDerived
    ];
    values = values.map((value)=>$ae5a206caee59654$var$clamp(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $4b23040a1d448740$export$2e2bcd8739ae039)();
    const [focusedThumbIndex, setFocusedThumbIndex] = $35jnV.useState(-1);
    const sliderRef = $35jnV.useRef();
    const handleFocusRef = (0, $0516f23cce01a3cc$export$2e2bcd8739ae039)(focusVisibleRef, sliderRef);
    const handleRef = (0, $0516f23cce01a3cc$export$2e2bcd8739ae039)(ref, handleFocusRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            var _otherHandlers$onFocu;
            const index = Number(event.currentTarget.getAttribute("data-index"));
            handleFocusVisible(event);
            if (isFocusVisibleRef.current === true) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers == null || (_otherHandlers$onFocu = otherHandlers.onFocus) == null || _otherHandlers$onFocu.call(otherHandlers, event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            var _otherHandlers$onBlur;
            handleBlurVisible(event);
            if (isFocusVisibleRef.current === false) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers == null || (_otherHandlers$onBlur = otherHandlers.onBlur) == null || _otherHandlers$onBlur.call(otherHandlers, event);
        };
    (0, $6d8594980b4d41a4$export$2e2bcd8739ae039)(()=>{
        if (disabled && sliderRef.current.contains(document.activeElement)) {
            var _document$activeEleme;
            // This is necessary because Firefox and Safari will keep focus
            // on a disabled element:
            // https://codesandbox.io/s/mui-pr-22247-forked-h151h?file=/src/App.js
            // @ts-ignore
            (_document$activeEleme = document.activeElement) == null || _document$activeEleme.blur();
        }
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            var _otherHandlers$onChan;
            (_otherHandlers$onChan = otherHandlers.onChange) == null || _otherHandlers$onChan.call(otherHandlers, event);
            const index = Number(event.currentTarget.getAttribute("data-index"));
            const value = values[index];
            const marksIndex = marksValues.indexOf(value);
            // @ts-ignore
            let newValue = event.target.valueAsNumber;
            if (marks && step == null) {
                const maxMarksValue = marksValues[marksValues.length - 1];
                if (newValue > maxMarksValue) newValue = maxMarksValue;
                else if (newValue < marksValues[0]) newValue = marksValues[0];
                else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
            }
            newValue = $ae5a206caee59654$var$clamp(newValue, min, max);
            if (range) {
                // Bound the new value to the thumb's neighbours.
                if (disableSwap) newValue = $ae5a206caee59654$var$clamp(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
                const previousValue = newValue;
                newValue = $ae5a206caee59654$var$setValueIndex({
                    values: values,
                    newValue: newValue,
                    index: index
                });
                let activeIndex = index;
                // Potentially swap the index if needed.
                if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
                $ae5a206caee59654$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex
                });
            }
            setValueState(newValue);
            setFocusedThumbIndex(index);
            if (handleChange && !$ae5a206caee59654$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
            if (onChangeCommitted) onChangeCommitted(event, newValue);
        };
    const previousIndex = $35jnV.useRef();
    let axis = orientation;
    if (isRtl && orientation === "horizontal") axis += "-reverse";
    const getFingerNewValue = ({ finger: finger, move: move = false })=>{
        const { current: slider } = sliderRef;
        const { width: width, height: height, bottom: bottom, left: left } = slider.getBoundingClientRect();
        let percent;
        if (axis.indexOf("vertical") === 0) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.indexOf("-reverse") !== -1) percent = 1 - percent;
        let newValue;
        newValue = $ae5a206caee59654$var$percentToValue(percent, min, max);
        if (step) newValue = $ae5a206caee59654$var$roundValueToStep(newValue, step, min);
        else {
            const closestIndex = $ae5a206caee59654$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = $ae5a206caee59654$var$clamp(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $ae5a206caee59654$var$findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = $ae5a206caee59654$var$clamp(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = $ae5a206caee59654$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    const handleTouchMove = (0, $6fd92d7c6a65060f$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $ae5a206caee59654$var$trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === "mousemove" && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
            finger: finger,
            move: true
        });
        $ae5a206caee59654$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > $ae5a206caee59654$var$INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !$ae5a206caee59654$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, $6fd92d7c6a65060f$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $ae5a206caee59654$var$trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue: newValue } = getFingerNewValue({
            finger: finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === "touchend") setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, $6fd92d7c6a65060f$export$2e2bcd8739ae039)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$ae5a206caee59654$var$doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = $ae5a206caee59654$var$trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                finger: finger
            });
            $ae5a206caee59654$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex,
                setActive: setActive
            });
            setValueState(newValue);
            if (handleChange && !$ae5a206caee59654$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, $0634ff1c5e38c440$export$2e2bcd8739ae039)(sliderRef.current);
        doc.addEventListener("touchmove", handleTouchMove);
        doc.addEventListener("touchend", handleTouchEnd);
    });
    const stopListening = $35jnV.useCallback(()=>{
        const doc = (0, $0634ff1c5e38c440$export$2e2bcd8739ae039)(sliderRef.current);
        doc.removeEventListener("mousemove", handleTouchMove);
        doc.removeEventListener("mouseup", handleTouchEnd);
        doc.removeEventListener("touchmove", handleTouchMove);
        doc.removeEventListener("touchend", handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    $35jnV.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener("touchstart", handleTouchStart, {
            passive: $ae5a206caee59654$var$doesSupportTouchActionNone()
        });
        return ()=>{
            // @ts-ignore
            slider.removeEventListener("touchstart", handleTouchStart, {
                passive: $ae5a206caee59654$var$doesSupportTouchActionNone()
            });
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    $35jnV.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous;
            (_otherHandlers$onMous = otherHandlers.onMouseDown) == null || _otherHandlers$onMous.call(otherHandlers, event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = $ae5a206caee59654$var$trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                    finger: finger
                });
                $ae5a206caee59654$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex,
                    setActive: setActive
                });
                setValueState(newValue);
                if (handleChange && !$ae5a206caee59654$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, $0634ff1c5e38c440$export$2e2bcd8739ae039)(sliderRef.current);
            doc.addEventListener("mousemove", handleTouchMove);
            doc.addEventListener("mouseup", handleTouchEnd);
        };
    const trackOffset = $ae5a206caee59654$export$83ce4bc8280540e6(range ? values[0] : min, min, max);
    const trackLeap = $ae5a206caee59654$export$83ce4bc8280540e6(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, $fdc0f5c8deb0c27f$export$24d5698b57eff81c)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = (0, $lfXYn.default)({}, externalHandlers, ownEventHandlers);
        return (0, $lfXYn.default)({}, externalProps, {
            ref: handleRef
        }, mergedEventHandlers);
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous2;
            (_otherHandlers$onMous2 = otherHandlers.onMouseOver) == null || _otherHandlers$onMous2.call(otherHandlers, event);
            const index = Number(event.currentTarget.getAttribute("data-index"));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous3;
            (_otherHandlers$onMous3 = otherHandlers.onMouseLeave) == null || _otherHandlers$onMous3.call(otherHandlers, event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, $fdc0f5c8deb0c27f$export$24d5698b57eff81c)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return (0, $lfXYn.default)({}, externalProps, externalHandlers, ownEventHandlers);
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? "none" : undefined
        };
    };
    const getHiddenInputProps = (externalProps = {})=>{
        var _parameters$step;
        const externalHandlers = (0, $fdc0f5c8deb0c27f$export$24d5698b57eff81c)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {})
        };
        const mergedEventHandlers = (0, $lfXYn.default)({}, externalHandlers, ownEventHandlers);
        return (0, $lfXYn.default)({
            tabIndex: tabIndex,
            "aria-labelledby": ariaLabelledby,
            "aria-orientation": orientation,
            "aria-valuemax": scale(max),
            "aria-valuemin": scale(min),
            name: name,
            type: "range",
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? "any" : (_parameters$step = parameters.step) != null ? _parameters$step : undefined,
            disabled: disabled
        }, externalProps, mergedEventHandlers, {
            style: (0, $lfXYn.default)({}, (0, $9a7bdf9018d474e7$export$2e2bcd8739ae039), {
                direction: isRtl ? "rtl" : "ltr",
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: "100%",
                height: "100%"
            })
        });
    };
    return {
        active: active,
        axis: axis,
        axisProps: $ae5a206caee59654$var$axisProps,
        dragging: dragging,
        focusedThumbIndex: focusedThumbIndex,
        getHiddenInputProps: getHiddenInputProps,
        getRootProps: getRootProps,
        getThumbProps: getThumbProps,
        marks: marks,
        open: open,
        range: range,
        rootRef: handleRef,
        trackLeap: trackLeap,
        trackOffset: trackOffset,
        values: values,
        getThumbStyle: getThumbStyle
    };
}



var $a7jdq = parcelRequire("a7jdq");

var $hZybU = parcelRequire("hZybU");

var $jBVCU = parcelRequire("jBVCU");


const $3dc2ba25d22d6a4d$var$shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, $34edd9d120733306$export$e28348cc2430497)(Slot);
};
var $3dc2ba25d22d6a4d$export$2e2bcd8739ae039 = $3dc2ba25d22d6a4d$var$shouldSpreadAdditionalProps;



var $1OAmh = parcelRequire("1OAmh");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $654eab6b4dd81516$export$9f59f2622d5cbc2a(slot) {
    return (0, $1reLR.default)("MuiSlider", slot);
}
const $654eab6b4dd81516$var$sliderClasses = (0, $ibC2g.default)("MuiSlider", [
    "root",
    "active",
    "colorPrimary",
    "colorSecondary",
    "disabled",
    "dragging",
    "focusVisible",
    "mark",
    "markActive",
    "marked",
    "markLabel",
    "markLabelActive",
    "rail",
    "sizeSmall",
    "thumb",
    "thumbColorPrimary",
    "thumbColorSecondary",
    "track",
    "trackInverted",
    "trackFalse",
    "thumbSizeSmall",
    "valueLabel",
    "valueLabelOpen",
    "valueLabelCircle",
    "valueLabelLabel",
    "vertical"
]);
var $654eab6b4dd81516$export$2e2bcd8739ae039 = $654eab6b4dd81516$var$sliderClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $88dc5a8e9643b5f5$var$useValueLabelClasses = (props)=>{
    const { open: open } = props;
    const utilityClasses = {
        offset: (0, $3eTha.default)(open && (0, $654eab6b4dd81516$export$2e2bcd8739ae039).valueLabelOpen),
        circle: (0, $654eab6b4dd81516$export$2e2bcd8739ae039).valueLabelCircle,
        label: (0, $654eab6b4dd81516$export$2e2bcd8739ae039).valueLabelLabel
    };
    return utilityClasses;
};
function $88dc5a8e9643b5f5$export$2e2bcd8739ae039(props) {
    const { children: children, className: className, value: value } = props;
    const classes = $88dc5a8e9643b5f5$var$useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ $35jnV.cloneElement(children, {
        className: (0, $3eTha.default)(children.props.className)
    }, /*#__PURE__*/ (0, $86rqb.jsxs)($35jnV.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, $86rqb.jsx)("span", {
                className: (0, $3eTha.default)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $86rqb.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, $86rqb.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}




var $86rqb = parcelRequire("86rqb");
"use client";
const $a3e5dd3600088bd8$var$_excluded = [
    "aria-label",
    "aria-valuetext",
    "aria-labelledby",
    "component",
    "components",
    "componentsProps",
    "color",
    "classes",
    "className",
    "disableSwap",
    "disabled",
    "getAriaLabel",
    "getAriaValueText",
    "marks",
    "max",
    "min",
    "name",
    "onChange",
    "onChangeCommitted",
    "orientation",
    "size",
    "step",
    "scale",
    "slotProps",
    "slots",
    "tabIndex",
    "track",
    "value",
    "valueLabelDisplay",
    "valueLabelFormat"
];
function $a3e5dd3600088bd8$var$Identity(x) {
    return x;
}
const $a3e5dd3600088bd8$export$c1a21b3b4da66aa1 = (0, $jBVCU.default)("span", {
    name: "MuiSlider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $1OAmh.default)(ownerState.color)}`],
            ownerState.size !== "medium" && styles[`size${(0, $1OAmh.default)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.track === "inverted" && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        borderRadius: 12,
        boxSizing: "content-box",
        display: "inline-block",
        position: "relative",
        cursor: "pointer",
        touchAction: "none",
        color: (theme.vars || theme).palette[ownerState.color].main,
        WebkitTapHighlightColor: "transparent"
    }, ownerState.orientation === "horizontal" && (0, $lfXYn.default)({
        height: 4,
        width: "100%",
        padding: "13px 0",
        // The primary input mechanism of the device includes a pointing device of limited accuracy.
        "@media (pointer: coarse)": {
            // Reach 42px touch target, about ~8mm on screen.
            padding: "20px 0"
        }
    }, ownerState.size === "small" && {
        height: 2
    }, ownerState.marked && {
        marginBottom: 20
    }), ownerState.orientation === "vertical" && (0, $lfXYn.default)({
        height: "100%",
        width: 4,
        padding: "0 13px",
        // The primary input mechanism of the device includes a pointing device of limited accuracy.
        "@media (pointer: coarse)": {
            // Reach 42px touch target, about ~8mm on screen.
            padding: "0 20px"
        }
    }, ownerState.size === "small" && {
        width: 2
    }, ownerState.marked && {
        marginRight: 44
    }), {
        "@media print": {
            colorAdjust: "exact"
        },
        [`&.${(0, $654eab6b4dd81516$export$2e2bcd8739ae039).disabled}`]: {
            pointerEvents: "none",
            cursor: "default",
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${(0, $654eab6b4dd81516$export$2e2bcd8739ae039).dragging}`]: {
            [`& .${(0, $654eab6b4dd81516$export$2e2bcd8739ae039).thumb}, & .${(0, $654eab6b4dd81516$export$2e2bcd8739ae039).track}`]: {
                transition: "none"
            }
        }
    }));
const $a3e5dd3600088bd8$export$b02fde61a3559c2 = (0, $jBVCU.default)("span", {
    name: "MuiSlider",
    slot: "Rail",
    overridesResolver: (props, styles)=>styles.rail
})(({ ownerState: ownerState })=>(0, $lfXYn.default)({
        display: "block",
        position: "absolute",
        borderRadius: "inherit",
        backgroundColor: "currentColor",
        opacity: 0.38
    }, ownerState.orientation === "horizontal" && {
        width: "100%",
        height: "inherit",
        top: "50%",
        transform: "translateY(-50%)"
    }, ownerState.orientation === "vertical" && {
        height: "100%",
        width: "inherit",
        left: "50%",
        transform: "translateX(-50%)"
    }, ownerState.track === "inverted" && {
        opacity: 1
    }));
const $a3e5dd3600088bd8$export$105594979f116971 = (0, $jBVCU.default)("span", {
    name: "MuiSlider",
    slot: "Track",
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme, ownerState: ownerState })=>{
    const color = // Same logic as the LinearProgress track color
    theme.palette.mode === "light" ? (0, $a7jdq.lighten)(theme.palette[ownerState.color].main, 0.62) : (0, $a7jdq.darken)(theme.palette[ownerState.color].main, 0.5);
    return (0, $lfXYn.default)({
        display: "block",
        position: "absolute",
        borderRadius: "inherit",
        border: "1px solid currentColor",
        backgroundColor: "currentColor",
        transition: theme.transitions.create([
            "left",
            "width",
            "bottom",
            "height"
        ], {
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.size === "small" && {
        border: "none"
    }, ownerState.orientation === "horizontal" && {
        height: "inherit",
        top: "50%",
        transform: "translateY(-50%)"
    }, ownerState.orientation === "vertical" && {
        width: "inherit",
        left: "50%",
        transform: "translateX(-50%)"
    }, ownerState.track === false && {
        display: "none"
    }, ownerState.track === "inverted" && {
        backgroundColor: theme.vars ? theme.vars.palette.Slider[`${ownerState.color}Track`] : color,
        borderColor: theme.vars ? theme.vars.palette.Slider[`${ownerState.color}Track`] : color
    });
});
const $a3e5dd3600088bd8$export$2c1b491743890dec = (0, $jBVCU.default)("span", {
    name: "MuiSlider",
    slot: "Thumb",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, $1OAmh.default)(ownerState.color)}`],
            ownerState.size !== "medium" && styles[`thumbSize${(0, $1OAmh.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        position: "absolute",
        width: 20,
        height: 20,
        boxSizing: "border-box",
        borderRadius: "50%",
        outline: 0,
        backgroundColor: "currentColor",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: theme.transitions.create([
            "box-shadow",
            "left",
            "bottom"
        ], {
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.size === "small" && {
        width: 12,
        height: 12
    }, ownerState.orientation === "horizontal" && {
        top: "50%",
        transform: "translate(-50%, -50%)"
    }, ownerState.orientation === "vertical" && {
        left: "50%",
        transform: "translate(-50%, 50%)"
    }, {
        "&:before": (0, $lfXYn.default)({
            position: "absolute",
            content: '""',
            borderRadius: "inherit",
            width: "100%",
            height: "100%",
            boxShadow: (theme.vars || theme).shadows[2]
        }, ownerState.size === "small" && {
            boxShadow: "none"
        }),
        "&::after": {
            position: "absolute",
            content: '""',
            borderRadius: "50%",
            // 42px is the hit target
            width: 42,
            height: 42,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
        },
        [`&:hover, &.${(0, $654eab6b4dd81516$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: `0px 0px 0px 8px ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.16)` : (0, $a7jdq.alpha)(theme.palette[ownerState.color].main, 0.16)}`,
            "@media (hover: none)": {
                boxShadow: "none"
            }
        },
        [`&.${(0, $654eab6b4dd81516$export$2e2bcd8739ae039).active}`]: {
            boxShadow: `0px 0px 0px 14px ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.16)` : (0, $a7jdq.alpha)(theme.palette[ownerState.color].main, 0.16)}`
        },
        [`&.${(0, $654eab6b4dd81516$export$2e2bcd8739ae039).disabled}`]: {
            "&:hover": {
                boxShadow: "none"
            }
        }
    }));
const $a3e5dd3600088bd8$export$6453176f504d54f0 = (0, $jBVCU.default)((0, $88dc5a8e9643b5f5$export$2e2bcd8739ae039), {
    name: "MuiSlider",
    slot: "ValueLabel",
    overridesResolver: (props, styles)=>styles.valueLabel
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        [`&.${(0, $654eab6b4dd81516$export$2e2bcd8739ae039).valueLabelOpen}`]: {
            transform: `${ownerState.orientation === "vertical" ? "translateY(-50%)" : "translateY(-100%)"} scale(1)`
        },
        zIndex: 1,
        whiteSpace: "nowrap"
    }, theme.typography.body2, {
        fontWeight: 500,
        transition: theme.transitions.create([
            "transform"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        transform: `${ownerState.orientation === "vertical" ? "translateY(-50%)" : "translateY(-100%)"} scale(0)`,
        position: "absolute",
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0.25rem 0.75rem"
    }, ownerState.orientation === "horizontal" && {
        top: "-10px",
        transformOrigin: "bottom center",
        "&:before": {
            position: "absolute",
            content: '""',
            width: 8,
            height: 8,
            transform: "translate(-50%, 50%) rotate(45deg)",
            backgroundColor: "inherit",
            bottom: 0,
            left: "50%"
        }
    }, ownerState.orientation === "vertical" && {
        right: ownerState.size === "small" ? "20px" : "30px",
        top: "50%",
        transformOrigin: "right center",
        "&:before": {
            position: "absolute",
            content: '""',
            width: 8,
            height: 8,
            transform: "translate(-50%, -50%) rotate(45deg)",
            backgroundColor: "inherit",
            right: -8,
            top: "50%"
        }
    }, ownerState.size === "small" && {
        fontSize: theme.typography.pxToRem(12),
        padding: "0.25rem 0.5rem"
    }));
const $a3e5dd3600088bd8$export$6f85f6a3c5da6f62 = (0, $jBVCU.default)("span", {
    name: "MuiSlider",
    slot: "Mark",
    shouldForwardProp: (prop)=>(0, $jBVCU.slotShouldForwardProp)(prop) && prop !== "markActive",
    overridesResolver: (props, styles)=>{
        const { markActive: markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})(({ theme: theme, ownerState: ownerState, markActive: markActive })=>(0, $lfXYn.default)({
        position: "absolute",
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: "currentColor"
    }, ownerState.orientation === "horizontal" && {
        top: "50%",
        transform: "translate(-1px, -50%)"
    }, ownerState.orientation === "vertical" && {
        left: "50%",
        transform: "translate(-50%, 1px)"
    }, markActive && {
        backgroundColor: (theme.vars || theme).palette.background.paper,
        opacity: 0.8
    }));
const $a3e5dd3600088bd8$export$e6cd369965e5aa95 = (0, $jBVCU.default)("span", {
    name: "MuiSlider",
    slot: "MarkLabel",
    shouldForwardProp: (prop)=>(0, $jBVCU.slotShouldForwardProp)(prop) && prop !== "markLabelActive",
    overridesResolver: (props, styles)=>styles.markLabel
})(({ theme: theme, ownerState: ownerState, markLabelActive: markLabelActive })=>(0, $lfXYn.default)({}, theme.typography.body2, {
        color: (theme.vars || theme).palette.text.secondary,
        position: "absolute",
        whiteSpace: "nowrap"
    }, ownerState.orientation === "horizontal" && {
        top: 30,
        transform: "translateX(-50%)",
        "@media (pointer: coarse)": {
            top: 40
        }
    }, ownerState.orientation === "vertical" && {
        left: 36,
        transform: "translateY(50%)",
        "@media (pointer: coarse)": {
            left: 44
        }
    }, markLabelActive && {
        color: (theme.vars || theme).palette.text.primary
    }));
const $a3e5dd3600088bd8$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dragging: dragging, marked: marked, orientation: orientation, track: track, classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            dragging && "dragging",
            marked && "marked",
            orientation === "vertical" && "vertical",
            track === "inverted" && "trackInverted",
            track === false && "trackFalse",
            color && `color${(0, $1OAmh.default)(color)}`,
            size && `size${(0, $1OAmh.default)(size)}`
        ],
        rail: [
            "rail"
        ],
        track: [
            "track"
        ],
        mark: [
            "mark"
        ],
        markActive: [
            "markActive"
        ],
        markLabel: [
            "markLabel"
        ],
        markLabelActive: [
            "markLabelActive"
        ],
        valueLabel: [
            "valueLabel"
        ],
        thumb: [
            "thumb",
            disabled && "disabled",
            size && `thumbSize${(0, $1OAmh.default)(size)}`,
            color && `thumbColor${(0, $1OAmh.default)(color)}`
        ],
        active: [
            "active"
        ],
        disabled: [
            "disabled"
        ],
        focusVisible: [
            "focusVisible"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $654eab6b4dd81516$export$9f59f2622d5cbc2a), classes);
};
const $a3e5dd3600088bd8$var$Forward = ({ children: children })=>children;
const $a3e5dd3600088bd8$var$Slider = /*#__PURE__*/ $35jnV.forwardRef(function Slider(inputProps, ref) {
    var _ref, _slots$root, _ref2, _slots$rail, _ref3, _slots$track, _ref4, _slots$thumb, _ref5, _slots$valueLabel, _ref6, _slots$mark, _ref7, _slots$markLabel, _ref8, _slots$input, _slotProps$root, _slotProps$rail, _slotProps$track, _slotProps$thumb, _slotProps$valueLabel, _slotProps$mark, _slotProps$markLabel, _slotProps$input;
    const props = (0, $hZybU.default)({
        props: inputProps,
        name: "MuiSlider"
    });
    const theme = (0, $e83902653e135773$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const { "aria-label": ariaLabel, "aria-valuetext": ariaValuetext, "aria-labelledby": ariaLabelledby, component: // eslint-disable-next-line react/prop-types
    component = "span", components: components = {}, componentsProps: componentsProps = {}, color: color = "primary", classes: classesProp, className: className, disableSwap: disableSwap = false, disabled: disabled = false, getAriaLabel: getAriaLabel, getAriaValueText: getAriaValueText, marks: marksProp = false, max: max = 100, min: min = 0, orientation: orientation = "horizontal", size: size = "medium", step: step = 1, scale: scale = $a3e5dd3600088bd8$var$Identity, slotProps: slotProps, slots: slots, track: track = "normal", valueLabelDisplay: valueLabelDisplay = "off", valueLabelFormat: valueLabelFormat = $a3e5dd3600088bd8$var$Identity } = props, other = (0, $5NWw9.default)(props, $a3e5dd3600088bd8$var$_excluded);
    const ownerState = (0, $lfXYn.default)({}, props, {
        isRtl: isRtl,
        max: max,
        min: min,
        classes: classesProp,
        disabled: disabled,
        disableSwap: disableSwap,
        orientation: orientation,
        marks: marksProp,
        color: color,
        size: size,
        step: step,
        scale: scale,
        track: track,
        valueLabelDisplay: valueLabelDisplay,
        valueLabelFormat: valueLabelFormat
    });
    const { axisProps: axisProps, getRootProps: getRootProps, getHiddenInputProps: getHiddenInputProps, getThumbProps: getThumbProps, open: open, active: active, axis: axis, focusedThumbIndex: focusedThumbIndex, range: range, dragging: dragging, marks: marks, values: values, trackOffset: trackOffset, trackLeap: trackLeap, getThumbStyle: getThumbStyle } = (0, $ae5a206caee59654$export$56b2c08e277f365)((0, $lfXYn.default)({}, ownerState, {
        rootRef: ref
    }));
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = $a3e5dd3600088bd8$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $a3e5dd3600088bd8$export$c1a21b3b4da66aa1;
    const RailSlot = (_ref2 = (_slots$rail = slots == null ? void 0 : slots.rail) != null ? _slots$rail : components.Rail) != null ? _ref2 : $a3e5dd3600088bd8$export$b02fde61a3559c2;
    const TrackSlot = (_ref3 = (_slots$track = slots == null ? void 0 : slots.track) != null ? _slots$track : components.Track) != null ? _ref3 : $a3e5dd3600088bd8$export$105594979f116971;
    const ThumbSlot = (_ref4 = (_slots$thumb = slots == null ? void 0 : slots.thumb) != null ? _slots$thumb : components.Thumb) != null ? _ref4 : $a3e5dd3600088bd8$export$2c1b491743890dec;
    const ValueLabelSlot = (_ref5 = (_slots$valueLabel = slots == null ? void 0 : slots.valueLabel) != null ? _slots$valueLabel : components.ValueLabel) != null ? _ref5 : $a3e5dd3600088bd8$export$6453176f504d54f0;
    const MarkSlot = (_ref6 = (_slots$mark = slots == null ? void 0 : slots.mark) != null ? _slots$mark : components.Mark) != null ? _ref6 : $a3e5dd3600088bd8$export$6f85f6a3c5da6f62;
    const MarkLabelSlot = (_ref7 = (_slots$markLabel = slots == null ? void 0 : slots.markLabel) != null ? _slots$markLabel : components.MarkLabel) != null ? _ref7 : $a3e5dd3600088bd8$export$e6cd369965e5aa95;
    const InputSlot = (_ref8 = (_slots$input = slots == null ? void 0 : slots.input) != null ? _slots$input : components.Input) != null ? _ref8 : "input";
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const railSlotProps = (_slotProps$rail = slotProps == null ? void 0 : slotProps.rail) != null ? _slotProps$rail : componentsProps.rail;
    const trackSlotProps = (_slotProps$track = slotProps == null ? void 0 : slotProps.track) != null ? _slotProps$track : componentsProps.track;
    const thumbSlotProps = (_slotProps$thumb = slotProps == null ? void 0 : slotProps.thumb) != null ? _slotProps$thumb : componentsProps.thumb;
    const valueLabelSlotProps = (_slotProps$valueLabel = slotProps == null ? void 0 : slotProps.valueLabel) != null ? _slotProps$valueLabel : componentsProps.valueLabel;
    const markSlotProps = (_slotProps$mark = slotProps == null ? void 0 : slotProps.mark) != null ? _slotProps$mark : componentsProps.mark;
    const markLabelSlotProps = (_slotProps$markLabel = slotProps == null ? void 0 : slotProps.markLabel) != null ? _slotProps$markLabel : componentsProps.markLabel;
    const inputSlotProps = (_slotProps$input = slotProps == null ? void 0 : slotProps.input) != null ? _slotProps$input : componentsProps.input;
    const rootProps = (0, $de1586982a0c1b8f$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: (0, $lfXYn.default)({}, (0, $3dc2ba25d22d6a4d$export$2e2bcd8739ae039)(RootSlot) && {
            as: component
        }),
        ownerState: (0, $lfXYn.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, $de1586982a0c1b8f$export$1e5c9e6e4e15efe3)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState: ownerState,
        className: classes.rail
    });
    const trackProps = (0, $de1586982a0c1b8f$export$1e5c9e6e4e15efe3)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: (0, $lfXYn.default)({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap))
        },
        ownerState: (0, $lfXYn.default)({}, ownerState, trackSlotProps == null ? void 0 : trackSlotProps.ownerState),
        className: classes.track
    });
    const thumbProps = (0, $de1586982a0c1b8f$export$1e5c9e6e4e15efe3)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: (0, $lfXYn.default)({}, ownerState, thumbSlotProps == null ? void 0 : thumbSlotProps.ownerState),
        className: classes.thumb
    });
    const valueLabelProps = (0, $de1586982a0c1b8f$export$1e5c9e6e4e15efe3)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: (0, $lfXYn.default)({}, ownerState, valueLabelSlotProps == null ? void 0 : valueLabelSlotProps.ownerState),
        className: classes.valueLabel
    });
    const markProps = (0, $de1586982a0c1b8f$export$1e5c9e6e4e15efe3)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState: ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, $de1586982a0c1b8f$export$1e5c9e6e4e15efe3)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState: ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, $de1586982a0c1b8f$export$1e5c9e6e4e15efe3)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $86rqb.jsxs)(RootSlot, (0, $lfXYn.default)({}, rootProps, {
        children: [
            /*#__PURE__*/ (0, $86rqb.jsx)(RailSlot, (0, $lfXYn.default)({}, railProps)),
            /*#__PURE__*/ (0, $86rqb.jsx)(TrackSlot, (0, $lfXYn.default)({}, trackProps)),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, $ae5a206caee59654$export$83ce4bc8280540e6)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.indexOf(mark.value) !== -1;
                else markActive = track === "normal" && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === "inverted" && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, $86rqb.jsxs)($35jnV.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $86rqb.jsx)(MarkSlot, (0, $lfXYn.default)({
                            "data-index": index
                        }, markProps, !(0, $34edd9d120733306$export$e28348cc2430497)(MarkSlot) && {
                            markActive: markActive
                        }, {
                            style: (0, $lfXYn.default)({}, style, markProps.style),
                            className: (0, $3eTha.default)(markProps.className, markActive && classes.markActive)
                        })),
                        mark.label != null ? /*#__PURE__*/ (0, $86rqb.jsx)(MarkLabelSlot, (0, $lfXYn.default)({
                            "aria-hidden": true,
                            "data-index": index
                        }, markLabelProps, !(0, $34edd9d120733306$export$e28348cc2430497)(MarkLabelSlot) && {
                            markLabelActive: markActive
                        }, {
                            style: (0, $lfXYn.default)({}, style, markLabelProps.style),
                            className: (0, $3eTha.default)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        })) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, $ae5a206caee59654$export$83ce4bc8280540e6)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === "off" ? $a3e5dd3600088bd8$var$Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, $86rqb.jsx)(ValueLabelComponent, (0, $lfXYn.default)({}, !(0, $34edd9d120733306$export$e28348cc2430497)(ValueLabelComponent) && {
                    valueLabelFormat: valueLabelFormat,
                    valueLabelDisplay: valueLabelDisplay,
                    value: typeof valueLabelFormat === "function" ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                    index: index,
                    open: open === index || active === index || valueLabelDisplay === "on",
                    disabled: disabled
                }, valueLabelProps, {
                    children: /*#__PURE__*/ (0, $86rqb.jsx)(ThumbSlot, (0, $lfXYn.default)({
                        "data-index": index
                    }, thumbProps, {
                        className: (0, $3eTha.default)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: (0, $lfXYn.default)({}, style, getThumbStyle(index), thumbProps.style),
                        children: /*#__PURE__*/ (0, $86rqb.jsx)(InputSlot, (0, $lfXYn.default)({
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index]
                        }, inputSliderProps))
                    }))
                }), index);
            })
        ]
    }));
});
var $a3e5dd3600088bd8$export$2e2bcd8739ae039 = $a3e5dd3600088bd8$var$Slider;




var $20e8c0995c8eeab5$exports = {};
"use strict";
"use client";

Object.defineProperty($20e8c0995c8eeab5$exports, "__esModule", {
    value: true
});
$20e8c0995c8eeab5$exports.default = void 0;

var $20e8c0995c8eeab5$var$_createSvgIcon = $dd204784e51ffdae$exports((parcelRequire("2jyxe")));

var $86rqb = parcelRequire("86rqb");
var $20e8c0995c8eeab5$var$_default = (0, $20e8c0995c8eeab5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), "SearchOutlined");
$20e8c0995c8eeab5$exports.default = $20e8c0995c8eeab5$var$_default;



var $c0b949b6aa5557b3$export$f727f52c778e92d5;
var $c0b949b6aa5557b3$export$e83f174dbf56adcc;
$c0b949b6aa5557b3$export$f727f52c778e92d5 = `_1nq5CG_toolbar`;
$c0b949b6aa5557b3$export$e83f174dbf56adcc = `_1nq5CG_zoom`;


const $91619c8d41397771$var$CustomSlider = (0, $jBVCU.default)((0, $a3e5dd3600088bd8$export$2e2bcd8739ae039))({
    width: 150,
    margin: "0 25px 0 95px"
});
function $91619c8d41397771$export$2e2bcd8739ae039(props) {
    const [scale, setScale] = (0, $2bb019ac2e75721b$export$2e2bcd8739ae039)((0, $9384c319ea675985$export$180f5a427f17c0fe)((state)=>[
            state.scale,
            state.setScale
        ]));
    const onScaleChange = (0, $35jnV.useCallback)((ev)=>setScale(ev.target.value / 100), [
        setScale
    ]);
    const onScaleReset = (0, $35jnV.useCallback)(()=>setScale(1), [
        setScale
    ]);
    return /*#__PURE__*/ (0, $86rqb.jsxs)("div", {
        className: (0, $3eTha.default)($c0b949b6aa5557b3$export$f727f52c778e92d5, props.className),
        children: [
            /*#__PURE__*/ (0, $86rqb.jsxs)("div", {
                className: $c0b949b6aa5557b3$export$e83f174dbf56adcc,
                children: [
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($20e8c0995c8eeab5$exports))), {}),
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $f77466060e074182$export$2e2bcd8739ae039), {
                        sx: {
                            m: "5px"
                        }
                    }),
                    `${Math.floor(scale * 100)}%`
                ]
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)($91619c8d41397771$var$CustomSlider, {
                "aria-label": "Zoom",
                defaultValue: 100,
                step: 1,
                min: 10,
                max: 2000,
                value: scale * 100,
                onChange: onScaleChange
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $f77466060e074182$export$2e2bcd8739ae039), {
                sx: {
                    "& button": {
                        margin: "0 5px"
                    }
                },
                children: /*#__PURE__*/ (0, $86rqb.jsx)((0, $c94a9b0aec52d6ff$export$2e2bcd8739ae039), {
                    size: "small",
                    variant: "outlined",
                    onClick: onScaleReset,
                    children: "1:1"
                })
            })
        ]
    });
}



var $86rqb = parcelRequire("86rqb");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");

var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $4eb8b6521214c00c$export$81478e24460c57f2(slot) {
    return (0, $1reLR.default)("MuiListItemIcon", slot);
}
const $4eb8b6521214c00c$var$listItemIconClasses = (0, $ibC2g.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $4eb8b6521214c00c$export$2e2bcd8739ae039 = $4eb8b6521214c00c$var$listItemIconClasses;




var $86rqb = parcelRequire("86rqb");
"use client";
const $c20e29e06d0b903e$var$_excluded = [
    "className"
];
const $c20e29e06d0b903e$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            alignItems === "flex-start" && "alignItemsFlexStart"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $4eb8b6521214c00c$export$81478e24460c57f2), classes);
};
const $c20e29e06d0b903e$var$ListItemIconRoot = (0, $jBVCU.default)("div", {
    name: "MuiListItemIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: "inline-flex"
    }, ownerState.alignItems === "flex-start" && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $c20e29e06d0b903e$var$ListItemIcon = /*#__PURE__*/ $35jnV.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiListItemIcon"
    });
    const { className: className } = props, other = (0, $5NWw9.default)(props, $c20e29e06d0b903e$var$_excluded);
    const context = $35jnV.useContext((0, $e4ad3368c7db7760$export$2e2bcd8739ae039));
    const ownerState = (0, $lfXYn.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $c20e29e06d0b903e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsx)($c20e29e06d0b903e$var$ListItemIconRoot, (0, $lfXYn.default)({
        className: (0, $3eTha.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $c20e29e06d0b903e$export$2e2bcd8739ae039 = $c20e29e06d0b903e$var$ListItemIcon;



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");



var $hZybU = parcelRequire("hZybU");

var $jBVCU = parcelRequire("jBVCU");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $0402ce6717731189$export$1061006a0db3aeb5(slot) {
    return (0, $1reLR.default)("MuiListItemText", slot);
}
const $0402ce6717731189$var$listItemTextClasses = (0, $ibC2g.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $0402ce6717731189$export$2e2bcd8739ae039 = $0402ce6717731189$var$listItemTextClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $6e1b20d8aac02c31$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $6e1b20d8aac02c31$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $0402ce6717731189$export$1061006a0db3aeb5), classes);
};
const $6e1b20d8aac02c31$var$ListItemTextRoot = (0, $jBVCU.default)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $0402ce6717731189$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $0402ce6717731189$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $lfXYn.default)({
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $6e1b20d8aac02c31$var$ListItemText = /*#__PURE__*/ $35jnV.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $5NWw9.default)(props, $6e1b20d8aac02c31$var$_excluded);
    const { dense: dense } = $35jnV.useContext((0, $e4ad3368c7db7760$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $lfXYn.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $6e1b20d8aac02c31$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $3d9a9295100a327d$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $86rqb.jsx)((0, $3d9a9295100a327d$export$2e2bcd8739ae039), (0, $lfXYn.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : "span",
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $3d9a9295100a327d$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $86rqb.jsx)((0, $3d9a9295100a327d$export$2e2bcd8739ae039), (0, $lfXYn.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $86rqb.jsxs)($6e1b20d8aac02c31$var$ListItemTextRoot, (0, $lfXYn.default)({
        className: (0, $3eTha.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $6e1b20d8aac02c31$export$2e2bcd8739ae039 = $6e1b20d8aac02c31$var$ListItemText;



var $8d741701b2ec121f$exports = {};
"use strict";
"use client";

Object.defineProperty($8d741701b2ec121f$exports, "__esModule", {
    value: true
});
$8d741701b2ec121f$exports.default = void 0;

var $8d741701b2ec121f$var$_createSvgIcon = $dd204784e51ffdae$exports((parcelRequire("2jyxe")));

var $86rqb = parcelRequire("86rqb");
var $8d741701b2ec121f$var$_default = (0, $8d741701b2ec121f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");
$8d741701b2ec121f$exports.default = $8d741701b2ec121f$var$_default;








var $35jnV = parcelRequire("35jnV");
function $70064c6fa1c34aa5$export$2e2bcd8739ae039() {
    const listRef = (0, $35jnV.useRef)(null);
    const anchorRef = (0, $35jnV.useRef)(null);
    const listHeight = (0, $35jnV.useRef)(0);
    (0, $35jnV.useEffect)(()=>{
        const observer = new ResizeObserver(([entry])=>{
            const current = entry.contentRect.height;
            if (current > listHeight.current) anchorRef.current.scrollIntoView({
                behavior: "smooth"
            });
            listHeight.current = entry.contentRect.height;
        });
        observer.observe(listRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return (0, $35jnV.useMemo)(()=>[
            listRef,
            anchorRef
        ], []);
}


var $5a36cc81236ed8e1$export$1ca1ec8b29a4ce27;
var $5a36cc81236ed8e1$export$8837f4fc672e936d;
var $5a36cc81236ed8e1$export$8fa4e5556fd77a60;
$5a36cc81236ed8e1$export$1ca1ec8b29a4ce27 = `_0XfxPW_icon`;
$5a36cc81236ed8e1$export$8837f4fc672e936d = `_0XfxPW_list`;
$5a36cc81236ed8e1$export$8fa4e5556fd77a60 = `_0XfxPW_white`;


function $f849948450fc01bc$var$getIcon(type) {
    switch(type){
        case "rect":
            return /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b8aafabe628b3703$exports))), {
                fontSize: "medium",
                color: "action"
            });
        case "circle":
            return /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4f8a499d1aa7e166$exports))), {
                fontSize: "medium",
                color: "action"
            });
        case "ellipse":
            return /*#__PURE__*/ (0, $86rqb.jsx)((0, $dbc5c032f60b5085$export$2e2bcd8739ae039), {
                className: (0, $3eTha.default)($5a36cc81236ed8e1$export$1ca1ec8b29a4ce27, $5a36cc81236ed8e1$export$8fa4e5556fd77a60)
            });
        case "customized":
            return /*#__PURE__*/ (0, $86rqb.jsx)((0, $747b01d3e1fed58f$export$2e2bcd8739ae039), {
                className: (0, $3eTha.default)($5a36cc81236ed8e1$export$1ca1ec8b29a4ce27, $5a36cc81236ed8e1$export$8fa4e5556fd77a60)
            });
        default:
            return null;
    }
}
const $f849948450fc01bc$var$ShapeList = (props)=>{
    const selectedFile = (0, $5a88544a0e784883$export$2e2bcd8739ae039)((state)=>state.selected);
    const [shapesMap, selectedShape] = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039)((0, $9384c319ea675985$export$180f5a427f17c0fe)((state)=>[
            state.shapesMap,
            state.selected
        ]));
    const [listRef, anchorRef] = (0, $70064c6fa1c34aa5$export$2e2bcd8739ae039)();
    const onItemClick = (0, $35jnV.useCallback)((shape)=>{
        const { selected: selected, setSelected: setSelected } = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        setSelected(selected === shape ? null : shape) // toggle
        ;
    }, []);
    const onRemoveClick = (0, $35jnV.useCallback)((ev, shape)=>{
        ev.stopPropagation();
        const { selected: selectedFile } = (0, $5a88544a0e784883$export$2e2bcd8739ae039).getState();
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        const { scene: scene } = (0, $2bb019ac2e75721b$export$2e2bcd8739ae039).getState();
        ss.setSelected(null);
        ss.remove(selectedFile, shape);
        scene.removeChild(shape.container);
        shape.destroy(true);
    }, []);
    const list = shapesMap[selectedFile] || [];
    return /*#__PURE__*/ (0, $86rqb.jsx)("div", {
        className: (0, $3eTha.default)($5a36cc81236ed8e1$export$8837f4fc672e936d, props.className),
        children: /*#__PURE__*/ (0, $86rqb.jsxs)((0, $9babbdecd9fbf836$export$2e2bcd8739ae039), {
            ref: listRef,
            dense: true,
            disablePadding: !list.length,
            children: [
                list.map((shape)=>{
                    return /*#__PURE__*/ (0, $86rqb.jsxs)((0, $8c1eb9cd3fc5e2f1$export$2e2bcd8739ae039), {
                        disableRipple: true,
                        selected: selectedShape === shape,
                        onClick: ()=>onItemClick(shape),
                        children: [
                            /*#__PURE__*/ (0, $86rqb.jsx)((0, $c20e29e06d0b903e$export$2e2bcd8739ae039), {
                                children: $f849948450fc01bc$var$getIcon(shape.type)
                            }),
                            /*#__PURE__*/ (0, $86rqb.jsx)((0, $6e1b20d8aac02c31$export$2e2bcd8739ae039), {
                                primary: shape.type
                            }),
                            /*#__PURE__*/ (0, $86rqb.jsx)((0, $0d33723cc471c46b$export$2e2bcd8739ae039), {
                                edge: "end",
                                "aria-label": "delete",
                                onClick: (ev)=>onRemoveClick(ev, shape),
                                children: /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8d741701b2ec121f$exports))), {})
                            })
                        ]
                    }, shape.id);
                }),
                /*#__PURE__*/ (0, $86rqb.jsx)("div", {
                    ref: anchorRef
                })
            ]
        })
    });
};
var $f849948450fc01bc$export$2e2bcd8739ae039 = $f849948450fc01bc$var$ShapeList;



var $86rqb = parcelRequire("86rqb");

var $3eTha = parcelRequire("3eTha");

var $86rqb = parcelRequire("86rqb");


var $86rqb = parcelRequire("86rqb");

var $35jnV = parcelRequire("35jnV");





var $ead999a0817de10c$export$d927737047eb3867;
var $ead999a0817de10c$export$e1d786d2f707b414;
var $ead999a0817de10c$export$aba86695643891f5;
var $ead999a0817de10c$export$5021d830294bf770;
var $ead999a0817de10c$export$35eec893e28a8a34;
var $ead999a0817de10c$export$4dbdc8f16fed8a34;
var $ead999a0817de10c$export$21f42ab9b6679f44;
var $ead999a0817de10c$export$9f048bf86ee2e9d2;
var $ead999a0817de10c$export$4b409e53cf4df6e6;
var $ead999a0817de10c$export$120ff0929b202a6d;
var $ead999a0817de10c$export$8b7a896ae75accbf;
$ead999a0817de10c$export$d927737047eb3867 = `GinEhq_bar`;
$ead999a0817de10c$export$e1d786d2f707b414 = `GinEhq_circle`;
$ead999a0817de10c$export$aba86695643891f5 = `GinEhq_col`;
$ead999a0817de10c$export$5021d830294bf770 = `GinEhq_customized`;
$ead999a0817de10c$export$35eec893e28a8a34 = `GinEhq_ellipse`;
$ead999a0817de10c$export$4dbdc8f16fed8a34 = `GinEhq_fields`;
$ead999a0817de10c$export$21f42ab9b6679f44 = `GinEhq_panel`;
$ead999a0817de10c$export$9f048bf86ee2e9d2 = `GinEhq_points`;
$ead999a0817de10c$export$4b409e53cf4df6e6 = `GinEhq_rect`;
$ead999a0817de10c$export$120ff0929b202a6d = `GinEhq_row`;
$ead999a0817de10c$export$8b7a896ae75accbf = `GinEhq_tags`;


function $04aad057c948f6db$var$Circle(props) {
    const shape = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039)((state)=>state.selected);
    const tags = (0, $078bc949f5227a17$export$2e2bcd8739ae039)((state)=>state.tags);
    const setParams = (0, $35jnV.useCallback)((params)=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        const { precision: precision } = (0, $078bc949f5227a17$export$2e2bcd8739ae039).getState();
        ss.update((state)=>{
            const { selected: selected } = state;
            if ((0, $3ab06b0b834e1fe0$export$2e2bcd8739ae039).exist(params.name)) selected.name = params.name;
            if ((0, $3ab06b0b834e1fe0$export$2e2bcd8739ae039).exist(params.radius) && params.radius >= 0) selected.radius = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(Number(params.radius), precision);
            if ((0, $3ab06b0b834e1fe0$export$2e2bcd8739ae039).exist(params.x)) selected.x = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(Number(params.x), precision);
            if ((0, $3ab06b0b834e1fe0$export$2e2bcd8739ae039).exist(params.y)) selected.y = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(Number(params.y), precision);
            if (params.tags) selected.tags = params.tags;
            selected.modifiedAt = Date.now();
            ss.setSelected(selected);
        });
        ss.selected.draw();
    }, []);
    const onNameChange = (0, $35jnV.useCallback)((ev)=>setParams({
            name: ev.target.value
        }), [
        setParams
    ]);
    const onRadiusChange = (0, $35jnV.useCallback)((ev)=>setParams({
            radius: ev.target.value
        }), [
        setParams
    ]);
    const onPosXChange = (0, $35jnV.useCallback)((ev)=>setParams({
            x: ev.target.value
        }), [
        setParams
    ]);
    const onPosYChange = (0, $35jnV.useCallback)((ev)=>setParams({
            y: ev.target.value
        }), [
        setParams
    ]);
    const onTagsChange = (0, $35jnV.useCallback)((ev, value)=>setParams({
            tags: value
        }), [
        setParams
    ]);
    return /*#__PURE__*/ (0, $86rqb.jsxs)("div", {
        className: $ead999a0817de10c$export$e1d786d2f707b414,
        children: [
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $126e412c1a491480$export$2e2bcd8739ae039), {
                multiple: true,
                filterSelectedOptions: true,
                options: tags,
                value: shape.tags,
                onChange: onTagsChange,
                renderInput: (params)=>/*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                        ...params,
                        label: "Tags",
                        placeholder: "Tag"
                    })
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                label: "name",
                type: "text",
                size: "small",
                InputLabelProps: {
                    shrink: true
                },
                value: shape.name,
                onChange: onNameChange
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                label: "x",
                type: "number",
                size: "small",
                InputLabelProps: {
                    shrink: true
                },
                value: shape.x,
                onChange: onPosXChange
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                label: "y",
                type: "number",
                size: "small",
                InputLabelProps: {
                    shrink: true
                },
                value: shape.y,
                onChange: onPosYChange
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                label: "radius",
                type: "number",
                size: "small",
                InputLabelProps: {
                    shrink: true
                },
                value: shape.radius,
                onChange: onRadiusChange
            })
        ]
    });
}
var $04aad057c948f6db$export$2e2bcd8739ae039 = $04aad057c948f6db$var$Circle;



var $86rqb = parcelRequire("86rqb");

var $35jnV = parcelRequire("35jnV");

var $3eTha = parcelRequire("3eTha");


var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $5wpQH = parcelRequire("5wpQH");

var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $755041e6d15dd540$export$d72d4cbdc30b331f(slot) {
    return (0, $1reLR.default)("MuiFormGroup", slot);
}
const $755041e6d15dd540$var$formGroupClasses = (0, $ibC2g.default)("MuiFormGroup", [
    "root",
    "row",
    "error"
]);
var $755041e6d15dd540$export$2e2bcd8739ae039 = $755041e6d15dd540$var$formGroupClasses;





var $86rqb = parcelRequire("86rqb");
"use client";
const $20bc6213c85b1f1d$var$_excluded = [
    "className",
    "row"
];
const $20bc6213c85b1f1d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            row && "row",
            error && "error"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $755041e6d15dd540$export$d72d4cbdc30b331f), classes);
};
const $20bc6213c85b1f1d$var$FormGroupRoot = (0, $jBVCU.default)("div", {
    name: "MuiFormGroup",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $lfXYn.default)({
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap"
    }, ownerState.row && {
        flexDirection: "row"
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $20bc6213c85b1f1d$var$FormGroup = /*#__PURE__*/ $35jnV.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiFormGroup"
    });
    const { className: className, row: row = false } = props, other = (0, $5NWw9.default)(props, $20bc6213c85b1f1d$var$_excluded);
    const muiFormControl = (0, $cbd44d6f2be34113$export$2e2bcd8739ae039)();
    const fcs = (0, $85be9b3ae8b6cb54$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $lfXYn.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $20bc6213c85b1f1d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsx)($20bc6213c85b1f1d$var$FormGroupRoot, (0, $lfXYn.default)({
        className: (0, $3eTha.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $20bc6213c85b1f1d$export$2e2bcd8739ae039 = $20bc6213c85b1f1d$var$FormGroup;



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");


var $5wpQH = parcelRequire("5wpQH");



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");

var $a2Szr = parcelRequire("a2Szr");
var $5wpQH = parcelRequire("5wpQH");
var $1reLR = parcelRequire("1reLR");

var $eTicN = parcelRequire("eTicN");
const $9c9291b9a0ad58b8$var$styled = (0, $eTicN.default)();
var $9c9291b9a0ad58b8$export$2e2bcd8739ae039 = $9c9291b9a0ad58b8$var$styled;



var $lBa3O = parcelRequire("lBa3O");


var $6Ux7a = parcelRequire("6Ux7a");

var $GqBeq = parcelRequire("GqBeq");

var $1fDcG = parcelRequire("1fDcG");

var $86rqb = parcelRequire("86rqb");
const $ca4d9cb9df13a448$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $ca4d9cb9df13a448$var$defaultTheme = (0, $6Ux7a.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $ca4d9cb9df13a448$var$defaultCreateStyledComponent = (0, $9c9291b9a0ad58b8$export$2e2bcd8739ae039)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $ca4d9cb9df13a448$var$useThemePropsDefault(props) {
    return (0, $lBa3O.default)({
        props: props,
        name: "MuiStack",
        defaultTheme: $ca4d9cb9df13a448$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $ca4d9cb9df13a448$var$joinChildren(children, separator) {
    const childrenArray = $35jnV.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $35jnV.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $ca4d9cb9df13a448$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $ca4d9cb9df13a448$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $lfXYn.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, $GqBeq.handleBreakpoints)({
        theme: theme
    }, (0, $GqBeq.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $1fDcG.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $GqBeq.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $GqBeq.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $1fDcG.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                "& > :not(style):not(style)": {
                    margin: 0
                },
                "& > :not(style) ~ :not(style)": {
                    [`margin${$ca4d9cb9df13a448$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $1fDcG.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $a2Szr.default)(styles, (0, $GqBeq.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $GqBeq.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $ca4d9cb9df13a448$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $ca4d9cb9df13a448$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $ca4d9cb9df13a448$var$useThemePropsDefault, componentName: componentName = "MuiStack" } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $5wpQH.default)(slots, (slot)=>(0, $1reLR.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($ca4d9cb9df13a448$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $35jnV.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $5bbc7abd735c8dea$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div", direction: direction = "column", spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $5NWw9.default)(props, $ca4d9cb9df13a448$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $86rqb.jsx)(StackRoot, (0, $lfXYn.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $3eTha.default)(classes.root, className)
        }, other, {
            children: divider ? $ca4d9cb9df13a448$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");
"use client";
const $42ad0b5f39f1d4b5$var$Stack = (0, $ca4d9cb9df13a448$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $jBVCU.default)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $hZybU.default)({
            props: inProps,
            name: "MuiStack"
        })
});
var $42ad0b5f39f1d4b5$export$2e2bcd8739ae039 = $42ad0b5f39f1d4b5$var$Stack;




var $1OAmh = parcelRequire("1OAmh");

var $jBVCU = parcelRequire("jBVCU");

var $hZybU = parcelRequire("hZybU");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $d16714384070ba84$export$717666c39ec07e12(slot) {
    return (0, $1reLR.default)("MuiFormControlLabel", slot);
}
const $d16714384070ba84$var$formControlLabelClasses = (0, $ibC2g.default)("MuiFormControlLabel", [
    "root",
    "labelPlacementStart",
    "labelPlacementTop",
    "labelPlacementBottom",
    "disabled",
    "label",
    "error",
    "required",
    "asterisk"
]);
var $d16714384070ba84$export$2e2bcd8739ae039 = $d16714384070ba84$var$formControlLabelClasses;




var $86rqb = parcelRequire("86rqb");
"use client";
const $36f99952d33708ab$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $36f99952d33708ab$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            `labelPlacement${(0, $1OAmh.default)(labelPlacement)}`,
            error && "error",
            required && "required"
        ],
        label: [
            "label",
            disabled && "disabled"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $d16714384070ba84$export$717666c39ec07e12), classes);
};
const $36f99952d33708ab$export$1b479270917a5676 = (0, $jBVCU.default)("label", {
    name: "MuiFormControlLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $d16714384070ba84$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $1OAmh.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        // For correct alignment with the text.
        verticalAlign: "middle",
        WebkitTapHighlightColor: "transparent",
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $d16714384070ba84$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.labelPlacement === "start" && {
        flexDirection: "row-reverse",
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === "top" && {
        flexDirection: "column-reverse",
        marginLeft: 16
    }, ownerState.labelPlacement === "bottom" && {
        flexDirection: "column",
        marginLeft: 16
    }, {
        [`& .${(0, $d16714384070ba84$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $d16714384070ba84$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $36f99952d33708ab$var$AsteriskComponent = (0, $jBVCU.default)("span", {
    name: "MuiFormControlLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $d16714384070ba84$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $36f99952d33708ab$var$FormControlLabel = /*#__PURE__*/ $35jnV.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiFormControlLabel"
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = "end", required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $5NWw9.default)(props, $36f99952d33708ab$var$_excluded);
    const muiFormControl = (0, $cbd44d6f2be34113$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach((key)=>{
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    const fcs = (0, $85be9b3ae8b6cb54$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $lfXYn.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $36f99952d33708ab$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $3d9a9295100a327d$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $86rqb.jsx)((0, $3d9a9295100a327d$export$2e2bcd8739ae039), (0, $lfXYn.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $3eTha.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $86rqb.jsxs)($36f99952d33708ab$export$1b479270917a5676, (0, $lfXYn.default)({
        className: (0, $3eTha.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $35jnV.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $86rqb.jsxs)((0, $42ad0b5f39f1d4b5$export$2e2bcd8739ae039), {
                direction: "row",
                alignItems: "center",
                children: [
                    label,
                    /*#__PURE__*/ (0, $86rqb.jsxs)($36f99952d33708ab$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            " ",
                            "*"
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $36f99952d33708ab$export$2e2bcd8739ae039 = $36f99952d33708ab$var$FormControlLabel;



var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");


var $5wpQH = parcelRequire("5wpQH");

var $a7jdq = parcelRequire("a7jdq");

var $5NWw9 = parcelRequire("5NWw9");

var $lfXYn = parcelRequire("lfXYn");

var $35jnV = parcelRequire("35jnV");


var $3eTha = parcelRequire("3eTha");


var $5wpQH = parcelRequire("5wpQH");

var $1OAmh = parcelRequire("1OAmh");

var $jBVCU = parcelRequire("jBVCU");




var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $94810b94fa13be18$export$baa0faa0c7ad8085(slot) {
    return (0, $1reLR.default)("PrivateSwitchBase", slot);
}
const $94810b94fa13be18$var$switchBaseClasses = (0, $ibC2g.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $94810b94fa13be18$export$2e2bcd8739ae039 = $94810b94fa13be18$var$switchBaseClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $8f158233899c8424$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $8f158233899c8424$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $1OAmh.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $5wpQH.default)(slots, (0, $94810b94fa13be18$export$baa0faa0c7ad8085), classes);
};
const $8f158233899c8424$var$SwitchBaseRoot = (0, $jBVCU.default)((0, $38bba7b782da1f95$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $lfXYn.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $8f158233899c8424$var$SwitchBaseInput = (0, $jBVCU.default)("input")({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $8f158233899c8424$var$SwitchBase = /*#__PURE__*/ $35jnV.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $5NWw9.default)(props, $8f158233899c8424$var$_excluded);
    const [checked, setCheckedState] = (0, $6550431a21008320$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $cbd44d6f2be34113$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $lfXYn.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $8f158233899c8424$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsxs)($8f158233899c8424$var$SwitchBaseRoot, (0, $lfXYn.default)({
        component: "span",
        className: (0, $3eTha.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $86rqb.jsx)($8f158233899c8424$var$SwitchBaseInput, (0, $lfXYn.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $8f158233899c8424$export$2e2bcd8739ae039 = $8f158233899c8424$var$SwitchBase;


parcelRequire("35jnV");

var $5gNfQ = parcelRequire("5gNfQ");

var $86rqb = parcelRequire("86rqb");
"use client";
var $8af19ff38d61240a$export$2e2bcd8739ae039 = (0, $5gNfQ.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");


parcelRequire("35jnV");

var $5gNfQ = parcelRequire("5gNfQ");

var $86rqb = parcelRequire("86rqb");
"use client";
var $078b730e8ca80538$export$2e2bcd8739ae039 = (0, $5gNfQ.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");


parcelRequire("35jnV");

var $5gNfQ = parcelRequire("5gNfQ");

var $86rqb = parcelRequire("86rqb");
"use client";
var $a40329483b24ed0f$export$2e2bcd8739ae039 = (0, $5gNfQ.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");



var $1OAmh = parcelRequire("1OAmh");

var $hZybU = parcelRequire("hZybU");

var $jBVCU = parcelRequire("jBVCU");

var $ibC2g = parcelRequire("ibC2g");

var $1reLR = parcelRequire("1reLR");
function $ec43fbdbcb99983a$export$6c57c6e16b4063b(slot) {
    return (0, $1reLR.default)("MuiCheckbox", slot);
}
const $ec43fbdbcb99983a$var$checkboxClasses = (0, $ibC2g.default)("MuiCheckbox", [
    "root",
    "checked",
    "disabled",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium"
]);
var $ec43fbdbcb99983a$export$2e2bcd8739ae039 = $ec43fbdbcb99983a$var$checkboxClasses;



var $86rqb = parcelRequire("86rqb");
"use client";
const $fd35da55a2a17d6c$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $fd35da55a2a17d6c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            indeterminate && "indeterminate",
            `color${(0, $1OAmh.default)(color)}`,
            `size${(0, $1OAmh.default)(size)}`
        ]
    };
    const composedClasses = (0, $5wpQH.default)(slots, (0, $ec43fbdbcb99983a$export$6c57c6e16b4063b), classes);
    return (0, $lfXYn.default)({}, classes, composedClasses);
};
const $fd35da55a2a17d6c$var$CheckboxRoot = (0, $jBVCU.default)((0, $8f158233899c8424$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $jBVCU.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiCheckbox",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            ownerState.color !== "default" && styles[`color${(0, $1OAmh.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lfXYn.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $a7jdq.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $ec43fbdbcb99983a$export$2e2bcd8739ae039).checked}, &.${(0, $ec43fbdbcb99983a$export$2e2bcd8739ae039).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $ec43fbdbcb99983a$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $fd35da55a2a17d6c$var$defaultCheckedIcon = /*#__PURE__*/ (0, $86rqb.jsx)((0, $078b730e8ca80538$export$2e2bcd8739ae039), {});
const $fd35da55a2a17d6c$var$defaultIcon = /*#__PURE__*/ (0, $86rqb.jsx)((0, $8af19ff38d61240a$export$2e2bcd8739ae039), {});
const $fd35da55a2a17d6c$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $86rqb.jsx)((0, $a40329483b24ed0f$export$2e2bcd8739ae039), {});
const $fd35da55a2a17d6c$var$Checkbox = /*#__PURE__*/ $35jnV.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $hZybU.default)({
        props: inProps,
        name: "MuiCheckbox"
    });
    const { checkedIcon: checkedIcon = $fd35da55a2a17d6c$var$defaultCheckedIcon, color: color = "primary", icon: iconProp = $fd35da55a2a17d6c$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $fd35da55a2a17d6c$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = "medium", className: className } = props, other = (0, $5NWw9.default)(props, $fd35da55a2a17d6c$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $lfXYn.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $fd35da55a2a17d6c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $86rqb.jsx)($fd35da55a2a17d6c$var$CheckboxRoot, (0, $lfXYn.default)({
        type: "checkbox",
        inputProps: (0, $lfXYn.default)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $35jnV.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $35jnV.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $3eTha.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $fd35da55a2a17d6c$export$2e2bcd8739ae039 = $fd35da55a2a17d6c$var$Checkbox;





var $68b9a9b6d213af33$exports = {};
"use strict";
"use client";

Object.defineProperty($68b9a9b6d213af33$exports, "__esModule", {
    value: true
});
$68b9a9b6d213af33$exports.default = void 0;

var $68b9a9b6d213af33$var$_createSvgIcon = $dd204784e51ffdae$exports((parcelRequire("2jyxe")));

var $86rqb = parcelRequire("86rqb");
var $68b9a9b6d213af33$var$_default = (0, $68b9a9b6d213af33$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), "Add");
$68b9a9b6d213af33$exports.default = $68b9a9b6d213af33$var$_default;





var $86rqb = parcelRequire("86rqb");

var $35jnV = parcelRequire("35jnV");

var $3eTha = parcelRequire("3eTha");




var $c111c8f38b4745a4$exports = {};
"use strict";
"use client";

Object.defineProperty($c111c8f38b4745a4$exports, "__esModule", {
    value: true
});
$c111c8f38b4745a4$exports.default = void 0;

var $c111c8f38b4745a4$var$_createSvgIcon = $dd204784e51ffdae$exports((parcelRequire("2jyxe")));

var $86rqb = parcelRequire("86rqb");
var $c111c8f38b4745a4$var$_default = (0, $c111c8f38b4745a4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "m7 14 5-5 5 5z"
}), "ArrowDropUp");
$c111c8f38b4745a4$exports.default = $c111c8f38b4745a4$var$_default;


var $57670c56954a7119$exports = {};
"use strict";
"use client";

Object.defineProperty($57670c56954a7119$exports, "__esModule", {
    value: true
});
$57670c56954a7119$exports.default = void 0;

var $57670c56954a7119$var$_createSvgIcon = $dd204784e51ffdae$exports((parcelRequire("2jyxe")));

var $86rqb = parcelRequire("86rqb");
var $57670c56954a7119$var$_default = (0, $57670c56954a7119$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $86rqb.jsx)("path", {
    d: "m7 10 5 5 5-5z"
}), "ArrowDropDown");
$57670c56954a7119$exports.default = $57670c56954a7119$var$_default;





const $0589504a741b1a5b$var$Item = (props)=>{
    const { point: point, style: style } = props;
    const onRemovePoint = (0, $35jnV.useCallback)((ev)=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        ss.update((state)=>{
            const { selected: selected, setSelected: setSelected } = state;
            selected.removePoint(point.id);
            setSelected(selected);
        });
        ss.selected.draw();
    }, [
        point
    ]);
    const onPointXChange = (0, $35jnV.useCallback)((ev)=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        const { precision: precision } = (0, $078bc949f5227a17$export$2e2bcd8739ae039).getState();
        ss.update((state)=>{
            const { selected: selected, setSelected: setSelected } = state;
            point.x = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(Number(ev.target.value), precision);
            selected.modifiedAt = Date.now();
            setSelected(selected);
        });
        ss.selected.draw();
    }, [
        point
    ]);
    const onPointYChange = (0, $35jnV.useCallback)((ev)=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        const { precision: precision } = (0, $078bc949f5227a17$export$2e2bcd8739ae039).getState();
        ss.update((state)=>{
            const { selected: selected, setSelected: setSelected } = state;
            point.y = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(Number(ev.target.value), precision);
            selected.modifiedAt = Date.now();
            setSelected(selected);
        });
        ss.selected.draw();
    }, [
        point
    ]);
    const onMoveUp = (0, $35jnV.useCallback)(()=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        ss.update((state)=>{
            const { selected: selected, setSelected: setSelected } = state;
            const index = selected.points.findIndex((p)=>p.id === point.id);
            selected.swapPoint(index, Math.max(0, index - 1));
            setSelected(selected);
        });
        ss.selected.draw();
    }, [
        point
    ]);
    const onMoveDown = (0, $35jnV.useCallback)(()=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        ss.update((state)=>{
            const { selected: selected, setSelected: setSelected } = state;
            const index = selected.points.findIndex((p)=>p.id === point.id);
            selected.swapPoint(index, Math.min(selected.points.length - 1, index + 1));
            setSelected(selected);
        });
        ss.selected.draw();
    }, [
        point
    ]);
    return /*#__PURE__*/ (0, $86rqb.jsxs)((0, $8c1eb9cd3fc5e2f1$export$2e2bcd8739ae039), {
        style: style,
        className: $ead999a0817de10c$export$120ff0929b202a6d,
        disableRipple: true,
        onMouseEnter: ()=>console.log("enter"),
        children: [
            /*#__PURE__*/ (0, $86rqb.jsxs)("div", {
                className: $ead999a0817de10c$export$aba86695643891f5,
                children: [
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $0d33723cc471c46b$export$2e2bcd8739ae039), {
                        edge: "start",
                        "aria-label": "up",
                        onClick: onMoveUp,
                        children: /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c111c8f38b4745a4$exports))), {})
                    }),
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $0d33723cc471c46b$export$2e2bcd8739ae039), {
                        edge: "start",
                        "aria-label": "down",
                        onClick: onMoveDown,
                        children: /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($57670c56954a7119$exports))), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $86rqb.jsxs)("div", {
                className: (0, $3eTha.default)($ead999a0817de10c$export$aba86695643891f5, $ead999a0817de10c$export$4dbdc8f16fed8a34),
                children: [
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                        label: "x",
                        type: "number",
                        size: "small",
                        InputLabelProps: {
                            shrink: true
                        },
                        value: point.x,
                        onChange: onPointXChange
                    }),
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                        label: "y",
                        type: "number",
                        size: "small",
                        InputLabelProps: {
                            shrink: true
                        },
                        value: point.y,
                        onChange: onPointYChange
                    })
                ]
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $0d33723cc471c46b$export$2e2bcd8739ae039), {
                edge: "end",
                "aria-label": "delete",
                onClick: onRemovePoint,
                children: /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8d741701b2ec121f$exports))), {})
            })
        ]
    });
};
var $0589504a741b1a5b$export$2e2bcd8739ae039 = $0589504a741b1a5b$var$Item;



function $92e11512f99cfc85$var$Customized(props) {
    const shape = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039)((state)=>state.selected);
    const tags = (0, $078bc949f5227a17$export$2e2bcd8739ae039)((state)=>state.tags);
    const [listRef, anchorRef] = (0, $70064c6fa1c34aa5$export$2e2bcd8739ae039)();
    const onAddClick = (0, $35jnV.useCallback)(()=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        ss.update((state)=>{
            const { selected: selected, setSelected: setSelected } = state;
            selected.addPoint(0, 0);
            setSelected(selected);
        });
        ss.selected.draw();
    }, []);
    const onCloseChange = (0, $35jnV.useCallback)(()=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        ss.update((state)=>{
            const { selected: selected, setSelected: setSelected } = state;
            selected.isClose = !selected.isClose;
            selected.modifiedAt = Date.now();
            setSelected(selected);
        });
        ss.selected.draw();
    }, []);
    const onNameChange = (0, $35jnV.useCallback)((ev)=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        ss.update((state)=>{
            const { selected: selected, setSelected: setSelected } = state;
            selected.name = ev.target.value;
            selected.modifiedAt = Date.now();
            setSelected(selected);
        });
        ss.selected.draw();
    }, []);
    const onTagsChange = (0, $35jnV.useCallback)((ev, value, reason, detail)=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        ss.update((state)=>{
            const { selected: selected, setSelected: setSelected } = state;
            selected.tags = value;
            selected.modifiedAt = Date.now();
            setSelected(selected);
        });
        ss.selected.draw();
    }, []);
    return /*#__PURE__*/ (0, $86rqb.jsxs)("div", {
        className: $ead999a0817de10c$export$5021d830294bf770,
        children: [
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $126e412c1a491480$export$2e2bcd8739ae039), {
                className: $ead999a0817de10c$export$8b7a896ae75accbf,
                multiple: true,
                filterSelectedOptions: true,
                options: tags,
                value: shape.tags,
                onChange: onTagsChange,
                renderInput: (params)=>/*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                        ...params,
                        label: "Tags",
                        placeholder: "Tag"
                    })
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                label: "name",
                type: "text",
                size: "small",
                InputLabelProps: {
                    shrink: true
                },
                value: shape.name,
                onChange: onNameChange
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)("div", {
                className: $ead999a0817de10c$export$9f048bf86ee2e9d2,
                children: /*#__PURE__*/ (0, $86rqb.jsxs)((0, $9babbdecd9fbf836$export$2e2bcd8739ae039), {
                    ref: listRef,
                    disablePadding: !shape.points,
                    children: [
                        shape.points.map((p)=>/*#__PURE__*/ (0, $86rqb.jsx)((0, $0589504a741b1a5b$export$2e2bcd8739ae039), {
                                point: p
                            }, p.id)),
                        /*#__PURE__*/ (0, $86rqb.jsx)("div", {
                            ref: anchorRef
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $86rqb.jsxs)("div", {
                className: (0, $3eTha.default)($ead999a0817de10c$export$d927737047eb3867, $ead999a0817de10c$export$120ff0929b202a6d),
                children: [
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $20bc6213c85b1f1d$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $86rqb.jsx)((0, $36f99952d33708ab$export$2e2bcd8739ae039), {
                            control: /*#__PURE__*/ (0, $86rqb.jsx)((0, $fd35da55a2a17d6c$export$2e2bcd8739ae039), {
                                checked: shape.isClose,
                                onChange: onCloseChange,
                                name: "close"
                            }),
                            label: "close"
                        })
                    }),
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $0d33723cc471c46b$export$2e2bcd8739ae039), {
                        edge: "end",
                        "aria-label": "add",
                        onClick: onAddClick,
                        children: /*#__PURE__*/ (0, $86rqb.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($68b9a9b6d213af33$exports))), {})
                    })
                ]
            })
        ]
    });
}
var $92e11512f99cfc85$export$2e2bcd8739ae039 = $92e11512f99cfc85$var$Customized;



var $86rqb = parcelRequire("86rqb");

var $35jnV = parcelRequire("35jnV");






function $cd39cee09c48a66b$var$Ellipse(props) {
    const shape = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039)((state)=>state.selected);
    const tags = (0, $078bc949f5227a17$export$2e2bcd8739ae039)((state)=>state.tags);
    const setParams = (0, $35jnV.useCallback)((params)=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        const { precision: precision } = (0, $078bc949f5227a17$export$2e2bcd8739ae039).getState();
        ss.update((state)=>{
            const { selected: selected } = state;
            if ((0, $3ab06b0b834e1fe0$export$2e2bcd8739ae039).exist(params.name)) selected.name = params.name;
            if ((0, $3ab06b0b834e1fe0$export$2e2bcd8739ae039).exist(params.x)) selected.x = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(Number(params.x), precision);
            if ((0, $3ab06b0b834e1fe0$export$2e2bcd8739ae039).exist(params.y)) selected.y = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(Number(params.y), precision);
            if ((0, $3ab06b0b834e1fe0$export$2e2bcd8739ae039).exist(params.width)) selected.width = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(Number(params.width), precision);
            if ((0, $3ab06b0b834e1fe0$export$2e2bcd8739ae039).exist(params.height)) selected.height = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(Number(params.height), precision);
            if (params.tags) selected.tags = params.tags;
            selected.modifiedAt = Date.now();
            ss.setSelected(selected);
        });
        ss.selected.draw();
    }, []);
    const onNameChange = (0, $35jnV.useCallback)((ev)=>setParams({
            name: ev.target.value
        }), [
        setParams
    ]);
    const onPosXChange = (0, $35jnV.useCallback)((ev)=>setParams({
            x: ev.target.value
        }), [
        setParams
    ]);
    const onPosYChange = (0, $35jnV.useCallback)((ev)=>setParams({
            y: ev.target.value
        }), [
        setParams
    ]);
    const onWidthChange = (0, $35jnV.useCallback)((ev)=>setParams({
            width: ev.target.value
        }), [
        setParams
    ]);
    const onHeightChange = (0, $35jnV.useCallback)((ev)=>setParams({
            height: ev.target.value
        }), [
        setParams
    ]);
    const onTagsChange = (0, $35jnV.useCallback)((ev, value)=>setParams({
            tags: value
        }), [
        setParams
    ]);
    return /*#__PURE__*/ (0, $86rqb.jsxs)("div", {
        className: $ead999a0817de10c$export$35eec893e28a8a34,
        children: [
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $126e412c1a491480$export$2e2bcd8739ae039), {
                multiple: true,
                filterSelectedOptions: true,
                options: tags,
                value: shape.tags,
                onChange: onTagsChange,
                renderInput: (params)=>/*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                        ...params,
                        label: "Tags",
                        placeholder: "Tag"
                    })
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                label: "name",
                type: "text",
                size: "small",
                InputLabelProps: {
                    shrink: true
                },
                value: shape.name,
                onChange: onNameChange
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                label: "x",
                type: "number",
                size: "small",
                InputLabelProps: {
                    shrink: true
                },
                value: shape.x,
                onChange: onPosXChange
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                label: "y",
                type: "number",
                size: "small",
                InputLabelProps: {
                    shrink: true
                },
                value: shape.y,
                onChange: onPosYChange
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                label: "width",
                type: "number",
                size: "small",
                InputLabelProps: {
                    shrink: true
                },
                value: shape.width,
                onChange: onWidthChange
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                label: "height",
                type: "number",
                size: "small",
                InputLabelProps: {
                    shrink: true
                },
                value: shape.height,
                onChange: onHeightChange
            })
        ]
    });
}
var $cd39cee09c48a66b$export$2e2bcd8739ae039 = $cd39cee09c48a66b$var$Ellipse;



var $86rqb = parcelRequire("86rqb");

var $35jnV = parcelRequire("35jnV");






function $d4c22055338a906b$var$Rect(props) {
    const shape = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039)((state)=>state.selected);
    const tags = (0, $078bc949f5227a17$export$2e2bcd8739ae039)((state)=>state.tags);
    const setParams = (0, $35jnV.useCallback)((params)=>{
        const ss = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039).getState();
        const { precision: precision } = (0, $078bc949f5227a17$export$2e2bcd8739ae039).getState();
        ss.update((state)=>{
            const { selected: selected } = state;
            if ((0, $3ab06b0b834e1fe0$export$2e2bcd8739ae039).exist(params.name)) selected.name = params.name;
            if ((0, $3ab06b0b834e1fe0$export$2e2bcd8739ae039).exist(params.x)) selected.x = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(Number(params.x), precision);
            if ((0, $3ab06b0b834e1fe0$export$2e2bcd8739ae039).exist(params.y)) selected.y = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(Number(params.y), precision);
            if ((0, $3ab06b0b834e1fe0$export$2e2bcd8739ae039).exist(params.width)) selected.width = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(Number(params.width), precision);
            if ((0, $3ab06b0b834e1fe0$export$2e2bcd8739ae039).exist(params.height)) selected.height = (0, $c749fe39302942ca$export$2e2bcd8739ae039).round(Number(params.height), precision);
            if (params.tags) selected.tags = params.tags;
            selected.modifiedAt = Date.now();
            ss.setSelected(selected);
        });
        ss.selected.draw();
    }, []);
    const onNameChange = (0, $35jnV.useCallback)((ev)=>setParams({
            name: ev.target.value
        }), [
        setParams
    ]);
    const onPosXChange = (0, $35jnV.useCallback)((ev)=>setParams({
            x: ev.target.value
        }), [
        setParams
    ]);
    const onPosYChange = (0, $35jnV.useCallback)((ev)=>setParams({
            y: ev.target.value
        }), [
        setParams
    ]);
    const onWidthChange = (0, $35jnV.useCallback)((ev)=>setParams({
            width: ev.target.value
        }), [
        setParams
    ]);
    const onHeightChange = (0, $35jnV.useCallback)((ev)=>setParams({
            height: ev.target.value
        }), [
        setParams
    ]);
    const onTagsChange = (0, $35jnV.useCallback)((ev, value)=>setParams({
            tags: value
        }), [
        setParams
    ]);
    return /*#__PURE__*/ (0, $86rqb.jsxs)("div", {
        className: $ead999a0817de10c$export$4b409e53cf4df6e6,
        children: [
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $126e412c1a491480$export$2e2bcd8739ae039), {
                multiple: true,
                filterSelectedOptions: true,
                options: tags,
                value: shape.tags,
                onChange: onTagsChange,
                renderInput: (params)=>/*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                        ...params,
                        label: "Tags",
                        placeholder: "Tag"
                    })
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                label: "name",
                type: "text",
                size: "small",
                InputLabelProps: {
                    shrink: true
                },
                value: shape.name,
                onChange: onNameChange
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                label: "x",
                type: "number",
                size: "small",
                InputLabelProps: {
                    shrink: true
                },
                value: shape.x,
                onChange: onPosXChange
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                label: "y",
                type: "number",
                size: "small",
                InputLabelProps: {
                    shrink: true
                },
                value: shape.y,
                onChange: onPosYChange
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                label: "width",
                type: "number",
                size: "small",
                InputLabelProps: {
                    shrink: true
                },
                value: shape.width,
                onChange: onWidthChange
            }),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $d16e3bc6c7fd28e7$export$2e2bcd8739ae039), {
                label: "height",
                type: "number",
                size: "small",
                InputLabelProps: {
                    shrink: true
                },
                value: shape.height,
                onChange: onHeightChange
            })
        ]
    });
}
var $d4c22055338a906b$export$2e2bcd8739ae039 = $d4c22055338a906b$var$Rect;


const $ed43c17993e9f3ec$var$Panel = (props)=>{
    // FIXME: shallow
    const [selected] = (0, $1a573d0e0cb11211$export$2e2bcd8739ae039)((state)=>[
            state.selected
        ]);
    switch(selected?.type){
        case "circle":
            return /*#__PURE__*/ (0, $86rqb.jsx)((0, $04aad057c948f6db$export$2e2bcd8739ae039), {});
        case "customized":
            return /*#__PURE__*/ (0, $86rqb.jsx)((0, $92e11512f99cfc85$export$2e2bcd8739ae039), {});
        case "ellipse":
            return /*#__PURE__*/ (0, $86rqb.jsx)((0, $cd39cee09c48a66b$export$2e2bcd8739ae039), {});
        case "rect":
            return /*#__PURE__*/ (0, $86rqb.jsx)((0, $d4c22055338a906b$export$2e2bcd8739ae039), {});
        default:
            return null;
    }
};
var $ed43c17993e9f3ec$export$2e2bcd8739ae039 = $ed43c17993e9f3ec$var$Panel;



const $a847b15ac492b698$var$InfoPanel = (props)=>{
    return /*#__PURE__*/ (0, $86rqb.jsx)("div", {
        className: (0, $3eTha.default)($ead999a0817de10c$export$21f42ab9b6679f44, props.className),
        children: /*#__PURE__*/ (0, $86rqb.jsx)((0, $ed43c17993e9f3ec$export$2e2bcd8739ae039), {})
    });
};
var $a847b15ac492b698$export$2e2bcd8739ae039 = $a847b15ac492b698$var$InfoPanel;


var $796b53f12295ec63$export$a7db06668cad9adb;
var $796b53f12295ec63$export$523fb3936f49e028;
var $796b53f12295ec63$export$af49d998f9e453;
$796b53f12295ec63$export$a7db06668cad9adb = `_0FACuW_content`;
$796b53f12295ec63$export$523fb3936f49e028 = `_0FACuW_page`;
$796b53f12295ec63$export$af49d998f9e453 = `_0FACuW_rightSide`;


function $ea1973bd21ce52e9$export$2e2bcd8739ae039() {
    const selected = (0, $5a88544a0e784883$export$2e2bcd8739ae039)((state)=>state.selected);
    return /*#__PURE__*/ (0, $86rqb.jsxs)("div", {
        className: $796b53f12295ec63$export$523fb3936f49e028,
        children: [
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $a70d4173f38562f9$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $86rqb.jsxs)("div", {
                className: $796b53f12295ec63$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $86rqb.jsx)((0, $f323bcb48dd1f187$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $86rqb.jsx)("div", {
                        className: $796b53f12295ec63$export$af49d998f9e453,
                        children: /*#__PURE__*/ (0, $86rqb.jsxs)((0, $de010c61f49f73ec$export$2e2bcd8739ae039), {
                            fallback: /*#__PURE__*/ (0, $86rqb.jsx)("p", {
                                children: "Something went wrong"
                            }),
                            children: [
                                /*#__PURE__*/ (0, $86rqb.jsx)((0, $7b549ec00ade720c$export$2e2bcd8739ae039), {
                                    className: "z0"
                                }),
                                selected !== null && /*#__PURE__*/ (0, $86rqb.jsxs)((0, $86rqb.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $86rqb.jsx)((0, $63e50d6a5d2e89f9$export$2e2bcd8739ae039), {
                                            className: "z1"
                                        }),
                                        /*#__PURE__*/ (0, $86rqb.jsx)((0, $91619c8d41397771$export$2e2bcd8739ae039), {
                                            className: "z1"
                                        }),
                                        /*#__PURE__*/ (0, $86rqb.jsx)((0, $f849948450fc01bc$export$2e2bcd8739ae039), {
                                            className: "z1"
                                        }),
                                        /*#__PURE__*/ (0, $86rqb.jsx)((0, $a847b15ac492b698$export$2e2bcd8739ae039), {
                                            className: "z1"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




const $4995ec573cc8a1ff$var$darkTheme = (0, $kPJLM.default)({
    palette: {
        mode: "dark"
    }
});
function $4995ec573cc8a1ff$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $86rqb.jsxs)((0, $30ddd8ad23484c6a$export$2e2bcd8739ae039), {
        theme: $4995ec573cc8a1ff$var$darkTheme,
        children: [
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $21f582aa7c0e8d71$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $86rqb.jsx)((0, $ea1973bd21ce52e9$export$2e2bcd8739ae039), {})
        ]
    });
}


const $00434a95140535cd$var$container = document.getElementById("app");
const $00434a95140535cd$var$root = (0, $b66eb0f3e66056aa$export$882461b6382ed46c)($00434a95140535cd$var$container);
$00434a95140535cd$var$root.render(/*#__PURE__*/ (0, $86rqb.jsx)((0, $4995ec573cc8a1ff$export$86fbec116b87613f), {}));

})();
//# sourceMappingURL=index.a4f2b987.js.map
